import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@retailer-platform/dashboard/apollo';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: string;
  CaperBillingService_BillingPeriod: any;
  CaperBillingService_File: any;
  DateTime: any;
  EmailAddress: any;
  GoogleProtobufAnyScalar: any;
  ISO8601Date: any;
  ISO8601DateTime: any;
  JSON: any;
  JSONObject: any;
  ObjMap: any;
  PermissionsInput: any;
  PositiveInt: any;
  RetailerContactManagement_mutationInput_addContact_input_name: any;
  RetailerContactManagement_mutationInput_addContact_input_role: any;
  RetailerContactManagement_mutationInput_updateContact_input_name: any;
  RetailerContactManagement_mutationInput_updateContact_input_role: any;
  Time: string;
  True: true;
  URL: any;
  UUID: any;
  UnsignedInt: any;
  Url: any;
  Void: any;
  google_protobuf_Empty: any;
  google_protobuf_Empty_Input: any;
  instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext: any;
  instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext_Input: any;
  instacart_ads_targeting_v1_NewToInstacartCondition: any;
  instacart_ads_targeting_v1_NewToInstacartCondition_Input: any;
  instacart_caper_admin_v1_AllRetailerStores_Input: any;
  instacart_caper_admin_v1_ArchiveNotificationGroupResponse: any;
  instacart_caper_admin_v1_CancelScheduledActionResponse: any;
  instacart_caper_admin_v1_CreateConfigKeyResponse: any;
  instacart_caper_admin_v1_CreateDeviceResponse: any;
  instacart_caper_admin_v1_CreateFeatureResponse: any;
  instacart_caper_admin_v1_CreatePartnerResponse: any;
  instacart_caper_admin_v1_CreateRetailerResponse: any;
  instacart_caper_admin_v1_EditStoreStaffBarcodeResponse: any;
  instacart_caper_admin_v1_GetAllEntitiesRequest_Input: any;
  instacart_caper_admin_v1_GetAvailableProfilesRequest_Input: any;
  instacart_caper_admin_v1_GetConfigCleanupReportRequest_Input: any;
  instacart_caper_admin_v1_GetConfigFeatureDriftReportRequest_Input: any;
  instacart_caper_admin_v1_GlobalPartnerAccess: any;
  instacart_caper_admin_v1_GlobalRetailerAccess: any;
  instacart_caper_admin_v1_GlobalStoreAccess: any;
  instacart_caper_admin_v1_GlobalStoreAccess_Input: any;
  instacart_caper_admin_v1_PartnerLevelGlobal_Input: any;
  instacart_caper_admin_v1_ReviewNofResponse: any;
  instacart_caper_admin_v1_SendReceiptResponse: any;
  instacart_caper_admin_v1_SetBanEntryArchivedResponse: any;
  instacart_caper_admin_v1_UpdateConfigKeyResponse: any;
  instacart_caper_admin_v1_UpdateConfigResponse: any;
  instacart_caper_admin_v1_UpdateGlobalResponse: any;
  instacart_caper_admin_v1_UpdateNotificationGroupResponse: any;
  instacart_caper_admin_v2_BasicGlobalInfo: any;
  instacart_care_tools_v1_DeleteUserShopperBanResponse: any;
  instacart_care_tools_v1_ForceCompleteOrderResponse: any;
  instacart_catalog_admin_v1_ApplyChangeRequestResponse: any;
  instacart_catalog_admin_v1_ApproveChangeRequestResponse: any;
  instacart_catalog_admin_v1_CancelChangeRequestResponse: any;
  instacart_catalog_admin_v1_MakeMissingCodeDecisionResponse: any;
  instacart_catalog_admin_v1_RejectChangeRequestResponse: any;
  instacart_catalog_admin_v1_RetryAnalysisResponse: any;
  instacart_catalog_admin_v1_RollbackChangeRequestResponse: any;
  instacart_catalog_admin_v1_SetRetailerDiscountThresholdBringBacksResponse: any;
  instacart_catalog_admin_v1_SetRetailerDiscountThresholdsResponse: any;
  instacart_catalog_admin_v1_TempOverrideServiceCreateResponse: any;
  instacart_catalog_catflow_v1_RevertToStepVersionResponse: any;
  instacart_catalog_catflow_v1_UpdateStepResponse: any;
  instacart_catalog_catflow_v1_UpdateStepVersionStateResponse: any;
  instacart_customers_basket_products_orchestrators_v1_GetBasketProductsRequest_NoUser_Input: any;
  instacart_customers_business_admin_v1_DeleteBusinessProgramContentResponse: any;
  instacart_customers_business_admin_v1_DeleteBusinessProgramOfferResponse: any;
  instacart_customers_business_admin_v1_DeleteBusinessProgramResponse: any;
  instacart_customers_campaigns_v1_TestOfflineCampaignResponse: any;
  instacart_customers_commerce_coupons_v1_BulkCreateChildCouponCodesResponse: any;
  instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_DirectedSpendProgramEnrollmentRequired: any;
  instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipExcluded: any;
  instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipRequired: any;
  instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario: any;
  instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario_Input: any;
  instacart_customers_flyer_pdf_v1_ClassificationFilter_Debug: any;
  instacart_customers_flyer_pdf_v1_ClassificationFlagger_Debug: any;
  instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition: any;
  instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_FilterClassification_Debug: any;
  instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default: any;
  instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default_Input: any;
  instacart_customers_flyer_pdf_v1_ImageClassifier_Definition: any;
  instacart_customers_flyer_pdf_v1_ImageClassifier_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_ImageCluster_Debug: any;
  instacart_customers_flyer_pdf_v1_PdfPageParser_Debug: any;
  instacart_customers_flyer_pdf_v1_PromptFilter_Debug: any;
  instacart_customers_flyer_pdf_v1_PromptFlagger_Debug: any;
  instacart_customers_flyer_pdf_v1_QualityReviewer_Debug: any;
  instacart_customers_flyer_pdf_v1_TextClassifier_Definition: any;
  instacart_customers_flyer_pdf_v1_TextClassifier_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_TextCorrect_Debug: any;
  instacart_customers_flyer_pdf_v1_TextCorrect_Definition: any;
  instacart_customers_flyer_pdf_v1_TextCorrect_Definition_Input: any;
  instacart_customers_flyer_pdf_v1_TextHeightCorrect_Debug: any;
  instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition: any;
  instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition_Input: any;
  instacart_customers_loyalty_admin_v1_DeleteLoyaltyCardValidationResponse: any;
  instacart_customers_payments_v1_InstrumentDetail_ApplePayDetail: any;
  instacart_customers_recipes_v1_GetCoreIngredientsRequest_Input: any;
  instacart_customers_search_v1_DeleteSearchTermOverridesByIdResponse: any;
  instacart_enterprise_boba_core_types_v1_OfferDetails_UncategorizedScenario: any;
  instacart_enterprise_frigate_delivery_software_v1_CancelDeliveryRouteSuccess: any;
  instacart_enterprise_frigate_delivery_software_v1_DeliveryRouteUpdateSuccess: any;
  instacart_enterprise_frigate_delivery_software_v1_DriverDelayedScenario: any;
  instacart_eversight_item_price_management_v1_DeleteChangeRequestRuleResponse: any;
  instacart_flawless_inventory_v1_GetJobSourcesRequest_Input: any;
  instacart_flawless_inventory_v1_GetMapleSupportedModelsRequest_Input: any;
  instacart_fulfillment_domains_transaction_integrity_v1_GetStepTypesRequest_Input: any;
  instacart_fulfillment_user_shopper_ban_v1_DeleteUserShopperBanResponse: any;
  instacart_growth_marketing_tooling_v1_IcPlusMemberRestriction: any;
  instacart_growth_marketing_tooling_v1_IcPlusMemberRestriction_Input: any;
  instacart_growth_marketing_tooling_v1_LoyaltyMemberRestriction: any;
  instacart_growth_marketing_tooling_v1_LoyaltyMemberRestriction_Input: any;
  instacart_logistics_v1_ListCreatorsRequest_Input: any;
  instacart_logistics_v1_ListTagsRequest_Input: any;
  instacart_partners_partners_v1_GetFlipFeatureGroupsRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_CheckHealthResponse: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetAutomationsRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetConnectionsRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetStoresRequest_Input: any;
  instacart_retailer_os_shelf_labels_admin_v1_GetSyncStrategiesRequest_Input: any;
  instacart_upos_config_v1_GetIntegrationsRequest_Input: any;
  instacart_upos_config_v1_GetProfilesRequest_Input: any;
  instacart_upos_config_v1_GetRetailersRequest_Input: any;
  instacart_upos_config_v1_GetStoresRequest_Input: any;
  instacart_upos_config_v1_Version_Create: any;
  instacart_upos_status_v1_GetIntegrationStatusesRequest_Input: any;
  instacart_upos_status_v1_IntegrationStatus_Undetermined: any;
  instacart_waves_v1_GetPresignedUploadUrlRequest_Input: any;
  instacart_waves_v1_ListAllStepFilterTagsRequest_Input: any;
};

export type AccessControlAuthorizationAuthorizationCheck = {
  __typename?: 'AccessControlAuthorizationAuthorizationCheck';
  /** Determines whether the current account has access to the given rules */
  authorized: Scalars['Boolean'];
  /** An array of reasons why validation failed, if any */
  reasons: Array<RejectionReasonEnum>;
  /** Details about why validation failed, if any */
  rejectDetails?: Maybe<AccessControlAuthorizationRejectionReasonDetails>;
};

export type AccessControlAuthorizationNoPartnerWriteAccess = {
  __typename?: 'AccessControlAuthorizationNoPartnerWriteAccess';
  /** The partners which the account does not have write access to */
  partnerDetails?: Maybe<Array<AccessControlAuthorizationPartnerWriteAccessErrorDetails>>;
  /** The partners names which the account does not have write access to */
  partners?: Maybe<Array<Scalars['String']>>;
};

export type AccessControlAuthorizationPartnerWriteAccessErrorDetails = {
  __typename?: 'AccessControlAuthorizationPartnerWriteAccessErrorDetails';
  /** A unique identifier for the partner */
  id?: Maybe<Scalars['ID']>;
  /** The name of the partner */
  name?: Maybe<Scalars['String']>;
};

export type AccessControlAuthorizationRejectionReasonDetails = {
  __typename?: 'AccessControlAuthorizationRejectionReasonDetails';
  /** The rejection reason details for no partner write access */
  noPartnerWriteAccess?: Maybe<AccessControlAuthorizationNoPartnerWriteAccess>;
};

export type AccessControlConfiguration = {
  __typename?: 'AccessControlConfiguration';
  /** The policies associated with the account */
  policies: AccessControlPolicies;
  /** The access control details for the retailer */
  retailerDetails: AccessControlRetailerDetails;
};


export type AccessControlConfigurationRetailerDetailsArgs = {
  retailerId: Scalars['ID'];
};

export type AccessControlPolicies = {
  __typename?: 'AccessControlPolicies';
  /** Permission to view the admin tools section */
  viewAdminToolsSection: Scalars['Boolean'];
  /** Permission to view the retailer dashboard section */
  viewRetailerDashboardSection: Scalars['Boolean'];
};

export type AccessControlRetailerDetails = {
  __typename?: 'AccessControlRetailerDetails';
  /** The policies associated with the retailer */
  policies: AccessControlRetailerPolicies;
};

export type AccessControlRetailerPolicies = {
  __typename?: 'AccessControlRetailerPolicies';
  /** Permission to modify retailer location groups */
  modifyRetailerLocationGroups: Scalars['Boolean'];
  /** Permission to modify retailer reports */
  modifyRetailerReports: Scalars['Boolean'];
  /** Permission to view retailer location groups */
  viewRetailerLocationGroups: Scalars['Boolean'];
  /** Permission to view retailer reports */
  viewRetailerReports: Scalars['Boolean'];
};

export type AccessRequest = {
  __typename?: 'AccessRequest';
  accessibleId?: Maybe<Scalars['BigInt']>;
  accessibleType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  decidedAt?: Maybe<Scalars['DateTime']>;
  decidedByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  ippApprovalRequestId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  status?: Maybe<AccessRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum AccessRequestStatus {
  AccessRequestStatusApproved = 'ACCESS_REQUEST_STATUS_APPROVED',
  AccessRequestStatusPending = 'ACCESS_REQUEST_STATUS_PENDING',
  AccessRequestStatusRejected = 'ACCESS_REQUEST_STATUS_REJECTED',
  AccessRequestStatusUnknown = 'ACCESS_REQUEST_STATUS_UNKNOWN'
}

export type AccessToken = {
  __typename?: 'AccessToken';
  /** The account associated with the token */
  enterpriseAccount?: Maybe<EnterpriseAccount>;
  /** A unique token for authentication purposes */
  token: Scalars['ID'];
};

export type AccountInput = {
  /** A unique identifier for the account */
  id: Scalars['ID'];
};

export type AccountOrdersEmptyState = {
  __typename?: 'AccountOrdersEmptyState';
  enabled?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type AccountRequestAccountRequest = {
  __typename?: 'AccountRequestAccountRequest';
  /** Canonical account ID */
  accountCanonicalId?: Maybe<Scalars['String']>;
  /** Time this request was created */
  createdAt: Scalars['Time'];
  /** Country associated with this retailer */
  email: Scalars['String'];
  /** Country associated with this retailer */
  fullName: Scalars['String'];
  /** A unique identifier for the retailer */
  id: Scalars['ID'];
  /** justification from retailer employee for account creation */
  requestReason: Scalars['String'];
  /** Current state of the request */
  requestState: RequestStateEnum;
  /** The name of the retailer */
  retailerId: Scalars['ID'];
  /** Requested role IDs */
  roles: Array<EnterpriseRole>;
};

export type AccountRequestPreviousRequestExists = {
  __typename?: 'AccountRequestPreviousRequestExists';
  /** Does a previous account request exist */
  requestExists: Scalars['Boolean'];
};

export enum AccountSortEnum {
  /** Sort by creation date */
  CreatedAt = 'CREATED_AT',
  /** Sort by email address */
  Email = 'EMAIL',
  /** Sort by account ID */
  Id = 'ID',
  /** Sort by name */
  Name = 'NAME',
  /** Sort by account status */
  Status = 'STATUS'
}

export enum AccountStatusEnum {
  /** Active status */
  Active = 'ACTIVE',
  /** Disabled status */
  Disabled = 'DISABLED',
  /** Pending status */
  Pending = 'PENDING'
}

export type AddRetailerCampaignTreatmentsRequestInput = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<CreateRetailerCampaignTreatmentParamsInput>>>;
};

export type AddRetailerCampaignTreatmentsResponse = {
  __typename?: 'AddRetailerCampaignTreatmentsResponse';
  treatments?: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
};

export type AddStoreConfigurationToClientConfigurationRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type AddStoreConfigurationToClientConfigurationResponse = {
  __typename?: 'AddStoreConfigurationToClientConfigurationResponse';
  clientConfiguration?: Maybe<ClientConfiguration>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AdditionalEnvVariableInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  apartmentNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type AddressDeliveryContact = {
  __typename?: 'AddressDeliveryContact';
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
};

export type AddressResponse = {
  __typename?: 'AddressResponse';
  accessCode?: Maybe<Scalars['String']>;
  addressCategory?: Maybe<Scalars['String']>;
  apartmentNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<GoogleTypeLatLng>;
  countryId?: Maybe<Scalars['BigInt']>;
  deliveryContact?: Maybe<AddressDeliveryContact>;
  dropoffLocation?: Maybe<Scalars['String']>;
  floorNumber?: Maybe<Scalars['String']>;
  geohash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  instructions?: Maybe<Scalars['String']>;
  placeName?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  unattendedDelivery?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['BigInt']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Autogenerated return type of AdminBannerCreate */
export type AdminBannerCreatePayload = {
  __typename?: 'AdminBannerCreatePayload';
  noticeBanner: NoticeBannersTypesBannerType;
};

/** Autogenerated return type of AdminBannerDelete */
export type AdminBannerDeletePayload = {
  __typename?: 'AdminBannerDeletePayload';
  deletedId: Scalars['ID'];
};

/** Autogenerated return type of AdminBannerUpdate */
export type AdminBannerUpdatePayload = {
  __typename?: 'AdminBannerUpdatePayload';
  noticeBanner: NoticeBannersTypesBannerType;
};

export type AdminNavigationV2 = {
  __typename?: 'AdminNavigationV2';
  desktopFlexibleHeaderLayoutV1?: Maybe<DesktopFlexibleHeaderLayoutV1Navigations>;
  desktopSidebarLayoutV1?: Maybe<DesktopSidebarLayoutV1Navigations>;
  mobileWebHamburgerMenuLayoutV1?: Maybe<MobileWebHamburgerMenuLayoutV1Navigations>;
  nativeMoreMenuLayoutV1?: Maybe<NativeMoreMenuLayoutV1Navigations>;
};

export type AdminNavigationV2Input = {
  desktopFlexibleHeaderLayoutV1?: InputMaybe<DesktopFlexibleHeaderLayoutV1NavigationsInput>;
  desktopSidebarLayoutV1?: InputMaybe<DesktopSidebarLayoutV1NavigationsInput>;
  mobileWebHamburgerMenuLayoutV1?: InputMaybe<MobileWebHamburgerMenuLayoutV1NavigationsInput>;
  nativeMoreMenuLayoutV1?: InputMaybe<NativeMoreMenuLayoutV1NavigationsInput>;
};

export type AdminRequestContextInput = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type AdsSchema = {
  __typename?: 'AdsSchema';
  allowAlcoholSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowBiaPageSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowBrowseSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowCartSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowCheckoutSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowExperimentalPlacements?: Maybe<Scalars['Boolean']>;
  allowItemDetailsSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowSearchGridSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowSearchOtherSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowSponsoredProducts?: Maybe<Scalars['Boolean']>;
  allowStorefrontSponsoredProducts?: Maybe<Scalars['Boolean']>;
};

export type AdvanceBatchStateRequestInput = {
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type AdvanceBatchStateResponse = {
  __typename?: 'AdvanceBatchStateResponse';
  id?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Scalars['String']>;
};

/** Defines a single affecting scope for querying approval requests. */
export type AffectingScopeInput = {
  /** Filter by partner IDs affected by the approval request. */
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by retailer IDs affected by the approval request. */
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by retailer location IDs affected by the approval request. */
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  /** Filter by store configuration IDs affected by the approval request. */
  storeConfigIds?: InputMaybe<Array<Scalars['ID']>>;
};

/** Defines filtering criteria for affecting scopes in a request to list approval requests. */
export type AffectingScopeSearchInput = {
  /** Returns ARs that match ANY of the provided AffectingScopes. To match, the AR's AffectingScope must be a superset of the provided AffectingScope. */
  affectingScopes?: InputMaybe<Array<AffectingScopeInput>>;
  /** Returns ARs that have no AffectingScope; i.e., empty partners/retailers/locations/store-configs. */
  includeGlobalScope?: InputMaybe<Scalars['Boolean']>;
};

export type AgentRequestInput = {
  messages: Array<MessageInput>;
  tools?: InputMaybe<Array<ToolInput>>;
  uiContext: UiContextInput;
};

export type AgentResponse = {
  __typename?: 'AgentResponse';
  finalResult?: Maybe<Scalars['String']>;
  messages: Array<Message>;
  summary?: Maybe<Scalars['String']>;
};

/** The type of agreement being accepted */
export enum AgreementTypeEnum {
  /** IDP Terms and Conditions v1 */
  IdpV1 = 'IDP_V1',
  /** Partner Dashboard Terms and Conditions v1 */
  PartnerDashboardV1 = 'PARTNER_DASHBOARD_V1'
}

/** Autogenerated return type of AiAgentConversationUpsert */
export type AiAgentConversationUpsertPayload = {
  __typename?: 'AiAgentConversationUpsertPayload';
  /** Whether the conversation was upserted successfully */
  success: Scalars['True'];
};

export type AiCarouselConfiguration = {
  __typename?: 'AiCarouselConfiguration';
  attributeFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  carouselTargeting?: Maybe<Scalars['String']>;
  carouselTitle?: Maybe<Scalars['String']>;
  duplicationFlag?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  itemRanking?: Maybe<Scalars['String']>;
  itemRetrievalFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  itemRetrievalLogic?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  rawAttributeFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  rawKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  similarCarousels?: Maybe<Array<Maybe<Scalars['String']>>>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type AisleGroup = {
  __typename?: 'AisleGroup';
  aisleDisplayName?: Maybe<Scalars['String']>;
  aisleId?: Maybe<Scalars['String']>;
  estimatedLostSales?: Maybe<Scalars['Float']>;
  items?: Maybe<Array<Maybe<AisleRestockItem>>>;
  lowStockCount?: Maybe<Scalars['Int']>;
  oosCount?: Maybe<Scalars['Int']>;
};

export enum AisleItemSortBy {
  AisleItemSortByEstimatedLostSales = 'AISLE_ITEM_SORT_BY_ESTIMATED_LOST_SALES',
  AisleItemSortByEstimatedLostUnits = 'AISLE_ITEM_SORT_BY_ESTIMATED_LOST_UNITS',
  AisleItemSortByLastScanDatetime = 'AISLE_ITEM_SORT_BY_LAST_SCAN_DATETIME',
  AisleItemSortByUnknown = 'AISLE_ITEM_SORT_BY_UNKNOWN',
  AisleItemSortByUrgencyScore = 'AISLE_ITEM_SORT_BY_URGENCY_SCORE'
}

export type AisleOrder = {
  __typename?: 'AisleOrder';
  inventoryAreaAisleId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['BigInt']>;
};

export type AisleOrderInput = {
  inventoryAreaAisleId?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['BigInt']>;
};

export type AisleRestockItem = {
  __typename?: 'AisleRestockItem';
  availabilityScore?: Maybe<Scalars['Float']>;
  backstockStatus?: Maybe<BackstockStatus>;
  category?: Maybe<Scalars['String']>;
  currentFacings?: Maybe<Scalars['Int']>;
  debugData?: Maybe<ItemDebugData>;
  department?: Maybe<Scalars['String']>;
  estimatedLostSales?: Maybe<Scalars['Float']>;
  estimatedLostUnits?: Maybe<Scalars['Float']>;
  expectedFacings?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  isKeyItem?: Maybe<Scalars['Boolean']>;
  isReplenishableNow?: Maybe<Scalars['Boolean']>;
  lastScanDatetime?: Maybe<Scalars['DateTime']>;
  missingScanImages?: Maybe<Array<Maybe<ProductScanImage>>>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  salesVelocity?: Maybe<Scalars['Float']>;
  shelfImageTimestamp?: Maybe<Scalars['DateTime']>;
  shelfImageUrl?: Maybe<Scalars['String']>;
  shelfImages?: Maybe<Array<Maybe<RestockShelfImage>>>;
  stockStatus?: Maybe<StockStatus>;
  upc?: Maybe<Scalars['String']>;
  urgencyScore?: Maybe<Scalars['Float']>;
};

export type AisleRestockRecommendationSummary = {
  __typename?: 'AisleRestockRecommendationSummary';
  aisleDisplayName?: Maybe<Scalars['String']>;
  aisleId?: Maybe<Scalars['String']>;
  backstockAvailableCount?: Maybe<Scalars['Int']>;
  estimatedLostSales?: Maybe<Scalars['Float']>;
  estimatedLostSalesFormatted?: Maybe<Scalars['String']>;
  lastScanTimestamp?: Maybe<Scalars['DateTime']>;
  lowStockCount?: Maybe<Scalars['Int']>;
  oosCount?: Maybe<Scalars['Int']>;
  totalRecommendationCount?: Maybe<Scalars['Int']>;
};

export type AisleRestockSummaryMetadata = {
  __typename?: 'AisleRestockSummaryMetadata';
  aisleScansInWindow?: Maybe<Scalars['Int']>;
  aisleScansToday?: Maybe<Scalars['Int']>;
  appliedSortBy?: Maybe<AisleSummarySortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  scanWindowHours?: Maybe<Scalars['Int']>;
  totalAislesScanned?: Maybe<Scalars['Int']>;
  totalEstimatedLostSales?: Maybe<Scalars['Float']>;
  totalLowStockItems?: Maybe<Scalars['Int']>;
  totalOosItems?: Maybe<Scalars['Int']>;
};

export type AisleSummary = {
  __typename?: 'AisleSummary';
  aisleDisplayName?: Maybe<Scalars['String']>;
  aisleId?: Maybe<Scalars['String']>;
  estimatedLostSales?: Maybe<Scalars['Float']>;
  lastScanTimestamp?: Maybe<Scalars['DateTime']>;
  lowStockCount?: Maybe<Scalars['Int']>;
  oosCount?: Maybe<Scalars['Int']>;
  replenishableNowCount?: Maybe<Scalars['Int']>;
  totalItemCount?: Maybe<Scalars['Int']>;
};

export enum AisleSummarySortBy {
  AisleSummarySortByEstimatedLostSales = 'AISLE_SUMMARY_SORT_BY_ESTIMATED_LOST_SALES',
  AisleSummarySortByLowStockCount = 'AISLE_SUMMARY_SORT_BY_LOW_STOCK_COUNT',
  AisleSummarySortByOosCount = 'AISLE_SUMMARY_SORT_BY_OOS_COUNT',
  AisleSummarySortByTotalItemCount = 'AISLE_SUMMARY_SORT_BY_TOTAL_ITEM_COUNT',
  AisleSummarySortByUnknown = 'AISLE_SUMMARY_SORT_BY_UNKNOWN'
}

export type AllNavigationWithContainersItems = {
  __typename?: 'AllNavigationWithContainersItems';
  container?: Maybe<Container>;
  flatNavigation?: Maybe<FlatNavigation>;
  navigationItem?: Maybe<NavigationV2Item>;
};

export type AllNavigationWithContainersItemsInput = {
  container?: InputMaybe<ContainerInput>;
  flatNavigation?: InputMaybe<FlatNavigationInput>;
  navigationItem?: InputMaybe<NavigationV2ItemInput>;
};

/** Placeholder reference to an AMS approval request. Fully wired in Sparse 3. */
export type AmsRequest = {
  __typename?: 'AmsRequest';
  /** AMS request id (nil while stubbed) */
  id?: Maybe<Scalars['ID']>;
  /** AMS request status (nil while stubbed) */
  status?: Maybe<Scalars['String']>;
  /** Names of the AMS triggers that fired */
  triggers?: Maybe<Array<Scalars['String']>>;
};

export type Analytics = {
  __typename?: 'Analytics';
  cadence?: Maybe<Cadence>;
  dateRange?: Maybe<InstacartAdsSharedV1DateRange>;
  entity?: Maybe<Entity>;
  metric?: Maybe<Metric>;
  valueToDate?: Maybe<Array<Maybe<AnalyticsUnit>>>;
  valueToDateV2?: Maybe<Array<Maybe<AnalyticsUnitV2>>>;
};

export type AnalyticsUnit = {
  __typename?: 'AnalyticsUnit';
  date?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
};

export type AnalyticsUnitV2 = {
  __typename?: 'AnalyticsUnitV2';
  date?: Maybe<GoogleTypeDate>;
  value?: Maybe<Scalars['Float']>;
};

export type AnomalousItemDateCount = {
  __typename?: 'AnomalousItemDateCount';
  count?: Maybe<Scalars['BigInt']>;
  date?: Maybe<Scalars['DateTime']>;
};

export enum AnomalyDetectionAlertLevel {
  Critical = 'critical',
  High = 'high',
  Low = 'low',
  Medium = 'medium',
  None = 'none'
}

export type AnomalyDetectionEntropyProfile = {
  __typename?: 'AnomalyDetectionEntropyProfile';
  high: Scalars['Int'];
  low: Scalars['Int'];
  moderate: Scalars['Int'];
  veryLow: Scalars['Int'];
};

export type AnomalyDetectionEntry = {
  __typename?: 'AnomalyDetectionEntry';
  alertLevel: AnomalyDetectionAlertLevel;
  avgEntropyScore: Scalars['Float'];
  avgSensitivityScore: Scalars['Float'];
  clientIps: Array<Scalars['String']>;
  compositeScore: Scalars['Int'];
  entropyProfile: AnomalyDetectionEntropyProfile;
  ipVariations: Scalars['Int'];
  ja3HashVariations: Scalars['Int'];
  ja3Hashes: Array<Scalars['String']>;
  lastActivity: Scalars['String'];
  recentRequestsCount: Scalars['Int'];
  requests: Array<AnomalyDetectionRequest>;
  sensitivityProfile: AnomalyDetectionSensitivityProfile;
  userAgentVariations: Scalars['Int'];
  userAgents: Array<Scalars['String']>;
  userInfo: AnomalyDetectionUserInfo;
};

export type AnomalyDetectionFilters = {
  alertLevel?: InputMaybe<AnomalyDetectionAlertLevel>;
  maxEntropyScore?: InputMaybe<Scalars['Int']>;
  maxJa3HashVariations?: InputMaybe<Scalars['Int']>;
  maxScore?: InputMaybe<Scalars['Int']>;
  minEntropyScore?: InputMaybe<Scalars['Int']>;
  minJa3HashVariations?: InputMaybe<Scalars['Int']>;
  minRequests?: InputMaybe<Scalars['Int']>;
  minScore?: InputMaybe<Scalars['Int']>;
  sensitivityCategory?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
};

export type AnomalyDetectionRequest = {
  __typename?: 'AnomalyDetectionRequest';
  clientIp: Scalars['String'];
  entropyScore: Scalars['Float'];
  operation: Scalars['String'];
  sensitivityCategory: Scalars['String'];
  sensitivityScore: Scalars['Int'];
  timestamp: Scalars['Float'];
};

export type AnomalyDetectionSensitivityProfile = {
  __typename?: 'AnomalyDetectionSensitivityProfile';
  financial: Scalars['Int'];
  pii: Scalars['Int'];
};

export enum AnomalyDetectionSortField {
  AlertLevel = 'alertLevel',
  CompositeScore = 'compositeScore',
  EntropyScore = 'entropyScore',
  LastActivity = 'lastActivity',
  RecentRequests = 'recentRequests',
  SensitivityScore = 'sensitivityScore'
}

export type AnomalyDetectionUserInfo = {
  __typename?: 'AnomalyDetectionUserInfo';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  uuid: Scalars['String'];
};

export type ApiIntegrationStoreLocation = {
  __typename?: 'ApiIntegrationStoreLocation';
  active?: Maybe<Scalars['Boolean']>;
  currentlySynced?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Defines the current state of the Approval Request. */
export enum ApprovalRequestState {
  /** Approval Request has been approved. */
  Approved = 'APPROVED',
  /** Approval Request has been cancelled. */
  Cancelled = 'CANCELLED',
  /** Approval Request is pending. */
  Pending = 'PENDING',
  /** Approval Request has been published. */
  Published = 'PUBLISHED',
  /** Approval Request is in the process of being published. */
  Publishing = 'PUBLISHING'
}

export type ApprovalRequestStatusResult = {
  __typename?: 'ApprovalRequestStatusResult';
  approvalRequest?: Maybe<LaunchOnboardingApprovalRequest>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Defines the resources that the Approval Request affects. */
export type ApprovalsManagementTypesAffectingScope = {
  __typename?: 'ApprovalsManagementTypesAffectingScope';
  /** The partner IDs affected by the approval request */
  partnerIds: Array<Scalars['String']>;
  /** The retailer IDs affected by the approval request */
  retailerIds: Array<Scalars['String']>;
  /** The retailer location IDs affected by the approval request */
  retailerLocationIds: Array<Scalars['String']>;
  /** The store configuration IDs affected by the approval request */
  storeConfigIds: Array<Scalars['String']>;
};

/** Per-group metadata for a resolved approval group. */
export type ApprovalsManagementTypesApprovalGroupInfo = {
  __typename?: 'ApprovalsManagementTypesApprovalGroupInfo';
  /** Stable join key (e.g. "PartnerReview"). */
  approvalGroupKey: Scalars['String'];
  /** Human-readable label for the group; falls back to the key when unset. */
  displayName: Scalars['String'];
  /** True when viewer-scoped visibility filtering hid eligible approvers, so the sibling `approvers` list is narrower than the real eligible set. */
  otherUsersExcluded: Scalars['Boolean'];
};

/** Snapshot of a single approval group's state for the current round. */
export type ApprovalsManagementTypesApprovalGroupStatus = {
  __typename?: 'ApprovalsManagementTypesApprovalGroupStatus';
  /** True if any APPROVAL activity exists for this (group, current round) */
  approved: Scalars['Boolean'];
  /** When this group was approved */
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The user who approved this group in the current round */
  approvedBy?: Maybe<EnterpriseAccount>;
  /** Keys of groups that must be approved before this group becomes eligible to act. */
  dependsOn: Array<Scalars['String']>;
  /** Human-friendly name for this group (e.g. 'Partner Review'). Falls back to `key` when YAML omits `display_name:`. */
  displayName: Scalars['String'];
  /** Stable join key for this group (e.g. 'PartnerReview'). Never user-facing — use `display_name` for that. */
  key: Scalars['String'];
  /** True iff this group is eligible to act in the current round (depends_on satisfied AND not yet approved this round). */
  pending: Scalars['Boolean'];
};

/** The Approval Request object. */
export type ApprovalsManagementTypesApprovalRequest = {
  __typename?: 'ApprovalsManagementTypesApprovalRequest';
  /** The resources affected by the changes underlying this approval request */
  affectingScope: ApprovalsManagementTypesAffectingScope;
  /** Increments on each rejection/revision; activities from prior rounds do not gate the new round. */
  approvalRound: Scalars['Int'];
  /** The base snapshot */
  baseSnapshot?: Maybe<ApprovalsManagementTypesContentSnapshotShallow>;
  /** Foreign keys pointing to the record(s) in the content's database */
  contentIds?: Maybe<Array<Scalars['String']>>;
  /** The content type, defined statically in AMS */
  contentType: Scalars['String'];
  /** The creation time of the approval request */
  createdAt: Scalars['ISO8601DateTime'];
  /** The user who created the approval request */
  createdByUser: EnterpriseAccount;
  /** Human-readable names of every approval group eligible to act in the current round. Each falls back to its key when YAML omits `display_name:`. */
  currentApprovalGroupDisplayNames: Array<Scalars['String']>;
  /** Stable join keys of every approval group eligible to act in the current round (depends_on satisfied, not yet approved). */
  currentApprovalGroupKeys: Array<Scalars['String']>;
  /** Per-group approval state for the current round. Single-approver integrations surface as a one-element array under the synthetic 'Approval' key. */
  groupStatuses: Array<ApprovalsManagementTypesApprovalGroupStatus>;
  /** The unique UUID for the Approval Request */
  id: Scalars['ID'];
  /** Used to de-duplicate Approval Requests */
  idempotencyId: Scalars['String'];
  /** Optional opaque metadata for the Approval Request */
  metadata?: Maybe<Scalars['JSON']>;
  /** A user-provided name/description for the Approval Request */
  name: Scalars['String'];
  /** The current state of the approval request */
  requestState: ApprovalRequestState;
  /** Reviews posted on this approval request */
  reviews: Array<ApprovalsManagementTypesUserReviewReference>;
  /** The list of revision snapshots */
  revisionSnapshots?: Maybe<Array<ApprovalsManagementTypesContentSnapshotShallow>>;
};

/** Eligible approvers for a single approval request as two flat lists. */
export type ApprovalsManagementTypesApprovalRequestApprovers = {
  __typename?: 'ApprovalsManagementTypesApprovalRequestApprovers';
  /** Eligible approvers, one row per (user, group) pairing. */
  approvers: Array<ApprovalsManagementTypesCandidateApprover>;
  /** The approval request these approvers belong to. */
  arId: Scalars['ID'];
  /** One entry per selected group (the requested keys, or the AR's current-stage groups when none are given), including groups with no visible approvers. */
  groups: Array<ApprovalsManagementTypesApprovalGroupInfo>;
};

/** An IPP user eligible to approve an approval group. */
export type ApprovalsManagementTypesApproverUser = {
  __typename?: 'ApprovalsManagementTypesApproverUser';
  /** The user's first (given) name. */
  name?: Maybe<Scalars['String']>;
  /** The user's email. */
  userEmail?: Maybe<Scalars['String']>;
  /** The user's canonical ID. */
  userUuid: Scalars['String'];
};

/** An eligible approver tagged with the approval group they qualify for. */
export type ApprovalsManagementTypesCandidateApprover = {
  __typename?: 'ApprovalsManagementTypesCandidateApprover';
  /** The group the user qualifies for; joins to the sibling `groups` list's approvalGroupKey. */
  approvalGroupKey: Scalars['String'];
  /** The user whose scoped permissions qualify them to approve `approvalGroupKey`. */
  approver: ApprovalsManagementTypesApproverUser;
};

/** A shallow snapshot, used primarily for referencing content revisions. */
export type ApprovalsManagementTypesContentSnapshot = {
  __typename?: 'ApprovalsManagementTypesContentSnapshot';
  /** The ID of the request associated with the snapshot */
  approvalRequestId: Scalars['ID'];
  /** The content of the snapshot, serialized as a string */
  contentBytes: Scalars['String'];
  /** Metadata associated with the content at the time of the snapshot */
  contentMetadata: Scalars['JSON'];
  /** The time at which the snapshot was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the snapshot */
  id: Scalars['ID'];
  /** The ID of the review associated with the snapshot */
  reviewId?: Maybe<Scalars['ID']>;
  /** The type of the snapshot: [BASE, REVISION] */
  snapshotType: ContentSnapshot;
};

/** A shallow snapshot, used primarily for referencing content revisions. */
export type ApprovalsManagementTypesContentSnapshotShallow = {
  __typename?: 'ApprovalsManagementTypesContentSnapshotShallow';
  /** The ID of the request associated with the snapshot */
  approvalRequestId: Scalars['ID'];
  /** Metadata associated with the content at the time of the snapshot */
  contentMetadata: Scalars['JSON'];
  /** The time at which the snapshot was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the snapshot */
  id: Scalars['ID'];
  /** The ID of the review associated with the snapshot */
  reviewId?: Maybe<Scalars['ID']>;
  /** The type of the snapshot: [BASE, REVISION] */
  snapshotType: ContentSnapshot;
};

/** Defines the resources that the Approval Request affects. */
export type ApprovalsManagementTypesListApprovalRequestsResult = {
  __typename?: 'ApprovalsManagementTypesListApprovalRequestsResult';
  /** The approval requests */
  approvalRequests: Array<ApprovalsManagementTypesApprovalRequest>;
  /** The total number of approval requests that match the scope, regardless of offset and limit */
  totalCount: Scalars['Int'];
};

/** Describes the actions a user is permitted to take on an approval request */
export type ApprovalsManagementTypesUserPermittedActions = {
  __typename?: 'ApprovalsManagementTypesUserPermittedActions';
  /** The unique ID of the Approval Request. */
  approvalRequestId: Scalars['ID'];
  /** Whether the user can approve the approval request. */
  canApprove: Scalars['Boolean'];
  /** Whether the user can publish the approval request via break glass. */
  canBreakGlassPublish: Scalars['Boolean'];
  /** Whether the user can cancel the approval request. */
  canCancel: Scalars['Boolean'];
  /** Whether the user can comment on the approval request. */
  canComment: Scalars['Boolean'];
  /** Whether the user can publish the approval request. */
  canPublish: Scalars['Boolean'];
  /** Whether the user can revise the approval request. */
  canRevise: Scalars['Boolean'];
  /** Human-readable names of every approval group eligible to act this round. Each falls back to its key when YAML omits `display_name:`. */
  currentApprovalGroupDisplayNames: Array<Scalars['String']>;
  /** Stable join keys of every approval group eligible to act this round (depends_on satisfied). */
  currentApprovalGroupKeys: Array<Scalars['String']>;
  /** Total number of approval groups configured for this AR's content type. */
  totalApprovalGroups: Scalars['Int'];
};

/** The content of a user's review. */
export type ApprovalsManagementTypesUserReviewContent = {
  __typename?: 'ApprovalsManagementTypesUserReviewContent';
  /** The action the user performed */
  action: ReviewAction;
  /** Optional user comment */
  comment?: Maybe<Scalars['String']>;
};

/** A User Review Content with a unique identifier. */
export type ApprovalsManagementTypesUserReviewReference = {
  __typename?: 'ApprovalsManagementTypesUserReviewReference';
  /** Human-readable names parallel to `approval_group_keys`. Each falls back to its key when YAML omits `display_name:`. */
  approvalGroupDisplayNames: Array<Scalars['String']>;
  /** Stable join keys of the groups this single click covered (Option B implicit multi-stamp). Populated only on APPROVAL / APPROVAL_AND_PUBLISH rows; empty for non-approval actions. */
  approvalGroupKeys: Array<Scalars['String']>;
  /** The ID of the Approval Request this review is posted on */
  arId: Scalars['ID'];
  /** The time the review was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the User Review */
  id: Scalars['ID'];
  /** The User Review content */
  reviewContent: ApprovalsManagementTypesUserReviewContent;
  /** The user that made the review */
  reviewedBy: EnterpriseAccount;
  /** The revision snapshot, if the review was posting a new revision */
  revisionSnapshot?: Maybe<ApprovalsManagementTypesContentSnapshot>;
  /** Time the review was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export enum AreaOfInterest {
  AreaOfInterestUnknown = 'AREA_OF_INTEREST_UNKNOWN',
  Claims = 'CLAIMS',
  DistributionVolume = 'DISTRIBUTION_VOLUME',
  ItemImage = 'ITEM_IMAGE',
  ProductSales = 'PRODUCT_SALES',
  UnitLevelPricing = 'UNIT_LEVEL_PRICING'
}

export enum AssetType {
  AppleTouchIcon = 'APPLE_TOUCH_ICON',
  CreativeAsset = 'CREATIVE_ASSET',
  Favicon = 'FAVICON',
  Font = 'FONT',
  FrothTemplatePreview = 'FROTH_TEMPLATE_PREVIEW',
  ItemAttributeIcon = 'ITEM_ATTRIBUTE_ICON',
  LandingPageBackgroundImage = 'LANDING_PAGE_BACKGROUND_IMAGE',
  Logo = 'LOGO',
  Loyalty = 'LOYALTY',
  MobileBackgroundImage = 'MOBILE_BACKGROUND_IMAGE',
  MobileLogo = 'MOBILE_LOGO',
  RetailerLogos = 'RETAILER_LOGOS',
  RewardsProgramLogo = 'REWARDS_PROGRAM_LOGO',
  Unknown = 'UNKNOWN'
}

/** Autogenerated return type of AssignPermissionToRole */
export type AssignPermissionToRolePayload = {
  __typename?: 'AssignPermissionToRolePayload';
  /** The role with the new permissions */
  role: EnterpriseRole;
};

export type AssignVirtualBatchRequestInput = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  batchType?: InputMaybe<BatchType>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  order?: InputMaybe<OrderInput>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
};

export type AssignVirtualBatchResponse = {
  __typename?: 'AssignVirtualBatchResponse';
  id?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Scalars['String']>;
};

export enum AtomsColor {
  AtomsColorUnknown = 'ATOMS_COLOR_UNKNOWN',
  BrandHighlightDark = 'BRAND_HIGHLIGHT_DARK',
  BrandHighlightLight = 'BRAND_HIGHLIGHT_LIGHT',
  BrandHighlightRegular = 'BRAND_HIGHLIGHT_REGULAR',
  BrandLoyaltyDark = 'BRAND_LOYALTY_DARK',
  BrandLoyaltyLight = 'BRAND_LOYALTY_LIGHT',
  BrandLoyaltyRegular = 'BRAND_LOYALTY_REGULAR',
  BrandPrimaryDark = 'BRAND_PRIMARY_DARK',
  BrandPrimaryExtraDark = 'BRAND_PRIMARY_EXTRA_DARK',
  BrandPrimaryRegular = 'BRAND_PRIMARY_REGULAR',
  BrandPromotionalDark = 'BRAND_PROMOTIONAL_DARK',
  BrandPromotionalLight = 'BRAND_PROMOTIONAL_LIGHT',
  BrandPromotionalRegular = 'BRAND_PROMOTIONAL_REGULAR',
  BrandSecondaryDark = 'BRAND_SECONDARY_DARK',
  BrandSecondaryLight = 'BRAND_SECONDARY_LIGHT',
  BrandSecondaryRegular = 'BRAND_SECONDARY_REGULAR',
  BrandTertiaryRegular = 'BRAND_TERTIARY_REGULAR',
  MaxYellow = 'MAX_YELLOW',
  PlusDark = 'PLUS_DARK',
  PlusExtraDark = 'PLUS_EXTRA_DARK',
  PlusExtraLight = 'PLUS_EXTRA_LIGHT',
  PlusLight = 'PLUS_LIGHT',
  PlusRegular = 'PLUS_REGULAR',
  SystemDetrimentalDark = 'SYSTEM_DETRIMENTAL_DARK',
  SystemDetrimentalExtraDark = 'SYSTEM_DETRIMENTAL_EXTRA_DARK',
  SystemDetrimentalLight = 'SYSTEM_DETRIMENTAL_LIGHT',
  SystemDetrimentalRegular = 'SYSTEM_DETRIMENTAL_REGULAR',
  SystemGrayscale00 = 'SYSTEM_GRAYSCALE00',
  SystemGrayscale10 = 'SYSTEM_GRAYSCALE10',
  SystemGrayscale20 = 'SYSTEM_GRAYSCALE20',
  SystemGrayscale30 = 'SYSTEM_GRAYSCALE30',
  SystemGrayscale50 = 'SYSTEM_GRAYSCALE50',
  SystemGrayscale70 = 'SYSTEM_GRAYSCALE70',
  SystemSuccessDark = 'SYSTEM_SUCCESS_DARK',
  SystemSuccessLight = 'SYSTEM_SUCCESS_LIGHT',
  SystemSuccessRegular = 'SYSTEM_SUCCESS_REGULAR'
}

export type AttributeData = {
  __typename?: 'AttributeData';
  attributeName?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<Scalars['String']>;
  productSourceId?: Maybe<Scalars['BigInt']>;
  sourceId?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
};

export type AuditBatch = {
  __typename?: 'AuditBatch';
  allowSuggestedValues?: Maybe<Scalars['Boolean']>;
  assignee?: Maybe<Scalars['String']>;
  assigneeAt?: Maybe<Scalars['DateTime']>;
  auditableTaskCount?: Maybe<Scalars['BigInt']>;
  auditableTasks?: Maybe<Array<Maybe<AuditTask>>>;
  auditedTaskCount?: Maybe<Scalars['BigInt']>;
  batchId?: Maybe<Scalars['BigInt']>;
  batchMetadata?: Maybe<Scalars['String']>;
  batchState?: Maybe<Scalars['String']>;
  batchUuid?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  correctnessThresholdCount?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extComment?: Maybe<Scalars['String']>;
  incorrectTaskCount?: Maybe<Scalars['BigInt']>;
  intComment?: Maybe<Scalars['String']>;
  isExplicitFailedRedrive?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Scalars['String']>;
  ownerAt?: Maybe<Scalars['DateTime']>;
  priority?: Maybe<Scalars['Int']>;
  recommendedSampleSize?: Maybe<Scalars['BigInt']>;
  reviewer?: Maybe<Scalars['String']>;
  reviewerAt?: Maybe<Scalars['DateTime']>;
  sampleTaskCount?: Maybe<Scalars['BigInt']>;
  sampleTasks?: Maybe<Array<Maybe<AuditTask>>>;
  secondaryStateId?: Maybe<Scalars['BigInt']>;
  slaDueDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  tasksRequiredToReviewCount?: Maybe<Scalars['BigInt']>;
  version?: Maybe<Scalars['BigInt']>;
  workflow?: Maybe<Scalars['String']>;
};

export type AuditDetectionRequestInput = {
  auditedBy?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  state?: InputMaybe<DetectionStatusState>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type AuditDetectionResponse = {
  __typename?: 'AuditDetectionResponse';
  _?: Maybe<Scalars['Boolean']>;
};

/** Coarse event type for the audit-page event-type filter (§5.4). */
export enum AuditEventType {
  /** Create events */
  Create = 'CREATE',
  /** Delete events */
  Delete = 'DELETE',
  /** Update events */
  Update = 'UPDATE'
}

export enum AuditLogEntityTypeEnum {
  /** Account entity */
  Account = 'ACCOUNT',
  /** Aisle entity */
  Aisle = 'AISLE',
  /** Collection entity */
  Collection = 'COLLECTION',
  /** ContentPage entity */
  ContentPage = 'CONTENT_PAGE',
  /** ContentPageVersion entity */
  ContentPageVersion = 'CONTENT_PAGE_VERSION',
  /** ContentPageVersionMeta entity */
  ContentPageVersionMeta = 'CONTENT_PAGE_VERSION_META',
  /** Department entity */
  Department = 'DEPARTMENT',
  /** DepartmentNavigation entity */
  DepartmentNavigation = 'DEPARTMENT_NAVIGATION',
  /** Item entity */
  Item = 'ITEM',
  /** Placement entity */
  Placement = 'PLACEMENT',
  /** Product entity */
  Product = 'PRODUCT',
  /** RetailerCampaign entity */
  RetailerCampaign = 'RETAILER_CAMPAIGN',
  /** Role entity */
  Role = 'ROLE'
}

/** An audit-log entry spanning bulk + singular account/role events. */
export type AuditLogEntry = {
  __typename?: 'AuditLogEntry';
  /** The account that performed the change */
  actor?: Maybe<EnterpriseAccount>;
  /** Canonical after-state row for replay; null when not replayable */
  afterRow?: Maybe<Scalars['JSON']>;
  /** Raw event name */
  eventName: Scalars['String'];
  /** When the event occurred */
  eventTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Audit-log record id */
  id: Scalars['ID'];
  /** Whether this entry came from a bulk operation */
  isBulk: Scalars['Boolean'];
  /** Bulk operation UUID (trace_id) if any */
  operationId?: Maybe<Scalars['ID']>;
  /** Whether this entry carries a canonical row and can be replayed */
  replayable: Scalars['Boolean'];
  /** Partner/retailer/location scope summary */
  scopeSummary?: Maybe<Scalars['String']>;
  /** Whether the change succeeded */
  succeeded: Scalars['Boolean'];
  /** Id of the targeted entity */
  targetId?: Maybe<Scalars['ID']>;
  /** Target entity kind (USER | ROLE) */
  targetKind?: Maybe<AuditTargetKind>;
  /** Human-readable label for the targeted entity */
  targetLabel?: Maybe<Scalars['String']>;
};

/** Filters applied to the bulkAuditLog query (audit page, §5.4). */
export type AuditLogFilter = {
  /** Filter to entries acted on by this account. */
  actorAccountId?: InputMaybe<Scalars['ID']>;
  /** Restrict to bulk-operation completion events. */
  bulkOnly?: InputMaybe<Scalars['Boolean']>;
  /** Coarse event type (CREATE | UPDATE | DELETE). */
  eventType?: InputMaybe<AuditEventType>;
  /** Id within the chosen scope dimension. */
  scopeId?: InputMaybe<Scalars['ID']>;
  /** Scope dimension to filter by (PARTNER | RETAILER | LOCATION). */
  scopeKind?: InputMaybe<AuditScopeKind>;
  /** Event-time lower bound. */
  since?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Restrict to successful events only. */
  successfulOnly?: InputMaybe<Scalars['Boolean']>;
  /** Filter to entries targeting this entity id. */
  targetId?: InputMaybe<Scalars['ID']>;
  /** Target entity kind (USER | ROLE). */
  targetKind?: InputMaybe<AuditTargetKind>;
  /** Event-time upper bound. */
  until?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Paginated list of audit-log entries. */
export type AuditLogPage = {
  __typename?: 'AuditLogPage';
  entries: Array<AuditLogEntry>;
  totalCount: Scalars['Int'];
};

export type AuditLogsAuditLog = {
  __typename?: 'AuditLogsAuditLog';
  /** The email of the account that made the change */
  accountEmail: Scalars['String'];
  /** The UUID of the account that made the change */
  accountUuid: Scalars['ID'];
  /** The entities related to this change */
  entities?: Maybe<Array<AuditLogsAuditLogEntity>>;
  /** Event name */
  eventName?: Maybe<Scalars['String']>;
  /** Time that the audit log event took place */
  eventTime: Scalars['ISO8601DateTime'];
  /** The internal unique identifier for the audit log */
  id: Scalars['ID'];
  /** The email of the account being impersonated */
  impersonatedAccountEmail?: Maybe<Scalars['String']>;
  /** The UUID of the account being impersonated */
  impersonatedAccountUuid?: Maybe<Scalars['ID']>;
  /** Whether or not the change was successful */
  success?: Maybe<Scalars['Boolean']>;
};

/** The connection type for AuditLogsAuditLog. */
export type AuditLogsAuditLogConnection = {
  __typename?: 'AuditLogsAuditLogConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AuditLogsAuditLogEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AuditLogsAuditLog>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AuditLogsAuditLogEdge = {
  __typename?: 'AuditLogsAuditLogEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<AuditLogsAuditLog>;
};

export type AuditLogsAuditLogEntity = {
  __typename?: 'AuditLogsAuditLogEntity';
  /** The entity display name */
  entityDisplayName?: Maybe<Scalars['String']>;
  /** The identifier of the entity */
  entityIds: Array<Scalars['ID']>;
  /** The entity type */
  entityType: AuditLogEntityTypeEnum;
  /** The internal unique identifier for the audit log entity */
  id: Scalars['ID'];
};

/** Which bulk editor the audit-log replay should open in. */
export enum AuditReplayTarget {
  /** Open in Bulk Roles editor */
  Role = 'ROLE',
  /** Open in Bulk Users editor */
  User = 'USER'
}

/** Scope dimension for the audit-page scope filter (§5.4). */
export enum AuditScopeKind {
  /** Scope to a retailer location */
  Location = 'LOCATION',
  /** Scope to a partner */
  Partner = 'PARTNER',
  /** Scope to a retailer */
  Retailer = 'RETAILER'
}

/** Target entity kind of an audit-log entry (audit page, §5.4). */
export enum AuditTargetKind {
  /** Audit entry targets a role */
  Role = 'ROLE',
  /** Audit entry targets a user/account */
  User = 'USER'
}

export type AuditTask = {
  __typename?: 'AuditTask';
  batchUuid?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId?: Maybe<EntityId>;
  extComment?: Maybe<Scalars['String']>;
  inputData?: Maybe<Scalars['String']>;
  intComment?: Maybe<Scalars['String']>;
  reviewState?: Maybe<Scalars['String']>;
  taskComponents?: Maybe<Array<Maybe<AuditTaskTaskComponent>>>;
  taskState?: Maybe<Scalars['String']>;
  taskUuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
  workflow?: Maybe<Scalars['String']>;
};

export type AuditTaskTaskComponent = {
  __typename?: 'AuditTaskTaskComponent';
  explicitAuditFailed?: Maybe<Scalars['Boolean']>;
  extComment?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  intComment?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  reviewState?: Maybe<Scalars['String']>;
  suggestedValue?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueType?: Maybe<Scalars['String']>;
};

export type AuditWorkflow = {
  __typename?: 'AuditWorkflow';
  approvedTaskCount?: Maybe<Scalars['BigInt']>;
  auditableTaskCount?: Maybe<Scalars['BigInt']>;
  correctnessThresholdPct?: Maybe<Scalars['Float']>;
  defaultPriority?: Maybe<Scalars['Int']>;
  defaultSamplePct?: Maybe<Scalars['Float']>;
  defaultSlaDays?: Maybe<Scalars['BigInt']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  failOverPct?: Maybe<Scalars['Float']>;
  firstPendingSlaDueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  numTasksPerBatch?: Maybe<Scalars['BigInt']>;
  rejectedTaskCount?: Maybe<Scalars['BigInt']>;
  taskReviewPct?: Maybe<Scalars['Float']>;
};

export type AuditWorkflowConfig = {
  __typename?: 'AuditWorkflowConfig';
  configType?: Maybe<Scalars['String']>;
  configValue?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  workflowL1?: Maybe<Scalars['String']>;
  workflowL2?: Maybe<Scalars['String']>;
  workflowL3?: Maybe<Scalars['String']>;
};

export type AuditWorkflowConfigInput = {
  configType?: InputMaybe<Scalars['String']>;
  configValue?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  workflowL1?: InputMaybe<Scalars['String']>;
  workflowL2?: InputMaybe<Scalars['String']>;
  workflowL3?: InputMaybe<Scalars['String']>;
};

export type AuditWorkflowInput = {
  approvedTaskCount?: InputMaybe<Scalars['BigInt']>;
  auditableTaskCount?: InputMaybe<Scalars['BigInt']>;
  correctnessThresholdPct?: InputMaybe<Scalars['Float']>;
  defaultPriority?: InputMaybe<Scalars['Int']>;
  defaultSamplePct?: InputMaybe<Scalars['Float']>;
  defaultSlaDays?: InputMaybe<Scalars['BigInt']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  failOverPct?: InputMaybe<Scalars['Float']>;
  firstPendingSlaDueDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  numTasksPerBatch?: InputMaybe<Scalars['BigInt']>;
  rejectedTaskCount?: InputMaybe<Scalars['BigInt']>;
  taskReviewPct?: InputMaybe<Scalars['Float']>;
};

export type AuthUserData = {
  __typename?: 'AuthUserData';
  /** Whether the user uses a password or not */
  usesPassword: Scalars['Boolean'];
};

export type Authentication = {
  __typename?: 'Authentication';
  postAuthPaths?: Maybe<PostAuthPaths>;
};

export type AuthenticationInput = {
  postAuthPaths?: InputMaybe<PostAuthPathsInput>;
};

/** The method of authentication associated with an account */
export type AuthenticationInterface = {
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID'];
};

export type AuthorizationContextInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type AutocompleteLocation = {
  __typename?: 'AutocompleteLocation';
  city?: Maybe<Scalars['String']>;
  placeId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  secondaryAddress?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type AvailableOfferFilter = {
  __typename?: 'AvailableOfferFilter';
  filterKey?: Maybe<Scalars['String']>;
  filterValue?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Background = {
  __typename?: 'Background';
  colorHex?: Maybe<Scalars['String']>;
  fillMode?: Maybe<BackgroundFillMode>;
  image?: Maybe<BackgroundImage>;
};

export enum BackgroundFillMode {
  FillModeContentWidth = 'FILL_MODE_CONTENT_WIDTH',
  FillModeFullBleed = 'FILL_MODE_FULL_BLEED',
  FillModeUnspecified = 'FILL_MODE_UNSPECIFIED'
}

export type BackgroundImage = {
  __typename?: 'BackgroundImage';
  imageMobileUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type BackgroundImageInput = {
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
};

export type BackgroundInput = {
  colorHex?: InputMaybe<Scalars['String']>;
  fillMode?: InputMaybe<BackgroundFillMode>;
  image?: InputMaybe<BackgroundImageInput>;
};

export enum BackstockStatus {
  BackstockStatusAvailable = 'BACKSTOCK_STATUS_AVAILABLE',
  BackstockStatusNone = 'BACKSTOCK_STATUS_NONE',
  BackstockStatusUnknown = 'BACKSTOCK_STATUS_UNKNOWN'
}

export type Banner = {
  __typename?: 'Banner';
  action?: Maybe<Scalars['String']>;
  actionData?: Maybe<Scalars['String']>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  buttonStyle?: Maybe<ButtonStyle>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaColorHex?: Maybe<Scalars['String']>;
  dataQuery?: Maybe<DataQuery>;
  id?: Maybe<Scalars['BigInt']>;
  imageAltText?: Maybe<Scalars['String']>;
  imageMobileUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  status?: Maybe<Status>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  taglineColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type BannerAction = {
  __typename?: 'BannerAction';
  dismissBusinessIdentication?: Maybe<DismissBusinessIdentication>;
  doNotNavigate?: Maybe<DoNotNavigate>;
  navigateToAllCarts?: Maybe<NavigateToAllCarts>;
  navigateToAskInstacart?: Maybe<NavigateToAskInstacart>;
  navigateToAuthentication?: Maybe<NavigateToAuthentication>;
  navigateToBenefitsModal?: Maybe<NavigateToBenefitsModal>;
  navigateToCategorySurface?: Maybe<NavigateToCategorySurface>;
  navigateToCollaborativeShopInfoModal?: Maybe<NavigateToCollaborativeShopInfoModal>;
  navigateToCollection?: Maybe<NavigateToCollection>;
  navigateToCollectionHub?: Maybe<NavigateToCollectionHub>;
  navigateToContainerPathViaStoreselector?: Maybe<NavigateToContainerPathViaStoreSelector>;
  navigateToContentPage?: Maybe<NavigateToContentPage>;
  navigateToCouponRedemption?: Maybe<NavigateToCouponRedemption>;
  navigateToDepartment?: Maybe<NavigateToDepartment>;
  navigateToExpressAccountPage?: Maybe<NavigateToExpressAccountPage>;
  navigateToFlyers?: Maybe<NavigateToFlyers>;
  navigateToHouseholdAccountSharingFlow?: Maybe<NavigateToHouseholdAccountSharingFlow>;
  navigateToPartnershipModal?: Maybe<NavigateToPartnershipModal>;
  navigateToPickupStoreselector?: Maybe<NavigateToPickupStoreSelector>;
  navigateToProduct?: Maybe<NavigateToProduct>;
  navigateToPromoModal?: Maybe<NavigateToPromoModal>;
  navigateToPromotionDetail?: Maybe<NavigateToPromotionDetail>;
  navigateToRetailerCollection?: Maybe<NavigateToRetailerCollection>;
  navigateToRetailerCollectionViaStoreselector?: Maybe<NavigateToRetailerCollectionViaStoreSelector>;
  navigateToSsaStoreselector?: Maybe<NavigateToSsaStoreSelector>;
  navigateToStoreSelectorWithOffer?: Maybe<NavigateToStoreSelectorWithOffer>;
  navigateToStorefront?: Maybe<NavigateToStorefront>;
  navigateToStoreselector?: Maybe<NavigateToStoreSelector>;
  navigateToUrl?: Maybe<NavigateToUrl>;
  openExpressPaidModal?: Maybe<OpenExpressPaidModal>;
  openExpressTrialModal?: Maybe<OpenExpressTrialModal>;
  optInUser?: Maybe<OptInUser>;
  redeemPartnershipOffer?: Maybe<RedeemPartnershipOffer>;
  renewSubscriptionIntoAnnual?: Maybe<RenewSubscriptionIntoAnnual>;
  renewSubscriptionIntoMonthly?: Maybe<RenewSubscriptionIntoMonthly>;
};

export type BannerActionInput = {
  dismissBusinessIdentication?: InputMaybe<DismissBusinessIdenticationInput>;
  doNotNavigate?: InputMaybe<DoNotNavigateInput>;
  navigateToAllCarts?: InputMaybe<NavigateToAllCartsInput>;
  navigateToAskInstacart?: InputMaybe<NavigateToAskInstacartInput>;
  navigateToAuthentication?: InputMaybe<NavigateToAuthenticationInput>;
  navigateToBenefitsModal?: InputMaybe<NavigateToBenefitsModalInput>;
  navigateToCategorySurface?: InputMaybe<NavigateToCategorySurfaceInput>;
  navigateToCollaborativeShopInfoModal?: InputMaybe<NavigateToCollaborativeShopInfoModalInput>;
  navigateToCollection?: InputMaybe<NavigateToCollectionInput>;
  navigateToCollectionHub?: InputMaybe<NavigateToCollectionHubInput>;
  navigateToContainerPathViaStoreselector?: InputMaybe<NavigateToContainerPathViaStoreSelectorInput>;
  navigateToContentPage?: InputMaybe<NavigateToContentPageInput>;
  navigateToCouponRedemption?: InputMaybe<NavigateToCouponRedemptionInput>;
  navigateToDepartment?: InputMaybe<NavigateToDepartmentInput>;
  navigateToExpressAccountPage?: InputMaybe<NavigateToExpressAccountPageInput>;
  navigateToFlyers?: InputMaybe<NavigateToFlyersInput>;
  navigateToHouseholdAccountSharingFlow?: InputMaybe<NavigateToHouseholdAccountSharingFlowInput>;
  navigateToPartnershipModal?: InputMaybe<NavigateToPartnershipModalInput>;
  navigateToPickupStoreselector?: InputMaybe<NavigateToPickupStoreSelectorInput>;
  navigateToProduct?: InputMaybe<NavigateToProductInput>;
  navigateToPromoModal?: InputMaybe<NavigateToPromoModalInput>;
  navigateToPromotionDetail?: InputMaybe<NavigateToPromotionDetailInput>;
  navigateToRetailerCollection?: InputMaybe<NavigateToRetailerCollectionInput>;
  navigateToRetailerCollectionViaStoreselector?: InputMaybe<NavigateToRetailerCollectionViaStoreSelectorInput>;
  navigateToSsaStoreselector?: InputMaybe<NavigateToSsaStoreSelectorInput>;
  navigateToStoreSelectorWithOffer?: InputMaybe<NavigateToStoreSelectorWithOfferInput>;
  navigateToStorefront?: InputMaybe<NavigateToStorefrontInput>;
  navigateToStoreselector?: InputMaybe<NavigateToStoreSelectorInput>;
  navigateToUrl?: InputMaybe<NavigateToUrlInput>;
  openExpressPaidModal?: InputMaybe<OpenExpressPaidModalInput>;
  openExpressTrialModal?: InputMaybe<OpenExpressTrialModalInput>;
  optInUser?: InputMaybe<OptInUserInput>;
  redeemPartnershipOffer?: InputMaybe<RedeemPartnershipOfferInput>;
  renewSubscriptionIntoAnnual?: InputMaybe<RenewSubscriptionIntoAnnualInput>;
  renewSubscriptionIntoMonthly?: InputMaybe<RenewSubscriptionIntoMonthlyInput>;
};

export type BannerInput = {
  action?: InputMaybe<Scalars['String']>;
  actionData?: InputMaybe<Scalars['String']>;
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  buttonStyle?: InputMaybe<ButtonStyle>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  dataQuery?: InputMaybe<DataQueryInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  status?: InputMaybe<Status>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  taglineColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export enum BannerLocaleEnum {
  /** Canadian English */
  EnCa = 'EN_CA',
  /** American English */
  EnUs = 'EN_US',
  /** Canadian French */
  FrCa = 'FR_CA'
}

export type BannerType = {
  __typename?: 'BannerType';
  compactBanner?: Maybe<CompactBanner>;
  defaultBanner?: Maybe<Banner>;
  heroBanner?: Maybe<HeroBanner>;
  imageForward?: Maybe<ImageForward>;
  imageForwardFlex?: Maybe<ImageForwardFlex>;
  infoSheet?: Maybe<StandardInfoModalSheet>;
  logoWithTextBanner?: Maybe<LogoWithTextBanner>;
  secondaryBanner?: Maybe<SecondaryBanner>;
  textWithThumbnail?: Maybe<TextWithThumbnail>;
  textWithThumbnailFlex?: Maybe<TextWithThumbnailFlex>;
  unknownBanner?: Maybe<UnknownBanner>;
};

export type BannerTypeInput = {
  compactBanner?: InputMaybe<CompactBannerInput>;
  defaultBanner?: InputMaybe<BannerInput>;
  heroBanner?: InputMaybe<HeroBannerInput>;
  imageForward?: InputMaybe<ImageForwardInput>;
  imageForwardFlex?: InputMaybe<ImageForwardFlexInput>;
  infoSheet?: InputMaybe<StandardInfoModalSheetInput>;
  logoWithTextBanner?: InputMaybe<LogoWithTextBannerInput>;
  secondaryBanner?: InputMaybe<SecondaryBannerInput>;
  textWithThumbnail?: InputMaybe<TextWithThumbnailInput>;
  textWithThumbnailFlex?: InputMaybe<TextWithThumbnailFlexInput>;
  unknownBanner?: InputMaybe<UnknownBannerInput>;
};

export enum BannerVariant {
  AnchorLink = 'ANCHOR_LINK',
  AppDownloadModal = 'APP_DOWNLOAD_MODAL',
  AsyncImage = 'ASYNC_IMAGE',
  AsyncModal = 'ASYNC_MODAL',
  BannerRow = 'BANNER_ROW',
  BottomTracker = 'BOTTOM_TRACKER',
  BusinessIdentificationShopBanner = 'BUSINESS_IDENTIFICATION_SHOP_BANNER',
  BusinessProfileModalApproverBuyerTier = 'BUSINESS_PROFILE_MODAL_APPROVER_BUYER_TIER',
  BusinessProfileModalIcPlus = 'BUSINESS_PROFILE_MODAL_IC_PLUS',
  BusinessProfileModalNonIcPlus = 'BUSINESS_PROFILE_MODAL_NON_IC_PLUS',
  BusinessProfileModalOwnerAdminTier = 'BUSINESS_PROFILE_MODAL_OWNER_ADMIN_TIER',
  BusinessProfileTakeover = 'BUSINESS_PROFILE_TAKEOVER',
  BusinessProfileUpsellFlyout = 'BUSINESS_PROFILE_UPSELL_FLYOUT',
  CarouselCard = 'CAROUSEL_CARD',
  CartIncentiveTrackerDetailSavingMessageBanner = 'CART_INCENTIVE_TRACKER_DETAIL_SAVING_MESSAGE_BANNER',
  CartIncentiveTrackerFlyOutBanner = 'CART_INCENTIVE_TRACKER_FLY_OUT_BANNER',
  CartIncentiveTrackerM3Banner = 'CART_INCENTIVE_TRACKER_M3_BANNER',
  CartTracker = 'CART_TRACKER',
  CategoryHub = 'CATEGORY_HUB',
  ChurnedUserSurvey = 'CHURNED_USER_SURVEY',
  Coachmark = 'COACHMARK',
  CompactBanner = 'COMPACT_BANNER',
  ContentCard = 'CONTENT_CARD',
  ContentPageEntry = 'CONTENT_PAGE_ENTRY',
  CrossRetailerPickerSearchBar = 'CROSS_RETAILER_PICKER_SEARCH_BAR',
  FeedUnit = 'FEED_UNIT',
  FlyerBanner = 'FLYER_BANNER',
  FullWidth = 'FULL_WIDTH',
  Gamification = 'GAMIFICATION',
  Header = 'HEADER',
  HeroBanner = 'HERO_BANNER',
  HomeHeroUnitBanner = 'HOME_HERO_UNIT_BANNER',
  HomeSavingsCardBanner = 'HOME_SAVINGS_CARD_BANNER',
  IcPlusAutoAssignModal = 'IC_PLUS_AUTO_ASSIGN_MODAL',
  Image = 'IMAGE',
  ImageForward = 'IMAGE_FORWARD',
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  ImageTileCard = 'IMAGE_TILE_CARD',
  InformationModal = 'INFORMATION_MODAL',
  LandingFaq = 'LANDING_FAQ',
  LandingHero = 'LANDING_HERO',
  LandingModule = 'LANDING_MODULE',
  LandingValueProp = 'LANDING_VALUE_PROP',
  Large = 'LARGE',
  LogoWithText = 'LOGO_WITH_TEXT',
  LoyaltyClubMembershipBottomBanner = 'LOYALTY_CLUB_MEMBERSHIP_BOTTOM_BANNER',
  LoyaltyClubMembershipModal = 'LOYALTY_CLUB_MEMBERSHIP_MODAL',
  LoyaltyHubHeader = 'LOYALTY_HUB_HEADER',
  LoyaltySavingsModal = 'LOYALTY_SAVINGS_MODAL',
  MandatoryBusinessOrgRegistration = 'MANDATORY_BUSINESS_ORG_REGISTRATION',
  Mega = 'MEGA',
  MultiOfferSheet = 'MULTI_OFFER_SHEET',
  NavigationBanner = 'NAVIGATION_BANNER',
  OccasionHub = 'OCCASION_HUB',
  OffersForYouCard = 'OFFERS_FOR_YOU_CARD',
  OfferCard = 'OFFER_CARD',
  OverHeader = 'OVER_HEADER',
  PartnershipModal = 'PARTNERSHIP_MODAL',
  PartnershipRedemptionModal = 'PARTNERSHIP_REDEMPTION_MODAL',
  PromotionSheetCard = 'PROMOTION_SHEET_CARD',
  QuickLinkPill = 'QUICK_LINK_PILL',
  RetailerStory = 'RETAILER_STORY',
  RichInformationModal = 'RICH_INFORMATION_MODAL',
  RichText = 'RICH_TEXT',
  SavingsCardV2Banner = 'SAVINGS_CARD_V2_BANNER',
  SecondaryBanner = 'SECONDARY_BANNER',
  ShopOnlineBenefitsModal = 'SHOP_ONLINE_BENEFITS_MODAL',
  ShortcutBanner = 'SHORTCUT_BANNER',
  StandardInformationModal = 'STANDARD_INFORMATION_MODAL',
  StorefrontSavingsCard = 'STOREFRONT_SAVINGS_CARD',
  StoreMenuCard = 'STORE_MENU_CARD',
  Survey = 'SURVEY',
  Text = 'TEXT',
  TextIconHeader = 'TEXT_ICON_HEADER',
  TextSlim = 'TEXT_SLIM',
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  TitledMedia = 'TITLED_MEDIA',
  TopTrackerBanner = 'TOP_TRACKER_BANNER',
  ValueCarouselCard = 'VALUE_CAROUSEL_CARD',
  WaveCard = 'WAVE_CARD'
}

export type BarNav = {
  __typename?: 'BarNav';
  column1FeaturedLinksBlock?: Maybe<FlatNavigationWithVariants>;
  column1LinksBlock?: Maybe<NavigationWithContainers>;
  column2FeaturedLinksBlock?: Maybe<FlatNavigationWithVariants>;
};

export type BarNavInput = {
  column1FeaturedLinksBlock?: InputMaybe<FlatNavigationWithVariantsInput>;
  column1LinksBlock?: InputMaybe<NavigationWithContainersInput>;
  column2FeaturedLinksBlock?: InputMaybe<FlatNavigationWithVariantsInput>;
};

export type BaseSubject = {
  __typename?: 'BaseSubject';
  criteria?: Maybe<SubjectCriteria>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  gid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  requiredAlcoholContext?: Maybe<Scalars['String']>;
  requiredRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  sourceCollectionId?: Maybe<Scalars['BigInt']>;
};

export type BatchGetUsersByIdsStrictRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type BatchGetUsersByIdsStrictResponse = {
  __typename?: 'BatchGetUsersByIdsStrictResponse';
  users?: Maybe<Array<Maybe<User>>>;
};

export enum BatchType {
  BatchTypeUnspecified = 'BATCH_TYPE_UNSPECIFIED',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DriveAndPick = 'DRIVE_AND_PICK'
}

export type BatchUpdatePlacementsRequestInput = {
  layout?: InputMaybe<Layout>;
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type BatchUpdateSlotCreativesRequestInput = {
  slotCreatives?: InputMaybe<Array<InputMaybe<SlotCreativeInput>>>;
};

export type BatchUpdateSlotCreativesResponse = {
  __typename?: 'BatchUpdateSlotCreativesResponse';
  slotCreatives?: Maybe<Array<Maybe<SlotCreative>>>;
};

export type BinPickingConfig = {
  __typename?: 'BinPickingConfig';
  enableBinPicking?: Maybe<Scalars['Boolean']>;
  enableBinStaging?: Maybe<Scalars['Boolean']>;
};

export type BorderRadiusSchema = {
  __typename?: 'BorderRadiusSchema';
  isCircle?: Maybe<Scalars['Boolean']>;
  radius?: Maybe<Scalars['BigInt']>;
};

export enum BotAccountAssignableRoleEnum {
  /** Engineer role */
  Engineer = 'ENGINEER',
  /** Admin role */
  NonEngineer = 'NON_ENGINEER'
}

export enum BotAccountOperationTypeEnum {
  /** Account was created */
  Created = 'CREATED',
  /** Account was updated */
  Updated = 'UPDATED'
}

/** Autogenerated return type of BotEnterpriseAccountDisable */
export type BotEnterpriseAccountDisablePayload = {
  __typename?: 'BotEnterpriseAccountDisablePayload';
  /** The newly created or updated account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of BotEnterpriseAccountUpsert */
export type BotEnterpriseAccountUpsertPayload = {
  __typename?: 'BotEnterpriseAccountUpsertPayload';
  /** The newly created or updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** What kind of operation was executed */
  operationType: BotAccountOperationTypeEnum;
};

export type BotGrantAttestationInput = {
  /** ISO-8601 timestamp of the approval (Slackbot supplies this). */
  approvedAt: Scalars['String'];
  /** Instacart email of the approver as reported by Slack. */
  approverEmail: Scalars['String'];
  /** Slack message ts of the approval action, for cross-linking in audit review. */
  slackMessageTs?: InputMaybe<Scalars['String']>;
};

export type BotGrantOwnerAttestationInput = {
  /** ISO-8601 timestamp of the approval. */
  approvedAt: Scalars['String'];
  /** Instacart email of the approver as reported by Slack. */
  approverEmail: Scalars['String'];
  /** Slack message ts of the approval action. */
  slackMessageTs?: InputMaybe<Scalars['String']>;
  /** Role slug or canonical owner key (user:UXXX / group:SXXX) identifying which owner slot this attestation fills. */
  slugOrGroupKey: Scalars['String'];
};

export type BotGrantSensitiveAccessAttestationsInput = {
  /** IPP-Admin approval (@oncall-retailer-app-ipp). Required for SOX-tier grants and APW. */
  ippAdmin?: InputMaybe<BotGrantAttestationInput>;
  /** Requester's manager approval. Always required. */
  manager: BotGrantAttestationInput;
  /** One entry per distinct role-owner slot required by the grants. */
  owners: Array<BotGrantOwnerAttestationInput>;
};

export type BotGrantSensitiveAccessGrantsInput = {
  /** When true, promote the account to all-partners full access and clear per-partner assignments. */
  grantAllPartnersWrite: Scalars['Boolean'];
  /** Enterprise::Role slugs to add to the target account. May include a mix of standard, protected, and SOX-tier slugs. */
  roleSlugs: Array<Scalars['String']>;
};

/** Autogenerated return type of BotGrantSensitiveAccess */
export type BotGrantSensitiveAccessPayload = {
  __typename?: 'BotGrantSensitiveAccessPayload';
  /** Whether All Partners Write access was applied by this call (false on an idempotent replay if already granted). */
  appliedApw: Scalars['Boolean'];
  /** The updated account object. */
  enterpriseAccount: EnterpriseAccount;
  /** Role slugs that were newly added by this call (empty on an idempotent replay). */
  grantedRoleSlugs: Array<Scalars['String']>;
};

export type BoundingBox = {
  __typename?: 'BoundingBox';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  x?: Maybe<Scalars['Int']>;
  y?: Maybe<Scalars['Int']>;
};

export type Brand = {
  __typename?: 'Brand';
  brandId?: Maybe<Scalars['BigInt']>;
  brandName?: Maybe<Scalars['String']>;
};

export type BrandContact = {
  __typename?: 'BrandContact';
  email?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type BrandContactRequestInput = {
  accountInformation?: InputMaybe<IppAccountInformationInput>;
  areasOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  areasOfInterestEnums?: InputMaybe<Array<InputMaybe<AreaOfInterest>>>;
  brandProfileId?: InputMaybe<Scalars['String']>;
  interestedSellSheetIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDebug?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
};

export type BrandContactResponse = {
  __typename?: 'BrandContactResponse';
  brandContactId?: Maybe<Scalars['String']>;
};

export type BrandNameMapping = {
  __typename?: 'BrandNameMapping';
  brandName?: Maybe<Scalars['String']>;
  brandProfileId?: Maybe<Scalars['String']>;
};

export type BrandProfileAttributes = {
  __typename?: 'BrandProfileAttributes';
  aboutBrand?: Maybe<Scalars['String']>;
  brandContacts?: Maybe<Array<Maybe<BrandContact>>>;
  brandName?: Maybe<Scalars['String']>;
  certifications?: Maybe<Array<Maybe<Scalars['String']>>>;
  distributors?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['String']>;
  imageAssets?: Maybe<Array<Maybe<ImageAsset>>>;
  regionalAreas?: Maybe<Array<Maybe<InstacartAdsNexusV1RegionalArea>>>;
  storeTypes?: Maybe<Array<Maybe<InstacartAdsNexusV1StoreType>>>;
  website?: Maybe<Scalars['String']>;
};

export type BrandProfileAttributesRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>;
};

export type BrandProfileAttributesResponse = {
  __typename?: 'BrandProfileAttributesResponse';
  brandProfileAttributes?: Maybe<BrandProfileAttributes>;
};

export type BrandProfileSellSheetCardsRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>;
  paginationRequest?: InputMaybe<InstacartAdsSharedV1PaginationRequestInput>;
};

export type BrandProfileSellSheetCardsResponse = {
  __typename?: 'BrandProfileSellSheetCardsResponse';
  paginationResponse?: Maybe<InstacartAdsSharedV1PaginationResponse>;
  sellSheetCards?: Maybe<Array<Maybe<SellSheetCard>>>;
};

export type BrandSellSheetsAttributesRequestInput = {
  brandProfileId?: InputMaybe<Scalars['String']>;
};

export type BrandSellSheetsAttributesResponse = {
  __typename?: 'BrandSellSheetsAttributesResponse';
  sellSheetsOverviewAttributes?: Maybe<Array<Maybe<SellSheetOverviewAttributes>>>;
};

export type BrandingSchema = {
  __typename?: 'BrandingSchema';
  appleTouchIcon?: Maybe<Scalars['String']>;
  customImages?: Maybe<CustomImages>;
  favicon?: Maybe<Scalars['String']>;
  loadingIcons?: Maybe<Array<Maybe<Scalars['String']>>>;
  logos?: Maybe<Logos>;
  retailerLogos?: Maybe<Array<Maybe<RetailerLogo>>>;
  retailerOverrides?: Maybe<Array<Maybe<RetailerOverride>>>;
};

export type BuildJobDetail = {
  __typename?: 'BuildJobDetail';
  artifactsUrl?: Maybe<Scalars['String']>;
  failureDetails?: Maybe<BuildJobFailureDetails>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  webUrl?: Maybe<Scalars['String']>;
};

export type BuildJobFailureDetails = {
  __typename?: 'BuildJobFailureDetails';
  summary?: Maybe<Scalars['String']>;
};

export type BuildkiteArtifactInfo = {
  __typename?: 'BuildkiteArtifactInfo';
  downloadUrl?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['BigInt']>;
  filename?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stepKey?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Structured rows extracted from selected audit log entries. */
export type BulkAccountManagementTypesBuildRowsPayload = {
  __typename?: 'BulkAccountManagementTypesBuildRowsPayload';
  /** Canonical rows pulled from audit-log after-state */
  rows: Array<BulkRow>;
  /** Entry ids whose payload could not be parsed */
  skippedEntryIds: Array<Scalars['ID']>;
  target: AuditReplayTarget;
};

/** Dry-run impact counts for a guided bulk operation. */
export type BulkAccountManagementTypesBulkOperationPreview = {
  __typename?: 'BulkAccountManagementTypesBulkOperationPreview';
  affected: Scalars['Int'];
  conflicts: Scalars['Int'];
  noOp: Scalars['Int'];
};

/** Accounts matched against pasted emails/canonical ids with an optional filter set. */
export type BulkAccountManagementTypesResolveUserSelectionPayload = {
  __typename?: 'BulkAccountManagementTypesResolveUserSelectionPayload';
  /** Accounts that exist and are accessible to the caller */
  matched: Array<EnterpriseAccount>;
  /** Total accounts matching, ignoring the page limit */
  totalCount: Scalars['Int'];
  /** Canonical ids that did not resolve to an accessible account */
  unmatchedCanonicalIds: Array<Scalars['ID']>;
  /** Emails that did not resolve to an accessible account */
  unmatchedEmails: Array<Scalars['String']>;
};

/** A failed row from a bulk operation, with the original input and the error message. */
export type BulkFailureRow = {
  __typename?: 'BulkFailureRow';
  /** Operator-facing error message */
  errorMessage: Scalars['String'];
  /** The input row as submitted */
  row?: Maybe<Scalars['JSON']>;
  /** Zero-based index of the row in the submitted input */
  rowIndex?: Maybe<Scalars['Int']>;
};

/** A bulk user or role operation. Backed by audit log + AMS + Sidekiq adapters via Repository. */
export type BulkOperation = {
  __typename?: 'BulkOperation';
  /** The AMS approval request (nil for non-gated ops) */
  amsRequest?: Maybe<AmsRequest>;
  /** Operator-typed justification for breakglass */
  breakglassJustification?: Maybe<Scalars['String']>;
  /** When the worker recorded completion */
  completedAt?: Maybe<Scalars['ISO8601DateTime']>;
  counts: BulkOperationCounts;
  /** Failed rows with original input + error */
  failureRows: Array<BulkFailureRow>;
  /** Operation UUID (also the trace_id on per-entity audit events) */
  id: Scalars['ID'];
  /** The user who submitted the operation */
  initiator?: Maybe<EnterpriseAccount>;
  /** Full input as submitted */
  inputRows: Array<BulkRow>;
  /** Whether the operation skipped AMS via breakglass */
  isBreakglass: Scalars['Boolean'];
  kind?: Maybe<BulkOperationKind>;
  /** Resolved mode (`upsert` / `create_only` / `disable`) */
  mode?: Maybe<Scalars['String']>;
  /** Homogeneous guided recipe; null for CSV ops. Powers 're-open guided operation' replay. */
  recipe?: Maybe<Scalars['JSON']>;
  status: BulkOperationStatus;
  /** When the operation was submitted */
  submittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Per-entity after-state pulled from audit log on demand */
  successRows: Array<BulkRow>;
};

/** Row-count breakdown for a bulk operation. */
export type BulkOperationCounts = {
  __typename?: 'BulkOperationCounts';
  /** Rows that failed */
  failed: Scalars['Int'];
  /** Rows still being processed (best effort) */
  inFlight?: Maybe<Scalars['Int']>;
  /** Rows that succeeded */
  succeeded: Scalars['Int'];
  /** Total rows submitted */
  total: Scalars['Int'];
};

/** Filters applied to the bulkOperations listing query. */
export type BulkOperationFilter = {
  initiatorAccountId?: InputMaybe<Scalars['ID']>;
  kind?: InputMaybe<BulkOperationKind>;
  since?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<BulkOperationStatus>;
  /** Restrict to operations the current viewer submitted (the "My submissions" tab). Server-derived from the authenticated account — a client-supplied initiator_account_id is ignored when this is set, to prevent viewing another user's submissions. */
  submittedByViewer?: InputMaybe<Scalars['Boolean']>;
  until?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Whether the bulk operation is for users or roles. */
export enum BulkOperationKind {
  /** Bulk role operation */
  Role = 'ROLE',
  /** Bulk user operation */
  User = 'USER'
}

/** Paginated list of bulk operations. */
export type BulkOperationPage = {
  __typename?: 'BulkOperationPage';
  entries: Array<BulkOperation>;
  totalCount: Scalars['Int'];
};

/** Current status of a bulk operation. */
export enum BulkOperationStatus {
  /** Worker has finished (full success, partial, or all-failed) */
  Completed = 'COMPLETED',
  /** Awaiting AMS approval before execution */
  PendingApproval = 'PENDING_APPROVAL',
  /** AMS approver rejected the request */
  Rejected = 'REJECTED',
  /** Sidekiq job is executing rows */
  Running = 'RUNNING',
  /** No durable record found (worker may have crashed) */
  Unknown = 'UNKNOWN'
}

/** A validation failure that prevented submission of a bulk operation. */
export type BulkParseError = {
  __typename?: 'BulkParseError';
  /** The offending input field name, when the error is field-specific */
  field?: Maybe<Scalars['String']>;
  /** Operator-facing error message */
  message: Scalars['String'];
  /** Zero-based row index, when the error is row-specific */
  rowIndex?: Maybe<Scalars['Int']>;
};

/** Per-row behaviour for a bulk role operation. */
export enum BulkRoleMode {
  /** Fail on slug match; create new roles only */
  CreateOnly = 'CREATE_ONLY',
  /** Update when matched by slug; create otherwise */
  Upsert = 'UPSERT'
}

/** One row of a bulk role operation. Nil on any updateable field preserves the existing value. */
export type BulkRoleRowInput = {
  description?: InputMaybe<Scalars['String']>;
  internal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  permissionSlugs?: InputMaybe<Array<Scalars['String']>>;
  retailerId?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** A single canonical bulk row (user or role), as submitted or recovered from audit state. */
export type BulkRow = {
  __typename?: 'BulkRow';
  /** Row fields keyed by canonical column name */
  data: Scalars['JSON'];
};

export type BulkUpdateApprovalRequestStatusRequestInput = {
  approvalRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  comment?: InputMaybe<Scalars['String']>;
  statusAction?: InputMaybe<Scalars['String']>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateApprovalRequestStatusResponse = {
  __typename?: 'BulkUpdateApprovalRequestStatusResponse';
  failureCount?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<ApprovalRequestStatusResult>>>;
  successCount?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type BulkUpdateAuditTasksRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  taskUpdates?: InputMaybe<Array<InputMaybe<BulkUpdateAuditTasksRequestTaskUpdateInput>>>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type BulkUpdateAuditTasksRequestTaskUpdateInput = {
  extComment?: InputMaybe<Scalars['String']>;
  intComment?: InputMaybe<Scalars['String']>;
  reviewState?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taskComponents?: InputMaybe<Array<InputMaybe<UpdateAuditTaskRequestUpdateTaskComponentInput>>>;
  taskUuid?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type BulkUpdateAuditTasksResponse = {
  __typename?: 'BulkUpdateAuditTasksResponse';
  results?: Maybe<Array<Maybe<BulkUpdateAuditTasksResponseTaskResult>>>;
};

export type BulkUpdateAuditTasksResponseTaskResult = {
  __typename?: 'BulkUpdateAuditTasksResponseTaskResult';
  errorCode?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  taskUuid?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

/** Per-row behaviour for a bulk user operation. */
export enum BulkUserMode {
  /** Fail on canonical_id match; create new accounts only */
  CreateOnly = 'CREATE_ONLY',
  /** Flip accounts.disabled = true on matched rows */
  Disable = 'DISABLE',
  /** Update when matched by canonical_id; create otherwise */
  Upsert = 'UPSERT'
}

/** One row of a bulk user op. Nil on any updateable field is the wire equivalent of `__skip__`. */
export type BulkUserRowInput = {
  canonicalId?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  givenName?: InputMaybe<Scalars['String']>;
  hasAllPartnersFullAccess?: InputMaybe<Scalars['Boolean']>;
  hasFullPartnerAccess?: InputMaybe<Scalars['Boolean']>;
  hasFullRetailerAccess?: InputMaybe<Scalars['Boolean']>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  permissionSlugs?: InputMaybe<Array<Scalars['String']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  surname?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userLocale?: InputMaybe<Scalars['String']>;
};

export enum BusinessDerivedAttributesSourceType {
  LangchainAi = 'LANGCHAIN_AI'
}

export type BusinessSchema = {
  __typename?: 'BusinessSchema';
  businessAccountOnly?: Maybe<Scalars['Boolean']>;
  enableDefaultBusinessFeatures?: Maybe<Scalars['Boolean']>;
};

export enum ButtonStyle {
  Detrimental = 'DETRIMENTAL',
  Plus = 'PLUS',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum ButtonVariantEnum {
  /** Use the dismiss button style */
  Dismiss = 'DISMISS',
  /** Use the link button style */
  Link = 'LINK',
  /** Use the plus button style */
  Plus = 'PLUS',
  /** Use the primary button style */
  Primary = 'PRIMARY',
  /** Use the secondary button style */
  Secondary = 'SECONDARY'
}

export enum Cadence {
  Weekly = 'WEEKLY'
}

export enum CampaignField {
  OfferData = 'OFFER_DATA',
  RetailerData = 'RETAILER_DATA'
}

export type CampaignFilter = {
  __typename?: 'CampaignFilter';
  filterType?: Maybe<FilterType>;
  filterValue?: Maybe<Scalars['String']>;
};

export type CampaignFilterInput = {
  filterType?: InputMaybe<FilterType>;
  filterValue?: InputMaybe<Scalars['String']>;
};

export type CampaignFiltersInput = {
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
};

export enum CampaignIncentiveFilter {
  CampaignIncentiveFilterIncentive = 'CAMPAIGN_INCENTIVE_FILTER_INCENTIVE',
  CampaignIncentiveFilterNonIncentive = 'CAMPAIGN_INCENTIVE_FILTER_NON_INCENTIVE',
  CampaignIncentiveFilterUnspecified = 'CAMPAIGN_INCENTIVE_FILTER_UNSPECIFIED'
}

export enum CampaignObjective {
  Acquisition = 'ACQUISITION',
  Activation = 'ACTIVATION',
  Awareness = 'AWARENESS',
  Custom = 'CUSTOM',
  Invalid = 'INVALID',
  Loyalty = 'LOYALTY',
  Merchandising = 'MERCHANDISING',
  Moment = 'MOMENT',
  Occasion = 'OCCASION',
  Reactivation = 'REACTIVATION',
  Resurrection = 'RESURRECTION',
  Retention = 'RETENTION'
}

export enum CampaignProgress {
  /** The campaign has been cancelled */
  Cancelled = 'cancelled',
  /** The campaign has completed successfully */
  Completed = 'completed',
  /** The campaign is waiting for the segment export to complete */
  ExportingSegment = 'exporting_segment',
  /** The campaign has failed for some users */
  Failed = 'failed',
  /** The campaign is in progress */
  InProgress = 'in_progress',
  /** The campaign is downloading and parsing the segment from S3 */
  LoadingSegment = 'loading_segment',
  /** The campaign has completed for some users */
  PartiallyCompleted = 'partially_completed',
  /** The campaign is not currently running */
  Pending = 'pending'
}

export type CampaignPropertyFilterInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CampaignPropertyFilterOrListInput = {
  orList?: InputMaybe<Array<InputMaybe<CampaignPropertyFilterInput>>>;
};

export type CampaignPropertyOverrideInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CampaignReference = {
  __typename?: 'CampaignReference';
  directLink?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
};

export type CampaignReferenceInput = {
  directLink?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmId?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type CampaignRouletteFeature = {
  __typename?: 'CampaignRouletteFeature';
  featureName?: Maybe<Scalars['String']>;
  featureUuid?: Maybe<Scalars['String']>;
  featureVariant?: Maybe<Scalars['String']>;
};

export type CampaignRouletteFeatureInput = {
  featureName?: InputMaybe<Scalars['String']>;
  featureUuid?: InputMaybe<Scalars['String']>;
  featureVariant?: InputMaybe<Scalars['String']>;
};

export type CampaignServiceData = {
  __typename?: 'CampaignServiceData';
  cancelledAt?: Maybe<Scalars['DateTime']>;
  slotIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentPolicyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CampaignTreatmentTask = {
  __typename?: 'CampaignTreatmentTask';
  definitionParams?: Maybe<Scalars['JSONObject']>;
  definitionType?: Maybe<Scalars['String']>;
  taskDescription?: Maybe<Scalars['String']>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
};

export type CampaignTreatmentTaskRequestParamsInput = {
  definitionParams?: InputMaybe<Scalars['JSONObject']>;
  definitionType?: InputMaybe<Scalars['String']>;
  taskDescription?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CancelCampaign */
export type CancelCampaignPayload = {
  __typename?: 'CancelCampaignPayload';
  /** Whether it succesfully cancelled */
  success: Scalars['Boolean'];
};

export type CancelMomentRequestInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type CancelMomentResponse = {
  __typename?: 'CancelMomentResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type CancelOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CancelOrderResponse = {
  __typename?: 'CancelOrderResponse';
  instrumentationData?: Maybe<Scalars['String']>;
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
  orderItems?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>;
};

export type CancelRetailerCampaignRequestInput = {
  disableOffer?: InputMaybe<Scalars['Boolean']>;
  ippContext?: InputMaybe<IppContextInput>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CancelRetailerCampaignResponse = {
  __typename?: 'CancelRetailerCampaignResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type CaperBillingService_BillingWarning = {
  __typename?: 'CaperBillingService_BillingWarning';
  cartId?: Maybe<Scalars['String']>;
  code: CaperBillingService_Query_GetRunDetail_OneOf_0_Warnings_Items_Code;
  message: Scalars['String'];
  /** Salesforce store id when the warning is store-scoped (e.g. `mixed_ads_treatment`, `fixed_monthly_missing_carts`). */
  storeId?: Maybe<Scalars['String']>;
  warehouseLocationId?: Maybe<Scalars['String']>;
};

export type CaperBillingService_CommitUploadRequest_Input = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  retailerId: Scalars['String'];
  uploadType: CaperBillingService_UploadType;
  /** Identity of the uploader (email) */
  uploadedBy: Scalars['EmailAddress'];
};

export type CaperBillingService_CommitUploadResponse = {
  __typename?: 'CaperBillingService_CommitUploadResponse';
  s3Key: Scalars['String'];
  status: CaperBillingService_Committed_Const;
  uploadId: Scalars['UUID'];
};

export type CaperBillingService_CreateUploadRequest_Input = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  /** Original filename for client reference; not stored in S3 key */
  filename: Scalars['String'];
  /** Retailer identifier */
  retailerId: Scalars['String'];
  uploadType: CaperBillingService_UploadType;
};

export type CaperBillingService_CreateUploadResponse = {
  __typename?: 'CaperBillingService_CreateUploadResponse';
  s3Key: Scalars['String'];
  uploadId: Scalars['UUID'];
  /** Absolute URL to PUT the CSV to (step 2 of the upload flow) */
  uploadUrl: Scalars['URL'];
};

export type CaperBillingService_CsvCellError = {
  __typename?: 'CaperBillingService_CsvCellError';
  /** Column name, or empty for row-level errors */
  column: Scalars['String'];
  /** 1-based line number in the file (header = line 1) */
  line: Scalars['Int'];
  /** Human-readable failure reason */
  reason: Scalars['String'];
  /** The actual value found in the cell */
  value: Scalars['String'];
};

export type CaperBillingService_CsvDuplicateError = {
  __typename?: 'CaperBillingService_CsvDuplicateError';
  /** Line numbers (1-based) of duplicate occurrences */
  lines: Array<Maybe<Scalars['Int']>>;
  /** First few column values to identify the row */
  preview: Scalars['String'];
};

/** URL slug for a CSV template. Maps to an internal validator schema key: contracts→contracts, orders→orders, ads→ads_revenue, active-carts→active_carts. */
export enum CaperBillingService_CsvTemplateType {
  ActiveCarts = 'active_carts',
  Ads = 'ads',
  Contracts = 'contracts',
  Orders = 'orders'
}

export type CaperBillingService_CsvValidationErrorResponse = {
  __typename?: 'CaperBillingService_CsvValidationErrorResponse';
  /** Groups of exact duplicate rows detected */
  duplicates: Array<Maybe<CaperBillingService_CsvDuplicateError>>;
  error: Scalars['String'];
  /** Cell-level validation errors (capped at 100) */
  errors: Array<Maybe<CaperBillingService_CsvCellError>>;
  /** Number of data rows parsed (excluding header) */
  rowCount: Scalars['Int'];
  /** Non-blocking validation warnings */
  warnings: Array<Maybe<CaperBillingService_CsvValidationWarning>>;
};

export type CaperBillingService_CsvValidationWarning = {
  __typename?: 'CaperBillingService_CsvValidationWarning';
  column: Scalars['String'];
  line: Scalars['Int'];
  reason: Scalars['String'];
  value: Scalars['String'];
};

export type CaperBillingService_Error = {
  __typename?: 'CaperBillingService_Error';
  error: Scalars['String'];
};

export type CaperBillingService_File_Container = {
  __typename?: 'CaperBillingService_File_container';
  File?: Maybe<Scalars['CaperBillingService_File']>;
};

export type CaperBillingService_FinalizeRunRequest_Input = {
  /** Email of the user finalizing the run */
  finalizedBy: Scalars['EmailAddress'];
};

export type CaperBillingService_FinalizeRunResponse = {
  __typename?: 'CaperBillingService_FinalizeRunResponse';
  /** ISO 8601 timestamp of when the run was finalized */
  finalizedAt: Scalars['DateTime'];
  /** Email of the user who finalized the run */
  finalizedBy: Scalars['EmailAddress'];
  runId: Scalars['UUID'];
  status: CaperBillingService_Finalized_Const;
};

export type CaperBillingService_GenerateRunRequest_Input = {
  /** S3 key of the committed active carts CSV (must start with uploads/) */
  activeCartsUploadKey?: InputMaybe<Scalars['String']>;
  /** S3 key of the committed ads revenue CSV (must start with uploads/) */
  adsRevenueUploadKey?: InputMaybe<Scalars['String']>;
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  /** S3 key of the committed contracts CSV (must start with uploads/). Parsed for per-store / per-device-group SaaS rates, ads treatment, guarantee rates (Y1/Y2/Y3 calendar-anchored), and organic rev share. Returns 400 when the parsed CSV violates a hard invariant (mixed SaaS terms within a store, expired legacy guarantee, cross-store device dup, mixed organic rev share within a store). */
  contractsUploadKey: Scalars['String'];
  /** Email of the user generating the run */
  generatedBy: Scalars['EmailAddress'];
  /** S3 key of the committed orders CSV (must start with uploads/) */
  ordersUploadKey: Scalars['String'];
  /** Retailer identifier */
  retailerId: Scalars['String'];
};

export type CaperBillingService_GenerateRunResponse = {
  __typename?: 'CaperBillingService_GenerateRunResponse';
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  /** ISO 8601 timestamp of when the run was generated */
  generatedAt: Scalars['DateTime'];
  /** Email of the user who generated the run */
  generatedBy: Scalars['EmailAddress'];
  partnerTotals: CaperBillingService_PartnerBillingTotals;
  runId: Scalars['UUID'];
  /** S3 prefix where run artifacts are stored */
  s3Prefix: Scalars['String'];
  status: CaperBillingService_Draft_Const;
  storeSummaries: Array<Maybe<CaperBillingService_StoreBillingSummary>>;
  warnings: Array<Maybe<CaperBillingService_BillingWarning>>;
};

export type CaperBillingService_GetCsvTemplateResponse = {
  __typename?: 'CaperBillingService_GetCsvTemplateResponse';
  /** CSV body — a single header row derived from the validator schema, no data rows */
  csv: Scalars['String'];
  /** Suggested filename (client sets it as the anchor download attribute) */
  filename: Scalars['String'];
};

export enum CaperBillingService_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type CaperBillingService_ListRunsResponse = {
  __typename?: 'CaperBillingService_ListRunsResponse';
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  /** Present and true when S3 truncated the result at the 200-key cap. Pass nextCursor to retrieve the next page. */
  listTruncated?: Maybe<Scalars['Boolean']>;
  /** Opaque cursor token for fetching the next page. Present only when listTruncated is true. */
  nextCursor?: Maybe<Scalars['String']>;
  retailerId: Scalars['String'];
  runs: Array<Maybe<CaperBillingService_RunItem>>;
};

export type CaperBillingService_ListUploadsResponse = {
  __typename?: 'CaperBillingService_ListUploadsResponse';
  from: Scalars['CaperBillingService_BillingPeriod'];
  /** Present and true when S3 cut the result at the 200-key cap. Narrow the date range with from/to to reduce the scanned key space. */
  listTruncated?: Maybe<Scalars['Boolean']>;
  retailerId: Scalars['String'];
  to: Scalars['CaperBillingService_BillingPeriod'];
  uploads: Array<Maybe<CaperBillingService_UploadItem>>;
};

export type CaperBillingService_PartnerBillingTotals = {
  __typename?: 'CaperBillingService_PartnerBillingTotals';
  /** Net amount due (totalSaasFeesDue - totalAdsPayout) */
  netAmountDue: Scalars['Float'];
  /** Total ads payout to retailer (max of organic and guarantee) */
  totalAdsPayout: Scalars['Float'];
  /** Total ads revenue share (organic) */
  totalAdsRevenue: Scalars['Float'];
  /** Total SaaS fees owed by the retailer */
  totalSaasFeesDue: Scalars['Float'];
};

export type CaperBillingService_RunDetailResponse = {
  __typename?: 'CaperBillingService_RunDetailResponse';
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  /** ISO 8601 timestamp of when the run was generated */
  generatedAt: Scalars['DateTime'];
  /** Email of the user who generated the run */
  generatedBy: Scalars['EmailAddress'];
  partnerTotals: CaperBillingService_PartnerBillingTotals;
  pdf?: Maybe<CaperBillingService_RunFileReference>;
  result: CaperBillingService_RunFileReference;
  retailerId: Scalars['String'];
  runId: Scalars['UUID'];
  sourceFiles: CaperBillingService_RunSourceFiles;
  status: CaperBillingService_RunStatus;
  /** Per-store billing breakdown. */
  storeSummaries: Array<Maybe<CaperBillingService_StoreBillingSummary>>;
  /** Billing warnings generated during the run. */
  warnings: Array<Maybe<CaperBillingService_BillingWarning>>;
  xlsx?: Maybe<CaperBillingService_RunFileReference>;
};

export type CaperBillingService_RunFileReference = {
  __typename?: 'CaperBillingService_RunFileReference';
  /** URL TTL in seconds */
  expiresIn: Scalars['Int'];
  /** S3 object key */
  s3Key: Scalars['String'];
  /** Presigned GetObject URL for direct download */
  url: Scalars['URL'];
};

export type CaperBillingService_RunItem = {
  __typename?: 'CaperBillingService_RunItem';
  generatedAt: Scalars['DateTime'];
  /** User slug extracted from the run folder name */
  generatedBy: Scalars['String'];
  runId: Scalars['UUID'];
  status: CaperBillingService_RunStatus;
};

/** Source CSV files used to generate the billing run. Keys are omitted if the referenced file no longer exists in S3. */
export type CaperBillingService_RunSourceFiles = {
  __typename?: 'CaperBillingService_RunSourceFiles';
  adsRevenue?: Maybe<CaperBillingService_RunFileReference>;
  contracts?: Maybe<CaperBillingService_RunFileReference>;
  orders?: Maybe<CaperBillingService_RunFileReference>;
};

/** Whether the billing run has been finalized */
export enum CaperBillingService_RunStatus {
  Draft = 'draft',
  Finalized = 'finalized'
}

export type CaperBillingService_StoreBillingSummary = {
  __typename?: 'CaperBillingService_StoreBillingSummary';
  /** Human-readable breakdown of the ads payout calculation */
  calculationTrace: Scalars['String'];
  orderCount: Scalars['Int'];
  /** Retailer name from order or active-carts data */
  retailerName: Scalars['String'];
  /** Human-readable breakdown of the SaaS fee calculation (per-order + per-cart) */
  saasCalculationTrace: Scalars['String'];
  saasFeesDue: Scalars['Float'];
  storeId: Scalars['String'];
  totalAdsPayout: Scalars['Float'];
  totalAdsRevenue: Scalars['Float'];
  totalGuaranteeShortfall: Scalars['Float'];
  /** Warehouse location ID (absent for carts-only stores) */
  warehouseLocationId?: Maybe<Scalars['String']>;
  /** Warehouse location name (absent for carts-only stores) */
  warehouseLocationName?: Maybe<Scalars['String']>;
};

export type CaperBillingService_StoreUploadResponse = {
  __typename?: 'CaperBillingService_StoreUploadResponse';
  s3Key: Scalars['String'];
  uploadId: Scalars['UUID'];
  /** Non-blocking validation warnings (e.g., optional fields that were empty) */
  warnings?: Maybe<Array<Maybe<CaperBillingService_CsvValidationWarning>>>;
};

export type CaperBillingService_UploadItem = {
  __typename?: 'CaperBillingService_UploadItem';
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  s3Key: Scalars['String'];
  uploadId: Scalars['UUID'];
  uploadType: CaperBillingService_UploadType;
  /** Absolute URL to stream the file through this service */
  url: Scalars['URL'];
};

/** Category of billing file */
export enum CaperBillingService_UploadType {
  ActiveCarts = 'active_carts',
  AdsRevenue = 'ads_revenue',
  Contracts = 'contracts',
  Orders = 'orders'
}

export type CaperBillingService_CommitUpload_Response = CaperBillingService_CommitUploadResponse | CaperBillingService_Error;

export enum CaperBillingService_Committed_Const {
  Committed = 'committed'
}

export type CaperBillingService_CreateUpload_Response = CaperBillingService_CreateUploadResponse | CaperBillingService_Error;

export type CaperBillingService_DownloadUpload_Response = CaperBillingService_Error | CaperBillingService_File_Container;

export enum CaperBillingService_Draft_Const {
  Draft = 'draft'
}

export type CaperBillingService_FinalizeRun_Response = CaperBillingService_Error | CaperBillingService_FinalizeRunResponse;

export enum CaperBillingService_Finalized_Const {
  Finalized = 'finalized'
}

export type CaperBillingService_GenerateRun_Response = CaperBillingService_Error | CaperBillingService_GenerateRunResponse;

export type CaperBillingService_GetCsvTemplate_Response = CaperBillingService_Error | CaperBillingService_GetCsvTemplateResponse;

export type CaperBillingService_GetHealth_200_Response = {
  __typename?: 'CaperBillingService_getHealth_200_response';
  service: Scalars['String'];
  status: Scalars['String'];
};

export type CaperBillingService_GetRunDetail_Response = CaperBillingService_Error | CaperBillingService_RunDetailResponse;

export type CaperBillingService_ListRuns_Response = CaperBillingService_Error | CaperBillingService_ListRunsResponse;

export type CaperBillingService_ListUploads_Response = CaperBillingService_Error | CaperBillingService_ListUploadsResponse;

/**
 * - `unmatched_cart`: a cart's device id was not found in the contracts CSV; cart is billed at $0.
 * - `missing_ads_revenue`: store has orders but no row in the ads revenue CSV.
 * - `no_orders`: store appears in another input but has no orders this period.
 * - `mixed_ads_treatment`: store has carts with more than one distinct ads treatment (e.g. `new_guarantee` and `legacy_guarantee`); guarantee floor is summed per device-group but ads-vs-guarantee comparison remains store-level (ESAE-4450 limitation).
 * - `fixed_monthly_missing_carts`: store's SaaS billing model is `fixed_monthly` but the active-carts CSV has no entry for it; SaaS is billed as $0 for the period.
 */
export enum CaperBillingService_Query_GetRunDetail_OneOf_0_Warnings_Items_Code {
  FixedMonthlyMissingCarts = 'fixed_monthly_missing_carts',
  MissingAdsRevenue = 'missing_ads_revenue',
  MixedAdsTreatment = 'mixed_ads_treatment',
  NoOrders = 'no_orders',
  UnmatchedCart = 'unmatched_cart'
}

export type CaperBillingService_StoreUpload_Response = CaperBillingService_CsvValidationErrorResponse | CaperBillingService_Error | CaperBillingService_StoreUploadResponse;

export type CardList = {
  __typename?: 'CardList';
  action?: Maybe<Scalars['String']>;
  actionData?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaVisibilityLimit?: Maybe<Scalars['BigInt']>;
  ctaVisibilityMin?: Maybe<Scalars['BigInt']>;
  dataQuery?: Maybe<DataQuery>;
  dataQueryValue?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  layout?: Maybe<Layout>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
  requestId?: Maybe<Scalars['String']>;
  settings?: Maybe<CardListSettings>;
  settingsValue?: Maybe<Scalars['JSONObject']>;
  subtitleIcon?: Maybe<Scalars['String']>;
  subtitleText?: Maybe<Scalars['String']>;
  subtitleTextHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<CardListVariant>;
};

export type CardListInput = {
  action?: InputMaybe<Scalars['String']>;
  actionData?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaVisibilityLimit?: InputMaybe<Scalars['BigInt']>;
  ctaVisibilityMin?: InputMaybe<Scalars['BigInt']>;
  dataQuery?: InputMaybe<DataQueryInput>;
  dataQueryValue?: InputMaybe<Scalars['JSONObject']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Layout>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  requestId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<CardListSettingsInput>;
  settingsValue?: InputMaybe<Scalars['JSONObject']>;
  subtitleIcon?: InputMaybe<Scalars['String']>;
  subtitleText?: InputMaybe<Scalars['String']>;
  subtitleTextHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<CardListVariant>;
};

export type CardListSettings = {
  __typename?: 'CardListSettings';
  autoScrollEnabled?: Maybe<Scalars['Boolean']>;
  autoScrollInterval?: Maybe<Scalars['BigInt']>;
  cardAlignment?: Maybe<CardListSettingsCardAlignment>;
  cardCtaStyle?: Maybe<CardListSettingsCardCtaStyle>;
  cardHeightPixelLarge?: Maybe<Scalars['BigInt']>;
  cardHeightPixelSmall?: Maybe<Scalars['BigInt']>;
  cardOrientation?: Maybe<CardListSettingsCardOrientation>;
  cardRowCount?: Maybe<Scalars['BigInt']>;
  cardWidthPixelLarge?: Maybe<Scalars['BigInt']>;
  cardWidthPixelSmall?: Maybe<Scalars['BigInt']>;
  carouselIncidatorType?: Maybe<CarouselIndicatorType>;
  carouselIncidatorVariant?: Maybe<Scalars['BigInt']>;
  carouselIndicatorType?: Maybe<CarouselIndicatorType>;
  carouselType?: Maybe<CarouselType>;
  filledIndicatorColorHex?: Maybe<Scalars['String']>;
  fullScreenWidth?: Maybe<Scalars['Boolean']>;
  maxNumOfCards?: Maybe<Scalars['BigInt']>;
  navigationMappingKey?: Maybe<Scalars['String']>;
  numOfCardsLarge?: Maybe<Scalars['BigInt']>;
  numOfCardsSmall?: Maybe<Scalars['BigInt']>;
  showCarouselIndicator?: Maybe<Scalars['Boolean']>;
  unfilledIndicatorColorHex?: Maybe<Scalars['String']>;
  valuePropsCardType?: Maybe<ValuePropsCardType>;
};

export enum CardListSettingsCardAlignment {
  CardAlignmentCenter = 'CARD_ALIGNMENT_CENTER',
  CardAlignmentLeft = 'CARD_ALIGNMENT_LEFT',
  CardAlignmentUnknown = 'CARD_ALIGNMENT_UNKNOWN'
}

export enum CardListSettingsCardCtaStyle {
  CardCtaStylePrimary = 'CARD_CTA_STYLE_PRIMARY',
  CardCtaStyleText = 'CARD_CTA_STYLE_TEXT',
  CardCtaStyleUnknown = 'CARD_CTA_STYLE_UNKNOWN'
}

export enum CardListSettingsCardOrientation {
  CardOrientationHorizontal = 'CARD_ORIENTATION_HORIZONTAL',
  CardOrientationUnknown = 'CARD_ORIENTATION_UNKNOWN',
  CardOrientationVertical = 'CARD_ORIENTATION_VERTICAL'
}

export type CardListSettingsInput = {
  autoScrollEnabled?: InputMaybe<Scalars['Boolean']>;
  autoScrollInterval?: InputMaybe<Scalars['BigInt']>;
  cardAlignment?: InputMaybe<CardListSettingsCardAlignment>;
  cardCtaStyle?: InputMaybe<CardListSettingsCardCtaStyle>;
  cardHeightPixelLarge?: InputMaybe<Scalars['BigInt']>;
  cardHeightPixelSmall?: InputMaybe<Scalars['BigInt']>;
  cardOrientation?: InputMaybe<CardListSettingsCardOrientation>;
  cardRowCount?: InputMaybe<Scalars['BigInt']>;
  cardWidthPixelLarge?: InputMaybe<Scalars['BigInt']>;
  cardWidthPixelSmall?: InputMaybe<Scalars['BigInt']>;
  carouselIncidatorType?: InputMaybe<CarouselIndicatorType>;
  carouselIncidatorVariant?: InputMaybe<Scalars['BigInt']>;
  carouselIndicatorType?: InputMaybe<CarouselIndicatorType>;
  carouselType?: InputMaybe<CarouselType>;
  filledIndicatorColorHex?: InputMaybe<Scalars['String']>;
  fullScreenWidth?: InputMaybe<Scalars['Boolean']>;
  maxNumOfCards?: InputMaybe<Scalars['BigInt']>;
  navigationMappingKey?: InputMaybe<Scalars['String']>;
  numOfCardsLarge?: InputMaybe<Scalars['BigInt']>;
  numOfCardsSmall?: InputMaybe<Scalars['BigInt']>;
  showCarouselIndicator?: InputMaybe<Scalars['Boolean']>;
  unfilledIndicatorColorHex?: InputMaybe<Scalars['String']>;
  valuePropsCardType?: InputMaybe<ValuePropsCardType>;
};

export enum CardListVariant {
  AnchorLinksList = 'ANCHOR_LINKS_LIST',
  AsyncPlacements = 'ASYNC_PLACEMENTS',
  CardList = 'CARD_LIST',
  CartStarterList = 'CART_STARTER_LIST',
  GridList = 'GRID_LIST',
  HomeSpotlight = 'HOME_SPOTLIGHT',
  ImageTileList = 'IMAGE_TILE_LIST',
  ItemBundles = 'ITEM_BUNDLES',
  LandingFaqsList = 'LANDING_FAQS_LIST',
  LandingRetailersList = 'LANDING_RETAILERS_LIST',
  LandingValuePropsList = 'LANDING_VALUE_PROPS_LIST',
  MarketplaceList = 'MARKETPLACE_LIST',
  PillList = 'PILL_LIST',
  QuickLinkList = 'QUICK_LINK_LIST',
  RetailerForwardList = 'RETAILER_FORWARD_LIST',
  RetailerStoriesList = 'RETAILER_STORIES_LIST',
  Slot = 'SLOT',
  StoreDirectoryStoreForwardList = 'STORE_DIRECTORY_STORE_FORWARD_LIST',
  StoreForwardList = 'STORE_FORWARD_LIST',
  StoreMenuList = 'STORE_MENU_LIST',
  StoreSpotlight = 'STORE_SPOTLIGHT',
  TaskCenter = 'TASK_CENTER',
  TileGridList = 'TILE_GRID_LIST',
  TileList = 'TILE_LIST',
  WindowShoppingList = 'WINDOW_SHOPPING_LIST'
}

export enum CarouselIndicatorType {
  CarouselIndicatorTypeDot = 'CAROUSEL_INDICATOR_TYPE_DOT',
  CarouselIndicatorTypeProgressBar = 'CAROUSEL_INDICATOR_TYPE_PROGRESS_BAR',
  CarouselIndicatorTypeUnknown = 'CAROUSEL_INDICATOR_TYPE_UNKNOWN'
}

export enum CarouselType {
  CarouselTypeContentCard = 'CAROUSEL_TYPE_CONTENT_CARD',
  CarouselTypeDiscoveryPage = 'CAROUSEL_TYPE_DISCOVERY_PAGE',
  CarouselTypeFeaturedCollection = 'CAROUSEL_TYPE_FEATURED_COLLECTION',
  CarouselTypeHero = 'CAROUSEL_TYPE_HERO',
  CarouselTypeHomeUniversalValue = 'CAROUSEL_TYPE_HOME_UNIVERSAL_VALUE',
  CarouselTypeImageTile = 'CAROUSEL_TYPE_IMAGE_TILE',
  CarouselTypeQuickLink = 'CAROUSEL_TYPE_QUICK_LINK',
  CarouselTypeRecipeCollectionCarousel = 'CAROUSEL_TYPE_RECIPE_COLLECTION_CAROUSEL',
  CarouselTypeRetailerSimplifiedCard = 'CAROUSEL_TYPE_RETAILER_SIMPLIFIED_CARD',
  CarouselTypeSecondary = 'CAROUSEL_TYPE_SECONDARY',
  CarouselTypeSlim = 'CAROUSEL_TYPE_SLIM',
  CarouselTypeUnknown = 'CAROUSEL_TYPE_UNKNOWN'
}

export type CartEmptyState = {
  __typename?: 'CartEmptyState';
  enabled?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export enum CartState {
  CartStateUnspecified = 'CART_STATE_UNSPECIFIED',
  Empty = 'EMPTY',
  InProgress = 'IN_PROGRESS',
  Qualified = 'QUALIFIED'
}

export type CashflowAuditItem = {
  __typename?: 'CashflowAuditItem';
  cashflowAuditItemId?: Maybe<Scalars['String']>;
};

export type CatalogAisle = {
  __typename?: 'CatalogAisle';
  /** The department associated with this aisle */
  department: CatalogDepartment;
  /** A unique identifier for the aisle */
  id: Scalars['ID'];
  /** The aisle's name - ('Candy & Chocolates', 'Chips & Pretzels', ...) */
  name: Scalars['String'];
};

export type CatalogClassificationInfo = {
  __typename?: 'CatalogClassificationInfo';
  /** The associated code (Could be a UPC - '034000170388', PLU - '1147', or In-House 'AB008') */
  code: Scalars['String'];
  /** The associated retailer (for in-house products) */
  retailer?: Maybe<Retailer>;
  /** The type of classified code (universal, commodity, in-house, ...) */
  type: ClassifiedTypeEnum;
};

export type CatalogDepartment = {
  __typename?: 'CatalogDepartment';
  /** An array of the department's aisles */
  aisles: Array<CatalogAisle>;
  /** A unique identifier for the department */
  id: Scalars['ID'];
  /** The department's name - ('Snacks', 'Meat & Seafood', ...) */
  name: Scalars['String'];
};

export enum CatalogPlatformApi_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type CatalogPlatformApi_String_Container = {
  __typename?: 'CatalogPlatformApi_String_container';
  String?: Maybe<Scalars['String']>;
};

export type CatalogPlatformApi_GetRetailerProductOverrides_Response = CatalogPlatformApi_String_Container | CatalogPlatformApi_Internal_Domain_Product_RetailerProductOverridesResponse;

export type CatalogPlatformApi_GetRetailerProducts_Response = CatalogPlatformApi_String_Container | CatalogPlatformApi_Internal_Domain_Product_RetailerProductsResponse;

export type CatalogPlatformApi_Internal_Domain_Product_RetailerProductOverrideRow = {
  __typename?: 'CatalogPlatformApi_internal_domain_product_retailerProductOverrideRow';
  data?: Maybe<Scalars['JSON']>;
  deleted?: Maybe<Scalars['Boolean']>;
  experiment_variant_id?: Maybe<Scalars['BigInt']>;
  locale_id?: Maybe<Scalars['BigInt']>;
  product_id?: Maybe<Scalars['BigInt']>;
  retailer_id?: Maybe<Scalars['Int']>;
  row_id?: Maybe<Scalars['BigInt']>;
  surface_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type CatalogPlatformApi_Internal_Domain_Product_RetailerProductOverridesResponse = {
  __typename?: 'CatalogPlatformApi_internal_domain_product_retailerProductOverridesResponse';
  rows?: Maybe<Array<Maybe<CatalogPlatformApi_Internal_Domain_Product_RetailerProductOverrideRow>>>;
};

export type CatalogPlatformApi_Internal_Domain_Product_RetailerProductRow = {
  __typename?: 'CatalogPlatformApi_internal_domain_product_retailerProductRow';
  attributes?: Maybe<Scalars['JSON']>;
  catalog_build_variant_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  generated_at?: Maybe<Scalars['String']>;
  locale_id?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['Int']>;
  retailer_id?: Maybe<Scalars['Int']>;
  sources?: Maybe<Scalars['JSON']>;
  surface_id?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type CatalogPlatformApi_Internal_Domain_Product_RetailerProductsResponse = {
  __typename?: 'CatalogPlatformApi_internal_domain_product_retailerProductsResponse';
  count?: Maybe<Scalars['Int']>;
  data?: Maybe<Array<Maybe<CatalogPlatformApi_Internal_Domain_Product_RetailerProductRow>>>;
};

export type CatalogProduct = {
  __typename?: 'CatalogProduct';
  /** The classified code/type associated with the product (contains UPC details) */
  classificationInfo: CatalogClassificationInfo;
  /**
   * The classified code associated with the product (Also referred to as UPC - '034000170388')
   * @deprecated Use `classification info` instead, as it has more details than `classified_code`
   */
  classifiedCode?: Maybe<Scalars['String']>;
  /** Details about the product, e.g. 'Brown, overripe bananas, suitable for baking */
  description?: Maybe<Scalars['String']>;
  /** The product's name - 'Hershey's Extra Large Chocolate Bar' */
  displayName: Scalars['String'];
  /** A unique identifier for the product */
  id: Scalars['ID'];
  /**
   * The product's name - 'Hershey's Extra Large Chocolate Bar'
   * @deprecated Use `display name` instead, as it has more details than `name`
   */
  name: Scalars['String'];
  /** An absolute url of the primary image associated with the product - 'https://www.example.com/etc' */
  primaryImageUrl?: Maybe<Scalars['String']>;
};

export type CatalogRetailerProduct = {
  __typename?: 'CatalogRetailerProduct';
  /** The available item count of the retailer product */
  availableItemsCount?: Maybe<Scalars['Int']>;
  /** The details of the retailer product */
  details?: Maybe<Scalars['String']>;
  /** The display_name of the retailer product */
  displayName?: Maybe<Scalars['String']>;
  /** A unique identifier for the retailer product */
  id: Scalars['ID'];
  /** The Url of the retailer product's primary image */
  primaryImageUrl?: Maybe<Scalars['Url']>;
  /** The unique identifier for the associated product */
  productId?: Maybe<Scalars['ID']>;
  /** The size of the retailer product (e.g., 4 oz) */
  size?: Maybe<Scalars['String']>;
  /** The unit count of the retailer product */
  unitCount?: Maybe<Scalars['Int']>;
};

/** The connection type for CatalogRetailerProduct. */
export type CatalogRetailerProductConnection = {
  __typename?: 'CatalogRetailerProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CatalogRetailerProductEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CatalogRetailerProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CatalogRetailerProductEdge = {
  __typename?: 'CatalogRetailerProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<CatalogRetailerProduct>;
};

export type CatalogSchema = {
  __typename?: 'CatalogSchema';
  _?: Maybe<Scalars['Boolean']>;
};

export type CatalogSearchDownloadsCatalogSearchDownloadSignedUrl = {
  __typename?: 'CatalogSearchDownloadsCatalogSearchDownloadSignedUrl';
  /** Signed url for the object */
  signedUrl: Scalars['String'];
};

export type CatalogTaxonomyNode = {
  __typename?: 'CatalogTaxonomyNode';
  /** A unique identifier for the taxonomy node */
  id: Scalars['ID'];
  /** The taxonomy nodes's name - ('Food', 'Meat', ...) */
  name: Scalars['String'];
  /** The parent taxonomy node */
  parentId: Scalars['ID'];
};

export enum CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION'
}

export type ChatMessageInput = {
  /** A comment for the feedback */
  comment?: InputMaybe<Scalars['String']>;
  /** The content of the message */
  content: Scalars['String'];
  /** The feedback for the message */
  feedback?: InputMaybe<FeedbackEnum>;
  /** The role of the message sender */
  role: Scalars['String'];
  /** The timestamp when the message was created */
  timestamp?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the tool call */
  toolCallId?: InputMaybe<Scalars['ID']>;
  /** The tool calls in the message */
  toolCalls?: InputMaybe<Array<ToolCallInput>>;
};

export type CheckLaunchOnboardingProgressByPartnerRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type CheckLaunchOnboardingProgressByPartnerResponse = {
  __typename?: 'CheckLaunchOnboardingProgressByPartnerResponse';
  workflowState?: Maybe<Scalars['String']>;
};

export type CheckoutSchema = {
  __typename?: 'CheckoutSchema';
  giftingEnabled?: Maybe<Scalars['Boolean']>;
  multiStepTippingEnabled?: Maybe<Scalars['Boolean']>;
  noRushSameDayDeliveryEnabled?: Maybe<Scalars['Boolean']>;
  smsMarketingOptIn?: Maybe<Scalars['Boolean']>;
  stepAnchors?: Maybe<CheckoutSchemaStepAnchors>;
  trackExtUserId?: Maybe<Scalars['Boolean']>;
};

export type CheckoutSchemaStepAnchors = {
  __typename?: 'CheckoutSchemaStepAnchors';
  loyalty?: Maybe<CheckoutSchemaStepAnchorsAnchor>;
};

export enum CheckoutSchemaStepAnchorsAnchor {
  AfterPayments = 'AFTER_PAYMENTS',
  AfterServiceOptions = 'AFTER_SERVICE_OPTIONS',
  AnchorUnspecified = 'ANCHOR_UNSPECIFIED',
  BeforePayments = 'BEFORE_PAYMENTS',
  BeforeServiceOptions = 'BEFORE_SERVICE_OPTIONS'
}

export type ChronicInsightCard = {
  __typename?: 'ChronicInsightCard';
  body?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productName?: Maybe<Scalars['String']>;
  recommendationId?: Maybe<Scalars['String']>;
  severity?: Maybe<ChronicInsightSeverity>;
  tableType?: Maybe<ChronicInsightTableType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ChronicInsightSeverity {
  ChronicInsightSeverityCritical = 'CHRONIC_INSIGHT_SEVERITY_CRITICAL',
  ChronicInsightSeverityNeedsAttention = 'CHRONIC_INSIGHT_SEVERITY_NEEDS_ATTENTION',
  ChronicInsightSeverityUnknown = 'CHRONIC_INSIGHT_SEVERITY_UNKNOWN',
  ChronicInsightSeverityWatch = 'CHRONIC_INSIGHT_SEVERITY_WATCH'
}

export enum ChronicInsightTableType {
  ChronicInsightTableTypeOverfacing = 'CHRONIC_INSIGHT_TABLE_TYPE_OVERFACING',
  ChronicInsightTableTypeOverordering = 'CHRONIC_INSIGHT_TABLE_TYPE_OVERORDERING',
  ChronicInsightTableTypeUnderstock = 'CHRONIC_INSIGHT_TABLE_TYPE_UNDERSTOCK',
  ChronicInsightTableTypeUnknown = 'CHRONIC_INSIGHT_TABLE_TYPE_UNKNOWN'
}

export type ChronicOverorderingRow = {
  __typename?: 'ChronicOverorderingRow';
  category?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['BigInt']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['BigInt']>;
  estimatedBackstockWeeks?: Maybe<Scalars['Float']>;
  estimatedRunwayFormatted?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  orderToSalesRatio?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['BigInt']>;
  salesVolumeFormatted?: Maybe<Scalars['String']>;
  shelfImageUrl?: Maybe<Scalars['String']>;
  unitsReceived?: Maybe<Scalars['Int']>;
  unitsSold?: Maybe<Scalars['Int']>;
  upc?: Maybe<Scalars['String']>;
};

export enum ChronicOverorderingSortBy {
  ChronicOverorderingSortByEstimatedBackstockWeeks = 'CHRONIC_OVERORDERING_SORT_BY_ESTIMATED_BACKSTOCK_WEEKS',
  ChronicOverorderingSortByOrderToSalesRatio = 'CHRONIC_OVERORDERING_SORT_BY_ORDER_TO_SALES_RATIO',
  ChronicOverorderingSortByUnitsReceived = 'CHRONIC_OVERORDERING_SORT_BY_UNITS_RECEIVED',
  ChronicOverorderingSortByUnitsSold = 'CHRONIC_OVERORDERING_SORT_BY_UNITS_SOLD',
  ChronicOverorderingSortByUnknown = 'CHRONIC_OVERORDERING_SORT_BY_UNKNOWN'
}

export type ChronicUnderstockRow = {
  __typename?: 'ChronicUnderstockRow';
  category?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['BigInt']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['BigInt']>;
  estimatedLostSales?: Maybe<Scalars['Float']>;
  estimatedLostUnits?: Maybe<Scalars['Float']>;
  isKeyItem?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  oosDayCount?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['BigInt']>;
  shelfImageUrl?: Maybe<Scalars['String']>;
  typicalEmptyAt?: Maybe<Scalars['DateTime']>;
  typicalEmptyAtFormatted?: Maybe<Scalars['String']>;
  typicalEmptyTime?: Maybe<GoogleTypeTimeOfDay>;
  upc?: Maybe<Scalars['String']>;
};

export enum ChronicUnderstockSortBy {
  ChronicUnderstockSortByEstimatedLostSales = 'CHRONIC_UNDERSTOCK_SORT_BY_ESTIMATED_LOST_SALES',
  ChronicUnderstockSortByEstimatedLostUnits = 'CHRONIC_UNDERSTOCK_SORT_BY_ESTIMATED_LOST_UNITS',
  ChronicUnderstockSortByOosDayCount = 'CHRONIC_UNDERSTOCK_SORT_BY_OOS_DAY_COUNT',
  ChronicUnderstockSortByUnknown = 'CHRONIC_UNDERSTOCK_SORT_BY_UNKNOWN'
}

/** Per-evaluation error codes. Mirrors the Claims proto's ClaimErrorCode. */
export enum ClaimErrorCodeEnum {
  /** Reserved. Mirrors the Claims proto's ClaimErrorCode and is not currently returned by evaluateMyClaims -- the resolver surfaces Pundit access denials as a partial denial (granted=false with accessibleScope), not as an INVALID_RESOURCE error. Consumers should treat it as a forward-compatible value that the GraphQL surface may begin emitting in the future. */
  InvalidResource = 'INVALID_RESOURCE',
  /** Claim is declared against a resource type but the evaluation was submitted without a scope. */
  ScopeRequired = 'SCOPE_REQUIRED',
  /** Claim name is not registered in any namespace. */
  UnknownClaim = 'UNKNOWN_CLAIM'
}

/** A single claim evaluation request for the authenticated user. */
export type ClaimEvaluationInput = {
  /** Namespaced claim name, e.g. 'cx_admin.can_manage_users'. */
  claim: Scalars['String'];
  /** Resource scope for the claim. Required for resource-scoped claims; ignored for global claims. */
  scope?: InputMaybe<ResourceScopeInput>;
};

/** Error reported on an individual claim evaluation. The query as a whole still succeeds; per-evaluation errors do not affect siblings. */
export type ClaimsTypesClaimErrorType = {
  __typename?: 'ClaimsTypesClaimErrorType';
  code: ClaimErrorCodeEnum;
  message: Scalars['String'];
};

/** Result of a single claim evaluation. Index-aligned with the request's evaluations. */
export type ClaimsTypesClaimResultType = {
  __typename?: 'ClaimsTypesClaimResultType';
  /** The subset of the requested scope the subject has access to. Populated only when the evaluator returns a partial denial; null on a grant or on a flat denial. */
  accessibleScope?: Maybe<ClaimsTypesResourceScopeType>;
  /** Populated instead of granted/accessibleScope when the evaluation itself could not be completed (unknown claim, missing scope, etc.). */
  error?: Maybe<ClaimsTypesClaimErrorType>;
  /** True iff the subject is authorized for the claim under the requested scope. */
  granted: Scalars['Boolean'];
};

/** Resource scope returned on a partial denial: the subset of the requested ids the subject can access (never a superset of the request). */
export type ClaimsTypesResourceScopeType = {
  __typename?: 'ClaimsTypesResourceScopeType';
  partnerIds: Array<Scalars['ID']>;
  retailerIds: Array<Scalars['ID']>;
  retailerLocationIds: Array<Scalars['ID']>;
  storeConfigIds: Array<Scalars['ID']>;
};

export enum ClassifiedTypeEnum {
  /** A commodity (bananas, apples, ...) */
  Commodity = 'COMMODITY',
  /** A product that is specific to a retailer (not universal) */
  InHouse = 'IN_HOUSE',
  /** A universal product (standard product with a UPC) */
  Universal = 'UNIVERSAL',
  /** The classification type is not known */
  Unknown = 'UNKNOWN'
}

export type ClearOverrideHoursCriteriaInput = {
  date?: InputMaybe<GoogleTypeDateInput>;
  serviceType?: InputMaybe<RetailerServiceType>;
};

export type ClientConfiguration = {
  __typename?: 'ClientConfiguration';
  applicationType?: Maybe<Scalars['String']>;
  clientConfigurationId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['BigInt']>;
  isUnata?: Maybe<Scalars['Boolean']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerName?: Maybe<Scalars['String']>;
  retailerSlug?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSONObject']>;
  storeConfigurationIds?: Maybe<Scalars['String']>;
  userIsolationContextId?: Maybe<Scalars['Int']>;
};

export type ClientConfigurationInput = {
  applicationType?: InputMaybe<Scalars['String']>;
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  isUnata?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['JSONObject']>;
  storeConfigurationIds?: InputMaybe<Scalars['String']>;
  userIsolationContextId?: InputMaybe<Scalars['Int']>;
};

export enum ClientContextClient {
  Ipp = 'IPP',
  Unknown = 'UNKNOWN'
}

export type ClientContextInput = {
  canonicalId?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<ClientContextClient>;
  email?: InputMaybe<Scalars['String']>;
};

export type ClientInput = {
  appName?: InputMaybe<Scalars['String']>;
  contextJson?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type ClonePartnerOauthApplicationRequestInput = {
  newName?: InputMaybe<Scalars['String']>;
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type ClonePartnerOauthApplicationResponse = {
  __typename?: 'ClonePartnerOauthApplicationResponse';
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
};

export type Collection = {
  __typename?: 'Collection';
  active?: Maybe<Scalars['Boolean']>;
  activeAdminOnly?: Maybe<Scalars['Boolean']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  associatedRetailerCollectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  collectionStoreConfigurations?: Maybe<Array<Maybe<CollectionStoreConfiguration>>>;
  collectionType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  gid?: Maybe<Scalars['String']>;
  headerImageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imagePath?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['BigInt']>;
  mobileHeaderImageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nestedCollections?: Maybe<Array<Maybe<Collection>>>;
  parentId?: Maybe<Scalars['BigInt']>;
  position?: Maybe<Scalars['BigInt']>;
  products?: Maybe<Array<Maybe<Product>>>;
  replaceDepartmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  requiredAlcoholContext?: Maybe<Scalars['String']>;
  requiredRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  searchThumbWideImageUrl?: Maybe<Scalars['String']>;
  showDepartmentTile?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  subjects?: Maybe<Array<Maybe<BaseSubject>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CollectionStoreConfiguration = {
  __typename?: 'CollectionStoreConfiguration';
  id?: Maybe<Scalars['BigInt']>;
  pinned?: Maybe<Scalars['Boolean']>;
};

export type ColorsSchema = {
  __typename?: 'ColorsSchema';
  brandExpressDark?: Maybe<Scalars['String']>;
  brandExpressExtraDark?: Maybe<Scalars['String']>;
  brandExpressLight?: Maybe<Scalars['String']>;
  brandExpressRegular?: Maybe<Scalars['String']>;
  brandHighlightDark?: Maybe<Scalars['String']>;
  brandHighlightLight?: Maybe<Scalars['String']>;
  brandHighlightRegular?: Maybe<Scalars['String']>;
  brandLoyaltyDark?: Maybe<Scalars['String']>;
  brandLoyaltyLight?: Maybe<Scalars['String']>;
  brandLoyaltyRegular?: Maybe<Scalars['String']>;
  brandMaxDark?: Maybe<Scalars['String']>;
  brandMaxLight?: Maybe<Scalars['String']>;
  brandPrimaryDark?: Maybe<Scalars['String']>;
  brandPrimaryExtraDark?: Maybe<Scalars['String']>;
  brandPrimaryExtraLight?: Maybe<Scalars['String']>;
  brandPrimaryLight?: Maybe<Scalars['String']>;
  brandPrimaryRegular?: Maybe<Scalars['String']>;
  brandPromotionalDark?: Maybe<Scalars['String']>;
  brandPromotionalLight?: Maybe<Scalars['String']>;
  brandPromotionalRegular?: Maybe<Scalars['String']>;
  brandSecondaryDark?: Maybe<Scalars['String']>;
  brandSecondaryLight?: Maybe<Scalars['String']>;
  brandSecondaryRegular?: Maybe<Scalars['String']>;
  brandTertiaryLight?: Maybe<Scalars['String']>;
  brandTertiaryRegular?: Maybe<Scalars['String']>;
  highContrastColors?: Maybe<HighContrastColorsSchema>;
  plusDark?: Maybe<Scalars['String']>;
  plusExtraDark?: Maybe<Scalars['String']>;
  plusExtraLight?: Maybe<Scalars['String']>;
  plusLight?: Maybe<Scalars['String']>;
  plusRegular?: Maybe<Scalars['String']>;
  systemDetrimentalDark?: Maybe<Scalars['String']>;
  systemDetrimentalExtraDark?: Maybe<Scalars['String']>;
  systemDetrimentalLight?: Maybe<Scalars['String']>;
  systemDetrimentalRegular?: Maybe<Scalars['String']>;
  systemGrayscale_00?: Maybe<Scalars['String']>;
  systemGrayscale_10?: Maybe<Scalars['String']>;
  systemGrayscale_20?: Maybe<Scalars['String']>;
  systemGrayscale_30?: Maybe<Scalars['String']>;
  systemGrayscale_50?: Maybe<Scalars['String']>;
  systemGrayscale_70?: Maybe<Scalars['String']>;
  systemSuccessDark?: Maybe<Scalars['String']>;
  systemSuccessLight?: Maybe<Scalars['String']>;
  systemSuccessRegular?: Maybe<Scalars['String']>;
  tertiaryRegular?: Maybe<Scalars['String']>;
};

export type CombineAuditBatchesRequestInput = {
  batchUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<Scalars['String']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type CombineAuditBatchesResponse = {
  __typename?: 'CombineAuditBatchesResponse';
  batchUuid?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
};

export type CompactBanner = {
  __typename?: 'CompactBanner';
  backgroundColorHex?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type CompactBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ComponentValueFilterInput = {
  groupName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ConfigurableButtonInput = {
  /** Background color of the button */
  backgroundColor?: InputMaybe<Scalars['String']>;
  /** Color of the button text */
  color?: InputMaybe<Scalars['String']>;
  /** The button text */
  label: Scalars['String'];
  /** The button style to use */
  styleVariant?: InputMaybe<ButtonVariantEnum>;
};

export type ConfigurableTextInput = {
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String'];
  /** The text to display */
  text: Scalars['String'];
};

export type ConfirmedStoreHours = {
  __typename?: 'ConfirmedStoreHours';
  confirmed?: Maybe<Scalars['Boolean']>;
  date?: Maybe<GoogleTypeDate>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type ConfirmedStoreHoursInput = {
  confirmed?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type ConnectApiKey = {
  __typename?: 'ConnectApiKey';
  applicationId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiresIn?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  ipWhitelist?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  revokedAt?: Maybe<Scalars['DateTime']>;
  rotatedAt?: Maybe<Scalars['DateTime']>;
  rotatedFromId?: Maybe<Scalars['BigInt']>;
  scopes?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConnectPlatformEvent = {
  __typename?: 'ConnectPlatformEvent';
  clientConfigurationId?: Maybe<Scalars['Int']>;
  consumerJobId?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  domainObjectId?: Maybe<Scalars['String']>;
  domainObjectType?: Maybe<Scalars['String']>;
  eventMetadata?: Maybe<Scalars['String']>;
  eventName?: Maybe<Scalars['String']>;
  eventTimestamp?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
};

export type ConnectPlatformEventCallback = {
  __typename?: 'ConnectPlatformEventCallback';
  eventId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  notificationStatus?: Maybe<Scalars['String']>;
  notifiedAt?: Maybe<Scalars['DateTime']>;
  payload?: Maybe<Scalars['String']>;
  retailerCallbackConfigurationId?: Maybe<Scalars['BigInt']>;
  successful?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['String']>;
};

export type ConnectPlatformEventCallbackResponse = {
  __typename?: 'ConnectPlatformEventCallbackResponse';
  callbackId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  payload?: Maybe<Scalars['String']>;
  statusCode?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConnectPlatformEventCallbackWithResponses = {
  __typename?: 'ConnectPlatformEventCallbackWithResponses';
  callback?: Maybe<ConnectPlatformEventCallback>;
  responses?: Maybe<Array<Maybe<ConnectPlatformEventCallbackResponse>>>;
};

export type ConnectPlatformEventWithCallbacks = {
  __typename?: 'ConnectPlatformEventWithCallbacks';
  callbacks?: Maybe<Array<Maybe<ConnectPlatformEventCallbackWithResponses>>>;
  event?: Maybe<ConnectPlatformEvent>;
};

export type ConnectRetailerCallbackConfiguration = {
  __typename?: 'ConnectRetailerCallbackConfiguration';
  accessTokenTtl?: Maybe<Scalars['Int']>;
  authUri?: Maybe<Scalars['String']>;
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  credentials?: Maybe<ConnectRetailerCallbackCredentials>;
  enabled?: Maybe<Scalars['Boolean']>;
  environment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  returnsPaymentAck?: Maybe<Scalars['Boolean']>;
  v1Settings?: Maybe<ConnectRetailerCallbackV1Settings>;
  v2Settings?: Maybe<ConnectRetailerCallbackV2Settings>;
};

export type ConnectRetailerCallbackConfigurationInput = {
  accessTokenTtl?: InputMaybe<Scalars['Int']>;
  authUri?: InputMaybe<Scalars['String']>;
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  credentials?: InputMaybe<ConnectRetailerCallbackCredentialsInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  environment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  returnsPaymentAck?: InputMaybe<Scalars['Boolean']>;
  v1Settings?: InputMaybe<ConnectRetailerCallbackV1SettingsInput>;
  v2Settings?: InputMaybe<ConnectRetailerCallbackV2SettingsInput>;
};

export type ConnectRetailerCallbackCredentials = {
  __typename?: 'ConnectRetailerCallbackCredentials';
  apiKey?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  clientSecretEnvKey?: Maybe<Scalars['String']>;
  customKey?: Maybe<Scalars['String']>;
  customTokenEnvKey?: Maybe<Scalars['String']>;
  grantType?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
};

export type ConnectRetailerCallbackCredentialsInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientSecret?: InputMaybe<Scalars['String']>;
  clientSecretEnvKey?: InputMaybe<Scalars['String']>;
  customKey?: InputMaybe<Scalars['String']>;
  customTokenEnvKey?: InputMaybe<Scalars['String']>;
  grantType?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scalars['String']>;
};

export type ConnectRetailerCallbackV1Settings = {
  __typename?: 'ConnectRetailerCallbackV1Settings';
  callbackUri?: Maybe<Scalars['String']>;
  statusesOfInterest?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ConnectRetailerCallbackV1SettingsInput = {
  callbackUri?: InputMaybe<Scalars['String']>;
  statusesOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ConnectRetailerCallbackV2Settings = {
  __typename?: 'ConnectRetailerCallbackV2Settings';
  callbackUri?: Maybe<Scalars['String']>;
  exposeRetailerId?: Maybe<Scalars['Boolean']>;
  orderLocationCallbackFrequency?: Maybe<Scalars['BigInt']>;
  redactShopperPii?: Maybe<Scalars['Boolean']>;
  statusesOfInterest?: Maybe<Array<Maybe<Scalars['String']>>>;
  useApiKey?: Maybe<Scalars['Boolean']>;
  useSignatureVerification?: Maybe<Scalars['Boolean']>;
};

export type ConnectRetailerCallbackV2SettingsInput = {
  callbackUri?: InputMaybe<Scalars['String']>;
  exposeRetailerId?: InputMaybe<Scalars['Boolean']>;
  orderLocationCallbackFrequency?: InputMaybe<Scalars['BigInt']>;
  redactShopperPii?: InputMaybe<Scalars['Boolean']>;
  statusesOfInterest?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useApiKey?: InputMaybe<Scalars['Boolean']>;
  useSignatureVerification?: InputMaybe<Scalars['Boolean']>;
};

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta';
  /** The total number of connection elements */
  totalCount: Scalars['Int'];
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ContactInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Container = {
  __typename?: 'Container';
  hasDepartments?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  navs?: Maybe<Array<Maybe<ContainerNav>>>;
  navsV2?: Maybe<Array<Maybe<ContainerNav>>>;
  placementId?: Maybe<Scalars['BigInt']>;
  position?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type ContainerInput = {
  hasDepartments?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  navs?: InputMaybe<Array<InputMaybe<ContainerNavInput>>>;
  navsV2?: InputMaybe<Array<InputMaybe<ContainerNavInput>>>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type ContainerNav = {
  __typename?: 'ContainerNav';
  departmentsPlaceholderNavigation?: Maybe<DepartmentsPlaceholderNavigation>;
  flatNavWithVariants?: Maybe<FlatNavigationWithVariants>;
};

export type ContainerNavInput = {
  departmentsPlaceholderNavigation?: InputMaybe<DepartmentsPlaceholderNavigationInput>;
  flatNavWithVariants?: InputMaybe<FlatNavigationWithVariantsInput>;
};

export type ContentManagementAnnouncementBannerGenericImages = {
  __typename?: 'ContentManagementAnnouncementBannerGenericImages';
  /** The foreground image url in the placement to be used on desktop clients */
  desktop?: Maybe<Scalars['Url']>;
  /** The foreground image url in the placement to be used on mobile clients */
  mobile: Scalars['Url'];
};

export type ContentManagementConfigurableButton = {
  __typename?: 'ContentManagementConfigurableButton';
  /** The background color of the button (Eg. #FFFFFF) */
  backgroundColor?: Maybe<Scalars['String']>;
  /** Color of the button text (Eg. #000000) */
  color?: Maybe<Scalars['String']>;
  /** The button text */
  label: Scalars['String'];
  /** The button style to use */
  styleVariant: ButtonVariantEnum;
};

export type ContentManagementConfigurableText = {
  __typename?: 'ContentManagementConfigurableText';
  /** The color of the text (Eg. #FFFFFF) */
  color: Scalars['String'];
  /** The text to display */
  text?: Maybe<Scalars['String']>;
};

export type ContentManagementFlyoutPlacement = {
  __typename?: 'ContentManagementFlyoutPlacement';
  /** A unique identifier of the banner associated with the placement */
  bannerId?: Maybe<Scalars['ID']>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** The style and text of the subheading */
  descriptionText: ContentManagementConfigurableText;
  /** The style and text of the secondary text */
  disclaimerText?: Maybe<ContentManagementConfigurableText>;
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment?: Maybe<ContentManagementPlacementExperiment>;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds: Array<Scalars['Int']>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Array<Scalars['Int']>;
  /** The layout the placement should appear on */
  layout: Scalars['String'];
  /** The style and text of the button within the placement */
  linkButton?: Maybe<ContentManagementConfigurableButton>;
  /** Where interacting with the placement leads */
  linkDestination?: Maybe<ContentManagementPlacementDestination>;
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The style and text of the button within the placement */
  primaryButton?: Maybe<ContentManagementConfigurableButton>;
  /** Where interacting with the placement leads */
  primaryDestination?: Maybe<ContentManagementPlacementDestination>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The style and text of the button within the placement */
  secondaryButton?: Maybe<ContentManagementConfigurableButton>;
  /** Where interacting with the placement leads */
  secondaryDestination?: Maybe<ContentManagementPlacementDestination>;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The layout the placement should appear on */
  stringLayout: Scalars['String'];
  /** The style and text of the heading */
  titleText: ContentManagementConfigurableText;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
  /** The variant of the banner */
  variant: Scalars['String'];
};

export type ContentManagementHeroBannerPlacement = {
  __typename?: 'ContentManagementHeroBannerPlacement';
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor?: Maybe<Scalars['String']>;
  /** A unique identifier of the banner associated with the placement */
  bannerId?: Maybe<Scalars['ID']>;
  /** The style and text of the button within the placement */
  button?: Maybe<ContentManagementConfigurableButton>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** Where interacting with the placement leads */
  destination?: Maybe<ContentManagementPlacementDestination>;
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment?: Maybe<ContentManagementPlacementExperiment>;
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds: Array<Scalars['Int']>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Array<Scalars['Int']>;
  /** The layout the placement should appear on */
  layout: Scalars['String'];
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The layout the placement should appear on */
  stringLayout: Scalars['String'];
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
  /** The color of the text area (Eg. #FFFFFF) */
  textareaColor?: Maybe<Scalars['String']>;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
  /** The variant of the banner */
  variant: Scalars['String'];
};

export type ContentManagementPbiConfiguration = {
  __typename?: 'ContentManagementPbiConfiguration';
  /** The url for the retailer's pbi instance */
  domainName: Scalars['String'];
  /** The unique slug for the retailer */
  slug: Scalars['String'];
};

export type ContentManagementPlacementDestination = {
  __typename?: 'ContentManagementPlacementDestination';
  /** The human readable value of the target */
  displayValue?: Maybe<Scalars['String']>;
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String'];
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum;
};

export type ContentManagementPlacementExperiment = {
  __typename?: 'ContentManagementPlacementExperiment';
  /** Experiment Assignment or Lookup */
  accessMethod?: Maybe<PlacementExperimentMethodEnum>;
  /** Name of the Experiment */
  name?: Maybe<Scalars['String']>;
  /** Variant of the Experiment for which placement should be visible */
  variant?: Maybe<Scalars['String']>;
};

export type ContentManagementPlacementImages = {
  __typename?: 'ContentManagementPlacementImages';
  /** The image url of the placement to display for large viewports */
  large?: Maybe<Scalars['Url']>;
  /** The image url of the placement to display for small viewports */
  small?: Maybe<Scalars['Url']>;
};

export type ContentManagementPlacementSchedule = {
  __typename?: 'ContentManagementPlacementSchedule';
  /** When the placement should stop being active */
  endDate?: Maybe<Scalars['Time']>;
  /** When the placement should become active */
  startDate: Scalars['Time'];
  /** The timezone in which the banner will stop being active at midnight */
  timezone?: Maybe<Scalars['String']>;
};

export type ContentManagementSecondaryBannerPlacement = {
  __typename?: 'ContentManagementSecondaryBannerPlacement';
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor?: Maybe<Scalars['String']>;
  /** A unique identifier of the banner associated with the placement */
  bannerId?: Maybe<Scalars['ID']>;
  /** The style and text of the button within the placement */
  button?: Maybe<ContentManagementConfigurableButton>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** Where interacting with the placement leads */
  destination?: Maybe<ContentManagementPlacementDestination>;
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment?: Maybe<ContentManagementPlacementExperiment>;
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The possible images to display */
  images: ContentManagementAnnouncementBannerGenericImages;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds: Array<Scalars['Int']>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds: Array<Scalars['Int']>;
  /** The layout the placement should appear on */
  layout: Scalars['String'];
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The style and text of the secondary text */
  secondaryText?: Maybe<ContentManagementConfigurableText>;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The layout the placement should appear on */
  stringLayout: Scalars['String'];
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
  /** The variant of the banner */
  variant: Scalars['String'];
};

export type ContentManagementStorefrontPlacement = {
  __typename?: 'ContentManagementStorefrontPlacement';
  /** The color of the background for text images (Eg. #FFFFFF) */
  backgroundColor?: Maybe<Scalars['String']>;
  /** A unique identifier of the banner associated with the placement */
  bannerId?: Maybe<Scalars['ID']>;
  /** The banners configured to the placement */
  banners: Array<ContentManagementStorefrontPlacementBanner>;
  /** The style and text of the button within the placement */
  button?: Maybe<ContentManagementConfigurableButton>;
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText;
  /** Where interacting with the placement leads */
  destination?: Maybe<ContentManagementPlacementDestination>;
  /** Whether or not the placement can be dismissed */
  dismissable: Scalars['Boolean'];
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: ContentManagementPlacementImages;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: Maybe<Array<Scalars['Int']>>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
};

export type ContentManagementStorefrontPlacementBanner = {
  __typename?: 'ContentManagementStorefrontPlacementBanner';
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor?: Maybe<Scalars['String']>;
  /** The style and text of the button within the placement */
  button?: Maybe<ContentManagementConfigurableButton>;
  /** The style and text of the description */
  descriptionText: ContentManagementConfigurableText;
  /** The style and text of the heading */
  headingText: ContentManagementConfigurableText;
  /** A unique identifier of the banner associated with the placement */
  id?: Maybe<Scalars['ID']>;
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: ContentManagementPlacementImages;
  /** The banner's locale */
  locale?: Maybe<BannerLocaleEnum>;
  /** The style and text of the subheading */
  subheadingText: ContentManagementConfigurableText;
};

/** The connection type for ContentManagementStorefrontPlacement. */
export type ContentManagementStorefrontPlacementConnection = {
  __typename?: 'ContentManagementStorefrontPlacementConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ContentManagementStorefrontPlacementEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ContentManagementStorefrontPlacement>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContentManagementStorefrontPlacementEdge = {
  __typename?: 'ContentManagementStorefrontPlacementEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ContentManagementStorefrontPlacement>;
};

export type ContentManagementUnknownBannerPlacement = {
  __typename?: 'ContentManagementUnknownBannerPlacement';
  /** When the placement was created */
  createdAt: Scalars['Time'];
  /** If the placement is enabled */
  enabled: Scalars['Boolean'];
  /** Experiment associated with the placement */
  experiment?: Maybe<ContentManagementPlacementExperiment>;
  /** A unique identifier for the placement */
  id: Scalars['ID'];
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank: Scalars['Int'];
  /** When the placement begins and ends */
  scheduling: ContentManagementPlacementSchedule;
  /** The current status of the placement */
  status: PlacementStatusEnum;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** When the placement was last edited */
  updatedAt: Scalars['Time'];
};

export type ContentManagementVisibilityConditionCountryIds = {
  __typename?: 'ContentManagementVisibilityConditionCountryIds';
  /** list of country ids */
  countryIds: Array<Scalars['Int']>;
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionDayOfWeek = {
  __typename?: 'ContentManagementVisibilityConditionDayOfWeek';
  /** list of days within the week */
  days: Array<Scalars['String']>;
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionExperimentVariant = {
  __typename?: 'ContentManagementVisibilityConditionExperimentVariant';
  /** The method of the experiment */
  experimentMethod: PlacementExperimentMethodEnum;
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** The name of the experiment variant */
  experimentVariant: Scalars['String'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionExpressMembership = {
  __typename?: 'ContentManagementVisibilityConditionExpressMembership';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>;
};

export type ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout = {
  __typename?: 'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: Maybe<Scalars['ID']>;
};

export type ContentManagementVisibilityConditionMatchesAnyRetailerId = {
  __typename?: 'ContentManagementVisibilityConditionMatchesAnyRetailerId';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of retailer ids */
  retailerIds: Array<Scalars['Int']>;
};

export type ContentManagementVisibilityConditionMinimumPlatformVersion = {
  __typename?: 'ContentManagementVisibilityConditionMinimumPlatformVersion';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum;
  /** Version used for the check */
  version: Scalars['String'];
};

export type ContentManagementVisibilityConditionNewVerticalUserTargeting = {
  __typename?: 'ContentManagementVisibilityConditionNewVerticalUserTargeting';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** The module type */
  moduleType: Scalars['String'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionRetailerAvailability = {
  __typename?: 'ContentManagementVisibilityConditionRetailerAvailability';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** A unique identifier of the retailer associated with the visibility condition */
  retailerId: Scalars['Int'];
};

export type ContentManagementVisibilityConditionShopped = {
  __typename?: 'ContentManagementVisibilityConditionShopped';
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int'];
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int'];
  /** Number of times in the past to check */
  numberOfTimes: Scalars['Int'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int'];
};

export type ContentManagementVisibilityConditionShoppedAtRetailer = {
  __typename?: 'ContentManagementVisibilityConditionShoppedAtRetailer';
  /** Id of the country where the check is to be performed */
  countryId: Scalars['Int'];
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Number of days in the past to check */
  numberOfDays: Scalars['Int'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the Retailer */
  retailerId: Scalars['Int'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId: Scalars['Int'];
};

export type ContentManagementVisibilityConditionUnknownVisibilityCondition = {
  __typename?: 'ContentManagementVisibilityConditionUnknownVisibilityCondition';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionUserInteractionLimit = {
  __typename?: 'ContentManagementVisibilityConditionUserInteractionLimit';
  /** Number of seconds to wait before resetting the counter */
  countCooldownSec?: Maybe<Scalars['Int']>;
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** Maximum number of dismiss events */
  maxDismissedCount?: Maybe<Scalars['Int']>;
  /** Maximum number of click events */
  maxEngagementsCount?: Maybe<Scalars['Int']>;
  /** Maximum number of view events */
  maxImpressionsCount?: Maybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

export type ContentManagementVisibilityConditionUtmParameters = {
  __typename?: 'ContentManagementVisibilityConditionUtmParameters';
  /** coupon_code */
  couponCode: Scalars['String'];
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** utm_campaign */
  utmCampaign: Scalars['String'];
  /** utm_content */
  utmContent: Scalars['String'];
  /** utm_medium */
  utmMedium: Scalars['String'];
  /** utm_source */
  utmSource: Scalars['String'];
  /** utm_term */
  utmTerm: Scalars['String'];
};

export type ContentManagementVisibilityConditionWhitelistedPostalCodes = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedPostalCodes';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>;
};

export type ContentManagementVisibilityConditionWhitelistedZones = {
  __typename?: 'ContentManagementVisibilityConditionWhitelistedZones';
  /** A unique identifier for the visibility condition */
  id: Scalars['ID'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of zone ids */
  zones: Array<Scalars['String']>;
};

export type ContentPage = {
  __typename?: 'ContentPage';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  internalName?: Maybe<Scalars['String']>;
  layout?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

export type ContentPageMetaInfoStatusFound302 = {
  __typename?: 'ContentPageMetaInfoStatusFound302';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusFound302Input = {
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusMovedPermanently301 = {
  __typename?: 'ContentPageMetaInfoStatusMovedPermanently301';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusMovedPermanently301Input = {
  redirectUrl?: InputMaybe<Scalars['String']>;
};

export type ContentPageMetaInfoStatusNotFound404 = {
  __typename?: 'ContentPageMetaInfoStatusNotFound404';
  _?: Maybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusNotFound404Input = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusOk200 = {
  __typename?: 'ContentPageMetaInfoStatusOk200';
  _?: Maybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusOk200Input = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type ContentPageMetaInfoStatusOneOf = {
  __typename?: 'ContentPageMetaInfoStatusOneOf';
  found302?: Maybe<ContentPageMetaInfoStatusFound302>;
  movedPermanently301?: Maybe<ContentPageMetaInfoStatusMovedPermanently301>;
  notFound404?: Maybe<ContentPageMetaInfoStatusNotFound404>;
  ok200?: Maybe<ContentPageMetaInfoStatusOk200>;
};

export type ContentPageMetaInfoStatusOneOfInput = {
  found302?: InputMaybe<ContentPageMetaInfoStatusFound302Input>;
  movedPermanently301?: InputMaybe<ContentPageMetaInfoStatusMovedPermanently301Input>;
  notFound404?: InputMaybe<ContentPageMetaInfoStatusNotFound404Input>;
  ok200?: InputMaybe<ContentPageMetaInfoStatusOk200Input>;
};

export type ContentPageSlotArea = {
  __typename?: 'ContentPageSlotArea';
  allowedPlacementVariants?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  maxPlacements?: Maybe<Scalars['BigInt']>;
  minPlacements?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['BigInt']>;
};

export type ContentPageSlots = {
  __typename?: 'ContentPageSlots';
  archivedAt?: Maybe<Scalars['DateTime']>;
  contentPageVersionId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  internalName?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  slotCreatives?: Maybe<Array<Maybe<SlotCreative>>>;
  slots?: Maybe<Array<Maybe<Slot>>>;
  slug?: Maybe<Scalars['String']>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContentPageV2 = {
  __typename?: 'ContentPageV2';
  activeVersionId?: Maybe<Scalars['BigInt']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  hasScheduledVersion?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  instacartInternal?: Maybe<Scalars['Boolean']>;
  internalName?: Maybe<Scalars['String']>;
  pageType?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  schedule?: Maybe<Scalars['String']>;
  scheduleEnabled?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  teamOwner?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContentPageVersion = {
  __typename?: 'ContentPageVersion';
  contentPageId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  pageStyle?: Maybe<PageStyle>;
  previewToken?: Maybe<Scalars['String']>;
  routingStatus?: Maybe<ContentPageMetaInfoStatusOneOf>;
  scheduledPublishAt?: Maybe<Scalars['DateTime']>;
  seoCanonicalUrl?: Maybe<Scalars['String']>;
  seoNoIndex?: Maybe<Scalars['Boolean']>;
  trackingProperties?: Maybe<Scalars['JSONObject']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContentPageVersionMeta = {
  __typename?: 'ContentPageVersionMeta';
  contentPageVersionId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Defines filtering criteria based on content attributes in a request to list approval requests. */
export type ContentSearchInput = {
  /** Returns ARs that match the provided content_type. */
  equalsContentType?: InputMaybe<Scalars['String']>;
  /** Returns ARs that contain a superset of the provided set of IDs. */
  hasContentIds?: InputMaybe<Array<Scalars['String']>>;
};

/** The type of content snapshot. */
export enum ContentSnapshot {
  /** A snapshot of the original content as it currently is published today. */
  Base = 'BASE',
  /** A snapshot of the proposed changes to the content. */
  Revision = 'REVISION'
}

export type ContractRenderData = {
  __typename?: 'ContractRenderData';
  companyAddress?: Maybe<Scalars['String']>;
  companyContactName?: Maybe<Scalars['String']>;
  companyContactTitle?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  currentDate?: Maybe<Scalars['String']>;
  stateOfIncorporation?: Maybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  /** country code */
  alpha2?: Maybe<Scalars['String']>;
  /** Unique identifier */
  id: Scalars['ID'];
  /** country name */
  name: Scalars['String'];
};

export type CountryIdsInput = {
  /** list of country ids */
  countryIds: Array<Scalars['Int']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of CountryIdsVisibilityConditionCreate */
export type CountryIdsVisibilityConditionCreatePayload = {
  __typename?: 'CountryIdsVisibilityConditionCreatePayload';
  /** The newly created CountryIds visibility condition */
  countryIdsVisibilityCondition: ContentManagementVisibilityConditionCountryIds;
};

/** Autogenerated return type of CountryIdsVisibilityConditionUpdate */
export type CountryIdsVisibilityConditionUpdatePayload = {
  __typename?: 'CountryIdsVisibilityConditionUpdatePayload';
  /** The newly updated CountryIds visibility condition */
  countryIdsVisibilityCondition: ContentManagementVisibilityConditionCountryIds;
};

export type CreateAddressWithoutDuplicatesRequestInput = {
  accessCode?: InputMaybe<Scalars['String']>;
  addressCategory?: InputMaybe<Scalars['String']>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  deliveryContactName?: InputMaybe<Scalars['String']>;
  deliveryContactPhoneNumber?: InputMaybe<Scalars['String']>;
  forceValid?: InputMaybe<Scalars['Boolean']>;
  placeName?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  skipUserCheck?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateAiCarouselRequestInput = {
  userPrompt?: InputMaybe<Scalars['String']>;
};

export type CreateAiCarouselResponse = {
  __typename?: 'CreateAiCarouselResponse';
  aiCarouselConfiguration?: Maybe<AiCarouselConfiguration>;
};

export type CreateAuditWorkflowRequestInput = {
  auditWorkflow?: InputMaybe<AuditWorkflowInput>;
};

export type CreateAuditWorkflowResponse = {
  __typename?: 'CreateAuditWorkflowResponse';
  id?: Maybe<Scalars['BigInt']>;
};

export type CreateAutomatedTestRunRequestInput = {
  additionalEnv?: InputMaybe<Scalars['String']>;
  additionalEnvVariables?: InputMaybe<Array<InputMaybe<AdditionalEnvVariableInput>>>;
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  testCaseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateAutomatedTestRunResponse = {
  __typename?: 'CreateAutomatedTestRunResponse';
  branch?: Maybe<Scalars['String']>;
  buildUrl?: Maybe<Scalars['String']>;
  commit?: Maybe<Scalars['String']>;
};

export type CreateClientConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>;
  clientConfiguration?: InputMaybe<ClientConfigurationInput>;
};

export type CreateClientConfigurationResponse = {
  __typename?: 'CreateClientConfigurationResponse';
  clientConfiguration?: Maybe<ClientConfiguration>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfiguration?: InputMaybe<ConnectRetailerCallbackConfigurationInput>;
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'CreateConnectRetailerCallbackConfigurationResponse';
  callbackConfiguration?: Maybe<ConnectRetailerCallbackConfiguration>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateContentPageRequestInput = {
  internalName?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateContentPageRequestV2Input = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  instacartInternal?: InputMaybe<Scalars['Boolean']>;
  internalName?: InputMaybe<Scalars['String']>;
  pageType?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  schedule?: InputMaybe<Scalars['String']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  teamOwner?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateContentPageResponse = {
  __typename?: 'CreateContentPageResponse';
  contentPage?: Maybe<ContentPage>;
};

export type CreateContentPageResponseV2 = {
  __typename?: 'CreateContentPageResponseV2';
  contentPage?: Maybe<ContentPageV2>;
};

export type CreateContentPageVersionMetaRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  description?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateContentPageVersionMetaResponse = {
  __typename?: 'CreateContentPageVersionMetaResponse';
  contentPageVersionMeta?: Maybe<ContentPageVersionMeta>;
};

export type CreateContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  baseContentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  pageStyle?: InputMaybe<PageStyleInput>;
  routingStatus?: InputMaybe<ContentPageMetaInfoStatusOneOfInput>;
  scheduledPublishAt?: InputMaybe<Scalars['DateTime']>;
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  seoNoIndex?: InputMaybe<Scalars['Boolean']>;
  trackingProperties?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateContentPageVersionResponse = {
  __typename?: 'CreateContentPageVersionResponse';
  contentPageVersion?: Maybe<ContentPageVersion>;
};

export type CreateCreativePlacementsRequestInput = {
  creatives?: InputMaybe<Array<InputMaybe<PlacementContentInput>>>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type CreateCreativePlacementsResponse = {
  __typename?: 'CreateCreativePlacementsResponse';
  creatives?: Maybe<Array<Maybe<CreateCreativePlacementsResponseCreativePlacementResult>>>;
};

export type CreateCreativePlacementsResponseCreativePlacementResult = {
  __typename?: 'CreateCreativePlacementsResponseCreativePlacementResult';
  creativeRank?: Maybe<Scalars['Int']>;
  placement?: Maybe<PlacementContent>;
  slotCreative?: Maybe<SlotCreative>;
};

export type CreateDefaultNavigationsV2RequestInput = {
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateDefaultNavigationsV2Response = {
  __typename?: 'CreateDefaultNavigationsV2Response';
  createdLayoutTypes?: Maybe<Array<Maybe<LayoutType>>>;
};

export type CreateDetectionRequestInput = {
  attributes?: InputMaybe<DetectionVersionAttributesInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateDetectionResponse = {
  __typename?: 'CreateDetectionResponse';
  id?: Maybe<Scalars['BigInt']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type CreateDetectionVersionRequestInput = {
  attributes?: InputMaybe<DetectionVersionAttributesInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type CreateDetectionVersionResponse = {
  __typename?: 'CreateDetectionVersionResponse';
  version?: Maybe<Scalars['BigInt']>;
};

export type CreateDriverRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CreateDriverResponse = {
  __typename?: 'CreateDriverResponse';
  id?: Maybe<Scalars['BigInt']>;
};

export type CreateFrothTemplateRequestInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  copyOfFrothTemplateVersionId?: InputMaybe<Scalars['BigInt']>;
  createdBy?: InputMaybe<Scalars['String']>;
  instacartInternal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerScope?: InputMaybe<FrothTemplateScope>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationScope?: InputMaybe<FrothTemplateScope>;
  tag?: InputMaybe<Scalars['String']>;
};

export type CreateFrothTemplateResponse = {
  __typename?: 'CreateFrothTemplateResponse';
  frothTemplate?: Maybe<FrothTemplate>;
};

export type CreateFrothTemplateVersionRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSONObject']>;
  contentSchema?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  dataQuery?: InputMaybe<DataQueryStructInput>;
  frothAst?: InputMaybe<Scalars['String']>;
  frothTemplateId?: InputMaybe<Scalars['BigInt']>;
  previewImageUrl?: InputMaybe<Scalars['String']>;
  previewImageUrlMobile?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type CreateFrothTemplateVersionResponse = {
  __typename?: 'CreateFrothTemplateVersionResponse';
  frothTemplateVersion?: Maybe<FrothTemplateVersionInfo>;
};

export type CreateImageUploadBatchRequestInput = {
  imagesAwsDetails?: InputMaybe<ImagesAwsDetailsInput>;
  imagesZipKey?: InputMaybe<Scalars['String']>;
  importType?: InputMaybe<Scalars['String']>;
  localeId?: InputMaybe<Scalars['BigInt']>;
  sourceType?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateImageUploadBatchResponse = {
  __typename?: 'CreateImageUploadBatchResponse';
  imageUploadBatchId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Scalars['String']>;
};

export type CreateLastmileOrderFromDashboardRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateLastmileOrderFromDashboardResponse = {
  __typename?: 'CreateLastmileOrderFromDashboardResponse';
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

export type CreateLayoutVariantRequestInput = {
  layoutVariant?: InputMaybe<LayoutVariantInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateLayoutVariantResponse = {
  __typename?: 'CreateLayoutVariantResponse';
  layoutVariant?: Maybe<LayoutVariant>;
};

export type CreateMassOpsInterventionRequestInput = {
  highPriorityOnly?: InputMaybe<Scalars['Boolean']>;
  investigationId?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateMassOpsInterventionResponse = {
  __typename?: 'CreateMassOpsInterventionResponse';
  integrationId?: Maybe<Scalars['BigInt']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type CreateMomentRequestInput = {
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  discoverability?: InputMaybe<Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type CreateMomentResponse = {
  __typename?: 'CreateMomentResponse';
  moment?: Maybe<Moment>;
};

export type CreateNativeTabBarNavigationRequestInput = {
  navigation?: InputMaybe<NativeTabBarNavigationInput>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNativeTabBarNavigationResponse = {
  __typename?: 'CreateNativeTabBarNavigationResponse';
  navigation?: Maybe<NativeTabBarNavigation>;
};

export type CreateNavigationPreviewRequestInput = {
  navigation?: InputMaybe<NavigationInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNavigationPreviewResponse = {
  __typename?: 'CreateNavigationPreviewResponse';
  previewToken?: Maybe<Scalars['String']>;
};

export type CreateNavigationRequestInput = {
  layout?: InputMaybe<Scalars['String']>;
  navigation?: InputMaybe<NavigationInput>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNavigationResponse = {
  __typename?: 'CreateNavigationResponse';
  navigation?: Maybe<Navigation>;
};

export type CreateNavigationV2PreviewRequestInput = {
  adminNavigationV2?: InputMaybe<AdminNavigationV2Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateNavigationV2PreviewResponse = {
  __typename?: 'CreateNavigationV2PreviewResponse';
  previewToken?: Maybe<Scalars['String']>;
};

export type CreateOnboardingStoreLocationRequestInput = {
  address?: InputMaybe<AddressInput>;
  token?: InputMaybe<Scalars['String']>;
};

export type CreateOnboardingStoreLocationResponse = {
  __typename?: 'CreateOnboardingStoreLocationResponse';
  onboarding?: Maybe<Onboarding>;
};

export type CreateOosAcknowledgmentRequestInput = {
  oosId?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateOosAcknowledgmentResponse = {
  __typename?: 'CreateOosAcknowledgmentResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdateLinkAutosuggestionAdminParametersInput = {
  linkAutosuggestion?: InputMaybe<LinkAutosuggestionAdminInput>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOrUpdateLinkAutosuggestionAdminRequestInput = {
  parameters?: InputMaybe<CreateOrUpdateLinkAutosuggestionAdminParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOrUpdateLinkAutosuggestionAdminResponse = {
  __typename?: 'CreateOrUpdateLinkAutosuggestionAdminResponse';
  linkAutosuggestion?: Maybe<LinkAutosuggestionAdmin>;
};

export type CreateOrUpdateReturnRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  returnData?: InputMaybe<ProposedReturnInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateOrUpdateReturnResponse = {
  __typename?: 'CreateOrUpdateReturnResponse';
  message?: Maybe<Scalars['String']>;
  status?: Maybe<ResponseStatus>;
};

export type CreatePartnerApiKeyRequestInput = {
  environment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type CreatePatchApprovalRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  expectedExpiryAt?: InputMaybe<Scalars['DateTime']>;
  investigationId?: InputMaybe<Scalars['String']>;
  patchName?: InputMaybe<Scalars['String']>;
  patchType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type CreatePatchApprovalResponse = {
  __typename?: 'CreatePatchApprovalResponse';
  approvalRequestId?: Maybe<Scalars['String']>;
  investigationId?: Maybe<Scalars['String']>;
  patchStatus?: Maybe<PatchStatus>;
};

export type CreatePiiRequestForRetailerRequestInput = {
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  requestType?: InputMaybe<RequestType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerNotes?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CreatePiiRequestForRetailerResponse = {
  __typename?: 'CreatePiiRequestForRetailerResponse';
  piiRequestCreationStatus?: Maybe<PiiRequestCreationStatus>;
  piiRequestId?: Maybe<Scalars['BigInt']>;
};

export type CreatePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>;
  content?: InputMaybe<PlacementContentInput>;
};

export type CreatePlacementContentResponse = {
  __typename?: 'CreatePlacementContentResponse';
  content?: Maybe<PlacementContent>;
};

export type CreatePlacementRequestInput = {
  placement?: InputMaybe<PlacementInput>;
};

export type CreatePlacementResponse = {
  __typename?: 'CreatePlacementResponse';
  placement?: Maybe<Placement>;
};

export type CreatePriceAnomalyInvestigationRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  createdWhy?: InputMaybe<Scalars['String']>;
  investigationParameters?: InputMaybe<Scalars['JSONObject']>;
  investigationType?: InputMaybe<InvestigationType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreatePriceAnomalyInvestigationResponse = {
  __typename?: 'CreatePriceAnomalyInvestigationResponse';
  investigation?: Maybe<Investigation>;
};

export type CreatePriceAnomalyPatchRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  expectedExpiryAt?: InputMaybe<Scalars['DateTime']>;
  investigationId?: InputMaybe<Scalars['String']>;
  patchName?: InputMaybe<Scalars['String']>;
  patchType?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type CreatePriceAnomalyPatchResponse = {
  __typename?: 'CreatePriceAnomalyPatchResponse';
  investigationId?: Maybe<Scalars['String']>;
  patchId?: Maybe<Scalars['String']>;
  patchStatus?: Maybe<PatchStatus>;
};

export type CreateProductWithProductCreationDataRequestInput = {
  finalProductData?: InputMaybe<Scalars['JSONObject']>;
  heroImageS3Url?: InputMaybe<Scalars['String']>;
  imageS3Urls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  redrive?: InputMaybe<Scalars['Boolean']>;
  retailerLocaleSubmissions?: InputMaybe<Array<InputMaybe<CreateProductWithProductCreationDataRowInput>>>;
  usePdp?: InputMaybe<Scalars['Boolean']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type CreateProductWithProductCreationDataResponse = {
  __typename?: 'CreateProductWithProductCreationDataResponse';
  error?: Maybe<Scalars['String']>;
};

export type CreateProductWithProductCreationDataRowInput = {
  locale?: InputMaybe<Scalars['String']>;
  productData?: InputMaybe<Scalars['JSONObject']>;
  redrive?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateRecommendationFeedbackRequestInput = {
  action?: InputMaybe<RecommendationAction>;
  recommendationId?: InputMaybe<Scalars['String']>;
  rejectionReasonCode?: InputMaybe<RejectionReasonCode>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type CreateRecommendationFeedbackResponse = {
  __typename?: 'CreateRecommendationFeedbackResponse';
  effectiveKind?: Maybe<RecommendationKind>;
  effectiveStockStatus?: Maybe<StockStatus>;
};

export type CreateRetailerCampaignRequestInput = {
  allowFutureVgpStartDate?: InputMaybe<Scalars['Boolean']>;
  automaticBudgetCappingEnrolled?: InputMaybe<Scalars['Boolean']>;
  automaticBudgetPausingEnrolled?: InputMaybe<Scalars['Boolean']>;
  budgetPacingEnabled?: InputMaybe<Scalars['Boolean']>;
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignReference?: InputMaybe<CampaignReferenceInput>;
  campaignType?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  countryIdValue?: InputMaybe<Scalars['BigInt']>;
  couponCount?: InputMaybe<Scalars['BigInt']>;
  creatorIppUserId?: InputMaybe<Scalars['BigInt']>;
  creatorUserEmail?: InputMaybe<Scalars['String']>;
  creatorUserId?: InputMaybe<Scalars['BigInt']>;
  crmsIntentionConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  customProperties?: InputMaybe<Array<InputMaybe<CustomPropertyInput>>>;
  discountPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  discoverability?: InputMaybe<Discoverability>;
  enableDirectLinkForOnlineCampaign?: InputMaybe<Scalars['Boolean']>;
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  enableOnlineCampaignCrm?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  exclusivityGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
  forInternalTestingOnly?: InputMaybe<Scalars['Boolean']>;
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  ippUserCanonicalUuid?: InputMaybe<Scalars['String']>;
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  marketingMessagingDetails?: InputMaybe<MarketingMessagingDetailsInput>;
  metadata?: InputMaybe<Scalars['JSONObject']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferInput>>>;
  offlineCampaignEstimatedSizeWhenCreation?: InputMaybe<Scalars['BigInt']>;
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  redemptionMethod?: InputMaybe<RedemptionMethod>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  reissuable?: InputMaybe<Scalars['Boolean']>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<RestaurantRewardPolicyInput>;
  retailerAgnostic?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  rouletteFeature?: InputMaybe<CampaignRouletteFeatureInput>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  separateTreatmentPolicies?: InputMaybe<Scalars['Boolean']>;
  skipCreateCouponCode?: InputMaybe<Scalars['Boolean']>;
  slotCreatives?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementAdminV1SlotCreativeInput>>>;
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  targeting?: InputMaybe<Array<InputMaybe<Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<TargetingRulesInput>>>;
  templateId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  treatmentTask?: InputMaybe<CampaignTreatmentTaskRequestParamsInput>;
  treatments?: InputMaybe<RetailerCampaignTreatmentsInput>;
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type CreateRetailerCampaignTreatmentParamsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<RetailerCampaignTreatmentDetailsInput>>>;
  treatmentType?: InputMaybe<RetailerCampaignTreatmentType>;
};

export type CreateRoleInput = {
  /** A description of the role */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the role */
  name: Scalars['String'];
  partnerId?: InputMaybe<Scalars['ID']>;
  /** The permissions associated with this role */
  permissions?: InputMaybe<Array<PermissionInput>>;
  retailerId?: InputMaybe<Scalars['ID']>;
};

export type CreateSignupRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  signupPartnerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateSignupResponse = {
  __typename?: 'CreateSignupResponse';
  token?: Maybe<Scalars['String']>;
};

export type CreateSiteSetupFormAccessRequestRequestInput = {
  accessValidityDays?: InputMaybe<Scalars['Int']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  jiraTicket?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateSiteSetupFormAccessRequestResponse = {
  __typename?: 'CreateSiteSetupFormAccessRequestResponse';
  accessRequest?: Maybe<AccessRequest>;
};

export type CreateSlotCreativeRequestInput = {
  cartState?: InputMaybe<CartState>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
};

export type CreateSlotCreativeResponse = {
  __typename?: 'CreateSlotCreativeResponse';
  slotCreative?: Maybe<SlotCreative>;
};

export type CreateSlotPlacementRequestInput = {
  placement?: InputMaybe<PlacementContentInput>;
  slot?: InputMaybe<CreateSlotPlacementRequestSlotConfigInput>;
};

export type CreateSlotPlacementRequestSlotConfigInput = {
  description?: InputMaybe<Scalars['String']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateSlotPlacementResponse = {
  __typename?: 'CreateSlotPlacementResponse';
  placement?: Maybe<PlacementContent>;
  slot?: Maybe<Slot>;
};

export type CreateSlotRequestInput = {
  description?: InputMaybe<Scalars['String']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  legacySlotId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateSlotResponse = {
  __typename?: 'CreateSlotResponse';
  slot?: Maybe<Slot>;
};

export type CreateStoreConfigurationDraftRequestInput = {
  draftName?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateStoreConfigurationDraftResponse = {
  __typename?: 'CreateStoreConfigurationDraftResponse';
  domainConfigurations?: Maybe<DomainConfiguration>;
  domainConfigurationsRaw?: Maybe<Scalars['JSONObject']>;
  draftId?: Maybe<Scalars['String']>;
  draftName?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  partnerAccessOptions?: Maybe<PartnerAccessOptionsSchema>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

export type CreateStoreConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>;
  storeConfiguration?: InputMaybe<StoreConfigurationInput>;
};

export type CreateStoreConfigurationResponse = {
  __typename?: 'CreateStoreConfigurationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  storeConfiguration?: Maybe<StoreConfiguration>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateThemePageRequestInput = {
  themePage?: InputMaybe<ThemePageInput>;
};

export type CreateThemePageResponse = {
  __typename?: 'CreateThemePageResponse';
  themePage?: Maybe<ThemePage>;
};

export type CreateTicketRequestInput = {
  assignee?: InputMaybe<UserInput>;
  client?: InputMaybe<ClientInput>;
  description?: InputMaybe<Scalars['String']>;
  entityIds?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  entityType?: InputMaybe<EntityType>;
  localeCode?: InputMaybe<Scalars['String']>;
  problemType?: InputMaybe<ProblemType>;
  reportedOnBehalfOf?: InputMaybe<UserInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateTicketResponse = {
  __typename?: 'CreateTicketResponse';
  cptTicketId?: Maybe<Scalars['BigInt']>;
};

export type CreateUserWithoutPasswordRequestInput = {
  clientIdentifier?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  signupSource?: InputMaybe<Scalars['String']>;
};

export type CreateValueBasedOverrideRequestInput = {
  valueBasedOverride?: InputMaybe<ValueBasedOverrideRequestInput>;
};

export type CreateValueBasedOverrideResponse = {
  __typename?: 'CreateValueBasedOverrideResponse';
  valueBasedOverride?: Maybe<ValueBasedOverrideResponse>;
};

export type CreateWhitelabelSiteCustomizableStringRequestInput = {
  whitelabelSiteCustomizableString?: InputMaybe<WhitelabelSiteCustomizableStringInput>;
};

export type CreateWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'CreateWhitelabelSiteCustomizableStringResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  whitelabelSiteCustomizableString?: Maybe<WhitelabelSiteCustomizableString>;
};

export type CreateWhitelabelSiteRequestInput = {
  delayRetailerEmail?: InputMaybe<Scalars['Boolean']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  jiraTicket?: InputMaybe<Scalars['String']>;
  ownerUserUuid?: InputMaybe<Scalars['String']>;
  retailerUserUuid?: InputMaybe<Scalars['String']>;
  skipRetailerForm?: InputMaybe<Scalars['Boolean']>;
  slackChannel?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  tier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type CreateWhitelabelSiteResponse = {
  __typename?: 'CreateWhitelabelSiteResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type CreateWhitelabelStoreConfigurationRequestInput = {
  allowExistingUserIsolationContextId?: InputMaybe<Scalars['Boolean']>;
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  setupOptions?: InputMaybe<Scalars['JSONObject']>;
  storeConfiguration?: InputMaybe<StoreConfigurationInput>;
};

export type CreateWhitelabelStoreConfigurationResponse = {
  __typename?: 'CreateWhitelabelStoreConfigurationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CustomFontFamilySchema = {
  __typename?: 'CustomFontFamilySchema';
  customFontFamily?: Maybe<FontFamily>;
};

export type CustomImages = {
  __typename?: 'CustomImages';
  accountOrdersEmptyState?: Maybe<AccountOrdersEmptyState>;
  cartEmptyState?: Maybe<CartEmptyState>;
  mobileAppWelcomeScreen?: Maybe<MobileAppWelcomeScreen>;
  recipeMissingIngredient?: Maybe<RecipeMissingIngredient>;
};

export type CustomProperty = {
  __typename?: 'CustomProperty';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type CustomPropertyInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum CustomersAddressType {
  AddressTypeUnspecified = 'ADDRESS_TYPE_UNSPECIFIED',
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL'
}

export type CustomersAdminRequestContextInput = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersAmounts = {
  __typename?: 'CustomersAmounts';
  amount?: Maybe<CustomersGoogleTypeMoney>;
  labelInEnglish?: Maybe<Scalars['String']>;
};

export type CustomersContext = {
  __typename?: 'CustomersContext';
  clientConfigurationId?: Maybe<Scalars['Int']>;
  clientName?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['Int']>;
  storeConfigurationId?: Maybe<Scalars['Int']>;
};

export type CustomersGetHandlingDetailsRequestInput = {
  omitOrdersWithErrors?: InputMaybe<Scalars['Boolean']>;
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetHandlingDetailsResponse = {
  __typename?: 'CustomersGetHandlingDetailsResponse';
  handlingDetails?: Maybe<CustomersGetHandlingDetailsResponseHandlingDetails>;
  handlingDetailsByOrderReference?: Maybe<CustomersGetHandlingDetailsResponseHandlingDetails>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetails = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetails';
  acceptableRetailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  baggingOption?: Maybe<CustomersInstacartCustomersCommerceTypesV1BaggingOption>;
  buyerAgeAttested?: Maybe<CustomersInstacartCustomersCommerceTypesV1BuyerAttestedAge>;
  delivery?: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsDelivery>;
  pickup?: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsPickup>;
  requiresAgeVerification?: Maybe<Scalars['Boolean']>;
  retailerPosCorrelationIdentifier?: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifier>;
  specialRequirements?: Maybe<Array<Maybe<CustomersSpecialRequirement>>>;
  unacceptableRetailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetailsDelivery = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsDelivery';
  address?: Maybe<CustomersGoogleTypePostalAddress>;
  addressId?: Maybe<Scalars['BigInt']>;
  addressType?: Maybe<CustomersAddressType>;
  customerManualLatLng?: Maybe<CustomersGoogleTypeLatLng>;
  doorCode?: Maybe<Scalars['String']>;
  dropoffLocation?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  latLng?: Maybe<CustomersGoogleTypeLatLng>;
  notes?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetailsPickup = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsPickup';
  address?: Maybe<CustomersGoogleTypePostalAddress>;
  addressId?: Maybe<Scalars['BigInt']>;
  instructions?: Maybe<Scalars['String']>;
  latLng?: Maybe<CustomersGoogleTypeLatLng>;
};

export type CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifier = {
  __typename?: 'CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifier';
  referenceId?: Maybe<Scalars['String']>;
  referenceType?: Maybe<CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifierReferenceType>;
};

export enum CustomersGetHandlingDetailsResponseHandlingDetailsRetailerPosCorrelationIdentifierReferenceType {
  Appcard = 'APPCARD',
  ReferenceTypeUnspecified = 'REFERENCE_TYPE_UNSPECIFIED'
}

export type CustomersGetOrderAmountsSummaryV0RequestInput = {
  orderAmountsSnapshot?: InputMaybe<CustomersOrderAmountsSnapshot>;
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  requestedAdditionalAmounts?: InputMaybe<Array<InputMaybe<CustomersGetOrderAmountsSummaryV0RequestOrderAmountsSummaryAdditionalAmount>>>;
};

export enum CustomersGetOrderAmountsSummaryV0RequestOrderAmountsSummaryAdditionalAmount {
  OrderAmountsSummaryAdditionalAmountMarkup = 'ORDER_AMOUNTS_SUMMARY_ADDITIONAL_AMOUNT_MARKUP',
  OrderAmountsSummaryAdditionalAmountRetailerPrice = 'ORDER_AMOUNTS_SUMMARY_ADDITIONAL_AMOUNT_RETAILER_PRICE',
  OrderAmountsSummaryAdditionalAmountUnspecified = 'ORDER_AMOUNTS_SUMMARY_ADDITIONAL_AMOUNT_UNSPECIFIED'
}

export type CustomersGetOrderAmountsSummaryV0Response = {
  __typename?: 'CustomersGetOrderAmountsSummaryV0Response';
  orderAmountsSummary?: Maybe<CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary>;
  orderAmountsSummaryByOrderReference?: Maybe<CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary>;
};

export type CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary = {
  __typename?: 'CustomersGetOrderAmountsSummaryV0ResponseAmountsSummary';
  orderAmounts?: Maybe<Array<Maybe<CustomersAmounts>>>;
};

export type CustomersGetOrderRequestInput = {
  deliveryReference?: InputMaybe<Scalars['String']>;
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetOrderResponse = {
  __typename?: 'CustomersGetOrderResponse';
  order?: Maybe<CustomersOrder>;
  ordersByOrderReference?: Maybe<CustomersOrder>;
};

export type CustomersGetPaymentMethodSummaryRequestInput = {
  orderReference?: InputMaybe<Scalars['String']>;
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersGetPaymentMethodSummaryResponse = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponse';
  paymentMethodSummariesByOrderReference?: Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary>;
  paymentMethodSummary?: Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary>;
};

export type CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponsePaymentMethodSummary';
  paymentMethod?: Maybe<Array<Maybe<CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod>>>;
};

export type CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod = {
  __typename?: 'CustomersGetPaymentMethodSummaryResponsePaymentMethodSummaryPaymentMethod';
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CustomersGoogleTypeDate = {
  __typename?: 'CustomersGoogleTypeDate';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type CustomersGoogleTypeLatLng = {
  __typename?: 'CustomersGoogleTypeLatLng';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type CustomersGoogleTypeMoney = {
  __typename?: 'CustomersGoogleTypeMoney';
  currencyCode?: Maybe<Scalars['String']>;
  nanos?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['BigInt']>;
};

export type CustomersGoogleTypePostalAddress = {
  __typename?: 'CustomersGoogleTypePostalAddress';
  addressLines?: Maybe<Array<Maybe<Scalars['String']>>>;
  administrativeArea?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  regionCode?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['Int']>;
  sortingCode?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
};

export enum CustomersInstacartCustomersCommerceTypesV1BaggingOption {
  BaggingOptionBagless = 'BAGGING_OPTION_BAGLESS',
  BaggingOptionDefault = 'BAGGING_OPTION_DEFAULT',
  BaggingOptionUnspecified = 'BAGGING_OPTION_UNSPECIFIED'
}

export enum CustomersInstacartCustomersCommerceTypesV1BuyerAttestedAge {
  BuyerAttestedAgeUnspecified = 'BUYER_ATTESTED_AGE_UNSPECIFIED',
  Over_18 = 'OVER_18',
  Over_21 = 'OVER_21'
}

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalData = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalData';
  cartExternalData?: Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalDataCartExternalData>;
  connectExternalData?: Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalDataConnectExternalData>;
  embeddedPartnerIdentifiers?: Maybe<Array<Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalDataEmbeddedPartnerIdentifier>>>;
  externalId?: Maybe<Scalars['String']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalDataCartExternalData = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalDataCartExternalData';
  _?: Maybe<Scalars['Boolean']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalDataConnectExternalData = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalDataConnectExternalData';
  appliedExpress?: Maybe<Scalars['Boolean']>;
  barcodeIdentifier?: Maybe<Scalars['String']>;
  paidWithEbtSnap?: Maybe<Scalars['Boolean']>;
  retailerRequiredCertifiedDelivery?: Maybe<Scalars['Boolean']>;
};

export type CustomersInstacartCustomersCommerceTypesV1SourceExternalDataEmbeddedPartnerIdentifier = {
  __typename?: 'CustomersInstacartCustomersCommerceTypesV1SourceExternalDataEmbeddedPartnerIdentifier';
  identifier?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export enum CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType {
  AffordableDelivery = 'AFFORDABLE_DELIVERY',
  Asap = 'ASAP',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  Eta = 'ETA',
  FiveHour = 'FIVE_HOUR',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  HyperFast = 'HYPER_FAST',
  InstoreOrderAheadAsap = 'INSTORE_ORDER_AHEAD_ASAP',
  InstoreOrderAheadScheduled = 'INSTORE_ORDER_AHEAD_SCHEDULED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  OneHour = 'ONE_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  RetailerInstore = 'RETAILER_INSTORE',
  RetailerManaged = 'RETAILER_MANAGED',
  ScanAndPay = 'SCAN_AND_PAY',
  Scheduled = 'SCHEDULED',
  ThreeHour = 'THREE_HOUR',
  TwoHour = 'TWO_HOUR',
  Ultrafast = 'ULTRAFAST',
  VirtualExpress = 'VIRTUAL_EXPRESS',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP'
}

export type CustomersInstacartCustomersSharedV1RequestContextInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum CustomersInstacartCustomersSharedV1ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  Virtual = 'VIRTUAL'
}

export type CustomersInstacartInternalRequestContextInput = {
  instacartInternalAppId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersListOrdersRequestFilterSetDateRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type CustomersListOrdersRequestFilterSetInput = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  creationDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>;
  fulfillmentDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>;
  orderLifecycleDateRange?: InputMaybe<CustomersListOrdersRequestFilterSetDateRangeInput>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersListOrdersRequestFilterSetOrderStatusCriteria>>>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceType?: InputMaybe<CustomersInstacartCustomersSharedV1ServiceType>;
};

export enum CustomersListOrdersRequestFilterSetOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  New = 'NEW',
  OrderStatusCriteriaUnspecified = 'ORDER_STATUS_CRITERIA_UNSPECIFIED'
}

export type CustomersListOrdersRequestInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  excludeOrderSummaries?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<CustomersListOrdersRequestFilterSetInput>;
  instacartInternalRequestContext?: InputMaybe<CustomersInstacartInternalRequestContextInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersListOrdersResponse = {
  __typename?: 'CustomersListOrdersResponse';
  orderSummaries?: Maybe<Array<Maybe<CustomersListOrdersResponseOrderSummary>>>;
  orders?: Maybe<Array<Maybe<CustomersOrder>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type CustomersListOrdersResponseOrderSummary = {
  __typename?: 'CustomersListOrdersResponseOrderSummary';
  creationDate?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  fulfillmentDate?: Maybe<Scalars['DateTime']>;
  fulfillmentType?: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>;
  id?: Maybe<Scalars['BigInt']>;
  legacyOrderId?: Maybe<Scalars['BigInt']>;
  orderReference?: Maybe<Scalars['String']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  totalAmount?: Maybe<CustomersGoogleTypeMoney>;
  userId?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<CustomersWorkflowState>;
};

export type CustomersOrder = {
  __typename?: 'CustomersOrder';
  arrivedAtCustomerLocationAt?: Maybe<Scalars['DateTime']>;
  beforeCheckout?: Maybe<Scalars['Boolean']>;
  businessId?: Maybe<Scalars['BigInt']>;
  buyerAgeAttested?: Maybe<CustomersInstacartCustomersCommerceTypesV1BuyerAttestedAge>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  certifiedDelivery?: Maybe<Scalars['Boolean']>;
  checkoutRetailerLocationId?: Maybe<Scalars['BigInt']>;
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  closestRetailerLocationId?: Maybe<Scalars['BigInt']>;
  communicationLocale?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  coordinatedOrderGroupId?: Maybe<Scalars['BigInt']>;
  countryId?: Maybe<Scalars['BigInt']>;
  creationClientIdentifier?: Maybe<Scalars['String']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  customerOrderNumber?: Maybe<Scalars['BigInt']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  deliveryStartedAt?: Maybe<Scalars['DateTime']>;
  deliveryStatus?: Maybe<CustomersOrderDeliveryStatus>;
  estimatedCustomerFulfillmentWindow?: Maybe<CustomersOrderOrderFulfillmentWindow>;
  expressSubscriptionId?: Maybe<Scalars['BigInt']>;
  externalData?: Maybe<CustomersInstacartCustomersCommerceTypesV1SourceExternalData>;
  finalizedAt?: Maybe<Scalars['DateTime']>;
  fulfillmentOperationWindow?: Maybe<CustomersOrderOrderFulfillmentWindow>;
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  fulfillmentType?: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>;
  fulfillmentWindow?: Maybe<CustomersOrderOrderFulfillmentWindow>;
  id?: Maybe<Scalars['BigInt']>;
  legacyOrderId?: Maybe<Scalars['BigInt']>;
  loyaltyNumber?: Maybe<Scalars['String']>;
  orderAhead?: Maybe<Scalars['Boolean']>;
  orderAheadExternalTicketNumber?: Maybe<Scalars['String']>;
  orderAheadReadyAt?: Maybe<Scalars['DateTime']>;
  orderReference?: Maybe<Scalars['String']>;
  plannedDeliveredAt?: Maybe<Scalars['DateTime']>;
  plannedDeliveryStartedAt?: Maybe<Scalars['DateTime']>;
  redelivery?: Maybe<Scalars['Boolean']>;
  retailerExternalOrderId?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerOriginatedData?: Maybe<CustomersOrderRetailerOriginatedData>;
  retailerReceiptBarcodeValue?: Maybe<Scalars['String']>;
  retailerReferenceId?: Maybe<Scalars['String']>;
  serviceOptionId?: Maybe<Scalars['BigInt']>;
  serviceType?: Maybe<CustomersInstacartCustomersSharedV1ServiceType>;
  shoppedRetailerLocationId?: Maybe<Scalars['BigInt']>;
  shopperOriginatedData?: Maybe<CustomersOrderShopperOriginatedData>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  subWorkflowState?: Maybe<CustomersSubWorkflowState>;
  userBirthday?: Maybe<CustomersGoogleTypeDate>;
  userId?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<CustomersWorkflowState>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export enum CustomersOrderAmountsSnapshot {
  OrderAmountsSnapshotCompletion = 'ORDER_AMOUNTS_SNAPSHOT_COMPLETION',
  OrderAmountsSnapshotCreation = 'ORDER_AMOUNTS_SNAPSHOT_CREATION',
  OrderAmountsSnapshotLatest = 'ORDER_AMOUNTS_SNAPSHOT_LATEST',
  OrderAmountsSnapshotUnspecified = 'ORDER_AMOUNTS_SNAPSHOT_UNSPECIFIED'
}

export enum CustomersOrderDeliveryStatus {
  AcknowledgedByFulfillment = 'ACKNOWLEDGED_BY_FULFILLMENT',
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  DeliveryStatusUnspecified = 'DELIVERY_STATUS_UNSPECIFIED',
  InTransit = 'IN_TRANSIT',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Received = 'RECEIVED',
  Shopping = 'SHOPPING',
  ShoppingComplete = 'SHOPPING_COMPLETE'
}

export type CustomersOrderOrderFulfillmentWindow = {
  __typename?: 'CustomersOrderOrderFulfillmentWindow';
  windowEnd?: Maybe<Scalars['DateTime']>;
  windowStart?: Maybe<Scalars['DateTime']>;
};

export type CustomersOrderRetailerOriginatedData = {
  __typename?: 'CustomersOrderRetailerOriginatedData';
  bagLabel?: Maybe<Scalars['String']>;
  bagsCount?: Maybe<Scalars['Int']>;
  barcodeIdentifier?: Maybe<Scalars['String']>;
};

export type CustomersOrderShopperOriginatedData = {
  __typename?: 'CustomersOrderShopperOriginatedData';
  bagsInFreezer?: Maybe<Scalars['Int']>;
  bagsInFridge?: Maybe<Scalars['Int']>;
  bagsInShelves?: Maybe<Scalars['Int']>;
  customerBagCount?: Maybe<Scalars['Int']>;
};

export enum CustomersOrderSource {
  OrderSourceApi = 'ORDER_SOURCE_API',
  OrderSourceMarketplace = 'ORDER_SOURCE_MARKETPLACE',
  OrderSourceStorefront = 'ORDER_SOURCE_STOREFRONT',
  OrderSourceUnata = 'ORDER_SOURCE_UNATA',
  OrderSourceUnspecified = 'ORDER_SOURCE_UNSPECIFIED'
}

export type CustomersOrderSummary = {
  __typename?: 'CustomersOrderSummary';
  creationDate?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  fulfillmentDate?: Maybe<Scalars['DateTime']>;
  fulfillmentType?: Maybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>;
  id?: Maybe<Scalars['BigInt']>;
  legacyOrderId?: Maybe<Scalars['BigInt']>;
  orderReference?: Maybe<Scalars['String']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  totalAmount?: Maybe<CustomersGoogleTypeMoney>;
  userId?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<CustomersWorkflowState>;
};

export enum CustomersOrdersSortByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED'
}

export type CustomersOrdersSortByInput = {
  direction?: InputMaybe<CustomersOrdersSortByDirection>;
  name?: InputMaybe<CustomersOrdersSortByOrdersAttributes>;
};

export enum CustomersOrdersSortByOrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT'
}

export type CustomersQueryOrderReferenceRequestConnectExternalOrderIdInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  externalId?: InputMaybe<Scalars['String']>;
};

export type CustomersQueryOrderReferenceRequestInput = {
  connectExternalOrderId?: InputMaybe<CustomersQueryOrderReferenceRequestConnectExternalOrderIdInput>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersQueryOrderReferenceResponse = {
  __typename?: 'CustomersQueryOrderReferenceResponse';
  deliveryReference?: Maybe<Scalars['String']>;
  orderReference?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestInput = {
  includeOrderSummaries?: InputMaybe<Scalars['Boolean']>;
  ordersSortBy?: InputMaybe<CustomersOrdersSortByInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  scenarioAbandonedOrderDeliveryCandidates?: InputMaybe<CustomersQueryOrdersRequestScenarioAbandonedOrderDeliveryCandidatesInput>;
  scenarioActivePickupOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActivePickupOrdersAtRetailerLocationInput>;
  scenarioActiveScanAndPayOrders?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveScanAndPayOrdersInput>;
  scenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocationInput>;
  scenarioActiveStoreManagerOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveStoreManagerOrdersAtRetailerLocationInput>;
  scenarioActiveUltrafastOrdersAtRetailerLocation?: InputMaybe<CustomersQueryOrdersRequestScenarioActiveUltrafastOrdersAtRetailerLocationInput>;
  scenarioCompletedScanAndPayOrders?: InputMaybe<CustomersQueryOrdersRequestScenarioCompletedScanAndPayOrdersInput>;
  scenarioCoordinatedOrderGroup?: InputMaybe<CustomersQueryOrdersRequestScenarioCoordinatedOrderGroupInput>;
  scenarioEnterpriseRppOrdersByCreationDate?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByCreationDateInput>;
  scenarioEnterpriseRppOrdersByFulfillmentDate?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByFulfillmentDateInput>;
  scenarioEnterpriseRppOrdersByOrderIdentifier?: InputMaybe<CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByOrderIdentifierInput>;
  scenarioIppOrdersByCreationDate?: InputMaybe<CustomersQueryOrdersRequestScenarioIppOrdersByCreationDateInput>;
  scenarioIppOrdersByFulfillmentDate?: InputMaybe<CustomersQueryOrdersRequestScenarioIppOrdersByFulfillmentDateInput>;
  scenarioIppOrdersByOrderIdentifier?: InputMaybe<CustomersQueryOrdersRequestScenarioIppOrdersByOrderIdentifierInput>;
  scenarioLateDeliveringOrderDeliveryCandidates?: InputMaybe<CustomersQueryOrdersRequestScenarioLateDeliveringOrderDeliveryCandidatesInput>;
  scenarioOrdersById?: InputMaybe<CustomersQueryOrdersRequestScenarioOrdersByIdInput>;
  scenarioOrdersByWorkflowStateAndWindow?: InputMaybe<CustomersQueryOrdersRequestScenarioOrdersByWorkflowStateAndWindowInput>;
  scenarioPayableOrderDeliveriesById?: InputMaybe<CustomersQueryOrdersRequestScenarioPayableOrderDeliveriesByIdInput>;
};

export type CustomersQueryOrdersRequestScenarioAbandonedOrderDeliveryCandidatesInput = {
  excludedWorkflowStates?: InputMaybe<Array<InputMaybe<CustomersWorkflowState>>>;
  fulfillmentTypes?: InputMaybe<Array<InputMaybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>>>;
  retailerIds?: InputMaybe<CustomersQueryOrdersRequestScenarioAbandonedOrderDeliveryCandidatesRetailerIdsInput>;
  windowEndsAtFrom?: InputMaybe<Scalars['DateTime']>;
  windowEndsAtThrough?: InputMaybe<Scalars['DateTime']>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioAbandonedOrderDeliveryCandidatesRetailerIdsInput = {
  values?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioActivePickupOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioActiveScanAndPayOrdersInput = {
  createdAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioActiveShopperFulfillDeliveryOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
};

export type CustomersQueryOrdersRequestScenarioActiveStoreManagerOrdersAtRetailerLocationInput = {
  excludedWorkflowStates?: InputMaybe<CustomersWorkflowStatesFilterInput>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  workflowStates?: InputMaybe<CustomersWorkflowStatesFilterInput>;
};

export type CustomersQueryOrdersRequestScenarioActiveUltrafastOrdersAtRetailerLocationInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationZoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
};

export type CustomersQueryOrdersRequestScenarioCompletedScanAndPayOrdersInput = {
  createdAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioCoordinatedOrderGroupInput = {
  coordinatedOrderGroupId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByCreationDateInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  creationDateRange?: InputMaybe<CustomersTimestampRangeInput>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>;
  orderType?: InputMaybe<CustomersRppOrderType>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  useCheckoutRetailerLocationAsFallback?: InputMaybe<Scalars['Boolean']>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByFulfillmentDateInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>;
  orderType?: InputMaybe<CustomersRppOrderType>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  useCheckoutRetailerLocationAsFallback?: InputMaybe<Scalars['Boolean']>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioEnterpriseRppOrdersByOrderIdentifierInput = {
  adminRequestContext?: InputMaybe<CustomersAdminRequestContextInput>;
  instacartInternalRequestContext?: InputMaybe<CustomersInstacartInternalRequestContextInput>;
  orderIdentifier?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<CustomersInstacartCustomersSharedV1RequestContextInput>;
};

export type CustomersQueryOrdersRequestScenarioIppOrdersByCreationDateInput = {
  creationDateRange?: InputMaybe<CustomersTimestampRangeInput>;
  instacartInternalRequestContext?: InputMaybe<CustomersInstacartInternalRequestContextInput>;
  orderSource?: InputMaybe<CustomersOrderSource>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>;
  orderType?: InputMaybe<CustomersRppOrderType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioIppOrdersByFulfillmentDateInput = {
  fulfillmentDateRange?: InputMaybe<CustomersTimestampRangeInput>;
  instacartInternalRequestContext?: InputMaybe<CustomersInstacartInternalRequestContextInput>;
  orderSource?: InputMaybe<CustomersOrderSource>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<CustomersRppOrderStatusCriteria>>>;
  orderType?: InputMaybe<CustomersRppOrderType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioIppOrdersByOrderIdentifierInput = {
  instacartInternalRequestContext?: InputMaybe<CustomersInstacartInternalRequestContextInput>;
  orderIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type CustomersQueryOrdersRequestScenarioLateDeliveringOrderDeliveryCandidatesInput = {
  evaluatedAt?: InputMaybe<Scalars['DateTime']>;
  minimumMinutesLate?: InputMaybe<Scalars['Int']>;
  windowStartsAtAfter?: InputMaybe<Scalars['DateTime']>;
};

export type CustomersQueryOrdersRequestScenarioOrdersByIdInput = {
  orderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioOrdersByWorkflowStateAndWindowInput = {
  clientConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedWorkflowStates?: InputMaybe<CustomersQueryOrdersRequestScenarioOrdersByWorkflowStateAndWindowWorkflowStatesFilterInput>;
  fulfillmentTypes?: InputMaybe<Array<InputMaybe<CustomersInstacartCustomersSharedV1FulfillmentTypeWrapperFulfillmentType>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  subWorkflowStates?: InputMaybe<Array<InputMaybe<CustomersSubWorkflowState>>>;
  windowEndsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  windowStartsAtRange?: InputMaybe<CustomersTimestampRangeInput>;
  workflowStates?: InputMaybe<CustomersQueryOrdersRequestScenarioOrdersByWorkflowStateAndWindowWorkflowStatesFilterInput>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersRequestScenarioOrdersByWorkflowStateAndWindowWorkflowStatesFilterInput = {
  values?: InputMaybe<Array<InputMaybe<CustomersWorkflowState>>>;
};

export type CustomersQueryOrdersRequestScenarioPayableOrderDeliveriesByIdInput = {
  orderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type CustomersQueryOrdersResponse = {
  __typename?: 'CustomersQueryOrdersResponse';
  orderSummaries?: Maybe<Array<Maybe<CustomersOrderSummary>>>;
  orders?: Maybe<Array<Maybe<CustomersOrder>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export enum CustomersRppOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  New = 'NEW',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  RppOrderStatusCriteriaUnspecified = 'RPP_ORDER_STATUS_CRITERIA_UNSPECIFIED',
  Shopping = 'SHOPPING'
}

export enum CustomersRppOrderType {
  Delivery = 'DELIVERY',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  Pickup = 'PICKUP',
  RppOrderTypeUnspecified = 'RPP_ORDER_TYPE_UNSPECIFIED'
}

export enum CustomersSpecialRequirement {
  AlcoholCompliant = 'ALCOHOL_COMPLIANT',
  AllowUnattendedTransition = 'ALLOW_UNATTENDED_TRANSITION',
  CertifiedDelivery = 'CERTIFIED_DELIVERY',
  CustomerFundingOptionDoesNotSupportTip = 'CUSTOMER_FUNDING_OPTION_DOES_NOT_SUPPORT_TIP',
  DisableShopperAdds = 'DISABLE_SHOPPER_ADDS',
  EbtRetailerLocationConstrained = 'EBT_RETAILER_LOCATION_CONSTRAINED',
  ExtraLongDistanceDelivery = 'EXTRA_LONG_DISTANCE_DELIVERY',
  FrozenItems = 'FROZEN_ITEMS',
  HempBasedCannabisCompliant = 'HEMP_BASED_CANNABIS_COMPLIANT',
  IncludesEbtPayment = 'INCLUDES_EBT_PAYMENT',
  MealItems = 'MEAL_ITEMS',
  OrderAhead = 'ORDER_AHEAD',
  OrderCreatedWithBigBulky = 'ORDER_CREATED_WITH_BIG_BULKY',
  RequiresShopperBgcProcess_1 = 'REQUIRES_SHOPPER_BGC_PROCESS_1',
  RestrictedOtcCompliant = 'RESTRICTED_OTC_COMPLIANT',
  RxCompliant = 'RX_COMPLIANT',
  RxOnlyCompliant = 'RX_ONLY_COMPLIANT',
  SecondStoreCheck = 'SECOND_STORE_CHECK',
  SpecialRequirementUnspecified = 'SPECIAL_REQUIREMENT_UNSPECIFIED',
  UnattendedDelivery = 'UNATTENDED_DELIVERY'
}

export enum CustomersSubWorkflowState {
  BrandNewProcessingFinalAcceptance = 'BRAND_NEW_PROCESSING_FINAL_ACCEPTANCE',
  BrandNewReadyForFulfillment = 'BRAND_NEW_READY_FOR_FULFILLMENT',
  InTransitPendingDeliveryReattempt = 'IN_TRANSIT_PENDING_DELIVERY_REATTEMPT',
  PickingEarly = 'PICKING_EARLY',
  PickingFinal = 'PICKING_FINAL',
  PickingPause = 'PICKING_PAUSE',
  PickingStandardBasket = 'PICKING_STANDARD_BASKET',
  PickingStandardBasketDoneAwaitingTopUp = 'PICKING_STANDARD_BASKET_DONE_AWAITING_TOP_UP',
  PickingTopUpBasket = 'PICKING_TOP_UP_BASKET',
  StagedConfirmedHandoffToPartnerForDelivery = 'STAGED_CONFIRMED_HANDOFF_TO_PARTNER_FOR_DELIVERY',
  SubWorkflowStateNone = 'SUB_WORKFLOW_STATE_NONE',
  SubWorkflowStateUnspecified = 'SUB_WORKFLOW_STATE_UNSPECIFIED'
}

export type CustomersTimestampRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export enum CustomersWorkflowState {
  Acknowledged = 'ACKNOWLEDGED',
  AcknowledgedForDelivery = 'ACKNOWLEDGED_FOR_DELIVERY',
  AcknowledgedForRunning = 'ACKNOWLEDGED_FOR_RUNNING',
  AtStore = 'AT_STORE',
  BagsCheck = 'BAGS_CHECK',
  BagsVerified = 'BAGS_VERIFIED',
  BrandNew = 'BRAND_NEW',
  Canceled = 'CANCELED',
  Checkout = 'CHECKOUT',
  CustomerSamples = 'CUSTOMER_SAMPLES',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  InTransit = 'IN_TRANSIT',
  Notified = 'NOTIFIED',
  PendingIdentityVerification = 'PENDING_IDENTITY_VERIFICATION',
  PendingReschedule = 'PENDING_RESCHEDULE',
  Picking = 'PICKING',
  ReceiptSanityCheck = 'RECEIPT_SANITY_CHECK',
  Returning = 'RETURNING',
  RunnerAwaiting = 'RUNNER_AWAITING',
  RunnerNotFound = 'RUNNER_NOT_FOUND',
  RxCheckout = 'RX_CHECKOUT',
  RxPicking = 'RX_PICKING',
  Staged = 'STAGED',
  StagedForCbt = 'STAGED_FOR_CBT',
  StagedForDelivery = 'STAGED_FOR_DELIVERY',
  StagingForCbt = 'STAGING_FOR_CBT',
  VerifyingReplacements = 'VERIFYING_REPLACEMENTS',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY',
  WorkflowStateUnspecified = 'WORKFLOW_STATE_UNSPECIFIED'
}

export type CustomersWorkflowStatesFilterInput = {
  values?: InputMaybe<Array<InputMaybe<CustomersWorkflowState>>>;
};

export type DataDescriptionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  description: Scalars['String'];
  key: Scalars['String'];
};

export type DataEntryItem = {
  __typename?: 'DataEntryItem';
  deiId?: Maybe<Scalars['String']>;
};

export type DataQuery = {
  __typename?: 'DataQuery';
  resourceDataQuery?: Maybe<ResourceDataQuery>;
};

export type DataQueryInput = {
  resourceDataQuery?: InputMaybe<ResourceDataQueryInput>;
};

export type DataQueryStruct = {
  __typename?: 'DataQueryStruct';
  data?: Maybe<Scalars['JSONObject']>;
  typeName?: Maybe<Scalars['String']>;
};

export type DataQueryStructInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

/** Attributes for a date range filter */
export type DateRange = {
  /** End date of date range */
  endDate: Scalars['ISO8601Date'];
  /** Start date of date range */
  startDate: Scalars['ISO8601Date'];
};

export type DateRangeInput = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
};

export type DayOfWeekInput = {
  /** list of days within the week */
  days: Array<Scalars['String']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of DayOfWeekVisibilityConditionCreate */
export type DayOfWeekVisibilityConditionCreatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionCreatePayload';
  /** The newly created express_membership visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek;
};

/** Autogenerated return type of DayOfWeekVisibilityConditionUpdate */
export type DayOfWeekVisibilityConditionUpdatePayload = {
  __typename?: 'DayOfWeekVisibilityConditionUpdatePayload';
  /** The newly created shopped_at_retailer visibility condition */
  dayOfWeekVisibilityCondition: ContentManagementVisibilityConditionDayOfWeek;
};

export type DeactivatePriceAnomalyPatchRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  investigationId?: InputMaybe<Scalars['String']>;
};

export type DeactivatePriceAnomalyPatchResponse = {
  __typename?: 'DeactivatePriceAnomalyPatchResponse';
  patchStatus?: Maybe<PatchStatus>;
};

export type DeleteApiSettingRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteApiSettingResponse = {
  __typename?: 'DeleteApiSettingResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'DeleteConnectRetailerCallbackConfigurationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteContentPageRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteContentPageResponse = {
  __typename?: 'DeleteContentPageResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteContentPageVersionResponse = {
  __typename?: 'DeleteContentPageVersionResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteFrothTemplateRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteFrothTemplateResponse = {
  __typename?: 'DeleteFrothTemplateResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteFrothTemplateVersionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteFrothTemplateVersionResponse = {
  __typename?: 'DeleteFrothTemplateVersionResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteImageRequestInput = {
  imageId?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteImageResponse = {
  __typename?: 'DeleteImageResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteLaunchOnboardingWarehouseLocationRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLaunchOnboardingWarehouseLocationResponse = {
  __typename?: 'DeleteLaunchOnboardingWarehouseLocationResponse';
  launchOnboarding?: Maybe<LaunchOnboarding>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteLayoutVariantRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLayoutVariantResponse = {
  __typename?: 'DeleteLayoutVariantResponse';
  response?: Maybe<Scalars['Boolean']>;
};

export type DeleteLinkAutosuggestionAdminParametersInput = {
  linkId?: InputMaybe<Scalars['BigInt']>;
  linkName?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLinkAutosuggestionAdminRequestInput = {
  parameters?: InputMaybe<DeleteLinkAutosuggestionAdminParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteLinkAutosuggestionAdminResponse = {
  __typename?: 'DeleteLinkAutosuggestionAdminResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeleteNativeTabBarNavigationRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteNativeTabBarNavigationResponse = {
  __typename?: 'DeleteNativeTabBarNavigationResponse';
  response?: Maybe<Scalars['Boolean']>;
};

export type DeleteNavigationRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteNavigationResponse = {
  __typename?: 'DeleteNavigationResponse';
  response?: Maybe<Scalars['Boolean']>;
};

export type DeletePartnerOauthApplicationRequestInput = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type DeletePartnerOauthApplicationResponse = {
  __typename?: 'DeletePartnerOauthApplicationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DeletePlacementRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeletePlacementResponse = {
  __typename?: 'DeletePlacementResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteSlotCreativeRequestInput = {
  creativeId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteSlotCreativeResponse = {
  __typename?: 'DeleteSlotCreativeResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DeleteSlotRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DeleteSlotResponse = {
  __typename?: 'DeleteSlotResponse';
  _?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of DeleteView */
export type DeleteViewPayload = {
  __typename?: 'DeleteViewPayload';
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DeleteWhitelabelSiteCustomizableStringRequestInput = {
  whitelabelSiteCustomizableStringId?: InputMaybe<Scalars['Int']>;
};

export type DeleteWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'DeleteWhitelabelSiteCustomizableStringResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type DemeterResponseStatus = {
  __typename?: 'DemeterResponseStatus';
  statusCode?: Maybe<Scalars['BigInt']>;
  statusMessage?: Maybe<Scalars['String']>;
};

export type DepartmentOosCount = {
  __typename?: 'DepartmentOosCount';
  department?: Maybe<Scalars['String']>;
  oosCount?: Maybe<Scalars['Int']>;
};

export type DepartmentsPlaceholderNavigation = {
  __typename?: 'DepartmentsPlaceholderNavigation';
  id?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
};

export type DepartmentsPlaceholderNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type DesktopFlexibleHeaderLayoutV1Navigations = {
  __typename?: 'DesktopFlexibleHeaderLayoutV1Navigations';
  bar1?: Maybe<BarNav>;
  bar2?: Maybe<BarNav>;
};

export type DesktopFlexibleHeaderLayoutV1NavigationsInput = {
  bar1?: InputMaybe<BarNavInput>;
  bar2?: InputMaybe<BarNavInput>;
};

export type DesktopSidebarLayoutV1Navigations = {
  __typename?: 'DesktopSidebarLayoutV1Navigations';
  navs?: Maybe<Array<Maybe<NavigationWithSubNavigation>>>;
};

export type DesktopSidebarLayoutV1NavigationsInput = {
  navs?: InputMaybe<Array<InputMaybe<NavigationWithSubNavigationInput>>>;
};

export enum DestinationBucket {
  Assets = 'ASSETS',
  StoreConfiguration = 'STORE_CONFIGURATION',
  UnkownDestinationBucket = 'UNKOWN_DESTINATION_BUCKET'
}

export enum DetectionStatusState {
  DetectionStatusStateAdminAudit = 'DETECTION_STATUS_STATE_ADMIN_AUDIT',
  DetectionStatusStateApproved = 'DETECTION_STATUS_STATE_APPROVED',
  DetectionStatusStateRejected = 'DETECTION_STATUS_STATE_REJECTED',
  DetectionStatusStateRunningAutomatedTests = 'DETECTION_STATUS_STATE_RUNNING_AUTOMATED_TESTS',
  DetectionStatusStateUnknown = 'DETECTION_STATUS_STATE_UNKNOWN'
}

export type DetectionVersionAttributes = {
  __typename?: 'DetectionVersionAttributes';
  cadence?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdWhy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  fixDefectTag?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['BigInt']>;
  owner?: Maybe<Scalars['String']>;
  query?: Maybe<Scalars['String']>;
};

export type DetectionVersionAttributesInput = {
  cadence?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdWhy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  fixDefectTag?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  owner?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
};

export type DetectionVersionState = {
  __typename?: 'DetectionVersionState';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['String']>;
  state?: Maybe<DetectionStatusState>;
};

export type DetectionVersionStats = {
  __typename?: 'DetectionVersionStats';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['String']>;
  stats?: Maybe<Scalars['String']>;
};

export enum DeviceTypeEnum {
  /** Phone plan */
  Phone = 'phone',
  /** Wi-Fi */
  Wifi = 'wifi'
}

export enum Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type DisablePartnerOauthApplicationRequestInput = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type DisablePartnerOauthApplicationResponse = {
  __typename?: 'DisablePartnerOauthApplicationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type DisablePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DisablePlacementContentResponse = {
  __typename?: 'DisablePlacementContentResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DisableThemePageRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DisableThemePageResponse = {
  __typename?: 'DisableThemePageResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type DiscountDiscountablesData = {
  __typename?: 'DiscountDiscountablesData';
  appliedAmount?: Maybe<GoogleTypeMoney>;
  discountableId?: Maybe<Scalars['BigInt']>;
  discountableType?: Maybe<DiscountDiscountablesDataDiscountableType>;
  id?: Maybe<Scalars['BigInt']>;
  offerId?: Maybe<Scalars['BigInt']>;
  offerInstanceId?: Maybe<Scalars['BigInt']>;
  orderId?: Maybe<Scalars['BigInt']>;
};

export enum DiscountDiscountablesDataDiscountableType {
  BasketLevelOffer = 'BASKET_LEVEL_OFFER',
  CustomerFeeOffer = 'CUSTOMER_FEE_OFFER',
  DiscountableTypeUnspecified = 'DISCOUNTABLE_TYPE_UNSPECIFIED',
  ItemLevelOffer = 'ITEM_LEVEL_OFFER'
}

export enum Discoverability {
  AdminOnly = 'ADMIN_ONLY',
  AutoApply = 'AUTO_APPLY',
  Browse = 'BROWSE',
  CouponCode = 'COUPON_CODE',
  Crm = 'CRM',
  DirectLink = 'DIRECT_LINK',
  DiscoverabilityUnknown = 'DISCOVERABILITY_UNKNOWN',
  EventBasedCrm = 'EVENT_BASED_CRM',
  Offline = 'OFFLINE',
  OfflineMl = 'OFFLINE_ML',
  OnlineEvent = 'ONLINE_EVENT',
  PartnerInitiated = 'PARTNER_INITIATED',
  TsDirectLink = 'TS_DIRECT_LINK'
}

export type DismissBusinessIdentication = {
  __typename?: 'DismissBusinessIdentication';
  id?: Maybe<Scalars['BigInt']>;
  source?: Maybe<BusinessDerivedAttributesSourceType>;
};

export type DismissBusinessIdenticationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<BusinessDerivedAttributesSourceType>;
};

export type DoNotNavigate = {
  __typename?: 'DoNotNavigate';
  recordClickAttempt?: Maybe<Scalars['Boolean']>;
};

export type DoNotNavigateInput = {
  recordClickAttempt?: InputMaybe<Scalars['Boolean']>;
};

export type DomainConfiguration = {
  __typename?: 'DomainConfiguration';
  ads?: Maybe<AdsSchema>;
  branding?: Maybe<BrandingSchema>;
  business?: Maybe<BusinessSchema>;
  catalog?: Maybe<CatalogSchema>;
  checkout?: Maybe<CheckoutSchema>;
  icplus?: Maybe<IcPlusSchema>;
  idsTheme?: Maybe<IdsThemeSchema>;
  inStore?: Maybe<InStoreSchema>;
  landing?: Maybe<LandingSchema>;
  loyalty?: Maybe<LoyaltySchema>;
  offers?: Maybe<OffersSchema>;
  orders?: Maybe<OrdersSchema>;
  partnerAccessOptions?: Maybe<PartnerAccessOptionsSchema>;
  payments?: Maybe<PaymentsSchema>;
  pricing?: Maybe<PricingSchema>;
  storefront?: Maybe<StorefrontSchema>;
  theme?: Maybe<ThemeSchema>;
  users?: Maybe<UsersSchema>;
};

export type DownloadCatalogSearchResultsRequestInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  costUnitType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  creationDate?: InputMaybe<DateRangeInput>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  isParWeighted?: InputMaybe<Scalars['Boolean']>;
  itemFilename?: InputMaybe<Scalars['String']>;
  itemsOnPromoDateRange?: InputMaybe<DateRangeInput>;
  itemsOnSaleDateRange?: InputMaybe<DateRangeInput>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  loyaltyPricing?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  primaryImageUrl?: InputMaybe<Scalars['Boolean']>;
  productAvailability?: InputMaybe<Scalars['Boolean']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productFilename?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  query?: InputMaybe<Scalars['String']>;
  requestItemData?: InputMaybe<Scalars['Boolean']>;
  requestProductData?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  snapEbtEligible?: InputMaybe<Scalars['Boolean']>;
  storeBrandProduct?: InputMaybe<Scalars['Boolean']>;
};

export type DownloadCatalogSearchResultsResponse = {
  __typename?: 'DownloadCatalogSearchResultsResponse';
  filename?: Maybe<Scalars['String']>;
};

export type DuplicateContentPageRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type DuplicateContentPageResponse = {
  __typename?: 'DuplicateContentPageResponse';
  contentPage?: Maybe<ContentPageV2>;
};

export type EbpAnalyticsRequestInput = {
  dateRange?: InputMaybe<InstacartAdsSharedV1DateRangeInput>;
  entity?: InputMaybe<Entity>;
  entityId?: InputMaybe<EntityIdInput>;
  metric?: InputMaybe<Metric>;
};

export type EbpAnalyticsResponse = {
  __typename?: 'EbpAnalyticsResponse';
  analytics?: Maybe<Analytics>;
};

export type EnablePartnerOauthApplicationRequestInput = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type EnablePartnerOauthApplicationResponse = {
  __typename?: 'EnablePartnerOauthApplicationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type EnterpriseAcceptedPartnerAgreement = {
  __typename?: 'EnterpriseAcceptedPartnerAgreement';
  /** The type of agreement accepted */
  agreementType: AgreementTypeEnum;
  createdAt: Scalars['Time'];
  /** The ID of the partner */
  partnerId: Scalars['ID'];
};

export type EnterpriseAccount = {
  __typename?: 'EnterpriseAccount';
  /** The terms accepted by the account */
  acceptedPartnerAgreements?: Maybe<Array<EnterpriseAcceptedPartnerAgreement>>;
  /** Whether or not the user is fully set up */
  accountStateValid?: Maybe<Scalars['Boolean']>;
  /** The IDs of the partners assigned to the account */
  assignedPartnerIds: Array<Scalars['ID']>;
  /** The IDs of the retailers assigned to the account */
  assignedRetailerIds: Array<Scalars['ID']>;
  /** The IDs of the retailer locations assigned to the account */
  assignedRetailerLocationIds: Array<Scalars['ID']>;
  /** Whether account must use SSO/auth service for authentication */
  authServiceRequired: Scalars['Boolean'];
  /** The user data from the auth service */
  authUserData?: Maybe<AuthUserData>;
  /** The associated authentication */
  authentication?: Maybe<AuthenticationInterface>;
  /** Whether the current user can impersonate the account */
  canImpersonate: Scalars['Boolean'];
  /** Whether account can be activated/reactivated by the current user */
  canSetDisabled: Scalars['Boolean'];
  /** Whether the current user can update partner write access for other users */
  canUpdatePartnerWriteAccess?: Maybe<Scalars['Boolean']>;
  /** The external unique identifier for the enterprise account */
  canonicalId: Scalars['ID'];
  /** When the account was created */
  createdAt: Scalars['Time'];
  /** The direct permissions associated with this account */
  directlyAssignedPermissions: Array<EnterprisePermission>;
  /** Whether account is active */
  disabled: Scalars['Boolean'];
  /** The roles that the current user cannot assign that the target account has */
  editUnassignableRoles?: Maybe<Array<EnterpriseRole>>;
  /** The email associated with the account */
  email?: Maybe<Scalars['String']>;
  /** The feature experiments associated with the account */
  featureExperiments: Array<FeatureExperiment>;
  /** The feature toggles associated with the account */
  featureToggles: Array<FeatureToggle>;
  /** Given name of user */
  givenName?: Maybe<Scalars['String']>;
  /** Whether the account has all partners write access */
  hasAllPartnersWriteAccess?: Maybe<Scalars['Boolean']>;
  /** The hidden settings for the user account */
  hiddenSettings?: Maybe<EnterpriseAccountSettingsHiddenSettings>;
  /** The internal unique identifier for the enterprise account */
  id: Scalars['ID'];
  /** The reason why the current user cannot impersonate the account */
  impersonateFailureReason?: Maybe<Scalars['String']>;
  /** The permissions slugs that the current user is missing to impersonate the account */
  impersonateMissingPermissionsSlugs?: Maybe<Array<Scalars['String']>>;
  /** The associated internal access configuration for the account */
  internalAccessConfiguration: EnterpriseInternalAccessConfiguration;
  /** Whether account is editable by the current user */
  isEditable: Scalars['Boolean'];
  /** Whether the current user is impersonating the account */
  isImpersonating: Scalars['Boolean'];
  /** Whether account is an internal account */
  isInternal: Scalars['Boolean'];
  /** When MFA was disabled for the account */
  mfaDeactivatedAt?: Maybe<Scalars['Time']>;
  /** Whether account has MFA enabled */
  mfaEnabled: Scalars['Boolean'];
  /** When MFA was enabled for the account */
  mfaEnabledAt?: Maybe<Scalars['Time']>;
  /** The partner write access assigned to the account */
  partnerWriteAccess?: Maybe<Array<EnterprisePartnerWriteAccess>>;
  /** The permissions associated with this account */
  permissions: Array<EnterprisePermission>;
  /** Phone number for the user */
  phone?: Maybe<Scalars['String']>;
  /** The policies associated with the account */
  policies: AccessControlPolicies;
  /** The reason why the account cannot be edited by the current user */
  preventEditReason?: Maybe<Scalars['String']>;
  /** The permissions associated with this account via roles */
  roleAssignedPermissions: Array<EnterprisePermission>;
  /** The roles associated with this account */
  roles: Array<EnterpriseRole>;
  /** Surname of user */
  surname?: Maybe<Scalars['String']>;
  /** The title of the user */
  title?: Maybe<Scalars['String']>;
  /** The user locale for the user account */
  userLocale?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of EnterpriseAccountAcceptPartnerAgreement */
export type EnterpriseAccountAcceptPartnerAgreementPayload = {
  __typename?: 'EnterpriseAccountAcceptPartnerAgreementPayload';
  acceptedPartnerAgreement: EnterpriseAcceptedPartnerAgreement;
};

/** Autogenerated return type of EnterpriseAccountAccountSetup */
export type EnterpriseAccountAccountSetupPayload = {
  __typename?: 'EnterpriseAccountAccountSetupPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

/** Autogenerated return type of EnterpriseAccountAuthenticateEmailPassword */
export type EnterpriseAccountAuthenticateEmailPasswordPayload = {
  __typename?: 'EnterpriseAccountAuthenticateEmailPasswordPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

/** Autogenerated return type of EnterpriseAccountAuthenticatePreflight */
export type EnterpriseAccountAuthenticatePreflightPayload = {
  __typename?: 'EnterpriseAccountAuthenticatePreflightPayload';
  canRequestAccount: Scalars['Boolean'];
  useAuthService: Scalars['Boolean'];
};

/** The connection type for EnterpriseAccount. */
export type EnterpriseAccountConnection = {
  __typename?: 'EnterpriseAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseAccountEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated return type of EnterpriseAccountCreateNoPartnerAccess */
export type EnterpriseAccountCreateNoPartnerAccessPayload = {
  __typename?: 'EnterpriseAccountCreateNoPartnerAccessPayload';
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountCreate */
export type EnterpriseAccountCreatePayload = {
  __typename?: 'EnterpriseAccountCreatePayload';
  /** The newly created account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountDisableImpersonation */
export type EnterpriseAccountDisableImpersonationPayload = {
  __typename?: 'EnterpriseAccountDisableImpersonationPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** An edge in a connection. */
export type EnterpriseAccountEdge = {
  __typename?: 'EnterpriseAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseAccount>;
};

/** Autogenerated return type of EnterpriseAccountEnableImpersonation */
export type EnterpriseAccountEnableImpersonationPayload = {
  __typename?: 'EnterpriseAccountEnableImpersonationPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountMfaDeactivate */
export type EnterpriseAccountMfaDeactivatePayload = {
  __typename?: 'EnterpriseAccountMfaDeactivatePayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountMfaEnable */
export type EnterpriseAccountMfaEnablePayload = {
  __typename?: 'EnterpriseAccountMfaEnablePayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountMfaReset */
export type EnterpriseAccountMfaResetPayload = {
  __typename?: 'EnterpriseAccountMfaResetPayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountPartnerOnboardingRequestAccountSetupEmail */
export type EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountRequestAccountSetupEmail */
export type EnterpriseAccountRequestAccountSetupEmailPayload = {
  __typename?: 'EnterpriseAccountRequestAccountSetupEmailPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountRequestBreakGlassPartnerWriteAccess */
export type EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload = {
  __typename?: 'EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountRequestEmailVerification */
export type EnterpriseAccountRequestEmailVerificationPayload = {
  __typename?: 'EnterpriseAccountRequestEmailVerificationPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountResetPassword */
export type EnterpriseAccountResetPasswordPayload = {
  __typename?: 'EnterpriseAccountResetPasswordPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

/** Autogenerated return type of EnterpriseAccountSetDisabled */
export type EnterpriseAccountSetDisabledPayload = {
  __typename?: 'EnterpriseAccountSetDisabledPayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
};

export type EnterpriseAccountSettingsHiddenSettings = {
  __typename?: 'EnterpriseAccountSettingsHiddenSettings';
  /** Last seen RSAT pulse survey data */
  rsatPulseSurvey?: Maybe<EnterpriseAccountSettingsRsatPulseSurvey>;
};

export type EnterpriseAccountSettingsRsatPulseSurvey = {
  __typename?: 'EnterpriseAccountSettingsRsatPulseSurvey';
  /** Whether the user has submitted the survey */
  hasSubmitted: Scalars['Boolean'];
  /** The UTC time when the survey was last seen */
  lastSeenTime: Scalars['Time'];
  /** The number of times the survey has been seen */
  seenCount: Scalars['Int'];
  /** The unique slug identifier for the survey */
  slug: RsatPulseSurveySlugEnum;
};

/** Autogenerated return type of EnterpriseAccountUpdateHiddenSettings */
export type EnterpriseAccountUpdateHiddenSettingsPayload = {
  __typename?: 'EnterpriseAccountUpdateHiddenSettingsPayload';
  /** Whether the hidden settings were updated */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnterpriseAccountUpdatePassword */
export type EnterpriseAccountUpdatePasswordPayload = {
  __typename?: 'EnterpriseAccountUpdatePasswordPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

/** Autogenerated return type of EnterpriseAccountUpdate */
export type EnterpriseAccountUpdatePayload = {
  __typename?: 'EnterpriseAccountUpdatePayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountUpdateRoles */
export type EnterpriseAccountUpdateRolesPayload = {
  __typename?: 'EnterpriseAccountUpdateRolesPayload';
  /** The updated account object */
  enterpriseAccount: EnterpriseAccount;
};

/** Autogenerated return type of EnterpriseAccountUpdateUserLocale */
export type EnterpriseAccountUpdateUserLocalePayload = {
  __typename?: 'EnterpriseAccountUpdateUserLocalePayload';
  /** Whether the user locale was updated */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of EnterpriseAccountVerifyAccountSetupToken */
export type EnterpriseAccountVerifyAccountSetupTokenPayload = {
  __typename?: 'EnterpriseAccountVerifyAccountSetupTokenPayload';
  /** Email of the verified account */
  email: Scalars['String'];
  /** List of partners with partner id and name */
  partners: Array<Partner>;
};

/** Autogenerated return type of EnterpriseAccountVerifyEmail */
export type EnterpriseAccountVerifyEmailPayload = {
  __typename?: 'EnterpriseAccountVerifyEmailPayload';
  /** The AuthenticationToken token to be used for future requests */
  accessToken: AccessToken;
};

export type EnterpriseAuthenticationEmailPassword = AuthenticationInterface & {
  __typename?: 'EnterpriseAuthenticationEmailPassword';
  /** Unique authentication identifier */
  authenticationIdentifier: Scalars['ID'];
  /** Whether or not the email has been verified */
  emailVerified: Scalars['Boolean'];
  /** Whether or not the password has been set */
  passwordSet: Scalars['Boolean'];
};

export type EnterpriseInternalAccessConfiguration = {
  __typename?: 'EnterpriseInternalAccessConfiguration';
  /** The associated assigned partners */
  assignedPartners: Array<Partner>;
  /** The associated assigned retailer locations */
  assignedRetailerLocations: Array<RetailerLocation>;
  /** The associated assigned retailers */
  assignedRetailers: Array<Retailer>;
  /** Whether access is granted for every partner, retailer and location */
  hasAllPartnersFullAccess: Scalars['Boolean'];
  /** Whether access is granted for every retailer and location for partners assigned */
  hasFullPartnerAccess: Scalars['Boolean'];
  /** Whether access is granted for every location for retailers assigned */
  hasFullRetailerAccess: Scalars['Boolean'];
  /** Whether access is not granted to any partner, retailer or location */
  hasNothingAccessible: Scalars['Boolean'];
};

/** An individual partner write access record for an account */
export type EnterprisePartnerWriteAccess = {
  __typename?: 'EnterprisePartnerWriteAccess';
  /** The ID of the account that has this entity access */
  accountId: Scalars['ID'];
  /** Whether this access applies to all entities of the given type */
  allEntitiesAccess?: Maybe<Scalars['Boolean']>;
  /** The action on the entity */
  entityAction: EntityActionEnum;
  /** The ID of the specific entity (null if all_entities_access is true) */
  entityId?: Maybe<Scalars['String']>;
  /** The type of entity */
  entityType: EntityTypeEnum;
  /** The time at which the access expires */
  expiresAt?: Maybe<Scalars['Time']>;
  /** The internal unique identifier for the account entity access */
  id: Scalars['ID'];
  /** The partner this access applies to */
  partner?: Maybe<Partner>;
  /** The partner ID (alias for entity_id) */
  partnerId?: Maybe<Scalars['String']>;
};

export type EnterprisePermission = {
  __typename?: 'EnterprisePermission';
  /** A description of the permission */
  description?: Maybe<Scalars['String']>;
  /** Indicates if the Permission can be used to assign to a Retailer role */
  isRetailerRoleAssignable: Scalars['Boolean'];
  /** A unique identifier for the permission */
  slug: Scalars['ID'];
};

export type EnterpriseRole = {
  __typename?: 'EnterpriseRole';
  /** The number of accounts currently attached to the role */
  attachedAccounts?: Maybe<Scalars['Int']>;
  /** Localized description of the role */
  description?: Maybe<Scalars['String']>;
  /** The role ID */
  id: Scalars['ID'];
  /** Whether this role can only be assigned to internal IC employees */
  internalOnly: Scalars['Boolean'];
  /** Localized name of the role */
  name: Scalars['String'];
  /** The origin system of this role (e.g. 'self', 'foodstorm') */
  origin: Scalars['String'];
  /** Slack-side approver metadata for protected/SOX-tier roles. Null for standard roles. */
  owner?: Maybe<EnterpriseRoleOwner>;
  partnerId?: Maybe<Scalars['ID']>;
  /** The permissions associated with this role */
  permissions: Array<EnterprisePermission>;
  retailerId?: Maybe<Scalars['ID']>;
  /** Sensitivity tier: 'sox' | 'protected' | 'standard'. Derived from role permissions and config/sensitive_roles.yml — see Services::Roles::SensitivityTier. */
  sensitivityTier: Scalars['String'];
  /** A unique identifier for the role */
  slug: Scalars['ID'];
  updatedAt: Scalars['Time'];
};

/** Approver contact metadata for a protected or SOX-tier role. */
export type EnterpriseRoleOwner = {
  __typename?: 'EnterpriseRoleOwner';
  /** Slack user-group ID (S-prefix) when the role is owned by a group (any-one-approves). */
  slackUserGroupId?: Maybe<Scalars['String']>;
  /** Slack user ID (U-prefix) of the named owner, when the role is owned by an individual. */
  slackUserId?: Maybe<Scalars['String']>;
};

/** Acknowledgment record (DynamoDB keys stripped) */
export type EnterpriseStatusPage_AckRecord = {
  __typename?: 'EnterpriseStatusPage_AckRecord';
  acknowledgedBy?: Maybe<Scalars['String']>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  incidentId?: Maybe<Scalars['UUID']>;
  timestamp?: Maybe<Scalars['DateTime']>;
  userIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type EnterpriseStatusPage_AcknowledgeRequest_Input = {
  acknowledgedBy?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EnterpriseStatusPage_AcknowledgeResponse = {
  __typename?: 'EnterpriseStatusPage_AcknowledgeResponse';
  ack?: Maybe<EnterpriseStatusPage_AckRecord>;
  acknowledged?: Maybe<Scalars['Boolean']>;
};

export type EnterpriseStatusPage_AudiencePreviewRequest_Input = {
  componentIds: Array<InputMaybe<Scalars['UUID']>>;
};

export type EnterpriseStatusPage_AudiencePreviewResponse = {
  __typename?: 'EnterpriseStatusPage_AudiencePreviewResponse';
  componentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Partner IDs the FE should use with enterpriseAccountSearch to resolve canonicalUserIds */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum EnterpriseStatusPage_Component_Group_Const {
  ComponentGroup = 'COMPONENT_GROUP'
}

export type EnterpriseStatusPage_Component = {
  __typename?: 'EnterpriseStatusPage_Component';
  createdAt?: Maybe<Scalars['DateTime']>;
  groupId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  /** Partner identifiers used for audience resolution */
  partnerIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  pk?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
};

/** Component group row as stored and returned by the API */
export type EnterpriseStatusPage_ComponentGroup = {
  __typename?: 'EnterpriseStatusPage_ComponentGroup';
  createdAt?: Maybe<Scalars['DateTime']>;
  entityType: EnterpriseStatusPage_Component_Group_Const;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_ComponentGroupInput_Input = {
  /** Display name for the component group */
  name: Scalars['String'];
};

export type EnterpriseStatusPage_ComponentInput_Input = {
  name: Scalars['String'];
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EnterpriseStatusPage_CreateIncidentRequest_Input = {
  componentIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  /** Impacted area names for this incident. The FE derives these from the selected notification user group names. Shown as "Impacted Areas" in notification emails. */
  components?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  isBackfill?: InputMaybe<Scalars['Boolean']>;
  /** When true, the incident represents a scheduled maintenance window. scheduledStartTime and scheduledEndTime are required. */
  isMaintenance?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** Optional. Retailer contact snapshots fetched by the FE from retailer-contact-management (via mesh). Each entry groups contacts under a retailerId. Saved as-is for later notification via POST /incidents/{id}/notify-contacts. */
  retailerContacts?: InputMaybe<Array<InputMaybe<EnterpriseStatusPage_RetailerContactsEntry_Input>>>;
  /** Scheduled end of the maintenance window (ISO 8601). Required when isMaintenance is true. Must be after scheduledStartTime. */
  scheduledEndTime?: InputMaybe<Scalars['DateTime']>;
  /** Scheduled start of the maintenance window (ISO 8601). Required when isMaintenance is true. */
  scheduledStartTime?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<EnterpriseStatusPage_IncidentStatus>;
};

export type EnterpriseStatusPage_CreateIncidentResponse = {
  __typename?: 'EnterpriseStatusPage_CreateIncidentResponse';
  incident?: Maybe<EnterpriseStatusPage_IncidentMeta>;
};

export type EnterpriseStatusPage_DeleteIncidentResponse = {
  __typename?: 'EnterpriseStatusPage_DeleteIncidentResponse';
  deleted?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
};

export type EnterpriseStatusPage_Error = {
  __typename?: 'EnterpriseStatusPage_Error';
  error?: Maybe<Scalars['String']>;
};

export enum EnterpriseStatusPage_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

/** Full detail view for an incident or maintenance record. Includes the metadata fields from IncidentMeta plus associated updates, component IDs, notifications, and acknowledgments. The type field indicates whether this is an incident or maintenance record. */
export type EnterpriseStatusPage_IncidentDetail = {
  __typename?: 'EnterpriseStatusPage_IncidentDetail';
  /** Timestamp of the most recent acknowledgment */
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  acks?: Maybe<Array<Maybe<EnterpriseStatusPage_AckRecord>>>;
  componentIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  /** Impacted area names for this incident, derived from selected notification user group names. */
  components?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  /** Whether this incident has been acknowledged by a retailer */
  isAcknowledged?: Maybe<Scalars['Boolean']>;
  isBackfill?: Maybe<Scalars['Boolean']>;
  /** Whether this incident represents a scheduled maintenance window */
  isMaintenance?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notifications?: Maybe<Array<Maybe<EnterpriseStatusPage_NotificationRecord>>>;
  /** Retailer contact snapshots captured at incident creation or refreshed via notify-contacts */
  retailerContacts?: Maybe<Array<Maybe<EnterpriseStatusPage_IncidentRetailerContacts>>>;
  /** ISO 8601 timestamp for when maintenance ends. Only populated for maintenance-type records. Null for incidents. */
  scheduledEndAt?: Maybe<Scalars['DateTime']>;
  /** Scheduled end time of the maintenance window (required when isMaintenance is true) */
  scheduledEndTime?: Maybe<Scalars['DateTime']>;
  /** ISO 8601 timestamp for when maintenance begins. Only populated for maintenance-type records. Null for incidents. */
  scheduledStartAt?: Maybe<Scalars['DateTime']>;
  /** Scheduled start time of the maintenance window (required when isMaintenance is true) */
  scheduledStartTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnterpriseStatusPage_Query_ListIncidents_OneOf_0_Items_Items_Status>;
  type?: Maybe<EnterpriseStatusPage_Query_ListIncidents_OneOf_0_Items_Items_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updates?: Maybe<Array<Maybe<EnterpriseStatusPage_IncidentUpdateRow>>>;
};

/** Incident or maintenance metadata. Internal DynamoDB keys (pk, sk, entityType) are stripped from responses. isAcknowledged defaults to false and acknowledgedAt to null when not yet set. The type field defaults to 'incident' for backwards compatibility with records created before the type discriminator was added. */
export type EnterpriseStatusPage_IncidentMeta = {
  __typename?: 'EnterpriseStatusPage_IncidentMeta';
  /** Timestamp of the most recent acknowledgment */
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  /** Impacted area names for this incident, derived from selected notification user group names. */
  components?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  /** Whether this incident has been acknowledged by a retailer */
  isAcknowledged?: Maybe<Scalars['Boolean']>;
  isBackfill?: Maybe<Scalars['Boolean']>;
  /** Whether this incident represents a scheduled maintenance window */
  isMaintenance?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** ISO 8601 timestamp for when maintenance ends. Only populated for maintenance-type records. Null for incidents. */
  scheduledEndAt?: Maybe<Scalars['DateTime']>;
  /** Scheduled end time of the maintenance window (required when isMaintenance is true) */
  scheduledEndTime?: Maybe<Scalars['DateTime']>;
  /** ISO 8601 timestamp for when maintenance begins. Only populated for maintenance-type records. Null for incidents. */
  scheduledStartAt?: Maybe<Scalars['DateTime']>;
  /** Scheduled start time of the maintenance window (required when isMaintenance is true) */
  scheduledStartTime?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EnterpriseStatusPage_Query_ListIncidents_OneOf_0_Items_Items_Status>;
  type?: Maybe<EnterpriseStatusPage_Query_ListIncidents_OneOf_0_Items_Items_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Retailer contact snapshot stored per incident per subgroup selection. Records are keyed by subGroupId (sk = RETAILER#<subGroupId>) when subGroupId is present, otherwise by retailerId for legacy records created before subGroupId keying was introduced. */
export type EnterpriseStatusPage_IncidentRetailerContacts = {
  __typename?: 'EnterpriseStatusPage_IncidentRetailerContacts';
  contacts?: Maybe<Array<Maybe<EnterpriseStatusPage_RetailerContact>>>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  incidentId?: Maybe<Scalars['UUID']>;
  /** ID of the top-level user group */
  parentGroupId?: Maybe<Scalars['UUID']>;
  /** Display name of the top-level user group; used to derive the incident's components (impacted areas) */
  parentGroupName?: Maybe<Scalars['String']>;
  /** Retailer ID for contact resolution and notification targeting */
  retailerId?: Maybe<Scalars['String']>;
  /** Subgroup UUID used as the record key; present on new-style records */
  subGroupId?: Maybe<Scalars['UUID']>;
  /** Display name of the subgroup */
  subGroupName?: Maybe<Scalars['String']>;
};

/** Filter by incident status */
export enum EnterpriseStatusPage_IncidentStatus {
  Identified = 'identified',
  Investigating = 'investigating',
  Monitoring = 'monitoring',
  Resolved = 'resolved'
}

export type EnterpriseStatusPage_IncidentStatus_Container = {
  __typename?: 'EnterpriseStatusPage_IncidentStatus_container';
  IncidentStatus?: Maybe<EnterpriseStatusPage_IncidentStatus>;
};

/** Single update record (DynamoDB keys stripped) */
export type EnterpriseStatusPage_IncidentUpdateRow = {
  __typename?: 'EnterpriseStatusPage_IncidentUpdateRow';
  createdBy?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<EnterpriseStatusPage_IncidentStatus>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** Valid status values for maintenance-type records. Maintenance records use these values instead of IncidentStatus. Runtime validation is handled by the maintenance CRUD endpoints. */
export enum EnterpriseStatusPage_MaintenanceStatus {
  Completed = 'completed',
  InProgress = 'in_progress',
  Scheduled = 'scheduled'
}

export type EnterpriseStatusPage_MaintenanceStatus_Container = {
  __typename?: 'EnterpriseStatusPage_MaintenanceStatus_container';
  MaintenanceStatus?: Maybe<EnterpriseStatusPage_MaintenanceStatus>;
};

/** Notification history record (DynamoDB keys stripped) */
export type EnterpriseStatusPage_NotificationRecord = {
  __typename?: 'EnterpriseStatusPage_NotificationRecord';
  dryRun?: Maybe<Scalars['Boolean']>;
  incidentId?: Maybe<Scalars['String']>;
  recipientCount?: Maybe<Scalars['Int']>;
  rpcUuid?: Maybe<Scalars['String']>;
  sent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<EnterpriseStatusPage_IncidentStatus>;
  /** Subgroup IDs (RETAILER# key suffixes) whose contacts were notified (only present for contact_notify records) */
  subGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  timestamp?: Maybe<Scalars['DateTime']>;
  triggerType?: Maybe<EnterpriseStatusPage_Query_GetIncident_OneOf_0_AllOf_1_Notifications_Items_TriggerType>;
};

export type EnterpriseStatusPage_NotificationResult = {
  __typename?: 'EnterpriseStatusPage_NotificationResult';
  dryRun?: Maybe<Scalars['Boolean']>;
  recipientCount?: Maybe<Scalars['Int']>;
  sent?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_NotifyContactsRequest_Input = {
  /** Identifier of the user or system triggering the notification */
  triggeredBy?: InputMaybe<Scalars['String']>;
};

export type EnterpriseStatusPage_NotifyContactsResponse = {
  __typename?: 'EnterpriseStatusPage_NotifyContactsResponse';
  notification?: Maybe<EnterpriseStatusPage_NotificationResult>;
  retailerContacts?: Maybe<Array<Maybe<EnterpriseStatusPage_IncidentRetailerContacts>>>;
};

/** Paginated list of incidents */
export type EnterpriseStatusPage_PaginatedIncidentList = {
  __typename?: 'EnterpriseStatusPage_PaginatedIncidentList';
  items?: Maybe<Array<Maybe<EnterpriseStatusPage_IncidentMeta>>>;
  /** Base64-encoded cursor for the next page. Pass as the nextToken query parameter to fetch the next page. Absent when there are no more results. */
  nextToken?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_PostIncidentUpdateRequest_Input = {
  ackGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ackUserIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** If true, also acknowledges the incident in the same request */
  acknowledge?: InputMaybe<Scalars['Boolean']>;
  /** Defaults to createdBy when acknowledge is true */
  acknowledgedBy?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
  /** When true, suppresses the automatic notification to saved retailer contacts for this update. Defaults to false — notifications are sent automatically on every status update. */
  skipNotification?: InputMaybe<Scalars['Boolean']>;
  status: EnterpriseStatusPage_MutationInput_PostIncidentUpdate_Input_Status_Input;
};

export type EnterpriseStatusPage_PostIncidentUpdateResponse = {
  __typename?: 'EnterpriseStatusPage_PostIncidentUpdateResponse';
  ack?: Maybe<EnterpriseStatusPage_AckRecord>;
  notification?: Maybe<EnterpriseStatusPage_NotificationResult>;
  update?: Maybe<EnterpriseStatusPage_IncidentUpdateRow>;
};

/** A contact record from retailer-contact-management, keyed by retailer */
export type EnterpriseStatusPage_RetailerContact = {
  __typename?: 'EnterpriseStatusPage_RetailerContact';
  createdAt?: Maybe<Scalars['DateTime']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['EmailAddress']>;
  /** IPP canonical user ID used as the notification recipient */
  ippCanonicalUserId?: Maybe<Scalars['String']>;
  ippUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['PositiveInt']>;
  retailerId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** A contact record from retailer-contact-management, keyed by retailer */
export type EnterpriseStatusPage_RetailerContact_Input = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** IPP canonical user ID used as the notification recipient */
  ippCanonicalUserId?: InputMaybe<Scalars['String']>;
  ippUserId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['PositiveInt']>;
  retailerId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/** FE-supplied retailer contact group for a single subgroup selection. subGroupId is the preferred key; retailerId is required for contact resolution. When subGroupId is provided, the snapshot is keyed by subGroupId so two subgroups sharing a retailerId are stored as distinct entries. */
export type EnterpriseStatusPage_RetailerContactsEntry_Input = {
  contacts: Array<InputMaybe<EnterpriseStatusPage_RetailerContact_Input>>;
  /** ID of the top-level user group */
  parentGroupId?: InputMaybe<Scalars['UUID']>;
  /** Display name of the top-level user group; determines the impacted area label */
  parentGroupName?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['String'];
  /** Unique ID of the subgroup the operator selected; used as the DynamoDB record key */
  subGroupId?: InputMaybe<Scalars['UUID']>;
  /** Display name of the subgroup */
  subGroupName?: InputMaybe<Scalars['String']>;
};

export type EnterpriseStatusPage_SystemComponentList = {
  __typename?: 'EnterpriseStatusPage_SystemComponentList';
  /** Available system component names configured via SYSTEM_COMPONENTS env var */
  components?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum EnterpriseStatusPage_User_Group_Const {
  UserGroup = 'USER_GROUP'
}

/** A user group record. Top-level groups are named categories (e.g. "Grocers"). Sub-groups (parentGroupId set) represent individual retailers and carry retailerId and retailerName so the FE can resolve contacts from retailer-contact-management. */
export type EnterpriseStatusPage_UserGroup = {
  __typename?: 'EnterpriseStatusPage_UserGroup';
  createdAt?: Maybe<Scalars['DateTime']>;
  entityType: EnterpriseStatusPage_User_Group_Const;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  /** ID of the parent top-level group; absent for top-level groups */
  parentGroupId?: Maybe<Scalars['UUID']>;
  pk?: Maybe<Scalars['String']>;
  /** Retailer identifier from retailer-contact-management. Present on sub-groups only. */
  retailerId?: Maybe<Scalars['String']>;
  /** Human-readable retailer display name. Present on sub-groups only. */
  retailerName?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
};

/** A top-level group with nested sub-groups and their users */
export type EnterpriseStatusPage_UserGroupHierarchy = {
  __typename?: 'EnterpriseStatusPage_UserGroupHierarchy';
  children?: Maybe<Array<Maybe<EnterpriseStatusPage_UserGroupWithUsers>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_UserGroupInput_Input = {
  name: Scalars['String'];
  /** If provided, creates a sub-group under this top-level group. Sub-groups represent retailers — include retailerId (and optionally retailerName) when creating one. */
  parentGroupId?: InputMaybe<Scalars['UUID']>;
  /** Retailer identifier from retailer-contact-management. Required for sub-groups; ignored for top-level groups. Must be unique within the parent group. */
  retailerId?: InputMaybe<Scalars['String']>;
  /** Human-readable retailer display name. Optional — used for display in the FE picker. */
  retailerName?: InputMaybe<Scalars['String']>;
};

/** Top-level group with sub-groups only (no users) */
export type EnterpriseStatusPage_UserGroupSummary = {
  __typename?: 'EnterpriseStatusPage_UserGroupSummary';
  children?: Maybe<Array<Maybe<EnterpriseStatusPage_UserGroupSummaryChild>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
};

/** A sub-group without user list (for lightweight selectors). Represents a retailer entry — retailerId and retailerName are present when the sub-group has been linked to a retailer. */
export type EnterpriseStatusPage_UserGroupSummaryChild = {
  __typename?: 'EnterpriseStatusPage_UserGroupSummaryChild';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  parentGroupId?: Maybe<Scalars['UUID']>;
  /** Retailer identifier from retailer-contact-management */
  retailerId?: Maybe<Scalars['String']>;
  /** Human-readable retailer display name */
  retailerName?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_UserGroupUpdateInput_Input = {
  name: Scalars['String'];
  /** Update the retailer ID linked to this sub-group */
  retailerId?: InputMaybe<Scalars['String']>;
  /** Update the retailer display name */
  retailerName?: InputMaybe<Scalars['String']>;
};

/** A sub-group with its user members. Represents a retailer entry — retailerId and retailerName are present when linked to a retailer. */
export type EnterpriseStatusPage_UserGroupWithUsers = {
  __typename?: 'EnterpriseStatusPage_UserGroupWithUsers';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  parentGroupId?: Maybe<Scalars['UUID']>;
  /** Retailer identifier from retailer-contact-management */
  retailerId?: Maybe<Scalars['String']>;
  /** Human-readable retailer display name */
  retailerName?: Maybe<Scalars['String']>;
  users?: Maybe<Array<Maybe<EnterpriseStatusPage_UserInGroup>>>;
};

export type EnterpriseStatusPage_UserInGroup = {
  __typename?: 'EnterpriseStatusPage_UserInGroup';
  canonicalUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  groupId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  pk?: Maybe<Scalars['String']>;
  sk?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_UserInput_Input = {
  canonicalUserId: Scalars['String'];
  name: Scalars['String'];
};

export type EnterpriseStatusPage_Void_Container = {
  __typename?: 'EnterpriseStatusPage_Void_container';
  Void?: Maybe<Scalars['Void']>;
};

export type EnterpriseStatusPage_AcknowledgeIncident_Response = EnterpriseStatusPage_AcknowledgeResponse | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_AddUserToGroup_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_UserInGroup;

export type EnterpriseStatusPage_CreateComponentGroup_Response = EnterpriseStatusPage_ComponentGroup | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_CreateComponent_Response = EnterpriseStatusPage_Component | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_CreateIncident_Response = EnterpriseStatusPage_CreateIncidentResponse | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_CreateUserGroup_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_UserGroup;

export type EnterpriseStatusPage_DeleteComponent_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_Void_Container;

export type EnterpriseStatusPage_DeleteIncident_Response = EnterpriseStatusPage_DeleteIncidentResponse | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_DeleteUserGroup_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_Void_Container;

export type EnterpriseStatusPage_GetIncident_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_IncidentDetail;

export type EnterpriseStatusPage_HealthCheck_200_Response = {
  __typename?: 'EnterpriseStatusPage_healthCheck_200_response';
  service?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_ListComponentGroups_Response = EnterpriseStatusPage_ComponentGroup | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_ListComponentsInGroup_Response = EnterpriseStatusPage_Component | EnterpriseStatusPage_Error;

export type EnterpriseStatusPage_ListIncidents_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_PaginatedIncidentList;

export type EnterpriseStatusPage_ListNotificationUserGroups_200_Response = {
  __typename?: 'EnterpriseStatusPage_listNotificationUserGroups_200_response';
  groups?: Maybe<Array<Maybe<EnterpriseStatusPage_UserGroupHierarchy>>>;
};

export type EnterpriseStatusPage_ListUserGroupsSummary_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_UserGroupSummary;

export type EnterpriseStatusPage_ListUserGroups_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_UserGroupHierarchy;

export type EnterpriseStatusPage_MutationInput_PostIncidentUpdate_Input_Status_Input = {
  IncidentStatus?: InputMaybe<EnterpriseStatusPage_IncidentStatus>;
  MaintenanceStatus?: InputMaybe<EnterpriseStatusPage_MaintenanceStatus>;
};

export type EnterpriseStatusPage_NotifyIncidentContacts_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_NotifyContactsResponse;

export type EnterpriseStatusPage_PostIncidentUpdate_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_PostIncidentUpdateResponse;

export type EnterpriseStatusPage_PreviewNotificationAudience_Response = EnterpriseStatusPage_AudiencePreviewResponse | EnterpriseStatusPage_Error;

export enum EnterpriseStatusPage_Query_GetIncident_OneOf_0_AllOf_1_Notifications_Items_TriggerType {
  ContactNotify = 'contact_notify',
  IncidentCreated = 'incident_created',
  IncidentUpdated = 'incident_updated'
}

/** Current status of the record. For incidents this is an IncidentStatus value (investigating, identified, monitoring, resolved). For maintenance records this is a MaintenanceStatus value (scheduled, in_progress, completed). */
export type EnterpriseStatusPage_Query_ListIncidents_OneOf_0_Items_Items_Status = EnterpriseStatusPage_IncidentStatus_Container | EnterpriseStatusPage_MaintenanceStatus_Container;

/** Discriminator indicating whether this record is an incident or a maintenance event. Defaults to 'incident' for backwards compatibility with existing records that do not have this field set. */
export enum EnterpriseStatusPage_Query_ListIncidents_OneOf_0_Items_Items_Type {
  Incident = 'incident',
  Maintenance = 'maintenance'
}

export type EnterpriseStatusPage_RemoveIncidentRetailerContacts_200_Response = {
  __typename?: 'EnterpriseStatusPage_removeIncidentRetailerContacts_200_response';
  deleted?: Maybe<Scalars['Boolean']>;
  subGroupId?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_RemoveIncidentRetailerContacts_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_RemoveIncidentRetailerContacts_200_Response;

export type EnterpriseStatusPage_RemoveUserFromGroup_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_Void_Container;

export type EnterpriseStatusPage_UpdateUserGroup_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_UserGroup;

export type EnterpriseStatusPage_UpsertIncidentRetailerContacts_200_Response = {
  __typename?: 'EnterpriseStatusPage_upsertIncidentRetailerContacts_200_response';
  contacts?: Maybe<Array<Maybe<EnterpriseStatusPage_RetailerContact>>>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  parentGroupId?: Maybe<Scalars['UUID']>;
  parentGroupName?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['String']>;
  subGroupId?: Maybe<Scalars['UUID']>;
  subGroupName?: Maybe<Scalars['String']>;
};

export type EnterpriseStatusPage_UpsertIncidentRetailerContacts_Request_Input = {
  contacts: Array<InputMaybe<EnterpriseStatusPage_RetailerContact_Input>>;
  /** ID of the top-level user group */
  parentGroupId?: InputMaybe<Scalars['UUID']>;
  /** Display name of the top-level user group; used as the impacted area label (required) */
  parentGroupName: Scalars['String'];
  /** Retailer ID for contact resolution and notification targeting */
  retailerId: Scalars['String'];
  /** Unique ID of the user group child (subgroup) the operator selected */
  subGroupId: Scalars['UUID'];
  /** Display name of the subgroup */
  subGroupName?: InputMaybe<Scalars['String']>;
};

export type EnterpriseStatusPage_UpsertIncidentRetailerContacts_Response = EnterpriseStatusPage_Error | EnterpriseStatusPage_UpsertIncidentRetailerContacts_200_Response;

export type EnterpriseUserAccessSettings = {
  __typename?: 'EnterpriseUserAccessSettings';
  /** Whether the user has write access to all partners */
  hasAllPartnersWriteAccess: Scalars['Boolean'];
  /** The IDs of the partners assigned to the account */
  partnerIds: Array<Scalars['ID']>;
  /** The IDs of the partners the user has write access to */
  partnerWriteAccessIds: Array<Scalars['ID']>;
  /** The IDs of the retailers assigned to the account */
  retailerIds: Array<Scalars['ID']>;
  /** The roles assigned to the account */
  roles: Array<EnterpriseRole>;
};

export type EnterpriseWelcomeModal = {
  __typename?: 'EnterpriseWelcomeModal';
  /** slug identifying type of welcome modal to be shown. */
  slug: Scalars['String'];
};

export enum Entity {
  Product = 'PRODUCT',
  SellSheet = 'SELL_SHEET'
}

/** The supported actions for account entity access, e.g write */
export enum EntityActionEnum {
  /** write access to the entity */
  Write = 'WRITE'
}

export type EntityId = {
  __typename?: 'EntityId';
  cashflowAuditItem?: Maybe<CashflowAuditItem>;
  dataEntryItem?: Maybe<DataEntryItem>;
  itemId?: Maybe<ItemId>;
  localeProduct?: Maybe<LocaleProduct>;
  localeRetailerProduct?: Maybe<LocaleRetailerProduct>;
  outsourceDataEntryItem?: Maybe<OutsourceDataEntryItem>;
  productId?: Maybe<ProductId>;
  qasTaskItem?: Maybe<QasTaskItem>;
  recipeEntryItem?: Maybe<RecipeEntryItem>;
  retailerProductId?: Maybe<RetailerProductId>;
  upc?: Maybe<Upc>;
};

export type EntityIdInput = {
  int64Id?: InputMaybe<Scalars['BigInt']>;
  itemId?: InputMaybe<ItemIdInput>;
  productId?: InputMaybe<ProductIdInput>;
  retailerProductId?: InputMaybe<RetailerProductIdInput>;
  stringId?: InputMaybe<Scalars['String']>;
  upc?: InputMaybe<UpcInput>;
};

export enum EntityStatus {
  EntityStatusCancelled = 'ENTITY_STATUS_CANCELLED',
  EntityStatusCompleted = 'ENTITY_STATUS_COMPLETED',
  EntityStatusDeduplicated = 'ENTITY_STATUS_DEDUPLICATED',
  EntityStatusEntityNotFound = 'ENTITY_STATUS_ENTITY_NOT_FOUND',
  EntityStatusFailed = 'ENTITY_STATUS_FAILED',
  EntityStatusFailedUncaught = 'ENTITY_STATUS_FAILED_UNCAUGHT',
  EntityStatusInProgress = 'ENTITY_STATUS_IN_PROGRESS',
  EntityStatusNonNormalizedUpc = 'ENTITY_STATUS_NON_NORMALIZED_UPC',
  EntityStatusStarted = 'ENTITY_STATUS_STARTED',
  EntityStatusSubmittedToFixService = 'ENTITY_STATUS_SUBMITTED_TO_FIX_SERVICE',
  EntityStatusUnknown = 'ENTITY_STATUS_UNKNOWN',
  EntityStatusUnknownError = 'ENTITY_STATUS_UNKNOWN_ERROR',
  EntityStatusUpcCollision = 'ENTITY_STATUS_UPC_COLLISION',
  EntityStatusWarning = 'ENTITY_STATUS_WARNING',
  EntityStatusWontDo = 'ENTITY_STATUS_WONT_DO'
}

export enum EntityType {
  EntityTypeItemIds = 'ENTITY_TYPE_ITEM_IDS',
  EntityTypeProductIds = 'ENTITY_TYPE_PRODUCT_IDS',
  EntityTypeRetailerProductIds = 'ENTITY_TYPE_RETAILER_PRODUCT_IDS',
  EntityTypeUnknown = 'ENTITY_TYPE_UNKNOWN',
  EntityTypeUpcs = 'ENTITY_TYPE_UPCS'
}

/** The supported types for account entity access, e.g partner */
export enum EntityTypeEnum {
  /** partner entity access */
  Partner = 'PARTNER'
}

export enum ErrorReason {
  DraftErrorConflict = 'DRAFT_ERROR_CONFLICT',
  DraftErrorNotFound = 'DRAFT_ERROR_NOT_FOUND',
  DraftErrorUnexpectedState = 'DRAFT_ERROR_UNEXPECTED_STATE',
  ErrorEnumUnknown = 'ERROR_ENUM_UNKNOWN',
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  ErrorReasonModificationNotPermitted = 'ERROR_REASON_MODIFICATION_NOT_PERMITTED',
  ErrorReasonUnknown = 'ERROR_REASON_UNKNOWN'
}

export enum ExperimentMethod {
  Assign = 'ASSIGN',
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  Lookup = 'LOOKUP',
  Preview = 'PREVIEW'
}

export type ExperimentVariantInput = {
  /** The method of the experiment */
  experimentMethod: PlacementExperimentMethodEnum;
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** The name of the experiment variant */
  experimentVariant: Scalars['String'];
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of ExperimentVariantVisibilityConditionCreate */
export type ExperimentVariantVisibilityConditionCreatePayload = {
  __typename?: 'ExperimentVariantVisibilityConditionCreatePayload';
  /** The newly created ExperimentVariant visibility condition */
  experimentVariantVisibilityCondition: ContentManagementVisibilityConditionExperimentVariant;
};

/** Autogenerated return type of ExperimentVariantVisibilityConditionUpdate */
export type ExperimentVariantVisibilityConditionUpdatePayload = {
  __typename?: 'ExperimentVariantVisibilityConditionUpdatePayload';
  /** The newly updated ExperimentVariant visibility condition */
  experimentVariantVisibilityCondition: ContentManagementVisibilityConditionExperimentVariant;
};

export type ExpressMembershipInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** Whether the user should be an express member */
  membershipStatus: Scalars['Boolean'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ExpressMembershipVisibilityConditionCreate */
export type ExpressMembershipVisibilityConditionCreatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionCreatePayload';
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership;
};

/** Autogenerated return type of ExpressMembershipVisibilityConditionUpdate */
export type ExpressMembershipVisibilityConditionUpdatePayload = {
  __typename?: 'ExpressMembershipVisibilityConditionUpdatePayload';
  /** The newly created express_membership visibility condition */
  expressMembershipVisibilityCondition: ContentManagementVisibilityConditionExpressMembership;
};

export type ExpressNonmemberLongTermHoldoutInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of ExpressNonmemberLongTermHoldoutVisibilityConditionCreate */
export type ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload = {
  __typename?: 'ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload';
  /** The newly created ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityCondition: ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout;
};

export type ExternalHealthDashboard_Error = {
  __typename?: 'ExternalHealthDashboard_Error';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ExternalHealthDashboard_ErrorBreakdownItem = {
  __typename?: 'ExternalHealthDashboard_ErrorBreakdownItem';
  /** Total error count across the metrics time window for this endpoint/status_code/exception_class tuple */
  count: Scalars['Float'];
  /** Connect API endpoint that emitted the error */
  endpoint: Scalars['String'];
  /** Collapsed, lowercased exception-class tag from Datadog, or "unknown" if untagged */
  exceptionClass: Scalars['String'];
  /** HTTP status code emitted by the upstream service */
  statusCode: Scalars['Int'];
};

export enum ExternalHealthDashboard_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type ExternalHealthDashboard_HealthCheck = {
  __typename?: 'ExternalHealthDashboard_HealthCheck';
  HttpCode?: Maybe<Scalars['String']>;
};

export type ExternalHealthDashboard_MonitorStatus = {
  __typename?: 'ExternalHealthDashboard_MonitorStatus';
  /** Metric window end for the breakdown query. Present only on non-operational rows; omitted on operational rows. */
  asOf?: Maybe<Scalars['DateTime']>;
  /** Top error contributors by endpoint, status_code, and exception_class. Present only on non-operational rows; omitted on operational rows. Available on both metrics-approach and monitor-approach retailers. */
  breakdown?: Maybe<Array<Maybe<ExternalHealthDashboard_ErrorBreakdownItem>>>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<ExternalHealthDashboard_Query_GetMonitorStatuses_OneOf_0_Items_Statuses_Items_Status>;
};

export type ExternalHealthDashboard_RetailerMonitorStatusGroup = {
  __typename?: 'ExternalHealthDashboard_RetailerMonitorStatusGroup';
  /** The ID of the retailer */
  retailerId: Scalars['String'];
  /** Array of monitor statuses for this retailer */
  statuses: Array<Maybe<ExternalHealthDashboard_MonitorStatus>>;
};

export type ExternalHealthDashboard_String_Container = {
  __typename?: 'ExternalHealthDashboard_String_container';
  String?: Maybe<Scalars['String']>;
};

export type ExternalHealthDashboard_GetMonitorStatuses_Response = ExternalHealthDashboard_Error | ExternalHealthDashboard_RetailerMonitorStatusGroup;

export type ExternalHealthDashboard_GetOpenApiSpec_Response = ExternalHealthDashboard_Error | ExternalHealthDashboard_String_Container;

export enum ExternalHealthDashboard_Query_GetMonitorStatuses_OneOf_0_Items_Statuses_Items_Status {
  Degraded = 'degraded',
  MajorOutage = 'major_outage',
  Operational = 'operational',
  PartialOutage = 'partial_outage'
}

export type FailedUpdate = {
  __typename?: 'FailedUpdate';
  reason?: Maybe<Scalars['String']>;
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type FastAttributeInfo = {
  __typename?: 'FastAttributeInfo';
  addedBy?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  deprecated?: Maybe<Scalars['Boolean']>;
  documentation?: Maybe<Scalars['String']>;
  inFastAttribute?: Maybe<Scalars['Boolean']>;
  mandatoryOnModels?: Maybe<Array<Maybe<Scalars['String']>>>;
  publishedAs?: Maybe<Scalars['String']>;
  rivercatId?: Maybe<Scalars['BigInt']>;
  scope?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
  usedByModels?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type FeatureEntitlement = {
  __typename?: 'FeatureEntitlement';
  /** The unique referable identifier of this entitlement */
  id: Scalars['String'];
  /** The display name of this entitlement */
  name: Scalars['String'];
};

export type FeatureExperiment = {
  __typename?: 'FeatureExperiment';
  /** The name of this feature */
  name: Scalars['String'];
  /** The variant picked */
  variant: Scalars['String'];
};

export type FeatureToggle = {
  __typename?: 'FeatureToggle';
  /** The name of this feature toggle */
  name: Scalars['String'];
};

export type FeatureToggleByRetailerId = {
  __typename?: 'FeatureToggleByRetailerId';
  /** feature toggles */
  featureToggles: Array<FeatureToggle>;
  /** The retailer ID */
  retailerId: Scalars['ID'];
};

export type FeatureTogglesEnabledCheck = {
  __typename?: 'FeatureTogglesEnabledCheck';
  /** Whether the feature toggle is enabled */
  enabled: Scalars['Boolean'];
};

export enum FeedbackEnum {
  /** Negative feedback */
  Negative = 'negative',
  /** Positive feedback */
  Positive = 'positive'
}

export enum FilterType {
  FilterTypeAdminOnly = 'FILTER_TYPE_ADMIN_ONLY',
  FilterTypeCollectionId = 'FILTER_TYPE_COLLECTION_ID',
  FilterTypeCollectionSlug = 'FILTER_TYPE_COLLECTION_SLUG',
  FilterTypeCreatedBy = 'FILTER_TYPE_CREATED_BY',
  FilterTypeMoment = 'FILTER_TYPE_MOMENT',
  FilterTypeMomentApproved = 'FILTER_TYPE_MOMENT_APPROVED',
  FilterTypeMomentRejected = 'FILTER_TYPE_MOMENT_REJECTED',
  FilterTypeMomentSubmitted = 'FILTER_TYPE_MOMENT_SUBMITTED',
  FilterTypeOccasion = 'FILTER_TYPE_OCCASION',
  FilterTypeOccasionApproved = 'FILTER_TYPE_OCCASION_APPROVED',
  FilterTypeOccasionRejected = 'FILTER_TYPE_OCCASION_REJECTED',
  FilterTypeOccasionSubmitted = 'FILTER_TYPE_OCCASION_SUBMITTED',
  FilterTypePartnershipOfferId = 'FILTER_TYPE_PARTNERSHIP_OFFER_ID',
  FilterTypeTag = 'FILTER_TYPE_TAG',
  FilterTypeUnknown = 'FILTER_TYPE_UNKNOWN'
}

export type FlatNavigation = {
  __typename?: 'FlatNavigation';
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
  position?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type FlatNavigationInput = {
  icon?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FlatNavigationWithVariants = {
  __typename?: 'FlatNavigationWithVariants';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type FlatNavigationWithVariantsInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type FlattenedTaxonomy = {
  __typename?: 'FlattenedTaxonomy';
  createdAt?: Maybe<Scalars['DateTime']>;
  productCategoryId?: Maybe<Scalars['BigInt']>;
  productCategoryPath?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FlattenedTaxonomyFilterInput = {
  updatedSince?: InputMaybe<Scalars['DateTime']>;
};

/** Autogenerated return type of FlyoutPlacementCreate */
export type FlyoutPlacementCreatePayload = {
  __typename?: 'FlyoutPlacementCreatePayload';
  /** The newly created flyout placement */
  flyoutPlacement: ContentManagementFlyoutPlacement;
};

export type FlyoutPlacementInput = {
  /** The style and text of the subheading */
  descriptionText: ConfigurableTextInput;
  /** The style and text of the secondary text */
  disclaimerText?: InputMaybe<ConfigurableTextInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>;
  /** The images on the banner */
  images: GenericImagesInput;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The layout the placement should appear on */
  layout?: InputMaybe<Scalars['String']>;
  /** The style and text of the button within the placement */
  linkButton: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  linkDestination?: InputMaybe<PlacementDestinationInput>;
  /** Locale */
  locale: BannerLocaleEnum;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The style and text of the button within the placement */
  primaryButton: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  primaryDestination?: InputMaybe<PlacementDestinationInput>;
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The style and text of the button within the placement */
  secondaryButton: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  secondaryDestination?: InputMaybe<PlacementDestinationInput>;
  /** The layout the placement should appear on */
  stringLayout?: InputMaybe<Scalars['String']>;
  /** The style and text of the heading */
  titleText: ConfigurableTextInput;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** The variant of the banner */
  variant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of FlyoutPlacementUpdate */
export type FlyoutPlacementUpdatePayload = {
  __typename?: 'FlyoutPlacementUpdatePayload';
  /** The updated flyout placement */
  flyoutPlacement: ContentManagementFlyoutPlacement;
};

export type FontFamily = {
  __typename?: 'FontFamily';
  files?: Maybe<FontFiles>;
  name?: Maybe<Scalars['String']>;
};

export type FontFile = {
  __typename?: 'FontFile';
  otf?: Maybe<Scalars['String']>;
  ttf?: Maybe<Scalars['String']>;
  woff?: Maybe<Scalars['String']>;
  woff2?: Maybe<Scalars['String']>;
};

export type FontFiles = {
  __typename?: 'FontFiles';
  bold?: Maybe<FontFile>;
  normal?: Maybe<FontFile>;
  semiBold?: Maybe<FontFile>;
};

export type Footer = {
  __typename?: 'Footer';
  variant?: Maybe<FooterVariant>;
};

export enum FooterVariant {
  MultiColumn = 'MULTI_COLUMN',
  NoFooter = 'NO_FOOTER',
  VariantUnknown = 'VARIANT_UNKNOWN'
}

export type FrothTemplate = {
  __typename?: 'FrothTemplate';
  archived?: Maybe<Scalars['Boolean']>;
  copyOfFrothTemplateVersionId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  instacartInternal?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailerScope?: Maybe<FrothTemplateScope>;
  status?: Maybe<FrothTemplateStatus>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  storeConfigurationScope?: Maybe<FrothTemplateScope>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<Maybe<FrothTemplateVersionInfo>>>;
};

export type FrothTemplateConstraints = {
  __typename?: 'FrothTemplateConstraints';
  dataQueryType?: Maybe<Scalars['String']>;
  variableTypes?: Maybe<Array<Maybe<FrothTemplateVariableType>>>;
};

export enum FrothTemplateScope {
  FrothTemplateScopeAll = 'FROTH_TEMPLATE_SCOPE_ALL',
  FrothTemplateScopeNone = 'FROTH_TEMPLATE_SCOPE_NONE',
  FrothTemplateScopeSpecific = 'FROTH_TEMPLATE_SCOPE_SPECIFIC',
  FrothTemplateScopeUnspecified = 'FROTH_TEMPLATE_SCOPE_UNSPECIFIED'
}

export enum FrothTemplateStatus {
  FrothTemplateStatusArchived = 'FROTH_TEMPLATE_STATUS_ARCHIVED',
  FrothTemplateStatusPublished = 'FROTH_TEMPLATE_STATUS_PUBLISHED',
  FrothTemplateStatusUnpublished = 'FROTH_TEMPLATE_STATUS_UNPUBLISHED',
  FrothTemplateStatusUnspecified = 'FROTH_TEMPLATE_STATUS_UNSPECIFIED'
}

export type FrothTemplateVariableType = {
  __typename?: 'FrothTemplateVariableType';
  path?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type FrothTemplateVersionBody = {
  __typename?: 'FrothTemplateVersionBody';
  body?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSONObject']>;
  contentSchema?: Maybe<Scalars['String']>;
  dataQuery?: Maybe<DataQueryStruct>;
  frothAst?: Maybe<Scalars['String']>;
};

export type FrothTemplateVersionInfo = {
  __typename?: 'FrothTemplateVersionInfo';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  frothTemplateId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  previewImageUrl?: Maybe<Scalars['String']>;
  previewImageUrlMobile?: Maybe<Scalars['String']>;
  referenceCount?: Maybe<Scalars['Int']>;
  status?: Maybe<FrothTemplateVersionStatus>;
  tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

export enum FrothTemplateVersionStatus {
  FrothTemplateVersionStatusDraft = 'FROTH_TEMPLATE_VERSION_STATUS_DRAFT',
  FrothTemplateVersionStatusPublished = 'FROTH_TEMPLATE_VERSION_STATUS_PUBLISHED',
  FrothTemplateVersionStatusUnspecified = 'FROTH_TEMPLATE_VERSION_STATUS_UNSPECIFIED'
}

export type FrothTemplatesPagination = {
  __typename?: 'FrothTemplatesPagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextOffset?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum FulfillmentModelEnum {
  /** Carrotwork */
  Carrotwork = 'CARROTWORK',
  /** In store shoppers */
  Iss = 'ISS',
  /** Locker */
  Locker = 'LOCKER',
  /** Partner managed */
  Retailer = 'RETAILER'
}

export type Function = {
  __typename?: 'Function';
  arguments: Scalars['String'];
  name: Scalars['String'];
};

export type FunctionDefinitionInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  parameters?: InputMaybe<Scalars['JSON']>;
};

export type FunctionInput = {
  arguments: Scalars['String'];
  name: Scalars['String'];
};

export type GenerateBatchRequestInput = {
  adminRequestContext?: InputMaybe<AdminRequestContextInput>;
  batchType?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  orders?: InputMaybe<Array<InputMaybe<OrderInput>>>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type GenerateBatchResponse = {
  __typename?: 'GenerateBatchResponse';
  id?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Scalars['String']>;
};

export type GeneratePresignedAssetDownloadUrlRequestInput = {
  assetUrl?: InputMaybe<Scalars['String']>;
};

export type GeneratePresignedAssetDownloadUrlResponse = {
  __typename?: 'GeneratePresignedAssetDownloadUrlResponse';
  presignedUrl?: Maybe<Scalars['String']>;
};

export type GeneratePresignedAssetUploadUrlRequestInput = {
  fileContentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
};

export type GeneratePresignedAssetUploadUrlResponse = {
  __typename?: 'GeneratePresignedAssetUploadUrlResponse';
  uploadFieldsJson?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export type GenerateProductCreationDataRequestInput = {
  heroImageS3Url?: InputMaybe<ProductCreationImageInput>;
  imageS3Urls?: InputMaybe<Array<InputMaybe<ProductCreationImageInput>>>;
  ippUserId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  productType?: InputMaybe<ProductType>;
  selectedLocales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  selectedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GenerateProductCreationDataResponse = {
  __typename?: 'GenerateProductCreationDataResponse';
  uuid?: Maybe<Scalars['String']>;
};

export type GeneratePrsForStringOverrideRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteStringOverrides?: InputMaybe<Array<InputMaybe<WhitelabelSiteStringOverrideInput>>>;
};

export type GeneratePrsForStringOverrideResponse = {
  __typename?: 'GeneratePrsForStringOverrideResponse';
  errorMessage?: Maybe<Scalars['String']>;
  githubPrLink?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type GenericImagesInput = {
  /** The image url of the placement to display for large viewports */
  desktop?: InputMaybe<Scalars['Url']>;
  /** The image url of the placement to display for small viewports */
  mobile: Scalars['Url'];
};

export type GetAcknowledgedOosIdsRequestInput = {
  retailerId?: InputMaybe<Scalars['String']>;
};

export type GetAcknowledgedOosIdsResponse = {
  __typename?: 'GetAcknowledgedOosIdsResponse';
  oosIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetAdminNavigationV2RequestInput = {
  layoutType?: InputMaybe<Scalars['String']>;
  layoutTypes?: InputMaybe<Array<InputMaybe<LayoutType>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAdminNavigationV2Response = {
  __typename?: 'GetAdminNavigationV2Response';
  adminNavigationV2?: Maybe<AdminNavigationV2>;
};

export type GetAisleRestockItemsRequestInput = {
  aisleId?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<RestockFilterTogglesInput>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  sortBy?: InputMaybe<AisleItemSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GetAisleRestockItemsResponse = {
  __typename?: 'GetAisleRestockItemsResponse';
  aisleId?: Maybe<Scalars['String']>;
  appliedSortBy?: Maybe<AisleItemSortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  items?: Maybe<Array<Maybe<AisleRestockItem>>>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type GetAisleRestockRecommendationSummaryListRequestInput = {
  backstockOnly?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  hideCompleted?: InputMaybe<Scalars['Boolean']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  sortBy?: InputMaybe<AisleSummarySortBy>;
  sortDirection?: InputMaybe<SortDirection>;
  stockStatusFilter?: InputMaybe<Array<InputMaybe<StockStatusFilter>>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GetAisleRestockRecommendationSummaryListResponse = {
  __typename?: 'GetAisleRestockRecommendationSummaryListResponse';
  aisleSummaries?: Maybe<Array<Maybe<AisleRestockRecommendationSummary>>>;
  appliedSortBy?: Maybe<AisleSummarySortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  totalEstimatedLostSales?: Maybe<Scalars['Float']>;
  totalEstimatedLostSalesFormatted?: Maybe<Scalars['String']>;
  totalLowStockItems?: Maybe<Scalars['Int']>;
  totalOosItems?: Maybe<Scalars['Int']>;
  totalRecommendationCount?: Maybe<Scalars['Int']>;
  totalReorderItems?: Maybe<Scalars['Int']>;
  totalRestockItems?: Maybe<Scalars['Int']>;
};

export type GetAisleRestockSummaryListRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<RestockFilterTogglesInput>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  scanWindowHours?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<AisleSummarySortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GetAisleRestockSummaryListResponse = {
  __typename?: 'GetAisleRestockSummaryListResponse';
  aisleSummaries?: Maybe<Array<Maybe<AisleSummary>>>;
  metadata?: Maybe<AisleRestockSummaryMetadata>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetAisleRestockSummaryRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<RestockFilterTogglesInput>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  scanWindowHours?: InputMaybe<Scalars['Int']>;
};

export type GetAisleRestockSummaryResponse = {
  __typename?: 'GetAisleRestockSummaryResponse';
  aisleGroups?: Maybe<Array<Maybe<AisleGroup>>>;
  metadata?: Maybe<AisleRestockSummaryMetadata>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetAnomalousItemsListRequestInput = {
  currentOnly?: InputMaybe<Scalars['Boolean']>;
  filterEndAtDate?: InputMaybe<Scalars['DateTime']>;
  filterStartAtDate?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAnomalousItemsListResponse = {
  __typename?: 'GetAnomalousItemsListResponse';
  dateCounts?: Maybe<Array<Maybe<AnomalousItemDateCount>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type GetAnomalousItemsReportRequestInput = {
  currentOnly?: InputMaybe<Scalars['Boolean']>;
  filterEndAtDate?: InputMaybe<Scalars['DateTime']>;
  filterStartAtDate?: InputMaybe<Scalars['DateTime']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  selectedDates?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
};

export type GetAnomalousItemsReportResponse = {
  __typename?: 'GetAnomalousItemsReportResponse';
  filename?: Maybe<Scalars['String']>;
};

export type GetApiSettingsRequestInput = {
  apiType?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetApiSettingsResponse = {
  __typename?: 'GetApiSettingsResponse';
  apiSettings?: Maybe<Array<Maybe<GetApiSettingsResponseApiSetting>>>;
};

export type GetApiSettingsResponseApiSetting = {
  __typename?: 'GetApiSettingsResponseApiSetting';
  apiType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cron?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  integrationType?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  storeLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetApprovalRequestsRequestInput = {
  attributeGroup?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetApprovalRequestsResponse = {
  __typename?: 'GetApprovalRequestsResponse';
  approvalRequests?: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
};

export type GetAuditBatchMetadataRequestInput = {
  client?: InputMaybe<Scalars['String']>;
};

export type GetAuditBatchMetadataResponse = {
  __typename?: 'GetAuditBatchMetadataResponse';
  secondaryStates?: Maybe<Array<Maybe<GetAuditBatchMetadataResponseSecondaryState>>>;
};

export type GetAuditBatchMetadataResponseSecondaryState = {
  __typename?: 'GetAuditBatchMetadataResponseSecondaryState';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type GetAuditBatchRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  componentValueFilters?: InputMaybe<Array<InputMaybe<ComponentValueFilterInput>>>;
  hasExternalComment?: InputMaybe<Scalars['Boolean']>;
  hasInternalComment?: InputMaybe<Scalars['Boolean']>;
  orderByComponent?: InputMaybe<OrderByComponentInput>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PaginationInput>;
  returnAuditableTasks?: InputMaybe<Scalars['Boolean']>;
  returnSampleTasks?: InputMaybe<Scalars['Boolean']>;
  reviewState?: InputMaybe<Scalars['String']>;
  taskStateId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAuditBatchResponse = {
  __typename?: 'GetAuditBatchResponse';
  auditBatch?: Maybe<AuditBatch>;
};

export type GetAuditTaskRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  taskUuid?: InputMaybe<Scalars['String']>;
};

export type GetAuditTaskResponse = {
  __typename?: 'GetAuditTaskResponse';
  auditTask?: Maybe<AuditTask>;
};

export type GetAuditWorkflowConfigsRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  configType?: InputMaybe<Scalars['String']>;
  workflowL1?: InputMaybe<Scalars['String']>;
  workflowL2?: InputMaybe<Scalars['String']>;
  workflowL3?: InputMaybe<Scalars['String']>;
};

export type GetAuditWorkflowConfigsResponse = {
  __typename?: 'GetAuditWorkflowConfigsResponse';
  configs?: Maybe<Array<Maybe<AuditWorkflowConfig>>>;
};

export type GetAuthenticationUrlRequestInput = {
  errorRedirectUrl?: InputMaybe<Scalars['String']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  successRedirectUrl?: InputMaybe<Scalars['String']>;
};

export type GetAuthenticationUrlResponse = {
  __typename?: 'GetAuthenticationUrlResponse';
  authenticationUrl?: Maybe<Scalars['String']>;
};

export type GetAutocompleteLocationsRequestInput = {
  countryCode?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type GetAutocompleteLocationsResponse = {
  __typename?: 'GetAutocompleteLocationsResponse';
  locations?: Maybe<Array<Maybe<AutocompleteLocation>>>;
};

export type GetAvailabilityScoreOverrideRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAvailabilityScoreOverrideResponse = {
  __typename?: 'GetAvailabilityScoreOverrideResponse';
  entities?: Maybe<Array<Maybe<GetAvailabilityScoreOverrideResponseOverrideEntity>>>;
};

export type GetAvailabilityScoreOverrideResponseOverrideEntity = {
  __typename?: 'GetAvailabilityScoreOverrideResponseOverrideEntity';
  entityId?: Maybe<EntityId>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['BigInt']>;
};

export type GetAvailableOfferFiltersRequestInput = {
  shopId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAvailableOfferFiltersResponse = {
  __typename?: 'GetAvailableOfferFiltersResponse';
  availableFilters?: Maybe<Array<Maybe<AvailableOfferFilter>>>;
};

export type GetAvailableStoreLocationsRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetAvailableStoreLocationsResponse = {
  __typename?: 'GetAvailableStoreLocationsResponse';
  storeLocations?: Maybe<Array<Maybe<ApiIntegrationStoreLocation>>>;
};

export type GetBuildkiteArtifactDownloadUrlRequestInput = {
  artifactId?: InputMaybe<Scalars['String']>;
  buildUrl?: InputMaybe<Scalars['String']>;
  downloadUrl?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
};

export type GetBuildkiteArtifactDownloadUrlResponse = {
  __typename?: 'GetBuildkiteArtifactDownloadUrlResponse';
  presignedUrl?: Maybe<Scalars['String']>;
};

export type GetBuildkiteArtifactsRequestInput = {
  buildUrl?: InputMaybe<Scalars['String']>;
  jobId?: InputMaybe<Scalars['String']>;
};

export type GetBuildkiteArtifactsResponse = {
  __typename?: 'GetBuildkiteArtifactsResponse';
  artifacts?: Maybe<Array<Maybe<BuildkiteArtifactInfo>>>;
};

export type GetCatalogFaqFileRequestInput = {
  fileName?: InputMaybe<Scalars['String']>;
};

export type GetCatalogFaqFileResponse = {
  __typename?: 'GetCatalogFaqFileResponse';
  file?: Maybe<Scalars['String']>;
};

export type GetChronicInsightsRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  lookbackDays?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetChronicInsightsResponse = {
  __typename?: 'GetChronicInsightsResponse';
  lookbackDays?: Maybe<Scalars['Int']>;
  overfacing?: Maybe<ChronicInsightCard>;
  overordering?: Maybe<ChronicInsightCard>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  understock?: Maybe<ChronicInsightCard>;
};

export type GetChronicOverorderingItemDetailRequestInput = {
  lookbackDays?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetChronicOverorderingItemDetailResponse = {
  __typename?: 'GetChronicOverorderingItemDetailResponse';
  aisleId?: Maybe<Scalars['String']>;
  currentFacings?: Maybe<Scalars['Int']>;
  itemThumbnailUrl?: Maybe<Scalars['String']>;
  latestScan?: Maybe<RestockShelfImage>;
  lookbackDays?: Maybe<Scalars['Int']>;
  overorderingContext?: Maybe<OverorderingContext>;
  productId?: Maybe<Scalars['BigInt']>;
  productName?: Maybe<Scalars['String']>;
  receivingContext?: Maybe<ReceivingContext>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  salesContext?: Maybe<SalesContext>;
  unitPriceCents?: Maybe<Scalars['BigInt']>;
  unitPriceFormatted?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type GetChronicOverorderingRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  lookbackDays?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  sortBy?: InputMaybe<ChronicOverorderingSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GetChronicOverorderingResponse = {
  __typename?: 'GetChronicOverorderingResponse';
  appliedSortBy?: Maybe<ChronicOverorderingSortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  lookbackDays?: Maybe<Scalars['Int']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  rows?: Maybe<Array<Maybe<ChronicOverorderingRow>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GetChronicUnderstockItemDetailRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetChronicUnderstockItemDetailResponse = {
  __typename?: 'GetChronicUnderstockItemDetailResponse';
  aisleId?: Maybe<Scalars['String']>;
  currentFacings?: Maybe<Scalars['Int']>;
  itemThumbnailUrl?: Maybe<Scalars['String']>;
  latestScan?: Maybe<RestockShelfImage>;
  productName?: Maybe<Scalars['String']>;
  receivingContext?: Maybe<ReceivingContext>;
  salesContext?: Maybe<SalesContext>;
  unitPriceCents?: Maybe<Scalars['BigInt']>;
  unitPriceFormatted?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type GetChronicUnderstocksRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  lookbackDays?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  sortBy?: InputMaybe<ChronicUnderstockSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GetChronicUnderstocksResponse = {
  __typename?: 'GetChronicUnderstocksResponse';
  appliedSortBy?: Maybe<ChronicUnderstockSortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  lookbackDays?: Maybe<Scalars['Int']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  rows?: Maybe<Array<Maybe<ChronicUnderstockRow>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GetClientConfigurationByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetClientConfigurationByIdResponse = {
  __typename?: 'GetClientConfigurationByIdResponse';
  clientConfiguration?: Maybe<ClientConfiguration>;
};

export type GetCollectionsRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  admin?: InputMaybe<Scalars['Boolean']>;
  collectionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludeDynamicRetailerCollections?: InputMaybe<Scalars['Boolean']>;
  excludedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includeAlcohol?: InputMaybe<Scalars['Boolean']>;
  includeArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  includeAssociatedRetailerCollections?: InputMaybe<Scalars['Boolean']>;
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>;
  parentId?: InputMaybe<Scalars['String']>;
  replaceDepartmentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduled?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  showDepartmentTile?: InputMaybe<Scalars['Boolean']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  useFullNamePath?: InputMaybe<Scalars['Boolean']>;
  useRetailerTypeMapping?: InputMaybe<Scalars['Boolean']>;
};

export type GetCollectionsResponse = {
  __typename?: 'GetCollectionsResponse';
  collections?: Maybe<Array<Maybe<Collection>>>;
};

export type GetConfirmedStoreHoursRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type GetConfirmedStoreHoursResponse = {
  __typename?: 'GetConfirmedStoreHoursResponse';
  confirmations?: Maybe<Array<Maybe<ConfirmedStoreHours>>>;
};

export type GetConnectPlatformEventsByDomainRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  domain?: InputMaybe<Scalars['String']>;
  domainObjectId?: InputMaybe<Scalars['String']>;
  domainObjectType?: InputMaybe<Scalars['String']>;
};

export type GetConnectPlatformEventsByDomainResponse = {
  __typename?: 'GetConnectPlatformEventsByDomainResponse';
  events?: Maybe<Array<Maybe<ConnectPlatformEventWithCallbacks>>>;
};

export type GetConnectRetailerCallbackConfigurationByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetConnectRetailerCallbackConfigurationByIdResponse = {
  __typename?: 'GetConnectRetailerCallbackConfigurationByIdResponse';
  callbackConfiguration?: Maybe<ConnectRetailerCallbackConfiguration>;
};

export type GetConnectRetailerCallbackConfigurationsRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  environment?: InputMaybe<Scalars['String']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetConnectRetailerCallbackConfigurationsResponse = {
  __typename?: 'GetConnectRetailerCallbackConfigurationsResponse';
  callbackConfigurations?: Maybe<Array<Maybe<ConnectRetailerCallbackConfiguration>>>;
};

export type GetConnectSettingsRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
};

export type GetConnectSettingsResponse = {
  __typename?: 'GetConnectSettingsResponse';
  enableEtaServiceOptions?: Maybe<Scalars['Boolean']>;
  postCheckoutAppDomain?: Maybe<Scalars['String']>;
};

export type GetCustomersContextRequestInput = {
  parameters?: InputMaybe<GetCustomersContextRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetCustomersContextRequestParametersInput = {
  partnerId?: InputMaybe<Scalars['Int']>;
};

export type GetCustomersContextResponse = {
  __typename?: 'GetCustomersContextResponse';
  contexts?: Maybe<Array<Maybe<CustomersContext>>>;
};

export type GetDashboardOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetDashboardOrderResponse = {
  __typename?: 'GetDashboardOrderResponse';
  dashboardOrder?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrder>;
};

export type GetDashboardOrdersRequestFilterSetInput = {
  orderIdentifier?: InputMaybe<Scalars['String']>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<GetDashboardOrdersRequestFilterSetOrderStatusCriteria>>>;
  orderType?: InputMaybe<GetDashboardOrdersRequestFilterSetOrderType>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  windowEndsAtRange?: InputMaybe<GetDashboardOrdersRequestFilterSetTimestampRangeInput>;
};

export enum GetDashboardOrdersRequestFilterSetOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  New = 'NEW',
  OrderStatusCriteriaUnspecified = 'ORDER_STATUS_CRITERIA_UNSPECIFIED',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Shopping = 'SHOPPING'
}

export enum GetDashboardOrdersRequestFilterSetOrderType {
  Delivery = 'DELIVERY',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  OrderTypeUnspecified = 'ORDER_TYPE_UNSPECIFIED',
  Pickup = 'PICKUP'
}

export type GetDashboardOrdersRequestFilterSetTimestampRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type GetDashboardOrdersRequestInput = {
  filterSet?: InputMaybe<GetDashboardOrdersRequestFilterSetInput>;
  ordersSortBy?: InputMaybe<GetDashboardOrdersRequestOrdersSortByInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
};

export enum GetDashboardOrdersRequestOrdersSortByDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED'
}

export type GetDashboardOrdersRequestOrdersSortByInput = {
  direction?: InputMaybe<GetDashboardOrdersRequestOrdersSortByDirection>;
  name?: InputMaybe<GetDashboardOrdersRequestOrdersSortByOrdersAttributes>;
};

export enum GetDashboardOrdersRequestOrdersSortByOrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT'
}

export type GetDashboardOrdersResponse = {
  __typename?: 'GetDashboardOrdersResponse';
  dashboardOrderSummary?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummary>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type GetDetectionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetDetectionResponse = {
  __typename?: 'GetDetectionResponse';
  name?: Maybe<Scalars['String']>;
  versions?: Maybe<Array<Maybe<GetDetectionResponseDetectionVersion>>>;
};

export type GetDetectionResponseDetectionVersion = {
  __typename?: 'GetDetectionResponseDetectionVersion';
  attributes?: Maybe<DetectionVersionAttributes>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  states?: Maybe<Array<Maybe<DetectionVersionState>>>;
  stats?: Maybe<Array<Maybe<DetectionVersionStats>>>;
  tombstoned?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type GetFlattenedTaxonomiesParametersInput = {
  filter?: InputMaybe<FlattenedTaxonomyFilterInput>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetFlattenedTaxonomiesRequestInput = {
  parameters?: InputMaybe<GetFlattenedTaxonomiesParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetFlattenedTaxonomiesResponse = {
  __typename?: 'GetFlattenedTaxonomiesResponse';
  taxonomies?: Maybe<Array<Maybe<FlattenedTaxonomy>>>;
};

export type GetFormGroupsRequestInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type GetFormGroupsResponse = {
  __typename?: 'GetFormGroupsResponse';
  androidFormAdditionalGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  androidFormDefaultGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  iosFormAdditionalGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  iosFormDefaultGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerFormAdditionalGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerFormDefaultGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
  saFormGroups?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetFrothTemplateConstraintsRequestInput = {
  frothTemplateId?: InputMaybe<Scalars['BigInt']>;
};

export type GetFrothTemplateConstraintsResponse = {
  __typename?: 'GetFrothTemplateConstraintsResponse';
  constraints?: Maybe<FrothTemplateConstraints>;
};

export type GetFrothTemplateRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetFrothTemplateResponse = {
  __typename?: 'GetFrothTemplateResponse';
  frothTemplate?: Maybe<FrothTemplate>;
};

export type GetFrothTemplateVersionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetFrothTemplateVersionResponse = {
  __typename?: 'GetFrothTemplateVersionResponse';
  body?: Maybe<FrothTemplateVersionBody>;
  info?: Maybe<FrothTemplateVersionInfo>;
};

export type GetHolidaysStatusRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetHolidaysStatusResponse = {
  __typename?: 'GetHolidaysStatusResponse';
  holidays?: Maybe<Array<Maybe<HolidayStatus>>>;
};

export type GetImageUploadBatchDetailsRequestInput = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type GetImageUploadBatchDetailsResponse = {
  __typename?: 'GetImageUploadBatchDetailsResponse';
  imageUploadBatchDetails?: Maybe<Array<Maybe<ImageUploadBatchDetails>>>;
  imageUploadBatchMetadata?: Maybe<ImageUploadBatchMetadata>;
};

export type GetImageUploadBatchesRequestInput = {
  endAt?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  timeRange?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type GetImageUploadBatchesResponse = {
  __typename?: 'GetImageUploadBatchesResponse';
  imageUploadBatch?: Maybe<Array<Maybe<ImageUploadBatch>>>;
  imageUploadBatchMetadata?: Maybe<ImageUploadBatchMetadata>;
};

export type GetIsGrocerRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetIsGrocerResponse = {
  __typename?: 'GetIsGrocerResponse';
  isGrocer?: Maybe<Scalars['Boolean']>;
};

export type GetItemRestockRecommendationRequestInput = {
  algorithm?: InputMaybe<ItemRestockRecommendationReadAlgorithm>;
  recommendationId?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GetItemRestockRecommendationResponse = {
  __typename?: 'GetItemRestockRecommendationResponse';
  debugData?: Maybe<ItemDebugData>;
  latestInstockCapturedAtFormatted?: Maybe<Scalars['String']>;
  latestInstockImage?: Maybe<RestockShelfImage>;
  latestOosCapturedAtFormatted?: Maybe<Scalars['String']>;
  latestOosImage?: Maybe<RestockShelfImage>;
  receivingContext?: Maybe<ReceivingContext>;
  recommendation?: Maybe<ItemRestockRecommendation>;
  salesContext?: Maybe<SalesContext>;
};

export type GetItemRestockRecommendationsRequestInput = {
  aisleId?: InputMaybe<Scalars['String']>;
  algorithm?: InputMaybe<ItemRestockRecommendationReadAlgorithm>;
  backstockOnly?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  effectiveKindFilter?: InputMaybe<Array<InputMaybe<RecommendationKind>>>;
  hideAccepted?: InputMaybe<Scalars['Boolean']>;
  hideCompleted?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  sortBy?: InputMaybe<ItemRestockRecommendationSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
  stockStatusFilter?: InputMaybe<Array<InputMaybe<StockStatusFilter>>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GetItemRestockRecommendationsResponse = {
  __typename?: 'GetItemRestockRecommendationsResponse';
  appliedSortBy?: Maybe<ItemRestockRecommendationSortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  oldestScanTimestamp?: Maybe<Scalars['DateTime']>;
  recommendations?: Maybe<Array<Maybe<ItemRestockRecommendation>>>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type GetItemsRequestInput = {
  parameters?: InputMaybe<GetItemsRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetItemsRequestParametersInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetItemsResponse = {
  __typename?: 'GetItemsResponse';
  results?: Maybe<Array<Maybe<Item>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type GetKpiRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetKpiResponse = {
  __typename?: 'GetKpiResponse';
  departmentOosDistribution?: Maybe<Array<Maybe<DepartmentOosCount>>>;
  kpiCards?: Maybe<KpiCards>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetLaunchOnboardingRequestInput = {
  includeApprovalRequests?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  token?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type GetLaunchOnboardingResponse = {
  __typename?: 'GetLaunchOnboardingResponse';
  launchOnboarding?: Maybe<LaunchOnboarding>;
};

export type GetLaunchOnboardingWarehouseLocationsRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetLaunchOnboardingWarehouseLocationsResponse = {
  __typename?: 'GetLaunchOnboardingWarehouseLocationsResponse';
  pagination?: Maybe<PaginationDetails>;
  warehouseLocations?: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>;
};

export type GetLayoutVariantsRequestInput = {
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Status>;
};

export type GetLayoutVariantsResponse = {
  __typename?: 'GetLayoutVariantsResponse';
  layoutVariants?: Maybe<Array<Maybe<LayoutVariant>>>;
};

export type GetLegacyElasticsearchRequestInput = {
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetLegacyItemsShoppersRequestBoostWhereBoostObjectInput = {
  factor?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['BigInt']>;
};

export type GetLegacyItemsShoppersRequestBoostWhereInput = {
  primaryDepartmentId?: InputMaybe<GetLegacyItemsShoppersRequestBoostWhereBoostObjectInput>;
};

export type GetLegacyItemsShoppersRequestInput = {
  aisleId?: InputMaybe<Scalars['BigInt']>;
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  anyMatchingProductCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  available?: InputMaybe<Scalars['Boolean']>;
  boostWhere?: InputMaybe<GetLegacyItemsShoppersRequestBoostWhereInput>;
  departmentId?: InputMaybe<Scalars['BigInt']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  hasImage?: InputMaybe<Scalars['Boolean']>;
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>;
  productCodes?: InputMaybe<Scalars['String']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerReferenceCode?: InputMaybe<Scalars['String']>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
  tsqueryQuery?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type GetLegacyProductsRequestInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  availableInventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  query?: InputMaybe<Scalars['String']>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  source?: InputMaybe<Scalars['String']>;
};

export type GetLiveInsightsRequestInput = {
  limit?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GetLiveInsightsResponse = {
  __typename?: 'GetLiveInsightsResponse';
  cards?: Maybe<Array<Maybe<LiveInsightCard>>>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetLocalesByRetailerRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetLocalesByRetailerResponse = {
  __typename?: 'GetLocalesByRetailerResponse';
  retailerLocales?: Maybe<Array<Maybe<RetailerLocale>>>;
};

export type GetManagedAttributeRequestInput = {
  managedAttributeId?: InputMaybe<Scalars['BigInt']>;
};

export type GetManagedAttributeResponse = {
  __typename?: 'GetManagedAttributeResponse';
  detail?: Maybe<ManagedAttributeDetail>;
};

export type GetManagedAttributeValuesForRetailerRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetManagedAttributeValuesForRetailerResponse = {
  __typename?: 'GetManagedAttributeValuesForRetailerResponse';
  managedAttributeValues?: Maybe<Array<Maybe<ManagedAttributeValue>>>;
};

export type GetMassOpsIntegrationStatusRequestInput = {
  investigationId?: InputMaybe<Scalars['String']>;
};

export type GetMassOpsIntegrationStatusResponse = {
  __typename?: 'GetMassOpsIntegrationStatusResponse';
  integrations?: Maybe<Array<Maybe<MassOpsIntegration>>>;
  status?: Maybe<MassOpsIntegrationState>;
  totalOrders?: Maybe<Scalars['BigInt']>;
};

export type GetMomentParticipatingRetailersRequestInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetMomentParticipatingRetailersResponse = {
  __typename?: 'GetMomentParticipatingRetailersResponse';
  participatingRetailerCampaigns?: Maybe<RetailerCampaign>;
  retailerMomentCampaigns?: Maybe<Array<Maybe<RetailerMomentCampaign>>>;
};

export type GetMomentRequestInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type GetMomentResponse = {
  __typename?: 'GetMomentResponse';
  moment?: Maybe<Moment>;
};

export type GetMomentsRequestInput = {
  momentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetMomentsResponse = {
  __typename?: 'GetMomentsResponse';
  moments?: Maybe<Array<Maybe<Moment>>>;
};

export type GetNativeTabBarNavigationRequestInput = {
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetNativeTabBarNavigationResponse = {
  __typename?: 'GetNativeTabBarNavigationResponse';
  navigation?: Maybe<NativeTabBarNavigation>;
};

export type GetNavigationRequestInput = {
  layout?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetNavigationResponse = {
  __typename?: 'GetNavigationResponse';
  navigation?: Maybe<Navigation>;
};

export type GetNextAuditBatchRequestInput = {
  userUuid?: InputMaybe<Scalars['String']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type GetNextAuditBatchResponse = {
  __typename?: 'GetNextAuditBatchResponse';
  batchUuid?: Maybe<Scalars['String']>;
};

export type GetOnboardingAttributesRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  attributeSubgroupName?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDetailsInput>;
  released?: InputMaybe<Scalars['Boolean']>;
  required?: InputMaybe<Scalars['Boolean']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  statuses?: InputMaybe<Array<InputMaybe<OnboardingAttributeStatus>>>;
  visibilityTiers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetOnboardingAttributesResponse = {
  __typename?: 'GetOnboardingAttributesResponse';
  onboardingAttributes?: Maybe<Array<Maybe<OnboardingAttribute>>>;
  pagination?: Maybe<PaginationDetails>;
};

export type GetOnboardingRequestInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type GetOnboardingResponse = {
  __typename?: 'GetOnboardingResponse';
  onboarding?: Maybe<Onboarding>;
};

export type GetOrderDiscountDetailsRequestInput = {
  orderId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderDiscountDetailsResponse = {
  __typename?: 'GetOrderDiscountDetailsResponse';
  discountDiscountables?: Maybe<Array<Maybe<DiscountDiscountablesData>>>;
};

export type GetOrderFulfillmentOverviewRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderFulfillmentOverviewResponse = {
  __typename?: 'GetOrderFulfillmentOverviewResponse';
  activeShopper?: Maybe<Scalars['Int']>;
  isFullService?: Maybe<Scalars['Boolean']>;
  shoppers?: Maybe<Array<Maybe<ShopperOrderProfile>>>;
  warehouseLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetOrderLocationRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderLocationResponse = {
  __typename?: 'GetOrderLocationResponse';
  shopperCoordinates?: Maybe<GoogleTypeLatLng>;
};

export type GetOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOrderResponse = {
  __typename?: 'GetOrderResponse';
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
  orderItems?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItem>>>;
};

export type GetOrderStateChangesRequestInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
};

export type GetOrderStateChangesResponse = {
  __typename?: 'GetOrderStateChangesResponse';
  currentState?: Maybe<GetOrderStateChangesResponseState>;
  stateChanges?: Maybe<Array<Maybe<GetOrderStateChangesResponseState>>>;
};

export type GetOrderStateChangesResponseState = {
  __typename?: 'GetOrderStateChangesResponseState';
  actor?: Maybe<GetOrderStateChangesResponseStateActor>;
  issues?: Maybe<Array<Maybe<GetOrderStateChangesResponseStateIssue>>>;
  stateDisplayName?: Maybe<Scalars['String']>;
  stateType?: Maybe<GetOrderStateChangesResponseStateStateType>;
  transitionedAt?: Maybe<Scalars['DateTime']>;
  transitionedEta?: Maybe<Scalars['DateTime']>;
};

export type GetOrderStateChangesResponseStateActor = {
  __typename?: 'GetOrderStateChangesResponseStateActor';
  id?: Maybe<Scalars['BigInt']>;
  type?: Maybe<Scalars['String']>;
};

export type GetOrderStateChangesResponseStateIssue = {
  __typename?: 'GetOrderStateChangesResponseStateIssue';
  issueDescription?: Maybe<Scalars['String']>;
  issueType?: Maybe<GetOrderStateChangesResponseStateIssueIssueType>;
};

export enum GetOrderStateChangesResponseStateIssueIssueType {
  IssueTypeCanceled = 'ISSUE_TYPE_CANCELED',
  IssueTypeDelayed = 'ISSUE_TYPE_DELAYED',
  IssueTypeFailedDelivery = 'ISSUE_TYPE_FAILED_DELIVERY',
  IssueTypePartiallyDelivery = 'ISSUE_TYPE_PARTIALLY_DELIVERY',
  IssueTypeUnknown = 'ISSUE_TYPE_UNKNOWN'
}

export enum GetOrderStateChangesResponseStateStateType {
  StateTypeArrived = 'STATE_TYPE_ARRIVED',
  StateTypeAssigned = 'STATE_TYPE_ASSIGNED',
  StateTypeAtStore = 'STATE_TYPE_AT_STORE',
  StateTypeAwaitingReturn = 'STATE_TYPE_AWAITING_RETURN',
  StateTypeBagsPickedUp = 'STATE_TYPE_BAGS_PICKED_UP',
  StateTypeCheckingOut = 'STATE_TYPE_CHECKING_OUT',
  StateTypeDelivered = 'STATE_TYPE_DELIVERED',
  StateTypeInTransit = 'STATE_TYPE_IN_TRANSIT',
  StateTypeOrderPlaced = 'STATE_TYPE_ORDER_PLACED',
  StateTypePicking = 'STATE_TYPE_PICKING',
  StateTypeReadyForPickup = 'STATE_TYPE_READY_FOR_PICKUP',
  StateTypeReturnCompleted = 'STATE_TYPE_RETURN_COMPLETED',
  StateTypeReturnInProgress = 'STATE_TYPE_RETURN_IN_PROGRESS',
  StateTypeRunningOrder = 'STATE_TYPE_RUNNING_ORDER',
  StateTypeStaging = 'STATE_TYPE_STAGING',
  StateTypeUnknown = 'STATE_TYPE_UNKNOWN'
}

export type GetOverfacingItemDetailRequestInput = {
  lookbackDays?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetOverfacingItemDetailResponse = {
  __typename?: 'GetOverfacingItemDetailResponse';
  aisleId?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['BigInt']>;
  currentFacings?: Maybe<Scalars['Int']>;
  itemThumbnailUrl?: Maybe<Scalars['String']>;
  latestScan?: Maybe<RestockShelfImage>;
  lookbackDays?: Maybe<Scalars['Int']>;
  overfacingContext?: Maybe<OverfacingContext>;
  productId?: Maybe<Scalars['BigInt']>;
  productName?: Maybe<Scalars['String']>;
  receivingContext?: Maybe<ReceivingContext>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  salesContext?: Maybe<SalesContext>;
  unitPriceCents?: Maybe<Scalars['BigInt']>;
  unitPriceFormatted?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type GetOverfacingItemsRequestInput = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  lookbackDays?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  sortBy?: InputMaybe<OverfacingSortBy>;
  sortDirection?: InputMaybe<SortDirection>;
};

export type GetOverfacingItemsResponse = {
  __typename?: 'GetOverfacingItemsResponse';
  appliedSortBy?: Maybe<OverfacingSortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  lookbackDays?: Maybe<Scalars['Int']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  rows?: Maybe<Array<Maybe<OverfacingRow>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GetParkingSettingsRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<PickupType>;
};

export type GetParkingSettingsResponse = {
  __typename?: 'GetParkingSettingsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  imageConfigs?: Maybe<Array<Maybe<ImageConfig>>>;
  instruction?: Maybe<Scalars['String']>;
  retailerLocationConfig?: Maybe<RetailerLocationInfo>;
};

export type GetPartnerApiKeysRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPartnerApiKeysResponse = {
  __typename?: 'GetPartnerApiKeysResponse';
  connectApiKeys?: Maybe<Array<Maybe<ConnectApiKey>>>;
};

export type GetPartnerIdRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPartnerIdResponse = {
  __typename?: 'GetPartnerIdResponse';
  partnerId?: Maybe<Scalars['BigInt']>;
};

export type GetPartnerOauthApplicationsRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPartnerOauthApplicationsResponse = {
  __typename?: 'GetPartnerOauthApplicationsResponse';
  oauthApplications?: Maybe<Array<Maybe<OauthApplication>>>;
};

export type GetPickupSettingsMetadataRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetPickupSettingsMetadataResponse = {
  __typename?: 'GetPickupSettingsMetadataResponse';
  binPickingConfig?: Maybe<BinPickingConfig>;
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  isCurbsidePickupEnabled?: Maybe<Scalars['Boolean']>;
  isReadyForPickup?: Maybe<Scalars['Boolean']>;
  isScanToStageEnabled?: Maybe<Scalars['Boolean']>;
  isSettingsOnboardingComplete?: Maybe<Scalars['Boolean']>;
  pickupEnableDate?: Maybe<GoogleTypeDate>;
};

export type GetPiiRequestsForRetailerRequestInput = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  requestCreatedAfter?: InputMaybe<Scalars['DateTime']>;
  requestCreatedBefore?: InputMaybe<Scalars['DateTime']>;
  requestTypes?: InputMaybe<Array<InputMaybe<RequestType>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  workflowStatus?: InputMaybe<Array<InputMaybe<WorkflowStatus>>>;
};

export type GetPiiRequestsForRetailerResponse = {
  __typename?: 'GetPiiRequestsForRetailerResponse';
  piiRequests?: Maybe<Array<Maybe<PiiRequest>>>;
};

export type GetPlaceDetailsRequestInput = {
  placeId?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type GetPlaceDetailsResponse = {
  __typename?: 'GetPlaceDetailsResponse';
  location?: Maybe<AutocompleteLocation>;
};

export type GetPlacementContentByIdRequestInput = {
  generateVisibilityConditions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetPlacementContentByIdResponse = {
  __typename?: 'GetPlacementContentByIdResponse';
  content?: Maybe<PlacementContent>;
};

export type GetPlacementsRequestInput = {
  collectionSlug?: InputMaybe<Scalars['String']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  enabledOnly?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<Layout>;
  layoutVariantId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  placementIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Direction>;
  status?: InputMaybe<Array<InputMaybe<Status>>>;
  stringLayout?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  variant?: InputMaybe<Array<InputMaybe<BannerVariant>>>;
};

export type GetPlatformVersionsRequestInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type GetPlatformVersionsResponse = {
  __typename?: 'GetPlatformVersionsResponse';
  nextPlatformVersion?: Maybe<Scalars['String']>;
  nextPlatformVersionRouletteName?: Maybe<Scalars['String']>;
  platformVersion?: Maybe<Scalars['String']>;
  platformVersionRouletteName?: Maybe<Scalars['String']>;
};

export type GetPriceInvestigationRequestInput = {
  investigationId?: InputMaybe<Scalars['String']>;
};

export type GetPriceInvestigationResponse = {
  __typename?: 'GetPriceInvestigationResponse';
  investigation?: Maybe<Investigation>;
};

export type GetProductCreationDataRequestInput = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type GetProductCreationDataResponse = {
  __typename?: 'GetProductCreationDataResponse';
  aiResult?: Maybe<Scalars['JSONObject']>;
  imageS3Urls?: Maybe<Array<Maybe<ProductCreationImage>>>;
  retailerLocaleEntries?: Maybe<Array<Maybe<GetProductCreationDataRow>>>;
  status?: Maybe<ProductCreationStatus>;
  storefrontImageS3Urls?: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type GetProductCreationDataRow = {
  __typename?: 'GetProductCreationDataRow';
  aiResultData?: Maybe<Scalars['JSONObject']>;
  imageS3Urls?: Maybe<Array<Maybe<ProductCreationImage>>>;
  locale?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<ProductCreationStatus>;
  storefrontImageS3Urls?: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid?: Maybe<Scalars['String']>;
};

export type GetProductDataRequestInput = {
  productId?: InputMaybe<ProductIdInput>;
};

export type GetProductDataResponse = {
  __typename?: 'GetProductDataResponse';
  productData?: Maybe<Array<Maybe<ProductData>>>;
  productId?: Maybe<ProductId>;
};

export type GetProductSourcesRequestInput = {
  sourceLevel?: InputMaybe<SourceLevel>;
};

export type GetProductSourcesResponse = {
  __typename?: 'GetProductSourcesResponse';
  sourceCount?: Maybe<Scalars['BigInt']>;
  sources?: Maybe<Array<Maybe<ProductSource>>>;
};

export type GetRequestContextsRequestInput = {
  partnerId?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['Int']>;
};

export type GetRequestContextsResponse = {
  __typename?: 'GetRequestContextsResponse';
  requestContexts?: Maybe<Array<Maybe<InstacartCustomersSharedV1RequestContext>>>;
};

export type GetRestockRankingListRequestInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<RestockSortBy>;
  sortDir?: InputMaybe<SortDirection>;
};

export type GetRestockRankingListResponse = {
  __typename?: 'GetRestockRankingListResponse';
  items?: Maybe<Array<Maybe<RestockItem>>>;
  metadata?: Maybe<RestockMetadata>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetRetailerAisleTemplateRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shopperType?: InputMaybe<ShopperType>;
};

export type GetRetailerAisleTemplateResponse = {
  __typename?: 'GetRetailerAisleTemplateResponse';
  activeAt?: Maybe<Scalars['DateTime']>;
  aisleOrders?: Maybe<Array<Maybe<AisleOrder>>>;
  aisleTemplateId?: Maybe<Scalars['BigInt']>;
  layoutId?: Maybe<Scalars['String']>;
};

export type GetRetailerCampaignRequestInput = {
  ippContext?: InputMaybe<IppContextInput>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerDepartmentsRequestInput = {
  lookbackDays?: InputMaybe<Scalars['Int']>;
  mainDepartmentsOnly?: InputMaybe<Scalars['Boolean']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  viewType?: InputMaybe<InventoryIntelligenceViewType>;
};

export type GetRetailerDepartmentsResponse = {
  __typename?: 'GetRetailerDepartmentsResponse';
  departments?: Maybe<Array<Maybe<RetailerDepartment>>>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type GetRetailerLocationByLayoutRequestInput = {
  layoutId?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerLocationByLayoutResponse = {
  __typename?: 'GetRetailerLocationByLayoutResponse';
  retailerLocationAisles?: Maybe<Array<Maybe<RetailerLocationAisle>>>;
};

export type GetRetailerLocationsByLocationCodesRequestInput = {
  locationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
  skipStatusCheck?: InputMaybe<Scalars['Boolean']>;
};

export type GetRetailerLocationsByLocationCodesResponse = {
  __typename?: 'GetRetailerLocationsByLocationCodesResponse';
  retailerLocations?: Maybe<Array<Maybe<RetailerLocationDetails>>>;
};

export type GetRetailerLocationsDetailsRequestInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetRetailerLocationsDetailsResponse = {
  __typename?: 'GetRetailerLocationsDetailsResponse';
  retailerLocations?: Maybe<Array<Maybe<RetailerLocationDetails>>>;
};

export type GetRetailerProductAssortmentRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  filter?: InputMaybe<RetailerProductAssortmentFilterInput>;
};

export type GetRetailerProductAssortmentResponse = {
  __typename?: 'GetRetailerProductAssortmentResponse';
  retailerProductAssortment?: Maybe<Array<Maybe<RetailerProductAssortment>>>;
};

export type GetRetailerProductAttributeSourcesRequestInput = {
  attribute?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  localeId?: InputMaybe<Scalars['BigInt']>;
  maxRetailerFileSourcesPerAttribute?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductAttributeSourcesResponse = {
  __typename?: 'GetRetailerProductAttributeSourcesResponse';
  attribute?: Maybe<Scalars['String']>;
  retailerValues?: Maybe<Array<Maybe<RetailerProvidedValue>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type GetRetailerProductDataRequestInput = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductDataResponse = {
  __typename?: 'GetRetailerProductDataResponse';
  retailerProductData?: Maybe<Array<Maybe<RetailerProductData>>>;
};

export type GetRetailerProductsRequestInput = {
  parameters?: InputMaybe<GetRetailerProductsRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductsRequestParametersDateTimeRangeInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type GetRetailerProductsRequestParametersInput = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  collectionId?: InputMaybe<Scalars['BigInt']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  hasPrimaryImageUrl?: InputMaybe<Scalars['Boolean']>;
  includeManagedAttributeValues?: InputMaybe<Scalars['Boolean']>;
  isStoreBrandProduct?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<InstacartCustomersSharedV1Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  omniSearchTerm?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<InstacartCustomersSharedV1OrderInput>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCreationDateRange?: InputMaybe<GetRetailerProductsRequestParametersDateTimeRangeInput>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerProductIds?: InputMaybe<Array<InputMaybe<GetRetailerProductsRequestParametersRetailerProductIdInput>>>;
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  surfaceIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  withUnclassifiedProducts?: InputMaybe<Scalars['Boolean']>;
};

export type GetRetailerProductsRequestParametersRetailerProductIdInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerProductsResponse = {
  __typename?: 'GetRetailerProductsResponse';
  results?: Maybe<Array<Maybe<RetailerProduct>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type GetRetailerRegionsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  skipCache?: InputMaybe<Scalars['Boolean']>;
};

export type GetRetailerRegionsResponse = {
  __typename?: 'GetRetailerRegionsResponse';
  regions?: Maybe<Array<Maybe<Region>>>;
};

export type GetRetailerSurfacesRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRetailerSurfacesResponse = {
  __typename?: 'GetRetailerSurfacesResponse';
  surfaceIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type GetRetailersForShortcutsRequestInput = {
  isShortcutsBarOverridden?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  retailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type GetRetailersForShortcutsResponse = {
  __typename?: 'GetRetailersForShortcutsResponse';
  retailers?: Maybe<Array<Maybe<RetailerForShortcut>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type GetRppConfigurableItemsRequestInput = {
  inventoryAreaId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetRppConfigurableItemsResponse = {
  __typename?: 'GetRppConfigurableItemsResponse';
  configurableProducts?: Maybe<Scalars['String']>;
};

export type GetSentinelMemberRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetSentinelMemberResponse = {
  __typename?: 'GetSentinelMemberResponse';
  member?: Maybe<SentinelMember>;
};

export type GetServiceOptionsFiltersInput = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  cartTotal?: InputMaybe<Scalars['Float']>;
  earliestOptionStartAt?: InputMaybe<Scalars['DateTime']>;
  itemsCount?: InputMaybe<Scalars['Int']>;
  postalCode?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<Scalars['String']>;
  unitsCount?: InputMaybe<Scalars['Float']>;
  warehouseId?: InputMaybe<Scalars['Int']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
  withEtaOptions?: InputMaybe<Scalars['Boolean']>;
  withPriorityEtaOptions?: InputMaybe<Scalars['Boolean']>;
};

export type GetServiceOptionsRequestInput = {
  filters?: InputMaybe<GetServiceOptionsFiltersInput>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type GetServiceOptionsResponse = {
  __typename?: 'GetServiceOptionsResponse';
  serviceOptions?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOption>>>;
};

export type GetSettingRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  settingName?: InputMaybe<Scalars['String']>;
};

export type GetSettingResponse = {
  __typename?: 'GetSettingResponse';
  settingRecord?: Maybe<RetailerSettingRecord>;
};

export type GetShelfViewRequestInput = {
  maxImages?: InputMaybe<Scalars['Int']>;
  numScans?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  scanOffset?: InputMaybe<Scalars['Int']>;
};

export type GetShelfViewResponse = {
  __typename?: 'GetShelfViewResponse';
  category?: Maybe<Scalars['String']>;
  currentFacings?: Maybe<Scalars['Int']>;
  department?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<ShelfLocation>>>;
  name?: Maybe<Scalars['String']>;
  onShelfCountHistory?: Maybe<Array<Maybe<OnShelfCountEntry>>>;
  productId?: Maybe<Scalars['BigInt']>;
  productImageUrl?: Maybe<Scalars['String']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  scanSnapshots?: Maybe<Array<Maybe<ScanSnapshot>>>;
  scanTimestamp?: Maybe<Scalars['DateTime']>;
  totalScansAvailable?: Maybe<Scalars['Int']>;
  upc?: Maybe<Scalars['String']>;
};

export type GetSignupPartnerRequestInput = {
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type GetSignupPartnerResponse = {
  __typename?: 'GetSignupPartnerResponse';
  signupPartner?: Maybe<SignupPartner>;
};

export type GetSlotByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type GetSlotByIdResponse = {
  __typename?: 'GetSlotByIdResponse';
  slot?: Maybe<Slot>;
};

export type GetSlotsByContentPagesRequestInput = {
  contentPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetSlotsByContentPagesResponse = {
  __typename?: 'GetSlotsByContentPagesResponse';
  contentPageSlots?: Maybe<Array<Maybe<ContentPageSlots>>>;
};

export type GetSlotsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetSlotsResponse = {
  __typename?: 'GetSlotsResponse';
  slots?: Maybe<Array<Maybe<Slot>>>;
};

export type GetSocialIconsNavigationRequestInput = {
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetSocialIconsNavigationResponse = {
  __typename?: 'GetSocialIconsNavigationResponse';
  socialIcons?: Maybe<SocialIconNav>;
};

export type GetStagingSettingsRequestInput = {
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetStagingSettingsResponse = {
  __typename?: 'GetStagingSettingsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  freezer?: Maybe<Array<Maybe<Scalars['String']>>>;
  fridge?: Maybe<Array<Maybe<Scalars['String']>>>;
  hotArea?: Maybe<Array<Maybe<Scalars['String']>>>;
  imageUrl?: Maybe<Scalars['String']>;
  instruction?: Maybe<Scalars['String']>;
  retailerLocationConfig?: Maybe<RetailerLocationInfo>;
  shelf?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GetStoreConfigurationDraftsRequestInput = {
  includeOutdatedDrafts?: InputMaybe<Scalars['Boolean']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetStoreConfigurationDraftsResponse = {
  __typename?: 'GetStoreConfigurationDraftsResponse';
  drafts?: Maybe<Array<Maybe<StoreConfigurationDraft>>>;
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type GetStoreHoursByDateRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  verticalType?: InputMaybe<VerticalType>;
};

export type GetStoreHoursByDateResponse = {
  __typename?: 'GetStoreHoursByDateResponse';
  storeHours?: Maybe<Array<Maybe<StoreHoursByDate>>>;
};

export type GetStoreHoursByDayOfWeekRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<GoogleTypeDayOfWeek>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  verticalType?: InputMaybe<VerticalType>;
};

export type GetStoreHoursByDayOfWeekResponse = {
  __typename?: 'GetStoreHoursByDayOfWeekResponse';
  storeHours?: Maybe<Array<Maybe<StoreHoursByDayOfWeek>>>;
};

export type GetStoreHoursByZoneRetailerRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  endDate?: InputMaybe<GoogleTypeDateInput>;
  includeClosedRetailer?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  verticalType?: InputMaybe<VerticalType>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type GetStoreHoursByZoneRetailerResponse = {
  __typename?: 'GetStoreHoursByZoneRetailerResponse';
  storeHours?: Maybe<Array<Maybe<StoreHoursByZoneRetailer>>>;
};

export type GetStoreHoursRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceTypes?: InputMaybe<Array<InputMaybe<RetailerServiceType>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type GetStoreHoursResponse = {
  __typename?: 'GetStoreHoursResponse';
  storeHours?: Maybe<Array<Maybe<StoreHours>>>;
};

export type GetStoreHoursUpdateTasksRequestInput = {
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type GetStoreHoursUpdateTasksResponse = {
  __typename?: 'GetStoreHoursUpdateTasksResponse';
  tasks?: Maybe<Array<Maybe<StoreHoursUpdateTask>>>;
};

export type GetTestCasesRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetTestCasesResponse = {
  __typename?: 'GetTestCasesResponse';
  automatedTestCases?: Maybe<Array<Maybe<TestCase>>>;
  manualTestCases?: Maybe<Array<Maybe<TestCase>>>;
};

export type GetThemePageRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type GetThemePageResponse = {
  __typename?: 'GetThemePageResponse';
  themePage?: Maybe<ThemePage>;
};

export type GetTicketRequestInput = {
  client?: InputMaybe<ClientInput>;
  cptTicketId?: InputMaybe<Scalars['BigInt']>;
};

export type GetTicketResponse = {
  __typename?: 'GetTicketResponse';
  comments?: Maybe<Array<Maybe<ProblemTrackerTicketComment>>>;
  entities?: Maybe<Array<Maybe<ProblemTrackerEntityStatus>>>;
  ticket?: Maybe<ProblemTrackerTicket>;
  watchers?: Maybe<Array<Maybe<User>>>;
};

export type GetToolingShortcutsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerType?: InputMaybe<Scalars['String']>;
};

export type GetToolingShortcutsResponse = {
  __typename?: 'GetToolingShortcutsResponse';
  shortcuts?: Maybe<Array<Maybe<ToolingShortcut>>>;
};

export type GetToteLabelsFileRequestInput = {
  numLabels?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type GetToteLabelsFileResponse = {
  __typename?: 'GetToteLabelsFileResponse';
  pdfUrl?: Maybe<Scalars['String']>;
};

export type GetUserByIdFilteredByIsolationContextParametersInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type GetUserByIdFilteredByIsolationContextRequestInput = {
  parameters?: InputMaybe<GetUserByIdFilteredByIsolationContextParametersInput>;
};

export type GetUsersByStoreConfigurationIdRequestInput = {
  email?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type GetUsersByStoreConfigurationIdResponse = {
  __typename?: 'GetUsersByStoreConfigurationIdResponse';
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type GetValueBasedOverridesRequestInput = {
  entityId?: InputMaybe<EntityIdInput>;
};

export type GetValueBasedOverridesResponse = {
  __typename?: 'GetValueBasedOverridesResponse';
  entityId?: Maybe<EntityId>;
  valueBasedOverride?: Maybe<Array<Maybe<ValueBasedOverrideResponse>>>;
};

export type GetVirtualRetailersRequestInput = {
  parameters?: InputMaybe<GetVirtualRetailersRequestParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type GetVirtualRetailersRequestParametersInput = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type GetVirtualRetailersResponse = {
  __typename?: 'GetVirtualRetailersResponse';
  virtualRetailers?: Maybe<Array<Maybe<VirtualRetailer>>>;
};

export type GetWaterfallEffectRequestInput = {
  externalReference?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  targetType?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWaterfallEffectResponse = {
  __typename?: 'GetWaterfallEffectResponse';
  waterfallEffect?: Maybe<WaterfallEffect>;
};

export type GetWaterfallEffectsRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  parentWaterfallEffectId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  targetService?: InputMaybe<Scalars['String']>;
  targetType?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWaterfallEffectsResponse = {
  __typename?: 'GetWaterfallEffectsResponse';
  pagination?: Maybe<PaginationDetails>;
  waterfallEffects?: Maybe<Array<Maybe<WaterfallEffect>>>;
};

export type GetWhitelabelGumloopWorkflowResultsRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  waterfallEffectId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowRunId?: InputMaybe<Scalars['String']>;
};

export type GetWhitelabelGumloopWorkflowResultsResponse = {
  __typename?: 'GetWhitelabelGumloopWorkflowResultsResponse';
  childWaterfallEffectId?: Maybe<Scalars['BigInt']>;
  dataPropagationStatus?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  waterfallEffectId?: Maybe<Scalars['BigInt']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
  workflowRunId?: Maybe<Scalars['String']>;
};

export type GetWhitelabelSiteTestRunBuildRequestInput = {
  buildUrl?: InputMaybe<Scalars['String']>;
  includeFailureDetails?: InputMaybe<Scalars['Boolean']>;
  testRunId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWhitelabelSiteTestRunBuildResponse = {
  __typename?: 'GetWhitelabelSiteTestRunBuildResponse';
  branch?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  envVariables?: Maybe<Scalars['JSONObject']>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  jobs?: Maybe<Array<Maybe<BuildJobDetail>>>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  webUrl?: Maybe<Scalars['String']>;
};

export type GetWhitelabelSiteTestRunsRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type GetWhitelabelSiteTestRunsResponse = {
  __typename?: 'GetWhitelabelSiteTestRunsResponse';
  testRuns?: Maybe<Array<Maybe<WhitelabelSiteTestRun>>>;
};

export type GetWhitelabelSitesAdminRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDetailsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type GetWhitelabelSitesAdminResponse = {
  __typename?: 'GetWhitelabelSitesAdminResponse';
  pagination?: Maybe<PaginationDetails>;
  whitelabelSites?: Maybe<Array<Maybe<WhitelabelSite>>>;
};

export type GetWhitelabelSitesRequestInput = {
  pagination?: InputMaybe<PaginationDetailsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  sorting?: InputMaybe<SortingDetailsInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type GetWhitelabelSitesResponse = {
  __typename?: 'GetWhitelabelSitesResponse';
  pagination?: Maybe<PaginationDetails>;
  whitelabelSites?: Maybe<Array<Maybe<WhitelabelSite>>>;
};

export type GoogleTypeDate = {
  __typename?: 'GoogleTypeDate';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type GoogleTypeDateInput = {
  day?: InputMaybe<Scalars['Int']>;
  month?: InputMaybe<Scalars['Int']>;
  year?: InputMaybe<Scalars['Int']>;
};

/** Represents a day of week. */
export enum GoogleTypeDayOfWeek {
  /** The unspecified day-of-week. */
  DayOfWeekUnspecified = 'DAY_OF_WEEK_UNSPECIFIED',
  /** The day-of-week of Friday. */
  Friday = 'FRIDAY',
  /** The day-of-week of Monday. */
  Monday = 'MONDAY',
  /** The day-of-week of Saturday. */
  Saturday = 'SATURDAY',
  /** The day-of-week of Sunday. */
  Sunday = 'SUNDAY',
  /** The day-of-week of Thursday. */
  Thursday = 'THURSDAY',
  /** The day-of-week of Tuesday. */
  Tuesday = 'TUESDAY',
  /** The day-of-week of Wednesday. */
  Wednesday = 'WEDNESDAY'
}

export type GoogleTypeLatLng = {
  __typename?: 'GoogleTypeLatLng';
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

/** Represents an amount of money with its currency type. */
export type GoogleTypeMoney = {
  __typename?: 'GoogleTypeMoney';
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode?: Maybe<Scalars['String']>;
  /**
   * Number of nano (10^-9) units of the amount.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos?: Maybe<Scalars['Int']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units?: Maybe<Scalars['BigInt']>;
};

/** Represents an amount of money with its currency type. */
export type GoogleTypeMoneyInput = {
  /** The 3-letter currency code defined in ISO 4217. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /**
   * Number of nano (10^-9) units of the amount.
   * The value must be between -999,999,999 and +999,999,999 inclusive.
   * If `units` is positive, `nanos` must be positive or zero.
   * If `units` is zero, `nanos` can be positive, zero, or negative.
   * If `units` is negative, `nanos` must be negative or zero.
   * For example $-1.75 is represented as `units`=-1 and `nanos`=-750,000,000.
   */
  nanos?: InputMaybe<Scalars['Int']>;
  /**
   * The whole units of the amount.
   * For example if `currencyCode` is `"USD"`, then 1 unit is one US dollar.
   */
  units?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Represents a time of day. The date and time zone are either not significant
 * or are specified elsewhere. An API may choose to allow leap seconds. Related
 * types are [google.type.Date][google.type.Date] and `google.protobuf.Timestamp`.
 */
export type GoogleTypeTimeOfDay = {
  __typename?: 'GoogleTypeTimeOfDay';
  /**
   * Hours of day in 24 hour format. Should be from 0 to 23. An API may choose
   * to allow the value "24:00:00" for scenarios like business closing time.
   */
  hours?: Maybe<Scalars['Int']>;
  /** Minutes of hour of day. Must be from 0 to 59. */
  minutes?: Maybe<Scalars['Int']>;
  /** Fractions of seconds in nanoseconds. Must be from 0 to 999,999,999. */
  nanos?: Maybe<Scalars['Int']>;
  /**
   * Seconds of minutes of the time. Must normally be from 0 to 59. An API may
   * allow the value 60 if it allows leap-seconds.
   */
  seconds?: Maybe<Scalars['Int']>;
};

/**
 * Represents a time of day. The date and time zone are either not significant
 * or are specified elsewhere. An API may choose to allow leap seconds. Related
 * types are [google.type.Date][google.type.Date] and `google.protobuf.Timestamp`.
 */
export type GoogleTypeTimeOfDayInput = {
  /**
   * Hours of day in 24 hour format. Should be from 0 to 23. An API may choose
   * to allow the value "24:00:00" for scenarios like business closing time.
   */
  hours?: InputMaybe<Scalars['Int']>;
  /** Minutes of hour of day. Must be from 0 to 59. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** Fractions of seconds in nanoseconds. Must be from 0 to 999,999,999. */
  nanos?: InputMaybe<Scalars['Int']>;
  /**
   * Seconds of minutes of the time. Must normally be from 0 to 59. An API may
   * allow the value 60 if it allows leap-seconds.
   */
  seconds?: InputMaybe<Scalars['Int']>;
};

export type GrantImpersonationRequestInput = {
  clientContext?: InputMaybe<ClientContextInput>;
  impersonatedUserId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type GrantImpersonationResponse = {
  __typename?: 'GrantImpersonationResponse';
  authorizationCode?: Maybe<Scalars['String']>;
};

export type GridNavigation = {
  __typename?: 'GridNavigation';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type GridNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Header = {
  __typename?: 'Header';
  desktopHeader?: Maybe<UnionType>;
  mobileHeader?: Maybe<UnionType>;
};

export type HealthCheck = {
  __typename?: 'HealthCheck';
  /** Server health status */
  alive: Scalars['True'];
  /** Postgresql health status */
  postgresql?: Maybe<Scalars['Boolean']>;
  /** Redis health status */
  redis?: Maybe<Scalars['Boolean']>;
  /** Snowflake health status */
  snowflake?: Maybe<Scalars['Boolean']>;
};

export type HeroBanner = {
  __typename?: 'HeroBanner';
  backgroundColorHex?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  textAreaColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type HeroBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Scalars['String']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  textAreaColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

/** Autogenerated return type of HeroBannerPlacementCreate */
export type HeroBannerPlacementCreatePayload = {
  __typename?: 'HeroBannerPlacementCreatePayload';
  /** The newly created hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement;
};

export type HeroBannerPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** The images on the banner */
  images: GenericImagesInput;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The layout the placement should appear on */
  layout?: InputMaybe<Scalars['String']>;
  /** Locale */
  locale?: InputMaybe<BannerLocaleEnum>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The layout the placement should appear on */
  stringLayout?: InputMaybe<Scalars['String']>;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
  /** The color of the text area for placements (Eg. #FFFFFF) */
  textareaColor?: InputMaybe<Scalars['String']>;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** The variant of the banner */
  variant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of HeroBannerPlacementUpdate */
export type HeroBannerPlacementUpdatePayload = {
  __typename?: 'HeroBannerPlacementUpdatePayload';
  /** The updated hero_banner placement */
  heroBannerPlacement: ContentManagementHeroBannerPlacement;
};

export type HiddenSettingsInput = {
  /** Last seen RSAT pulse survey data */
  rsatPulseSurvey?: InputMaybe<RsatPulseSurveyInput>;
};

export type HighContrastColorsSchema = {
  __typename?: 'HighContrastColorsSchema';
  brandExpressDark?: Maybe<Scalars['String']>;
  brandExpressExtraDark?: Maybe<Scalars['String']>;
  brandExpressLight?: Maybe<Scalars['String']>;
  brandExpressRegular?: Maybe<Scalars['String']>;
  brandHighlightDark?: Maybe<Scalars['String']>;
  brandHighlightLight?: Maybe<Scalars['String']>;
  brandHighlightRegular?: Maybe<Scalars['String']>;
  brandLoyaltyDark?: Maybe<Scalars['String']>;
  brandLoyaltyLight?: Maybe<Scalars['String']>;
  brandLoyaltyRegular?: Maybe<Scalars['String']>;
  brandMaxDark?: Maybe<Scalars['String']>;
  brandMaxLight?: Maybe<Scalars['String']>;
  brandPrimaryDark?: Maybe<Scalars['String']>;
  brandPrimaryExtraDark?: Maybe<Scalars['String']>;
  brandPrimaryRegular?: Maybe<Scalars['String']>;
  brandPromotionalDark?: Maybe<Scalars['String']>;
  brandPromotionalLight?: Maybe<Scalars['String']>;
  brandPromotionalRegular?: Maybe<Scalars['String']>;
  brandSecondaryDark?: Maybe<Scalars['String']>;
  brandSecondaryLight?: Maybe<Scalars['String']>;
  brandSecondaryRegular?: Maybe<Scalars['String']>;
};

export type HistoricalPerformanceOverviewRecord = {
  __typename?: 'HistoricalPerformanceOverviewRecord';
  currentValue?: Maybe<InstacartTypesV1BigDecimal>;
  metricType?: Maybe<MetricType>;
  pastValue?: Maybe<InstacartTypesV1BigDecimal>;
};

export type HistoricalStorePerformanceRecord = {
  __typename?: 'HistoricalStorePerformanceRecord';
  dedicatedMatchRate?: Maybe<InstacartTypesV1BigDecimal>;
  dedicatedUtilizationRate?: Maybe<InstacartTypesV1BigDecimal>;
  fiveHourAvailabilityRate?: Maybe<InstacartTypesV1BigDecimal>;
  fssOrdersCount?: Maybe<Scalars['Int']>;
  matchRate?: Maybe<InstacartTypesV1BigDecimal>;
  name?: Maybe<Scalars['String']>;
  partnerPickOrdersCount?: Maybe<Scalars['Int']>;
  recommendedHours?: Maybe<InstacartTypesV1BigDecimal>;
  scheduledGaps?: Maybe<Scalars['Int']>;
  scheduledHours?: Maybe<InstacartTypesV1BigDecimal>;
  utilizationRate?: Maybe<InstacartTypesV1BigDecimal>;
  warehouseId?: Maybe<Scalars['BigInt']>;
  warehouseLocationId?: Maybe<Scalars['BigInt']>;
};

export type HistoricalStorePerformanceRequestInput = {
  devicePrioritizationEnabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<GoogleTypeDateInput>;
  metricThresholds?: InputMaybe<Array<InputMaybe<MetricThresholdInput>>>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type HistoricalStorePerformanceResponse = {
  __typename?: 'HistoricalStorePerformanceResponse';
  metrics?: Maybe<Array<Maybe<HistoricalStorePerformanceRecord>>>;
  overviewMetrics?: Maybe<Array<Maybe<HistoricalPerformanceOverviewRecord>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

export type Holiday = {
  __typename?: 'Holiday';
  date?: Maybe<GoogleTypeDate>;
  holidaySlug?: Maybe<Scalars['String']>;
  regions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type HolidayStatus = {
  __typename?: 'HolidayStatus';
  confirmedRetailerLocationCount?: Maybe<Scalars['Int']>;
  holiday?: Maybe<Holiday>;
  retailerId?: Maybe<Scalars['BigInt']>;
  unconfirmedRetailerLocationCount?: Maybe<Scalars['Int']>;
};

/** Types of Home Placements which may be returned */
export type HomePlacement = ContentManagementFlyoutPlacement | ContentManagementHeroBannerPlacement | ContentManagementSecondaryBannerPlacement | ContentManagementUnknownBannerPlacement;

export type HubPaginationMeta = {
  __typename?: 'HubPaginationMeta';
  perPage: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type IcPlusSchema = {
  __typename?: 'IcPlusSchema';
  enabledFeatures?: Maybe<Array<Maybe<IcPlusSchemaIcPlusFeature>>>;
};

export enum IcPlusSchemaIcPlusFeature {
  CreditBack = 'CREDIT_BACK',
  EnterpriseUpsell = 'ENTERPRISE_UPSELL',
  Unknown = 'UNKNOWN',
  Upsell = 'UPSELL'
}

export type IdsThemeSchema = {
  __typename?: 'IdsThemeSchema';
  buttonBorderRadius?: Maybe<BorderRadiusSchema>;
  colors?: Maybe<ColorsSchema>;
  fonts?: Maybe<Array<Maybe<CustomFontFamilySchema>>>;
  inputBorderRadius?: Maybe<BorderRadiusSchema>;
  radius?: Maybe<RadiusSchema>;
  typography?: Maybe<TypographySchema>;
};

export type ImageAsset = {
  __typename?: 'ImageAsset';
  altText?: Maybe<Scalars['String']>;
  identifier?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type ImageConfig = {
  __typename?: 'ImageConfig';
  caption?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

export type ImageConfigInput = {
  caption?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ImageForward = {
  __typename?: 'ImageForward';
  backgroundColorHex?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type ImageForwardFlex = {
  __typename?: 'ImageForwardFlex';
  backgroundColorHex?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type ImageForwardFlexInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ImageForwardInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ImageUploadBatch = {
  __typename?: 'ImageUploadBatch';
  batchId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  processedImageUploads?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Scalars['String']>;
  successfulImageUploads?: Maybe<Scalars['BigInt']>;
  totalImageUploads?: Maybe<Scalars['BigInt']>;
};

export type ImageUploadBatchDetails = {
  __typename?: 'ImageUploadBatchDetails';
  filename?: Maybe<Scalars['String']>;
  imageUploadId?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  productName?: Maybe<Scalars['String']>;
};

export type ImageUploadBatchMetadata = {
  __typename?: 'ImageUploadBatchMetadata';
  perPage?: Maybe<Scalars['BigInt']>;
  totalCount?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['BigInt']>;
};

export type ImagesAwsDetailsInput = {
  bucket?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
};

export type InStoreSchema = {
  __typename?: 'InStoreSchema';
  inStoreModeEnabled?: Maybe<Scalars['Boolean']>;
  scanItemBarcodeEnabled?: Maybe<Scalars['Boolean']>;
};

export type IndexBrandNamesRequestInput = {
  isDebug?: InputMaybe<Scalars['Boolean']>;
  superCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type IndexBrandNamesResponse = {
  __typename?: 'IndexBrandNamesResponse';
  brandNameMappings?: Maybe<Array<Maybe<BrandNameMapping>>>;
  brandProfileIdToName?: Maybe<Scalars['String']>;
};

export type IndexEbpCategoriesRequestInput = {
  brandProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDebug?: InputMaybe<Scalars['Boolean']>;
};

export type IndexEbpCategoriesResponse = {
  __typename?: 'IndexEbpCategoriesResponse';
  superCategories?: Maybe<Array<Maybe<Scalars['String']>>>;
  superCategoryIdToString?: Maybe<Scalars['String']>;
};

export enum InstacartAdsNexusV1RegionalArea {
  Midwest = 'MIDWEST',
  Mountain = 'MOUNTAIN',
  Northeast = 'NORTHEAST',
  Pacific = 'PACIFIC',
  RegionalAreaUnknown = 'REGIONAL_AREA_UNKNOWN',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST'
}

export enum InstacartAdsNexusV1StoreType {
  Alcohol = 'ALCOHOL',
  Asian = 'ASIAN',
  Baby = 'BABY',
  ClubWarehouse = 'CLUB_WAREHOUSE',
  Convenience = 'CONVENIENCE',
  ConventionalTraditional = 'CONVENTIONAL_TRADITIONAL',
  Coop = 'COOP',
  DepartmentStore = 'DEPARTMENT_STORE',
  Drugstore = 'DRUGSTORE',
  HomeKitchenBath = 'HOME_KITCHEN_BATH',
  LatinAmerican = 'LATIN_AMERICAN',
  LocalSpecialty = 'LOCAL_SPECIALTY',
  NaturalOrganic = 'NATURAL_ORGANIC',
  Other = 'OTHER',
  Pet = 'PET',
  StoreTypeUnknown = 'STORE_TYPE_UNKNOWN',
  Supplement = 'SUPPLEMENT',
  Value = 'VALUE'
}

export type InstacartAdsSharedV1DateRange = {
  __typename?: 'InstacartAdsSharedV1DateRange';
  endDate?: Maybe<GoogleTypeDate>;
  startDate?: Maybe<GoogleTypeDate>;
};

export type InstacartAdsSharedV1DateRangeInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
};

export type InstacartAdsSharedV1PaginationRequestInput = {
  page?: InputMaybe<Scalars['BigInt']>;
  resultsPerPage?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartAdsSharedV1PaginationResponse = {
  __typename?: 'InstacartAdsSharedV1PaginationResponse';
  page?: Maybe<Scalars['BigInt']>;
  resultsPerPage?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['BigInt']>;
};

export type InstacartCatalogAdminV1ClientInput = {
  appName?: InputMaybe<Scalars['String']>;
  contextJson?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export enum InstacartCustomersCommerceTypesV1FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

export type InstacartCustomersCommerceTypesV1SlimOffer = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOffer';
  buyComboGetNUnitsWithXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetNUnitsWithXPercentOffScenario>;
  buyComboGetXAmountOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetXAmountOffScenario>;
  buyMAmountGetNQtyWithXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenario>;
  buyMAmountGetXAmountOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenario>;
  buyMAmountGetXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenario>;
  buyMAmountGetXPercentPointsBackScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentPointsBackScenario>;
  buyMAmountGetXPointsBackScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPointsBackScenario>;
  buyMAmountOfAGetBForXAmountPerUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOfAGetBForXAmountScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenario>;
  buyMAmountOfAGetXAmountOffOnBScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenario>;
  buyMAmountOfAGetXPercentOffOnBScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenario>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenario>;
  buyMGetXPointsBackPerUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackPerUnitScenario>;
  buyMGetXPointsBackScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackScenario>;
  buyMOfAGetBForXAmountPerUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenario>;
  buyMOrMoreOfAGetBForXAmountPerUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMOrMoreOfAGetBForXAmountPerUnitScenario>;
  buyMQtyForXAmountScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenario>;
  buyMQtyGetNForFreeScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenario>;
  buyMQtyGetNQtyForXAmountScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenario>;
  buyMQtyGetNQtyWithXAmountOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenario>;
  buyMQtyGetNQtyWithXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenario>;
  buyMQtyGetXAmountOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenario>;
  buyMQtyGetXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenario>;
  buyMQtyOfAGetBForXAmountScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenario>;
  buyMQtyOfAGetXAmountOffOnBScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenario>;
  buyMQtyOfAGetXPercentOffOnBScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenario>;
  buyMQtyOrMoreForXAmountEachScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenario>;
  buyMQtyOrMoreGetXAmountOffEachScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenario>;
  buyMQtyOrMoreGetXAmountOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenario>;
  buyMQtyOrMoreGetXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenario>;
  buyMRangeQtyGetXPercentOffTieredScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenario>;
  buyMUnitsGetNUnitsForFreeScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenario>;
  buyMUnitsGetXAmountOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenario>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenario>;
  buyMUnitsGetXPercentOffScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenario>;
  buyMUnitsOfAGetXPercentOffOnBScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenario>;
  buyMWeightForXAmountPerWeightUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenario>;
  buyMWeightGetXAmountOffPerWeightUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenario>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenario>;
  conditionRewardString?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
  discountToken?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  exclusiveSpendMAmountOrMoreGetNForXPerUnitScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario>;
  fundingDetail?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferFundingDetail>;
  imageUrl?: Maybe<Scalars['String']>;
  isLoyaltyOffer?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferMetadata>;
  name?: Maybe<Scalars['String']>;
  offerConditions?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferCondition>>>;
  offerExternalReference?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  offerLabelString?: Maybe<Scalars['String']>;
  offerRequestKey?: Maybe<Scalars['String']>;
  offerRewards?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferReward>>>;
  offerSource?: Maybe<Scalars['String']>;
  offerStackability?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferStackability>;
  offerType?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferType>;
  promoCode?: Maybe<Scalars['String']>;
  redemptionLimits?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits>;
  startsAt?: Maybe<Scalars['DateTime']>;
  terms?: Maybe<Scalars['String']>;
  uncategorizedScenario?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenario>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferAdditionalMetadata = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferAdditionalMetadata';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferAdditionalMetadataInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetNUnitsWithXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetNUnitsWithXPercentOffScenario';
  nQty?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetNUnitsWithXPercentOffScenarioInput = {
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetXAmountOffScenario';
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetXAmountOffScenarioInput = {
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentPointsBackScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentPointsBackScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentPointsBackScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPointsBackScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPointsBackScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xValue?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPointsBackScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xValue?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackPerUnitScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xValue?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackPerUnitScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xValue?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xValue?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xValue?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMOrMoreOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMOrMoreOfAGetBForXAmountPerUnitScenario';
  mUnit?: Maybe<InstacartTypesV1MeasuredQuantity>;
  nQty?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMOrMoreOfAGetBForXAmountPerUnitScenarioInput = {
  mUnit?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  nQty?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  nQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenario';
  mQty?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenarioInput = {
  mQty?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenario';
  mQtyMax?: Maybe<InstacartTypesV1BigDecimal>;
  mQtyMin?: Maybe<InstacartTypesV1BigDecimal>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenarioInput = {
  mQtyMax?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  mQtyMin?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenario';
  currentTier?: Maybe<Scalars['BigInt']>;
  tiers?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenario>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenarioInput = {
  currentTier?: InputMaybe<Scalars['BigInt']>;
  tiers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffScenarioInput>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  nUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenario';
  mUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  nUnits?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xPercent?: Maybe<InstacartTypesV1BigDecimal>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenarioInput = {
  mUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  nUnits?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xPercent?: InputMaybe<InstacartTypesV1BigDecimalInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenario';
  mWeight?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenarioInput = {
  mWeight?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenario';
  mWeight?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenarioInput = {
  mWeight?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenario';
  mWeight?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenarioInput = {
  mWeight?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadata = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadata';
  retailerDepartmentTaxonomyCategories?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory>>>;
  taxonomyCategory?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadataInput = {
  retailerDepartmentTaxonomyCategories?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategoryInput>>>;
  taxonomyCategory?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategoryInput>>>;
};

export enum InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  AmountPerUnit = 'AMOUNT_PER_UNIT',
  AmountPerUnitWeight = 'AMOUNT_PER_UNIT_WEIGHT',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  PercentMille = 'PERCENT_MILLE',
  PercentMillePerUnit = 'PERCENT_MILLE_PER_UNIT',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
  SetPricePerUnit = 'SET_PRICE_PER_UNIT',
  SetPricePerUnitWeight = 'SET_PRICE_PER_UNIT_WEIGHT'
}

export type InstacartCustomersCommerceTypesV1SlimOfferExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<InstacartTypesV1MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferExclusiveSpendMAmountOrMoreGetNForXPerUnitScenarioInput = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingDetail = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferFundingDetail';
  budgetLimit?: Maybe<GoogleTypeMoney>;
  fundingProviderInfo?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingDetailInput = {
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>;
  fundingProviderInfo?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformationInput>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformation';
  percent?: Maybe<Scalars['BigInt']>;
  source?: Maybe<InstacartCustomersCommerceTypesV1FundingSource>;
  sourceName?: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferFundingProviderInformationInput = {
  percent?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<InstacartCustomersCommerceTypesV1FundingSource>;
  sourceName?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferInput = {
  buyComboGetNUnitsWithXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetNUnitsWithXPercentOffScenarioInput>;
  buyComboGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyComboGetXAmountOffScenarioInput>;
  buyMAmountGetNQtyWithXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetNQtyWithXPercentOffScenarioInput>;
  buyMAmountGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXAmountOffScenarioInput>;
  buyMAmountGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentOffScenarioInput>;
  buyMAmountGetXPercentPointsBackScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPercentPointsBackScenarioInput>;
  buyMAmountGetXPointsBackScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountGetXPointsBackScenarioInput>;
  buyMAmountOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountPerUnitScenarioInput>;
  buyMAmountOfAGetBForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetBForXAmountScenarioInput>;
  buyMAmountOfAGetXAmountOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXAmountOffOnBScenarioInput>;
  buyMAmountOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOfAGetXPercentOffOnBScenarioInput>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetBForXAmountPerUnitScenarioInput>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMAmountOrMoreOfAGetXPercentOffOnBScenarioInput>;
  buyMGetXPointsBackPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackPerUnitScenarioInput>;
  buyMGetXPointsBackScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMGetXPointsBackScenarioInput>;
  buyMOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMOfAGetBForXAmountPerUnitScenarioInput>;
  buyMOrMoreOfAGetBForXAmountPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMOrMoreOfAGetBForXAmountPerUnitScenarioInput>;
  buyMQtyForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyForXAmountScenarioInput>;
  buyMQtyGetNForFreeScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForFreeScenarioInput>;
  buyMQtyGetNQtyForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyForXAmountScenarioInput>;
  buyMQtyGetNQtyWithXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXAmountOffScenarioInput>;
  buyMQtyGetNQtyWithXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetNQtyWithXPercentOffScenarioInput>;
  buyMQtyGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXAmountOffScenarioInput>;
  buyMQtyGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyGetXPercentOffScenarioInput>;
  buyMQtyOfAGetBForXAmountScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetBForXAmountScenarioInput>;
  buyMQtyOfAGetXAmountOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXAmountOffOnBScenarioInput>;
  buyMQtyOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOfAGetXPercentOffOnBScenarioInput>;
  buyMQtyOrMoreForXAmountEachScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreForXAmountEachScenarioInput>;
  buyMQtyOrMoreGetXAmountOffEachScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffEachScenarioInput>;
  buyMQtyOrMoreGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXAmountOffScenarioInput>;
  buyMQtyOrMoreGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMQtyOrMoreGetXPercentOffScenarioInput>;
  buyMRangeQtyGetXPercentOffTieredScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMRangeQtyGetXPercentOffTieredScenarioInput>;
  buyMUnitsGetNUnitsForFreeScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetNUnitsForFreeScenarioInput>;
  buyMUnitsGetXAmountOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXAmountOffScenarioInput>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffPerMeasurementUnitScenarioInput>;
  buyMUnitsGetXPercentOffScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsGetXPercentOffScenarioInput>;
  buyMUnitsOfAGetXPercentOffOnBScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMUnitsOfAGetXPercentOffOnBScenarioInput>;
  buyMWeightForXAmountPerWeightUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightForXAmountPerWeightUnitScenarioInput>;
  buyMWeightGetXAmountOffPerWeightUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightGetXAmountOffPerWeightUnitScenarioInput>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferBuyMWeightOrMoreForXAmountPerWeightUnitScenarioInput>;
  conditionRewardString?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountToken?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  exclusiveSpendMAmountOrMoreGetNForXPerUnitScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferExclusiveSpendMAmountOrMoreGetNForXPerUnitScenarioInput>;
  fundingDetail?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferFundingDetailInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isLoyaltyOffer?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferMetadataInput>;
  name?: InputMaybe<Scalars['String']>;
  offerConditions?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionInput>>>;
  offerExternalReference?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerLabelString?: InputMaybe<Scalars['String']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  offerRewards?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardInput>>>;
  offerSource?: InputMaybe<Scalars['String']>;
  offerStackability?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferStackability>;
  offerType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferType>;
  promoCode?: InputMaybe<Scalars['String']>;
  redemptionLimits?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimitsInput>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  terms?: InputMaybe<Scalars['String']>;
  uncategorizedScenario?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenarioInput>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferLocaleCategories = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferLocaleCategories';
  category?: Maybe<Array<Maybe<Scalars['String']>>>;
  locale?: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferLocaleCategoriesInput = {
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferMetadata = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferMetadata';
  additionalMetadata?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferAdditionalMetadata>>>;
  categoryMetadata?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadata>;
  termsAndConditions?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditions>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferMetadataInput = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferAdditionalMetadataInput>>>;
  categoryMetadata?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferCategoryMetadataInput>;
  termsAndConditions?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditionsInput>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferCondition = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferCondition';
  allowPartialApplication?: Maybe<Scalars['Boolean']>;
  collectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  conditionProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedCollectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  maximumQuantity?: Maybe<Scalars['BigInt']>;
  minimumQuantity?: Maybe<Scalars['BigInt']>;
  minimumSpend?: Maybe<GoogleTypeMoney>;
  offerConditionType?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType>;
  retailerDepartments?: Maybe<Array<Maybe<Scalars['String']>>>;
  serviceType?: Maybe<InstacartCustomersSharedV1ServiceType>;
  taxonomyNodeIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferConditionInput = {
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  conditionProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  maximumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumSpend?: InputMaybe<GoogleTypeMoneyInput>;
  offerConditionType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType>;
  retailerDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceType?: InputMaybe<InstacartCustomersSharedV1ServiceType>;
  taxonomyNodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeRetailerDepartments = 'OFFER_CONDITION_TYPE_RETAILER_DEPARTMENTS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED',
  OfferConditionTypeWeightUnit = 'OFFER_CONDITION_TYPE_WEIGHT_UNIT'
}

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimits';
  redemptionLimit?: Maybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: Maybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRedemptionLimitsInput = {
  redemptionLimit?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferReward = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferOfferReward';
  amountDiscount?: Maybe<GoogleTypeMoney>;
  discountRewardType?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType>;
  includeConditionGroup?: Maybe<Scalars['Boolean']>;
  maximumDiscount?: Maybe<GoogleTypeMoney>;
  offerPrice?: Maybe<GoogleTypeMoney>;
  offerRewardType?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType>;
  percentDiscount?: Maybe<InstacartTypesV1BigDecimal>;
  quantityLimit?: Maybe<Scalars['BigInt']>;
  rewardProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  serviceItemType?: Maybe<InstacartCustomersCommerceTypesV1SlimOfferServiceItemType>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferOfferRewardInput = {
  amountDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  discountRewardType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferDiscountRewardType>;
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>;
  maximumDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  offerPrice?: InputMaybe<GoogleTypeMoneyInput>;
  offerRewardType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType>;
  percentDiscount?: InputMaybe<InstacartTypesV1BigDecimalInput>;
  quantityLimit?: InputMaybe<Scalars['BigInt']>;
  rewardProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceItemType?: InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferServiceItemType>;
};

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeRetailerDepartments = 'OFFER_REWARD_TYPE_RETAILER_DEPARTMENTS',
  OfferRewardTypeServiceItem = 'OFFER_REWARD_TYPE_SERVICE_ITEM',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED',
  OfferRewardTypeWeightUnit = 'OFFER_REWARD_TYPE_WEIGHT_UNIT'
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferStackability {
  AlwaysStackable = 'ALWAYS_STACKABLE',
  NonStackable = 'NON_STACKABLE',
  OfferStackabilityUnspecified = 'OFFER_STACKABILITY_UNSPECIFIED',
  Stackable = 'STACKABLE'
}

export enum InstacartCustomersCommerceTypesV1SlimOfferOfferType {
  AutoApply = 'AUTO_APPLY',
  AutoApplyCreditBack = 'AUTO_APPLY_CREDIT_BACK',
  AutoApplyInKindBack = 'AUTO_APPLY_IN_KIND_BACK',
  CheckoutCodeBasedDiscount = 'CHECKOUT_CODE_BASED_DISCOUNT',
  Coupon = 'COUPON',
  CouponBasedCreditBack = 'COUPON_BASED_CREDIT_BACK',
  CouponBasedInKindBack = 'COUPON_BASED_IN_KIND_BACK',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED',
  PointsBasedDiscount = 'POINTS_BASED_DISCOUNT',
  ValueIssuedInKind = 'VALUE_ISSUED_IN_KIND'
}

export enum InstacartCustomersCommerceTypesV1SlimOfferServiceItemType {
  DeliveryFee = 'DELIVERY_FEE',
  ServiceItemTypeUnspecified = 'SERVICE_ITEM_TYPE_UNSPECIFIED'
}

export type InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategory';
  localeCategories?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOfferLocaleCategories>>>;
  taxonomyLevel?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferTaxonomyCategoryInput = {
  localeCategories?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferLocaleCategoriesInput>>>;
  taxonomyLevel?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditions = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditions';
  locale?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferTermsAndConditionsInput = {
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenario = {
  __typename?: 'InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenario';
  _?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersCommerceTypesV1SlimOfferUncategorizedScenarioInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export enum InstacartCustomersContentManagementAdminV1CartState {
  CartStateUnspecified = 'CART_STATE_UNSPECIFIED',
  Empty = 'EMPTY',
  InProgress = 'IN_PROGRESS',
  Qualified = 'QUALIFIED'
}

export type InstacartCustomersContentManagementAdminV1SlotCreative = {
  __typename?: 'InstacartCustomersContentManagementAdminV1SlotCreative';
  cartState?: Maybe<InstacartCustomersContentManagementAdminV1CartState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creativeId?: Maybe<Scalars['BigInt']>;
  creativeRank?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['BigInt']>;
  treatmentOfferState?: Maybe<InstacartCustomersContentManagementAdminV1TreatmentOfferState>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartCustomersContentManagementAdminV1SlotCreativeInput = {
  cartState?: InputMaybe<InstacartCustomersContentManagementAdminV1CartState>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<InstacartCustomersContentManagementAdminV1TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum InstacartCustomersContentManagementAdminV1TreatmentOfferState {
  Activated = 'ACTIVATED',
  Applied = 'APPLIED',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
  TreatmentOfferStateUnspecified = 'TREATMENT_OFFER_STATE_UNSPECIFIED',
  Unredeemable = 'UNREDEEMABLE'
}

export type InstacartCustomersContentManagementV1Authentication = {
  __typename?: 'InstacartCustomersContentManagementV1Authentication';
  postAuthPaths?: Maybe<InstacartCustomersContentManagementV1PostAuthPaths>;
};

export type InstacartCustomersContentManagementV1AuthenticationInput = {
  postAuthPaths?: InputMaybe<InstacartCustomersContentManagementV1PostAuthPathsInput>;
};

export type InstacartCustomersContentManagementV1BannerAction = {
  __typename?: 'InstacartCustomersContentManagementV1BannerAction';
  dismissBusinessIdentication?: Maybe<InstacartCustomersContentManagementV1DismissBusinessIdentication>;
  doNotNavigate?: Maybe<InstacartCustomersContentManagementV1DoNotNavigate>;
  navigateToAllCarts?: Maybe<InstacartCustomersContentManagementV1NavigateToAllCarts>;
  navigateToAskInstacart?: Maybe<InstacartCustomersContentManagementV1NavigateToAskInstacart>;
  navigateToAuthentication?: Maybe<InstacartCustomersContentManagementV1NavigateToAuthentication>;
  navigateToBenefitsModal?: Maybe<InstacartCustomersContentManagementV1NavigateToBenefitsModal>;
  navigateToCategorySurface?: Maybe<InstacartCustomersContentManagementV1NavigateToCategorySurface>;
  navigateToCollaborativeShopInfoModal?: Maybe<InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModal>;
  navigateToCollection?: Maybe<InstacartCustomersContentManagementV1NavigateToCollection>;
  navigateToCollectionHub?: Maybe<InstacartCustomersContentManagementV1NavigateToCollectionHub>;
  navigateToContainerPathViaStoreselector?: Maybe<InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelector>;
  navigateToContentPage?: Maybe<InstacartCustomersContentManagementV1NavigateToContentPage>;
  navigateToCouponRedemption?: Maybe<InstacartCustomersContentManagementV1NavigateToCouponRedemption>;
  navigateToDepartment?: Maybe<InstacartCustomersContentManagementV1NavigateToDepartment>;
  navigateToExpressAccountPage?: Maybe<InstacartCustomersContentManagementV1NavigateToExpressAccountPage>;
  navigateToFlyers?: Maybe<InstacartCustomersContentManagementV1NavigateToFlyers>;
  navigateToHouseholdAccountSharingFlow?: Maybe<InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlow>;
  navigateToPartnershipModal?: Maybe<InstacartCustomersContentManagementV1NavigateToPartnershipModal>;
  navigateToPickupStoreselector?: Maybe<InstacartCustomersContentManagementV1NavigateToPickupStoreSelector>;
  navigateToProduct?: Maybe<InstacartCustomersContentManagementV1NavigateToProduct>;
  navigateToPromoModal?: Maybe<InstacartCustomersContentManagementV1NavigateToPromoModal>;
  navigateToPromotionDetail?: Maybe<InstacartCustomersContentManagementV1NavigateToPromotionDetail>;
  navigateToRetailerCollection?: Maybe<InstacartCustomersContentManagementV1NavigateToRetailerCollection>;
  navigateToRetailerCollectionViaStoreselector?: Maybe<InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelector>;
  navigateToSsaStoreselector?: Maybe<InstacartCustomersContentManagementV1NavigateToSsaStoreSelector>;
  navigateToStoreSelectorWithOffer?: Maybe<InstacartCustomersContentManagementV1NavigateToStoreSelectorWithOffer>;
  navigateToStorefront?: Maybe<InstacartCustomersContentManagementV1NavigateToStorefront>;
  navigateToStoreselector?: Maybe<InstacartCustomersContentManagementV1NavigateToStoreSelector>;
  navigateToUrl?: Maybe<InstacartCustomersContentManagementV1NavigateToUrl>;
  openExpressPaidModal?: Maybe<InstacartCustomersContentManagementV1OpenExpressPaidModal>;
  openExpressTrialModal?: Maybe<InstacartCustomersContentManagementV1OpenExpressTrialModal>;
  optInUser?: Maybe<InstacartCustomersContentManagementV1OptInUser>;
  redeemPartnershipOffer?: Maybe<InstacartCustomersContentManagementV1RedeemPartnershipOffer>;
  renewSubscriptionIntoAnnual?: Maybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnual>;
  renewSubscriptionIntoMonthly?: Maybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthly>;
};

export type InstacartCustomersContentManagementV1BannerActionInput = {
  dismissBusinessIdentication?: InputMaybe<InstacartCustomersContentManagementV1DismissBusinessIdenticationInput>;
  doNotNavigate?: InputMaybe<InstacartCustomersContentManagementV1DoNotNavigateInput>;
  navigateToAllCarts?: InputMaybe<InstacartCustomersContentManagementV1NavigateToAllCartsInput>;
  navigateToAskInstacart?: InputMaybe<InstacartCustomersContentManagementV1NavigateToAskInstacartInput>;
  navigateToAuthentication?: InputMaybe<InstacartCustomersContentManagementV1NavigateToAuthenticationInput>;
  navigateToBenefitsModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToBenefitsModalInput>;
  navigateToCategorySurface?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCategorySurfaceInput>;
  navigateToCollaborativeShopInfoModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModalInput>;
  navigateToCollection?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCollectionInput>;
  navigateToCollectionHub?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCollectionHubInput>;
  navigateToContainerPathViaStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelectorInput>;
  navigateToContentPage?: InputMaybe<InstacartCustomersContentManagementV1NavigateToContentPageInput>;
  navigateToCouponRedemption?: InputMaybe<InstacartCustomersContentManagementV1NavigateToCouponRedemptionInput>;
  navigateToDepartment?: InputMaybe<InstacartCustomersContentManagementV1NavigateToDepartmentInput>;
  navigateToExpressAccountPage?: InputMaybe<InstacartCustomersContentManagementV1NavigateToExpressAccountPageInput>;
  navigateToFlyers?: InputMaybe<InstacartCustomersContentManagementV1NavigateToFlyersInput>;
  navigateToHouseholdAccountSharingFlow?: InputMaybe<InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlowInput>;
  navigateToPartnershipModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPartnershipModalInput>;
  navigateToPickupStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPickupStoreSelectorInput>;
  navigateToProduct?: InputMaybe<InstacartCustomersContentManagementV1NavigateToProductInput>;
  navigateToPromoModal?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPromoModalInput>;
  navigateToPromotionDetail?: InputMaybe<InstacartCustomersContentManagementV1NavigateToPromotionDetailInput>;
  navigateToRetailerCollection?: InputMaybe<InstacartCustomersContentManagementV1NavigateToRetailerCollectionInput>;
  navigateToRetailerCollectionViaStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelectorInput>;
  navigateToSsaStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToSsaStoreSelectorInput>;
  navigateToStoreSelectorWithOffer?: InputMaybe<InstacartCustomersContentManagementV1NavigateToStoreSelectorWithOfferInput>;
  navigateToStorefront?: InputMaybe<InstacartCustomersContentManagementV1NavigateToStorefrontInput>;
  navigateToStoreselector?: InputMaybe<InstacartCustomersContentManagementV1NavigateToStoreSelectorInput>;
  navigateToUrl?: InputMaybe<InstacartCustomersContentManagementV1NavigateToUrlInput>;
  openExpressPaidModal?: InputMaybe<InstacartCustomersContentManagementV1OpenExpressPaidModalInput>;
  openExpressTrialModal?: InputMaybe<InstacartCustomersContentManagementV1OpenExpressTrialModalInput>;
  optInUser?: InputMaybe<InstacartCustomersContentManagementV1OptInUserInput>;
  redeemPartnershipOffer?: InputMaybe<InstacartCustomersContentManagementV1RedeemPartnershipOfferInput>;
  renewSubscriptionIntoAnnual?: InputMaybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnualInput>;
  renewSubscriptionIntoMonthly?: InputMaybe<InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthlyInput>;
};

export enum InstacartCustomersContentManagementV1BusinessDerivedAttributesSourceType {
  LangchainAi = 'LANGCHAIN_AI'
}

export enum InstacartCustomersContentManagementV1CategorySurfaceType {
  AlcoholSurface = 'ALCOHOL_SURFACE',
  RetailerRecommendation = 'RETAILER_RECOMMENDATION'
}

export type InstacartCustomersContentManagementV1DismissBusinessIdentication = {
  __typename?: 'InstacartCustomersContentManagementV1DismissBusinessIdentication';
  id?: Maybe<Scalars['BigInt']>;
  source?: Maybe<InstacartCustomersContentManagementV1BusinessDerivedAttributesSourceType>;
};

export type InstacartCustomersContentManagementV1DismissBusinessIdenticationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<InstacartCustomersContentManagementV1BusinessDerivedAttributesSourceType>;
};

export type InstacartCustomersContentManagementV1DoNotNavigate = {
  __typename?: 'InstacartCustomersContentManagementV1DoNotNavigate';
  recordClickAttempt?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1DoNotNavigateInput = {
  recordClickAttempt?: InputMaybe<Scalars['Boolean']>;
};

export enum InstacartCustomersContentManagementV1ModalSize {
  ModalSizeFitContents = 'MODAL_SIZE_FIT_CONTENTS',
  ModalSizeFullSize = 'MODAL_SIZE_FULL_SIZE',
  ModalSizeUnspecified = 'MODAL_SIZE_UNSPECIFIED'
}

export type InstacartCustomersContentManagementV1NavigateToAllCarts = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToAllCarts';
  _?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAllCartsInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAskInstacart = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToAskInstacart';
  prompt?: Maybe<Scalars['String']>;
  useBusinessDerivedAttributes?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAskInstacartInput = {
  prompt?: InputMaybe<Scalars['String']>;
  useBusinessDerivedAttributes?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToAuthentication = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToAuthentication';
  authentication?: Maybe<InstacartCustomersContentManagementV1Authentication>;
};

export type InstacartCustomersContentManagementV1NavigateToAuthenticationInput = {
  authentication?: InputMaybe<InstacartCustomersContentManagementV1AuthenticationInput>;
};

export type InstacartCustomersContentManagementV1NavigateToBenefitsModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToBenefitsModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToBenefitsModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToCategorySurface = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCategorySurface';
  categorySurfaceType?: Maybe<InstacartCustomersContentManagementV1CategorySurfaceType>;
};

export type InstacartCustomersContentManagementV1NavigateToCategorySurfaceInput = {
  categorySurfaceType?: InputMaybe<InstacartCustomersContentManagementV1CategorySurfaceType>;
};

export type InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollaborativeShopInfoModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollection = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCollection';
  legacyPath?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollectionHub = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCollectionHub';
  category?: Maybe<Scalars['String']>;
  collection?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollectionHubInput = {
  category?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToCollectionInput = {
  legacyPath?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelector';
  retailers?: Maybe<Array<Maybe<InstacartCustomersContentManagementV1RetailerContainerPath>>>;
};

export type InstacartCustomersContentManagementV1NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementV1RetailerContainerPathInput>>>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPage = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToContentPage';
  anchorId?: Maybe<Scalars['String']>;
  initialFilters?: Maybe<Array<Maybe<InstacartCustomersContentManagementV1NavigateToContentPageInitialFilter>>>;
  modalInfo?: Maybe<InstacartCustomersContentManagementV1NavigateToContentPageModalInfo>;
  slug?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPageInitialFilter = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToContentPageInitialFilter';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPageInitialFilterInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPageInput = {
  anchorId?: InputMaybe<Scalars['String']>;
  initialFilters?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementV1NavigateToContentPageInitialFilterInput>>>;
  modalInfo?: InputMaybe<InstacartCustomersContentManagementV1NavigateToContentPageModalInfoInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPageModalInfo = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToContentPageModalInfo';
  size?: Maybe<InstacartCustomersContentManagementV1ModalSize>;
};

export type InstacartCustomersContentManagementV1NavigateToContentPageModalInfoInput = {
  size?: InputMaybe<InstacartCustomersContentManagementV1ModalSize>;
};

export type InstacartCustomersContentManagementV1NavigateToCouponRedemption = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToCouponRedemption';
  couponCode?: Maybe<Scalars['String']>;
  landingUrl?: Maybe<Scalars['String']>;
  validateDays?: Maybe<Scalars['BigInt']>;
  visibleAfterRedeem?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToCouponRedemptionInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  landingUrl?: InputMaybe<Scalars['String']>;
  validateDays?: InputMaybe<Scalars['BigInt']>;
  visibleAfterRedeem?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToDepartment = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToDepartment';
  departmentId?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToDepartmentInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToExpressAccountPage = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToExpressAccountPage';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToExpressAccountPageInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToFlyers = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToFlyers';
  isDigitalFlyer?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToFlyersInput = {
  isDigitalFlyer?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlow = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlow';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToHouseholdAccountSharingFlowInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPartnershipModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPartnershipModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPartnershipModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPickupStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPickupStoreSelector';
  showDistance?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToPickupStoreSelectorInput = {
  showDistance?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1NavigateToProduct = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToProduct';
  productId?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToProductInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromoModal = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPromoModal';
  discountPolicyId?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromoModalInput = {
  discountPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromotionDetail = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToPromotionDetail';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToPromotionDetailInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollection = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToRetailerCollection';
  retailerId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelector';
  retailerCollections?: Maybe<Array<Maybe<InstacartCustomersContentManagementV1RetailerCollection>>>;
};

export type InstacartCustomersContentManagementV1NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementV1RetailerCollectionInput>>>;
};

export type InstacartCustomersContentManagementV1NavigateToSsaStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToSsaStoreSelector';
  serviceAreaType?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStoreSelector = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToStoreSelector';
  collectionSlug?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  storeForwardModuleType?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStoreSelectorInput = {
  collectionSlug?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeForwardModuleType?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStoreSelectorWithOffer = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToStoreSelectorWithOffer';
  itemId?: Maybe<Scalars['String']>;
  offerRequestKey?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type InstacartCustomersContentManagementV1NavigateToStoreSelectorWithOfferInput = {
  itemId?: InputMaybe<Scalars['String']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type InstacartCustomersContentManagementV1NavigateToStorefront = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToStorefront';
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerSlug?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToStorefrontInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToUrl = {
  __typename?: 'InstacartCustomersContentManagementV1NavigateToUrl';
  openAsModal?: Maybe<Scalars['Boolean']>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1NavigateToUrlInput = {
  openAsModal?: InputMaybe<Scalars['Boolean']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1OpenExpressPaidModal = {
  __typename?: 'InstacartCustomersContentManagementV1OpenExpressPaidModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OpenExpressPaidModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OpenExpressTrialModal = {
  __typename?: 'InstacartCustomersContentManagementV1OpenExpressTrialModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OpenExpressTrialModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1OptInUser = {
  __typename?: 'InstacartCustomersContentManagementV1OptInUser';
  id?: Maybe<Scalars['BigInt']>;
  optOut?: Maybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1OptInUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  optOut?: InputMaybe<Scalars['Boolean']>;
};

export type InstacartCustomersContentManagementV1PostAuthPaths = {
  __typename?: 'InstacartCustomersContentManagementV1PostAuthPaths';
  loginPath?: Maybe<Scalars['String']>;
  signupPath?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1PostAuthPathsInput = {
  loginPath?: InputMaybe<Scalars['String']>;
  signupPath?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RedeemPartnershipOffer = {
  __typename?: 'InstacartCustomersContentManagementV1RedeemPartnershipOffer';
  partnershipBenefitName?: Maybe<Scalars['String']>;
  partnershipOfferName?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RedeemPartnershipOfferInput = {
  partnershipBenefitName?: InputMaybe<Scalars['String']>;
  partnershipOfferName?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnual = {
  __typename?: 'InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnual';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoAnnualInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthly = {
  __typename?: 'InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthly';
  id?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RenewSubscriptionIntoMonthlyInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RetailerCollection = {
  __typename?: 'InstacartCustomersContentManagementV1RetailerCollection';
  retailerId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersContentManagementV1RetailerContainerPath = {
  __typename?: 'InstacartCustomersContentManagementV1RetailerContainerPath';
  containerPath?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type InstacartCustomersContentManagementV1RetailerContainerPathInput = {
  containerPath?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export enum InstacartCustomersProductsV1StockLevel {
  HighlyInStock = 'HIGHLY_IN_STOCK',
  InStock = 'IN_STOCK',
  LowStock = 'LOW_STOCK',
  NotWorthAdvertisingFor = 'NOT_WORTH_ADVERTISING_FOR',
  OutOfStock = 'OUT_OF_STOCK',
  SeverelyLowStock = 'SEVERELY_LOW_STOCK'
}

export enum InstacartCustomersSharedV1Locale {
  DeAt = 'DE_AT',
  EnAt = 'EN_AT',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  EnUk = 'EN_UK',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  EsSp = 'ES_SP',
  EsUs = 'ES_US',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  LocaleUnspecified = 'LOCALE_UNSPECIFIED'
}

export enum InstacartCustomersSharedV1OrderAttributeDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type InstacartCustomersSharedV1OrderAttributeInput = {
  direction?: InputMaybe<InstacartCustomersSharedV1OrderAttributeDirection>;
  name?: InputMaybe<Scalars['String']>;
};

export type InstacartCustomersSharedV1OrderInput = {
  attributes?: InputMaybe<Array<InputMaybe<InstacartCustomersSharedV1OrderAttributeInput>>>;
};

/** Represents pagination info extracted from Domain::PageInfo objects */
export type InstacartCustomersSharedV1PageInfo = {
  __typename?: 'InstacartCustomersSharedV1PageInfo';
  /** The last cursor of the current page */
  endCursor?: Maybe<Scalars['String']>;
  /** Indicates whether or not there is a next page */
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

/** Pagination request parameters for Domain::Shared::Pagination */
export type InstacartCustomersSharedV1PaginationInput = {
  /** Cursor to start from when fetching. */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type InstacartCustomersSharedV1RequestContext = {
  __typename?: 'InstacartCustomersSharedV1RequestContext';
  clientConfigurationId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  storeConfigurationId?: Maybe<Scalars['Int']>;
};

export type InstacartCustomersSharedV1RequestContextInput = {
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum InstacartCustomersSharedV1ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  Virtual = 'VIRTUAL'
}

export type InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1AddressInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1AddressInformation';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1CustomerInformation = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1CustomerInformation';
  customerEmail?: Maybe<Scalars['String']>;
  customerFirstName?: Maybe<Scalars['String']>;
  customerFullName?: Maybe<Scalars['String']>;
  customerLastName?: Maybe<Scalars['String']>;
  customerPhoneNumber?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrder = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrder';
  addressInformation?: Maybe<InstacartEnterpriseBobaCoreTypesV1AddressInformation>;
  addressLatitude?: Maybe<Scalars['Float']>;
  addressLongitude?: Maybe<Scalars['Float']>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  areDeliveryOrderPhotosExpired?: Maybe<Scalars['Boolean']>;
  cancellationOrigin?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCancellationOrigin>;
  cancellationReason?: Maybe<Scalars['String']>;
  carModelAndColor?: Maybe<Scalars['String']>;
  customerContext?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext>;
  customerInformation?: Maybe<InstacartEnterpriseBobaCoreTypesV1CustomerInformation>;
  dashboardOptions?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions>;
  deliveryPhotos?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderDeliveryPhoto>>>;
  displayId?: Maybe<Scalars['BigInt']>;
  estimatedDeliveryTime?: Maybe<Scalars['DateTime']>;
  estimatedPickupTime?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['String']>;
  formattedTipAmount?: Maybe<Scalars['String']>;
  fulfillmentDetails?: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>;
  id?: Maybe<Scalars['BigInt']>;
  initialTip?: Maybe<Scalars['Float']>;
  isExpress?: Maybe<Scalars['Boolean']>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  orderHistoryEvents?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent>>>;
  previouslyRescheduled?: Maybe<Scalars['Boolean']>;
  retailerProvidedAmounts?: Maybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts>;
  shopperAvatarUrl?: Maybe<Scalars['String']>;
  shopperFirstName?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouseLocationId?: Maybe<Scalars['BigInt']>;
  warehouseLocationName?: Maybe<Scalars['String']>;
  workflowState?: Maybe<Scalars['String']>;
};

export enum InstacartEnterpriseBobaCoreTypesV1DashboardOrderCancellationOrigin {
  CancellationOriginUnspecified = 'CANCELLATION_ORIGIN_UNSPECIFIED',
  Customer = 'CUSTOMER',
  Instacart = 'INSTACART',
  Other = 'OTHER',
  Retailer = 'RETAILER',
  Shopper = 'SHOPPER'
}

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderCustomerContext';
  clientConfigurationId?: Maybe<Scalars['Int']>;
  countryId?: Maybe<Scalars['Int']>;
  storeConfigurationId?: Maybe<Scalars['Int']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderDeliveryPhoto = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderDeliveryPhoto';
  id?: Maybe<Scalars['BigInt']>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderOptions';
  leaveUnattended?: Maybe<Scalars['Boolean']>;
  specialInstructions?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummary = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummary';
  bagCount?: Maybe<Scalars['Int']>;
  bagLabel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveryWindow?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryDeliveryWindow>;
  fulfillmentTimes?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryFulfillmentTimes>;
  id?: Maybe<Scalars['BigInt']>;
  legacyOrderId?: Maybe<Scalars['BigInt']>;
  orderReference?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryOrderStatus>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  retailerReferenceId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryDeliveryWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryDeliveryWindow';
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  windowStartsAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryFulfillmentTimes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryFulfillmentTimes';
  shopperDeliveredAt?: Maybe<Scalars['DateTime']>;
  shopperDispatchedAt?: Maybe<Scalars['DateTime']>;
  shopperEstimatedDeliveredAt?: Maybe<Scalars['DateTime']>;
  shopperEstimatedPickedAt?: Maybe<Scalars['DateTime']>;
  shopperPickedAt?: Maybe<Scalars['DateTime']>;
  shopperStartedDeliveryAt?: Maybe<Scalars['DateTime']>;
};

export enum InstacartEnterpriseBobaCoreTypesV1DashboardOrderSummaryOrderStatus {
  OrderCancelled = 'ORDER_CANCELLED',
  OrderComplete = 'ORDER_COMPLETE',
  OrderDelayed = 'ORDER_DELAYED',
  OrderEnRoute = 'ORDER_EN_ROUTE',
  OrderInProgress = 'ORDER_IN_PROGRESS',
  OrderPlaced = 'ORDER_PLACED',
  WaitingForDelivery = 'WAITING_FOR_DELIVERY'
}

export type InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails';
  addressId?: Maybe<Scalars['BigInt']>;
  fulfillmentType?: Maybe<Scalars['String']>;
  numOfBags?: Maybe<Scalars['BigInt']>;
  serviceOptionId?: Maybe<Scalars['BigInt']>;
  warehouseLocationId?: Maybe<Scalars['BigInt']>;
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  windowStartsAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ItemReplacement = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ItemReplacement';
  itemRrc?: Maybe<Scalars['String']>;
  itemUpc?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1LastMileOrderDashboardCreationParamsInput = {
  addressCreationParams?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1AddressDashboardCreationParamsInput>;
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  endAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>;
  initialTip?: InputMaybe<Scalars['Float']>;
  locale?: InputMaybe<Scalars['String']>;
  locationCode?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput>;
  retailerProvidedAmounts?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>;
  serviceOptionId?: InputMaybe<Scalars['BigInt']>;
  serviceOptionReference?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
  userBirthday?: InputMaybe<Scalars['String']>;
  userCreationParams?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput>;
  userPhone?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ModificationEventInput = {
  reason?: InputMaybe<Scalars['String']>;
  reasonDetailed?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType>;
};

export enum InstacartEnterpriseBobaCoreTypesV1ModificationEventUserType {
  Rpp = 'RPP',
  UserTypeUnspecified = 'USER_TYPE_UNSPECIFIED'
}

export type InstacartEnterpriseBobaCoreTypesV1Order = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1Order';
  batchId?: Maybe<Scalars['BigInt']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancellationReason?: Maybe<Scalars['String']>;
  cancellationType?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  deliveryEta?: Maybe<Scalars['DateTime']>;
  displayId?: Maybe<Scalars['BigInt']>;
  externalData?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalData>;
  fulfillmentDetails?: Maybe<InstacartEnterpriseBobaCoreTypesV1FulfillmentDetails>;
  id?: Maybe<Scalars['BigInt']>;
  isExpress?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  loyaltyCardId?: Maybe<Scalars['BigInt']>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  postCheckoutLink?: Maybe<Scalars['String']>;
  statusUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
  warnings?: Maybe<Array<Maybe<InstacartEnterpriseBobaCoreTypesV1OrderWarning>>>;
  workflowState?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderExternalData';
  externalId?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput = {
  externalId?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderHistoryEvent';
  action?: Maybe<Scalars['String']>;
  actionedAt?: Maybe<Scalars['DateTime']>;
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  windowStartsAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItem = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  externalData?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData>;
  id?: Maybe<Scalars['BigInt']>;
  isAddOnItem?: Maybe<Scalars['Boolean']>;
  itemCodes?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemCodes>;
  itemId?: Maybe<Scalars['BigInt']>;
  itemProperties?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemProperties>;
  itemType?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['BigInt']>;
  pickedAt?: Maybe<Scalars['DateTime']>;
  quantity?: Maybe<InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity>;
  replacementItem?: Maybe<InstacartEnterpriseBobaCoreTypesV1ItemReplacement>;
  replacementPolicy?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  substituteId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemCodes = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemCodes';
  deliveredRrc?: Maybe<Scalars['String']>;
  deliveredUpc?: Maybe<Scalars['String']>;
  requestedRrc?: Maybe<Scalars['String']>;
  requestedUpc?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemExternalData';
  itemRrc?: Maybe<Scalars['String']>;
  itemUpc?: Maybe<Scalars['String']>;
  lineNum?: Maybe<Scalars['String']>;
  scanCode?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemProperties = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemProperties';
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productType?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderItemQuantity';
  countDelivered?: Maybe<Scalars['Int']>;
  countOrdered?: Maybe<Scalars['Int']>;
  unit?: Maybe<Scalars['String']>;
  weightDelivered?: Maybe<Scalars['Float']>;
  weightOrdered?: Maybe<Scalars['Float']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderOptionsInput = {
  leaveUnattended?: InputMaybe<Scalars['Boolean']>;
  smsOptIn?: InputMaybe<Scalars['Boolean']>;
  specialInstructions?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1OrderWarning = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1OrderWarning';
  errorCode?: Maybe<Scalars['Int']>;
  itemCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput = {
  canceledExternalOrderId?: InputMaybe<Scalars['String']>;
  canceledOrderId?: InputMaybe<Scalars['BigInt']>;
  endAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>;
  serviceOptionId?: InputMaybe<Scalars['BigInt']>;
  serviceOptionReference?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput = {
  endAt?: InputMaybe<Scalars['String']>;
  externalData?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1OrderExternalDataInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  serviceOptionId?: InputMaybe<Scalars['BigInt']>;
  serviceOptionReference?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['String']>;
};

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmounts';
  bagLabel?: Maybe<Scalars['String']>;
  bagScanCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  bagsCount?: Maybe<Scalars['Int']>;
  cartTotal?: Maybe<Scalars['Float']>;
  itemsCount?: Maybe<Scalars['Int']>;
  itemsWeight?: Maybe<Scalars['Float']>;
};

export type InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput = {
  bagLabel?: InputMaybe<Scalars['String']>;
  bagScanCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  bagsCount?: InputMaybe<Scalars['Int']>;
  cartTotal?: InputMaybe<Scalars['Float']>;
  itemsCount?: InputMaybe<Scalars['Int']>;
  itemsWeight?: InputMaybe<Scalars['Float']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOption = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOption';
  asapWindow?: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow>;
  availability?: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability>;
  date?: Maybe<GoogleTypeDate>;
  id?: Maybe<Scalars['BigInt']>;
  immediateWindow?: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow>;
  scheduledWindow?: Maybe<InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow>;
  serviceOptionReference?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warehouseLocationId?: Maybe<Scalars['Int']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionAsapWindow';
  asap?: Maybe<Scalars['Boolean']>;
  descriptor?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['DateTime']>;
  startAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionAvailability';
  available?: Maybe<Scalars['Boolean']>;
  itemCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionImmediateWindow';
  descriptor?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['DateTime']>;
  immediateHour?: Maybe<Scalars['Int']>;
  startAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow = {
  __typename?: 'InstacartEnterpriseBobaCoreTypesV1ServiceOptionScheduledWindow';
  descriptor?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['DateTime']>;
  startAt?: Maybe<Scalars['DateTime']>;
};

export type InstacartEnterpriseBobaCoreTypesV1UserDashboardCreationParamsInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userPhone?: InputMaybe<Scalars['String']>;
};

export type InstacartStoreConfiguration = {
  __typename?: 'InstacartStoreConfiguration';
  /** Indicates if the Store Configuration is active or not */
  active: Scalars['Boolean'];
  /** Flag to indicate if this StoreConfiguration is associated to all warehouses */
  allowAllWarehouses: Scalars['Boolean'];
  /** The brand name as customers would see on Instacart, PBI, etc */
  brandedName: Scalars['String'];
  /** The list of associated client configurations */
  clientConfigurationIds?: Maybe<Array<Scalars['ID']>>;
  /** When the Store Configuration was created */
  createdAt: Scalars['Time'];
  /** Unata, etc... */
  deApplicationPlatform?: Maybe<Scalars['String']>;
  /** The domain name of the Storefront (eg. costco.ca) */
  domainName?: Maybe<Scalars['String']>;
  /** A unique identifier for the Store Configuration */
  id: Scalars['ID'];
  /** Legal data */
  legal?: Maybe<InstacartStoreConfigurationLegal>;
  /** The primary logo URL */
  logoUrl: Scalars['String'];
  /** The rules on how Partners can access this Store Configuration */
  partnerAccessSettings: InstacartStoreConfigurationPartnerAccessSettings;
  /** The unique slug for this Store Configuration */
  slug: Scalars['String'];
  /** When the Store Configuration was last updated */
  updatedAt: Scalars['Time'];
  /** Indicates if the user is permitted to modify data related to this Store Configuration */
  userAccessToModify: Scalars['Boolean'];
  /** The unique identifier for the User Isolation Context this Store Configuration uses */
  userIsolationContextId: Scalars['ID'];
  /** The list of associated warehouses */
  whitelistedWarehouseIds?: Maybe<Array<Scalars['ID']>>;
};

export type InstacartStoreConfigurationLegal = {
  __typename?: 'InstacartStoreConfigurationLegal';
  /** The shorter name for business entity */
  shortName: Scalars['String'];
};

export type InstacartStoreConfigurationModificationRules = {
  __typename?: 'InstacartStoreConfigurationModificationRules';
  /** The list of Partner IDs who are permitted to make modificaftions to this Store Configuration */
  allowlistPartnerIds?: Maybe<Array<Scalars['ID']>>;
  /** The list of Retailer IDs who are permitted to make modifications to this Store Configuration */
  allowlistRetailerIds?: Maybe<Array<Scalars['ID']>>;
};

export type InstacartStoreConfigurationPartnerAccessSettings = {
  __typename?: 'InstacartStoreConfigurationPartnerAccessSettings';
  /** The ruleset for allowing modifications for this Store Configuration */
  modificationRules?: Maybe<InstacartStoreConfigurationModificationRules>;
  /** True if Partners are allow to view this Store Configuration on IPP */
  visibleToPartnersOnIpp: Scalars['Boolean'];
};

export type InstacartTypesV1BigDecimal = {
  __typename?: 'InstacartTypesV1BigDecimal';
  nanos?: Maybe<Scalars['Int']>;
  units?: Maybe<Scalars['BigInt']>;
};

export type InstacartTypesV1BigDecimalInput = {
  nanos?: InputMaybe<Scalars['Int']>;
  units?: InputMaybe<Scalars['BigInt']>;
};

export type InstacartTypesV1MeasuredQuantity = {
  __typename?: 'InstacartTypesV1MeasuredQuantity';
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<InstacartTypesV1MeasurementUnit>;
};

export type InstacartTypesV1MeasuredQuantityInput = {
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<InstacartTypesV1MeasurementUnitInput>;
};

export type InstacartTypesV1MeasurementUnit = {
  __typename?: 'InstacartTypesV1MeasurementUnit';
  costUnit?: Maybe<InstacartTypesV1MeasurementUnitCostUnit>;
  unitCode?: Maybe<Scalars['String']>;
};

export enum InstacartTypesV1MeasurementUnitCostUnit {
  CostUnitUnspecified = 'COST_UNIT_UNSPECIFIED',
  Each = 'EACH',
  FlOz = 'FL_OZ',
  Gallon = 'GALLON',
  Gram = 'GRAM',
  Kg = 'KG',
  Lb = 'LB',
  Liter = 'LITER',
  Ml = 'ML',
  Oz = 'OZ',
  Pint = 'PINT',
  Quart = 'QUART'
}

export type InstacartTypesV1MeasurementUnitInput = {
  costUnit?: InputMaybe<InstacartTypesV1MeasurementUnitCostUnit>;
  unitCode?: InputMaybe<Scalars['String']>;
};

export type InstacartTypesV1RequestContextInput = {
  applicationId?: InputMaybe<Scalars['Int']>;
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum InventoryIntelligenceViewType {
  InventoryIntelligenceViewTypeChronicOverordering = 'INVENTORY_INTELLIGENCE_VIEW_TYPE_CHRONIC_OVERORDERING',
  InventoryIntelligenceViewTypeChronicUnderstocks = 'INVENTORY_INTELLIGENCE_VIEW_TYPE_CHRONIC_UNDERSTOCKS',
  InventoryIntelligenceViewTypeOverfacingItems = 'INVENTORY_INTELLIGENCE_VIEW_TYPE_OVERFACING_ITEMS',
  InventoryIntelligenceViewTypeUnknown = 'INVENTORY_INTELLIGENCE_VIEW_TYPE_UNKNOWN'
}

export type Investigation = {
  __typename?: 'Investigation';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['BigInt']>;
  investigationParameters?: Maybe<Scalars['JSONObject']>;
  investigationType?: Maybe<InvestigationType>;
  massopsAggregateStatus?: Maybe<MassOpsIntegrationState>;
  massopsIntegrationCount?: Maybe<Scalars['BigInt']>;
  massopsIntegrations?: Maybe<Array<Maybe<MassOpsIntegration>>>;
  orderSummary?: Maybe<Scalars['JSONObject']>;
  patchApprovalId?: Maybe<Scalars['String']>;
  patchCreatedAt?: Maybe<Scalars['DateTime']>;
  patchCreatedBy?: Maybe<Scalars['JSONObject']>;
  patchDeletedAt?: Maybe<Scalars['DateTime']>;
  patchDeletedBy?: Maybe<Scalars['JSONObject']>;
  patchDetails?: Maybe<Scalars['String']>;
  patchId?: Maybe<Scalars['String']>;
  patchStatus?: Maybe<PatchStatus>;
  priceHistorySummary?: Maybe<Scalars['JSONObject']>;
  reason?: Maybe<Scalars['String']>;
  resultsFileUrl?: Maybe<Scalars['String']>;
  resultsSummary?: Maybe<Scalars['JSONObject']>;
  status?: Maybe<InvestigationStatus>;
  temporaryOverrideRequestId?: Maybe<Scalars['String']>;
  totalOrdersCancelled?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum InvestigationStatus {
  InvestigationStatusFailed = 'INVESTIGATION_STATUS_FAILED',
  InvestigationStatusInProgress = 'INVESTIGATION_STATUS_IN_PROGRESS',
  InvestigationStatusSuccessful = 'INVESTIGATION_STATUS_SUCCESSFUL',
  InvestigationStatusUnspecified = 'INVESTIGATION_STATUS_UNSPECIFIED'
}

export enum InvestigationType {
  InvestigationTypeCostUnitChanges = 'INVESTIGATION_TYPE_COST_UNIT_CHANGES',
  InvestigationTypeItemId = 'INVESTIGATION_TYPE_ITEM_ID',
  InvestigationTypeLoyalty = 'INVESTIGATION_TYPE_LOYALTY',
  InvestigationTypePriceDrop = 'INVESTIGATION_TYPE_PRICE_DROP',
  InvestigationTypePriceHike = 'INVESTIGATION_TYPE_PRICE_HIKE',
  InvestigationTypePriceRange = 'INVESTIGATION_TYPE_PRICE_RANGE',
  InvestigationTypeProductId = 'INVESTIGATION_TYPE_PRODUCT_ID',
  InvestigationTypePromotions = 'INVESTIGATION_TYPE_PROMOTIONS',
  InvestigationTypeSales = 'INVESTIGATION_TYPE_SALES',
  InvestigationTypeUnspecified = 'INVESTIGATION_TYPE_UNSPECIFIED'
}

export type IppAccountInformationInput = {
  canonicalId?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type IppContextInput = {
  ippUserId?: InputMaybe<Scalars['BigInt']>;
  isAdminUser?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type IroncladData = {
  __typename?: 'IroncladData';
  isaGroupKey?: Maybe<Scalars['String']>;
  ndaGroupKey?: Maybe<Scalars['String']>;
  siteId?: Maybe<Scalars['String']>;
  useIronclad?: Maybe<Scalars['Boolean']>;
};

export type Item = {
  __typename?: 'Item';
  localeCode?: Maybe<Scalars['String']>;
  primaryAisleId?: Maybe<Scalars['BigInt']>;
  primaryDepartmentId?: Maybe<Scalars['BigInt']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productDisplayName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
};

export type ItemDebugData = {
  __typename?: 'ItemDebugData';
  algorithm?: Maybe<Scalars['String']>;
  arpalusConfidenceSnapshot?: Maybe<Scalars['Float']>;
  arpalusFacingCount?: Maybe<Scalars['Int']>;
  arpalusScanSegmentId?: Maybe<Scalars['BigInt']>;
  availabilityScore?: Maybe<Scalars['Float']>;
  externalSessionId?: Maybe<Scalars['String']>;
  givenSku?: Maybe<Scalars['String']>;
  missingConfidence?: Maybe<Scalars['Float']>;
  mostRecentInstockScanId?: Maybe<Scalars['BigInt']>;
  mostRecentScanId?: Maybe<Scalars['BigInt']>;
  recCreatedAt?: Maybe<Scalars['DateTime']>;
  recPkId?: Maybe<Scalars['BigInt']>;
  recommendationId?: Maybe<Scalars['String']>;
  sourceScanId?: Maybe<Scalars['BigInt']>;
  triggerRule?: Maybe<Scalars['String']>;
};

export type ItemId = {
  __typename?: 'ItemId';
  itemId?: Maybe<Scalars['BigInt']>;
};

export type ItemIdInput = {
  itemId?: InputMaybe<Scalars['BigInt']>;
};

export type ItemList = {
  __typename?: 'ItemList';
  cta?: Maybe<Scalars['String']>;
  ctaVisibilityMin?: Maybe<Scalars['BigInt']>;
  dataQuery?: Maybe<DataQuery>;
  dataQueryValue?: Maybe<Scalars['JSONObject']>;
  disclaimer?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  placementId?: Maybe<Scalars['BigInt']>;
  selectable?: Maybe<Scalars['Boolean']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<ItemListVariant>;
};

export type ItemListInput = {
  cta?: InputMaybe<Scalars['String']>;
  ctaVisibilityMin?: InputMaybe<Scalars['BigInt']>;
  dataQuery?: InputMaybe<DataQueryInput>;
  dataQueryValue?: InputMaybe<Scalars['JSONObject']>;
  disclaimer?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  selectable?: InputMaybe<Scalars['Boolean']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<ItemListVariant>;
};

export enum ItemListVariant {
  CarouselItemList = 'CAROUSEL_ITEM_LIST',
  CategoryForwardList = 'CATEGORY_FORWARD_LIST',
  CompactShoppable = 'COMPACT_SHOPPABLE',
  CouponList = 'COUPON_LIST',
  DoubleDeckerItemList = 'DOUBLE_DECKER_ITEM_LIST',
  FilterableItemList = 'FILTERABLE_ITEM_LIST',
  GridCouponList = 'GRID_COUPON_LIST',
  GridItemList = 'GRID_ITEM_LIST',
  ItemForwardList = 'ITEM_FORWARD_LIST',
  ItemList = 'ITEM_LIST',
  UnspecifiedItemList = 'UNSPECIFIED_ITEM_LIST'
}

export type ItemRestockRecommendation = {
  __typename?: 'ItemRestockRecommendation';
  aisleId?: Maybe<Scalars['String']>;
  availabilityScore?: Maybe<Scalars['Float']>;
  avgDailySales_7dDollars?: Maybe<Scalars['Float']>;
  avgDailySales_7dDollarsFormatted?: Maybe<Scalars['String']>;
  backstockStatus?: Maybe<BackstockStatus>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  effectiveKind?: Maybe<RecommendationKind>;
  effectiveStockStatus?: Maybe<StockStatus>;
  estimatedLostSalesDollars?: Maybe<Scalars['Float']>;
  estimatedLostSalesDollarsFormatted?: Maybe<Scalars['String']>;
  estimatedLostSalesUnits?: Maybe<Scalars['Float']>;
  freshness?: Maybe<ItemRestockRecommendationFreshness>;
  itemThumbnailUrl?: Maybe<Scalars['String']>;
  lastUpdatedFormatted?: Maybe<Scalars['String']>;
  medianDailySales_7dDollars?: Maybe<Scalars['Float']>;
  medianDailySales_7dDollarsFormatted?: Maybe<Scalars['String']>;
  medianDailySales_30dDollars?: Maybe<Scalars['Float']>;
  medianDailySales_30dDollarsFormatted?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productName?: Maybe<Scalars['String']>;
  recommendationId?: Maybe<Scalars['String']>;
  scanTimestamp?: Maybe<Scalars['DateTime']>;
  shelfImageUrl?: Maybe<Scalars['String']>;
  stockStatus?: Maybe<StockStatus>;
  upc?: Maybe<Scalars['String']>;
  userAction?: Maybe<RecommendationAction>;
  userActionTimestamp?: Maybe<Scalars['DateTime']>;
  userRejectionReason?: Maybe<RejectionReasonCode>;
};

export enum ItemRestockRecommendationFreshness {
  ItemRestockRecommendationFreshnessFresh = 'ITEM_RESTOCK_RECOMMENDATION_FRESHNESS_FRESH',
  ItemRestockRecommendationFreshnessStale = 'ITEM_RESTOCK_RECOMMENDATION_FRESHNESS_STALE',
  ItemRestockRecommendationFreshnessUnknown = 'ITEM_RESTOCK_RECOMMENDATION_FRESHNESS_UNKNOWN'
}

export enum ItemRestockRecommendationReadAlgorithm {
  ItemRestockRecommendationReadAlgorithmAvailIntersectV1 = 'ITEM_RESTOCK_RECOMMENDATION_READ_ALGORITHM_AVAIL_INTERSECT_V1',
  ItemRestockRecommendationReadAlgorithmLegacy = 'ITEM_RESTOCK_RECOMMENDATION_READ_ALGORITHM_LEGACY',
  ItemRestockRecommendationReadAlgorithmUnknown = 'ITEM_RESTOCK_RECOMMENDATION_READ_ALGORITHM_UNKNOWN'
}

export enum ItemRestockRecommendationSortBy {
  ItemRestockRecommendationSortByAisle = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_AISLE',
  ItemRestockRecommendationSortByEffectiveStockStatus = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_EFFECTIVE_STOCK_STATUS',
  ItemRestockRecommendationSortByLastScanned = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_LAST_SCANNED',
  ItemRestockRecommendationSortByLastUpdated = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_LAST_UPDATED',
  ItemRestockRecommendationSortByLostSalesDollars = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_LOST_SALES_DOLLARS',
  ItemRestockRecommendationSortByLostUnits = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_LOST_UNITS',
  ItemRestockRecommendationSortByStockStatus = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_STOCK_STATUS',
  ItemRestockRecommendationSortByUnknown = 'ITEM_RESTOCK_RECOMMENDATION_SORT_BY_UNKNOWN'
}

export type ItemsSchema = {
  __typename?: 'ItemsSchema';
  promoPricingBackgroundColor?: Maybe<AtomsColor>;
  promoPricingTextColor?: Maybe<AtomsColor>;
};

export type KpiCards = {
  __typename?: 'KpiCards';
  estimatedDailyLoss?: Maybe<Scalars['Float']>;
  lowStockItems?: Maybe<Scalars['Int']>;
  restockableItemCount?: Maybe<Scalars['Int']>;
  totalOosItems?: Maybe<Scalars['Int']>;
};

export type LandingSchema = {
  __typename?: 'LandingSchema';
  landingSkipPostalCode?: Maybe<Scalars['Boolean']>;
};

export type LaunchOnboarding = {
  __typename?: 'LaunchOnboarding';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserId?: Maybe<Scalars['BigInt']>;
  entityName?: Maybe<Scalars['String']>;
  expansionsOwnerUserId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  ippAccountUuid?: Maybe<Scalars['String']>;
  partner?: Maybe<LaunchOnboardingPartner>;
  tamOnboardingOwnerUserId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouse?: Maybe<LaunchOnboardingWarehouse>;
  warehouseLocations?: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>;
  workflowState?: Maybe<Scalars['String']>;
};

export type LaunchOnboardingAddress = {
  __typename?: 'LaunchOnboardingAddress';
  apartmentNumber?: Maybe<Scalars['String']>;
  approvalRequests?: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  approved?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

export type LaunchOnboardingAddressInput = {
  apartmentNumber?: InputMaybe<Scalars['String']>;
  approvalRequests?: InputMaybe<Array<InputMaybe<LaunchOnboardingApprovalRequestInput>>>;
  approved?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
};

export type LaunchOnboardingApprovalRequest = {
  __typename?: 'LaunchOnboardingApprovalRequest';
  approveableId?: Maybe<Scalars['BigInt']>;
  approveableType?: Maybe<Scalars['String']>;
  attributeGroup?: Maybe<Scalars['String']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeValue?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  iscConfId?: Maybe<Scalars['BigInt']>;
  iscConfName?: Maybe<Scalars['String']>;
  secretRefId?: Maybe<Scalars['BigInt']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type LaunchOnboardingApprovalRequestInput = {
  approveableId?: InputMaybe<Scalars['BigInt']>;
  approveableType?: InputMaybe<Scalars['String']>;
  attributeGroup?: InputMaybe<Scalars['String']>;
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  iscConfId?: InputMaybe<Scalars['BigInt']>;
  iscConfName?: InputMaybe<Scalars['String']>;
  secretRefId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type LaunchOnboardingPartner = {
  __typename?: 'LaunchOnboardingPartner';
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  partnerType?: Maybe<Scalars['String']>;
  salesforceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LaunchOnboardingWarehouse = {
  __typename?: 'LaunchOnboardingWarehouse';
  aliasName?: Maybe<Scalars['String']>;
  allowAlcohol?: Maybe<Scalars['Boolean']>;
  approvalRequests?: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  approved?: Maybe<Scalars['Boolean']>;
  backgroundColor?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  certifiedDeliveryThreshold?: Maybe<Scalars['Float']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['BigInt']>;
  franchiseeId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  logo?: Maybe<Scalars['String']>;
  logoBackgroundColor?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pricingPolicy?: Maybe<Scalars['String']>;
  pricingPolicyOverride?: Maybe<Scalars['String']>;
  pricingPolicyOverrideText?: Maybe<Scalars['String']>;
  pricingPolicyText?: Maybe<Scalars['String']>;
  retailerType?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visible?: Maybe<Scalars['Boolean']>;
  warehouseLocations?: Maybe<Array<Maybe<LaunchOnboardingWarehouseLocation>>>;
};

export type LaunchOnboardingWarehouseLocation = {
  __typename?: 'LaunchOnboardingWarehouseLocation';
  address?: Maybe<LaunchOnboardingAddress>;
  approvalRequests?: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  approvalRequestsStatus?: Maybe<Scalars['String']>;
  approved?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  isochroneData?: Maybe<Scalars['String']>;
  locationCode?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

export enum LaunchOnboardingWorkflowStateAction {
  LaunchOnboardingWorkflowStateActionCompleteInitialOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE_INITIAL_ONBOARDING',
  LaunchOnboardingWorkflowStateActionCompleteLaunchOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE_LAUNCH_ONBOARDING',
  LaunchOnboardingWorkflowStateActionCreateIppAccount = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_CREATE_IPP_ACCOUNT',
  LaunchOnboardingWorkflowStateActionLaunch = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_LAUNCH',
  LaunchOnboardingWorkflowStateActionProvideInitialWarehouseInfo = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_INITIAL_WAREHOUSE_INFO',
  LaunchOnboardingWorkflowStateActionProvideInitialWarehouseLocationsInfo = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_INITIAL_WAREHOUSE_LOCATIONS_INFO',
  LaunchOnboardingWorkflowStateActionSendEmailInvite = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_SEND_EMAIL_INVITE',
  LaunchOnboardingWorkflowStateActionStartInitialOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_START_INITIAL_ONBOARDING',
  LaunchOnboardingWorkflowStateActionStartLaunchOnboarding = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_START_LAUNCH_ONBOARDING',
  LaunchOnboardingWorkflowStateActionUnknown = 'LAUNCH_ONBOARDING_WORKFLOW_STATE_ACTION_UNKNOWN'
}

export enum Layout {
  ActionSheet = 'ACTION_SHEET',
  BloomTargetStorefront = 'BLOOM_TARGET_STOREFRONT',
  BloomTargetStorefrontDealsLists = 'BLOOM_TARGET_STOREFRONT_DEALS_LISTS',
  BrowseDepartments = 'BROWSE_DEPARTMENTS',
  BrowseFeed = 'BROWSE_FEED',
  CampaignPlacement = 'CAMPAIGN_PLACEMENT',
  CartCoachmark = 'CART_COACHMARK',
  CartIncentiveTracker = 'CART_INCENTIVE_TRACKER',
  CartIncentiveTrackerDetailSavingMessage = 'CART_INCENTIVE_TRACKER_DETAIL_SAVING_MESSAGE',
  CartIncentiveTrackerDetailSavingMessageNonIncentive = 'CART_INCENTIVE_TRACKER_DETAIL_SAVING_MESSAGE_NON_INCENTIVE',
  CartIncentiveTrackerM3 = 'CART_INCENTIVE_TRACKER_M3',
  CartIncentiveTrackerNonIncentive = 'CART_INCENTIVE_TRACKER_NON_INCENTIVE',
  CartMessages = 'CART_MESSAGES',
  CartMessagesNonIncentive = 'CART_MESSAGES_NON_INCENTIVE',
  CartMessagesNonIncentives = 'CART_MESSAGES_NON_INCENTIVES',
  CartOnLoad = 'CART_ON_LOAD',
  CartRecommendations = 'CART_RECOMMENDATIONS',
  CheckoutAisle = 'CHECKOUT_AISLE',
  CheckoutAisleNewUser = 'CHECKOUT_AISLE_NEW_USER',
  CheckoutBanner = 'CHECKOUT_BANNER',
  CollectionDepartment = 'COLLECTION_DEPARTMENT',
  CollectionHub = 'COLLECTION_HUB',
  CollectionHubOnLoad = 'COLLECTION_HUB_ON_LOAD',
  ContentLibraryPreferencesBroadCategory = 'CONTENT_LIBRARY_PREFERENCES_BROAD_CATEGORY',
  ContentLibraryPreferencesRecuratedKeywords = 'CONTENT_LIBRARY_PREFERENCES_RECURATED_KEYWORDS',
  CreativeManager = 'CREATIVE_MANAGER',
  CrossRetailerSearchEyebrow = 'CROSS_RETAILER_SEARCH_EYEBROW',
  CustomStorefront = 'CUSTOM_STOREFRONT',
  DealsTabHero = 'DEALS_TAB_HERO',
  DealsTabSecondary = 'DEALS_TAB_SECONDARY',
  EntStorefront = 'ENT_STOREFRONT',
  FloatingCart = 'FLOATING_CART',
  FloatingCartNonIncentive = 'FLOATING_CART_NON_INCENTIVE',
  FlyerDestination = 'FLYER_DESTINATION',
  FlyoutModal = 'FLYOUT_MODAL',
  Home = 'HOME',
  HomeAboveTheFold = 'HOME_ABOVE_THE_FOLD',
  HomeCategoryAlcohol = 'HOME_CATEGORY_ALCOHOL',
  HomeCategoryApparel = 'HOME_CATEGORY_APPAREL',
  HomeCategoryBaby = 'HOME_CATEGORY_BABY',
  HomeCategoryBeauty = 'HOME_CATEGORY_BEAUTY',
  HomeCategoryConvenience = 'HOME_CATEGORY_CONVENIENCE',
  HomeCategoryDiscount = 'HOME_CATEGORY_DISCOUNT',
  HomeCategoryElectronics = 'HOME_CATEGORY_ELECTRONICS',
  HomeCategoryForward = 'HOME_CATEGORY_FORWARD',
  HomeCategoryGifts = 'HOME_CATEGORY_GIFTS',
  HomeCategoryGrocery = 'HOME_CATEGORY_GROCERY',
  HomeCategoryHome = 'HOME_CATEGORY_HOME',
  HomeCategoryOffice = 'HOME_CATEGORY_OFFICE',
  HomeCategoryPet = 'HOME_CATEGORY_PET',
  HomeCategoryPharmacy = 'HOME_CATEGORY_PHARMACY',
  HomeCategoryRetail = 'HOME_CATEGORY_RETAIL',
  HomeCategorySports = 'HOME_CATEGORY_SPORTS',
  HomeCoachmark = 'HOME_COACHMARK',
  HomeEyebrow = 'HOME_EYEBROW',
  HomeFeed = 'HOME_FEED',
  HomeFeedAlcohol = 'HOME_FEED_ALCOHOL',
  HomeFeedBackToSchool = 'HOME_FEED_BACK_TO_SCHOOL',
  HomeFeedBeauty = 'HOME_FEED_BEAUTY',
  HomeFeedBecauseYouBought = 'HOME_FEED_BECAUSE_YOU_BOUGHT',
  HomeFeedConvenience = 'HOME_FEED_CONVENIENCE',
  HomeFeedDefault = 'HOME_FEED_DEFAULT',
  HomeFeedGifts = 'HOME_FEED_GIFTS',
  HomeFeedGrocery = 'HOME_FEED_GROCERY',
  HomeFeedHeader = 'HOME_FEED_HEADER',
  HomeFeedNewUser = 'HOME_FEED_NEW_USER',
  HomeFeedOpenLate = 'HOME_FEED_OPEN_LATE',
  HomeFeedPets = 'HOME_FEED_PETS',
  HomeFeedPharmacy = 'HOME_FEED_PHARMACY',
  HomeFeedUseCaseTiles = 'HOME_FEED_USE_CASE_TILES',
  HomeFeedWholesale = 'HOME_FEED_WHOLESALE',
  HomeHero = 'HOME_HERO',
  HomeHeroUnit = 'HOME_HERO_UNIT',
  HomeItemForward = 'HOME_ITEM_FORWARD',
  HomeMarketplace = 'HOME_MARKETPLACE',
  HomeOnLoad = 'HOME_ON_LOAD',
  HomeOnLoadCsc = 'HOME_ON_LOAD_CSC',
  HomeOnLoadIncentive = 'HOME_ON_LOAD_INCENTIVE',
  HomeSecondary = 'HOME_SECONDARY',
  HomeSuperSaver = 'HOME_SUPER_SAVER',
  Hub = 'HUB',
  HubHeader = 'HUB_HEADER',
  IcPlusPerksRewardsHubCsc = 'IC_PLUS_PERKS_REWARDS_HUB_CSC',
  InStoreDeals = 'IN_STORE_DEALS',
  IsolatedStorefront = 'ISOLATED_STOREFRONT',
  ItemDetailsRecommendations = 'ITEM_DETAILS_RECOMMENDATIONS',
  ItemDetailsRecommendationsPostAtc = 'ITEM_DETAILS_RECOMMENDATIONS_POST_ATC',
  ItemDetailsRecommendationsPrimary = 'ITEM_DETAILS_RECOMMENDATIONS_PRIMARY',
  ItemDetailsRecommendationsProductNotCarried = 'ITEM_DETAILS_RECOMMENDATIONS_PRODUCT_NOT_CARRIED',
  ItemDetailsRecommendationsSecondary = 'ITEM_DETAILS_RECOMMENDATIONS_SECONDARY',
  LandingContentPage = 'LANDING_CONTENT_PAGE',
  LoyaltyWalletPassOnDemand = 'LOYALTY_WALLET_PASS_ON_DEMAND',
  MealsHub = 'MEALS_HUB',
  MealsTabOnStorefront = 'MEALS_TAB_ON_STOREFRONT',
  MultiOfferCartTrackerIncentive = 'MULTI_OFFER_CART_TRACKER_INCENTIVE',
  MultiRetailerFlyerDestination = 'MULTI_RETAILER_FLYER_DESTINATION',
  NewVerticalsStorefront = 'NEW_VERTICALS_STOREFRONT',
  OffersForYouNonIncentive = 'OFFERS_FOR_YOU_NON_INCENTIVE',
  OnLoadRedemptionCsc = 'ON_LOAD_REDEMPTION_CSC',
  OnLoadRedemptionTemplate = 'ON_LOAD_REDEMPTION_TEMPLATE',
  OrderStatusRecommendations = 'ORDER_STATUS_RECOMMENDATIONS',
  OrderStatusSecondary = 'ORDER_STATUS_SECONDARY',
  PostCheckoutRecommendations = 'POST_CHECKOUT_RECOMMENDATIONS',
  PostCheckoutSheet = 'POST_CHECKOUT_SHEET',
  PostCheckoutSlot_1 = 'POST_CHECKOUT_SLOT_1',
  PromotionSheet = 'PROMOTION_SHEET',
  RecipeOnLoad = 'RECIPE_ON_LOAD',
  RecommendationsTray = 'RECOMMENDATIONS_TRAY',
  RedemptionModal = 'REDEMPTION_MODAL',
  RestaurantFlyoutLarge = 'RESTAURANT_FLYOUT_LARGE',
  RestaurantFlyoutMedium = 'RESTAURANT_FLYOUT_MEDIUM',
  RestaurantFlyoutMediumCombined_40DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_40_DOLLAR_OFF',
  RestaurantFlyoutMediumCombined_60DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_60_DOLLAR_OFF',
  RestaurantFlyoutMediumCombined_80DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_80_DOLLAR_OFF',
  RestaurantFlyoutMediumCombinedDollarOff = 'RESTAURANT_FLYOUT_MEDIUM_COMBINED_DOLLAR_OFF',
  RestaurantFlyoutMediumFreeDelivery = 'RESTAURANT_FLYOUT_MEDIUM_FREE_DELIVERY',
  RestaurantFlyoutMediumRestaurant_20DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_20_DOLLAR_OFF',
  RestaurantFlyoutMediumRestaurant_30DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_30_DOLLAR_OFF',
  RestaurantFlyoutMediumRestaurant_40DollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_40_DOLLAR_OFF',
  RestaurantFlyoutMediumRestaurantDollarOff = 'RESTAURANT_FLYOUT_MEDIUM_RESTAURANT_DOLLAR_OFF',
  RestaurantFlyoutSmall = 'RESTAURANT_FLYOUT_SMALL',
  RestaurantFlyoutSmallIcPlusUpsell = 'RESTAURANT_FLYOUT_SMALL_IC_PLUS_UPSELL',
  RetailerStories = 'RETAILER_STORIES',
  Search = 'SEARCH',
  ShopContentPage = 'SHOP_CONTENT_PAGE',
  Shortcuts = 'SHORTCUTS',
  Storefront = 'STOREFRONT',
  StorefrontCoachmark = 'STOREFRONT_COACHMARK',
  StorefrontDesktopSidebarNavigationV2 = 'STOREFRONT_DESKTOP_SIDEBAR_NAVIGATION_V2',
  StorefrontEyebrow = 'STOREFRONT_EYEBROW',
  StorefrontHeaderBottomFeaturedNavigationV2 = 'STOREFRONT_HEADER_BOTTOM_FEATURED_NAVIGATION_V2',
  StorefrontHeaderBottomNavigationV2 = 'STOREFRONT_HEADER_BOTTOM_NAVIGATION_V2',
  StorefrontHeaderTopFeaturedNavigationV2 = 'STOREFRONT_HEADER_TOP_FEATURED_NAVIGATION_V2',
  StorefrontHeaderTopNavigationV2 = 'STOREFRONT_HEADER_TOP_NAVIGATION_V2',
  StorefrontHero = 'STOREFRONT_HERO',
  StorefrontMobileWebMenuNavigationV2 = 'STOREFRONT_MOBILE_WEB_MENU_NAVIGATION_V2',
  StorefrontNativeMoreMenuNavigationV2 = 'STOREFRONT_NATIVE_MORE_MENU_NAVIGATION_V2',
  StorefrontNavigationAccount = 'STOREFRONT_NAVIGATION_ACCOUNT',
  StorefrontNavigationEmbeddedApp = 'STOREFRONT_NAVIGATION_EMBEDDED_APP',
  StorefrontNavigationFooter = 'STOREFRONT_NAVIGATION_FOOTER',
  StorefrontNavigationGrid = 'STOREFRONT_NAVIGATION_GRID',
  StorefrontNavigationHeader = 'STOREFRONT_NAVIGATION_HEADER',
  StorefrontNavigationItem = 'STOREFRONT_NAVIGATION_ITEM',
  StorefrontNavigationNativeTabbar = 'STOREFRONT_NAVIGATION_NATIVE_TABBAR',
  StorefrontNavigationSocialIcons = 'STOREFRONT_NAVIGATION_SOCIAL_ICONS',
  StorefrontNavigationV2 = 'STOREFRONT_NAVIGATION_V2',
  StorefrontNavigationWarehouseSelector = 'STOREFRONT_NAVIGATION_WAREHOUSE_SELECTOR',
  StorefrontNewUser = 'STOREFRONT_NEW_USER',
  StorefrontOnLoad = 'STOREFRONT_ON_LOAD',
  StorefrontOnLoadCsc = 'STOREFRONT_ON_LOAD_CSC',
  StorefrontOnLoadIncentive = 'STOREFRONT_ON_LOAD_INCENTIVE',
  StorefrontOverHeader = 'STOREFRONT_OVER_HEADER',
  StorefrontPostAtc = 'STOREFRONT_POST_ATC',
  StorefrontSuperSaver = 'STOREFRONT_SUPER_SAVER',
  StoreDirectoryAlcohol = 'STORE_DIRECTORY_ALCOHOL',
  StoreDirectoryAll = 'STORE_DIRECTORY_ALL',
  StoreDirectoryConvenience = 'STORE_DIRECTORY_CONVENIENCE',
  StoreDirectoryGrocery = 'STORE_DIRECTORY_GROCERY',
  StoreDirectoryRetail = 'STORE_DIRECTORY_RETAIL',
  TopTracker = 'TOP_TRACKER',
  TreatmentOffersForYou = 'TREATMENT_OFFERS_FOR_YOU',
  TreatmentOffersForYouNonIncentive = 'TREATMENT_OFFERS_FOR_YOU_NON_INCENTIVE',
  TreatmentSheet = 'TREATMENT_SHEET',
  TreatmentSlimTracker = 'TREATMENT_SLIM_TRACKER',
  TreatmentTracker = 'TREATMENT_TRACKER',
  TreatmentTrackerNonIncentive = 'TREATMENT_TRACKER_NON_INCENTIVE',
  TreatmentWave = 'TREATMENT_WAVE',
  UniversalValueCarousel = 'UNIVERSAL_VALUE_CAROUSEL',
  UniversalValueCarouselIncentive = 'UNIVERSAL_VALUE_CAROUSEL_INCENTIVE',
  UniversalValueCarouselNonIncentive = 'UNIVERSAL_VALUE_CAROUSEL_NON_INCENTIVE',
  UserSurvey = 'USER_SURVEY',
  YourItems = 'YOUR_ITEMS'
}

export enum LayoutType {
  DesktopFlexibleHeaderLayoutV1 = 'DESKTOP_FLEXIBLE_HEADER_LAYOUT_V1',
  DesktopSidebarLayoutV1 = 'DESKTOP_SIDEBAR_LAYOUT_V1',
  MobileWebHamburgerMenuLayoutV1 = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_V1',
  NativeMoreMenuLayoutV1 = 'NATIVE_MORE_MENU_LAYOUT_V1'
}

export type LayoutVariant = {
  __typename?: 'LayoutVariant';
  contentPageId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  placements?: Maybe<Array<Maybe<Placement>>>;
  platform?: Maybe<Array<Maybe<PlatformType>>>;
  previewToken?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Status>;
};

export type LayoutVariantInput = {
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  previewToken?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Status>;
};

export type LegacyElasticsearchResponse = {
  __typename?: 'LegacyElasticsearchResponse';
  docs?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
};

export type LegacyItemTyped = {
  __typename?: 'LegacyItemTyped';
  aisleId?: Maybe<Scalars['BigInt']>;
  aisleName?: Maybe<Scalars['String']>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  allergensKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  available?: Maybe<Scalars['Boolean']>;
  brandName?: Maybe<Scalars['String']>;
  configurableProducts?: Maybe<Scalars['JSONObject']>;
  costPricePerUnit?: Maybe<InstacartTypesV1BigDecimal>;
  costUnit?: Maybe<Scalars['String']>;
  dairyFree?: Maybe<Scalars['Boolean']>;
  departmentId?: Maybe<Scalars['BigInt']>;
  departmentName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  fullPrice?: Maybe<InstacartTypesV1BigDecimal>;
  halal?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  inStoreLocation?: Maybe<Scalars['String']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  isCatering?: Maybe<Scalars['Boolean']>;
  isHot?: Maybe<Scalars['Boolean']>;
  isPackagedByWeight?: Maybe<Scalars['Boolean']>;
  ketoDiet?: Maybe<Scalars['Boolean']>;
  largeImageUrl?: Maybe<Scalars['String']>;
  localeCode?: Maybe<Scalars['String']>;
  lowSodium?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nonenumeratedManagedAttributes?: Maybe<NonenumeratedManagedAttributes>;
  normalizedHeightCm?: Maybe<InstacartTypesV1BigDecimal>;
  normalizedLengthCm?: Maybe<InstacartTypesV1BigDecimal>;
  normalizedWeightG?: Maybe<InstacartTypesV1BigDecimal>;
  normalizedWidthCm?: Maybe<InstacartTypesV1BigDecimal>;
  parWeight?: Maybe<InstacartTypesV1BigDecimal>;
  price?: Maybe<InstacartTypesV1BigDecimal>;
  pricePerUnit?: Maybe<InstacartTypesV1BigDecimal>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  productCategory?: Maybe<ProductCategory>;
  productCategoryTaxonomy?: Maybe<ProductCategoryTaxonomy>;
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productEnrichmentKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  productId?: Maybe<Scalars['BigInt']>;
  productType?: Maybe<Scalars['String']>;
  requestUnit?: Maybe<LegacyItemTypedRequestUnit>;
  restrictedOtc?: Maybe<Scalars['Boolean']>;
  restrictedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerLookupCode?: Maybe<Scalars['String']>;
  retailerMetadata?: Maybe<LegacyItemTypedLegacyRetailerMetadataTyped>;
  retailerOmsEligible?: Maybe<Scalars['Boolean']>;
  retailerPreferredLookupCode?: Maybe<Scalars['String']>;
  retailerProductSize?: Maybe<Scalars['String']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  retailerSpecificMetadata?: Maybe<LegacyItemTypedLegacyRetailerSpecificMetadataTyped>;
  shopperHeroImageUrl?: Maybe<Scalars['String']>;
  shopperHeroLargeImageUrl?: Maybe<Scalars['String']>;
  shouldScan?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Scalars['String']>;
  sizeUomVariable?: Maybe<Scalars['String']>;
  storageTemp?: Maybe<Scalars['String']>;
  sugarFree?: Maybe<Scalars['Boolean']>;
  suggestedReplacementIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  syntheticCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  tobacco?: Maybe<Scalars['Boolean']>;
  unitCount?: Maybe<Scalars['BigInt']>;
  unitPrice?: Maybe<InstacartTypesV1BigDecimal>;
  unlisted?: Maybe<Scalars['Boolean']>;
  usaSnapEligible?: Maybe<Scalars['Boolean']>;
  variantDimensionValues?: Maybe<Array<Maybe<LegacyItemTypedLegacyVariantDimensionValueTyped>>>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

export type LegacyItemTypedLegacyRetailerMetadataTyped = {
  __typename?: 'LegacyItemTypedLegacyRetailerMetadataTyped';
  aldiProductCode?: Maybe<Scalars['String']>;
};

export type LegacyItemTypedLegacyRetailerSpecificMetadataTyped = {
  __typename?: 'LegacyItemTypedLegacyRetailerSpecificMetadataTyped';
  aldiProductCode?: Maybe<Scalars['String']>;
};

export type LegacyItemTypedLegacyVariantDimensionValueTyped = {
  __typename?: 'LegacyItemTypedLegacyVariantDimensionValueTyped';
  heading?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum LegacyItemTypedRequestUnit {
  Each = 'EACH',
  Kg = 'KG',
  Lb = 'LB',
  Package = 'PACKAGE',
  RequestUnitUnspecified = 'REQUEST_UNIT_UNSPECIFIED'
}

export type LegacyItemsTyped = {
  __typename?: 'LegacyItemsTyped';
  items?: Maybe<Array<Maybe<LegacyItemTyped>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type LegacyProducts = {
  __typename?: 'LegacyProducts';
  items?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['BigInt']>;
};

export enum LegalFilterType {
  FullyFiltered = 'FULLY_FILTERED',
  LegalFilterTypeUnknown = 'LEGAL_FILTER_TYPE_UNKNOWN',
  NotFiltered = 'NOT_FILTERED',
  PartiallyFiltered = 'PARTIALLY_FILTERED'
}

export type LinkAutosuggestion = {
  __typename?: 'LinkAutosuggestion';
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  linkDescription?: Maybe<Scalars['String']>;
  linkId?: Maybe<Scalars['BigInt']>;
  linkImageUrl?: Maybe<Scalars['String']>;
  linkName?: Maybe<Scalars['String']>;
  linkTitle?: Maybe<Scalars['String']>;
  linkType?: Maybe<LinkAutosuggestionLinkType>;
  linkUrl?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  startDate?: Maybe<Scalars['DateTime']>;
  storeConfigurationId?: Maybe<Scalars['Int']>;
};

export type LinkAutosuggestionAdmin = {
  __typename?: 'LinkAutosuggestionAdmin';
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  linkAutosuggestion?: Maybe<LinkAutosuggestion>;
};

export type LinkAutosuggestionAdminInput = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  linkAutosuggestion?: InputMaybe<LinkAutosuggestionInput>;
};

export type LinkAutosuggestionInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  linkDescription?: InputMaybe<Scalars['String']>;
  linkId?: InputMaybe<Scalars['BigInt']>;
  linkImageUrl?: InputMaybe<Scalars['String']>;
  linkName?: InputMaybe<Scalars['String']>;
  linkTitle?: InputMaybe<Scalars['String']>;
  linkType?: InputMaybe<LinkAutosuggestionLinkType>;
  linkUrl?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum LinkAutosuggestionLinkType {
  LinkTypeHard = 'LINK_TYPE_HARD',
  LinkTypeSoft = 'LINK_TYPE_SOFT',
  LinkTypeUnknown = 'LINK_TYPE_UNKNOWN'
}

export type ListAuditBatchesRequestInput = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  batchMetadata?: InputMaybe<Scalars['String']>;
  batchSecondaryStateIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  batchStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<OrderByInput>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  page?: InputMaybe<PaginationInput>;
  priorities?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  showReassignmentMappings?: InputMaybe<Scalars['Boolean']>;
  showStatistics?: InputMaybe<Scalars['Boolean']>;
  submissionUuids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  workflows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListAuditBatchesResponse = {
  __typename?: 'ListAuditBatchesResponse';
  aggregateStatistics?: Maybe<ListAuditBatchesResponseAggregateStatistics>;
  auditBatches?: Maybe<Array<Maybe<AuditBatch>>>;
  totalResultCount?: Maybe<Scalars['BigInt']>;
  workflowReassignmentMappings?: Maybe<Array<Maybe<ListAuditBatchesResponseWorkflowReassignmentMapping>>>;
};

export type ListAuditBatchesResponseAggregateStatistics = {
  __typename?: 'ListAuditBatchesResponseAggregateStatistics';
  totalAudited?: Maybe<Scalars['BigInt']>;
  totalCorrected?: Maybe<Scalars['BigInt']>;
  totalTasks?: Maybe<Scalars['BigInt']>;
};

export type ListAuditBatchesResponseWorkflowReassignmentMapping = {
  __typename?: 'ListAuditBatchesResponseWorkflowReassignmentMapping';
  fromWorkflow?: Maybe<Scalars['String']>;
  toWorkflows?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ListAuditTaskComponentsRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  componentValueFilters?: InputMaybe<Array<InputMaybe<ComponentValueFilterInput>>>;
  groupName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<PaginationInput>;
  searchTerm?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ListAuditTaskComponentsResponse = {
  __typename?: 'ListAuditTaskComponentsResponse';
  totalResultCount?: Maybe<Scalars['BigInt']>;
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type ListAuditWorkflowsRequestInput = {
  batchStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['DateTime']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  returnTaskInformation?: InputMaybe<Scalars['Boolean']>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  workflows?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListAuditWorkflowsResponse = {
  __typename?: 'ListAuditWorkflowsResponse';
  auditWorkflows?: Maybe<Array<Maybe<AuditWorkflow>>>;
};

export type ListContentPageAnchorsRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
};

export type ListContentPageAnchorsResponse = {
  __typename?: 'ListContentPageAnchorsResponse';
  anchors?: Maybe<Array<Maybe<PageAnchor>>>;
};

export type ListContentPageSlotAreasRequestInput = {
  contentPageType?: InputMaybe<Scalars['String']>;
};

export type ListContentPageSlotAreasResponse = {
  __typename?: 'ListContentPageSlotAreasResponse';
  slotAreas?: Maybe<Array<Maybe<ContentPageSlotArea>>>;
};

export type ListContentPageVersionMetasRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
};

export type ListContentPageVersionMetasResponse = {
  __typename?: 'ListContentPageVersionMetasResponse';
  contentPageVersionMetas?: Maybe<Array<Maybe<ContentPageVersionMeta>>>;
};

export type ListContentPageVersionsRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ListContentPageVersionsResponse = {
  __typename?: 'ListContentPageVersionsResponse';
  contentPageVersions?: Maybe<Array<Maybe<ContentPageVersion>>>;
};

export type ListContentPagesRequestV2Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  includeHasScheduledVersion?: InputMaybe<Scalars['Boolean']>;
  includeInstacartInternal?: InputMaybe<Scalars['Boolean']>;
  isOverlapAnyRetailerIds?: InputMaybe<Scalars['Boolean']>;
  isOverlapAnyStoreConfigurationIds?: InputMaybe<Scalars['Boolean']>;
  matchBySlugAcrossRetailers?: InputMaybe<Scalars['Boolean']>;
  pageType?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  search?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<ListContentPagesRequestV2SortColumn>;
  sortDirection?: InputMaybe<ListContentPagesRequestV2SortDirection>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export enum ListContentPagesRequestV2SortColumn {
  SortColumnCreatedAt = 'SORT_COLUMN_CREATED_AT',
  SortColumnInternalName = 'SORT_COLUMN_INTERNAL_NAME',
  SortColumnUnspecified = 'SORT_COLUMN_UNSPECIFIED'
}

export enum ListContentPagesRequestV2SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

export type ListContentPagesResponseV2 = {
  __typename?: 'ListContentPagesResponseV2';
  contentPages?: Maybe<Array<Maybe<ContentPageV2>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type ListDeletedContentPagesRequestInput = {
  pageType?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ListDeletedContentPagesResponse = {
  __typename?: 'ListDeletedContentPagesResponse';
  contentPages?: Maybe<Array<Maybe<ContentPageV2>>>;
};

export type ListDetectionsRequestFiltersInput = {
  hideRejectedVersions?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
};

export type ListDetectionsRequestInput = {
  filters?: InputMaybe<ListDetectionsRequestFiltersInput>;
  page?: InputMaybe<PaginationInput>;
};

export type ListDetectionsResponse = {
  __typename?: 'ListDetectionsResponse';
  detections?: Maybe<Array<Maybe<ListDetectionsResponseDetection>>>;
  totalResultCount?: Maybe<Scalars['BigInt']>;
};

export type ListDetectionsResponseDetection = {
  __typename?: 'ListDetectionsResponseDetection';
  createdAt?: Maybe<Scalars['DateTime']>;
  currentAttributes?: Maybe<DetectionVersionAttributes>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<DetectionStatusState>;
  tombstone?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedWhy?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type ListFrothTemplateVersionsRequestInput = {
  frothTemplateId?: InputMaybe<Scalars['BigInt']>;
};

export type ListFrothTemplateVersionsResponse = {
  __typename?: 'ListFrothTemplateVersionsResponse';
  frothTemplateVersions?: Maybe<Array<Maybe<FrothTemplateVersionInfo>>>;
};

export type ListFrothTemplatesRequestInput = {
  includeInstacartInternal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<FrothTemplateStatus>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ListFrothTemplatesResponse = {
  __typename?: 'ListFrothTemplatesResponse';
  frothTemplates?: Maybe<Array<Maybe<FrothTemplate>>>;
  pagination?: Maybe<FrothTemplatesPagination>;
};

export type ListLinkAutosuggestionAdminParametersInput = {
  keyword?: InputMaybe<Scalars['String']>;
  linkIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  linkNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
};

export type ListLinkAutosuggestionAdminRequestInput = {
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  parameters?: InputMaybe<ListLinkAutosuggestionAdminParametersInput>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type ListLinkAutosuggestionAdminResponse = {
  __typename?: 'ListLinkAutosuggestionAdminResponse';
  linkAutosuggestions?: Maybe<Array<Maybe<LinkAutosuggestionAdmin>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type ListMemberVersionsRequestInput = {
  changedField?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  memberId?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type ListMemberVersionsResponse = {
  __typename?: 'ListMemberVersionsResponse';
  activeVersions?: Maybe<Scalars['JSONObject']>;
  totalCount?: Maybe<Scalars['Int']>;
  versions?: Maybe<Array<Maybe<SentinelMemberVersion>>>;
};

export type ListMomentsRequestFilterSetInput = {
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListMomentsRequestInput = {
  filters?: InputMaybe<ListMomentsRequestFilterSetInput>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type ListMomentsResponse = {
  __typename?: 'ListMomentsResponse';
  moments?: Maybe<Array<Maybe<Moment>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type ListPbiStoreConfigurationsRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ListPbiStoreConfigurationsResponse = {
  __typename?: 'ListPbiStoreConfigurationsResponse';
  pbiStoreConfigurations?: Maybe<Array<Maybe<PbiStoreConfiguration>>>;
};

export type ListPlacementContentParamsInput = {
  campaignEndsAfter?: InputMaybe<Scalars['DateTime']>;
  campaignEndsBefore?: InputMaybe<Scalars['DateTime']>;
  campaignStartsAfter?: InputMaybe<Scalars['DateTime']>;
  campaignStartsBefore?: InputMaybe<Scalars['DateTime']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  contentPageVersionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  createdByCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  creativeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  enabledOnly?: InputMaybe<Scalars['Boolean']>;
  excludedLayoutVariants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedLayouts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedNamesRegex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedPlatforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedRetailers?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  experimentNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedLayoutVariants?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedLayouts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedPlatforms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedRetailers?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  internalNameRegex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PlacementContentRequestPaginationInput>;
  parentPlacementId?: InputMaybe<Scalars['BigInt']>;
  placementIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  placementSurface?: InputMaybe<PlacementContentSurfaceInput>;
  placementTypeVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  placementTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  updatedByCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListPlacementContentRequestInput = {
  excludingLocales?: InputMaybe<InstacartCustomersSharedV1Locale>;
  params?: InputMaybe<ListPlacementContentParamsInput>;
};

export type ListPlacementContentResponse = {
  __typename?: 'ListPlacementContentResponse';
  contents?: Maybe<Array<Maybe<PlacementContent>>>;
  pagination?: Maybe<PlacementContentResponsePagination>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type ListPriceInvestigationsRequestInput = {
  client?: InputMaybe<InstacartCatalogAdminV1ClientInput>;
  investigationStatus?: InputMaybe<InvestigationStatus>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  patchStatus?: InputMaybe<PatchStatus>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ListPriceInvestigationsResponse = {
  __typename?: 'ListPriceInvestigationsResponse';
  investigations?: Maybe<Array<Maybe<Investigation>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ListPublishedFrothTemplatesRequestInput = {
  includeInstacartInternal?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ListPublishedFrothTemplatesResponse = {
  __typename?: 'ListPublishedFrothTemplatesResponse';
  pagination?: Maybe<FrothTemplatesPagination>;
  publishedFrothTemplates?: Maybe<Array<Maybe<PublishedFrothTemplate>>>;
};

export type ListRetailerCampaignTreatmentsRequestInput = {
  ippContext?: InputMaybe<IppContextInput>;
  retailerCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ListRetailerCampaignTreatmentsResponse = {
  __typename?: 'ListRetailerCampaignTreatmentsResponse';
  treatments?: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
};

export type ListRetailerCampaignsRequestFilterSetInput = {
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignReference?: InputMaybe<CampaignReferenceInput>;
  discoverability?: InputMaybe<Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludeAdminOnlyCampaigns?: InputMaybe<Scalars['Boolean']>;
  excludeRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
  incentiveFilters?: InputMaybe<Array<InputMaybe<CampaignIncentiveFilter>>>;
  includeCampaignFromInternalTemplate?: InputMaybe<Scalars['Boolean']>;
  isActiveOnDatetime?: InputMaybe<Scalars['DateTime']>;
  propertyFilters?: InputMaybe<Array<InputMaybe<CampaignPropertyFilterOrListInput>>>;
  queryFields?: InputMaybe<Array<InputMaybe<ListRetailerCampaignsRequestFilterSetQueryFieldInput>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchValue?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withEnrichedProperties?: InputMaybe<Scalars['Boolean']>;
};

export type ListRetailerCampaignsRequestFilterSetQueryFieldInput = {
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListRetailerCampaignsRequestInput = {
  filters?: InputMaybe<ListRetailerCampaignsRequestFilterSetInput>;
  includeFields?: InputMaybe<Array<InputMaybe<CampaignField>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ListRetailerCampaignsResponse = {
  __typename?: 'ListRetailerCampaignsResponse';
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  retailerCampaigns?: Maybe<Array<Maybe<RetailerCampaign>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type ListSentinelMembersRequestInput = {
  groupId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['Int']>;
  managedAttributeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  ungroupedOnly?: InputMaybe<Scalars['Boolean']>;
};

export type ListSentinelMembersResponse = {
  __typename?: 'ListSentinelMembersResponse';
  members?: Maybe<Array<Maybe<SentinelMember>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ListThemePagesRequestInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  includeSections?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type ListThemePagesResponse = {
  __typename?: 'ListThemePagesResponse';
  themePages?: Maybe<Array<Maybe<ThemePage>>>;
};

export type ListTicketsRequestInput = {
  associatedUser?: InputMaybe<UserInput>;
  client?: InputMaybe<ClientInput>;
  createdBy?: InputMaybe<UserInput>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  entityType?: InputMaybe<EntityType>;
  getSummaryStatus?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<PaginationInput>;
  problemType?: InputMaybe<ProblemType>;
  reportedOnBehalfOf?: InputMaybe<UserInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  severity?: InputMaybe<Scalars['BigInt']>;
  sourceAppNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  ticketIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type ListTicketsResponse = {
  __typename?: 'ListTicketsResponse';
  includesOnBehalfOf?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Pagination>;
  tickets?: Maybe<Array<Maybe<ProblemTrackerTicket>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type ListUserSettingsRequestInput = {
  appNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  client?: InputMaybe<ClientInput>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ListUserSettingsResponse = {
  __typename?: 'ListUserSettingsResponse';
  settings?: Maybe<Array<Maybe<UserSetting>>>;
};

export type ListUsersByPersonalIdentifiersStrictRequestInput = {
  firstName?: InputMaybe<Scalars['String']>;
  identifier?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  prefixMatch?: InputMaybe<Scalars['Boolean']>;
  providerUid?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type ListUsersByPersonalIdentifiersStrictResponse = {
  __typename?: 'ListUsersByPersonalIdentifiersStrictResponse';
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type LiveInsightCard = {
  __typename?: 'LiveInsightCard';
  aisleId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estimatedLostSales?: Maybe<Scalars['Float']>;
  imageUrl?: Maybe<Scalars['String']>;
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  recommendationId?: Maybe<Scalars['String']>;
  scanTimestamp?: Maybe<Scalars['DateTime']>;
  severity?: Maybe<LiveInsightSeverity>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<LiveInsightType>;
};

export enum LiveInsightSeverity {
  LiveInsightSeverityCritical = 'LIVE_INSIGHT_SEVERITY_CRITICAL',
  LiveInsightSeverityNeedsAttention = 'LIVE_INSIGHT_SEVERITY_NEEDS_ATTENTION',
  LiveInsightSeverityUnknown = 'LIVE_INSIGHT_SEVERITY_UNKNOWN',
  LiveInsightSeverityWatch = 'LIVE_INSIGHT_SEVERITY_WATCH'
}

export enum LiveInsightType {
  LiveInsightTypeAisleRestock = 'LIVE_INSIGHT_TYPE_AISLE_RESTOCK',
  LiveInsightTypeKeyItemOos = 'LIVE_INSIGHT_TYPE_KEY_ITEM_OOS',
  LiveInsightTypeUnknown = 'LIVE_INSIGHT_TYPE_UNKNOWN'
}

export type LoadOrCreateDraftRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
};

export type LoadOrCreateDraftResponse = {
  __typename?: 'LoadOrCreateDraftResponse';
  draft?: Maybe<ContentPageVersion>;
  wasCreated?: Maybe<Scalars['Boolean']>;
};

export type LocaleProduct = {
  __typename?: 'LocaleProduct';
  localeId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
};

export type LocaleRetailerProduct = {
  __typename?: 'LocaleRetailerProduct';
  localeId?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['String']>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  locale?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum LocationFeatureEnum {
  /** Indicator whether retailer does alcohol delivery */
  RetailerAlcoholDelivery = 'RETAILER_ALCOHOL_DELIVERY',
  /** Indicator of whether retailer location does pickup */
  RetailerPickup = 'RETAILER_PICKUP'
}

export type LockSiteSetupFormRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type LockSiteSetupFormResponse = {
  __typename?: 'LockSiteSetupFormResponse';
  formLockedAt?: Maybe<Scalars['DateTime']>;
};

export type Logo = {
  __typename?: 'Logo';
  /** full url of the image */
  url?: Maybe<Scalars['String']>;
};

export type LogoWithTextBanner = {
  __typename?: 'LogoWithTextBanner';
  backgroundColorHex?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  id?: Maybe<Scalars['BigInt']>;
  imageAltText?: Maybe<Scalars['String']>;
  imageMobileUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type LogoWithTextBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type Logos = {
  __typename?: 'Logos';
  defaultSiteLogoImageUrl?: Maybe<Scalars['String']>;
  mobileBackgroundUrl?: Maybe<Scalars['String']>;
  mobileLogoUrl?: Maybe<Scalars['String']>;
  showPoweredByBranding?: Maybe<Scalars['Boolean']>;
};

export type LoyaltySchema = {
  __typename?: 'LoyaltySchema';
  showLoyaltyActionsInList?: Maybe<Scalars['Boolean']>;
};

export type ManagedAttributeDataSource = {
  __typename?: 'ManagedAttributeDataSource';
  allowNullOverrides?: Maybe<Scalars['Boolean']>;
  path?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
  transformations?: Maybe<Scalars['JSONObject']>;
};

export type ManagedAttributeDetail = {
  __typename?: 'ManagedAttributeDetail';
  adminUrl?: Maybe<Scalars['String']>;
  alreadyRegistered?: Maybe<Scalars['Boolean']>;
  core?: Maybe<Scalars['JSONObject']>;
  dataSources?: Maybe<Array<Maybe<ManagedAttributeDataSource>>>;
  enumValues?: Maybe<Array<Maybe<ManagedAttributeEnumValue>>>;
  fastAttribute?: Maybe<FastAttributeInfo>;
  managedAttributeId?: Maybe<Scalars['BigInt']>;
  productScopes?: Maybe<Array<Maybe<ManagedAttributeScope>>>;
  registeredGroupDisplayName?: Maybe<Scalars['String']>;
  registeredGroupId?: Maybe<Scalars['BigInt']>;
  registeredGroupSlug?: Maybe<Scalars['String']>;
  registeredMemberId?: Maybe<Scalars['BigInt']>;
  taxonomyNodes?: Maybe<Array<Maybe<ManagedAttributeTaxonomyNode>>>;
  unsupportedDataSources?: Maybe<Array<Maybe<ManagedAttributeDataSource>>>;
};

export type ManagedAttributeEnumValue = {
  __typename?: 'ManagedAttributeEnumValue';
  displayNameByLocale?: Maybe<Scalars['JSONObject']>;
  isPublishable?: Maybe<Scalars['Boolean']>;
  retailerScopes?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  value?: Maybe<Scalars['JSONObject']>;
};

export type ManagedAttributeScope = {
  __typename?: 'ManagedAttributeScope';
  isRequired?: Maybe<Scalars['Boolean']>;
  scopeName?: Maybe<Scalars['String']>;
};

export type ManagedAttributeSearchResult = {
  __typename?: 'ManagedAttributeSearchResult';
  alreadyRegistered?: Maybe<Scalars['Boolean']>;
  attributeType?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  fastAttributeDeprecated?: Maybe<Scalars['Boolean']>;
  inFastAttribute?: Maybe<Scalars['Boolean']>;
  isEnum?: Maybe<Scalars['Boolean']>;
  managedAttributeId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  registeredGroupDisplayName?: Maybe<Scalars['String']>;
  registeredGroupId?: Maybe<Scalars['BigInt']>;
  registeredGroupSlug?: Maybe<Scalars['String']>;
  registeredMemberId?: Maybe<Scalars['BigInt']>;
  tombstoned?: Maybe<Scalars['Boolean']>;
};

export type ManagedAttributeTaxonomyNode = {
  __typename?: 'ManagedAttributeTaxonomyNode';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type ManagedAttributeValue = {
  __typename?: 'ManagedAttributeValue';
  valueDisplayName?: Maybe<Scalars['String']>;
  valueId?: Maybe<Scalars['BigInt']>;
};

export type MarketingFeatureTypesBrazeSegment = {
  __typename?: 'MarketingFeatureTypesBrazeSegment';
  /** Warehouse ids the segment is visible by */
  accessibleWarehouseIds: Array<Scalars['Int']>;
  /** A unique identifier for the braze segment. For Braze's API */
  brazeSegmentId: Scalars['String'];
  /** The role ID */
  id: Scalars['ID'];
  /** The visible name of the segment */
  segmentName: Scalars['String'];
  updatedAt: Scalars['Time'];
};

export type MarketingFeatureTypesBrazeSegmentSize = {
  __typename?: 'MarketingFeatureTypesBrazeSegmentSize';
  /** The size of the segment */
  size: Scalars['Int'];
};

export type MarketingFeatureTypesCampaignConfiguration = {
  __typename?: 'MarketingFeatureTypesCampaignConfiguration';
  /** The id of the campaign returned from the campaign domain */
  campaignId: Scalars['ID'];
  /** The name of the experiment to run the campaign for */
  experimentName?: Maybe<Scalars['String']>;
  /** The push_notification id of the push notification template returned */
  pushNotificationId?: Maybe<Scalars['String']>;
  /** A unique identifier for the segment. Currently for Braze's API */
  segmentId: Scalars['String'];
  /** The external id of the template returned */
  templateId?: Maybe<Scalars['String']>;
  /** The warehouse id to run the campaign for */
  warehouseId: Scalars['ID'];
};

export type MarketingFeatureTypesCampaignStatus = {
  __typename?: 'MarketingFeatureTypesCampaignStatus';
  /** The name of the associated experiment */
  experimentName?: Maybe<Scalars['String']>;
  /** The id of the braze template */
  failedUserCount?: Maybe<Scalars['Int']>;
  /** The id of the braze template */
  pendingUserCount?: Maybe<Scalars['Int']>;
  /** The id of the associated push notification */
  pushNotificationId?: Maybe<Scalars['ID']>;
  /** The send types of the campaign */
  sendTypes?: Maybe<Array<Send>>;
  /** The id of the push notification */
  sentUserCount?: Maybe<Scalars['Int']>;
  /** The internal id of the template */
  status: CampaignProgress;
  /** The id of the associated template */
  templateId?: Maybe<Scalars['ID']>;
  /** The name of the template */
  totalUserCount: Scalars['Int'];
};

export type MarketingFeatureTypesEmailTemplatePreview = {
  __typename?: 'MarketingFeatureTypesEmailTemplatePreview';
  /** The full html preview of the email body */
  body: Scalars['String'];
  /** the preheader of the email */
  preheader?: Maybe<Scalars['String']>;
  /** The subject of the email */
  subject?: Maybe<Scalars['String']>;
  /** The external id of the template returned */
  templateId?: Maybe<Scalars['String']>;
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
  /** Variables used in the template */
  variables?: Maybe<Array<Scalars['String']>>;
};

export type MarketingFeatureTypesPushTemplatePreview = {
  __typename?: 'MarketingFeatureTypesPushTemplatePreview';
  /** The body of the push notification returned */
  body?: Maybe<Scalars['String']>;
  /** The id of the push notification returned */
  id: Scalars['String'];
  /** The title of the push notification returned */
  title?: Maybe<Scalars['String']>;
};

export type MarketingFeatureTypesTemplate = {
  __typename?: 'MarketingFeatureTypesTemplate';
  /** The id of the braze template */
  brazeTemplateId?: Maybe<Scalars['String']>;
  /** The name of the template */
  emailTemplateName: Scalars['String'];
  /** The internal id of the template */
  id: Scalars['ID'];
  /** Preview of the template */
  preview?: Maybe<MarketingFeatureTypesTemplatePreview>;
  /** The id of the push notification */
  pushNotificationId?: Maybe<Scalars['String']>;
};


export type MarketingFeatureTypesTemplatePreviewArgs = {
  useCache?: InputMaybe<Scalars['Boolean']>;
  variables?: InputMaybe<TemplateVariablesInput>;
};

export type MarketingFeatureTypesTemplatePreview = {
  __typename?: 'MarketingFeatureTypesTemplatePreview';
  email?: Maybe<MarketingFeatureTypesEmailTemplatePreview>;
  push?: Maybe<MarketingFeatureTypesPushTemplatePreview>;
};

export type MarketingMessagingDetailsInput = {
  experimentName?: InputMaybe<Scalars['String']>;
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  pushNotificationId?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVariables?: InputMaybe<Scalars['JSONObject']>;
  userEmailOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type MassOpsIntegration = {
  __typename?: 'MassOpsIntegration';
  batchNumber?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  csvS3Url?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  massopsInterventionUuid?: Maybe<Scalars['String']>;
  massopsState?: Maybe<MassOpsIntegrationState>;
  monitoringIteration?: Maybe<Scalars['BigInt']>;
  ordersCount?: Maybe<Scalars['BigInt']>;
  priceAnomalyInvestigationId?: Maybe<Scalars['BigInt']>;
  totalBatches?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum MassOpsIntegrationState {
  MassopsIntegrationStateCompleted = 'MASSOPS_INTEGRATION_STATE_COMPLETED',
  MassopsIntegrationStateCreatingIntervention = 'MASSOPS_INTEGRATION_STATE_CREATING_INTERVENTION',
  MassopsIntegrationStateFailed = 'MASSOPS_INTEGRATION_STATE_FAILED',
  MassopsIntegrationStateGeneratingCsv = 'MASSOPS_INTEGRATION_STATE_GENERATING_CSV',
  MassopsIntegrationStateInProgress = 'MASSOPS_INTEGRATION_STATE_IN_PROGRESS',
  MassopsIntegrationStatePending = 'MASSOPS_INTEGRATION_STATE_PENDING',
  MassopsIntegrationStateQueryingOrders = 'MASSOPS_INTEGRATION_STATE_QUERYING_ORDERS',
  MassopsIntegrationStateUnspecified = 'MASSOPS_INTEGRATION_STATE_UNSPECIFIED',
  MassopsIntegrationStateUploadingData = 'MASSOPS_INTEGRATION_STATE_UPLOADING_DATA'
}

export type MatchesAnyRetailerIdInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of retailer ids */
  retailerIds: Array<Scalars['Int']>;
};

/** Autogenerated return type of MatchesAnyRetailerIdVisibilityConditionCreate */
export type MatchesAnyRetailerIdVisibilityConditionCreatePayload = {
  __typename?: 'MatchesAnyRetailerIdVisibilityConditionCreatePayload';
  /** The newly created MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityCondition: ContentManagementVisibilityConditionMatchesAnyRetailerId;
};

/** Autogenerated return type of MatchesAnyRetailerIdVisibilityConditionUpdate */
export type MatchesAnyRetailerIdVisibilityConditionUpdatePayload = {
  __typename?: 'MatchesAnyRetailerIdVisibilityConditionUpdatePayload';
  /** The newly updated MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityCondition: ContentManagementVisibilityConditionMatchesAnyRetailerId;
};

/** The membership field a guided operation adds/removes/replaces. */
export enum Membership {
  /** assigned_partner_ids (users) */
  Partner = 'PARTNER',
  /** permission slugs (direct for users, role perms for roles) */
  Permission = 'PERMISSION',
  /** assigned_retailer_ids (users) */
  Retailer = 'RETAILER',
  /** assigned_retailer_location_ids (users) */
  RetailerLocation = 'RETAILER_LOCATION',
  /** accounts_roles (users) */
  Role = 'ROLE'
}

/** Verb for a guided (homogeneous) bulk operation. */
export enum MembershipAction {
  /** Union the given ids into the current membership set */
  Add = 'ADD',
  /** Set accounts.disabled = true (users only) */
  Disable = 'DISABLE',
  /** Set accounts.disabled = false (users only) */
  Enable = 'ENABLE',
  /** Subtract the given ids from the current membership set */
  Remove = 'REMOVE',
  /** Overwrite the membership set with exactly the given ids */
  Replace = 'REPLACE'
}

/** A homogeneous membership change applied to many targets. */
export type MembershipDeltaInput = {
  action: MembershipAction;
  /** Ids (roles/partners/retailers/locations) or permission slugs to add/remove/replace-with. */
  membershipIds?: InputMaybe<Array<Scalars['String']>>;
  /** Required for ADD/REMOVE/REPLACE; null for ENABLE/DISABLE. */
  membershipType?: InputMaybe<Membership>;
};

export enum MergeableReportTypeEnum {
  /** In Store Transactions */
  InStoreTransactions = 'IN_STORE_TRANSACTIONS',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** Shopper Reimbursements Monthly */
  ShopperReimbursementsMonthly = 'SHOPPER_REIMBURSEMENTS_MONTHLY',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Transaction Logs */
  TransactionLogs = 'TRANSACTION_LOGS'
}

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['String']>;
  role: Role;
  toolCallId?: Maybe<Scalars['String']>;
  toolCalls?: Maybe<Array<ToolCall>>;
};

export type MessageInput = {
  content?: InputMaybe<Scalars['String']>;
  role: Role;
  toolCallId?: InputMaybe<Scalars['String']>;
  toolCalls?: InputMaybe<Array<InputMaybe<ToolCallInput>>>;
};

export enum Metric {
  Orders = 'ORDERS',
  OrderPerStore = 'ORDER_PER_STORE',
  Sales = 'SALES',
  SalesPerStore = 'SALES_PER_STORE',
  Stores = 'STORES'
}

export type MetricThresholdInput = {
  metricType?: InputMaybe<MetricType>;
  threshold?: InputMaybe<Scalars['BigInt']>;
};

export enum MetricType {
  DedicatedMatchRate = 'DEDICATED_MATCH_RATE',
  DedicatedUtilizationRate = 'DEDICATED_UTILIZATION_RATE',
  Default = 'DEFAULT',
  FiveHourAvailabilityRate = 'FIVE_HOUR_AVAILABILITY_RATE',
  FulfilledOrders = 'FULFILLED_ORDERS',
  MatchRate = 'MATCH_RATE',
  RecommendedHours = 'RECOMMENDED_HOURS',
  ScheduledGaps = 'SCHEDULED_GAPS',
  ScheduledHours = 'SCHEDULED_HOURS',
  StaffingRate = 'STAFFING_RATE',
  UtilizationRate = 'UTILIZATION_RATE'
}

export type MinimumPlatformVersionInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId?: InputMaybe<Scalars['ID']>;
  /** The platform the version is being checked for */
  platform: PlacementPlatformEnum;
  /** Version used for the check */
  version: Scalars['String'];
};

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionCreate */
export type MinimumPlatformVersionVisibilityConditionCreatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionCreatePayload';
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion;
};

/** Autogenerated return type of MinimumPlatformVersionVisibilityConditionUpdate */
export type MinimumPlatformVersionVisibilityConditionUpdatePayload = {
  __typename?: 'MinimumPlatformVersionVisibilityConditionUpdatePayload';
  /** The newly created minimum_platform_version visibility condition */
  minimumPlatformVersionVisibilityCondition: ContentManagementVisibilityConditionMinimumPlatformVersion;
};

export type MobileAppWelcomeScreen = {
  __typename?: 'MobileAppWelcomeScreen';
  enabled?: Maybe<Scalars['Boolean']>;
  valueProps?: Maybe<Array<Maybe<ValueProp>>>;
};

export type MobileWebHamburgerMenuLayoutV1Navigations = {
  __typename?: 'MobileWebHamburgerMenuLayoutV1Navigations';
  navs?: Maybe<Array<Maybe<NavigationWithSubNavigation>>>;
};

export type MobileWebHamburgerMenuLayoutV1NavigationsInput = {
  navs?: InputMaybe<Array<InputMaybe<NavigationWithSubNavigationInput>>>;
};

export enum ModalSize {
  ModalSizeFitContents = 'MODAL_SIZE_FIT_CONTENTS',
  ModalSizeFullSize = 'MODAL_SIZE_FULL_SIZE',
  ModalSizeUnspecified = 'MODAL_SIZE_UNSPECIFIED'
}

export type Moment = {
  __typename?: 'Moment';
  campaigns?: Maybe<Array<Maybe<RetailerCampaign>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  momentCampaignId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  submissionDeadline?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MomentCampaignStatusInput = {
  campaignId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<Array<InputMaybe<StatusMapInput>>>;
};

export type MoveRetailerAssetsFromFilestackBucketRequestInput = {
  assetType?: InputMaybe<AssetType>;
  destinationBucket?: InputMaybe<DestinationBucket>;
  isPublicAccessible?: InputMaybe<Scalars['Boolean']>;
  objectKeyMappings?: InputMaybe<Array<InputMaybe<ObjectKeyMappingInput>>>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type MoveRetailerAssetsFromFilestackBucketResponse = {
  __typename?: 'MoveRetailerAssetsFromFilestackBucketResponse';
  assetKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  assetUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MutableS3Asset = {
  __typename?: 'MutableS3Asset';
  /** The s3 file exists */
  exists: Scalars['Boolean'];
  /** The idenfitier for the asset */
  id: Scalars['String'];
  /** The s3 read url for getting the asset */
  s3ReadUrl?: Maybe<Scalars['String']>;
  /** The s3 upload url for putting the asset */
  s3WriteUrl: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * AddAccount creates an account with the requested application permissions
   * and initiates password setup.
   */
  Auth0PermissionManagementService_instacart_caper_admin_v1_Auth0PermissionManagementService_AddAccount?: Maybe<Instacart_Caper_Admin_V1_AddAccountResponse>;
  /**
   * UpdateAccount replaces an existing account's mutable profile and
   * application permissions. The login email cannot be changed.
   */
  Auth0PermissionManagementService_instacart_caper_admin_v1_Auth0PermissionManagementService_UpdateAccount?: Maybe<Instacart_Caper_Admin_V1_UpdateAccountResponse>;
  /**
   * UpdateAccountStatus blocks or re-enables an existing account without
   * deleting its identity or application permissions.
   */
  Auth0PermissionManagementService_instacart_caper_admin_v1_Auth0PermissionManagementService_UpdateAccountStatus?: Maybe<Instacart_Caper_Admin_V1_UpdateAccountStatusResponse>;
  /**
   * AddAccount creates an account with the requested application permissions
   * and initiates password setup.
   */
  Auth0PermissionManagementStagingService_instacart_caper_admin_v1_Auth0PermissionManagementService_AddAccount?: Maybe<Instacart_Caper_Admin_V1_AddAccountResponse>;
  /**
   * UpdateAccount replaces an existing account's mutable profile and
   * application permissions. The login email cannot be changed.
   */
  Auth0PermissionManagementStagingService_instacart_caper_admin_v1_Auth0PermissionManagementService_UpdateAccount?: Maybe<Instacart_Caper_Admin_V1_UpdateAccountResponse>;
  /**
   * UpdateAccountStatus blocks or re-enables an existing account without
   * deleting its identity or application permissions.
   */
  Auth0PermissionManagementStagingService_instacart_caper_admin_v1_Auth0PermissionManagementService_UpdateAccountStatus?: Maybe<Instacart_Caper_Admin_V1_UpdateAccountStatusResponse>;
  /**
   * Adds scopes to an existing ban entry (additive only, safe for automation)
   * Never removes existing scopes - only adds new ones
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_AddBanEntryScopes?: Maybe<Instacart_Caper_Admin_V1_AddBanEntryScopesResponse>;
  /** Creates a new ban entry with scopes */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_CreateBanEntry?: Maybe<Instacart_Caper_Admin_V1_CreateBanEntryResponse>;
  /**
   * Removes specific scopes from an existing ban entry
   * Only removes the specified scopes - other scopes remain unchanged
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_RemoveBanEntryScopes?: Maybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesResponse>;
  /**
   * Sets the archived status of a ban entry
   * Archived entries are soft-deleted and can be viewed with include_archived filter
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryArchived?: Maybe<Scalars['instacart_caper_admin_v1_SetBanEntryArchivedResponse']>;
  /**
   * Sets the complete list of scopes for a ban entry (full replacement)
   * Replaces all existing scopes with the provided list - convenient for UI toggle states
   */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryScopes?: Maybe<Instacart_Caper_Admin_V1_SetBanEntryScopesResponse>;
  /**
   * Adds scopes to an existing ban entry (additive only, safe for automation)
   * Never removes existing scopes - only adds new ones
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_AddBanEntryScopes?: Maybe<Instacart_Caper_Admin_V1_AddBanEntryScopesResponse>;
  /** Creates a new ban entry with scopes */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_CreateBanEntry?: Maybe<Instacart_Caper_Admin_V1_CreateBanEntryResponse>;
  /**
   * Removes specific scopes from an existing ban entry
   * Only removes the specified scopes - other scopes remain unchanged
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_RemoveBanEntryScopes?: Maybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesResponse>;
  /**
   * Sets the archived status of a ban entry
   * Archived entries are soft-deleted and can be viewed with include_archived filter
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryArchived?: Maybe<Scalars['instacart_caper_admin_v1_SetBanEntryArchivedResponse']>;
  /**
   * Sets the complete list of scopes for a ban entry (full replacement)
   * Replaces all existing scopes with the provided list - convenient for UI toggle states
   */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_SetBanEntryScopes?: Maybe<Instacart_Caper_Admin_V1_SetBanEntryScopesResponse>;
  /** Creates one or more barcode-to-PLU mappings. */
  CaperBarcodePluMappingService_instacart_caper_admin_v1_BarcodePluMappingService_CreateBarcodePluMappings?: Maybe<Instacart_Caper_Admin_V1_CreateBarcodePluMappingsResponse>;
  /** Deletes one or more barcode-to-PLU mappings. */
  CaperBarcodePluMappingService_instacart_caper_admin_v1_BarcodePluMappingService_DeleteBarcodePluMappings?: Maybe<Instacart_Caper_Admin_V1_DeleteBarcodePluMappingsResponse>;
  /** Replaces one or more existing barcode-to-PLU mappings. */
  CaperBarcodePluMappingService_instacart_caper_admin_v1_BarcodePluMappingService_UpdateBarcodePluMappings?: Maybe<Instacart_Caper_Admin_V1_UpdateBarcodePluMappingsResponse>;
  /** Verifies the file exists in S3 via HeadObject and records an upload.committed audit event. Call this after the client finishes the presigned PUT. */
  CaperBillingService_commitUpload?: Maybe<CaperBillingService_CommitUpload_Response>;
  /** Allocates an uploadId and the S3 key for a new file. The caller must then PUT the CSV to PUT /uploads/{uploadId} (through this service), then call commitUpload to confirm. */
  CaperBillingService_createUpload?: Maybe<CaperBillingService_CreateUpload_Response>;
  /** Writes a write-once FINALIZED marker to S3 for the specified run. Uses conditional PutObject (IfNoneMatch: *) to ensure idempotent write-once semantics. Returns 409 if the run is already finalized. */
  CaperBillingService_finalizeRun?: Maybe<CaperBillingService_FinalizeRun_Response>;
  /** Reads committed CSV files from S3, runs the billing engine, writes result.json, result.pdf, and result.xlsx to S3, and returns the billing summary for inline display. The run starts in draft status. */
  CaperBillingService_generateRun?: Maybe<CaperBillingService_GenerateRun_Response>;
  /** Buffers the request body (CSV), validates it against the schema for the given uploadType, and writes to S3 only on success. All four upload types (contracts, orders, ads_revenue, active_carts) have registered schemas; invalid CSVs return 422 with per-row errors and are not stored. Call createUpload first to obtain uploadId, then PUT the file here with Content-Type text/csv. Follow with commitUpload to confirm and log the upload. */
  CaperBillingService_storeUpload?: Maybe<CaperBillingService_StoreUpload_Response>;
  /** Archives a notification group (soft delete). */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ArchiveNotificationGroup?: Maybe<Scalars['instacart_caper_admin_v1_ArchiveNotificationGroupResponse']>;
  /** Cancels scheduled actions before execution */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CancelScheduledAction?: Maybe<Scalars['instacart_caper_admin_v1_CancelScheduledActionResponse']>;
  /** Creates a config key in the db */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateConfigKey?: Maybe<Scalars['instacart_caper_admin_v1_CreateConfigKeyResponse']>;
  /** Creates a new device */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateDevice?: Maybe<Scalars['instacart_caper_admin_v1_CreateDeviceResponse']>;
  /** Creates new devices */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateDevices?: Maybe<Instacart_Caper_Admin_V1_CreateDevicesResponse>;
  /** Creates a new feature */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateFeature?: Maybe<Scalars['instacart_caper_admin_v1_CreateFeatureResponse']>;
  /** Creates a new notification group. */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateNotificationGroup?: Maybe<Instacart_Caper_Admin_V1_CreateNotificationGroupResponse>;
  /** Creates a new partner */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreatePartner?: Maybe<Scalars['instacart_caper_admin_v1_CreatePartnerResponse']>;
  /** Creates a presigned asset url */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreatePresignedAssetUrl?: Maybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlResponse>;
  /** Creates a new retailer */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateRetailer?: Maybe<Scalars['instacart_caper_admin_v1_CreateRetailerResponse']>;
  /** Creates a new store */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_CreateStore?: Maybe<Instacart_Caper_Admin_V1_CreateStoreResponse>;
  /** Lock or unlock carts at a given entity level */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_LockCarts?: Maybe<Instacart_Caper_Admin_V1_LockCartsResponse>;
  /** Scheduled Actions - Creates a scheduled config or feature change */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ScheduleAction?: Maybe<Instacart_Caper_Admin_V1_ScheduleActionResponse>;
  /** Batch Scheduled Actions - Creates multiple scheduled config/feature changes in one call */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ScheduleBatchActions?: Maybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsResponse>;
  /** Updates configs for an entity, can include adding, editing, or deleting a config */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfig?: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigResponse']>;
  /** Updates a config key in the db */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfigKey?: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigKeyResponse']>;
  /** Update a device */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateDevice?: Maybe<Instacart_Caper_Admin_V1_UpdateDeviceResponse>;
  /** Updates an existing feature */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateFeature?: Maybe<Instacart_Caper_Admin_V1_UpdateFeatureResponse>;
  /** Updates the global level */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateGlobal?: Maybe<Scalars['instacart_caper_admin_v1_UpdateGlobalResponse']>;
  /** Updates an existing notification group. */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateNotificationGroup?: Maybe<Scalars['instacart_caper_admin_v1_UpdateNotificationGroupResponse']>;
  /** Update a partner */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdatePartner?: Maybe<Instacart_Caper_Admin_V1_UpdatePartnerResponse>;
  /** Update a retailer */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateRetailer?: Maybe<Instacart_Caper_Admin_V1_UpdateRetailerResponse>;
  /** Update a store */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_UpdateStore?: Maybe<Instacart_Caper_Admin_V1_UpdateStoreResponse>;
  /** Archives a notification group (soft delete). */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ArchiveNotificationGroup?: Maybe<Scalars['instacart_caper_admin_v1_ArchiveNotificationGroupResponse']>;
  /** Cancels scheduled actions before execution */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CancelScheduledAction?: Maybe<Scalars['instacart_caper_admin_v1_CancelScheduledActionResponse']>;
  /** Creates a config key in the db */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateConfigKey?: Maybe<Scalars['instacart_caper_admin_v1_CreateConfigKeyResponse']>;
  /** Creates a new device */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateDevice?: Maybe<Scalars['instacart_caper_admin_v1_CreateDeviceResponse']>;
  /** Creates new devices */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateDevices?: Maybe<Instacart_Caper_Admin_V1_CreateDevicesResponse>;
  /** Creates a new feature */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateFeature?: Maybe<Scalars['instacart_caper_admin_v1_CreateFeatureResponse']>;
  /** Creates a new notification group. */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateNotificationGroup?: Maybe<Instacart_Caper_Admin_V1_CreateNotificationGroupResponse>;
  /** Creates a new partner */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreatePartner?: Maybe<Scalars['instacart_caper_admin_v1_CreatePartnerResponse']>;
  /** Creates a presigned asset url */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreatePresignedAssetUrl?: Maybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlResponse>;
  /** Creates a new retailer */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateRetailer?: Maybe<Scalars['instacart_caper_admin_v1_CreateRetailerResponse']>;
  /** Creates a new store */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_CreateStore?: Maybe<Instacart_Caper_Admin_V1_CreateStoreResponse>;
  /** Lock or unlock carts at a given entity level */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_LockCarts?: Maybe<Instacart_Caper_Admin_V1_LockCartsResponse>;
  /** Scheduled Actions - Creates a scheduled config or feature change */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ScheduleAction?: Maybe<Instacart_Caper_Admin_V1_ScheduleActionResponse>;
  /** Batch Scheduled Actions - Creates multiple scheduled config/feature changes in one call */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ScheduleBatchActions?: Maybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsResponse>;
  /** Updates configs for an entity, can include adding, editing, or deleting a config */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfig?: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigResponse']>;
  /** Updates a config key in the db */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateConfigKey?: Maybe<Scalars['instacart_caper_admin_v1_UpdateConfigKeyResponse']>;
  /** Update a device */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateDevice?: Maybe<Instacart_Caper_Admin_V1_UpdateDeviceResponse>;
  /** Updates an existing feature */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateFeature?: Maybe<Instacart_Caper_Admin_V1_UpdateFeatureResponse>;
  /** Updates the global level */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateGlobal?: Maybe<Scalars['instacart_caper_admin_v1_UpdateGlobalResponse']>;
  /** Updates an existing notification group. */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateNotificationGroup?: Maybe<Scalars['instacart_caper_admin_v1_UpdateNotificationGroupResponse']>;
  /** Update a partner */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdatePartner?: Maybe<Instacart_Caper_Admin_V1_UpdatePartnerResponse>;
  /** Update a retailer */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateRetailer?: Maybe<Instacart_Caper_Admin_V1_UpdateRetailerResponse>;
  /** Update a store */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_UpdateStore?: Maybe<Instacart_Caper_Admin_V1_UpdateStoreResponse>;
  /**
   * Applies a snapshot to an entity by writing new CSC config/feature changes.
   * The original snapshot is never mutated.
   */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_CscSnapshotService_ApplyCscSnapshot?: Maybe<Instacart_Caper_Admin_V2_ApplyCscSnapshotResponse>;
  /**
   * Creates an immutable CSC snapshot for one entity. Manual calls must include
   * at least one of tag or note.
   */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_CscSnapshotService_CreateCscSnapshot?: Maybe<Instacart_Caper_Admin_V2_CreateCscSnapshotResponse>;
  /** Updates mutable snapshot metadata only. Snapshot payloads are immutable. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_CscSnapshotService_UpdateCscSnapshotMetadata?: Maybe<Instacart_Caper_Admin_V2_UpdateCscSnapshotMetadataResponse>;
  /**
   * Activates a DRAFT experiment: captures baselines, applies planned writes.
   * Fails with FAILED_PRECONDITION + OverlappingExperimentError on conflicts.
   */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_ActivateExperiment?: Maybe<Instacart_Caper_Admin_V2_ActivateExperimentResponse>;
  /** Cancels a DRAFT experiment. ACTIVE experiments must use RevertExperiment. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_CancelExperiment?: Maybe<Instacart_Caper_Admin_V2_CancelExperimentResponse>;
  /**
   * Closes an ACTIVE experiment without reverting its writes. Terminal
   * state = COMPLETED.
   */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_CompleteExperiment?: Maybe<Instacart_Caper_Admin_V2_CompleteExperimentResponse>;
  /** Creates a DRAFT experiment. Editable via UpdateExperiment until activated. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_CreateExperiment?: Maybe<Instacart_Caper_Admin_V2_CreateExperimentResponse>;
  /** Pushes an ACTIVE experiment's end_at forward. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_ExtendExperiment?: Maybe<Instacart_Caper_Admin_V2_ExtendExperimentResponse>;
  /** Manually reverts an ACTIVE experiment to its captured baselines. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_RevertExperiment?: Maybe<Instacart_Caper_Admin_V2_RevertExperimentResponse>;
  /** Updates a DRAFT experiment. Rejected if the experiment is no longer DRAFT. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_UpdateExperiment?: Maybe<Instacart_Caper_Admin_V2_UpdateExperimentResponse>;
  /**
   * Applies a snapshot to an entity by writing new CSC config/feature changes.
   * The original snapshot is never mutated.
   */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_CscSnapshotService_ApplyCscSnapshot?: Maybe<Instacart_Caper_Admin_V2_ApplyCscSnapshotResponse>;
  /**
   * Creates an immutable CSC snapshot for one entity. Manual calls must include
   * at least one of tag or note.
   */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_CscSnapshotService_CreateCscSnapshot?: Maybe<Instacart_Caper_Admin_V2_CreateCscSnapshotResponse>;
  /** Updates mutable snapshot metadata only. Snapshot payloads are immutable. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_CscSnapshotService_UpdateCscSnapshotMetadata?: Maybe<Instacart_Caper_Admin_V2_UpdateCscSnapshotMetadataResponse>;
  /**
   * Activates a DRAFT experiment: captures baselines, applies planned writes.
   * Fails with FAILED_PRECONDITION + OverlappingExperimentError on conflicts.
   */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_ActivateExperiment?: Maybe<Instacart_Caper_Admin_V2_ActivateExperimentResponse>;
  /** Cancels a DRAFT experiment. ACTIVE experiments must use RevertExperiment. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_CancelExperiment?: Maybe<Instacart_Caper_Admin_V2_CancelExperimentResponse>;
  /**
   * Closes an ACTIVE experiment without reverting its writes. Terminal
   * state = COMPLETED.
   */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_CompleteExperiment?: Maybe<Instacart_Caper_Admin_V2_CompleteExperimentResponse>;
  /** Creates a DRAFT experiment. Editable via UpdateExperiment until activated. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_CreateExperiment?: Maybe<Instacart_Caper_Admin_V2_CreateExperimentResponse>;
  /** Pushes an ACTIVE experiment's end_at forward. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_ExtendExperiment?: Maybe<Instacart_Caper_Admin_V2_ExtendExperimentResponse>;
  /** Manually reverts an ACTIVE experiment to its captured baselines. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_RevertExperiment?: Maybe<Instacart_Caper_Admin_V2_RevertExperimentResponse>;
  /** Updates a DRAFT experiment. Rejected if the experiment is no longer DRAFT. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_UpdateExperiment?: Maybe<Instacart_Caper_Admin_V2_UpdateExperimentResponse>;
  /**
   * Triggers a new warehouse provisioning pipeline run.
   * Generates a task_id, persists a PENDING run, and initiates the pipeline
   * asynchronously. Returns immediately with the PENDING run record.
   */
  CaperDeviceProvisioningPipelineService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_TriggerPipeline?: Maybe<Instacart_Caper_Admin_V1_TriggerPipelineResponse>;
  /**
   * Triggers a new warehouse provisioning pipeline run.
   * Generates a task_id, persists a PENDING run, and initiates the pipeline
   * asynchronously. Returns immediately with the PENDING run record.
   */
  CaperDeviceProvisioningPipelineStagingService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_TriggerPipeline?: Maybe<Instacart_Caper_Admin_V1_TriggerPipelineResponse>;
  /** Sends a receipt */
  CaperIPPReceiptService_instacart_caper_admin_v1_IPPReceiptService_SendReceipt?: Maybe<Scalars['instacart_caper_admin_v1_SendReceiptResponse']>;
  /** CreateStoreStaffBarcode creates a new store staff barcode entry. */
  CaperIPPStoreStaffBarcodeService_instacart_caper_admin_v1_IPPStoreStaffBarcodeService_CreateStoreStaffBarcode?: Maybe<Instacart_Caper_Admin_V1_CreateStoreStaffBarcodeResponse>;
  /** EditStoreStaffBarcode updates an existing store staff barcode entry. */
  CaperIPPStoreStaffBarcodeService_instacart_caper_admin_v1_IPPStoreStaffBarcodeService_EditStoreStaffBarcode?: Maybe<Scalars['instacart_caper_admin_v1_EditStoreStaffBarcodeResponse']>;
  /** Reviews a specific NOF item with category and sub-category */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_ReviewNof?: Maybe<Scalars['instacart_caper_admin_v1_ReviewNofResponse']>;
  /** Reviews a specific NOF item with category and sub-category */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_ReviewNof?: Maybe<Scalars['instacart_caper_admin_v1_ReviewNofResponse']>;
  /** Creates a new merchant for a store with optional terminals. */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_CreateMerchant?: Maybe<Instacart_Caper_Admin_V1_CreateMerchantResponse>;
  /** Creates payment terminals for devices in a store (partial-success semantics). */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_CreateTerminals?: Maybe<Instacart_Caper_Admin_V1_CreateTerminalsResponse>;
  /** Transfers terminal credentials from one device to another (device replacement). */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_TransferTerminal?: Maybe<Instacart_Caper_Admin_V1_TransferTerminalResponse>;
  /** Creates a new merchant for a store with optional terminals. */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_CreateMerchant?: Maybe<Instacart_Caper_Admin_V1_CreateMerchantResponse>;
  /** Creates payment terminals for devices in a store (partial-success semantics). */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_CreateTerminals?: Maybe<Instacart_Caper_Admin_V1_CreateTerminalsResponse>;
  /** Transfers terminal credentials from one device to another (device replacement). */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_TransferTerminal?: Maybe<Instacart_Caper_Admin_V1_TransferTerminalResponse>;
  /** Initiates async datadog triage summary generation */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_CreateDatadogSummaryAsync?: Maybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncResponse>;
  /** Initiates async session summary generation */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_CreateSessionSummaryAsync?: Maybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncResponse>;
  /** Updates feedback and rating for an existing session summary */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_UpdateSessionSummaryFeedback?: Maybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackResponse>;
  /** Initiates async datadog triage summary generation */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_CreateDatadogSummaryAsync?: Maybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncResponse>;
  /** Initiates async session summary generation */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_CreateSessionSummaryAsync?: Maybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncResponse>;
  /** Updates feedback and rating for an existing session summary */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_UpdateSessionSummaryFeedback?: Maybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackResponse>;
  CartAssistant_instacart_customers_sage_v1_SageService_CreateSessionPreviewToken?: Maybe<Instacart_Customers_Sage_V1_CreateSessionPreviewTokenResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunCarouselGroupQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunContentDesignQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunFilterQualityQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunKeywordCompletenessQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunKeywordQualityQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunPageQualityQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunPolicyQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunProductQualityQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunRetailerCollectionQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunRetailerCollectionQaResponse>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_RunTopicQualityQa?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaResponse>;
  /** Records a retailer acknowledgment of the incident. Can be called multiple times; each call creates a new ACK record and updates isAcknowledged/acknowledgedAt on the incident meta. */
  EnterpriseStatusPage_acknowledgeIncident?: Maybe<EnterpriseStatusPage_AcknowledgeIncident_Response>;
  /** Add a user to a group */
  EnterpriseStatusPage_addUserToGroup?: Maybe<EnterpriseStatusPage_AddUserToGroup_Response>;
  /** Creates the component and a lookup record for O(1) access by component ID */
  EnterpriseStatusPage_createComponent?: Maybe<EnterpriseStatusPage_CreateComponent_Response>;
  /** Create a component group */
  EnterpriseStatusPage_createComponentGroup?: Maybe<EnterpriseStatusPage_CreateComponentGroup_Response>;
  /** Creates an incident, initial update, and component links. Creates an incident and saves retailer contact snapshots for future notifications. Pass retailerContacts fetched from retailer-contact-management; contacts are saved as a snapshot and notified via POST /incidents/{id}/notify-contacts or automatically on each POST /incidents/{id}/updates. Pass canonicalUserIds (optional, legacy) to trigger an immediate IPP notification on creation when non-empty and isBackfill is false. */
  EnterpriseStatusPage_createIncident?: Maybe<EnterpriseStatusPage_CreateIncident_Response>;
  /** Creates a top-level group or, when parentGroupId is provided, a sub-group under an existing top-level group. */
  EnterpriseStatusPage_createUserGroup?: Maybe<EnterpriseStatusPage_CreateUserGroup_Response>;
  /** Removes the component from the group and deletes the COMP# lookup item */
  EnterpriseStatusPage_deleteComponent?: Maybe<EnterpriseStatusPage_DeleteComponent_Response>;
  /** Deletes an incident and all its associated DynamoDB items (META, UPDATE#*, COMP#*, NOTIF#*, ACK#*). Uses BatchWrite to remove all items with the incident's partition key. */
  EnterpriseStatusPage_deleteIncident?: Maybe<EnterpriseStatusPage_DeleteIncident_Response>;
  /** Deletes a user group. Top-level groups must have no sub-groups before deletion (returns 409 if they do). Deleting a sub-group also removes all its members. */
  EnterpriseStatusPage_deleteUserGroup?: Maybe<EnterpriseStatusPage_DeleteUserGroup_Response>;
  /** Reads the retailer contact snapshots saved on the incident and sends an IPP notification to all contacts that have an ippCanonicalUserId. Returns 422 when no notifiable contacts exist. */
  EnterpriseStatusPage_notifyIncidentContacts?: Maybe<EnterpriseStatusPage_NotifyIncidentContacts_Response>;
  /** Appends an update, updates incident meta, and optionally sends IPP notification */
  EnterpriseStatusPage_postIncidentUpdate?: Maybe<EnterpriseStatusPage_PostIncidentUpdate_Response>;
  /** Given component IDs, returns partner IDs. FE uses these with enterpriseAccountSearch(partnerId) to resolve the notification audience for those components. */
  EnterpriseStatusPage_previewNotificationAudience?: Maybe<EnterpriseStatusPage_PreviewNotificationAudience_Response>;
  /** Removes the contact snapshot keyed by subGroupId from an existing incident. Idempotent — removing a non-existent entry returns deleted:false rather than 404. */
  EnterpriseStatusPage_removeIncidentRetailerContacts?: Maybe<EnterpriseStatusPage_RemoveIncidentRetailerContacts_Response>;
  /** Remove a user from a group */
  EnterpriseStatusPage_removeUserFromGroup?: Maybe<EnterpriseStatusPage_RemoveUserFromGroup_Response>;
  /** Rename a user group */
  EnterpriseStatusPage_updateUserGroup?: Maybe<EnterpriseStatusPage_UpdateUserGroup_Response>;
  /** Upserts the contact snapshot keyed by subGroupId for an existing incident. The FE sends the full subgroup identity it already holds from the group hierarchy selector. Two subgroups that share a retailerId are stored as two distinct entries. Contacts will be deduped by ippCanonicalUserId at notification time. */
  EnterpriseStatusPage_upsertIncidentRetailerContacts?: Maybe<EnterpriseStatusPage_UpsertIncidentRetailerContacts_Response>;
  /**
   * CompileTemplate transforms a template string into a TreeNode[] AST.
   * The AST is the server-authoritative representation of the template — compiling
   * server-side ensures the AST is always derived from the stored template source,
   * preventing clients from submitting arbitrary ASTs.
   */
  FrothProcessing_instacart_customers_froth_v1_FrothProcessingService_CompileTemplate?: Maybe<Instacart_Customers_Froth_V1_CompileTemplateResponse>;
  /** Create a new response configuration */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_CreateResponseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigResponse>;
  /** Delete a response configuration */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_DeleteResponseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigResponse>;
  /** Send an inbound event that would normally come from partner/retailer to Relay */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_TriggerInboundEvent?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventResponse>;
  /** Update an existing response configuration */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_UpdateResponseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigResponse>;
  /**
   * Create a new Rule with the given payload and initial attachment set.
   * Server validates content + per-attached-scope before insert; returns
   * INVALID_ARGUMENT with ValidationFinding details on failure. Supports
   * idempotent retries via idempotency_key on the request.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_CreateFulfillmentRuleConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentRuleConfigurationsResponse>;
  /**
   * Create a new Strategy with the given parameters and initial attachment set.
   * Supports idempotent retries via idempotency_key on the request.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_CreateFulfillmentStrategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentStrategyResponse>;
  /**
   * Full-replacement capability update. Uses expected_version for optimistic
   * concurrency (ABORTED on mismatch). PERMISSION_DENIED when a submitted
   * value change targets a field the caller may not write.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_UpdateFulfillmentProviderPartnerConfiguration?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationResponse>;
  /**
   * Flip status between ENABLED and DISABLED; capability values are
   * unchanged. Uses expected_version for optimistic concurrency (ABORTED on
   * mismatch).
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_UpdateFulfillmentProviderPartnerConfigurationStatus?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationStatusResponse>;
  /**
   * Edit a Rule's content (name, description, payload) and/or attachment set.
   * Client sends the complete desired state.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_UpdateFulfillmentRuleConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleConfigurationsResponse>;
  /**
   * One-click status toggle. ENABLED ↔ DISABLED reversible; setting to
   * DELETED is the soft-delete operation. Setting to the current status is a
   * no-op.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_UpdateFulfillmentRuleStatusConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleStatusConfigurationsResponse>;
  /**
   * Edit a Strategy's content (name, description, type, payload) and/or
   * attachment set. Client sends the complete desired state.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_UpdateFulfillmentStrategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyResponse>;
  /**
   * One-click status toggle. ENABLED ↔ DISABLED reversible; setting to DELETED
   * is the soft-delete operation. Setting to the current status is a no-op.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_UpdateFulfillmentStrategyStatus?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyStatusResponse>;
  /** Create strings for a resource */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_CreateStrings?: Maybe<Instacart_Customers_Commerce_Garnish_V1_CreateStringsResponse>;
  /** Delete resources */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_DeleteResources?: Maybe<Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesResponse>;
  /** Update strings for a resource */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_UpdateStrings?: Maybe<Instacart_Customers_Commerce_Garnish_V1_UpdateStringsResponse>;
  /** Cancels a marketing campaign in progress */
  MarketingToolingService_instacart_growth_crm_messaging_service_v1_CRMMessagingService_CancelMarketingCampaign?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignResponse>;
  /** Sends a marketing campaign email blast */
  MarketingToolingService_instacart_growth_crm_messaging_service_v1_CRMMessagingService_CreateMarketingCampaign?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignResponse>;
  /** CancelMarketingCampaign cancels a marketing campaign and disables its associated offer. */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_CancelMarketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CancelMarketingCampaignResponse>;
  /**
   * CreateMarketingCampaign creates a new marketing campaign with all associated
   * configurations across integrated systems (targeting, messaging, discounts, experiments).
   */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_CreateMarketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignResponse>;
  /**
   * UpdateMarketingCampaign updates an existing marketing campaign and its associated
   * entities (segment, VGP, roulette experiment, CRM configuration). The update is
   * executed as a saga with LIFO rollback: every successful sub-step captures the prior
   * state of its target entity, so a downstream failure restores all already-mutated
   * entities to their pre-call state.
   */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_UpdateMarketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_UpdateMarketingCampaignResponse>;
  /**
   * CreatePublisher creates a provider/source with associated metadata.
   *
   * Returns:
   * - Created provider/source details with generated ID and slug
   * - INVALID_ARGUMENT error if required fields are missing or invalid
   * - ALREADY_EXISTS error if a provider/source with the same slug already exists
   */
  MealsIngestionService_instacart_customers_meals_services_ingestion_v1_MealsIngestionService_CreatePublisher?: Maybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreatePublisherResponse>;
  /**
   * CreateRecipe creates a new recipe with all associated data.
   *
   * Returns:
   * - Created recipe with generated ID and content hash
   * - INVALID_ARGUMENT error if required fields are missing or invalid
   * - NOT_FOUND error if the referenced provider/source id does not exist
   * - ALREADY_EXISTS error if a recipe with the same content_hash or provider_recipe_id exists for this provider/source
   */
  MealsIngestionService_instacart_customers_meals_services_ingestion_v1_MealsIngestionService_CreateRecipe?: Maybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreateRecipeResponse>;
  /**
   * ResetPublisherAndRecipe replaces all mutable publisher and recipe data atomically.
   * recipe_raw_ingredients rows and their overrides are preserved.
   *
   * Returns:
   * - Updated publisher and recipe on success
   * - INVALID_ARGUMENT if required fields are missing or any permission action is ACTION_UNSPECIFIED
   * - NOT_FOUND if publisher_id or recipe_id does not exist, or recipe is not owned by publisher
   * - INTERNAL on unexpected storage error
   */
  MealsIngestionService_instacart_customers_meals_services_ingestion_v1_MealsIngestionService_ResetPublisherAndRecipe?: Maybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_UnifiedCreateRecipeResponse>;
  /**
   * SetPublisherPermissions upserts provider-level permission rules for an existing provider/source.
   * Rules are merged by action: incoming rules replace existing rows for the same action;
   * rows for actions not present in the request are left unchanged.
   *
   * Returns:
   * - Empty response on success
   * - INVALID_ARGUMENT error if publisher_id is empty or any permission action is ACTION_UNSPECIFIED
   * - NOT_FOUND error if the referenced provider/source id does not exist
   */
  MealsIngestionService_instacart_customers_meals_services_ingestion_v1_MealsIngestionService_SetPublisherPermissions?: Maybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetPublisherPermissionsResponse>;
  /**
   * SetRecipePermissions upserts permission rules for an existing recipe.
   * Rules are merged by action: incoming rules replace existing rows for the same action;
   * rows for actions not present in the request are left unchanged.
   *
   * Returns:
   * - Empty response on success
   * - INVALID_ARGUMENT error if recipe_id is empty or any permission action is ACTION_UNSPECIFIED
   * - NOT_FOUND error if the referenced recipe_id does not exist
   */
  MealsIngestionService_instacart_customers_meals_services_ingestion_v1_MealsIngestionService_SetRecipePermissions?: Maybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetRecipePermissionsResponse>;
  /**
   * UnifiedCreateRecipe creates a publisher and a recipe together. The
   * publisher is reused if one with the same avatar_url and source already exists. The recipe is
   * created only if no duplicate is found for this publisher (matched by
   * content_hash or provider_recipe_id); otherwise the existing recipe is
   * returned unchanged.
   *
   * Returns:
   * - Resolved publisher and created (or pre-existing) recipe on success
   * - INVALID_ARGUMENT if required fields are missing or any permission action is ACTION_UNSPECIFIED
   * - INTERNAL on unexpected storage error
   */
  MealsIngestionService_instacart_customers_meals_services_ingestion_v1_MealsIngestionService_UnifiedCreateRecipe?: Maybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_UnifiedCreateRecipeResponse>;
  /**
   * UnifiedRecipeSearch searches recipes by free-text query and optional
   * attribute filters (see RecipeSearchFilters), returning matching recipes.
   *
   * Returns:
   * - Recipes in relevance order; empty list on no match
   * - INVALID_ARGUMENT if flow_context is missing/invalid
   * - INTERNAL on search backend or database unavailability
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_UnifiedRecipeSearch?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_UnifiedRecipeSearchResponse>;
  /** Creates a new contact under the given retailer ID. Email must be unique within the retailer. */
  RetailerContactManagement_addContact?: Maybe<RetailerContactManagement_AddContact_Response>;
  /** Creates a new contact under the given partner ID. Email must be unique within the partner. */
  RetailerContactManagement_addPartnerContact?: Maybe<RetailerContactManagement_AddPartnerContact_Response>;
  /** Deletes every contact under the given retailer ID and returns the number of records removed. */
  RetailerContactManagement_deleteAllContacts?: Maybe<RetailerContactManagement_DeleteAllContacts_Response>;
  /** Deletes every contact under the given partner ID and returns the number of records removed. */
  RetailerContactManagement_deleteAllPartnerContacts?: Maybe<RetailerContactManagement_DeleteAllPartnerContacts_Response>;
  /** Deletes a single contact identified by retailer ID and email address */
  RetailerContactManagement_deleteContact?: Maybe<RetailerContactManagement_DeleteContact_Response>;
  /** Deletes a single contact identified by partner ID and email address */
  RetailerContactManagement_deletePartnerContact?: Maybe<RetailerContactManagement_DeletePartnerContact_Response>;
  /** Updates one or more fields of an existing contact. At least one field must be provided. If the email field is changed, the old record is deleted and recreated with the new email. */
  RetailerContactManagement_updateContact?: Maybe<RetailerContactManagement_UpdateContact_Response>;
  /** Updates one or more fields of an existing contact. At least one field must be provided. If the email field is changed, the old record is deleted and recreated with the new email. */
  RetailerContactManagement_updatePartnerContact?: Maybe<RetailerContactManagement_UpdatePartnerContact_Response>;
  /**
   * InitializeCampaignBrief creates a new brief and places it at the requested
   * initial state (DRAFT, TEST, PENDING_APPROVAL, or PUBLISHED). Any non-draft
   * initial state runs the full draft-to-target Saga, provisioning downstream
   * entities atomically. On failure, LIFO compensating transactions roll back
   * partial work and no brief row is persisted.
   */
  UnifiedMarketingBackendService_instacart_growth_unified_marketing_backend_v1_UnifiedMarketingBackendService_InitializeCampaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_InitializeCampaignBriefResponse>;
  /**
   * TransitionCampaignBrief advances an existing brief forward through the
   * lifecycle state machine. Skips are legal (e.g. DRAFT to PUBLISHED in one
   * call) and are composed into a single Saga. Cancel is modeled here as a
   * transition into CAMPAIGN_BRIEF_STATE_CANCELLED, reachable from any
   * non-terminal state and from PUBLISHED.
   */
  UnifiedMarketingBackendService_instacart_growth_unified_marketing_backend_v1_UnifiedMarketingBackendService_TransitionCampaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_TransitionCampaignBriefResponse>;
  /**
   * UpdateCampaignBrief updates mutable fields on an existing brief. State
   * changes are NOT permitted through this RPC; they must go through
   * TransitionCampaignBrief. A field_mask that includes "state" is rejected
   * with INVALID_ARGUMENT; when field_mask is unset, the state value on the
   * payload is ignored.
   */
  UnifiedMarketingBackendService_instacart_growth_unified_marketing_backend_v1_UnifiedMarketingBackendService_UpdateCampaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_UpdateCampaignBriefResponse>;
  _empty?: Maybe<Scalars['String']>;
  /** Create a new notice banner (admin only) */
  adminNoticeBannerCreate?: Maybe<AdminBannerCreatePayload>;
  /** Delete a notice banner (admin only) */
  adminNoticeBannerDelete?: Maybe<AdminBannerDeletePayload>;
  /** Update an existing notice banner (admin only) */
  adminNoticeBannerUpdate?: Maybe<AdminBannerUpdatePayload>;
  /** Upsert an AI agent conversation */
  aiAgentConversationUpsert?: Maybe<AiAgentConversationUpsertPayload>;
  aiAgentExecute: AgentResponse;
  apiIntegrationsServiceDeleteApiSetting?: Maybe<DeleteApiSettingResponse>;
  apiIntegrationsServiceUpdateApiSetting?: Maybe<UpdateApiSettingResponse>;
  /** Adds a review to an approval request. */
  approvalsManagementAddReview?: Maybe<ReviewAddPayload>;
  /** Deletes an existing review. */
  approvalsManagementDeleteReview?: Maybe<ReviewDeletePayload>;
  /** Edits an existing review. */
  approvalsManagementEditReview?: Maybe<ReviewEditPayload>;
  /** Publishes an approved approval request. */
  approvalsManagementPublishApprovalRequest?: Maybe<PublishApprovalRequestPayload>;
  /** Assign a permission to a role */
  assignPermissionToRole?: Maybe<AssignPermissionToRolePayload>;
  /** Disable an enterprise account and associated alias accounts by its email */
  botEnterpriseAccountDisable?: Maybe<BotEnterpriseAccountDisablePayload>;
  /** Create/update a new enterprise account by its email */
  botEnterpriseAccountUpsert?: Maybe<BotEnterpriseAccountUpsertPayload>;
  /** Grant sensitive access (protected roles, SOX-tier roles, and/or all-partners write) after the Slackbot's approver matrix has been satisfied. */
  botGrantSensitiveAccess?: Maybe<BotGrantSensitiveAccessPayload>;
  catalogProblemTrackerServiceCreateTicket?: Maybe<CreateTicketResponse>;
  catalogToolsApiServiceCreateMassOpsIntervention?: Maybe<CreateMassOpsInterventionResponse>;
  catalogToolsApiServiceCreatePatchApproval?: Maybe<CreatePatchApprovalResponse>;
  catalogToolsApiServiceCreatePriceAnomalyInvestigation?: Maybe<CreatePriceAnomalyInvestigationResponse>;
  catalogToolsApiServiceCreatePriceAnomalyPatch?: Maybe<CreatePriceAnomalyPatchResponse>;
  catalogToolsApiServiceCreateProductWithProductCreationData?: Maybe<CreateProductWithProductCreationDataResponse>;
  catalogToolsApiServiceDeactivatePriceAnomalyPatch?: Maybe<DeactivatePriceAnomalyPatchResponse>;
  catalogToolsApiServiceGenerateProductCreationData?: Maybe<GenerateProductCreationDataResponse>;
  catalogToolsApiServiceRefreshAffectedOrders?: Maybe<RefreshAffectedOrdersResponse>;
  collectionsServiceSetMultiRetailerPageCollectionsCache?: Maybe<SetMultiRetailerPageCollectionsCacheResponse>;
  configurableItemsServicePublishRppConfigurableItems?: Maybe<PublishRppConfigurableItemsResponse>;
  connectPlatformServiceAdvanceBatchState?: Maybe<AdvanceBatchStateResponse>;
  connectPlatformServiceAssignVirtualBatch?: Maybe<AssignVirtualBatchResponse>;
  connectPlatformServiceCreateDriver?: Maybe<CreateDriverResponse>;
  connectPlatformServiceCreatePartnerApiKey?: Maybe<ConnectApiKey>;
  connectPlatformServiceGenerateBatch?: Maybe<GenerateBatchResponse>;
  connectPlatformServiceRevokePartnerApiKey?: Maybe<RevokePartnerApiKeyResponse>;
  connectPlatformServiceUpdateShopperOrderItem?: Maybe<UpdateShopperOrderItemResponse>;
  contentManagementAdminServiceBatchUpdateSlotCreatives?: Maybe<BatchUpdateSlotCreativesResponse>;
  contentManagementAdminServiceCreateAiCarousel?: Maybe<CreateAiCarouselResponse>;
  contentManagementAdminServiceCreateContentPage?: Maybe<CreateContentPageResponse>;
  contentManagementAdminServiceCreateContentPageV2?: Maybe<CreateContentPageResponseV2>;
  contentManagementAdminServiceCreateContentPageVersion?: Maybe<CreateContentPageVersionResponse>;
  contentManagementAdminServiceCreateContentPageVersionMeta?: Maybe<CreateContentPageVersionMetaResponse>;
  contentManagementAdminServiceCreateCreativePlacements?: Maybe<CreateCreativePlacementsResponse>;
  contentManagementAdminServiceCreateDefaultNavigationsV2?: Maybe<CreateDefaultNavigationsV2Response>;
  contentManagementAdminServiceCreateFrothTemplate?: Maybe<CreateFrothTemplateResponse>;
  contentManagementAdminServiceCreateFrothTemplateVersion?: Maybe<CreateFrothTemplateVersionResponse>;
  contentManagementAdminServiceCreateNativeTabBarNavigation?: Maybe<CreateNativeTabBarNavigationResponse>;
  contentManagementAdminServiceCreateNavigation?: Maybe<CreateNavigationResponse>;
  contentManagementAdminServiceCreateNavigationPreview?: Maybe<CreateNavigationPreviewResponse>;
  contentManagementAdminServiceCreateNavigationV2Preview?: Maybe<CreateNavigationV2PreviewResponse>;
  contentManagementAdminServiceCreatePlacementContent?: Maybe<CreatePlacementContentResponse>;
  contentManagementAdminServiceCreateSlot?: Maybe<CreateSlotResponse>;
  contentManagementAdminServiceCreateSlotCreative?: Maybe<CreateSlotCreativeResponse>;
  contentManagementAdminServiceCreateSlotPlacement?: Maybe<CreateSlotPlacementResponse>;
  contentManagementAdminServiceDeleteContentPage?: Maybe<DeleteContentPageResponse>;
  contentManagementAdminServiceDeleteContentPageVersion?: Maybe<DeleteContentPageVersionResponse>;
  contentManagementAdminServiceDeleteFrothTemplate?: Maybe<DeleteFrothTemplateResponse>;
  contentManagementAdminServiceDeleteFrothTemplateVersion?: Maybe<DeleteFrothTemplateVersionResponse>;
  contentManagementAdminServiceDeleteNativeTabBarNavigation?: Maybe<DeleteNativeTabBarNavigationResponse>;
  contentManagementAdminServiceDeleteNavigation?: Maybe<DeleteNavigationResponse>;
  contentManagementAdminServiceDeleteSlot?: Maybe<DeleteSlotResponse>;
  contentManagementAdminServiceDeleteSlotCreative?: Maybe<DeleteSlotCreativeResponse>;
  contentManagementAdminServiceDisablePlacementContent?: Maybe<DisablePlacementContentResponse>;
  contentManagementAdminServiceDuplicateContentPage?: Maybe<DuplicateContentPageResponse>;
  contentManagementAdminServiceLoadOrCreateDraft?: Maybe<LoadOrCreateDraftResponse>;
  contentManagementAdminServicePublishContentPageVersion?: Maybe<PublishContentPageVersionResponse>;
  contentManagementAdminServicePublishFrothTemplateVersion?: Maybe<PublishFrothTemplateVersionResponse>;
  contentManagementAdminServiceResetDraftVersion?: Maybe<ResetDraftVersionResponse>;
  contentManagementAdminServiceRestoreContentPage?: Maybe<RestoreContentPageResponse>;
  contentManagementAdminServiceSaveToolingShortcuts?: Maybe<SaveToolingShortcutsResponse>;
  contentManagementAdminServiceSchedulePublishVersion?: Maybe<SchedulePublishVersionResponse>;
  contentManagementAdminServiceStartConvertPlacementVideo?: Maybe<StartConvertPlacementVideoResponse>;
  contentManagementAdminServiceUpdateAdminNavigationV2?: Maybe<UpdateAdminNavigationV2Response>;
  contentManagementAdminServiceUpdateContentPageV2?: Maybe<UpdateContentPageResponseV2>;
  contentManagementAdminServiceUpdateContentPageVersion?: Maybe<UpdateContentPageVersionResponse>;
  contentManagementAdminServiceUpdateContentPageVersionMeta?: Maybe<UpdateContentPageVersionMetaResponse>;
  contentManagementAdminServiceUpdateFrothTemplate?: Maybe<UpdateFrothTemplateResponse>;
  contentManagementAdminServiceUpdateFrothTemplateVersion?: Maybe<UpdateFrothTemplateVersionResponse>;
  contentManagementAdminServiceUpdateNativeTabBarNavigation?: Maybe<UpdateNativeTabBarNavigationResponse>;
  contentManagementAdminServiceUpdateNavigation?: Maybe<UpdateNavigationResponse>;
  contentManagementAdminServiceUpdatePlacementContent?: Maybe<UpdatePlacementContentResponse>;
  contentManagementAdminServiceUpdateSocialIconsNavigation?: Maybe<UpdateSocialIconsNavigationResponse>;
  contentManagementServiceBatchUpdatePlacements?: Maybe<PlacementsResponse>;
  contentManagementServiceCreateLayoutVariant?: Maybe<CreateLayoutVariantResponse>;
  contentManagementServiceCreatePlacement?: Maybe<CreatePlacementResponse>;
  contentManagementServiceCreateThemePage?: Maybe<CreateThemePageResponse>;
  contentManagementServiceDeleteLayoutVariant?: Maybe<DeleteLayoutVariantResponse>;
  contentManagementServiceDeletePlacement?: Maybe<DeletePlacementResponse>;
  contentManagementServiceDisableThemePage?: Maybe<DisableThemePageResponse>;
  contentManagementServiceUpdateLayoutVariant?: Maybe<UpdateLayoutVariantResponse>;
  contentManagementServiceUpdateThemePage?: Maybe<UpdateThemePageResponse>;
  /** Create a CountryIds visibility condition */
  countryIdsVisibilityConditionCreate?: Maybe<CountryIdsVisibilityConditionCreatePayload>;
  /** Update a CountryIds visibility condition */
  countryIdsVisibilityConditionUpdate?: Maybe<CountryIdsVisibilityConditionUpdatePayload>;
  /** Create a ExpressMembership visibility condition */
  dayOfWeekVisibilityConditionCreate?: Maybe<DayOfWeekVisibilityConditionCreatePayload>;
  /** Update an existing ShoppedAtRetailer visibility condition */
  dayOfWeekVisibilityConditionUpdate?: Maybe<DayOfWeekVisibilityConditionUpdatePayload>;
  demeterServiceAuditDetection?: Maybe<AuditDetectionResponse>;
  demeterServiceBulkUpdateAuditTasks?: Maybe<BulkUpdateAuditTasksResponse>;
  demeterServiceCombineAuditBatches?: Maybe<CombineAuditBatchesResponse>;
  demeterServiceCreateAuditWorkflow?: Maybe<CreateAuditWorkflowResponse>;
  demeterServiceCreateDetection?: Maybe<CreateDetectionResponse>;
  demeterServiceCreateDetectionVersion?: Maybe<CreateDetectionVersionResponse>;
  demeterServiceReassignAuditBatchWorkflow?: Maybe<ReassignAuditBatchWorkflowResponse>;
  demeterServiceTombstoneDetectionVersion?: Maybe<TombstoneDetectionVersionResponse>;
  demeterServiceUpdateAuditBatch?: Maybe<UpdateAuditBatchResponse>;
  demeterServiceUpdateAuditTask?: Maybe<UpdateAuditTaskResponse>;
  demeterServiceUpdateAuditWorkflow?: Maybe<UpdateAuditWorkflowResponse>;
  emergingBrandPortalServiceContactBrand?: Maybe<BrandContactResponse>;
  /** Accept a partner agreement for the current account */
  enterpriseAccountAcceptPartnerAgreement?: Maybe<EnterpriseAccountAcceptPartnerAgreementPayload>;
  /** Set up a new account using an account setup token */
  enterpriseAccountAccountSetup?: Maybe<EnterpriseAccountAccountSetupPayload>;
  /** Authenticate an account using an email and password */
  enterpriseAccountAuthenticateEmailPassword?: Maybe<EnterpriseAccountAuthenticateEmailPasswordPayload>;
  /** Preflight authentication info per email address */
  enterpriseAccountAuthenticatePreflight?: Maybe<EnterpriseAccountAuthenticatePreflightPayload>;
  /** Create a new enterprise account */
  enterpriseAccountCreate?: Maybe<EnterpriseAccountCreatePayload>;
  /** Create a new enterprise account that can only access documentation */
  enterpriseAccountCreateNoPartnerAccess?: Maybe<EnterpriseAccountCreateNoPartnerAccessPayload>;
  /** Disable the impersonation for the current account */
  enterpriseAccountDisableImpersonation?: Maybe<EnterpriseAccountDisableImpersonationPayload>;
  /** Enable impersonation for the current account */
  enterpriseAccountEnableImpersonation?: Maybe<EnterpriseAccountEnableImpersonationPayload>;
  /** Deactivate MFA for an account */
  enterpriseAccountMfaDeactivate?: Maybe<EnterpriseAccountMfaDeactivatePayload>;
  /** Enable MFA for an account */
  enterpriseAccountMfaEnable?: Maybe<EnterpriseAccountMfaEnablePayload>;
  /** Reset MFA for an account */
  enterpriseAccountMfaReset?: Maybe<EnterpriseAccountMfaResetPayload>;
  /** Partner Onboarding new account token request, generate new email that will be sent to an Account's email address */
  enterpriseAccountPartnerOnboardingRequestAccountSetupEmail?: Maybe<EnterpriseAccountPartnerOnboardingRequestAccountSetupEmailPayload>;
  /** Request that an account setup email be sent to an Account's email address */
  enterpriseAccountRequestAccountSetupEmail?: Maybe<EnterpriseAccountRequestAccountSetupEmailPayload>;
  /** Request for partner write access for a specific partner */
  enterpriseAccountRequestBreakGlassPartnerWriteAccess?: Maybe<EnterpriseAccountRequestBreakGlassPartnerWriteAccessPayload>;
  /** Request that a verification email be sent to an Account's email address */
  enterpriseAccountRequestEmailVerification?: Maybe<EnterpriseAccountRequestEmailVerificationPayload>;
  /** Set/Reset an account's password using a password reset token */
  enterpriseAccountResetPassword?: Maybe<EnterpriseAccountResetPasswordPayload>;
  /** Sets the disabled flag on an account to true/false */
  enterpriseAccountSetDisabled?: Maybe<EnterpriseAccountSetDisabledPayload>;
  /** Update an enterprise account */
  enterpriseAccountUpdate?: Maybe<EnterpriseAccountUpdatePayload>;
  /** Updates the hidden settings for an account */
  enterpriseAccountUpdateHiddenSettings?: Maybe<EnterpriseAccountUpdateHiddenSettingsPayload>;
  /** Update the password for the currently logged-in account */
  enterpriseAccountUpdatePassword?: Maybe<EnterpriseAccountUpdatePasswordPayload>;
  /** Update an enterprise account's roles */
  enterpriseAccountUpdateRoles?: Maybe<EnterpriseAccountUpdateRolesPayload>;
  /** Updates the user locale for an account */
  enterpriseAccountUpdateUserLocale?: Maybe<EnterpriseAccountUpdateUserLocalePayload>;
  /** Verify an account via account setup token */
  enterpriseAccountVerifyAccountSetupToken?: Maybe<EnterpriseAccountVerifyAccountSetupTokenPayload>;
  /** Verify an account's email using a verification token */
  enterpriseAccountVerifyEmail?: Maybe<EnterpriseAccountVerifyEmailPayload>;
  /** Create a ExperimentVariant visibility condition */
  experimentVariantVisibilityConditionCreate?: Maybe<ExperimentVariantVisibilityConditionCreatePayload>;
  /** Update a ExperimentVariant visibility condition */
  experimentVariantVisibilityConditionUpdate?: Maybe<ExperimentVariantVisibilityConditionUpdatePayload>;
  /** Create a ExpressMembership visibility condition */
  expressMembershipVisibilityConditionCreate?: Maybe<ExpressMembershipVisibilityConditionCreatePayload>;
  /** Update an existing ExpressMembership visibility condition */
  expressMembershipVisibilityConditionUpdate?: Maybe<ExpressMembershipVisibilityConditionUpdatePayload>;
  /** Create an ExpressNonmemberLongTermHoldout visibility condition */
  expressNonmemberLongTermHoldoutVisibilityConditionCreate?: Maybe<ExpressNonmemberLongTermHoldoutVisibilityConditionCreatePayload>;
  /** Create a new flyout placement */
  flyoutPlacementCreate?: Maybe<FlyoutPlacementCreatePayload>;
  /** Update an existing flyout placement */
  flyoutPlacementUpdate?: Maybe<FlyoutPlacementUpdatePayload>;
  /** Create a new home placement with HeroBanner banner */
  heroBannerPlacementCreate?: Maybe<HeroBannerPlacementCreatePayload>;
  /** Update an existing hero_banner placement placement */
  heroBannerPlacementUpdate?: Maybe<HeroBannerPlacementUpdatePayload>;
  instacart_ads_nexus_v1_AdsBlockingService_UpsertAdReview?: Maybe<Instacart_Ads_Nexus_V1_UpsertAdReviewsResponse>;
  /** Creates a segment based on user intention using generative AI */
  instacart_ads_platform_taas_v1_SegmentRegistryService_CreateGenerativeAudienceSegmentDefinition?: Maybe<Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentResponse>;
  /**
   * CREATE
   *
   * The response will have a newly-minted ID, which always have version_number
   * 1, and the definition will be the same as what was passed in the request.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_CreateSegment?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  /**
   * DELETE
   *
   * The response will have the version number one greater than the request,
   * and the definition will be empty.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_DeleteSegment?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  /**
   * ESTIMATE AUDIENCE
   *
   * Returns estimated audience size metrics for a given targeting rule,
   * universe, context, and campaign type.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_EstimateAudience?: Maybe<Instacart_Ads_Platform_Taas_V1_EstimateAudienceResponse>;
  /**
   * SUBMIT EXACT AUDIENCE SIZE
   *
   * Enqueues an async job to compute an exact audience size for a targeting rule.
   * Returns a job_key immediately; poll GetExactAudienceSize with the job_key to retrieve results.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_SubmitExactAudienceSize?: Maybe<Instacart_Ads_Platform_Taas_V1_SubmitExactAudienceSizeResponse>;
  /**
   * UDPATE
   *
   * The response will have the version number one greater than the request,
   * and the definition will be the same as what was passed in the request.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_UpdateSegment?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  instacart_ads_v3_RetailerBlockedAdsService_RetailerBlockAd?: Maybe<Instacart_Ads_V3_RetailerBlockAdResponse>;
  instacart_ads_v3_RetailerBlockedAdsService_RetailerBlockAdBySha256?: Maybe<Instacart_Ads_V3_RetailerBlockAdResponse>;
  /** Creates a new carousel based on a user prompt and other criteria. */
  instacart_algorithms_ai_carousel_creator_v1_AiCarouselCreatorService_CreateCarousel?: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselResponse>;
  /** Creates a carousel with structured collection rules from a user prompt. */
  instacart_algorithms_ai_carousel_creator_v1_AiCarouselCreatorService_CreateCarouselV2?: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselV2Response>;
  /** Create a customer-MIA (customer missing) order issue. */
  instacart_care_tools_v1_AppeasementsOrchestratorService_CreateCustomerMIAIssue?: Maybe<Instacart_Care_Tools_V1_CreateCustomerMiaIssueResponse>;
  instacart_care_tools_v1_AppeasementsOrchestratorService_IssueIcPlusFreeMonth?: Maybe<Instacart_Care_Tools_V1_IssueIcPlusFreeMonthResponse>;
  instacart_care_tools_v1_AppeasementsOrchestratorService_IssuePoorServiceCredit?: Maybe<Instacart_Care_Tools_V1_IssuePoorServiceCreditResponse>;
  instacart_care_tools_v1_CareToolsService_AddFreeMonthSubscription?: Maybe<Instacart_Care_Tools_V1_AddFreeMonthSubscriptionResponse>;
  /**
   * Adds or updates a fulfillment order line. Thin pass-through to
   * instacart.fulfillment.in_store.fulfillment_picking.v1.FulfillmentPickingService#AddOrUpdateFulfillmentOrderLine.
   */
  instacart_care_tools_v1_CareToolsService_AddOrUpdateFulfillmentOrderLine?: Maybe<Instacart_Care_Tools_V1_AddOrUpdateFulfillmentOrderLineResponse>;
  instacart_care_tools_v1_CareToolsService_AdminCancelSubscription?: Maybe<Instacart_Care_Tools_V1_AdminCancelSubscriptionResponse>;
  instacart_care_tools_v1_CareToolsService_CreateAddressForUser?: Maybe<Instacart_Care_Tools_V1_CreateAddressForUserResponse>;
  instacart_care_tools_v1_CareToolsService_CreateNoteForOrder?: Maybe<Instacart_Care_Tools_V1_CreateNoteForOrderResponse>;
  instacart_care_tools_v1_CareToolsService_CreateNoteForUser?: Maybe<Instacart_Care_Tools_V1_CreateNoteForUserResponse>;
  /** Creates a return for an eligible order delivery. */
  instacart_care_tools_v1_CareToolsService_CreateOrderReturn?: Maybe<Instacart_Care_Tools_V1_CreateOrderReturnResponse>;
  /** Creates a new ban between a user and a shopper. */
  instacart_care_tools_v1_CareToolsService_CreateUserShopperBan?: Maybe<Instacart_Care_Tools_V1_CreateUserShopperBanResponse>;
  /** Deletes a ban by ID. */
  instacart_care_tools_v1_CareToolsService_DeleteUserShopperBan?: Maybe<Scalars['instacart_care_tools_v1_DeleteUserShopperBanResponse']>;
  /** Force completes an order delivery (e.g. when it is stuck in a terminal-ish state). */
  instacart_care_tools_v1_CareToolsService_ForceCompleteOrder?: Maybe<Scalars['instacart_care_tools_v1_ForceCompleteOrderResponse']>;
  instacart_care_tools_v1_CareToolsService_LinkIsolatedUser?: Maybe<Instacart_Care_Tools_V1_LinkIsolatedUserResponse>;
  instacart_care_tools_v1_CareToolsService_UnlinkIsolatedUser?: Maybe<Instacart_Care_Tools_V1_UnlinkIsolatedUserResponse>;
  instacart_care_tools_v1_CareToolsService_UpdateAddressForUser?: Maybe<Instacart_Care_Tools_V1_UpdateAddressForUserResponse>;
  instacart_care_tools_v1_CareToolsService_UpdateSubscriptionAutorenew?: Maybe<Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewResponse>;
  instacart_care_tools_v1_CareToolsService_UpdateUserName?: Maybe<Instacart_Care_Tools_V1_UpdateUserNameResponse>;
  instacart_care_tools_v1_CareToolsService_UpdateUserPhone?: Maybe<Instacart_Care_Tools_V1_UpdateUserPhoneResponse>;
  /** The SetAuditFindings API persists audit findings */
  instacart_cashflow_nutella_v1_NutellaService_SetAuditFindings?: Maybe<Instacart_Cashflow_Nutella_V1_SetAuditFindingsResponse>;
  /** GetMissingCodesForcemarkDetails retrieves missing codes forcemark details for a specific forcemark. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_MakeMissingCodeDecision?: Maybe<Scalars['instacart_catalog_admin_v1_MakeMissingCodeDecisionResponse']>;
  /** SetRetailerDiscountThresholdBringBacks will bring back any selected items that were taken down due to this tool */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_SetRetailerDiscountThresholdBringBacks?: Maybe<Scalars['instacart_catalog_admin_v1_SetRetailerDiscountThresholdBringBacksResponse']>;
  /** SetRetailerDiscountThresholds sets retailer discount thresholds in the db for a particular retailer */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_SetRetailerDiscountThresholds?: Maybe<Scalars['instacart_catalog_admin_v1_SetRetailerDiscountThresholdsResponse']>;
  /** ApplyChangeRequest applies an approved change request to source_priorities. Restricted to the original submitter. */
  instacart_catalog_admin_v1_SourcePriorityService_ApplyChangeRequest?: Maybe<Scalars['instacart_catalog_admin_v1_ApplyChangeRequestResponse']>;
  /** ApproveChangeRequest transitions a change request from pending_review to approved. Restricted to source_priority_admin. */
  instacart_catalog_admin_v1_SourcePriorityService_ApproveChangeRequest?: Maybe<Scalars['instacart_catalog_admin_v1_ApproveChangeRequestResponse']>;
  /** CancelChangeRequest withdraws a change request from pending_review. Restricted to the original submitter. */
  instacart_catalog_admin_v1_SourcePriorityService_CancelChangeRequest?: Maybe<Scalars['instacart_catalog_admin_v1_CancelChangeRequestResponse']>;
  /** CreateChangeRequest creates a new change request for a create or edit operation and triggers impact analysis. */
  instacart_catalog_admin_v1_SourcePriorityService_CreateChangeRequest?: Maybe<Instacart_Catalog_Admin_V1_CreateChangeRequestResponse>;
  /** RejectChangeRequest transitions a change request from pending_review to rejected. Restricted to source_priority_admin. */
  instacart_catalog_admin_v1_SourcePriorityService_RejectChangeRequest?: Maybe<Scalars['instacart_catalog_admin_v1_RejectChangeRequestResponse']>;
  /** RetryAnalysis re-triggers impact analysis for a change request in analysis_failed state. */
  instacart_catalog_admin_v1_SourcePriorityService_RetryAnalysis?: Maybe<Scalars['instacart_catalog_admin_v1_RetryAnalysisResponse']>;
  /** RollbackChangeRequest cancels an in-progress staged rollout and transitions the change request to rolled_back. */
  instacart_catalog_admin_v1_SourcePriorityService_RollbackChangeRequest?: Maybe<Scalars['instacart_catalog_admin_v1_RollbackChangeRequestResponse']>;
  /** Create Item Bring Back Requests from a CSV uploaded to Filestack */
  instacart_catalog_admin_v1_TakeDownService_ItemBringBackBatchCsv?: Maybe<Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvResponse>;
  /** Create a temporary override for a retailer product or item. */
  instacart_catalog_admin_v1_TempOverrideService_Create?: Maybe<Scalars['instacart_catalog_admin_v1_TempOverrideServiceCreateResponse']>;
  /** CAMP Pipeline Step Endpoints */
  instacart_catalog_catflow_v1_CatflowAPI_CreateNewStep?: Maybe<Instacart_Catalog_Catflow_V1_CreateNewStepResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_CreateNewStepVersion?: Maybe<Instacart_Catalog_Catflow_V1_CreateNewStepVersionResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_RevertToStepVersion?: Maybe<Scalars['instacart_catalog_catflow_v1_RevertToStepVersionResponse']>;
  instacart_catalog_catflow_v1_CatflowAPI_RunManualStepTest?: Maybe<Instacart_Catalog_Catflow_V1_RunManualStepTestResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_UpdateStep?: Maybe<Scalars['instacart_catalog_catflow_v1_UpdateStepResponse']>;
  instacart_catalog_catflow_v1_CatflowAPI_UpdateStepVersionState?: Maybe<Scalars['instacart_catalog_catflow_v1_UpdateStepVersionStateResponse']>;
  /** Appends a new schema version (input + output) for a bridge */
  instacart_catalog_data_bridge_v1_DataBridgeService_AddSchemaVersion?: Maybe<Instacart_Catalog_Data_Bridge_V1_AddSchemaVersionResponse>;
  /**
   * Batch Execution APIs
   * Creates a new batch execution for a bridge
   */
  instacart_catalog_data_bridge_v1_DataBridgeService_CreateBatch?: Maybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchResponse>;
  /** Creates a new batch event for tracking batch lifecycle */
  instacart_catalog_data_bridge_v1_DataBridgeService_CreateBatchEvent?: Maybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchEventResponse>;
  /**
   * Bridge Management APIs
   * Creates a new bridge configuration for connecting data systems
   */
  instacart_catalog_data_bridge_v1_DataBridgeService_CreateBridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_CreateBridgeResponse>;
  /** Soft deletes a bridge by setting tombstoned flag */
  instacart_catalog_data_bridge_v1_DataBridgeService_DeleteBridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_DeleteBridgeResponse>;
  /** Updates an existing bridge configuration */
  instacart_catalog_data_bridge_v1_DataBridgeService_UpdateBridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_UpdateBridgeResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_CreateBusinessProgram?: Maybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_CreateBusinessProgramContent?: Maybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_CreateBusinessProgramOffer?: Maybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_DeleteBusinessProgram?: Maybe<Scalars['instacart_customers_business_admin_v1_DeleteBusinessProgramResponse']>;
  instacart_customers_business_admin_v1_BusinessAdminService_DeleteBusinessProgramContent?: Maybe<Scalars['instacart_customers_business_admin_v1_DeleteBusinessProgramContentResponse']>;
  instacart_customers_business_admin_v1_BusinessAdminService_DeleteBusinessProgramOffer?: Maybe<Scalars['instacart_customers_business_admin_v1_DeleteBusinessProgramOfferResponse']>;
  instacart_customers_business_admin_v1_BusinessAdminService_UpdateBusinessProgram?: Maybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_UpdateBusinessProgramContent?: Maybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_UpdateBusinessProgramOffer?: Maybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferResponse>;
  instacart_customers_campaigns_v1_CampaignsService_BulkUpdateCampaignSlotRanking?: Maybe<Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingResponse>;
  instacart_customers_campaigns_v1_CampaignsService_MarketingAgentCalculatePerformanceMetrics?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ProcessEmailCsv?: Maybe<Instacart_Customers_Campaigns_V1_ProcessEmailCsvResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ProcessMemberCsv?: Maybe<Instacart_Customers_Campaigns_V1_ProcessMemberCsvResponse>;
  instacart_customers_campaigns_v1_CampaignsService_SaveMarketingAgentCampaign?: Maybe<Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignResponse>;
  instacart_customers_campaigns_v1_CampaignsService_TestOfflineCampaign?: Maybe<Scalars['instacart_customers_campaigns_v1_TestOfflineCampaignResponse']>;
  /** SetCartItems can be used to add, update or remove cart items. It calls the UpdateCartItems orchestrator used by the IC App. */
  instacart_customers_carts_v1_CartsService_SetCartItems?: Maybe<Instacart_Customers_Carts_V1_SetCartItemsResponse>;
  /**
   * Allocates a delegated checkout cart for the given user and retailer.
   * Each invocation returns a newly allocated cart_id; multiple carts may
   * exist concurrently for the same (user_id, retailer_id).
   */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_AllocateDelegatedCheckoutCart?: Maybe<Instacart_Customers_Carts_V1_AllocateDelegatedCheckoutCartResponse>;
  /** Cancels an existing delegated checkout link, invalidating the checkout link. */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_CancelDelegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_CancelDelegatedCheckoutLinkResponse>;
  /** Creates a delegated checkout link record without sending notifications. */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_CreateDelegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_CreateDelegatedCheckoutLinkResponse>;
  /** Sends notifications for an existing delegated checkout link. */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_SendDelegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_SendDelegatedCheckoutLinkResponse>;
  /** Adds, updates, or removes items on a specific DelegatedCheckout cart. */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_UpdateDelegatedCheckoutCartItems?: Maybe<Instacart_Customers_Carts_V1_UpdateDelegatedCheckoutCartItemsResponse>;
  instacart_customers_commerce_coupons_v1_CommerceCouponsService_BulkCreateChildCouponCodes?: Maybe<Scalars['instacart_customers_commerce_coupons_v1_BulkCreateChildCouponCodesResponse']>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_CreateValueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_PublishValueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_UpdateValueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyResponse>;
  instacart_customers_connect_platform_v1_ConnectPlatformService_GenerateBatch?: Maybe<Instacart_Customers_Connect_Platform_V1_GenerateBatchResponse>;
  instacart_customers_connect_platform_v1_ConnectPlatformService_UpdateShopperOrderItem?: Maybe<Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_AddRetailerCampaignTreatments?: Maybe<Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CancelMoment?: Maybe<Instacart_Customers_Coupons_V1_CancelMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CancelRetailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_CancelRetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CreateMoment?: Maybe<Instacart_Customers_Coupons_V1_CreateMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_CreateRetailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateCampaignBudget?: Maybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateMoment?: Maybe<Instacart_Customers_Coupons_V1_UpdateMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateMomentCampaignStatus?: Maybe<Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateRetailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_UpdateRetailerCampaignTreatments?: Maybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsResponse>;
  /** Run the ruleset */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_EvaluateRuleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse>;
  /** Publish rule set run results to flyer service */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_PublishRuleSetRunResults?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsResponse>;
  /** Updates/Creates a rule set */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_UpdateRuleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetResponse>;
  /** Creates a new gift order digital card */
  instacart_customers_gifting_v1_GiftOrderDigitalCardService_CreateGiftOrderDigitalCard?: Maybe<Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardResponse>;
  /** Updates an existing gift order digital card */
  instacart_customers_gifting_v1_GiftOrderDigitalCardService_UpdateGiftOrderDigitalCard?: Maybe<Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardResponse>;
  /** Create a loyalty benefit for a program. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_CreateLoyaltyBenefit?: Maybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitResponse>;
  /** Create a loyalty card validation. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_CreateLoyaltyCardValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationResponse>;
  /** Create a loyalty program for a retailer. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_CreateLoyaltyProgram?: Maybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramResponse>;
  /** Delete a loyalty card validation. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_DeleteLoyaltyCardValidation?: Maybe<Scalars['instacart_customers_loyalty_admin_v1_DeleteLoyaltyCardValidationResponse']>;
  /** Update a loyalty benefit for a program. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_UpdateLoyaltyBenefit?: Maybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitResponse>;
  /** Update a loyalty card validation. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_UpdateLoyaltyCardValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationResponse>;
  /** Update a loyalty program for a retailer. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_UpdateLoyaltyProgram?: Maybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramResponse>;
  instacart_customers_partners_v1_PartnersService_CreateOrUpdatePartner?: Maybe<Instacart_Customers_Partners_V1_CreateOrUpdatePartnerResponse>;
  instacart_customers_partnership_offer_v1_PartnershipOfferService_CreateRedemptionUrls?: Maybe<Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsResponse>;
  instacart_customers_payments_v1_PaymentsService_CreateStripeConnectedAccountOnboardingLink?: Maybe<Instacart_Customers_Payments_V1_CreateStripeConnectedAccountOnboardingLinkResponse>;
  instacart_customers_recipes_v1_RecipesService_BulkUpdateRecipes?: Maybe<Instacart_Customers_Recipes_V1_BulkUpdateRecipesResponse>;
  instacart_customers_recipes_v1_RecipesService_UpdateRecipes?: Maybe<Instacart_Customers_Recipes_V1_UpdateRecipesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CloneFlyerContentPage?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CloneFlyerContentPageResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CopyFlyerClickableAreas?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CreateFlyerActivity?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CreateFlyerClickableArea?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CreateOrUpdateFlyerMetadata?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_DeleteFlyerClickableAreas?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_ProcessFlyerIngestionFileUpload?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_TriggerFlyerSync?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyerActivity?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyerClickableArea?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyerPages?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerPagesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_UpdateFlyers?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateFeaturedCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFeaturedCollectionSetResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateGlobalCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateInvfMapping?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_CreateRootNode?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteFeaturedCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFeaturedCollectionSetResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteGlobalCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteInvfMapping?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DeleteNavigationNode?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_DuplicateDepartment?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_OrderNavigationNodes?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_QueueNavigationMigration?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateCollectionProducts?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateFeaturedCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFeaturedCollectionSetResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateGlobalCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpdateNavigationConfiguration?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_UpsertNavigationNode?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeResponse>;
  instacart_customers_retailer_management_orchestrator_v1_RetailerManagementService_DeleteIppDraft?: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftResponse>;
  instacart_customers_retailer_management_orchestrator_v1_RetailerManagementService_PublishIppDraft?: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftResponse>;
  instacart_customers_retailer_management_orchestrator_v1_RetailerManagementService_RevertIppDraft?: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_CreateIppDraft?: Maybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_DeleteIppDraft?: Maybe<Instacart_Customers_Retailer_Management_V1_DeleteIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_PublishIppDraft?: Maybe<Instacart_Customers_Retailer_Management_V1_PublishIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_RevertIppDraft?: Maybe<Instacart_Customers_Retailer_Management_V1_RevertIppDraftResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_UpdateIppDraftContent?: Maybe<Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentResponse>;
  instacart_customers_retailer_management_v1_IppDraftPreviewService_CreateIppDraftPreview?: Maybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewResponse>;
  /** Enable CMS site widgets for a store configuration */
  instacart_customers_retailer_management_v1_WidgetConfigurationService_EnableCmsSiteWidgets?: Maybe<Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsResponse>;
  /** Update a client configuration */
  instacart_customers_retailer_management_v1_WidgetConfigurationService_UpdateClientConfiguration?: Maybe<Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationResponse>;
  instacart_customers_search_v1_SearchService_CreateOrUpdateSearchTermOverrides?: Maybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesResponse>;
  instacart_customers_search_v1_SearchService_DeleteSearchTermOverridesById?: Maybe<Scalars['instacart_customers_search_v1_DeleteSearchTermOverridesByIdResponse']>;
  /** Cancels a partner bulk delivery route and transfers all orders to specified destinations. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_CancelPartnerBulkDeliveryRoute?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelPartnerBulkDeliveryRouteResponse>;
  /** Updates a partner bulk delivery route with reordering and/or transfer operations. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_UpdatePartnerBulkDeliveryRoute?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdatePartnerBulkDeliveryRouteResponse>;
  /** Creates a new vehicle for a warehouse location. */
  instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehiclesService_CreateWarehouseLocationVehicle?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleResponse>;
  /** Updates an existing warehouse location vehicle. */
  instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehiclesService_UpdateWarehouseLocationVehicle?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleResponse>;
  /** Process an adjustment request (e.g. a refund) */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_AdjustDashboardOrder?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderResponse>;
  /** Cancels an order via an OrderCancellationPolicy. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_CancelDashboardOrder?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderResponse>;
  /** Force-completes an order. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_ForceCompleteDashboardOrder?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_ForceCompleteDashboardOrderResponse>;
  /** Mark an order item as found or not found during active picking. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_MarkOrderItemStatus?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusResponse>;
  /** Reschedules an order via an OrderReschedulePolicy. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_RescheduleDashboardOrder?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderResponse>;
  /** Generates a shifts report based on the provided criteria */
  instacart_enterprise_frigate_shifts_v1_BulkShiftDownloadService_GenerateShiftsReport?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportResponse>;
  /** Service for getting presigned file upload URL */
  instacart_enterprise_frigate_shifts_v1_BulkShiftUploadService_GeneratePresignedFileUploadUrl?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlResponse>;
  /** Process uploaded CSV file for shift management */
  instacart_enterprise_frigate_shifts_v1_BulkShiftUploadService_ProcessUploadedCsv?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvResponse>;
  /** Service for validating uploaded bulk shift CSV */
  instacart_enterprise_frigate_shifts_v1_BulkShiftUploadService_ValidateUploadedBulkShiftFile?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse>;
  /** Creates a new partner-managed shift (either single or recurring). */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_CreatePartnerManagedShift?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftResponse>;
  /** Deletes a partner-managed shift. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_DeletePartnerManagedShift?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftResponse>;
  /** Updates an existing partner-managed shift. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_UpdatePartnerManagedShift?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftResponse>;
  /** Unlocks a partner-managed driver's device. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShoppersService_UnlockPartnerManagedDriverDevice?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceResponse>;
  /**
   * Matches the existing Connect Platform RPC as we move this out of
   * customers-backend
   */
  instacart_enterprise_fulfillment_simulation_engine_v1_OrderSimulationService_AdvanceBatch?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchResponse>;
  /**
   * Generate a batch for the order(s)
   * Matches the existing Connect Platform RPC as we move this out of
   * customers-backend
   */
  instacart_enterprise_fulfillment_simulation_engine_v1_OrderSimulationService_GenerateBatch?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchResponse>;
  /** Create a shopper (driver) given an email, phone number and password. */
  instacart_enterprise_fulfillment_simulation_engine_v1_ShopperSimulationService_CreateShopper?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperResponse>;
  /** Updates an existing shopper order item */
  instacart_enterprise_fulfillment_simulation_engine_v1_ShopperSimulationService_UpdateShopperOrderItem?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemResponse>;
  /**
   * AddChangeRequestReview posts an approve/reject/cancel review to the AMS approval request
   * associated with a change request.
   */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_AddChangeRequestReview?: Maybe<Instacart_Eversight_Item_Price_Management_V1_AddChangeRequestReviewResponse>;
  /** CreateChangeRequest creates a new change request with cloned rules and conditions. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_CreateChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestResponse>;
  /** CreateChangeRequestRule adds a brand-new rule to an existing change request. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_CreateChangeRequestRule?: Maybe<Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestRuleResponse>;
  /** DebugAdvanceChangeRequest advances a draft or review-tier change request by one debug lifecycle step. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_DebugAdvanceChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_DebugAdvanceChangeRequestResponse>;
  /** DeleteChangeRequest deletes a change request and all its child records. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_DeleteChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_DeleteChangeRequestResponse>;
  /** DeleteChangeRequestRule removes a rule from a change request (hard-deletes new rules, soft-deletes existing ones). */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_DeleteChangeRequestRule?: Maybe<Scalars['instacart_eversight_item_price_management_v1_DeleteChangeRequestRuleResponse']>;
  /** PublishChangeRequest publishes a pending change request to ItemPricingService and flips its status to "active". */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_PublishChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_PublishChangeRequestResponse>;
  /**
   * RegenerateChangeRequestSamplePricesSnapshot drops the existing
   * sample-price snapshot for a change request and writes a fresh one
   * computed against the CR's current rules and groups.
   */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_RegenerateChangeRequestSamplePricesSnapshot?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RegenerateChangeRequestSamplePricesSnapshotResponse>;
  /** SubmitChangeRequestForReview submits a change request for AMS multi-layer approval review. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_SubmitChangeRequestForReview?: Maybe<Instacart_Eversight_Item_Price_Management_V1_SubmitChangeRequestForReviewResponse>;
  /** UpdateChangeRequest updates change request metadata using an update mask. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_UpdateChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestResponse>;
  /** UpdateChangeRequestRule modifies an existing rule within a change request. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_UpdateChangeRequestRule?: Maybe<Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestRuleResponse>;
  /** WithdrawChangeRequest manually withdraws a non-terminal change request. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_WithdrawChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_WithdrawChangeRequestResponse>;
  /** Create a secondary review for a primary step log audit */
  instacart_fulfillment_domains_transaction_integrity_v1_TransactionIntegrityService_CreateSecondaryStepLogAudit?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_CreateSecondaryStepLogAuditResponse>;
  /** Creates pending override intent and snapshots concrete zone-window targets. */
  instacart_fulfillment_shopper_incentives_v1_IncentiveBudgetOverrideService_CreateBudgetOverride?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_CreateBudgetOverrideResponse>;
  /** Applies an approval decision to pending override intent. */
  instacart_fulfillment_shopper_incentives_v1_IncentiveBudgetOverrideService_ReviewBudgetOverride?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ReviewBudgetOverrideResponse>;
  /** Create a step log audit */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_CreateStepLogAudit?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditResponse>;
  /**
   * Replay dive-and-catch for a batch for debugging purposes.
   * This runs the full dive-and-catch flow in dry-run mode
   * (EXECUTION_MODE_DRY_RUN): it performs calculations and generates logs for
   * inspection but executes no actions and persists no records.
   */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_ReplayDiveAndCatch?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayDiveAndCatchResponse>;
  /**
   * Replay reconciliation for a batch for debugging purposes.
   * This will NOT execute any reconciliation actions, but only performs
   * calculations and generates logs for inspection.
   */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_ReplayReconciliation?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationResponse>;
  /** Run a decision component from input */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_RunDecision?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionResponse>;
  /** Categorize line items by batch ID */
  instacart_fulfillment_shopper_transaction_integrity_v1_CategorizationService_CategorizeByBatch?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchResponse>;
  /** Create categorization analysis record */
  instacart_fulfillment_shopper_transaction_integrity_v1_CategorizationService_CreateCategorizationAnalysis?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisResponse>;
  /** Creates a new ban between a user and a shopper. */
  instacart_fulfillment_user_shopper_ban_v1_UserShopperBanService_CreateUserShopperBan?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_CreateUserShopperBanResponse>;
  /** Hard-deletes a ban by ID. Callbacks are not triggered. */
  instacart_fulfillment_user_shopper_ban_v1_UserShopperBanService_DeleteUserShopperBan?: Maybe<Scalars['instacart_fulfillment_user_shopper_ban_v1_DeleteUserShopperBanResponse']>;
  /** Cancels a marketing campaign in progress */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_CancelMarketingCampaign?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignResponse>;
  /** Creates an intention configuration for a future message */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_CreateIntentionConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationResponse>;
  /** Send a test message using a real or inline intention configuration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_TestSendIntentionConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TestSendIntentionConfigurationResponse>;
  /** Update an intention configuration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpdateIntentionConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationResponse>;
  /** Update the settings of a retailer_configuration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpdateRetailerConfigurationSettings?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsResponse>;
  /** Upsert email unsubscribers */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpsertEmailUnsubscribers?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersResponse>;
  /** Upsert user subscription status (email + push) from a 3-column CSV */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_UpsertUserSubscriptionStatus?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_UpsertUserSubscriptionStatusResponse>;
  /** Endpoint to create a new Module */
  instacart_infra_instaform_v1_InstaformService_CreateModule?: Maybe<Instacart_Infra_Instaform_V1_CreateModuleResponse>;
  /** Create a new request note */
  instacart_logistics_marketplace_ops_v1_MarketplaceOps_CreateRequestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteResponse>;
  /** Delete an existing note */
  instacart_logistics_marketplace_ops_v1_MarketplaceOps_DeleteRequestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteResponse>;
  /** Update an existing note */
  instacart_logistics_marketplace_ops_v1_MarketplaceOps_UpdateRequestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteResponse>;
  /** Adding a request note to OpsEscalationRequest */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_AddRequestNoteToOpsEscalationRequest?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestResponse>;
  /** Update the status of multiple OpsEscalationRequests */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_BulkUpdateOpsEscalationRequestStatus?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusResponse>;
  /** Bulk create OpsEscalationRequests */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_CreateOpsEscalationRequests?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsResponse>;
  /** Deleting request notes (bulk) */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_DeleteOpsEscalationRequestRequestNotes?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesResponse>;
  /** Bulk delete OpsEscalationRequests by IDs */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_DeleteOpsEscalationRequests?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsResponse>;
  /** Updating a request note */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_UpdateOpsEscalationRequestRequestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteResponse>;
  /** Update the status of an OpsEscalationRequest */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_UpdateOpsEscalationRequestStatus?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusResponse>;
  /** Bulk update OpsEscalationRequests */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_UpdateOpsEscalationRequests?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsResponse>;
  /** Add 1 or more locations to an existing event */
  instacart_logistics_v1_FulfillmentEvents_AddLocationsToParentEvent?: Maybe<Instacart_Logistics_V1_AddLocationsToParentEventResponse>;
  /** Cancel/stop a list of fulfillment events */
  instacart_logistics_v1_FulfillmentEvents_CancelFulfillmentEvents?: Maybe<Instacart_Logistics_V1_CancelFulfillmentEventsResponse>;
  /** Create a new closure event */
  instacart_logistics_v1_FulfillmentEvents_CreateClosureEvent?: Maybe<Instacart_Logistics_V1_CreateClosureEventResponse>;
  /** Create a closure event approval request */
  instacart_logistics_v1_FulfillmentEvents_CreateClosureEventApprovalRequest?: Maybe<Instacart_Logistics_V1_CreateClosureEventApprovalRequestResponse>;
  /** Create a new fulfillment capacity-impacting event */
  instacart_logistics_v1_FulfillmentEvents_CreateFulfillmentEvent?: Maybe<Instacart_Logistics_V1_CreateFulfillmentEventResponse>;
  /** Create a new restricted availability event */
  instacart_logistics_v1_FulfillmentEvents_CreateRestrictedAvailabilityEvent?: Maybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventResponse>;
  /** Create a restricted availability event approval request */
  instacart_logistics_v1_FulfillmentEvents_CreateRestrictedAvailabilityEventApprovalRequest?: Maybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestResponse>;
  /**
   * Create an SLA exclusion record (for manual creation or copying from a completed event)
   * Writes directly to sla_exclusions — no fulfillment event created, no side effects
   */
  instacart_logistics_v1_FulfillmentEvents_CreateSlaExclusion?: Maybe<Instacart_Logistics_V1_CreateSlaExclusionResponse>;
  /** Update a closure event */
  instacart_logistics_v1_FulfillmentEvents_UpdateClosureEvents?: Maybe<Instacart_Logistics_V1_UpdateClosureEventsResponse>;
  /** Update a fulfillment capacity-impacting event */
  instacart_logistics_v1_FulfillmentEvents_UpdateFulfillmentEvents?: Maybe<Instacart_Logistics_V1_UpdateFulfillmentEventsResponse>;
  /** Update a restricted availability event */
  instacart_logistics_v1_FulfillmentEvents_UpdateRestrictedAvailabilityEvents?: Maybe<Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsResponse>;
  /**
   * Update an existing SLA exclusion record (severity only for now)
   * Writes directly to sla_exclusions — original fulfillment event unchanged, no side effects
   */
  instacart_logistics_v1_FulfillmentEvents_UpdateSlaExclusion?: Maybe<Instacart_Logistics_V1_UpdateSlaExclusionResponse>;
  /**
   * CancelIntervention cancels an intervention that is in a pre-execution state.
   * Interventions can be canceled when they are in draft, pending_approval, or approved states.
   */
  instacart_massops_v1_MassOpsService_CancelIntervention?: Maybe<Instacart_Massops_V1_CancelInterventionResponse>;
  /**
   * ChatWithAgent sends a natural language message to the MassOps AI agent and returns its response.
   * Use previous_response_id to continue an existing conversation; omit it to start a new one.
   */
  instacart_massops_v1_MassOpsService_ChatWithAgent?: Maybe<Instacart_Massops_V1_ChatWithAgentResponse>;
  /**
   * CreateIntervention creates a new intervention instance with the specified type and parameters.
   * The intervention is created in a pending state and must be executed separately.
   */
  instacart_massops_v1_MassOpsService_CreateIntervention?: Maybe<Instacart_Massops_V1_CreateInterventionResponse>;
  /**
   * CreateInterventionBundle creates a new reusable intervention bundle in draft state.
   * The bundle groups an approval-gated template that can later spawn concrete interventions.
   */
  instacart_massops_v1_MassOpsService_CreateInterventionBundle?: Maybe<Instacart_Massops_V1_CreateInterventionBundleResponse>;
  /**
   * CreateInterventionFromBundle spawns a concrete intervention from an approved bundle,
   * seeded with the bundle's configuration and the caller-supplied task data.
   */
  instacart_massops_v1_MassOpsService_CreateInterventionFromBundle?: Maybe<Instacart_Massops_V1_CreateInterventionFromBundleResponse>;
  /**
   * DropFailingRowsAndRegen drops the CSV rows flagged by drop-eligible validation checks
   * and re-triggers the pre-execution summary so validation re-runs on the reduced data set.
   */
  instacart_massops_v1_MassOpsService_DropFailingRowsAndRegen?: Maybe<Instacart_Massops_V1_DropFailingRowsAndRegenResponse>;
  /**
   * ExecuteIntervention starts the execution of a previously created intervention.
   * This will begin processing all tasks associated with the intervention.
   */
  instacart_massops_v1_MassOpsService_ExecuteIntervention?: Maybe<Instacart_Massops_V1_ExecuteInterventionResponse>;
  /**
   * ExecuteInterventionQuery executes a query associated with an intervention
   * and returns the refreshed intervention along with the query execution status.
   */
  instacart_massops_v1_MassOpsService_ExecuteInterventionQuery?: Maybe<Instacart_Massops_V1_ExecuteInterventionQueryResponse>;
  /**
   * RequestInterventionApproval requests approval for an intervention that is in draft state.
   * This transitions the intervention from draft to pending_approval state.
   */
  instacart_massops_v1_MassOpsService_RequestInterventionApproval?: Maybe<Instacart_Massops_V1_RequestInterventionApprovalResponse>;
  /**
   * RequestInterventionBundleApproval requests one or more dimensions of approval
   * (e.g., finance, legal) for a bundle. Transitions the bundle to pending_approval.
   */
  instacart_massops_v1_MassOpsService_RequestInterventionBundleApproval?: Maybe<Instacart_Massops_V1_RequestInterventionBundleApprovalResponse>;
  /**
   * SyncInterventionApprovalResult receives approval callback from external systems and syncs
   * the approval decision state. This is a passive endpoint that records externally-made
   * decisions, not an action trigger. Future ApproveIntervention/RejectIntervention
   * endpoints will be added to actually trigger approval flows.
   */
  instacart_massops_v1_MassOpsService_SyncInterventionApprovalResult?: Maybe<Instacart_Massops_V1_SyncInterventionApprovalResultResponse>;
  /**
   * SyncInterventionBundleApprovalResult pulls the latest approval decisions from
   * the external approval service and reconciles the bundle's state accordingly.
   */
  instacart_massops_v1_MassOpsService_SyncInterventionBundleApprovalResult?: Maybe<Instacart_Massops_V1_SyncInterventionBundleApprovalResultResponse>;
  /**
   * UpdateIntervention updates an existing intervention's name, description, and parameters.
   * Only the fields provided in the request will be updated.
   */
  instacart_massops_v1_MassOpsService_UpdateIntervention?: Maybe<Instacart_Massops_V1_UpdateInterventionResponse>;
  /**
   * UpdateInterventionCommunicationSettings updates the communication settings for an intervention.
   * This includes email and SMS notification configurations with multi-locale support.
   */
  instacart_massops_v1_MassOpsService_UpdateInterventionCommunicationSettings?: Maybe<Instacart_Massops_V1_UpdateInterventionCommunicationSettingsResponse>;
  /**
   * UploadInterventionData uploads CSV data containing the entities or tasks to be processed
   * by the intervention. This data defines what the intervention will operate on.
   */
  instacart_massops_v1_MassOpsService_UploadInterventionData?: Maybe<Instacart_Massops_V1_UploadInterventionDataResponse>;
  /** Get Medusa Query and Execute it */
  instacart_medusa_v1_MedusaService_ExecuteMetricsQuery?: Maybe<Instacart_Medusa_V1_ExecuteMetricsQueryResponse>;
  /** Create a note on a site × feature intersection */
  instacart_partners_partners_v1_FlipService_CreateFlipNote?: Maybe<Instacart_Partners_Partners_V1_CreateFlipNoteResponse>;
  /** Soft-delete a note */
  instacart_partners_partners_v1_FlipService_DeleteFlipNote?: Maybe<Instacart_Partners_Partners_V1_DeleteFlipNoteResponse>;
  /** Update an existing note's body */
  instacart_partners_partners_v1_FlipService_UpdateFlipNote?: Maybe<Instacart_Partners_Partners_V1_UpdateFlipNoteResponse>;
  /** Release an App to Production.  This RPC starts an asyncrhonous process which submits this app to App Store (or Play Store) */
  instacart_partners_partners_v1_MobileAppsManagementService_ReleaseAppToProduction?: Maybe<Instacart_Partners_Partners_V1_ReleaseAppToProductionResponse>;
  /** Update a WhitelabelApp. */
  instacart_partners_partners_v1_MobileAppsManagementService_UpdateWhitelabelApp?: Maybe<Instacart_Partners_Partners_V1_UpdateWhitelabelAppResponse>;
  /** Bulk create partner configurations; can support creating different configurations for different entities */
  instacart_partners_partners_v1_PartnerConfigurationsService_BulkCreatePartnerConfigurations?: Maybe<Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsResponse>;
  /** Bulk delete partner configurations; only does a soft delete. Can support deleting different configurations for different entities */
  instacart_partners_partners_v1_PartnerConfigurationsService_BulkDeletePartnerConfigurations?: Maybe<Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsResponse>;
  /** Bulk update partner configurations; can support updating different configurations for different entities */
  instacart_partners_partners_v1_PartnerConfigurationsService_BulkUpdatePartnerConfigurations?: Maybe<Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsResponse>;
  /**
   * Submit a BulkCreatePartnerConfigurations change through the Approval Management Service.
   * The wrapped request is serialized into the initial snapshot; on approve/publish, AMS
   * calls back into PartnerConfigurationsAmsFollowerService which invokes BulkCreatePartnerConfigurations.
   */
  instacart_partners_partners_v1_PartnerConfigurationsService_CreateBulkCreatePartnerConfigurationsApprovalRequest?: Maybe<Instacart_Partners_Partners_V1_CreateBulkCreatePartnerConfigurationsApprovalRequestResponse>;
  /** Submit a BulkDeletePartnerConfigurations change through the Approval Management Service. */
  instacart_partners_partners_v1_PartnerConfigurationsService_CreateBulkDeletePartnerConfigurationsApprovalRequest?: Maybe<Instacart_Partners_Partners_V1_CreateBulkDeletePartnerConfigurationsApprovalRequestResponse>;
  /** Submit a BulkUpdatePartnerConfigurations change through the Approval Management Service. */
  instacart_partners_partners_v1_PartnerConfigurationsService_CreateBulkUpdatePartnerConfigurationsApprovalRequest?: Maybe<Instacart_Partners_Partners_V1_CreateBulkUpdatePartnerConfigurationsApprovalRequestResponse>;
  /** Create a new partner configuration type; after create, configuration type must be added to PartnerConfigurationType to support reads */
  instacart_partners_partners_v1_PartnerConfigurationsService_CreatePartnerConfigurationType?: Maybe<Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeResponse>;
  /** delete an existing partner configuration type; only does a soft delete. */
  instacart_partners_partners_v1_PartnerConfigurationsService_DeletePartnerConfigurationType?: Maybe<Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeResponse>;
  /** Update an existing partner configuration type */
  instacart_partners_partners_v1_PartnerConfigurationsService_UpdatePartnerConfigurationType?: Maybe<Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeResponse>;
  /** Provision a sandbox whitelabel site linked to a production store configuration */
  instacart_partners_partners_v1_SandboxService_CreateSandboxWhitelabelSite?: Maybe<Instacart_Partners_Partners_V1_CreateSandboxWhitelabelSiteResponse>;
  /** Tear down a previously provisioned sandbox whitelabel site */
  instacart_partners_partners_v1_SandboxService_DeleteSandboxWhitelabelSite?: Maybe<Instacart_Partners_Partners_V1_DeleteSandboxWhitelabelSiteResponse>;
  /** Tear down routing metadata for a sandbox whitelabel site. */
  instacart_partners_partners_v1_SandboxService_DeprovisionSandboxWhitelabelSite?: Maybe<Instacart_Partners_Partners_V1_DeprovisionSandboxWhitelabelSiteResponse>;
  /**
   * Provision routing metadata for a sandbox whose warehouse / store
   * configuration lineage already exists.
   */
  instacart_partners_partners_v1_SandboxService_ProvisionSandboxWhitelabelSite?: Maybe<Instacart_Partners_Partners_V1_ProvisionSandboxWhitelabelSiteResponse>;
  /**
   * Re-copy approved-or-later attribute values from the linked production
   * warehouse into an existing sandbox. Idempotent — safe to re-run when a
   * prior sync partially completed.
   */
  instacart_partners_partners_v1_SandboxService_ResyncSandboxAttributeValues?: Maybe<Instacart_Partners_Partners_V1_ResyncSandboxAttributeValuesResponse>;
  /** Update metadata (enabled state, IP allowlist) on an existing sandbox whitelabel site */
  instacart_partners_partners_v1_SandboxService_UpdateSandboxWhitelabelSiteMetadata?: Maybe<Instacart_Partners_Partners_V1_UpdateSandboxWhitelabelSiteMetadataResponse>;
  /** CheckHealth */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_CheckHealth?: Maybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_CheckHealthResponse']>;
  /** PutAutomation */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutAutomation?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationResponse>;
  /** PutConnection */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutConnection?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionResponse>;
  /** PutStore */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutStore?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreResponse>;
  /** PutSyncStrategy */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_PutSyncStrategy?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_CreateInsightsPortalCustomExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_CreateInsightsPortalCustomReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_DeleteInsightsPortalCustomExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_RegenerateInsightsPortalCustomExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_SetInsightsPortalCustomReportDisabled?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_UpdateInsightsPortalCustomReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportResponse>;
  instacart_retailers_v1_AppeasementsService_GiveAppeasements?: Maybe<Instacart_Retailers_V1_GiveAppeasementsResponse>;
  instacart_retailers_v1_RetailersService_UpsertWidgetsConfig?: Maybe<Instacart_Retailers_V1_UpsertWidgetsConfigResponse>;
  /** Create or modify a feature. */
  instacart_roulette_v1_RouletteService_StoreFeature?: Maybe<Instacart_Roulette_V1_StoreFeatureResponse>;
  /** PutIntegration */
  instacart_upos_config_v1_ConfigService_PutIntegration?: Maybe<Instacart_Upos_Config_V1_PutIntegrationResponse>;
  /** PutProfile */
  instacart_upos_config_v1_ConfigService_PutProfile?: Maybe<Instacart_Upos_Config_V1_PutProfileResponse>;
  /** PutRetailer */
  instacart_upos_config_v1_ConfigService_PutRetailer?: Maybe<Instacart_Upos_Config_V1_PutRetailerResponse>;
  /** PutStore */
  instacart_upos_config_v1_ConfigService_PutStore?: Maybe<Instacart_Upos_Config_V1_PutStoreResponse>;
  /** Cancels an in-progress async step preview. */
  instacart_waves_v1_WavesService_CancelPreview?: Maybe<Instacart_Waves_V1_CancelPreviewResponse>;
  /** Creates Sesame view+edit actions for a pipeline that has none, setting the caller as owner. */
  instacart_waves_v1_WavesService_ClaimPipelineOwnership?: Maybe<Instacart_Waves_V1_ClaimPipelineOwnershipResponse>;
  /** Creates a new step with an initial version */
  instacart_waves_v1_WavesService_CreateNewStep?: Maybe<Instacart_Waves_V1_CreateNewStepResponse>;
  /** Creates a new version of an existing step */
  instacart_waves_v1_WavesService_CreateNewStepVersion?: Maybe<Instacart_Waves_V1_CreateNewStepVersionResponse>;
  /** Creates a new scheduled workflow or updates an existing one. */
  instacart_waves_v1_WavesService_CreateOrUpdateScheduledWorkflow?: Maybe<Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowResponse>;
  /** Creates (upserts) a pipeline-level alert config. */
  instacart_waves_v1_WavesService_CreatePipelineAlertConfig?: Maybe<Instacart_Waves_V1_CreatePipelineAlertConfigResponse>;
  /** Submits an async step preview and returns a preview_id. */
  instacart_waves_v1_WavesService_CreatePreview?: Maybe<Instacart_Waves_V1_CreatePreviewResponse>;
  /** Creates a new step filter tag */
  instacart_waves_v1_WavesService_CreateStepFilterTag?: Maybe<Instacart_Waves_V1_CreateStepFilterTagResponse>;
  /** Soft-deletes a pipeline alert config and all child step thresholds. */
  instacart_waves_v1_WavesService_DeletePipelineAlertConfig?: Maybe<Instacart_Waves_V1_DeletePipelineAlertConfigResponse>;
  /** Deletes an existing scheduled workflow by step_id. */
  instacart_waves_v1_WavesService_DeleteScheduledWorkflow?: Maybe<Instacart_Waves_V1_DeleteScheduledWorkflowResponse>;
  /** Soft-deletes a per-step threshold. */
  instacart_waves_v1_WavesService_DeleteStepAlertThreshold?: Maybe<Instacart_Waves_V1_DeleteStepAlertThresholdResponse>;
  /** Deletes a step filter tag by step_id and tag_name */
  instacart_waves_v1_WavesService_DeleteStepFilterTag?: Maybe<Instacart_Waves_V1_DeleteStepFilterTagResponse>;
  /** Invalidate deduplication for tasks filtered by workflow_run_id */
  instacart_waves_v1_WavesService_InvalidateDeduplication?: Maybe<Instacart_Waves_V1_InvalidateDeduplicationResponse>;
  /** Runs a CAMP step version (starts a Temporal workflow) */
  instacart_waves_v1_WavesService_RunCampStepVersion?: Maybe<Instacart_Waves_V1_RunCampStepVersionResponse>;
  /** Soft deletes a step by step_id */
  instacart_waves_v1_WavesService_TombstoneStep?: Maybe<Instacart_Waves_V1_TombstoneStepResponse>;
  /** Soft deletes a single step version by step_version_id */
  instacart_waves_v1_WavesService_TombstoneStepVersion?: Maybe<Instacart_Waves_V1_TombstoneStepVersionResponse>;
  /** Partially updates a pipeline-level alert config. */
  instacart_waves_v1_WavesService_UpdatePipelineAlertConfig?: Maybe<Instacart_Waves_V1_UpdatePipelineAlertConfigResponse>;
  /** Updates a step's owner and/or description */
  instacart_waves_v1_WavesService_UpdateStep?: Maybe<Instacart_Waves_V1_UpdateStepResponse>;
  /** Creates or updates a per-step threshold inside a pipeline alert config. */
  instacart_waves_v1_WavesService_UpsertStepAlertThreshold?: Maybe<Instacart_Waves_V1_UpsertStepAlertThresholdResponse>;
  inventoryIntelligenceServiceCreateOosAcknowledgment?: Maybe<CreateOosAcknowledgmentResponse>;
  inventoryIntelligenceServiceCreateRecommendationFeedback?: Maybe<CreateRecommendationFeedbackResponse>;
  linkAutosuggestServiceCreateOrUpdateLinkAutosuggestionAdmin?: Maybe<CreateOrUpdateLinkAutosuggestionAdminResponse>;
  linkAutosuggestServiceDeleteLinkAutosuggestionAdmin?: Maybe<DeleteLinkAutosuggestionAdminResponse>;
  /** Cancels a marketing email campaign in progress */
  marketingFeatureCancelCampaign?: Maybe<CancelCampaignPayload>;
  /** Starts a marketing email campaign */
  marketingFeatureStartCampaign?: Maybe<StartCampaignPayload>;
  /** Triggers the send for an existing marketing campaign */
  marketingFeatureTriggerCampaign?: Maybe<TriggerCampaignPayload>;
  /** Create a MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityConditionCreate?: Maybe<MatchesAnyRetailerIdVisibilityConditionCreatePayload>;
  /** Update a MatchesAnyRetailerId visibility condition */
  matchesAnyRetailerIdVisibilityConditionUpdate?: Maybe<MatchesAnyRetailerIdVisibilityConditionUpdatePayload>;
  /** Create a MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionCreate?: Maybe<MinimumPlatformVersionVisibilityConditionCreatePayload>;
  /** Update an existing MinimumPlatformVersion visibility condition */
  minimumPlatformVersionVisibilityConditionUpdate?: Maybe<MinimumPlatformVersionVisibilityConditionUpdatePayload>;
  /** Create a NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityConditionCreate?: Maybe<NewVerticalUserTargetingVisibilityConditionCreatePayload>;
  /** Update a NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityConditionUpdate?: Maybe<NewVerticalUserTargetingVisibilityConditionUpdatePayload>;
  /** Merges two or more normalized-reports by combining their contents into one file */
  normalizedReportsMerge?: Maybe<NormalizedReportsMergePayload>;
  /** Subscribe an account to a notification type for a retailer */
  notificationSubscriptionCreate?: Maybe<NotificationSubscriptionCreatePayload>;
  /** Unsubscribe an account to a notification type for a retailer */
  notificationSubscriptionDelete?: Maybe<NotificationSubscriptionDeletePayload>;
  /** Delete notifications from the current account */
  notificationsDelete?: Maybe<NotificationsDeletePayload>;
  /** Mark notifications as read */
  notificationsMarkRead?: Maybe<NotificationsMarkReadPayload>;
  /** Sets properties for mobile apps */
  onboardingMobileAppPropertiesUpdate?: Maybe<SetMobilePropertiesPayload>;
  onboardingServiceBulkUpdateApprovalRequestStatus?: Maybe<BulkUpdateApprovalRequestStatusResponse>;
  onboardingServiceCreateAutomatedTestRun?: Maybe<CreateAutomatedTestRunResponse>;
  onboardingServiceCreateOnboardingStoreLocation?: Maybe<CreateOnboardingStoreLocationResponse>;
  onboardingServiceCreateSignup?: Maybe<CreateSignupResponse>;
  onboardingServiceCreateSiteSetupFormAccessRequest?: Maybe<CreateSiteSetupFormAccessRequestResponse>;
  onboardingServiceCreateWhitelabelSite?: Maybe<CreateWhitelabelSiteResponse>;
  onboardingServiceCreateWhitelabelSiteCustomizableString?: Maybe<CreateWhitelabelSiteCustomizableStringResponse>;
  onboardingServiceCreateWhitelabelStoreConfiguration?: Maybe<CreateWhitelabelStoreConfigurationResponse>;
  onboardingServiceDeleteLaunchOnboardingWarehouseLocation?: Maybe<DeleteLaunchOnboardingWarehouseLocationResponse>;
  onboardingServiceDeleteWhitelabelSiteCustomizableString?: Maybe<DeleteWhitelabelSiteCustomizableStringResponse>;
  onboardingServiceGeneratePresignedAssetDownloadUrl?: Maybe<GeneratePresignedAssetDownloadUrlResponse>;
  onboardingServiceGeneratePresignedAssetUploadUrl?: Maybe<GeneratePresignedAssetUploadUrlResponse>;
  onboardingServiceGeneratePrsForStringOverride?: Maybe<GeneratePrsForStringOverrideResponse>;
  onboardingServiceLockSiteSetupForm?: Maybe<LockSiteSetupFormResponse>;
  onboardingServiceOnboardRelayRetailer?: Maybe<OnboardRelayRetailerResponse>;
  onboardingServiceSendWhitelabelSiteRetailerEmail?: Maybe<SendWhitelabelSiteRetailerEmailResponse>;
  onboardingServiceStartWhitelabelGumloopWorkflow?: Maybe<StartWhitelabelGumloopWorkflowResponse>;
  onboardingServiceTriggerRakeTaskForStoreConfiguration?: Maybe<TriggerRakeTaskForStoreConfigurationResponse>;
  onboardingServiceUpdateApprovalRequestStatus?: Maybe<UpdateApprovalRequestStatusResponse>;
  onboardingServiceUpdateLaunchOnboardingWarehouseInfo?: Maybe<UpdateLaunchOnboardingWarehouseInfoResponse>;
  onboardingServiceUpdateLaunchOnboardingWarehouseLocationInfo?: Maybe<UpdateLaunchOnboardingWarehouseLocationInfoResponse>;
  onboardingServiceUpdateLaunchOnboardingWorkflowState?: Maybe<UpdateLaunchOnboardingWorkflowStateResponse>;
  onboardingServiceUpdateOnboarding?: Maybe<UpdateOnboardingResponse>;
  onboardingServiceUpdateOnboardingBillingAddress?: Maybe<UpdateOnboardingBillingAddressResponse>;
  onboardingServiceUpdateOnboardingWorkflowState?: Maybe<UpdateOnboardingWorkflowStateResponse>;
  onboardingServiceUpdateRetailerFormGroupVisibility?: Maybe<UpdateRetailerFormGroupVisibilityResponse>;
  onboardingServiceUpdateWhitelabelSite?: Maybe<UpdateWhitelabelSiteResponse>;
  onboardingServiceUpdateWhitelabelSiteAttributes?: Maybe<UpdateWhitelabelSiteAttributesResponse>;
  onboardingServiceUpdateWhitelabelSiteAttributesAdmin?: Maybe<UpdateWhitelabelSiteAttributesAdminResponse>;
  onboardingServiceUpdateWhitelabelSiteCustomizableString?: Maybe<UpdateWhitelabelSiteCustomizableStringResponse>;
  onboardingServiceUpdateWhitelabelSiteSlackChannel?: Maybe<UpdateWhitelabelSiteSlackChannelResponse>;
  onboardingServiceUpdateWhitelabelSiteWorkflowState?: Maybe<UpdateWhitelabelSiteWorkflowStateResponse>;
  /** Trigger a workflow */
  onboardingTriggerWorkflow?: Maybe<TriggerWorkflowPayload>;
  orderServiceCancelOrder?: Maybe<CancelOrderResponse>;
  orderServiceCreateLastmileOrderFromDashboard?: Maybe<CreateLastmileOrderFromDashboardResponse>;
  orderServiceReopenLastmileOrder?: Maybe<ReopenLastmileOrderResponse>;
  orderServiceRescheduleOrder?: Maybe<RescheduleOrderResponse>;
  orderServiceStageLastmileOrder?: Maybe<StageLastmileOrderResponse>;
  /** Create a new partner pick device */
  partnerPickDeviceCreate?: Maybe<PartnerPickDeviceCreatePayload>;
  /** Update an existing partner pick device's status */
  partnerPickDeviceSetStatus?: Maybe<PartnerPickDeviceSetStatusPayload>;
  /** Update an existing partner pick device */
  partnerPickDeviceUpdate?: Maybe<PartnerPickDeviceUpdatePayload>;
  /** Create a new partner pick recurring shift */
  partnerPickRecurringShiftCreate?: Maybe<PartnerPickRecurringShiftCreatePayload>;
  /** Delete a partner pick recurring shift by id, from some date onward */
  partnerPickRecurringShiftDelete?: Maybe<PartnerPickRecurringShiftDeletePayload>;
  /** Update an existing partner pick recurring shift */
  partnerPickRecurringShiftUpdate?: Maybe<PartnerPickRecurringShiftUpdatePayload>;
  privacyServiceCreatePiiRequestForRetailer?: Maybe<CreatePiiRequestForRetailerResponse>;
  /** Create a new report request */
  reportRequestCreate?: Maybe<ReportRequestCreatePayload>;
  /** Resync partners from main to our enterprise_api database */
  resyncPartners?: Maybe<ResyncPartnersPayload>;
  retailerAislesUpdateRetailerAisleTemplate?: Maybe<UpdateRetailerAisleTemplateResponse>;
  /** Create a RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityConditionCreate?: Maybe<RetailerAvailabilityVisibilityConditionCreatePayload>;
  /** Update a RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityConditionUpdate?: Maybe<RetailerAvailabilityVisibilityConditionUpdatePayload>;
  retailerCampaignServiceAddRetailerCampaignTreatments?: Maybe<AddRetailerCampaignTreatmentsResponse>;
  retailerCampaignServiceCancelMoment?: Maybe<CancelMomentResponse>;
  retailerCampaignServiceCancelRetailerCampaign?: Maybe<CancelRetailerCampaignResponse>;
  retailerCampaignServiceCreateMoment?: Maybe<CreateMomentResponse>;
  retailerCampaignServiceCreateRetailerCampaign?: Maybe<RetailerCampaignResponse>;
  retailerCampaignServiceUpdateMoment?: Maybe<UpdateMomentResponse>;
  retailerCampaignServiceUpdateMomentCampaignStatus?: Maybe<UpdateMomentCampaignStatusResponse>;
  retailerCampaignServiceUpdateRetailerCampaign?: Maybe<RetailerCampaignResponse>;
  retailerCampaignServiceUpdateRetailerCampaignTreatments?: Maybe<UpdateRetailerCampaignTreatmentsResponse>;
  /** Create a new retailer location group */
  retailerLocationGroupCreate?: Maybe<RetailerLocationGroupCreatePayload>;
  /** Delete an existing retailer location group */
  retailerLocationGroupDelete?: Maybe<RetailerLocationGroupDeletePayload>;
  /** Update an existing retailer location group */
  retailerLocationGroupUpdate?: Maybe<RetailerLocationGroupUpdatePayload>;
  retailerManagementServiceAddStoreConfigurationToClientConfiguration?: Maybe<AddStoreConfigurationToClientConfigurationResponse>;
  retailerManagementServiceClonePartnerOauthApplication?: Maybe<ClonePartnerOauthApplicationResponse>;
  retailerManagementServiceCreateClientConfiguration?: Maybe<CreateClientConfigurationResponse>;
  retailerManagementServiceCreateConnectRetailerCallbackConfiguration?: Maybe<CreateConnectRetailerCallbackConfigurationResponse>;
  retailerManagementServiceCreateStoreConfiguration?: Maybe<CreateStoreConfigurationResponse>;
  retailerManagementServiceDeleteConnectRetailerCallbackConfiguration?: Maybe<DeleteConnectRetailerCallbackConfigurationResponse>;
  retailerManagementServiceDeletePartnerOauthApplication?: Maybe<DeletePartnerOauthApplicationResponse>;
  retailerManagementServiceDisablePartnerOauthApplication?: Maybe<DisablePartnerOauthApplicationResponse>;
  retailerManagementServiceEnablePartnerOauthApplication?: Maybe<EnablePartnerOauthApplicationResponse>;
  retailerManagementServiceUpdateClientConfigurationForOrdersDashboard?: Maybe<UpdateClientConfigurationForOrdersDashboardResponse>;
  retailerManagementServiceUpdateConnectRetailerCallbackConfiguration?: Maybe<UpdateConnectRetailerCallbackConfigurationResponse>;
  /** Set MFA enabled status for a retailer */
  retailerMfaSetEnabled?: Maybe<RetailerMfaSetEnabledPayload>;
  retailerProductAttributeEditServiceUpdateAvailabilityScoreOverride?: Maybe<UpdateAvailabilityScoreOverrideResponse>;
  retailerProductAttributeEditServiceUpdateRetailerProductVisibilities?: Maybe<UpdateRetailerProductVisibilitiesResponse>;
  /** Submit the results of the Retailer Satisfication Survey form */
  retailerSatisfactionSurveySubmissionCreate?: Maybe<SubmissionCreatePayload>;
  retailerSettingsServiceDeleteImage?: Maybe<DeleteImageResponse>;
  retailerSettingsServiceUpdateParkingSettings?: Maybe<UpdateParkingSettingsResponse>;
  retailerSettingsServiceUpdateStagingSettings?: Maybe<UpdateStagingSettingsResponse>;
  retailerStoreHoursUpdateConfirmStoreHours?: Maybe<UpdateConfirmedStoreHoursResponse>;
  retailerStoreHoursUpdateStoreHours?: Maybe<UpdateStoreHoursResponse>;
  retailersServiceMoveRetailerAssetsFromFilestackBucket?: Maybe<MoveRetailerAssetsFromFilestackBucketResponse>;
  returnsServiceCreateOrUpdateReturn?: Maybe<CreateOrUpdateReturnResponse>;
  /** Create a role */
  roleCreate?: Maybe<RoleCreatePayload>;
  /** Delete a role */
  roleDelete?: Maybe<RoleDeletePayload>;
  /** Update a role */
  roleUpdate?: Maybe<RoleUpdatePayload>;
  rppBulkImageUploadsServiceCreateImageUploadBatch?: Maybe<CreateImageUploadBatchResponse>;
  /** Soft-delete a saved view */
  savedViewsDelete?: Maybe<DeleteViewPayload>;
  /** Create or update a saved view. Omit id to create; include id to update an existing view. */
  savedViewsSave?: Maybe<SaveViewPayload>;
  /** Create a new home placement with SecondaryBanner banner */
  secondaryBannerPlacementCreate?: Maybe<SecondaryBannerPlacementCreatePayload>;
  /** Update an existing secondary_banner placement placement */
  secondaryBannerPlacementUpdate?: Maybe<SecondaryBannerPlacementUpdatePayload>;
  /** Create a ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionCreate?: Maybe<ShoppedAtRetailerVisibilityConditionCreatePayload>;
  /** Update an existing ShoppedAtRetailer visibility condition */
  shoppedAtRetailerVisibilityConditionUpdate?: Maybe<ShoppedAtRetailerVisibilityConditionUpdatePayload>;
  /** Create a shopped visibility condition */
  shoppedVisibilityConditionCreate?: Maybe<ShoppedVisibilityConditionCreatePayload>;
  /** Update an existing Shopped visibility condition */
  shoppedVisibilityConditionUpdate?: Maybe<ShoppedVisibilityConditionUpdatePayload>;
  storeConfigurationsDraftServiceCreateStoreConfigurationDraft?: Maybe<CreateStoreConfigurationDraftResponse>;
  storeConfigurationsDraftServicePublishStoreConfigurationDraft?: Maybe<PublishStoreConfigurationDraftResponse>;
  storeConfigurationsDraftServiceRollbackStoreConfiguration?: Maybe<RollbackStoreConfigurationResponse>;
  storeConfigurationsDraftServiceUpdateStoreConfigurationDraft?: Maybe<UpdateStoreConfigurationDraftResponse>;
  /** Create a new storefront placement */
  storefrontPlacementCreate?: Maybe<StorefrontPlacementCreatePayload>;
  /** Delete an existing storefront placement */
  storefrontPlacementDelete?: Maybe<StorefrontPlacementDeletePayload>;
  /** Update an existing storefront placement placement */
  storefrontPlacementUpdate?: Maybe<StorefrontPlacementUpdatePayload>;
  /** Submit a bulk role operation. Heterogeneous (mode + rows) or guided homogeneous permission change (membership + targets). */
  submitBulkRoleOperation?: Maybe<SubmitBulkRoleOperationPayload>;
  /** Submit a bulk user operation. Heterogeneous (mode + rows) or guided homogeneous (membership + targets). */
  submitBulkUserOperation?: Maybe<SubmitBulkUserOperationPayload>;
  /** Create a UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityConditionCreate?: Maybe<UserInteractionLimitVisibilityConditionCreatePayload>;
  /** Update a UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityConditionUpdate?: Maybe<UserInteractionLimitVisibilityConditionUpdatePayload>;
  userSettingServiceSetUserSetting?: Maybe<SetUserSettingResponse>;
  usersServiceCreateAddressWithoutDuplicates?: Maybe<AddressResponse>;
  usersServiceCreateUserWithoutPassword?: Maybe<UserResponse>;
  usersServiceGrantImpersonation?: Maybe<GrantImpersonationResponse>;
  usersServiceUpdateAddressToDefaultById?: Maybe<AddressResponse>;
  usersServiceUpdateUserProfileInfo?: Maybe<UserResponse>;
  /** Create a UtmParameters visibility condition */
  utmParametersVisibilityConditionCreate?: Maybe<UtmParametersVisibilityConditionCreatePayload>;
  /** Update a UtmParameters visibility condition */
  utmParametersVisibilityConditionUpdate?: Maybe<UtmParametersVisibilityConditionUpdatePayload>;
  valueBasedOverrideServiceCreateValueBasedOverride?: Maybe<CreateValueBasedOverrideResponse>;
  /** Update the retailers for a virtual partner */
  virtualPartnerUpdateRetailers?: Maybe<VirtualPartnerUpdateRetailersPayload>;
  /** Delete an existing visibility condition */
  visibilityConditionDelete?: Maybe<VisibilityConditionDeletePayload>;
  /** Create a WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionCreate?: Maybe<WhitelistedPostalCodesVisibilityConditionCreatePayload>;
  /** Update an existing WhitelistedPostalCodes visibility condition */
  whitelistedPostalCodesVisibilityConditionUpdate?: Maybe<WhitelistedPostalCodesVisibilityConditionUpdatePayload>;
  /** Create a WhitelistedZones visibility condition */
  whitelistedZonesVisibilityConditionCreate?: Maybe<WhitelistedZonesVisibilityConditionCreatePayload>;
  /** Update a WhitelistedZones visibility condition */
  whitelistedZonesVisibilityConditionUpdate?: Maybe<WhitelistedZonesVisibilityConditionUpdatePayload>;
  /** Update the wizard progress for the currently logged in account */
  wizardProgressUpdate?: Maybe<WizardProgressUpdatePayload>;
};


export type MutationAuth0PermissionManagementService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_AddAccountArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_AddAccountRequest_Input>;
};


export type MutationAuth0PermissionManagementService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_UpdateAccountArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateAccountRequest_Input>;
};


export type MutationAuth0PermissionManagementService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_UpdateAccountStatusArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateAccountStatusRequest_Input>;
};


export type MutationAuth0PermissionManagementStagingService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_AddAccountArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_AddAccountRequest_Input>;
};


export type MutationAuth0PermissionManagementStagingService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_UpdateAccountArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateAccountRequest_Input>;
};


export type MutationAuth0PermissionManagementStagingService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_UpdateAccountStatusArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateAccountStatusRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_AddBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_AddBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_CreateBanEntryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateBanEntryRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_RemoveBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryArchivedArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryArchivedRequest_Input>;
};


export type MutationCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_AddBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_AddBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_CreateBanEntryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateBanEntryRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_RemoveBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_RemoveBanEntryScopesRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryArchivedArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryArchivedRequest_Input>;
};


export type MutationCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_SetBanEntryScopesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SetBanEntryScopesRequest_Input>;
};


export type MutationCaperBarcodePluMappingService_Instacart_Caper_Admin_V1_BarcodePluMappingService_CreateBarcodePluMappingsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateBarcodePluMappingsRequest_Input>;
};


export type MutationCaperBarcodePluMappingService_Instacart_Caper_Admin_V1_BarcodePluMappingService_DeleteBarcodePluMappingsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_DeleteBarcodePluMappingsRequest_Input>;
};


export type MutationCaperBarcodePluMappingService_Instacart_Caper_Admin_V1_BarcodePluMappingService_UpdateBarcodePluMappingsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateBarcodePluMappingsRequest_Input>;
};


export type MutationCaperBillingService_CommitUploadArgs = {
  input?: InputMaybe<CaperBillingService_CommitUploadRequest_Input>;
  uploadId: Scalars['UUID'];
};


export type MutationCaperBillingService_CreateUploadArgs = {
  input?: InputMaybe<CaperBillingService_CreateUploadRequest_Input>;
};


export type MutationCaperBillingService_FinalizeRunArgs = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  input?: InputMaybe<CaperBillingService_FinalizeRunRequest_Input>;
  retailerId: Scalars['String'];
  runId: Scalars['UUID'];
};


export type MutationCaperBillingService_GenerateRunArgs = {
  input?: InputMaybe<CaperBillingService_GenerateRunRequest_Input>;
};


export type MutationCaperBillingService_StoreUploadArgs = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  input?: InputMaybe<Scalars['CaperBillingService_File']>;
  retailerId: Scalars['String'];
  uploadId: Scalars['UUID'];
  uploadType: CaperBillingService_UploadType;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ArchiveNotificationGroupArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ArchiveNotificationGroupRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CancelScheduledActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CancelScheduledActionRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDevicesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDevicesRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateNotificationGroupArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateNotificationGroupRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePresignedAssetUrlArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateStoreRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_LockCartsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_LockCartsRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleActionRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleBatchActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateGlobalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateGlobalRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateNotificationGroupArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateNotificationGroupRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateStoreRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ArchiveNotificationGroupArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ArchiveNotificationGroupRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CancelScheduledActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CancelScheduledActionRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateDevicesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDevicesRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateNotificationGroupArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateNotificationGroupRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreatePresignedAssetUrlArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreatePresignedAssetUrlRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_CreateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateStoreRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_LockCartsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_LockCartsRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleActionArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleActionRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ScheduleBatchActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ScheduleBatchActionsRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateConfigKeyArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateConfigKeyRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateDeviceArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateDeviceRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateFeatureArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateFeatureRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateGlobalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateGlobalRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateNotificationGroupArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateNotificationGroupRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdatePartnerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdatePartnerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateRetailerArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateRetailerRequest_Input>;
};


export type MutationCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_UpdateStoreArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateStoreRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_CscSnapshotService_ApplyCscSnapshotArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ApplyCscSnapshotRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_CscSnapshotService_CreateCscSnapshotArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CreateCscSnapshotRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_CscSnapshotService_UpdateCscSnapshotMetadataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_UpdateCscSnapshotMetadataRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_ActivateExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ActivateExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_CancelExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CancelExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_CompleteExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CompleteExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_CreateExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CreateExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_ExtendExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ExtendExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_RevertExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_RevertExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_UpdateExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_UpdateExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_CscSnapshotService_ApplyCscSnapshotArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ApplyCscSnapshotRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_CscSnapshotService_CreateCscSnapshotArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CreateCscSnapshotRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_CscSnapshotService_UpdateCscSnapshotMetadataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_UpdateCscSnapshotMetadataRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_ActivateExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ActivateExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_CancelExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CancelExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_CompleteExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CompleteExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_CreateExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_CreateExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_ExtendExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ExtendExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_RevertExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_RevertExperimentRequest_Input>;
};


export type MutationCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_UpdateExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_UpdateExperimentRequest_Input>;
};


export type MutationCaperDeviceProvisioningPipelineService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_TriggerPipelineArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TriggerPipelineRequest_Input>;
};


export type MutationCaperDeviceProvisioningPipelineStagingService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_TriggerPipelineArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TriggerPipelineRequest_Input>;
};


export type MutationCaperIppReceiptService_Instacart_Caper_Admin_V1_IppReceiptService_SendReceiptArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_SendReceiptRequest_Input>;
};


export type MutationCaperIppStoreStaffBarcodeService_Instacart_Caper_Admin_V1_IppStoreStaffBarcodeService_CreateStoreStaffBarcodeArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateStoreStaffBarcodeRequest_Input>;
};


export type MutationCaperIppStoreStaffBarcodeService_Instacart_Caper_Admin_V1_IppStoreStaffBarcodeService_EditStoreStaffBarcodeArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_EditStoreStaffBarcodeRequest_Input>;
};


export type MutationCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_ReviewNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ReviewNofRequest_Input>;
};


export type MutationCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_ReviewNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ReviewNofRequest_Input>;
};


export type MutationCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateMerchantArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateMerchantRequest_Input>;
};


export type MutationCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateTerminalsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateTerminalsRequest_Input>;
};


export type MutationCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_TransferTerminalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TransferTerminalRequest_Input>;
};


export type MutationCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateMerchantArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateMerchantRequest_Input>;
};


export type MutationCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_CreateTerminalsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateTerminalsRequest_Input>;
};


export type MutationCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_TransferTerminalArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_TransferTerminalRequest_Input>;
};


export type MutationCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_CreateDatadogSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_CreateSessionSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_UpdateSessionSummaryFeedbackArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackRequest_Input>;
};


export type MutationCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_CreateDatadogSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_CreateSessionSummaryAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncRequest_Input>;
};


export type MutationCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_UpdateSessionSummaryFeedbackArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackRequest_Input>;
};


export type MutationCartAssistant_Instacart_Customers_Sage_V1_SageService_CreateSessionPreviewTokenArgs = {
  input?: InputMaybe<Instacart_Customers_Sage_V1_CreateSessionPreviewTokenRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunCarouselGroupQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunContentDesignQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunFilterQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunKeywordCompletenessQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunKeywordQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunPageQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunPolicyQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunProductQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunRetailerCollectionQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunRetailerCollectionQaRequest_Input>;
};


export type MutationContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_RunTopicQualityQaArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaRequest_Input>;
};


export type MutationEnterpriseStatusPage_AcknowledgeIncidentArgs = {
  id: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_AcknowledgeRequest_Input>;
};


export type MutationEnterpriseStatusPage_AddUserToGroupArgs = {
  groupId: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_UserInput_Input>;
};


export type MutationEnterpriseStatusPage_CreateComponentArgs = {
  groupId: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_ComponentInput_Input>;
};


export type MutationEnterpriseStatusPage_CreateComponentGroupArgs = {
  input?: InputMaybe<EnterpriseStatusPage_ComponentGroupInput_Input>;
};


export type MutationEnterpriseStatusPage_CreateIncidentArgs = {
  input?: InputMaybe<EnterpriseStatusPage_CreateIncidentRequest_Input>;
};


export type MutationEnterpriseStatusPage_CreateUserGroupArgs = {
  input?: InputMaybe<EnterpriseStatusPage_UserGroupInput_Input>;
};


export type MutationEnterpriseStatusPage_DeleteComponentArgs = {
  compId: Scalars['UUID'];
  groupId: Scalars['UUID'];
};


export type MutationEnterpriseStatusPage_DeleteIncidentArgs = {
  id: Scalars['UUID'];
};


export type MutationEnterpriseStatusPage_DeleteUserGroupArgs = {
  groupId: Scalars['UUID'];
};


export type MutationEnterpriseStatusPage_NotifyIncidentContactsArgs = {
  id: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_NotifyContactsRequest_Input>;
};


export type MutationEnterpriseStatusPage_PostIncidentUpdateArgs = {
  id: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_PostIncidentUpdateRequest_Input>;
};


export type MutationEnterpriseStatusPage_PreviewNotificationAudienceArgs = {
  input?: InputMaybe<EnterpriseStatusPage_AudiencePreviewRequest_Input>;
};


export type MutationEnterpriseStatusPage_RemoveIncidentRetailerContactsArgs = {
  id: Scalars['UUID'];
  subGroupId: Scalars['UUID'];
};


export type MutationEnterpriseStatusPage_RemoveUserFromGroupArgs = {
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


export type MutationEnterpriseStatusPage_UpdateUserGroupArgs = {
  groupId: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_UserGroupUpdateInput_Input>;
};


export type MutationEnterpriseStatusPage_UpsertIncidentRetailerContactsArgs = {
  id: Scalars['UUID'];
  input?: InputMaybe<EnterpriseStatusPage_UpsertIncidentRetailerContacts_Request_Input>;
};


export type MutationFrothProcessing_Instacart_Customers_Froth_V1_FrothProcessingService_CompileTemplateArgs = {
  input?: InputMaybe<Instacart_Customers_Froth_V1_CompileTemplateRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_CreateResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_DeleteResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_TriggerInboundEventArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventRequest_Input>;
};


export type MutationFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_UpdateResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_CreateFulfillmentRuleConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentRuleConfigurationsRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_CreateFulfillmentStrategyArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentStrategyRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_UpdateFulfillmentProviderPartnerConfigurationArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_UpdateFulfillmentProviderPartnerConfigurationStatusArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationStatusRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_UpdateFulfillmentRuleConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleConfigurationsRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_UpdateFulfillmentRuleStatusConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleStatusConfigurationsRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_UpdateFulfillmentStrategyArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyRequest_Input>;
};


export type MutationFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_UpdateFulfillmentStrategyStatusArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyStatusRequest_Input>;
};


export type MutationGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_CreateStringsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_CreateStringsRequest_Input>;
};


export type MutationGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_DeleteResourcesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesRequest_Input>;
};


export type MutationGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_UpdateStringsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_UpdateStringsRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CancelMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CreateMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_CancelMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CancelMarketingCampaignRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_CreateMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignRequest_Input>;
};


export type MutationMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_UpdateMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_UpdateMarketingCampaignRequest_Input>;
};


export type MutationMealsIngestionService_Instacart_Customers_Meals_Services_Ingestion_V1_MealsIngestionService_CreatePublisherArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreatePublisherRequest_Input>;
};


export type MutationMealsIngestionService_Instacart_Customers_Meals_Services_Ingestion_V1_MealsIngestionService_CreateRecipeArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreateRecipeRequest_Input>;
};


export type MutationMealsIngestionService_Instacart_Customers_Meals_Services_Ingestion_V1_MealsIngestionService_ResetPublisherAndRecipeArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_UnifiedCreateRecipeRequest_Input>;
};


export type MutationMealsIngestionService_Instacart_Customers_Meals_Services_Ingestion_V1_MealsIngestionService_SetPublisherPermissionsArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetPublisherPermissionsRequest_Input>;
};


export type MutationMealsIngestionService_Instacart_Customers_Meals_Services_Ingestion_V1_MealsIngestionService_SetRecipePermissionsArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetRecipePermissionsRequest_Input>;
};


export type MutationMealsIngestionService_Instacart_Customers_Meals_Services_Ingestion_V1_MealsIngestionService_UnifiedCreateRecipeArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_UnifiedCreateRecipeRequest_Input>;
};


export type MutationMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_UnifiedRecipeSearchArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_UnifiedRecipeSearchRequest_Input>;
};


export type MutationRetailerContactManagement_AddContactArgs = {
  input?: InputMaybe<RetailerContactManagement_ContactInput_Input>;
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_AddPartnerContactArgs = {
  input?: InputMaybe<RetailerContactManagement_ContactInput_Input>;
  partnerId: Scalars['String'];
};


export type MutationRetailerContactManagement_DeleteAllContactsArgs = {
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_DeleteAllPartnerContactsArgs = {
  partnerId: Scalars['String'];
};


export type MutationRetailerContactManagement_DeleteContactArgs = {
  email: Scalars['EmailAddress'];
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_DeletePartnerContactArgs = {
  email: Scalars['EmailAddress'];
  partnerId: Scalars['String'];
};


export type MutationRetailerContactManagement_UpdateContactArgs = {
  email: Scalars['EmailAddress'];
  input?: InputMaybe<RetailerContactManagement_ContactUpdate_Input>;
  retailerId: Scalars['String'];
};


export type MutationRetailerContactManagement_UpdatePartnerContactArgs = {
  email: Scalars['EmailAddress'];
  input?: InputMaybe<RetailerContactManagement_ContactUpdate_Input>;
  partnerId: Scalars['String'];
};


export type MutationUnifiedMarketingBackendService_Instacart_Growth_Unified_Marketing_Backend_V1_UnifiedMarketingBackendService_InitializeCampaignBriefArgs = {
  input?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_InitializeCampaignBriefRequest_Input>;
};


export type MutationUnifiedMarketingBackendService_Instacart_Growth_Unified_Marketing_Backend_V1_UnifiedMarketingBackendService_TransitionCampaignBriefArgs = {
  input?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_TransitionCampaignBriefRequest_Input>;
};


export type MutationUnifiedMarketingBackendService_Instacart_Growth_Unified_Marketing_Backend_V1_UnifiedMarketingBackendService_UpdateCampaignBriefArgs = {
  input?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_UpdateCampaignBriefRequest_Input>;
};


export type MutationAdminNoticeBannerCreateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  dismissible?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['Int']>;
  pathGlob: Scalars['String'];
  variant: NoticeBannerVariantEnum;
  warehouseId?: InputMaybe<Scalars['Int']>;
};


export type MutationAdminNoticeBannerDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationAdminNoticeBannerUpdateArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  dismissible?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  partnerId?: InputMaybe<Scalars['Int']>;
  pathGlob?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<NoticeBannerVariantEnum>;
  warehouseId?: InputMaybe<Scalars['Int']>;
};


export type MutationAiAgentConversationUpsertArgs = {
  conversationId: Scalars['ID'];
  messages: Array<ChatMessageInput>;
};


export type MutationAiAgentExecuteArgs = {
  input: AgentRequestInput;
};


export type MutationApiIntegrationsServiceDeleteApiSettingArgs = {
  input?: InputMaybe<DeleteApiSettingRequestInput>;
};


export type MutationApiIntegrationsServiceUpdateApiSettingArgs = {
  input?: InputMaybe<UpdateApiSettingRequestInput>;
};


export type MutationApprovalsManagementAddReviewArgs = {
  input: ReviewAddInput;
};


export type MutationApprovalsManagementDeleteReviewArgs = {
  input: ReviewDeleteInput;
};


export type MutationApprovalsManagementEditReviewArgs = {
  input: ReviewEditInput;
};


export type MutationApprovalsManagementPublishApprovalRequestArgs = {
  input: PublishApprovalRequestInput;
};


export type MutationAssignPermissionToRoleArgs = {
  permission: PermissionInput;
  role: RoleInput;
};


export type MutationBotEnterpriseAccountDisableArgs = {
  email: Scalars['String'];
};


export type MutationBotEnterpriseAccountUpsertArgs = {
  email: Scalars['String'];
  extraRoleSlugs?: InputMaybe<Array<Scalars['String']>>;
  givenName: Scalars['String'];
  hasAllPartnersWriteAccess?: InputMaybe<Scalars['Boolean']>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  partnerWriteAccessIds?: InputMaybe<Array<Scalars['ID']>>;
  readOnly?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  role: BotAccountAssignableRoleEnum;
  slackParentMessageTs?: InputMaybe<Scalars['String']>;
  surname: Scalars['String'];
};


export type MutationBotGrantSensitiveAccessArgs = {
  attestations: BotGrantSensitiveAccessAttestationsInput;
  email: Scalars['String'];
  grants: BotGrantSensitiveAccessGrantsInput;
  requestId: Scalars['String'];
};


export type MutationCatalogProblemTrackerServiceCreateTicketArgs = {
  input?: InputMaybe<CreateTicketRequestInput>;
};


export type MutationCatalogToolsApiServiceCreateMassOpsInterventionArgs = {
  input?: InputMaybe<CreateMassOpsInterventionRequestInput>;
};


export type MutationCatalogToolsApiServiceCreatePatchApprovalArgs = {
  input?: InputMaybe<CreatePatchApprovalRequestInput>;
};


export type MutationCatalogToolsApiServiceCreatePriceAnomalyInvestigationArgs = {
  input?: InputMaybe<CreatePriceAnomalyInvestigationRequestInput>;
};


export type MutationCatalogToolsApiServiceCreatePriceAnomalyPatchArgs = {
  input?: InputMaybe<CreatePriceAnomalyPatchRequestInput>;
};


export type MutationCatalogToolsApiServiceCreateProductWithProductCreationDataArgs = {
  input?: InputMaybe<CreateProductWithProductCreationDataRequestInput>;
};


export type MutationCatalogToolsApiServiceDeactivatePriceAnomalyPatchArgs = {
  input?: InputMaybe<DeactivatePriceAnomalyPatchRequestInput>;
};


export type MutationCatalogToolsApiServiceGenerateProductCreationDataArgs = {
  input?: InputMaybe<GenerateProductCreationDataRequestInput>;
};


export type MutationCatalogToolsApiServiceRefreshAffectedOrdersArgs = {
  input?: InputMaybe<RefreshAffectedOrdersRequestInput>;
};


export type MutationCollectionsServiceSetMultiRetailerPageCollectionsCacheArgs = {
  input?: InputMaybe<SetMultiRetailerPageCollectionsCacheRequestInput>;
};


export type MutationConfigurableItemsServicePublishRppConfigurableItemsArgs = {
  input?: InputMaybe<PublishRppConfigurableItemsRequestInput>;
};


export type MutationConnectPlatformServiceAdvanceBatchStateArgs = {
  input?: InputMaybe<AdvanceBatchStateRequestInput>;
};


export type MutationConnectPlatformServiceAssignVirtualBatchArgs = {
  input?: InputMaybe<AssignVirtualBatchRequestInput>;
};


export type MutationConnectPlatformServiceCreateDriverArgs = {
  input?: InputMaybe<CreateDriverRequestInput>;
};


export type MutationConnectPlatformServiceCreatePartnerApiKeyArgs = {
  input?: InputMaybe<CreatePartnerApiKeyRequestInput>;
};


export type MutationConnectPlatformServiceGenerateBatchArgs = {
  input?: InputMaybe<GenerateBatchRequestInput>;
};


export type MutationConnectPlatformServiceRevokePartnerApiKeyArgs = {
  input?: InputMaybe<RevokePartnerApiKeyRequestInput>;
};


export type MutationConnectPlatformServiceUpdateShopperOrderItemArgs = {
  input?: InputMaybe<UpdateShopperOrderItemRequestInput>;
};


export type MutationContentManagementAdminServiceBatchUpdateSlotCreativesArgs = {
  input?: InputMaybe<BatchUpdateSlotCreativesRequestInput>;
};


export type MutationContentManagementAdminServiceCreateAiCarouselArgs = {
  input?: InputMaybe<CreateAiCarouselRequestInput>;
};


export type MutationContentManagementAdminServiceCreateContentPageArgs = {
  input?: InputMaybe<CreateContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceCreateContentPageV2Args = {
  input?: InputMaybe<CreateContentPageRequestV2Input>;
};


export type MutationContentManagementAdminServiceCreateContentPageVersionArgs = {
  input?: InputMaybe<CreateContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServiceCreateContentPageVersionMetaArgs = {
  input?: InputMaybe<CreateContentPageVersionMetaRequestInput>;
};


export type MutationContentManagementAdminServiceCreateCreativePlacementsArgs = {
  input?: InputMaybe<CreateCreativePlacementsRequestInput>;
};


export type MutationContentManagementAdminServiceCreateDefaultNavigationsV2Args = {
  input?: InputMaybe<CreateDefaultNavigationsV2RequestInput>;
};


export type MutationContentManagementAdminServiceCreateFrothTemplateArgs = {
  input?: InputMaybe<CreateFrothTemplateRequestInput>;
};


export type MutationContentManagementAdminServiceCreateFrothTemplateVersionArgs = {
  input?: InputMaybe<CreateFrothTemplateVersionRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNativeTabBarNavigationArgs = {
  input?: InputMaybe<CreateNativeTabBarNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNavigationArgs = {
  input?: InputMaybe<CreateNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNavigationPreviewArgs = {
  input?: InputMaybe<CreateNavigationPreviewRequestInput>;
};


export type MutationContentManagementAdminServiceCreateNavigationV2PreviewArgs = {
  input?: InputMaybe<CreateNavigationV2PreviewRequestInput>;
};


export type MutationContentManagementAdminServiceCreatePlacementContentArgs = {
  input?: InputMaybe<CreatePlacementContentRequestInput>;
};


export type MutationContentManagementAdminServiceCreateSlotArgs = {
  input?: InputMaybe<CreateSlotRequestInput>;
};


export type MutationContentManagementAdminServiceCreateSlotCreativeArgs = {
  input?: InputMaybe<CreateSlotCreativeRequestInput>;
};


export type MutationContentManagementAdminServiceCreateSlotPlacementArgs = {
  input?: InputMaybe<CreateSlotPlacementRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteContentPageArgs = {
  input?: InputMaybe<DeleteContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteContentPageVersionArgs = {
  input?: InputMaybe<DeleteContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteFrothTemplateArgs = {
  input?: InputMaybe<DeleteFrothTemplateRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteFrothTemplateVersionArgs = {
  input?: InputMaybe<DeleteFrothTemplateVersionRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteNativeTabBarNavigationArgs = {
  input?: InputMaybe<DeleteNativeTabBarNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteNavigationArgs = {
  input?: InputMaybe<DeleteNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteSlotArgs = {
  input?: InputMaybe<DeleteSlotRequestInput>;
};


export type MutationContentManagementAdminServiceDeleteSlotCreativeArgs = {
  input?: InputMaybe<DeleteSlotCreativeRequestInput>;
};


export type MutationContentManagementAdminServiceDisablePlacementContentArgs = {
  input?: InputMaybe<DisablePlacementContentRequestInput>;
};


export type MutationContentManagementAdminServiceDuplicateContentPageArgs = {
  input?: InputMaybe<DuplicateContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceLoadOrCreateDraftArgs = {
  input?: InputMaybe<LoadOrCreateDraftRequestInput>;
};


export type MutationContentManagementAdminServicePublishContentPageVersionArgs = {
  input?: InputMaybe<PublishContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServicePublishFrothTemplateVersionArgs = {
  input?: InputMaybe<PublishFrothTemplateVersionRequestInput>;
};


export type MutationContentManagementAdminServiceResetDraftVersionArgs = {
  input?: InputMaybe<ResetDraftVersionRequestInput>;
};


export type MutationContentManagementAdminServiceRestoreContentPageArgs = {
  input?: InputMaybe<RestoreContentPageRequestInput>;
};


export type MutationContentManagementAdminServiceSaveToolingShortcutsArgs = {
  input?: InputMaybe<SaveToolingShortcutsRequestInput>;
};


export type MutationContentManagementAdminServiceSchedulePublishVersionArgs = {
  input?: InputMaybe<SchedulePublishVersionRequestInput>;
};


export type MutationContentManagementAdminServiceStartConvertPlacementVideoArgs = {
  input?: InputMaybe<StartConvertPlacementVideoRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateAdminNavigationV2Args = {
  input?: InputMaybe<UpdateAdminNavigationV2RequestInput>;
};


export type MutationContentManagementAdminServiceUpdateContentPageV2Args = {
  input?: InputMaybe<UpdateContentPageRequestV2Input>;
};


export type MutationContentManagementAdminServiceUpdateContentPageVersionArgs = {
  input?: InputMaybe<UpdateContentPageVersionRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateContentPageVersionMetaArgs = {
  input?: InputMaybe<UpdateContentPageVersionMetaRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateFrothTemplateArgs = {
  input?: InputMaybe<UpdateFrothTemplateRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateFrothTemplateVersionArgs = {
  input?: InputMaybe<UpdateFrothTemplateVersionRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateNativeTabBarNavigationArgs = {
  input?: InputMaybe<UpdateNativeTabBarNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateNavigationArgs = {
  input?: InputMaybe<UpdateNavigationRequestInput>;
};


export type MutationContentManagementAdminServiceUpdatePlacementContentArgs = {
  input?: InputMaybe<UpdatePlacementContentRequestInput>;
};


export type MutationContentManagementAdminServiceUpdateSocialIconsNavigationArgs = {
  input?: InputMaybe<UpdateSocialIconsNavigationRequestInput>;
};


export type MutationContentManagementServiceBatchUpdatePlacementsArgs = {
  input?: InputMaybe<BatchUpdatePlacementsRequestInput>;
};


export type MutationContentManagementServiceCreateLayoutVariantArgs = {
  input?: InputMaybe<CreateLayoutVariantRequestInput>;
};


export type MutationContentManagementServiceCreatePlacementArgs = {
  input?: InputMaybe<CreatePlacementRequestInput>;
};


export type MutationContentManagementServiceCreateThemePageArgs = {
  input?: InputMaybe<CreateThemePageRequestInput>;
};


export type MutationContentManagementServiceDeleteLayoutVariantArgs = {
  input?: InputMaybe<DeleteLayoutVariantRequestInput>;
};


export type MutationContentManagementServiceDeletePlacementArgs = {
  input?: InputMaybe<DeletePlacementRequestInput>;
};


export type MutationContentManagementServiceDisableThemePageArgs = {
  input?: InputMaybe<DisableThemePageRequestInput>;
};


export type MutationContentManagementServiceUpdateLayoutVariantArgs = {
  input?: InputMaybe<UpdateLayoutVariantRequestInput>;
};


export type MutationContentManagementServiceUpdateThemePageArgs = {
  input?: InputMaybe<UpdateThemePageRequestInput>;
};


export type MutationCountryIdsVisibilityConditionCreateArgs = {
  countryIdsVisibilityConditionData: CountryIdsInput;
};


export type MutationCountryIdsVisibilityConditionUpdateArgs = {
  countryIdsVisibilityConditionData: CountryIdsInput;
};


export type MutationDayOfWeekVisibilityConditionCreateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput;
};


export type MutationDayOfWeekVisibilityConditionUpdateArgs = {
  dayOfWeekVisibilityConditionData: DayOfWeekInput;
};


export type MutationDemeterServiceAuditDetectionArgs = {
  input?: InputMaybe<AuditDetectionRequestInput>;
};


export type MutationDemeterServiceBulkUpdateAuditTasksArgs = {
  input?: InputMaybe<BulkUpdateAuditTasksRequestInput>;
};


export type MutationDemeterServiceCombineAuditBatchesArgs = {
  input?: InputMaybe<CombineAuditBatchesRequestInput>;
};


export type MutationDemeterServiceCreateAuditWorkflowArgs = {
  input?: InputMaybe<CreateAuditWorkflowRequestInput>;
};


export type MutationDemeterServiceCreateDetectionArgs = {
  input?: InputMaybe<CreateDetectionRequestInput>;
};


export type MutationDemeterServiceCreateDetectionVersionArgs = {
  input?: InputMaybe<CreateDetectionVersionRequestInput>;
};


export type MutationDemeterServiceReassignAuditBatchWorkflowArgs = {
  input?: InputMaybe<ReassignAuditBatchWorkflowRequestInput>;
};


export type MutationDemeterServiceTombstoneDetectionVersionArgs = {
  input?: InputMaybe<TombstoneDetectionVersionRequestInput>;
};


export type MutationDemeterServiceUpdateAuditBatchArgs = {
  input?: InputMaybe<UpdateAuditBatchRequestInput>;
};


export type MutationDemeterServiceUpdateAuditTaskArgs = {
  input?: InputMaybe<UpdateAuditTaskRequestInput>;
};


export type MutationDemeterServiceUpdateAuditWorkflowArgs = {
  input?: InputMaybe<UpdateAuditWorkflowRequestInput>;
};


export type MutationEmergingBrandPortalServiceContactBrandArgs = {
  input?: InputMaybe<BrandContactRequestInput>;
};


export type MutationEnterpriseAccountAcceptPartnerAgreementArgs = {
  agreementType: AgreementTypeEnum;
  partnerId: Scalars['ID'];
};


export type MutationEnterpriseAccountAccountSetupArgs = {
  givenName?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  rawToken: Scalars['String'];
  surname?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountAuthenticateEmailPasswordArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountAuthenticatePreflightArgs = {
  email: Scalars['String'];
};


export type MutationEnterpriseAccountCreateArgs = {
  accountRequestId?: InputMaybe<Scalars['ID']>;
  email: Scalars['String'];
  givenName: Scalars['String'];
  hasAllPartnersFullAccess: Scalars['Boolean'];
  hasAllPartnersWriteAccess?: InputMaybe<Scalars['Boolean']>;
  hasFullPartnerAccess: Scalars['Boolean'];
  hasFullRetailerAccess: Scalars['Boolean'];
  partnerIds: Array<Scalars['ID']>;
  partnerWriteAccessIds?: InputMaybe<Array<Scalars['ID']>>;
  permissionSlugs?: InputMaybe<Array<Scalars['String']>>;
  phone?: InputMaybe<Scalars['String']>;
  retailerIds: Array<Scalars['ID']>;
  retailerLocationIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
  surname?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userLocale?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountCreateNoPartnerAccessArgs = {
  email: Scalars['String'];
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationEnterpriseAccountEnableImpersonationArgs = {
  breakglass?: InputMaybe<Scalars['Boolean']>;
  breakglassAdditionalInfo?: InputMaybe<Scalars['String']>;
  breakglassJiraTicket?: InputMaybe<Scalars['String']>;
  breakglassReason?: InputMaybe<Scalars['String']>;
  impersonatedCanonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountMfaDeactivateArgs = {
  canonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountMfaEnableArgs = {
  canonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountMfaResetArgs = {
  canonicalId: Scalars['ID'];
};


export type MutationEnterpriseAccountPartnerOnboardingRequestAccountSetupEmailArgs = {
  email: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountRequestAccountSetupEmailArgs = {
  email: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountRequestBreakGlassPartnerWriteAccessArgs = {
  partnerIds: Array<Scalars['ID']>;
  ticketUrl: Scalars['String'];
  userJustification: Scalars['String'];
};


export type MutationEnterpriseAccountRequestEmailVerificationArgs = {
  email: Scalars['String'];
  reCaptchaToken?: InputMaybe<Scalars['String']>;
  turnstileToken?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountResetPasswordArgs = {
  password: Scalars['String'];
  rawToken: Scalars['String'];
};


export type MutationEnterpriseAccountSetDisabledArgs = {
  accountCanonicalId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationEnterpriseAccountUpdateArgs = {
  canonicalId: Scalars['ID'];
  givenName: Scalars['String'];
  hasAllPartnersFullAccess: Scalars['Boolean'];
  hasAllPartnersWriteAccess?: InputMaybe<Scalars['Boolean']>;
  hasFullPartnerAccess: Scalars['Boolean'];
  hasFullRetailerAccess: Scalars['Boolean'];
  partnerIds: Array<Scalars['ID']>;
  partnerWriteAccessIds?: InputMaybe<Array<Scalars['ID']>>;
  permissionSlugs?: InputMaybe<Array<Scalars['String']>>;
  phone?: InputMaybe<Scalars['String']>;
  retailerIds: Array<Scalars['ID']>;
  retailerLocationIds: Array<Scalars['ID']>;
  roleIds: Array<Scalars['ID']>;
  surname?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userLocale?: InputMaybe<Scalars['String']>;
};


export type MutationEnterpriseAccountUpdateHiddenSettingsArgs = {
  hiddenSettings: HiddenSettingsInput;
};


export type MutationEnterpriseAccountUpdatePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type MutationEnterpriseAccountUpdateRolesArgs = {
  addRoleIds?: InputMaybe<Array<Scalars['ID']>>;
  canonicalId: Scalars['ID'];
  removeRoleIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationEnterpriseAccountUpdateUserLocaleArgs = {
  userLocale: Scalars['String'];
};


export type MutationEnterpriseAccountVerifyAccountSetupTokenArgs = {
  rawToken: Scalars['String'];
};


export type MutationEnterpriseAccountVerifyEmailArgs = {
  rawToken: Scalars['String'];
};


export type MutationExperimentVariantVisibilityConditionCreateArgs = {
  experimentVariantVisibilityConditionData: ExperimentVariantInput;
};


export type MutationExperimentVariantVisibilityConditionUpdateArgs = {
  experimentVariantVisibilityConditionData: ExperimentVariantInput;
};


export type MutationExpressMembershipVisibilityConditionCreateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput;
};


export type MutationExpressMembershipVisibilityConditionUpdateArgs = {
  expressMembershipVisibilityConditionData: ExpressMembershipInput;
};


export type MutationExpressNonmemberLongTermHoldoutVisibilityConditionCreateArgs = {
  expressNonmemberLongTermHoldoutVisibilityConditionData: ExpressNonmemberLongTermHoldoutInput;
};


export type MutationFlyoutPlacementCreateArgs = {
  flyoutPlacementData: FlyoutPlacementInput;
};


export type MutationFlyoutPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  flyoutPlacementData: FlyoutPlacementInput;
  id: Scalars['ID'];
};


export type MutationHeroBannerPlacementCreateArgs = {
  heroBannerPlacementData: HeroBannerPlacementInput;
};


export type MutationHeroBannerPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  heroBannerPlacementData: HeroBannerPlacementInput;
  id: Scalars['ID'];
};


export type MutationInstacart_Ads_Nexus_V1_AdsBlockingService_UpsertAdReviewArgs = {
  input?: InputMaybe<Instacart_Ads_Nexus_V1_UpsertAdReviewsRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_CreateGenerativeAudienceSegmentDefinitionArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_CreateSegmentArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_CreateSegmentRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_DeleteSegmentArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_DeleteSegmentRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_EstimateAudienceArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_EstimateAudienceRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_SubmitExactAudienceSizeArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SubmitExactAudienceSizeRequest_Input>;
};


export type MutationInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_UpdateSegmentArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_UpdateSegmentRequest_Input>;
};


export type MutationInstacart_Ads_V3_RetailerBlockedAdsService_RetailerBlockAdArgs = {
  input?: InputMaybe<Instacart_Ads_V3_RetailerBlockAdRequest_Input>;
};


export type MutationInstacart_Ads_V3_RetailerBlockedAdsService_RetailerBlockAdBySha256Args = {
  input?: InputMaybe<Instacart_Ads_V3_RetailerBlockAdBySha256Request_Input>;
};


export type MutationInstacart_Algorithms_Ai_Carousel_Creator_V1_AiCarouselCreatorService_CreateCarouselArgs = {
  input?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselRequest_Input>;
};


export type MutationInstacart_Algorithms_Ai_Carousel_Creator_V1_AiCarouselCreatorService_CreateCarouselV2Args = {
  input?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselV2Request_Input>;
};


export type MutationInstacart_Care_Tools_V1_AppeasementsOrchestratorService_CreateCustomerMiaIssueArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateCustomerMiaIssueRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_AppeasementsOrchestratorService_IssueIcPlusFreeMonthArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_IssueIcPlusFreeMonthRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_AppeasementsOrchestratorService_IssuePoorServiceCreditArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_IssuePoorServiceCreditRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_AddFreeMonthSubscriptionArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_AddFreeMonthSubscriptionRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_AddOrUpdateFulfillmentOrderLineArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_AddOrUpdateFulfillmentOrderLineRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_AdminCancelSubscriptionArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_AdminCancelSubscriptionRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateAddressForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateAddressForUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateNoteForOrderArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateNoteForOrderRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateNoteForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateNoteForUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateOrderReturnArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateOrderReturnRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_CreateUserShopperBanArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CreateUserShopperBanRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_DeleteUserShopperBanArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_DeleteUserShopperBanRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_ForceCompleteOrderArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ForceCompleteOrderRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_LinkIsolatedUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_LinkIsolatedUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UnlinkIsolatedUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UnlinkIsolatedUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UpdateAddressForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UpdateAddressForUserRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UpdateSubscriptionAutorenewArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UpdateUserNameArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UpdateUserNameRequest_Input>;
};


export type MutationInstacart_Care_Tools_V1_CareToolsService_UpdateUserPhoneArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_UpdateUserPhoneRequest_Input>;
};


export type MutationInstacart_Cashflow_Nutella_V1_NutellaService_SetAuditFindingsArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_SetAuditFindingsRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_MakeMissingCodeDecisionArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_MakeMissingCodeDecisionRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_SetRetailerDiscountThresholdBringBacksArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_SetRetailerDiscountThresholdsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdsRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_ApplyChangeRequestArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_ApplyChangeRequestRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_ApproveChangeRequestArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_ApproveChangeRequestRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_CancelChangeRequestArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_CancelChangeRequestRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_CreateChangeRequestArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_CreateChangeRequestRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_RejectChangeRequestArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_RejectChangeRequestRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_RetryAnalysisArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_RetryAnalysisRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_SourcePriorityService_RollbackChangeRequestArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_RollbackChangeRequestRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_TakeDownService_ItemBringBackBatchCsvArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvRequest_Input>;
};


export type MutationInstacart_Catalog_Admin_V1_TempOverrideService_CreateArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideServiceCreateRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_CreateNewStepArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_CreateNewStepRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_CreateNewStepVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_CreateNewStepVersionRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_RevertToStepVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_RevertToStepVersionRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_RunManualStepTestArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_RunManualStepTestRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_UpdateStepArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_UpdateStepRequest_Input>;
};


export type MutationInstacart_Catalog_Catflow_V1_CatflowApi_UpdateStepVersionStateArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_UpdateStepVersionStateRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_AddSchemaVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_AddSchemaVersionRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_CreateBatchArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_CreateBatchEventArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_CreateBatchEventRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_CreateBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_CreateBridgeRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_DeleteBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_DeleteBridgeRequest_Input>;
};


export type MutationInstacart_Catalog_Data_Bridge_V1_DataBridgeService_UpdateBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_UpdateBridgeRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_CreateBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_CreateBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_CreateBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_DeleteBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_DeleteBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramContentRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_DeleteBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramOfferRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_UpdateBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_UpdateBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentRequest_Input>;
};


export type MutationInstacart_Customers_Business_Admin_V1_BusinessAdminService_UpdateBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_BulkUpdateCampaignSlotRankingArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_MarketingAgentCalculatePerformanceMetricsArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_ProcessEmailCsvArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ProcessEmailCsvRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_ProcessMemberCsvArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ProcessMemberCsvRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_SaveMarketingAgentCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Campaigns_V1_CampaignsService_TestOfflineCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_TestOfflineCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Carts_V1_CartsService_SetCartItemsArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_SetCartItemsRequest_Input>;
};


export type MutationInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_AllocateDelegatedCheckoutCartArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_AllocateDelegatedCheckoutCartRequest_Input>;
};


export type MutationInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_CancelDelegatedCheckoutLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_CancelDelegatedCheckoutLinkRequest_Input>;
};


export type MutationInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_CreateDelegatedCheckoutLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_CreateDelegatedCheckoutLinkRequest_Input>;
};


export type MutationInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_SendDelegatedCheckoutLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_SendDelegatedCheckoutLinkRequest_Input>;
};


export type MutationInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_UpdateDelegatedCheckoutCartItemsArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_UpdateDelegatedCheckoutCartItemsRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Coupons_V1_CommerceCouponsService_BulkCreateChildCouponCodesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Coupons_V1_BulkCreateChildCouponCodesRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_CreateValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_PublishValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyRequest_Input>;
};


export type MutationInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_UpdateValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyRequest_Input>;
};


export type MutationInstacart_Customers_Connect_Platform_V1_ConnectPlatformService_GenerateBatchArgs = {
  input?: InputMaybe<Instacart_Customers_Connect_Platform_V1_GenerateBatchRequest_Input>;
};


export type MutationInstacart_Customers_Connect_Platform_V1_ConnectPlatformService_UpdateShopperOrderItemArgs = {
  input?: InputMaybe<Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_AddRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CancelMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CancelMomentRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CancelRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CancelRetailerCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CreateMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CreateMomentRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_CreateRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_CreateRetailerCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateCampaignBudgetArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateMomentRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateMomentCampaignStatusArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignRequest_Input>;
};


export type MutationInstacart_Customers_Coupons_V1_RetailerCampaignService_UpdateRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsRequest_Input>;
};


export type MutationInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_EvaluateRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_Input>;
};


export type MutationInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_PublishRuleSetRunResultsArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsRequest_Input>;
};


export type MutationInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_UpdateRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetRequest_Input>;
};


export type MutationInstacart_Customers_Gifting_V1_GiftOrderDigitalCardService_CreateGiftOrderDigitalCardArgs = {
  input?: InputMaybe<Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardRequest_Input>;
};


export type MutationInstacart_Customers_Gifting_V1_GiftOrderDigitalCardService_UpdateGiftOrderDigitalCardArgs = {
  input?: InputMaybe<Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_CreateLoyaltyBenefitArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_CreateLoyaltyCardValidationArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_CreateLoyaltyProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_DeleteLoyaltyCardValidationArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_DeleteLoyaltyCardValidationRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_UpdateLoyaltyBenefitArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_UpdateLoyaltyCardValidationArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationRequest_Input>;
};


export type MutationInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_UpdateLoyaltyProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramRequest_Input>;
};


export type MutationInstacart_Customers_Partners_V1_PartnersService_CreateOrUpdatePartnerArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequest_Input>;
};


export type MutationInstacart_Customers_Partnership_Offer_V1_PartnershipOfferService_CreateRedemptionUrlsArgs = {
  input?: InputMaybe<Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsRequest_Input>;
};


export type MutationInstacart_Customers_Payments_V1_PaymentsService_CreateStripeConnectedAccountOnboardingLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Payments_V1_CreateStripeConnectedAccountOnboardingLinkRequest_Input>;
};


export type MutationInstacart_Customers_Recipes_V1_RecipesService_BulkUpdateRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_BulkUpdateRecipesRequest_Input>;
};


export type MutationInstacart_Customers_Recipes_V1_RecipesService_UpdateRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_UpdateRecipesRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CloneFlyerContentPageArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CloneFlyerContentPageRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CopyFlyerClickableAreasArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CreateFlyerActivityArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CreateFlyerClickableAreaArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CreateOrUpdateFlyerMetadataArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_DeleteFlyerClickableAreasArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_ProcessFlyerIngestionFileUploadArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_TriggerFlyerSyncArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyerActivityArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyerClickableAreaArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyerPagesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerPagesRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_UpdateFlyersArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateFeaturedCollectionSetArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateFeaturedCollectionSetRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateGlobalCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateInvfMappingArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_CreateRootNodeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteFeaturedCollectionSetArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFeaturedCollectionSetRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteGlobalCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteInvfMappingArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DeleteNavigationNodeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_DuplicateDepartmentArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_OrderNavigationNodesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_QueueNavigationMigrationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateCollectionProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateFeaturedCollectionSetArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFeaturedCollectionSetRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateGlobalCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpdateNavigationConfigurationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_UpsertNavigationNodeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_Orchestrator_V1_RetailerManagementService_DeleteIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_Orchestrator_V1_RetailerManagementService_PublishIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_Orchestrator_V1_RetailerManagementService_RevertIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_CreateIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_DeleteIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_DeleteIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_PublishIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_PublishIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_RevertIppDraftArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_RevertIppDraftRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_UpdateIppDraftContentArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_IppDraftPreviewService_CreateIppDraftPreviewArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_WidgetConfigurationService_EnableCmsSiteWidgetsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsRequest_Input>;
};


export type MutationInstacart_Customers_Retailer_Management_V1_WidgetConfigurationService_UpdateClientConfigurationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationRequest_Input>;
};


export type MutationInstacart_Customers_Search_V1_SearchService_CreateOrUpdateSearchTermOverridesArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesRequest_Input>;
};


export type MutationInstacart_Customers_Search_V1_SearchService_DeleteSearchTermOverridesByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_CancelPartnerBulkDeliveryRouteArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelPartnerBulkDeliveryRouteRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_UpdatePartnerBulkDeliveryRouteArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdatePartnerBulkDeliveryRouteRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehiclesService_CreateWarehouseLocationVehicleArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehiclesService_UpdateWarehouseLocationVehicleArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_AdjustDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_CancelDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_ForceCompleteDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_ForceCompleteDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_MarkOrderItemStatusArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_RescheduleDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftDownloadService_GenerateShiftsReportArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftUploadService_GeneratePresignedFileUploadUrlArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftUploadService_ProcessUploadedCsvArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_BulkShiftUploadService_ValidateUploadedBulkShiftFileArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_CreatePartnerManagedShiftArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_DeletePartnerManagedShiftArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_UpdatePartnerManagedShiftArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_Input>;
};


export type MutationInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShoppersService_UnlockPartnerManagedDriverDeviceArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_OrderSimulationService_AdvanceBatchArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_OrderSimulationService_GenerateBatchArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperSimulationService_CreateShopperArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperRequest_Input>;
};


export type MutationInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperSimulationService_UpdateShopperOrderItemArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_AddChangeRequestReviewArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AddChangeRequestReviewRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_CreateChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_CreateChangeRequestRuleArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestRuleRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_DebugAdvanceChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_DebugAdvanceChangeRequestRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_DeleteChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_DeleteChangeRequestRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_DeleteChangeRequestRuleArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_DeleteChangeRequestRuleRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_PublishChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_PublishChangeRequestRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_RegenerateChangeRequestSamplePricesSnapshotArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RegenerateChangeRequestSamplePricesSnapshotRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_SubmitChangeRequestForReviewArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_SubmitChangeRequestForReviewRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_UpdateChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_UpdateChangeRequestRuleArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestRuleRequest_Input>;
};


export type MutationInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_WithdrawChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_WithdrawChangeRequestRequest_Input>;
};


export type MutationInstacart_Fulfillment_Domains_Transaction_Integrity_V1_TransactionIntegrityService_CreateSecondaryStepLogAuditArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_CreateSecondaryStepLogAuditRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Incentives_V1_IncentiveBudgetOverrideService_CreateBudgetOverrideArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_CreateBudgetOverrideRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Incentives_V1_IncentiveBudgetOverrideService_ReviewBudgetOverrideArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_ReviewBudgetOverrideRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_CreateStepLogAuditArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_ReplayDiveAndCatchArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayDiveAndCatchRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_ReplayReconciliationArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_RunDecisionArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizationService_CategorizeByBatchArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchRequest_Input>;
};


export type MutationInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizationService_CreateCategorizationAnalysisArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisRequest_Input>;
};


export type MutationInstacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanService_CreateUserShopperBanArgs = {
  input?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_CreateUserShopperBanRequest_Input>;
};


export type MutationInstacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanService_DeleteUserShopperBanArgs = {
  input?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_DeleteUserShopperBanRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CancelMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_CreateIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_TestSendIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TestSendIntentionConfigurationRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpdateIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpdateRetailerConfigurationSettingsArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpsertEmailUnsubscribersArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersRequest_Input>;
};


export type MutationInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_UpsertUserSubscriptionStatusArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UpsertUserSubscriptionStatusRequest_Input>;
};


export type MutationInstacart_Infra_Instaform_V1_InstaformService_CreateModuleArgs = {
  input?: InputMaybe<Instacart_Infra_Instaform_V1_CreateModuleRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_MarketplaceOps_CreateRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_MarketplaceOps_DeleteRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_MarketplaceOps_UpdateRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_AddRequestNoteToOpsEscalationRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_BulkUpdateOpsEscalationRequestStatusArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_CreateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_DeleteOpsEscalationRequestRequestNotesArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_DeleteOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_UpdateOpsEscalationRequestRequestNoteArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_UpdateOpsEscalationRequestStatusArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusRequest_Input>;
};


export type MutationInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_UpdateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_AddLocationsToParentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_AddLocationsToParentEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CancelFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CancelFulfillmentEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateClosureEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateClosureEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateClosureEventApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateClosureEventApprovalRequestRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateFulfillmentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateFulfillmentEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateRestrictedAvailabilityEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateRestrictedAvailabilityEventApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_CreateSlaExclusionArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_CreateSlaExclusionRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateClosureEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateClosureEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateFulfillmentEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateRestrictedAvailabilityEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsRequest_Input>;
};


export type MutationInstacart_Logistics_V1_FulfillmentEvents_UpdateSlaExclusionArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_UpdateSlaExclusionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_CancelInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_CancelInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_ChatWithAgentArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ChatWithAgentRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_CreateInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_CreateInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_CreateInterventionBundleArgs = {
  input?: InputMaybe<Instacart_Massops_V1_CreateInterventionBundleRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_CreateInterventionFromBundleArgs = {
  input?: InputMaybe<Instacart_Massops_V1_CreateInterventionFromBundleRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_DropFailingRowsAndRegenArgs = {
  input?: InputMaybe<Instacart_Massops_V1_DropFailingRowsAndRegenRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_ExecuteInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ExecuteInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_ExecuteInterventionQueryArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ExecuteInterventionQueryRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_RequestInterventionApprovalArgs = {
  input?: InputMaybe<Instacart_Massops_V1_RequestInterventionApprovalRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_RequestInterventionBundleApprovalArgs = {
  input?: InputMaybe<Instacart_Massops_V1_RequestInterventionBundleApprovalRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_SyncInterventionApprovalResultArgs = {
  input?: InputMaybe<Instacart_Massops_V1_SyncInterventionApprovalResultRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_SyncInterventionBundleApprovalResultArgs = {
  input?: InputMaybe<Instacart_Massops_V1_SyncInterventionBundleApprovalResultRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_UpdateInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_UpdateInterventionRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_UpdateInterventionCommunicationSettingsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_UpdateInterventionCommunicationSettingsRequest_Input>;
};


export type MutationInstacart_Massops_V1_MassOpsService_UploadInterventionDataArgs = {
  input?: InputMaybe<Instacart_Massops_V1_UploadInterventionDataRequest_Input>;
};


export type MutationInstacart_Medusa_V1_MedusaService_ExecuteMetricsQueryArgs = {
  input?: InputMaybe<Instacart_Medusa_V1_ExecuteMetricsQueryRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_FlipService_CreateFlipNoteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreateFlipNoteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_FlipService_DeleteFlipNoteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_DeleteFlipNoteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_FlipService_UpdateFlipNoteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdateFlipNoteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_MobileAppsManagementService_ReleaseAppToProductionArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ReleaseAppToProductionRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_MobileAppsManagementService_UpdateWhitelabelAppArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdateWhitelabelAppRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_BulkCreatePartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_BulkDeletePartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_BulkUpdatePartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_CreateBulkCreatePartnerConfigurationsApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreateBulkCreatePartnerConfigurationsApprovalRequestRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_CreateBulkDeletePartnerConfigurationsApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreateBulkDeletePartnerConfigurationsApprovalRequestRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_CreateBulkUpdatePartnerConfigurationsApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreateBulkUpdatePartnerConfigurationsApprovalRequestRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_CreatePartnerConfigurationTypeArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_DeletePartnerConfigurationTypeArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_PartnerConfigurationsService_UpdatePartnerConfigurationTypeArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_SandboxService_CreateSandboxWhitelabelSiteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_CreateSandboxWhitelabelSiteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_SandboxService_DeleteSandboxWhitelabelSiteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_DeleteSandboxWhitelabelSiteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_SandboxService_DeprovisionSandboxWhitelabelSiteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_DeprovisionSandboxWhitelabelSiteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_SandboxService_ProvisionSandboxWhitelabelSiteArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ProvisionSandboxWhitelabelSiteRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_SandboxService_ResyncSandboxAttributeValuesArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ResyncSandboxAttributeValuesRequest_Input>;
};


export type MutationInstacart_Partners_Partners_V1_SandboxService_UpdateSandboxWhitelabelSiteMetadataArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_UpdateSandboxWhitelabelSiteMetadataRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_CheckHealthArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_CheckHealthRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutAutomationArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutConnectionArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutStoreArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreRequest_Input>;
};


export type MutationInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_PutSyncStrategyArgs = {
  input?: InputMaybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_CreateInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_CreateInsightsPortalCustomReportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_DeleteInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_RegenerateInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_SetInsightsPortalCustomReportDisabledArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledRequest_Input>;
};


export type MutationInstacart_Retailer_Tools_V2_InsightsPortalService_UpdateInsightsPortalCustomReportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportRequest_Input>;
};


export type MutationInstacart_Retailers_V1_AppeasementsService_GiveAppeasementsArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GiveAppeasementsRequest_Input>;
};


export type MutationInstacart_Retailers_V1_RetailersService_UpsertWidgetsConfigArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_UpsertWidgetsConfigRequest_Input>;
};


export type MutationInstacart_Roulette_V1_RouletteService_StoreFeatureArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_StoreFeatureRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutIntegrationArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutIntegrationRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutProfileArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutProfileRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutRetailerArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutRetailerRequest_Input>;
};


export type MutationInstacart_Upos_Config_V1_ConfigService_PutStoreArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_PutStoreRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CancelPreviewArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CancelPreviewRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_ClaimPipelineOwnershipArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ClaimPipelineOwnershipRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateNewStepArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateNewStepRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateNewStepVersionArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateNewStepVersionRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateOrUpdateScheduledWorkflowArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreatePipelineAlertConfigArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreatePipelineAlertConfigRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreatePreviewArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreatePreviewRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_CreateStepFilterTagArgs = {
  input?: InputMaybe<Instacart_Waves_V1_CreateStepFilterTagRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_DeletePipelineAlertConfigArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DeletePipelineAlertConfigRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_DeleteScheduledWorkflowArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DeleteScheduledWorkflowRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_DeleteStepAlertThresholdArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DeleteStepAlertThresholdRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_DeleteStepFilterTagArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DeleteStepFilterTagRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_InvalidateDeduplicationArgs = {
  input?: InputMaybe<Instacart_Waves_V1_InvalidateDeduplicationRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_RunCampStepVersionArgs = {
  input?: InputMaybe<Instacart_Waves_V1_RunCampStepVersionRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_TombstoneStepArgs = {
  input?: InputMaybe<Instacart_Waves_V1_TombstoneStepRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_TombstoneStepVersionArgs = {
  input?: InputMaybe<Instacart_Waves_V1_TombstoneStepVersionRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_UpdatePipelineAlertConfigArgs = {
  input?: InputMaybe<Instacart_Waves_V1_UpdatePipelineAlertConfigRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_UpdateStepArgs = {
  input?: InputMaybe<Instacart_Waves_V1_UpdateStepRequest_Input>;
};


export type MutationInstacart_Waves_V1_WavesService_UpsertStepAlertThresholdArgs = {
  input?: InputMaybe<Instacart_Waves_V1_UpsertStepAlertThresholdRequest_Input>;
};


export type MutationInventoryIntelligenceServiceCreateOosAcknowledgmentArgs = {
  input?: InputMaybe<CreateOosAcknowledgmentRequestInput>;
};


export type MutationInventoryIntelligenceServiceCreateRecommendationFeedbackArgs = {
  input?: InputMaybe<CreateRecommendationFeedbackRequestInput>;
};


export type MutationLinkAutosuggestServiceCreateOrUpdateLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<CreateOrUpdateLinkAutosuggestionAdminRequestInput>;
};


export type MutationLinkAutosuggestServiceDeleteLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<DeleteLinkAutosuggestionAdminRequestInput>;
};


export type MutationMarketingFeatureCancelCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationMarketingFeatureStartCampaignArgs = {
  campaign: StartCampaignInput;
};


export type MutationMarketingFeatureTriggerCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type MutationMatchesAnyRetailerIdVisibilityConditionCreateArgs = {
  matchesAnyRetailerIdVisibilityConditionData: MatchesAnyRetailerIdInput;
};


export type MutationMatchesAnyRetailerIdVisibilityConditionUpdateArgs = {
  matchesAnyRetailerIdVisibilityConditionData: MatchesAnyRetailerIdInput;
};


export type MutationMinimumPlatformVersionVisibilityConditionCreateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput;
};


export type MutationMinimumPlatformVersionVisibilityConditionUpdateArgs = {
  minimumPlatformVersionVisibilityConditionData: MinimumPlatformVersionInput;
};


export type MutationNewVerticalUserTargetingVisibilityConditionCreateArgs = {
  newVerticalUserTargetingVisibilityConditionData: NewVerticalUserTargetingInput;
};


export type MutationNewVerticalUserTargetingVisibilityConditionUpdateArgs = {
  newVerticalUserTargetingVisibilityConditionData: NewVerticalUserTargetingInput;
};


export type MutationNormalizedReportsMergeArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  partnerId: Scalars['ID'];
  reportType: MergeableReportTypeEnum;
  retailerId: Scalars['ID'];
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  startDate: Scalars['ISO8601Date'];
};


export type MutationNotificationSubscriptionCreateArgs = {
  accountId: Scalars['ID'];
  notificationChannelId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  subscriptionMethod?: InputMaybe<NotificationSubscriptionMethodEnum>;
};


export type MutationNotificationSubscriptionDeleteArgs = {
  accountId: Scalars['ID'];
  notificationChannelId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  subscriptionMethod?: InputMaybe<NotificationSubscriptionMethodEnum>;
};


export type MutationNotificationsDeleteArgs = {
  notificationIds: Array<Scalars['ID']>;
};


export type MutationNotificationsMarkReadArgs = {
  notificationIds: Array<Scalars['ID']>;
};


export type MutationOnboardingMobileAppPropertiesUpdateArgs = {
  mobileAppProperties: Array<PropertyInput>;
  os: Os;
  storeConfigurationId: Scalars['Int'];
};


export type MutationOnboardingServiceBulkUpdateApprovalRequestStatusArgs = {
  input?: InputMaybe<BulkUpdateApprovalRequestStatusRequestInput>;
};


export type MutationOnboardingServiceCreateAutomatedTestRunArgs = {
  input?: InputMaybe<CreateAutomatedTestRunRequestInput>;
};


export type MutationOnboardingServiceCreateOnboardingStoreLocationArgs = {
  input?: InputMaybe<CreateOnboardingStoreLocationRequestInput>;
};


export type MutationOnboardingServiceCreateSignupArgs = {
  input?: InputMaybe<CreateSignupRequestInput>;
};


export type MutationOnboardingServiceCreateSiteSetupFormAccessRequestArgs = {
  input?: InputMaybe<CreateSiteSetupFormAccessRequestRequestInput>;
};


export type MutationOnboardingServiceCreateWhitelabelSiteArgs = {
  input?: InputMaybe<CreateWhitelabelSiteRequestInput>;
};


export type MutationOnboardingServiceCreateWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<CreateWhitelabelSiteCustomizableStringRequestInput>;
};


export type MutationOnboardingServiceCreateWhitelabelStoreConfigurationArgs = {
  input?: InputMaybe<CreateWhitelabelStoreConfigurationRequestInput>;
};


export type MutationOnboardingServiceDeleteLaunchOnboardingWarehouseLocationArgs = {
  input?: InputMaybe<DeleteLaunchOnboardingWarehouseLocationRequestInput>;
};


export type MutationOnboardingServiceDeleteWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<DeleteWhitelabelSiteCustomizableStringRequestInput>;
};


export type MutationOnboardingServiceGeneratePresignedAssetDownloadUrlArgs = {
  input?: InputMaybe<GeneratePresignedAssetDownloadUrlRequestInput>;
};


export type MutationOnboardingServiceGeneratePresignedAssetUploadUrlArgs = {
  input?: InputMaybe<GeneratePresignedAssetUploadUrlRequestInput>;
};


export type MutationOnboardingServiceGeneratePrsForStringOverrideArgs = {
  input?: InputMaybe<GeneratePrsForStringOverrideRequestInput>;
};


export type MutationOnboardingServiceLockSiteSetupFormArgs = {
  input?: InputMaybe<LockSiteSetupFormRequestInput>;
};


export type MutationOnboardingServiceOnboardRelayRetailerArgs = {
  input?: InputMaybe<OnboardRelayRetailerRequestInput>;
};


export type MutationOnboardingServiceSendWhitelabelSiteRetailerEmailArgs = {
  input?: InputMaybe<SendWhitelabelSiteRetailerEmailRequestInput>;
};


export type MutationOnboardingServiceStartWhitelabelGumloopWorkflowArgs = {
  input?: InputMaybe<StartWhitelabelGumloopWorkflowRequestInput>;
};


export type MutationOnboardingServiceTriggerRakeTaskForStoreConfigurationArgs = {
  input?: InputMaybe<TriggerRakeTaskForStoreConfigurationRequestInput>;
};


export type MutationOnboardingServiceUpdateApprovalRequestStatusArgs = {
  input?: InputMaybe<UpdateApprovalRequestStatusRequestInput>;
};


export type MutationOnboardingServiceUpdateLaunchOnboardingWarehouseInfoArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWarehouseInfoRequestInput>;
};


export type MutationOnboardingServiceUpdateLaunchOnboardingWarehouseLocationInfoArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWarehouseLocationInfoRequestInput>;
};


export type MutationOnboardingServiceUpdateLaunchOnboardingWorkflowStateArgs = {
  input?: InputMaybe<UpdateLaunchOnboardingWorkflowStateRequestInput>;
};


export type MutationOnboardingServiceUpdateOnboardingArgs = {
  input?: InputMaybe<UpdateOnboardingRequestInput>;
};


export type MutationOnboardingServiceUpdateOnboardingBillingAddressArgs = {
  input?: InputMaybe<UpdateOnboardingBillingAddressRequestInput>;
};


export type MutationOnboardingServiceUpdateOnboardingWorkflowStateArgs = {
  input?: InputMaybe<UpdateOnboardingWorkflowStateRequestInput>;
};


export type MutationOnboardingServiceUpdateRetailerFormGroupVisibilityArgs = {
  input?: InputMaybe<UpdateRetailerFormGroupVisibilityRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteAttributesArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteAttributesRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteAttributesAdminArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteAttributesAdminRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteCustomizableStringRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteSlackChannelArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteSlackChannelRequestInput>;
};


export type MutationOnboardingServiceUpdateWhitelabelSiteWorkflowStateArgs = {
  input?: InputMaybe<UpdateWhitelabelSiteWorkflowStateRequestInput>;
};


export type MutationOnboardingTriggerWorkflowArgs = {
  storeConfigurationId: Scalars['Int'];
  workflowName: Scalars['String'];
  workflowParameters: Array<WorkflowParameter>;
};


export type MutationOrderServiceCancelOrderArgs = {
  input?: InputMaybe<CancelOrderRequestInput>;
};


export type MutationOrderServiceCreateLastmileOrderFromDashboardArgs = {
  input?: InputMaybe<CreateLastmileOrderFromDashboardRequestInput>;
};


export type MutationOrderServiceReopenLastmileOrderArgs = {
  input?: InputMaybe<ReopenLastmileOrderRequestInput>;
};


export type MutationOrderServiceRescheduleOrderArgs = {
  input?: InputMaybe<RescheduleOrderRequestInput>;
};


export type MutationOrderServiceStageLastmileOrderArgs = {
  input?: InputMaybe<StageLastmileOrderRequestInput>;
};


export type MutationPartnerPickDeviceCreateArgs = {
  deviceType: DeviceTypeEnum;
  email: Scalars['String'];
  firstName: Scalars['String'];
  isPartnerPickStoreManager: Scalars['Boolean'];
  lastName: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  warehouseLocationId: Scalars['ID'];
};


export type MutationPartnerPickDeviceSetStatusArgs = {
  active: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationPartnerPickDeviceUpdateArgs = {
  deviceType?: InputMaybe<DeviceTypeEnum>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isPartnerPickStoreManager?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  warehouseLocationId?: InputMaybe<Scalars['ID']>;
};


export type MutationPartnerPickRecurringShiftCreateArgs = {
  daysOfWeek: Array<Scalars['Int']>;
  driverId: Scalars['ID'];
  onCall?: InputMaybe<Scalars['Boolean']>;
  recurEndDate?: InputMaybe<Scalars['String']>;
  recurStartDate: Scalars['String'];
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  shiftType: ShiftTypeEnum;
  warehouseLocationId: Scalars['ID'];
};


export type MutationPartnerPickRecurringShiftDeleteArgs = {
  deleteShiftsFromDate: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationPartnerPickRecurringShiftUpdateArgs = {
  daysOfWeek?: InputMaybe<Array<Scalars['Int']>>;
  id: Scalars['ID'];
  onCall?: InputMaybe<Scalars['Boolean']>;
  recurEndDate?: InputMaybe<Scalars['String']>;
  recurStartDate?: InputMaybe<Scalars['String']>;
  shiftLengthSeconds?: InputMaybe<Scalars['Int']>;
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['Int']>;
};


export type MutationPrivacyServiceCreatePiiRequestForRetailerArgs = {
  input?: InputMaybe<CreatePiiRequestForRetailerRequestInput>;
};


export type MutationReportRequestCreateArgs = {
  associatedObjectId: Scalars['ID'];
  associatedObjectType: ReportRequestAssociatedObjectTypeEnum;
  filters?: InputMaybe<ReportFilters>;
  name: Scalars['String'];
  reportId: Scalars['ID'];
};


export type MutationRetailerAislesUpdateRetailerAisleTemplateArgs = {
  input?: InputMaybe<UpdateRetailerAisleTemplateRequestInput>;
};


export type MutationRetailerAvailabilityVisibilityConditionCreateArgs = {
  retailerAvailabilityVisibilityConditionData: RetailerAvailabilityInput;
};


export type MutationRetailerAvailabilityVisibilityConditionUpdateArgs = {
  retailerAvailabilityVisibilityConditionData: RetailerAvailabilityInput;
};


export type MutationRetailerCampaignServiceAddRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<AddRetailerCampaignTreatmentsRequestInput>;
};


export type MutationRetailerCampaignServiceCancelMomentArgs = {
  input?: InputMaybe<CancelMomentRequestInput>;
};


export type MutationRetailerCampaignServiceCancelRetailerCampaignArgs = {
  input?: InputMaybe<CancelRetailerCampaignRequestInput>;
};


export type MutationRetailerCampaignServiceCreateMomentArgs = {
  input?: InputMaybe<CreateMomentRequestInput>;
};


export type MutationRetailerCampaignServiceCreateRetailerCampaignArgs = {
  input?: InputMaybe<CreateRetailerCampaignRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateMomentArgs = {
  input?: InputMaybe<UpdateMomentRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateMomentCampaignStatusArgs = {
  input?: InputMaybe<UpdateMomentCampaignStatusRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateRetailerCampaignArgs = {
  input?: InputMaybe<UpdateRetailerCampaignRequestInput>;
};


export type MutationRetailerCampaignServiceUpdateRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<UpdateRetailerCampaignTreatmentsRequestInput>;
};


export type MutationRetailerLocationGroupCreateArgs = {
  name: Scalars['String'];
  partnerId: Scalars['ID'];
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRetailerLocationGroupDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationRetailerLocationGroupUpdateArgs = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationRetailerManagementServiceAddStoreConfigurationToClientConfigurationArgs = {
  input?: InputMaybe<AddStoreConfigurationToClientConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceClonePartnerOauthApplicationArgs = {
  input?: InputMaybe<ClonePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceCreateClientConfigurationArgs = {
  input?: InputMaybe<CreateClientConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceCreateConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<CreateConnectRetailerCallbackConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceCreateStoreConfigurationArgs = {
  input?: InputMaybe<CreateStoreConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceDeleteConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<DeleteConnectRetailerCallbackConfigurationRequestInput>;
};


export type MutationRetailerManagementServiceDeletePartnerOauthApplicationArgs = {
  input?: InputMaybe<DeletePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceDisablePartnerOauthApplicationArgs = {
  input?: InputMaybe<DisablePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceEnablePartnerOauthApplicationArgs = {
  input?: InputMaybe<EnablePartnerOauthApplicationRequestInput>;
};


export type MutationRetailerManagementServiceUpdateClientConfigurationForOrdersDashboardArgs = {
  input?: InputMaybe<UpdateClientConfigurationForOrdersDashboardRequestInput>;
};


export type MutationRetailerManagementServiceUpdateConnectRetailerCallbackConfigurationArgs = {
  input?: InputMaybe<UpdateConnectRetailerCallbackConfigurationRequestInput>;
};


export type MutationRetailerMfaSetEnabledArgs = {
  retailerId: Scalars['ID'];
  value: Scalars['Boolean'];
};


export type MutationRetailerProductAttributeEditServiceUpdateAvailabilityScoreOverrideArgs = {
  input?: InputMaybe<UpdateAvailabilityScoreOverrideRequestInput>;
};


export type MutationRetailerProductAttributeEditServiceUpdateRetailerProductVisibilitiesArgs = {
  input?: InputMaybe<UpdateRetailerProductVisibilitiesRequestInput>;
};


export type MutationRetailerSatisfactionSurveySubmissionCreateArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  accountUuid?: InputMaybe<Scalars['String']>;
  milestoneSlug?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  shownAt: Scalars['String'];
  submittedAt: Scalars['String'];
  surveyResponses: Array<RetailerSatisfactionSurveyResponse>;
  urlPath: Scalars['String'];
  workflowSlug?: InputMaybe<Scalars['String']>;
};


export type MutationRetailerSettingsServiceDeleteImageArgs = {
  input?: InputMaybe<DeleteImageRequestInput>;
};


export type MutationRetailerSettingsServiceUpdateParkingSettingsArgs = {
  input?: InputMaybe<UpdateParkingSettingsRequestInput>;
};


export type MutationRetailerSettingsServiceUpdateStagingSettingsArgs = {
  input?: InputMaybe<UpdateStagingSettingsRequestInput>;
};


export type MutationRetailerStoreHoursUpdateConfirmStoreHoursArgs = {
  input?: InputMaybe<UpdateConfirmedStoreHoursRequestInput>;
};


export type MutationRetailerStoreHoursUpdateStoreHoursArgs = {
  input?: InputMaybe<UpdateStoreHoursRequestInput>;
};


export type MutationRetailersServiceMoveRetailerAssetsFromFilestackBucketArgs = {
  input?: InputMaybe<MoveRetailerAssetsFromFilestackBucketRequestInput>;
};


export type MutationReturnsServiceCreateOrUpdateReturnArgs = {
  input?: InputMaybe<CreateOrUpdateReturnRequestInput>;
};


export type MutationRoleCreateArgs = {
  role: CreateRoleInput;
};


export type MutationRoleDeleteArgs = {
  roleId: Scalars['ID'];
};


export type MutationRoleUpdateArgs = {
  role: UpdateRoleInput;
};


export type MutationRppBulkImageUploadsServiceCreateImageUploadBatchArgs = {
  input?: InputMaybe<CreateImageUploadBatchRequestInput>;
};


export type MutationSavedViewsDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationSavedViewsSaveArgs = {
  featureContext: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  viewState: Scalars['JSON'];
};


export type MutationSecondaryBannerPlacementCreateArgs = {
  secondaryBannerPlacementData: SecondaryBannerPlacementInput;
};


export type MutationSecondaryBannerPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  id: Scalars['ID'];
  secondaryBannerPlacementData: SecondaryBannerPlacementInput;
};


export type MutationShoppedAtRetailerVisibilityConditionCreateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput;
};


export type MutationShoppedAtRetailerVisibilityConditionUpdateArgs = {
  shoppedAtRetailerVisibilityConditionData: ShoppedAtRetailerInput;
};


export type MutationShoppedVisibilityConditionCreateArgs = {
  shoppedVisibilityConditionData: ShoppedInput;
};


export type MutationShoppedVisibilityConditionUpdateArgs = {
  shoppedVisibilityConditionData: ShoppedInput;
};


export type MutationStoreConfigurationsDraftServiceCreateStoreConfigurationDraftArgs = {
  input?: InputMaybe<CreateStoreConfigurationDraftRequestInput>;
};


export type MutationStoreConfigurationsDraftServicePublishStoreConfigurationDraftArgs = {
  input?: InputMaybe<PublishStoreConfigurationDraftRequestInput>;
};


export type MutationStoreConfigurationsDraftServiceRollbackStoreConfigurationArgs = {
  input?: InputMaybe<RollbackStoreConfigurationRequestInput>;
};


export type MutationStoreConfigurationsDraftServiceUpdateStoreConfigurationDraftArgs = {
  input?: InputMaybe<UpdateStoreConfigurationDraftRequestInput>;
};


export type MutationStorefrontPlacementCreateArgs = {
  retailerId: Scalars['ID'];
  storefrontPlacementData: StorefrontPlacementInput;
};


export type MutationStorefrontPlacementDeleteArgs = {
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
};


export type MutationStorefrontPlacementUpdateArgs = {
  bannerId: Scalars['ID'];
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
  storefrontPlacementData: StorefrontPlacementInput;
};


export type MutationSubmitBulkRoleOperationArgs = {
  input: SubmitBulkRoleOperationInput;
};


export type MutationSubmitBulkUserOperationArgs = {
  input: SubmitBulkUserOperationInput;
};


export type MutationUserInteractionLimitVisibilityConditionCreateArgs = {
  userInteractionLimitVisibilityConditionData: UserInteractionLimitInput;
};


export type MutationUserInteractionLimitVisibilityConditionUpdateArgs = {
  userInteractionLimitVisibilityConditionData: UserInteractionLimitInput;
};


export type MutationUserSettingServiceSetUserSettingArgs = {
  input?: InputMaybe<SetUserSettingRequestInput>;
};


export type MutationUsersServiceCreateAddressWithoutDuplicatesArgs = {
  input?: InputMaybe<CreateAddressWithoutDuplicatesRequestInput>;
};


export type MutationUsersServiceCreateUserWithoutPasswordArgs = {
  input?: InputMaybe<CreateUserWithoutPasswordRequestInput>;
};


export type MutationUsersServiceGrantImpersonationArgs = {
  input?: InputMaybe<GrantImpersonationRequestInput>;
};


export type MutationUsersServiceUpdateAddressToDefaultByIdArgs = {
  input?: InputMaybe<UpdateAddressToDefaultByIdRequestInput>;
};


export type MutationUsersServiceUpdateUserProfileInfoArgs = {
  input?: InputMaybe<UpdateUserProfileInfoRequestInput>;
};


export type MutationUtmParametersVisibilityConditionCreateArgs = {
  utmParametersVisibilityConditionData: UtmParametersInput;
};


export type MutationUtmParametersVisibilityConditionUpdateArgs = {
  utmParametersVisibilityConditionData: UtmParametersInput;
};


export type MutationValueBasedOverrideServiceCreateValueBasedOverrideArgs = {
  input?: InputMaybe<CreateValueBasedOverrideRequestInput>;
};


export type MutationVirtualPartnerUpdateRetailersArgs = {
  partnerId: Scalars['ID'];
  retailerIds: Array<Scalars['ID']>;
};


export type MutationVisibilityConditionDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationWhitelistedPostalCodesVisibilityConditionCreateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput;
};


export type MutationWhitelistedPostalCodesVisibilityConditionUpdateArgs = {
  whitelistedPostalCodesVisibilityConditionData: WhitelistedPostalCodesInput;
};


export type MutationWhitelistedZonesVisibilityConditionCreateArgs = {
  whitelistedZonesVisibilityConditionData: WhitelistedZonesInput;
};


export type MutationWhitelistedZonesVisibilityConditionUpdateArgs = {
  whitelistedZonesVisibilityConditionData: WhitelistedZonesInput;
};


export type MutationWizardProgressUpdateArgs = {
  complete?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

export type NativeMoreMenuLayoutV1Navigations = {
  __typename?: 'NativeMoreMenuLayoutV1Navigations';
  navs?: Maybe<Array<Maybe<NativeMoreMenuNavigation>>>;
};

export type NativeMoreMenuLayoutV1NavigationsInput = {
  navs?: InputMaybe<Array<InputMaybe<NativeMoreMenuNavigationInput>>>;
};

export type NativeMoreMenuNavigation = {
  __typename?: 'NativeMoreMenuNavigation';
  gridNavigation?: Maybe<GridNavigation>;
  navigationWithSubNavigation?: Maybe<NavigationWithSubNavigation>;
};

export type NativeMoreMenuNavigationInput = {
  gridNavigation?: InputMaybe<GridNavigationInput>;
  navigationWithSubNavigation?: InputMaybe<NavigationWithSubNavigationInput>;
};

export type NativeTabBarNavigation = {
  __typename?: 'NativeTabBarNavigation';
  displayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
};

export type NativeTabBarNavigationInput = {
  displayText?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToAllCarts = {
  __typename?: 'NavigateToAllCarts';
  _?: Maybe<Scalars['Boolean']>;
};

export type NavigateToAllCartsInput = {
  _?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToAskInstacart = {
  __typename?: 'NavigateToAskInstacart';
  prompt?: Maybe<Scalars['String']>;
  useBusinessDerivedAttributes?: Maybe<Scalars['Boolean']>;
};

export type NavigateToAskInstacartInput = {
  prompt?: InputMaybe<Scalars['String']>;
  useBusinessDerivedAttributes?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToAuthentication = {
  __typename?: 'NavigateToAuthentication';
  authentication?: Maybe<Authentication>;
};

export type NavigateToAuthenticationInput = {
  authentication?: InputMaybe<AuthenticationInput>;
};

export type NavigateToBenefitsModal = {
  __typename?: 'NavigateToBenefitsModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type NavigateToBenefitsModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToCategorySurface = {
  __typename?: 'NavigateToCategorySurface';
  categorySurfaceType?: Maybe<CategorySurfaceType>;
};

export type NavigateToCategorySurfaceInput = {
  categorySurfaceType?: InputMaybe<CategorySurfaceType>;
};

export type NavigateToCollaborativeShopInfoModal = {
  __typename?: 'NavigateToCollaborativeShopInfoModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type NavigateToCollaborativeShopInfoModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToCollection = {
  __typename?: 'NavigateToCollection';
  legacyPath?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type NavigateToCollectionHub = {
  __typename?: 'NavigateToCollectionHub';
  category?: Maybe<Scalars['String']>;
  collection?: Maybe<Scalars['String']>;
};

export type NavigateToCollectionHubInput = {
  category?: InputMaybe<Scalars['String']>;
  collection?: InputMaybe<Scalars['String']>;
};

export type NavigateToCollectionInput = {
  legacyPath?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type NavigateToContainerPathViaStoreSelector = {
  __typename?: 'NavigateToContainerPathViaStoreSelector';
  retailers?: Maybe<Array<Maybe<RetailerContainerPath>>>;
};

export type NavigateToContainerPathViaStoreSelectorInput = {
  retailers?: InputMaybe<Array<InputMaybe<RetailerContainerPathInput>>>;
};

export type NavigateToContentPage = {
  __typename?: 'NavigateToContentPage';
  anchorId?: Maybe<Scalars['String']>;
  initialFilters?: Maybe<Array<Maybe<NavigateToContentPageInitialFilter>>>;
  modalInfo?: Maybe<NavigateToContentPageModalInfo>;
  slug?: Maybe<Scalars['String']>;
};

export type NavigateToContentPageInitialFilter = {
  __typename?: 'NavigateToContentPageInitialFilter';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type NavigateToContentPageInitialFilterInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type NavigateToContentPageInput = {
  anchorId?: InputMaybe<Scalars['String']>;
  initialFilters?: InputMaybe<Array<InputMaybe<NavigateToContentPageInitialFilterInput>>>;
  modalInfo?: InputMaybe<NavigateToContentPageModalInfoInput>;
  slug?: InputMaybe<Scalars['String']>;
};

export type NavigateToContentPageModalInfo = {
  __typename?: 'NavigateToContentPageModalInfo';
  size?: Maybe<ModalSize>;
};

export type NavigateToContentPageModalInfoInput = {
  size?: InputMaybe<ModalSize>;
};

export type NavigateToCouponRedemption = {
  __typename?: 'NavigateToCouponRedemption';
  couponCode?: Maybe<Scalars['String']>;
  landingUrl?: Maybe<Scalars['String']>;
  validateDays?: Maybe<Scalars['BigInt']>;
  visibleAfterRedeem?: Maybe<Scalars['Boolean']>;
};

export type NavigateToCouponRedemptionInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  landingUrl?: InputMaybe<Scalars['String']>;
  validateDays?: InputMaybe<Scalars['BigInt']>;
  visibleAfterRedeem?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToDepartment = {
  __typename?: 'NavigateToDepartment';
  departmentId?: Maybe<Scalars['BigInt']>;
};

export type NavigateToDepartmentInput = {
  departmentId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToExpressAccountPage = {
  __typename?: 'NavigateToExpressAccountPage';
  id?: Maybe<Scalars['BigInt']>;
};

export type NavigateToExpressAccountPageInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToFlyers = {
  __typename?: 'NavigateToFlyers';
  isDigitalFlyer?: Maybe<Scalars['Boolean']>;
  tag?: Maybe<Scalars['String']>;
};

export type NavigateToFlyersInput = {
  isDigitalFlyer?: InputMaybe<Scalars['Boolean']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type NavigateToHouseholdAccountSharingFlow = {
  __typename?: 'NavigateToHouseholdAccountSharingFlow';
  id?: Maybe<Scalars['BigInt']>;
};

export type NavigateToHouseholdAccountSharingFlowInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPartnershipModal = {
  __typename?: 'NavigateToPartnershipModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type NavigateToPartnershipModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPickupStoreSelector = {
  __typename?: 'NavigateToPickupStoreSelector';
  showDistance?: Maybe<Scalars['Boolean']>;
};

export type NavigateToPickupStoreSelectorInput = {
  showDistance?: InputMaybe<Scalars['Boolean']>;
};

export type NavigateToProduct = {
  __typename?: 'NavigateToProduct';
  productId?: Maybe<Scalars['BigInt']>;
};

export type NavigateToProductInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPromoModal = {
  __typename?: 'NavigateToPromoModal';
  discountPolicyId?: Maybe<Scalars['BigInt']>;
};

export type NavigateToPromoModalInput = {
  discountPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToPromotionDetail = {
  __typename?: 'NavigateToPromotionDetail';
  id?: Maybe<Scalars['BigInt']>;
};

export type NavigateToPromotionDetailInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type NavigateToRetailerCollection = {
  __typename?: 'NavigateToRetailerCollection';
  retailerId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
};

export type NavigateToRetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type NavigateToRetailerCollectionViaStoreSelector = {
  __typename?: 'NavigateToRetailerCollectionViaStoreSelector';
  retailerCollections?: Maybe<Array<Maybe<RetailerCollection>>>;
};

export type NavigateToRetailerCollectionViaStoreSelectorInput = {
  retailerCollections?: InputMaybe<Array<InputMaybe<RetailerCollectionInput>>>;
};

export type NavigateToSsaStoreSelector = {
  __typename?: 'NavigateToSsaStoreSelector';
  serviceAreaType?: Maybe<Scalars['String']>;
};

export type NavigateToSsaStoreSelectorInput = {
  serviceAreaType?: InputMaybe<Scalars['String']>;
};

export type NavigateToStoreSelector = {
  __typename?: 'NavigateToStoreSelector';
  collectionSlug?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  storeForwardModuleType?: Maybe<Scalars['String']>;
};

export type NavigateToStoreSelectorInput = {
  collectionSlug?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeForwardModuleType?: InputMaybe<Scalars['String']>;
};

export type NavigateToStoreSelectorWithOffer = {
  __typename?: 'NavigateToStoreSelectorWithOffer';
  itemId?: Maybe<Scalars['String']>;
  offerRequestKey?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type NavigateToStoreSelectorWithOfferInput = {
  itemId?: InputMaybe<Scalars['String']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type NavigateToStorefront = {
  __typename?: 'NavigateToStorefront';
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerSlug?: Maybe<Scalars['String']>;
};

export type NavigateToStorefrontInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
};

export type NavigateToUrl = {
  __typename?: 'NavigateToUrl';
  openAsModal?: Maybe<Scalars['Boolean']>;
  openInNewTab?: Maybe<Scalars['Boolean']>;
  openInNewWindow?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type NavigateToUrlInput = {
  openAsModal?: InputMaybe<Scalars['Boolean']>;
  openInNewTab?: InputMaybe<Scalars['Boolean']>;
  openInNewWindow?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};

export type Navigation = {
  __typename?: 'Navigation';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationItem>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  logoUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
};

export type NavigationAction = {
  __typename?: 'NavigationAction';
  data?: Maybe<Scalars['JSONObject']>;
  typeName?: Maybe<Scalars['String']>;
};

export type NavigationActionInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

export type NavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  logoUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type NavigationItem = {
  __typename?: 'NavigationItem';
  actions?: Maybe<Array<Maybe<NavigationAction>>>;
  groupPosition?: Maybe<Scalars['String']>;
  grouping?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  icon2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  isNested?: Maybe<Scalars['Boolean']>;
  itemType?: Maybe<Scalars['String']>;
  placement?: Maybe<PlacementContent>;
  placementId?: Maybe<Scalars['BigInt']>;
  position?: Maybe<Scalars['BigInt']>;
  text?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type NavigationItemInput = {
  actions?: InputMaybe<Array<InputMaybe<NavigationActionInput>>>;
  groupPosition?: InputMaybe<Scalars['String']>;
  grouping?: InputMaybe<Scalars['String']>;
  icon?: InputMaybe<Scalars['String']>;
  icon2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isNested?: InputMaybe<Scalars['Boolean']>;
  itemType?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<PlacementContentInput>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  text?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type NavigationV2Action = {
  __typename?: 'NavigationV2Action';
  data?: Maybe<Scalars['JSONObject']>;
  typeName?: Maybe<Scalars['String']>;
};

export type NavigationV2ActionInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

export type NavigationV2Item = {
  __typename?: 'NavigationV2Item';
  action?: Maybe<NavigationV2Action>;
  icon?: Maybe<Scalars['String']>;
  icon2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  itemType?: Maybe<Scalars['String']>;
  placement?: Maybe<PlacementContent>;
  placementId?: Maybe<Scalars['BigInt']>;
  position?: Maybe<Scalars['BigInt']>;
  text?: Maybe<Scalars['String']>;
  variant?: Maybe<Scalars['String']>;
};

export type NavigationV2ItemInput = {
  action?: InputMaybe<NavigationV2ActionInput>;
  icon?: InputMaybe<Scalars['String']>;
  icon2?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  itemType?: InputMaybe<Scalars['String']>;
  placement?: InputMaybe<PlacementContentInput>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  position?: InputMaybe<Scalars['BigInt']>;
  text?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<Scalars['String']>;
};

export type NavigationWithContainers = {
  __typename?: 'NavigationWithContainers';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<AllNavigationWithContainersItems>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type NavigationWithContainersInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<AllNavigationWithContainersItemsInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NavigationWithSubNavigation = {
  __typename?: 'NavigationWithSubNavigation';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<SubNavigation>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
};

export type NavigationWithSubNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<SubNavigationInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type NewVerticalUserTargetingInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** The module type */
  moduleType: Scalars['String'];
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of NewVerticalUserTargetingVisibilityConditionCreate */
export type NewVerticalUserTargetingVisibilityConditionCreatePayload = {
  __typename?: 'NewVerticalUserTargetingVisibilityConditionCreatePayload';
  /** The newly created NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityCondition: ContentManagementVisibilityConditionNewVerticalUserTargeting;
};

/** Autogenerated return type of NewVerticalUserTargetingVisibilityConditionUpdate */
export type NewVerticalUserTargetingVisibilityConditionUpdatePayload = {
  __typename?: 'NewVerticalUserTargetingVisibilityConditionUpdatePayload';
  /** The newly updated NewVerticalUserTargeting visibility condition */
  newVerticalUserTargetingVisibilityCondition: ContentManagementVisibilityConditionNewVerticalUserTargeting;
};

export type NonenumeratedManagedAttributes = {
  __typename?: 'NonenumeratedManagedAttributes';
  digitalScaleRequired?: Maybe<Scalars['Boolean']>;
  lookupCodePluOnly?: Maybe<Array<Maybe<Scalars['String']>>>;
  potentialScanCodes?: Maybe<Array<Maybe<PotentialScanCodesByStrategy>>>;
  retailerPreferredLookupCode?: Maybe<Scalars['String']>;
};

/** Autogenerated return type of NormalizedReportsMerge */
export type NormalizedReportsMergePayload = {
  __typename?: 'NormalizedReportsMergePayload';
  /** Merge successful */
  success: Scalars['Boolean'];
};

export type NormalizedReportsNormalizedReport = {
  __typename?: 'NormalizedReportsNormalizedReport';
  /** Name of the bucket where the report comes from */
  bucketName: Scalars['String'];
  /** Date at which the report was created in YYYY-MM-DD format */
  createdAt: Scalars['Time'];
  /** Type of the file */
  fileType: Scalars['String'];
  /** Name of the file */
  name: Scalars['String'];
  /** Type of the report */
  reportType: ReportTypeEnum;
  /** Retailer ID */
  retailerId?: Maybe<Scalars['String']>;
  /** Retailer Location Group ID */
  retailerLocationGroupId?: Maybe<Scalars['String']>;
  /** Name of the retailer location group */
  retailerLocationGroupName?: Maybe<Scalars['String']>;
  /** File path to the object in the bucket */
  s3Key: Scalars['String'];
  /** Size in bytes of the object */
  size: Scalars['Int'];
};

/** The connection type for NormalizedReportsNormalizedReport. */
export type NormalizedReportsNormalizedReportConnection = {
  __typename?: 'NormalizedReportsNormalizedReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NormalizedReportsNormalizedReportEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NormalizedReportsNormalizedReport>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NormalizedReportsNormalizedReportEdge = {
  __typename?: 'NormalizedReportsNormalizedReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NormalizedReportsNormalizedReport>;
};

export type NormalizedReportsNormalizedReportSignedUrl = {
  __typename?: 'NormalizedReportsNormalizedReportSignedUrl';
  /** Signed url for the object */
  signedUrl: Scalars['String'];
};

export type NormalizedReportsReportType = {
  __typename?: 'NormalizedReportsReportType';
  /** Report type label */
  label: Scalars['String'];
  /** The report type value */
  value: ReportTypeEnum;
};

export enum NoticeBannerVariantEnum {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

/** A banner shown on IPP pages whose URL matches path_glob */
export type NoticeBannersTypesBannerType = {
  __typename?: 'NoticeBannersTypesBannerType';
  active: Scalars['Boolean'];
  body: Scalars['String'];
  createdBy: EnterpriseAccount;
  dismissible: Scalars['Boolean'];
  id: Scalars['ID'];
  partnerId?: Maybe<Scalars['ID']>;
  pathGlob: Scalars['String'];
  updatedAt: Scalars['ISO8601DateTime'];
  updatedBy: EnterpriseAccount;
  variant: NoticeBannerVariantEnum;
  warehouseId?: Maybe<Scalars['ID']>;
};

/** The scope for the notification */
export enum NotificationScopeTypeEnum {
  /** Banner scope */
  Banner = 'banner',
  /** Global scope */
  Global = 'global',
  /** Partner scope */
  Partner = 'partner'
}

export enum NotificationSeverityEnum {
  /** Info */
  Info = 'info',
  /** Urgent */
  Urgent = 'urgent'
}

/** Autogenerated return type of NotificationSubscriptionCreate */
export type NotificationSubscriptionCreatePayload = {
  __typename?: 'NotificationSubscriptionCreatePayload';
  /** Subscription successful */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of NotificationSubscriptionDelete */
export type NotificationSubscriptionDeletePayload = {
  __typename?: 'NotificationSubscriptionDeletePayload';
  /** Unsubscribe successful */
  success: Scalars['Boolean'];
};

/** The method of subscription */
export enum NotificationSubscriptionMethodEnum {
  /** Email */
  Email = 'email',
  /** In App */
  InApp = 'in_app'
}

/** Autogenerated return type of NotificationsDelete */
export type NotificationsDeletePayload = {
  __typename?: 'NotificationsDeletePayload';
  /** Notifications deleted successfully */
  success: Scalars['Boolean'];
};

/** Autogenerated return type of NotificationsMarkRead */
export type NotificationsMarkReadPayload = {
  __typename?: 'NotificationsMarkReadPayload';
  /** Notifications marked as read successfully */
  success: Scalars['Boolean'];
};

export type NotificationsNotification = {
  __typename?: 'NotificationsNotification';
  channelId: Scalars['ID'];
  channelName: Scalars['String'];
  channelSlug: Scalars['String'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  scopeId?: Maybe<Scalars['ID']>;
  scopeType: NotificationScopeTypeEnum;
  severity: NotificationSeverityEnum;
  templateName: Scalars['String'];
  templateValues?: Maybe<Scalars['JSON']>;
};

export type NotificationsNotificationChannel = {
  __typename?: 'NotificationsNotificationChannel';
  /** Localized description of notification channel */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** If the user making the request is subscribed to the notification channel via email */
  isEmailSubscribed?: Maybe<Scalars['Boolean']>;
  /** If the user making the request is subscribed to the notification channel via the app */
  isInAppSubscribed?: Maybe<Scalars['Boolean']>;
  /** Localized name of notification channel */
  name: Scalars['String'];
  /** The scope type of the notification channel */
  scopeType: NotificationScopeTypeEnum;
  /** Unique identifier for the notification channel */
  slug: Scalars['String'];
};

/** The connection type for NotificationsNotification. */
export type NotificationsNotificationConnection = {
  __typename?: 'NotificationsNotificationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationsNotificationEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<NotificationsNotification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationsNotificationEdge = {
  __typename?: 'NotificationsNotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<NotificationsNotification>;
};

export type OauthApplication = {
  __typename?: 'OauthApplication';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  environment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  moreTokensExist?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tokenCount?: Maybe<Scalars['BigInt']>;
};

export type ObjectKeyMappingInput = {
  destinationObjectKey?: InputMaybe<Scalars['String']>;
  sourceObjectKey?: InputMaybe<Scalars['String']>;
};

export type OffersSchema = {
  __typename?: 'OffersSchema';
  disableFlierPlacement?: Maybe<Scalars['Boolean']>;
};

export type OnShelfCountEntry = {
  __typename?: 'OnShelfCountEntry';
  count?: Maybe<Scalars['Int']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type OnboardRelayRetailerPr = {
  __typename?: 'OnboardRelayRetailerPr';
  branch?: Maybe<Scalars['String']>;
  prNumber?: Maybe<Scalars['Int']>;
  prUrl?: Maybe<Scalars['String']>;
  repoDir?: Maybe<Scalars['String']>;
};

export type OnboardRelayRetailerRequestInput = {
  banners?: InputMaybe<Array<InputMaybe<RelayBannerInput>>>;
  integrationName?: InputMaybe<Scalars['String']>;
  integrationSlug?: InputMaybe<Scalars['String']>;
  jiraTicket?: InputMaybe<Scalars['String']>;
  modality?: InputMaybe<RelayModality>;
};

export type OnboardRelayRetailerResponse = {
  __typename?: 'OnboardRelayRetailerResponse';
  errorMessage?: Maybe<Scalars['String']>;
  prs?: Maybe<Array<Maybe<OnboardRelayRetailerPr>>>;
  status?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  billingAddress?: Maybe<Address>;
  businessRegistrationDocument?: Maybe<Scalars['String']>;
  contactInfo?: Maybe<Contact>;
  contractRenderData?: Maybe<ContractRenderData>;
  corporationType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  duns?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  exclusivity?: Maybe<Scalars['String']>;
  ironcladData?: Maybe<IroncladData>;
  isaCheckboxTimestamp?: Maybe<Scalars['String']>;
  isaImageSignedUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  isaPdfSignedUrl?: Maybe<Scalars['String']>;
  ndaCheckboxTimestamp?: Maybe<Scalars['String']>;
  ndaImageSignedUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  ndaPdfSignedUrl?: Maybe<Scalars['String']>;
  onboardingType?: Maybe<Scalars['String']>;
  posSystemName?: Maybe<Scalars['String']>;
  priceParity?: Maybe<Scalars['String']>;
  signupPartner?: Maybe<SignupPartner>;
  stateOfIncorporation?: Maybe<Scalars['String']>;
  storeCount?: Maybe<Scalars['String']>;
  storeLocation?: Maybe<Address>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  w9Form?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  workflowState?: Maybe<Scalars['String']>;
};

export type OnboardingAttribute = {
  __typename?: 'OnboardingAttribute';
  allowedValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  attributeDisplayName?: Maybe<Scalars['String']>;
  attributeName?: Maybe<Scalars['String']>;
  attributeQuestion?: Maybe<Scalars['String']>;
  attributeSubgroupName?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['String']>;
  configDetails?: Maybe<OnboardingAttributeConfigDetails>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['BigInt']>;
  dataType?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isFile?: Maybe<Scalars['Boolean']>;
  isSecret?: Maybe<Scalars['Boolean']>;
  maxLength?: Maybe<Scalars['BigInt']>;
  minLength?: Maybe<Scalars['BigInt']>;
  modifiedBy?: Maybe<Scalars['BigInt']>;
  readOnly?: Maybe<Scalars['Boolean']>;
  released?: Maybe<Scalars['Boolean']>;
  required?: Maybe<Scalars['Boolean']>;
  requiredIf?: Maybe<Scalars['String']>;
  retailerAllowedToChange?: Maybe<Scalars['Boolean']>;
  secretConfig?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibilityTiers?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type OnboardingAttributeAutomation = {
  __typename?: 'OnboardingAttributeAutomation';
  propagateToStoreConfiguration?: Maybe<Scalars['Boolean']>;
  storeConfigurationDetails?: Maybe<OnboardingAttributeAutomationStoreConfigurationDetails>;
};

export type OnboardingAttributeAutomationStoreConfigurationDetails = {
  __typename?: 'OnboardingAttributeAutomationStoreConfigurationDetails';
  booleanInverted?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  schemaKey?: Maybe<Scalars['String']>;
};

export type OnboardingAttributeConfigDetails = {
  __typename?: 'OnboardingAttributeConfigDetails';
  automation?: Maybe<OnboardingAttributeAutomation>;
  componentType?: Maybe<Scalars['String']>;
  dimensions?: Maybe<OnboardingAttributeDimensions>;
  formats?: Maybe<Array<Maybe<OnboardingAttributeFormat>>>;
  maxFileSize?: Maybe<Scalars['String']>;
  messages?: Maybe<OnboardingAttributeMessages>;
  multiselectOptions?: Maybe<Array<Maybe<OnboardingAttributeMultiselectOptions>>>;
  options?: Maybe<OnboardingAttributeOptions>;
  pattern?: Maybe<OnboardingAttributePattern>;
  radioOptions?: Maybe<Array<Maybe<OnboardingAttributeRadioOptions>>>;
  visibleIf?: Maybe<Scalars['String']>;
};

export type OnboardingAttributeDimensions = {
  __typename?: 'OnboardingAttributeDimensions';
  height?: Maybe<Scalars['BigInt']>;
  width?: Maybe<Scalars['BigInt']>;
};

export type OnboardingAttributeFormat = {
  __typename?: 'OnboardingAttributeFormat';
  extension?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OnboardingAttributeMessages = {
  __typename?: 'OnboardingAttributeMessages';
  description?: Maybe<Scalars['String']>;
  dropFile?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
};

export type OnboardingAttributeMultiselectOptions = {
  __typename?: 'OnboardingAttributeMultiselectOptions';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OnboardingAttributeOptions = {
  __typename?: 'OnboardingAttributeOptions';
  falseValue?: Maybe<Scalars['String']>;
  trueValue?: Maybe<Scalars['String']>;
};

export type OnboardingAttributePattern = {
  __typename?: 'OnboardingAttributePattern';
  message?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OnboardingAttributeRadioOptions = {
  __typename?: 'OnboardingAttributeRadioOptions';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum OnboardingAttributeStatus {
  OnboardingAttributeStatusArchived = 'ONBOARDING_ATTRIBUTE_STATUS_ARCHIVED',
  OnboardingAttributeStatusDraft = 'ONBOARDING_ATTRIBUTE_STATUS_DRAFT',
  OnboardingAttributeStatusPreReleased = 'ONBOARDING_ATTRIBUTE_STATUS_PRE_RELEASED',
  OnboardingAttributeStatusReleased = 'ONBOARDING_ATTRIBUTE_STATUS_RELEASED',
  OnboardingAttributeStatusUnknown = 'ONBOARDING_ATTRIBUTE_STATUS_UNKNOWN'
}

export type OnboardingFeatureTypesMobileAppConfig = {
  __typename?: 'OnboardingFeatureTypesMobileAppConfig';
  /** The asset information for uploaded items */
  assets: Array<MutableS3Asset>;
  /** The properties for the app */
  properties: Array<OnboardingFeatureTypesProperty>;
};

export type OnboardingFeatureTypesProperty = {
  __typename?: 'OnboardingFeatureTypesProperty';
  /** The property name */
  name: Scalars['String'];
  /** The property value */
  value?: Maybe<Scalars['JSON']>;
};

export type OnboardingFeatureTypesWorkflow = {
  __typename?: 'OnboardingFeatureTypesWorkflow';
  /** The time the workflow was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The workflow id */
  id: Scalars['Int'];
  /** The workflow being run */
  name: Scalars['String'];
  /** The status of the workflow */
  status: Scalars['String'];
  /** The time the status was last updated */
  statusUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The url to the workflow */
  url?: Maybe<Scalars['String']>;
};

export enum OnboardingWorkflowStateAction {
  OnboardingWorkflowStateActionComplete = 'ONBOARDING_WORKFLOW_STATE_ACTION_COMPLETE',
  OnboardingWorkflowStateActionProvideBillingAddress = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_BILLING_ADDRESS',
  OnboardingWorkflowStateActionProvideOnboardingInfo = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_ONBOARDING_INFO',
  OnboardingWorkflowStateActionProvideStoreLocations = 'ONBOARDING_WORKFLOW_STATE_ACTION_PROVIDE_STORE_LOCATIONS',
  OnboardingWorkflowStateActionSignIsa = 'ONBOARDING_WORKFLOW_STATE_ACTION_SIGN_ISA',
  OnboardingWorkflowStateActionSignNda = 'ONBOARDING_WORKFLOW_STATE_ACTION_SIGN_NDA',
  OnboardingWorkflowStateActionStart = 'ONBOARDING_WORKFLOW_STATE_ACTION_START',
  OnboardingWorkflowStateActionUnknown = 'ONBOARDING_WORKFLOW_STATE_ACTION_UNKNOWN',
  OnboardingWorkflowStateActionViewIsa = 'ONBOARDING_WORKFLOW_STATE_ACTION_VIEW_ISA',
  OnboardingWorkflowStateActionViewNda = 'ONBOARDING_WORKFLOW_STATE_ACTION_VIEW_NDA'
}

export type OpenExpressPaidModal = {
  __typename?: 'OpenExpressPaidModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type OpenExpressPaidModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type OpenExpressTrialModal = {
  __typename?: 'OpenExpressTrialModal';
  id?: Maybe<Scalars['BigInt']>;
};

export type OpenExpressTrialModalInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type OperationalHours = {
  __typename?: 'OperationalHours';
  displayableTimePeriods?: Maybe<Array<Maybe<TimePeriod>>>;
  isCrossDay?: Maybe<Scalars['Boolean']>;
  isOpenAllDay?: Maybe<Scalars['Boolean']>;
  timePeriods?: Maybe<Array<Maybe<TimePeriod>>>;
};

export type OptInUser = {
  __typename?: 'OptInUser';
  id?: Maybe<Scalars['BigInt']>;
  optOut?: Maybe<Scalars['Boolean']>;
};

export type OptInUserInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  optOut?: InputMaybe<Scalars['Boolean']>;
};

export type OrderByComponentInput = {
  asc?: InputMaybe<Scalars['Boolean']>;
  component?: InputMaybe<Scalars['String']>;
};

export type OrderByInput = {
  asc?: InputMaybe<Scalars['Boolean']>;
  attribute?: InputMaybe<Scalars['String']>;
};

export type OrderInput = {
  checkoutRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  shoppedRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type OrderSources = {
  __typename?: 'OrderSources';
  /** Order Sources */
  orderSources?: Maybe<Array<Scalars['String']>>;
};

export type OrdersSchema = {
  __typename?: 'OrdersSchema';
  disablePostCheckoutDeliveryFallbackImage?: Maybe<Scalars['Boolean']>;
  disableSpecialRequests?: Maybe<Scalars['Boolean']>;
  liveActivitiesOptIn?: Maybe<Scalars['Boolean']>;
  tlogIngestionEnabled?: Maybe<Scalars['Boolean']>;
};

export enum Os {
  /** Android app */
  Android = 'android',
  /** iOS app */
  IOs = 'iOS'
}

export type OutsourceDataEntryItem = {
  __typename?: 'OutsourceDataEntryItem';
  outsourceItemId?: Maybe<Scalars['String']>;
};

export type OverfacingContext = {
  __typename?: 'OverfacingContext';
  categoryMedianSalesPerFacing?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  salesPerFacing?: Maybe<Scalars['Float']>;
  totalSales?: Maybe<Scalars['Float']>;
};

export type OverfacingRow = {
  __typename?: 'OverfacingRow';
  category?: Maybe<Scalars['String']>;
  categoryAvgSalesPerFacing?: Maybe<Scalars['Float']>;
  categoryId?: Maybe<Scalars['BigInt']>;
  categoryMedianSalesPerFacing?: Maybe<Scalars['Float']>;
  currentFacings?: Maybe<Scalars['Int']>;
  delta?: Maybe<Scalars['Float']>;
  department?: Maybe<Scalars['String']>;
  departmentId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  salesPerFacing?: Maybe<Scalars['Float']>;
  shelfImageUrl?: Maybe<Scalars['String']>;
  totalSales?: Maybe<Scalars['Float']>;
  upc?: Maybe<Scalars['String']>;
};

export enum OverfacingSortBy {
  OverfacingSortByCategoryAvgSalesPerFacing = 'OVERFACING_SORT_BY_CATEGORY_AVG_SALES_PER_FACING',
  OverfacingSortByCategoryMedianSalesPerFacing = 'OVERFACING_SORT_BY_CATEGORY_MEDIAN_SALES_PER_FACING',
  OverfacingSortByCurrentFacings = 'OVERFACING_SORT_BY_CURRENT_FACINGS',
  OverfacingSortByDelta = 'OVERFACING_SORT_BY_DELTA',
  OverfacingSortBySalesPerFacing = 'OVERFACING_SORT_BY_SALES_PER_FACING',
  OverfacingSortByUnknown = 'OVERFACING_SORT_BY_UNKNOWN'
}

export type OverorderingContext = {
  __typename?: 'OverorderingContext';
  backstockUnitsDerived?: Maybe<Scalars['Int']>;
  estimatedBackstockWeeks?: Maybe<Scalars['Float']>;
  orderToSalesRatio?: Maybe<Scalars['Float']>;
  runwayDays?: Maybe<Scalars['Int']>;
  unitsReceived?: Maybe<Scalars['Int']>;
  unitsSold?: Maybe<Scalars['Int']>;
};

export type OverrideHours = {
  __typename?: 'OverrideHours';
  date?: Maybe<GoogleTypeDate>;
  description?: Maybe<Scalars['String']>;
  endTime?: Maybe<GoogleTypeTimeOfDay>;
  serviceType?: Maybe<RetailerServiceType>;
  startTime?: Maybe<GoogleTypeTimeOfDay>;
};

export type OverrideHoursInput = {
  date?: InputMaybe<GoogleTypeDateInput>;
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
  serviceType?: InputMaybe<RetailerServiceType>;
  startTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

export enum OverrideType {
  OverrideTypeExclude = 'OVERRIDE_TYPE_EXCLUDE',
  OverrideTypeReplace = 'OVERRIDE_TYPE_REPLACE',
  OverrideTypeUnknown = 'OVERRIDE_TYPE_UNKNOWN'
}

export type PageAnchor = {
  __typename?: 'PageAnchor';
  anchorId?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  placementTitle?: Maybe<Scalars['String']>;
  placementType?: Maybe<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Offset-based pagination input for bulk operation listings. */
export type PageInput = {
  /** Page size. Capped server-side. */
  limit?: InputMaybe<Scalars['Int']>;
  /** Number of rows to skip. */
  offset?: InputMaybe<Scalars['Int']>;
};

export type PageStyle = {
  __typename?: 'PageStyle';
  background?: Maybe<Background>;
};

export type PageStyleInput = {
  background?: InputMaybe<BackgroundInput>;
};

export type Pagination = {
  __typename?: 'Pagination';
  limit?: Maybe<Scalars['BigInt']>;
  offset?: Maybe<Scalars['BigInt']>;
};

export type PaginationDetails = {
  __typename?: 'PaginationDetails';
  page?: Maybe<Scalars['BigInt']>;
  perPage?: Maybe<Scalars['BigInt']>;
  totalCount?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['BigInt']>;
};

export type PaginationDetailsInput = {
  page?: InputMaybe<Scalars['BigInt']>;
  perPage?: InputMaybe<Scalars['BigInt']>;
  totalCount?: InputMaybe<Scalars['BigInt']>;
  totalPages?: InputMaybe<Scalars['BigInt']>;
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Partner = {
  __typename?: 'Partner';
  /** The feature toggles associated with the partner */
  featureToggles: Array<FeatureToggle>;
  /** The feature toggles associated with the partner broken down by retailer */
  featureTogglesByRetailer: Array<FeatureToggleByRetailerId>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  /** Feature toggles evaluated with partner_id as the Roulette input. Distinct from `featureToggles`, which is the union of every IPP-visible retailer's roulettes under the partner (evaluated with retailer_id). */
  partnerFeatureToggles: Array<FeatureToggle>;
  /** A unique identifier for the partner */
  partnerId?: Maybe<Scalars['ID']>;
  /** The type of partner */
  partnerType?: Maybe<Scalars['String']>;
  /** List of retailer IDs for this partner */
  retailerIds: Array<Scalars['ID']>;
  /** The retailers belonging to this partner */
  retailers: Array<Retailer>;
};


export type PartnerRetailersArgs = {
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type PartnerAccessModificationRulesSchema = {
  __typename?: 'PartnerAccessModificationRulesSchema';
  allowlistPartnerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  allowlistRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type PartnerAccessModificationRulesSchemaInput = {
  allowlistPartnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  allowlistRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type PartnerAccessOptionsSchema = {
  __typename?: 'PartnerAccessOptionsSchema';
  modificationRules?: Maybe<PartnerAccessModificationRulesSchema>;
  visibleToPartnersOnIpp?: Maybe<Scalars['Boolean']>;
};

export type PartnerAccessOptionsSchemaInput = {
  modificationRules?: InputMaybe<PartnerAccessModificationRulesSchemaInput>;
  visibleToPartnersOnIpp?: InputMaybe<Scalars['Boolean']>;
};

/** The connection type for Partner. */
export type PartnerConnection = {
  __typename?: 'PartnerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PartnerEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Partner>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PartnerEdge = {
  __typename?: 'PartnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Partner>;
};

export type PartnerPickCapacityGetCapacityRecommendationsResponse = {
  __typename?: 'PartnerPickCapacityGetCapacityRecommendationsResponse';
  allowedRecommendationTypes: Array<RecommendationTypeEnum>;
  recommendations: Array<PartnerPickCapacityRecommendation>;
};

export type PartnerPickCapacityRecommendation = {
  __typename?: 'PartnerPickCapacityRecommendation';
  date: Scalars['ISO8601Date'];
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  recommendationType: RecommendationTypeEnum;
  retailerLocationId: Scalars['ID'];
  shiftType: ShiftTypeEnum;
  startsAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated return type of PartnerPickDeviceCreate */
export type PartnerPickDeviceCreatePayload = {
  __typename?: 'PartnerPickDeviceCreatePayload';
  /** The newly created device */
  partnerPickDevice: PartnerPickDevicesDevice;
};

/** Autogenerated return type of PartnerPickDeviceSetStatus */
export type PartnerPickDeviceSetStatusPayload = {
  __typename?: 'PartnerPickDeviceSetStatusPayload';
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice;
};

/** Autogenerated return type of PartnerPickDeviceUpdate */
export type PartnerPickDeviceUpdatePayload = {
  __typename?: 'PartnerPickDeviceUpdatePayload';
  /** The updated device */
  partnerPickDevice: PartnerPickDevicesDevice;
};

export type PartnerPickDevicesDevice = {
  __typename?: 'PartnerPickDevicesDevice';
  /** Status for the device */
  active: Scalars['Boolean'];
  /** Type of device */
  deviceType: DeviceTypeEnum;
  /** Email address for the device */
  email: Scalars['String'];
  /** First name for the device */
  firstName: Scalars['String'];
  /** A unique identifier for the device */
  id: Scalars['ID'];
  /** Whether the device belongs to a store manager */
  isPartnerPickStoreManager: Scalars['Boolean'];
  /** Last name for the device */
  lastName: Scalars['String'];
  /** marqeta cards metatdata for the device */
  marqetaCardsMetadata?: Maybe<PartnerPickDevicesMarqetaCardsMetadata>;
  /** Phone number for the device */
  phone: Scalars['String'];
};

export type PartnerPickDevicesDeviceSearch = {
  __typename?: 'PartnerPickDevicesDeviceSearch';
  devices: Array<PartnerPickDevicesDevice>;
  meta: HubPaginationMeta;
};

export type PartnerPickDevicesMarqetaCardsMetadata = {
  __typename?: 'PartnerPickDevicesMarqetaCardsMetadata';
  digital?: Maybe<Scalars['Int']>;
  inactive?: Maybe<Scalars['Int']>;
  physical?: Maybe<Scalars['Int']>;
  suspended?: Maybe<Scalars['Int']>;
  terminated?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of PartnerPickRecurringShiftCreate */
export type PartnerPickRecurringShiftCreatePayload = {
  __typename?: 'PartnerPickRecurringShiftCreatePayload';
  /** The newly created recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift;
};

/** Autogenerated return type of PartnerPickRecurringShiftDelete */
export type PartnerPickRecurringShiftDeletePayload = {
  __typename?: 'PartnerPickRecurringShiftDeletePayload';
  errorMessage?: Maybe<Scalars['String']>;
  /** Whether the deletion succeeded or not */
  success: Scalars['True'];
};

/** Autogenerated return type of PartnerPickRecurringShiftUpdate */
export type PartnerPickRecurringShiftUpdatePayload = {
  __typename?: 'PartnerPickRecurringShiftUpdatePayload';
  /** The updated recurring shift */
  partnerPickRecurringShift: PartnerPickRecurringShiftsRecurringShift;
};

export type PartnerPickRecurringShiftsConflict = {
  __typename?: 'PartnerPickRecurringShiftsConflict';
  recurringShiftConflicts: Array<PartnerPickRecurringShiftsRecurringShiftConflict>;
  singleShiftConflicts: Array<PartnerPickRecurringShiftsSingleShiftConflict>;
};

export type PartnerPickRecurringShiftsRecurringShift = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShift';
  /** an array of Ruby Date wday that a shift recurs on (0-6, Sunday is zero) */
  daysOfWeek: Array<Scalars['Int']>;
  driverId: Scalars['ID'];
  driverShiftId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  onCall?: Maybe<Scalars['Boolean']>;
  recurEndDate?: Maybe<Scalars['ISO8601Date']>;
  recurStartDate?: Maybe<Scalars['ISO8601Date']>;
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  shiftType: ShiftTypeEnum;
};

export type PartnerPickRecurringShiftsRecurringShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsRecurringShiftConflict';
  /** Days of the week when a shift occurs, represented as an Int (0-6). Sunday is 0 */
  daysOfWeek: Array<Scalars['Int']>;
  id: Scalars['ID'];
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  shiftType: ShiftTypeEnum;
};

export type PartnerPickRecurringShiftsSingleShiftConflict = {
  __typename?: 'PartnerPickRecurringShiftsSingleShiftConflict';
  date: Scalars['ISO8601Date'];
  endsAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  shiftType: ShiftTypeEnum;
  startsAt: Scalars['ISO8601DateTime'];
};

export enum PatchStatus {
  PatchStatusApplyingOverrides = 'PATCH_STATUS_APPLYING_OVERRIDES',
  PatchStatusApproved = 'PATCH_STATUS_APPROVED',
  PatchStatusDeleted = 'PATCH_STATUS_DELETED',
  PatchStatusFailed = 'PATCH_STATUS_FAILED',
  PatchStatusPatchCreationInProgress = 'PATCH_STATUS_PATCH_CREATION_IN_PROGRESS',
  PatchStatusPendingApproval = 'PATCH_STATUS_PENDING_APPROVAL',
  PatchStatusRejected = 'PATCH_STATUS_REJECTED',
  PatchStatusSuccessful = 'PATCH_STATUS_SUCCESSFUL',
  PatchStatusUnspecified = 'PATCH_STATUS_UNSPECIFIED'
}

export type PaymentsSchema = {
  __typename?: 'PaymentsSchema';
  useSiteNameForIcWalletBranding?: Maybe<Scalars['Boolean']>;
};

export type PbiStoreConfiguration = {
  __typename?: 'PbiStoreConfiguration';
  id?: Maybe<Scalars['BigInt']>;
  label?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Permission = {
  __typename?: 'Permission';
  /** Indicates if the permission can be used for Retailer custom roles */
  isRetailerRoleAssignable: Scalars['Boolean'];
  /** A unique identifier for the permission */
  slug: Scalars['ID'];
};

export type PermissionInput = {
  /** A unique identifier for the permission */
  slug: Scalars['ID'];
};

export enum PickingModelEnum {
  /** Carrotwork */
  Carrotwork = 'CARROTWORK',
  /** Full service shoppers */
  FullService = 'FULL_SERVICE',
  /** In store shoppers */
  Iss = 'ISS',
  /** Partner managed */
  Retailer = 'RETAILER'
}

export enum PickupType {
  PickupTypeCurbside = 'PICKUP_TYPE_CURBSIDE',
  PickupTypeInStore = 'PICKUP_TYPE_IN_STORE',
  PickupTypeUnknown = 'PICKUP_TYPE_UNKNOWN'
}

export type PiiRequest = {
  __typename?: 'PiiRequest';
  createdAt?: Maybe<Scalars['DateTime']>;
  downloadLink?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['BigInt']>;
  requestType?: Maybe<RequestType>;
  retailerNotes?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userEmail?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
  workflowStatus?: Maybe<WorkflowStatus>;
};

export enum PiiRequestCreationStatus {
  PiiRequestCreationStatusDuplicateError = 'PII_REQUEST_CREATION_STATUS_DUPLICATE_ERROR',
  PiiRequestCreationStatusInternalError = 'PII_REQUEST_CREATION_STATUS_INTERNAL_ERROR',
  PiiRequestCreationStatusNotFound = 'PII_REQUEST_CREATION_STATUS_NOT_FOUND',
  PiiRequestCreationStatusSuccess = 'PII_REQUEST_CREATION_STATUS_SUCCESS',
  PiiRequestCreationStatusUnspecified = 'PII_REQUEST_CREATION_STATUS_UNSPECIFIED',
  PiiRequestCreationStatusUserNotFound = 'PII_REQUEST_CREATION_STATUS_USER_NOT_FOUND',
  PiiRequestCreationStatusUserStoreConfigurationNotFound = 'PII_REQUEST_CREATION_STATUS_USER_STORE_CONFIGURATION_NOT_FOUND'
}

export type Placement = {
  __typename?: 'Placement';
  banner?: Maybe<BannerType>;
  banners?: Maybe<Array<Maybe<BannerType>>>;
  cardList?: Maybe<CardList>;
  contentPageVersionId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creativeRank?: Maybe<Scalars['BigInt']>;
  enabled?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  experimentMethod?: Maybe<ExperimentMethod>;
  experimentName?: Maybe<Scalars['String']>;
  experimentVariant?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  includedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  includedStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  internalName?: Maybe<Scalars['String']>;
  itemList?: Maybe<ItemList>;
  layout?: Maybe<Layout>;
  layoutVariantId?: Maybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior?: Maybe<Scalars['Boolean']>;
  matchedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  placementContext?: Maybe<PlacementContext>;
  platform?: Maybe<Array<Maybe<PlatformType>>>;
  rank?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Status>;
  stringLayout?: Maybe<Scalars['String']>;
  teamOwner?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userOwner?: Maybe<Scalars['BigInt']>;
  widget?: Maybe<Widget>;
};

export enum PlacementAdminContextAudience {
  AdminContextAudienceUnspecified = 'ADMIN_CONTEXT_AUDIENCE_UNSPECIFIED',
  InstacartAdmins = 'INSTACART_ADMINS',
  ThirdPartyAdmins = 'THIRD_PARTY_ADMINS'
}

export type PlacementAdminContextInput = {
  audience?: InputMaybe<PlacementAdminContextAudience>;
};

export type PlacementContent = {
  __typename?: 'PlacementContent';
  anchorId?: Maybe<Scalars['String']>;
  contentPageVersionId?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByCanonicalId?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedRetailerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  excludedStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  experimentMethod?: Maybe<Scalars['String']>;
  experimentName?: Maybe<Scalars['String']>;
  experimentVariant?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  includedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  includedRetailerLocationGroupIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  includedRetailerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  includedStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  internalName?: Maybe<Scalars['String']>;
  layout?: Maybe<Scalars['String']>;
  layoutVariantId?: Maybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior?: Maybe<Scalars['Boolean']>;
  parentPlacementId?: Maybe<Scalars['BigInt']>;
  placementBucketId?: Maybe<Scalars['BigInt']>;
  placementStyle?: Maybe<PlacementStyle>;
  placementType?: Maybe<Scalars['String']>;
  placementTypeData?: Maybe<Array<Maybe<PlacementContentDataStruct>>>;
  platform?: Maybe<Array<Maybe<Scalars['String']>>>;
  rank?: Maybe<Scalars['BigInt']>;
  slotAreaId?: Maybe<Scalars['BigInt']>;
  slotCreatives?: Maybe<Array<Maybe<SlotCreative>>>;
  slots?: Maybe<Array<Maybe<Slot>>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  teamOwner?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByCanonicalId?: Maybe<Scalars['String']>;
  userOwner?: Maybe<Scalars['String']>;
  visibilityConditions?: Maybe<Array<Maybe<VisibilityConditionStruct>>>;
};

export type PlacementContentDataStruct = {
  __typename?: 'PlacementContentDataStruct';
  contentData?: Maybe<Scalars['JSONObject']>;
  contentDataId?: Maybe<Scalars['BigInt']>;
  contentType?: Maybe<Scalars['String']>;
  contentVariant?: Maybe<Scalars['String']>;
};

export type PlacementContentDataStructInput = {
  contentData?: InputMaybe<Scalars['JSONObject']>;
  contentDataId?: InputMaybe<Scalars['BigInt']>;
  contentType?: InputMaybe<Scalars['String']>;
  contentVariant?: InputMaybe<Scalars['String']>;
};

export type PlacementContentInput = {
  anchorId?: InputMaybe<Scalars['String']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdByCanonicalId?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  experimentMethod?: InputMaybe<Scalars['String']>;
  experimentName?: InputMaybe<Scalars['String']>;
  experimentVariant?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedRetailerLocationGroupIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  internalName?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['String']>;
  layoutVariantId?: InputMaybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior?: InputMaybe<Scalars['Boolean']>;
  parentPlacementId?: InputMaybe<Scalars['BigInt']>;
  placementBucketId?: InputMaybe<Scalars['BigInt']>;
  placementStyle?: InputMaybe<PlacementStyleInput>;
  placementType?: InputMaybe<Scalars['String']>;
  placementTypeData?: InputMaybe<Array<InputMaybe<PlacementContentDataStructInput>>>;
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  rank?: InputMaybe<Scalars['BigInt']>;
  slotAreaId?: InputMaybe<Scalars['BigInt']>;
  slotCreatives?: InputMaybe<Array<InputMaybe<SlotCreativeInput>>>;
  slots?: InputMaybe<Array<InputMaybe<SlotInput>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  teamOwner?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedByCanonicalId?: InputMaybe<Scalars['String']>;
  userOwner?: InputMaybe<Scalars['String']>;
  visibilityConditions?: InputMaybe<Array<InputMaybe<VisibilityConditionStructInput>>>;
};

export type PlacementContentRequestPagination = {
  __typename?: 'PlacementContentRequestPagination';
  orderBy?: Maybe<Array<Maybe<PlacementContentRequestPaginationOrder>>>;
  pageNumber?: Maybe<Scalars['BigInt']>;
  pageSize?: Maybe<Scalars['BigInt']>;
};

export type PlacementContentRequestPaginationInput = {
  orderBy?: InputMaybe<Array<InputMaybe<PlacementContentRequestPaginationOrderInput>>>;
  pageNumber?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
};

export type PlacementContentRequestPaginationOrder = {
  __typename?: 'PlacementContentRequestPaginationOrder';
  descending?: Maybe<Scalars['Boolean']>;
  placementId?: Maybe<Scalars['BigInt']>;
  placementRank?: Maybe<Scalars['BigInt']>;
};

export type PlacementContentRequestPaginationOrderInput = {
  descending?: InputMaybe<Scalars['Boolean']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  placementRank?: InputMaybe<Scalars['BigInt']>;
};

export type PlacementContentResponsePagination = {
  __typename?: 'PlacementContentResponsePagination';
  hasNextPage?: Maybe<Scalars['Boolean']>;
  requestPagination?: Maybe<PlacementContentRequestPagination>;
};

export type PlacementContentSurfaceInput = {
  surfaceIdentifier?: InputMaybe<Scalars['String']>;
  surfaceType?: InputMaybe<Scalars['String']>;
};

export type PlacementContext = {
  __typename?: 'PlacementContext';
  searchMetadata?: Maybe<SearchPlacementMetadata>;
};

export type PlacementContextInput = {
  searchMetadata?: InputMaybe<SearchPlacementMetadataInput>;
};

export type PlacementDestinationInput = {
  /** The target destination of interacting with the placement. Can be an ID of a product/collection/department, or a URL */
  target: Scalars['String'];
  /** What the corresponding target refers to */
  type: PlacementDestinationTypeEnum;
};

export enum PlacementDestinationTypeEnum {
  /** The placement links to a collection */
  Collection = 'COLLECTION',
  /** The placement links to a collection hub */
  CollectionHub = 'COLLECTION_HUB',
  /** The placement links to containers via a store selector */
  ContainerPathViaStoreSelector = 'CONTAINER_PATH_VIA_STORE_SELECTOR',
  /** The placement links to a department */
  Department = 'DEPARTMENT',
  /** The placement does not have an action */
  DoNotNavigate = 'DO_NOT_NAVIGATE',
  /** The placement links to an external url */
  External = 'EXTERNAL',
  /** The placement navigates to order ahead */
  OrderAhead = 'ORDER_AHEAD',
  /** The placement links to the pickup store selector */
  PickupStoreselector = 'PICKUP_STORESELECTOR',
  /** The placement links to a product */
  Product = 'PRODUCT',
  /** The placement links to the SSA store selector */
  SsaStoreselector = 'SSA_STORESELECTOR',
  /** The placement links to a storefront */
  Storefront = 'STOREFRONT',
  /** The placement links to a store selector */
  StoreSelector = 'STORE_SELECTOR',
  /** Unfamiliar Banner Action */
  Unknown = 'UNKNOWN'
}

export type PlacementExperimentInput = {
  /** Experiment Assignment or Lookup */
  accessMethod?: InputMaybe<PlacementExperimentMethodEnum>;
  /** Name of the Experiment */
  name: Scalars['String'];
  /** Variant of the Experiment for which placement should be visible */
  variant: Scalars['String'];
};

export enum PlacementExperimentMethodEnum {
  /** Whether variant assignment should happen */
  Assign = 'ASSIGN',
  /** Not specified */
  ExperimentMethodUnspecified = 'EXPERIMENT_METHOD_UNSPECIFIED',
  /** Whether a variant lookup should occur */
  Lookup = 'LOOKUP',
  /** Whether a variant preview should occur */
  Preview = 'PREVIEW'
}

export type PlacementFilterInput = {
  /** The locale of the placement (Eg. en_US) */
  locale?: InputMaybe<Scalars['String']>;
  /** The platform(s) the placement is configured for (Eg. [MOBILE, WEB]) */
  platform?: InputMaybe<Array<PlacementPlatformEnum>>;
  /** A term to use to search for a placement */
  searchTerm?: InputMaybe<Scalars['String']>;
  /** The current status of the placement (Eg. ACTIVE) */
  status?: InputMaybe<PlacementStatusEnum>;
  /** The type of the placement (Eg. TEXT) */
  type?: InputMaybe<PlacementTypeEnum>;
};

export type PlacementImagesInput = {
  /** The image url of the placement to display for large viewports */
  large: Scalars['Url'];
  /** The image url of the placement to display for small viewports */
  small: Scalars['Url'];
};

export type PlacementInput = {
  banner?: InputMaybe<BannerTypeInput>;
  banners?: InputMaybe<Array<InputMaybe<BannerTypeInput>>>;
  cardList?: InputMaybe<CardListInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  experimentMethod?: InputMaybe<ExperimentMethod>;
  experimentName?: InputMaybe<Scalars['String']>;
  experimentVariant?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  includedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  internalName?: InputMaybe<Scalars['String']>;
  itemList?: InputMaybe<ItemListInput>;
  layout?: InputMaybe<Layout>;
  layoutVariantId?: InputMaybe<Scalars['BigInt']>;
  marketplaceDefaultBehavior?: InputMaybe<Scalars['Boolean']>;
  matchedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  placementContext?: InputMaybe<PlacementContextInput>;
  platform?: InputMaybe<Array<InputMaybe<PlatformType>>>;
  rank?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Status>;
  stringLayout?: InputMaybe<Scalars['String']>;
  teamOwner?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userOwner?: InputMaybe<Scalars['BigInt']>;
  widget?: InputMaybe<WidgetInput>;
};

export enum PlacementPlatformEnum {
  /** This placement should display on android */
  Android = 'ANDROID',
  /** This placement should display on ios */
  Ios = 'IOS',
  /** This placement should display on mobile */
  Mobile = 'MOBILE',
  /** This placement should display on web */
  Web = 'WEB'
}

export type PlacementScheduleInput = {
  /** When the placement should stop being active */
  endDate?: InputMaybe<Scalars['Time']>;
  /** When the placement should become active */
  startDate: Scalars['Time'];
  /** The timezone in which the banner will stop being active at midnight */
  timezone: Scalars['String'];
};

export type PlacementSortInput = {
  /** The direction to sort */
  direction?: InputMaybe<PlacementSortInputDirectionEnum>;
  /** The field to sort on */
  field: PlacementSortInputFieldEnum;
};

export enum PlacementSortInputDirectionEnum {
  /** Sort the results in ascending order */
  Asc = 'ASC',
  /** Sort the results in descending order */
  Desc = 'DESC'
}

export enum PlacementSortInputFieldEnum {
  /** Sort the results based on the status of the placement */
  CreatedAt = 'CREATED_AT',
  /** Sort the results based on the status of the placement */
  Status = 'STATUS'
}

export enum PlacementStatusEnum {
  /** The placement is currently active */
  Active = 'ACTIVE',
  /** The placement is not currently active */
  Inactive = 'INACTIVE',
  /** The placement is currently the live banner */
  Live = 'LIVE'
}

export type PlacementStyle = {
  __typename?: 'PlacementStyle';
  base?: Maybe<StyleFields>;
  viewportOverrides?: Maybe<Array<Maybe<ViewportOverride>>>;
};

export type PlacementStyleInput = {
  base?: InputMaybe<StyleFieldsInput>;
  viewportOverrides?: InputMaybe<Array<InputMaybe<ViewportOverrideInput>>>;
};

export enum PlacementTypeEnum {
  /** This is ASYNC_IMAGE placement */
  AsyncImage = 'ASYNC_IMAGE',
  /** This is ASYNC_MODAL placement */
  AsyncModal = 'ASYNC_MODAL',
  /** This is CAROUSEL_CARD placement */
  CarouselCard = 'CAROUSEL_CARD',
  /** This is CATEGORY_HUB placement */
  CategoryHub = 'CATEGORY_HUB',
  /** This is HEADER placement */
  Header = 'HEADER',
  /** This placement displays a HeroBanner Home Announcement Banner */
  HeroBanner = 'HERO_BANNER',
  /** This placement displays an image */
  Image = 'IMAGE',
  /** This placement displays an ImageForward Home Announcement Banner */
  ImageForward = 'IMAGE_FORWARD',
  /** This placement displays a ImageForwardFlex Home Announcement Banner */
  ImageForwardFlex = 'IMAGE_FORWARD_FLEX',
  /** This is INFORMATION_MODAL placement */
  InformationModal = 'INFORMATION_MODAL',
  /** This is LARGE placement */
  Large = 'LARGE',
  /** This is LOGO_WITH_TEXT placement */
  LogoWithText = 'LOGO_WITH_TEXT',
  /** This is MEGA placement */
  Mega = 'MEGA',
  /** This is OCCASION_HUB placement */
  OccasionHub = 'OCCASION_HUB',
  /** This is RICH_TEXT placement */
  RichText = 'RICH_TEXT',
  /** This placement displays a SecondaryBanner Home Announcement Banner */
  SecondaryBanner = 'SECONDARY_BANNER',
  /** This is flyout placement */
  StandardInformationModal = 'STANDARD_INFORMATION_MODAL',
  /** This is SURVEY placement */
  Survey = 'SURVEY',
  /** This placement displays text */
  Text = 'TEXT',
  /** This is TEXT_SLIM placement */
  TextSlim = 'TEXT_SLIM',
  /** This placement displays a TextWithThumbnail Home Announcement Banner */
  TextWithThumbnail = 'TEXT_WITH_THUMBNAIL',
  /** This placement displays a TextWithThumbnailFlex Home Announcement Banner */
  TextWithThumbnailFlex = 'TEXT_WITH_THUMBNAIL_FLEX',
  /** This is TITLED_MEDIA placement */
  TitledMedia = 'TITLED_MEDIA',
  /** This placement displays an ImageForward Home Announcement Banner */
  Unknown = 'UNKNOWN'
}

export type PlacementsResponse = {
  __typename?: 'PlacementsResponse';
  placements?: Maybe<Array<Maybe<Placement>>>;
};

export enum PlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type PostAuthPaths = {
  __typename?: 'PostAuthPaths';
  loginPath?: Maybe<Scalars['String']>;
  signupPath?: Maybe<Scalars['String']>;
};

export type PostAuthPathsInput = {
  loginPath?: InputMaybe<Scalars['String']>;
  signupPath?: InputMaybe<Scalars['String']>;
};

export type PotentialScanCodesByStrategy = {
  __typename?: 'PotentialScanCodesByStrategy';
  codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  strategy?: Maybe<ScanCodeStrategy>;
  strategyName?: Maybe<Scalars['String']>;
};

export type PrepareToSubmitAuditBatchRequestInput = {
  assignees?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  batchMetadata?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  correctnessThresholdPct?: InputMaybe<Scalars['Float']>;
  dataType?: InputMaybe<Scalars['String']>;
  dataValue?: InputMaybe<Scalars['String']>;
  maxBatchSize?: InputMaybe<Scalars['BigInt']>;
  maxNumOfBatches?: InputMaybe<Scalars['BigInt']>;
  overrideDueDate?: InputMaybe<Scalars['DateTime']>;
  owner?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Int']>;
  reviewers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showPreview?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  taskReviewPct?: InputMaybe<Scalars['Float']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type PrepareToSubmitAuditBatchResponse = {
  __typename?: 'PrepareToSubmitAuditBatchResponse';
  previewTasks?: Maybe<Array<Maybe<AuditTask>>>;
  status?: Maybe<DemeterResponseStatus>;
  submissionUuid?: Maybe<Scalars['String']>;
};

export type PricingSchema = {
  __typename?: 'PricingSchema';
  _?: Maybe<Scalars['Boolean']>;
};

export type ProblemTrackerEntityStatus = {
  __typename?: 'ProblemTrackerEntityStatus';
  calculatedEntityId?: Maybe<EntityId>;
  createdAt?: Maybe<Scalars['DateTime']>;
  explanation?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  providedEntityId?: Maybe<EntityId>;
  providedEntityType?: Maybe<EntityType>;
  status?: Maybe<EntityStatus>;
  ticketId?: Maybe<Scalars['BigInt']>;
};

export type ProblemTrackerTicket = {
  __typename?: 'ProblemTrackerTicket';
  assignee?: Maybe<User>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  entities?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  entityType?: Maybe<EntityType>;
  fixTaskGroupUuid?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  localeCode?: Maybe<Scalars['String']>;
  problemType?: Maybe<ProblemType>;
  reportedOnBehalfOf?: Maybe<User>;
  retailerId?: Maybe<Scalars['BigInt']>;
  severity?: Maybe<Scalars['BigInt']>;
  sourceAppName?: Maybe<Scalars['String']>;
  status?: Maybe<TicketStatus>;
  summaryStatus?: Maybe<Array<Maybe<SummaryStatus>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProblemTrackerTicketComment = {
  __typename?: 'ProblemTrackerTicketComment';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  id?: Maybe<Scalars['BigInt']>;
};

export enum ProblemType {
  ProblemTypeOther = 'PROBLEM_TYPE_OTHER',
  ProblemTypeProductAlcohol = 'PROBLEM_TYPE_PRODUCT_ALCOHOL',
  ProblemTypeProductAvailability = 'PROBLEM_TYPE_PRODUCT_AVAILABILITY',
  ProblemTypeProductBrand = 'PROBLEM_TYPE_PRODUCT_BRAND',
  ProblemTypeProductCharacteristics = 'PROBLEM_TYPE_PRODUCT_CHARACTERISTICS',
  ProblemTypeProductClassification = 'PROBLEM_TYPE_PRODUCT_CLASSIFICATION',
  ProblemTypeProductDetails = 'PROBLEM_TYPE_PRODUCT_DETAILS',
  ProblemTypeProductIdentity = 'PROBLEM_TYPE_PRODUCT_IDENTITY',
  ProblemTypeProductImage = 'PROBLEM_TYPE_PRODUCT_IMAGE',
  ProblemTypeProductSize = 'PROBLEM_TYPE_PRODUCT_SIZE',
  ProblemTypeProductTaxonomy = 'PROBLEM_TYPE_PRODUCT_TAXONOMY',
  ProblemTypeUnknown = 'PROBLEM_TYPE_UNKNOWN'
}

export type Product = {
  __typename?: 'Product';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
};

export type ProductAnalyticSummaryRequestInput = {
  dateRange?: InputMaybe<InstacartAdsSharedV1DateRangeInput>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductAnalyticsSummary = {
  __typename?: 'ProductAnalyticsSummary';
  avgOrdersPerStore?: Maybe<Scalars['Float']>;
  avgSalesPerStoreUsd?: Maybe<Scalars['Float']>;
  avgStoreCount?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['BigInt']>;
  totalOrders?: Maybe<Scalars['BigInt']>;
  totalSalesUsd?: Maybe<Scalars['Float']>;
  totalStores?: Maybe<Scalars['BigInt']>;
};

export type ProductAnalyticsSummaryGrowthMetrics = {
  __typename?: 'ProductAnalyticsSummaryGrowthMetrics';
  avgOrdersPerStoreGrowth?: Maybe<Scalars['Float']>;
  avgSalesPerStoreUsdGrowth?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['BigInt']>;
  totalOrdersGrowth?: Maybe<Scalars['Float']>;
  totalSalesUsdGrowth?: Maybe<Scalars['Float']>;
  totalStoresGrowth?: Maybe<Scalars['Float']>;
};

export type ProductAnalyticsSummaryResponse = {
  __typename?: 'ProductAnalyticsSummaryResponse';
  analyticsSummary?: Maybe<ProductAnalyticsSummary>;
  growthMetrics?: Maybe<ProductAnalyticsSummaryGrowthMetrics>;
  previousPeriodMetrics?: Maybe<ProductAnalyticsSummary>;
};

export type ProductAttributes = {
  __typename?: 'ProductAttributes';
  avgUnitPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  legalFilterType?: Maybe<LegalFilterType>;
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['String']>;
  upc?: Maybe<Scalars['String']>;
};

export type ProductAttributesRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductAttributesResponse = {
  __typename?: 'ProductAttributesResponse';
  productAttributes?: Maybe<ProductAttributes>;
};

export type ProductBrandProfileAttributesRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductBrandProfileAttributesResponse = {
  __typename?: 'ProductBrandProfileAttributesResponse';
  brandProfileAttributes?: Maybe<BrandProfileAttributes>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  l1Category?: Maybe<Scalars['String']>;
  l1CategoryId?: Maybe<Scalars['BigInt']>;
  l2Category?: Maybe<Scalars['String']>;
  l2CategoryId?: Maybe<Scalars['BigInt']>;
  l3Category?: Maybe<Scalars['String']>;
  l3CategoryId?: Maybe<Scalars['BigInt']>;
  l4Category?: Maybe<Scalars['String']>;
  l4CategoryId?: Maybe<Scalars['BigInt']>;
  l5Category?: Maybe<Scalars['String']>;
  l5CategoryId?: Maybe<Scalars['BigInt']>;
  l6Category?: Maybe<Scalars['String']>;
  l6CategoryId?: Maybe<Scalars['BigInt']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryId?: Maybe<Scalars['BigInt']>;
};

export type ProductCategoryTaxonomy = {
  __typename?: 'ProductCategoryTaxonomy';
  l1?: Maybe<Scalars['String']>;
  l2?: Maybe<Scalars['String']>;
  l3?: Maybe<Scalars['String']>;
  l4?: Maybe<Scalars['String']>;
  l5?: Maybe<Scalars['String']>;
  l6?: Maybe<Scalars['String']>;
};

export type ProductCodeValue = {
  __typename?: 'ProductCodeValue';
  code?: Maybe<Scalars['String']>;
  codeType?: Maybe<Scalars['String']>;
};

export type ProductCreationImage = {
  __typename?: 'ProductCreationImage';
  isStorefrontVisible?: Maybe<Scalars['Boolean']>;
  s3Url?: Maybe<Scalars['String']>;
};

export type ProductCreationImageInput = {
  isStorefrontVisible?: InputMaybe<Scalars['Boolean']>;
  s3Url?: InputMaybe<Scalars['String']>;
};

export enum ProductCreationStatus {
  ProductCreationStatusAiComplete = 'PRODUCT_CREATION_STATUS_AI_COMPLETE',
  ProductCreationStatusAiProcessing = 'PRODUCT_CREATION_STATUS_AI_PROCESSING',
  ProductCreationStatusFailed = 'PRODUCT_CREATION_STATUS_FAILED',
  ProductCreationStatusPending = 'PRODUCT_CREATION_STATUS_PENDING',
  ProductCreationStatusProductCreated = 'PRODUCT_CREATION_STATUS_PRODUCT_CREATED',
  ProductCreationStatusSubmissionFailed = 'PRODUCT_CREATION_STATUS_SUBMISSION_FAILED',
  ProductCreationStatusSubmitted = 'PRODUCT_CREATION_STATUS_SUBMITTED',
  ProductCreationStatusSubmitting = 'PRODUCT_CREATION_STATUS_SUBMITTING',
  ProductCreationStatusUnspecified = 'PRODUCT_CREATION_STATUS_UNSPECIFIED'
}

export type ProductData = {
  __typename?: 'ProductData';
  attributeData?: Maybe<Array<Maybe<AttributeData>>>;
  localeId?: Maybe<Scalars['String']>;
};

export type ProductDisplay = {
  __typename?: 'ProductDisplay';
  imageAsset?: Maybe<ImageAsset>;
  productId?: Maybe<Scalars['BigInt']>;
};

export type ProductId = {
  __typename?: 'ProductId';
  locale?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
};

export type ProductIdInput = {
  locale?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductImageValue = {
  __typename?: 'ProductImageValue';
  angle?: Maybe<Scalars['String']>;
  imageProvidedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
};

export type ProductScanImage = {
  __typename?: 'ProductScanImage';
  boundingBoxes?: Maybe<Array<Maybe<BoundingBox>>>;
  capturedAt?: Maybe<Scalars['DateTime']>;
  debugData?: Maybe<ScanImageDebugData>;
  height?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type ProductSellSheetCardsRequestInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type ProductSellSheetCardsResponse = {
  __typename?: 'ProductSellSheetCardsResponse';
  sellSheetCards?: Maybe<Array<Maybe<SellSheetCard>>>;
};

export type ProductSource = {
  __typename?: 'ProductSource';
  defaultPriority?: Maybe<Scalars['BigInt']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sourceLevel?: Maybe<SourceLevel>;
};

export type ProductSummaryMetrics = {
  __typename?: 'ProductSummaryMetrics';
  avgSalesPerStoreUsd?: Maybe<Scalars['Float']>;
  dateRange?: Maybe<InstacartAdsSharedV1DateRange>;
  storeCount?: Maybe<Scalars['BigInt']>;
  totalSalesUsd?: Maybe<Scalars['Float']>;
};

export type ProductSummaryTraits = {
  __typename?: 'ProductSummaryTraits';
  isCarriedByRetailer?: Maybe<Scalars['Boolean']>;
  productAttributes?: Maybe<ProductAttributes>;
  productSummaryMetrics?: Maybe<ProductSummaryMetrics>;
};

export enum ProductType {
  ProductTypeFood = 'PRODUCT_TYPE_FOOD',
  ProductTypeNonFood = 'PRODUCT_TYPE_NON_FOOD',
  ProductTypeUnspecified = 'PRODUCT_TYPE_UNSPECIFIED'
}

export type PropertyInput = {
  /** The property name */
  name: Scalars['String'];
  /** The property value */
  value?: InputMaybe<Scalars['JSON']>;
};

export type ProposedReturnInput = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  returnItems?: InputMaybe<Array<InputMaybe<ReturnItemInput>>>;
  returnStatus?: InputMaybe<ProposedReturnStatus>;
  returnType?: InputMaybe<ProposedReturnType>;
};

export enum ProposedReturnStatus {
  Accepted = 'Accepted',
  Canceled = 'Canceled',
  Expired = 'Expired',
  Pending = 'Pending',
  ProposedReturnStatusUnspecified = 'ProposedReturnStatusUnspecified',
  Refunded = 'Refunded'
}

export enum ProposedReturnType {
  Manual = 'Manual',
  ProposedReturnTypeUnspecified = 'ProposedReturnTypeUnspecified',
  RetailerIntegration = 'RetailerIntegration'
}

/** Input parameters for publishing an approval request */
export type PublishApprovalRequestInput = {
  /** The unique ID of the Approval Request to publish. */
  approvalRequestId: Scalars['ID'];
  /** Flag to indicate if the publish action should proceed despite normal restrictions. */
  isBreakGlass?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of PublishApprovalRequest */
export type PublishApprovalRequestPayload = {
  __typename?: 'PublishApprovalRequestPayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

export type PublishContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
};

export type PublishContentPageVersionResponse = {
  __typename?: 'PublishContentPageVersionResponse';
  contentPage?: Maybe<ContentPageV2>;
  newDraft?: Maybe<ContentPageVersion>;
};

export type PublishFrothTemplateVersionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type PublishFrothTemplateVersionResponse = {
  __typename?: 'PublishFrothTemplateVersionResponse';
  frothTemplateVersion?: Maybe<FrothTemplateVersionInfo>;
};

export type PublishRppConfigurableItemsRequestInput = {
  configurableProducts?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type PublishRppConfigurableItemsResponse = {
  __typename?: 'PublishRppConfigurableItemsResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type PublishStoreConfigurationDraftRequestInput = {
  draftId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type PublishStoreConfigurationDraftResponse = {
  __typename?: 'PublishStoreConfigurationDraftResponse';
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type PublishedFrothTemplate = {
  __typename?: 'PublishedFrothTemplate';
  metadata?: Maybe<FrothTemplate>;
  publishedVersionBody?: Maybe<FrothTemplateVersionBody>;
  publishedVersionInfo?: Maybe<FrothTemplateVersionInfo>;
};

export type QasTaskItem = {
  __typename?: 'QasTaskItem';
  itemType?: Maybe<Scalars['String']>;
  itemValue?: Maybe<Scalars['String']>;
};

/** Aggregated quality scorecard metrics per tool */
export type QualityScorecardsAggScorecard = {
  __typename?: 'QualityScorecardsAggScorecard';
  /** Average user rating score for the tool */
  averageRatingScore?: Maybe<Scalars['Float']>;
  /** Human-readable IPP Tool name */
  ippToolName?: Maybe<Scalars['String']>;
  /** IPP Totem Entity identifier */
  ippTotemEntity?: Maybe<Scalars['String']>;
  /** Total number of views in the period */
  monthlyViews?: Maybe<Scalars['Int']>;
  /** P90 page loading time in seconds */
  p90LoadingTime?: Maybe<Scalars['Float']>;
  /** Team responsible for the tool */
  team?: Maybe<Scalars['String']>;
  /** Percentage of views that had errors */
  viewsWithErrorsPercentage?: Maybe<Scalars['Float']>;
};

/** Response containing aggregated Quality Scorecard metrics */
export type QualityScorecardsAggScorecardsResponse = {
  __typename?: 'QualityScorecardsAggScorecardsResponse';
  /** List of aggregated scorecards */
  scorecards: Array<QualityScorecardsAggScorecard>;
  /** Total number of scorecards returned */
  totalCount: Scalars['Int'];
};

/** Aggregated platform-wide statistics from RUM data */
export type QualityScorecardsPlatformStats = {
  __typename?: 'QualityScorecardsPlatformStats';
  /** End of the date range queried */
  endDate: Scalars['ISO8601Date'];
  /** Total number of views in the date range */
  monthlyViews?: Maybe<Scalars['Int']>;
  /** P90 page loading time in seconds across all views */
  p90LoadingTime?: Maybe<Scalars['Float']>;
  /** Percentage of sessions that had errors */
  sessionsWithErrorsPercentage?: Maybe<Scalars['Float']>;
  /** Start of the date range queried */
  startDate: Scalars['ISO8601Date'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * ListAccounts returns accounts that match application, partner, hierarchy,
   * search, and status filters.
   */
  Auth0PermissionManagementService_instacart_caper_admin_v1_Auth0PermissionManagementService_ListAccounts?: Maybe<Instacart_Caper_Admin_V1_ListAccountsResponse>;
  /**
   * ListAccounts returns accounts that match application, partner, hierarchy,
   * search, and status filters.
   */
  Auth0PermissionManagementStagingService_instacart_caper_admin_v1_Auth0PermissionManagementService_ListAccounts?: Maybe<Instacart_Caper_Admin_V1_ListAccountsResponse>;
  /** Lists ban entries with optional filtering and pagination */
  CaperBanListManagementService_instacart_caper_admin_v1_BanListManagementService_ListBanEntries?: Maybe<Instacart_Caper_Admin_V1_ListBanEntriesResponse>;
  /** Lists ban entries with optional filtering and pagination */
  CaperBanListManagementStagingService_instacart_caper_admin_v1_BanListManagementService_ListBanEntries?: Maybe<Instacart_Caper_Admin_V1_ListBanEntriesResponse>;
  /** Omit scope to list all (.any). */
  CaperBarcodePluMappingService_instacart_caper_admin_v1_BarcodePluMappingService_ListBarcodePluMappings?: Maybe<Instacart_Caper_Admin_V1_ListBarcodePluMappingsResponse>;
  /** Fetches the object from S3 and streams it directly to the caller. Requires retailerId, billingPeriod, and uploadType as query params because the S3 key is reconstructed from them — no database lookup occurs. Responds with Content-Type text/csv and Content-Disposition attachment. */
  CaperBillingService_downloadUpload?: Maybe<CaperBillingService_DownloadUpload_Response>;
  /** Returns a JSON envelope { filename, csv } where csv is a single-header-row CSV whose column names are derived at request time from the same validator schemas used by the upload endpoint (CSV_SCHEMAS in src/csv-validation/schemas.ts). No sample data rows are included. Feeding the csv field back through the upload endpoint unchanged passes validation with rowCount 0. The JSON envelope is used (rather than raw text/csv) so consumers behind GraphQL Mesh can discriminate the response into the union response type. */
  CaperBillingService_getCsvTemplate?: Maybe<CaperBillingService_GetCsvTemplate_Response>;
  /** Returns liveness status for load balancers and monitors */
  CaperBillingService_getHealth?: Maybe<CaperBillingService_GetHealth_200_Response>;
  /** Returns the OpenAPI specification for this service as a YAML file. */
  CaperBillingService_getOpenApiSpec?: Maybe<Scalars['String']>;
  /** Retrieves full details for a single billing run including metadata, presigned download URLs for the result PDF and source CSV files, and finalization status. Requires billingPeriod to scope the S3 lookup. */
  CaperBillingService_getRunDetail?: Maybe<CaperBillingService_GetRunDetail_Response>;
  /** Issues a single S3 ListObjectsV2 on the retailer runs prefix (capped at 200 keys) and returns parsed run metadata. Supports cursor-based pagination via the nextCursor field. Optionally filter by billing period or finalization status. */
  CaperBillingService_listRuns?: Maybe<CaperBillingService_ListRuns_Response>;
  /** Issues a single S3 ListObjectsV2 on the retailer prefix (capped at 200 keys) and returns absolute download URLs for each matching file. Optionally filter by billing period range. If S3 truncated the result at the 200-key cap, listTruncated is true — narrow with from/to to reduce the scanned key space. */
  CaperBillingService_listUploads?: Maybe<CaperBillingService_ListUploads_Response>;
  /** Fetches metadata for the latest config cleanup report. Fields on the response may be unset if a given report type has not yet been generated. */
  CaperConfigCleanupReportService_instacart_caper_admin_v1_ConfigCleanupReportService_GetConfigCleanupReport?: Maybe<Instacart_Caper_Admin_V1_GetConfigCleanupReportResponse>;
  /** Fetches metadata for the latest config feature drift reports. Fields on the response may be unset if a given report type has not yet been generated. */
  CaperConfigCleanupReportService_instacart_caper_admin_v1_ConfigFeatureDriftReportService_GetConfigFeatureDriftReport?: Maybe<Instacart_Caper_Admin_V1_GetConfigFeatureDriftReportResponse>;
  /** Fetches metadata for the latest config cleanup report. Fields on the response may be unset if a given report type has not yet been generated. */
  CaperConfigCleanupReportStagingService_instacart_caper_admin_v1_ConfigCleanupReportService_GetConfigCleanupReport?: Maybe<Instacart_Caper_Admin_V1_GetConfigCleanupReportResponse>;
  /** Fetches metadata for the latest config feature drift reports. Fields on the response may be unset if a given report type has not yet been generated. */
  CaperConfigCleanupReportStagingService_instacart_caper_admin_v1_ConfigFeatureDriftReportService_GetConfigFeatureDriftReport?: Maybe<Instacart_Caper_Admin_V1_GetConfigFeatureDriftReportResponse>;
  /** Returns all Caper entities (partner, retailer, store, device) and their configs */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_GetAllEntities?: Maybe<Instacart_Caper_Admin_V1_GetAllEntitiesResponse>;
  /** Returns all available configuration keys and metadata about them */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_GetConfigKeys?: Maybe<Instacart_Caper_Admin_V1_GetConfigKeysResponse>;
  /** Get all Features */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_GetFeatures?: Maybe<Instacart_Caper_Admin_V1_GetFeaturesResponse>;
  /** Lists batch scheduled actions with filtering options */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ListBatchScheduledActions?: Maybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsResponse>;
  /** Lists notification groups (named recipient buckets used for feature notifications). */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ListNotificationGroups?: Maybe<Instacart_Caper_Admin_V1_ListNotificationGroupsResponse>;
  /** Lists scheduled actions with filtering options */
  CaperConfigManagementService_instacart_caper_admin_v1_ConfigManagementService_ListScheduledActions?: Maybe<Instacart_Caper_Admin_V1_ListScheduledActionsResponse>;
  /** Returns all Caper entities (partner, retailer, store, device) and their configs */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_GetAllEntities?: Maybe<Instacart_Caper_Admin_V1_GetAllEntitiesResponse>;
  /** Returns all available configuration keys and metadata about them */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_GetConfigKeys?: Maybe<Instacart_Caper_Admin_V1_GetConfigKeysResponse>;
  /** Get all Features */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_GetFeatures?: Maybe<Instacart_Caper_Admin_V1_GetFeaturesResponse>;
  /** Lists batch scheduled actions with filtering options */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ListBatchScheduledActions?: Maybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsResponse>;
  /** Lists notification groups (named recipient buckets used for feature notifications). */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ListNotificationGroups?: Maybe<Instacart_Caper_Admin_V1_ListNotificationGroupsResponse>;
  /** Lists scheduled actions with filtering options */
  CaperConfigManagementStagingService_instacart_caper_admin_v1_ConfigManagementService_ListScheduledActions?: Maybe<Instacart_Caper_Admin_V1_ListScheduledActionsResponse>;
  /** Returns basic entity hierarchy metadata (id, name, parent IDs) without configs or feature values. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ConfigManagementService_GetAllEntitiesBasic?: Maybe<Instacart_Caper_Admin_V2_GetAllEntitiesBasicResponse>;
  /** Returns full entity attributes, configs, and feature values for a batch of specific entities. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ConfigManagementService_GetEntitiesDetails?: Maybe<Instacart_Caper_Admin_V2_GetEntitiesDetailsResponse>;
  /** Searches entities by name, config key/value, or enabled feature. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ConfigManagementService_SearchEntities?: Maybe<Instacart_Caper_Admin_V2_SearchEntitiesResponse>;
  /** Returns one snapshot by id. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_CscSnapshotService_GetCscSnapshot?: Maybe<Instacart_Caper_Admin_V2_GetCscSnapshotResponse>;
  /** Lists snapshot summaries with optional filters. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_CscSnapshotService_ListCscSnapshots?: Maybe<Instacart_Caper_Admin_V2_ListCscSnapshotsResponse>;
  /** Returns one experiment by id, including its bindings. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_GetExperiment?: Maybe<Instacart_Caper_Admin_V2_GetExperimentResponse>;
  /** Returns the ordered activity timeline for one experiment. */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_ListExperimentHistory?: Maybe<Instacart_Caper_Admin_V2_ListExperimentHistoryResponse>;
  /**
   * Lists experiments filtered by status, DRI, or overlap with a point-in-time.
   * Bindings are omitted from list entries; use GetExperiment for those.
   */
  CaperConfigManagementV2Service_instacart_caper_admin_v2_ExperimentService_ListExperiments?: Maybe<Instacart_Caper_Admin_V2_ListExperimentsResponse>;
  /** Returns basic entity hierarchy metadata (id, name, parent IDs) without configs or feature values. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ConfigManagementService_GetAllEntitiesBasic?: Maybe<Instacart_Caper_Admin_V2_GetAllEntitiesBasicResponse>;
  /** Returns full entity attributes, configs, and feature values for a batch of specific entities. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ConfigManagementService_GetEntitiesDetails?: Maybe<Instacart_Caper_Admin_V2_GetEntitiesDetailsResponse>;
  /** Searches entities by name, config key/value, or enabled feature. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ConfigManagementService_SearchEntities?: Maybe<Instacart_Caper_Admin_V2_SearchEntitiesResponse>;
  /** Returns one snapshot by id. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_CscSnapshotService_GetCscSnapshot?: Maybe<Instacart_Caper_Admin_V2_GetCscSnapshotResponse>;
  /** Lists snapshot summaries with optional filters. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_CscSnapshotService_ListCscSnapshots?: Maybe<Instacart_Caper_Admin_V2_ListCscSnapshotsResponse>;
  /** Returns one experiment by id, including its bindings. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_GetExperiment?: Maybe<Instacart_Caper_Admin_V2_GetExperimentResponse>;
  /** Returns the ordered activity timeline for one experiment. */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_ListExperimentHistory?: Maybe<Instacart_Caper_Admin_V2_ListExperimentHistoryResponse>;
  /**
   * Lists experiments filtered by status, DRI, or overlap with a point-in-time.
   * Bindings are omitted from list entries; use GetExperiment for those.
   */
  CaperConfigManagementV2StagingService_instacart_caper_admin_v2_ExperimentService_ListExperiments?: Maybe<Instacart_Caper_Admin_V2_ListExperimentsResponse>;
  /**
   * Returns the current state of a single pipeline run, including the full
   * per-stage status list derived from stage_index and the known stage order.
   */
  CaperDeviceProvisioningPipelineService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_GetPipelineRun?: Maybe<Instacart_Caper_Admin_V1_GetPipelineRunResponse>;
  /**
   * Returns a paginated list of pipeline runs, sorted by created_at descending.
   * All filter fields are optional.
   */
  CaperDeviceProvisioningPipelineService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_ListPipelineRuns?: Maybe<Instacart_Caper_Admin_V1_ListPipelineRunsResponse>;
  /**
   * Returns the current state of a single pipeline run, including the full
   * per-stage status list derived from stage_index and the known stage order.
   */
  CaperDeviceProvisioningPipelineStagingService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_GetPipelineRun?: Maybe<Instacart_Caper_Admin_V1_GetPipelineRunResponse>;
  /**
   * Returns a paginated list of pipeline runs, sorted by created_at descending.
   * All filter fields are optional.
   */
  CaperDeviceProvisioningPipelineStagingService_instacart_caper_admin_v1_DeviceProvisioningPipelineService_ListPipelineRuns?: Maybe<Instacart_Caper_Admin_V1_ListPipelineRunsResponse>;
  /** Returns the full details of a single receipt identified by its uPOS order id */
  CaperIPPReceiptService_instacart_caper_admin_v1_IPPReceiptService_GetReceiptDetails?: Maybe<Instacart_Caper_Admin_V1_GetReceiptDetailsResponse>;
  /** Returns a paginated, filterable list of receipt summaries for the requested warehouse locations */
  CaperIPPReceiptService_instacart_caper_admin_v1_IPPReceiptService_GetReceiptsList?: Maybe<Instacart_Caper_Admin_V1_GetReceiptsListResponse>;
  /** Returns holistic receipt identification information based on the receipt identifiers passed in the request */
  CaperIPPReceiptService_instacart_caper_admin_v1_IPPReceiptService_GetReceiptsMetadata?: Maybe<Instacart_Caper_Admin_V1_GetReceiptsMetadataResponse>;
  /** GetStoreStaffBarcode retrieves a single store staff barcode by ID. */
  CaperIPPStoreStaffBarcodeService_instacart_caper_admin_v1_IPPStoreStaffBarcodeService_GetStoreStaffBarcode?: Maybe<Instacart_Caper_Admin_V1_GetStoreStaffBarcodeResponse>;
  /** ListStoreStaffBarcodes returns a paginated list of store staff barcodes. */
  CaperIPPStoreStaffBarcodeService_instacart_caper_admin_v1_IPPStoreStaffBarcodeService_ListStoreStaffBarcodes?: Maybe<Instacart_Caper_Admin_V1_ListStoreStaffBarcodesResponse>;
  /**
   * ListStoresByWarehouseLocations resolves a set of IPP warehouse location
   * IDs to their corresponding Caper stores, optionally filtered by the
   * store's active deployment state.
   */
  CaperIPPStoreStaffBarcodeService_instacart_caper_admin_v1_IPPStoreStaffBarcodeService_ListStoresByWarehouseLocations?: Maybe<Instacart_Caper_Admin_V1_ListStoresByWarehouseLocationsResponse>;
  /**
   * Retrieves entity information (partners/retailers/stores) with hierarchical relationships.
   * Supports querying by partner, retailer, or store IDs and returns related entities.
   */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_GetEntities?: Maybe<Instacart_Caper_Admin_V1_GetEntitiesResponse>;
  /** Retrieves a specific NOF item by its ID */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_GetNof?: Maybe<Instacart_Caper_Admin_V1_GetNofResponse>;
  /** Returns a paginated list of NOF items based on filter criteria */
  CaperNofManagementService_instacart_caper_admin_v1_NofManagementService_ListNofs?: Maybe<Instacart_Caper_Admin_V1_ListNofsResponse>;
  /**
   * Retrieves entity information (partners/retailers/stores) with hierarchical relationships.
   * Supports querying by partner, retailer, or store IDs and returns related entities.
   */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_GetEntities?: Maybe<Instacart_Caper_Admin_V1_GetEntitiesResponse>;
  /** Retrieves a specific NOF item by its ID */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_GetNof?: Maybe<Instacart_Caper_Admin_V1_GetNofResponse>;
  /** Returns a paginated list of NOF items based on filter criteria */
  CaperNofManagementStagingService_instacart_caper_admin_v1_NofManagementService_ListNofs?: Maybe<Instacart_Caper_Admin_V1_ListNofsResponse>;
  /** Gets available payment profiles for merchant creation. */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_GetAvailableProfiles?: Maybe<Instacart_Caper_Admin_V1_GetAvailableProfilesResponse>;
  /** Gets payment info for a store: the merchant and its terminals. */
  CaperPaymentTerminalService_instacart_caper_admin_v1_PaymentTerminalService_GetStorePaymentInfo?: Maybe<Instacart_Caper_Admin_V1_GetStorePaymentInfoResponse>;
  /** Gets available payment profiles for merchant creation. */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_GetAvailableProfiles?: Maybe<Instacart_Caper_Admin_V1_GetAvailableProfilesResponse>;
  /** Gets payment info for a store: the merchant and its terminals. */
  CaperPaymentTerminalStagingService_instacart_caper_admin_v1_PaymentTerminalService_GetStorePaymentInfo?: Maybe<Instacart_Caper_Admin_V1_GetStorePaymentInfoResponse>;
  /**
   * Retrieves structured cart event data including basket events,
   * event-derived video audit events, and audit-issue video records
   */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetCartData?: Maybe<Instacart_Caper_Admin_V1_GetCartDataResponse>;
  /**
   * Retrieves async datadog triage summary by ID
   * Used to poll for the status and results of a datadog summary initiated by CreateDatadogSummaryAsync.
   * Returns the current processing status and the generated markdown summary when completed.
   * This allows clients to check if the summary generation has finished and retrieve the results.
   */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetDatadogSummaryByIdAsync?: Maybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncResponse>;
  /**
   * Retrieves events, logs, and other detailed information about a Caper
   * session. To eventually be extended with summarization and other data
   */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionInfo?: Maybe<Instacart_Caper_Admin_V1_GetSessionInfoResponse>;
  /** Retrieves session screenshots from GCS with signed URLs */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionScreenshots?: Maybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsResponse>;
  /** Retrieves an LLM-derived summary of a session's events and logs */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummary?: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryResponse>;
  /** Retrieves async session summary by ID */
  CaperSessionInfoService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummaryByIdAsync?: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncResponse>;
  /**
   * Retrieves structured cart event data including basket events,
   * event-derived video audit events, and audit-issue video records
   */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetCartData?: Maybe<Instacart_Caper_Admin_V1_GetCartDataResponse>;
  /**
   * Retrieves async datadog triage summary by ID
   * Used to poll for the status and results of a datadog summary initiated by CreateDatadogSummaryAsync.
   * Returns the current processing status and the generated markdown summary when completed.
   * This allows clients to check if the summary generation has finished and retrieve the results.
   */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetDatadogSummaryByIdAsync?: Maybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncResponse>;
  /**
   * Retrieves events, logs, and other detailed information about a Caper
   * session. To eventually be extended with summarization and other data
   */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionInfo?: Maybe<Instacart_Caper_Admin_V1_GetSessionInfoResponse>;
  /** Retrieves session screenshots from GCS with signed URLs */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionScreenshots?: Maybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsResponse>;
  /** Retrieves an LLM-derived summary of a session's events and logs */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummary?: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryResponse>;
  /** Retrieves async session summary by ID */
  CaperSessionInfoStagingService_instacart_caper_admin_v1_SessionInfoService_GetSessionSummaryByIdAsync?: Maybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncResponse>;
  /** Get all es_retailer_product_overrides rows (all locale/surface/experiment partitions) for one (retailer_id, product_id) from Yugabyte */
  CatalogPlatformApi_getRetailerProductOverrides?: Maybe<CatalogPlatformApi_GetRetailerProductOverrides_Response>;
  /** Get all clustering rows for one retailer-product from YCQL */
  CatalogPlatformApi_getRetailerProducts?: Maybe<CatalogPlatformApi_GetRetailerProducts_Response>;
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_GetWorkflowResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultResponse>;
  /** --- Common APIs for checking job status and retrieving results (async) --- */
  ContentAiQaService_instacart_algorithms_content_ai_qa_v1_AiQaService_GetWorkflowStatus?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusResponse>;
  /** Returns the full detail view for an incident or maintenance record. The endpoint first looks up the record under the INC# partition key; if not found, it falls back to MAINT# so the FE can use a single detail endpoint regardless of record type. When retailerId is supplied, the endpoint verifies that the retailer is a saved notification contact on the incident (returns 404 if not), and the response omits acks, notifications, and contact PII (contacts[] in each retailerContacts entry is returned as an empty array). */
  EnterpriseStatusPage_getIncident?: Maybe<EnterpriseStatusPage_GetIncident_Response>;
  /** Returns the OpenAPI specification for this service in YAML format */
  EnterpriseStatusPage_getOpenApiSpec?: Maybe<Scalars['String']>;
  /** Returns liveness status for monitors and load balancers */
  EnterpriseStatusPage_healthCheck?: Maybe<EnterpriseStatusPage_HealthCheck_200_Response>;
  /** Returns all component groups sorted by name */
  EnterpriseStatusPage_listComponentGroups?: Maybe<Array<Maybe<EnterpriseStatusPage_ListComponentGroups_Response>>>;
  /** List components in a group */
  EnterpriseStatusPage_listComponentsInGroup?: Maybe<Array<Maybe<EnterpriseStatusPage_ListComponentsInGroup_Response>>>;
  /** Returns incidents sorted by createdAt descending. Optionally filter by status. Supports cursor-based pagination via limit and nextToken query params. When retailerId is supplied, only incidents where that retailer is a saved notification contact are returned, and openOnly is automatically enforced (resolved/completed incidents are excluded). The response never includes contact PII (contacts[] is always empty for list items). */
  EnterpriseStatusPage_listIncidents?: Maybe<EnterpriseStatusPage_ListIncidents_Response>;
  /** Returns notification user groups from DB (managed via /users/groups) as a 3-level hierarchy. FE renders this as a nested group/member picker for selecting notification recipients. */
  EnterpriseStatusPage_listNotificationUserGroups?: Maybe<EnterpriseStatusPage_ListNotificationUserGroups_200_Response>;
  /** Returns the list of system component names available for incident association. Populated from the SYSTEM_COMPONENTS environment variable (comma-separated). Returns an empty list when the env var is not set. */
  EnterpriseStatusPage_listSystemComponents?: Maybe<EnterpriseStatusPage_SystemComponentList>;
  /** Returns top-level groups with nested sub-groups and their user members. */
  EnterpriseStatusPage_listUserGroups?: Maybe<Array<Maybe<EnterpriseStatusPage_ListUserGroups_Response>>>;
  /** Returns top-level groups with their sub-groups (no users). Each sub-group represents a retailer and includes retailerId and retailerName when set. FE uses this to populate the group picker: selecting a group gives the FE the retailerIds it needs to fetch contacts from retailer-contact-management via mesh. */
  EnterpriseStatusPage_listUserGroupsSummary?: Maybe<Array<Maybe<EnterpriseStatusPage_ListUserGroupsSummary_Response>>>;
  /** Returns the status of Datadog monitors for a specific retailer */
  ExternalHealthDashboard_getMonitorStatuses?: Maybe<Array<Maybe<ExternalHealthDashboard_GetMonitorStatuses_Response>>>;
  /** Returns the OpenAPI specification for this API in YAML format */
  ExternalHealthDashboard_getOpenApiSpec?: Maybe<ExternalHealthDashboard_GetOpenApiSpec_Response>;
  /** Handles the OIDC authentication callback and redirects users */
  ExternalHealthDashboard_handleAuthCallback?: Maybe<ExternalHealthDashboard_Error>;
  /** Returns the health status of the API */
  ExternalHealthDashboard_healthCheck?: Maybe<ExternalHealthDashboard_HealthCheck>;
  /** Get a response configuration by ID */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_GetResponseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigResponse>;
  /** List response configurations with optional filters */
  FulfillmentPartnerTesting_instacart_enterprise_fulfillment_partner_testing_v1_FulfillmentPartnerTestingService_ListResponseConfigs?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsResponse>;
  /** Get fulfillment providers by id, slug, or name */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_GetFulfillmentProvider?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderResponse>;
  /**
   * Return every configuration row for a partner. Bounded result set (single
   * partner, small number of providers); no pagination.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_GetFulfillmentProviderPartnerConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderPartnerConfigurationsResponse>;
  /** Fetch a Rule (with current version, payload, and attachments) by id. */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_GetFulfillmentRuleConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentRuleConfigurationsResponse>;
  /** Fetch a Strategy (with current version, payload, and attachments) by id. */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_GetFulfillmentStrategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentStrategyResponse>;
  /**
   * List rules attached at the given scope. Set include_children to also
   * include rules attached at any descendant scope.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_ListFulfillmentRulesConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentRulesConfigurationsResponse>;
  /**
   * List strategies attached at the given scope. Set include_children to also
   * include strategies attached at any descendant scope.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_ListFulfillmentStrategies?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentStrategiesResponse>;
  /**
   * Standalone validation. Called separately by FE during rule authoring
   * (e.g. as the user types). CRUD RPCs run the same validators internally
   * before persisting; this RPC does not persist.
   */
  FulfillmentRuleEngine_instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentConstraintsService_ValidateFulfillmentRuleConfigurations?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidateFulfillmentRuleConfigurationsResponse>;
  /** Get strings for a resource */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_GetStrings?: Maybe<Instacart_Customers_Commerce_Garnish_V1_GetStringsResponse>;
  /** List resources */
  GarnishService_instacart_customers_commerce_garnish_v1_GarnishService_ListResources?: Maybe<Instacart_Customers_Commerce_Garnish_V1_ListResourcesResponse>;
  /**
   * GetMarketingCampaign retrieves a marketing campaign by ID along with all its
   * associated entities (segment, VGP, roulette experiment, CRM configuration).
   * Returns partial results if some entity fetches fail.
   */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_GetMarketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignResponse>;
  /**
   * ListMarketingCampaigns retrieves a paginated list of marketing campaigns
   * with optional filtering. Returns basic campaign data without enriched entities.
   */
  MarketingToolingService_instacart_growth_marketing_tooling_v1_MarketingToolingService_ListMarketingCampaigns?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ListMarketingCampaignsResponse>;
  /**
   * GetAllowedActionsByRecipeID evaluates all known actions for a recipe and
   * returns those that passed layered permission evaluation. Supports both
   * icapp (flow_context) and internal callers (internal_context).
   *
   * Returns:
   * - Allowed actions sorted by enum declaration order; may be empty
   * - INVALID_ARGUMENT if caller oneof is unset, recipe_id is invalid,
   * shop scope is missing (icapp), or publisher_id is invalid (internal)
   * - INTERNAL on database error, query timeout, or unexpected failure
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetAllowedActionsByRecipeID?: Maybe<Instacart_Customers_Meals_Endpoints_Permissions_V1_GetAllowedActionsByRecipeIdResponse>;
  /**
   * GetEligibleAttributes retrieves all active, eligible recipe attributes as a flat list.
   *
   * Returns:
   * - Flat list of active recipe attributes (orphaned children excluded)
   * - INTERNAL error on database unavailability
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetEligibleAttributes?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetEligibleAttributesResponse>;
  /**
   * GetPublisher retrieves a provider/source by ID with associated metadata and scopes.
   *
   * Returns:
   * - Provider/source details including all scopes
   * - NOT_FOUND error if provider/source does not exist
   * - INVALID_REQUEST error if publisher_id is invalid
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetPublisher?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherResponse>;
  /**
   * GetPublisherByLegacyContentCreatorId retrieves a provider/source by its legacy content creator ID.
   *
   * Returns:
   * - Provider/source details including all scopes
   * - NOT_FOUND error if no provider/source is found with the given legacy content creator ID
   * - INVALID_ARGUMENT error if legacy_content_creator_id is invalid
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetPublisherByLegacyContentCreatorId?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherByLegacyContentCreatorIdResponse>;
  /**
   * GetRecipe retrieves a single recipe by ID with all associated data.
   *
   * Returns:
   * - Recipe with descriptions, ingredients, instructions, nutrition facts, FAQs, and images
   * - NOT_FOUND error if recipe does not exist or is soft-deleted
   * - INVALID_ARGUMENT error if recipe_id is invalid (0 or negative)
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetRecipe?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeResponse>;
  /**
   * GetRecipeIdBySparkRecipeId retrieves the meals recipe ID corresponding to a
   * given Spark recipe ID.
   *
   * Returns:
   * - Meals DB recipe ID for the supplied Spark recipe ID
   * - NOT_FOUND error if no recipe is associated with the given Spark recipe ID
   * - INVALID_ARGUMENT error if spark_recipe_id is invalid (0 or negative)
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetRecipeIdBySparkRecipeId?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeIdBySparkRecipeIdResponse>;
  /**
   * GetShoppableProducts retrieves the shoppable ingredients of a recipe,
   * grouped for presentation, scoped to the shop carried on the flow
   * context. Empty groups, ingredients, or product_ids lists are valid
   * success responses; only validation and infrastructure failures error.
   *
   * Returns:
   * - Ingredient groups, each with its ingredients and matching product ids
   * - INVALID_ARGUMENT error if recipe_id is invalid (0 or negative) or flow_context is missing
   * - INTERNAL error on database unavailability
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetShoppableProducts?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetShoppableProductsResponse>;
  /**
   * GetSparkRecipeIdsByRecipeId retrieves the Spark (legacy) recipe IDs
   * corresponding to a given Meals DB recipe ID. A single Meals DB recipe
   * can map to multiple Spark recipe IDs (1->many).
   *
   * Returns:
   * - All Spark recipe IDs mapped to the supplied Meals DB recipe ID
   * - NOT_FOUND error if no Spark mappings exist for the given recipe ID
   * - INVALID_ARGUMENT error if recipe_id is invalid (0 or negative)
   */
  MealsRetrievalService_instacart_customers_meals_services_retrieval_v1_MealsRetrievalService_GetSparkRecipeIdsByRecipeId?: Maybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetSparkRecipeIdsByRecipeIdResponse>;
  /** Returns a single contact identified by retailer ID and email address */
  RetailerContactManagement_getContact?: Maybe<RetailerContactManagement_GetContact_Response>;
  /** Returns all contacts for a retailer, sorted by priority (ascending) then email. Optionally filtered by domain and/or priority. */
  RetailerContactManagement_getContacts?: Maybe<Array<Maybe<RetailerContactManagement_GetContacts_Response>>>;
  /** Returns this OpenAPI specification in YAML format */
  RetailerContactManagement_getOpenApiSpec?: Maybe<RetailerContactManagement_GetOpenApiSpec_Response>;
  /** Returns a single contact identified by partner ID and email address */
  RetailerContactManagement_getPartnerContact?: Maybe<RetailerContactManagement_GetPartnerContact_Response>;
  /** Returns all contacts for a partner, sorted by priority (ascending) then email. Optionally filtered by domain and/or priority. */
  RetailerContactManagement_getPartnerContacts?: Maybe<Array<Maybe<RetailerContactManagement_GetPartnerContacts_Response>>>;
  /** Returns the health status of the API. Available at both /health and /api/v1/health */
  RetailerContactManagement_healthCheck?: Maybe<RetailerContactManagement_HealthCheck>;
  /**
   * GetCampaignBrief retrieves a campaign brief by its brief ID or its
   * downstream Campaigns Domain campaign ID.
   */
  UnifiedMarketingBackendService_instacart_growth_unified_marketing_backend_v1_UnifiedMarketingBackendService_GetCampaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_GetCampaignBriefResponse>;
  /** ListCampaignBriefs retrieves a paginated list of campaign briefs with optional filtering. */
  UnifiedMarketingBackendService_instacart_growth_unified_marketing_backend_v1_UnifiedMarketingBackendService_ListCampaignBriefs?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_ListCampaignBriefsResponse>;
  _empty?: Maybe<Scalars['String']>;
  _noop?: Maybe<Scalars['String']>;
  /** The access control details for the account */
  accessControlConfiguration: AccessControlConfiguration;
  /** Check if account request for given email already exists */
  accountRequestPreviousRequestExistByEmail: AccountRequestPreviousRequestExists;
  /** Search for an previously created Account Request by ID */
  accountRequestSearchById: AccountRequestAccountRequest;
  /** Check if an account token (reset password or verify email) is valid */
  accountTokenValidate: TokensValidation;
  /** Notice banners whose path_glob matches the supplied path */
  activeNoticeBanners: Array<NoticeBannersTypesBannerType>;
  /** Fetch a single notice banner by id (admin only) */
  adminNoticeBanner?: Maybe<NoticeBannersTypesBannerType>;
  /** All notice banners (admin only), ordered by most recently updated */
  adminNoticeBanners: Array<NoticeBannersTypesBannerType>;
  aiAgentAvailable?: Maybe<Scalars['Boolean']>;
  anomalyDetectionSummary: Array<AnomalyDetectionEntry>;
  apiIntegrationsServiceGetApiSettings?: Maybe<GetApiSettingsResponse>;
  apiIntegrationsServiceGetAuthenticationUrl?: Maybe<GetAuthenticationUrlResponse>;
  apiIntegrationsServiceGetAvailableStoreLocations?: Maybe<GetAvailableStoreLocationsResponse>;
  /** Resolves eligible approvers for one or more approval requests, keyed by ar_id. */
  approvalsManagementGetApproverLists: Array<ApprovalsManagementTypesApprovalRequestApprovers>;
  /** Retrieves a specific approval request by its ID. */
  approvalsManagementGetRequest?: Maybe<ApprovalsManagementTypesApprovalRequest>;
  /** Retrieves a list of content snapshots by their IDs. */
  approvalsManagementGetSnapshots: Array<ApprovalsManagementTypesContentSnapshot>;
  /** Retrieves permitted actions for a user on a set of approval requests. */
  approvalsManagementGetUserPermittedActions: Array<ApprovalsManagementTypesUserPermittedActions>;
  /** Retrieves a list of approval requests. */
  approvalsManagementListRequests: ApprovalsManagementTypesListApprovalRequestsResult;
  assignmentsGetOrderFulfillmentOverview?: Maybe<GetOrderFulfillmentOverviewResponse>;
  /** Search for Audit Logs */
  auditLogSearch: AuditLogsAuditLogConnection;
  availabilityGetStoreHoursByDate?: Maybe<GetStoreHoursByDateResponse>;
  availabilityGetStoreHoursByDayOfWeek?: Maybe<GetStoreHoursByDayOfWeekResponse>;
  availabilityGetStoreHoursByZoneRetailer?: Maybe<GetStoreHoursByZoneRetailerResponse>;
  /** Extract canonical bulk rows from selected audit log entries (for 'Open in Bulk Editor'). */
  buildRowsFromAuditLogEntries: BulkAccountManagementTypesBuildRowsPayload;
  /** Query audit-log entries across bulk + singular paths. Offset pagination per Repository semantics. */
  bulkAuditLog: AuditLogPage;
  /** Look up a single bulk operation by its client-generated operation id. */
  bulkOperation: BulkOperation;
  /** List past bulk operations. Filters and offset pagination per Repository semantics. */
  bulkOperations: BulkOperationPage;
  /** Fetch a specific aisle by id */
  catalogAisle: CatalogAisle;
  /** Fetch a specific department by id */
  catalogDepartment: CatalogDepartment;
  catalogProblemTrackerServiceGetTicket?: Maybe<GetTicketResponse>;
  catalogProblemTrackerServiceListTickets?: Maybe<ListTicketsResponse>;
  /** Retrieve products by IDs */
  catalogProducts: Array<CatalogProduct>;
  /** Retrieve a retailer-product by its ID */
  catalogRetailerProduct: CatalogRetailerProduct;
  /** Search for retailer-products matching a set of criteria */
  catalogRetailerProductSearch: CatalogRetailerProductConnection;
  /** Fetch a signed url for an S3 report */
  catalogSearchDownloadSignedUrl: CatalogSearchDownloadsCatalogSearchDownloadSignedUrl;
  catalogToolsApiServiceDownloadCatalogSearchResults?: Maybe<DownloadCatalogSearchResultsResponse>;
  catalogToolsApiServiceGetAnomalousItemsList?: Maybe<GetAnomalousItemsListResponse>;
  catalogToolsApiServiceGetAnomalousItemsReport?: Maybe<GetAnomalousItemsReportResponse>;
  catalogToolsApiServiceGetLocalesByRetailer?: Maybe<GetLocalesByRetailerResponse>;
  catalogToolsApiServiceGetManagedAttribute?: Maybe<GetManagedAttributeResponse>;
  catalogToolsApiServiceGetMassOpsIntegrationStatus?: Maybe<GetMassOpsIntegrationStatusResponse>;
  catalogToolsApiServiceGetPriceInvestigation?: Maybe<GetPriceInvestigationResponse>;
  catalogToolsApiServiceGetProductCreationData?: Maybe<GetProductCreationDataResponse>;
  catalogToolsApiServiceGetRetailerProductAttributeSources?: Maybe<GetRetailerProductAttributeSourcesResponse>;
  catalogToolsApiServiceGetRetailerProductData?: Maybe<GetRetailerProductDataResponse>;
  catalogToolsApiServiceGetRetailerSurfaces?: Maybe<GetRetailerSurfacesResponse>;
  catalogToolsApiServiceGetSentinelMember?: Maybe<GetSentinelMemberResponse>;
  catalogToolsApiServiceListMemberVersions?: Maybe<ListMemberVersionsResponse>;
  catalogToolsApiServiceListPriceInvestigations?: Maybe<ListPriceInvestigationsResponse>;
  catalogToolsApiServiceListSentinelMembers?: Maybe<ListSentinelMembersResponse>;
  catalogToolsApiServiceSearchManagedAttributes?: Maybe<SearchManagedAttributesResponse>;
  collectionsServiceGetCollections?: Maybe<GetCollectionsResponse>;
  commerceInvoicingServiceGetOrderDiscountDetails?: Maybe<GetOrderDiscountDetailsResponse>;
  configurableItemsServiceGetRppConfigurableItems?: Maybe<GetRppConfigurableItemsResponse>;
  connectPlatformServiceGetConnectPlatformEventsByDomain?: Maybe<GetConnectPlatformEventsByDomainResponse>;
  connectPlatformServiceGetConnectSettings?: Maybe<GetConnectSettingsResponse>;
  connectPlatformServiceGetPartnerApiKeys?: Maybe<GetPartnerApiKeysResponse>;
  connectPlatformServiceGetPartnerId?: Maybe<GetPartnerIdResponse>;
  connectPlatformServiceGetRequestContexts?: Maybe<GetRequestContextsResponse>;
  contentManagementAdminServiceGetAdminNavigationV2?: Maybe<GetAdminNavigationV2Response>;
  contentManagementAdminServiceGetAvailableOfferFilters?: Maybe<GetAvailableOfferFiltersResponse>;
  contentManagementAdminServiceGetFrothTemplate?: Maybe<GetFrothTemplateResponse>;
  contentManagementAdminServiceGetFrothTemplateConstraints?: Maybe<GetFrothTemplateConstraintsResponse>;
  contentManagementAdminServiceGetFrothTemplateVersion?: Maybe<GetFrothTemplateVersionResponse>;
  contentManagementAdminServiceGetNativeTabBarNavigation?: Maybe<GetNativeTabBarNavigationResponse>;
  contentManagementAdminServiceGetNavigation?: Maybe<GetNavigationResponse>;
  contentManagementAdminServiceGetPlacementContentById?: Maybe<GetPlacementContentByIdResponse>;
  contentManagementAdminServiceGetRetailersForShortcuts?: Maybe<GetRetailersForShortcutsResponse>;
  contentManagementAdminServiceGetSlotById?: Maybe<GetSlotByIdResponse>;
  contentManagementAdminServiceGetSlots?: Maybe<GetSlotsResponse>;
  contentManagementAdminServiceGetSlotsByContentPages?: Maybe<GetSlotsByContentPagesResponse>;
  contentManagementAdminServiceGetSocialIconsNavigation?: Maybe<GetSocialIconsNavigationResponse>;
  contentManagementAdminServiceGetToolingShortcuts?: Maybe<GetToolingShortcutsResponse>;
  contentManagementAdminServiceListContentPageAnchors?: Maybe<ListContentPageAnchorsResponse>;
  contentManagementAdminServiceListContentPageSlotAreas?: Maybe<ListContentPageSlotAreasResponse>;
  contentManagementAdminServiceListContentPageVersionMetas?: Maybe<ListContentPageVersionMetasResponse>;
  contentManagementAdminServiceListContentPageVersions?: Maybe<ListContentPageVersionsResponse>;
  contentManagementAdminServiceListContentPagesV2?: Maybe<ListContentPagesResponseV2>;
  contentManagementAdminServiceListDeletedContentPages?: Maybe<ListDeletedContentPagesResponse>;
  contentManagementAdminServiceListFrothTemplateVersions?: Maybe<ListFrothTemplateVersionsResponse>;
  contentManagementAdminServiceListFrothTemplates?: Maybe<ListFrothTemplatesResponse>;
  contentManagementAdminServiceListPlacementContent?: Maybe<ListPlacementContentResponse>;
  contentManagementAdminServiceListPublishedFrothTemplates?: Maybe<ListPublishedFrothTemplatesResponse>;
  contentManagementServiceGetLayoutVariants?: Maybe<GetLayoutVariantsResponse>;
  contentManagementServiceGetPlacements?: Maybe<PlacementsResponse>;
  contentManagementServiceGetThemePage?: Maybe<GetThemePageResponse>;
  contentManagementServiceListThemePages?: Maybe<ListThemePagesResponse>;
  /** The currently authenticated account */
  currentEnterpriseAccount: EnterpriseAccount;
  /** Check if user has access to the given arguments */
  currentEnterpriseAccountAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck;
  customersOrdersServiceGetHandlingDetails?: Maybe<CustomersGetHandlingDetailsResponse>;
  customersOrdersServiceGetOrder?: Maybe<CustomersGetOrderResponse>;
  customersOrdersServiceGetOrderAmountsSummaryV0?: Maybe<CustomersGetOrderAmountsSummaryV0Response>;
  customersOrdersServiceGetPaymentMethodSummary?: Maybe<CustomersGetPaymentMethodSummaryResponse>;
  customersOrdersServiceListOrders?: Maybe<CustomersListOrdersResponse>;
  customersOrdersServiceQueryOrderReference?: Maybe<CustomersQueryOrderReferenceResponse>;
  customersOrdersServiceQueryOrders?: Maybe<CustomersQueryOrdersResponse>;
  demeterServiceGetAuditBatch?: Maybe<GetAuditBatchResponse>;
  demeterServiceGetAuditBatchMetadata?: Maybe<GetAuditBatchMetadataResponse>;
  demeterServiceGetAuditTask?: Maybe<GetAuditTaskResponse>;
  demeterServiceGetAuditWorkflowConfigs?: Maybe<GetAuditWorkflowConfigsResponse>;
  demeterServiceGetDetection?: Maybe<GetDetectionResponse>;
  demeterServiceGetNextAuditBatch?: Maybe<GetNextAuditBatchResponse>;
  demeterServiceListAuditBatches?: Maybe<ListAuditBatchesResponse>;
  demeterServiceListAuditTaskComponents?: Maybe<ListAuditTaskComponentsResponse>;
  demeterServiceListAuditWorkflows?: Maybe<ListAuditWorkflowsResponse>;
  demeterServiceListDetections?: Maybe<ListDetectionsResponse>;
  demeterServicePrepareToSubmitAuditBatch?: Maybe<PrepareToSubmitAuditBatchResponse>;
  emergingBrandPortalServiceGetBrandProfileAttributes?: Maybe<BrandProfileAttributesResponse>;
  emergingBrandPortalServiceGetBrandProfileSellSheetCards?: Maybe<BrandProfileSellSheetCardsResponse>;
  emergingBrandPortalServiceGetBrandSellSheetsAttributes?: Maybe<BrandSellSheetsAttributesResponse>;
  emergingBrandPortalServiceGetEBPAnalytics?: Maybe<EbpAnalyticsResponse>;
  emergingBrandPortalServiceGetEBPProductAnalyticsSummary?: Maybe<ProductAnalyticsSummaryResponse>;
  emergingBrandPortalServiceGetEBPProductAttributes?: Maybe<ProductAttributesResponse>;
  emergingBrandPortalServiceGetIndexBrandNames?: Maybe<IndexBrandNamesResponse>;
  emergingBrandPortalServiceGetIndexEBPCategories?: Maybe<IndexEbpCategoriesResponse>;
  emergingBrandPortalServiceGetIndexSellSheetCards?: Maybe<SellSheetCardsResponse>;
  emergingBrandPortalServiceGetProductBrandProfileAttributes?: Maybe<ProductBrandProfileAttributesResponse>;
  emergingBrandPortalServiceGetProductSellSheetCards?: Maybe<ProductSellSheetCardsResponse>;
  emergingBrandPortalServiceGetSellSheetAnalyticsSummary?: Maybe<SellSheetAnalyticsSummaryResponse>;
  emergingBrandPortalServiceGetSellSheetAttributes?: Maybe<SellSheetAttributesResponse>;
  emergingBrandPortalServiceGetSellSheetBrandProfileAttributes?: Maybe<SellSheetBrandProfileAttributesResponse>;
  emergingBrandPortalServiceGetSellSheetProductsAttributes?: Maybe<SellSheetProductsAttributesResponse>;
  emergingBrandPortalServiceGetSellSheetProductsSummaryTraits?: Maybe<SellSheetProductsSummaryTraitsResponse>;
  /** Fetch an EnterpriseAccount by its canonical id */
  enterpriseAccount: EnterpriseAccount;
  /** Search for EnterpriseAccounts matching a set of criteria */
  enterpriseAccountSearch: EnterpriseAccountConnection;
  /** Evaluate one or more claims for the currently authenticated user. Returns a result per requested evaluation, in input order. */
  evaluateMyClaims: Array<ClaimsTypesClaimResultType>;
  /** Check whether a known publicly-gated feature flag is fully enabled. */
  featureToggleFullyEnabled: FeatureTogglesEnabledCheck;
  /** Check the health of the server */
  healthCheck: HealthCheck;
  historicalStorePerformanceServiceGetAggregatedHistoricalStorePerformance?: Maybe<HistoricalStorePerformanceResponse>;
  /** Fetch a list of Marketplace Home placements */
  homePlacementSearch: Array<HomePlacement>;
  /** Check if user has access to the given arguments */
  insightsPortalAuthorizationCheck: AccessControlAuthorizationAuthorizationCheck;
  /**
   * READ (Batch)
   *
   * Returns the set of segments matching the given context. Useful for
   * finding, e.g., all targeting segments in use by a particular retailer.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetAllSegmentDefinitions?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentStates>;
  /**
   * GET EXACT AUDIENCE SIZE
   *
   * Polls for the result of a job submitted via SubmitExactAudienceSize.
   * Returns the computed audience metrics once the job completes.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetExactAudienceSize?: Maybe<Instacart_Ads_Platform_Taas_V1_GetExactAudienceSizeResponse>;
  /**
   * READ
   *
   * The response will have the same version number as the request (or the
   * greatest available if none was specified; see below) and the definition
   * associated with that version.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetSegmentDefinition?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
  /**
   * READ
   *
   * The response will have the same version number as the request (or the
   * greatest available if none was specified; see below) and the audience size of the segment
   * associated with that version.
   */
  instacart_ads_platform_taas_v1_SegmentRegistryService_GetSegmentSize?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentSize>;
  instacart_ads_v3_EmergingBrandPortalService_GetIndexBrandNames?: Maybe<Instacart_Ads_V3_IndexBrandNamesResponse>;
  instacart_ads_v3_EmergingBrandPortalService_GetProductAdditionalInfo?: Maybe<Instacart_Ads_V3_ProductAdditionalInfoResponse>;
  instacart_ads_v3_RetailerBlockedAdsService_GetRetailerBlockedAdIds?: Maybe<Instacart_Ads_V3_GetRetailerBlockedAdIdsResponse>;
  instacart_ads_v3_RetailerReviewToolService_GetDisplayPreviewData?: Maybe<Instacart_Ads_V3_GetDisplayPreviewDataResponse>;
  instacart_ads_v3_RetailerReviewToolService_GetDisplayPreviewDataBySha256?: Maybe<Instacart_Ads_V3_GetDisplayPreviewDataResponse>;
  /** Finds existing carousels that are similar to the provided carousel configuration. */
  instacart_algorithms_ai_carousel_creator_v1_AiCarouselCreatorService_GetSimilarCarousels?: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsResponse>;
  /**
   * Returns the store-level Value Grant Policy override ID for the provided
   * appeasement context. See the response field for unset semantics.
   */
  instacart_care_tools_v1_AppeasementsService_GetAppeasementValueGrantPolicyId?: Maybe<Instacart_Care_Tools_V1_GetAppeasementValueGrantPolicyIdResponse>;
  /** Returns resolutions and appeasements for a single order, with agent names resolved and statuses pre-computed. */
  instacart_care_tools_v1_AppeasementsService_ListOrderResolutionsAndAppeasements?: Maybe<Instacart_Care_Tools_V1_ListOrderResolutionsAndAppeasementsResponse>;
  /** Returns paginated resolutions and appeasements across all orders for a user. */
  instacart_care_tools_v1_AppeasementsService_ListUserResolutionsAndAppeasements?: Maybe<Instacart_Care_Tools_V1_ListUserResolutionsAndAppeasementsResponse>;
  instacart_care_tools_v1_BannersService_ListBanners?: Maybe<Instacart_Care_Tools_V1_ListBannersResponse>;
  instacart_care_tools_v1_CareToolsService_CheckAdminRefundEligibility?: Maybe<Instacart_Care_Tools_V1_CheckAdminRefundEligibilityResponse>;
  instacart_care_tools_v1_CareToolsService_FindRelatedUsers?: Maybe<Instacart_Care_Tools_V1_FindRelatedUsersResponse>;
  instacart_care_tools_v1_CareToolsService_FindUsers?: Maybe<Instacart_Care_Tools_V1_FindUsersResponse>;
  /** Express endpoints */
  instacart_care_tools_v1_CareToolsService_GetActiveBenefits?: Maybe<Instacart_Care_Tools_V1_GetActiveBenefitsResponse>;
  instacart_care_tools_v1_CareToolsService_GetCommonIdentityUsers?: Maybe<Instacart_Care_Tools_V1_GetCommonIdentityUsersResponse>;
  /** Spending endpoints */
  instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummary?: Maybe<Instacart_Care_Tools_V1_GetCustomerSpendingSummaryResponse>;
  /** Get lifetime customer spending metrics for a customer. */
  instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummaryV2?: Maybe<Instacart_Care_Tools_V1_GetCustomerSpendingSummaryV2Response>;
  instacart_care_tools_v1_CareToolsService_GetHouseholdByUser?: Maybe<Instacart_Care_Tools_V1_GetHouseholdByUserResponse>;
  /** User endpoints */
  instacart_care_tools_v1_CareToolsService_GetInstacartPlusMembership?: Maybe<Instacart_Care_Tools_V1_GetInstacartPlusMembershipResponse>;
  instacart_care_tools_v1_CareToolsService_GetLatestActiveAttributeForUser?: Maybe<Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserResponse>;
  instacart_care_tools_v1_CareToolsService_GetLifetimeSavingsForUser?: Maybe<Instacart_Care_Tools_V1_GetLifetimeSavingsForUserResponse>;
  instacart_care_tools_v1_CareToolsService_GetLinkedUserAccounts?: Maybe<Instacart_Care_Tools_V1_GetLinkedUserAccountsResponse>;
  /** Returns detailed fields for an order. Requires an order_reference. */
  instacart_care_tools_v1_CareToolsService_GetOrder?: Maybe<Instacart_Care_Tools_V1_GetOrderResponse>;
  /** Returns detailed fields for an order. Requires an order_id. */
  instacart_care_tools_v1_CareToolsService_GetOrderById?: Maybe<Instacart_Care_Tools_V1_GetOrderByIdResponse>;
  /** Returns simplified fields for an order. Requires an order_id. */
  instacart_care_tools_v1_CareToolsService_GetOrderByIdBasic?: Maybe<Instacart_Care_Tools_V1_GetOrderByIdBasicResponse>;
  /** Returns order counts grouped by status for a retailer over a bounded date range. */
  instacart_care_tools_v1_CareToolsService_GetOrderCountsByRetailer?: Maybe<Instacart_Care_Tools_V1_GetOrderCountsByRetailerResponse>;
  /** Fetch the return for an order, if it exists. */
  instacart_care_tools_v1_CareToolsService_GetOrderReturn?: Maybe<Instacart_Care_Tools_V1_GetOrderReturnResponse>;
  /** Checks whether an order delivery is eligible for a shopper return and lists items with their action. */
  instacart_care_tools_v1_CareToolsService_GetOrderReturnEligibility?: Maybe<Instacart_Care_Tools_V1_GetOrderReturnEligibilityResponse>;
  instacart_care_tools_v1_CareToolsService_GetUser?: Maybe<Instacart_Care_Tools_V1_GetUserResponse>;
  instacart_care_tools_v1_CareToolsService_ListActiveAttributesByCountry?: Maybe<Instacart_Care_Tools_V1_ListActiveAttributesByCountryResponse>;
  instacart_care_tools_v1_CareToolsService_ListAddressesForUser?: Maybe<Instacart_Care_Tools_V1_ListAddressesForUserResponse>;
  /** Return payment instruments that can be used for moving or adding charges to. */
  instacart_care_tools_v1_CareToolsService_ListAdminMoveOrAddChargesPaymentInstruments?: Maybe<Instacart_Care_Tools_V1_ListAdminMoveOrAddChargesPaymentInstrumentsResponse>;
  /** Returns charge logs for a given order delivery. */
  instacart_care_tools_v1_CareToolsService_ListChargeLogsForOrderDelivery?: Maybe<Instacart_Care_Tools_V1_ListChargeLogsForOrderDeliveryResponse>;
  instacart_care_tools_v1_CareToolsService_ListNotesForUser?: Maybe<Instacart_Care_Tools_V1_ListNotesForUserResponse>;
  instacart_care_tools_v1_CareToolsService_ListOrderChatMessagesAndNotes?: Maybe<Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesResponse>;
  /**
   * Order endpoints
   * Returns summarized fields for orders, best used for table/list views.
   */
  instacart_care_tools_v1_CareToolsService_ListOrdersByCustomer?: Maybe<Instacart_Care_Tools_V1_ListOrdersByCustomerResponse>;
  /** Returns summarized fields for orders, best used for table/list views. */
  instacart_care_tools_v1_CareToolsService_ListOrdersByRetailer?: Maybe<Instacart_Care_Tools_V1_ListOrdersByRetailerResponse>;
  /** Returns restaurant orders for a customer. */
  instacart_care_tools_v1_CareToolsService_ListRestaurantOrdersByCustomer?: Maybe<Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerResponse>;
  /** Lists predefined ban reasons. */
  instacart_care_tools_v1_CareToolsService_ListUserShopperBanReasons?: Maybe<Instacart_Care_Tools_V1_ListUserShopperBanReasonsResponse>;
  /**
   * User-Shopper Ban endpoints
   * Lists all bans for a given shopper.
   */
  instacart_care_tools_v1_CareToolsService_ListUserShopperBans?: Maybe<Instacart_Care_Tools_V1_ListUserShopperBansResponse>;
  /**
   * Salesforce endpoints
   * Validates that a Salesforce case ID exists.
   */
  instacart_care_tools_v1_CareToolsService_ValidateSalesforceCase?: Maybe<Instacart_Care_Tools_V1_ValidateSalesforceCaseResponse>;
  /** The GetAuditReview API returns an audit review */
  instacart_cashflow_nutella_v1_NutellaService_GetAuditReview?: Maybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewResponse>;
  /** The GetAuditReviewsWithFeedback API returns audit reviews and pagination info */
  instacart_cashflow_nutella_v1_NutellaService_GetAuditReviewsWithFeedback?: Maybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackResponse>;
  /** The GetNextAuditReview API returns the current audit review assigned to a user or returns the next unassigned audit review */
  instacart_cashflow_nutella_v1_NutellaService_GetNextAuditReview?: Maybe<Instacart_Cashflow_Nutella_V1_GetNextAuditReviewResponse>;
  /** The GetWorkflowMetadata API returns metadata for a workflow */
  instacart_cashflow_nutella_v1_NutellaService_GetWorkflowMetadata?: Maybe<Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataResponse>;
  /**
   * The ListAuditReviewSiblings API returns sibling audit reviews under the same order_delivery_id,
   * along with any incoming receipt-pair signals and BE-computed pre-fill candidates for the source review
   */
  instacart_cashflow_nutella_v1_NutellaService_ListAuditReviewSiblings?: Maybe<Instacart_Cashflow_Nutella_V1_ListAuditReviewSiblingsResponse>;
  /** GetL2Categories retrieves all l2 categories from the list of forcemark retailer reports based on the list of provided retailer IDs. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetL2Categories?: Maybe<Instacart_Catalog_Admin_V1_GetL2CategoriesResponse>;
  /** GetMissingCodesForcemarkDetails retrieves missing codes forcemark details for a specific forcemark. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetMissingCodesForcemarkDetails?: Maybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsResponse>;
  /** GetMissingCodesForcemarks retrieves missing codes forcemarks for a specific retailer. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetMissingCodesForcemarks?: Maybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksResponse>;
  /** GetMissingCodesReviewedForcemarks retrieves reviewed missing codes forcemarks for a specific retailer. */
  instacart_catalog_admin_v1_MissingCodesForcemarkService_GetMissingCodesReviewedForcemarks?: Maybe<Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksResponse>;
  /** GetMlPriceAnomalyProductDetails retrieves item-level details for a specific product flagged by the ML price anomaly model */
  instacart_catalog_admin_v1_MlPriceAnomalyService_GetMlPriceAnomalyProductDetails?: Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse>;
  /** GetMlPriceAnomalyProducts retrieves a paginated list of products flagged by the ML price anomaly model */
  instacart_catalog_admin_v1_MlPriceAnomalyService_GetMlPriceAnomalyProducts?: Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse>;
  /** GetPriceAlertProductDetails gets details on product that triggered a price alert */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetPriceAlertProductDetails?: Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse>;
  /** GetPriceAlertProducts gets list of products that triggered price alert */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetPriceAlertProducts?: Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse>;
  /** GetPriceAlertProductsCategories gets list of categories for use by the FE category filter */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetPriceAlertProductsCategories?: Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse>;
  /** GetRetailerDiscountInitialThresholds retrieves global thresholds by partner_id or retailer_id */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetRetailerDiscountInitialThresholds?: Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse>;
  /** GetRetailerDiscountThresholds retrieves all retailer discount thresholds from the DB */
  instacart_catalog_admin_v1_RetailerDiscountThresholdService_GetRetailerDiscountThresholds?: Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse>;
  /** GetImpactAnalysis returns the full change request record along with sampled impact results and summary counts. */
  instacart_catalog_admin_v1_SourcePriorityService_GetImpactAnalysis?: Maybe<Instacart_Catalog_Admin_V1_GetImpactAnalysisResponse>;
  /** GetSourcePriorityFilterOptions returns distinct attributes, source types, and retailers present in source priority rules. */
  instacart_catalog_admin_v1_SourcePriorityService_GetSourcePriorityFilterOptions?: Maybe<Instacart_Catalog_Admin_V1_GetSourcePriorityFilterOptionsResponse>;
  /** GetSourcePriorityRule returns a single source priority rule by ID. */
  instacart_catalog_admin_v1_SourcePriorityService_GetSourcePriorityRule?: Maybe<Instacart_Catalog_Admin_V1_GetSourcePriorityRuleResponse>;
  /** ListChangeRequests returns a filtered, paginated list of change requests. */
  instacart_catalog_admin_v1_SourcePriorityService_ListChangeRequests?: Maybe<Instacart_Catalog_Admin_V1_ListChangeRequestsResponse>;
  /** ListSourcePriorityRules returns a filtered, paginated list of source priority rules. */
  instacart_catalog_admin_v1_SourcePriorityService_ListSourcePriorityRules?: Maybe<Instacart_Catalog_Admin_V1_ListSourcePriorityRulesResponse>;
  /** Search for a taxonomy node */
  instacart_catalog_admin_v1_TaxonomyService_SearchTaxonomyNodes?: Maybe<Instacart_Catalog_Admin_V1_SearchTaxonomyNodesResponse>;
  /** List temporary overrides for a set of retailer products or items. */
  instacart_catalog_admin_v1_TempOverrideService_List?: Maybe<Instacart_Catalog_Admin_V1_TempOverrideServiceListResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_DescribeSnowflakeTable?: Maybe<Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetPresignedUploadUrl?: Maybe<Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetStepRunResults?: Maybe<Instacart_Catalog_Catflow_V1_GetStepRunResultsResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetStepVersion?: Maybe<Instacart_Catalog_Catflow_V1_GetStepVersionResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_GetStepVersionHistory?: Maybe<Instacart_Catalog_Catflow_V1_GetStepVersionHistoryResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_ListStepRuns?: Maybe<Instacart_Catalog_Catflow_V1_ListStepRunsResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_ListStepVersions?: Maybe<Instacart_Catalog_Catflow_V1_ListStepVersionsResponse>;
  instacart_catalog_catflow_v1_CatflowAPI_ListSteps?: Maybe<Instacart_Catalog_Catflow_V1_ListStepsResponse>;
  /** Retrieves batch information without event history */
  instacart_catalog_data_bridge_v1_DataBridgeService_GetBatch?: Maybe<Instacart_Catalog_Data_Bridge_V1_GetBatchResponse>;
  /** Retrieves batch status with event history */
  instacart_catalog_data_bridge_v1_DataBridgeService_GetBatchStatus?: Maybe<Instacart_Catalog_Data_Bridge_V1_GetBatchStatusResponse>;
  /** Retrieves a bridge by its name */
  instacart_catalog_data_bridge_v1_DataBridgeService_GetBridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_GetBridgeResponse>;
  /** Lists batches with optional filtering and pagination */
  instacart_catalog_data_bridge_v1_DataBridgeService_ListBatches?: Maybe<Instacart_Catalog_Data_Bridge_V1_ListBatchesResponse>;
  /** Lists all bridges with optional filtering and pagination */
  instacart_catalog_data_bridge_v1_DataBridgeService_ListBridges?: Maybe<Instacart_Catalog_Data_Bridge_V1_ListBridgesResponse>;
  /** Lists all schema versions for a bridge */
  instacart_catalog_data_bridge_v1_DataBridgeService_ListSchemaVersions?: Maybe<Instacart_Catalog_Data_Bridge_V1_ListSchemaVersionsResponse>;
  /** GetProductCounts returns product count metrics from the catalog health data warehouse. */
  instacart_catalog_health_v1_CatalogHealthService_GetProductCounts?: Maybe<Instacart_Catalog_Health_V1_GetProductCountsResponse>;
  /** Get tender transactions for a list of WHLs */
  instacart_checkout_v1_PosDataService_GetTenderTransactionsByWhlIds?: Maybe<Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsResponse>;
  /** Returns a short-lived presigned URL the client can use to fetch a stored email body HTML directly from S3. */
  instacart_communications_v2_Communications_GetEmailBodyDownloadUrl?: Maybe<Instacart_Communications_V2_GetEmailBodyDownloadUrlResponse>;
  /** Gets a paginated list of notifications matching the parameters */
  instacart_communications_v2_Communications_GetNotifications?: Maybe<Instacart_Communications_V2_GetNotificationsResponse>;
  /** get basket product. */
  instacart_customers_basket_products_orchestrators_v1_BasketProductsOrchestratorsService_GetBasketProducts?: Maybe<Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsReponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgram?: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramContent?: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramContentByProgramId?: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramOffer?: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_GetBusinessProgramOffersByProgramId?: Maybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_ListBusinessProgram?: Maybe<Instacart_Customers_Business_Admin_V1_ListBusinessProgramResponse>;
  instacart_customers_business_admin_v1_BusinessAdminService_ListBusinesses?: Maybe<Instacart_Customers_Business_Admin_V1_ListBusinessesResponse>;
  instacart_customers_business_v1_BusinessService_GetBusinessProgramContent?: Maybe<Instacart_Customers_Business_V1_GetBusinessProgramContentResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetBucketDownloadUrl?: Maybe<Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetBucketUploadUrl?: Maybe<Instacart_Customers_Campaigns_V1_GetBucketUploadUrlResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetCsvFoundEntriesCount?: Maybe<Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetCsvProcessingSummary?: Maybe<Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryResponse>;
  instacart_customers_campaigns_v1_CampaignsService_GetGroupedSlots?: Maybe<Instacart_Customers_Campaigns_V1_GetGroupedSlotsResponse>;
  /** BEGIN Marketing AI Agent */
  instacart_customers_campaigns_v1_CampaignsService_GetMarketingAgentCampaign?: Maybe<Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ListMarketingAgentCampaigns?: Maybe<Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsResponse>;
  instacart_customers_campaigns_v1_CampaignsService_ValidateMarketingAgentSchedule?: Maybe<Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleResponse>;
  /** Gets the active cart ID for a user at a specific retailer */
  instacart_customers_carts_v1_CartsService_GetActiveCartIdForUser?: Maybe<Instacart_Customers_Carts_V1_GetActiveCartIdForUserResponse>;
  instacart_customers_carts_v1_CartsService_GetCartBasketTotals?: Maybe<Instacart_Customers_Carts_V1_GetCartBasketTotalsResponse>;
  instacart_customers_carts_v1_CartsService_GetCartItemCollections?: Maybe<Instacart_Customers_Carts_V1_GetCartItemCollectionsResponse>;
  /** Retrieves a single delegated checkout link by ID. */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_GetDelegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_GetDelegatedCheckoutLinkResponse>;
  /** Returns delegated checkout links matching the request criteria. */
  instacart_customers_carts_v1_DelegatedCheckoutLinkService_ListDelegatedCheckoutLinks?: Maybe<Instacart_Customers_Carts_V1_ListDelegatedCheckoutLinksResponse>;
  instacart_customers_commerce_coupons_v1_CommerceCouponsService_GetRedemptionCodeExists?: Maybe<Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_GetValueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyResponse>;
  instacart_customers_commerce_discount_v1_CommerceDiscountService_GetValueGrantPolicyFacade?: Maybe<Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeResponse>;
  instacart_customers_commerce_stored_value_orchestrator_v1_CommerceStoredValueService_GetAvailableCreditsBalances?: Maybe<Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_GetAvailableCreditsBalancesResponse>;
  instacart_customers_coupons_v1_CouponsDomainService_GetCouponCodeExists?: Maybe<Instacart_Customers_Coupons_V1_GetCouponCodeExistsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetCampaignLinks?: Maybe<Instacart_Customers_Coupons_V1_GetCampaignLinksResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetMoment?: Maybe<Instacart_Customers_Coupons_V1_GetMomentResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetMomentParticipatingRetailers?: Maybe<Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetMoments?: Maybe<Instacart_Customers_Coupons_V1_GetMomentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_GetRetailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_ListMoments?: Maybe<Instacart_Customers_Coupons_V1_ListMomentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_ListRetailerCampaignTreatments?: Maybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsResponse>;
  instacart_customers_coupons_v1_RetailerCampaignService_ListRetailerCampaigns?: Maybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsResponse>;
  instacart_customers_express_v1_ExpressService_GetCurrentExpressMemberStatusForUser?: Maybe<Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserResponse>;
  instacart_customers_express_v1_ExpressService_GetLatestActiveOrInactiveSubscriptionForUser?: Maybe<Instacart_Customers_Express_V1_GetLatestActiveOrInactiveSubscriptionForUserResponse>;
  /** Gets a rule set */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetResponse>;
  /** Gets a rule set run (debug data) */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRun?: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunResponse>;
  /** Get rule set run debug data */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRunDebug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugResponse>;
  /** Get image by stub ref */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRunImage?: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageResponse>;
  /** Get run status and details */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_GetRuleSetRunStatus?: Maybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusResponse>;
  /** List runs by status */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_ListRuleSetRunStatuses?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse>;
  /** List rule set runs (debug data) */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_ListRuleSetRuns?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse>;
  /** Validates a rule set */
  instacart_customers_flyer_pdf_v1_FlyerPdfService_ValidateRuleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetResponse>;
  /** Gets a gift order digital card by ID */
  instacart_customers_gifting_v1_GiftOrderDigitalCardService_GetGiftOrderDigitalCardById?: Maybe<Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdResponse>;
  /** Get loyalty benefits for a program. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_GetLoyaltyBenefits?: Maybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsResponse>;
  /** Get loyalty card validations for a warehouse. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_GetLoyaltyCardValidations?: Maybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsResponse>;
  /** Get a loyalty program for a retailer. */
  instacart_customers_loyalty_admin_v1_LoyaltyAdminService_GetLoyaltyProgram?: Maybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramResponse>;
  /** Get loyalty cards by card number. */
  instacart_customers_loyalty_v1_LoyaltyService_GetLoyaltyCardsByCardNumber?: Maybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberResponse>;
  /** Get loyalty cards for a user. */
  instacart_customers_loyalty_v1_LoyaltyService_GetLoyaltyCardsForUser?: Maybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserResponse>;
  instacart_customers_offers_tooling_orchestrator_v1_OffersToolingService_PrepareCreateOfferPayload?: Maybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadResponse>;
  /** API to return order items details. */
  instacart_customers_orders_v1_OrdersService_GetOrderLines?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse>;
  /** Countries API */
  instacart_customers_partners_v1_PartnersService_GetCountries?: Maybe<Instacart_Customers_Partners_V1_GetCountriesResponse>;
  /** Partners API */
  instacart_customers_partners_v1_PartnersService_GetPartners?: Maybe<Instacart_Customers_Partners_V1_GetPartnersResponse>;
  /**
   * PostalCodes API
   * Search postal codes by name or id. Not recommended unless you can't use GetPostalCodesByZones, as
   * the list can be very long.
   */
  instacart_customers_partners_v1_PartnersService_GetPostalCodes?: Maybe<Instacart_Customers_Partners_V1_GetPostalCodesResponse>;
  /** Search postal codes within a zone. This is the preferred method for searching postal codes. */
  instacart_customers_partners_v1_PartnersService_GetPostalCodesByZones?: Maybe<Instacart_Customers_Partners_V1_GetPostalCodesByZonesResponse>;
  /** Regions API */
  instacart_customers_partners_v1_PartnersService_GetRegions?: Maybe<Instacart_Customers_Partners_V1_GetRegionsResponse>;
  /** RetailerLocations aka WarehouseLocations API */
  instacart_customers_partners_v1_PartnersService_GetRetailerLocations?: Maybe<Instacart_Customers_Partners_V1_GetRetailerLocationsResponse>;
  instacart_customers_partners_v1_PartnersService_GetRetailerLocationsByRetailer?: Maybe<Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerResponse>;
  instacart_customers_partners_v1_PartnersService_GetRetailerZones?: Maybe<Instacart_Customers_Partners_V1_GetRetailerZonesResponse>;
  instacart_customers_partners_v1_PartnersService_GetRetailers?: Maybe<Instacart_Customers_Partners_V1_GetRetailersResponse>;
  /**
   * Zones API
   * Gets all zones, optionally filtered by name. Using GetZonesByRegion is preferred where possible as
   * the list of zones is very long when not filtered by region.
   */
  instacart_customers_partners_v1_PartnersService_GetZones?: Maybe<Instacart_Customers_Partners_V1_GetZonesResponse>;
  /** Gets all zones in a region, optionally filtered by name. Preferred where possible. */
  instacart_customers_partners_v1_PartnersService_GetZonesByRegion?: Maybe<Instacart_Customers_Partners_V1_GetZonesByRegionResponse>;
  instacart_customers_partnership_offer_v1_PartnershipOfferService_GetPartnershipManagementUrlDownloadLink?: Maybe<Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkResponse>;
  instacart_customers_partnership_offer_v1_PartnershipOfferService_ListPartnershipManagementUrls?: Maybe<Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsResponse>;
  instacart_customers_product_retrieval_v1_ProductRetrievalService_GetLegacyProductsWithFilters?: Maybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetAggregatedItemData?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetItems?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_GetRetailerProducts?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse>;
  instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerToolsProductRetrievalService_SearchRetailerBrands?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse>;
  instacart_customers_recipes_v1_RecipesService_GetCategoriesByName?: Maybe<Instacart_Customers_Recipes_V1_GetCategoriesByNameResponse>;
  instacart_customers_recipes_v1_RecipesService_GetCoreIngredients?: Maybe<Instacart_Customers_Recipes_V1_GetCoreIngredientsResponse>;
  instacart_customers_recipes_v1_RecipesService_GetRecipeById?: Maybe<Instacart_Customers_Recipes_V1_GetRecipeByIdResponse>;
  instacart_customers_recipes_v1_RecipesService_GetRecipeByIdForDashboard?: Maybe<Instacart_Customers_Recipes_V1_GetRecipeByIdResponse>;
  instacart_customers_recipes_v1_RecipesService_GetRecipes?: Maybe<Instacart_Customers_Recipes_V1_GetRecipesResponse>;
  instacart_customers_recipes_v1_RecipesService_ListRecipes?: Maybe<Instacart_Customers_Recipes_V1_ListRecipesResponse>;
  instacart_customers_recipes_v1_RecipesService_ValidateAndUploadRecipes?: Maybe<Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_CheckBulkEditStatus?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyer?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerActivities?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerClickableAreas?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerMetadata?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerPageEditPresignedUrl?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPageEditPresignedUrlResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerPipelineDebug?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerPresignedUrls?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerStats?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerTags?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_GetFlyerUploadDetails?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsResponse>;
  instacart_customers_retailer_collections_admin_v1_FlyerService_ListFlyers?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetCollectionPreviewProducts?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetCollectionRules?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetFeaturedCollectionProductPreview?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionProductPreviewResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetFeaturedCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionSetResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetLowerPriceDefinitions?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetNavigationTree?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_GetRetailerCsv?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListActiveFeaturedCollectionSets?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListActiveFeaturedCollectionSetsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListCollectionProducts?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListCollections?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListFeaturedCollectionSets?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFeaturedCollectionSetsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListGlobalCollections?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ListRetailerDepartments?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_SearchCollectionProducts?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsResponse>;
  instacart_customers_retailer_collections_admin_v1_RetailerCollectionsAdminService_ValidateCollectionSlug?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_GetIppDraftById?: Maybe<Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdResponse>;
  instacart_customers_retailer_management_v1_IppDraftManagementService_ListIppDrafts?: Maybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsResponse>;
  instacart_customers_retailer_management_v1_IppDraftPreviewService_GetIppPreviewByToken?: Maybe<Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenResponse>;
  instacart_customers_retailer_management_v1_IppDraftPreviewService_GetPreviewAuthToken?: Maybe<Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenResponse>;
  instacart_customers_retailer_management_v1_WidgetConfigurationService_GetWidgetConfiguration?: Maybe<Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationResponse>;
  instacart_customers_retailers_orchestrator_v1_RetailersService_GetShopCollection?: Maybe<Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionResponse>;
  /**
   * Internal request for getting esci labels for products
   * This is created specifically for validating product relevance for IPP custom boosting rules
   */
  instacart_customers_search_results_v2_SearchResultsService_GetProductEsciLabel?: Maybe<Instacart_Customers_Search_Results_V2_GetProductEsciLabelResponse>;
  instacart_customers_search_v1_SearchService_GetSearchTermOverrides?: Maybe<Instacart_Customers_Search_V1_GetSearchTermOverridesResponse>;
  instacart_customers_search_v1_SearchService_GetSearchTermOverridesById?: Maybe<Instacart_Customers_Search_V1_GetSearchTermOverridesByIdResponse>;
  instacart_customers_value_grant_v1_ValueGrantService_GetStoredValueAndDiscounts?: Maybe<Instacart_Customers_Value_Grant_V1_GetStoredValueAndDiscountsResponse>;
  instacart_customers_value_grant_v1_ValueGrantService_GetStoredValueTransactionHistory?: Maybe<Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryResponse>;
  instacart_enterprise_boba_core_offers_v1_OfferService_GetOrderDiscountInfo?: Maybe<Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoResponse>;
  /** Retrieves bulk delivery configurations for a specific retailer location. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurations?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsResponse>;
  /** Retrieves bulk delivery configurations for multiple retailer locations in a single call. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurationsList?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListResponse>;
  /** Retrieves delivery routes with active issues at a retailer location. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryIssues?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryIssuesResponse>;
  /** Retrieves an overview of order statuses for a retailer location on a given date. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryOrderOverview?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewResponse>;
  /** Retrieves detailed information about a single delivery route including orders. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRoute?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteResponse>;
  /** Retrieves a list of bulk delivery routes for a specific retailer location and date. */
  instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRouteList?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListResponse>;
  /** Retrieves a paginated list of vehicles for a warehouse location. */
  instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehiclesService_GetWarehouseLocationVehicleList?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListResponse>;
  /** fetches a Dashboard Order. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetDashboardOrder?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderResponse>;
  /** Get a list of orders from filters or order ID. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetDashboardOrderSearchResultList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse>;
  /** Get an operation for an order */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOperation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationResponse>;
  /** Get Order Adjustment Policies and validates adjustment request */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderAdjustmentPolicyList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListResponse>;
  /**
   * Get a list of OrderCancellationPolicies in order to cancel an order.
   *
   * TODO: contrary to the naming, this endpoint also fetches reschedule policies.
   * When we upgrade from the experimental ICP service we should rename this
   * to GetOrderChangePolicyList, which also should include refunds.
   */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderCancellationPolicyList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListResponse>;
  /** Get order lines for an order */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderLineList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListResponse>;
  /** Get a list of state changes for an order. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardOrderService_GetOrderStateChangeList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListResponse>;
  /** Fetches a list of users by email, phone, or loyalty id. */
  instacart_enterprise_frigate_fulfillment_v1_DashboardUserService_GetDashboardUserSearchResultList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse>;
  instacart_enterprise_frigate_fulfillment_v1_EnterpriseServiceOptionService_GetEnterpriseServiceOptionList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse>;
  /** Fetches detailed information about retailer products */
  instacart_enterprise_frigate_fulfillment_v1_RetailerProductDetailsService_GetRetailerProductDetails?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse>;
  /** Get messages for conversation */
  instacart_enterprise_frigate_post_checkout_v1_EnterpriseChatService_GetEnterpriseChatMessageList?: Maybe<Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListResponse>;
  /** Retrieves a list of partner-managed shifts for a specific retailer location and date. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_GetPartnerManagedShiftList?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListResponse>;
  /** Retrieves specified partner-managed shifts with their assigned equipment for a retailer location. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftsService_GetPartnerManagedShiftsWithEquipment?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftsWithEquipmentResponse>;
  /** Retrieves a paginated list of partner-managed shoppers with optional filtering. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedShoppersService_GetPartnerManagedShopperList?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListResponse>;
  /** Retrieves staffing hours for a specific retailer location and date. */
  instacart_enterprise_frigate_shifts_v1_PartnerManagedStaffingService_GetStaffingHoursListByDate?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateResponse>;
  /** GetPresignedDownloadUrl generates a presigned URL for downloading a file from cloud storage */
  instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationsService_GetPresignedDownloadUrl?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlResponse>;
  /** GetShiftManagementOperationRecord retrieves a single shift management operation record by ID */
  instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationsService_GetShiftManagementOperationRecord?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordResponse>;
  /**
   * GetShiftManagementOperationRecordList retrieves shift management operation records
   * for a given retailer with pagination support
   */
  instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationsService_GetShiftManagementOperationRecordList?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListResponse>;
  /** Retrieves staffing allocation data for a specified date range. */
  instacart_enterprise_frigate_shifts_v1_StaffingAllocationService_GetStaffingAllocationList?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListResponse>;
  /** Get checkout state and barcode for an order delivery */
  instacart_enterprise_fulfillment_simulation_engine_v1_OrderSimulationService_GetCheckoutStateAndBarcode?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeResponse>;
  /** GetChangeRequest returns a single change request with its rules and conditions. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_GetChangeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestResponse>;
  /** GetChangeRequestSamplePrices computes sample before/after prices for a change request. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_GetChangeRequestSamplePrices?: Maybe<Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestSamplePricesResponse>;
  /**
   * GetPartnerAlcoholMarkupProhibitedStates returns one entry per retailer owned by
   * the partner, listing the state/province codes where the retailer carries alcohol
   * and markup is prohibited by policy. Retailer scope is resolved server-side from
   * partner_id (CP-918 trust boundary); callers do not supply retailer IDs. Empty
   * per-retailer lists are fail-safe (no warning shown).
   */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_GetPartnerAlcoholMarkupProhibitedStates?: Maybe<Instacart_Eversight_Item_Price_Management_V1_GetPartnerAlcoholMarkupProhibitedStatesResponse>;
  /** GetProductGroup returns a single product group by ID. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_GetProductGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_GetProductGroupResponse>;
  /** GetStoreGroup returns a single store group with its elements. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_GetStoreGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_GetStoreGroupResponse>;
  /**
   * ListAdminMarkupPartners returns a paginated cross-partner summary of
   * trailing 7-day average markup. Requires item_price_management.view plus
   * all_partners_full_access; the backend returns all active partners and does
   * not apply per-caller partner filtering in this revision.
   */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListAdminMarkupPartners?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupPartnersResponse>;
  /**
   * ListAdminMarkupRules returns a paginated, filterable list of active rules
   * across partners. Requires item_price_management.view plus
   * all_partners_full_access; the backend returns active rules for all partners
   * and does not apply per-caller partner filtering in this revision.
   */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListAdminMarkupRules?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupRulesResponse>;
  /** ListChangeRequests returns paginated change requests for a partner. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListChangeRequests?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListChangeRequestsResponse>;
  /** ListProductGroups returns paginated product groups for a partner. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListProductGroups?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListProductGroupsResponse>;
  /** ListRules returns paginated active pricing rules. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListRules?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListRulesResponse>;
  /** ListStoreGroups returns paginated store groups for a retailer. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListStoreGroups?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListStoreGroupsResponse>;
  /** ListStores returns all stores for a given retailer. */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ListStores?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ListStoresResponse>;
  /**
   * ValidateAndPrioritizeRules checks a candidate rule's scope against its change request's
   * rule set without persisting anything, returning the priority slot it would occupy
   * or the conflicts that reject it.
   */
  instacart_eversight_item_price_management_v1_ItemPriceManagementService_ValidateAndPrioritizeRules?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ValidateAndPrioritizeRulesResponse>;
  /**
   * Gets detailed information about a single MAPLE job.
   * Use this for the job details/monitoring view.
   */
  instacart_flawless_inventory_v1_MapleService_GetJobDetails?: Maybe<Instacart_Flawless_Inventory_V1_GetJobDetailsResponse>;
  /** Gets details about the run of a job. */
  instacart_flawless_inventory_v1_MapleService_GetJobResults?: Maybe<Instacart_Flawless_Inventory_V1_GetJobResultsResponse>;
  /**
   * Gets all unique AI Gateway sources that have been used in MAPLE jobs.
   * Use this for populating filter dropdowns in the dashboard.
   */
  instacart_flawless_inventory_v1_MapleService_GetJobSources?: Maybe<Instacart_Flawless_Inventory_V1_GetJobSourcesResponse>;
  /** Gets the status of a given job. Is one of ['completed', 'in_progress', 'failed'] */
  instacart_flawless_inventory_v1_MapleService_GetJobStatus?: Maybe<Instacart_Flawless_Inventory_V1_GetJobStatusResponse>;
  /**
   * Dashboard APIs
   * Lists all MAPLE jobs with optional filtering and pagination.
   * Use this for the job browser/dashboard view.
   */
  instacart_flawless_inventory_v1_MapleService_GetJobs?: Maybe<Instacart_Flawless_Inventory_V1_GetJobsResponse>;
  /** Get a list of all the AI models supported for MAPLE. */
  instacart_flawless_inventory_v1_MapleService_GetMapleSupportedModels?: Maybe<Instacart_Flawless_Inventory_V1_GetMapleSupportedModelsResponse>;
  /** Gets picking order items */
  instacart_fulfillment_domains_picking_v1_PickingItem_GetPickingItems?: Maybe<Instacart_Fulfillment_Domains_Picking_V1_GetPickingItemsResponse>;
  /** Get quality metrics for step log audits by step type */
  instacart_fulfillment_domains_transaction_integrity_v1_TransactionIntegrityService_GetStepLogAuditMetrics?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogAuditMetricsResponse>;
  /** Get step logs for a batch */
  instacart_fulfillment_domains_transaction_integrity_v1_TransactionIntegrityService_GetStepLogs?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogsResponse>;
  /** Get all available step types */
  instacart_fulfillment_domains_transaction_integrity_v1_TransactionIntegrityService_GetStepTypes?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepTypesResponse>;
  /**
   * GetReceiptItemCatalogCandidates returns catalog candidates for each receipt line item
   * in the receipt corresponding to the given pos_receipts_classifier_output_id. CatalogCandidates are sourced
   * from offline and online matching algorithms, with UPC-matched candidates surfaced first.
   * When available, each candidate is enriched with an AI confidence tier (high/medium/low).
   * If AI scoring fails, candidates are still returned with tier unspecified.
   */
  instacart_fulfillment_shopper_checkout_receipt_understanding_v1_ReceiptUnderstandingService_GetReceiptItemCatalogCandidates?: Maybe<Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_GetReceiptItemCatalogCandidatesResponse>;
  /** Lists override history and concrete targets for audit. */
  instacart_fulfillment_shopper_incentives_v1_IncentiveBudgetOverrideService_ListBudgetOverrides?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ListBudgetOverridesResponse>;
  /**
   * Lists every zone-window budget from one selected complete run for an inclusive range of at most 31 calendar dates.
   * Selects by generated_at descending, then by numeric projection-run resource ID descending.
   * Reversed or wider ranges fail with INVALID_ARGUMENT; the response is intentionally unpaginated as one run snapshot.
   */
  instacart_fulfillment_shopper_incentives_v1_IncentiveBudgetProjectionRunsService_ListProjectionBudgets?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ListProjectionBudgetsResponse>;
  /** Get audit logs for debugging reconciliation actions */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetAuditLogs?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsResponse>;
  /** Get step log audits with optional filters */
  instacart_fulfillment_shopper_transaction_integrity_v1_AuditService_GetStepLogAudits?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsResponse>;
  /** Get categorization analysis result for a batch */
  instacart_fulfillment_shopper_transaction_integrity_v1_CategorizationService_GetCategorizationAnalysis?: Maybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisResponse>;
  /** Lists predefined ban reasons, with "Other" sorted last. */
  instacart_fulfillment_user_shopper_ban_v1_UserShopperBanService_ListUserShopperBanReasons?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBanReasonsResponse>;
  /** Lists all bans for a given shopper, ordered by creation time descending. */
  instacart_fulfillment_user_shopper_ban_v1_UserShopperBanService_ListUserShopperBans?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBansResponse>;
  /** Gets the status of a campaign */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetCampaignStatus?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusResponse>;
  /** Gets the email unsubscribe lists */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetEmailUnsubscribeLists?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsResponse>;
  /** Get an IntentionConfiguration */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetIntentionConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationResponse>;
  /** Get a single retailer configuration based on retailer_id/store_configuration_id */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetRetailerConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationResponse>;
  /** Gets the size of a segment */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetSegmentSize?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeResponse>;
  /** Gets a template */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_GetTemplate?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateResponse>;
  /** List supported editable template variables */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_ListEditableTemplateVariables?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesResponse>;
  /** Lists segments for a warehouse */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_ListSegments?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsResponse>;
  /** Lists templates */
  instacart_growth_crm_messaging_service_v1_CRMMessagingService_ListTemplates?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesResponse>;
  /** Fetch Module by Name */
  instacart_infra_instaform_v1_InstaformService_GetModuleByName?: Maybe<Instacart_Infra_Instaform_V1_GetModuleByNameResponse>;
  /** Fetch all the Modules */
  instacart_infra_instaform_v1_InstaformService_GetModules?: Maybe<Instacart_Infra_Instaform_V1_GetModulesResponse>;
  /** Get the details of an Entity */
  instacart_infra_totem_v1_TotemService_GetEntity?: Maybe<Instacart_Infra_Totem_V1_GetEntityResponse>;
  /** Get the details of a system */
  instacart_infra_totem_v1_TotemService_GetSystem?: Maybe<Instacart_Infra_Totem_V1_GetSystemResponse>;
  /** Get a single OpsEscalationRequest by ID. */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_GetOpsEscalationRequest?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestResponse>;
  /** List all OpsEscalationRequests matching the ones in request based on a list of OpsEscalationRequest IDs */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_ListBulkDuplicateOpsEscalationRequests?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsResponse>;
  /** List all OpsEscalationRequests matching the one in request based on Warehouse Location IDs */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_ListDuplicateOpsEscalationRequests?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsResponse>;
  /** List all OpsEscalationRequests that match the given criteria */
  instacart_logistics_marketplace_ops_v1_OpsEscalationRequests_ListOpsEscalationRequests?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsResponse>;
  instacart_logistics_v1_FulfillmentEvents_GetFulfillmentEvent?: Maybe<Instacart_Logistics_V1_GetFulfillmentEventResponse>;
  /** Get many fulfillment events by id */
  instacart_logistics_v1_FulfillmentEvents_GetFulfillmentEventsById?: Maybe<Instacart_Logistics_V1_GetFulfillmentEventsByIdResponse>;
  /** List all child fulfillment events for a specified parent event that match the given criteria */
  instacart_logistics_v1_FulfillmentEvents_ListChildFulfillmentEvents?: Maybe<Instacart_Logistics_V1_ListChildFulfillmentEventsResponse>;
  /** List all creators */
  instacart_logistics_v1_FulfillmentEvents_ListCreators?: Maybe<Instacart_Logistics_V1_ListCreatorsResponse>;
  /** List all fulfillment events that match the given criteria */
  instacart_logistics_v1_FulfillmentEvents_ListFulfillmentEvents?: Maybe<Instacart_Logistics_V1_ListFulfillmentEventsResponse>;
  /** List all tags */
  instacart_logistics_v1_FulfillmentEvents_ListTags?: Maybe<Instacart_Logistics_V1_ListTagsResponse>;
  /** Validate a new closure event */
  instacart_logistics_v1_FulfillmentEvents_ValidateNewClosureEvent?: Maybe<Instacart_Logistics_V1_ValidateNewClosureEventResponse>;
  /** Validate a new fulfillment capacity-impacting event */
  instacart_logistics_v1_FulfillmentEvents_ValidateNewFulfillmentEvent?: Maybe<Instacart_Logistics_V1_ValidateNewFulfillmentEventResponse>;
  /** Validate a new restricted availability event */
  instacart_logistics_v1_FulfillmentEvents_ValidateNewRestrictedAvailabilityEvent?: Maybe<Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventResponse>;
  /**
   * DownloadInterventionData generates a presigned URL to download the full CSV data uploaded for an intervention.
   * This allows downloading the complete dataset for offline analysis or processing.
   */
  instacart_massops_v1_MassOpsService_DownloadInterventionData?: Maybe<Instacart_Massops_V1_DownloadInterventionDataResponse>;
  /**
   * DownloadInterventionTasksCSV generates a presigned URL to download the tasks for an intervention as a CSV file.
   * Supports optional filtering by task state and/or specific task param names.
   * When both state and task param names are provided, AND semantics apply: only tasks that match a given state
   * AND have a matching param name are exported.
   */
  instacart_massops_v1_MassOpsService_DownloadInterventionTasksCSV?: Maybe<Instacart_Massops_V1_DownloadInterventionTasksCsvResponse>;
  /**
   * DownloadValidationFailures generates a presigned URL to download the full CSV of validation
   * failure records for a given check. The CSV is pre-stored at all_violations_s3_key.
   */
  instacart_massops_v1_MassOpsService_DownloadValidationFailures?: Maybe<Instacart_Massops_V1_DownloadValidationFailuresResponse>;
  /** GetIncident returns a single incident from the incident service based on the provided filter. */
  instacart_massops_v1_MassOpsService_GetIncident?: Maybe<Instacart_Massops_V1_GetIncidentResponse>;
  /**
   * GetIntervention retrieves detailed information about a specific intervention,
   * including its current state, execution progress, and parameters.
   */
  instacart_massops_v1_MassOpsService_GetIntervention?: Maybe<Instacart_Massops_V1_GetInterventionResponse>;
  /**
   * GetInterventionBundle retrieves the full details of a single intervention bundle,
   * including its state, communication templates, and approval metadata.
   */
  instacart_massops_v1_MassOpsService_GetInterventionBundle?: Maybe<Instacart_Massops_V1_GetInterventionBundleResponse>;
  /**
   * GetInterventionCommunicationSettings retrieves the communication settings for an intervention.
   * Returns the current email and SMS notification configurations.
   */
  instacart_massops_v1_MassOpsService_GetInterventionCommunicationSettings?: Maybe<Instacart_Massops_V1_GetInterventionCommunicationSettingsResponse>;
  /**
   * GetInterventionCountsByArtifactType returns the number of interventions grouped by artifact type
   * over time periods based on the specified aggregation (week, month, or quarter).
   */
  instacart_massops_v1_MassOpsService_GetInterventionCountsByArtifactType?: Maybe<Instacart_Massops_V1_GetInterventionCountsByArtifactTypeResponse>;
  /**
   * GetInterventionCountsByIncident returns the number of incident-related interventions
   * grouped by incident reference and intervention type.
   */
  instacart_massops_v1_MassOpsService_GetInterventionCountsByIncident?: Maybe<Instacart_Massops_V1_GetInterventionCountsByIncidentResponse>;
  /**
   * GetInterventionCountsByInterventionType returns the number of interventions categorized by
   * incident-related and non-incident-related types, broken down by intervention type.
   */
  instacart_massops_v1_MassOpsService_GetInterventionCountsByInterventionType?: Maybe<Instacart_Massops_V1_GetInterventionCountsByInterventionTypeResponse>;
  /**
   * GetInterventionEmailContentUsage returns whether an intervention requires
   * Instacart-based email templates, retailer-based email templates, or both.
   */
  instacart_massops_v1_MassOpsService_GetInterventionEmailContentUsage?: Maybe<Instacart_Massops_V1_GetInterventionEmailContentUsageResponse>;
  /**
   * GetInterventionPreExecutionSummary retrieves the pre-execution summary for a specific intervention.
   * This includes estimated impact, validation results, and readiness checks before execution begins.
   */
  instacart_massops_v1_MassOpsService_GetInterventionPreExecutionSummary?: Maybe<Instacart_Massops_V1_GetInterventionPreExecutionSummaryResponse>;
  /**
   * GetInterventionQueryExecutionDetail retrieves the latest query execution detail
   * for an intervention, including the executed query string and its current execution status.
   */
  instacart_massops_v1_MassOpsService_GetInterventionQueryExecutionDetail?: Maybe<Instacart_Massops_V1_GetInterventionQueryExecutionDetailResponse>;
  /**
   * GetInterventionStatistics returns aggregate statistics about interventions
   * within the specified date range, including counts for each workflow state.
   */
  instacart_massops_v1_MassOpsService_GetInterventionStatistics?: Maybe<Instacart_Massops_V1_GetInterventionStatisticsResponse>;
  /**
   * GetInterventionType retrieves detailed information about a specific intervention type,
   * including its required task and intervention parameters.
   */
  instacart_massops_v1_MassOpsService_GetInterventionType?: Maybe<Instacart_Massops_V1_GetInterventionTypeResponse>;
  /**
   * GetInterventionTypeIdForIntervention retrieves the intervention type ID
   * for a given intervention UUID.
   */
  instacart_massops_v1_MassOpsService_GetInterventionTypeIdForIntervention?: Maybe<Instacart_Massops_V1_GetInterventionTypeIdForInterventionResponse>;
  /**
   * GetNotificationTemplate retrieves full details of a specific notification template
   * including all locale contents.
   */
  instacart_massops_v1_MassOpsService_GetNotificationTemplate?: Maybe<Instacart_Massops_V1_GetNotificationTemplateResponse>;
  /**
   * GetTotalFinancialImpact returns the current aggregated financial impact total
   * across interventions within the specified filter (e.g., date range). This reflects actual
   * realized impact from completed tasks, not pre-execution estimates.
   */
  instacart_massops_v1_MassOpsService_GetTotalFinancialImpact?: Maybe<Instacart_Massops_V1_GetTotalFinancialImpactResponse>;
  /**
   * ListInterventionApprovalRequests returns a list of approval requests for a specific intervention.
   * Supports filtering by active status to show current or historical approval requests.
   */
  instacart_massops_v1_MassOpsService_ListInterventionApprovalRequests?: Maybe<Instacart_Massops_V1_ListInterventionApprovalRequestsResponse>;
  /**
   * ListInterventionBundles returns a paginated list of intervention bundles,
   * optionally filtered by creator, state, or intervention type.
   */
  instacart_massops_v1_MassOpsService_ListInterventionBundles?: Maybe<Instacart_Massops_V1_ListInterventionBundlesResponse>;
  /**
   * ListInterventionQueryTemplates returns the available query templates
   * for each intervention type, sourced from the plugin registry. No I/O is performed.
   */
  instacart_massops_v1_MassOpsService_ListInterventionQueryTemplates?: Maybe<Instacart_Massops_V1_ListInterventionQueryTemplatesResponse>;
  /**
   * ListInterventionTemplateVariables returns the template variable names that operators may use
   * in Communication Settings for a given intervention. The allowlist is intervention-specific
   * and includes any extra_contact_user_variables defined in the intervention's params.
   */
  instacart_massops_v1_MassOpsService_ListInterventionTemplateVariables?: Maybe<Instacart_Massops_V1_ListInterventionTemplateVariablesResponse>;
  /**
   * ListInterventionTypes returns all available intervention types that can be used
   * to create new interventions. Each type defines the required parameters and behavior.
   */
  instacart_massops_v1_MassOpsService_ListInterventionTypes?: Maybe<Instacart_Massops_V1_ListInterventionTypesResponse>;
  /**
   * ListInterventions returns a paginated list of all interventions in the system,
   * including their current state and execution metadata.
   */
  instacart_massops_v1_MassOpsService_ListInterventions?: Maybe<Instacart_Massops_V1_ListInterventionsResponse>;
  /**
   * ListNotificationTemplates returns a list of available notification templates
   * for customer communication in interventions.
   */
  instacart_massops_v1_MassOpsService_ListNotificationTemplates?: Maybe<Instacart_Massops_V1_ListNotificationTemplatesResponse>;
  /**
   * ListTasks returns a paginated list of all tasks associated with a specific intervention.
   * Each task represents an individual operation to be performed.
   */
  instacart_massops_v1_MassOpsService_ListTasks?: Maybe<Instacart_Massops_V1_ListTasksResponse>;
  /**
   * ListTemplateVariables returns all supported template variables.
   * Variables are global and can be used in any notification template.
   */
  instacart_massops_v1_MassOpsService_ListTemplateVariables?: Maybe<Instacart_Massops_V1_ListTemplateVariablesResponse>;
  /**
   * PreviewInterventionData returns the first 10 rows of CSV data uploaded for an intervention.
   * This provides a quick preview of the data without needing to download the entire file.
   */
  instacart_massops_v1_MassOpsService_PreviewInterventionData?: Maybe<Instacart_Massops_V1_PreviewInterventionDataResponse>;
  /** Return distinct values for one or more dimensions */
  instacart_medusa_v1_MedusaService_GetDimensionValues?: Maybe<Instacart_Medusa_V1_GetDimensionValuesResponse>;
  /** Retrieves a change approval request by its ID */
  instacart_partners_data_ingestion_v1_ChangeApprovalService_GetChangeApprovalRequest?: Maybe<Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestResponse>;
  /** Get CSV validation result by ID */
  instacart_partners_partners_v1_FileService_GetCsvValidationResult?: Maybe<Instacart_Partners_Partners_V1_GetCsvValidationResultResponse>;
  /** Main dashboard matrix view: paginated enrollments with feature statuses */
  instacart_partners_partners_v1_FlipService_GetFlipDashboard?: Maybe<Instacart_Partners_Partners_V1_GetFlipDashboardResponse>;
  /** Single enrollment detail with full feature groups and items */
  instacart_partners_partners_v1_FlipService_GetFlipEnrollmentDetail?: Maybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailResponse>;
  /** Paginated enrollments with site metadata (no feature matrix) */
  instacart_partners_partners_v1_FlipService_GetFlipEnrollments?: Maybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentsResponse>;
  /** Feature group catalog for dashboard organization */
  instacart_partners_partners_v1_FlipService_GetFlipFeatureGroups?: Maybe<Instacart_Partners_Partners_V1_GetFlipFeatureGroupsResponse>;
  /** Feature catalog for filter dropdowns and column configuration */
  instacart_partners_partners_v1_FlipService_GetFlipFeatures?: Maybe<Instacart_Partners_Partners_V1_GetFlipFeaturesResponse>;
  /** Get the full edit history of a note (all versions from root to latest) */
  instacart_partners_partners_v1_FlipService_GetFlipNoteHistory?: Maybe<Instacart_Partners_Partners_V1_GetFlipNoteHistoryResponse>;
  /** List all notes for a site × feature intersection (feed order) */
  instacart_partners_partners_v1_FlipService_ListFlipNotes?: Maybe<Instacart_Partners_Partners_V1_ListFlipNotesResponse>;
  /** Get a single WhitelabelApp by ID. */
  instacart_partners_partners_v1_MobileAppsManagementService_GetWhitelabelApp?: Maybe<Instacart_Partners_Partners_V1_GetWhitelabelAppResponse>;
  /** Get, filter, and paginate WhitelabelApps. */
  instacart_partners_partners_v1_MobileAppsManagementService_GetWhitelabelApps?: Maybe<Instacart_Partners_Partners_V1_GetWhitelabelAppsResponse>;
  /** Bulk fetch partner configuration types; supports filtering by configurable type (e.g. RetailerLocation) */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurationTypesPaginated?: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedResponse>;
  /**
   * Bulk look up by configuration type. Look up a single configuration for multiple entities like WHL or WH IDs
   * Does not have `Bulk` in the method name even though it should have, and it's too late to change as it's been live since early 2024
   */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurations?: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsResponse>;
  /**
   * Bulk look up by configuration type for composite keys
   * This is used for hierarchical configurations
   * Fields loaded are: id, configurable_id, configurable_type, and setting
   */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurationsByCompositeKey?: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsByCompositeKeyResponse>;
  /** Paginated bulk look up configurations */
  instacart_partners_partners_v1_PartnerConfigurationsService_GetPartnerConfigurationsPaginated?: Maybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedResponse>;
  /** List sandbox whitelabel sites associated with a retailer */
  instacart_partners_partners_v1_SandboxService_ListSandboxWhitelabelSitesByRetailer?: Maybe<Instacart_Partners_Partners_V1_ListSandboxWhitelabelSitesByRetailerResponse>;
  /**
   * List sandbox whitelabel sites associated with a partner (all sandboxes
   * under the partner's retailers).
   */
  instacart_partners_partners_v1_SandboxService_ListSandboxesWhitelabelSitesByPartner?: Maybe<Instacart_Partners_Partners_V1_ListSandboxesWhitelabelSitesByPartnerResponse>;
  /** GetAutomations */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetAutomations?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetAutomationsResponse>;
  /** GetConnections */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetConnections?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetConnectionsResponse>;
  /** GetStores */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetStores?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetStoresResponse>;
  /** GetSyncStrategies */
  instacart_retailer_os_shelf_labels_admin_v1_ShelfLabelsAdminService_GetSyncStrategies?: Maybe<Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetSyncStrategiesResponse>;
  instacart_retailer_tools_growth_targeting_v1_GrowthTargetingToolingService_GetTargetingFeatures?: Maybe<Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesResponse>;
  /** fetches detailed entitlement data for a single entitlement */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetEntitlementDetails?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsResponse>;
  /** fetches shallow entitlement data for many entitlements */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetEntitlements?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsResponse>;
  /** fetches detailed package data for a single package */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetPackageDetails?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsResponse>;
  /** fetches shallow package data for many packages */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetPackages?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesResponse>;
  /** fetches detailed entitlement profile data for a single retailer */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetRetailerEntitlementProfileDetails?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsResponse>;
  /** fetches shallow entitlement profile data for many retailers */
  instacart_retailer_tools_retailer_platform_api_v1_FeatureEntitlementsService_GetRetailerEntitlementProfiles?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_DownloadInsightsPortalCustomExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalCustomExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalCustomReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalFilterOptions?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_GetInsightsPortalMultiDimensionDataset?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_ListInsightsPortalCustomExports?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsResponse>;
  instacart_retailer_tools_v2_InsightsPortalService_ListInsightsPortalCustomReports?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsResponse>;
  instacart_retailers_v1_AppeasementsService_GetAppeasementsByUser?: Maybe<Instacart_Retailers_V1_GetAppeasementsByUserResponse>;
  instacart_retailers_v1_AppeasementsService_GetCreditsByUser?: Maybe<Instacart_Retailers_V1_GetCreditsByUserResponse>;
  instacart_retailers_v1_RetailersService_GetWidgetsConfig?: Maybe<Instacart_Retailers_V1_GetWidgetsConfigResponse>;
  instacart_retailers_v1_RetailersService_ValidateWidgetsConfig?: Maybe<Instacart_Retailers_V1_ValidateWidgetsConfigResponse>;
  instacart_retailers_v1_StoreConfigurationsService_GetStoreConfigurationsForRetailers?: Maybe<Instacart_Retailers_V1_StoreConfigurationsForRetailersResponse>;
  /** Get the specific version of a feature by its name */
  instacart_roulette_v1_RouletteService_GetFeatureByNameAndVersion?: Maybe<Instacart_Roulette_V1_GetFeatureByNameAndVersionResponse>;
  /** Retrieves all active features matching the given request criteria. */
  instacart_roulette_v1_RouletteService_ListFeatures?: Maybe<Instacart_Roulette_V1_GetFeaturesResponse>;
  /** Search Features */
  instacart_roulette_v1_RouletteService_SearchFeatures?: Maybe<Instacart_Roulette_V1_SearchFeaturesResponse>;
  /** GetIntegrationVersions */
  instacart_upos_config_v1_ConfigService_GetIntegrationVersions?: Maybe<Instacart_Upos_Config_V1_GetIntegrationVersionsResponse>;
  /** GetIntegrations */
  instacart_upos_config_v1_ConfigService_GetIntegrations?: Maybe<Instacart_Upos_Config_V1_GetIntegrationsResponse>;
  /** GetProfileVersions */
  instacart_upos_config_v1_ConfigService_GetProfileVersions?: Maybe<Instacart_Upos_Config_V1_GetProfileVersionsResponse>;
  /** GetProfiles */
  instacart_upos_config_v1_ConfigService_GetProfiles?: Maybe<Instacart_Upos_Config_V1_GetProfilesResponse>;
  /** GetRetailerVersions */
  instacart_upos_config_v1_ConfigService_GetRetailerVersions?: Maybe<Instacart_Upos_Config_V1_GetRetailerVersionsResponse>;
  /** GetRetailers */
  instacart_upos_config_v1_ConfigService_GetRetailers?: Maybe<Instacart_Upos_Config_V1_GetRetailersResponse>;
  /** GetStoreVersions */
  instacart_upos_config_v1_ConfigService_GetStoreVersions?: Maybe<Instacart_Upos_Config_V1_GetStoreVersionsResponse>;
  /** GetStores */
  instacart_upos_config_v1_ConfigService_GetStores?: Maybe<Instacart_Upos_Config_V1_GetStoresResponse>;
  /** Returns a list of statuses for every retailer location */
  instacart_upos_status_v1_StatusService_GetIntegrationStatuses?: Maybe<Instacart_Upos_Status_V1_GetIntegrationStatusesResponse>;
  /** Describe snowflake table's schema */
  instacart_waves_v1_WavesService_DescribeSnowflakeTable?: Maybe<Instacart_Waves_V1_DescribeSnowflakeTableResponse>;
  /** Fetches a pipeline alert config plus its child step thresholds. */
  instacart_waves_v1_WavesService_GetPipelineAlertConfig?: Maybe<Instacart_Waves_V1_GetPipelineAlertConfigResponse>;
  /** Gets a presigned S3 upload URL for CAMP input files */
  instacart_waves_v1_WavesService_GetPresignedUploadUrl?: Maybe<Instacart_Waves_V1_GetPresignedUploadUrlResponse>;
  /** Polls an async step preview by id. */
  instacart_waves_v1_WavesService_GetPreview?: Maybe<Instacart_Waves_V1_GetPreviewResponse>;
  /** Gets a specific step version by step_id and version number */
  instacart_waves_v1_WavesService_GetStepVersion?: Maybe<Instacart_Waves_V1_GetStepVersionResponse>;
  /** Gets paginated version history for a step */
  instacart_waves_v1_WavesService_GetStepVersionHistory?: Maybe<Instacart_Waves_V1_GetStepVersionHistoryResponse>;
  /** Returns the details about the specific workflow run */
  instacart_waves_v1_WavesService_GetWorkflowRun?: Maybe<Instacart_Waves_V1_GetWorkflowRunResponse>;
  /** Lists every distinct filter tag_name across all steps (global scope) */
  instacart_waves_v1_WavesService_ListAllStepFilterTags?: Maybe<Instacart_Waves_V1_ListAllStepFilterTagsResponse>;
  /** Lists step filter tags for a given step */
  instacart_waves_v1_WavesService_ListStepFilterTags?: Maybe<Instacart_Waves_V1_ListStepFilterTagsResponse>;
  /** Lists step runs with pagination */
  instacart_waves_v1_WavesService_ListStepRuns?: Maybe<Instacart_Waves_V1_ListStepRunsResponse>;
  /** Lists step versions with optional filters */
  instacart_waves_v1_WavesService_ListStepVersions?: Maybe<Instacart_Waves_V1_ListStepVersionsResponse>;
  /** Lists steps with optional filters */
  instacart_waves_v1_WavesService_ListSteps?: Maybe<Instacart_Waves_V1_ListStepsResponse>;
  /** Returns a list of workflow runs by pipeline step id */
  instacart_waves_v1_WavesService_ListWorkflowRuns?: Maybe<Instacart_Waves_V1_ListWorkflowRunsResponse>;
  /** Returns a bounded preview of the rows a SELECT query returns. */
  instacart_waves_v1_WavesService_PreviewSnowflakeQuery?: Maybe<Instacart_Waves_V1_PreviewSnowflakeQueryResponse>;
  /** Substring-search Totem Systems for the pipeline-create form `totem_system` typeahead picker. */
  instacart_waves_v1_WavesService_SearchTotemSystems?: Maybe<Instacart_Waves_V1_SearchTotemSystemsResponse>;
  /**
   * Validates step attributes without persisting and returns structured
   * per-field validation errors when invalid. Read-only counterpart to
   * CreateNewStepVersion.
   */
  instacart_waves_v1_WavesService_ValidateStepAttributes?: Maybe<Instacart_Waves_V1_ValidateStepAttributesResponse>;
  inventoryIntelligenceServiceGetAcknowledgedOosIds?: Maybe<GetAcknowledgedOosIdsResponse>;
  inventoryIntelligenceServiceGetAisleRestockItems?: Maybe<GetAisleRestockItemsResponse>;
  inventoryIntelligenceServiceGetAisleRestockRecommendationSummaryList?: Maybe<GetAisleRestockRecommendationSummaryListResponse>;
  inventoryIntelligenceServiceGetAisleRestockSummary?: Maybe<GetAisleRestockSummaryResponse>;
  inventoryIntelligenceServiceGetAisleRestockSummaryList?: Maybe<GetAisleRestockSummaryListResponse>;
  inventoryIntelligenceServiceGetChronicInsights?: Maybe<GetChronicInsightsResponse>;
  inventoryIntelligenceServiceGetChronicOverordering?: Maybe<GetChronicOverorderingResponse>;
  inventoryIntelligenceServiceGetChronicOverorderingItemDetail?: Maybe<GetChronicOverorderingItemDetailResponse>;
  inventoryIntelligenceServiceGetChronicUnderstockItemDetail?: Maybe<GetChronicUnderstockItemDetailResponse>;
  inventoryIntelligenceServiceGetChronicUnderstocks?: Maybe<GetChronicUnderstocksResponse>;
  inventoryIntelligenceServiceGetItemRestockRecommendation?: Maybe<GetItemRestockRecommendationResponse>;
  inventoryIntelligenceServiceGetItemRestockRecommendations?: Maybe<GetItemRestockRecommendationsResponse>;
  inventoryIntelligenceServiceGetKpi?: Maybe<GetKpiResponse>;
  inventoryIntelligenceServiceGetLiveInsights?: Maybe<GetLiveInsightsResponse>;
  inventoryIntelligenceServiceGetOverfacingItemDetail?: Maybe<GetOverfacingItemDetailResponse>;
  inventoryIntelligenceServiceGetOverfacingItems?: Maybe<GetOverfacingItemsResponse>;
  inventoryIntelligenceServiceGetRestockRankingList?: Maybe<GetRestockRankingListResponse>;
  inventoryIntelligenceServiceGetRetailerDepartments?: Maybe<GetRetailerDepartmentsResponse>;
  inventoryIntelligenceServiceGetShelfView?: Maybe<GetShelfViewResponse>;
  linkAutosuggestServiceListLinkAutosuggestionAdmin?: Maybe<ListLinkAutosuggestionAdminResponse>;
  /** Retrieve the size of the Braze Segment */
  marketingFeatureBrazeSegmentSize: MarketingFeatureTypesBrazeSegmentSize;
  /** Retrieve a list of available braze segments for the retailer */
  marketingFeatureBrazeSegments: Array<MarketingFeatureTypesBrazeSegment>;
  /** Fetches the status of a marketing campaign */
  marketingFeatureCampaignStatus: MarketingFeatureTypesCampaignStatus;
  /** Fetches an email template */
  marketingFeatureTemplate: MarketingFeatureTypesTemplate;
  /** Retrieves a list of email templates */
  marketingFeatureTemplateSearch: Array<MarketingFeatureTypesTemplate>;
  /** Fetch a signed url for a single S3 report */
  normalizedReportSignedUrl: NormalizedReportsNormalizedReportSignedUrl;
  /** Fetch a list of S3 report types */
  normalizedReportTypes: Array<NormalizedReportsReportType>;
  /** Fetch a list of S3 reports */
  normalizedReportsSearch: NormalizedReportsNormalizedReportConnection;
  /** Fetch list of notification channels for the current account */
  notificationChannelsForCurrentAccount: Array<NotificationsNotificationChannel>;
  /** Fetch list of notifications for the current account */
  notifications: NotificationsNotificationConnection;
  /** Get mobile app config */
  onboardingMobileAppConfig: OnboardingFeatureTypesMobileAppConfig;
  onboardingServiceCheckLaunchOnboardingProgressByPartner?: Maybe<CheckLaunchOnboardingProgressByPartnerResponse>;
  onboardingServiceGetApprovalRequests?: Maybe<GetApprovalRequestsResponse>;
  onboardingServiceGetBuildkiteArtifactDownloadUrl?: Maybe<GetBuildkiteArtifactDownloadUrlResponse>;
  onboardingServiceGetBuildkiteArtifacts?: Maybe<GetBuildkiteArtifactsResponse>;
  onboardingServiceGetCatalogFaqFile?: Maybe<GetCatalogFaqFileResponse>;
  onboardingServiceGetFormGroups?: Maybe<GetFormGroupsResponse>;
  onboardingServiceGetLaunchOnboarding?: Maybe<GetLaunchOnboardingResponse>;
  onboardingServiceGetLaunchOnboardingWarehouseLocations?: Maybe<GetLaunchOnboardingWarehouseLocationsResponse>;
  onboardingServiceGetOnboarding?: Maybe<GetOnboardingResponse>;
  onboardingServiceGetOnboardingAttributes?: Maybe<GetOnboardingAttributesResponse>;
  onboardingServiceGetSignupPartner?: Maybe<GetSignupPartnerResponse>;
  onboardingServiceGetTestCases?: Maybe<GetTestCasesResponse>;
  onboardingServiceGetWaterfallEffect?: Maybe<GetWaterfallEffectResponse>;
  onboardingServiceGetWaterfallEffects?: Maybe<GetWaterfallEffectsResponse>;
  onboardingServiceGetWhitelabelGumloopWorkflowResults?: Maybe<GetWhitelabelGumloopWorkflowResultsResponse>;
  onboardingServiceGetWhitelabelSiteTestRunBuild?: Maybe<GetWhitelabelSiteTestRunBuildResponse>;
  onboardingServiceGetWhitelabelSiteTestRuns?: Maybe<GetWhitelabelSiteTestRunsResponse>;
  onboardingServiceGetWhitelabelSites?: Maybe<GetWhitelabelSitesResponse>;
  onboardingServiceGetWhitelabelSitesAdmin?: Maybe<GetWhitelabelSitesAdminResponse>;
  onboardingServiceListPbiStoreConfigurations?: Maybe<ListPbiStoreConfigurationsResponse>;
  onboardingServiceSearchWhitelabelSiteCustomizableString?: Maybe<SearchWhitelabelSiteCustomizableStringResponse>;
  /** Get workflow details */
  onboardingWorkflow: Array<OnboardingFeatureTypesWorkflow>;
  orderServiceGetDashboardOrder?: Maybe<GetDashboardOrderResponse>;
  orderServiceGetDashboardOrders?: Maybe<GetDashboardOrdersResponse>;
  orderServiceGetOrder?: Maybe<GetOrderResponse>;
  orderServiceGetOrderLocation?: Maybe<GetOrderLocationResponse>;
  orderServiceGetOrderStateChanges?: Maybe<GetOrderStateChangesResponse>;
  /** Fetch Types of Order Sources for a given retailer */
  orderSources: OrderSources;
  /** Fetch a specific partner by id */
  partner: Partner;
  /** Fetch a specific partner pick device by id */
  partnerPickDevice: PartnerPickDevicesDevice;
  /** Fetch list of partner pick devices */
  partnerPickDeviceSearch: PartnerPickDevicesDeviceSearch;
  /** Fetch capacity recommendations for a given retailer location and date */
  partnerPickGetCapacityRecommendations: PartnerPickCapacityGetCapacityRecommendationsResponse;
  /** Check if recurring_shift being created will conflict with existing shifts */
  partnerPickRecurringShiftConflictCheck: PartnerPickRecurringShiftsConflict;
  /** Search for partners (and its warehouses) matching a set of criteria. Returns a set of partners */
  partnerRetailerSearch: PartnerConnection;
  /** Search for partners matching a set of criteria */
  partnerSearch: PartnerConnection;
  /** Search for partners matching a set of criteria - returns an array instead of a connection type */
  partnerSearchArray: Array<Partner>;
  /** Fetches multiple partners by their ids */
  partners: Array<Partner>;
  /** Fetches the list of permissions available for the current user */
  permissions: Array<Permission>;
  /** Retrieve pickup retailer location groups that belong to a specific retailer */
  pickupRetailerLocationGroup: Array<RetailersPickupRetailerLocationGroup>;
  /** True if the given path_glob would match the given preview_path */
  previewNoticeBannerMatch: Scalars['Boolean'];
  privacyServiceGetPiiRequestsForRetailer?: Maybe<GetPiiRequestsForRetailerResponse>;
  productDataServiceGetProductData?: Maybe<GetProductDataResponse>;
  productSourceServiceGetProductSources?: Maybe<GetProductSourcesResponse>;
  productsServiceGetFlattenedTaxonomies?: Maybe<GetFlattenedTaxonomiesResponse>;
  productsServiceGetLegacyElasticsearch?: Maybe<LegacyElasticsearchResponse>;
  productsServiceGetLegacyItemsShoppers?: Maybe<LegacyItemsTyped>;
  productsServiceGetLegacyProducts?: Maybe<LegacyProducts>;
  productsServiceGetManagedAttributeValuesForRetailer?: Maybe<GetManagedAttributeValuesForRetailerResponse>;
  productsServiceSearchBrands?: Maybe<SearchBrandsResponse>;
  /** Fetch aggregated Quality Scorecard metrics per tool */
  qualityScorecardsAggScorecards: QualityScorecardsAggScorecardsResponse;
  /** Fetch aggregated platform-wide statistics from RUM data */
  qualityScorecardsPlatformStats: QualityScorecardsPlatformStats;
  /** Retrieve a list of reports requested by the retailer */
  reportRequests: ReportsReportRequestConnection;
  /** Retrieve a report view by report view id */
  reportView: ReportViewsInterface;
  /** Retrieve a list of available reports to request */
  reports: Array<ReportsReport>;
  /** Resolve pasted emails / canonical ids plus filters into accounts the caller can access. */
  resolveUserSelection: BulkAccountManagementTypesResolveUserSelectionPayload;
  /** Fetch a specific retailer by id */
  retailer: Retailer;
  retailerAislesGetRetailerAisleTemplate?: Maybe<GetRetailerAisleTemplateResponse>;
  retailerAislesGetRetailerLocationByLayout?: Maybe<GetRetailerLocationByLayoutResponse>;
  retailerCampaignServiceGetMoment?: Maybe<GetMomentResponse>;
  retailerCampaignServiceGetMomentParticipatingRetailers?: Maybe<GetMomentParticipatingRetailersResponse>;
  retailerCampaignServiceGetMoments?: Maybe<GetMomentsResponse>;
  retailerCampaignServiceGetRetailerCampaign?: Maybe<RetailerCampaignResponse>;
  retailerCampaignServiceListMoments?: Maybe<ListMomentsResponse>;
  retailerCampaignServiceListRetailerCampaignTreatments?: Maybe<ListRetailerCampaignTreatmentsResponse>;
  retailerCampaignServiceListRetailerCampaigns?: Maybe<ListRetailerCampaignsResponse>;
  /** Fetch a specific retailer location by id */
  retailerLocation: RetailerLocation;
  /** Retrieve a retailer location group by id */
  retailerLocationGroup: RetailersRetailerLocationGroup;
  /** Retrieve multiple retailer location groups by their IDs */
  retailerLocationGroupsByIds: Array<RetailersRetailerLocationGroup>;
  /** Retrieve retailer location groups that belong to a specific retailer */
  retailerLocationGroupsByRetailer: RetailersRetailerLocationGroupConnection;
  /** Search for retailer locations matching a set of criteria */
  retailerLocationSearch: RetailerLocationConnection;
  /** Search for retailer locations matching a set of criteria - returns an array instead of a connection type */
  retailerLocationSearchArray: Array<RetailerLocation>;
  retailerManagementServiceGetClientConfigurationById?: Maybe<GetClientConfigurationByIdResponse>;
  retailerManagementServiceGetConnectRetailerCallbackConfigurationById?: Maybe<GetConnectRetailerCallbackConfigurationByIdResponse>;
  retailerManagementServiceGetConnectRetailerCallbackConfigurations?: Maybe<GetConnectRetailerCallbackConfigurationsResponse>;
  retailerManagementServiceGetPartnerOauthApplications?: Maybe<GetPartnerOauthApplicationsResponse>;
  /** Fetch a Retailer's MFA configuration settings by id */
  retailerMfaConfig: RetailerMfaConfig;
  /** Fetch pickup metadata for a retailer by its id */
  retailerPickupMetadata: RetailersRetailerPickupMetadata;
  retailerProductAttributeEditServiceGetAvailabilityScoreOverride?: Maybe<GetAvailabilityScoreOverrideResponse>;
  retailerProductAttributeEditServiceGetRetailerProductAssortment?: Maybe<GetRetailerProductAssortmentResponse>;
  /** Returns recent tool survey submissions for the current account. Used by the frontend to enforce display frequency rules across browser sessions (e.g., incognito windows where local storage is unavailable). */
  retailerSatisfactionSurveySubmissionFrequency: Array<RetailerSatisfactionSurveyTypesSubmissionRecord>;
  /** Search for retailers matching a set of criteria */
  retailerSearch: RetailerConnection;
  /** Search for retailers matching a set of criteria - returns an array instead of a connection type */
  retailerSearchArray: Array<Retailer>;
  retailerSettingServiceGetSetting?: Maybe<GetSettingResponse>;
  retailerSettingsServiceGetIsGrocer?: Maybe<GetIsGrocerResponse>;
  retailerSettingsServiceGetParkingSettings?: Maybe<GetParkingSettingsResponse>;
  retailerSettingsServiceGetPickupSettingsMetadata?: Maybe<GetPickupSettingsMetadataResponse>;
  retailerSettingsServiceGetStagingSettings?: Maybe<GetStagingSettingsResponse>;
  retailerSettingsServiceGetToteLabelsFile?: Maybe<GetToteLabelsFileResponse>;
  retailerStoreHoursGetConfirmedStoreHours?: Maybe<GetConfirmedStoreHoursResponse>;
  retailerStoreHoursGetRetailerHolidaysStatus?: Maybe<GetHolidaysStatusResponse>;
  retailerStoreHoursGetStoreHours?: Maybe<GetStoreHoursResponse>;
  retailerStoreHoursGetStoreHoursUpdateTasks?: Maybe<GetStoreHoursUpdateTasksResponse>;
  retailerToolsServiceGetCustomersContext?: Maybe<GetCustomersContextResponse>;
  retailerToolsServiceGetItems?: Maybe<GetItemsResponse>;
  retailerToolsServiceGetRetailerProducts?: Maybe<GetRetailerProductsResponse>;
  retailerToolsServiceGetVirtualRetailers?: Maybe<GetVirtualRetailersResponse>;
  retailersServiceGetPlatformVersions?: Maybe<GetPlatformVersionsResponse>;
  retailersServiceGetRetailerLocationsByLocationCodes?: Maybe<GetRetailerLocationsByLocationCodesResponse>;
  retailersServiceGetRetailerLocationsDetails?: Maybe<GetRetailerLocationsDetailsResponse>;
  retailersServiceGetRetailerRegions?: Maybe<GetRetailerRegionsResponse>;
  /** Fetch a single role by ID */
  roleFetch: EnterpriseRole;
  /** Search for roles */
  roleSearch: Array<EnterpriseRole>;
  rppBulkImageUploadsServiceGetImageUploadBatchDetails?: Maybe<GetImageUploadBatchDetailsResponse>;
  rppBulkImageUploadsServiceGetImageUploadBatches?: Maybe<GetImageUploadBatchesResponse>;
  /** List saved views for the current account and feature context, ordered by name */
  savedViewsList: Array<SavedViewsTypesViewType>;
  serviceOptionServiceGetServiceOptions?: Maybe<GetServiceOptionsResponse>;
  /** Fetch Store Configuration by Id */
  storeConfigurationById: InstacartStoreConfiguration;
  /** Fetch list of Store Configurations by Partner/Retailer IDs */
  storeConfigurationsByPartnerId: Array<InstacartStoreConfiguration>;
  /** Fetch list of Store Configurations by Partner/Retailer IDs */
  storeConfigurationsByRetailerIds: Array<InstacartStoreConfiguration>;
  storeConfigurationsDraftServiceGetStoreConfigurationDrafts?: Maybe<GetStoreConfigurationDraftsResponse>;
  storeConfigurationsDraftServiceReadLatestStoreConfigurationDraft?: Maybe<ReadLatestStoreConfigurationDraftResponse>;
  storeConfigurationsDraftServiceReadStoreConfiguration?: Maybe<ReadStoreConfigurationResponse>;
  storePerformanceServiceGetAggregatedStorePerformance?: Maybe<StorePerformanceResponse>;
  /** Fetch a storefront placement by id */
  storefrontPlacement: ContentManagementStorefrontPlacement;
  /** Fetch a list of storefront placements */
  storefrontPlacementSearch: ContentManagementStorefrontPlacementConnection;
  /** Fetch taxonomy nodes */
  taxonomyNodes: Array<CatalogTaxonomyNode>;
  /** Get the roles, partners, and retailers assigned to an account */
  userAccessSettings: EnterpriseUserAccessSettings;
  userSettingServiceListUserSettings?: Maybe<ListUserSettingsResponse>;
  usersServiceBatchGetUsersByIdsStrict?: Maybe<BatchGetUsersByIdsStrictResponse>;
  usersServiceGetAutocompleteLocations?: Maybe<GetAutocompleteLocationsResponse>;
  usersServiceGetPlaceDetails?: Maybe<GetPlaceDetailsResponse>;
  usersServiceGetUserByIdFilteredByIsolationContext?: Maybe<UserResponse>;
  usersServiceGetUsersByStoreConfigurationId?: Maybe<GetUsersByStoreConfigurationIdResponse>;
  usersServiceListUsersByPersonalIdentifiersStrict?: Maybe<ListUsersByPersonalIdentifiersStrictResponse>;
  valueBasedOverrideServiceGetValueBasedOverrides?: Maybe<GetValueBasedOverridesResponse>;
  /** Fetch visibility conditions */
  visibilityConditionSearch: Array<VisibilityCondition>;
  /** Returns a WelcomeModal that should be shown to current user */
  welcomeModal: EnterpriseWelcomeModal;
  /** Find progress of wizard for given partner/retailer/location and type */
  wizardProgress?: Maybe<WizardsWizardProgress>;
};


export type QueryAuth0PermissionManagementService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_ListAccountsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListAccountsRequest_Input>;
};


export type QueryAuth0PermissionManagementStagingService_Instacart_Caper_Admin_V1_Auth0PermissionManagementService_ListAccountsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListAccountsRequest_Input>;
};


export type QueryCaperBanListManagementService_Instacart_Caper_Admin_V1_BanListManagementService_ListBanEntriesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBanEntriesRequest_Input>;
};


export type QueryCaperBanListManagementStagingService_Instacart_Caper_Admin_V1_BanListManagementService_ListBanEntriesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBanEntriesRequest_Input>;
};


export type QueryCaperBarcodePluMappingService_Instacart_Caper_Admin_V1_BarcodePluMappingService_ListBarcodePluMappingsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBarcodePluMappingsRequest_Input>;
};


export type QueryCaperBillingService_DownloadUploadArgs = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  retailerId: Scalars['String'];
  uploadId: Scalars['UUID'];
  uploadType: CaperBillingService_UploadType;
};


export type QueryCaperBillingService_GetCsvTemplateArgs = {
  type: CaperBillingService_CsvTemplateType;
};


export type QueryCaperBillingService_GetRunDetailArgs = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  retailerId: Scalars['String'];
  runId: Scalars['UUID'];
};


export type QueryCaperBillingService_ListRunsArgs = {
  billingPeriod: Scalars['CaperBillingService_BillingPeriod'];
  cursor?: InputMaybe<Scalars['String']>;
  retailerId: Scalars['String'];
  status?: InputMaybe<CaperBillingService_RunStatus>;
};


export type QueryCaperBillingService_ListUploadsArgs = {
  from: Scalars['CaperBillingService_BillingPeriod'];
  retailerId: Scalars['String'];
  to: Scalars['CaperBillingService_BillingPeriod'];
};


export type QueryCaperConfigCleanupReportService_Instacart_Caper_Admin_V1_ConfigCleanupReportService_GetConfigCleanupReportArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetConfigCleanupReportRequest_Input']>;
};


export type QueryCaperConfigCleanupReportService_Instacart_Caper_Admin_V1_ConfigFeatureDriftReportService_GetConfigFeatureDriftReportArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetConfigFeatureDriftReportRequest_Input']>;
};


export type QueryCaperConfigCleanupReportStagingService_Instacart_Caper_Admin_V1_ConfigCleanupReportService_GetConfigCleanupReportArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetConfigCleanupReportRequest_Input']>;
};


export type QueryCaperConfigCleanupReportStagingService_Instacart_Caper_Admin_V1_ConfigFeatureDriftReportService_GetConfigFeatureDriftReportArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetConfigFeatureDriftReportRequest_Input']>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_GetAllEntitiesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAllEntitiesRequest_Input']>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_GetConfigKeysArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetConfigKeysRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_GetFeaturesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetFeaturesRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ListBatchScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ListNotificationGroupsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListNotificationGroupsRequest_Input>;
};


export type QueryCaperConfigManagementService_Instacart_Caper_Admin_V1_ConfigManagementService_ListScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_GetAllEntitiesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAllEntitiesRequest_Input']>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_GetConfigKeysArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetConfigKeysRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_GetFeaturesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetFeaturesRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ListBatchScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListBatchScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ListNotificationGroupsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListNotificationGroupsRequest_Input>;
};


export type QueryCaperConfigManagementStagingService_Instacart_Caper_Admin_V1_ConfigManagementService_ListScheduledActionsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListScheduledActionsRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ConfigManagementService_GetAllEntitiesBasicArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetAllEntitiesBasicRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ConfigManagementService_GetEntitiesDetailsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetEntitiesDetailsRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ConfigManagementService_SearchEntitiesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_SearchEntitiesRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_CscSnapshotService_GetCscSnapshotArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetCscSnapshotRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_CscSnapshotService_ListCscSnapshotsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ListCscSnapshotsRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_GetExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetExperimentRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_ListExperimentHistoryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ListExperimentHistoryRequest_Input>;
};


export type QueryCaperConfigManagementV2Service_Instacart_Caper_Admin_V2_ExperimentService_ListExperimentsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ListExperimentsRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ConfigManagementService_GetAllEntitiesBasicArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetAllEntitiesBasicRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ConfigManagementService_GetEntitiesDetailsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetEntitiesDetailsRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ConfigManagementService_SearchEntitiesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_SearchEntitiesRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_CscSnapshotService_GetCscSnapshotArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetCscSnapshotRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_CscSnapshotService_ListCscSnapshotsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ListCscSnapshotsRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_GetExperimentArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_GetExperimentRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_ListExperimentHistoryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ListExperimentHistoryRequest_Input>;
};


export type QueryCaperConfigManagementV2StagingService_Instacart_Caper_Admin_V2_ExperimentService_ListExperimentsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V2_ListExperimentsRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_GetPipelineRunArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetPipelineRunRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_ListPipelineRunsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListPipelineRunsRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineStagingService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_GetPipelineRunArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetPipelineRunRequest_Input>;
};


export type QueryCaperDeviceProvisioningPipelineStagingService_Instacart_Caper_Admin_V1_DeviceProvisioningPipelineService_ListPipelineRunsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListPipelineRunsRequest_Input>;
};


export type QueryCaperIppReceiptService_Instacart_Caper_Admin_V1_IppReceiptService_GetReceiptDetailsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetReceiptDetailsRequest_Input>;
};


export type QueryCaperIppReceiptService_Instacart_Caper_Admin_V1_IppReceiptService_GetReceiptsListArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetReceiptsListRequest_Input>;
};


export type QueryCaperIppReceiptService_Instacart_Caper_Admin_V1_IppReceiptService_GetReceiptsMetadataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetReceiptsMetadataRequest_Input>;
};


export type QueryCaperIppStoreStaffBarcodeService_Instacart_Caper_Admin_V1_IppStoreStaffBarcodeService_GetStoreStaffBarcodeArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetStoreStaffBarcodeRequest_Input>;
};


export type QueryCaperIppStoreStaffBarcodeService_Instacart_Caper_Admin_V1_IppStoreStaffBarcodeService_ListStoreStaffBarcodesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListStoreStaffBarcodesRequest_Input>;
};


export type QueryCaperIppStoreStaffBarcodeService_Instacart_Caper_Admin_V1_IppStoreStaffBarcodeService_ListStoresByWarehouseLocationsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListStoresByWarehouseLocationsRequest_Input>;
};


export type QueryCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_GetEntitiesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetEntitiesRequest_Input>;
};


export type QueryCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_GetNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetNofRequest_Input>;
};


export type QueryCaperNofManagementService_Instacart_Caper_Admin_V1_NofManagementService_ListNofsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListNofsRequest_Input>;
};


export type QueryCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_GetEntitiesArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetEntitiesRequest_Input>;
};


export type QueryCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_GetNofArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetNofRequest_Input>;
};


export type QueryCaperNofManagementStagingService_Instacart_Caper_Admin_V1_NofManagementService_ListNofsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_ListNofsRequest_Input>;
};


export type QueryCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_GetAvailableProfilesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAvailableProfilesRequest_Input']>;
};


export type QueryCaperPaymentTerminalService_Instacart_Caper_Admin_V1_PaymentTerminalService_GetStorePaymentInfoArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetStorePaymentInfoRequest_Input>;
};


export type QueryCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_GetAvailableProfilesArgs = {
  input?: InputMaybe<Scalars['instacart_caper_admin_v1_GetAvailableProfilesRequest_Input']>;
};


export type QueryCaperPaymentTerminalStagingService_Instacart_Caper_Admin_V1_PaymentTerminalService_GetStorePaymentInfoArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetStorePaymentInfoRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetCartDataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetCartDataRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetDatadogSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionInfoArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionInfoRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionScreenshotsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryRequest_Input>;
};


export type QueryCaperSessionInfoService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetCartDataArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetCartDataRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetDatadogSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionInfoArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionInfoRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionScreenshotsArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionScreenshotsRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryRequest_Input>;
};


export type QueryCaperSessionInfoStagingService_Instacart_Caper_Admin_V1_SessionInfoService_GetSessionSummaryByIdAsyncArgs = {
  input?: InputMaybe<Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncRequest_Input>;
};


export type QueryCatalogPlatformApi_GetRetailerProductOverridesArgs = {
  product_id: Scalars['BigInt'];
  retailer_id: Scalars['Int'];
};


export type QueryCatalogPlatformApi_GetRetailerProductsArgs = {
  catalog_build_variant_id?: InputMaybe<Scalars['Int']>;
  locale_id?: InputMaybe<Scalars['Int']>;
  product_id: Scalars['BigInt'];
  retailer_id: Scalars['Int'];
  surface_id?: InputMaybe<Scalars['Int']>;
};


export type QueryContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_GetWorkflowResultArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultRequest_Input>;
};


export type QueryContentAiQaService_Instacart_Algorithms_Content_Ai_Qa_V1_AiQaService_GetWorkflowStatusArgs = {
  input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusRequest_Input>;
};


export type QueryEnterpriseStatusPage_GetIncidentArgs = {
  id: Scalars['UUID'];
  retailerId?: InputMaybe<Scalars['String']>;
};


export type QueryEnterpriseStatusPage_ListComponentsInGroupArgs = {
  groupId: Scalars['UUID'];
};


export type QueryEnterpriseStatusPage_ListIncidentsArgs = {
  limit?: InputMaybe<Scalars['PositiveInt']>;
  nextToken?: InputMaybe<Scalars['String']>;
  openOnly?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<EnterpriseStatusPage_IncidentStatus>;
};


export type QueryExternalHealthDashboard_GetMonitorStatusesArgs = {
  retailerId: Scalars['String'];
};


export type QueryExternalHealthDashboard_HandleAuthCallbackArgs = {
  code: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type QueryFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_GetResponseConfigArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigRequest_Input>;
};


export type QueryFulfillmentPartnerTesting_Instacart_Enterprise_Fulfillment_Partner_Testing_V1_FulfillmentPartnerTestingService_ListResponseConfigsArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_GetFulfillmentProviderArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_GetFulfillmentProviderPartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderPartnerConfigurationsRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_GetFulfillmentRuleConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentRuleConfigurationsRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_GetFulfillmentStrategyArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentStrategyRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_ListFulfillmentRulesConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentRulesConfigurationsRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_ListFulfillmentStrategiesArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentStrategiesRequest_Input>;
};


export type QueryFulfillmentRuleEngine_Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentConstraintsService_ValidateFulfillmentRuleConfigurationsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidateFulfillmentRuleConfigurationsRequest_Input>;
};


export type QueryGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_GetStringsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_GetStringsRequest_Input>;
};


export type QueryGarnishService_Instacart_Customers_Commerce_Garnish_V1_GarnishService_ListResourcesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Input>;
};


export type QueryMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_GetMarketingCampaignArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignRequest_Input>;
};


export type QueryMarketingToolingService_Instacart_Growth_Marketing_Tooling_V1_MarketingToolingService_ListMarketingCampaignsArgs = {
  input?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ListMarketingCampaignsRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetAllowedActionsByRecipeIdArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Permissions_V1_GetAllowedActionsByRecipeIdRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetEligibleAttributesArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetEligibleAttributesRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetPublisherArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetPublisherByLegacyContentCreatorIdArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherByLegacyContentCreatorIdRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetRecipeArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetRecipeIdBySparkRecipeIdArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeIdBySparkRecipeIdRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetShoppableProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetShoppableProductsRequest_Input>;
};


export type QueryMealsRetrievalService_Instacart_Customers_Meals_Services_Retrieval_V1_MealsRetrievalService_GetSparkRecipeIdsByRecipeIdArgs = {
  input?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetSparkRecipeIdsByRecipeIdRequest_Input>;
};


export type QueryRetailerContactManagement_GetContactArgs = {
  email: Scalars['EmailAddress'];
  retailerId: Scalars['String'];
};


export type QueryRetailerContactManagement_GetContactsArgs = {
  domain?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['PositiveInt']>;
  retailerId: Scalars['String'];
};


export type QueryRetailerContactManagement_GetPartnerContactArgs = {
  email: Scalars['EmailAddress'];
  partnerId: Scalars['String'];
};


export type QueryRetailerContactManagement_GetPartnerContactsArgs = {
  domain?: InputMaybe<Scalars['String']>;
  partnerId: Scalars['String'];
  priority?: InputMaybe<Scalars['PositiveInt']>;
};


export type QueryUnifiedMarketingBackendService_Instacart_Growth_Unified_Marketing_Backend_V1_UnifiedMarketingBackendService_GetCampaignBriefArgs = {
  input?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_GetCampaignBriefRequest_Input>;
};


export type QueryUnifiedMarketingBackendService_Instacart_Growth_Unified_Marketing_Backend_V1_UnifiedMarketingBackendService_ListCampaignBriefsArgs = {
  input?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_ListCampaignBriefsRequest_Input>;
};


export type QueryAccountRequestPreviousRequestExistByEmailArgs = {
  email: Scalars['String'];
};


export type QueryAccountRequestSearchByIdArgs = {
  accountRequestId: Scalars['ID'];
};


export type QueryAccountTokenValidateArgs = {
  rawToken: Scalars['String'];
  tokenType: TokenTypeEnum;
};


export type QueryActiveNoticeBannersArgs = {
  partnerId?: InputMaybe<Scalars['Int']>;
  path: Scalars['String'];
  warehouseId?: InputMaybe<Scalars['Int']>;
};


export type QueryAdminNoticeBannerArgs = {
  id: Scalars['Int'];
};


export type QueryAnomalyDetectionSummaryArgs = {
  filters?: InputMaybe<AnomalyDetectionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<AnomalyDetectionSortField>;
  userUuid?: InputMaybe<Scalars['String']>;
};


export type QueryApiIntegrationsServiceGetApiSettingsArgs = {
  input?: InputMaybe<GetApiSettingsRequestInput>;
};


export type QueryApiIntegrationsServiceGetAuthenticationUrlArgs = {
  input?: InputMaybe<GetAuthenticationUrlRequestInput>;
};


export type QueryApiIntegrationsServiceGetAvailableStoreLocationsArgs = {
  input?: InputMaybe<GetAvailableStoreLocationsRequestInput>;
};


export type QueryApprovalsManagementGetApproverListsArgs = {
  approvalGroupKeys?: InputMaybe<Array<Scalars['String']>>;
  arIds: Array<Scalars['ID']>;
};


export type QueryApprovalsManagementGetRequestArgs = {
  arId: Scalars['ID'];
};


export type QueryApprovalsManagementGetSnapshotsArgs = {
  snapshotIds: Array<Scalars['ID']>;
};


export type QueryApprovalsManagementGetUserPermittedActionsArgs = {
  approvalRequestIds: Array<Scalars['ID']>;
};


export type QueryApprovalsManagementListRequestsArgs = {
  affectingScopeSearch?: InputMaybe<AffectingScopeSearchInput>;
  contentSearches?: InputMaybe<Array<ContentSearchInput>>;
  ilikeName?: InputMaybe<Scalars['String']>;
  includesStates?: InputMaybe<Array<ApprovalRequestState>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryAssignmentsGetOrderFulfillmentOverviewArgs = {
  input?: InputMaybe<GetOrderFulfillmentOverviewRequestInput>;
};


export type QueryAuditLogSearchArgs = {
  accountEmails?: InputMaybe<Array<Scalars['String']>>;
  accountUuids?: InputMaybe<Array<Scalars['ID']>>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  entityIds?: InputMaybe<Array<Scalars['ID']>>;
  entityType?: InputMaybe<AuditLogEntityTypeEnum>;
  eventName?: InputMaybe<Scalars['String']>;
  eventTimeEndAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventTimeStartAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryAvailabilityGetStoreHoursByDateArgs = {
  input?: InputMaybe<GetStoreHoursByDateRequestInput>;
};


export type QueryAvailabilityGetStoreHoursByDayOfWeekArgs = {
  input?: InputMaybe<GetStoreHoursByDayOfWeekRequestInput>;
};


export type QueryAvailabilityGetStoreHoursByZoneRetailerArgs = {
  input?: InputMaybe<GetStoreHoursByZoneRetailerRequestInput>;
};


export type QueryBuildRowsFromAuditLogEntriesArgs = {
  entryIds: Array<Scalars['ID']>;
  target: AuditReplayTarget;
};


export type QueryBulkAuditLogArgs = {
  filter?: InputMaybe<AuditLogFilter>;
  page?: InputMaybe<PageInput>;
};


export type QueryBulkOperationArgs = {
  operationId: Scalars['ID'];
};


export type QueryBulkOperationsArgs = {
  filter?: InputMaybe<BulkOperationFilter>;
  page?: InputMaybe<PageInput>;
};


export type QueryCatalogAisleArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogDepartmentArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogProblemTrackerServiceGetTicketArgs = {
  input?: InputMaybe<GetTicketRequestInput>;
};


export type QueryCatalogProblemTrackerServiceListTicketsArgs = {
  input?: InputMaybe<ListTicketsRequestInput>;
};


export type QueryCatalogProductsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryCatalogRetailerProductArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogRetailerProductSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  aisleIds?: InputMaybe<Array<Scalars['ID']>>;
  available?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  localeCode?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  searchLimit?: InputMaybe<Scalars['Int']>;
  searchTerm: Scalars['String'];
  searchType: Scalars['String'];
};


export type QueryCatalogSearchDownloadSignedUrlArgs = {
  s3Key: Scalars['String'];
};


export type QueryCatalogToolsApiServiceDownloadCatalogSearchResultsArgs = {
  input?: InputMaybe<DownloadCatalogSearchResultsRequestInput>;
};


export type QueryCatalogToolsApiServiceGetAnomalousItemsListArgs = {
  input?: InputMaybe<GetAnomalousItemsListRequestInput>;
};


export type QueryCatalogToolsApiServiceGetAnomalousItemsReportArgs = {
  input?: InputMaybe<GetAnomalousItemsReportRequestInput>;
};


export type QueryCatalogToolsApiServiceGetLocalesByRetailerArgs = {
  input?: InputMaybe<GetLocalesByRetailerRequestInput>;
};


export type QueryCatalogToolsApiServiceGetManagedAttributeArgs = {
  input?: InputMaybe<GetManagedAttributeRequestInput>;
};


export type QueryCatalogToolsApiServiceGetMassOpsIntegrationStatusArgs = {
  input?: InputMaybe<GetMassOpsIntegrationStatusRequestInput>;
};


export type QueryCatalogToolsApiServiceGetPriceInvestigationArgs = {
  input?: InputMaybe<GetPriceInvestigationRequestInput>;
};


export type QueryCatalogToolsApiServiceGetProductCreationDataArgs = {
  input?: InputMaybe<GetProductCreationDataRequestInput>;
};


export type QueryCatalogToolsApiServiceGetRetailerProductAttributeSourcesArgs = {
  input?: InputMaybe<GetRetailerProductAttributeSourcesRequestInput>;
};


export type QueryCatalogToolsApiServiceGetRetailerProductDataArgs = {
  input?: InputMaybe<GetRetailerProductDataRequestInput>;
};


export type QueryCatalogToolsApiServiceGetRetailerSurfacesArgs = {
  input?: InputMaybe<GetRetailerSurfacesRequestInput>;
};


export type QueryCatalogToolsApiServiceGetSentinelMemberArgs = {
  input?: InputMaybe<GetSentinelMemberRequestInput>;
};


export type QueryCatalogToolsApiServiceListMemberVersionsArgs = {
  input?: InputMaybe<ListMemberVersionsRequestInput>;
};


export type QueryCatalogToolsApiServiceListPriceInvestigationsArgs = {
  input?: InputMaybe<ListPriceInvestigationsRequestInput>;
};


export type QueryCatalogToolsApiServiceListSentinelMembersArgs = {
  input?: InputMaybe<ListSentinelMembersRequestInput>;
};


export type QueryCatalogToolsApiServiceSearchManagedAttributesArgs = {
  input?: InputMaybe<SearchManagedAttributesRequestInput>;
};


export type QueryCollectionsServiceGetCollectionsArgs = {
  input?: InputMaybe<GetCollectionsRequestInput>;
};


export type QueryCommerceInvoicingServiceGetOrderDiscountDetailsArgs = {
  input?: InputMaybe<GetOrderDiscountDetailsRequestInput>;
};


export type QueryConfigurableItemsServiceGetRppConfigurableItemsArgs = {
  input?: InputMaybe<GetRppConfigurableItemsRequestInput>;
};


export type QueryConnectPlatformServiceGetConnectPlatformEventsByDomainArgs = {
  input?: InputMaybe<GetConnectPlatformEventsByDomainRequestInput>;
};


export type QueryConnectPlatformServiceGetConnectSettingsArgs = {
  input?: InputMaybe<GetConnectSettingsRequestInput>;
};


export type QueryConnectPlatformServiceGetPartnerApiKeysArgs = {
  input?: InputMaybe<GetPartnerApiKeysRequestInput>;
};


export type QueryConnectPlatformServiceGetPartnerIdArgs = {
  input?: InputMaybe<GetPartnerIdRequestInput>;
};


export type QueryConnectPlatformServiceGetRequestContextsArgs = {
  input?: InputMaybe<GetRequestContextsRequestInput>;
};


export type QueryContentManagementAdminServiceGetAdminNavigationV2Args = {
  input?: InputMaybe<GetAdminNavigationV2RequestInput>;
};


export type QueryContentManagementAdminServiceGetAvailableOfferFiltersArgs = {
  input?: InputMaybe<GetAvailableOfferFiltersRequestInput>;
};


export type QueryContentManagementAdminServiceGetFrothTemplateArgs = {
  input?: InputMaybe<GetFrothTemplateRequestInput>;
};


export type QueryContentManagementAdminServiceGetFrothTemplateConstraintsArgs = {
  input?: InputMaybe<GetFrothTemplateConstraintsRequestInput>;
};


export type QueryContentManagementAdminServiceGetFrothTemplateVersionArgs = {
  input?: InputMaybe<GetFrothTemplateVersionRequestInput>;
};


export type QueryContentManagementAdminServiceGetNativeTabBarNavigationArgs = {
  input?: InputMaybe<GetNativeTabBarNavigationRequestInput>;
};


export type QueryContentManagementAdminServiceGetNavigationArgs = {
  input?: InputMaybe<GetNavigationRequestInput>;
};


export type QueryContentManagementAdminServiceGetPlacementContentByIdArgs = {
  input?: InputMaybe<GetPlacementContentByIdRequestInput>;
};


export type QueryContentManagementAdminServiceGetRetailersForShortcutsArgs = {
  input?: InputMaybe<GetRetailersForShortcutsRequestInput>;
};


export type QueryContentManagementAdminServiceGetSlotByIdArgs = {
  input?: InputMaybe<GetSlotByIdRequestInput>;
};


export type QueryContentManagementAdminServiceGetSlotsArgs = {
  input?: InputMaybe<GetSlotsRequestInput>;
};


export type QueryContentManagementAdminServiceGetSlotsByContentPagesArgs = {
  input?: InputMaybe<GetSlotsByContentPagesRequestInput>;
};


export type QueryContentManagementAdminServiceGetSocialIconsNavigationArgs = {
  input?: InputMaybe<GetSocialIconsNavigationRequestInput>;
};


export type QueryContentManagementAdminServiceGetToolingShortcutsArgs = {
  input?: InputMaybe<GetToolingShortcutsRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPageAnchorsArgs = {
  input?: InputMaybe<ListContentPageAnchorsRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPageSlotAreasArgs = {
  input?: InputMaybe<ListContentPageSlotAreasRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPageVersionMetasArgs = {
  input?: InputMaybe<ListContentPageVersionMetasRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPageVersionsArgs = {
  input?: InputMaybe<ListContentPageVersionsRequestInput>;
};


export type QueryContentManagementAdminServiceListContentPagesV2Args = {
  input?: InputMaybe<ListContentPagesRequestV2Input>;
};


export type QueryContentManagementAdminServiceListDeletedContentPagesArgs = {
  input?: InputMaybe<ListDeletedContentPagesRequestInput>;
};


export type QueryContentManagementAdminServiceListFrothTemplateVersionsArgs = {
  input?: InputMaybe<ListFrothTemplateVersionsRequestInput>;
};


export type QueryContentManagementAdminServiceListFrothTemplatesArgs = {
  input?: InputMaybe<ListFrothTemplatesRequestInput>;
};


export type QueryContentManagementAdminServiceListPlacementContentArgs = {
  input?: InputMaybe<ListPlacementContentRequestInput>;
};


export type QueryContentManagementAdminServiceListPublishedFrothTemplatesArgs = {
  input?: InputMaybe<ListPublishedFrothTemplatesRequestInput>;
};


export type QueryContentManagementServiceGetLayoutVariantsArgs = {
  input?: InputMaybe<GetLayoutVariantsRequestInput>;
};


export type QueryContentManagementServiceGetPlacementsArgs = {
  input?: InputMaybe<GetPlacementsRequestInput>;
};


export type QueryContentManagementServiceGetThemePageArgs = {
  input?: InputMaybe<GetThemePageRequestInput>;
};


export type QueryContentManagementServiceListThemePagesArgs = {
  input?: InputMaybe<ListThemePagesRequestInput>;
};


export type QueryCurrentEnterpriseAccountAuthorizationCheckArgs = {
  accountFeatureToggles?: InputMaybe<Array<Scalars['String']>>;
  approvalRequestIds?: InputMaybe<Array<Scalars['ID']>>;
  featureEntitlementIds?: InputMaybe<Array<Scalars['ID']>>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  permissionsV2?: InputMaybe<Scalars['PermissionsInput']>;
  requireAllPartnersFullAccess?: InputMaybe<Scalars['Boolean']>;
  requireFullPartnerAccess?: InputMaybe<Scalars['Boolean']>;
  requireFullRetailerAccess?: InputMaybe<Scalars['Boolean']>;
  requireWriteAccess?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  storeConfigIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryCustomersOrdersServiceGetHandlingDetailsArgs = {
  input?: InputMaybe<CustomersGetHandlingDetailsRequestInput>;
};


export type QueryCustomersOrdersServiceGetOrderArgs = {
  input?: InputMaybe<CustomersGetOrderRequestInput>;
};


export type QueryCustomersOrdersServiceGetOrderAmountsSummaryV0Args = {
  input?: InputMaybe<CustomersGetOrderAmountsSummaryV0RequestInput>;
};


export type QueryCustomersOrdersServiceGetPaymentMethodSummaryArgs = {
  input?: InputMaybe<CustomersGetPaymentMethodSummaryRequestInput>;
};


export type QueryCustomersOrdersServiceListOrdersArgs = {
  input?: InputMaybe<CustomersListOrdersRequestInput>;
};


export type QueryCustomersOrdersServiceQueryOrderReferenceArgs = {
  input?: InputMaybe<CustomersQueryOrderReferenceRequestInput>;
};


export type QueryCustomersOrdersServiceQueryOrdersArgs = {
  input?: InputMaybe<CustomersQueryOrdersRequestInput>;
};


export type QueryDemeterServiceGetAuditBatchArgs = {
  input?: InputMaybe<GetAuditBatchRequestInput>;
};


export type QueryDemeterServiceGetAuditBatchMetadataArgs = {
  input?: InputMaybe<GetAuditBatchMetadataRequestInput>;
};


export type QueryDemeterServiceGetAuditTaskArgs = {
  input?: InputMaybe<GetAuditTaskRequestInput>;
};


export type QueryDemeterServiceGetAuditWorkflowConfigsArgs = {
  input?: InputMaybe<GetAuditWorkflowConfigsRequestInput>;
};


export type QueryDemeterServiceGetDetectionArgs = {
  input?: InputMaybe<GetDetectionRequestInput>;
};


export type QueryDemeterServiceGetNextAuditBatchArgs = {
  input?: InputMaybe<GetNextAuditBatchRequestInput>;
};


export type QueryDemeterServiceListAuditBatchesArgs = {
  input?: InputMaybe<ListAuditBatchesRequestInput>;
};


export type QueryDemeterServiceListAuditTaskComponentsArgs = {
  input?: InputMaybe<ListAuditTaskComponentsRequestInput>;
};


export type QueryDemeterServiceListAuditWorkflowsArgs = {
  input?: InputMaybe<ListAuditWorkflowsRequestInput>;
};


export type QueryDemeterServiceListDetectionsArgs = {
  input?: InputMaybe<ListDetectionsRequestInput>;
};


export type QueryDemeterServicePrepareToSubmitAuditBatchArgs = {
  input?: InputMaybe<PrepareToSubmitAuditBatchRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetBrandProfileAttributesArgs = {
  input?: InputMaybe<BrandProfileAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetBrandProfileSellSheetCardsArgs = {
  input?: InputMaybe<BrandProfileSellSheetCardsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetBrandSellSheetsAttributesArgs = {
  input?: InputMaybe<BrandSellSheetsAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetEbpAnalyticsArgs = {
  input?: InputMaybe<EbpAnalyticsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetEbpProductAnalyticsSummaryArgs = {
  input?: InputMaybe<ProductAnalyticSummaryRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetEbpProductAttributesArgs = {
  input?: InputMaybe<ProductAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetIndexBrandNamesArgs = {
  input?: InputMaybe<IndexBrandNamesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetIndexEbpCategoriesArgs = {
  input?: InputMaybe<IndexEbpCategoriesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetIndexSellSheetCardsArgs = {
  input?: InputMaybe<SellSheetCardsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetProductBrandProfileAttributesArgs = {
  input?: InputMaybe<ProductBrandProfileAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetProductSellSheetCardsArgs = {
  input?: InputMaybe<ProductSellSheetCardsRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetAnalyticsSummaryArgs = {
  input?: InputMaybe<SellSheetAnalyticsSummaryRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetAttributesArgs = {
  input?: InputMaybe<SellSheetAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetBrandProfileAttributesArgs = {
  input?: InputMaybe<SellSheetBrandProfileAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetProductsAttributesArgs = {
  input?: InputMaybe<SellSheetProductsAttributesRequestInput>;
};


export type QueryEmergingBrandPortalServiceGetSellSheetProductsSummaryTraitsArgs = {
  input?: InputMaybe<SellSheetProductsSummaryTraitsRequestInput>;
};


export type QueryEnterpriseAccountArgs = {
  canonicalId?: InputMaybe<Scalars['ID']>;
};


export type QueryEnterpriseAccountSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  canonicalIds?: InputMaybe<Array<Scalars['ID']>>;
  email?: InputMaybe<Scalars['String']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']>;
  excludeOutsourcerUsers?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
  searchQuery?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<AccountSortEnum>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  status?: InputMaybe<AccountStatusEnum>;
};


export type QueryEvaluateMyClaimsArgs = {
  evaluations: Array<ClaimEvaluationInput>;
};


export type QueryFeatureToggleFullyEnabledArgs = {
  featureName: Scalars['String'];
};


export type QueryHealthCheckArgs = {
  metricsToken?: InputMaybe<Scalars['String']>;
};


export type QueryHistoricalStorePerformanceServiceGetAggregatedHistoricalStorePerformanceArgs = {
  input?: InputMaybe<HistoricalStorePerformanceRequestInput>;
};


export type QueryHomePlacementSearchArgs = {
  filter?: InputMaybe<PlacementFilterInput>;
  placementId?: InputMaybe<Scalars['ID']>;
  sort?: InputMaybe<PlacementSortInput>;
};


export type QueryInsightsPortalAuthorizationCheckArgs = {
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  permissions?: InputMaybe<Array<Scalars['String']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetAllSegmentDefinitionsArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetAllSegmentDefinitionsRequest_Input>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetExactAudienceSizeArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetExactAudienceSizeRequest_Input>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetSegmentDefinitionArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetSegmentDefinitionRequest_Input>;
};


export type QueryInstacart_Ads_Platform_Taas_V1_SegmentRegistryService_GetSegmentSizeArgs = {
  input?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetSegmentSizeRequest_Input>;
};


export type QueryInstacart_Ads_V3_EmergingBrandPortalService_GetIndexBrandNamesArgs = {
  input?: InputMaybe<Instacart_Ads_V3_IndexBrandNamesRequest_Input>;
};


export type QueryInstacart_Ads_V3_EmergingBrandPortalService_GetProductAdditionalInfoArgs = {
  input?: InputMaybe<Instacart_Ads_V3_ProductAdditionalInfoRequest_Input>;
};


export type QueryInstacart_Ads_V3_RetailerBlockedAdsService_GetRetailerBlockedAdIdsArgs = {
  input?: InputMaybe<Instacart_Ads_V3_GetRetailerBlockedAdIdsRequest_Input>;
};


export type QueryInstacart_Ads_V3_RetailerReviewToolService_GetDisplayPreviewDataArgs = {
  input?: InputMaybe<Instacart_Ads_V3_GetDisplayPreviewDataRequest_Input>;
};


export type QueryInstacart_Ads_V3_RetailerReviewToolService_GetDisplayPreviewDataBySha256Args = {
  input?: InputMaybe<Instacart_Ads_V3_GetDisplayPreviewDataRequest_Input>;
};


export type QueryInstacart_Algorithms_Ai_Carousel_Creator_V1_AiCarouselCreatorService_GetSimilarCarouselsArgs = {
  input?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_AppeasementsService_GetAppeasementValueGrantPolicyIdArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetAppeasementValueGrantPolicyIdRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_AppeasementsService_ListOrderResolutionsAndAppeasementsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListOrderResolutionsAndAppeasementsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_AppeasementsService_ListUserResolutionsAndAppeasementsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListUserResolutionsAndAppeasementsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_BannersService_ListBannersArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListBannersRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_CheckAdminRefundEligibilityArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_CheckAdminRefundEligibilityRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_FindRelatedUsersArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_FindRelatedUsersRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_FindUsersArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_FindUsersRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetActiveBenefitsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetActiveBenefitsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetCommonIdentityUsersArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetCommonIdentityUsersRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetCustomerSpendingSummaryArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetCustomerSpendingSummaryRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetCustomerSpendingSummaryV2Args = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetCustomerSpendingSummaryV2Request_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetHouseholdByUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetHouseholdByUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetInstacartPlusMembershipArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetInstacartPlusMembershipRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetLatestActiveAttributeForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetLifetimeSavingsForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetLifetimeSavingsForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetLinkedUserAccountsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetLinkedUserAccountsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderByIdArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderByIdRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderByIdBasicArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderByIdBasicRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderCountsByRetailerArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderCountsByRetailerRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderReturnArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderReturnRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetOrderReturnEligibilityArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetOrderReturnEligibilityRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_GetUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_GetUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListActiveAttributesByCountryArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListActiveAttributesByCountryRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListAddressesForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListAddressesForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListAdminMoveOrAddChargesPaymentInstrumentsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListAdminMoveOrAddChargesPaymentInstrumentsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListChargeLogsForOrderDeliveryArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListChargeLogsForOrderDeliveryRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListNotesForUserArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListNotesForUserRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListOrderChatMessagesAndNotesArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListOrdersByCustomerArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByCustomerRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListOrdersByRetailerArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListRestaurantOrdersByCustomerArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListUserShopperBanReasonsArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListUserShopperBanReasonsRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ListUserShopperBansArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ListUserShopperBansRequest_Input>;
};


export type QueryInstacart_Care_Tools_V1_CareToolsService_ValidateSalesforceCaseArgs = {
  input?: InputMaybe<Instacart_Care_Tools_V1_ValidateSalesforceCaseRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetAuditReviewArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetAuditReviewsWithFeedbackArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetNextAuditReviewArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetNextAuditReviewRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_GetWorkflowMetadataArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataRequest_Input>;
};


export type QueryInstacart_Cashflow_Nutella_V1_NutellaService_ListAuditReviewSiblingsArgs = {
  input?: InputMaybe<Instacart_Cashflow_Nutella_V1_ListAuditReviewSiblingsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetL2CategoriesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetL2CategoriesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetMissingCodesForcemarkDetailsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetMissingCodesForcemarksArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MissingCodesForcemarkService_GetMissingCodesReviewedForcemarksArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MlPriceAnomalyService_GetMlPriceAnomalyProductDetailsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_MlPriceAnomalyService_GetMlPriceAnomalyProductsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetPriceAlertProductDetailsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetPriceAlertProductsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetPriceAlertProductsCategoriesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetRetailerDiscountInitialThresholdsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_RetailerDiscountThresholdService_GetRetailerDiscountThresholdsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_SourcePriorityService_GetImpactAnalysisArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetImpactAnalysisRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_SourcePriorityService_GetSourcePriorityFilterOptionsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetSourcePriorityFilterOptionsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_SourcePriorityService_GetSourcePriorityRuleArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_GetSourcePriorityRuleRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_SourcePriorityService_ListChangeRequestsArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_ListChangeRequestsRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_SourcePriorityService_ListSourcePriorityRulesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_ListSourcePriorityRulesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_TaxonomyService_SearchTaxonomyNodesArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_SearchTaxonomyNodesRequest_Input>;
};


export type QueryInstacart_Catalog_Admin_V1_TempOverrideService_ListArgs = {
  input?: InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideServiceListRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_DescribeSnowflakeTableArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetPresignedUploadUrlArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetStepRunResultsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetStepRunResultsRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetStepVersionArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetStepVersionRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_GetStepVersionHistoryArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_GetStepVersionHistoryRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_ListStepRunsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_ListStepRunsRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_ListStepVersionsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_ListStepVersionsRequest_Input>;
};


export type QueryInstacart_Catalog_Catflow_V1_CatflowApi_ListStepsArgs = {
  input?: InputMaybe<Instacart_Catalog_Catflow_V1_ListStepsRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_GetBatchArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_GetBatchRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_GetBatchStatusArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_GetBatchStatusRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_GetBridgeArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_GetBridgeRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_ListBatchesArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ListBatchesRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_ListBridgesArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ListBridgesRequest_Input>;
};


export type QueryInstacart_Catalog_Data_Bridge_V1_DataBridgeService_ListSchemaVersionsArgs = {
  input?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ListSchemaVersionsRequest_Input>;
};


export type QueryInstacart_Catalog_Health_V1_CatalogHealthService_GetProductCountsArgs = {
  input?: InputMaybe<Instacart_Catalog_Health_V1_GetProductCountsRequest_Input>;
};


export type QueryInstacart_Checkout_V1_PosDataService_GetTenderTransactionsByWhlIdsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsRequest_Input>;
};


export type QueryInstacart_Communications_V2_Communications_GetEmailBodyDownloadUrlArgs = {
  input?: InputMaybe<Instacart_Communications_V2_GetEmailBodyDownloadUrlRequest_Input>;
};


export type QueryInstacart_Communications_V2_Communications_GetNotificationsArgs = {
  input?: InputMaybe<Instacart_Communications_V2_GetNotificationsRequest_Input>;
};


export type QueryInstacart_Customers_Basket_Products_Orchestrators_V1_BasketProductsOrchestratorsService_GetBasketProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramContentByProgramIdArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramOfferArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_GetBusinessProgramOffersByProgramIdArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_ListBusinessProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_Input>;
};


export type QueryInstacart_Customers_Business_Admin_V1_BusinessAdminService_ListBusinessesArgs = {
  input?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_Input>;
};


export type QueryInstacart_Customers_Business_V1_BusinessService_GetBusinessProgramContentArgs = {
  input?: InputMaybe<Instacart_Customers_Business_V1_GetBusinessProgramContentRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetBucketDownloadUrlArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetBucketUploadUrlArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetBucketUploadUrlRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetCsvFoundEntriesCountArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetCsvProcessingSummaryArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetGroupedSlotsArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_GetMarketingAgentCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_ListMarketingAgentCampaignsArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsRequest_Input>;
};


export type QueryInstacart_Customers_Campaigns_V1_CampaignsService_ValidateMarketingAgentScheduleArgs = {
  input?: InputMaybe<Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleRequest_Input>;
};


export type QueryInstacart_Customers_Carts_V1_CartsService_GetActiveCartIdForUserArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_GetActiveCartIdForUserRequest_Input>;
};


export type QueryInstacart_Customers_Carts_V1_CartsService_GetCartBasketTotalsArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_GetCartBasketTotalsRequest_Input>;
};


export type QueryInstacart_Customers_Carts_V1_CartsService_GetCartItemCollectionsArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_GetCartItemCollectionsRequest_Input>;
};


export type QueryInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_GetDelegatedCheckoutLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_GetDelegatedCheckoutLinkRequest_Input>;
};


export type QueryInstacart_Customers_Carts_V1_DelegatedCheckoutLinkService_ListDelegatedCheckoutLinksArgs = {
  input?: InputMaybe<Instacart_Customers_Carts_V1_ListDelegatedCheckoutLinksRequest_Input>;
};


export type QueryInstacart_Customers_Commerce_Coupons_V1_CommerceCouponsService_GetRedemptionCodeExistsArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsRequest_Input>;
};


export type QueryInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_GetValueGrantPolicyArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyRequest_Input>;
};


export type QueryInstacart_Customers_Commerce_Discount_V1_CommerceDiscountService_GetValueGrantPolicyFacadeArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeRequest_Input>;
};


export type QueryInstacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CommerceStoredValueService_GetAvailableCreditsBalancesArgs = {
  input?: InputMaybe<Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_GetAvailableCreditsBalancesRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_CouponsDomainService_GetCouponCodeExistsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetCouponCodeExistsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetCampaignLinksArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetCampaignLinksRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetMomentArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetMomentRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetMomentParticipatingRetailersArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetMomentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetMomentsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_GetRetailerCampaignArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_GetRetailerCampaignRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_ListMomentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_ListMomentsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_ListRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsRequest_Input>;
};


export type QueryInstacart_Customers_Coupons_V1_RetailerCampaignService_ListRetailerCampaignsArgs = {
  input?: InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_Input>;
};


export type QueryInstacart_Customers_Express_V1_ExpressService_GetCurrentExpressMemberStatusForUserArgs = {
  input?: InputMaybe<Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserRequest_Input>;
};


export type QueryInstacart_Customers_Express_V1_ExpressService_GetLatestActiveOrInactiveSubscriptionForUserArgs = {
  input?: InputMaybe<Instacart_Customers_Express_V1_GetLatestActiveOrInactiveSubscriptionForUserRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunDebugArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunImageArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_GetRuleSetRunStatusArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_ListRuleSetRunStatusesArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_ListRuleSetRunsArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsRequest_Input>;
};


export type QueryInstacart_Customers_Flyer_Pdf_V1_FlyerPdfService_ValidateRuleSetArgs = {
  input?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetRequest_Input>;
};


export type QueryInstacart_Customers_Gifting_V1_GiftOrderDigitalCardService_GetGiftOrderDigitalCardByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_GetLoyaltyBenefitsArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_GetLoyaltyCardValidationsArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_Admin_V1_LoyaltyAdminService_GetLoyaltyProgramArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_V1_LoyaltyService_GetLoyaltyCardsByCardNumberArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberRequest_Input>;
};


export type QueryInstacart_Customers_Loyalty_V1_LoyaltyService_GetLoyaltyCardsForUserArgs = {
  input?: InputMaybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Input>;
};


export type QueryInstacart_Customers_Offers_Tooling_Orchestrator_V1_OffersToolingService_PrepareCreateOfferPayloadArgs = {
  input?: InputMaybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadRequest_Input>;
};


export type QueryInstacart_Customers_Orders_V1_OrdersService_GetOrderLinesArgs = {
  input?: InputMaybe<Instacart_Customers_Orders_V1_GetOrderLinesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetCountriesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetCountriesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetPartnersArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetPartnersRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetPostalCodesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetPostalCodesByZonesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRegionsArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRegionsRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailerLocationsArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailerLocationsByRetailerArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailerZonesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerZonesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetRetailersArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailersRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetZonesArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesRequest_Input>;
};


export type QueryInstacart_Customers_Partners_V1_PartnersService_GetZonesByRegionArgs = {
  input?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesByRegionRequest_Input>;
};


export type QueryInstacart_Customers_Partnership_Offer_V1_PartnershipOfferService_GetPartnershipManagementUrlDownloadLinkArgs = {
  input?: InputMaybe<Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkRequest_Input>;
};


export type QueryInstacart_Customers_Partnership_Offer_V1_PartnershipOfferService_ListPartnershipManagementUrlsArgs = {
  input?: InputMaybe<Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_ProductRetrievalService_GetLegacyProductsWithFiltersArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_GetAggregatedItemDataArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_GetItemsArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_GetRetailerProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Input>;
};


export type QueryInstacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerToolsProductRetrievalService_SearchRetailerBrandsArgs = {
  input?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetCategoriesByNameArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetCategoriesByNameRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetCoreIngredientsArgs = {
  input?: InputMaybe<Scalars['instacart_customers_recipes_v1_GetCoreIngredientsRequest_Input']>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetRecipeByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetRecipeByIdRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetRecipeByIdForDashboardArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetRecipeByIdRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_GetRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_GetRecipesRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_ListRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesRequest_Input>;
};


export type QueryInstacart_Customers_Recipes_V1_RecipesService_ValidateAndUploadRecipesArgs = {
  input?: InputMaybe<Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_CheckBulkEditStatusArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerActivitiesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerClickableAreasArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerMetadataArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerPageEditPresignedUrlArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPageEditPresignedUrlRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerPipelineDebugArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerPresignedUrlsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerStatsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerTagsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_GetFlyerUploadDetailsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_FlyerService_ListFlyersArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetCollectionPreviewProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetCollectionRulesArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetFeaturedCollectionProductPreviewArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionProductPreviewRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetFeaturedCollectionSetArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionSetRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetLowerPriceDefinitionsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetNavigationTreeArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_GetRetailerCsvArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListActiveFeaturedCollectionSetsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListActiveFeaturedCollectionSetsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListCollectionProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListCollectionsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListFeaturedCollectionSetsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFeaturedCollectionSetsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListGlobalCollectionsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ListRetailerDepartmentsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_SearchCollectionProductsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Collections_Admin_V1_RetailerCollectionsAdminService_ValidateCollectionSlugArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_GetIppDraftByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftManagementService_ListIppDraftsArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftPreviewService_GetIppPreviewByTokenArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_IppDraftPreviewService_GetPreviewAuthTokenArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenRequest_Input>;
};


export type QueryInstacart_Customers_Retailer_Management_V1_WidgetConfigurationService_GetWidgetConfigurationArgs = {
  input?: InputMaybe<Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationRequest_Input>;
};


export type QueryInstacart_Customers_Retailers_Orchestrator_V1_RetailersService_GetShopCollectionArgs = {
  input?: InputMaybe<Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionRequest_Input>;
};


export type QueryInstacart_Customers_Search_Results_V2_SearchResultsService_GetProductEsciLabelArgs = {
  input?: InputMaybe<Instacart_Customers_Search_Results_V2_GetProductEsciLabelRequest_Input>;
};


export type QueryInstacart_Customers_Search_V1_SearchService_GetSearchTermOverridesArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesRequest_Input>;
};


export type QueryInstacart_Customers_Search_V1_SearchService_GetSearchTermOverridesByIdArgs = {
  input?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesByIdRequest_Input>;
};


export type QueryInstacart_Customers_Value_Grant_V1_ValueGrantService_GetStoredValueAndDiscountsArgs = {
  input?: InputMaybe<Instacart_Customers_Value_Grant_V1_GetStoredValueAndDiscountsRequest_Input>;
};


export type QueryInstacart_Customers_Value_Grant_V1_ValueGrantService_GetStoredValueTransactionHistoryArgs = {
  input?: InputMaybe<Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryRequest_Input>;
};


export type QueryInstacart_Enterprise_Boba_Core_Offers_V1_OfferService_GetOrderDiscountInfoArgs = {
  input?: InputMaybe<Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurationsArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryConfigurationsListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryIssuesArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryIssuesRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryOrderOverviewArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRouteArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoutesService_GetPartnerBulkDeliveryRouteListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehiclesService_GetWarehouseLocationVehicleListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetDashboardOrderArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetDashboardOrderSearchResultListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOperationArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderAdjustmentPolicyListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderCancellationPolicyListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderLineListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderService_GetOrderStateChangeListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_DashboardUserService_GetDashboardUserSearchResultListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_EnterpriseServiceOptionService_GetEnterpriseServiceOptionListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Fulfillment_V1_RetailerProductDetailsService_GetRetailerProductDetailsArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Post_Checkout_V1_EnterpriseChatService_GetEnterpriseChatMessageListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_GetPartnerManagedShiftListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftsService_GetPartnerManagedShiftsWithEquipmentArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftsWithEquipmentRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShoppersService_GetPartnerManagedShopperListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_PartnerManagedStaffingService_GetStaffingHoursListByDateArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationsService_GetPresignedDownloadUrlArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationsService_GetShiftManagementOperationRecordArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationsService_GetShiftManagementOperationRecordListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListRequest_Input>;
};


export type QueryInstacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationService_GetStaffingAllocationListArgs = {
  input?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListRequest_Input>;
};


export type QueryInstacart_Enterprise_Fulfillment_Simulation_Engine_V1_OrderSimulationService_GetCheckoutStateAndBarcodeArgs = {
  input?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_GetChangeRequestArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_GetChangeRequestSamplePricesArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestSamplePricesRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_GetPartnerAlcoholMarkupProhibitedStatesArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_GetPartnerAlcoholMarkupProhibitedStatesRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_GetProductGroupArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_GetProductGroupRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_GetStoreGroupArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_GetStoreGroupRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListAdminMarkupPartnersArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupPartnersRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListAdminMarkupRulesArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupRulesRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListChangeRequestsArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListChangeRequestsRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListProductGroupsArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListProductGroupsRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListRulesArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListRulesRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListStoreGroupsArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListStoreGroupsRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ListStoresArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ListStoresRequest_Input>;
};


export type QueryInstacart_Eversight_Item_Price_Management_V1_ItemPriceManagementService_ValidateAndPrioritizeRulesArgs = {
  input?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ValidateAndPrioritizeRulesRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobDetailsArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobDetailsRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobResultsArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobResultsRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobSourcesArgs = {
  input?: InputMaybe<Scalars['instacart_flawless_inventory_v1_GetJobSourcesRequest_Input']>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobStatusArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobStatusRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetJobsArgs = {
  input?: InputMaybe<Instacart_Flawless_Inventory_V1_GetJobsRequest_Input>;
};


export type QueryInstacart_Flawless_Inventory_V1_MapleService_GetMapleSupportedModelsArgs = {
  input?: InputMaybe<Scalars['instacart_flawless_inventory_v1_GetMapleSupportedModelsRequest_Input']>;
};


export type QueryInstacart_Fulfillment_Domains_Picking_V1_PickingItem_GetPickingItemsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Domains_Picking_V1_GetPickingItemsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Domains_Transaction_Integrity_V1_TransactionIntegrityService_GetStepLogAuditMetricsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogAuditMetricsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Domains_Transaction_Integrity_V1_TransactionIntegrityService_GetStepLogsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Domains_Transaction_Integrity_V1_TransactionIntegrityService_GetStepTypesArgs = {
  input?: InputMaybe<Scalars['instacart_fulfillment_domains_transaction_integrity_v1_GetStepTypesRequest_Input']>;
};


export type QueryInstacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_ReceiptUnderstandingService_GetReceiptItemCatalogCandidatesArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_GetReceiptItemCatalogCandidatesRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Incentives_V1_IncentiveBudgetOverrideService_ListBudgetOverridesArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_ListBudgetOverridesRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Incentives_V1_IncentiveBudgetProjectionRunsService_ListProjectionBudgetsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_ListProjectionBudgetsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetAuditLogsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_AuditService_GetStepLogAuditsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsRequest_Input>;
};


export type QueryInstacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizationService_GetCategorizationAnalysisArgs = {
  input?: InputMaybe<Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisRequest_Input>;
};


export type QueryInstacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanService_ListUserShopperBanReasonsArgs = {
  input?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBanReasonsRequest_Input>;
};


export type QueryInstacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanService_ListUserShopperBansArgs = {
  input?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBansRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetCampaignStatusArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetEmailUnsubscribeListsArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetIntentionConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetRetailerConfigurationArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetSegmentSizeArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_GetTemplateArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_ListEditableTemplateVariablesArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_ListSegmentsArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsRequest_Input>;
};


export type QueryInstacart_Growth_Crm_Messaging_Service_V1_CrmMessagingService_ListTemplatesArgs = {
  input?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesRequest_Input>;
};


export type QueryInstacart_Infra_Instaform_V1_InstaformService_GetModuleByNameArgs = {
  input?: InputMaybe<Instacart_Infra_Instaform_V1_GetModuleByNameRequest_Input>;
};


export type QueryInstacart_Infra_Instaform_V1_InstaformService_GetModulesArgs = {
  input?: InputMaybe<Instacart_Infra_Instaform_V1_GetModulesRequest_Input>;
};


export type QueryInstacart_Infra_Totem_V1_TotemService_GetEntityArgs = {
  input?: InputMaybe<Instacart_Infra_Totem_V1_GetEntityRequest_Input>;
};


export type QueryInstacart_Infra_Totem_V1_TotemService_GetSystemArgs = {
  input?: InputMaybe<Instacart_Infra_Totem_V1_GetSystemRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_GetOpsEscalationRequestArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_ListBulkDuplicateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_ListDuplicateOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsRequest_Input>;
};


export type QueryInstacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequests_ListOpsEscalationRequestsArgs = {
  input?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_GetFulfillmentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_GetFulfillmentEventRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_GetFulfillmentEventsByIdArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_GetFulfillmentEventsByIdRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListChildFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ListChildFulfillmentEventsRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListCreatorsArgs = {
  input?: InputMaybe<Scalars['instacart_logistics_v1_ListCreatorsRequest_Input']>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListFulfillmentEventsArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ListFulfillmentEventsRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ListTagsArgs = {
  input?: InputMaybe<Scalars['instacart_logistics_v1_ListTagsRequest_Input']>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ValidateNewClosureEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ValidateNewClosureEventRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ValidateNewFulfillmentEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ValidateNewFulfillmentEventRequest_Input>;
};


export type QueryInstacart_Logistics_V1_FulfillmentEvents_ValidateNewRestrictedAvailabilityEventArgs = {
  input?: InputMaybe<Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_DownloadInterventionDataArgs = {
  input?: InputMaybe<Instacart_Massops_V1_DownloadInterventionDataRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_DownloadInterventionTasksCsvArgs = {
  input?: InputMaybe<Instacart_Massops_V1_DownloadInterventionTasksCsvRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_DownloadValidationFailuresArgs = {
  input?: InputMaybe<Instacart_Massops_V1_DownloadValidationFailuresRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetIncidentArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetIncidentRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionBundleArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionBundleRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCommunicationSettingsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCommunicationSettingsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCountsByArtifactTypeArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCountsByArtifactTypeRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCountsByIncidentArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCountsByIncidentRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionCountsByInterventionTypeArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionCountsByInterventionTypeRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionEmailContentUsageArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionEmailContentUsageRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionPreExecutionSummaryArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionPreExecutionSummaryRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionQueryExecutionDetailArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionQueryExecutionDetailRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionStatisticsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionStatisticsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionTypeArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionTypeRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetInterventionTypeIdForInterventionArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetInterventionTypeIdForInterventionRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetNotificationTemplateArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetNotificationTemplateRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_GetTotalFinancialImpactArgs = {
  input?: InputMaybe<Instacart_Massops_V1_GetTotalFinancialImpactRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionApprovalRequestsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionBundlesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionBundlesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionQueryTemplatesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionQueryTemplatesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionTemplateVariablesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionTemplateVariablesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionTypesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionTypesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListInterventionsArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListInterventionsRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListNotificationTemplatesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListNotificationTemplatesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListTasksArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListTasksRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_ListTemplateVariablesArgs = {
  input?: InputMaybe<Instacart_Massops_V1_ListTemplateVariablesRequest_Input>;
};


export type QueryInstacart_Massops_V1_MassOpsService_PreviewInterventionDataArgs = {
  input?: InputMaybe<Instacart_Massops_V1_PreviewInterventionDataRequest_Input>;
};


export type QueryInstacart_Medusa_V1_MedusaService_GetDimensionValuesArgs = {
  input?: InputMaybe<Instacart_Medusa_V1_GetDimensionValuesRequest_Input>;
};


export type QueryInstacart_Partners_Data_Ingestion_V1_ChangeApprovalService_GetChangeApprovalRequestArgs = {
  input?: InputMaybe<Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FileService_GetCsvValidationResultArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipDashboardArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipDashboardRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipEnrollmentDetailArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipEnrollmentsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipEnrollmentsRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipFeatureGroupsArgs = {
  input?: InputMaybe<Scalars['instacart_partners_partners_v1_GetFlipFeatureGroupsRequest_Input']>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipFeaturesArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipFeaturesRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_GetFlipNoteHistoryArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetFlipNoteHistoryRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_FlipService_ListFlipNotesArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ListFlipNotesRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_MobileAppsManagementService_GetWhitelabelAppArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetWhitelabelAppRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_MobileAppsManagementService_GetWhitelabelAppsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetWhitelabelAppsRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationTypesPaginatedArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationsArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationsByCompositeKeyArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsByCompositeKeyRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_PartnerConfigurationsService_GetPartnerConfigurationsPaginatedArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_SandboxService_ListSandboxWhitelabelSitesByRetailerArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ListSandboxWhitelabelSitesByRetailerRequest_Input>;
};


export type QueryInstacart_Partners_Partners_V1_SandboxService_ListSandboxesWhitelabelSitesByPartnerArgs = {
  input?: InputMaybe<Instacart_Partners_Partners_V1_ListSandboxesWhitelabelSitesByPartnerRequest_Input>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetAutomationsArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetAutomationsRequest_Input']>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetConnectionsArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetConnectionsRequest_Input']>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetStoresArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetStoresRequest_Input']>;
};


export type QueryInstacart_Retailer_Os_Shelf_Labels_Admin_V1_ShelfLabelsAdminService_GetSyncStrategiesArgs = {
  input?: InputMaybe<Scalars['instacart_retailer_os_shelf_labels_admin_v1_GetSyncStrategiesRequest_Input']>;
};


export type QueryInstacart_Retailer_Tools_Growth_Targeting_V1_GrowthTargetingToolingService_GetTargetingFeaturesArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Growth_Targeting_V1_GetTargetingFeaturesRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetEntitlementDetailsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetEntitlementsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetPackageDetailsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetPackagesArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetRetailerEntitlementProfileDetailsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_Retailer_Platform_Api_V1_FeatureEntitlementsService_GetRetailerEntitlementProfilesArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_DownloadInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalCustomExportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalCustomReportArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalFilterOptionsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_GetInsightsPortalMultiDimensionDatasetArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_ListInsightsPortalCustomExportsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsRequest_Input>;
};


export type QueryInstacart_Retailer_Tools_V2_InsightsPortalService_ListInsightsPortalCustomReportsArgs = {
  input?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsRequest_Input>;
};


export type QueryInstacart_Retailers_V1_AppeasementsService_GetAppeasementsByUserArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetAppeasementsByUserRequest_Input>;
};


export type QueryInstacart_Retailers_V1_AppeasementsService_GetCreditsByUserArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetCreditsByUserRequest_Input>;
};


export type QueryInstacart_Retailers_V1_RetailersService_GetWidgetsConfigArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetWidgetsConfigRequest_Input>;
};


export type QueryInstacart_Retailers_V1_RetailersService_ValidateWidgetsConfigArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_ValidateWidgetsConfigRequest_Input>;
};


export type QueryInstacart_Retailers_V1_StoreConfigurationsService_GetStoreConfigurationsForRetailersArgs = {
  input?: InputMaybe<Instacart_Retailers_V1_GetStoreConfigurationsForRetailersRequest_Input>;
};


export type QueryInstacart_Roulette_V1_RouletteService_GetFeatureByNameAndVersionArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_GetFeatureByNameAndVersionRequest_Input>;
};


export type QueryInstacart_Roulette_V1_RouletteService_ListFeaturesArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_GetFeaturesRequest_Input>;
};


export type QueryInstacart_Roulette_V1_RouletteService_SearchFeaturesArgs = {
  input?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetIntegrationVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetIntegrationVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetIntegrationsArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetIntegrationsRequest_Input']>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetProfileVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetProfileVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetProfilesArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetProfilesRequest_Input']>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetRetailerVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetRetailerVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetRetailersArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetRetailersRequest_Input']>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetStoreVersionsArgs = {
  input?: InputMaybe<Instacart_Upos_Config_V1_GetStoreVersionsRequest_Input>;
};


export type QueryInstacart_Upos_Config_V1_ConfigService_GetStoresArgs = {
  input?: InputMaybe<Scalars['instacart_upos_config_v1_GetStoresRequest_Input']>;
};


export type QueryInstacart_Upos_Status_V1_StatusService_GetIntegrationStatusesArgs = {
  input?: InputMaybe<Scalars['instacart_upos_status_v1_GetIntegrationStatusesRequest_Input']>;
};


export type QueryInstacart_Waves_V1_WavesService_DescribeSnowflakeTableArgs = {
  input?: InputMaybe<Instacart_Waves_V1_DescribeSnowflakeTableRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetPipelineAlertConfigArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetPipelineAlertConfigRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetPresignedUploadUrlArgs = {
  input?: InputMaybe<Scalars['instacart_waves_v1_GetPresignedUploadUrlRequest_Input']>;
};


export type QueryInstacart_Waves_V1_WavesService_GetPreviewArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetPreviewRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetStepVersionArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetStepVersionRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetStepVersionHistoryArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetStepVersionHistoryRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_GetWorkflowRunArgs = {
  input?: InputMaybe<Instacart_Waves_V1_GetWorkflowRunRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListAllStepFilterTagsArgs = {
  input?: InputMaybe<Scalars['instacart_waves_v1_ListAllStepFilterTagsRequest_Input']>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepFilterTagsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepFilterTagsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepRunsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepRunsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepVersionsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepVersionsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListStepsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListStepsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ListWorkflowRunsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ListWorkflowRunsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_PreviewSnowflakeQueryArgs = {
  input?: InputMaybe<Instacart_Waves_V1_PreviewSnowflakeQueryRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_SearchTotemSystemsArgs = {
  input?: InputMaybe<Instacart_Waves_V1_SearchTotemSystemsRequest_Input>;
};


export type QueryInstacart_Waves_V1_WavesService_ValidateStepAttributesArgs = {
  input?: InputMaybe<Instacart_Waves_V1_ValidateStepAttributesRequest_Input>;
};


export type QueryInventoryIntelligenceServiceGetAcknowledgedOosIdsArgs = {
  input?: InputMaybe<GetAcknowledgedOosIdsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetAisleRestockItemsArgs = {
  input?: InputMaybe<GetAisleRestockItemsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetAisleRestockRecommendationSummaryListArgs = {
  input?: InputMaybe<GetAisleRestockRecommendationSummaryListRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetAisleRestockSummaryArgs = {
  input?: InputMaybe<GetAisleRestockSummaryRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetAisleRestockSummaryListArgs = {
  input?: InputMaybe<GetAisleRestockSummaryListRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetChronicInsightsArgs = {
  input?: InputMaybe<GetChronicInsightsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetChronicOverorderingArgs = {
  input?: InputMaybe<GetChronicOverorderingRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetChronicOverorderingItemDetailArgs = {
  input?: InputMaybe<GetChronicOverorderingItemDetailRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetChronicUnderstockItemDetailArgs = {
  input?: InputMaybe<GetChronicUnderstockItemDetailRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetChronicUnderstocksArgs = {
  input?: InputMaybe<GetChronicUnderstocksRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetItemRestockRecommendationArgs = {
  input?: InputMaybe<GetItemRestockRecommendationRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetItemRestockRecommendationsArgs = {
  input?: InputMaybe<GetItemRestockRecommendationsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetKpiArgs = {
  input?: InputMaybe<GetKpiRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetLiveInsightsArgs = {
  input?: InputMaybe<GetLiveInsightsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetOverfacingItemDetailArgs = {
  input?: InputMaybe<GetOverfacingItemDetailRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetOverfacingItemsArgs = {
  input?: InputMaybe<GetOverfacingItemsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetRestockRankingListArgs = {
  input?: InputMaybe<GetRestockRankingListRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetRetailerDepartmentsArgs = {
  input?: InputMaybe<GetRetailerDepartmentsRequestInput>;
};


export type QueryInventoryIntelligenceServiceGetShelfViewArgs = {
  input?: InputMaybe<GetShelfViewRequestInput>;
};


export type QueryLinkAutosuggestServiceListLinkAutosuggestionAdminArgs = {
  input?: InputMaybe<ListLinkAutosuggestionAdminRequestInput>;
};


export type QueryMarketingFeatureBrazeSegmentSizeArgs = {
  segmentId: Scalars['ID'];
};


export type QueryMarketingFeatureCampaignStatusArgs = {
  campaignId: Scalars['ID'];
};


export type QueryMarketingFeatureTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
  pushNotificationId?: InputMaybe<Scalars['ID']>;
};


export type QueryNormalizedReportSignedUrlArgs = {
  bucketName: Scalars['String'];
  s3Key: Scalars['String'];
};


export type QueryNormalizedReportTypesArgs = {
  filterUnavailable?: InputMaybe<Scalars['Boolean']>;
  partnerId: Scalars['ID'];
};


export type QueryNormalizedReportsSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId: Scalars['ID'];
  reportType?: InputMaybe<ReportTypeEnum>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationGroupId?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['ISO8601Date'];
};


export type QueryNotificationChannelsForCurrentAccountArgs = {
  scopeId?: InputMaybe<Scalars['ID']>;
  scopeType: NotificationScopeTypeEnum;
};


export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  scopeType?: InputMaybe<NotificationScopeTypeEnum>;
  severity?: InputMaybe<NotificationSeverityEnum>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryOnboardingMobileAppConfigArgs = {
  os: Os;
  storeConfigurationId: Scalars['Int'];
};


export type QueryOnboardingServiceCheckLaunchOnboardingProgressByPartnerArgs = {
  input?: InputMaybe<CheckLaunchOnboardingProgressByPartnerRequestInput>;
};


export type QueryOnboardingServiceGetApprovalRequestsArgs = {
  input?: InputMaybe<GetApprovalRequestsRequestInput>;
};


export type QueryOnboardingServiceGetBuildkiteArtifactDownloadUrlArgs = {
  input?: InputMaybe<GetBuildkiteArtifactDownloadUrlRequestInput>;
};


export type QueryOnboardingServiceGetBuildkiteArtifactsArgs = {
  input?: InputMaybe<GetBuildkiteArtifactsRequestInput>;
};


export type QueryOnboardingServiceGetCatalogFaqFileArgs = {
  input?: InputMaybe<GetCatalogFaqFileRequestInput>;
};


export type QueryOnboardingServiceGetFormGroupsArgs = {
  input?: InputMaybe<GetFormGroupsRequestInput>;
};


export type QueryOnboardingServiceGetLaunchOnboardingArgs = {
  input?: InputMaybe<GetLaunchOnboardingRequestInput>;
};


export type QueryOnboardingServiceGetLaunchOnboardingWarehouseLocationsArgs = {
  input?: InputMaybe<GetLaunchOnboardingWarehouseLocationsRequestInput>;
};


export type QueryOnboardingServiceGetOnboardingArgs = {
  input?: InputMaybe<GetOnboardingRequestInput>;
};


export type QueryOnboardingServiceGetOnboardingAttributesArgs = {
  input?: InputMaybe<GetOnboardingAttributesRequestInput>;
};


export type QueryOnboardingServiceGetSignupPartnerArgs = {
  input?: InputMaybe<GetSignupPartnerRequestInput>;
};


export type QueryOnboardingServiceGetTestCasesArgs = {
  input?: InputMaybe<GetTestCasesRequestInput>;
};


export type QueryOnboardingServiceGetWaterfallEffectArgs = {
  input?: InputMaybe<GetWaterfallEffectRequestInput>;
};


export type QueryOnboardingServiceGetWaterfallEffectsArgs = {
  input?: InputMaybe<GetWaterfallEffectsRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelGumloopWorkflowResultsArgs = {
  input?: InputMaybe<GetWhitelabelGumloopWorkflowResultsRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSiteTestRunBuildArgs = {
  input?: InputMaybe<GetWhitelabelSiteTestRunBuildRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSiteTestRunsArgs = {
  input?: InputMaybe<GetWhitelabelSiteTestRunsRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSitesArgs = {
  input?: InputMaybe<GetWhitelabelSitesRequestInput>;
};


export type QueryOnboardingServiceGetWhitelabelSitesAdminArgs = {
  input?: InputMaybe<GetWhitelabelSitesAdminRequestInput>;
};


export type QueryOnboardingServiceListPbiStoreConfigurationsArgs = {
  input?: InputMaybe<ListPbiStoreConfigurationsRequestInput>;
};


export type QueryOnboardingServiceSearchWhitelabelSiteCustomizableStringArgs = {
  input?: InputMaybe<SearchWhitelabelSiteCustomizableStringRequestInput>;
};


export type QueryOnboardingWorkflowArgs = {
  filter?: InputMaybe<WorkflowQueryFilter>;
  storeConfigurationId: Scalars['Int'];
};


export type QueryOrderServiceGetDashboardOrderArgs = {
  input?: InputMaybe<GetDashboardOrderRequestInput>;
};


export type QueryOrderServiceGetDashboardOrdersArgs = {
  input?: InputMaybe<GetDashboardOrdersRequestInput>;
};


export type QueryOrderServiceGetOrderArgs = {
  input?: InputMaybe<GetOrderRequestInput>;
};


export type QueryOrderServiceGetOrderLocationArgs = {
  input?: InputMaybe<GetOrderLocationRequestInput>;
};


export type QueryOrderServiceGetOrderStateChangesArgs = {
  input?: InputMaybe<GetOrderStateChangesRequestInput>;
};


export type QueryOrderSourcesArgs = {
  retailerId: Scalars['ID'];
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPartnerArgs = {
  id: Scalars['ID'];
};


export type QueryPartnerPickDeviceArgs = {
  id: Scalars['ID'];
};


export type QueryPartnerPickDeviceSearchArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  warehouseLocationId: Scalars['ID'];
};


export type QueryPartnerPickGetCapacityRecommendationsArgs = {
  date: Scalars['ISO8601Date'];
  retailerLocationId: Scalars['ID'];
};


export type QueryPartnerPickRecurringShiftConflictCheckArgs = {
  daysOfWeek: Array<Scalars['Int']>;
  driverId: Scalars['ID'];
  existingDriverShiftId?: InputMaybe<Scalars['ID']>;
  existingRecurringShiftId?: InputMaybe<Scalars['ID']>;
  recurEndDate?: InputMaybe<Scalars['String']>;
  recurStartDate?: InputMaybe<Scalars['String']>;
  shiftLengthSeconds: Scalars['Int'];
  shiftStartSecondsSinceMidnight: Scalars['Int'];
  warehouseLocationId: Scalars['ID'];
};


export type QueryPartnerRetailerSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerType?: InputMaybe<Scalars['String']>;
};


export type QueryPartnerSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerType?: InputMaybe<Scalars['String']>;
};


export type QueryPartnerSearchArrayArgs = {
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<Scalars['String']>;
};


export type QueryPartnersArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryPermissionsArgs = {
  retailerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
};


export type QueryPickupRetailerLocationGroupArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryPreviewNoticeBannerMatchArgs = {
  pathGlob: Scalars['String'];
  previewPath: Scalars['String'];
};


export type QueryPrivacyServiceGetPiiRequestsForRetailerArgs = {
  input?: InputMaybe<GetPiiRequestsForRetailerRequestInput>;
};


export type QueryProductDataServiceGetProductDataArgs = {
  input?: InputMaybe<GetProductDataRequestInput>;
};


export type QueryProductSourceServiceGetProductSourcesArgs = {
  input?: InputMaybe<GetProductSourcesRequestInput>;
};


export type QueryProductsServiceGetFlattenedTaxonomiesArgs = {
  input?: InputMaybe<GetFlattenedTaxonomiesRequestInput>;
};


export type QueryProductsServiceGetLegacyElasticsearchArgs = {
  input?: InputMaybe<GetLegacyElasticsearchRequestInput>;
};


export type QueryProductsServiceGetLegacyItemsShoppersArgs = {
  input?: InputMaybe<GetLegacyItemsShoppersRequestInput>;
};


export type QueryProductsServiceGetLegacyProductsArgs = {
  input?: InputMaybe<GetLegacyProductsRequestInput>;
};


export type QueryProductsServiceGetManagedAttributeValuesForRetailerArgs = {
  input?: InputMaybe<GetManagedAttributeValuesForRetailerRequestInput>;
};


export type QueryProductsServiceSearchBrandsArgs = {
  input?: InputMaybe<SearchBrandsRequestInput>;
};


export type QueryQualityScorecardsAggScorecardsArgs = {
  ippTotemEntity?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
};


export type QueryQualityScorecardsPlatformStatsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601Date']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']>;
};


export type QueryReportRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId: Scalars['ID'];
};


export type QueryReportViewArgs = {
  reportViewId: Scalars['ID'];
};


export type QueryResolveUserSelectionArgs = {
  canonicalIds?: InputMaybe<Array<Scalars['ID']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<UserSelectionFilters>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryRetailerArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerAislesGetRetailerAisleTemplateArgs = {
  input?: InputMaybe<GetRetailerAisleTemplateRequestInput>;
};


export type QueryRetailerAislesGetRetailerLocationByLayoutArgs = {
  input?: InputMaybe<GetRetailerLocationByLayoutRequestInput>;
};


export type QueryRetailerCampaignServiceGetMomentArgs = {
  input?: InputMaybe<GetMomentRequestInput>;
};


export type QueryRetailerCampaignServiceGetMomentParticipatingRetailersArgs = {
  input?: InputMaybe<GetMomentParticipatingRetailersRequestInput>;
};


export type QueryRetailerCampaignServiceGetMomentsArgs = {
  input?: InputMaybe<GetMomentsRequestInput>;
};


export type QueryRetailerCampaignServiceGetRetailerCampaignArgs = {
  input?: InputMaybe<GetRetailerCampaignRequestInput>;
};


export type QueryRetailerCampaignServiceListMomentsArgs = {
  input?: InputMaybe<ListMomentsRequestInput>;
};


export type QueryRetailerCampaignServiceListRetailerCampaignTreatmentsArgs = {
  input?: InputMaybe<ListRetailerCampaignTreatmentsRequestInput>;
};


export type QueryRetailerCampaignServiceListRetailerCampaignsArgs = {
  input?: InputMaybe<ListRetailerCampaignsRequestInput>;
};


export type QueryRetailerLocationArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerLocationGroupArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerLocationGroupsByIdsArgs = {
  ids: Array<Scalars['ID']>;
};


export type QueryRetailerLocationGroupsByRetailerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  matchType?: InputMaybe<RetailerLocationGroupQuery>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerLocationSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  includeInactiveLocations?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerLocationSearchArrayArgs = {
  includeInactiveLocations?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  pickup?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerManagementServiceGetClientConfigurationByIdArgs = {
  input?: InputMaybe<GetClientConfigurationByIdRequestInput>;
};


export type QueryRetailerManagementServiceGetConnectRetailerCallbackConfigurationByIdArgs = {
  input?: InputMaybe<GetConnectRetailerCallbackConfigurationByIdRequestInput>;
};


export type QueryRetailerManagementServiceGetConnectRetailerCallbackConfigurationsArgs = {
  input?: InputMaybe<GetConnectRetailerCallbackConfigurationsRequestInput>;
};


export type QueryRetailerManagementServiceGetPartnerOauthApplicationsArgs = {
  input?: InputMaybe<GetPartnerOauthApplicationsRequestInput>;
};


export type QueryRetailerMfaConfigArgs = {
  retailerId: Scalars['ID'];
};


export type QueryRetailerPickupMetadataArgs = {
  id: Scalars['ID'];
};


export type QueryRetailerProductAttributeEditServiceGetAvailabilityScoreOverrideArgs = {
  input?: InputMaybe<GetAvailabilityScoreOverrideRequestInput>;
};


export type QueryRetailerProductAttributeEditServiceGetRetailerProductAssortmentArgs = {
  input?: InputMaybe<GetRetailerProductAssortmentRequestInput>;
};


export type QueryRetailerSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerSearchArrayArgs = {
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QueryRetailerSettingServiceGetSettingArgs = {
  input?: InputMaybe<GetSettingRequestInput>;
};


export type QueryRetailerSettingsServiceGetIsGrocerArgs = {
  input?: InputMaybe<GetIsGrocerRequestInput>;
};


export type QueryRetailerSettingsServiceGetParkingSettingsArgs = {
  input?: InputMaybe<GetParkingSettingsRequestInput>;
};


export type QueryRetailerSettingsServiceGetPickupSettingsMetadataArgs = {
  input?: InputMaybe<GetPickupSettingsMetadataRequestInput>;
};


export type QueryRetailerSettingsServiceGetStagingSettingsArgs = {
  input?: InputMaybe<GetStagingSettingsRequestInput>;
};


export type QueryRetailerSettingsServiceGetToteLabelsFileArgs = {
  input?: InputMaybe<GetToteLabelsFileRequestInput>;
};


export type QueryRetailerStoreHoursGetConfirmedStoreHoursArgs = {
  input?: InputMaybe<GetConfirmedStoreHoursRequestInput>;
};


export type QueryRetailerStoreHoursGetRetailerHolidaysStatusArgs = {
  input?: InputMaybe<GetHolidaysStatusRequestInput>;
};


export type QueryRetailerStoreHoursGetStoreHoursArgs = {
  input?: InputMaybe<GetStoreHoursRequestInput>;
};


export type QueryRetailerStoreHoursGetStoreHoursUpdateTasksArgs = {
  input?: InputMaybe<GetStoreHoursUpdateTasksRequestInput>;
};


export type QueryRetailerToolsServiceGetCustomersContextArgs = {
  input?: InputMaybe<GetCustomersContextRequestInput>;
};


export type QueryRetailerToolsServiceGetItemsArgs = {
  input?: InputMaybe<GetItemsRequestInput>;
};


export type QueryRetailerToolsServiceGetRetailerProductsArgs = {
  input?: InputMaybe<GetRetailerProductsRequestInput>;
};


export type QueryRetailerToolsServiceGetVirtualRetailersArgs = {
  input?: InputMaybe<GetVirtualRetailersRequestInput>;
};


export type QueryRetailersServiceGetPlatformVersionsArgs = {
  input?: InputMaybe<GetPlatformVersionsRequestInput>;
};


export type QueryRetailersServiceGetRetailerLocationsByLocationCodesArgs = {
  input?: InputMaybe<GetRetailerLocationsByLocationCodesRequestInput>;
};


export type QueryRetailersServiceGetRetailerLocationsDetailsArgs = {
  input?: InputMaybe<GetRetailerLocationsDetailsRequestInput>;
};


export type QueryRetailersServiceGetRetailerRegionsArgs = {
  input?: InputMaybe<GetRetailerRegionsRequestInput>;
};


export type QueryRoleFetchArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type QueryRoleSearchArgs = {
  assignableByAccountUuid?: InputMaybe<Scalars['ID']>;
  attainableByAccountUuid?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  includeInstacartManaged?: InputMaybe<Scalars['Boolean']>;
  instacartManagedOnly?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  origins?: InputMaybe<Array<Scalars['String']>>;
  partnerId?: InputMaybe<Scalars['ID']>;
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRppBulkImageUploadsServiceGetImageUploadBatchDetailsArgs = {
  input?: InputMaybe<GetImageUploadBatchDetailsRequestInput>;
};


export type QueryRppBulkImageUploadsServiceGetImageUploadBatchesArgs = {
  input?: InputMaybe<GetImageUploadBatchesRequestInput>;
};


export type QuerySavedViewsListArgs = {
  featureContext: Scalars['String'];
};


export type QueryServiceOptionServiceGetServiceOptionsArgs = {
  input?: InputMaybe<GetServiceOptionsRequestInput>;
};


export type QueryStoreConfigurationByIdArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type QueryStoreConfigurationsByPartnerIdArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  partnerId: Scalars['ID'];
  storeConfigRelationship: StoreConfigurationRelationshipEnum;
};


export type QueryStoreConfigurationsByRetailerIdsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  retailerIds: Array<Scalars['ID']>;
  storeConfigRelationship: StoreConfigurationRelationshipEnum;
};


export type QueryStoreConfigurationsDraftServiceGetStoreConfigurationDraftsArgs = {
  input?: InputMaybe<GetStoreConfigurationDraftsRequestInput>;
};


export type QueryStoreConfigurationsDraftServiceReadLatestStoreConfigurationDraftArgs = {
  input?: InputMaybe<ReadLatestStoreConfigurationDraftRequestInput>;
};


export type QueryStoreConfigurationsDraftServiceReadStoreConfigurationArgs = {
  input?: InputMaybe<ReadStoreConfigurationRequestInput>;
};


export type QueryStorePerformanceServiceGetAggregatedStorePerformanceArgs = {
  input?: InputMaybe<StorePerformanceRequestInput>;
};


export type QueryStorefrontPlacementArgs = {
  id: Scalars['ID'];
  retailerId: Scalars['ID'];
};


export type QueryStorefrontPlacementSearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PlacementFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId: Scalars['ID'];
  sort?: InputMaybe<PlacementSortInput>;
};


export type QueryUserAccessSettingsArgs = {
  email: Scalars['String'];
};


export type QueryUserSettingServiceListUserSettingsArgs = {
  input?: InputMaybe<ListUserSettingsRequestInput>;
};


export type QueryUsersServiceBatchGetUsersByIdsStrictArgs = {
  input?: InputMaybe<BatchGetUsersByIdsStrictRequestInput>;
};


export type QueryUsersServiceGetAutocompleteLocationsArgs = {
  input?: InputMaybe<GetAutocompleteLocationsRequestInput>;
};


export type QueryUsersServiceGetPlaceDetailsArgs = {
  input?: InputMaybe<GetPlaceDetailsRequestInput>;
};


export type QueryUsersServiceGetUserByIdFilteredByIsolationContextArgs = {
  input?: InputMaybe<GetUserByIdFilteredByIsolationContextRequestInput>;
};


export type QueryUsersServiceGetUsersByStoreConfigurationIdArgs = {
  input?: InputMaybe<GetUsersByStoreConfigurationIdRequestInput>;
};


export type QueryUsersServiceListUsersByPersonalIdentifiersStrictArgs = {
  input?: InputMaybe<ListUsersByPersonalIdentifiersStrictRequestInput>;
};


export type QueryValueBasedOverrideServiceGetValueBasedOverridesArgs = {
  input?: InputMaybe<GetValueBasedOverridesRequestInput>;
};


export type QueryVisibilityConditionSearchArgs = {
  placementId?: InputMaybe<Scalars['ID']>;
  visibilityConditionId?: InputMaybe<Scalars['ID']>;
};


export type QueryWelcomeModalArgs = {
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationId?: InputMaybe<Scalars['ID']>;
};


export type QueryWizardProgressArgs = {
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  retailerLocationId: Scalars['ID'];
  wizardType: WizardTypeEnum;
};

export type RadiusSchema = {
  __typename?: 'RadiusSchema';
  r0?: Maybe<Scalars['BigInt']>;
  r4?: Maybe<Scalars['BigInt']>;
  r8?: Maybe<Scalars['BigInt']>;
  r12?: Maybe<Scalars['BigInt']>;
  r24?: Maybe<Scalars['BigInt']>;
};

export type ReadLatestStoreConfigurationDraftRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ReadLatestStoreConfigurationDraftResponse = {
  __typename?: 'ReadLatestStoreConfigurationDraftResponse';
  domainConfigurations?: Maybe<DomainConfiguration>;
  domainConfigurationsRaw?: Maybe<Scalars['JSONObject']>;
  draftId?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  partnerAccessOptions?: Maybe<PartnerAccessOptionsSchema>;
};

export type ReadStoreConfigurationRequestInput = {
  draftId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type ReadStoreConfigurationResponse = {
  __typename?: 'ReadStoreConfigurationResponse';
  domainConfigurations?: Maybe<DomainConfiguration>;
  domainConfigurationsRaw?: Maybe<Scalars['JSONObject']>;
  draftId?: Maybe<Scalars['String']>;
  draftName?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  parentDraftId?: Maybe<Scalars['String']>;
  partnerAccessOptions?: Maybe<PartnerAccessOptionsSchema>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

export type ReassignAuditBatchWorkflowRequestInput = {
  batchUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  newWorkflow?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type ReassignAuditBatchWorkflowResponse = {
  __typename?: 'ReassignAuditBatchWorkflowResponse';
  completedAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type ReceivingContext = {
  __typename?: 'ReceivingContext';
  exceptionStatus?: Maybe<Scalars['String']>;
  exceptionStatusCode?: Maybe<Scalars['String']>;
  externalItemName?: Maybe<Scalars['String']>;
  lastDeliveryAt?: Maybe<Scalars['DateTime']>;
  lastDeliveryCases?: Maybe<Scalars['Int']>;
  lastDeliveryDate?: Maybe<GoogleTypeDate>;
  lastDeliveryUnits?: Maybe<Scalars['Int']>;
  retailerItemCode?: Maybe<Scalars['String']>;
  soldUnitsSinceLastDelivery?: Maybe<Scalars['Int']>;
};

export type RecipeEntryItem = {
  __typename?: 'RecipeEntryItem';
  recipeId?: Maybe<Scalars['String']>;
};

export type RecipeMissingIngredient = {
  __typename?: 'RecipeMissingIngredient';
  enabled?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export enum RecommendationAction {
  RecommendationActionDismiss = 'RECOMMENDATION_ACTION_DISMISS',
  RecommendationActionDone = 'RECOMMENDATION_ACTION_DONE',
  RecommendationActionReject = 'RECOMMENDATION_ACTION_REJECT',
  RecommendationActionUndoAccept = 'RECOMMENDATION_ACTION_UNDO_ACCEPT',
  RecommendationActionUndoReject = 'RECOMMENDATION_ACTION_UNDO_REJECT',
  RecommendationActionUnknown = 'RECOMMENDATION_ACTION_UNKNOWN'
}

export enum RecommendationKind {
  RecommendationKindReorder = 'RECOMMENDATION_KIND_REORDER',
  RecommendationKindRestock = 'RECOMMENDATION_KIND_RESTOCK',
  RecommendationKindUnknown = 'RECOMMENDATION_KIND_UNKNOWN'
}

export enum RecommendationTypeEnum {
  DemandSurge = 'DEMAND_SURGE',
  NoRunner = 'NO_RUNNER'
}

export type RedeemPartnershipOffer = {
  __typename?: 'RedeemPartnershipOffer';
  partnershipBenefitName?: Maybe<Scalars['String']>;
  partnershipOfferName?: Maybe<Scalars['String']>;
};

export type RedeemPartnershipOfferInput = {
  partnershipBenefitName?: InputMaybe<Scalars['String']>;
  partnershipOfferName?: InputMaybe<Scalars['String']>;
};

export enum RedemptionMethod {
  RedemptionMethodAutoApply = 'REDEMPTION_METHOD_AUTO_APPLY',
  RedemptionMethodAutoRedeem = 'REDEMPTION_METHOD_AUTO_REDEEM',
  RedemptionMethodClickToRedeem = 'REDEMPTION_METHOD_CLICK_TO_REDEEM',
  RedemptionMethodCouponCode = 'REDEMPTION_METHOD_COUPON_CODE',
  RedemptionMethodRedeemOnCompletion = 'REDEMPTION_METHOD_REDEEM_ON_COMPLETION',
  RedemptionMethodUnknown = 'REDEMPTION_METHOD_UNKNOWN'
}

export type RefreshAffectedOrdersRequestInput = {
  investigationId?: InputMaybe<Scalars['String']>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type RefreshAffectedOrdersResponse = {
  __typename?: 'RefreshAffectedOrdersResponse';
  workflowId?: Maybe<Scalars['String']>;
};

export type Region = {
  __typename?: 'Region';
  id?: Maybe<Scalars['BigInt']>;
  locationCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RegularHours = {
  __typename?: 'RegularHours';
  dayOfWeek?: Maybe<GoogleTypeDayOfWeek>;
  endTime?: Maybe<GoogleTypeTimeOfDay>;
  serviceType?: Maybe<RetailerServiceType>;
  startTime?: Maybe<GoogleTypeTimeOfDay>;
};

export type RegularHoursInput = {
  dayOfWeek?: InputMaybe<GoogleTypeDayOfWeek>;
  endTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
  serviceType?: InputMaybe<RetailerServiceType>;
  startTime?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

export enum RejectionReasonCode {
  RejectionReasonCodeAlreadyRestocked = 'REJECTION_REASON_CODE_ALREADY_RESTOCKED',
  RejectionReasonCodeBackstockAvailable = 'REJECTION_REASON_CODE_BACKSTOCK_AVAILABLE',
  RejectionReasonCodeIncorrectDetection = 'REJECTION_REASON_CODE_INCORRECT_DETECTION',
  RejectionReasonCodeNotNeeded = 'REJECTION_REASON_CODE_NOT_NEEDED',
  RejectionReasonCodeNoBackstock = 'REJECTION_REASON_CODE_NO_BACKSTOCK',
  RejectionReasonCodeOrderAlreadyPlaced = 'REJECTION_REASON_CODE_ORDER_ALREADY_PLACED',
  RejectionReasonCodeSupplierOutOfStock = 'REJECTION_REASON_CODE_SUPPLIER_OUT_OF_STOCK',
  RejectionReasonCodeUnknown = 'REJECTION_REASON_CODE_UNKNOWN'
}

export enum RejectionReasonEnum {
  /** Whether the authorization check failed because of lack of all partners full access */
  NoAllPartnersFullAccess = 'no_all_partners_full_access',
  /** Whether the authorization check failed because of lack of full partner access */
  NoFullPartnerAccess = 'no_full_partner_access',
  /** Whether the authorization check failed because of lack of full retailer access */
  NoFullRetailerAccess = 'no_full_retailer_access',
  /** Whether the authorization check failed because of lack of partner write access */
  NoPartnerWriteAccess = 'no_partner_write_access',
  /** Whether the authorization check failed because of lack of write access */
  NoWriteAccess = 'no_write_access',
  /** Whether the authorization check failed because of inaccessible approval requests */
  UnauthorizedApprovalRequests = 'unauthorized_approval_requests',
  /** Whether the authorization check failed because of unauthorized partners */
  UnauthorizedPartners = 'unauthorized_partners',
  /** Whether the authorization check failed because of unauthorized retailer locations */
  UnauthorizedRetailerLocations = 'unauthorized_retailer_locations',
  /** Whether the authorization check failed because of unauthorized retailers */
  UnauthorizedRetailers = 'unauthorized_retailers',
  /** Whether the authorization check failed because of unauthorized access to store configuration */
  UnauthorizedStoreConfigs = 'unauthorized_store_configs',
  /** Whether the authorization check failed because missing entitlements */
  UnmetFeatureEntitlements = 'unmet_feature_entitlements',
  /** Whether the authorization check failed because of unmet feature toggles */
  UnmetFeatureToggles = 'unmet_feature_toggles',
  /** Whether the authorization check failed because of unmet permissions */
  UnmetPermissions = 'unmet_permissions'
}

export type RelayBannerInput = {
  displayName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
};

export enum RelayModality {
  RelayModality_3PPick_3PDeliver = 'RELAY_MODALITY_3P_PICK_3P_DELIVER',
  RelayModality_3PPick_3PRunning = 'RELAY_MODALITY_3P_PICK_3P_RUNNING',
  RelayModality_3PPickIcDeliver = 'RELAY_MODALITY_3P_PICK_IC_DELIVER',
  RelayModalityIcPick_3PDeliver = 'RELAY_MODALITY_IC_PICK_3P_DELIVER',
  RelayModalityIcPick_3PRunning = 'RELAY_MODALITY_IC_PICK_3P_RUNNING',
  RelayModalityPassthrough = 'RELAY_MODALITY_PASSTHROUGH',
  RelayModalityUnknown = 'RELAY_MODALITY_UNKNOWN'
}

export type RenewSubscriptionIntoAnnual = {
  __typename?: 'RenewSubscriptionIntoAnnual';
  id?: Maybe<Scalars['BigInt']>;
};

export type RenewSubscriptionIntoAnnualInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RenewSubscriptionIntoMonthly = {
  __typename?: 'RenewSubscriptionIntoMonthly';
  id?: Maybe<Scalars['BigInt']>;
};

export type RenewSubscriptionIntoMonthlyInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type ReopenLastmileOrderRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ReopenLastmileOrderParamsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type ReopenLastmileOrderResponse = {
  __typename?: 'ReopenLastmileOrderResponse';
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

/** A report filter definition */
export type ReportFilterDefinitionsInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Whether this filter is required */
  required: Scalars['Boolean'];
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export enum ReportFilterTypeEnum {
  /** A filter that allows selection of a date range. */
  DateRange = 'DATE_RANGE',
  /** A filter that allows selection of a list of retailer locations. */
  RetailerLocations = 'RETAILER_LOCATIONS'
}

/** Report filter values */
export type ReportFilterValuesInterface = {
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Identifier for this filter */
  slug: Scalars['String'];
};

/** Report Filters */
export type ReportFilters = {
  dateRange?: InputMaybe<DateRange>;
  retailerLocations?: InputMaybe<RetailerLocations>;
};

export enum ReportRequestAssociatedObjectTypeEnum {
  /** Retailer type of associated object */
  Retailer = 'Retailer'
}

/** Autogenerated return type of ReportRequestCreate */
export type ReportRequestCreatePayload = {
  __typename?: 'ReportRequestCreatePayload';
  /** The newly created report request */
  reportRequest?: Maybe<ReportsReportRequest>;
};

export enum ReportRequestStateEnum {
  /** A report request that has been successfully processed */
  Complete = 'COMPLETE',
  /** A report request that has failed processing */
  Failed = 'FAILED',
  /** A report request that is currently being processed */
  InProgress = 'IN_PROGRESS',
  /** A report request that is new and not yet processed */
  New = 'NEW'
}

export enum ReportTypeEnum {
  /** Ads report daily */
  AdsDaily = 'ADS_DAILY',
  /** Ads report monthly */
  AdsMonthly = 'ADS_MONTHLY',
  /** Ads report monthly advertiser level */
  AdsMonthlyAdvertiserLevel = 'ADS_MONTHLY_ADVERTISER_LEVEL',
  /** Ads report weekly */
  AdsWeekly = 'ADS_WEEKLY',
  /** Aldi ACI Daily Report */
  AldiAciDailyReport = 'ALDI_ACI_DAILY_REPORT',
  /** Aldi ACI Daily Store Level Report */
  AldiAciDailyStoreLevelReport = 'ALDI_ACI_DAILY_STORE_LEVEL_REPORT',
  /** Associate level performance */
  AssociateLevelPartnerPerformanceReport = 'ASSOCIATE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Bypass Order Feedback Outstanding Files Report */
  BypassOrdersFeedbackOutstandingFilesReport = 'BYPASS_ORDERS_FEEDBACK_OUTSTANDING_FILES_REPORT',
  /** Campaign Performance Weekly */
  CampaignPerformanceWeekly = 'CAMPAIGN_PERFORMANCE_WEEKLY',
  /** Caper ads report daily */
  CaperAdsDaily = 'CAPER_ADS_DAILY',
  /** Caper ads report monthly */
  CaperAdsMonthly = 'CAPER_ADS_MONTHLY',
  /** Caper ads report weekly */
  CaperAdsWeekly = 'CAPER_ADS_WEEKLY',
  /** Caper Daily Transactions Details */
  CaperDailyTransactionsDetails = 'CAPER_DAILY_TRANSACTIONS_DETAILS',
  /** Caper Daily Transactions Summary */
  CaperDailyTransactionsSummary = 'CAPER_DAILY_TRANSACTIONS_SUMMARY',
  /** Caper Force Resolve All Resolution Log */
  CaperForceResolveAllResolutionLog = 'CAPER_FORCE_RESOLVE_ALL_RESOLUTION_LOG',
  /** Monthly Caper Incentives Report */
  CaperIncentivesMonthly = 'CAPER_INCENTIVES_MONTHLY',
  /** Caper Incentives Report */
  CaperIncentivesReport = 'CAPER_INCENTIVES_REPORT',
  /** Caper Store Performance Breakdown */
  CaperStorePerformanceBreakdown = 'CAPER_STORE_PERFORMANCE_BREAKDOWN',
  /** Caper Top Line Metrics Summary */
  CaperTopLineMetricsSummary = 'CAPER_TOP_LINE_METRICS_SUMMARY',
  /** Customer Care Contacts */
  CareContacts = 'CARE_CONTACTS',
  /** Daily Ultrafast Dashboard */
  DailyUltrafastDashboard = 'DAILY_ULTRAFAST_DASHBOARD',
  /** Daily Ultrafast Order Reporting */
  DailyUltrafastOrderReporting = 'DAILY_ULTRAFAST_ORDER_REPORTING',
  /** Delivery Now By Marianos - Daily Adjustment Report */
  DeliveryNowByMarianosDailyAdjustmentReport = 'DELIVERY_NOW_BY_MARIANOS_DAILY_ADJUSTMENT_REPORT',
  /** Ads display preview report daily */
  DisplayPreviewDaily = 'DISPLAY_PREVIEW_DAILY',
  /** Distribution System Report */
  DistributionSystemReport = 'DISTRIBUTION_SYSTEM_REPORT',
  /** Monthly DLOG report */
  DlogMonthly = 'DLOG_MONTHLY',
  /** Lost sales by brand */
  DsdVendorOosBrandRollup = 'DSD_VENDOR_OOS_BRAND_ROLLUP',
  /** Lost sales by item */
  DsdVendorOosTopItems = 'DSD_VENDOR_OOS_TOP_ITEMS',
  /** EBT Monthly */
  EbtMonthly = 'EBT_MONTHLY',
  /** Giant Eagle Loyalty Perks Attribution Ad-Hoc Report */
  GiantEagleLoyaltyPerksAttributionAdHocReport = 'GIANT_EAGLE_LOYALTY_PERKS_ATTRIBUTION_AD_HOC_REPORT',
  /** In Store Transactions */
  InStoreTransactions = 'IN_STORE_TRANSACTIONS',
  /** Live Issue */
  LiveIssue = 'LIVE_ISSUE',
  /** Merged: In Store Transactions */
  MergedInStoreTransactions = 'MERGED_IN_STORE_TRANSACTIONS',
  /** Merged: Retailer Tax Logs */
  MergedRetailerTaxLogs = 'MERGED_RETAILER_TAX_LOGS',
  /** Merged: Shopper Reimbursements Monthly */
  MergedShopperReimbursementsMonthly = 'MERGED_SHOPPER_REIMBURSEMENTS_MONTHLY',
  /** Merged: Taxes Paid at POS */
  MergedTaxesPaidAtPos = 'MERGED_TAXES_PAID_AT_POS',
  /** Merged: Transaction Logs */
  MergedTransactionLogs = 'MERGED_TRANSACTION_LOGS',
  /** Monthly MLOG report */
  MlogMonthly = 'MLOG_MONTHLY',
  /** MPF Taxes Semi Monthly */
  MpfTaxesSemiMonthly = 'MPF_TAXES_SEMI_MONTHLY',
  /** New Verticals - Weekly Retailer Update */
  NewVerticalsWeeklyRetailerUpdate = 'NEW_VERTICALS_WEEKLY_RETAILER_UPDATE',
  /** Order ratings */
  OrderRatings = 'ORDER_RATINGS',
  /** Out of stock items */
  OutOfStock = 'OUT_OF_STOCK',
  /** Partner Pick Daily Performance Metrics */
  PartnerPickDailyPerformanceMetrics = 'PARTNER_PICK_DAILY_PERFORMANCE_METRICS',
  /** Replacements and refunds */
  ReplacementsAndRefunds = 'REPLACEMENTS_AND_REFUNDS',
  /** Retailer Managed Advertiser Campaign Performance */
  RetailerManagedAdvertiserCampaignPerformance = 'RETAILER_MANAGED_ADVERTISER_CAMPAIGN_PERFORMANCE',
  /** Retailer Pickup */
  RetailerPickup = 'RETAILER_PICKUP',
  /** Retailer Tax Logs */
  RetailerTaxLogs = 'RETAILER_TAX_LOGS',
  /** RTD Performance Report - Monthly */
  RtdPerformanceMonthly = 'RTD_PERFORMANCE_MONTHLY',
  /** Live Issue */
  RunnerHours = 'RUNNER_HOURS',
  /** Scan & Pay */
  ScanAndPay = 'SCAN_AND_PAY',
  /** Shopper Breaks */
  ShopperBreaks = 'SHOPPER_BREAKS',
  /** Shopper Pickup Performance Daily */
  ShopperPickupPerformanceDaily = 'SHOPPER_PICKUP_PERFORMANCE_DAILY',
  /** Shopper Reimbursements Monthly */
  ShopperReimbursementsMonthly = 'SHOPPER_REIMBURSEMENTS_MONTHLY',
  /** Skipped Checkout Orders */
  SkippedCheckoutOrders = 'SKIPPED_CHECKOUT_ORDERS',
  /** Store in Store Report Aggregate */
  StoreInStorePerformanceAgg = 'STORE_IN_STORE_PERFORMANCE_AGG',
  /** Store in Store Report Detail */
  StoreInStorePerformanceDtl = 'STORE_IN_STORE_PERFORMANCE_DTL',
  /** Store level performance */
  StoreLevelPartnerPerformanceReport = 'STORE_LEVEL_PARTNER_PERFORMANCE_REPORT',
  /** Taxes Paid at POS */
  TaxesPaidAtPos = 'TAXES_PAID_AT_POS',
  /** Top items */
  TopItems = 'TOP_ITEMS',
  /** Transaction Logs */
  TransactionLogs = 'TRANSACTION_LOGS',
  /** Live Issue */
  UnataExpressWeekly = 'UNATA_EXPRESS_WEEKLY',
  /** UUID Compliance */
  UuidCompliance = 'UUID_COMPLIANCE',
  /** General weekly updates */
  WeeklyRetailerUpdate = 'WEEKLY_RETAILER_UPDATE',
  /** Willcall Billing Reports */
  WillcallBillingReports = 'WILLCALL_BILLING_REPORTS'
}

/** A generated view of the report data */
export type ReportViewsInterface = {
  /** A unique identifier for the report view */
  id: Scalars['ID'];
};

export type ReportsReport = {
  __typename?: 'ReportsReport';
  /** The time at which the report was created */
  createdAt: Scalars['Time'];
  /** A unique identifier for the each report */
  id: Scalars['ID'];
  /** A url-friendly ID for this report */
  slug: Scalars['String'];
  supportedFilters: Array<ReportFilterDefinitionsInterface>;
  /** The time at which the report was updated */
  updatedAt: Scalars['Time'];
};

export type ReportsReportFilterDefinitionsDateRange = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsDateRange';
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Maximum date allowed */
  maxDate: Scalars['ISO8601Date'];
  /** Minimum date */
  minDate: Scalars['ISO8601Date'];
  /** Whether this filter is required */
  required: Scalars['Boolean'];
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export type ReportsReportFilterDefinitionsRetailerLocations = ReportFilterDefinitionsInterface & {
  __typename?: 'ReportsReportFilterDefinitionsRetailerLocations';
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Whether this filter is required */
  required: Scalars['Boolean'];
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export type ReportsReportFilterValuesDateRange = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesDateRange';
  /** End date of date range */
  endDate: Scalars['ISO8601Date'];
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** Identifier for this filter */
  slug: Scalars['String'];
  /** Start date of date range */
  startDate: Scalars['ISO8601Date'];
};

export type ReportsReportFilterValuesRetailerLocations = ReportFilterValuesInterface & {
  __typename?: 'ReportsReportFilterValuesRetailerLocations';
  /** Type of filter */
  filterType: ReportFilterTypeEnum;
  /** A retailer location group ID */
  retailerLocationGroupId?: Maybe<Scalars['ID']>;
  /** A list of retailer location IDs */
  retailerLocationIds?: Maybe<Array<Scalars['ID']>>;
  /** Identifier for this filter */
  slug: Scalars['String'];
};

export type ReportsReportRequest = {
  __typename?: 'ReportsReportRequest';
  /** The time at which the report request was created */
  createdAt: Scalars['Time'];
  enterpriseAccount?: Maybe<EnterpriseAccount>;
  /** The state the report request is currently in */
  generationState: ReportRequestStateEnum;
  /** A unique identifier for the report request */
  id: Scalars['ID'];
  /** The name of the report request */
  name: Scalars['String'];
  report: ReportsReport;
  reportFilters: Array<ReportFilterValuesInterface>;
  reportViews: Array<ReportViewsInterface>;
  /** The time at which the report request was updated */
  updatedAt: Scalars['Time'];
};

/** The connection type for ReportsReportRequest. */
export type ReportsReportRequestConnection = {
  __typename?: 'ReportsReportRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportsReportRequestEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReportsReportRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReportsReportRequestEdge = {
  __typename?: 'ReportsReportRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ReportsReportRequest>;
};

export type ReportsReportViewsCsv = ReportViewsInterface & {
  __typename?: 'ReportsReportViewsCsv';
  /** download URL for the report view */
  downloadUrl?: Maybe<Scalars['String']>;
  /** A unique identifier for the report view */
  id: Scalars['ID'];
};

export enum RequestStateEnum {
  /** Account Request accepted and completed */
  Completed = 'COMPLETED',
  /** Waiting for admin to confirm request */
  PendingAdminAction = 'PENDING_ADMIN_ACTION',
  /** Waiting for requestee to verify email */
  PendingEmailVerification = 'PENDING_EMAIL_VERIFICATION',
  /** Account Request rejected */
  Rejected = 'REJECTED'
}

export enum RequestType {
  RequestTypeAccess = 'REQUEST_TYPE_ACCESS',
  RequestTypeDeletion = 'REQUEST_TYPE_DELETION',
  RequestTypeUnspecified = 'REQUEST_TYPE_UNSPECIFIED'
}

export type RescheduleOrderRequestInput = {
  modificationEvent?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1ModificationEventInput>;
  order?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RescheduleOrderParamsInput>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type RescheduleOrderResponse = {
  __typename?: 'RescheduleOrderResponse';
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

export type ResetDraftVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageId?: InputMaybe<Scalars['BigInt']>;
};

export type ResetDraftVersionResponse = {
  __typename?: 'ResetDraftVersionResponse';
  draft?: Maybe<ContentPageVersion>;
};

export type ResourceDataQuery = {
  __typename?: 'ResourceDataQuery';
  id?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
};

export type ResourceDataQueryInput = {
  id?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<Scalars['String']>;
};

/** Resource scope for a claim evaluation. Dimensions are ANDed; within each dimension every id must be accessible to the subject. */
export type ResourceScopeInput = {
  partnerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerIds?: InputMaybe<Array<Scalars['ID']>>;
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
  storeConfigIds?: InputMaybe<Array<Scalars['ID']>>;
};

export enum ResponseStatus {
  Failed = 'Failed',
  Success = 'Success',
  Unknown = 'Unknown'
}

export type RestaurantRewardCondition = {
  __typename?: 'RestaurantRewardCondition';
  conditionType?: Maybe<RestaurantRewardConditionType>;
  value?: Maybe<GoogleTypeMoney>;
};

export type RestaurantRewardConditionInput = {
  conditionType?: InputMaybe<RestaurantRewardConditionType>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
};

export enum RestaurantRewardConditionType {
  RestaurantRewardConditionTypeDeliveryFeeMaximumValue = 'RESTAURANT_REWARD_CONDITION_TYPE_DELIVERY_FEE_MAXIMUM_VALUE',
  RestaurantRewardConditionTypeMinimumSpend = 'RESTAURANT_REWARD_CONDITION_TYPE_MINIMUM_SPEND',
  RestaurantRewardConditionTypeUnknown = 'RESTAURANT_REWARD_CONDITION_TYPE_UNKNOWN'
}

export type RestaurantRewardPolicy = {
  __typename?: 'RestaurantRewardPolicy';
  conditions?: Maybe<Array<Maybe<RestaurantRewardCondition>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  maxDiscountCents?: Maybe<Scalars['BigInt']>;
  rewardType?: Maybe<RestaurantRewardType>;
  secondsValid?: Maybe<Scalars['BigInt']>;
  value?: Maybe<GoogleTypeMoney>;
  valuePercentage?: Maybe<Scalars['Float']>;
};

export type RestaurantRewardPolicyInput = {
  conditions?: InputMaybe<Array<InputMaybe<RestaurantRewardConditionInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  maxDiscountCents?: InputMaybe<Scalars['BigInt']>;
  rewardType?: InputMaybe<RestaurantRewardType>;
  secondsValid?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
  valuePercentage?: InputMaybe<Scalars['Float']>;
};

export enum RestaurantRewardType {
  RestaurantRewardTypeDollarOff = 'RESTAURANT_REWARD_TYPE_DOLLAR_OFF',
  RestaurantRewardTypeFreeDelivery = 'RESTAURANT_REWARD_TYPE_FREE_DELIVERY',
  RestaurantRewardTypePercentOff = 'RESTAURANT_REWARD_TYPE_PERCENT_OFF',
  RestaurantRewardTypeUnknown = 'RESTAURANT_REWARD_TYPE_UNKNOWN'
}

export type RestockFilterTogglesInput = {
  keyItemsOnly?: InputMaybe<Scalars['Boolean']>;
  predictedLow?: InputMaybe<Scalars['Boolean']>;
  replenishableNow?: InputMaybe<Scalars['Boolean']>;
  scannedLowStock?: InputMaybe<Scalars['Boolean']>;
  scannedOos?: InputMaybe<Scalars['Boolean']>;
};

export type RestockItem = {
  __typename?: 'RestockItem';
  backInventoryQty?: Maybe<Scalars['Int']>;
  category?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  estimatedLoss?: Maybe<Scalars['Float']>;
  imageUrl?: Maybe<Scalars['String']>;
  isPromo?: Maybe<Scalars['Boolean']>;
  lastScanDatetime?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  salesVelocity?: Maybe<Scalars['Float']>;
  sales_24h?: Maybe<Scalars['BigInt']>;
  upc?: Maybe<Scalars['String']>;
  urgencyScore?: Maybe<Scalars['Float']>;
};

export type RestockMetadata = {
  __typename?: 'RestockMetadata';
  appliedSortBy?: Maybe<RestockSortBy>;
  appliedSortDirection?: Maybe<SortDirection>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  totalItems?: Maybe<Scalars['Int']>;
};

export type RestockShelfImage = {
  __typename?: 'RestockShelfImage';
  boundingBoxes?: Maybe<Array<Maybe<BoundingBox>>>;
  capturedAt?: Maybe<Scalars['DateTime']>;
  debugData?: Maybe<ScanImageDebugData>;
  detectionType?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export enum RestockSortBy {
  RestockSortByEstimatedLoss = 'RESTOCK_SORT_BY_ESTIMATED_LOSS',
  RestockSortBySales_24H = 'RESTOCK_SORT_BY_SALES_24H',
  RestockSortBySalesVelocity = 'RESTOCK_SORT_BY_SALES_VELOCITY',
  RestockSortByUnknown = 'RESTOCK_SORT_BY_UNKNOWN',
  RestockSortByUrgencyScore = 'RESTOCK_SORT_BY_URGENCY_SCORE'
}

export type RestoreContentPageRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
};

export type RestoreContentPageResponse = {
  __typename?: 'RestoreContentPageResponse';
  _?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of ResyncPartners */
export type ResyncPartnersPayload = {
  __typename?: 'ResyncPartnersPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
  /** The number of partners that were upserted */
  upsertedCount: Scalars['Int'];
};

export type Retailer = {
  __typename?: 'Retailer';
  /** Country associated with this retailer */
  country: Country;
  /** An array of the retailer's departments */
  departments: Array<CatalogDepartment>;
  /** The entitlements granted to the retailer */
  featureEntitlements: Array<FeatureEntitlement>;
  /** The feature toggles associated with the retailer */
  featureToggles: Array<FeatureToggle>;
  id?: Maybe<Scalars['BigInt']>;
  /** The features across all locations for this retailer */
  locationFeatures: Array<LocationFeatureEnum>;
  /** A url for the logo */
  logo?: Maybe<Logo>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** The partner that this retailer belongs to */
  partner: Partner;
  partnerId?: Maybe<Scalars['BigInt']>;
  /** The store configuration for the pbi retailer */
  pbiConfiguration?: Maybe<ContentManagementPbiConfiguration>;
  /** The warehouse slug for a retailer */
  slug: Scalars['String'];
  /** Warehouse group id for this retailer */
  warehouseGroup?: Maybe<WarehouseGroup>;
};

export type RetailerAvailabilityInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** The ID of the retailer */
  retailerId: Scalars['Int'];
};

/** Autogenerated return type of RetailerAvailabilityVisibilityConditionCreate */
export type RetailerAvailabilityVisibilityConditionCreatePayload = {
  __typename?: 'RetailerAvailabilityVisibilityConditionCreatePayload';
  /** The newly created RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityCondition: ContentManagementVisibilityConditionRetailerAvailability;
};

/** Autogenerated return type of RetailerAvailabilityVisibilityConditionUpdate */
export type RetailerAvailabilityVisibilityConditionUpdatePayload = {
  __typename?: 'RetailerAvailabilityVisibilityConditionUpdatePayload';
  /** The newly updated RetailerAvailability visibility condition */
  retailerAvailabilityVisibilityCondition: ContentManagementVisibilityConditionRetailerAvailability;
};

export type RetailerCampaign = {
  __typename?: 'RetailerCampaign';
  budget?: Maybe<GoogleTypeMoney>;
  campaignObjective?: Maybe<CampaignObjective>;
  campaignReference?: Maybe<CampaignReference>;
  campaignServiceData?: Maybe<CampaignServiceData>;
  coreProperties?: Maybe<Scalars['JSONObject']>;
  countryIdValue?: Maybe<Scalars['BigInt']>;
  couponCount?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorIppUserId?: Maybe<Scalars['BigInt']>;
  creatorUserEmail?: Maybe<Scalars['String']>;
  creatorUserId?: Maybe<Scalars['BigInt']>;
  customProperties?: Maybe<Array<Maybe<CustomProperty>>>;
  discountPolicyIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  discoverability?: Maybe<Discoverability>;
  endsAt?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  filters?: Maybe<Array<Maybe<CampaignFilter>>>;
  fundingDetails?: Maybe<Scalars['String']>;
  fundingSummaryDetails?: Maybe<Array<Maybe<SummaryDetails>>>;
  id?: Maybe<Scalars['BigInt']>;
  intentionConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  ippUserCanonicalUuid?: Maybe<Scalars['String']>;
  lookbackWindowDays?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  name?: Maybe<Scalars['String']>;
  narrowSearchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  offerDurationInDays?: Maybe<Scalars['BigInt']>;
  offerRequestKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  offerSummary?: Maybe<Scalars['String']>;
  offerSummaryDetails?: Maybe<Array<Maybe<SummaryDetails>>>;
  rawTreatments?: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
  redemptionMethod?: Maybe<RedemptionMethod>;
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  restaurantPromotionId?: Maybe<Scalars['String']>;
  restaurantRewardPolicy?: Maybe<RestaurantRewardPolicy>;
  retailerData?: Maybe<Retailer>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailersData?: Maybe<Array<Maybe<Retailer>>>;
  rouletteFeature?: Maybe<CampaignRouletteFeature>;
  schedule?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['String']>;
  slotCreatives?: Maybe<Array<Maybe<InstacartCustomersContentManagementAdminV1SlotCreative>>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  targeting?: Maybe<Array<Maybe<Targeting>>>;
  targetingRules?: Maybe<Array<Maybe<TargetingRules>>>;
  templateId?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  treatmentTask?: Maybe<CampaignTreatmentTask>;
  treatments?: Maybe<RetailerCampaignTreatments>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validForDays?: Maybe<Scalars['BigInt']>;
};

export type RetailerCampaignCreativeTreatment = {
  __typename?: 'RetailerCampaignCreativeTreatment';
  placementId?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['String']>;
};

export type RetailerCampaignCreativeTreatmentInput = {
  placementId?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type RetailerCampaignOfferTreatment = {
  __typename?: 'RetailerCampaignOfferTreatment';
  offerDurationInDays?: Maybe<Scalars['BigInt']>;
  offerId?: Maybe<Scalars['BigInt']>;
  offerRequestKey?: Maybe<Scalars['String']>;
  slotId?: Maybe<Scalars['String']>;
  validForDays?: Maybe<Scalars['BigInt']>;
};

export type RetailerCampaignOfferTreatmentInput = {
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offerId?: InputMaybe<Scalars['BigInt']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  slotId?: InputMaybe<Scalars['String']>;
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type RetailerCampaignResponse = {
  __typename?: 'RetailerCampaignResponse';
  errors?: Maybe<Scalars['JSONObject']>;
  offers?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOffer>>>;
  retailerCampaign?: Maybe<RetailerCampaign>;
  slotCreatives?: Maybe<Array<Maybe<InstacartCustomersContentManagementAdminV1SlotCreative>>>;
};

export type RetailerCampaignTreatment = {
  __typename?: 'RetailerCampaignTreatment';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  retailerCampaignId?: Maybe<Scalars['BigInt']>;
  slotIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentDetails?: Maybe<Array<Maybe<RetailerCampaignTreatmentDetails>>>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
  treatmentType?: Maybe<RetailerCampaignTreatmentType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RetailerCampaignTreatmentDetails = {
  __typename?: 'RetailerCampaignTreatmentDetails';
  creativeTreatment?: Maybe<RetailerCampaignCreativeTreatment>;
  offerTreatment?: Maybe<RetailerCampaignOfferTreatment>;
};

export type RetailerCampaignTreatmentDetailsInput = {
  creativeTreatment?: InputMaybe<RetailerCampaignCreativeTreatmentInput>;
  offerTreatment?: InputMaybe<RetailerCampaignOfferTreatmentInput>;
};

export enum RetailerCampaignTreatmentType {
  Creative = 'CREATIVE',
  InvalidTreatment = 'INVALID_TREATMENT',
  Offer = 'OFFER'
}

export type RetailerCampaignTreatments = {
  __typename?: 'RetailerCampaignTreatments';
  treatments?: Maybe<Array<Maybe<RetailerCampaignTreatmentsTreatment>>>;
};

export type RetailerCampaignTreatmentsInput = {
  treatments?: InputMaybe<Array<InputMaybe<RetailerCampaignTreatmentsTreatmentInput>>>;
};

export type RetailerCampaignTreatmentsTreatment = {
  __typename?: 'RetailerCampaignTreatmentsTreatment';
  placements?: Maybe<Array<Maybe<Placement>>>;
  slotId?: Maybe<Scalars['BigInt']>;
  treatmentVisibilityConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RetailerCampaignTreatmentsTreatmentInput = {
  placements?: InputMaybe<Array<InputMaybe<PlacementInput>>>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentVisibilityConditions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RetailerCollection = {
  __typename?: 'RetailerCollection';
  retailerId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
};

export type RetailerCollectionInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** The connection type for Retailer. */
export type RetailerConnection = {
  __typename?: 'RetailerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RetailerEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Retailer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Fields for creating a new contact. email is required; all others are optional. */
export type RetailerContactManagement_ContactInput_Input = {
  /** Areas of responsibility (e.g. API, Payments) */
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contact email address — unique within a retailer */
  email: Scalars['EmailAddress'];
  /** IPP canonical user ID for linking to IPP users */
  ippCanonicalUserId?: InputMaybe<Scalars['String']>;
  /** IPP user ID for linking to IPP users */
  ippUserId?: InputMaybe<Scalars['String']>;
  /** Display name */
  name?: InputMaybe<Scalars['RetailerContactManagement_mutationInput_addContact_input_name']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Escalation order — lower number = higher priority */
  priority?: InputMaybe<Scalars['PositiveInt']>;
  /** Job title */
  role?: InputMaybe<Scalars['RetailerContactManagement_mutationInput_addContact_input_role']>;
  /** IANA timezone */
  timezone?: InputMaybe<Scalars['String']>;
};

/** Partial update — all fields optional, but at least one must be provided. If email changes, the old record is deleted and a new one is created. */
export type RetailerContactManagement_ContactUpdate_Input = {
  /** Areas of responsibility */
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** New email address — renames the contact record */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** IPP canonical user ID for linking to IPP users */
  ippCanonicalUserId?: InputMaybe<Scalars['String']>;
  /** IPP user ID for linking to IPP users */
  ippUserId?: InputMaybe<Scalars['String']>;
  /** Display name */
  name?: InputMaybe<Scalars['RetailerContactManagement_mutationInput_updateContact_input_name']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']>;
  /** Escalation order — lower number = higher priority */
  priority?: InputMaybe<Scalars['PositiveInt']>;
  /** Job title */
  role?: InputMaybe<Scalars['RetailerContactManagement_mutationInput_updateContact_input_role']>;
  /** IANA timezone */
  timezone?: InputMaybe<Scalars['String']>;
};

export type RetailerContactManagement_DeleteAllContactsResponse = {
  __typename?: 'RetailerContactManagement_DeleteAllContactsResponse';
  /** Number of contacts deleted */
  deletedCount?: Maybe<Scalars['Int']>;
};

export type RetailerContactManagement_Error = {
  __typename?: 'RetailerContactManagement_Error';
  details?: Maybe<Array<Maybe<RetailerContactManagement_Query_GetOpenApiSpec_OneOf_1_Details_Items>>>;
  error?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export enum RetailerContactManagement_HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

export type RetailerContactManagement_HealthCheck = {
  __typename?: 'RetailerContactManagement_HealthCheck';
  service?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type RetailerContactManagement_PartnerContact = {
  __typename?: 'RetailerContactManagement_PartnerContact';
  createdAt?: Maybe<Scalars['DateTime']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['EmailAddress']>;
  ippCanonicalUserId?: Maybe<Scalars['String']>;
  ippUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Partner grouping identifier */
  partnerId?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['PositiveInt']>;
  role?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RetailerContactManagement_RetailerContact = {
  __typename?: 'RetailerContactManagement_RetailerContact';
  createdAt?: Maybe<Scalars['DateTime']>;
  domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  email?: Maybe<Scalars['EmailAddress']>;
  ippCanonicalUserId?: Maybe<Scalars['String']>;
  ippUserId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['PositiveInt']>;
  /** Retailer grouping identifier */
  retailerId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RetailerContactManagement_String_Container = {
  __typename?: 'RetailerContactManagement_String_container';
  String?: Maybe<Scalars['String']>;
};

export type RetailerContactManagement_Void_Container = {
  __typename?: 'RetailerContactManagement_Void_container';
  Void?: Maybe<Scalars['Void']>;
};

export type RetailerContactManagement_AddContact_Response = RetailerContactManagement_Error | RetailerContactManagement_RetailerContact;

export type RetailerContactManagement_AddPartnerContact_Response = RetailerContactManagement_Error | RetailerContactManagement_PartnerContact;

export type RetailerContactManagement_DeleteAllContacts_Response = RetailerContactManagement_DeleteAllContactsResponse | RetailerContactManagement_Error;

export type RetailerContactManagement_DeleteAllPartnerContacts_Response = RetailerContactManagement_DeleteAllContactsResponse | RetailerContactManagement_Error;

export type RetailerContactManagement_DeleteContact_Response = RetailerContactManagement_Error | RetailerContactManagement_Void_Container;

export type RetailerContactManagement_DeletePartnerContact_Response = RetailerContactManagement_Error | RetailerContactManagement_Void_Container;

export type RetailerContactManagement_GetContact_Response = RetailerContactManagement_Error | RetailerContactManagement_RetailerContact;

export type RetailerContactManagement_GetContacts_Response = RetailerContactManagement_Error | RetailerContactManagement_RetailerContact;

export type RetailerContactManagement_GetOpenApiSpec_Response = RetailerContactManagement_Error | RetailerContactManagement_String_Container;

export type RetailerContactManagement_GetPartnerContact_Response = RetailerContactManagement_Error | RetailerContactManagement_PartnerContact;

export type RetailerContactManagement_GetPartnerContacts_Response = RetailerContactManagement_Error | RetailerContactManagement_PartnerContact;

export type RetailerContactManagement_Query_GetOpenApiSpec_OneOf_1_Details_Items = {
  __typename?: 'RetailerContactManagement_query_getOpenApiSpec_oneOf_1_details_items';
  field?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type RetailerContactManagement_UpdateContact_Response = RetailerContactManagement_Error | RetailerContactManagement_RetailerContact;

export type RetailerContactManagement_UpdatePartnerContact_Response = RetailerContactManagement_Error | RetailerContactManagement_PartnerContact;

export type RetailerContainerPath = {
  __typename?: 'RetailerContainerPath';
  containerPath?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type RetailerContainerPathInput = {
  containerPath?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type RetailerDepartment = {
  __typename?: 'RetailerDepartment';
  departmentId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  parentDepartmentId?: Maybe<Scalars['BigInt']>;
};

/** An edge in a connection. */
export type RetailerEdge = {
  __typename?: 'RetailerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Retailer>;
};

export type RetailerEmailLogEntry = {
  __typename?: 'RetailerEmailLogEntry';
  actionType?: Maybe<RetailerEmailLogEntryActionType>;
  recipient?: Maybe<RetailerEmailLogEntryRecipient>;
  sentAt?: Maybe<Scalars['DateTime']>;
  sentByIppAccountCanonicalId?: Maybe<Scalars['String']>;
};

export enum RetailerEmailLogEntryActionType {
  ActionTypeInitial = 'ACTION_TYPE_INITIAL',
  ActionTypeSecondarySubmission = 'ACTION_TYPE_SECONDARY_SUBMISSION',
  ActionTypeUnknown = 'ACTION_TYPE_UNKNOWN',
  ActionTypeUpdatesRequired = 'ACTION_TYPE_UPDATES_REQUIRED'
}

export type RetailerEmailLogEntryRecipient = {
  __typename?: 'RetailerEmailLogEntryRecipient';
  email?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  ippAccountUuid?: Maybe<Scalars['String']>;
  surname?: Maybe<Scalars['String']>;
  wasProvisioned?: Maybe<Scalars['Boolean']>;
};

export type RetailerEmailRecipientInput = {
  ippAccountUuid?: InputMaybe<Scalars['String']>;
  manualEntry?: InputMaybe<RetailerEmailRecipientManualEntryInput>;
};

export type RetailerEmailRecipientManualEntryInput = {
  email?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  surname?: InputMaybe<Scalars['String']>;
};

export type RetailerForShortcut = {
  __typename?: 'RetailerForShortcut';
  id?: Maybe<Scalars['BigInt']>;
  isShortcutsBarOverridden?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  retailerType?: Maybe<Scalars['String']>;
};

export type RetailerLocale = {
  __typename?: 'RetailerLocale';
  localeCode?: Maybe<Scalars['String']>;
  localeId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type RetailerLocation = {
  __typename?: 'RetailerLocation';
  /** The active status for the location */
  active: Scalars['Boolean'];
  /** The location's city */
  city?: Maybe<Scalars['String']>;
  /** Represents the set of 'Fullfillment Models' (how fulfillment is facilitated for the location) */
  fulfillmentModels?: Maybe<Array<FulfillmentModelEnum>>;
  /** Hybrid Picking setting for the location indicates combined ISS and Partner Pick */
  hybridPickingEnabled?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the retailer location */
  id: Scalars['ID'];
  /** The retailer-assigned location code */
  locationCode?: Maybe<Scalars['String']>;
  /** The name of the retailer location */
  name?: Maybe<Scalars['String']>;
  /** Identifies if the location does partner run alcohol delivery */
  partnerAlcoholDelivery: Scalars['Boolean'];
  /** Identifies if the location can deliver orders with partner delivery drivers */
  partnerDeliveryDriversEnabled?: Maybe<Scalars['Boolean']>;
  /** Represents the 'Picking Model' (how picking is facilitated for the location) */
  pickingModel?: Maybe<PickingModelEnum>;
  /** A flag representing whether pickup is enabled */
  pickup: Scalars['Boolean'];
  /** Identifies if the location does platform only deliveries */
  platformOnlyEnabled?: Maybe<Scalars['Boolean']>;
  /** The retailer that this location belongs to */
  retailer: Retailer;
  /** The retailer ID that this location belongs to */
  retailerId: Scalars['ID'];
  /** The location's state */
  state?: Maybe<Scalars['String']>;
  /** The location's street (including street #) */
  street?: Maybe<Scalars['String']>;
  /** IANA timezone name (e.g. "America/New_York") resolved from (zip_code, country_id) */
  timeZoneName?: Maybe<Scalars['String']>;
  /** The location's zip code or postal code */
  zipCode?: Maybe<Scalars['String']>;
  /** The location's ZIP+4 (US-specific) */
  zipPlusFour?: Maybe<Scalars['String']>;
  /** Fulfillment zone IDs for this location, synced from Hub */
  zoneIds?: Maybe<Array<Scalars['Int']>>;
};

export type RetailerLocationAisle = {
  __typename?: 'RetailerLocationAisle';
  aisleCount?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  retailerLocationName?: Maybe<Scalars['String']>;
};

/** The connection type for RetailerLocation. */
export type RetailerLocationConnection = {
  __typename?: 'RetailerLocationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RetailerLocationEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RetailerLocation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RetailerLocationDetails = {
  __typename?: 'RetailerLocationDetails';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<GoogleTypeLatLng>;
  countryId?: Maybe<Scalars['BigInt']>;
  flags?: Maybe<RetailerLocationFlags>;
  id?: Maybe<Scalars['Int']>;
  inventoryAreaId?: Maybe<Scalars['Int']>;
  locationCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  regionCode?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type RetailerLocationEdge = {
  __typename?: 'RetailerLocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RetailerLocation>;
};

export type RetailerLocationFlags = {
  __typename?: 'RetailerLocationFlags';
  active?: Maybe<Scalars['Boolean']>;
  alcohol?: Maybe<Scalars['Boolean']>;
  available?: Maybe<Scalars['Boolean']>;
  closed?: Maybe<Scalars['Boolean']>;
  curbsidePickup?: Maybe<Scalars['Boolean']>;
  pickup?: Maybe<Scalars['Boolean']>;
  pickupOnly?: Maybe<Scalars['Boolean']>;
  rx?: Maybe<Scalars['Boolean']>;
  serviceable?: Maybe<Scalars['Boolean']>;
  unavailable?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RetailerLocationGroupCreate */
export type RetailerLocationGroupCreatePayload = {
  __typename?: 'RetailerLocationGroupCreatePayload';
  /** The newly created group */
  retailerLocationGroup: RetailersRetailerLocationGroup;
};

/** Autogenerated return type of RetailerLocationGroupDelete */
export type RetailerLocationGroupDeletePayload = {
  __typename?: 'RetailerLocationGroupDeletePayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

export enum RetailerLocationGroupQuery {
  /** Return all Store Groups where client query matches retailer IDs exactly */
  Equal = 'EQUAL',
  /** Return all Store Groups where client query intersects retailer IDs */
  Intersect = 'INTERSECT',
  /** Return all Store Groups where client query is a subset of retailer IDs */
  Subset = 'SUBSET'
}

/** Autogenerated return type of RetailerLocationGroupUpdate */
export type RetailerLocationGroupUpdatePayload = {
  __typename?: 'RetailerLocationGroupUpdatePayload';
  /** The updated group */
  retailerLocationGroup: RetailersRetailerLocationGroup;
};

export type RetailerLocationInfo = {
  __typename?: 'RetailerLocationInfo';
  name?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

/** Attributes for a retailer location filter */
export type RetailerLocations = {
  /** A retailer location group ID */
  retailerLocationGroupId?: InputMaybe<Scalars['ID']>;
  /** A list of retailer location IDs */
  retailerLocationIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type RetailerLogo = {
  __typename?: 'RetailerLogo';
  dark?: Maybe<RetailerLogoImage>;
  darkFillColorHex?: Maybe<Scalars['String']>;
  darkSquare?: Maybe<RetailerLogoImage>;
  light?: Maybe<RetailerLogoImage>;
  lightFillColorHex?: Maybe<Scalars['String']>;
  lightSquare?: Maybe<RetailerLogoImage>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type RetailerLogoImage = {
  __typename?: 'RetailerLogoImage';
  filename?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['BigInt']>;
  width?: Maybe<Scalars['BigInt']>;
};

export type RetailerMfaConfig = {
  __typename?: 'RetailerMfaConfig';
  /** Whether or not MFA is enabled for the retailer */
  mfaEnabled: Scalars['Boolean'];
  /** A unique identifier for the retailer */
  retailerId: Scalars['ID'];
};

/** Autogenerated return type of RetailerMfaSetEnabled */
export type RetailerMfaSetEnabledPayload = {
  __typename?: 'RetailerMfaSetEnabledPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

export type RetailerMomentCampaign = {
  __typename?: 'RetailerMomentCampaign';
  collectionData?: Maybe<Collection>;
  offers?: Maybe<Array<Maybe<InstacartCustomersCommerceTypesV1SlimOffer>>>;
  retailerCampaign?: Maybe<RetailerCampaign>;
  retailerData?: Maybe<Retailer>;
};

export type RetailerNav = {
  __typename?: 'RetailerNav';
  navId?: Maybe<Scalars['BigInt']>;
};

export type RetailerOverride = {
  __typename?: 'RetailerOverride';
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerName?: Maybe<Scalars['String']>;
};

export type RetailerProduct = {
  __typename?: 'RetailerProduct';
  aisleName?: Maybe<Scalars['String']>;
  aisles?: Maybe<Array<Maybe<RetailerProductAisle>>>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  atkinsDiet?: Maybe<Scalars['Boolean']>;
  bottle?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['BigInt']>;
  brandName?: Maybe<Scalars['String']>;
  calories?: Maybe<Scalars['Float']>;
  carbFree?: Maybe<Scalars['Boolean']>;
  carbohydrate?: Maybe<Scalars['Float']>;
  cchGroupCode?: Maybe<Scalars['String']>;
  cchItemCode?: Maybe<Scalars['String']>;
  coldPrepared?: Maybe<Scalars['Boolean']>;
  containsFlour?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dairyFree?: Maybe<Scalars['Boolean']>;
  departments?: Maybe<Array<Maybe<RetailerProductDepartment>>>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  fatFree?: Maybe<Scalars['Boolean']>;
  glutenFree?: Maybe<Scalars['Boolean']>;
  hasImage?: Maybe<Scalars['Boolean']>;
  highCarb?: Maybe<Scalars['Boolean']>;
  highFat?: Maybe<Scalars['Boolean']>;
  highProtein?: Maybe<Scalars['Boolean']>;
  imageList?: Maybe<Array<Maybe<RetailerProductImageInfo>>>;
  ingredients?: Maybe<Scalars['String']>;
  isOrganic?: Maybe<Scalars['Boolean']>;
  ketoDiet?: Maybe<Scalars['Boolean']>;
  kidFriendly?: Maybe<Scalars['Boolean']>;
  kosher?: Maybe<Scalars['Boolean']>;
  lactoseFree?: Maybe<Scalars['Boolean']>;
  localeCode?: Maybe<Scalars['String']>;
  lowCarb?: Maybe<Scalars['Boolean']>;
  lowFat?: Maybe<Scalars['Boolean']>;
  lowSodium?: Maybe<Scalars['Boolean']>;
  lowSugar?: Maybe<Scalars['Boolean']>;
  managedAttributeValues?: Maybe<Array<Maybe<RetailerProductManagedAttributeValue>>>;
  name?: Maybe<Scalars['String']>;
  organic?: Maybe<Scalars['Boolean']>;
  originalName?: Maybe<Scalars['String']>;
  paleoDiet?: Maybe<Scalars['Boolean']>;
  prepSlicedRepackagedPasteurizedByRetailer?: Maybe<Scalars['Boolean']>;
  primaryAisleId?: Maybe<Scalars['BigInt']>;
  primaryDepartmentId?: Maybe<Scalars['BigInt']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryTaxonomy?: Maybe<RetailerProductProductCategoryTaxonomy>;
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productDisplayName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productTags?: Maybe<Scalars['String']>;
  prop65Text?: Maybe<Scalars['String']>;
  requireReheating?: Maybe<Scalars['Boolean']>;
  requiresKeepFrozen?: Maybe<Scalars['Boolean']>;
  requiresRefrigeration?: Maybe<Scalars['Boolean']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
  seasonality?: Maybe<Scalars['JSONObject']>;
  servingSize?: Maybe<Scalars['String']>;
  servingsPerContainer?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sizeUom?: Maybe<Scalars['String']>;
  storeBrand?: Maybe<Scalars['Boolean']>;
  sugarFree?: Maybe<Scalars['Boolean']>;
  suggestedIncrementalWeight?: Maybe<Scalars['Float']>;
  unitCount?: Maybe<Scalars['BigInt']>;
  vegan?: Maybe<Scalars['Boolean']>;
  vegetarian?: Maybe<Scalars['Boolean']>;
  vertexTaxOverrideAttribute?: Maybe<Scalars['String']>;
  weightWatchers?: Maybe<Scalars['Boolean']>;
  wholeGrain?: Maybe<Scalars['Boolean']>;
};

export type RetailerProductAisle = {
  __typename?: 'RetailerProductAisle';
  departmentId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type RetailerProductAssortment = {
  __typename?: 'RetailerProductAssortment';
  entityId?: Maybe<EntityId>;
  inAssortment?: Maybe<Scalars['Boolean']>;
  outOfAssortmentEndAt?: Maybe<Scalars['DateTime']>;
  outOfAssortmentStartAt?: Maybe<Scalars['DateTime']>;
};

export type RetailerProductAssortmentFilterInput = {
  inAssortment?: InputMaybe<Scalars['Boolean']>;
};

export type RetailerProductData = {
  __typename?: 'RetailerProductData';
  availableItemsCount?: Maybe<Scalars['BigInt']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  itemsCount?: Maybe<Scalars['BigInt']>;
  maxPriceCents?: Maybe<Scalars['BigInt']>;
  minPriceCents?: Maybe<Scalars['BigInt']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  visibleItemsCount?: Maybe<Scalars['BigInt']>;
};

export type RetailerProductDepartment = {
  __typename?: 'RetailerProductDepartment';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type RetailerProductId = {
  __typename?: 'RetailerProductId';
  locale?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerProductId?: Maybe<Scalars['BigInt']>;
};

export type RetailerProductIdInput = {
  locale?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerProductId?: InputMaybe<Scalars['BigInt']>;
};

export type RetailerProductImageInfo = {
  __typename?: 'RetailerProductImageInfo';
  cacheType?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  imageType?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
};

export type RetailerProductManagedAttributeValue = {
  __typename?: 'RetailerProductManagedAttributeValue';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueDisplayName?: Maybe<Scalars['String']>;
};

export type RetailerProductProductCategoryTaxonomy = {
  __typename?: 'RetailerProductProductCategoryTaxonomy';
  l1?: Maybe<Scalars['String']>;
  l2?: Maybe<Scalars['String']>;
  l3?: Maybe<Scalars['String']>;
  l4?: Maybe<Scalars['String']>;
  l5?: Maybe<Scalars['String']>;
  l6?: Maybe<Scalars['String']>;
};

export type RetailerProvidedValue = {
  __typename?: 'RetailerProvidedValue';
  codeValue?: Maybe<ProductCodeValue>;
  imageValue?: Maybe<ProductImageValue>;
  productSourceId?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
  sourceUpdatedAt?: Maybe<Scalars['DateTime']>;
  stringValue?: Maybe<Scalars['String']>;
};

export type RetailerSatisfactionSurveyResponse = {
  /** Text that was displayed to user */
  surveyQuestion: Scalars['String'];
  /** Can be either numeric or text based on survey type */
  surveyResponse: Scalars['String'];
};

/** A survey submission record used for client-side display frequency control */
export type RetailerSatisfactionSurveyTypesSubmissionRecord = {
  __typename?: 'RetailerSatisfactionSurveyTypesSubmissionRecord';
  /** Tool identifier (Totem entity external ID) */
  milestoneSlug?: Maybe<Scalars['String']>;
  /** Timestamp of when the survey was submitted */
  submittedAt: Scalars['ISO8601DateTime'];
  /** Workflow that triggered the survey */
  workflowSlug?: Maybe<Scalars['String']>;
};

export enum RetailerServiceType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP',
  ServiceTypeUndefined = 'SERVICE_TYPE_UNDEFINED'
}

export type RetailerSettingDetailRecord = {
  __typename?: 'RetailerSettingDetailRecord';
  detailName?: Maybe<Scalars['String']>;
  detailType?: Maybe<Scalars['String']>;
  detailValue?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  settingName?: Maybe<Scalars['String']>;
  validValues?: Maybe<Scalars['String']>;
};

export type RetailerSettingRecord = {
  __typename?: 'RetailerSettingRecord';
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  details?: Maybe<Array<Maybe<RetailerSettingDetailRecord>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
  settingName?: Maybe<Scalars['String']>;
  settingType?: Maybe<RetailerSettingType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

export enum RetailerSettingType {
  RetailerSettingTypeBoolean = 'RETAILER_SETTING_TYPE_BOOLEAN',
  RetailerSettingTypeInteger = 'RETAILER_SETTING_TYPE_INTEGER',
  RetailerSettingTypeString = 'RETAILER_SETTING_TYPE_STRING',
  RetailerSettingTypeUnknown = 'RETAILER_SETTING_TYPE_UNKNOWN'
}

export type RetailerSlot = {
  __typename?: 'RetailerSlot';
  slotId?: Maybe<Scalars['BigInt']>;
};

export type RetailersPickupRetailerLocationGroup = {
  __typename?: 'RetailersPickupRetailerLocationGroup';
  /** A unique identifier for the location group */
  id: Scalars['ID'];
  /** A name for this location group */
  name: Scalars['String'];
  /** The identifier for the retailer which all locations in the group belong to (deprecated) */
  retailerId?: Maybe<Scalars['ID']>;
  /** The identifiers for the retailers which all locations in the group belong to */
  retailerIds?: Maybe<Array<Scalars['ID']>>;
  /** The retailer locations associated with the group */
  retailerLocations: Array<RetailerLocation>;
};

export type RetailersRetailerLocationGroup = {
  __typename?: 'RetailersRetailerLocationGroup';
  /** A unique identifier for the location group */
  id: Scalars['ID'];
  /** A name for this location group */
  name: Scalars['String'];
  /** The identifier for the partner which all locations in the group belong to */
  partnerId: Scalars['ID'];
  /** The identifier for the retailer which all locations in the group belong to (deprecated) */
  retailerId?: Maybe<Scalars['ID']>;
  /** The identifiers for the retailers which all locations in the group belong to */
  retailerIds?: Maybe<Array<Scalars['ID']>>;
  /** The ids for the retailer locations associated with the group */
  retailerLocationIds: Array<Scalars['ID']>;
  /** The retailer locations associated with the group */
  retailerLocations: RetailerLocationConnection;
  /** The time at which the group was last updated */
  updatedAt: Scalars['Time'];
};


export type RetailersRetailerLocationGroupRetailerLocationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The connection type for RetailersRetailerLocationGroup. */
export type RetailersRetailerLocationGroupConnection = {
  __typename?: 'RetailersRetailerLocationGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RetailersRetailerLocationGroupEdge>>>;
  /** Metadata regarding the connection */
  meta: ConnectionMeta;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RetailersRetailerLocationGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RetailersRetailerLocationGroupEdge = {
  __typename?: 'RetailersRetailerLocationGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<RetailersRetailerLocationGroup>;
};

export type RetailersRetailerPickupMetadata = {
  __typename?: 'RetailersRetailerPickupMetadata';
  /** Warehouse early picking hour [if one is set] */
  earlyPickingHour?: Maybe<Scalars['Int']>;
};

export type ReturnItemInput = {
  productId?: InputMaybe<Scalars['BigInt']>;
  returnedQuantity?: InputMaybe<InstacartTypesV1MeasuredQuantityInput>;
};

/** The possible actions performed during a review on an Approval Request. */
export enum ReviewAction {
  /** A approval for the update to the content. */
  Approval = 'APPROVAL',
  /** An approval and publication of the content in one atomic step. */
  ApprovalAndPublish = 'APPROVAL_AND_PUBLISH',
  /** A publication of the content without the required approvals. */
  BreakGlassPublish = 'BREAK_GLASS_PUBLISH',
  /** A cancellation of the content update. */
  Cancel = 'CANCEL',
  /** A comment on the Approval Request. No state updates. */
  Comment = 'COMMENT',
  /** A publication for the content. */
  Publish = 'PUBLISH',
  /** A request for changes to the content update. */
  RequestChanges = 'REQUEST_CHANGES',
  /** A revision of the content (invalidates approvals). */
  ReviseContent = 'REVISE_CONTENT'
}

/** Input parameters for adding a review to an Approval Request */
export type ReviewAddInput = {
  /** The action to take on the approval request. */
  action: ReviewAction;
  /** The unique ID of the Approval Request. */
  arId: Scalars['ID'];
  /** A comment to add to the approval request. */
  userComment?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ReviewAdd */
export type ReviewAddPayload = {
  __typename?: 'ReviewAddPayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

/** Input parameters for deleting a review on an Approval Request */
export type ReviewDeleteInput = {
  /** The unique ID of the Review. */
  reviewId: Scalars['ID'];
};

/** Autogenerated return type of ReviewDelete */
export type ReviewDeletePayload = {
  __typename?: 'ReviewDeletePayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

/** Input parameters for editing a review to an Approval Request */
export type ReviewEditInput = {
  /** The unique ID of the Review. */
  reviewId: Scalars['ID'];
  /** Update the comment on the approval request. */
  userComment?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ReviewEdit */
export type ReviewEditPayload = {
  __typename?: 'ReviewEditPayload';
  approvalRequest: ApprovalsManagementTypesApprovalRequest;
};

export type RevokePartnerApiKeyRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

export type RevokePartnerApiKeyResponse = {
  __typename?: 'RevokePartnerApiKeyResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export enum Role {
  Assistant = 'ASSISTANT',
  Developer = 'DEVELOPER',
  Tool = 'TOOL',
  User = 'USER'
}

/** Autogenerated return type of RoleCreate */
export type RoleCreatePayload = {
  __typename?: 'RoleCreatePayload';
  /** The created role object */
  role: EnterpriseRole;
};

/** Autogenerated return type of RoleDelete */
export type RoleDeletePayload = {
  __typename?: 'RoleDeletePayload';
  /** The delete role object */
  role: EnterpriseRole;
};

export type RoleInput = {
  /** A unique identifier for the role */
  id: Scalars['ID'];
};

/** Selects the roles a guided operation applies to. */
export type RoleTargetSelectorInput = {
  /** true = internal only, false = external only, null = both. */
  internal?: InputMaybe<Scalars['Boolean']>;
  /** Name or slug substring match. */
  query?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<Scalars['ID']>>;
  selectAllMatching?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of RoleUpdate */
export type RoleUpdatePayload = {
  __typename?: 'RoleUpdatePayload';
  /** The update role object */
  role: EnterpriseRole;
};

export type RollbackStoreConfigurationRequestInput = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type RollbackStoreConfigurationResponse = {
  __typename?: 'RollbackStoreConfigurationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type RsatPulseSurveyInput = {
  /** Whether the user has submitted the survey */
  hasSubmitted: Scalars['Boolean'];
  /** Whether the user has seen the survey */
  seen: Scalars['Boolean'];
  /** The unique slug identifier for the survey */
  slug: RsatPulseSurveySlugEnum;
};

export enum RsatPulseSurveySlugEnum {
  /** RETAILER_SATISFACTION_SURVEY_R202507 survey */
  RetailerSatisfactionSurveyR202507 = 'RETAILER_SATISFACTION_SURVEY_R202507'
}

export type SalesContext = {
  __typename?: 'SalesContext';
  avgDailySales_7d?: Maybe<Scalars['Float']>;
  avgDailySales_7dCents?: Maybe<Scalars['BigInt']>;
  avgDailySales_7dFormatted?: Maybe<Scalars['String']>;
  avgDailySales_30d?: Maybe<Scalars['Float']>;
  avgDailySales_30dCents?: Maybe<Scalars['BigInt']>;
  avgDailySales_30dFormatted?: Maybe<Scalars['String']>;
  lastSaleAt?: Maybe<Scalars['DateTime']>;
  medianDailySales_7d?: Maybe<Scalars['Float']>;
  medianDailySales_7dCents?: Maybe<Scalars['BigInt']>;
  medianDailySales_7dFormatted?: Maybe<Scalars['String']>;
  medianDailySales_30d?: Maybe<Scalars['Float']>;
  medianDailySales_30dCents?: Maybe<Scalars['BigInt']>;
  medianDailySales_30dFormatted?: Maybe<Scalars['String']>;
  soldUnitsToday?: Maybe<Scalars['Int']>;
  totalSales_7dCents?: Maybe<Scalars['BigInt']>;
  totalSales_7dFormatted?: Maybe<Scalars['String']>;
  totalSales_30dCents?: Maybe<Scalars['BigInt']>;
  totalSales_30dFormatted?: Maybe<Scalars['String']>;
  totalUnits_7d?: Maybe<Scalars['Int']>;
  totalUnits_30d?: Maybe<Scalars['Int']>;
};

export type SaveToolingShortcutsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerType?: InputMaybe<Scalars['String']>;
  shortcuts?: InputMaybe<Array<InputMaybe<ToolingShortcutInput>>>;
};

export type SaveToolingShortcutsResponse = {
  __typename?: 'SaveToolingShortcutsResponse';
  shortcuts?: Maybe<Array<Maybe<ToolingShortcut>>>;
};

/** Autogenerated return type of SaveView */
export type SaveViewPayload = {
  __typename?: 'SaveViewPayload';
  errors: Array<Scalars['String']>;
  savedView?: Maybe<SavedViewsTypesViewType>;
};

/** A saved view representing a named filter/sort/search configuration for an IPP page */
export type SavedViewsTypesViewType = {
  __typename?: 'SavedViewsTypesViewType';
  /** When the view was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Page/feature identifier (e.g., flip.by_site) */
  featureContext: Scalars['String'];
  /** Unique identifier */
  id: Scalars['ID'];
  /** Whether this is the default view for the user+context */
  isDefault: Scalars['Boolean'];
  /** User-chosen display name */
  name: Scalars['String'];
  /** When the view was last modified */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Opaque filter/sort/search configuration */
  viewState: Scalars['JSON'];
};

export enum ScanCodeStrategy {
  ScanCodeStrategy_004To_002 = 'SCAN_CODE_STRATEGY_004_TO_002',
  ScanCodeStrategyCostco_004To_002 = 'SCAN_CODE_STRATEGY_COSTCO_004_to_002',
  ScanCodeStrategyCrossRetailerDataExactMatch = 'SCAN_CODE_STRATEGY_CROSS_RETAILER_DATA_EXACT_MATCH',
  ScanCodeStrategyCrossRetailerUnbrandedForcemarksExactMatch = 'SCAN_CODE_STRATEGY_CROSS_RETAILER_UNBRANDED_FORCEMARKS_EXACT_MATCH',
  ScanCodeStrategyCspExactMatch = 'SCAN_CODE_STRATEGY_CSP_EXACT_MATCH',
  ScanCodeStrategyMlV1 = 'SCAN_CODE_STRATEGY_ML_V1',
  ScanCodeStrategyRetailerDataExactMatch = 'SCAN_CODE_STRATEGY_RETAILER_DATA_EXACT_MATCH',
  ScanCodeStrategyRetailerUnbrandedForcemarksExactMatch = 'SCAN_CODE_STRATEGY_RETAILER_UNBRANDED_FORCEMARKS_EXACT_MATCH',
  ScanCodeStrategyUnknown = 'SCAN_CODE_STRATEGY_UNKNOWN'
}

export type ScanImageDebugData = {
  __typename?: 'ScanImageDebugData';
  arpalusScanId?: Maybe<Scalars['BigInt']>;
  arpalusScanImageId?: Maybe<Scalars['BigInt']>;
  boundingBoxIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  panoramaImageUrl?: Maybe<Scalars['String']>;
};

export type ScanSnapshot = {
  __typename?: 'ScanSnapshot';
  currentFacings?: Maybe<Scalars['Int']>;
  locations?: Maybe<Array<Maybe<ShelfLocation>>>;
  scanTimestamp?: Maybe<Scalars['DateTime']>;
};

export type SchedulePublishVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  contentPageVersionId?: InputMaybe<Scalars['BigInt']>;
  scheduledPublishAt?: InputMaybe<Scalars['DateTime']>;
};

export type SchedulePublishVersionResponse = {
  __typename?: 'SchedulePublishVersionResponse';
  contentPageVersion?: Maybe<ContentPageVersion>;
};

export type SearchBrandsRequestInput = {
  limit?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  storeBrandsOnly?: InputMaybe<Scalars['Boolean']>;
};

export type SearchBrandsResponse = {
  __typename?: 'SearchBrandsResponse';
  brands?: Maybe<Array<Maybe<Brand>>>;
};

export type SearchManagedAttributesRequestInput = {
  includeTombstoned?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};

export type SearchManagedAttributesResponse = {
  __typename?: 'SearchManagedAttributesResponse';
  results?: Maybe<Array<Maybe<ManagedAttributeSearchResult>>>;
};

export type SearchPlacementMetadata = {
  __typename?: 'SearchPlacementMetadata';
  allowInterleaving?: Maybe<Scalars['Boolean']>;
  contentType?: Maybe<SearchPlacementMetadataSearchContentType>;
  isPinned?: Maybe<Scalars['Boolean']>;
  maxPosition?: Maybe<Scalars['BigInt']>;
  minPosition?: Maybe<Scalars['BigInt']>;
  sectionType?: Maybe<SearchPlacementMetadataSearchSectionType>;
};

export type SearchPlacementMetadataInput = {
  allowInterleaving?: InputMaybe<Scalars['Boolean']>;
  contentType?: InputMaybe<SearchPlacementMetadataSearchContentType>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  maxPosition?: InputMaybe<Scalars['BigInt']>;
  minPosition?: InputMaybe<Scalars['BigInt']>;
  sectionType?: InputMaybe<SearchPlacementMetadataSearchSectionType>;
};

export enum SearchPlacementMetadataSearchContentType {
  SearchContentTypeAsyncDisplay = 'SEARCH_CONTENT_TYPE_ASYNC_DISPLAY',
  SearchContentTypeAsyncSpAds = 'SEARCH_CONTENT_TYPE_ASYNC_SP_ADS',
  SearchContentTypeBundle = 'SEARCH_CONTENT_TYPE_BUNDLE',
  SearchContentTypeComplementary = 'SEARCH_CONTENT_TYPE_COMPLEMENTARY',
  SearchContentTypeExact = 'SEARCH_CONTENT_TYPE_EXACT',
  SearchContentTypeFlyer = 'SEARCH_CONTENT_TYPE_FLYER',
  SearchContentTypeHeader = 'SEARCH_CONTENT_TYPE_HEADER',
  SearchContentTypeOtherExactContent = 'SEARCH_CONTENT_TYPE_OTHER_EXACT_CONTENT',
  SearchContentTypeOtherRelatedContent = 'SEARCH_CONTENT_TYPE_OTHER_RELATED_CONTENT',
  SearchContentTypeRelated = 'SEARCH_CONTENT_TYPE_RELATED',
  SearchContentTypeSubstitute = 'SEARCH_CONTENT_TYPE_SUBSTITUTE',
  SearchContentTypeSyncDisplay = 'SEARCH_CONTENT_TYPE_SYNC_DISPLAY',
  SearchContentTypeSyncSpAds = 'SEARCH_CONTENT_TYPE_SYNC_SP_ADS',
  SearchContentTypeTheme = 'SEARCH_CONTENT_TYPE_THEME',
  SearchContentTypeUnspecified = 'SEARCH_CONTENT_TYPE_UNSPECIFIED'
}

export enum SearchPlacementMetadataSearchSectionType {
  SearchSectionTypeExact = 'SEARCH_SECTION_TYPE_EXACT',
  SearchSectionTypeOther = 'SEARCH_SECTION_TYPE_OTHER',
  SearchSectionTypeRelated = 'SEARCH_SECTION_TYPE_RELATED',
  SearchSectionTypeUnknown = 'SEARCH_SECTION_TYPE_UNKNOWN'
}

export type SearchWhitelabelSiteCustomizableStringRequestInput = {
  copySubstring?: InputMaybe<Scalars['String']>;
  keySubstring?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationDetailsInput>;
  sorting?: InputMaybe<SortingDetailsInput>;
};

export type SearchWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'SearchWhitelabelSiteCustomizableStringResponse';
  errorMessage?: Maybe<Scalars['String']>;
  pagination?: Maybe<PaginationDetails>;
  success?: Maybe<Scalars['Boolean']>;
  whitelabelSiteCustomizableString?: Maybe<Array<Maybe<WhitelabelSiteCustomizableString>>>;
};

export type SecondaryBanner = {
  __typename?: 'SecondaryBanner';
  backgroundColorHex?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  secondaryText?: Maybe<Scalars['String']>;
  secondaryTextColorHex?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type SecondaryBannerInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Scalars['String']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  secondaryText?: InputMaybe<Scalars['String']>;
  secondaryTextColorHex?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

/** Autogenerated return type of SecondaryBannerPlacementCreate */
export type SecondaryBannerPlacementCreatePayload = {
  __typename?: 'SecondaryBannerPlacementCreatePayload';
  /** The newly created secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement;
};

export type SecondaryBannerPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Information of Experiment associated with the placement */
  experiment?: InputMaybe<PlacementExperimentInput>;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** The images on the banner */
  images: GenericImagesInput;
  /** The retailers that this placement should be displayed on */
  includedRetailerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The layout the placement should appear on */
  layout?: InputMaybe<Scalars['String']>;
  /** Locale */
  locale?: InputMaybe<BannerLocaleEnum>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** The priority rank of the placement */
  rank?: InputMaybe<Scalars['Int']>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The style and text of the secondary text */
  secondaryText?: InputMaybe<ConfigurableTextInput>;
  /** The layout the placement should appear on */
  stringLayout?: InputMaybe<Scalars['String']>;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
  /** The type of this placement */
  type: PlacementTypeEnum;
  /** The variant of the banner */
  variant?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SecondaryBannerPlacementUpdate */
export type SecondaryBannerPlacementUpdatePayload = {
  __typename?: 'SecondaryBannerPlacementUpdatePayload';
  /** The updated secondary_banner placement */
  secondaryBannerPlacement: ContentManagementSecondaryBannerPlacement;
};

export type SellSheetAnalyticsSummary = {
  __typename?: 'SellSheetAnalyticsSummary';
  sellSheetId?: Maybe<Scalars['String']>;
  totalOrders?: Maybe<Scalars['BigInt']>;
  totalSalesUsd?: Maybe<Scalars['Float']>;
};

export type SellSheetAnalyticsSummaryGrowthMetrics = {
  __typename?: 'SellSheetAnalyticsSummaryGrowthMetrics';
  sellSheetId?: Maybe<Scalars['String']>;
  totalOrdersGrowth?: Maybe<Scalars['Float']>;
  totalSalesUsdGrowth?: Maybe<Scalars['Float']>;
};

export type SellSheetAnalyticsSummaryRequestInput = {
  dateRange?: InputMaybe<InstacartAdsSharedV1DateRangeInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetAnalyticsSummaryResponse = {
  __typename?: 'SellSheetAnalyticsSummaryResponse';
  analyticsSummary?: Maybe<SellSheetAnalyticsSummary>;
  growthMetrics?: Maybe<SellSheetAnalyticsSummaryGrowthMetrics>;
  previousPeriodMetrics?: Maybe<SellSheetAnalyticsSummary>;
};

export type SellSheetAttributes = {
  __typename?: 'SellSheetAttributes';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  overview?: Maybe<Scalars['String']>;
};

export type SellSheetAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetAttributesResponse = {
  __typename?: 'SellSheetAttributesResponse';
  legalFilterType?: Maybe<LegalFilterType>;
  sellSheetAttributes?: Maybe<SellSheetAttributes>;
};

export type SellSheetBrandProfileAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetBrandProfileAttributesResponse = {
  __typename?: 'SellSheetBrandProfileAttributesResponse';
  brandProfileAttributes?: Maybe<BrandProfileAttributes>;
};

export type SellSheetCard = {
  __typename?: 'SellSheetCard';
  brandImages?: Maybe<Array<Maybe<ImageAsset>>>;
  brandName?: Maybe<Scalars['String']>;
  brandProfileId?: Maybe<Scalars['String']>;
  productDisplays?: Maybe<Array<Maybe<ProductDisplay>>>;
  productImages?: Maybe<Array<Maybe<ImageAsset>>>;
  sellSheetAnalyticsGrowthMetrics?: Maybe<SellSheetAnalyticsSummaryGrowthMetrics>;
  sellSheetAnalyticsSummary?: Maybe<SellSheetAnalyticsSummary>;
  sellSheetAttributes?: Maybe<SellSheetAttributes>;
};

export type SellSheetCardsRequestInput = {
  brandProfileIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isDebug?: InputMaybe<Scalars['Boolean']>;
  paginationRequest?: InputMaybe<InstacartAdsSharedV1PaginationRequestInput>;
  regionalAreas?: InputMaybe<Array<InputMaybe<InstacartAdsNexusV1RegionalArea>>>;
  retailerCarriedState?: InputMaybe<SellSheetRetailerCarriedState>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sortKeys?: InputMaybe<Array<InputMaybe<SellSheetSortKey>>>;
  superCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  superCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type SellSheetCardsResponse = {
  __typename?: 'SellSheetCardsResponse';
  paginationResponse?: Maybe<InstacartAdsSharedV1PaginationResponse>;
  sellSheetCards?: Maybe<Array<Maybe<SellSheetCard>>>;
};

export type SellSheetOverviewAttributes = {
  __typename?: 'SellSheetOverviewAttributes';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['BigInt']>;
};

export type SellSheetProductsAttributesRequestInput = {
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetProductsAttributesResponse = {
  __typename?: 'SellSheetProductsAttributesResponse';
  productsAttributes?: Maybe<Array<Maybe<ProductAttributes>>>;
};

export type SellSheetProductsSummaryTraitsRequestInput = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sellSheetId?: InputMaybe<Scalars['String']>;
};

export type SellSheetProductsSummaryTraitsResponse = {
  __typename?: 'SellSheetProductsSummaryTraitsResponse';
  productsSummaryTraits?: Maybe<Array<Maybe<ProductSummaryTraits>>>;
};

export enum SellSheetRetailerCarriedState {
  PartiallyCarried = 'PARTIALLY_CARRIED',
  RetailerCarriedUnkown = 'RETAILER_CARRIED_UNKOWN'
}

export enum SellSheetSortKey {
  BrandName = 'BRAND_NAME',
  CreatedAt = 'CREATED_AT',
  ProductOrders = 'PRODUCT_ORDERS',
  ProductOrdersGrowth = 'PRODUCT_ORDERS_GROWTH',
  SalesAmount = 'SALES_AMOUNT',
  SalesGrowth = 'SALES_GROWTH',
  SortKeyUnkwown = 'SORT_KEY_UNKWOWN',
  UnitsSold = 'UNITS_SOLD',
  UnitsSoldGrowth = 'UNITS_SOLD_GROWTH'
}

export enum Send {
  /** The campaign has an email template */
  Email = 'email',
  /** The campaign has a push notification template */
  Push = 'push'
}

export type SendWhitelabelSiteRetailerEmailRequestInput = {
  recipient?: InputMaybe<RetailerEmailRecipientInput>;
  sentByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type SendWhitelabelSiteRetailerEmailResponse = {
  __typename?: 'SendWhitelabelSiteRetailerEmailResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type SentinelMember = {
  __typename?: 'SentinelMember';
  activeVersions?: Maybe<Scalars['JSONObject']>;
  attributeName?: Maybe<Scalars['String']>;
  availableVersions?: Maybe<Scalars['JSONObject']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  latestVersion?: Maybe<Scalars['BigInt']>;
  managedAttributeId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SentinelMemberVersion = {
  __typename?: 'SentinelMemberVersion';
  body?: Maybe<Scalars['JSONObject']>;
  changedFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  memberId?: Maybe<Scalars['BigInt']>;
  version?: Maybe<Scalars['BigInt']>;
};

/** Autogenerated return type of SetMobileProperties */
export type SetMobilePropertiesPayload = {
  __typename?: 'SetMobilePropertiesPayload';
  /** The full set of properties */
  mobileAppProperties: Array<OnboardingFeatureTypesProperty>;
};

export type SetMultiRetailerPageCollectionsCacheRequestInput = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type SetMultiRetailerPageCollectionsCacheResponse = {
  __typename?: 'SetMultiRetailerPageCollectionsCacheResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type SetUserSettingRequestInput = {
  client?: InputMaybe<ClientInput>;
  setting?: InputMaybe<UserSettingInput>;
};

export type SetUserSettingResponse = {
  __typename?: 'SetUserSettingResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type ShelfImage = {
  __typename?: 'ShelfImage';
  boundingBox?: Maybe<BoundingBox>;
  capturedAt?: Maybe<Scalars['DateTime']>;
  imageUrl?: Maybe<Scalars['String']>;
};

export type ShelfLocation = {
  __typename?: 'ShelfLocation';
  currentFacings?: Maybe<Scalars['Int']>;
  images?: Maybe<Array<Maybe<ShelfImage>>>;
  location?: Maybe<Scalars['String']>;
};

export enum ShiftTypeEnum {
  FullService = 'FULL_SERVICE',
  PickingOnly = 'PICKING_ONLY',
  Runner = 'RUNNER'
}

export type ShopSidebar = {
  __typename?: 'ShopSidebar';
  collapsed?: Maybe<Scalars['Boolean']>;
};

export type ShoppedAtRetailerInput = {
  /** Id of the country where the check is to be performed */
  countryId?: InputMaybe<Scalars['Int']>;
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** Number of days in the past to check */
  numberOfDays?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the Retailer */
  retailerId: Scalars['Int'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionCreate */
export type ShoppedAtRetailerVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionCreatePayload';
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer;
};

/** Autogenerated return type of ShoppedAtRetailerVisibilityConditionUpdate */
export type ShoppedAtRetailerVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedAtRetailerVisibilityConditionUpdatePayload';
  /** The newly created shopped_at_retailer visibility condition */
  shoppedAtRetailerVisibilityCondition: ContentManagementVisibilityConditionShoppedAtRetailer;
};

export type ShoppedInput = {
  /** Id of the country where the check is to be performed */
  countryId?: InputMaybe<Scalars['Int']>;
  /** Whether the user should have shopped at the retailer */
  hasShopped: Scalars['Boolean'];
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** Number of days in the past to check */
  numberOfDays?: InputMaybe<Scalars['Int']>;
  /** Number of times in the past to check */
  numberOfTimes?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** Id of the store configuraiton for which the check is to be performed */
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ShoppedVisibilityConditionCreate */
export type ShoppedVisibilityConditionCreatePayload = {
  __typename?: 'ShoppedVisibilityConditionCreatePayload';
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped;
};

/** Autogenerated return type of ShoppedVisibilityConditionUpdate */
export type ShoppedVisibilityConditionUpdatePayload = {
  __typename?: 'ShoppedVisibilityConditionUpdatePayload';
  /** The newly created shopped visibility condition */
  shoppedVisibilityCondition: ContentManagementVisibilityConditionShopped;
};

export type ShopperOrderItemScanInput = {
  scannedString?: InputMaybe<Scalars['String']>;
  scannedStringType?: InputMaybe<Scalars['String']>;
};

export type ShopperOrderProfile = {
  __typename?: 'ShopperOrderProfile';
  avatarUrl?: Maybe<Scalars['String']>;
  batchId?: Maybe<Scalars['BigInt']>;
  canChat?: Maybe<Scalars['Boolean']>;
  canReceiveTips?: Maybe<Scalars['Boolean']>;
  canTakeAlcoholOrders?: Maybe<Scalars['Boolean']>;
  deliverer?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  lastName?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  partnerType?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  picker?: Maybe<Scalars['Boolean']>;
  primaryZoneId?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  rolesMask?: Maybe<Scalars['Int']>;
  runner?: Maybe<Scalars['Boolean']>;
  shareCode?: Maybe<Scalars['String']>;
  signatureUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export enum ShopperType {
  ShopperTypeFss = 'SHOPPER_TYPE_FSS',
  ShopperTypePartnerPick = 'SHOPPER_TYPE_PARTNER_PICK',
  ShopperTypeUnknown = 'SHOPPER_TYPE_UNKNOWN'
}

export type SignupPartner = {
  __typename?: 'SignupPartner';
  description?: Maybe<Scalars['String']>;
  hasExclusiveOption?: Maybe<Scalars['Boolean']>;
  hasPriceParityOption?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  skipCreditCheck?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
};

export type Slot = {
  __typename?: 'Slot';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isStatic?: Maybe<Scalars['Boolean']>;
  legacySlotId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SlotCreative = {
  __typename?: 'SlotCreative';
  cartState?: Maybe<CartState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creativeId?: Maybe<Scalars['BigInt']>;
  creativeRank?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['BigInt']>;
  treatmentOfferState?: Maybe<TreatmentOfferState>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SlotCreativeInput = {
  cartState?: InputMaybe<CartState>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SlotInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isStatic?: InputMaybe<Scalars['Boolean']>;
  legacySlotId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type SocialIconNav = {
  __typename?: 'SocialIconNav';
  icons?: Maybe<SocialIconsNavigation>;
  text?: Maybe<SocialIconsTextNavigation>;
};

export type SocialIconNavInput = {
  icons?: InputMaybe<SocialIconsNavigationInput>;
  text?: InputMaybe<SocialIconsTextNavigationInput>;
};

export type SocialIconsNavigation = {
  __typename?: 'SocialIconsNavigation';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
};

export type SocialIconsNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export type SocialIconsTextNavigation = {
  __typename?: 'SocialIconsTextNavigation';
  id?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<NavigationV2Item>>>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  placementId?: Maybe<Scalars['BigInt']>;
};

export type SocialIconsTextNavigationInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  items?: InputMaybe<Array<InputMaybe<NavigationV2ItemInput>>>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  placementId?: InputMaybe<Scalars['BigInt']>;
};

export enum SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnknown = 'SORT_DIRECTION_UNKNOWN'
}

export enum SortDirectionEnum {
  /** Sort in ascending order */
  Asc = 'ASC',
  /** Sort in descending order */
  Desc = 'DESC'
}

export type SortingDetailsInput = {
  direction?: InputMaybe<SortingDirection>;
  fieldName?: InputMaybe<Scalars['String']>;
};

export enum SortingDirection {
  SortingDirectionAsc = 'SORTING_DIRECTION_ASC',
  SortingDirectionDesc = 'SORTING_DIRECTION_DESC',
  SortingDirectionUnknown = 'SORTING_DIRECTION_UNKNOWN'
}

export enum SourceLevel {
  SourceLevelMulti = 'SOURCE_LEVEL_MULTI',
  SourceLevelProduct = 'SOURCE_LEVEL_PRODUCT',
  SourceLevelRetailerProduct = 'SOURCE_LEVEL_RETAILER_PRODUCT',
  SourceLevelUnknown = 'SOURCE_LEVEL_UNKNOWN'
}

export type StageLastmileOrderRequestInput = {
  externalId?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartTypesV1RequestContextInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerProvidedAmounts?: InputMaybe<InstacartEnterpriseBobaCoreTypesV1RetailerProvidedAmountsInput>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type StageLastmileOrderResponse = {
  __typename?: 'StageLastmileOrderResponse';
  order?: Maybe<InstacartEnterpriseBobaCoreTypesV1Order>;
};

export type StandardInfoModalSheet = {
  __typename?: 'StandardInfoModalSheet';
  description?: Maybe<Scalars['String']>;
  desktopImageUrl?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imageAltText?: Maybe<Scalars['String']>;
  linkCta?: Maybe<Scalars['String']>;
  linkCtaAction?: Maybe<BannerAction>;
  linkCtaButtonStyle?: Maybe<ButtonStyle>;
  locale?: Maybe<Scalars['String']>;
  mobileImageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  primaryCta?: Maybe<Scalars['String']>;
  primaryCtaAction?: Maybe<BannerAction>;
  primaryCtaButtonStyle?: Maybe<ButtonStyle>;
  secondaryCta?: Maybe<Scalars['String']>;
  secondaryCtaAction?: Maybe<BannerAction>;
  secondaryCtaButtonStyle?: Maybe<ButtonStyle>;
  title?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type StandardInfoModalSheetInput = {
  description?: InputMaybe<Scalars['String']>;
  desktopImageUrl?: InputMaybe<Scalars['String']>;
  disclaimer?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  linkCta?: InputMaybe<Scalars['String']>;
  linkCtaAction?: InputMaybe<BannerActionInput>;
  linkCtaButtonStyle?: InputMaybe<ButtonStyle>;
  locale?: InputMaybe<Scalars['String']>;
  mobileImageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  primaryCta?: InputMaybe<Scalars['String']>;
  primaryCtaAction?: InputMaybe<BannerActionInput>;
  primaryCtaButtonStyle?: InputMaybe<ButtonStyle>;
  secondaryCta?: InputMaybe<Scalars['String']>;
  secondaryCtaAction?: InputMaybe<BannerActionInput>;
  secondaryCtaButtonStyle?: InputMaybe<ButtonStyle>;
  title?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type StartCampaignInput = {
  /** The id of the campaign returned from the campaign domain */
  campaignId: Scalars['ID'];
  /** The user friendly name of the campaign returned from the campaign domain */
  campaignName?: InputMaybe<Scalars['String']>;
  /** Whether or not to create a split experiment */
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the push notification template returned */
  pushNotificationId?: InputMaybe<Scalars['ID']>;
  /** A unique identifier for the segment. Currently for Braze's API */
  segmentId: Scalars['ID'];
  /** The start time for the email to send. A null value indicates immediately */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The external id of the template returned */
  templateId?: InputMaybe<Scalars['ID']>;
  /** Variables to append to the Braze template */
  templateVariables: TemplateVariablesInput;
  /** The experiment name to use for the CRM Campaign */
  userProvidedExperimentName?: InputMaybe<Scalars['String']>;
  /** The warehouse id to run the campaign for */
  warehouseId: Scalars['ID'];
};

/** Autogenerated return type of StartCampaign */
export type StartCampaignPayload = {
  __typename?: 'StartCampaignPayload';
  /** The campaign configuration object */
  campaignConfiguration: MarketingFeatureTypesCampaignConfiguration;
};

export type StartConvertPlacementVideoRequestInput = {
  localeCode?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  subtitlesUri?: InputMaybe<Scalars['String']>;
  videoUri?: InputMaybe<Scalars['String']>;
};

export type StartConvertPlacementVideoResponse = {
  __typename?: 'StartConvertPlacementVideoResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type StartWhitelabelGumloopWorkflowRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
  workflowName?: InputMaybe<Scalars['String']>;
  workflowParameters?: InputMaybe<WhitelabelGumloopWorkflowParametersInput>;
};

export type StartWhitelabelGumloopWorkflowResponse = {
  __typename?: 'StartWhitelabelGumloopWorkflowResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  waterfallEffectId?: Maybe<Scalars['BigInt']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
  workflowRunId?: Maybe<Scalars['String']>;
};

export enum Status {
  Active = 'ACTIVE',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
  Live = 'LIVE'
}

export type StatusMapInput = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<FilterType>;
  status?: InputMaybe<FilterType>;
};

export enum StockStatus {
  StockStatusFilled = 'STOCK_STATUS_FILLED',
  StockStatusLow = 'STOCK_STATUS_LOW',
  StockStatusOos = 'STOCK_STATUS_OOS',
  StockStatusPredictedLow = 'STOCK_STATUS_PREDICTED_LOW',
  StockStatusUnknown = 'STOCK_STATUS_UNKNOWN'
}

export enum StockStatusFilter {
  StockStatusFilterOos = 'STOCK_STATUS_FILTER_OOS',
  StockStatusFilterPredictedLow = 'STOCK_STATUS_FILTER_PREDICTED_LOW',
  StockStatusFilterUnknown = 'STOCK_STATUS_FILTER_UNKNOWN'
}

export enum Store {
  /** Retailer with 1 hour delivery */
  OneHour = 'one_hour',
  /** Retailer with 30 min delivery */
  ThirtyMin = 'thirty_min'
}

export type StoreConfiguration = {
  __typename?: 'StoreConfiguration';
  enterpriseRetailerSettings?: Maybe<Scalars['JSONObject']>;
  environment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  linkedStoreConfigurationId?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  userIsolationContextId?: Maybe<Scalars['Int']>;
};

export type StoreConfigurationDraft = {
  __typename?: 'StoreConfigurationDraft';
  createdAt?: Maybe<Scalars['DateTime']>;
  domainConfigurations?: Maybe<DomainConfiguration>;
  domainConfigurationsRaw?: Maybe<Scalars['JSONObject']>;
  draftId?: Maybe<Scalars['String']>;
  draftName?: Maybe<Scalars['String']>;
  parentDraftId?: Maybe<Scalars['String']>;
  partnerAccessOptions?: Maybe<PartnerAccessOptionsSchema>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StoreConfigurationInput = {
  enterpriseRetailerSettings?: InputMaybe<Scalars['JSONObject']>;
  environment?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  linkedStoreConfigurationId?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Scalars['JSONObject']>;
  userIsolationContextId?: InputMaybe<Scalars['Int']>;
};

export enum StoreConfigurationRelationshipEnum {
  /** StoreConfigurations that are associated */
  Associated = 'ASSOCIATED',
  /** StoreConfigurations that are owned */
  Owner = 'OWNER'
}

export type StoreHours = {
  __typename?: 'StoreHours';
  overrideHours?: Maybe<Array<Maybe<OverrideHours>>>;
  regularHours?: Maybe<Array<Maybe<RegularHours>>>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type StoreHoursByDate = {
  __typename?: 'StoreHoursByDate';
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<GoogleTypeDate>;
  endsAt?: Maybe<GoogleTypeTimeOfDay>;
  operationalHours?: Maybe<OperationalHours>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerLocationFlags?: Maybe<RetailerLocationFlags>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  startsAt?: Maybe<GoogleTypeTimeOfDay>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export type StoreHoursByDayOfWeek = {
  __typename?: 'StoreHoursByDayOfWeek';
  createdAt?: Maybe<Scalars['DateTime']>;
  dayOfWeek?: Maybe<GoogleTypeDayOfWeek>;
  endsAt?: Maybe<GoogleTypeTimeOfDay>;
  operationalHours?: Maybe<OperationalHours>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerLocationFlags?: Maybe<RetailerLocationFlags>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  startsAt?: Maybe<GoogleTypeTimeOfDay>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export type StoreHoursByZoneRetailer = {
  __typename?: 'StoreHoursByZoneRetailer';
  createdAt?: Maybe<Scalars['DateTime']>;
  date?: Maybe<GoogleTypeDate>;
  endsAt?: Maybe<GoogleTypeTimeOfDay>;
  retailerId?: Maybe<Scalars['BigInt']>;
  startsAt?: Maybe<GoogleTypeTimeOfDay>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export type StoreHoursUpdateTask = {
  __typename?: 'StoreHoursUpdateTask';
  author?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  failedUpdates?: Maybe<Array<Maybe<FailedUpdate>>>;
  id?: Maybe<Scalars['BigInt']>;
  status?: Maybe<TaskStatus>;
  updateSource?: Maybe<Scalars['String']>;
  updatedRetailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type StorePerformanceRecord = {
  __typename?: 'StorePerformanceRecord';
  name?: Maybe<Scalars['String']>;
  overstaffedHours?: Maybe<InstacartTypesV1BigDecimal>;
  recommendedHours?: Maybe<InstacartTypesV1BigDecimal>;
  scheduledDevices?: Maybe<Scalars['Int']>;
  scheduledGaps?: Maybe<Scalars['Int']>;
  scheduledHours?: Maybe<InstacartTypesV1BigDecimal>;
  understaffedHours?: Maybe<InstacartTypesV1BigDecimal>;
  warehouseLocationId?: Maybe<Scalars['BigInt']>;
};

export type StorePerformanceRequestInput = {
  endDate?: InputMaybe<GoogleTypeDateInput>;
  startDate?: InputMaybe<GoogleTypeDateInput>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type StorePerformanceResponse = {
  __typename?: 'StorePerformanceResponse';
  metric?: Maybe<Array<Maybe<StorePerformanceRecord>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

export enum Storefront {
  /** Marketplace storefront */
  Instacart = 'instacart',
  /** Storefront / Storefront PRO storefronts */
  Pbi = 'pbi'
}

export type StorefrontFlyers = {
  __typename?: 'StorefrontFlyers';
  limit?: Maybe<Scalars['BigInt']>;
  maxPastCount?: Maybe<Scalars['BigInt']>;
  maxUpcomingCount?: Maybe<Scalars['BigInt']>;
};

export type StorefrontHiddenBadges = {
  __typename?: 'StorefrontHiddenBadges';
  highlyInStock?: Maybe<Scalars['Boolean']>;
};

export type StorefrontLayouts = {
  __typename?: 'StorefrontLayouts';
  activeVariants?: Maybe<StorefrontLayoutsActiveVariants>;
  desktopFlexibleHeaderLayoutV1?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1>;
  desktopSidebarLayoutV1?: Maybe<StorefrontLayoutsDesktopSidebarLayoutV1>;
  mobileWebHamburgerMenuLayoutV1?: Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1>;
  mobileWebHeaderLayoutV1?: Maybe<StorefrontLayoutsMobileWebHeaderLayoutV1>;
  nativeAppHeaderLayoutV1?: Maybe<StorefrontLayoutsNativeAppHeaderLayoutV1>;
  nativeMoreMenuLayoutV1?: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1>;
  nativeStoreMenuLayoutV1?: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1>;
};

export type StorefrontLayoutsActiveVariants = {
  __typename?: 'StorefrontLayoutsActiveVariants';
  desktop?: Maybe<StorefrontLayoutsActiveVariantsDesktop>;
  mobileWeb?: Maybe<StorefrontLayoutsActiveVariantsMobileWeb>;
  nativeApp?: Maybe<StorefrontLayoutsActiveVariantsNativeApp>;
};

export type StorefrontLayoutsActiveVariantsDesktop = {
  __typename?: 'StorefrontLayoutsActiveVariantsDesktop';
  footerVariant?: Maybe<StorefrontLayoutsActiveVariantsDesktopFooterVariants>;
  hamburgerMenuVariant?: Maybe<StorefrontLayoutsActiveVariantsDesktopHamburgerMenuVariants>;
  headerVariant?: Maybe<StorefrontLayoutsActiveVariantsDesktopHeaderVariants>;
  sidebarVariant?: Maybe<StorefrontLayoutsActiveVariantsDesktopSidebarVariants>;
};

export enum StorefrontLayoutsActiveVariantsDesktopFooterVariants {
  DesktopFooterLayoutUnknown = 'DESKTOP_FOOTER_LAYOUT_UNKNOWN',
  DesktopFooterLayoutV1 = 'DESKTOP_FOOTER_LAYOUT_V1',
  FooterVariantsUnknown = 'FOOTER_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsDesktopHamburgerMenuVariants {
  DesktopHamburgerMenuLayoutUnknown = 'DESKTOP_HAMBURGER_MENU_LAYOUT_UNKNOWN',
  DesktopHamburgerMenuLayoutV1 = 'DESKTOP_HAMBURGER_MENU_LAYOUT_V1',
  HamburgerMenuVariantsUnknown = 'HAMBURGER_MENU_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsDesktopHeaderVariants {
  DesktopFlexibleHeaderLayoutV1 = 'DESKTOP_FLEXIBLE_HEADER_LAYOUT_V1',
  DesktopHeaderLayoutUnknown = 'DESKTOP_HEADER_LAYOUT_UNKNOWN',
  HeaderVariantsUnknown = 'HEADER_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsDesktopSidebarVariants {
  DesktopSidebarLayoutUnknown = 'DESKTOP_SIDEBAR_LAYOUT_UNKNOWN',
  DesktopSidebarLayoutV1 = 'DESKTOP_SIDEBAR_LAYOUT_V1',
  SidebarVariantsUnknown = 'SIDEBAR_VARIANTS_UNKNOWN'
}

export type StorefrontLayoutsActiveVariantsMobileWeb = {
  __typename?: 'StorefrontLayoutsActiveVariantsMobileWeb';
  hamburgerMenuVariant?: Maybe<StorefrontLayoutsActiveVariantsMobileWebMobileWebHamburgerMenuVariants>;
  headerVariant?: Maybe<StorefrontLayoutsActiveVariantsMobileWebMobileWebHeaderVariants>;
};

export enum StorefrontLayoutsActiveVariantsMobileWebMobileWebHamburgerMenuVariants {
  MobileWebHamburgerMenuLayoutUnspecified = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_UNSPECIFIED',
  MobileWebHamburgerMenuLayoutV1 = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_V1',
  MobileWebHamburgerMenuVariantsUnknown = 'MOBILE_WEB_HAMBURGER_MENU_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsMobileWebMobileWebHeaderVariants {
  MobileWebHeaderLayoutUnspecified = 'MOBILE_WEB_HEADER_LAYOUT_UNSPECIFIED',
  MobileWebHeaderLayoutV1 = 'MOBILE_WEB_HEADER_LAYOUT_V1',
  MobileWebHeaderVariantsUnknown = 'MOBILE_WEB_HEADER_VARIANTS_UNKNOWN'
}

export type StorefrontLayoutsActiveVariantsNativeApp = {
  __typename?: 'StorefrontLayoutsActiveVariantsNativeApp';
  headerVariant?: Maybe<StorefrontLayoutsActiveVariantsNativeAppNativeAppHeaderVariants>;
  moreMenuVariant?: Maybe<StorefrontLayoutsActiveVariantsNativeAppNativeMoreMenuVariants>;
  storeMenuVariant?: Maybe<StorefrontLayoutsActiveVariantsNativeAppNativeStoreMenuVariants>;
};

export enum StorefrontLayoutsActiveVariantsNativeAppNativeAppHeaderVariants {
  NativeAppHeaderLayoutUnspecified = 'NATIVE_APP_HEADER_LAYOUT_UNSPECIFIED',
  NativeAppHeaderLayoutV1 = 'NATIVE_APP_HEADER_LAYOUT_V1',
  NativeAppHeaderVariantsUnknown = 'NATIVE_APP_HEADER_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsNativeAppNativeMoreMenuVariants {
  NativeMoreMenuLayoutUnknown = 'NATIVE_MORE_MENU_LAYOUT_UNKNOWN',
  NativeMoreMenuLayoutV1 = 'NATIVE_MORE_MENU_LAYOUT_V1',
  NativeMoreMenuVariantsUnknown = 'NATIVE_MORE_MENU_VARIANTS_UNKNOWN'
}

export enum StorefrontLayoutsActiveVariantsNativeAppNativeStoreMenuVariants {
  NativeStoreMenuLayoutUnspecified = 'NATIVE_STORE_MENU_LAYOUT_UNSPECIFIED',
  NativeStoreMenuLayoutV1 = 'NATIVE_STORE_MENU_LAYOUT_V1',
  NativeStoreMenuVariantsUnknown = 'NATIVE_STORE_MENU_VARIANTS_UNKNOWN'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1 = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1';
  clientElementConfigurations?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurations>;
  dynamicElementConfigurationsHeaderBar1?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations>;
  dynamicElementConfigurationsHeaderBar2?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations>;
  headerBar1?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar>;
  headerBar2?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurations = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurations';
  account?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsAccount>;
  cart?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCart>;
  fulfillmentSelector?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelector>;
  search?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearch>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsAccount = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsAccount';
  showName?: Maybe<Scalars['Boolean']>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCart = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCart';
  variant?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCartCartVariant>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsCartCartVariant {
  CartVariantUnknown = 'CART_VARIANT_UNKNOWN',
  Default = 'DEFAULT',
  Outlined = 'OUTLINED'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelector = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelector';
  storeLabel?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorStoreLabelType>;
  variant?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorFulfillmentSelectorVariant>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorFulfillmentSelectorVariant {
  FulfillmentSelectorVariantUnknown = 'FULFILLMENT_SELECTOR_VARIANT_UNKNOWN',
  MultiLine = 'MULTI_LINE',
  SingleLine = 'SINGLE_LINE'
}

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsFulfillmentSelectorStoreLabelType {
  StoreAddress = 'STORE_ADDRESS',
  StoreLabelTypeUnknown = 'STORE_LABEL_TYPE_UNKNOWN',
  StoreName = 'STORE_NAME'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearch = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearch';
  variant?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearchSearchVariant>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1ClientElementConfigurationsSearchSearchVariant {
  Branded = 'BRANDED',
  Default = 'DEFAULT',
  SearchVariantUnknown = 'SEARCH_VARIANT_UNKNOWN'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurations';
  adminColumn1FeaturedLinksBlock?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock>;
  adminColumn1LinksBlock?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsHeaderBarLinksBlock>;
  adminColumn2FeaturedLinksBlock?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsFeaturedLinksBlock';
  navs?: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsHeaderBarLinksBlock = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1DynamicElementConfigurationsHeaderBarLinksBlock';
  navs?: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBar';
  column1Elements?: Maybe<Array<Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn1Elements>>>;
  column2Elements?: Maybe<Array<Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn2Elements>>>;
  size?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarSize>;
  sticky?: Maybe<Scalars['Boolean']>;
  theme?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarTheme>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn1Elements {
  Column1ElementsSearch = 'COLUMN1_ELEMENTS_SEARCH',
  Column1ElementsUnknown = 'COLUMN1_ELEMENTS_UNKNOWN',
  HamburgerMenu = 'HAMBURGER_MENU',
  HeaderBarLinksBlock = 'HEADER_BAR_LINKS_BLOCK',
  Logo = 'LOGO',
  WarehouseSelector = 'WAREHOUSE_SELECTOR'
}

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarColumn2Elements {
  Account = 'ACCOUNT',
  Cart = 'CART',
  Column2ElementsUnknown = 'COLUMN2_ELEMENTS_UNKNOWN',
  FeaturedLinksBlock = 'FEATURED_LINKS_BLOCK',
  FulfillmentSelector = 'FULFILLMENT_SELECTOR',
  LanguageSelector = 'LANGUAGE_SELECTOR',
  Search = 'SEARCH'
}

export type StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarTheme = {
  __typename?: 'StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarTheme';
  backgroundColor?: Maybe<AtomsColor>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  backgroundType?: Maybe<StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarThemeBackgroundType>;
};

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarHeaderBarThemeBackgroundType {
  BackgroundTypeUnknown = 'BACKGROUND_TYPE_UNKNOWN',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export enum StorefrontLayoutsDesktopFlexibleHeaderLayoutV1HeaderBarSize {
  Large = 'LARGE',
  SizeUnknown = 'SIZE_UNKNOWN',
  Small = 'SMALL'
}

export type StorefrontLayoutsDesktopSidebarLayoutV1 = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1';
  dynamicElementConfigurations?: Maybe<StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurations>;
  retailerElements?: Maybe<Array<Maybe<StorefrontLayoutsDesktopSidebarLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurations';
  navigations?: Maybe<StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurationsNavigations>;
};

export type StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1DynamicElementConfigurationsNavigations';
  navs?: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsDesktopSidebarLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsDesktopSidebarLayoutV1RetailerElements';
  elements?: Maybe<Array<Maybe<StorefrontLayoutsDesktopSidebarLayoutV1RetailerElementsElementsType>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsDesktopSidebarLayoutV1RetailerElementsElementsType {
  Departments = 'DEPARTMENTS',
  DesktopSidebarLayoutV1ElementsTypeUnknown = 'DESKTOP_SIDEBAR_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR'
}

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1 = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1';
  dynamicElementConfigurations?: Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurations>;
  retailerElements?: Maybe<Array<Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurations';
  navigations?: Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurationsNavigations>;
};

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1DynamicElementConfigurationsNavigations';
  navs?: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElements';
  elements?: Maybe<Array<Maybe<StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElementsElementsType>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsMobileWebHamburgerMenuLayoutV1RetailerElementsElementsType {
  AccountOrAuthenticationArea = 'ACCOUNT_OR_AUTHENTICATION_AREA',
  Departments = 'DEPARTMENTS',
  FooterDisclaimer = 'FOOTER_DISCLAIMER',
  LanguageSelector = 'LANGUAGE_SELECTOR',
  MobileWebHamburgerMenuLayoutV1ElementsTypeUnknown = 'MOBILE_WEB_HAMBURGER_MENU_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR',
  SocialLinks = 'SOCIAL_LINKS',
  WarehouseSelector = 'WAREHOUSE_SELECTOR'
}

export type StorefrontLayoutsMobileWebHeaderLayoutV1 = {
  __typename?: 'StorefrontLayoutsMobileWebHeaderLayoutV1';
  theme?: Maybe<StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarTheme>;
};

export type StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarTheme = {
  __typename?: 'StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarTheme';
  backgroundColor?: Maybe<AtomsColor>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  backgroundType?: Maybe<StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarThemeBackgroundType>;
};

export enum StorefrontLayoutsMobileWebHeaderLayoutV1HeaderBarThemeBackgroundType {
  BackgroundTypeUnknown = 'BACKGROUND_TYPE_UNKNOWN',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type StorefrontLayoutsNativeAppHeaderLayoutV1 = {
  __typename?: 'StorefrontLayoutsNativeAppHeaderLayoutV1';
  theme?: Maybe<StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarTheme>;
};

export type StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarTheme = {
  __typename?: 'StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarTheme';
  backgroundColor?: Maybe<AtomsColor>;
  backgroundType?: Maybe<StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarThemeBackgroundType>;
};

export enum StorefrontLayoutsNativeAppHeaderLayoutV1HeaderBarThemeBackgroundType {
  BackgroundTypeUnknown = 'BACKGROUND_TYPE_UNKNOWN',
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type StorefrontLayoutsNativeMoreMenuLayoutV1 = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1';
  dynamicElementConfigurations?: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurations>;
  retailerElements?: Maybe<Array<Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurations';
  navigations?: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsNavigations>;
  slots?: Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsSlots>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsNavigations';
  navs?: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsSlots = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1DynamicElementConfigurationsSlots';
  slots?: Maybe<Array<Maybe<RetailerSlot>>>;
};

export type StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElements';
  elements?: Maybe<Array<Maybe<StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElementsElementsType>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsNativeMoreMenuLayoutV1RetailerElementsElementsType {
  AccountLinks = 'ACCOUNT_LINKS',
  AuthLinks = 'AUTH_LINKS',
  FooterDisclaimer = 'FOOTER_DISCLAIMER',
  NativeMoreMenuLayoutV1ElementsTypeUnknown = 'NATIVE_MORE_MENU_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR',
  SocialLinks = 'SOCIAL_LINKS'
}

export type StorefrontLayoutsNativeStoreMenuLayoutV1 = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1';
  dynamicElementConfigurations?: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurations>;
  retailerElements?: Maybe<Array<Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElements>>>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurations = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurations';
  navigations?: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsNavigations>;
  slots?: Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsSlots>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsNavigations = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsNavigations';
  navs?: Maybe<Array<Maybe<RetailerNav>>>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsSlots = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1DynamicElementConfigurationsSlots';
  slots?: Maybe<Array<Maybe<RetailerSlot>>>;
};

export type StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElements = {
  __typename?: 'StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElements';
  elements?: Maybe<Array<Maybe<StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElementsElementsType>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export enum StorefrontLayoutsNativeStoreMenuLayoutV1RetailerElementsElementsType {
  Departments = 'DEPARTMENTS',
  NativeStoreMenuLayoutV1ElementsTypeUnknown = 'NATIVE_STORE_MENU_LAYOUT_V1_ELEMENTS_TYPE_UNKNOWN',
  Navigation = 'NAVIGATION',
  Separator = 'SEPARATOR'
}

export type StorefrontLocationSelector = {
  __typename?: 'StorefrontLocationSelector';
  showCrossRetailerInStoreLocations?: Maybe<Scalars['Boolean']>;
  showCrossRetailerPickupLocations?: Maybe<Scalars['Boolean']>;
  showNameForDeliveryLocation?: Maybe<Scalars['Boolean']>;
  showRetailerNameForHeaderStoreLocation?: Maybe<Scalars['Boolean']>;
};

export type StorefrontPlacementBannerInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** A unique identifier of the banner associated with the placement */
  id?: InputMaybe<Scalars['ID']>;
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: PlacementImagesInput;
  /** The banner's locale (not used right now) */
  locale: BannerLocaleEnum;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
};

/** Autogenerated return type of StorefrontPlacementCreate */
export type StorefrontPlacementCreatePayload = {
  __typename?: 'StorefrontPlacementCreatePayload';
  /** The newly created storefront storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement;
};

/** Autogenerated return type of StorefrontPlacementDelete */
export type StorefrontPlacementDeletePayload = {
  __typename?: 'StorefrontPlacementDeletePayload';
  /** Whether deleting the storefront placement succeeded or not */
  success: Scalars['Boolean'];
};

export type StorefrontPlacementInput = {
  /** The color of the background for text placements (Eg. #FFFFFF) */
  backgroundColor: Scalars['String'];
  /** The banners configured to the placement */
  banners?: InputMaybe<Array<StorefrontPlacementBannerInput>>;
  /** The style and text of the button within the placement */
  button: ConfigurableButtonInput;
  /** The style and text of the description */
  descriptionText: ConfigurableTextInput;
  /** Where interacting with the placement leads */
  destination?: InputMaybe<PlacementDestinationInput>;
  /** The style and text of the heading */
  headingText: ConfigurableTextInput;
  /** the alt text for the placement images */
  imageAltText: Scalars['String'];
  /** The possible placement images to display */
  images: PlacementImagesInput;
  /** The store configurations that this placement should be displayed on */
  includedStoreConfigurationIds?: InputMaybe<Array<Scalars['Int']>>;
  /** The name of the placement */
  name: Scalars['String'];
  /** The platform which this placement should be displayed */
  platform: Array<PlacementPlatformEnum>;
  /** When the placement begins and ends */
  scheduling: PlacementScheduleInput;
  /** The style and text of the subheading */
  subheadingText: ConfigurableTextInput;
  /** The type of this placement */
  type: PlacementTypeEnum;
};

/** Autogenerated return type of StorefrontPlacementUpdate */
export type StorefrontPlacementUpdatePayload = {
  __typename?: 'StorefrontPlacementUpdatePayload';
  /** The updated storefront placement */
  storefrontPlacement: ContentManagementStorefrontPlacement;
};

export type StorefrontSchema = {
  __typename?: 'StorefrontSchema';
  crossRetailersCustomStorefrontAllowed?: Maybe<Scalars['Boolean']>;
  crossRetailersDepartmentsAllowed?: Maybe<Scalars['Boolean']>;
  crossRetailersDepartmentsPrimaryRetailerId?: Maybe<Scalars['BigInt']>;
  defaultServiceType?: Maybe<InstacartCustomersSharedV1ServiceType>;
  displayCustomAttributes?: Maybe<Scalars['Boolean']>;
  flyers?: Maybe<StorefrontFlyers>;
  hiddenBadges?: Maybe<StorefrontHiddenBadges>;
  hideOutOfStockItemsInSearch?: Maybe<Scalars['Boolean']>;
  layouts?: Maybe<StorefrontLayouts>;
  locationSelector?: Maybe<StorefrontLocationSelector>;
  minOnSaleCarouselItems?: Maybe<Scalars['BigInt']>;
  minStockLevel?: Maybe<InstacartCustomersProductsV1StockLevel>;
  onlyShowInStockItems?: Maybe<Scalars['Boolean']>;
  salePromotionBadgeInDollars?: Maybe<Scalars['Boolean']>;
  sfpEmailLogEnabled?: Maybe<Scalars['Boolean']>;
  showRetailerReferenceCodeOnItemDetails?: Maybe<Scalars['Boolean']>;
};

export type StringsInput = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type StyleFields = {
  __typename?: 'StyleFields';
  background?: Maybe<Background>;
  headerAlignment?: Maybe<StyleFieldsHeaderAlignment>;
  placementAlignment?: Maybe<StyleFieldsPlacementAlignment>;
  spacing?: Maybe<StyleFieldsSpacing>;
};

export enum StyleFieldsHeaderAlignment {
  HeaderAlignmentCenter = 'HEADER_ALIGNMENT_CENTER',
  HeaderAlignmentLeft = 'HEADER_ALIGNMENT_LEFT',
  HeaderAlignmentRight = 'HEADER_ALIGNMENT_RIGHT',
  HeaderAlignmentUnspecified = 'HEADER_ALIGNMENT_UNSPECIFIED'
}

export type StyleFieldsInput = {
  background?: InputMaybe<BackgroundInput>;
  headerAlignment?: InputMaybe<StyleFieldsHeaderAlignment>;
  placementAlignment?: InputMaybe<StyleFieldsPlacementAlignment>;
  spacing?: InputMaybe<StyleFieldsSpacingInput>;
};

export enum StyleFieldsPlacementAlignment {
  PlacementAlignmentCenter = 'PLACEMENT_ALIGNMENT_CENTER',
  PlacementAlignmentLeft = 'PLACEMENT_ALIGNMENT_LEFT',
  PlacementAlignmentRight = 'PLACEMENT_ALIGNMENT_RIGHT',
  PlacementAlignmentUnspecified = 'PLACEMENT_ALIGNMENT_UNSPECIFIED'
}

export type StyleFieldsSpacing = {
  __typename?: 'StyleFieldsSpacing';
  bottomPx?: Maybe<Scalars['Int']>;
  topPx?: Maybe<Scalars['Int']>;
};

export type StyleFieldsSpacingInput = {
  bottomPx?: InputMaybe<Scalars['Int']>;
  topPx?: InputMaybe<Scalars['Int']>;
};

export type SubNavigation = {
  __typename?: 'SubNavigation';
  flatNavigation?: Maybe<FlatNavigation>;
  navigationItem?: Maybe<NavigationV2Item>;
};

export type SubNavigationInput = {
  flatNavigation?: InputMaybe<FlatNavigationInput>;
  navigationItem?: InputMaybe<NavigationV2ItemInput>;
};

export type SubjectCriteria = {
  __typename?: 'SubjectCriteria';
  categoryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l1CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l2CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l3CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l4CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l5CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  l6CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notCategoryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL1CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL2CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL3CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL4CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL5CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  notL6CategoryId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  onSale?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  term?: Maybe<Array<Maybe<Scalars['String']>>>;
  termRelevanceThreshold?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of SubmissionCreate */
export type SubmissionCreatePayload = {
  __typename?: 'SubmissionCreatePayload';
  /** Survey submit successful */
  success: Scalars['Boolean'];
};

/** Input for submitBulkRoleOperation. */
export type SubmitBulkRoleOperationInput = {
  breakglassJustification?: InputMaybe<Scalars['String']>;
  /** When true, return only `preview` counts; do not execute. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  isBreakglass?: InputMaybe<Scalars['Boolean']>;
  /** Modify permission change; server expands into rows. Mutually exclusive with `rows`. */
  membership?: InputMaybe<MembershipDeltaInput>;
  mode?: InputMaybe<BulkRoleMode>;
  /** Client-generated UUID. Used as idempotency key and audit trace_id. */
  operationId: Scalars['ID'];
  rows?: InputMaybe<Array<BulkRoleRowInput>>;
  /** Which roles the guided `membership` change applies to. */
  targets?: InputMaybe<RoleTargetSelectorInput>;
};

/** Autogenerated return type of SubmitBulkRoleOperation */
export type SubmitBulkRoleOperationPayload = {
  __typename?: 'SubmitBulkRoleOperationPayload';
  amsRequest?: Maybe<AmsRequest>;
  operation?: Maybe<BulkOperation>;
  parseErrors: Array<BulkParseError>;
  preview?: Maybe<BulkAccountManagementTypesBulkOperationPreview>;
};

/** Input for submitBulkUserOperation. */
export type SubmitBulkUserOperationInput = {
  breakglassJustification?: InputMaybe<Scalars['String']>;
  /** When true, return only `preview` counts; do not execute. */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  isBreakglass?: InputMaybe<Scalars['Boolean']>;
  /** Modify homogeneous change; server expands into rows. Mutually exclusive with `rows`. */
  membership?: InputMaybe<MembershipDeltaInput>;
  mode?: InputMaybe<BulkUserMode>;
  /** Client-generated UUID. Used as idempotency key and audit trace_id. */
  operationId: Scalars['ID'];
  rows?: InputMaybe<Array<BulkUserRowInput>>;
  /** Who the guided `membership` change applies to. */
  targets?: InputMaybe<TargetSelectorInput>;
};

/** Autogenerated return type of SubmitBulkUserOperation */
export type SubmitBulkUserOperationPayload = {
  __typename?: 'SubmitBulkUserOperationPayload';
  amsRequest?: Maybe<AmsRequest>;
  operation?: Maybe<BulkOperation>;
  parseErrors: Array<BulkParseError>;
  preview?: Maybe<BulkAccountManagementTypesBulkOperationPreview>;
};

export type SummaryDetails = {
  __typename?: 'SummaryDetails';
  details?: Maybe<Scalars['String']>;
};

export type SummaryStatus = {
  __typename?: 'SummaryStatus';
  count?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Scalars['String']>;
};

/** Selects the users a guided operation applies to. */
export type TargetSelectorInput = {
  canonicalIds?: InputMaybe<Array<Scalars['ID']>>;
  emails?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<UserSelectionFilters>;
  /** Apply to every user matching the filters (subject to the server result cap), not just the pasted ids. */
  selectAllMatching?: InputMaybe<Scalars['Boolean']>;
};

export enum Targeting {
  ActivatedCustomer = 'ACTIVATED_CUSTOMER',
  ChurnedCustomer = 'CHURNED_CUSTOMER',
  LoyaltyCustomer = 'LOYALTY_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  NonLoyaltyCustomer = 'NON_LOYALTY_CUSTOMER',
  Unknown = 'UNKNOWN'
}

export type TargetingRules = {
  __typename?: 'TargetingRules';
  lookbackWindowDays?: Maybe<Scalars['BigInt']>;
  targetingType?: Maybe<Targeting>;
};

export type TargetingRulesInput = {
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  targetingType?: InputMaybe<Targeting>;
};

export enum TaskStatus {
  CompletedFailure = 'COMPLETED_FAILURE',
  CompletedSuccess = 'COMPLETED_SUCCESS',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  TaskStatusUndefined = 'TASK_STATUS_UNDEFINED'
}

export type TemplateVariablesInput = {
  couponCode?: InputMaybe<Scalars['String']>;
  daysValid?: InputMaybe<Scalars['Int']>;
  editableTemplateVariables?: InputMaybe<Scalars['JSON']>;
  offerDetailsDollarOff?: InputMaybe<Scalars['String']>;
  offerDetailsMinimumOrder?: InputMaybe<Scalars['String']>;
  retailerLogoUrl?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
  storeType?: InputMaybe<Store>;
  storefrontType?: InputMaybe<Storefront>;
};

export type TestCase = {
  __typename?: 'TestCase';
  applicable?: Maybe<Scalars['Boolean']>;
  capabilityPath?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  scenario?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type TextWithThumbnail = {
  __typename?: 'TextWithThumbnail';
  backgroundColorHex?: Maybe<Scalars['String']>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type TextWithThumbnailFlex = {
  __typename?: 'TextWithThumbnailFlex';
  backgroundColorHex?: Maybe<Scalars['String']>;
  backgroundImageUrl?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<BannerAction>;
  ctaBackgroundColorHex?: Maybe<Scalars['String']>;
  ctaColorHex?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  placementId?: Maybe<Scalars['BigInt']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
  variant?: Maybe<BannerVariant>;
};

export type TextWithThumbnailFlexInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type TextWithThumbnailInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  backgroundImageUrl?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<BannerActionInput>;
  ctaBackgroundColorHex?: InputMaybe<Scalars['String']>;
  ctaColorHex?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
  variant?: InputMaybe<BannerVariant>;
};

export type ThemePage = {
  __typename?: 'ThemePage';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  headerSection?: Maybe<ThemePageHeader>;
  id?: Maybe<Scalars['BigInt']>;
  retailerPicker?: Maybe<ThemePageRetailerPicker>;
  searchBar?: Maybe<ThemePageSearchBar>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ThemePageHeader = {
  __typename?: 'ThemePageHeader';
  backgroundColorHex?: Maybe<Scalars['String']>;
  disclaimerUrl?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  imageAltText?: Maybe<Scalars['String']>;
  imageMobileUrl?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  subTitleColorHex?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleColorHex?: Maybe<Scalars['String']>;
};

export type ThemePageHeaderInput = {
  backgroundColorHex?: InputMaybe<Scalars['String']>;
  disclaimerUrl?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageMobileUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  subTitleColorHex?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleColorHex?: InputMaybe<Scalars['String']>;
};

export type ThemePageInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  headerSection?: InputMaybe<ThemePageHeaderInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  retailerPicker?: InputMaybe<ThemePageRetailerPickerInput>;
  searchBar?: InputMaybe<ThemePageSearchBarInput>;
  slug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ThemePageRetailerPicker = {
  __typename?: 'ThemePageRetailerPicker';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ThemePageRetailerPickerInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ThemePageSearchBar = {
  __typename?: 'ThemePageSearchBar';
  enabled?: Maybe<Scalars['Boolean']>;
};

export type ThemePageSearchBarInput = {
  enabled?: InputMaybe<Scalars['Boolean']>;
};

export type ThemeSchema = {
  __typename?: 'ThemeSchema';
  footer?: Maybe<Footer>;
  header?: Maybe<Header>;
  idsTheme?: Maybe<IdsThemeSchema>;
  items?: Maybe<ItemsSchema>;
  shopSidebar?: Maybe<ShopSidebar>;
};

export enum TicketStatus {
  TicketStatusCompleted = 'TICKET_STATUS_COMPLETED',
  TicketStatusInProgress = 'TICKET_STATUS_IN_PROGRESS',
  TicketStatusUnknown = 'TICKET_STATUS_UNKNOWN',
  TicketStatusWontDo = 'TICKET_STATUS_WONT_DO'
}

export type TimePeriod = {
  __typename?: 'TimePeriod';
  closesAt?: Maybe<Scalars['DateTime']>;
  opensAt?: Maybe<Scalars['DateTime']>;
};

export enum TokenTypeEnum {
  /** Account Setup Token Type */
  AccountSetup = 'account_setup',
  /** Email Verification Token Type */
  EmailVerification = 'email_verification',
  /** Password Reset Token Type */
  PasswordReset = 'password_reset'
}

export type TokensValidation = {
  __typename?: 'TokensValidation';
  /** Whether account is already set up */
  accountStateValid: Scalars['Boolean'];
  /** Email associated with the token */
  email?: Maybe<Scalars['String']>;
  /** Whether the token is valid */
  valid: Scalars['Boolean'];
};

export type TombstoneDetectionVersionRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  tombstonedBy?: InputMaybe<Scalars['String']>;
  tombstonedWhy?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type TombstoneDetectionVersionResponse = {
  __typename?: 'TombstoneDetectionVersionResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type ToolCall = {
  __typename?: 'ToolCall';
  function: Function;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ToolCallInput = {
  function: FunctionInput;
  id: Scalars['String'];
  type: Scalars['String'];
};

export type ToolInput = {
  function: FunctionDefinitionInput;
  type: Scalars['String'];
};

export type ToolingShortcut = {
  __typename?: 'ToolingShortcut';
  country?: Maybe<Scalars['String']>;
  cta?: Maybe<Scalars['String']>;
  ctaAction?: Maybe<InstacartCustomersContentManagementV1BannerAction>;
  experimentName?: Maybe<Scalars['String']>;
  imageAltText?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isAbsoluteRanking?: Maybe<Scalars['Boolean']>;
  isBusinessPriority?: Maybe<Scalars['Boolean']>;
  isPriceParity?: Maybe<Scalars['Boolean']>;
  localizedData?: Maybe<Array<Maybe<ToolingShortcutLocalizedData>>>;
  placementId?: Maybe<Scalars['BigInt']>;
  rank?: Maybe<Scalars['Int']>;
  shortcutScope?: Maybe<Scalars['String']>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  userStatus?: Maybe<Scalars['String']>;
};

export type ToolingShortcutInput = {
  country?: InputMaybe<Scalars['String']>;
  cta?: InputMaybe<Scalars['String']>;
  ctaAction?: InputMaybe<InstacartCustomersContentManagementV1BannerActionInput>;
  experimentName?: InputMaybe<Scalars['String']>;
  imageAltText?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isAbsoluteRanking?: InputMaybe<Scalars['Boolean']>;
  isBusinessPriority?: InputMaybe<Scalars['Boolean']>;
  isPriceParity?: InputMaybe<Scalars['Boolean']>;
  localizedData?: InputMaybe<Array<InputMaybe<ToolingShortcutLocalizedDataInput>>>;
  placementId?: InputMaybe<Scalars['BigInt']>;
  rank?: InputMaybe<Scalars['Int']>;
  shortcutScope?: InputMaybe<Scalars['String']>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userStatus?: InputMaybe<Scalars['String']>;
};

export type ToolingShortcutLocalizedData = {
  __typename?: 'ToolingShortcutLocalizedData';
  imageAltText?: Maybe<Scalars['String']>;
  locale?: Maybe<InstacartCustomersSharedV1Locale>;
  subTitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ToolingShortcutLocalizedDataInput = {
  imageAltText?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<InstacartCustomersSharedV1Locale>;
  subTitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum TreatmentOfferState {
  Activated = 'ACTIVATED',
  Applied = 'APPLIED',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
  TreatmentOfferStateUnspecified = 'TREATMENT_OFFER_STATE_UNSPECIFIED',
  Unredeemable = 'UNREDEEMABLE'
}

/** Autogenerated return type of TriggerCampaign */
export type TriggerCampaignPayload = {
  __typename?: 'TriggerCampaignPayload';
  /** Whether it succesfully triggered */
  success: Scalars['Boolean'];
};

export type TriggerRakeTaskForStoreConfigurationRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  attributeValue?: InputMaybe<Scalars['String']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type TriggerRakeTaskForStoreConfigurationResponse = {
  __typename?: 'TriggerRakeTaskForStoreConfigurationResponse';
  errorMessage?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

/** Autogenerated return type of TriggerWorkflow */
export type TriggerWorkflowPayload = {
  __typename?: 'TriggerWorkflowPayload';
  /** The triggered workflow */
  workflow: OnboardingFeatureTypesWorkflow;
};

export type TypographyFontSchema = {
  __typename?: 'TypographyFontSchema';
  fontFamily?: Maybe<Scalars['String']>;
  fontWeight?: Maybe<Scalars['String']>;
};

export type TypographySchema = {
  __typename?: 'TypographySchema';
  headline?: Maybe<TypographyFontSchema>;
  headlineLarge2?: Maybe<TypographyFontSchema>;
  rootElement?: Maybe<TypographyFontSchema>;
  subtitle?: Maybe<TypographyFontSchema>;
  subtitleLarge?: Maybe<TypographyFontSchema>;
  subtitleMedium?: Maybe<TypographyFontSchema>;
  subtitleSmall?: Maybe<TypographyFontSchema>;
  title?: Maybe<TypographyFontSchema>;
  titleLarge?: Maybe<TypographyFontSchema>;
  titleMedium?: Maybe<TypographyFontSchema>;
};

export type UiContextInput = {
  urlPath: Scalars['String'];
};

export type UnionType = {
  __typename?: 'UnionType';
  content?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
};

export type UnknownBanner = {
  __typename?: 'UnknownBanner';
  id?: Maybe<Scalars['BigInt']>;
};

export type UnknownBannerInput = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Upc = {
  __typename?: 'Upc';
  upc?: Maybe<Scalars['String']>;
};

export type UpcInput = {
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateAddressToDefaultByIdRequestInput = {
  id?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
};

export type UpdateAdminNavigationV2RequestInput = {
  adminNavigationV2?: InputMaybe<AdminNavigationV2Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAdminNavigationV2Response = {
  __typename?: 'UpdateAdminNavigationV2Response';
  adminNavigationV2?: Maybe<AdminNavigationV2>;
};

export type UpdateApiSettingRequestInput = {
  apiType?: InputMaybe<Scalars['String']>;
  cron?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  integrationType?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateApiSettingResponse = {
  __typename?: 'UpdateApiSettingResponse';
  apiType?: Maybe<Scalars['String']>;
  cron?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  integrationType?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
};

export type UpdateApprovalRequestStatusRequestInput = {
  approvalRequestId?: InputMaybe<Scalars['BigInt']>;
  comment?: InputMaybe<Scalars['String']>;
  statusAction?: InputMaybe<Scalars['String']>;
  userUuid?: InputMaybe<Scalars['String']>;
};

export type UpdateApprovalRequestStatusResponse = {
  __typename?: 'UpdateApprovalRequestStatusResponse';
  approvalRequest?: Maybe<LaunchOnboardingApprovalRequest>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateAuditBatchRequestInput = {
  action?: InputMaybe<Scalars['String']>;
  batchUuid?: InputMaybe<Scalars['String']>;
  changeSampleSizeValue?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Scalars['String']>;
  newSecondaryStateId?: InputMaybe<Scalars['BigInt']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  overrideDueDate?: InputMaybe<Scalars['DateTime']>;
  priority?: InputMaybe<Scalars['Int']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  userUuid?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAuditBatchResponse = {
  __typename?: 'UpdateAuditBatchResponse';
  completedAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type UpdateAuditTaskRequestInput = {
  client?: InputMaybe<Scalars['String']>;
  extComment?: InputMaybe<Scalars['String']>;
  intComment?: InputMaybe<Scalars['String']>;
  outsourceVendor?: InputMaybe<Scalars['String']>;
  reviewState?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taskComponents?: InputMaybe<Array<InputMaybe<UpdateAuditTaskRequestUpdateTaskComponentInput>>>;
  taskUuid?: InputMaybe<Scalars['String']>;
  userUuid?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAuditTaskRequestUpdateTaskComponentInput = {
  explicitAuditFailed?: InputMaybe<Scalars['Boolean']>;
  extComment?: InputMaybe<Scalars['String']>;
  groupName?: InputMaybe<Scalars['String']>;
  intComment?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  reviewState?: InputMaybe<Scalars['String']>;
  suggestedValue?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateAuditTaskResponse = {
  __typename?: 'UpdateAuditTaskResponse';
  batchVersion?: Maybe<Scalars['BigInt']>;
  message?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type UpdateAuditWorkflowRequestInput = {
  auditWorkflow?: InputMaybe<AuditWorkflowInput>;
  configs?: InputMaybe<Array<InputMaybe<AuditWorkflowConfigInput>>>;
  tombstone?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateAuditWorkflowResponse = {
  __typename?: 'UpdateAuditWorkflowResponse';
  _?: Maybe<Scalars['Boolean']>;
};

export type UpdateAvailabilityScoreOverrideRequestInput = {
  enable?: InputMaybe<Scalars['Boolean']>;
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  overrideEndAt?: InputMaybe<Scalars['DateTime']>;
  overrideStartAt?: InputMaybe<Scalars['DateTime']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateAvailabilityScoreOverrideResponse = {
  __typename?: 'UpdateAvailabilityScoreOverrideResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateClientConfigurationForOrdersDashboardRequestInput = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  isUnata?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Scalars['String']>;
};

export type UpdateClientConfigurationForOrdersDashboardResponse = {
  __typename?: 'UpdateClientConfigurationForOrdersDashboardResponse';
  clientConfiguration?: Maybe<ClientConfiguration>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateConfirmedStoreHoursRequestInput = {
  confirmations?: InputMaybe<Array<InputMaybe<ConfirmedStoreHoursInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateConfirmedStoreHoursResponse = {
  __typename?: 'UpdateConfirmedStoreHoursResponse';
  confirmations?: Maybe<Array<Maybe<ConfirmedStoreHours>>>;
};

export type UpdateConnectRetailerCallbackConfigurationRequestInput = {
  callbackConfiguration?: InputMaybe<ConnectRetailerCallbackConfigurationInput>;
  callbackConfigurationId?: InputMaybe<Scalars['BigInt']>;
  ignoreV1Settings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateConnectRetailerCallbackConfigurationResponse = {
  __typename?: 'UpdateConnectRetailerCallbackConfigurationResponse';
  callbackConfiguration?: Maybe<ConnectRetailerCallbackConfiguration>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateContentPageRequestV2Input = {
  activeVersionId?: InputMaybe<Scalars['BigInt']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  authContext?: InputMaybe<AuthorizationContextInput>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  instacartInternal?: InputMaybe<Scalars['Boolean']>;
  internalName?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  schedule?: InputMaybe<Scalars['String']>;
  scheduleEnabled?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateContentPageResponseV2 = {
  __typename?: 'UpdateContentPageResponseV2';
  contentPage?: Maybe<ContentPageV2>;
};

export type UpdateContentPageVersionMetaRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateContentPageVersionMetaResponse = {
  __typename?: 'UpdateContentPageVersionMetaResponse';
  contentPageVersionMeta?: Maybe<ContentPageVersionMeta>;
};

export type UpdateContentPageVersionRequestInput = {
  authContext?: InputMaybe<AuthorizationContextInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  pageStyle?: InputMaybe<PageStyleInput>;
  routingStatus?: InputMaybe<ContentPageMetaInfoStatusOneOfInput>;
  seoCanonicalUrl?: InputMaybe<Scalars['String']>;
  seoNoIndex?: InputMaybe<Scalars['Boolean']>;
  trackingProperties?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateContentPageVersionResponse = {
  __typename?: 'UpdateContentPageVersionResponse';
  contentPageVersion?: Maybe<ContentPageVersion>;
};

export type UpdateFrothTemplateRequestInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  instacartInternal?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerScope?: InputMaybe<FrothTemplateScope>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationScope?: InputMaybe<FrothTemplateScope>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateFrothTemplateResponse = {
  __typename?: 'UpdateFrothTemplateResponse';
  frothTemplate?: Maybe<FrothTemplate>;
};

export type UpdateFrothTemplateVersionRequestInput = {
  body?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSONObject']>;
  contentSchema?: InputMaybe<Scalars['String']>;
  dataQuery?: InputMaybe<DataQueryStructInput>;
  frothAst?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  previewImageUrl?: InputMaybe<Scalars['String']>;
  previewImageUrlMobile?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

export type UpdateFrothTemplateVersionResponse = {
  __typename?: 'UpdateFrothTemplateVersionResponse';
  frothTemplateVersion?: Maybe<FrothTemplateVersionInfo>;
};

export type UpdateLaunchOnboardingWarehouseInfoRequestInput = {
  aliasName?: InputMaybe<Scalars['String']>;
  allowAlcohol?: InputMaybe<Scalars['Boolean']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  certifiedDeliveryThreshold?: InputMaybe<Scalars['Float']>;
  country?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  logoBackgroundColor?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  pricingPolicy?: InputMaybe<Scalars['String']>;
  pricingPolicyText?: InputMaybe<Scalars['String']>;
  retailerType?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLaunchOnboardingWarehouseInfoResponse = {
  __typename?: 'UpdateLaunchOnboardingWarehouseInfoResponse';
  launchOnboarding?: Maybe<LaunchOnboarding>;
};

export type UpdateLaunchOnboardingWarehouseLocationInfoRequestInput = {
  address?: InputMaybe<LaunchOnboardingAddressInput>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  locationCode?: InputMaybe<Scalars['String']>;
  merchantId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  warehouseLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLaunchOnboardingWarehouseLocationInfoResponse = {
  __typename?: 'UpdateLaunchOnboardingWarehouseLocationInfoResponse';
  launchOnboarding?: Maybe<LaunchOnboarding>;
  warehouseLocation?: Maybe<LaunchOnboardingWarehouseLocation>;
};

export type UpdateLaunchOnboardingWorkflowStateRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  stateAction?: InputMaybe<LaunchOnboardingWorkflowStateAction>;
  token?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLaunchOnboardingWorkflowStateResponse = {
  __typename?: 'UpdateLaunchOnboardingWorkflowStateResponse';
  launchOnboarding?: Maybe<LaunchOnboarding>;
};

export type UpdateLayoutVariantRequestInput = {
  layoutVariant?: InputMaybe<LayoutVariantInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateLayoutVariantResponse = {
  __typename?: 'UpdateLayoutVariantResponse';
  layoutVariant?: Maybe<LayoutVariant>;
};

export type UpdateMomentCampaignStatusRequestInput = {
  momentCampaignStatus?: InputMaybe<Array<InputMaybe<MomentCampaignStatusInput>>>;
  momentCampaigns?: InputMaybe<StatusMapInput>;
};

export type UpdateMomentCampaignStatusResponse = {
  __typename?: 'UpdateMomentCampaignStatusResponse';
  campaigns?: Maybe<Array<Maybe<RetailerCampaign>>>;
};

export type UpdateMomentRequestInput = {
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  momentId?: InputMaybe<Scalars['BigInt']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateMomentResponse = {
  __typename?: 'UpdateMomentResponse';
  moment?: Maybe<Moment>;
};

export type UpdateNativeTabBarNavigationRequestInput = {
  navigation?: InputMaybe<NativeTabBarNavigationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateNativeTabBarNavigationResponse = {
  __typename?: 'UpdateNativeTabBarNavigationResponse';
  navigation?: Maybe<NativeTabBarNavigation>;
};

export type UpdateNavigationRequestInput = {
  navigation?: InputMaybe<NavigationInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateNavigationResponse = {
  __typename?: 'UpdateNavigationResponse';
  navigation?: Maybe<Navigation>;
};

export type UpdateOnboardingBillingAddressRequestInput = {
  billingAddress?: InputMaybe<AddressInput>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateOnboardingBillingAddressResponse = {
  __typename?: 'UpdateOnboardingBillingAddressResponse';
  onboarding?: Maybe<Onboarding>;
};

export type UpdateOnboardingRequestInput = {
  businessRegistrationDocument?: InputMaybe<Scalars['String']>;
  contactInfo?: InputMaybe<ContactInput>;
  corporationType?: InputMaybe<Scalars['String']>;
  duns?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  exclusivity?: InputMaybe<Scalars['String']>;
  isaCheckboxTimestamp?: InputMaybe<Scalars['String']>;
  ndaCheckboxTimestamp?: InputMaybe<Scalars['String']>;
  onboardingType?: InputMaybe<Scalars['String']>;
  posSystemName?: InputMaybe<Scalars['String']>;
  priceParity?: InputMaybe<Scalars['String']>;
  stateOfIncorporation?: InputMaybe<Scalars['String']>;
  storeCount?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  w9Form?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateOnboardingResponse = {
  __typename?: 'UpdateOnboardingResponse';
  onboarding?: Maybe<Onboarding>;
};

export type UpdateOnboardingWorkflowStateRequestInput = {
  ipAddress?: InputMaybe<Scalars['String']>;
  stateAction?: InputMaybe<OnboardingWorkflowStateAction>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateOnboardingWorkflowStateResponse = {
  __typename?: 'UpdateOnboardingWorkflowStateResponse';
  onboarding?: Maybe<Onboarding>;
};

export type UpdateParkingSettingsRequestInput = {
  imageConfigs?: InputMaybe<Array<InputMaybe<ImageConfigInput>>>;
  instruction?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  setDefault?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<PickupType>;
};

export type UpdateParkingSettingsResponse = {
  __typename?: 'UpdateParkingSettingsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  imageConfigs?: Maybe<Array<Maybe<ImageConfig>>>;
  instruction?: Maybe<Scalars['String']>;
  retailerLocationConfig?: Maybe<RetailerLocationInfo>;
};

export type UpdatePlacementContentRequestInput = {
  adminContext?: InputMaybe<PlacementAdminContextInput>;
  content?: InputMaybe<PlacementContentInput>;
  localesToDelete?: InputMaybe<Array<InputMaybe<InstacartCustomersSharedV1Locale>>>;
};

export type UpdatePlacementContentResponse = {
  __typename?: 'UpdatePlacementContentResponse';
  content?: Maybe<PlacementContent>;
};

export type UpdateRetailerAisleTemplateRequestInput = {
  aisleOrders?: InputMaybe<Array<InputMaybe<AisleOrderInput>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  shopperType?: InputMaybe<ShopperType>;
};

export type UpdateRetailerAisleTemplateResponse = {
  __typename?: 'UpdateRetailerAisleTemplateResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  updated?: Maybe<Scalars['Boolean']>;
};

export type UpdateRetailerCampaignRequestInput = {
  budget?: InputMaybe<GoogleTypeMoneyInput>;
  campaignObjective?: InputMaybe<CampaignObjective>;
  campaignReference?: InputMaybe<CampaignReferenceInput>;
  couponCount?: InputMaybe<Scalars['BigInt']>;
  disableTreatmentPolicy?: InputMaybe<Scalars['Boolean']>;
  discoverability?: InputMaybe<Discoverability>;
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<CampaignFilterInput>>>;
  filtersV2?: InputMaybe<CampaignFiltersInput>;
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  ippContext?: InputMaybe<IppContextInput>;
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offers?: InputMaybe<Array<InputMaybe<InstacartCustomersCommerceTypesV1SlimOfferInput>>>;
  propertyOverrides?: InputMaybe<Array<InputMaybe<CampaignPropertyOverrideInput>>>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<RestaurantRewardPolicyInput>;
  resumeAfterRedemptionLimitIncrease?: InputMaybe<Scalars['Boolean']>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  rouletteFeature?: InputMaybe<CampaignRouletteFeatureInput>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  slotCreatives?: InputMaybe<Array<InputMaybe<InstacartCustomersContentManagementAdminV1SlotCreativeInput>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  targeting?: InputMaybe<Array<InputMaybe<Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<TargetingRulesInput>>>;
  treatments?: InputMaybe<RetailerCampaignTreatmentsInput>;
};

export type UpdateRetailerCampaignTreatmentParamsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<RetailerCampaignTreatmentDetailsInput>>>;
  treatmentType?: InputMaybe<RetailerCampaignTreatmentType>;
};

export type UpdateRetailerCampaignTreatmentsRequestInput = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<UpdateRetailerCampaignTreatmentParamsInput>>>;
};

export type UpdateRetailerCampaignTreatmentsResponse = {
  __typename?: 'UpdateRetailerCampaignTreatmentsResponse';
  treatments?: Maybe<Array<Maybe<RetailerCampaignTreatment>>>;
};

export type UpdateRetailerFormGroupVisibilityRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  retailerFormGroupVisibility?: InputMaybe<Scalars['JSONObject']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateRetailerFormGroupVisibilityResponse = {
  __typename?: 'UpdateRetailerFormGroupVisibilityResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateRetailerProductVisibilitiesRequestInput = {
  entityId?: InputMaybe<Array<InputMaybe<EntityIdInput>>>;
  inAssortment?: InputMaybe<Scalars['Boolean']>;
  outOfAssortmentEndAt?: InputMaybe<Scalars['DateTime']>;
  outOfAssortmentStartAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateRetailerProductVisibilitiesResponse = {
  __typename?: 'UpdateRetailerProductVisibilitiesResponse';
  entityId?: Maybe<Array<Maybe<EntityId>>>;
};

export type UpdateRoleInput = {
  /** The accounts to add to the role */
  addedAccounts?: InputMaybe<Array<AccountInput>>;
  /** A description of the role */
  description?: InputMaybe<Scalars['String']>;
  /** The role ID */
  id: Scalars['ID'];
  /** The name of the role */
  name?: InputMaybe<Scalars['String']>;
  /** The permissions associated with this role */
  permissions?: InputMaybe<Array<PermissionInput>>;
  /** The accounts to remove from the role */
  removedAccounts?: InputMaybe<Array<AccountInput>>;
};

export type UpdateShopperOrderItemRequestInput = {
  adminRequestContext?: InputMaybe<AdminRequestContextInput>;
  deliveredCount?: InputMaybe<Scalars['BigInt']>;
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  lineNum?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<InstacartCustomersSharedV1RequestContextInput>;
  rrc?: InputMaybe<Scalars['String']>;
  scans?: InputMaybe<Array<InputMaybe<ShopperOrderItemScanInput>>>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  substituteId?: InputMaybe<Scalars['BigInt']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type UpdateShopperOrderItemResponse = {
  __typename?: 'UpdateShopperOrderItemResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateSocialIconsNavigationRequestInput = {
  navigation?: InputMaybe<SocialIconNavInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateSocialIconsNavigationResponse = {
  __typename?: 'UpdateSocialIconsNavigationResponse';
  navigation?: Maybe<SocialIconNav>;
};

export type UpdateStagingSettingsRequestInput = {
  freezer?: InputMaybe<StringsInput>;
  fridge?: InputMaybe<StringsInput>;
  hotArea?: InputMaybe<StringsInput>;
  imageUrl?: InputMaybe<Scalars['String']>;
  instruction?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shelf?: InputMaybe<StringsInput>;
};

export type UpdateStagingSettingsResponse = {
  __typename?: 'UpdateStagingSettingsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  freezer?: Maybe<Array<Maybe<Scalars['String']>>>;
  fridge?: Maybe<Array<Maybe<Scalars['String']>>>;
  hotArea?: Maybe<Array<Maybe<Scalars['String']>>>;
  imageUrl?: Maybe<Scalars['String']>;
  instruction?: Maybe<Scalars['String']>;
  retailerLocationConfig?: Maybe<RetailerLocationInfo>;
  shelf?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type UpdateStoreConfigurationDraftRequestInput = {
  domainConfigurations?: InputMaybe<Scalars['JSONObject']>;
  draftId?: InputMaybe<Scalars['String']>;
  draftName?: InputMaybe<Scalars['String']>;
  partnerAccessOptions?: InputMaybe<PartnerAccessOptionsSchemaInput>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateStoreConfigurationDraftResponse = {
  __typename?: 'UpdateStoreConfigurationDraftResponse';
  domainConfigurations?: Maybe<DomainConfiguration>;
  domainConfigurationsRaw?: Maybe<Scalars['JSONObject']>;
  draftId?: Maybe<Scalars['String']>;
  draftName?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  errorReason?: Maybe<ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  partnerAccessOptions?: Maybe<PartnerAccessOptionsSchema>;
};

export type UpdateStoreHoursRequestInput = {
  author?: InputMaybe<Scalars['String']>;
  clearOverrideHoursByType?: InputMaybe<Array<InputMaybe<RetailerServiceType>>>;
  clearOverrideHoursCriteria?: InputMaybe<Array<InputMaybe<ClearOverrideHoursCriteriaInput>>>;
  confirmations?: InputMaybe<Array<InputMaybe<ConfirmedStoreHoursInput>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  updateRegularHours?: InputMaybe<Array<InputMaybe<RegularHoursInput>>>;
  updateSource?: InputMaybe<Scalars['String']>;
  upsertOverrideHours?: InputMaybe<Array<InputMaybe<OverrideHoursInput>>>;
};

export type UpdateStoreHoursResponse = {
  __typename?: 'UpdateStoreHoursResponse';
  taskId?: Maybe<Scalars['BigInt']>;
};

export type UpdateThemePageRequestInput = {
  themePage?: InputMaybe<ThemePageInput>;
};

export type UpdateThemePageResponse = {
  __typename?: 'UpdateThemePageResponse';
  themePage?: Maybe<ThemePage>;
};

export type UpdateUserProfileInfoRequestInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteAttributesAdminRequestInput = {
  attributes?: InputMaybe<Array<InputMaybe<WhitelabelSiteAttributeInput>>>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteAttributesAdminResponse = {
  __typename?: 'UpdateWhitelabelSiteAttributesAdminResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteAttributesRequestInput = {
  attributes?: InputMaybe<Array<InputMaybe<WhitelabelSiteAttributeInput>>>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteAttributesResponse = {
  __typename?: 'UpdateWhitelabelSiteAttributesResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteCustomizableStringRequestInput = {
  whitelabelSiteCustomizableString?: InputMaybe<WhitelabelSiteCustomizableStringInput>;
};

export type UpdateWhitelabelSiteCustomizableStringResponse = {
  __typename?: 'UpdateWhitelabelSiteCustomizableStringResponse';
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  whitelabelSiteCustomizableString?: Maybe<WhitelabelSiteCustomizableString>;
};

export type UpdateWhitelabelSiteRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  ownerUserUuid?: InputMaybe<Scalars['String']>;
  retailerUserUuid?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  tier?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteResponse = {
  __typename?: 'UpdateWhitelabelSiteResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteSlackChannelRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  slackChannel?: InputMaybe<Scalars['String']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteSlackChannelResponse = {
  __typename?: 'UpdateWhitelabelSiteSlackChannelResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type UpdateWhitelabelSiteWorkflowStateRequestInput = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  stateAction?: InputMaybe<WhitelabelSiteWorkflowStateAction>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

export type UpdateWhitelabelSiteWorkflowStateResponse = {
  __typename?: 'UpdateWhitelabelSiteWorkflowStateResponse';
  whitelabelSite?: Maybe<WhitelabelSite>;
};

export type User = {
  __typename?: 'User';
  active?: Maybe<Scalars['Boolean']>;
  activeZoneId?: Maybe<Scalars['BigInt']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['BigInt']>;
  phone?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  rolesMask?: Maybe<Scalars['BigInt']>;
  timeZoneName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userType?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vip?: Maybe<Scalars['Boolean']>;
};

export type UserInput = {
  userId?: InputMaybe<Scalars['String']>;
  userType?: InputMaybe<Scalars['String']>;
};

export type UserInteractionLimitInput = {
  /** number of seconds to wait before resetting the counter */
  countCooldownSec?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** maximum number of dismiss events */
  maxDismissedCount?: InputMaybe<Scalars['Int']>;
  /** maximum number of click events */
  maxEngagementsCount?: InputMaybe<Scalars['Int']>;
  /** maximum number of view events */
  maxImpressionsCount?: InputMaybe<Scalars['Int']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
};

/** Autogenerated return type of UserInteractionLimitVisibilityConditionCreate */
export type UserInteractionLimitVisibilityConditionCreatePayload = {
  __typename?: 'UserInteractionLimitVisibilityConditionCreatePayload';
  /** The newly created UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityCondition: ContentManagementVisibilityConditionUserInteractionLimit;
};

/** Autogenerated return type of UserInteractionLimitVisibilityConditionUpdate */
export type UserInteractionLimitVisibilityConditionUpdatePayload = {
  __typename?: 'UserInteractionLimitVisibilityConditionUpdatePayload';
  /** The newly updated UserInteractionLimit visibility condition */
  userInteractionLimitVisibilityCondition: ContentManagementVisibilityConditionUserInteractionLimit;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  active?: Maybe<Scalars['Boolean']>;
  activeZoneId?: Maybe<Scalars['BigInt']>;
  completedOrdersCount?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  guest?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ordersCount?: Maybe<Scalars['BigInt']>;
  partner?: Maybe<Partner>;
  partnerId?: Maybe<Scalars['BigInt']>;
  phone?: Maybe<Scalars['String']>;
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  rolesMask?: Maybe<Scalars['BigInt']>;
  signUpWhitelabelId?: Maybe<Scalars['BigInt']>;
  timeZoneName?: Maybe<Scalars['String']>;
  userIsolationContextId?: Maybe<Scalars['BigInt']>;
  uuid?: Maybe<Scalars['String']>;
  vip?: Maybe<Scalars['Boolean']>;
};

/** Filter facets used by the bulk user selection panel — wraps the existing user search options. */
export type UserSelectionFilters = {
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']>;
  excludeOutsourcerUsers?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  retailerId?: InputMaybe<Scalars['ID']>;
  roleId?: InputMaybe<Scalars['ID']>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  key?: Maybe<UserSettingKey>;
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
};

export type UserSettingInput = {
  key?: InputMaybe<UserSettingKeyInput>;
  value?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type UserSettingKey = {
  __typename?: 'UserSettingKey';
  app?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserSettingKeyInput = {
  app?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UsersSchema = {
  __typename?: 'UsersSchema';
  additionalExternalCanSendPushTarget?: Maybe<Scalars['String']>;
  additionalExternalSendPushTarget?: Maybe<Scalars['String']>;
  afterSignOutPathOrUrl?: Maybe<Scalars['String']>;
  displayRetailerPrivacyPolicyOnSignup?: Maybe<Scalars['Boolean']>;
  manageAccountUrl?: Maybe<Scalars['String']>;
  notificationSettingsCallBeforeCheckoutOptionsEnabled?: Maybe<Scalars['Boolean']>;
  notificationSettingsEmailOptionsEnabled?: Maybe<Scalars['Boolean']>;
  notificationSettingsPushNotificationOptionsEnabled?: Maybe<Scalars['Boolean']>;
  notificationSettingsTextMessageOptionsEnabled?: Maybe<Scalars['Boolean']>;
  privacyOptOutCookieDomain?: Maybe<Scalars['String']>;
  signupPhoneNumberLoyaltyLinkage?: Maybe<Scalars['Boolean']>;
};

export type UtmParametersInput = {
  /** coupon_code */
  couponCode?: InputMaybe<Scalars['String']>;
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** utm_campaign */
  utmCampaign?: InputMaybe<Scalars['String']>;
  /** utm_content */
  utmContent?: InputMaybe<Scalars['String']>;
  /** utm_medium */
  utmMedium?: InputMaybe<Scalars['String']>;
  /** utm_source */
  utmSource?: InputMaybe<Scalars['String']>;
  /** utm_term */
  utmTerm?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of UtmParametersVisibilityConditionCreate */
export type UtmParametersVisibilityConditionCreatePayload = {
  __typename?: 'UtmParametersVisibilityConditionCreatePayload';
  /** The newly created UtmParameters visibility condition */
  utmParametersVisibilityCondition: ContentManagementVisibilityConditionUtmParameters;
};

/** Autogenerated return type of UtmParametersVisibilityConditionUpdate */
export type UtmParametersVisibilityConditionUpdatePayload = {
  __typename?: 'UtmParametersVisibilityConditionUpdatePayload';
  /** The newly updated UtmParameters visibility condition */
  utmParametersVisibilityCondition: ContentManagementVisibilityConditionUtmParameters;
};

export type ValueBasedOverrideRequestInput = {
  attributeName?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<ClientInput>;
  createdWhy?: InputMaybe<Scalars['String']>;
  entityId?: InputMaybe<EntityIdInput>;
  expiryDate?: InputMaybe<Scalars['DateTime']>;
  overrideType?: InputMaybe<OverrideType>;
  overrideValue?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['String']>;
  sourceValue?: InputMaybe<Scalars['String']>;
  ticketUrl?: InputMaybe<Scalars['String']>;
};

export type ValueBasedOverrideResponse = {
  __typename?: 'ValueBasedOverrideResponse';
  attributeName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByJson?: Maybe<Scalars['String']>;
  createdWhy?: Maybe<Scalars['String']>;
  entityId?: Maybe<EntityId>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  overrideType?: Maybe<OverrideType>;
  overrideValue?: Maybe<Scalars['String']>;
  rowId?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
  sourceValue?: Maybe<Scalars['String']>;
  ticketUrl?: Maybe<Scalars['String']>;
};

export type ValueProp = {
  __typename?: 'ValueProp';
  darkModeImageAlt?: Maybe<Array<Maybe<LocalizedString>>>;
  darkModeImageUrl?: Maybe<Scalars['String']>;
  header?: Maybe<Array<Maybe<LocalizedString>>>;
  imageAlt?: Maybe<Array<Maybe<LocalizedString>>>;
  imageUrl?: Maybe<Scalars['String']>;
  subheader?: Maybe<Array<Maybe<LocalizedString>>>;
};

export enum ValuePropsCardType {
  ValuePropsCardTypeBorder = 'VALUE_PROPS_CARD_TYPE_BORDER',
  ValuePropsCardTypeFilled = 'VALUE_PROPS_CARD_TYPE_FILLED',
  ValuePropsCardTypeFlushed = 'VALUE_PROPS_CARD_TYPE_FLUSHED',
  ValuePropsCardTypeOrderedList = 'VALUE_PROPS_CARD_TYPE_ORDERED_LIST',
  ValuePropsCardTypeUnknown = 'VALUE_PROPS_CARD_TYPE_UNKNOWN'
}

export enum VerticalType {
  AlcoholHours = 'ALCOHOL_HOURS',
  DeliveryHours = 'DELIVERY_HOURS',
  IssHours = 'ISS_HOURS',
  PharmacyHours = 'PHARMACY_HOURS',
  PickupHours = 'PICKUP_HOURS',
  PickupOverrideHours = 'PICKUP_OVERRIDE_HOURS'
}

export type ViewportOverride = {
  __typename?: 'ViewportOverride';
  fields?: Maybe<StyleFields>;
  viewport?: Maybe<ViewportOverrideViewport>;
};

export type ViewportOverrideInput = {
  fields?: InputMaybe<StyleFieldsInput>;
  viewport?: InputMaybe<ViewportOverrideViewport>;
};

export enum ViewportOverrideViewport {
  ViewportDesktop = 'VIEWPORT_DESKTOP',
  ViewportUnspecified = 'VIEWPORT_UNSPECIFIED'
}

/** Autogenerated return type of VirtualPartnerUpdateRetailers */
export type VirtualPartnerUpdateRetailersPayload = {
  __typename?: 'VirtualPartnerUpdateRetailersPayload';
  /** A status which is true if no errors were encountered */
  success: Scalars['True'];
};

export type VirtualRetailer = {
  __typename?: 'VirtualRetailer';
  coreRetailerId?: Maybe<Scalars['BigInt']>;
  virtualRetailerId?: Maybe<Scalars['BigInt']>;
};

/** Union of the Types of Visibility Conditions which may be returned */
export type VisibilityCondition = ContentManagementVisibilityConditionCountryIds | ContentManagementVisibilityConditionDayOfWeek | ContentManagementVisibilityConditionExperimentVariant | ContentManagementVisibilityConditionExpressMembership | ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout | ContentManagementVisibilityConditionMatchesAnyRetailerId | ContentManagementVisibilityConditionMinimumPlatformVersion | ContentManagementVisibilityConditionNewVerticalUserTargeting | ContentManagementVisibilityConditionRetailerAvailability | ContentManagementVisibilityConditionShopped | ContentManagementVisibilityConditionShoppedAtRetailer | ContentManagementVisibilityConditionUnknownVisibilityCondition | ContentManagementVisibilityConditionUserInteractionLimit | ContentManagementVisibilityConditionUtmParameters | ContentManagementVisibilityConditionWhitelistedPostalCodes | ContentManagementVisibilityConditionWhitelistedZones;

/** Autogenerated return type of VisibilityConditionDelete */
export type VisibilityConditionDeletePayload = {
  __typename?: 'VisibilityConditionDeletePayload';
  /** Whether deleting the visibility condition succeeded or not */
  success: Scalars['Boolean'];
};

export type VisibilityConditionStruct = {
  __typename?: 'VisibilityConditionStruct';
  data?: Maybe<Scalars['JSONObject']>;
  typeName?: Maybe<Scalars['String']>;
};

export type VisibilityConditionStructInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  typeName?: InputMaybe<Scalars['String']>;
};

export type WarehouseGroup = {
  __typename?: 'WarehouseGroup';
  /** The franchisee ID for this warehouse group */
  franchiseeId: Scalars['ID'];
  /** The franchisee name for this warehouse group */
  franchiseeName: Scalars['String'];
  /** The franchisor ID for this warehouse group */
  franchisorId: Scalars['ID'];
  /** The franchisor name for this warehouse group */
  franchisorName: Scalars['String'];
  /** The retailer ID for this warehouse group */
  retailerId: Scalars['ID'];
  /** The retailer name for this warehouse group */
  retailerName: Scalars['String'];
};

export type WaterfallEffect = {
  __typename?: 'WaterfallEffect';
  childWaterfallEffectIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  depth?: Maybe<Scalars['Int']>;
  errorMessage?: Maybe<Scalars['String']>;
  externalReference?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isAsync?: Maybe<Scalars['Boolean']>;
  isLeaf?: Maybe<Scalars['Boolean']>;
  isRoot?: Maybe<Scalars['Boolean']>;
  launchOnboardingId?: Maybe<Scalars['BigInt']>;
  launchOnboardingPartnerId?: Maybe<Scalars['BigInt']>;
  launchOnboardingWarehouseId?: Maybe<Scalars['BigInt']>;
  launchOnboardingWarehouseLocationId?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSONObject']>;
  params?: Maybe<Scalars['JSONObject']>;
  parentWaterfallEffectId?: Maybe<Scalars['BigInt']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  targetId?: Maybe<Scalars['BigInt']>;
  targetService?: Maybe<Scalars['String']>;
  targetType?: Maybe<Scalars['String']>;
  timeSpent?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
  workflowType?: Maybe<Scalars['String']>;
};

export type WhitelabelGumloopWorkflowParametersInput = {
  url?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSite = {
  __typename?: 'WhitelabelSite';
  approvalRequests?: Maybe<Array<Maybe<LaunchOnboardingApprovalRequest>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  formLockedAt?: Maybe<Scalars['DateTime']>;
  formLockedBy?: Maybe<Scalars['String']>;
  hasActiveFormEditAccess?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  launchOnboardingWarehouseId?: Maybe<Scalars['BigInt']>;
  ownerUserUuid?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  pendingApprovalRequestId?: Maybe<Scalars['String']>;
  pendingRequestExists?: Maybe<Scalars['Boolean']>;
  retailerEmailSendLog?: Maybe<Array<Maybe<RetailerEmailLogEntry>>>;
  retailerFormGroupVisibility?: Maybe<Scalars['JSONObject']>;
  retailerUserUuid?: Maybe<Scalars['String']>;
  slackChannel?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  tier?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Scalars['String']>;
};

export type WhitelabelSiteAttributeInput = {
  group?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSiteCustomizableString = {
  __typename?: 'WhitelabelSiteCustomizableString';
  app?: Maybe<Scalars['String']>;
  customizable?: Maybe<Scalars['Boolean']>;
  defaultCopy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  key?: Maybe<Scalars['String']>;
  ymlFilePath?: Maybe<Scalars['String']>;
};

export type WhitelabelSiteCustomizableStringInput = {
  app?: InputMaybe<Scalars['String']>;
  customizable?: InputMaybe<Scalars['Boolean']>;
  defaultCopy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  key?: InputMaybe<Scalars['String']>;
  ymlFilePath?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSiteStringOverrideInput = {
  customizableStringId?: InputMaybe<Scalars['Int']>;
  customizableStringYmlKey?: InputMaybe<Scalars['String']>;
  overrideStringCopy?: InputMaybe<Scalars['String']>;
};

export type WhitelabelSiteTestRun = {
  __typename?: 'WhitelabelSiteTestRun';
  buildUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  testCaseIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
};

export enum WhitelabelSiteWorkflowStateAction {
  WhitelabelSiteWorkflowStateActionPublish = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_PUBLISH',
  WhitelabelSiteWorkflowStateActionSendInitialEmailInvite = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_SEND_INITIAL_EMAIL_INVITE',
  WhitelabelSiteWorkflowStateActionStartProgress = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_START_PROGRESS',
  WhitelabelSiteWorkflowStateActionStartReview = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_START_REVIEW',
  WhitelabelSiteWorkflowStateActionUnknown = 'WHITELABEL_SITE_WORKFLOW_STATE_ACTION_UNKNOWN'
}

export type WhitelistedPostalCodesInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of postal codes */
  postalCodes: Array<Scalars['String']>;
};

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionCreate */
export type WhitelistedPostalCodesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionCreatePayload';
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes;
};

/** Autogenerated return type of WhitelistedPostalCodesVisibilityConditionUpdate */
export type WhitelistedPostalCodesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedPostalCodesVisibilityConditionUpdatePayload';
  /** The newly created whitelisted_postal_codes visibility condition */
  whitelistedPostalCodesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedPostalCodes;
};

export type WhitelistedZonesInput = {
  /** A unique identifier of the visibility condition */
  id?: InputMaybe<Scalars['ID']>;
  /** A unique identifier of the placement associated with the visibility condition */
  placementId: Scalars['ID'];
  /** List of zones ids */
  zones: Array<Scalars['String']>;
};

/** Autogenerated return type of WhitelistedZonesVisibilityConditionCreate */
export type WhitelistedZonesVisibilityConditionCreatePayload = {
  __typename?: 'WhitelistedZonesVisibilityConditionCreatePayload';
  /** The newly created whitelisted_zones visibility condition */
  whitelistedZonesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedZones;
};

/** Autogenerated return type of WhitelistedZonesVisibilityConditionUpdate */
export type WhitelistedZonesVisibilityConditionUpdatePayload = {
  __typename?: 'WhitelistedZonesVisibilityConditionUpdatePayload';
  /** The updated WhitelistedZones visibility condition */
  whitelistedZonesVisibilityCondition: ContentManagementVisibilityConditionWhitelistedZones;
};

export type Widget = {
  __typename?: 'Widget';
  dataQuery?: Maybe<DataQuery>;
  id?: Maybe<Scalars['BigInt']>;
  variant?: Maybe<WidgetVariant>;
};

export type WidgetInput = {
  dataQuery?: InputMaybe<DataQueryInput>;
  id?: InputMaybe<Scalars['BigInt']>;
  variant?: InputMaybe<WidgetVariant>;
};

export enum WidgetVariant {
  CouponsSavings = 'COUPONS_SAVINGS',
  IframeEmbed = 'IFRAME_EMBED',
  NavigationList = 'NAVIGATION_LIST',
  OrderHistory = 'ORDER_HISTORY',
  QuickLinks = 'QUICK_LINKS',
  ServiceOptionSelector = 'SERVICE_OPTION_SELECTOR',
  UnspecifiedWidget = 'UNSPECIFIED_WIDGET',
  WaysToShop = 'WAYS_TO_SHOP'
}

/** Autogenerated return type of WizardProgressUpdate */
export type WizardProgressUpdatePayload = {
  __typename?: 'WizardProgressUpdatePayload';
  /** A status which is true if no errors were encountered while performing the update */
  success: Scalars['True'];
};

export enum WizardStatusEnum {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export enum WizardTypeEnum {
  PickupSettingsOnboarding = 'PICKUP_SETTINGS_ONBOARDING'
}

export type WizardsWizardProgress = {
  __typename?: 'WizardsWizardProgress';
  id: Scalars['ID'];
  status: WizardStatusEnum;
  wizardType: WizardTypeEnum;
};

export type WorkflowParameter = {
  /** The parameter name */
  name: Scalars['String'];
  /** The value of the parameter */
  value: Scalars['JSON'];
};

export type WorkflowQueryFilter = {
  /** Query by specific statuses */
  status?: InputMaybe<Scalars['String']>;
  /** Query by specific workflow id */
  workflowId?: InputMaybe<Scalars['Int']>;
  /** Query by specific workflow definition */
  workflowName?: InputMaybe<Scalars['String']>;
};

export enum WorkflowStatus {
  WorkflowStatusCompleted = 'WORKFLOW_STATUS_COMPLETED',
  WorkflowStatusDeactivate = 'WORKFLOW_STATUS_DEACTIVATE',
  WorkflowStatusExpired = 'WORKFLOW_STATUS_EXPIRED',
  WorkflowStatusFailed = 'WORKFLOW_STATUS_FAILED',
  WorkflowStatusGetData = 'WORKFLOW_STATUS_GET_DATA',
  WorkflowStatusInProgress = 'WORKFLOW_STATUS_IN_PROGRESS',
  WorkflowStatusReadyToDelete = 'WORKFLOW_STATUS_READY_TO_DELETE',
  WorkflowStatusUnspecified = 'WORKFLOW_STATUS_UNSPECIFIED'
}

export type Google_Protobuf_FieldMask_Input = {
  paths?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Google_Protobuf_ListValue = {
  __typename?: 'google_protobuf_ListValue';
  values?: Maybe<Array<Maybe<Google_Protobuf_Value>>>;
};

export enum Google_Protobuf_NullValue {
  NullValue = 'NULL_VALUE'
}

export type Google_Protobuf_Value = {
  __typename?: 'google_protobuf_Value';
  boolValue?: Maybe<Scalars['Boolean']>;
  listValue?: Maybe<Google_Protobuf_ListValue>;
  nullValue?: Maybe<Google_Protobuf_NullValue>;
  numberValue?: Maybe<Scalars['Float']>;
  stringValue?: Maybe<Scalars['String']>;
  structValue?: Maybe<Scalars['JSON']>;
};

/**
 * Represents a whole or partial calendar date, e.g. a birthday. The time of day
 * and time zone are either specified elsewhere or are not significant. The date
 * is relative to the Proleptic Gregorian Calendar. This can represent:
 *
 * * A full date, with non-zero year, month and day values
 * * A month and day value, with a zero year, e.g. an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, e.g. a credit card expiration date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and `google.protobuf.Timestamp`.
 */
export type Google_Type_Date = {
  __typename?: 'google_type_Date';
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year by itself or a year and month where the day is not
   * significant.
   */
  day?: Maybe<Scalars['Int']>;
  /**
   * Month of year. Must be from 1 to 12, or 0 if specifying a year without a
   * month and day.
   */
  month?: Maybe<Scalars['Int']>;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year?: Maybe<Scalars['Int']>;
};

/**
 * Represents a whole or partial calendar date, e.g. a birthday. The time of day
 * and time zone are either specified elsewhere or are not significant. The date
 * is relative to the Proleptic Gregorian Calendar. This can represent:
 *
 * * A full date, with non-zero year, month and day values
 * * A month and day value, with a zero year, e.g. an anniversary
 * * A year on its own, with zero month and day values
 * * A year and month value, with a zero day, e.g. a credit card expiration date
 *
 * Related types are [google.type.TimeOfDay][google.type.TimeOfDay] and `google.protobuf.Timestamp`.
 */
export type Google_Type_Date_Input = {
  /**
   * Day of month. Must be from 1 to 31 and valid for the year and month, or 0
   * if specifying a year by itself or a year and month where the day is not
   * significant.
   */
  day?: InputMaybe<Scalars['Int']>;
  /**
   * Month of year. Must be from 1 to 12, or 0 if specifying a year without a
   * month and day.
   */
  month?: InputMaybe<Scalars['Int']>;
  /**
   * Year of date. Must be from 1 to 9999, or 0 if specifying a date without
   * a year.
   */
  year?: InputMaybe<Scalars['Int']>;
};

/**
 * An object representing a latitude/longitude pair. This is expressed as a pair
 * of doubles representing degrees latitude and degrees longitude. Unless
 * specified otherwise, this must conform to the
 * <a href="http://www.unoosa.org/pdf/icg/2012/template/WGS_84.pdf">WGS84
 * standard</a>. Values must be within normalized ranges.
 */
export type Google_Type_LatLng = {
  __typename?: 'google_type_LatLng';
  /** The latitude in degrees. It must be in the range [-90.0, +90.0]. */
  latitude?: Maybe<Scalars['Float']>;
  /** The longitude in degrees. It must be in the range [-180.0, +180.0]. */
  longitude?: Maybe<Scalars['Float']>;
};

/**
 * An object representing a latitude/longitude pair. This is expressed as a pair
 * of doubles representing degrees latitude and degrees longitude. Unless
 * specified otherwise, this must conform to the
 * <a href="http://www.unoosa.org/pdf/icg/2012/template/WGS_84.pdf">WGS84
 * standard</a>. Values must be within normalized ranges.
 */
export type Google_Type_LatLng_Input = {
  /** The latitude in degrees. It must be in the range [-90.0, +90.0]. */
  latitude?: InputMaybe<Scalars['Float']>;
  /** The longitude in degrees. It must be in the range [-180.0, +180.0]. */
  longitude?: InputMaybe<Scalars['Float']>;
};

/**
 * Represents a postal address, e.g. for postal delivery or payments addresses.
 * Given a postal address, a postal service can deliver items to a premise, P.O.
 * Box or similar.
 * It is not intended to model geographical locations (roads, towns,
 * mountains).
 *
 * In typical usage an address would be created via user input or from importing
 * existing data, depending on the type of process.
 *
 * Advice on address input / editing:
 * - Use an i18n-ready address widget such as
 * https://github.com/google/libaddressinput)
 * - Users should not be presented with UI elements for input or editing of
 * fields outside countries where that field is used.
 *
 * For more guidance on how to use this schema, please see:
 * https://support.google.com/business/answer/6397478
 */
export type Google_Type_PostalAddress = {
  __typename?: 'google_type_PostalAddress';
  /**
   * Unstructured address lines describing the lower levels of an address.
   *
   * Because values in address_lines do not have type information and may
   * sometimes contain multiple values in a single field (e.g.
   * "Austin, TX"), it is important that the line order is clear. The order of
   * address lines should be "envelope order" for the country/region of the
   * address. In places where this can vary (e.g. Japan), address_language is
   * used to make it explicit (e.g. "ja" for large-to-small ordering and
   * "ja-Latn" or "en" for small-to-large). This way, the most specific line of
   * an address can be selected based on the language.
   *
   * The minimum permitted structural representation of an address consists
   * of a region_code with all remaining information placed in the
   * address_lines. It would be possible to format such an address very
   * approximately without geocoding, but no semantic reasoning could be
   * made about any of the address components until it was at least
   * partially resolved.
   *
   * Creating an address only containing a region_code and address_lines, and
   * then geocoding is the recommended way to handle completely unstructured
   * addresses (as opposed to guessing which parts of the address should be
   * localities or administrative areas).
   */
  addressLines?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional. Highest administrative subdivision which is used for postal
   * addresses of a country or region.
   * For example, this can be a state, a province, an oblast, or a prefecture.
   * Specifically, for Spain this is the province and not the autonomous
   * community (e.g. "Barcelona" and not "Catalonia").
   * Many countries don't use an administrative area in postal addresses. E.g.
   * in Switzerland this should be left unpopulated.
   */
  administrativeArea?: Maybe<Scalars['String']>;
  /**
   * Optional. BCP-47 language code of the contents of this address (if
   * known). This is often the UI language of the input form or is expected
   * to match one of the languages used in the address' country/region, or their
   * transliterated equivalents.
   * This can affect formatting in certain countries, but is not critical
   * to the correctness of the data and will never affect any validation or
   * other non-formatting related operations.
   *
   * If this value is not known, it should be omitted (rather than specifying a
   * possibly incorrect default).
   *
   * Examples: "zh-Hant", "ja", "ja-Latn", "en".
   */
  languageCode?: Maybe<Scalars['String']>;
  /**
   * Optional. Generally refers to the city/town portion of the address.
   * Examples: US city, IT comune, UK post town.
   * In regions of the world where localities are not well defined or do not fit
   * into this structure well, leave locality empty and use address_lines.
   */
  locality?: Maybe<Scalars['String']>;
  /** Optional. The name of the organization at the address. */
  organization?: Maybe<Scalars['String']>;
  /**
   * Optional. Postal code of the address. Not all countries use or require
   * postal codes to be present, but where they are used, they may trigger
   * additional validation with other parts of the address (e.g. state/zip
   * validation in the U.S.A.).
   */
  postalCode?: Maybe<Scalars['String']>;
  /**
   * Optional. The recipient at the address.
   * This field may, under certain circumstances, contain multiline information.
   * For example, it might contain "care of" information.
   */
  recipients?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Required. CLDR region code of the country/region of the address. This
   * is never inferred and it is up to the user to ensure the value is
   * correct. See http://cldr.unicode.org/ and
   * http://www.unicode.org/cldr/charts/30/supplemental/territory_information.html
   * for details. Example: "CH" for Switzerland.
   */
  regionCode?: Maybe<Scalars['String']>;
  /**
   * The schema revision of the `PostalAddress`.
   * All new revisions **must** be backward compatible with old revisions.
   */
  revision?: Maybe<Scalars['Int']>;
  /**
   * Optional. Additional, country-specific, sorting code. This is not used
   * in most regions. Where it is used, the value is either a string like
   * "CEDEX", optionally followed by a number (e.g. "CEDEX 7"), or just a number
   * alone, representing the "sector code" (Jamaica), "delivery area indicator"
   * (Malawi) or "post office indicator" (e.g. Côte d'Ivoire).
   */
  sortingCode?: Maybe<Scalars['String']>;
  /**
   * Optional. Sublocality of the address.
   * For example, this can be neighborhoods, boroughs, districts.
   */
  sublocality?: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier';
  adGroup?: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup>;
  asset?: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Asset>;
  campaign?: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign>;
  creative?: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative>;
  product?: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_AdGroup';
  identifier?: Maybe<Instacart_Ads_Shared_V1_VersionedIdentifier>;
  internalId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup_Input = {
  identifier?: InputMaybe<Instacart_Ads_Shared_V1_VersionedIdentifier_Input>;
  internalId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Asset = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Asset';
  sha256Hash?: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Asset_Input = {
  sha256Hash?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Campaign';
  identifier?: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign_Input = {
  identifier?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Creative';
  identifier?: Maybe<Instacart_Ads_Shared_V1_VersionedIdentifier>;
  internalId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative_Input = {
  identifier?: InputMaybe<Instacart_Ads_Shared_V1_VersionedIdentifier_Input>;
  internalId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Input = {
  adGroup?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_AdGroup_Input>;
  asset?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Asset_Input>;
  campaign?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Campaign_Input>;
  creative?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Creative_Input>;
  product?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product_Input>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product = {
  __typename?: 'instacart_ads_nexus_v1_AdBlockingEntityIdentifier_Product';
  identifier?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Product_Input = {
  identifier?: InputMaybe<Scalars['BigInt']>;
};

/** Represents a human review of an ad that has been flagged. */
export type Instacart_Ads_Nexus_V1_AdReviewStatus = {
  __typename?: 'instacart_ads_nexus_v1_AdReviewStatus';
  /** Use reviewed. */
  approved?: Maybe<Scalars['Boolean']>;
  /** The ad entity in question. */
  blockingEntityIdentifier?: Maybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier>;
  /** When the review was last updated. */
  lastReview?: Maybe<Scalars['DateTime']>;
  /** The retailer who reviewed the request. */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** Whether the ad was reviewed by a human. */
  reviewed?: Maybe<Scalars['Boolean']>;
  /** The user who submitted the most recent review. */
  userId?: Maybe<Scalars['String']>;
};

/** Represents a human review of an ad that has been flagged. */
export type Instacart_Ads_Nexus_V1_AdReviewStatus_Input = {
  /** Use reviewed. */
  approved?: InputMaybe<Scalars['Boolean']>;
  /** The ad entity in question. */
  blockingEntityIdentifier?: InputMaybe<Instacart_Ads_Nexus_V1_AdBlockingEntityIdentifier_Input>;
  /** When the review was last updated. */
  lastReview?: InputMaybe<Scalars['DateTime']>;
  /** The retailer who reviewed the request. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Whether the ad was reviewed by a human. */
  reviewed?: InputMaybe<Scalars['Boolean']>;
  /** The user who submitted the most recent review. */
  userId?: InputMaybe<Scalars['String']>;
};

/** Submits a new review for a given ad blocking identifier. */
export type Instacart_Ads_Nexus_V1_UpsertAdReviewsRequest_Input = {
  /** The review to save. */
  newStatus?: InputMaybe<Instacart_Ads_Nexus_V1_AdReviewStatus_Input>;
};

export type Instacart_Ads_Nexus_V1_UpsertAdReviewsResponse = {
  __typename?: 'instacart_ads_nexus_v1_UpsertAdReviewsResponse';
  /** The new review data after it has been persisted. */
  updatedStatus?: Maybe<Instacart_Ads_Nexus_V1_AdReviewStatus>;
};

export type Instacart_Ads_Platform_Taas_V1_AudienceMetrics = {
  __typename?: 'instacart_ads_platform_taas_v1_AudienceMetrics';
  /** CRM eligibility metrics — only populated when the corresponding AudienceBreakdown is requested. */
  emailSubscribed?: Maybe<Scalars['BigInt']>;
  pushSubscribed?: Maybe<Scalars['BigInt']>;
  /** Total number of users matching the targeting rule. */
  totalAudience?: Maybe<Scalars['BigInt']>;
  /** Number of users active in the last 7 days. */
  weeklyActiveUsers?: Maybe<Scalars['BigInt']>;
};

/**
 * Contextual scope restrictions that are handled first-class.
 *
 * MOST scoping should come from the targeting rule itself. The ones here are
 * special and use-case specific.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction = {
  __typename?: 'instacart_ads_platform_taas_v1_ContextRestriction';
  global?: Maybe<Scalars['instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext']>;
  partner?: Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext>;
  retailer?: Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext>;
};

/**
 * Contextual scope restrictions that are handled first-class.
 *
 * MOST scoping should come from the targeting rule itself. The ones here are
 * special and use-case specific.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input = {
  global?: InputMaybe<Scalars['instacart_ads_platform_taas_v1_ContextRestriction_GlobalContext_Input']>;
  partner?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext_Input>;
  retailer?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext_Input>;
};

export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext = {
  __typename?: 'instacart_ads_platform_taas_v1_ContextRestriction_PartnerContext';
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerContexts?: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext>>>;
};

export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_PartnerContext_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerContexts?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext_Input>>>;
};

/**
 * Controls a particular segment to only be valid at a particular
 * retailer/whitelabel combination. For Marketplace, use whitelabel_id = 1.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext = {
  __typename?: 'instacart_ads_platform_taas_v1_ContextRestriction_RetailerContext';
  retailerId?: Maybe<Scalars['BigInt']>;
  whitelabelId?: Maybe<Scalars['BigInt']>;
};

/**
 * Controls a particular segment to only be valid at a particular
 * retailer/whitelabel combination. For Marketplace, use whitelabel_id = 1.
 */
export type Instacart_Ads_Platform_Taas_V1_ContextRestriction_RetailerContext_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

/** Creates a new segment with the given definition. */
export type Instacart_Ads_Platform_Taas_V1_CreateSegmentRequest_Input = {
  /**
   * Specific context in which this segment is valid.
   *
   * NOT editable after the segment is created!
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Definition of the new segment. */
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  /** Optional description of the segment. */
  description?: InputMaybe<Scalars['String']>;
  /** Optional IPP user ID who favorited this segment. */
  favoritedByIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** Optional flag to mark the segment as favorited for the creator. */
  isFavoritedSegment?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional flag to mark the favorited segment as a Golden Segment.
   * When true, the segment is inserted into taas.favorited_segments with is_golden_segment = true.
   */
  isGoldenSegment?: InputMaybe<Scalars['Boolean']>;
  /** Optional name of the segment. */
  name?: InputMaybe<Scalars['String']>;
  /** Data to be returned from TaaS when this segment matches. */
  payload?: InputMaybe<Scalars['GoogleProtobufAnyScalar']>;
  /**
   * Optional flag to return existing segment by name instead of creating a new one.
   * When true, if a segment with the same name already exists, returns that segment's UUID.
   * When false (default), creates a new segment even if a segment with the same name exists.
   */
  returnExistingByName?: InputMaybe<Scalars['Boolean']>;
  /**
   * Optional event-based trigger configuration. Unset creates a batch-only
   * segment; when set, the segment is armed for real-time trigger evaluation.
   */
  triggerConfig?: InputMaybe<Instacart_Ads_Platform_Taas_V1_TriggerConfig_Input>;
  /** Scope in which to create the new segment. */
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

export type Instacart_Ads_Platform_Taas_V1_DeleteSegmentRequest_Input = {
  /** This field is REQUIRED. */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /**
   * The ID of the favorited segment to be deleted. If the segment does not exist, or if
   * the version number in this field does not match the actual most-recent
   * version number for the segment, then the request will fail.
   */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
  /**
   * When true, the caller is a golden-segment admin (authorization validated in GraphQL mesh).
   * The backend allows deletion of any Golden Segment without requiring user_id to match
   * favorited_by_ipp_user_id. Ignored if the segment is not a Golden Segment.
   */
  isGoldenAdmin?: InputMaybe<Scalars['Boolean']>;
  /** User ID representing the user who initiated the deletion of favorited_segments. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** Supported feature */
export type Instacart_Ads_Platform_Taas_V1_EntityId = {
  __typename?: 'instacart_ads_platform_taas_v1_EntityId';
  /** Name of the entity id */
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Ads_Platform_Taas_V1_EntityIdType>;
};

/** Type of entity id */
export enum Instacart_Ads_Platform_Taas_V1_EntityIdType {
  /** The value of entity id is passed from API payload */
  Context = 'CONTEXT',
  /** The value of entity id is defined as the key of the map type feature such as order count in the taas segment */
  MapKey = 'MAP_KEY',
  /** The value of entity id is defined in the taas segment */
  Segment = 'SEGMENT'
}

export type Instacart_Ads_Platform_Taas_V1_EstimateAudienceRequest_Input = {
  /**
   * CRM channels to include eligibility metrics for in the response.
   * Supported values: "email", "push". An empty list omits all CRM metrics.
   */
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Scope (Global/Retailer/Partner). */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  targetingRule?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

export type Instacart_Ads_Platform_Taas_V1_EstimateAudienceResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_EstimateAudienceResponse';
  /**
   * Estimated audience metrics for the given targeting rule.
   * Counts are approximate when served from a TABLESAMPLE query.
   */
  metrics?: Maybe<Instacart_Ads_Platform_Taas_V1_AudienceMetrics>;
  /**
   * True if the response was served from a previously computed exact count,
   * in which case metrics are exact. False if counts are approximate.
   */
  servedFromCache?: Maybe<Scalars['Boolean']>;
};

/** Type of the data source of the feature */
export enum Instacart_Ads_Platform_Taas_V1_FeatureDataSourceType {
  BrazeSnowflake = 'BRAZE_SNOWFLAKE',
  Contextual = 'CONTEXTUAL',
  Csv = 'CSV',
  FeatureStore = 'FEATURE_STORE',
  HubEvent = 'HUB_EVENT',
  KafkaEvent = 'KAFKA_EVENT',
  Snowflake = 'SNOWFLAKE'
}

/** feature data used by ingestion job to populate necessary feature data */
export type Instacart_Ads_Platform_Taas_V1_FeatureSourceDetails = {
  __typename?: 'instacart_ads_platform_taas_v1_FeatureSourceDetails';
  /** feature column */
  column?: Maybe<Scalars['String']>;
  /** feature database */
  database?: Maybe<Scalars['String']>;
  /** feature schema */
  schema?: Maybe<Scalars['String']>;
  /** feature table */
  table?: Maybe<Scalars['String']>;
};

/** Request to generate audience segment from user intention */
export type Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentRequest_Input = {
  /**
   * Specific context in which this segment is valid.
   * The reason we have this field is because we want to generate a segment for a particular universe and context
   * and we want to make sure the generated segment only leverage the features that are supported by the universe and context
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Scope in which to create the new segment. */
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
  /** User intention/description in natural language */
  userIntention?: InputMaybe<Scalars['String']>;
};

/** Response containing generated audience segment definition */
export type Instacart_Ads_Platform_Taas_V1_GenerativeAudienceSegmentResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_GenerativeAudienceSegmentResponse';
  /** The generated segment definition */
  definition?: Maybe<Instacart_Ads_Targeting_V1_TargetingRule>;
};

export type Instacart_Ads_Platform_Taas_V1_GetAllSegmentDefinitionsRequest_Input = {
  /**
   * Only segments matching this context will be returned.
   *
   * This field is REQUIRED. It is not valid to request all segments for an
   * entire universe via this interface.
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Optional IPP user ID to filter favorited segments by. */
  favoritedByIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** When ignore_deleted is true then filter out deleted segments */
  ignoreDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Optional filter to return only favorited segments. */
  isFavoritedSegment?: InputMaybe<Scalars['Boolean']>;
  /** Optional pagination parameters. If not specified, all results are returned (unpaginated). */
  pagination?: InputMaybe<Instacart_Ads_Platform_Taas_V1_PaginationRequest_Input>;
  /**
   * Optional filter by segment types. If empty or not specified, all segment types are returned.
   * Multiple types can be specified to get segments matching any of the specified types.
   */
  segmentTypes?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentType>>>;
  /** Optional sorting parameters. If not specified, defaults to sorting by updated_at DESC. */
  sortOptions?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SortOptions_Input>;
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

/** Request to get all supported features */
export type Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesRequest_Input = {
  /**
   * Only features matching this context via restricted_whitelabel_ids and restricted_retailer_ids will be returned.
   * This field is REQUIRED.
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** list of feature types to be queried */
  featureTypes?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_SupportedFeatureType>>>;
  ignoreToolingEnabled?: InputMaybe<Scalars['Boolean']>;
  offlineEvalOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Response to get all supported features */
export type Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_GetAllSupportedFeaturesResponse';
  /** List of supported features */
  supportedFeatures?: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_SupportedFeature>>>;
};

export type Instacart_Ads_Platform_Taas_V1_GetExactAudienceSizeRequest_Input = {
  /** Scope (Global/Retailer/Partner). */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** Deprecated: ignored. Pass targeting_rule, universe, and context instead. */
  jobKey?: InputMaybe<Scalars['String']>;
  targetingRule?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

export type Instacart_Ads_Platform_Taas_V1_GetExactAudienceSizeResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_GetExactAudienceSizeResponse';
  /** Populated only when status == COMPLETE. */
  metrics?: Maybe<Instacart_Ads_Platform_Taas_V1_AudienceMetrics>;
  status?: Maybe<Instacart_Ads_Platform_Taas_V1_GetExactAudienceSizeResponse_ResultStatus>;
};

export enum Instacart_Ads_Platform_Taas_V1_GetExactAudienceSizeResponse_ResultStatus {
  /** exact count ready */
  Complete = 'COMPLETE',
  /** job failed; retry by submitting a new request */
  Failed = 'FAILED',
  /** still running, poll again */
  Pending = 'PENDING',
  ResultStatusUnknown = 'RESULT_STATUS_UNKNOWN'
}

export type Instacart_Ads_Platform_Taas_V1_GetSegmentDefinitionRequest_Input = {
  /** This field is REQUIRED. */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /**
   * The segment to look up.
   *
   * Must contain an ID, but the version_number is optional. If provided, the
   * response will be the definition for that exact version, which may or may
   * not be the latest (currently live) version. If not provided, then the
   * response will be for the latest (currently live) version of that segment.
   */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
};

export type Instacart_Ads_Platform_Taas_V1_GetSegmentSizeRequest_Input = {
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
};

/** Pagination metadata returned with paginated results */
export type Instacart_Ads_Platform_Taas_V1_PaginationMetadata = {
  __typename?: 'instacart_ads_platform_taas_v1_PaginationMetadata';
  /** Current page number (1-indexed) */
  page?: Maybe<Scalars['Int']>;
  /** Number of items per page */
  pageSize?: Maybe<Scalars['Int']>;
  /** Total number of segments matching the query (across all pages) */
  totalCount?: Maybe<Scalars['Int']>;
  /** Total number of pages available */
  totalPages?: Maybe<Scalars['Int']>;
};

/** Pagination request parameters */
export type Instacart_Ads_Platform_Taas_V1_PaginationRequest_Input = {
  /** Page number (1-indexed). Defaults to 1 if not specified. */
  page?: InputMaybe<Scalars['Int']>;
  /**
   * Number of items per page. Defaults to 20 if not specified.
   * Maximum allowed value is 100.
   */
  pageSize?: InputMaybe<Scalars['Int']>;
};

/**
 * Binds a TriggerConfig to a specific RISE event topic, optionally narrowed
 * by a filter expression evaluated against the event envelope.
 */
export type Instacart_Ads_Platform_Taas_V1_RiseEventBinding = {
  __typename?: 'instacart_ads_platform_taas_v1_RiseEventBinding';
  /**
   * Optional CEL predicate evaluated against the RISE event envelope. Must
   * evaluate to bool. Empty string matches every event on the bound topic.
   * The available envelope bindings and CEL function set are defined by the
   * server-side trigger evaluator; invalid expressions are rejected at write
   * time.
   */
  filterExpression?: Maybe<Scalars['String']>;
  /**
   * Identifier of the RISE event topic this binding subscribes to. Format:
   * lowercase, optionally dot-namespaced (e.g. "cart.add_item_backend",
   * "checkout_completed"). Must match a topic registered in the RISE event
   * catalog; unknown names are rejected at write time.
   */
  riseEventName?: Maybe<Scalars['String']>;
};

/**
 * Binds a TriggerConfig to a specific RISE event topic, optionally narrowed
 * by a filter expression evaluated against the event envelope.
 */
export type Instacart_Ads_Platform_Taas_V1_RiseEventBinding_Input = {
  /**
   * Optional CEL predicate evaluated against the RISE event envelope. Must
   * evaluate to bool. Empty string matches every event on the bound topic.
   * The available envelope bindings and CEL function set are defined by the
   * server-side trigger evaluator; invalid expressions are rejected at write
   * time.
   */
  filterExpression?: InputMaybe<Scalars['String']>;
  /**
   * Identifier of the RISE event topic this binding subscribes to. Format:
   * lowercase, optionally dot-namespaced (e.g. "cart.add_item_backend",
   * "checkout_completed"). Must match a topic registered in the RISE event
   * catalog; unknown names are rejected at write time.
   */
  riseEventName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentId = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentId';
  /** Universe to which the segment belongs. */
  universe?: Maybe<Instacart_Ads_Platform_V1_Universe>;
  /**
   * Unique identifier for a segment. This is guaranteed to be unique among all
   * segments ever created.
   */
  uuid?: Maybe<Scalars['String']>;
  /** Counts the number of revisions that have been made (via UpdateSegment). */
  versionNumber?: Maybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentId_Input = {
  /** Universe to which the segment belongs. */
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
  /**
   * Unique identifier for a segment. This is guaranteed to be unique among all
   * segments ever created.
   */
  uuid?: InputMaybe<Scalars['String']>;
  /** Counts the number of revisions that have been made (via UpdateSegment). */
  versionNumber?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentSize = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentSize';
  /** Audience size of the segment */
  size?: Maybe<Scalars['Int']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentState = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentState';
  /**
   * Specific context in which this segment is valid.
   *
   * NOT editable after the segment is created!
   */
  context?: Maybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction>;
  /**
   * Date-Time this segment version was created. Populated on RPCs whose read
   * path loads it from the store (ListSegmentVersions, GetAllSegmentDefinitions,
   * GetSegmentDefinitionByName); other RPCs leave it unset. Version-history
   * consumers should prefer this over updated_at, which is not per-version.
   */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * The definition of the segment, after the operation.
   *
   * If this field is unset (null), then the segment has been deleted; note
   * that this is semantically very different from an extant definition with no
   * fields filled.
   */
  definition?: Maybe<Instacart_Ads_Targeting_V1_TargetingRule>;
  /** Optional description of the segment. */
  description?: Maybe<Scalars['String']>;
  /** Optional IPP user ID who favorited this segment. */
  favoritedByIppUserId?: Maybe<Scalars['BigInt']>;
  /** The ID of the segment, with the version number after the operation. */
  id?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentId>;
  /** Optional name of the segment. */
  name?: Maybe<Scalars['String']>;
  /** Data to be returned from TaaS when this segment matches. */
  payload?: Maybe<Scalars['GoogleProtobufAnyScalar']>;
  /**
   * Lifecycle status of this version. Populated by ListSegmentVersions; other
   * RPCs leave it SEGMENT_STATUS_UNSPECIFIED. In version history the "definition
   * unset = deleted" convention on field 3 does not apply (tombstones carry the
   * definition forward), so rely on this field.
   */
  status?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentStatus>;
  /**
   * Event-based trigger configuration attached to this segment. Unset for
   * batch-only segments. See TriggerConfig for shape and semantics.
   */
  triggerConfig?: Maybe<Instacart_Ads_Platform_Taas_V1_TriggerConfig>;
  /** Date-Time Segment was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentState_Input = {
  /**
   * Specific context in which this segment is valid.
   *
   * NOT editable after the segment is created!
   */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /**
   * Date-Time this segment version was created. Populated on RPCs whose read
   * path loads it from the store (ListSegmentVersions, GetAllSegmentDefinitions,
   * GetSegmentDefinitionByName); other RPCs leave it unset. Version-history
   * consumers should prefer this over updated_at, which is not per-version.
   */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The definition of the segment, after the operation.
   *
   * If this field is unset (null), then the segment has been deleted; note
   * that this is semantically very different from an extant definition with no
   * fields filled.
   */
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  /** Optional description of the segment. */
  description?: InputMaybe<Scalars['String']>;
  /** Optional IPP user ID who favorited this segment. */
  favoritedByIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** The ID of the segment, with the version number after the operation. */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
  /** Optional name of the segment. */
  name?: InputMaybe<Scalars['String']>;
  /** Data to be returned from TaaS when this segment matches. */
  payload?: InputMaybe<Scalars['GoogleProtobufAnyScalar']>;
  /**
   * Lifecycle status of this version. Populated by ListSegmentVersions; other
   * RPCs leave it SEGMENT_STATUS_UNSPECIFIED. In version history the "definition
   * unset = deleted" convention on field 3 does not apply (tombstones carry the
   * definition forward), so rely on this field.
   */
  status?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentStatus>;
  /**
   * Event-based trigger configuration attached to this segment. Unset for
   * batch-only segments. See TriggerConfig for shape and semantics.
   */
  triggerConfig?: InputMaybe<Instacart_Ads_Platform_Taas_V1_TriggerConfig_Input>;
  /** Date-Time Segment was last updated */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Platform_Taas_V1_SegmentStates = {
  __typename?: 'instacart_ads_platform_taas_v1_SegmentStates';
  /** Optional pagination metadata when pagination is requested */
  paginationMetadata?: Maybe<Instacart_Ads_Platform_Taas_V1_PaginationMetadata>;
  segments?: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>>>;
};

/** Lifecycle status of a segment version. */
export enum Instacart_Ads_Platform_Taas_V1_SegmentStatus {
  /** Live, active definition. */
  SegmentStatusActive = 'SEGMENT_STATUS_ACTIVE',
  /** Records a (soft) deletion of the segment. */
  SegmentStatusDeleted = 'SEGMENT_STATUS_DELETED',
  /** Records a pause (membership-clear) of the segment. */
  SegmentStatusPaused = 'SEGMENT_STATUS_PAUSED',
  /** Not set. Returned by RPCs that do not populate per-version status. */
  SegmentStatusUnspecified = 'SEGMENT_STATUS_UNSPECIFIED'
}

/** Enum representing different segment types based on their features */
export enum Instacart_Ads_Platform_Taas_V1_SegmentType {
  /** All customers segments - segments with no specific feature restrictions */
  SegmentTypeAllCustomers = 'SEGMENT_TYPE_ALL_CUSTOMERS',
  /** API segments - identified by 'dynamic_segment_membership' feature */
  SegmentTypeApi = 'SEGMENT_TYPE_API',
  /** Default value when segment type is not specified */
  SegmentTypeDefault = 'SEGMENT_TYPE_DEFAULT',
  /** Email CSV segments - identified by 'present_in_email_csv' or 'user_id_csvs' features */
  SegmentTypeEmailCsv = 'SEGMENT_TYPE_EMAIL_CSV',
  /** Filter: Golden Segments only. */
  SegmentTypeGolden = 'SEGMENT_TYPE_GOLDEN',
  /** Member CSV segments - identified by 'user_id_csvs' feature with member_ filename prefix in target_values */
  SegmentTypeMemberCsv = 'SEGMENT_TYPE_MEMBER_CSV',
  /** Filter: user's saved ruleset (favorited) segments plus Golden Segments (saved-or-golden combined). */
  SegmentTypeSavedOrGolden = 'SEGMENT_TYPE_SAVED_OR_GOLDEN',
  /** Saved ruleset segments - identified by favorited_by_ipp_user_id being set */
  SegmentTypeSavedRuleset = 'SEGMENT_TYPE_SAVED_RULESET',
  /** Store group segments - identified by 'store_group' feature */
  SegmentTypeStoreGroup = 'SEGMENT_TYPE_STORE_GROUP',
  /**
   * Tooling all customers segments - segments with empty conjunctions AND payload.value.all_customers = true
   * This is stricter than SEGMENT_TYPE_ALL_CUSTOMERS and filters for segments created by the marketing tooling
   */
  SegmentTypeToolingAllCustomers = 'SEGMENT_TYPE_TOOLING_ALL_CUSTOMERS'
}

/** Sort direction */
export enum Instacart_Ads_Platform_Taas_V1_SortDirection {
  /** Ascending order */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** Descending order */
  SortDirectionDesc = 'SORT_DIRECTION_DESC'
}

/** Fields available for sorting */
export enum Instacart_Ads_Platform_Taas_V1_SortField {
  /** Sort by creation timestamp */
  SortFieldCreatedAt = 'SORT_FIELD_CREATED_AT',
  /** Sort by segment name */
  SortFieldName = 'SORT_FIELD_NAME',
  /** Unknown or unspecified sort field - defaults to updated_at */
  SortFieldUnknown = 'SORT_FIELD_UNKNOWN',
  /** Sort by last updated timestamp */
  SortFieldUpdatedAt = 'SORT_FIELD_UPDATED_AT'
}

/** Sorting options for segment results */
export type Instacart_Ads_Platform_Taas_V1_SortOptions_Input = {
  /** Sort direction (ascending or descending) */
  sortDirection?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SortDirection>;
  /** Field to sort by */
  sortField?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SortField>;
};

export type Instacart_Ads_Platform_Taas_V1_SubmitExactAudienceSizeRequest_Input = {
  /**
   * CRM channels to include eligibility metrics for in the response.
   * Supported values: "email", "push". An empty list omits all CRM metrics.
   */
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Scope (Global/Retailer/Partner). */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  targetingRule?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  universe?: InputMaybe<Instacart_Ads_Platform_V1_Universe>;
};

export type Instacart_Ads_Platform_Taas_V1_SubmitExactAudienceSizeResponse = {
  __typename?: 'instacart_ads_platform_taas_v1_SubmitExactAudienceSizeResponse';
  /**
   * Deprecated: no longer populated. The job_key is an internal implementation
   * detail and is not needed by clients.
   */
  jobKey?: Maybe<Scalars['String']>;
  /** Indicates the outcome of the submission request. */
  status?: Maybe<Instacart_Ads_Platform_Taas_V1_SubmitExactAudienceSizeResponse_JobStatus>;
};

export enum Instacart_Ads_Platform_Taas_V1_SubmitExactAudienceSizeResponse_JobStatus {
  /** A job for this rule is already in progress. */
  AlreadyRunning = 'ALREADY_RUNNING',
  /** The job has finished. */
  Complete = 'COMPLETE',
  JobStatusUnknown = 'JOB_STATUS_UNKNOWN',
  /** A new job was accepted. */
  Submitted = 'SUBMITTED'
}

/** Supported feature */
export type Instacart_Ads_Platform_Taas_V1_SupportedFeature = {
  __typename?: 'instacart_ads_platform_taas_v1_SupportedFeature';
  /** Whether the feature is contextual or regular feature */
  contextual?: Maybe<Scalars['Boolean']>;
  /** data granularity of the feature */
  dataGranularity?: Maybe<Scalars['String']>;
  /** data refreshness of the feature such as daily, every 2 hours, near real-time */
  dataRefreshness?: Maybe<Scalars['String']>;
  /**
   * True when this feature has been deprecated via DeleteFeature. Deprecated
   * features are retained but are not served. False means the feature is active.
   */
  deprecated?: Maybe<Scalars['Boolean']>;
  /** Description of the feature */
  description?: Maybe<Scalars['String']>;
  /** DynamoDB table identifier this feature is resolved from. */
  dynamodbTable?: Maybe<Scalars['String']>;
  /** the source of the eligible values of the feature */
  eligibleValueSource?: Maybe<Scalars['String']>;
  /** the eligible values of the feature */
  eligibleValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the logical primary key in TaaS storage */
  entityIds?: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_EntityId>>>;
  /** whether the feature is enabled */
  featureEnabled?: Maybe<Scalars['Boolean']>;
  /** feature data used by offline jobs to populate necessary feature data */
  featureSourceDetails?: Maybe<Instacart_Ads_Platform_Taas_V1_FeatureSourceDetails>;
  /** ipp specific meta info such as required_permissions, roulette */
  ippMetadata?: Maybe<Scalars['JSON']>;
  /**
   * Storage shape: true when the upstream column is a map<key, value> rather
   * than a scalar of `type`. Orthogonal to `type`, which always describes the
   * leaf value type. Callers branch on this to decode the column accordingly.
   */
  isMap?: Maybe<Scalars['Boolean']>;
  /**
   * Scope: whether this feature is written into the Marketplace and/or SFX
   * physical unified-user-features DynamoDB tables. Both may be true for
   * cross-scope features. Mirrors supported_features.is_marketplace_supported /
   * is_sfx_supported.
   */
  isMarketplaceSupported?: Maybe<Scalars['Boolean']>;
  isSfxSupported?: Maybe<Scalars['Boolean']>;
  /** Name of the feature */
  name?: Maybe<Scalars['String']>;
  /** offline support for the feature */
  offlineEvalSupport?: Maybe<Scalars['Boolean']>;
  /** Online eval Support for the feature */
  onlineEvalSupport?: Maybe<Scalars['Boolean']>;
  /** the supported retailers. If this is not specified, it means the feature is available for all the retailers */
  restrictedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** the supported whitelabel site. If this is not specified, it means the feature is available for all the whitelabel sites */
  restrictedWhitelabelIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** whether the feature is enabled in serving */
  servingEnabled?: Maybe<Scalars['Boolean']>;
  /** data source type of the feature */
  sourceType?: Maybe<Instacart_Ads_Platform_Taas_V1_FeatureDataSourceType>;
  /** whether the feature is enabled in tooling */
  toolingEnabled?: Maybe<Scalars['Boolean']>;
  /** Type of the feature */
  type?: Maybe<Instacart_Ads_Platform_Taas_V1_SupportedFeatureType>;
  /**
   * Server-managed version of this feature, starting at 1 on creation and
   * bumped on every successful mutation. Returned populated on the Create /
   * Update / Delete feature responses; echo the most recent value back as
   * `expected_version` on UpdateFeature / DeleteFeature, and the server rejects
   * the write with FAILED_PRECONDITION if the value no longer matches.
   */
  version?: Maybe<Scalars['BigInt']>;
};

/**
 * Type of the feature this is mapped to taas_config.go
 * https://github.com/instacart/carrot/blob/master/ads/targeting/rule-engine/taas_config.go#L12
 */
export enum Instacart_Ads_Platform_Taas_V1_SupportedFeatureType {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING',
  StringList = 'STRING_LIST',
  Time = 'TIME',
  /** Unknown type placeholder */
  Unknown = 'UNKNOWN'
}

/** Per-segment timer shape for delayed-shape triggers. */
export type Instacart_Ads_Platform_Taas_V1_TimerSpec = {
  __typename?: 'instacart_ads_platform_taas_v1_TimerSpec';
  /**
   * Per-(user, segment) inactivity window. Each matching RISE event resets
   * the timer; the trigger fires when no matching event arrives for this
   * duration.
   */
  inactivityWindow?: Maybe<Scalars['String']>;
  /**
   * Hard cap on time-from-arm to fire, enforced server-side. Must be
   * >= inactivity_window. Bounds per-(user, segment) state growth.
   */
  maxWindow?: Maybe<Scalars['String']>;
};

/** Per-segment timer shape for delayed-shape triggers. */
export type Instacart_Ads_Platform_Taas_V1_TimerSpec_Input = {
  /**
   * Per-(user, segment) inactivity window. Each matching RISE event resets
   * the timer; the trigger fires when no matching event arrives for this
   * duration.
   */
  inactivityWindow?: InputMaybe<Scalars['String']>;
  /**
   * Hard cap on time-from-arm to fire, enforced server-side. Must be
   * >= inactivity_window. Bounds per-(user, segment) state growth.
   */
  maxWindow?: InputMaybe<Scalars['String']>;
};

/**
 * Event-based trigger configuration attached to a segment.
 *
 * A segment whose trigger_config is unset is evaluated batch-only. When
 * trigger_config is present and the segment is active, matching RISE events
 * drive per-(user, segment) trigger firings whose shape is controlled by the
 * timer field. Each firing causes the segment to be re-evaluated for the
 * affected user.
 */
export type Instacart_Ads_Platform_Taas_V1_TriggerConfig = {
  __typename?: 'instacart_ads_platform_taas_v1_TriggerConfig';
  /**
   * Optional. RISE events that, when observed before a delayed-shape trigger
   * fires, clear the armed timer and per-(user, segment) state. Invalid for
   * immediate-shape triggers (timer unset).
   */
  cancelRiseEventBindings?: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_RiseEventBinding>>>;
  /**
   * Envelope field names to copy from the triggering RISE event into the
   * resulting trigger event's context. Each entry is a top-level field on
   * the RISE event envelope (e.g. "store_configuration_id"); nested paths
   * and wildcards are not supported, and missing fields are skipped. The
   * captured values are surfaced as evaluation-time context features.
   */
  captureEventFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** RISE events that arm or refire the trigger. Empty = invalid. */
  riseEventBindings?: Maybe<Array<Maybe<Instacart_Ads_Platform_Taas_V1_RiseEventBinding>>>;
  /**
   * When set, the trigger uses the "delayed" shape: arm a cancel-and-replace
   * event-time timer per (user, segment), fire on inactivity_window expiry
   * bounded by max_window. When unset, the trigger uses the "immediate" shape:
   * every matching RISE event fires immediately with no keyed state.
   */
  timer?: Maybe<Instacart_Ads_Platform_Taas_V1_TimerSpec>;
};

/**
 * Event-based trigger configuration attached to a segment.
 *
 * A segment whose trigger_config is unset is evaluated batch-only. When
 * trigger_config is present and the segment is active, matching RISE events
 * drive per-(user, segment) trigger firings whose shape is controlled by the
 * timer field. Each firing causes the segment to be re-evaluated for the
 * affected user.
 */
export type Instacart_Ads_Platform_Taas_V1_TriggerConfig_Input = {
  /**
   * Optional. RISE events that, when observed before a delayed-shape trigger
   * fires, clear the armed timer and per-(user, segment) state. Invalid for
   * immediate-shape triggers (timer unset).
   */
  cancelRiseEventBindings?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_RiseEventBinding_Input>>>;
  /**
   * Envelope field names to copy from the triggering RISE event into the
   * resulting trigger event's context. Each entry is a top-level field on
   * the RISE event envelope (e.g. "store_configuration_id"); nested paths
   * and wildcards are not supported, and missing fields are skipped. The
   * captured values are surfaced as evaluation-time context features.
   */
  captureEventFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** RISE events that arm or refire the trigger. Empty = invalid. */
  riseEventBindings?: InputMaybe<Array<InputMaybe<Instacart_Ads_Platform_Taas_V1_RiseEventBinding_Input>>>;
  /**
   * When set, the trigger uses the "delayed" shape: arm a cancel-and-replace
   * event-time timer per (user, segment), fire on inactivity_window expiry
   * bounded by max_window. When unset, the trigger uses the "immediate" shape:
   * every matching RISE event fires immediately with no keyed state.
   */
  timer?: InputMaybe<Instacart_Ads_Platform_Taas_V1_TimerSpec_Input>;
};

/**
 * This request has OVERWRITE semantics - any existing definition for the segment
 * or its payload will be dropped entirely. Merge semantics, if necessary, are
 * left to the client - the client can get the current definition with
 * GetSegmentDefinition, then assemble what they want the final state to be.
 */
export type Instacart_Ads_Platform_Taas_V1_UpdateSegmentRequest_Input = {
  /** This field is REQUIRED. */
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** The new definition of the segment. */
  definition?: InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Input>;
  /** Optional description of the segment. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * The ID of the segment to be modified. If the segment does not exist, or if
   * the version number in this field does not match the actual most-recent
   * version number for the segment, then the request will fail.
   */
  id?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentId_Input>;
  /** Optional name of the segment. */
  name?: InputMaybe<Scalars['String']>;
  /** New data to be returned from TaaS when this segment matches. */
  payload?: InputMaybe<Scalars['GoogleProtobufAnyScalar']>;
  /**
   * Optional event-based trigger configuration. Merge semantics: unset
   * preserves the prior config unchanged; set replaces the prior config
   * entirely. To clear an existing trigger, callers must use a dedicated
   * clear operation (not yet exposed) rather than sending an unset field.
   */
  triggerConfig?: InputMaybe<Instacart_Ads_Platform_Taas_V1_TriggerConfig_Input>;
};

/**
 * A set of distinct tenants of Ads Platform services. All requests should be
 * scoped to a particular universe, which may imply additional restrictions on
 * available functionality.
 */
export enum Instacart_Ads_Platform_V1_Universe {
  ScopeAds = 'SCOPE_ADS',
  ScopeAdsDiscounts = 'SCOPE_ADS_DISCOUNTS',
  ScopeCmdMarketplace = 'SCOPE_CMD_MARKETPLACE',
  ScopeCmdSfx = 'SCOPE_CMD_SFX',
  ScopeIbottaPromotions = 'SCOPE_IBOTTA_PROMOTIONS',
  ScopeInternalTesting = 'SCOPE_INTERNAL_TESTING',
  ScopeItemAvailability = 'SCOPE_ITEM_AVAILABILITY',
  ScopeRetailerPromotion = 'SCOPE_RETAILER_PROMOTION',
  ScopeRetailerRankingAndBoosting = 'SCOPE_RETAILER_RANKING_AND_BOOSTING',
  /** Default/invalid */
  ScopeUnknown = 'SCOPE_UNKNOWN'
}

/**
 * VersionedIdentifier contains a set of fields that give metadata for the current
 * record version.
 */
export type Instacart_Ads_Shared_V1_VersionedIdentifier = {
  __typename?: 'instacart_ads_shared_v1_VersionedIdentifier';
  /**
   * Indicates the first time this entity was created (i.e. the creation of the first
   * version). This should **NEVER** be used in any kind of optimistic locking.
   */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The unique identifier of this particular entity across the models. */
  id?: Maybe<Scalars['String']>;
  /**
   * Indicates the last time this particular version was updated. This should **NEVER**
   * be used as a lock key of any sort. This should **NEVER** be used in any kind
   * of optimistic locking.
   */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The particular version of this entity. This usually changes whenever of its
   * fields does. Please note that, while this is an increasing number, it should **NOT**
   * be used as a lock key for optimistic locking or similar.
   */
  version?: Maybe<Scalars['BigInt']>;
};

/**
 * VersionedIdentifier contains a set of fields that give metadata for the current
 * record version.
 */
export type Instacart_Ads_Shared_V1_VersionedIdentifier_Input = {
  /**
   * Indicates the first time this entity was created (i.e. the creation of the first
   * version). This should **NEVER** be used in any kind of optimistic locking.
   */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** The unique identifier of this particular entity across the models. */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Indicates the last time this particular version was updated. This should **NEVER**
   * be used as a lock key of any sort. This should **NEVER** be used in any kind
   * of optimistic locking.
   */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * The particular version of this entity. This usually changes whenever of its
   * fields does. Please note that, while this is an increasing number, it should **NOT**
   * be used as a lock key for optimistic locking or similar.
   */
  version?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Ads_Targeting_V1_AlcoholBuyerLicense {
  /** off_premise implies that they sell alcohol for consumption off premise (eg. Bevmo) */
  AlcoholOffPremises = 'ALCOHOL_OFF_PREMISES',
  /**
   * on_and_off_premise implies that they sell alcohol for consumption both on and off premises (eg. Brewery)
   * This is a distinct license and NOT equivalent to having both an on_premise and an off_premise license.
   */
  AlcoholOnAndOffPremises = 'ALCOHOL_ON_AND_OFF_PREMISES',
  /** on_premise implies that they only sell alcohol on premise (eg. restaurant) */
  AlcoholOnPremises = 'ALCOHOL_ON_PREMISES',
  BuyerLicenseUnknown = 'BUYER_LICENSE_UNKNOWN'
}

export type Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition = {
  __typename?: 'instacart_ads_targeting_v1_AlcoholBuyerLicenseCondition';
  /**
   * This represents the Alcohol license for a user.
   * The license is relevent only for retailers at the moment.
   * This is an OR, the licenses list is a form of A || B || C
   * For example, ALCOHOL_ON_PREMISES OR ALCOHOL_OFF_PREMISES can be combined for both cases
   * Like (eg. brewery)
   */
  licenses?: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicense>>>;
};

export type Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition_Input = {
  /**
   * This represents the Alcohol license for a user.
   * The license is relevent only for retailers at the moment.
   * This is an OR, the licenses list is a form of A || B || C
   * For example, ALCOHOL_ON_PREMISES OR ALCOHOL_OFF_PREMISES can be combined for both cases
   * Like (eg. brewery)
   */
  licenses?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicense>>>;
};

export type Instacart_Ads_Targeting_V1_Audience = {
  __typename?: 'instacart_ads_targeting_v1_Audience';
  audienceId?: Maybe<Scalars['String']>;
};

/** Condition for predefined audiences generated from ML models. */
export type Instacart_Ads_Targeting_V1_AudienceCondition = {
  __typename?: 'instacart_ads_targeting_v1_AudienceCondition';
  /** Only target users that are assigned any of the audiences. */
  audiences?: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_Audience>>>;
};

/** Condition for predefined audiences generated from ML models. */
export type Instacart_Ads_Targeting_V1_AudienceCondition_Input = {
  /** Only target users that are assigned any of the audiences. */
  audiences?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_Audience_Input>>>;
};

export type Instacart_Ads_Targeting_V1_Audience_Input = {
  audienceId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Targeting_V1_BoolCondition = {
  __typename?: 'instacart_ads_targeting_v1_BoolCondition';
  mapKey?: Maybe<Scalars['String']>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
};

export type Instacart_Ads_Targeting_V1_BoolCondition_Input = {
  mapKey?: InputMaybe<Scalars['String']>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
};

/**
 * Condition that requires a user to have bought a product from one of the
 * given brands.
 */
export type Instacart_Ads_Targeting_V1_BrandIdCondition = {
  __typename?: 'instacart_ads_targeting_v1_BrandIdCondition';
  /** Brands in which purchases are considered. */
  brandIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * A single BrandIdCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two BrandIdCondition, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: Maybe<Scalars['String']>;
};

/**
 * Condition that requires a user to have bought a product from one of the
 * given brands.
 */
export type Instacart_Ads_Targeting_V1_BrandIdCondition_Input = {
  /** Brands in which purchases are considered. */
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * A single BrandIdCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two BrandIdCondition, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: InputMaybe<Scalars['String']>;
};

/**
 * Condition that requires a user to have bought a product from
 * one of the given categories.
 */
export type Instacart_Ads_Targeting_V1_CategoryCondition = {
  __typename?: 'instacart_ads_targeting_v1_CategoryCondition';
  /** Product categories in which purchases are considered. */
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single CategoryCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two CategoryConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: Maybe<Scalars['String']>;
};

/**
 * Condition that requires a user to have bought a product from
 * one of the given categories.
 */
export type Instacart_Ads_Targeting_V1_CategoryCondition_Input = {
  /** Product categories in which purchases are considered. */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single CategoryCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * It is invalid not to specify a time window. Not all time window values
   * will be valid; writers should use the targeting dictionary API (coming
   * soon) to find valid values.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two CategoryConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Ads_Targeting_V1_ComparisonOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  /** only for string, time, time window types */
  IsEmpty = 'IS_EMPTY',
  LessThan = 'LESS_THAN',
  Unknown = 'UNKNOWN'
}

export enum Instacart_Ads_Targeting_V1_CrossRetailerReducer {
  Max = 'MAX',
  Min = 'MIN',
  None = 'NONE',
  Sum = 'SUM'
}

export type Instacart_Ads_Targeting_V1_EmailCsvCondition = {
  __typename?: 'instacart_ads_targeting_v1_EmailCsvCondition';
  /** This represents the name of the uploaded csv file. */
  emailCsvName?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  whitelabelId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_EmailCsvCondition_Input = {
  /** This represents the name of the uploaded csv file. */
  emailCsvName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_FloatCondition = {
  __typename?: 'instacart_ads_targeting_v1_FloatCondition';
  crossRetailerReducer?: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  operator?: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  threshold?: Maybe<Scalars['Float']>;
};

export type Instacart_Ads_Targeting_V1_FloatCondition_Input = {
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  threshold?: InputMaybe<Scalars['Float']>;
};

/** For geo targeting. */
export type Instacart_Ads_Targeting_V1_Geo = {
  __typename?: 'instacart_ads_targeting_v1_Geo';
  /** Currently ignored. All Geo matching elements must specify a state. */
  countryCode?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
};

/** Condition for geo check. */
export type Instacart_Ads_Targeting_V1_GeoCondition = {
  __typename?: 'instacart_ads_targeting_v1_GeoCondition';
  /** Only target users in any of the regions. */
  geo?: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_Geo>>>;
};

/** Condition for geo check. */
export type Instacart_Ads_Targeting_V1_GeoCondition_Input = {
  /** Only target users in any of the regions. */
  geo?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_Geo_Input>>>;
};

/** For geo targeting. */
export type Instacart_Ads_Targeting_V1_Geo_Input = {
  /** Currently ignored. All Geo matching elements must specify a state. */
  countryCode?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  stateCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Ads_Targeting_V1_IntCondition = {
  __typename?: 'instacart_ads_targeting_v1_IntCondition';
  crossRetailerReducer?: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  operator?: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  /** List-based matching; mutually exclusive with threshold. */
  targetValues?: Maybe<Instacart_Ads_Targeting_V1_IntTargetValues>;
  threshold?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_IntCondition_Input = {
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  /** List-based matching; mutually exclusive with threshold. */
  targetValues?: InputMaybe<Instacart_Ads_Targeting_V1_IntTargetValues_Input>;
  threshold?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_IntTargetValues = {
  __typename?: 'instacart_ads_targeting_v1_IntTargetValues';
  /** The list of int values to match against. */
  values?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Ads_Targeting_V1_IntTargetValues_Input = {
  /** The list of int values to match against. */
  values?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Ads_Targeting_V1_Region = {
  __typename?: 'instacart_ads_targeting_v1_Region';
  regionCode?: Maybe<Instacart_Ads_Targeting_V1_RegionCode>;
};

export enum Instacart_Ads_Targeting_V1_RegionCode {
  AlcoholEast = 'ALCOHOL_EAST',
  AlcoholEastNorthCentral = 'ALCOHOL_EAST_NORTH_CENTRAL',
  /** alcohol advertiser region codes */
  AlcoholWest = 'ALCOHOL_WEST',
  AlcoholWestNorthCentral = 'ALCOHOL_WEST_NORTH_CENTRAL',
  CcConsolidated = 'CC_CONSOLIDATED',
  CcHeartland = 'CC_HEARTLAND',
  CcLiberty = 'CC_LIBERTY',
  CcReyes = 'CC_REYES',
  CcSouthwest = 'CC_SOUTHWEST',
  /** Coca Cola region codes */
  CcSwire = 'CC_SWIRE',
  DefaultEastNorthCentral = 'DEFAULT_EAST_NORTH_CENTRAL',
  DefaultMiddleAtlantic = 'DEFAULT_MIDDLE_ATLANTIC',
  DefaultMidwest = 'DEFAULT_MIDWEST',
  DefaultMountain = 'DEFAULT_MOUNTAIN',
  DefaultNewEngland = 'DEFAULT_NEW_ENGLAND',
  /** default region codes */
  DefaultPacific = 'DEFAULT_PACIFIC',
  DefaultSouthAtlantic = 'DEFAULT_SOUTH_ATLANTIC',
  DefaultSouthCentral = 'DEFAULT_SOUTH_CENTRAL',
  DefaultWestNorthCentral = 'DEFAULT_WEST_NORTH_CENTRAL',
  UnknownRegion = 'UNKNOWN_REGION'
}

export type Instacart_Ads_Targeting_V1_RegionCondition = {
  __typename?: 'instacart_ads_targeting_v1_RegionCondition';
  /** Create by mistake. Use regions instead. */
  region?: Maybe<Instacart_Ads_Targeting_V1_Region>;
  regions?: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_Region>>>;
};

export type Instacart_Ads_Targeting_V1_RegionCondition_Input = {
  /** Create by mistake. Use regions instead. */
  region?: InputMaybe<Instacart_Ads_Targeting_V1_Region_Input>;
  regions?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_Region_Input>>>;
};

export type Instacart_Ads_Targeting_V1_Region_Input = {
  regionCode?: InputMaybe<Instacart_Ads_Targeting_V1_RegionCode>;
};

export type Instacart_Ads_Targeting_V1_RetailerDetails = {
  __typename?: 'instacart_ads_targeting_v1_RetailerDetails';
  orderSource?: Maybe<Scalars['String']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context. This allows one rule to be reused across contexts, but
   * be evaluated with context-specific data.
   */
  retailerFromContext?: Maybe<Scalars['google_protobuf_Empty']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_RetailerDetails_Input = {
  orderSource?: InputMaybe<Scalars['String']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context. This allows one rule to be reused across contexts, but
   * be evaluated with context-specific data.
   */
  retailerFromContext?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Ads_Targeting_V1_SetComparisonOperator {
  /** Elements must exactly match between target and feature sets. */
  EqualElements = 'EQUAL_ELEMENTS',
  /** Check if the feature set is null or empty */
  IsEmptySet = 'IS_EMPTY_SET',
  /** At least one element is common between target and feature sets. */
  NonEmptyIntersection = 'NON_EMPTY_INTERSECTION',
  NonEmptyIntersectionWithContext = 'NON_EMPTY_INTERSECTION_WITH_CONTEXT',
  UnknownSetOperator = 'UNKNOWN_SET_OPERATOR'
}

export type Instacart_Ads_Targeting_V1_StringCondition = {
  __typename?: 'instacart_ads_targeting_v1_StringCondition';
  isRegex?: Maybe<Scalars['Boolean']>;
  mapKey?: Maybe<Scalars['String']>;
  operator?: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  /** For matching against a single target string. */
  targetValue?: Maybe<Scalars['String']>;
  /** For matching against any of multiple target strings. */
  targetValues?: Maybe<Instacart_Ads_Targeting_V1_StringTargetValues>;
};

export type Instacart_Ads_Targeting_V1_StringCondition_Input = {
  isRegex?: InputMaybe<Scalars['Boolean']>;
  mapKey?: InputMaybe<Scalars['String']>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  /** For matching against a single target string. */
  targetValue?: InputMaybe<Scalars['String']>;
  /** For matching against any of multiple target strings. */
  targetValues?: InputMaybe<Instacart_Ads_Targeting_V1_StringTargetValues_Input>;
};

/** This condition compares two lists of strings with one of the available operators */
export type Instacart_Ads_Targeting_V1_StringListCondition = {
  __typename?: 'instacart_ads_targeting_v1_StringListCondition';
  isCaseInsensitive?: Maybe<Scalars['Boolean']>;
  mapKey?: Maybe<Scalars['String']>;
  /** Operator defaults to NON_EMPTY_INTERSECTION for backward compatibility */
  operator?: Maybe<Instacart_Ads_Targeting_V1_SetComparisonOperator>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  targetValues?: Maybe<Scalars['JSON']>;
};

/** This condition compares two lists of strings with one of the available operators */
export type Instacart_Ads_Targeting_V1_StringListCondition_Input = {
  isCaseInsensitive?: InputMaybe<Scalars['Boolean']>;
  mapKey?: InputMaybe<Scalars['String']>;
  /** Operator defaults to NON_EMPTY_INTERSECTION for backward compatibility */
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_SetComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  targetValues?: InputMaybe<Scalars['JSON']>;
};

export type Instacart_Ads_Targeting_V1_StringTargetValues = {
  __typename?: 'instacart_ads_targeting_v1_StringTargetValues';
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Ads_Targeting_V1_StringTargetValues_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * A TargetingRule is a Boolean-logic rule over features of a user or serving
 * context. Rules are stored with creatives/adgroups. At serving time, each
 * creative is eligible to participate in an auction only if its TargetingRule
 * is satisfied by that auction's context.
 *
 * A rule is defined in disjunctive-normal form (an OR of ANDs). (Note,
 * however, that individual rule elements may themselves implicitly be
 * disjunctions - for instance, by specifying a list of product categories on
 * which to match behavior.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule = {
  __typename?: 'instacart_ads_targeting_v1_TargetingRule';
  /**
   * If any of the conjunctions in this list is satisfied, then the rule is
   * satisfied.
   *
   * As a special case, if this list is empty, then the rule is also satisfied.
   * That means that a rule with no conjunctions is semantically equivalent to
   * a rule with a single, empty conjunction.
   */
  conjunctions?: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_TargetingRule_Conjunction>>>;
};

export type Instacart_Ads_Targeting_V1_TargetingRuleElement = {
  __typename?: 'instacart_ads_targeting_v1_TargetingRuleElement';
  alcoholBuyerLicenseCondition?: Maybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition>;
  /**
   * Special value for conditions that are always true. For system-internal
   * use only (e.g., as a simplification of A OR !A); should not be set
   * normally. If 'not' is set, then this element should always evaulate to
   * false.
   */
  alwaysTrue?: Maybe<Scalars['google_protobuf_Empty']>;
  audience?: Maybe<Instacart_Ads_Targeting_V1_AudienceCondition>;
  boolCondition?: Maybe<Instacart_Ads_Targeting_V1_BoolCondition>;
  brandId?: Maybe<Instacart_Ads_Targeting_V1_BrandIdCondition>;
  brandIdInterest?: Maybe<Instacart_Ads_Targeting_V1_BrandIdCondition>;
  category?: Maybe<Instacart_Ads_Targeting_V1_CategoryCondition>;
  categoryInterest?: Maybe<Instacart_Ads_Targeting_V1_CategoryCondition>;
  emailCsvCondition?: Maybe<Instacart_Ads_Targeting_V1_EmailCsvCondition>;
  /** The feature dependency for a given targeting rule. */
  feature?: Maybe<Scalars['String']>;
  floatCondition?: Maybe<Instacart_Ads_Targeting_V1_FloatCondition>;
  geo?: Maybe<Instacart_Ads_Targeting_V1_GeoCondition>;
  /** These conditions are used for implementing generic use cases and should be used by retailers to set up all taas segments */
  intCondition?: Maybe<Instacart_Ads_Targeting_V1_IntCondition>;
  newToInstacart?: Maybe<Scalars['instacart_ads_targeting_v1_NewToInstacartCondition']>;
  /**
   * Logical NOT: inverts the condition to match users/contexts where the
   * condition is otherwise not true.
   */
  not?: Maybe<Scalars['Boolean']>;
  region?: Maybe<Instacart_Ads_Targeting_V1_RegionCondition>;
  stringCondition?: Maybe<Instacart_Ads_Targeting_V1_StringCondition>;
  stringListCondition?: Maybe<Instacart_Ads_Targeting_V1_StringListCondition>;
  timeCondition?: Maybe<Instacart_Ads_Targeting_V1_TimeCondition>;
  timeIntervalCondition?: Maybe<Instacart_Ads_Targeting_V1_TimeIntervalCondition>;
  upc?: Maybe<Instacart_Ads_Targeting_V1_UpcCondition>;
  upcInterest?: Maybe<Instacart_Ads_Targeting_V1_UpcCondition>;
  userOrdersCount?: Maybe<Instacart_Ads_Targeting_V1_UserOrdersCountCondition>;
};

export type Instacart_Ads_Targeting_V1_TargetingRuleElement_Input = {
  alcoholBuyerLicenseCondition?: InputMaybe<Instacart_Ads_Targeting_V1_AlcoholBuyerLicenseCondition_Input>;
  /**
   * Special value for conditions that are always true. For system-internal
   * use only (e.g., as a simplification of A OR !A); should not be set
   * normally. If 'not' is set, then this element should always evaulate to
   * false.
   */
  alwaysTrue?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  audience?: InputMaybe<Instacart_Ads_Targeting_V1_AudienceCondition_Input>;
  boolCondition?: InputMaybe<Instacart_Ads_Targeting_V1_BoolCondition_Input>;
  brandId?: InputMaybe<Instacart_Ads_Targeting_V1_BrandIdCondition_Input>;
  brandIdInterest?: InputMaybe<Instacart_Ads_Targeting_V1_BrandIdCondition_Input>;
  category?: InputMaybe<Instacart_Ads_Targeting_V1_CategoryCondition_Input>;
  categoryInterest?: InputMaybe<Instacart_Ads_Targeting_V1_CategoryCondition_Input>;
  emailCsvCondition?: InputMaybe<Instacart_Ads_Targeting_V1_EmailCsvCondition_Input>;
  /** The feature dependency for a given targeting rule. */
  feature?: InputMaybe<Scalars['String']>;
  floatCondition?: InputMaybe<Instacart_Ads_Targeting_V1_FloatCondition_Input>;
  geo?: InputMaybe<Instacart_Ads_Targeting_V1_GeoCondition_Input>;
  /** These conditions are used for implementing generic use cases and should be used by retailers to set up all taas segments */
  intCondition?: InputMaybe<Instacart_Ads_Targeting_V1_IntCondition_Input>;
  newToInstacart?: InputMaybe<Scalars['instacart_ads_targeting_v1_NewToInstacartCondition_Input']>;
  /**
   * Logical NOT: inverts the condition to match users/contexts where the
   * condition is otherwise not true.
   */
  not?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Instacart_Ads_Targeting_V1_RegionCondition_Input>;
  stringCondition?: InputMaybe<Instacart_Ads_Targeting_V1_StringCondition_Input>;
  stringListCondition?: InputMaybe<Instacart_Ads_Targeting_V1_StringListCondition_Input>;
  timeCondition?: InputMaybe<Instacart_Ads_Targeting_V1_TimeCondition_Input>;
  timeIntervalCondition?: InputMaybe<Instacart_Ads_Targeting_V1_TimeIntervalCondition_Input>;
  upc?: InputMaybe<Instacart_Ads_Targeting_V1_UpcCondition_Input>;
  upcInterest?: InputMaybe<Instacart_Ads_Targeting_V1_UpcCondition_Input>;
  userOrdersCount?: InputMaybe<Instacart_Ads_Targeting_V1_UserOrdersCountCondition_Input>;
};

/**
 * Within a single conjunction, /all/ elements must be satisfied in order for
 * the conjunction to be satisfied.
 *
 * As a special case, if the list of elements is empty, then the conjunction
 * is also satisfied. (Another way of looking at this: every conjunction
 * implicitly includes literal TRUE.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule_Conjunction = {
  __typename?: 'instacart_ads_targeting_v1_TargetingRule_Conjunction';
  elements?: Maybe<Array<Maybe<Instacart_Ads_Targeting_V1_TargetingRuleElement>>>;
};

/**
 * Within a single conjunction, /all/ elements must be satisfied in order for
 * the conjunction to be satisfied.
 *
 * As a special case, if the list of elements is empty, then the conjunction
 * is also satisfied. (Another way of looking at this: every conjunction
 * implicitly includes literal TRUE.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule_Conjunction_Input = {
  elements?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_TargetingRuleElement_Input>>>;
};

/**
 * A TargetingRule is a Boolean-logic rule over features of a user or serving
 * context. Rules are stored with creatives/adgroups. At serving time, each
 * creative is eligible to participate in an auction only if its TargetingRule
 * is satisfied by that auction's context.
 *
 * A rule is defined in disjunctive-normal form (an OR of ANDs). (Note,
 * however, that individual rule elements may themselves implicitly be
 * disjunctions - for instance, by specifying a list of product categories on
 * which to match behavior.)
 */
export type Instacart_Ads_Targeting_V1_TargetingRule_Input = {
  /**
   * If any of the conjunctions in this list is satisfied, then the rule is
   * satisfied.
   *
   * As a special case, if this list is empty, then the rule is also satisfied.
   * That means that a rule with no conjunctions is semantically equivalent to
   * a rule with a single, empty conjunction.
   */
  conjunctions?: InputMaybe<Array<InputMaybe<Instacart_Ads_Targeting_V1_TargetingRule_Conjunction_Input>>>;
};

export type Instacart_Ads_Targeting_V1_TimeCondition = {
  __typename?: 'instacart_ads_targeting_v1_TimeCondition';
  crossRetailerReducer?: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  operator?: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  threshold?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Targeting_V1_TimeCondition_Input = {
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  threshold?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Ads_Targeting_V1_TimeIntervalCondition = {
  __typename?: 'instacart_ads_targeting_v1_TimeIntervalCondition';
  /**
   * MAX/MIN here means we will take the max/min of the times and then compare with the time interval specified
   * We will not be taking max/min of the intervals
   */
  crossRetailerReducer?: Maybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapIndices?: Maybe<Array<Maybe<Scalars['String']>>>;
  mapKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  operator?: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: Maybe<Instacart_Ads_Targeting_V1_RetailerDetails>;
  timeWindow?: Maybe<Scalars['String']>;
};

export type Instacart_Ads_Targeting_V1_TimeIntervalCondition_Input = {
  /**
   * MAX/MIN here means we will take the max/min of the times and then compare with the time interval specified
   * We will not be taking max/min of the intervals
   */
  crossRetailerReducer?: InputMaybe<Instacart_Ads_Targeting_V1_CrossRetailerReducer>;
  mapIndices?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mapKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  retailerDetails?: InputMaybe<Instacart_Ads_Targeting_V1_RetailerDetails_Input>;
  timeWindow?: InputMaybe<Scalars['String']>;
};

/** Condition for availability check. */
export type Instacart_Ads_Targeting_V1_UpcCondition = {
  __typename?: 'instacart_ads_targeting_v1_UPCCondition';
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single UPCCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * If the time window is empty, this field is for availability check.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two UPCConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: Maybe<Scalars['String']>;
  /**
   * At least 1 of the UPCs must be available at the stores
   * in which the user has shopped (or is shopping).
   */
  upcs?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Condition for availability check. */
export type Instacart_Ads_Targeting_V1_UpcCondition_Input = {
  /**
   * Time range in which to consider purchase, relative to the auction time.
   *
   * A single UPCCondition's time window establishes a time range:
   * [auction_time - time_window, auction_time]
   *
   * If the time window is empty, this field is for availability check.
   *
   * In order to construct a time window with its right bound in the past
   * (e.g., "users who have bought this product in the past 90 days, but not in
   * the past 30), create two UPCConditions, with the one containing the
   * shorter time_window inverted.
   */
  timeWindow?: InputMaybe<Scalars['String']>;
  /**
   * At least 1 of the UPCs must be available at the stores
   * in which the user has shopped (or is shopping).
   */
  upcs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Ads_Targeting_V1_UserOrdersCountCondition = {
  __typename?: 'instacart_ads_targeting_v1_UserOrdersCountCondition';
  /**
   * If set, the condition considers all completed orders.
   *
   * Valid only if order_source == "marketplace"
   */
  includeAllOrders?: Maybe<Scalars['Boolean']>;
  operator?: Maybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  orderSource?: Maybe<Scalars['String']>;
  orderThreshold?: Maybe<Scalars['BigInt']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context.
   */
  retailerFromContext?: Maybe<Scalars['google_protobuf_Empty']>;
  /** If set, the condition applies to only the orders from the given retailer. */
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Ads_Targeting_V1_UserOrdersCountCondition_Input = {
  /**
   * If set, the condition considers all completed orders.
   *
   * Valid only if order_source == "marketplace"
   */
  includeAllOrders?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<Instacart_Ads_Targeting_V1_ComparisonOperator>;
  orderSource?: InputMaybe<Scalars['String']>;
  orderThreshold?: InputMaybe<Scalars['BigInt']>;
  /**
   * If set, the condition considers orders from the retailer set in the
   * request context.
   */
  retailerFromContext?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** If set, the condition applies to only the orders from the given retailer. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_V3_BrandNameMapping = {
  __typename?: 'instacart_ads_v3_BrandNameMapping';
  brandName?: Maybe<Scalars['String']>;
  brandProfileId?: Maybe<Scalars['String']>;
};

export type Instacart_Ads_V3_DisplayPreviewData = {
  __typename?: 'instacart_ads_v3_DisplayPreviewData';
  accountName?: Maybe<Scalars['String']>;
  adGroupUuid?: Maybe<Scalars['String']>;
  assetType?: Maybe<Scalars['String']>;
  bannerPreview?: Maybe<Scalars['String']>;
  blocked?: Maybe<Scalars['Boolean']>;
  brandPageSlug?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creativeId?: Maybe<Scalars['String']>;
  creativeType?: Maybe<Scalars['String']>;
  demandSource?: Maybe<Scalars['String']>;
  displayAssetId?: Maybe<Scalars['String']>;
  entityNames?: Maybe<Scalars['String']>;
  flaggedByAi?: Maybe<Scalars['Boolean']>;
  modifiedAt?: Maybe<Scalars['String']>;
  productIds?: Maybe<Scalars['JSON']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  reviewed?: Maybe<Scalars['Boolean']>;
  sha256Hash?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  upcMatchPercentage?: Maybe<Scalars['Float']>;
  upcs?: Maybe<Scalars['JSON']>;
};

export type Instacart_Ads_V3_Filter_Input = {
  field?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Request message to get display preview data */
export type Instacart_Ads_V3_GetDisplayPreviewDataRequest_Input = {
  creativeTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  demandSources?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Ads_V3_Filter_Input>>>;
  pageCriteria?: InputMaybe<Instacart_Ads_V3_PageCriteria_Input>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sortCriteria?: InputMaybe<Instacart_Ads_V3_SortCriteria_Input>;
};

/** Response message for display preview data */
export type Instacart_Ads_V3_GetDisplayPreviewDataResponse = {
  __typename?: 'instacart_ads_v3_GetDisplayPreviewDataResponse';
  displayPreviewData?: Maybe<Array<Maybe<Instacart_Ads_V3_DisplayPreviewData>>>;
  pagination?: Maybe<Instacart_Ads_V3_Pagination>;
};

/** Request message to get the ID of Ads blocked by the retailer */
export type Instacart_Ads_V3_GetRetailerBlockedAdIdsRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message to get the ID of Ads blocked by the retailer */
export type Instacart_Ads_V3_GetRetailerBlockedAdIdsResponse = {
  __typename?: 'instacart_ads_v3_GetRetailerBlockedAdIdsResponse';
  ids?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Ads_V3_IndexBrandNamesRequest_Input = {
  isDebug?: InputMaybe<Scalars['Boolean']>;
  superCategories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Ads_V3_IndexBrandNamesResponse = {
  __typename?: 'instacart_ads_v3_IndexBrandNamesResponse';
  brandNameMappings?: Maybe<Array<Maybe<Instacart_Ads_V3_BrandNameMapping>>>;
  /** This message is in path to deprecation, since maps do not support ordering */
  brandProfileIdToName?: Maybe<Scalars['JSON']>;
};

export type Instacart_Ads_V3_PageCriteria_Input = {
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Ads_V3_Pagination = {
  __typename?: 'instacart_ads_v3_Pagination';
  currentPage?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Instacart_Ads_V3_ProductAdditionalInfoRequest_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Ads_V3_ProductAdditionalInfoResponse = {
  __typename?: 'instacart_ads_v3_ProductAdditionalInfoResponse';
  details?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Scalars['String']>;
};

/**
 * Request message to block/unblock an Ad keyed by asset sha256 hash.
 * Produces / updates an Asset-keyed AdBlockingRule in the Nexus store.
 */
export type Instacart_Ads_V3_RetailerBlockAdBySha256Request_Input = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sha256Hash?: InputMaybe<Scalars['String']>;
};

/** Request message to block/unblock an Ad */
export type Instacart_Ads_V3_RetailerBlockAdRequest_Input = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message to block/unblock an Ad */
export type Instacart_Ads_V3_RetailerBlockAdResponse = {
  __typename?: 'instacart_ads_v3_RetailerBlockAdResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Ads_V3_SortCriteria_Input = {
  direction?: InputMaybe<Scalars['String']>;
  field?: InputMaybe<Scalars['String']>;
};

/** A matched product category from the taxonomy. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CategoryRule = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_CategoryRule';
  /** The taxonomy node ID. */
  product_category_id?: Maybe<Scalars['String']>;
  /**
   * The full category path.
   * e.g. "Snacks > Chocolate > Dark Chocolate"
   */
  product_category_path?: Maybe<Scalars['String']>;
};

/** Request message for creating a carousel. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselRequest_Input = {
  /** Optional parameters that control how content is generated */
  generation_params?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationParams_Input>;
  /**
   * The user's natural language prompt for the carousel.
   * e.g. "I want a carousel featuring budget-friendly, healthy weeknight dinners"
   */
  user_prompt?: InputMaybe<Scalars['String']>;
};

/** Response message containing the generated carousel configuration. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselResponse = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_CreateCarouselResponse';
  /**
   * Attribute filters for refining item selection.
   * e.g. ["organic", "low sugar", "low sodium", "low fat", "high protein", "nut-free"]
   */
  attribute_filters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Description of the target audience for the carousel.
   * e.g. "users who have toddlers"
   */
  carousel_targeting?: Maybe<Scalars['String']>;
  /**
   * The generated title for the carousel (<=45 characters).
   * e.g. "Healthy lunchbox heroes"
   */
  carousel_title?: Maybe<Scalars['String']>;
  /**
   * Flag indicating if the carousel is similar to an existing one
   * (based on keyword overlap).
   */
  duplication_flag?: Maybe<Scalars['Boolean']>;
  /**
   * Optional end date for the carousel's validity.
   * Only applies to holiday related carousels (e.g. Valentine's day).
   */
  end_date?: Maybe<Scalars['DateTime']>;
  /**
   * The method used for ranking items within the carousel.
   * Defaults to "best match" (unified item ranker).
   */
  item_ranking?: Maybe<Scalars['String']>;
  /**
   * Filters to apply for item retrieval.
   * e.g. ["price < $10"]
   */
  item_retrieval_filters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * The logic used to retrieve items for the carousel.
   * Currently supports "keywords"
   */
  item_retrieval_logic?: Maybe<Scalars['String']>;
  /**
   * Keywords used for item retrieval.
   * e.g. ["whole-grain bread", "baby carrots", "hummus cups", "string cheese",
   * "apple slices", "low-sugar yogurt", "turkey slices", "whole-grain crackers",
   * "mini cucumbers", "almond butter packets"]
   */
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Raw attribute filters before processing or filtering.
   * Used to store immediate media output for attribute filters.
   */
  raw_attribute_filters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Raw keywords before processing or filtering.
   * Used to store immediate media output for keywords.
   */
  raw_keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * List of existing carousels that are similar to the generated one.
   * Empty if no duplicates found.
   */
  similar_carousels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional start date for the carousel's validity.
   * Only applies to holiday related carousels (e.g. Valentine's day).
   */
  start_date?: Maybe<Scalars['DateTime']>;
};

/** Request message for creating a carousel with structured collection rules. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselV2Request_Input = {
  /** Optional parameters that control how content is generated */
  generation_params?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationParams_Input>;
  /**
   * Identifier of a previously submitted async job whose status or result is requested.
   * When set, user_prompt and generation_params are ignored.
   */
  job_id?: InputMaybe<Scalars['String']>;
  /**
   * Enables asynchronous execution. When true, the response contains only
   * job_id and job_status; result fields are not populated until the job completes.
   */
  run_async?: InputMaybe<Scalars['Boolean']>;
  /**
   * The user's natural language prompt for the carousel.
   * e.g. "chocolates under $20"
   */
  user_prompt?: InputMaybe<Scalars['String']>;
};

/** Response message containing structured collection rules. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_CreateCarouselV2Response = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_CreateCarouselV2Response';
  /** The generated title for the carousel. */
  carousel_title?: Maybe<Scalars['String']>;
  /** Matched product categories from the taxonomy. */
  categories?: Maybe<Array<Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_CategoryRule>>>;
  /** Human-readable error description, populated when job_status is JOB_STATUS_FAILED. */
  job_error?: Maybe<Scalars['String']>;
  /** Opaque identifier for this job, populated for async requests. */
  job_id?: Maybe<Scalars['String']>;
  /** Execution status of this job. Unspecified for synchronous requests. */
  job_status?: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_JobStatus>;
  /**
   * Generated search keywords for the collection.
   * e.g. ["dark chocolate", "chocolate bars", "cocoa"]
   */
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether all rules must match ("ALL") or any rule can match ("ANY"). */
  match_criteria?: Maybe<Scalars['String']>;
  /**
   * Nutrition/dietary attributes.
   * e.g. ["organic", "gluten_free", "vegan"]
   */
  nutrition?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Structured price range output. Unset if not applicable. */
  price_range?: Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_PriceRange>;
  /**
   * Promotion rule type values.
   * e.g. ["BuyMGetNFree", "BuyMForXDollars"]
   */
  promotion_rules?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Savings or promotion filter values.
   * e.g. ["on_sale", "bogo", "discount"]
   */
  savings_or_filters?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Enum describing generation modes used by the creator */
export enum Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode {
  /** Select from an existing pool/catalog only */
  ExistingPool = 'EXISTING_POOL',
  /** Accept user-provided values without mapping to existing pools */
  FreeForm = 'FREE_FORM',
  /** Generate candidate values and map them to an existing pool */
  GenerateAndMap = 'GENERATE_AND_MAP',
  GenerationModeUnspecified = 'GENERATION_MODE_UNSPECIFIED'
}

/** Parameters controlling how different assets are generated */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationParams_Input = {
  /** Mode for generating attribute filters */
  attribute_filters_mode?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode>;
  /** Mode for generating brand terms */
  brand_mode?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode>;
  /** Mode for generating keywords */
  keywords_mode?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_GenerationMode>;
  /** Parameters for the underlying model */
  model_params?: InputMaybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_ModelParams_Input>;
};

/** Request message for finding similar carousels. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsRequest_Input = {
  /**
   * Optional attribute filters to include in similarity comparison.
   * e.g. ["organic", "low sugar", "low sodium", "low fat", "high protein", "nut-free"]
   */
  attribute_filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The carousel title to compare against existing carousels.
   * e.g. "Healthy lunchbox heroes"
   */
  carousel_title?: InputMaybe<Scalars['String']>;
  /**
   * Optional item retrieval filters to include in similarity comparison.
   * e.g. ["price < $10"]
   */
  item_retrieval_filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Keywords used for similarity comparison.
   * This is the primary field used for similarity matching via vector embeddings.
   * e.g. ["whole-grain bread", "baby carrots", "hummus cups", "string cheese"]
   */
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Maximum number of similar carousels to return.
   * Defaults to 5 if not specified or 0.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /**
   * Minimum similarity threshold (0.0 to 1.0).
   * Only carousels with similarity scores above this threshold will be returned.
   */
  similarity_threshold?: InputMaybe<Scalars['Float']>;
};

/** Response message containing similar carousels. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_GetSimilarCarouselsResponse = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_GetSimilarCarouselsResponse';
  /** List of similar carousels found, ordered by similarity score (highest first). */
  similar_carousels?: Maybe<Array<Maybe<Instacart_Algorithms_Ai_Carousel_Creator_V1_SimilarCarousel>>>;
  /** Total number of similar carousels found (may be higher than returned if limit was applied). */
  total_count?: Maybe<Scalars['Int']>;
};

/** Status of an async carousel creation job. */
export enum Instacart_Algorithms_Ai_Carousel_Creator_V1_JobStatus {
  JobStatusCompleted = 'JOB_STATUS_COMPLETED',
  JobStatusFailed = 'JOB_STATUS_FAILED',
  JobStatusQueued = 'JOB_STATUS_QUEUED',
  JobStatusRunning = 'JOB_STATUS_RUNNING',
  JobStatusUnspecified = 'JOB_STATUS_UNSPECIFIED'
}

/** Parameters for the LLM/model used during generation */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_ModelParams_Input = {
  /** Identifier of the LLM/model to use (e.g., "gpt-4o", "claude-3-sonnet") */
  llm_model?: InputMaybe<Scalars['String']>;
  /** Temperature for sampling; typical range [0.0, 1.0] */
  llm_temperature?: InputMaybe<Scalars['Float']>;
};

/** Price range filter with min and/or max bounds. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_PriceRange = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_PriceRange';
  /** Maximum price in dollars. */
  max?: Maybe<Scalars['Float']>;
  /** Minimum price in dollars. */
  min?: Maybe<Scalars['Float']>;
};

/** Information about a similar carousel. */
export type Instacart_Algorithms_Ai_Carousel_Creator_V1_SimilarCarousel = {
  __typename?: 'instacart_algorithms_ai_carousel_creator_v1_SimilarCarousel';
  /** Unique identifier of the similar carousel from the content library. */
  content_intent_id?: Maybe<Scalars['String']>;
  /** Keywords from the similar carousel. */
  keywords?: Maybe<Scalars['String']>;
  /** Similarity score (0.0 to 1.0, where 1.0 is identical). */
  similarity_score?: Maybe<Scalars['Float']>;
};

/** For when we have many small requests, we can handle throughput more effectively */
export type Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input = {
  inlineCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCarouselSummaries_Input>;
  inlineCookingSteps?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCookingSteps_Input>;
  inlineFilters?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineFilters_Input>;
  inlineKeywordProductBuckets?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywordProductBuckets_Input>;
  inlineKeywords?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywords_Input>;
  inlinePageCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePageCarousels_Input>;
  inlinePolicy?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePolicy_Input>;
  inlineProducts?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineProducts_Input>;
  inlineRetailerCollection?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineRetailerCollection_Input>;
};

/** Used for large offline batch analysis */
export type Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input = {
  s3Input?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_S3Input_Input>;
  snowflakeInput?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SnowflakeInput_Input>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CarouselGroupQaResult';
  dimensionScores?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult_DimensionScore>>>;
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

/** Detailed assessments across key dimensions */
export type Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult_DimensionScore = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CarouselGroupQaResult_DimensionScore';
  /** e.g., "diversity", "coherence", "complementarity", "balance", "user_experience" */
  dimension?: Maybe<Scalars['String']>;
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  /** Optional numeric score 0-1 (0.0 if not set) */
  score?: Maybe<Scalars['Float']>;
};

/** Lightweight carousel representation for group evaluation */
export type Instacart_Algorithms_Content_Ai_Qa_V1_CarouselSummary_Input = {
  carouselId?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_CategoriesEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CategoriesEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedRemoveCategoryIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * path is the LLM input (human-readable, used for evaluation); id is what
 * suggestions reference so the FE can round-trip back to form state.
 */
export type Instacart_Algorithms_Content_Ai_Qa_V1_Category_Input = {
  id?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ContentDesignQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ContentDesignQaResult';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_CookingStepsQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_CookingStepsQualityQaResult';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

/** Identifies an immutable evaluation definition. */
export type Instacart_Algorithms_Content_Ai_Qa_V1_EvaluationDefinitionRef = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_EvaluationDefinitionRef';
  evaluationId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_FilterQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_FilterQualityQaResult';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

/** Output produced by the resolved evaluation definition. */
export type Instacart_Algorithms_Content_Ai_Qa_V1_GenericEvaluationResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_GenericEvaluationResult';
  definitionRef?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_EvaluationDefinitionRef>;
  output?: Maybe<Scalars['JSON']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultRequest_Input = {
  jobUuid?: InputMaybe<Scalars['String']>;
};

/**
 * A single response message for all result-fetching, using `oneof`
 * to provide the correctly typed result.
 */
export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowResultResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_GetWorkflowResultResponse';
  carouselGroupQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult>;
  contentDesignQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ContentDesignQaResult>;
  cookingStepsQualityQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CookingStepsQualityQaResult>;
  filterQualityQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_FilterQualityQaResult>;
  genericEvaluationResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_GenericEvaluationResult>;
  jobUuid?: Maybe<Scalars['String']>;
  keywordCompletenessQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordCompletenessQaResult>;
  keywordQualityQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordQualityQaResult>;
  pageQualityQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult>;
  policyQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult>;
  productCompletenessQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductCompletenessQaResult>;
  productQualityQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult>;
  retailerCollectionQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RetailerCollectionQaResult>;
  s3Uri?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_WorkflowStatus>;
  topicQualityQaResult?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_TopicQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusRequest_Input = {
  jobUuid?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_GetWorkflowStatusResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_GetWorkflowStatusResponse';
  errorDetails?: Maybe<Scalars['String']>;
  jobUuid?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_WorkflowStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineCarouselSummaries_Input = {
  carousels?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselSummary_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineCookingSteps_Input = {
  cookingSteps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineFilters_Input = {
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Combined keyword + mapped products input for product completeness evaluation. */
export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywordProductBuckets_Input = {
  keywordBuckets?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordProductBucket_Input>>>;
};

/** Inline wrappers for repeated fields */
export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywords_Input = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlinePageCarousels_Input = {
  carousels?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageCarousel_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlinePolicy_Input = {
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineProducts_Input = {
  products?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_Product_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_InlineRetailerCollection_Input = {
  categories?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_Category_Input>>>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  matchCriteria?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_MatchCriteria>;
  nutrition?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  priceRange?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_PriceRange_Input>;
  promotionRules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  savingsOrFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordCompletenessQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordCompletenessQaResult';
  additionalFields?: Maybe<Scalars['JSON']>;
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

/** KeywordProductBucket groups a single keyword with its associated products. */
export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordProductBucket_Input = {
  /** Stable identifier for tracking within a workflow */
  bucketId?: InputMaybe<Scalars['String']>;
  /** The keyword this group represents (e.g., "low sugar") */
  keyword?: InputMaybe<Scalars['String']>;
  /** Candidate products associated with the keyword */
  products?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_Product_Input>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordQualityQaResult';
  keywordResults?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordResult>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordResult';
  /**
   * Flexible additional fields that can vary per request
   * e.g., {"confidence": 0.92, "quality_score": 8.5}
   */
  additionalFields?: Maybe<Scalars['JSON']>;
  explanation?: Maybe<Scalars['String']>;
  /** the individual keyword */
  keyword?: Maybe<Scalars['String']>;
  /** whether this keyword satisfies requirement */
  passed?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_KeywordsEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_KeywordsEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedRemove?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Algorithms_Content_Ai_Qa_V1_MatchCriteria {
  MatchCriteriaAll = 'MATCH_CRITERIA_ALL',
  MatchCriteriaAny = 'MATCH_CRITERIA_ANY',
  MatchCriteriaUnspecified = 'MATCH_CRITERIA_UNSPECIFIED'
}

export type Instacart_Algorithms_Content_Ai_Qa_V1_MatchCriteriaEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_MatchCriteriaEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedMatchCriteria?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_MatchCriteria>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_NutritionEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_NutritionEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedRemove?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageCarousel_Input = {
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title?: InputMaybe<Scalars['String']>;
};

/** Result for page quality evaluation with multiple carousels */
export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult';
  carouselEvaluations?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation>>>;
  pageEvaluation?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_PageEvaluation>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_CarouselEvaluation';
  filtersQuality?: Maybe<Scalars['Boolean']>;
  filtersQualityReasoning?: Maybe<Scalars['String']>;
  filtersUserAlignment?: Maybe<Scalars['Boolean']>;
  filtersUserAlignmentReasoning?: Maybe<Scalars['String']>;
  keywords?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_KeywordEvaluation>>>;
  products?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_ProductEvaluation>>>;
  titleClarity?: Maybe<Scalars['Boolean']>;
  titleClarityReasoning?: Maybe<Scalars['String']>;
  titleQuality?: Maybe<Scalars['Boolean']>;
  titleQualityReasoning?: Maybe<Scalars['String']>;
  titleSafety?: Maybe<Scalars['Boolean']>;
  titleSafetyReasoning?: Maybe<Scalars['String']>;
  titleUserAlignment?: Maybe<Scalars['Boolean']>;
  titleUserAlignmentReasoning?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_KeywordEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_CarouselEvaluation_KeywordEvaluation';
  keywordTitleAlignment?: Maybe<Scalars['Boolean']>;
  keywordTitleAlignmentReasoning?: Maybe<Scalars['String']>;
  keywordUserAlignment?: Maybe<Scalars['Boolean']>;
  keywordUserAlignmentReasoning?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_CarouselEvaluation_ProductEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_CarouselEvaluation_ProductEvaluation';
  productTitleAlignment?: Maybe<Scalars['Boolean']>;
  productTitleAlignmentReasoning?: Maybe<Scalars['String']>;
  productUserAlignment?: Maybe<Scalars['Boolean']>;
  productUserAlignmentReasoning?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult_PageEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PageQualityQaResult_PageEvaluation';
  consistency?: Maybe<Scalars['Boolean']>;
  consistencyReasoning?: Maybe<Scalars['String']>;
  familyCoverage?: Maybe<Scalars['Boolean']>;
  familyCoverageReasoning?: Maybe<Scalars['String']>;
  householdCoverage?: Maybe<Scalars['Boolean']>;
  householdCoverageReasoning?: Maybe<Scalars['String']>;
  noRedundancy?: Maybe<Scalars['Boolean']>;
  noRedundancyReasoning?: Maybe<Scalars['String']>;
  restockingBreadth?: Maybe<Scalars['Boolean']>;
  restockingBreadthReasoning?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PolicyQaResult';
  passed?: Maybe<Scalars['Boolean']>;
  violations?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult_Violation>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult_Violation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PolicyQaResult_Violation';
  explanation?: Maybe<Scalars['String']>;
  /** e.g., "Health Inference", "Cultural Insensitivity" */
  violationType?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PriceRange = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PriceRange';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PriceRangeEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PriceRangeEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedPriceRange?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PriceRange>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PriceRange_Input = {
  max?: InputMaybe<Scalars['Float']>;
  min?: InputMaybe<Scalars['Float']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ProductCompletenessQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ProductCompletenessQaResult';
  additionalFields?: Maybe<Scalars['JSON']>;
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ProductQualityQaResult';
  conclusions?: Maybe<Array<Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult_Conclusion>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult_Conclusion = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_ProductQualityQaResult_Conclusion';
  additionalFields?: Maybe<Scalars['JSON']>;
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  productId?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_Product_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  /** From the file proto's `ProductRef` */
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_PromotionRulesEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_PromotionRulesEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedRemove?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RetailerCollectionQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RetailerCollectionQaResult';
  categories?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CategoriesEvaluation>;
  keywords?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordsEvaluation>;
  matchCriteria?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_MatchCriteriaEvaluation>;
  nutrition?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_NutritionEvaluation>;
  passed?: Maybe<Scalars['Boolean']>;
  priceRange?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PriceRangeEvaluation>;
  promotionRules?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PromotionRulesEvaluation>;
  savingsOrFilters?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_SavingsOrFiltersEvaluation>;
  score?: Maybe<Scalars['Float']>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_TitleEvaluation>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunCarouselGroupQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunCarouselGroupQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_CarouselGroupQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunContentDesignQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunContentDesignQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ContentDesignQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunFilterQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunFilterQualityQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_FilterQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordCompletenessQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunKeywordCompletenessQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordCompletenessQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunKeywordQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunKeywordQualityQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_KeywordQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  purchaseHistory?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userPersona?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPageQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunPageQualityQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PageQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunPolicyQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunPolicyQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_PolicyQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  cookingSteps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Optional recipe-level context for downstream prompt construction. */
  ingredients?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keyword?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunProductQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunProductQualityQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_ProductQualityQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunRetailerCollectionQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userPrompt?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunRetailerCollectionQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunRetailerCollectionQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_RetailerCollectionQaResult>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaRequest_Input = {
  async?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_AsyncExecution_Input>;
  batch?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_BatchExecution_Input>;
  carouselTitle?: InputMaybe<Scalars['String']>;
  evalVersionId?: InputMaybe<Scalars['String']>;
  idempotencyKey?: InputMaybe<Scalars['String']>;
  sourceId?: InputMaybe<Scalars['String']>;
  sync?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input>;
  userIntent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_RunTopicQualityQaResponse = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_RunTopicQualityQaResponse';
  jobUuid?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Algorithms_Content_Ai_Qa_V1_TopicQualityQaResult>;
};

export enum Instacart_Algorithms_Content_Ai_Qa_V1_S3FileFormat {
  S3FileFormatCsv = 'S3_FILE_FORMAT_CSV',
  S3FileFormatNdjson = 'S3_FILE_FORMAT_NDJSON',
  S3FileFormatParquet = 'S3_FILE_FORMAT_PARQUET',
  S3FileFormatUnspecified = 'S3_FILE_FORMAT_UNSPECIFIED'
}

/** Input source configurations */
export type Instacart_Algorithms_Content_Ai_Qa_V1_S3Input_Input = {
  bucket?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_S3FileFormat>;
  /** optional file listing keys; if omitted, service lists by prefix */
  manifestKey?: InputMaybe<Scalars['String']>;
  /** optional subset for pilots */
  maxRecords?: InputMaybe<Scalars['Int']>;
  /** e.g., s3://bucket/prefix/... */
  prefix?: InputMaybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_SavingsOrFiltersEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_SavingsOrFiltersEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedRemove?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_SnowflakeInput_Input = {
  database?: InputMaybe<Scalars['String']>;
  /** optional WHERE clause (safe-listed) */
  filterSql?: InputMaybe<Scalars['String']>;
  /** optional subset for pilots */
  maxRecords?: InputMaybe<Scalars['Int']>;
  schema?: InputMaybe<Scalars['String']>;
  tableOrView?: InputMaybe<Scalars['String']>;
  warehouse?: InputMaybe<Scalars['String']>;
};

/** Execution mode messages - enforces input constraints at schema level */
export type Instacart_Algorithms_Content_Ai_Qa_V1_SyncExecution_Input = {
  inlineCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCarouselSummaries_Input>;
  inlineCookingSteps?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineCookingSteps_Input>;
  inlineFilters?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineFilters_Input>;
  inlineKeywordProductBuckets?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywordProductBuckets_Input>;
  inlineKeywords?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineKeywords_Input>;
  inlinePageCarousels?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePageCarousels_Input>;
  inlinePolicy?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlinePolicy_Input>;
  inlineProducts?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineProducts_Input>;
  inlineRetailerCollection?: InputMaybe<Instacart_Algorithms_Content_Ai_Qa_V1_InlineRetailerCollection_Input>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_TitleEvaluation = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_TitleEvaluation';
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
  score?: Maybe<Scalars['Float']>;
  suggestedTitle?: Maybe<Scalars['String']>;
};

export type Instacart_Algorithms_Content_Ai_Qa_V1_TopicQualityQaResult = {
  __typename?: 'instacart_algorithms_content_ai_qa_v1_TopicQualityQaResult';
  /**
   * Flexible additional fields for hard failure rule checks
   * Stored as nested pass/explanation pairs (length_check, grammar_spelling_check)
   */
  additionalFields?: Maybe<Scalars['JSON']>;
  explanation?: Maybe<Scalars['String']>;
  passed?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Algorithms_Content_Ai_Qa_V1_WorkflowStatus {
  WorkflowStatusCompleted = 'WORKFLOW_STATUS_COMPLETED',
  WorkflowStatusFailed = 'WORKFLOW_STATUS_FAILED',
  WorkflowStatusQueued = 'WORKFLOW_STATUS_QUEUED',
  WorkflowStatusRunning = 'WORKFLOW_STATUS_RUNNING',
  WorkflowStatusUnspecified = 'WORKFLOW_STATUS_UNSPECIFIED'
}

/** Cooking method. Multi-select, max 4 values. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_CookingMethod {
  CookingMethodAirFryer = 'COOKING_METHOD_AIR_FRYER',
  CookingMethodBaked = 'COOKING_METHOD_BAKED',
  CookingMethodBlender = 'COOKING_METHOD_BLENDER',
  CookingMethodChilled = 'COOKING_METHOD_CHILLED',
  CookingMethodFried = 'COOKING_METHOD_FRIED',
  CookingMethodGrilled = 'COOKING_METHOD_GRILLED',
  CookingMethodInstantPot = 'COOKING_METHOD_INSTANT_POT',
  CookingMethodMicrowave = 'COOKING_METHOD_MICROWAVE',
  CookingMethodNoCook = 'COOKING_METHOD_NO_COOK',
  CookingMethodOnePot = 'COOKING_METHOD_ONE_POT',
  CookingMethodPoaching = 'COOKING_METHOD_POACHING',
  CookingMethodSlowCooker = 'COOKING_METHOD_SLOW_COOKER',
  CookingMethodStovetop = 'COOKING_METHOD_STOVETOP',
  CookingMethodUnspecified = 'COOKING_METHOD_UNSPECIFIED'
}

/** Cuisine. Single-select. 64-value set aligned to catalog taxonomy. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_Cuisine {
  CuisineAfghan = 'CUISINE_AFGHAN',
  CuisineAfrican = 'CUISINE_AFRICAN',
  CuisineAmerican = 'CUISINE_AMERICAN',
  CuisineArgentinian = 'CUISINE_ARGENTINIAN',
  CuisineAsian = 'CUISINE_ASIAN',
  CuisineAustralian = 'CUISINE_AUSTRALIAN',
  CuisineBrazilian = 'CUISINE_BRAZILIAN',
  CuisineBritish = 'CUISINE_BRITISH',
  CuisineBurmese = 'CUISINE_BURMESE',
  CuisineCajun = 'CUISINE_CAJUN',
  CuisineCanadian = 'CUISINE_CANADIAN',
  CuisineCaribbean = 'CUISINE_CARIBBEAN',
  CuisineChinese = 'CUISINE_CHINESE',
  CuisineColombian = 'CUISINE_COLOMBIAN',
  CuisineCuban = 'CUISINE_CUBAN',
  CuisineCzech = 'CUISINE_CZECH',
  CuisineDominican = 'CUISINE_DOMINICAN',
  CuisineEgyptian = 'CUISINE_EGYPTIAN',
  CuisineEthiopian = 'CUISINE_ETHIOPIAN',
  CuisineFilipino = 'CUISINE_FILIPINO',
  CuisineFrench = 'CUISINE_FRENCH',
  CuisineGerman = 'CUISINE_GERMAN',
  CuisineGreek = 'CUISINE_GREEK',
  CuisineGuatemalan = 'CUISINE_GUATEMALAN',
  CuisineHawaiian = 'CUISINE_HAWAIIAN',
  CuisineHungarian = 'CUISINE_HUNGARIAN',
  CuisineIndian = 'CUISINE_INDIAN',
  CuisineIndonesian = 'CUISINE_INDONESIAN',
  CuisineIrish = 'CUISINE_IRISH',
  CuisineItalian = 'CUISINE_ITALIAN',
  CuisineJamaican = 'CUISINE_JAMAICAN',
  CuisineJapanese = 'CUISINE_JAPANESE',
  CuisineKorean = 'CUISINE_KOREAN',
  CuisineLatinAmerican = 'CUISINE_LATIN_AMERICAN',
  CuisineLebanese = 'CUISINE_LEBANESE',
  CuisineMalaysian = 'CUISINE_MALAYSIAN',
  CuisineMediterranean = 'CUISINE_MEDITERRANEAN',
  CuisineMexican = 'CUISINE_MEXICAN',
  CuisineMiddleEastern = 'CUISINE_MIDDLE_EASTERN',
  CuisineMoroccan = 'CUISINE_MOROCCAN',
  CuisineNepalese = 'CUISINE_NEPALESE',
  CuisineOthers = 'CUISINE_OTHERS',
  CuisinePersian = 'CUISINE_PERSIAN',
  CuisinePeruvian = 'CUISINE_PERUVIAN',
  CuisinePolish = 'CUISINE_POLISH',
  CuisinePortuguese = 'CUISINE_PORTUGUESE',
  CuisinePuertoRican = 'CUISINE_PUERTO_RICAN',
  CuisineRussian = 'CUISINE_RUSSIAN',
  CuisineSalvadoran = 'CUISINE_SALVADORAN',
  CuisineScandinavian = 'CUISINE_SCANDINAVIAN',
  CuisineSingaporean = 'CUISINE_SINGAPOREAN',
  CuisineSouthern = 'CUISINE_SOUTHERN',
  CuisineSouthwest = 'CUISINE_SOUTHWEST',
  CuisineSouthAfrican = 'CUISINE_SOUTH_AFRICAN',
  CuisineSouthAsian = 'CUISINE_SOUTH_ASIAN',
  CuisineSpanish = 'CUISINE_SPANISH',
  CuisineSwedish = 'CUISINE_SWEDISH',
  CuisineSwiss = 'CUISINE_SWISS',
  CuisineTaiwanese = 'CUISINE_TAIWANESE',
  CuisineThai = 'CUISINE_THAI',
  CuisineTurkish = 'CUISINE_TURKISH',
  CuisineUkrainian = 'CUISINE_UKRAINIAN',
  CuisineUnspecified = 'CUISINE_UNSPECIFIED',
  CuisineVenezuelan = 'CUISINE_VENEZUELAN',
  CuisineVietnamese = 'CUISINE_VIETNAMESE'
}

/** Dietary label. Multi-select, no max limit. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_DietaryLabel {
  DietaryLabelDairyFree = 'DIETARY_LABEL_DAIRY_FREE',
  DietaryLabelGlutenFree = 'DIETARY_LABEL_GLUTEN_FREE',
  DietaryLabelPescatarian = 'DIETARY_LABEL_PESCATARIAN',
  DietaryLabelUnspecified = 'DIETARY_LABEL_UNSPECIFIED',
  DietaryLabelVegan = 'DIETARY_LABEL_VEGAN',
  DietaryLabelVegetarian = 'DIETARY_LABEL_VEGETARIAN'
}

/** Flavor profile. Multi-select, max 3 values. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_FlavorProfile {
  FlavorProfileCreamy = 'FLAVOR_PROFILE_CREAMY',
  FlavorProfileFresh = 'FLAVOR_PROFILE_FRESH',
  FlavorProfileHerbal = 'FLAVOR_PROFILE_HERBAL',
  FlavorProfileRich = 'FLAVOR_PROFILE_RICH',
  FlavorProfileSavory = 'FLAVOR_PROFILE_SAVORY',
  FlavorProfileSmoky = 'FLAVOR_PROFILE_SMOKY',
  FlavorProfileSpicy = 'FLAVOR_PROFILE_SPICY',
  FlavorProfileSweet = 'FLAVOR_PROFILE_SWEET',
  FlavorProfileTangy = 'FLAVOR_PROFILE_TANGY',
  FlavorProfileUmami = 'FLAVOR_PROFILE_UMAMI',
  FlavorProfileUnspecified = 'FLAVOR_PROFILE_UNSPECIFIED'
}

/** Meal type. Multi-select, max 2 values. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_MealType {
  MealTypeBreakfast = 'MEAL_TYPE_BREAKFAST',
  MealTypeDessert = 'MEAL_TYPE_DESSERT',
  MealTypeDinner = 'MEAL_TYPE_DINNER',
  MealTypeDrink = 'MEAL_TYPE_DRINK',
  MealTypeLunch = 'MEAL_TYPE_LUNCH',
  MealTypeSideDish = 'MEAL_TYPE_SIDE_DISH',
  MealTypeSnack = 'MEAL_TYPE_SNACK',
  MealTypeUnspecified = 'MEAL_TYPE_UNSPECIFIED'
}

/**
 * Occasion. Multi-select, max 3 values. Base set (1-8) plus 46 holidays/life
 * events (9-54).
 */
export enum Instacart_Algorithms_Meals_Enrichment_V1_Occasion {
  OccasionAnniversary = 'OCCASION_ANNIVERSARY',
  OccasionBabyShower = 'OCCASION_BABY_SHOWER',
  OccasionBarBatMitzvah = 'OCCASION_BAR_BAT_MITZVAH',
  OccasionBirthday = 'OCCASION_BIRTHDAY',
  OccasionBridalShower = 'OCCASION_BRIDAL_SHOWER',
  OccasionChristmas = 'OCCASION_CHRISTMAS',
  OccasionCincoDeMayo = 'OCCASION_CINCO_DE_MAYO',
  OccasionDateNight = 'OCCASION_DATE_NIGHT',
  OccasionDiaDeLosMuertos = 'OCCASION_DIA_DE_LOS_MUERTOS',
  OccasionDiwali = 'OCCASION_DIWALI',
  OccasionEaster = 'OCCASION_EASTER',
  OccasionEid = 'OCCASION_EID',
  OccasionFathersDay = 'OCCASION_FATHERS_DAY',
  OccasionFriendsgiving = 'OCCASION_FRIENDSGIVING',
  OccasionGameDay = 'OCCASION_GAME_DAY',
  OccasionGetWell = 'OCCASION_GET_WELL',
  OccasionGraduation = 'OCCASION_GRADUATION',
  OccasionGrillingBbq = 'OCCASION_GRILLING_BBQ',
  OccasionHalloween = 'OCCASION_HALLOWEEN',
  OccasionHanukkah = 'OCCASION_HANUKKAH',
  OccasionHolidayParty = 'OCCASION_HOLIDAY_PARTY',
  OccasionHousewarming = 'OCCASION_HOUSEWARMING',
  OccasionIndependenceDay = 'OCCASION_INDEPENDENCE_DAY',
  OccasionJuneteenth = 'OCCASION_JUNETEENTH',
  OccasionKidFriendly = 'OCCASION_KID_FRIENDLY',
  OccasionKwanzaa = 'OCCASION_KWANZAA',
  OccasionLaborDay = 'OCCASION_LABOR_DAY',
  OccasionLunarNewYear = 'OCCASION_LUNAR_NEW_YEAR',
  OccasionMardiGras = 'OCCASION_MARDI_GRAS',
  OccasionMealPrep = 'OCCASION_MEAL_PREP',
  OccasionMemorialDay = 'OCCASION_MEMORIAL_DAY',
  OccasionMothersDay = 'OCCASION_MOTHERS_DAY',
  OccasionMovieNight = 'OCCASION_MOVIE_NIGHT',
  OccasionNewYearsEve = 'OCCASION_NEW_YEARS_EVE',
  OccasionPartyEntertaining = 'OCCASION_PARTY_ENTERTAINING',
  OccasionPassover = 'OCCASION_PASSOVER',
  OccasionPicnic = 'OCCASION_PICNIC',
  OccasionPotluck = 'OCCASION_POTLUCK',
  OccasionPride = 'OCCASION_PRIDE',
  OccasionRamadan = 'OCCASION_RAMADAN',
  OccasionRetirementParty = 'OCCASION_RETIREMENT_PARTY',
  OccasionRoshHashanah = 'OCCASION_ROSH_HASHANAH',
  OccasionStJosephsDay = 'OCCASION_ST_JOSEPHS_DAY',
  OccasionStPatricksDay = 'OCCASION_ST_PATRICKS_DAY',
  OccasionSuperbowl = 'OCCASION_SUPERBOWL',
  OccasionSympathy = 'OCCASION_SYMPATHY',
  OccasionThanksgiving = 'OCCASION_THANKSGIVING',
  OccasionUnspecified = 'OCCASION_UNSPECIFIED',
  OccasionValentinesDay = 'OCCASION_VALENTINES_DAY',
  OccasionVeteransDay = 'OCCASION_VETERANS_DAY',
  OccasionWedding = 'OCCASION_WEDDING',
  OccasionWeekendBrunch = 'OCCASION_WEEKEND_BRUNCH',
  OccasionWeeknightDinner = 'OCCASION_WEEKNIGHT_DINNER',
  OccasionWorldCup = 'OCCASION_WORLD_CUP',
  OccasionYomKippur = 'OCCASION_YOM_KIPPUR'
}

/** Protein. Multi-select, max 2 values. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_Protein {
  ProteinBeansLegumes = 'PROTEIN_BEANS_LEGUMES',
  ProteinBeef = 'PROTEIN_BEEF',
  ProteinChicken = 'PROTEIN_CHICKEN',
  ProteinLamb = 'PROTEIN_LAMB',
  ProteinNoProtein = 'PROTEIN_NO_PROTEIN',
  ProteinPork = 'PROTEIN_PORK',
  ProteinSeafood = 'PROTEIN_SEAFOOD',
  ProteinSeitan = 'PROTEIN_SEITAN',
  ProteinTempeh = 'PROTEIN_TEMPEH',
  ProteinTofu = 'PROTEIN_TOFU',
  ProteinTurkey = 'PROTEIN_TURKEY',
  ProteinUnspecified = 'PROTEIN_UNSPECIFIED'
}

/** Skill level. Single-select. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_SkillLevel {
  SkillLevelAdvanced = 'SKILL_LEVEL_ADVANCED',
  SkillLevelBeginner = 'SKILL_LEVEL_BEGINNER',
  SkillLevelIntermediate = 'SKILL_LEVEL_INTERMEDIATE',
  SkillLevelUnspecified = 'SKILL_LEVEL_UNSPECIFIED'
}

/** Speed. Single-select. Derived from active time only. */
export enum Instacart_Algorithms_Meals_Enrichment_V1_Speed {
  Speed_15_30Min = 'SPEED_15_30_MIN',
  Speed_30_60Min = 'SPEED_30_60_MIN',
  Speed_60PlusMin = 'SPEED_60_PLUS_MIN',
  SpeedUnder_15Min = 'SPEED_UNDER_15_MIN',
  SpeedUnspecified = 'SPEED_UNSPECIFIED'
}

/**
 * AccountListSortDirection identifies the requested account-status order.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_AccountListSortDirection {
  AccountListSortDirectionAscending = 'ACCOUNT_LIST_SORT_DIRECTION_ASCENDING',
  AccountListSortDirectionDescending = 'ACCOUNT_LIST_SORT_DIRECTION_DESCENDING',
  AccountListSortDirectionUnspecified = 'ACCOUNT_LIST_SORT_DIRECTION_UNSPECIFIED'
}

/**
 * AccountListSort orders accounts by effective Auth0 blocked status. ASCENDING
 * returns active accounts first and DESCENDING returns blocked accounts first.
 * Relative order within the same status group preserves Auth0 result order.
 */
export type Instacart_Caper_Admin_V1_AccountListSort_Input = {
  direction?: InputMaybe<Instacart_Caper_Admin_V1_AccountListSortDirection>;
};

/**
 * AccountPartnerAccess represents either access across all partners or access
 * beneath exactly one partner.
 */
export type Instacart_Caper_Admin_V1_AccountPartnerAccess = {
  __typename?: 'instacart_caper_admin_v1_AccountPartnerAccess';
  /**
   * Access spans every partner. This is used for Video Inspector accounts and
   * Cart Manager accounts with literal global Auth0 store access.
   */
  globalAccess?: Maybe<Scalars['instacart_caper_admin_v1_GlobalPartnerAccess']>;
  /** Access is limited to one partner. */
  partner?: Maybe<Instacart_Caper_Admin_V1_AccountPartnerSummary>;
};

/**
 * AccountPartnerSummary carries identifiers and display data for one
 * accessible partner.
 */
export type Instacart_Caper_Admin_V1_AccountPartnerSummary = {
  __typename?: 'instacart_caper_admin_v1_AccountPartnerSummary';
  /** Partner name used by Caper. */
  caperPartnerName?: Maybe<Scalars['String']>;
  /** Stable Instacart partner identifier. */
  instacartPartnerId?: Maybe<Scalars['String']>;
  /** Human-readable partner name. */
  partnerName?: Maybe<Scalars['String']>;
};

/**
 * AccountRetailerAccess represents either access across all retailers in the
 * partner scope or access to multiple selected retailers.
 */
export type Instacart_Caper_Admin_V1_AccountRetailerAccess = {
  __typename?: 'instacart_caper_admin_v1_AccountRetailerAccess';
  /**
   * Access spans every retailer. This is used for Video Inspector accounts
   * and Cart Manager accounts with literal global Auth0 store access.
   */
  globalAccess?: Maybe<Scalars['instacart_caper_admin_v1_GlobalRetailerAccess']>;
  /**
   * Access is limited to retailers owning at least one resolved concrete
   * accessible store.
   */
  selectedRetailers?: Maybe<Instacart_Caper_Admin_V1_SelectedAccountRetailers>;
};

/**
 * AccountRetailerSummary carries identifiers and display data for one
 * accessible retailer.
 */
export type Instacart_Caper_Admin_V1_AccountRetailerSummary = {
  __typename?: 'instacart_caper_admin_v1_AccountRetailerSummary';
  /** Retailer name used by Caper. */
  caperRetailerName?: Maybe<Scalars['String']>;
  /** Instacart warehouse identifier. */
  instacartWarehouseId?: Maybe<Scalars['String']>;
  /** Human-readable retailer name. */
  retailerName?: Maybe<Scalars['String']>;
};

/**
 * AccountStatus describes whether an account may authenticate.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_AccountStatus {
  AccountStatusActive = 'ACCOUNT_STATUS_ACTIVE',
  AccountStatusBlocked = 'ACCOUNT_STATUS_BLOCKED',
  AccountStatusUnspecified = 'ACCOUNT_STATUS_UNSPECIFIED'
}

/**
 * AccountSummary is the account representation returned by create and other
 * account-management RPCs.
 */
export type Instacart_Caper_Admin_V1_AccountSummary = {
  __typename?: 'instacart_caper_admin_v1_AccountSummary';
  /**
   * De-duplicated concrete store IDs available to this account. This field is
   * empty when global_access is set.
   */
  accessibleStoreIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Application the account may access. */
  appType?: Maybe<Instacart_Caper_Admin_V1_AppType>;
  /**
   * Typed role granted within the application. The existing role string is
   * retained for compatibility.
   */
  applicationRole?: Maybe<Instacart_Caper_Admin_V1_ApplicationRole>;
  /** Stable identifier for the account. */
  auth0UserId?: Maybe<Scalars['String']>;
  /** Login email address for the account. */
  email?: Maybe<Scalars['String']>;
  /** Application environments this user may access. */
  environments?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ApplicationEnvironment>>>;
  /**
   * Present when the account has unrestricted access to every current and
   * future store. ListAccounts always sets this for Video Inspector accounts
   * and sets it for Cart Manager accounts with literal Auth0 global access.
   * accessible_store_ids must be empty when this is set.
   */
  globalAccess?: Maybe<Scalars['instacart_caper_admin_v1_GlobalStoreAccess']>;
  /** Display name for the account. */
  name?: Maybe<Scalars['String']>;
  /** Role granted within the application. */
  role?: Maybe<Scalars['String']>;
  /** Current account status. */
  status?: Maybe<Instacart_Caper_Admin_V1_AccountStatus>;
  /** Count of concrete accessible stores. This is zero for global access. */
  storeCount?: Maybe<Scalars['Int']>;
  /** Last access-relevant update time for the account. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** AddAccountRequest contains the identity and permissions for a new account. */
export type Instacart_Caper_Admin_V1_AddAccountRequest_Input = {
  /** Verified email address of the actor creating the account. */
  actorEmail?: InputMaybe<Scalars['String']>;
  /** Application the account may access. */
  appType?: InputMaybe<Instacart_Caper_Admin_V1_AppType>;
  /** Optional application-specific role metadata. */
  applicationRole?: InputMaybe<Instacart_Caper_Admin_V1_ApplicationRole_Input>;
  /** Store permissions for application types that support store-scoped access. */
  cartManagerPermissionScope?: InputMaybe<Instacart_Caper_Admin_V1_CartManagerPermissionScope_Input>;
  /** Email address used as the login identifier. */
  email?: InputMaybe<Scalars['String']>;
  /** Application environments this user may access. */
  environments?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ApplicationEnvironment>>>;
  /** Display name for the account. */
  name?: InputMaybe<Scalars['String']>;
  /** Deprecated: use cart_manager_permission_scope.selected_partner. */
  partnerName?: InputMaybe<Scalars['String']>;
  /** Deprecated: use preferred_language_code. */
  preferredLanguage?: InputMaybe<Scalars['String']>;
  /** Optional preferred language represented as a supported language code. */
  preferredLanguageCode?: InputMaybe<Instacart_Caper_Admin_V1_SupportedLanguageCode>;
  /** Deprecated: use preferred_store_identifier. */
  preferredStoreId?: InputMaybe<Scalars['String']>;
  /** Optional default store context. This does not grant access to the store. */
  preferredStoreIdentifier?: InputMaybe<Instacart_Caper_Admin_V1_PreferredStoreIdentifier_Input>;
  /** Deprecated: use application_role. */
  role?: InputMaybe<Scalars['String']>;
};

/** AddAccountResponse returns the created account and password-setup result. */
export type Instacart_Caper_Admin_V1_AddAccountResponse = {
  __typename?: 'instacart_caper_admin_v1_AddAccountResponse';
  /** Summary of the newly created account. */
  account?: Maybe<Instacart_Caper_Admin_V1_AccountSummary>;
  /** Whether the password-setup notification was accepted for delivery. */
  passwordSetupEmailSent?: Maybe<Scalars['Boolean']>;
};

/** Request message for adding scopes to a ban entry (additive only) */
export type Instacart_Caper_Admin_V1_AddBanEntryScopesRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  /** The ban entry ID to add scopes to */
  banEntryId?: InputMaybe<Scalars['String']>;
  /**
   * Scopes to add to this ban entry
   * Only adds new scopes - never removes existing ones
   */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for adding scopes to a ban entry */
export type Instacart_Caper_Admin_V1_AddBanEntryScopesResponse = {
  __typename?: 'instacart_caper_admin_v1_AddBanEntryScopesResponse';
  /** The updated list of all scopes for this ban entry after addition */
  scopes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/**
 * Application type available to an account.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_AppType {
  AppTypeCartManager = 'APP_TYPE_CART_MANAGER',
  AppTypeUnspecified = 'APP_TYPE_UNSPECIFIED',
  AppTypeVideoInspector = 'APP_TYPE_VIDEO_INSPECTOR'
}

/**
 * ApplicationEnvironment identifies a deployment environment in which an
 * account may use an application.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_ApplicationEnvironment {
  ApplicationEnvironmentBeta = 'APPLICATION_ENVIRONMENT_BETA',
  ApplicationEnvironmentDevelopment = 'APPLICATION_ENVIRONMENT_DEVELOPMENT',
  ApplicationEnvironmentLegacyDev = 'APPLICATION_ENVIRONMENT_LEGACY_DEV',
  ApplicationEnvironmentLegacyQa = 'APPLICATION_ENVIRONMENT_LEGACY_QA',
  /** Compatibility values for legacy environment identifiers. */
  ApplicationEnvironmentLegacyUatUppercase = 'APPLICATION_ENVIRONMENT_LEGACY_UAT_UPPERCASE',
  ApplicationEnvironmentLocal = 'APPLICATION_ENVIRONMENT_LOCAL',
  ApplicationEnvironmentProduction = 'APPLICATION_ENVIRONMENT_PRODUCTION',
  ApplicationEnvironmentProdNa = 'APPLICATION_ENVIRONMENT_PROD_NA',
  ApplicationEnvironmentStaging = 'APPLICATION_ENVIRONMENT_STAGING',
  ApplicationEnvironmentStgNa = 'APPLICATION_ENVIRONMENT_STG_NA',
  ApplicationEnvironmentUat = 'APPLICATION_ENVIRONMENT_UAT',
  ApplicationEnvironmentUnspecified = 'APPLICATION_ENVIRONMENT_UNSPECIFIED'
}

/** ApplicationRole assigns metadata appropriate to one application. */
export type Instacart_Caper_Admin_V1_ApplicationRole = {
  __typename?: 'instacart_caper_admin_v1_ApplicationRole';
  /** Role metadata for a Cart Manager account. */
  cartManagerRole?: Maybe<Instacart_Caper_Admin_V1_CartManagerRole>;
  /** Role metadata for a Video Inspector account. */
  videoInspectorRole?: Maybe<Instacart_Caper_Admin_V1_VideoInspectorRole>;
};

/** ApplicationRole assigns metadata appropriate to one application. */
export type Instacart_Caper_Admin_V1_ApplicationRole_Input = {
  /** Role metadata for a Cart Manager account. */
  cartManagerRole?: InputMaybe<Instacart_Caper_Admin_V1_CartManagerRole>;
  /** Role metadata for a Video Inspector account. */
  videoInspectorRole?: InputMaybe<Instacart_Caper_Admin_V1_VideoInspectorRole>;
};

/** Request for archiving a notification group. */
export type Instacart_Caper_Admin_V1_ArchiveNotificationGroupRequest_Input = {
  /** The email of the person making the change. Must be a valid Instacart company email (format: firstname.lastname@instacart.com). */
  authorEmail?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Video metadata for an audit issue associated with this session */
export type Instacart_Caper_Admin_V1_AuditIssueVideoData = {
  __typename?: 'instacart_caper_admin_v1_AuditIssueVideoData';
  /** Unique identifier for the audit issue */
  auditIssueId?: Maybe<Scalars['String']>;
  /** Sub-category within the audit issue type */
  auditIssueSubCategory?: Maybe<Scalars['String']>;
  /** Top-level audit issue type (e.g., "WEIGHT", "SCAN") */
  auditIssueType?: Maybe<Scalars['String']>;
  /** When the audit issue was created (UTC) */
  issueCreateTimeUtc?: Maybe<Scalars['DateTime']>;
  /** Primary video URL for this audit issue */
  videoUrl?: Maybe<Scalars['String']>;
  /** Additional video URLs when multiple clips exist for the issue */
  videoUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Represents a single ban list entry (barcode or regex pattern) */
export type Instacart_Caper_Admin_V1_BanEntry = {
  __typename?: 'instacart_caper_admin_v1_BanEntry';
  /**
   * Whether this entry is archived (soft-deleted)
   * Archived entries are only returned when include_archived filter is true
   */
  archived?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Caper_Admin_V1_BanEntryType>;
  /**
   * Raw Barcode or regex pattern
   * For type=REGEX, the Cart will:
   * 1. Match using RE2 or equivalent engine
   * 2. Treat all patterns as case-sensitive
   * 3. NOT anchor automatically - pattern author must use ^ and $ if needed
   *
   * Examples:
   * "^18\d{5}$"     - matches exactly 7 digits starting with 18
   * "^40000\d{6}$"  - matches exactly 11 digits starting with 40000
   */
  value?: Maybe<Scalars['String']>;
};

/** Type of audit operation */
export enum Instacart_Caper_Admin_V1_BanEntryAuditOperation {
  BanEntryAuditOperationDelete = 'BAN_ENTRY_AUDIT_OPERATION_DELETE',
  BanEntryAuditOperationInsert = 'BAN_ENTRY_AUDIT_OPERATION_INSERT',
  BanEntryAuditOperationUnknown = 'BAN_ENTRY_AUDIT_OPERATION_UNKNOWN',
  BanEntryAuditOperationUpdate = 'BAN_ENTRY_AUDIT_OPERATION_UPDATE'
}

/** Audit record representing a point in the ban entry's edit history timeline */
export type Instacart_Caper_Admin_V1_BanEntryAuditRecord = {
  __typename?: 'instacart_caper_admin_v1_BanEntryAuditRecord';
  /** Who made the change */
  author?: Maybe<Scalars['String']>;
  /** Type of operation performed */
  operation?: Maybe<Instacart_Caper_Admin_V1_BanEntryAuditOperation>;
  /** The scopes at this point in time (snapshot after this change) */
  scopes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
  /** When the change was made */
  timestamp?: Maybe<Scalars['DateTime']>;
};

/** Filter criteria for listing ban entries */
export type Instacart_Caper_Admin_V1_BanEntryFilter_Input = {
  /** Include archived entries (default: false) */
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  /** Filter by partner IDs (OR within this list; empty means no partner filter) */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by retailer IDs (OR within this list; empty means no retailer filter) */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by store IDs (OR within this list; empty means no store filter) */
  storeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by ban entry type */
  type?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryType>;
  /** Filter by value (partial match) */
  value?: InputMaybe<Scalars['String']>;
};

/** Information about a ban entry's scope */
export type Instacart_Caper_Admin_V1_BanEntryScopeInfo = {
  __typename?: 'instacart_caper_admin_v1_BanEntryScopeInfo';
  /**
   * Category of the ban entry at this scope (e.g., "reusable_bag", "flyer")
   * Same barcode may have different categories for different retailers/stores
   */
  category?: Maybe<Scalars['String']>;
  level?: Maybe<Instacart_Caper_Admin_V1_BanEntryScopeLevel>;
  overrideCatalog?: Maybe<Scalars['Boolean']>;
  /**
   * Entity ID based on level (ignored for GLOBAL):
   * PARTNER -> partner_id
   * RETAILER -> retailer_id
   * STORE -> store_id
   */
  scopeId?: Maybe<Scalars['BigInt']>;
};

/** Information about a ban entry's scope */
export type Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input = {
  /**
   * Category of the ban entry at this scope (e.g., "reusable_bag", "flyer")
   * Same barcode may have different categories for different retailers/stores
   */
  category?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeLevel>;
  overrideCatalog?: InputMaybe<Scalars['Boolean']>;
  /**
   * Entity ID based on level (ignored for GLOBAL):
   * PARTNER -> partner_id
   * RETAILER -> retailer_id
   * STORE -> store_id
   */
  scopeId?: InputMaybe<Scalars['BigInt']>;
};

/** Scope level for ban entries */
export enum Instacart_Caper_Admin_V1_BanEntryScopeLevel {
  BanEntryScopeLevelGlobal = 'BAN_ENTRY_SCOPE_LEVEL_GLOBAL',
  BanEntryScopeLevelPartner = 'BAN_ENTRY_SCOPE_LEVEL_PARTNER',
  BanEntryScopeLevelRetailer = 'BAN_ENTRY_SCOPE_LEVEL_RETAILER',
  BanEntryScopeLevelStore = 'BAN_ENTRY_SCOPE_LEVEL_STORE',
  BanEntryScopeLevelUnknown = 'BAN_ENTRY_SCOPE_LEVEL_UNKNOWN'
}

/** Type of ban list entry */
export enum Instacart_Caper_Admin_V1_BanEntryType {
  BanEntryTypeRawBarcode = 'BAN_ENTRY_TYPE_RAW_BARCODE',
  BanEntryTypeRegex = 'BAN_ENTRY_TYPE_REGEX',
  BanEntryTypeUnknown = 'BAN_ENTRY_TYPE_UNKNOWN'
}

/** Ban entry with full scope information */
export type Instacart_Caper_Admin_V1_BanEntryWithScopes = {
  __typename?: 'instacart_caper_admin_v1_BanEntryWithScopes';
  /** Audit history timeline, ordered by timestamp descending (newest first) */
  auditHistory?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryAuditRecord>>>;
  entry?: Maybe<Instacart_Caper_Admin_V1_BanEntry>;
  scopes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** Represents a single ban list entry (barcode or regex pattern) */
export type Instacart_Caper_Admin_V1_BanEntry_Input = {
  /**
   * Whether this entry is archived (soft-deleted)
   * Archived entries are only returned when include_archived filter is true
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryType>;
  /**
   * Raw Barcode or regex pattern
   * For type=REGEX, the Cart will:
   * 1. Match using RE2 or equivalent engine
   * 2. Treat all patterns as case-sensitive
   * 3. NOT anchor automatically - pattern author must use ^ and $ if needed
   *
   * Examples:
   * "^18\d{5}$"     - matches exactly 7 digits starting with 18
   * "^40000\d{6}$"  - matches exactly 11 digits starting with 40000
   */
  value?: InputMaybe<Scalars['String']>;
};

/** A barcode-to-PLU mapping override. */
export type Instacart_Caper_Admin_V1_BarcodePluMapping = {
  __typename?: 'instacart_caper_admin_v1_BarcodePluMapping';
  barcode?: Maybe<Scalars['String']>;
  /**
   * Read-only. Server-managed creation time; populated in successful
   * responses and must be unset in mutation inputs.
   */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Read-only. Server-managed; must be unset in mutation inputs. */
  createdBy?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  plu?: Maybe<Scalars['String']>;
  /** Required; must contain exactly one scope. */
  scope?: Maybe<Instacart_Caper_Admin_V1_MappingScope>;
  source?: Maybe<Scalars['String']>;
  /**
   * Read-only. Server-managed update time; populated in successful responses
   * and must be unset in mutation inputs.
   */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Read-only. Server-managed; must be unset in mutation inputs. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Describes why a mapping mutation failed. */
export type Instacart_Caper_Admin_V1_BarcodePluMappingError = {
  __typename?: 'instacart_caper_admin_v1_BarcodePluMappingError';
  /** The barcode from the failed request item. */
  barcode?: Maybe<Scalars['String']>;
  /** Stable machine-readable error code for frontend translation. */
  code?: Maybe<Scalars['String']>;
  /** The scope from the failed request item. */
  scope?: Maybe<Instacart_Caper_Admin_V1_MappingScope>;
};

/** A barcode-to-PLU mapping override. */
export type Instacart_Caper_Admin_V1_BarcodePluMapping_Input = {
  barcode?: InputMaybe<Scalars['String']>;
  /**
   * Read-only. Server-managed creation time; populated in successful
   * responses and must be unset in mutation inputs.
   */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Read-only. Server-managed; must be unset in mutation inputs. */
  createdBy?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  plu?: InputMaybe<Scalars['String']>;
  /** Required; must contain exactly one scope. */
  scope?: InputMaybe<Instacart_Caper_Admin_V1_MappingScope_Input>;
  source?: InputMaybe<Scalars['String']>;
  /**
   * Read-only. Server-managed update time; populated in successful responses
   * and must be unset in mutation inputs.
   */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Read-only. Server-managed; must be unset in mutation inputs. */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Basket changed event containing current basket state */
export type Instacart_Caper_Admin_V1_BasketChanged = {
  __typename?: 'instacart_caper_admin_v1_BasketChanged';
  /** List of all items currently in the basket */
  basketItems?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BasketItem>>>;
  /** Total discount in cents */
  discount?: Maybe<Scalars['Int']>;
  /** Subtotal amount in cents */
  subTotalAmount?: Maybe<Scalars['Int']>;
  /** Total weight of all items in grams */
  totalWeight?: Maybe<Scalars['Float']>;
};

/** Basket event with timestamp and sequence information */
export type Instacart_Caper_Admin_V1_BasketEventData = {
  __typename?: 'instacart_caper_admin_v1_BasketEventData';
  /** The basket state at this event */
  basketChanged?: Maybe<Instacart_Caper_Admin_V1_BasketChanged>;
  /** Sequence number of this event within the session */
  eventSequence?: Maybe<Scalars['Int']>;
  /** When this event occurred */
  eventTimestamp?: Maybe<Scalars['DateTime']>;
};

/** Individual basket item with full details */
export type Instacart_Caper_Admin_V1_BasketItem = {
  __typename?: 'instacart_caper_admin_v1_BasketItem';
  /** Actual weight in grams (if weighed) */
  actualWeightGrams?: Maybe<Scalars['Float']>;
  /** Barcode of the item */
  barcode?: Maybe<Scalars['String']>;
  /** Unique ID for this basket item */
  basketItemId?: Maybe<Scalars['String']>;
  /** Location in basket (e.g., "MAIN_BASKET", "CHILD_SEAT") */
  basketLocation?: Maybe<Scalars['String']>;
  /** Catalog product ID */
  catalogProductId?: Maybe<Scalars['String']>;
  /** Discount information */
  discount?: Maybe<Instacart_Caper_Admin_V1_PriceData>;
  /** Expected weight with tolerance */
  expectedWeight?: Maybe<Instacart_Caper_Admin_V1_ExpectedWeightData>;
  /** Price information */
  price?: Maybe<Instacart_Caper_Admin_V1_PriceData>;
  /** Quantity of items */
  quantity?: Maybe<Scalars['Int']>;
  /** URL to product thumbnail image */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** Display title of the item */
  title?: Maybe<Scalars['String']>;
  /** Timestamp when item was last updated */
  updateTimestamp?: Maybe<Scalars['String']>;
  /** Amount sold by weight in grams (alternative to quantity for produce items) */
  weightGrams?: Maybe<Scalars['Float']>;
};

/** A batch scheduled action with all its details */
export type Instacart_Caper_Admin_V1_BatchScheduledAction = {
  __typename?: 'instacart_caper_admin_v1_BatchScheduledAction';
  /** Multiple action details (all actions share same schedule_id and workflow_id) */
  actionDetails?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScheduledActionBatchItem>>>;
  /** Cancellation details */
  cancellationReason?: Maybe<Scalars['String']>;
  /** cancelled_at */
  cancelledAt?: Maybe<Scalars['DateTime']>;
  /** cancelled_by */
  cancelledBy?: Maybe<Scalars['String']>;
  /** created_at */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** created_by */
  createdBy?: Maybe<Scalars['String']>;
  executionEndTime?: Maybe<Scalars['DateTime']>;
  /** execution_start_time */
  executionStartTime?: Maybe<Scalars['DateTime']>;
  scheduleId?: Maybe<Scalars['String']>;
  /** scheduled_time */
  scheduledTime?: Maybe<Scalars['DateTime']>;
  /** overall batch status */
  status?: Maybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** updated_at */
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

/** Request to cancel a scheduled action */
export type Instacart_Caper_Admin_V1_CancelScheduledActionRequest_Input = {
  /** Maps to cancellation_reason */
  cancellationReason?: InputMaybe<Scalars['String']>;
  /** Maps to cancelled_by */
  cancelledBy?: InputMaybe<Scalars['String']>;
  scheduleId?: InputMaybe<Scalars['String']>;
};

/** Categorizes the reason for a cart lock to enable accurate incident classification. */
export enum Instacart_Caper_Admin_V1_CartLockReasonType {
  /** Basket camera failure */
  CartLockReasonTypeBasketCameraFailure = 'CART_LOCK_REASON_TYPE_BASKET_CAMERA_FAILURE',
  /** Cart-level network/WiFi failure */
  CartLockReasonTypeConnectivityIssue = 'CART_LOCK_REASON_TYPE_CONNECTIVITY_ISSUE',
  /** Physical cart hardware failure */
  CartLockReasonTypeHardwareIssue = 'CART_LOCK_REASON_TYPE_HARDWARE_ISSUE',
  /** Default catch-all */
  CartLockReasonTypeOther = 'CART_LOCK_REASON_TYPE_OTHER',
  /** Scheduled maintenance or batch job */
  CartLockReasonTypePeriodicJob = 'CART_LOCK_REASON_TYPE_PERIODIC_JOB',
  /** Point-of-sale system failure */
  CartLockReasonTypePosIssue = 'CART_LOCK_REASON_TYPE_POS_ISSUE',
  /** Automated system-initiated lock via a randomized selection process */
  CartLockReasonTypeRoulette = 'CART_LOCK_REASON_TYPE_ROULETTE',
  /** Cart software / app crash or bug */
  CartLockReasonTypeSoftwareIssue = 'CART_LOCK_REASON_TYPE_SOFTWARE_ISSUE',
  /** Store staffing or operational decision */
  CartLockReasonTypeStaffingIssue = 'CART_LOCK_REASON_TYPE_STAFFING_ISSUE',
  /** Store-system integration failure (e.g. third-party POS or inventory system) */
  CartLockReasonTypeStoreIntegration = 'CART_LOCK_REASON_TYPE_STORE_INTEGRATION',
  /** Retailer or store-wide network outage */
  CartLockReasonTypeStoreNetwork = 'CART_LOCK_REASON_TYPE_STORE_NETWORK',
  /** Cart temp out of range */
  CartLockReasonTypeTempOutOfWeighingRange = 'CART_LOCK_REASON_TYPE_TEMP_OUT_OF_WEIGHING_RANGE',
  /** Do not use, Other is defaulted in the backend */
  CartLockReasonTypeUnknown = 'CART_LOCK_REASON_TYPE_UNKNOWN',
  /** Weights and Measures regulatory inspection or audit */
  CartLockReasonTypeWeightAndMeasures = 'CART_LOCK_REASON_TYPE_WEIGHT_AND_MEASURES',
  /** Hardware Ops requirement for weight calibration failed */
  CartLockReasonTypeWeightCalibration = 'CART_LOCK_REASON_TYPE_WEIGHT_CALIBRATION'
}

/**
 * CartManagerPermissionScope describes global, legacy retailer-scoped, or
 * partner-scoped store access.
 */
export type Instacart_Caper_Admin_V1_CartManagerPermissionScope_Input = {
  /** Grants access to every current and future store. */
  globalAccess?: InputMaybe<Scalars['instacart_caper_admin_v1_GlobalStoreAccess_Input']>;
  /** Grants access beneath one selected partner. */
  selectedPartner?: InputMaybe<Instacart_Caper_Admin_V1_SelectedPartnerAccess_Input>;
  /** Deprecated: use selected_partner for new clients. */
  selectedRetailers?: InputMaybe<Instacart_Caper_Admin_V1_SelectedRetailerAccess_Input>;
};

/** CartManagerRole is the title assigned to a Cart Manager account. */
export enum Instacart_Caper_Admin_V1_CartManagerRole {
  CartManagerRoleAssociate = 'CART_MANAGER_ROLE_ASSOCIATE',
  CartManagerRoleCorporateManager = 'CART_MANAGER_ROLE_CORPORATE_MANAGER',
  CartManagerRoleLossPrevention = 'CART_MANAGER_ROLE_LOSS_PREVENTION',
  CartManagerRoleRegionalManager = 'CART_MANAGER_ROLE_REGIONAL_MANAGER',
  CartManagerRoleStoreManager = 'CART_MANAGER_ROLE_STORE_MANAGER',
  CartManagerRoleUnknown = 'CART_MANAGER_ROLE_UNKNOWN'
}

/**
 * Inputs for the Cart Replacement pipeline.
 * Provisions a single new cart into a store.
 */
export type Instacart_Caper_Admin_V1_CartReplacementConfig_Input = {
  /** CSC name of the device being replaced (e.g. "P_WAKEFERN_15_M3_001"). */
  cscDeviceName?: InputMaybe<Scalars['String']>;
  /** Warehouse IPv4 address of the device (e.g. "192.168.1.100"). */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Whether the cart has a bottom tray. Defaults to false. */
  isBottomTray?: InputMaybe<Scalars['Boolean']>;
  /** Whether the cart is an M3S model (no Jetson board). Defaults to false. */
  isM3s?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether the cart is a 2CV model.
   * Proto3 bool defaults to false if unset; the backend treats unset as true.
   */
  is_2cv?: InputMaybe<Scalars['Boolean']>;
  /** OTA bundle version to deploy. Backend uses the default version if omitted. */
  packageVersion?: InputMaybe<Scalars['String']>;
  /**
   * Physical product ID of the cart (printed on the cart; referred to as
   * productId in IoT Platform).
   */
  productId?: InputMaybe<Scalars['String']>;
  /** Store identifier (e.g. "prod-wakefern-25"). */
  storeId?: InputMaybe<Scalars['String']>;
};

/** Cart session data containing device info and all events */
export type Instacart_Caper_Admin_V1_CartSessionData = {
  __typename?: 'instacart_caper_admin_v1_CartSessionData';
  /** Audit-issue video records linked to this session */
  auditIssueVideos?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_AuditIssueVideoData>>>;
  /** List of basket events showing cart contents over time */
  basketEvents?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BasketEventData>>>;
  /** Device information for the cart */
  deviceInfo?: Maybe<Instacart_Caper_Admin_V1_DeviceInfo>;
  /** The session ID for this data */
  sessionId?: Maybe<Scalars['String']>;
  /** List of video audit events */
  videoAuditEvents?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_VideoAuditEventData>>>;
};

export enum Instacart_Caper_Admin_V1_CatalogAvailability {
  CatalogAvailabilityExtInCaperCatalog = 'CATALOG_AVAILABILITY_EXT_IN_CAPER_CATALOG',
  CatalogAvailabilityExtInIcCatalog = 'CATALOG_AVAILABILITY_EXT_IN_IC_CATALOG',
  CatalogAvailabilityExtInRetailerCatalog = 'CATALOG_AVAILABILITY_EXT_IN_RETAILER_CATALOG',
  CatalogAvailabilityExtNotInAny = 'CATALOG_AVAILABILITY_EXT_NOT_IN_ANY',
  CatalogAvailabilityExtProcessingFailure = 'CATALOG_AVAILABILITY_EXT_PROCESSING_FAILURE',
  CatalogAvailabilityInIcCatalog = 'CATALOG_AVAILABILITY_IN_IC_CATALOG',
  CatalogAvailabilityInRetailerCatalog = 'CATALOG_AVAILABILITY_IN_RETAILER_CATALOG',
  CatalogAvailabilityInStoreCatalog = 'CATALOG_AVAILABILITY_IN_STORE_CATALOG',
  CatalogAvailabilityNotInAny = 'CATALOG_AVAILABILITY_NOT_IN_ANY',
  CatalogAvailabilityUnknown = 'CATALOG_AVAILABILITY_UNKNOWN'
}

/** Config action for scheduled changes */
export type Instacart_Caper_Admin_V1_ConfigAction = {
  __typename?: 'instacart_caper_admin_v1_ConfigAction';
  /** Optional: config ID for future enhancement */
  configKeyId?: Maybe<Scalars['BigInt']>;
  /** Required: config name (aligns with current ConfigValue.name usage) */
  configName?: Maybe<Scalars['String']>;
  /** set/update to this value */
  configValue?: Maybe<Scalars['String']>;
  /** explicitly remove/reset to default */
  unset?: Maybe<Scalars['Boolean']>;
};

/** Config action for scheduled changes */
export type Instacart_Caper_Admin_V1_ConfigAction_Input = {
  /** Optional: config ID for future enhancement */
  configKeyId?: InputMaybe<Scalars['BigInt']>;
  /** Required: config name (aligns with current ConfigValue.name usage) */
  configName?: InputMaybe<Scalars['String']>;
  /** set/update to this value */
  configValue?: InputMaybe<Scalars['String']>;
  /** explicitly remove/reset to default */
  unset?: InputMaybe<Scalars['Boolean']>;
};

/** Shared entry for a single report artifact. */
export type Instacart_Caper_Admin_V1_ConfigCleanupReportEntry = {
  __typename?: 'instacart_caper_admin_v1_ConfigCleanupReportEntry';
  /** URL that triggers a file download in the browser instead of inline rendering. */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Timestamp when the report was generated. */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** URL for viewing the report inline (e.g., in a browser tab or iframe). Treat as short-lived. */
  viewUrl?: Maybe<Scalars['String']>;
};

/** Shared entry for a single config feature drift report artifact. */
export type Instacart_Caper_Admin_V1_ConfigFeatureDriftReportEntry = {
  __typename?: 'instacart_caper_admin_v1_ConfigFeatureDriftReportEntry';
  /** URL that triggers a file download in the browser instead of inline rendering. */
  downloadUrl?: Maybe<Scalars['String']>;
  /** Timestamp when the report was generated. */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** URL for viewing the report inline (e.g., in a browser tab or iframe). Treat as short-lived. */
  viewUrl?: Maybe<Scalars['String']>;
};

/** A config key and metadata about it */
export type Instacart_Caper_Admin_V1_ConfigKey = {
  __typename?: 'instacart_caper_admin_v1_ConfigKey';
  /**
   * For TYPE_ENUM and TYPE_ROULETTE_EXPERIMENT configs, this defines the allowed enum values.
   * Each string in this array represents a valid enum value that can be set for this config.
   * This field is required when type = TYPE_ENUM or TYPE_ROULETTE_EXPERIMENT and ignored for other types.
   * When validating config values, the value must exactly match one of these strings (case-sensitive).
   * For TYPE_ROULETTE_EXPERIMENT, allowed_enum_values must include the "ROULETTE" sentinel value.
   */
  allowedEnumValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * You can mark config fields that are no longer read by the cart as "archived".
   * In the future, this will prevent these options from showing up in the UI.
   */
  archived?: Maybe<Scalars['Boolean']>;
  /** A link to the relevant SOP, JIRA, or other doc. Must be a link. */
  contextLink?: Maybe<Scalars['String']>;
  /** free form text field to indicate Ii this config relies on Roulette Flags or other configs. If there are none, leave blank */
  dependencies?: Maybe<Scalars['String']>;
  /**
   * A description of the config, visible in CSC UI. Must be at least 100 characters, and should at minimum
   * communicate expected input values, their expected behavior, and the default value.
   * For TYPE_ENUM and TYPE_ROULETTE_EXPERIMENT configs, should also document the meaning of each enum value.
   */
  description?: Maybe<Scalars['String']>;
  /** What feature this is a part of, such as Streaks, GI, USF. If it's not a specific feature, leave blank */
  feature?: Maybe<Scalars['String']>;
  /**
   * This will be empty if the data is being returned from the config_keys.json instead of the database.
   * Do not set during creation.
   */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * An optional field that defines the minimum required version of the Caper Core app for a configuration to be enabled.
   * Inclusion Criteria: If the app version is greater than or equal to min_app_version, the feature is included. If the app version is lower, the feature is excluded.
   * Example: min_app_version = "24.1.1-v04" If the app version is 24.2.0, the feature is included. If the app version is 24.1.1-v03, the feature is excluded.
   * Version Requirements: The min_app_version must be a string and follow valid semantic versioning (major, minor, patch, and pre-release tags). Build metadata is ignored when comparing versions.
   * Invalid Versions: If min_app_version is invalid or cannot be parsed correctly, tests will fail. However, in production, the logic will exclude the feature by default to prevent configuration errors.
   */
  minAppVersion?: Maybe<Scalars['String']>;
  /**
   * This should be the name of the config in snake case. It should be as descriptive as possible.
   * There is a 10 char minimum, but no character limit.
   */
  name?: Maybe<Scalars['String']>;
  /** DRI, either an individual or a team (eg, value, deployment, hsi) */
  owner?: Maybe<Scalars['String']>;
  /** this controls how it can be set in the CSC UI, and the type of validation */
  type?: Maybe<Instacart_Caper_Admin_V1_ConfigKey_Type>;
};

/** A config key and metadata about it */
export type Instacart_Caper_Admin_V1_ConfigKey_Input = {
  /**
   * For TYPE_ENUM and TYPE_ROULETTE_EXPERIMENT configs, this defines the allowed enum values.
   * Each string in this array represents a valid enum value that can be set for this config.
   * This field is required when type = TYPE_ENUM or TYPE_ROULETTE_EXPERIMENT and ignored for other types.
   * When validating config values, the value must exactly match one of these strings (case-sensitive).
   * For TYPE_ROULETTE_EXPERIMENT, allowed_enum_values must include the "ROULETTE" sentinel value.
   */
  allowedEnumValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * You can mark config fields that are no longer read by the cart as "archived".
   * In the future, this will prevent these options from showing up in the UI.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** A link to the relevant SOP, JIRA, or other doc. Must be a link. */
  contextLink?: InputMaybe<Scalars['String']>;
  /** free form text field to indicate Ii this config relies on Roulette Flags or other configs. If there are none, leave blank */
  dependencies?: InputMaybe<Scalars['String']>;
  /**
   * A description of the config, visible in CSC UI. Must be at least 100 characters, and should at minimum
   * communicate expected input values, their expected behavior, and the default value.
   * For TYPE_ENUM and TYPE_ROULETTE_EXPERIMENT configs, should also document the meaning of each enum value.
   */
  description?: InputMaybe<Scalars['String']>;
  /** What feature this is a part of, such as Streaks, GI, USF. If it's not a specific feature, leave blank */
  feature?: InputMaybe<Scalars['String']>;
  /**
   * This will be empty if the data is being returned from the config_keys.json instead of the database.
   * Do not set during creation.
   */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * An optional field that defines the minimum required version of the Caper Core app for a configuration to be enabled.
   * Inclusion Criteria: If the app version is greater than or equal to min_app_version, the feature is included. If the app version is lower, the feature is excluded.
   * Example: min_app_version = "24.1.1-v04" If the app version is 24.2.0, the feature is included. If the app version is 24.1.1-v03, the feature is excluded.
   * Version Requirements: The min_app_version must be a string and follow valid semantic versioning (major, minor, patch, and pre-release tags). Build metadata is ignored when comparing versions.
   * Invalid Versions: If min_app_version is invalid or cannot be parsed correctly, tests will fail. However, in production, the logic will exclude the feature by default to prevent configuration errors.
   */
  minAppVersion?: InputMaybe<Scalars['String']>;
  /**
   * This should be the name of the config in snake case. It should be as descriptive as possible.
   * There is a 10 char minimum, but no character limit.
   */
  name?: InputMaybe<Scalars['String']>;
  /** DRI, either an individual or a team (eg, value, deployment, hsi) */
  owner?: InputMaybe<Scalars['String']>;
  /** this controls how it can be set in the CSC UI, and the type of validation */
  type?: InputMaybe<Instacart_Caper_Admin_V1_ConfigKey_Type>;
};

export enum Instacart_Caper_Admin_V1_ConfigKey_Type {
  /** A subset of url, this is for configs that should be animation urls */
  TypeAnimationUrl = 'TYPE_ANIMATION_URL',
  TypeBoolean = 'TYPE_BOOLEAN',
  /** Enum type with allowed values defined in allowed_enum_values field */
  TypeEnum = 'TYPE_ENUM',
  /** A subset of url, this is for configs that should be general file urls except image and animation */
  TypeFileUrl = 'TYPE_FILE_URL',
  /** A subset of url, this is for configs that should be image urls */
  TypeImageUrl = 'TYPE_IMAGE_URL',
  TypeInt = 'TYPE_INT',
  /** JSON type for configs that should be JSON objects or arrays */
  TypeJson = 'TYPE_JSON',
  /** Roulette experiment type with allowed variants and a required ROULETTE sentinel value */
  TypeRouletteExperiment = 'TYPE_ROULETTE_EXPERIMENT',
  TypeString = 'TYPE_STRING',
  /** should never be set to this */
  TypeUnknown = 'TYPE_UNKNOWN',
  /** not currently supported */
  TypeUrl = 'TYPE_URL'
}

/** Configs to remove or update/add for a specified entity */
export type Instacart_Caper_Admin_V1_ConfigUpdate_Input = {
  cartId?: InputMaybe<Scalars['BigInt']>;
  /**
   * To make a config use the default value hardcoded on the Android side
   * you must unset the config in the database by providing the key name in
   * the following field
   */
  configsKeysToUnset?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  configsToUpdate?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  global?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Name and value pair for a configuration */
export type Instacart_Caper_Admin_V1_ConfigValue = {
  __typename?: 'instacart_caper_admin_v1_ConfigValue';
  /** the time of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** the author of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAtAuthor?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Name and value pair for a configuration */
export type Instacart_Caper_Admin_V1_ConfigValue_Input = {
  /** the time of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** the author of the last update to this config, this does not need to be set when creating, it's for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Request message for creating a ban entry */
export type Instacart_Caper_Admin_V1_CreateBanEntryRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  entry?: InputMaybe<Instacart_Caper_Admin_V1_BanEntry_Input>;
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for creating a ban entry */
export type Instacart_Caper_Admin_V1_CreateBanEntryResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateBanEntryResponse';
  /** The created ban entry ID */
  id?: Maybe<Scalars['String']>;
};

/** Request for creating barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_CreateBarcodePluMappingsRequest_Input = {
  /** Must contain at least one mapping. */
  mappings?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BarcodePluMapping_Input>>>;
};

/** Response for creating barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_CreateBarcodePluMappingsResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateBarcodePluMappingsResponse';
  /** Successfully created mappings. */
  createdMappings?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMapping>>>;
  /** Failed request items. May coexist with created_mappings. */
  failedCreates?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMappingError>>>;
};

/** Request for creating a new config key */
export type Instacart_Caper_Admin_V1_CreateConfigKeyRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  configKey?: InputMaybe<Instacart_Caper_Admin_V1_ConfigKey_Input>;
};

/** Request to initiate async generation of a session summary */
export type Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncRequest_Input = {
  sessionId?: InputMaybe<Scalars['String']>;
  /** Id of generated user journey report */
  summaryId?: InputMaybe<Scalars['String']>;
  /** Enable fetching cached results for the session summary generation */
  useCache?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Response for initiating asynchronous datadog triage report creation
 * Returns the initial status of the datadog triage report generation process
 */
export type Instacart_Caper_Admin_V1_CreateDatadogSummaryAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateDatadogSummaryAsyncResponse';
  status?: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for creating a new device */
export type Instacart_Caper_Admin_V1_CreateDeviceRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  device?: InputMaybe<Instacart_Caper_Admin_V1_Device_Input>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Request for creating new devices */
export type Instacart_Caper_Admin_V1_CreateDevicesRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Cart hardware model, e.g. "M3", "M3S". Used for auto-generating device names. */
  cartModel?: InputMaybe<Scalars['String']>;
  /** base names for the devices about to be created, this name will be appended with numbers */
  deviceNamePrefix?: InputMaybe<Scalars['String']>;
  /** The purpose of the devices about to be created */
  devicePurpose?: InputMaybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  /** number of devices that will be created */
  numDevices?: InputMaybe<Scalars['BigInt']>;
  /** The ID of the store that the devices will be created for */
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for creating new devices */
export type Instacart_Caper_Admin_V1_CreateDevicesResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateDevicesResponse';
  /** IDs of all newly created devices, for use in provisioning workflows */
  deviceIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Request for creating a new feature */
export type Instacart_Caper_Admin_V1_CreateFeatureRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  feature?: InputMaybe<Instacart_Caper_Admin_V1_Feature_Input>;
};

/**
 * A request to create a new payment merchant for a store.
 * The merchant_id (MID) must match the format provided in the VAR sheet.
 */
export type Instacart_Caper_Admin_V1_CreateMerchantRequest_Input = {
  /** Email of the CSC user making the request. Used for audit trail. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** "Doing Business As" name - the merchant's display name. */
  dbaName?: InputMaybe<Scalars['String']>;
  /** Merchant Identification Number (MID) from VAR sheet. */
  merchantId?: InputMaybe<Scalars['String']>;
  /**
   * The payment profile ID. Determines the Worldline parent organization
   * and processor configuration (e.g., Vantiv, FDC RapidConnect).
   */
  profileId?: InputMaybe<Scalars['BigInt']>;
  /** The Caper store ID. The store must exist in the entity database. */
  storeId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Terminals to create along with the merchant. */
  terminals?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_TerminalInput_Input>>>;
};

/** Response from CreateMerchant. Returned with gRPC status OK on success. */
export type Instacart_Caper_Admin_V1_CreateMerchantResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateMerchantResponse';
  /** The created merchant entity. */
  merchant?: Maybe<Instacart_Caper_Admin_V1_PaymentMerchant>;
  /** Terminals created if terminals were provided in the request. */
  terminals?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>>>;
};

/** Request for creating a notification group. */
export type Instacart_Caper_Admin_V1_CreateNotificationGroupRequest_Input = {
  /** The email of the person making the change. Must be a valid Instacart company email (format: firstname.lastname@instacart.com). */
  authorEmail?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Instacart_Caper_Admin_V1_NotificationGroup_Input>;
};

/** Response for creating a notification group. Returned group includes the server-assigned id. */
export type Instacart_Caper_Admin_V1_CreateNotificationGroupResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateNotificationGroupResponse';
  group?: Maybe<Instacart_Caper_Admin_V1_NotificationGroup>;
};

/** Request for creating a new partner */
export type Instacart_Caper_Admin_V1_CreatePartnerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Instacart_Caper_Admin_V1_Partner_Input>;
};

/** Request for creating a presigned asset url */
export type Instacart_Caper_Admin_V1_CreatePresignedAssetUrlRequest_Input = {
  configName?: InputMaybe<Scalars['String']>;
  /** png, riv supported */
  fileExtension?: InputMaybe<Scalars['String']>;
};

/** Response for creating a presigned asset url */
export type Instacart_Caper_Admin_V1_CreatePresignedAssetUrlResponse = {
  __typename?: 'instacart_caper_admin_v1_CreatePresignedAssetUrlResponse';
  readUrl?: Maybe<Scalars['String']>;
  writeUrl?: Maybe<Scalars['String']>;
};

/** Request for creating a new retailer */
export type Instacart_Caper_Admin_V1_CreateRetailerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailer?: InputMaybe<Instacart_Caper_Admin_V1_Retailer_Input>;
};

/** Request to initiate async generation of a session summary */
export type Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncRequest_Input = {
  sessionId?: InputMaybe<Scalars['String']>;
  /** Enable fetching cached results for the session summary generation */
  useCache?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Response for initiating asynchronous session summary creation
 * Returns the initial status of the summary generation process
 */
export type Instacart_Caper_Admin_V1_CreateSessionSummaryAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateSessionSummaryAsyncResponse';
  status?: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for creating a new store */
export type Instacart_Caper_Admin_V1_CreateStoreRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Cart hardware model, e.g. "M3", "M3S". Used for auto-generating device names. */
  cartModel?: InputMaybe<Scalars['String']>;
  /** base names for the devices about to be created, this name will be appended with numbers */
  deviceNamePrefix?: InputMaybe<Scalars['String']>;
  /** number of devices that will be created for this store */
  numDevices?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  store?: InputMaybe<Instacart_Caper_Admin_V1_Store_Input>;
};

/** Response for creating a new store */
export type Instacart_Caper_Admin_V1_CreateStoreResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateStoreResponse';
  /** IDs of devices created with the store, for use in provisioning workflows */
  deviceIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** CreateStoreStaffBarcodeRequest is the request to create a new store staff barcode. */
export type Instacart_Caper_Admin_V1_CreateStoreStaffBarcodeRequest_Input = {
  /**
   * Symbology to use when generating the barcode value. If unset or
   * STORE_STAFF_BARCODE_TYPE_UNKNOWN, interpret as
   * STORE_STAFF_BARCODE_TYPE_CODE_128 for legacy requests that predate
   * this field.
   */
  barcodeType?: InputMaybe<Instacart_Caper_Admin_V1_StoreStaffBarcodeType>;
  /**
   * Caper store IDs to create barcodes for (one barcode per store),
   * parallel to warehouse_location_ids.
   */
  caperStoreIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Identifier of who created this barcode (IPP user email or system/migration job name). */
  createdBy?: InputMaybe<Scalars['String']>;
  /** First name of the store staff member. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Last name of the store staff member. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Permissions granted to the staff member (e.g., force resolve). */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_StoreStaffPermission>>>;
  /**
   * Optional predefined barcode string. If provided, uses this value instead of generating one.
   * Useful for migrating existing barcodes or assigning a specific barcode to a staff member.
   */
  predefinedBarcode?: InputMaybe<Scalars['String']>;
  /** Role assigned to the staff member (e.g., associate or manager). */
  role?: InputMaybe<Instacart_Caper_Admin_V1_StoreStaffRole>;
  /** IPP warehouse location IDs to create barcodes for (one barcode per location). */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** CreateStoreStaffBarcodeResponse is the response after creating store staff barcodes. */
export type Instacart_Caper_Admin_V1_CreateStoreStaffBarcodeResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateStoreStaffBarcodeResponse';
  /** IDs of the newly created barcodes (one per warehouse location). */
  barcodeIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * A request to create payment terminals for devices in a store.
 * The store must already have a merchant.
 */
export type Instacart_Caper_Admin_V1_CreateTerminalsRequest_Input = {
  /** Email of the CSC user making the request. Used for audit trail. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The Caper store ID. The store must have an existing merchant. */
  storeId?: InputMaybe<Scalars['BigInt']>;
  /** List of terminals to create. Each entry maps a device to a TID. */
  terminals?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_TerminalInput_Input>>>;
};

/**
 * Response from CreateTerminals. Uses partial-success semantics:
 * the RPC returns OK even if some terminals failed.
 */
export type Instacart_Caper_Admin_V1_CreateTerminalsResponse = {
  __typename?: 'instacart_caper_admin_v1_CreateTerminalsResponse';
  /** Per-terminal errors for items that failed to create. */
  errors?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_TerminalCreationError>>>;
  /** Count of terminals that failed to create. */
  failureCount?: Maybe<Scalars['Int']>;
  /** Count of successfully created terminals. */
  successCount?: Maybe<Scalars['Int']>;
  /** Successfully created terminal entities. */
  terminals?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>>>;
};

/** Represents a default value for a config key associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureDefaultValue = {
  __typename?: 'instacart_caper_admin_v1_CscFeatureDefaultValue';
  /** The config key ID this default value is for (references the ConfigKey entity) */
  configKeyId?: Maybe<Scalars['BigInt']>;
  /** The default value for the config key */
  defaultValue?: Maybe<Scalars['String']>;
  /** Database ID of the default value. Does not need to be set for creation. */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Classification of default_value's encoded form.
   * proto3 deserializes unset values as DEFAULT_VALUE_TYPE_UNKNOWN, not STRING — consumers must coalesce UNKNOWN to STRING (see enum doc).
   */
  valueType?: Maybe<Instacart_Caper_Admin_V1_DefaultValueType>;
};

/** Represents a default value for a config key associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureDefaultValue_Input = {
  /** The config key ID this default value is for (references the ConfigKey entity) */
  configKeyId?: InputMaybe<Scalars['BigInt']>;
  /** The default value for the config key */
  defaultValue?: InputMaybe<Scalars['String']>;
  /** Database ID of the default value. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Classification of default_value's encoded form.
   * proto3 deserializes unset values as DEFAULT_VALUE_TYPE_UNKNOWN, not STRING — consumers must coalesce UNKNOWN to STRING (see enum doc).
   */
  valueType?: InputMaybe<Instacart_Caper_Admin_V1_DefaultValueType>;
};

/** Represents a roulette link associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureRouletteLink = {
  __typename?: 'instacart_caper_admin_v1_CscFeatureRouletteLink';
  /** Database ID of the roulette link. Does not need to be set for creation. */
  id?: Maybe<Scalars['BigInt']>;
  /** The roulette link URL */
  link?: Maybe<Scalars['String']>;
  /** Status of this roulette link */
  status?: Maybe<Instacart_Caper_Admin_V1_RouletteLinkStatus>;
};

/** Represents a roulette link associated with a CSC feature */
export type Instacart_Caper_Admin_V1_CscFeatureRouletteLink_Input = {
  /** Database ID of the roulette link. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The roulette link URL */
  link?: InputMaybe<Scalars['String']>;
  /** Status of this roulette link */
  status?: InputMaybe<Instacart_Caper_Admin_V1_RouletteLinkStatus>;
};

/** Date field type for date range filtering */
export enum Instacart_Caper_Admin_V1_DateField {
  /** Filter by NOF creation date */
  DateFieldCreationDate = 'DATE_FIELD_CREATION_DATE',
  /** Filter by last updated date */
  DateFieldLastUpdatedDate = 'DATE_FIELD_LAST_UPDATED_DATE',
  /** Filter by resolution date */
  DateFieldResolutionDate = 'DATE_FIELD_RESOLUTION_DATE',
  DateFieldUnknown = 'DATE_FIELD_UNKNOWN'
}

/** Classification of the encoded form of CscFeatureDefaultValue.default_value. */
export enum Instacart_Caper_Admin_V1_DefaultValueType {
  /** default_value is a JSON-encoded document. */
  DefaultValueTypeJson = 'DEFAULT_VALUE_TYPE_JSON',
  /** default_value is an opaque string. */
  DefaultValueTypeString = 'DEFAULT_VALUE_TYPE_STRING',
  /**
   * Wire-level zero value, observed when older producers or legacy rows omit the field.
   * Consumers MUST treat UNKNOWN as DEFAULT_VALUE_TYPE_STRING — proto3 does not distinguish unset from explicit zero, and STRING is the canonical default form of default_value.
   */
  DefaultValueTypeUnknown = 'DEFAULT_VALUE_TYPE_UNKNOWN'
}

/** Request for deleting barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_DeleteBarcodePluMappingsRequest_Input = {
  /**
   * Must contain at least one mapping.
   * Delete uses only scope and barcode. All other fields are ignored.
   */
  mappings?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BarcodePluMapping_Input>>>;
};

/** Response for deleting barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_DeleteBarcodePluMappingsResponse = {
  __typename?: 'instacart_caper_admin_v1_DeleteBarcodePluMappingsResponse';
  /** Successfully deleted mappings as they existed before tombstoning. */
  deletedMappings?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMapping>>>;
  /** Failed request items. May coexist with deleted_mappings. */
  failedDeletes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMappingError>>>;
};

/** A Caper device, aka a cart. This is the lowest level of the hierarchy */
export type Instacart_Caper_Admin_V1_Device = {
  __typename?: 'instacart_caper_admin_v1_Device';
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: Maybe<Scalars['DateTime']>;
  devicePurpose?: Maybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  /** Features associated with this device */
  featureValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  /** Attributes of a store, separate from configs */
  id?: Maybe<Scalars['BigInt']>;
  iotDeviceName?: Maybe<Scalars['String']>;
  /** whether this config is synced to the latest version, this does not need to be set when creating, it's for display purposes */
  isSyncedToLatest?: Maybe<Scalars['Boolean']>;
  /** the time the device was last synced with the device config */
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: Maybe<Scalars['String']>;
  legacyNgcpObjectId?: Maybe<Scalars['String']>;
  mdmDeviceId?: Maybe<Scalars['String']>;
  mdmDeviceName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  operationalState?: Maybe<Instacart_Caper_Admin_V1_Device_OperationalState>;
  /** the effective time for the operational_state change, only set this if the operational_state has been changed */
  operationalStateEffectiveTime?: Maybe<Scalars['DateTime']>;
  publicKey?: Maybe<Scalars['String']>;
};

/** Device information for a cart */
export type Instacart_Caper_Admin_V1_DeviceInfo = {
  __typename?: 'instacart_caper_admin_v1_DeviceInfo';
  /** Device label (e.g., "Cart #3") */
  deviceLabel?: Maybe<Scalars['String']>;
  /** Device purpose (e.g., "SHOPPING_CART") */
  devicePurpose?: Maybe<Scalars['String']>;
  /** Store ID where the device is located */
  storeId?: Maybe<Scalars['String']>;
};

/**
 * Unlock evaluation for one device, identifying the affected cart. A scoped
 * unlock (store, retailer, partner, warehouse) resolves to many devices whose
 * held locks may differ, so each device is evaluated independently.
 */
export type Instacart_Caper_Admin_V1_DeviceUnlockEvaluation = {
  __typename?: 'instacart_caper_admin_v1_DeviceUnlockEvaluation';
  /** Device the evaluation applies to. */
  deviceId?: Maybe<Scalars['BigInt']>;
  /** How the unlock request was evaluated for this device. */
  evaluation?: Maybe<Instacart_Caper_Admin_V1_UnlockEvaluation>;
};

/** The purpose of the device */
export enum Instacart_Caper_Admin_V1_Device_DevicePurpose {
  DevicePurposeDemo = 'DEVICE_PURPOSE_DEMO',
  /** Only standard devices are included in analytics */
  DevicePurposeStandard = 'DEVICE_PURPOSE_STANDARD',
  /** Testing devices cannot finalize orders */
  DevicePurposeTesting = 'DEVICE_PURPOSE_TESTING',
  DevicePurposeUat = 'DEVICE_PURPOSE_UAT',
  DevicePurposeUnknown = 'DEVICE_PURPOSE_UNKNOWN'
}

/** A Caper device, aka a cart. This is the lowest level of the hierarchy */
export type Instacart_Caper_Admin_V1_Device_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  devicePurpose?: InputMaybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  /** Features associated with this device */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Attributes of a store, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  iotDeviceName?: InputMaybe<Scalars['String']>;
  /** whether this config is synced to the latest version, this does not need to be set when creating, it's for display purposes */
  isSyncedToLatest?: InputMaybe<Scalars['Boolean']>;
  /** the time the device was last synced with the device config */
  lastSyncedAt?: InputMaybe<Scalars['DateTime']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  legacyNgcpObjectId?: InputMaybe<Scalars['String']>;
  mdmDeviceId?: InputMaybe<Scalars['String']>;
  mdmDeviceName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  operationalState?: InputMaybe<Instacart_Caper_Admin_V1_Device_OperationalState>;
  /** the effective time for the operational_state change, only set this if the operational_state has been changed */
  operationalStateEffectiveTime?: InputMaybe<Scalars['DateTime']>;
  publicKey?: InputMaybe<Scalars['String']>;
};

/** The operational state of the device */
export enum Instacart_Caper_Admin_V1_Device_OperationalState {
  /** Decommissioned means the device can no longer be used at any store, it is returned to warehouse */
  OperationalStateDecommisioned = 'OPERATIONAL_STATE_DECOMMISIONED',
  /** In circulation means the device is in the store and can be used */
  OperationalStateInCirculation = 'OPERATIONAL_STATE_IN_CIRCULATION',
  /** Undeployed means the device is put aside due to business reason */
  OperationalStateInStoreUndeployed = 'OPERATIONAL_STATE_IN_STORE_UNDEPLOYED',
  /** New means the device has just been created in the factory */
  OperationalStateNew = 'OPERATIONAL_STATE_NEW',
  /** Out of circulation means the device is in the field but possibly in an error state and not being used */
  OperationalStateOutOfCirculation = 'OPERATIONAL_STATE_OUT_OF_CIRCULATION',
  /** Unknown */
  OperationalStateUnknown = 'OPERATIONAL_STATE_UNKNOWN'
}

/**
 * EditStoreStaffBarcodeRequest is the request to update an existing store staff barcode.
 * Update fields (first_name, last_name, permissions, is_active) represent the
 * full current state of the edited barcode — the caller must send the complete
 * value of each (partial update semantics are handled at the service layer).
 * additional_warehouse_location_ids is the exception: it is an additive
 * operation applied on top of the current state and lists only *new*
 * locations at which to create the same barcode. It is optional and, when
 * empty, no additional barcodes are created; it must not include the
 * barcode's own warehouse_location_id or any location that already has this
 * barcode value, both of which are rejected by the service as duplicates.
 */
export type Instacart_Caper_Admin_V1_EditStoreStaffBarcodeRequest_Input = {
  /**
   * Optional additional Caper store IDs at which to also create this barcode,
   * parallel to additional_warehouse_location_ids. Empty means no additional
   * stores are populated.
   */
  additionalCaperStoreIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional additional IPP warehouse location IDs to also create this
   * barcode at. When set, the service creates new barcodes at each of
   * these locations reusing the same barcode value and staff login as
   * the barcode identified by barcode_id. Locations that already have a
   * barcode with this value are rejected. Empty means no additional
   * locations are populated.
   */
  additionalWarehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the barcode to edit. */
  barcodeId?: InputMaybe<Scalars['BigInt']>;
  /** Updated first name of the store staff member. */
  firstName?: InputMaybe<Scalars['String']>;
  /** Whether the barcode is active. Set to false to deactivate. */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Updated last name of the store staff member. */
  lastName?: InputMaybe<Scalars['String']>;
  /** Full list of permissions to set (replaces existing permissions). */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_StoreStaffPermission>>>;
  /** Identifier of who made this edit (IPP user email or system/migration job name). */
  updatedBy?: InputMaybe<Scalars['String']>;
  /** IPP warehouse location ID for resource authorization. */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** Categories of work required to enable a feature for a given retailer/store. */
export enum Instacart_Caper_Admin_V1_EnablementRequirement {
  /** Feature requires CSC config keys to be set at the appropriate entity level (global/partner/retailer/store/device). */
  EnablementRequirementCscConfiguration = 'ENABLEMENT_REQUIREMENT_CSC_CONFIGURATION',
  /** Custom engineering work (integration, retailer-specific code, backend changes) is required to enable this feature. */
  EnablementRequirementEngineeringEffort = 'ENABLEMENT_REQUIREMENT_ENGINEERING_EFFORT',
  /** Physical hardware (cart, sensors, mounts, peripherals) must be installed or configured before this feature can be enabled. */
  EnablementRequirementHardware = 'ENABLEMENT_REQUIREMENT_HARDWARE',
  EnablementRequirementUnknown = 'ENABLEMENT_REQUIREMENT_UNKNOWN'
}

/** The type of entity */
export enum Instacart_Caper_Admin_V1_EntityType {
  EntityTypeDevice = 'ENTITY_TYPE_DEVICE',
  EntityTypeGlobal = 'ENTITY_TYPE_GLOBAL',
  EntityTypePartner = 'ENTITY_TYPE_PARTNER',
  EntityTypeRetailer = 'ENTITY_TYPE_RETAILER',
  EntityTypeStore = 'ENTITY_TYPE_STORE',
  EntityTypeUnknown = 'ENTITY_TYPE_UNKNOWN'
}

/** Expected weight information with tolerance */
export type Instacart_Caper_Admin_V1_ExpectedWeightData = {
  __typename?: 'instacart_caper_admin_v1_ExpectedWeightData';
  /** Tolerance in grams */
  toleranceGrams?: Maybe<Scalars['Float']>;
  /** Expected weight in grams */
  weightGrams?: Maybe<Scalars['Float']>;
};

/** A CSC feature, which is a product feature with various metadata, including how to turn it on */
export type Instacart_Caper_Admin_V1_Feature = {
  __typename?: 'instacart_caper_admin_v1_Feature';
  /** Allowed user emails stored as JSON array in DB, modeled as repeated string in protobuf */
  allowedUserEmails?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * You can mark features that are no longer actively used as "archived".
   * In the future, this will prevent these features from showing up in the UI by default.
   */
  archived?: Maybe<Scalars['Boolean']>;
  /**
   * The names of the config keys that are related to this feature
   * Note: a config key can be associated with more than one feature at a time.
   */
  configKeyName?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of default values for config keys associated with this feature */
  defaultValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_CscFeatureDefaultValue>>>;
  /** Freeform text about this feature, for display purposes */
  description?: Maybe<Scalars['String']>;
  /** Primarily used for RPM/TPMs to contact correct feature owner for roulette or other dependencies outside csc configs. */
  dri?: Maybe<Scalars['String']>;
  /** Categories of work required to enable this feature (hardware, CSC configuration, engineering effort). */
  enablementRequirements?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_EnablementRequirement>>>;
  /** External-facing feature identifier used to map CSC to external sources */
  externalFeatureName?: Maybe<Scalars['String']>;
  /** Status of the feature in its lifecycle */
  featureStatus?: Maybe<Instacart_Caper_Admin_V1_FeatureStatus>;
  /** GA (General Availability) version. Official sign off version by QA for production deployment. */
  gaVersion?: Maybe<Scalars['String']>;
  /** database ID of the feature, which is is unique per environment. Does not need to be set for creation. */
  id?: Maybe<Scalars['BigInt']>;
  /** Locking a feature */
  isLocked?: Maybe<Scalars['Boolean']>;
  /**
   * Whether this feature is scoped to specific retailers rather than an all-retailer rollout.
   * Lifecycle (feature_status) is independent of scope — a retailer-specific feature still progresses through Beta -> GA -> Fully Rolled Out for its target retailers.
   */
  isRetailerSpecific?: Maybe<Scalars['Boolean']>;
  /** The email of the person who last modified this feature. Does not need to be set for creation. */
  lastModifiedBy?: Maybe<Scalars['String']>;
  /**
   * Email of the user who most recently submitted this feature for approval. Set only on transitions into a PENDING_* status.
   * Empty string indicates the feature has never been submitted — proto3 cannot distinguish unset from explicit empty string.
   */
  lastSubmittedBy?: Maybe<Scalars['String']>;
  /** Timestamp when last modified. Does not need to be set for creation. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** min app version same as used in config keys. Not actively used, for display purposes */
  minAppVersion?: Maybe<Scalars['String']>;
  /** Name of the feature, unique per environment */
  name?: Maybe<Scalars['String']>;
  /** Notification groups attached to this feature. On write, server resolves each entry by id when set; on read, server returns the full hydrated groups. */
  notificationGroups?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_NotificationGroup>>>;
  /** Owner of the feature used for locking a feature, must be valid email. */
  ownerEmail?: Maybe<Scalars['String']>;
  /** Contact person for roulette experiments. Valid user instacart emails. */
  rouletteExperimentContact?: Maybe<Scalars['String']>;
  /** List of roulette links associated with this feature */
  rouletteLinks?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_CscFeatureRouletteLink>>>;
  /** This should be a link to an extended guide to the feature, usually called an SOP within Caper */
  sopLink?: Maybe<Scalars['String']>;
  /** List of retailers whom are the primary target for a given Feature. */
  targetRetailers?: Maybe<Scalars['String']>;
  /** Version introduced, for display purpose */
  versionIntroduced?: Maybe<Scalars['String']>;
};

/** Feature action for scheduled changes */
export type Instacart_Caper_Admin_V1_FeatureAction = {
  __typename?: 'instacart_caper_admin_v1_FeatureAction';
  /** Maps to feature_action */
  actionType?: Maybe<Instacart_Caper_Admin_V1_FeatureActionType>;
  /**
   * Maps to csc_feature_id
   * Optional: feature name for display/logging
   */
  cscFeatureId?: Maybe<Scalars['BigInt']>;
  featureName?: Maybe<Scalars['String']>;
};

/** Feature action type for scheduled feature changes */
export enum Instacart_Caper_Admin_V1_FeatureActionType {
  FeatureActionTypeSet = 'FEATURE_ACTION_TYPE_SET',
  FeatureActionTypeUnknown = 'FEATURE_ACTION_TYPE_UNKNOWN',
  FeatureActionTypeUnset = 'FEATURE_ACTION_TYPE_UNSET'
}

/** Feature action for scheduled changes */
export type Instacart_Caper_Admin_V1_FeatureAction_Input = {
  /** Maps to feature_action */
  actionType?: InputMaybe<Instacart_Caper_Admin_V1_FeatureActionType>;
  /**
   * Maps to csc_feature_id
   * Optional: feature name for display/logging
   */
  cscFeatureId?: InputMaybe<Scalars['BigInt']>;
  featureName?: InputMaybe<Scalars['String']>;
};

/** Status of a features */
export enum Instacart_Caper_Admin_V1_FeatureStatus {
  /** Early/limited rollout prior to GA approval. */
  FeatureStatusBeta = 'FEATURE_STATUS_BETA',
  FeatureStatusDeprecated = 'FEATURE_STATUS_DEPRECATED',
  FeatureStatusFullyRolledOut = 'FEATURE_STATUS_FULLY_ROLLED_OUT',
  /** (General Availability): Marks the field as signed off by QA and fully released for production use. */
  FeatureStatusGaApproved = 'FEATURE_STATUS_GA_APPROVED',
  /** Active experiment restricted to a narrow scope of devices. */
  FeatureStatusLimitedExperiment = 'FEATURE_STATUS_LIMITED_EXPERIMENT',
  FeatureStatusOngoingExperiment = 'FEATURE_STATUS_ONGOING_EXPERIMENT',
  /** Awaiting approval to enter a limited experiment. */
  FeatureStatusPendingExperimentApproval = 'FEATURE_STATUS_PENDING_EXPERIMENT_APPROVAL',
  /** Awaiting approval to advance to GA. */
  FeatureStatusPendingGaApproval = 'FEATURE_STATUS_PENDING_GA_APPROVAL',
  FeatureStatusUnknown = 'FEATURE_STATUS_UNKNOWN'
}

/** Association between an entity and a feature (many-to-many relationship) */
export type Instacart_Caper_Admin_V1_FeatureValue = {
  __typename?: 'instacart_caper_admin_v1_FeatureValue';
  /** The email of the person who created this association */
  authorEmail?: Maybe<Scalars['String']>;
  /** Timestamp when this association was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  featureId?: Maybe<Scalars['BigInt']>;
};

/** Association between an entity and a feature (many-to-many relationship) */
export type Instacart_Caper_Admin_V1_FeatureValue_Input = {
  /** The email of the person who created this association */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Timestamp when this association was created */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  featureId?: InputMaybe<Scalars['BigInt']>;
};

/** A CSC feature, which is a product feature with various metadata, including how to turn it on */
export type Instacart_Caper_Admin_V1_Feature_Input = {
  /** Allowed user emails stored as JSON array in DB, modeled as repeated string in protobuf */
  allowedUserEmails?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * You can mark features that are no longer actively used as "archived".
   * In the future, this will prevent these features from showing up in the UI by default.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /**
   * The names of the config keys that are related to this feature
   * Note: a config key can be associated with more than one feature at a time.
   */
  configKeyName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** List of default values for config keys associated with this feature */
  defaultValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_CscFeatureDefaultValue_Input>>>;
  /** Freeform text about this feature, for display purposes */
  description?: InputMaybe<Scalars['String']>;
  /** Primarily used for RPM/TPMs to contact correct feature owner for roulette or other dependencies outside csc configs. */
  dri?: InputMaybe<Scalars['String']>;
  /** Categories of work required to enable this feature (hardware, CSC configuration, engineering effort). */
  enablementRequirements?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_EnablementRequirement>>>;
  /** External-facing feature identifier used to map CSC to external sources */
  externalFeatureName?: InputMaybe<Scalars['String']>;
  /** Status of the feature in its lifecycle */
  featureStatus?: InputMaybe<Instacart_Caper_Admin_V1_FeatureStatus>;
  /** GA (General Availability) version. Official sign off version by QA for production deployment. */
  gaVersion?: InputMaybe<Scalars['String']>;
  /** database ID of the feature, which is is unique per environment. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Locking a feature */
  isLocked?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whether this feature is scoped to specific retailers rather than an all-retailer rollout.
   * Lifecycle (feature_status) is independent of scope — a retailer-specific feature still progresses through Beta -> GA -> Fully Rolled Out for its target retailers.
   */
  isRetailerSpecific?: InputMaybe<Scalars['Boolean']>;
  /** The email of the person who last modified this feature. Does not need to be set for creation. */
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  /**
   * Email of the user who most recently submitted this feature for approval. Set only on transitions into a PENDING_* status.
   * Empty string indicates the feature has never been submitted — proto3 cannot distinguish unset from explicit empty string.
   */
  lastSubmittedBy?: InputMaybe<Scalars['String']>;
  /** Timestamp when last modified. Does not need to be set for creation. */
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** min app version same as used in config keys. Not actively used, for display purposes */
  minAppVersion?: InputMaybe<Scalars['String']>;
  /** Name of the feature, unique per environment */
  name?: InputMaybe<Scalars['String']>;
  /** Notification groups attached to this feature. On write, server resolves each entry by id when set; on read, server returns the full hydrated groups. */
  notificationGroups?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_NotificationGroup_Input>>>;
  /** Owner of the feature used for locking a feature, must be valid email. */
  ownerEmail?: InputMaybe<Scalars['String']>;
  /** Contact person for roulette experiments. Valid user instacart emails. */
  rouletteExperimentContact?: InputMaybe<Scalars['String']>;
  /** List of roulette links associated with this feature */
  rouletteLinks?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_CscFeatureRouletteLink_Input>>>;
  /** This should be a link to an extended guide to the feature, usually called an SOP within Caper */
  sopLink?: InputMaybe<Scalars['String']>;
  /** List of retailers whom are the primary target for a given Feature. */
  targetRetailers?: InputMaybe<Scalars['String']>;
  /** Version introduced, for display purpose */
  versionIntroduced?: InputMaybe<Scalars['String']>;
};

/** Filter criteria for listing NOF items */
export type Instacart_Caper_Admin_V1_Filter_Input = {
  catalog?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_CatalogAvailability>>>;
  /** which timestamp field to filter on */
  dateField?: InputMaybe<Instacart_Caper_Admin_V1_DateField>;
  /** optional: end of date range (inclusive) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** whether to apply external view filtering */
  isExternalView?: InputMaybe<Scalars['Boolean']>;
  /** default 5 */
  minOccurrences?: InputMaybe<Scalars['Int']>;
  /** OR within this list; empty means "no POS filter" */
  pos?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_PosAvailability>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** filter by review category, null or REVIEW_CATEGORY_UNKNOWN represents needs review */
  reviewCategory?: InputMaybe<Instacart_Caper_Admin_V1_ReviewCategory>;
  /** Date range filtering fields */
  startDate?: InputMaybe<Scalars['DateTime']>;
  storeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** default all */
  tab?: InputMaybe<Instacart_Caper_Admin_V1_Tab>;
  /** exact */
  upcQuery?: InputMaybe<Scalars['String']>;
};

/** All Caper entities, starting with partner, and global level configs */
export type Instacart_Caper_Admin_V1_GetAllEntitiesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetAllEntitiesResponse';
  /**
   * These are global configs that should apply to all devices that do not have
   * lower level overrides
   */
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** These are globally enabled features */
  featureValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  partners?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Partner>>>;
};

/** Response containing available payment profiles. */
export type Instacart_Caper_Admin_V1_GetAvailableProfilesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetAvailableProfilesResponse';
  /** List of available payment profiles. */
  profiles?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentProfile>>>;
};

/** Request to fetch cart event data for a session */
export type Instacart_Caper_Admin_V1_GetCartDataRequest_Input = {
  /** Optional timestamp to filter events (returns events before this time) */
  latestTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** The Caper session ID to fetch cart events for */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Response containing structured cart event data */
export type Instacart_Caper_Admin_V1_GetCartDataResponse = {
  __typename?: 'instacart_caper_admin_v1_GetCartDataResponse';
  /**
   * Structured cart event data with device info, basket events,
   * event-derived video audit events, and audit-issue video records
   */
  cartData?: Maybe<Instacart_Caper_Admin_V1_CartSessionData>;
};

/**
 * Response containing URLs for prod, staging, and diff reports.
 * Absent fields indicate that a report type is not yet available.
 */
export type Instacart_Caper_Admin_V1_GetConfigCleanupReportResponse = {
  __typename?: 'instacart_caper_admin_v1_GetConfigCleanupReportResponse';
  diff?: Maybe<Instacart_Caper_Admin_V1_ConfigCleanupReportEntry>;
  production?: Maybe<Instacart_Caper_Admin_V1_ConfigCleanupReportEntry>;
  staging?: Maybe<Instacart_Caper_Admin_V1_ConfigCleanupReportEntry>;
};

/**
 * Response containing URLs for production, staging, and diff reports.
 * Absent fields indicate that a report type is not yet available.
 */
export type Instacart_Caper_Admin_V1_GetConfigFeatureDriftReportResponse = {
  __typename?: 'instacart_caper_admin_v1_GetConfigFeatureDriftReportResponse';
  diff?: Maybe<Instacart_Caper_Admin_V1_ConfigFeatureDriftReportEntry>;
  production?: Maybe<Instacart_Caper_Admin_V1_ConfigFeatureDriftReportEntry>;
  staging?: Maybe<Instacart_Caper_Admin_V1_ConfigFeatureDriftReportEntry>;
};

/** The request for Config Keys */
export type Instacart_Caper_Admin_V1_GetConfigKeysRequest_Input = {
  /** Maximum number of config keys to return. If unset or 0, the server will use a default page size. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Token for fetching the next page of results. Leave empty to get the first page. */
  pageToken?: InputMaybe<Scalars['String']>;
  /**
   * Originally used to migrate from the json config keys to the db one. This migration is now complete
   * and the db config keys are always returned and this value is not read.
   */
  pullFromDb?: InputMaybe<Scalars['Boolean']>;
};

/** The list of available config keys that the frontend should allow to be set */
export type Instacart_Caper_Admin_V1_GetConfigKeysResponse = {
  __typename?: 'instacart_caper_admin_v1_GetConfigKeysResponse';
  configKeys?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigKey>>>;
  /** Token to retrieve the next page of results. Empty if there are no more results. */
  nextPageToken?: Maybe<Scalars['String']>;
  /** Total number of config keys matching the request (across all pages). */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** Request to retrieve an existing datadog summary by its ID */
export type Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncRequest_Input = {
  /**
   * The summary ID returned from CreateDatadogSummaryAsync
   * (found in CreateDatadogSummaryAsyncResponse.status.id)
   */
  summaryId?: InputMaybe<Scalars['String']>;
};

/**
 * Response for retrieving an existing datadog summary by its ID
 * Returns the current status and content of a previously created datadog summary
 */
export type Instacart_Caper_Admin_V1_GetDatadogSummaryByIdAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_GetDatadogSummaryByIdAsyncResponse';
  status?: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for retrieving entity information with hierarchical relationships */
export type Instacart_Caper_Admin_V1_GetEntitiesRequest_Input = {
  /** Query by retailer Instacart warehouse IDs to retrieve full partner/retailer/store hierarchy */
  instacartWarehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Query by store Instacart warehouse location IDs to retrieve full partner/retailer/store hierarchy */
  instacartWarehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Response containing entity information with hierarchical relationships */
export type Instacart_Caper_Admin_V1_GetEntitiesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetEntitiesResponse';
  partners?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PartnerInfo>>>;
};

/** Request for getting features */
export type Instacart_Caper_Admin_V1_GetFeaturesRequest_Input = {
  /** Empty = return all features. Non-empty = return only these CSC feature database IDs. */
  featureIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for getting features */
export type Instacart_Caper_Admin_V1_GetFeaturesResponse = {
  __typename?: 'instacart_caper_admin_v1_GetFeaturesResponse';
  features?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Feature>>>;
};

/** Request message for retrieving a specific NOF item */
export type Instacart_Caper_Admin_V1_GetNofRequest_Input = {
  isExternalView?: InputMaybe<Scalars['Boolean']>;
  nofId?: InputMaybe<Scalars['String']>;
};

/** Response message containing the requested NOF item */
export type Instacart_Caper_Admin_V1_GetNofResponse = {
  __typename?: 'instacart_caper_admin_v1_GetNofResponse';
  item?: Maybe<Instacart_Caper_Admin_V1_NofItem>;
};

/** Request to fetch a single pipeline run by task_id. */
export type Instacart_Caper_Admin_V1_GetPipelineRunRequest_Input = {
  /** UUID task_id of the pipeline run to fetch. */
  taskId?: InputMaybe<Scalars['String']>;
};

/** Response from GetPipelineRun. */
export type Instacart_Caper_Admin_V1_GetPipelineRunResponse = {
  __typename?: 'instacart_caper_admin_v1_GetPipelineRunResponse';
  /** The pipeline run with the full derived stages list populated. */
  run?: Maybe<Instacart_Caper_Admin_V1_PipelineRun>;
};

/** The request message to get the details of a single receipt */
export type Instacart_Caper_Admin_V1_GetReceiptDetailsRequest_Input = {
  /** the uPOS order id of the receipt to retrieve */
  uposOrderId?: InputMaybe<Scalars['String']>;
  /** the instacart warehouse location id of the store the receipt belongs to */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** The response message containing the details of a single receipt */
export type Instacart_Caper_Admin_V1_GetReceiptDetailsResponse = {
  __typename?: 'instacart_caper_admin_v1_GetReceiptDetailsResponse';
  receiptDetails?: Maybe<Instacart_Caper_Admin_V1_ReceiptDetails>;
};

/** The request message to get a paginated list of receipt summaries */
export type Instacart_Caper_Admin_V1_GetReceiptsListRequest_Input = {
  /** additional filter criteria applied to the list query */
  filter?: InputMaybe<Instacart_Caper_Admin_V1_ReceiptFilter_Input>;
  /** filter by order type; ORDER_TYPE_UNKNOWN returns receipts of every order type */
  orderType?: InputMaybe<Instacart_Caper_Admin_V1_OrderType>;
  /** 1-based page number to retrieve */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /** maximum number of receipts to return per page */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** which identifier search_value is matched against; RECEIPT_SEARCH_BY_UNKNOWN disables identifier search */
  searchBy?: InputMaybe<Instacart_Caper_Admin_V1_ReceiptSearchBy>;
  /** the value to match against the field selected by search_by */
  searchValue?: InputMaybe<Scalars['String']>;
  /** the instacart warehouse location ids of the stores to return receipts for */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The paginated response of receipt summaries */
export type Instacart_Caper_Admin_V1_GetReceiptsListResponse = {
  __typename?: 'instacart_caper_admin_v1_GetReceiptsListResponse';
  /** current page number */
  pageNumber?: Maybe<Scalars['Int']>;
  /** page size used in the response */
  pageSize?: Maybe<Scalars['Int']>;
  /** the receipt summaries matching the query for the requested page */
  receipts?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ReceiptSummary>>>;
  /** total number of matching receipts across all pages */
  totalSize?: Maybe<Scalars['Int']>;
};

/** The request message to get receipts metadata */
export type Instacart_Caper_Admin_V1_GetReceiptsMetadataRequest_Input = {
  /** last 4 digits of the ebt card number */
  ebtCardLast_4Digits?: InputMaybe<Scalars['String']>;
  /** the unique identifier for each ebt transaction that is also used as the ebt refund id, at least one of either this field or the ebt_card_last_4_digits field is required to retrieve ebt receipt metadata */
  ebtId?: InputMaybe<Scalars['String']>;
  /** the instacart warehouse location id of the store where receipt metadata is being requested, authorization is handled by the IPP graphql tier which is trusted infrastructure that will then make this rpc request */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** The response message for getting receipt metadata */
export type Instacart_Caper_Admin_V1_GetReceiptsMetadataResponse = {
  __typename?: 'instacart_caper_admin_v1_GetReceiptsMetadataResponse';
  orderSummaries?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_OrderSummary>>>;
};

/** Describes the Caper session to fetch details for */
export type Instacart_Caper_Admin_V1_GetSessionInfoRequest_Input = {
  /** The Caper session ID, typically a UUID generated by the cart */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Contains the Caper session details, including events */
export type Instacart_Caper_Admin_V1_GetSessionInfoResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionInfoResponse';
  /**
   * For MVP/fast prototyping: semi-structured details about the session
   * As the shape of this solidifies, this will be replaced by a more
   * structured contract
   */
  sessionInfo?: Maybe<Scalars['JSON']>;
};

/** Request to fetch session screenshots */
export type Instacart_Caper_Admin_V1_GetSessionScreenshotsRequest_Input = {
  /** The Caper session ID to fetch screenshots for */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Response containing session screenshot information */
export type Instacart_Caper_Admin_V1_GetSessionScreenshotsResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionScreenshotsResponse';
  /** List of screenshot information with signed URLs */
  screenshots?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScreenshotInfo>>>;
  /** Whether screenshots are available for this session */
  screenshotsAvailable?: Maybe<Scalars['Boolean']>;
  /** Reason why screenshots are unavailable (if screenshots_available is false) */
  unavailableReason?: Maybe<Scalars['String']>;
};

/** Request to retrieve an existing session summary by its ID */
export type Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncRequest_Input = {
  summaryId?: InputMaybe<Scalars['String']>;
};

/**
 * Response for retrieving an existing session summary by its ID
 * Returns the current status and content of a previously created summary
 */
export type Instacart_Caper_Admin_V1_GetSessionSummaryByIdAsyncResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionSummaryByIdAsyncResponse';
  status?: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Describes the Caper session to create a summary for */
export type Instacart_Caper_Admin_V1_GetSessionSummaryRequest_Input = {
  /** The Caper session ID, typically a UUID generated by the cart */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Contains the Caper session details, including events */
export type Instacart_Caper_Admin_V1_GetSessionSummaryResponse = {
  __typename?: 'instacart_caper_admin_v1_GetSessionSummaryResponse';
  /** A Markdown-formatted summary of the session */
  markdownSummary?: Maybe<Scalars['String']>;
};

/** A request to get payment info for a store. */
export type Instacart_Caper_Admin_V1_GetStorePaymentInfoRequest_Input = {
  /** The Caper store ID to look up. */
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the merchant and terminals for a store. */
export type Instacart_Caper_Admin_V1_GetStorePaymentInfoResponse = {
  __typename?: 'instacart_caper_admin_v1_GetStorePaymentInfoResponse';
  /** The merchant for this store, if one exists. */
  merchant?: Maybe<Instacart_Caper_Admin_V1_PaymentMerchant>;
  /** Active terminals under this merchant. */
  terminals?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>>>;
};

/** GetStoreStaffBarcodeRequest is the request to retrieve a store staff barcode by ID. */
export type Instacart_Caper_Admin_V1_GetStoreStaffBarcodeRequest_Input = {
  /** ID of the barcode to retrieve. */
  barcodeId?: InputMaybe<Scalars['BigInt']>;
  /** IPP warehouse location ID for resource authorization. */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** GetStoreStaffBarcodeResponse is the response containing a single store staff barcode. */
export type Instacart_Caper_Admin_V1_GetStoreStaffBarcodeResponse = {
  __typename?: 'instacart_caper_admin_v1_GetStoreStaffBarcodeResponse';
  storeStaffBarcode?: Maybe<Instacart_Caper_Admin_V1_StoreStaffBarcode>;
};

/**
 * Inputs for the In-Warehouse Replacement pipeline.
 * Runs the same provisioning stages as Cart Replacement. PipelineRun.new_device_name
 * is not populated and no post-provisioning backend record updates are made.
 */
export type Instacart_Caper_Admin_V1_InWarehouseReplacementConfig_Input = {
  /** CSC name of the device being replaced (e.g. "P_WAKEFERN_15_M3_001"). */
  cscDeviceName?: InputMaybe<Scalars['String']>;
  /** Warehouse IPv4 address of the device (e.g. "192.168.1.100"). */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** OTA bundle version to deploy. Backend uses the default version if omitted. */
  packageVersion?: InputMaybe<Scalars['String']>;
  /**
   * Physical product ID of the cart (printed on the cart; referred to as
   * productId in IoT Platform).
   */
  productId?: InputMaybe<Scalars['String']>;
  /** Store identifier (e.g. "prod-wakefern-25"). */
  storeId?: InputMaybe<Scalars['String']>;
};

/** InstacartWarehouseLocationIds contains Instacart warehouse location IDs. */
export type Instacart_Caper_Admin_V1_InstacartWarehouseLocationIds_Input = {
  /** Instacart warehouse location IDs. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * ListAccountsPartnerFilter identifies the required partner using exactly one
 * supported identifier.
 */
export type Instacart_Caper_Admin_V1_ListAccountsPartnerFilter_Input = {
  /** Partner name used by Caper. */
  caperPartnerName?: InputMaybe<Scalars['String']>;
  /**
   * Stable Instacart partner identifier. This currently returns UNIMPLEMENTED
   * until the identifier is available on the Caper partner record.
   */
  instacartPartnerId?: InputMaybe<Scalars['String']>;
};

/**
 * ListAccountsRequest selects one Auth0-backed page of accounts.
 *
 * app_type and partner are required. The service resolves partner to one
 * exact, case-sensitive Auth0 tenant and always filters the configured Auth0
 * connection. Different filter dimensions are combined with AND. Repeated
 * retailer and store filters are combined with OR within their dimensions.
 *
 * Auth0 search is eventually consistent and exposes at most the first 1,000
 * candidate accounts for a query. The service may apply hierarchy filters and
 * pagination locally within those candidates. Concurrent Auth0 changes can
 * cause duplicates or omissions across pages.
 *
 * Application-specific cases:
 * - VIDEO_INSPECTOR requires caper_partner_name = "caper", rejects retailer and
 * store filters, and returns every listed account with global store, retailer,
 * and partner access regardless of legacy Auth0 allowed_stores metadata.
 * - CART_MANAGER resolves the requested partner, retailer, and store hierarchy
 * against the Caper catalog and returns effective access from Auth0 metadata.
 */
export type Instacart_Caper_Admin_V1_ListAccountsRequest_Input = {
  /** Required application type, mapped to the exact Auth0 job_position value. */
  appType?: InputMaybe<Instacart_Caper_Admin_V1_AppType>;
  /**
   * Optional trimmed, case-insensitive name or email. A complete email
   * may be matched exactly. When present, this must contain at least 3
   * characters; unrestricted substring search is not supported.
   */
  nameOrEmailQuery?: InputMaybe<Scalars['String']>;
  /**
   * Zero-based result page number. Zero requests the first page. The request
   * is rejected when page_number is negative or its offset reaches Auth0's
   * 1,000-candidate search limit.
   */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /**
   * Requested page size. Zero uses the service default of 15; values greater
   * than 50 are rejected because Auth0 Public Cloud returns at most 50 users
   * per page.
   */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Required partner identifier. It is resolved to one literal Auth0 tenant. */
  partner?: InputMaybe<Instacart_Caper_Admin_V1_ListAccountsPartnerFilter_Input>;
  /**
   * Optional hierarchy restriction. An empty list permits any store access
   * under the selected partner.
   */
  retailers?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ListAccountsRetailerFilter_Input>>>;
  /**
   * Optional status ordering. When status is UNSPECIFIED, the service groups
   * active or blocked accounts first before applying pagination. When status
   * already selects one group, status ordering has no effect.
   */
  sort?: InputMaybe<Instacart_Caper_Admin_V1_AccountListSort_Input>;
  /**
   * Optional account-status filter. UNSPECIFIED returns both active and
   * blocked accounts. ACTIVE includes users whose Auth0 blocked field is
   * absent or false; BLOCKED includes only users with blocked set to true.
   */
  status?: InputMaybe<Instacart_Caper_Admin_V1_AccountStatus>;
};

/** ListAccountsResponse returns one Auth0-owned account page. */
export type Instacart_Caper_Admin_V1_ListAccountsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListAccountsResponse';
  /**
   * Accounts after applying all requested filters and status ordering. Without
   * status ordering, the service preserves Auth0 result order.
   */
  accounts?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ListedAccount>>>;
  /** Zero-based page number returned by the service. */
  pageNumber?: Maybe<Scalars['Int']>;
  /** Effective page size used for this query. */
  pageSize?: Maybe<Scalars['Int']>;
  /**
   * True when the candidate search reaches 1,000 and additional matching
   * accounts may exist outside the searchable result window.
   */
  resultLimitReached?: Maybe<Scalars['Boolean']>;
  /** Matching accounts found within Auth0's 1,000-candidate search limit. */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/**
 * ListAccountsRetailerFilter identifies one retailer and an optional set of
 * stores beneath it. Repeated retailer filters are combined with OR.
 */
export type Instacart_Caper_Admin_V1_ListAccountsRetailerFilter_Input = {
  /** Retailer name used by Caper. */
  caperRetailerName?: InputMaybe<Scalars['String']>;
  /** Instacart warehouse identifier for the retailer. */
  instacartWarehouseId?: InputMaybe<Scalars['String']>;
  /**
   * Optional store restriction. An empty list matches accounts with effective
   * access to any store under this retailer. Repeated stores use OR.
   */
  stores?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ListAccountsStoreFilter_Input>>>;
};

/**
 * ListAccountsStoreFilter identifies one store using exactly one supported
 * identifier.
 */
export type Instacart_Caper_Admin_V1_ListAccountsStoreFilter_Input = {
  /** Caper store identifier stored as store.legacy_ngcp_store_id. */
  caperStoreId?: InputMaybe<Scalars['String']>;
  /** Instacart warehouse location identifier for the store. */
  instacartWarehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** Request message for listing ban entries */
export type Instacart_Caper_Admin_V1_ListBanEntriesRequest_Input = {
  /** Optional filter criteria */
  filter?: InputMaybe<Instacart_Caper_Admin_V1_BanEntryFilter_Input>;
  /** Pagination: maximum number of entries to return (default: 100) */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Pagination: token for fetching next page */
  pageToken?: InputMaybe<Scalars['String']>;
};

/** Response message for listing ban entries */
export type Instacart_Caper_Admin_V1_ListBanEntriesResponse = {
  __typename?: 'instacart_caper_admin_v1_ListBanEntriesResponse';
  /** List of ban entries with their scopes */
  entries?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryWithScopes>>>;
  /** Token for fetching next page (empty if no more results) */
  nextPageToken?: Maybe<Scalars['String']>;
  /** Total count of entries matching the filter */
  totalCount?: Maybe<Scalars['Int']>;
};

/** Request for listing barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_ListBarcodePluMappingsRequest_Input = {
  /** Zero-based offset. Must not be negative. */
  offset?: InputMaybe<Scalars['Int']>;
  /** Defaults to 500 when zero. Maximum 500. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Unset = list all scopes (.any). Mutations still require a scope. */
  scope?: InputMaybe<Instacart_Caper_Admin_V1_MappingScope_Input>;
};

/** Response for listing barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_ListBarcodePluMappingsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListBarcodePluMappingsResponse';
  mappings?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMapping>>>;
  /** Omitted when there are no more results. */
  nextOffset?: Maybe<Scalars['Int']>;
};

/** Request to list batch scheduled actions with filtering */
export type Instacart_Caper_Admin_V1_ListBatchScheduledActionsRequest_Input = {
  actionTypes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionType>>>;
  /** Author filter */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Entity filter - can filter by any entity involved in batch actions */
  entityFilter?: InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionTarget_Input>;
  /** Time range filter */
  scheduledAfter?: InputMaybe<Scalars['DateTime']>;
  scheduledBefore?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>>>;
};

/** Response containing list of batch scheduled actions */
export type Instacart_Caper_Admin_V1_ListBatchScheduledActionsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListBatchScheduledActionsResponse';
  actions?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BatchScheduledAction>>>;
};

/** Request message for listing NOF items with filtering and pagination */
export type Instacart_Caper_Admin_V1_ListNofsRequest_Input = {
  filter?: InputMaybe<Instacart_Caper_Admin_V1_Filter_Input>;
  /**
   * Sorting order for NOF items. Options:
   * - FREQUENCY_DESC, FREQUENCY_ASC
   * - RECENCY_DESC, RECENCY_ASC
   * - LATEST_REVIEW_DATE_DESC, LATEST_REVIEW_DATE_ASC
   */
  orderBy?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};

/** Response message containing paginated NOF items */
export type Instacart_Caper_Admin_V1_ListNofsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListNofsResponse';
  items?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_NofItem>>>;
  nextPageToken?: Maybe<Scalars['String']>;
  /** total across current filter scope */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** Request for listing notification groups. */
export type Instacart_Caper_Admin_V1_ListNotificationGroupsRequest_Input = {
  /** When false (default), archived groups are excluded from the response. */
  includeArchived?: InputMaybe<Scalars['Boolean']>;
};

/** Response for listing notification groups. */
export type Instacart_Caper_Admin_V1_ListNotificationGroupsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListNotificationGroupsResponse';
  groups?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_NotificationGroup>>>;
};

/**
 * Request to list pipeline runs with optional filters and cursor-based pagination.
 * Omitting a filter field disables that filter (returns all values).
 */
export type Instacart_Caper_Admin_V1_ListPipelineRunsRequest_Input = {
  /**
   * Filter by device name (exact match against old_device_name or new_device_name).
   * Empty string disables this filter.
   */
  deviceName?: InputMaybe<Scalars['String']>;
  /** Maximum number of runs to return. Defaults to 20; maximum 100. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /**
   * Opaque pagination cursor from a previous ListPipelineRunsResponse.
   * Empty string or omitted fetches the first page.
   */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Filter by pipeline type. Set to PIPELINE_TYPE_UNKNOWN to return all types. */
  pipelineType?: InputMaybe<Instacart_Caper_Admin_V1_PipelineType>;
  /** Filter by run status. Set to PIPELINE_RUN_STATUS_UNKNOWN to return all statuses. */
  status?: InputMaybe<Instacart_Caper_Admin_V1_PipelineRunStatus>;
};

/** Response from ListPipelineRuns. */
export type Instacart_Caper_Admin_V1_ListPipelineRunsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListPipelineRunsResponse';
  /** Opaque cursor for the next page. Empty when there are no more results. */
  nextPageToken?: Maybe<Scalars['String']>;
  /**
   * Matching pipeline runs sorted by created_at descending.
   * stages is empty on each run; use GetPipelineRun to retrieve stages.
   */
  runs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PipelineRun>>>;
};

/** Request to list scheduled actions with filtering */
export type Instacart_Caper_Admin_V1_ListScheduledActionsRequest_Input = {
  actionTypes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionType>>>;
  /** Author filter */
  createdBy?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['BigInt']>;
  globalOnly?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Time range filter */
  scheduledAfter?: InputMaybe<Scalars['DateTime']>;
  scheduledBefore?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>>>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing list of scheduled actions */
export type Instacart_Caper_Admin_V1_ListScheduledActionsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListScheduledActionsResponse';
  actions?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScheduledAction>>>;
};

/** ListStoreStaffBarcodesRequest is the request to list store staff barcodes with filtering and pagination. */
export type Instacart_Caper_Admin_V1_ListStoreStaffBarcodesRequest_Input = {
  /** Filter criteria for the list query. */
  filter?: InputMaybe<Instacart_Caper_Admin_V1_StoreStaffFilter_Input>;
  /** Field name to order results by (e.g., "first_name", "created_at"). */
  orderBy?: InputMaybe<Scalars['String']>;
  /** 1-based page number to retrieve. */
  pageNumber?: InputMaybe<Scalars['Int']>;
  /** Maximum number of results per page. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Sort direction (ascending or descending). */
  sortOrder?: InputMaybe<Instacart_Caper_Admin_V1_SortOrder>;
};

/** ListStoreStaffBarcodesResponse is the paginated response of store staff barcodes. */
export type Instacart_Caper_Admin_V1_ListStoreStaffBarcodesResponse = {
  __typename?: 'instacart_caper_admin_v1_ListStoreStaffBarcodesResponse';
  /** Current page number. */
  pageNumber?: Maybe<Scalars['Int']>;
  /** Page size used in the response. */
  pageSize?: Maybe<Scalars['Int']>;
  /** List of store staff barcodes matching the query. */
  storeStaffBarcodes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_StoreStaffBarcode>>>;
  /** Total number of matching records across all pages. */
  totalSize?: Maybe<Scalars['Int']>;
};

/**
 * ListStoresByWarehouseLocationsRequest is the request to resolve IPP warehouse
 * location IDs to their corresponding Caper stores.
 */
export type Instacart_Caper_Admin_V1_ListStoresByWarehouseLocationsRequest_Input = {
  /**
   * Optional filter by the Caper store's active deployment state. A plain bool
   * cannot express "return both active and inactive" since unset is
   * indistinguishable from false, so a tri-state wrapper is used: unset
   * returns stores of every state, true returns only active stores, and false
   * returns only inactive stores.
   */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** IPP warehouse location IDs to resolve Caper stores for. */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * ListStoresByWarehouseLocationsResponse is the response containing the Caper
 * stores that matched the requested warehouse locations. The number of returned
 * stores may be fewer than the requested IDs: a warehouse location with no
 * matching Caper store (or none in the requested active state) is simply omitted.
 */
export type Instacart_Caper_Admin_V1_ListStoresByWarehouseLocationsResponse = {
  __typename?: 'instacart_caper_admin_v1_ListStoresByWarehouseLocationsResponse';
  /** Caper stores matching the requested warehouse locations. */
  stores?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_WarehouseLocationStore>>>;
};

/**
 * ListedAccount combines the existing account summary with resolved hierarchy
 * context.
 *
 * VIDEO_INSPECTOR accounts and CART_MANAGER accounts with literal Auth0
 * allowed_stores = ["*"] use global access at the store, retailer, and partner
 * levels. Scoped CART_MANAGER accounts return concrete stores plus the distinct
 * retailers that own at least one of those stores. Unmatched legacy expressions
 * are ignored; when nothing resolves, hierarchy access fields may be unset.
 */
export type Instacart_Caper_Admin_V1_ListedAccount = {
  __typename?: 'instacart_caper_admin_v1_ListedAccount';
  /**
   * Auth0 account and effective access summary. updated_at is the actual Auth0
   * profile timestamp for this RPC, not response construction time.
   */
  account?: Maybe<Instacart_Caper_Admin_V1_AccountSummary>;
  /**
   * Partner scope derived from effective store access. Global accounts set
   * global_access; scoped accounts set the single requested partner when at
   * least one concrete store resolves.
   */
  partnerAccess?: Maybe<Instacart_Caper_Admin_V1_AccountPartnerAccess>;
  /**
   * Retailer scope derived from effective store access. Global accounts set
   * global_access; scoped accounts list each distinct retailer owning at least
   * one resolved concrete store.
   */
  retailerAccess?: Maybe<Instacart_Caper_Admin_V1_AccountRetailerAccess>;
};

/** Action to perform when locking/unlocking carts */
export enum Instacart_Caper_Admin_V1_LockAction {
  LockActionLock = 'LOCK_ACTION_LOCK',
  LockActionUnknown = 'LOCK_ACTION_UNKNOWN',
  LockActionUnlock = 'LOCK_ACTION_UNLOCK'
}

/** Request for locking/unlocking devices */
export type Instacart_Caper_Admin_V1_LockCartsRequest_Input = {
  /** The main action to perform */
  action?: InputMaybe<Instacart_Caper_Admin_V1_LockAction>;
  /** Single device */
  deviceId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Justification required to unlock a lock that requires an override reason.
   * Accepted only for UNLOCK actions on locks in that tier; ignored otherwise.
   */
  overrideReason?: InputMaybe<Scalars['String']>;
  /** All devices under a partner */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Freeform description of the lock reason, e.g. incident link or additional context */
  reasonDescription?: InputMaybe<Scalars['String']>;
  /**
   * Classifiable reason type to customer and store staff.
   * Required for LOCK actions; defaults to OTHER if omitted.
   */
  reasonType?: InputMaybe<Instacart_Caper_Admin_V1_CartLockReasonType>;
  /** The email of the person performing the action */
  requesterEmail?: InputMaybe<Scalars['String']>;
  /** All devices under a retailer */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** All devices in a store */
  storeId?: InputMaybe<Scalars['BigInt']>;
  /** Store-level by Instacart WHLID UPOS request */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** Returned on success; errors returned via gRPC status codes. */
export type Instacart_Caper_Admin_V1_LockCartsResponse = {
  __typename?: 'instacart_caper_admin_v1_LockCartsResponse';
  /**
   * For UNLOCK actions: the evaluation outcome per affected device. A single
   * request may resolve to several devices with mixed allow, override, or
   * block outcomes, so each is reported separately. Empty for LOCK actions.
   */
  unlockEvaluations?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_DeviceUnlockEvaluation>>>;
};

/**
 * Priority tier from the cart-lock reason taxonomy. A higher tier cannot be
 * masked or unlocked by a lower-tier action.
 */
export enum Instacart_Caper_Admin_V1_LockPriority {
  /** Compliance (Weights and Measures); never unlockable via the guardrail */
  LockPriorityP0 = 'LOCK_PRIORITY_P0',
  /** Manual lock; unlock requires an override reason */
  LockPriorityP1 = 'LOCK_PRIORITY_P1',
  /** Engineering or operational; freely unlockable */
  LockPriorityP2 = 'LOCK_PRIORITY_P2',
  /** Priority not classified */
  LockPriorityUnknown = 'LOCK_PRIORITY_UNKNOWN'
}

/** Error details returned when an operation fails due to a locked feature */
export type Instacart_Caper_Admin_V1_LockedFeatureError = {
  __typename?: 'instacart_caper_admin_v1_LockedFeatureError';
  /** Database ID of the locked feature */
  featureId?: Maybe<Scalars['BigInt']>;
  /** The name of the locked feature */
  featureName?: Maybe<Scalars['String']>;
  /** Error message, e.g., "Feature is locked. Contact owner@email.com for access." */
  message?: Maybe<Scalars['String']>;
};

/** Identifies the scope at which a mapping applies. */
export type Instacart_Caper_Admin_V1_MappingScope = {
  __typename?: 'instacart_caper_admin_v1_MappingScope';
  /** Must be true when selected. */
  global?: Maybe<Scalars['Boolean']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  storeId?: Maybe<Scalars['BigInt']>;
};

/** Identifies the scope at which a mapping applies. */
export type Instacart_Caper_Admin_V1_MappingScope_Input = {
  /** Must be true when selected. */
  global?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** A NOF (Not on File) item with all details */
export type Instacart_Caper_Admin_V1_NofItem = {
  __typename?: 'instacart_caper_admin_v1_NofItem';
  /**
   * For MVP/fast prototyping: semi-structured details about NOF Item
   * As the shape of this solidifies, this will be replaced by a more
   * structured contract
   */
  info?: Maybe<Scalars['JSON']>;
};

/** A named recipient bucket (e.g., pillar, hardware-QA, sub-team) used for feature notifications. M:N to Feature. */
export type Instacart_Caper_Admin_V1_NotificationGroup = {
  __typename?: 'instacart_caper_admin_v1_NotificationGroup';
  /** Whether this group is archived (soft delete). */
  archived?: Maybe<Scalars['Boolean']>;
  /** Freeform description. */
  description?: Maybe<Scalars['String']>;
  /** Database ID of the notification group. Does not need to be set for creation. */
  id?: Maybe<Scalars['BigInt']>;
  /** The email of the person who last modified this group. Does not need to be set for creation. */
  lastModifiedBy?: Maybe<Scalars['String']>;
  /** Timestamp when last modified. Does not need to be set for creation. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** Members of the notification group. */
  members?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_NotificationGroupMember>>>;
  /** Unique name of the notification group. */
  name?: Maybe<Scalars['String']>;
};

/** A single member of a notification group. */
export type Instacart_Caper_Admin_V1_NotificationGroupMember = {
  __typename?: 'instacart_caper_admin_v1_NotificationGroupMember';
  /** Member email. Must be a valid Instacart company email (format: firstname.lastname@instacart.com). */
  email?: Maybe<Scalars['String']>;
  /** Optional free-form role label (e.g., "PM", "Eng", "QA"). */
  role?: Maybe<Scalars['String']>;
};

/** A single member of a notification group. */
export type Instacart_Caper_Admin_V1_NotificationGroupMember_Input = {
  /** Member email. Must be a valid Instacart company email (format: firstname.lastname@instacart.com). */
  email?: InputMaybe<Scalars['String']>;
  /** Optional free-form role label (e.g., "PM", "Eng", "QA"). */
  role?: InputMaybe<Scalars['String']>;
};

/** A named recipient bucket (e.g., pillar, hardware-QA, sub-team) used for feature notifications. M:N to Feature. */
export type Instacart_Caper_Admin_V1_NotificationGroup_Input = {
  /** Whether this group is archived (soft delete). */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Freeform description. */
  description?: InputMaybe<Scalars['String']>;
  /** Database ID of the notification group. Does not need to be set for creation. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The email of the person who last modified this group. Does not need to be set for creation. */
  lastModifiedBy?: InputMaybe<Scalars['String']>;
  /** Timestamp when last modified. Does not need to be set for creation. */
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Members of the notification group. */
  members?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_NotificationGroupMember_Input>>>;
  /** Unique name of the notification group. */
  name?: InputMaybe<Scalars['String']>;
};

/** The identifying information for a receipt */
export type Instacart_Caper_Admin_V1_OrderSummary = {
  __typename?: 'instacart_caper_admin_v1_OrderSummary';
  /** last 4 digits of the ebt card number */
  ebtCardLast_4Digits?: Maybe<Scalars['String']>;
  /** the unique identifier for each ebt transaction that is also used as the ebt refund id */
  ebtId?: Maybe<Scalars['String']>;
  /** the payment amount */
  paymentAmount?: Maybe<GoogleTypeMoney>;
  /** the time when the order was finalized */
  paymentTimestamp?: Maybe<Scalars['DateTime']>;
};

/** The type of an order associated with a receipt */
export enum Instacart_Caper_Admin_V1_OrderType {
  /** paid with ebt */
  OrderTypeEbt = 'ORDER_TYPE_EBT',
  /** paid using more than one tender type */
  OrderTypeSplitTender = 'ORDER_TYPE_SPLIT_TENDER',
  /** standard (non-ebt) order */
  OrderTypeStandard = 'ORDER_TYPE_STANDARD',
  /** transfer order */
  OrderTypeTransfer = 'ORDER_TYPE_TRANSFER',
  /** order type is not known */
  OrderTypeUnknown = 'ORDER_TYPE_UNKNOWN'
}

/**
 * A Caper partner, the highest level of the Caper hierarchy.
 * Example is Wakefern, Kroger, Schnucks
 */
export type Instacart_Caper_Admin_V1_Partner = {
  __typename?: 'instacart_caper_admin_v1_Partner';
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts. Set by support team during store setup.
   */
  esperBlueprintId?: Maybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId?: Maybe<Scalars['String']>;
  /** Features associated with this partner */
  featureValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  /** Attributes of a partner, separate from configs */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Instacart partner ID that maps this Caper partner to its corresponding IPP partner.
   * CSC requires this field when creating a partner. An empty value on update preserves the
   * existing mapping.
   */
  instacartPartnerId?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  retailers?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Retailer>>>;
};

/**
 * Partner information with nested retailers and stores
 * Maintains the full hierarchy: Partner -> Retailers -> Stores
 */
export type Instacart_Caper_Admin_V1_PartnerInfo = {
  __typename?: 'instacart_caper_admin_v1_PartnerInfo';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  retailers?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_RetailerInfo>>>;
};

/**
 * PartnerRetailerPermissionScope grants all or selected stores under one
 * retailer in a selected partner.
 */
export type Instacart_Caper_Admin_V1_PartnerRetailerPermissionScope_Input = {
  /** Grants access to every non-deleted store under the retailer. */
  allStores?: InputMaybe<Scalars['instacart_caper_admin_v1_AllRetailerStores_Input']>;
  /** Instacart warehouse identifier for the retailer. */
  instacartWarehouseId?: InputMaybe<Scalars['String']>;
  /** Retailer name used by Caper. */
  retailerCaperName?: InputMaybe<Scalars['String']>;
  /** Grants access to an explicit list of stores. */
  selectedStores?: InputMaybe<Instacart_Caper_Admin_V1_SelectedPartnerRetailerStores_Input>;
};

/**
 * A Caper partner, the highest level of the Caper hierarchy.
 * Example is Wakefern, Kroger, Schnucks
 */
export type Instacart_Caper_Admin_V1_Partner_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts. Set by support team during store setup.
   */
  esperBlueprintId?: InputMaybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId?: InputMaybe<Scalars['String']>;
  /** Features associated with this partner */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Attributes of a partner, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Instacart partner ID that maps this Caper partner to its corresponding IPP partner.
   * CSC requires this field when creating a partner. An empty value on update preserves the
   * existing mapping.
   */
  instacartPartnerId?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailers?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_Retailer_Input>>>;
};

/**
 * Store-level payment merchant entity.
 * One merchant per store, representing the store's payment processing identity.
 */
export type Instacart_Caper_Admin_V1_PaymentMerchant = {
  __typename?: 'instacart_caper_admin_v1_PaymentMerchant';
  /** Email of the CSC user who created/modified this merchant. */
  author?: Maybe<Scalars['String']>;
  /** Timestamp when the merchant was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** "Doing Business As" name. */
  dbaName?: Maybe<Scalars['String']>;
  /** Merchant database ID. */
  id?: Maybe<Scalars['BigInt']>;
  /** Merchant Identification Number (MID). */
  merchantId?: Maybe<Scalars['String']>;
  /** Worldline's internal organization ID for this merchant. */
  organizationId?: Maybe<Scalars['BigInt']>;
  /** The profile ID used when creating this merchant. */
  profileId?: Maybe<Scalars['BigInt']>;
  /** Current lifecycle status of the merchant. */
  status?: Maybe<Instacart_Caper_Admin_V1_PaymentMerchantStatus>;
  /** The Caper store ID this merchant belongs to. */
  storeId?: Maybe<Scalars['BigInt']>;
  /** Timestamp when the merchant was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Lifecycle status of a payment merchant.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_PaymentMerchantStatus {
  /** Merchant is operational and can process payments. */
  PaymentMerchantStatusActive = 'PAYMENT_MERCHANT_STATUS_ACTIVE',
  /** Merchant has been deactivated. */
  PaymentMerchantStatusInactive = 'PAYMENT_MERCHANT_STATUS_INACTIVE',
  /** Merchant is temporarily suspended. */
  PaymentMerchantStatusSuspended = 'PAYMENT_MERCHANT_STATUS_SUSPENDED',
  /** buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX */
  PaymentMerchantStatusUnspecified = 'PAYMENT_MERCHANT_STATUS_UNSPECIFIED'
}

/**
 * Payment processor type for a terminal.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_PaymentProcessorType {
  /**
   * First Data Corporation RapidConnect processor.
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  FdcRapidConnect = 'FDC_RAPID_CONNECT',
  /** buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX */
  PaymentProcessorTypeUnspecified = 'PAYMENT_PROCESSOR_TYPE_UNSPECIFIED',
  /**
   * Vantiv processor.
   * buf:lint:ignore ENUM_VALUE_PREFIX
   */
  Vantiv = 'VANTIV'
}

/**
 * Worldline profile configuration template.
 * Profiles are pre-configured with processor-specific settings
 * and serve as parent templates when onboarding new merchants.
 */
export type Instacart_Caper_Admin_V1_PaymentProfile = {
  __typename?: 'instacart_caper_admin_v1_PaymentProfile';
  /** Bank identifier. Required by some processors. */
  bankId?: Maybe<Scalars['String']>;
  /** Transaction capture type configuration. */
  captureType?: Maybe<Scalars['String']>;
  /** Timestamp when the profile was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Optional description of this profile's purpose. */
  description?: Maybe<Scalars['String']>;
  /** Group identifier. Required for FDC RapidConnect processor. */
  groupId?: Maybe<Scalars['String']>;
  /** Profile database ID. */
  id?: Maybe<Scalars['BigInt']>;
  /** Industry type classification. */
  industryType?: Maybe<Scalars['String']>;
  /** Whether this profile is available for use. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Merchant Category Code - industry classification. */
  mccCode?: Maybe<Scalars['String']>;
  /** Payment processor name, e.g., "Fiserv", "Vantiv". */
  processor?: Maybe<Scalars['String']>;
  /** Human-readable name for this profile. */
  profileName?: Maybe<Scalars['String']>;
  /** Support contact email. */
  supportEmail?: Maybe<Scalars['String']>;
  /** Support contact first name. */
  supportFirstName?: Maybe<Scalars['String']>;
  /** Support contact last name. */
  supportLastName?: Maybe<Scalars['String']>;
  /** Timestamp when the profile was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Display name of the organization in Worldline's system. */
  worldlineOrgName?: Maybe<Scalars['String']>;
  /** Worldline's internal organization ID. */
  worldlineOrganizationId?: Maybe<Scalars['BigInt']>;
};

/**
 * Device-level payment terminal entity.
 * One terminal per device, representing a physical payment device.
 */
export type Instacart_Caper_Admin_V1_PaymentTerminal = {
  __typename?: 'instacart_caper_admin_v1_PaymentTerminal';
  /** Email of the CSC user who created/modified this terminal. */
  author?: Maybe<Scalars['String']>;
  /** Timestamp when the terminal was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The Caper device ID this terminal is assigned to. */
  deviceId?: Maybe<Scalars['BigInt']>;
  /** Terminal database ID. */
  id?: Maybe<Scalars['BigInt']>;
  /** The merchant ID this terminal belongs to. */
  merchantId?: Maybe<Scalars['BigInt']>;
  /** Hardware model name of the device. */
  modelType?: Maybe<Scalars['String']>;
  /** The payment processor type for this terminal. */
  processorType?: Maybe<Instacart_Caper_Admin_V1_PaymentProcessorType>;
  /** Hardware serial number of the device. */
  serialNumber?: Maybe<Scalars['String']>;
  /** Current lifecycle status of the terminal. */
  status?: Maybe<Instacart_Caper_Admin_V1_PaymentTerminalStatus>;
  /** Terminal Identification Number (TID). */
  terminalId?: Maybe<Scalars['String']>;
  /** Timestamp when the terminal was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Lifecycle status of a payment terminal.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Caper_Admin_V1_PaymentTerminalStatus {
  /** Terminal is operational and can process payments. */
  PaymentTerminalStatusActive = 'PAYMENT_TERMINAL_STATUS_ACTIVE',
  /** Terminal has been deactivated. */
  PaymentTerminalStatusInactive = 'PAYMENT_TERMINAL_STATUS_INACTIVE',
  /** Terminal credentials have been transferred to a different device. */
  PaymentTerminalStatusTransferred = 'PAYMENT_TERMINAL_STATUS_TRANSFERRED',
  /** buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX */
  PaymentTerminalStatusUnspecified = 'PAYMENT_TERMINAL_STATUS_UNSPECIFIED'
}

/**
 * Audit trail for payment terminal credential transfers.
 * Immutable - records are only inserted, never updated or deleted.
 */
export type Instacart_Caper_Admin_V1_PaymentTerminalTransfer = {
  __typename?: 'instacart_caper_admin_v1_PaymentTerminalTransfer';
  /** The source device ID (the old/replaced cart). */
  fromDeviceId?: Maybe<Scalars['BigInt']>;
  /** Transfer record database ID. */
  id?: Maybe<Scalars['BigInt']>;
  /** Human-readable reason for the transfer. */
  reason?: Maybe<Scalars['String']>;
  /** The terminal ID that was transferred. */
  terminalId?: Maybe<Scalars['BigInt']>;
  /** The target device ID (the new/replacement cart). */
  toDeviceId?: Maybe<Scalars['BigInt']>;
  /** Timestamp when the transfer was executed. */
  transferredAt?: Maybe<Scalars['DateTime']>;
  /** Email of the CSC user who initiated the transfer. */
  transferredBy?: Maybe<Scalars['String']>;
};

/** Target environment for a pipeline run. */
export enum Instacart_Caper_Admin_V1_PipelineEnvironment {
  PipelineEnvironmentProd = 'PIPELINE_ENVIRONMENT_PROD',
  PipelineEnvironmentStage = 'PIPELINE_ENVIRONMENT_STAGE',
  PipelineEnvironmentUnknown = 'PIPELINE_ENVIRONMENT_UNKNOWN'
}

/**
 * A warehouse pipeline run record.
 *
 * Stage sequences by pipeline type:
 * Cart Replacement (11 stages):
 * device_liveness_check → setup_esper → setup_zerotier →
 * start_horae_agent → link_iot_devices → register_bottom_tray →
 * deregister_front_unit → pre_ota_check → deploy_ota →
 * post_ota_check → cleanup_old_device
 * In-Warehouse Replacement (11 stages, same as Cart Replacement):
 * device_liveness_check → setup_esper → setup_zerotier →
 * start_horae_agent → link_iot_devices → register_bottom_tray →
 * deregister_front_unit → pre_ota_check → deploy_ota →
 * post_ota_check → cleanup_old_device
 * TU Swap (9 stages):
 * device_liveness_check → setup_esper → setup_zerotier →
 * start_horae → register_iot → link_csc →
 * pre_ota_check → post_ota_check → cleanup_old_device
 */
export type Instacart_Caper_Admin_V1_PipelineRun = {
  __typename?: 'instacart_caper_admin_v1_PipelineRun';
  /** Physical charger location in the warehouse (e.g. "Charger 1", "Misc"). Empty if not set. */
  charger?: Maybe<Scalars['String']>;
  /**
   * Timestamp when the run reached a terminal status (SUCCESS or FAILED).
   * Not set while the run is still active.
   */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Timestamp when the run record was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Snake-case name of the currently executing stage (e.g. "setup_esper"). */
  currentStage?: Maybe<Scalars['String']>;
  /** Target environment for this run. */
  env?: Maybe<Instacart_Caper_Admin_V1_PipelineEnvironment>;
  /** Error message set when status is PIPELINE_RUN_STATUS_FAILED. */
  errorMessage?: Maybe<Scalars['String']>;
  /** CSC name of the newly provisioned device. */
  newDeviceName?: Maybe<Scalars['String']>;
  /** Free-form note entered by the triggering user at trigger time. Empty if not set. */
  note?: Maybe<Scalars['String']>;
  /** CSC name of the device being replaced/worked on. Populated for all pipeline types. */
  oldDeviceName?: Maybe<Scalars['String']>;
  /** Type of provisioning pipeline. */
  pipelineType?: Maybe<Instacart_Caper_Admin_V1_PipelineType>;
  /** 1-based index of the currently executing stage. */
  stageIndex?: Maybe<Scalars['Int']>;
  /**
   * Derived ordered stage list for this pipeline type with per-stage statuses.
   * Populated by GetPipelineRun. Empty in TriggerPipeline and ListPipelineRuns
   * responses to keep list payloads compact.
   */
  stages?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_PipelineStage>>>;
  /** Overall run status. */
  status?: Maybe<Instacart_Caper_Admin_V1_PipelineRunStatus>;
  /**
   * Store identifier (e.g. "prod-wakefern-25").
   * Populated for all pipeline types.
   */
  storeId?: Maybe<Scalars['String']>;
  /**
   * UUID primary key generated at trigger time.
   * Used as the sole correlation identifier across all status updates for this run.
   */
  taskId?: Maybe<Scalars['String']>;
  /**
   * Total number of stages for this pipeline type.
   * 11 for Cart Replacement and In-Warehouse Replacement; 9 for TU Swap.
   */
  totalStages?: Maybe<Scalars['Int']>;
  /** Email of the IPP user who triggered the run. */
  triggeredBy?: Maybe<Scalars['String']>;
  /** Timestamp when the run record was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Lifecycle status of a pipeline run or individual stage. */
export enum Instacart_Caper_Admin_V1_PipelineRunStatus {
  /** Pipeline failed at one or more stages. */
  PipelineRunStatusFailed = 'PIPELINE_RUN_STATUS_FAILED',
  /** At least one stage has started. */
  PipelineRunStatusInProgress = 'PIPELINE_RUN_STATUS_IN_PROGRESS',
  /** Run created; Jenkins trigger in flight. */
  PipelineRunStatusPending = 'PIPELINE_RUN_STATUS_PENDING',
  /**
   * Stage-only: the stage was skipped (e.g. no active payment terminal to transfer).
   * Never set as a run-level status; runs resolve to SUCCESS or FAILED only.
   */
  PipelineRunStatusSkipped = 'PIPELINE_RUN_STATUS_SKIPPED',
  /** All stages completed successfully. */
  PipelineRunStatusSuccess = 'PIPELINE_RUN_STATUS_SUCCESS',
  PipelineRunStatusUnknown = 'PIPELINE_RUN_STATUS_UNKNOWN'
}

/**
 * A single stage within a pipeline run.
 *
 * The stages list on PipelineRun is derived server-side from stage_index,
 * the hardcoded ordered stage list for the pipeline type, and stage_history
 * — it is not stored directly. Derivation rule:
 * - index < stage_index  → PIPELINE_RUN_STATUS_SUCCESS
 * - index == stage_index → current run status
 * - index > stage_index  → PIPELINE_RUN_STATUS_UNKNOWN (not yet started)
 * started_at and completed_at are populated from the stage history.
 */
export type Instacart_Caper_Admin_V1_PipelineStage = {
  __typename?: 'instacart_caper_admin_v1_PipelineStage';
  /** Timestamp when this stage reached SUCCESS or FAILED. Not set if not yet complete. */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** 1-based position of this stage in the full ordered stage list. */
  index?: Maybe<Scalars['Int']>;
  /** Human-readable label for display (e.g. "Setup Esper"). */
  label?: Maybe<Scalars['String']>;
  /** Snake-case name as published by Jenkins (e.g. "setup_esper"). */
  name?: Maybe<Scalars['String']>;
  /** Timestamp when this stage entered IN_PROGRESS. Not set if not yet started. */
  startedAt?: Maybe<Scalars['DateTime']>;
  /** Status of this stage. */
  status?: Maybe<Instacart_Caper_Admin_V1_PipelineRunStatus>;
};

/** Type of warehouse provisioning pipeline. */
export enum Instacart_Caper_Admin_V1_PipelineType {
  /** Full cart replacement: same stages as E2E provision plus cleanup_old_device. */
  PipelineTypeCartReplacement = 'PIPELINE_TYPE_CART_REPLACEMENT',
  /**
   * In-warehouse replacement: runs the same provisioning stages as Cart Replacement;
   * PipelineRun.new_device_name is not populated and no post-provisioning backend record updates are made.
   */
  PipelineTypeInWarehouseReplacement = 'PIPELINE_TYPE_IN_WAREHOUSE_REPLACEMENT',
  /** Top Unit swap: replaces the Top Unit of a single existing cart. */
  PipelineTypeTuSwap = 'PIPELINE_TYPE_TU_SWAP',
  PipelineTypeUnknown = 'PIPELINE_TYPE_UNKNOWN'
}

export enum Instacart_Caper_Admin_V1_PosAvailability {
  PosAvailabilityExtInRetailerPos = 'POS_AVAILABILITY_EXT_IN_RETAILER_POS',
  PosAvailabilityExtNotInRetailerPos = 'POS_AVAILABILITY_EXT_NOT_IN_RETAILER_POS',
  PosAvailabilityInRetailerPos = 'POS_AVAILABILITY_IN_RETAILER_POS',
  PosAvailabilityNotInRetailerPos = 'POS_AVAILABILITY_NOT_IN_RETAILER_POS',
  PosAvailabilityUnknown = 'POS_AVAILABILITY_UNKNOWN'
}

/** PreferredStoreIdentifier identifies an optional default store context. */
export type Instacart_Caper_Admin_V1_PreferredStoreIdentifier_Input = {
  /** Store ID used by Caper. */
  preferredStoreId?: InputMaybe<Scalars['String']>;
  /** Instacart warehouse location ID. */
  preferredWarehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** Price information for basket items */
export type Instacart_Caper_Admin_V1_PriceData = {
  __typename?: 'instacart_caper_admin_v1_PriceData';
  /** Currency code (e.g., "USD") */
  currencyCode?: Maybe<Scalars['String']>;
  /** Price amount in currency units */
  units?: Maybe<Scalars['String']>;
};

/** A single item in a receipt's basket */
export type Instacart_Caper_Admin_V1_ReceiptBasketItem = {
  __typename?: 'instacart_caper_admin_v1_ReceiptBasketItem';
  /** adjustments applied to the item total */
  adjustments?: Maybe<GoogleTypeMoney>;
  /** the display name of the item */
  itemName?: Maybe<Scalars['String']>;
  /** the quantity of the item purchased */
  qty?: Maybe<Scalars['Int']>;
  /** url of the item's thumbnail image */
  thumbnailUrl?: Maybe<Scalars['String']>;
  total?: Maybe<GoogleTypeMoney>;
  /** the cost of a single unit of the item */
  unitCost?: Maybe<GoogleTypeMoney>;
  /**
   * The unit of measure that unit_cost is priced in. When set to
   * UNIT_OF_MEASURE_POUND / _KILOGRAM (or any non-each unit), unit_cost is the
   * per-unit-of-measure price (e.g. $/lb) and `weight` carries the measured
   * amount; clients should render "<weight> <unit> × <unit_cost> = <total>"
   * rather than "<qty> × <unit_cost>". Unset or UNIT_OF_MEASURE_EACH means
   * the line is priced by discrete count and qty × unit_cost = total.
   */
  unitOfMeasure?: Maybe<Instacart_Caper_Admin_V1_UnitOfMeasure>;
  /** the item's universal product code */
  upc?: Maybe<Scalars['String']>;
  /**
   * The measured amount for weight-priced lines, in the unit given by
   * unit_of_measure. Zero / unset for count-priced lines. Encoded as an
   * integer number of thousandths of the unit (milli-units) to avoid
   * floating-point rounding: 2.16 lb -> 2160, 1.175 kg -> 1175. Divide by
   * 1000 to render.
   */
  weightMilliUnits?: Maybe<Scalars['BigInt']>;
};

/** The full details of a single receipt */
export type Instacart_Caper_Admin_V1_ReceiptDetails = {
  __typename?: 'instacart_caper_admin_v1_ReceiptDetails';
  /** the items in the receipt's basket */
  basketItems?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ReceiptBasketItem>>>;
  /** the id of the card used for payment */
  cardId?: Maybe<Scalars['String']>;
  /** the number of issues reviewed for the order */
  issuesReviewed?: Maybe<Scalars['Int']>;
  /** payment information for the receipt */
  paymentInfo?: Maybe<Instacart_Caper_Admin_V1_ReceiptPaymentInfo>;
  /** the summary view of the receipt */
  receiptSummary?: Maybe<Instacart_Caper_Admin_V1_ReceiptSummary>;
  /** the time when shopping was started */
  shopStartedTimestamp?: Maybe<Scalars['DateTime']>;
  /** the caper store id the receipt belongs to */
  storeId?: Maybe<Scalars['String']>;
  /** the tender type used for payment */
  tenderType?: Maybe<Scalars['String']>;
};

/** Additional filter criteria for a receipt list query */
export type Instacart_Caper_Admin_V1_ReceiptFilter_Input = {
  /** inclusive upper bound on the receipt checkout-started time */
  endTimestamp?: InputMaybe<Scalars['DateTime']>;
  /** inclusive lower bound on the receipt checkout-started time */
  startTimestamp?: InputMaybe<Scalars['DateTime']>;
};

/** Payment information for a receipt */
export type Instacart_Caper_Admin_V1_ReceiptPaymentInfo = {
  __typename?: 'instacart_caper_admin_v1_ReceiptPaymentInfo';
  /** last 4 digits of the card used for payment */
  cardLast_4Digits?: Maybe<Scalars['String']>;
  /** the type of cart used */
  cartType?: Maybe<Scalars['String']>;
  /** the total amount purchased */
  purchaseTotal?: Maybe<GoogleTypeMoney>;
  /** the total amount saved */
  savings?: Maybe<GoogleTypeMoney>;
};

/** The identifier a receipt list search matches search_value against */
export enum Instacart_Caper_Admin_V1_ReceiptSearchBy {
  /** match against the cart id */
  ReceiptSearchByCartId = 'RECEIPT_SEARCH_BY_CART_ID',
  /** match against the ebt transaction id */
  ReceiptSearchByEbtId = 'RECEIPT_SEARCH_BY_EBT_ID',
  /** match against the retailer point-of-sale id */
  ReceiptSearchByRetailerPosId = 'RECEIPT_SEARCH_BY_RETAILER_POS_ID',
  /** match against the checkout session id */
  ReceiptSearchBySessionId = 'RECEIPT_SEARCH_BY_SESSION_ID',
  /** no identifier search; return all receipts matching the other criteria */
  ReceiptSearchByUnknown = 'RECEIPT_SEARCH_BY_UNKNOWN',
  /** match against the uPOS order id */
  ReceiptSearchByUposOrderId = 'RECEIPT_SEARCH_BY_UPOS_ORDER_ID'
}

/** A summary view of a single receipt */
export type Instacart_Caper_Admin_V1_ReceiptSummary = {
  __typename?: 'instacart_caper_admin_v1_ReceiptSummary';
  /** last 4 digits of the card used for payment */
  cardLast_4Digits?: Maybe<Scalars['String']>;
  /** the time when checkout was started */
  checkoutStartedTimestamp?: Maybe<Scalars['DateTime']>;
  /** the ebt transaction id, if the order was paid with ebt */
  ebtId?: Maybe<Scalars['String']>;
  /** the type of the order */
  orderType?: Maybe<Instacart_Caper_Admin_V1_OrderType>;
  /** the total amount purchased */
  purchaseTotal?: Maybe<GoogleTypeMoney>;
  /** the retailer point-of-sale id */
  retailerPosId?: Maybe<Scalars['String']>;
  /** the checkout session id */
  sessionId?: Maybe<Scalars['String']>;
  /** the caper store id the receipt belongs to */
  storeId?: Maybe<Scalars['String']>;
  /** the uPOS order id */
  uposOrderId?: Maybe<Scalars['String']>;
  /** the instacart warehouse location id of the store the receipt belongs to */
  warehouseLocationId?: Maybe<Scalars['String']>;
};

/** Request message for removing scopes from a ban entry */
export type Instacart_Caper_Admin_V1_RemoveBanEntryScopesRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  /** The ban entry ID to remove scopes from */
  banEntryId?: InputMaybe<Scalars['String']>;
  /**
   * Scopes to remove from this ban entry
   * Only removes the specified scopes - other scopes remain unchanged
   */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for removing scopes from a ban entry */
export type Instacart_Caper_Admin_V1_RemoveBanEntryScopesResponse = {
  __typename?: 'instacart_caper_admin_v1_RemoveBanEntryScopesResponse';
  /** The updated list of all remaining scopes for this ban entry after removal */
  scopes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** A Caper retailer, such as Shoprite, Kroger, QFC. Same thing as a Banner */
export type Instacart_Caper_Admin_V1_Retailer = {
  __typename?: 'instacart_caper_admin_v1_Retailer';
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Features associated with this retailer */
  featureValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  /** Attributes of a retailer, separate from configs */
  id?: Maybe<Scalars['BigInt']>;
  instacartStoreConfigurationId?: Maybe<Scalars['String']>;
  instacartWarehouseId?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  programmaticName?: Maybe<Scalars['String']>;
  stores?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Store>>>;
};

/** Retailer information with nested stores */
export type Instacart_Caper_Admin_V1_RetailerInfo = {
  __typename?: 'instacart_caper_admin_v1_RetailerInfo';
  id?: Maybe<Scalars['String']>;
  instacartWarehouseId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  stores?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_StoreInfo>>>;
};

/**
 * RetailerPermissionScope grants either all stores or selected stores under one
 * retailer in the legacy permission model.
 */
export type Instacart_Caper_Admin_V1_RetailerPermissionScope_Input = {
  /** Grants access to every non-deleted store under the retailer. */
  allStores?: InputMaybe<Scalars['instacart_caper_admin_v1_AllRetailerStores_Input']>;
  /** Warehouse identifier for the retailer. */
  instacartWarehouseId?: InputMaybe<Scalars['String']>;
  /** Grants access to an explicit list of warehouse locations. */
  selectedStores?: InputMaybe<Instacart_Caper_Admin_V1_SelectedRetailerStores_Input>;
};

/** A Caper retailer, such as Shoprite, Kroger, QFC. Same thing as a Banner */
export type Instacart_Caper_Admin_V1_Retailer_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /** Features associated with this retailer */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Attributes of a retailer, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  instacartStoreConfigurationId?: InputMaybe<Scalars['String']>;
  instacartWarehouseId?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  programmaticName?: InputMaybe<Scalars['String']>;
  stores?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_Store_Input>>>;
};

/** Category for reviewing and resolving NOF items */
export enum Instacart_Caper_Admin_V1_ReviewCategory {
  /** Represents External Escalation: REVIEW_CATEGORY_ESCALATION_EXTERNAL */
  ReviewCategoryExternal = 'REVIEW_CATEGORY_EXTERNAL',
  ReviewCategoryExtNeedsAttentionFromInstacart = 'REVIEW_CATEGORY_EXT_NEEDS_ATTENTION_FROM_INSTACART',
  ReviewCategoryExtNeedsMoreData = 'REVIEW_CATEGORY_EXT_NEEDS_MORE_DATA',
  ReviewCategoryExtResolved = 'REVIEW_CATEGORY_EXT_RESOLVED',
  ReviewCategoryFalsePositive = 'REVIEW_CATEGORY_FALSE_POSITIVE',
  ReviewCategoryFixed = 'REVIEW_CATEGORY_FIXED',
  /** Represents Internal Escalation: REVIEW_CATEGORY_ESCALATION_INTERNAL */
  ReviewCategoryInternal = 'REVIEW_CATEGORY_INTERNAL',
  ReviewCategoryNeedsMoreData = 'REVIEW_CATEGORY_NEEDS_MORE_DATA',
  ReviewCategoryResolved = 'REVIEW_CATEGORY_RESOLVED',
  ReviewCategoryUnknown = 'REVIEW_CATEGORY_UNKNOWN'
}

/** Request message for reviewing a NOF item */
export type Instacart_Caper_Admin_V1_ReviewNofRequest_Input = {
  author?: InputMaybe<Scalars['String']>;
  nofId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  reviewCategory?: InputMaybe<Instacart_Caper_Admin_V1_ReviewCategory>;
  reviewSubCategory?: InputMaybe<Scalars['String']>;
};

/** Status of a roulette link */
export enum Instacart_Caper_Admin_V1_RouletteLinkStatus {
  /** The roulette link is completely deployed either enabled by min app verison or list of affected partners */
  RouletteLinkStatusFullyRolledOut = 'ROULETTE_LINK_STATUS_FULLY_ROLLED_OUT',
  /** The roulette link is active but may still be in an experimental phase. */
  RouletteLinkStatusInUse = 'ROULETTE_LINK_STATUS_IN_USE',
  RouletteLinkStatusNotUsed = 'ROULETTE_LINK_STATUS_NOT_USED',
  RouletteLinkStatusUnknown = 'ROULETTE_LINK_STATUS_UNKNOWN'
}

/** Weekly & date-specific schedule for store/cart operating hours */
export type Instacart_Caper_Admin_V1_Schedule = {
  __typename?: 'instacart_caper_admin_v1_Schedule';
  /** Special dates: ISO dates ("2025-12-26") to time ranges for overrides */
  special?: Maybe<Scalars['JSON']>;
  /** Weekly schedule: explicit day-to-ranges mapping */
  weekly?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_WeeklySchedule>>>;
};

/** Request to schedule a config or feature change */
export type Instacart_Caper_Admin_V1_ScheduleActionRequest_Input = {
  configAction?: InputMaybe<Instacart_Caper_Admin_V1_ConfigAction_Input>;
  /** Maps to created_by */
  createdBy?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['BigInt']>;
  featureAction?: InputMaybe<Instacart_Caper_Admin_V1_FeatureAction_Input>;
  global?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for scheduling an action */
export type Instacart_Caper_Admin_V1_ScheduleActionResponse = {
  __typename?: 'instacart_caper_admin_v1_ScheduleActionResponse';
  scheduleId?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

/** Request to schedule multiple config/feature changes in batch */
export type Instacart_Caper_Admin_V1_ScheduleBatchActionsRequest_Input = {
  /** Multiple actions to schedule (all will share same schedule_id and workflow_id) */
  actions?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionBatchItem_Input>>>;
  /** Maps to created_by */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
};

/** Response for batch scheduling actions */
export type Instacart_Caper_Admin_V1_ScheduleBatchActionsResponse = {
  __typename?: 'instacart_caper_admin_v1_ScheduleBatchActionsResponse';
  /** Individual results for each action with status and error details */
  actionResults?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ScheduledActionBatchItem>>>;
  failedActions?: Maybe<Scalars['Int']>;
  /** Same for all actions in the batch */
  scheduleId?: Maybe<Scalars['String']>;
  /** Number of actions successfully scheduled */
  successfulActions?: Maybe<Scalars['Int']>;
  /** Total number of actions attempted */
  totalActions?: Maybe<Scalars['Int']>;
  /** Same for all actions in the batch */
  workflowId?: Maybe<Scalars['String']>;
};

/** Weekly & date-specific schedule for store/cart operating hours */
export type Instacart_Caper_Admin_V1_Schedule_Input = {
  /** Special dates: ISO dates ("2025-12-26") to time ranges for overrides */
  special?: InputMaybe<Scalars['JSON']>;
  /** Weekly schedule: explicit day-to-ranges mapping */
  weekly?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_WeeklySchedule_Input>>>;
};

/** A scheduled action with all its details */
export type Instacart_Caper_Admin_V1_ScheduledAction = {
  __typename?: 'instacart_caper_admin_v1_ScheduledAction';
  /** Cancellation details */
  cancellationReason?: Maybe<Scalars['String']>;
  /** cancelled_at */
  cancelledAt?: Maybe<Scalars['DateTime']>;
  /** cancelled_by */
  cancelledBy?: Maybe<Scalars['String']>;
  configAction?: Maybe<Instacart_Caper_Admin_V1_ConfigAction>;
  /** created_at */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** created_by */
  createdBy?: Maybe<Scalars['String']>;
  /** Execution details */
  errorMessage?: Maybe<Scalars['String']>;
  executionEndTime?: Maybe<Scalars['DateTime']>;
  /** execution_start_time */
  executionStartTime?: Maybe<Scalars['DateTime']>;
  featureAction?: Maybe<Instacart_Caper_Admin_V1_FeatureAction>;
  scheduleId?: Maybe<Scalars['String']>;
  /** scheduled_time */
  scheduledTime?: Maybe<Scalars['DateTime']>;
  /** status */
  status?: Maybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** Target entity */
  target?: Maybe<Instacart_Caper_Admin_V1_ScheduledActionTarget>;
  /** updated_at */
  updatedAt?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

/** Unified action item for batch scheduling (used in both requests and responses) */
export type Instacart_Caper_Admin_V1_ScheduledActionBatchItem = {
  __typename?: 'instacart_caper_admin_v1_ScheduledActionBatchItem';
  configAction?: Maybe<Instacart_Caper_Admin_V1_ConfigAction>;
  errorMessage?: Maybe<Scalars['String']>;
  featureAction?: Maybe<Instacart_Caper_Admin_V1_FeatureAction>;
  /** Optional fields (only populated in responses, ignored in requests) */
  status?: Maybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** Target entity for this action */
  target?: Maybe<Instacart_Caper_Admin_V1_ScheduledActionTarget>;
};

/** Unified action item for batch scheduling (used in both requests and responses) */
export type Instacart_Caper_Admin_V1_ScheduledActionBatchItem_Input = {
  configAction?: InputMaybe<Instacart_Caper_Admin_V1_ConfigAction_Input>;
  errorMessage?: InputMaybe<Scalars['String']>;
  featureAction?: InputMaybe<Instacart_Caper_Admin_V1_FeatureAction_Input>;
  /** Optional fields (only populated in responses, ignored in requests) */
  status?: InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionStatus>;
  /** Target entity for this action */
  target?: InputMaybe<Instacart_Caper_Admin_V1_ScheduledActionTarget_Input>;
};

/** Status of a scheduled action */
export enum Instacart_Caper_Admin_V1_ScheduledActionStatus {
  ScheduledActionStatusCancelled = 'SCHEDULED_ACTION_STATUS_CANCELLED',
  ScheduledActionStatusCompleted = 'SCHEDULED_ACTION_STATUS_COMPLETED',
  ScheduledActionStatusFailed = 'SCHEDULED_ACTION_STATUS_FAILED',
  ScheduledActionStatusPending = 'SCHEDULED_ACTION_STATUS_PENDING',
  ScheduledActionStatusRunning = 'SCHEDULED_ACTION_STATUS_RUNNING',
  ScheduledActionStatusUnknown = 'SCHEDULED_ACTION_STATUS_UNKNOWN'
}

/** Target entity information for a scheduled action */
export type Instacart_Caper_Admin_V1_ScheduledActionTarget = {
  __typename?: 'instacart_caper_admin_v1_ScheduledActionTarget';
  /** target_entity_id (-1 for global) */
  entityId?: Maybe<Scalars['BigInt']>;
  /** target_entity_type */
  type?: Maybe<Instacart_Caper_Admin_V1_EntityType>;
};

/** Target entity information for a scheduled action */
export type Instacart_Caper_Admin_V1_ScheduledActionTarget_Input = {
  /** target_entity_id (-1 for global) */
  entityId?: InputMaybe<Scalars['BigInt']>;
  /** target_entity_type */
  type?: InputMaybe<Instacart_Caper_Admin_V1_EntityType>;
};

/** Type of scheduled action */
export enum Instacart_Caper_Admin_V1_ScheduledActionType {
  ScheduledActionTypeConfig = 'SCHEDULED_ACTION_TYPE_CONFIG',
  ScheduledActionTypeFeature = 'SCHEDULED_ACTION_TYPE_FEATURE',
  ScheduledActionTypeUnknown = 'SCHEDULED_ACTION_TYPE_UNKNOWN'
}

/** Information about a single session screenshot */
export type Instacart_Caper_Admin_V1_ScreenshotInfo = {
  __typename?: 'instacart_caper_admin_v1_ScreenshotInfo';
  /** Original filename of the screenshot */
  filename?: Maybe<Scalars['String']>;
  /** GCS signed URL for accessing the screenshot */
  signedUrl?: Maybe<Scalars['String']>;
  /** Unix milliseconds timestamp for sorting screenshots chronologically */
  timestampMs?: Maybe<Scalars['BigInt']>;
};

/** SelectedAccountRetailers contains the accessible retailers. */
export type Instacart_Caper_Admin_V1_SelectedAccountRetailers = {
  __typename?: 'instacart_caper_admin_v1_SelectedAccountRetailers';
  /** De-duplicated retailers owning at least one resolved accessible store. */
  retailers?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_AccountRetailerSummary>>>;
};

/**
 * SelectedPartnerAccess grants either partner-wide access or retailer-scoped
 * access beneath one partner.
 */
export type Instacart_Caper_Admin_V1_SelectedPartnerAccess_Input = {
  /** Stable Instacart partner identifier stored on the Caper partner record. */
  instacartPartnerId?: InputMaybe<Scalars['String']>;
  /** Partner name used by Caper. */
  partnerCaperName?: InputMaybe<Scalars['String']>;
  /** Deprecated: use instacart_partner_id. */
  partnerIppName?: InputMaybe<Scalars['String']>;
  /** Grants access to every current and future store under this partner. */
  partnerLevelGlobal?: InputMaybe<Scalars['instacart_caper_admin_v1_PartnerLevelGlobal_Input']>;
  /** Grants access to selected retailers and stores under this partner. */
  selectedRetailers?: InputMaybe<Instacart_Caper_Admin_V1_SelectedPartnerRetailerAccess_Input>;
};

/**
 * SelectedPartnerRetailerAccess contains one or more retailer permission
 * scopes beneath a selected partner.
 */
export type Instacart_Caper_Admin_V1_SelectedPartnerRetailerAccess_Input = {
  /** Retailers and the store access granted under each retailer. */
  retailers?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_PartnerRetailerPermissionScope_Input>>>;
};

/**
 * SelectedPartnerRetailerStores lists stores using exactly one identifier
 * type.
 */
export type Instacart_Caper_Admin_V1_SelectedPartnerRetailerStores_Input = {
  /** Instacart warehouse location IDs under the retailer. */
  instacartWarehouseLocationIds?: InputMaybe<Instacart_Caper_Admin_V1_InstacartWarehouseLocationIds_Input>;
  /** Store IDs used by Caper under the retailer. */
  storeCaperIds?: InputMaybe<Instacart_Caper_Admin_V1_StoreCaperIds_Input>;
};

/** SelectedRetailerAccess contains the legacy retailer-scoped permission model. */
export type Instacart_Caper_Admin_V1_SelectedRetailerAccess_Input = {
  /** Retailers and the store access granted under each retailer. */
  retailers?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_RetailerPermissionScope_Input>>>;
};

/**
 * SelectedRetailerStores lists warehouse locations in the legacy permission
 * model.
 */
export type Instacart_Caper_Admin_V1_SelectedRetailerStores_Input = {
  /** Warehouse location IDs under the retailer. */
  instacartWarehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The request message to send a receipt */
export type Instacart_Caper_Admin_V1_SendReceiptRequest_Input = {
  /** the unique identifier for each ebt transaction that is also used as the ebt refund id; set this to send an ebt-only refund receipt. Ignored when upos_order_id is also set (upos_order_id takes priority). Exactly one of ebt_id or upos_order_id must be set. */
  ebtId?: InputMaybe<Scalars['String']>;
  /** the email of the user to whom the receipt will be sent */
  email?: InputMaybe<Scalars['String']>;
  /** the uPOS order id of the receipt to send; set this to send a full-order receipt for any order type (standard, ebt, transfer). Takes priority over ebt_id when both are set. Exactly one of ebt_id or upos_order_id must be set. */
  uposOrderId?: InputMaybe<Scalars['String']>;
  /** the instacart warehouse location id of the store the receipt belongs to; the identifier passed in (ebt_id or upos_order_id) is expected to be associated with this warehouse_location_id */
  warehouseLocationId?: InputMaybe<Scalars['String']>;
};

/** Response containing session/datadog summary data and processing status */
export type Instacart_Caper_Admin_V1_SessionSummaryCreationStatus = {
  __typename?: 'instacart_caper_admin_v1_SessionSummaryCreationStatus';
  /** Error details if summary generation failed */
  errorMessage?: Maybe<Scalars['String']>;
  /** User feedback text about the summary quality */
  feedback?: Maybe<Scalars['String']>;
  /** Unique identifier for this summary record */
  id?: Maybe<Scalars['String']>;
  /** Generated markdown summary (only present when status is COMPLETED) */
  markdownSummary?: Maybe<Scalars['String']>;
  /** User rating for the summary (1-5 scale) */
  rating?: Maybe<Scalars['Int']>;
  /** The original session ID this summary was created for */
  sessionId?: Maybe<Scalars['String']>;
  /** Current processing status of the summary generation */
  status?: Maybe<Instacart_Caper_Admin_V1_SummaryStatus>;
};

/** Request message for setting archived status of a ban entry */
export type Instacart_Caper_Admin_V1_SetBanEntryArchivedRequest_Input = {
  /** Whether the entry should be archived (true) or active (false) */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** The ban entry ID to update */
  banEntryId?: InputMaybe<Scalars['String']>;
};

/** Request message for setting complete scope list for a ban entry (full replacement) */
export type Instacart_Caper_Admin_V1_SetBanEntryScopesRequest_Input = {
  /** Author/user who is making this change (for audit tracking) */
  author?: InputMaybe<Scalars['String']>;
  /** The ban entry ID to set scopes for */
  banEntryId?: InputMaybe<Scalars['String']>;
  /**
   * Scopes that should be the complete set for this ban entry
   * Replaces all existing scopes with this list
   */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo_Input>>>;
};

/** Response message for setting scopes for a ban entry */
export type Instacart_Caper_Admin_V1_SetBanEntryScopesResponse = {
  __typename?: 'instacart_caper_admin_v1_SetBanEntryScopesResponse';
  /** The updated list of all scopes for this ban entry */
  scopes?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BanEntryScopeInfo>>>;
};

/** SortOrder specifies the direction of sorting. */
export enum Instacart_Caper_Admin_V1_SortOrder {
  SortOrderAsc = 'SORT_ORDER_ASC',
  SortOrderDesc = 'SORT_ORDER_DESC',
  SortOrderUnknown = 'SORT_ORDER_UNKNOWN'
}

/** A Caper store, a specific physical location of a store under a retailer */
export type Instacart_Caper_Admin_V1_Store = {
  __typename?: 'instacart_caper_admin_v1_Store';
  /** Smart cart availability hours (may differ from store hours) */
  cartHours?: Maybe<Instacart_Caper_Admin_V1_Schedule>;
  city?: Maybe<Scalars['String']>;
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  country?: Maybe<Scalars['String']>;
  /** ISO 4217 currency code for the store (e.g. "USD", "GBP"). Defaults to "USD" when unset. */
  currencyCode?: Maybe<Scalars['String']>;
  /** For record soft deletion if the field is set */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Deprecated: Retained for wire compatibility. New clients must not use this field. */
  demoStore?: Maybe<Scalars['Boolean']>;
  deploymentState?: Maybe<Instacart_Caper_Admin_V1_Store_StoreDeploymentState>;
  devices?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_Device>>>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts for this specific store. Set by support team during store setup.
   */
  esperBlueprintId?: Maybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId?: Maybe<Scalars['String']>;
  externalStoreId?: Maybe<Scalars['String']>;
  /** Features associated with this store */
  featureValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
  flippStoreName?: Maybe<Scalars['String']>;
  /** Attributes of a store, separate from configs */
  id?: Maybe<Scalars['BigInt']>;
  instacartWarehouseLocationId?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: Maybe<Scalars['String']>;
  /** This is the legacy_ngcp_store_id from the database */
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  pricingOverrideInstacartWarehouseLocationId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  /** Store operating hours (when front door is open to customers) */
  storeOpenHours?: Maybe<Instacart_Caper_Admin_V1_Schedule>;
  street?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  /**
   * ZeroTier Network ID for store-specific cart networking used for cart maintenance only.
   * Each store has its own virtual network that carts join, allowing teams to connect remotely for
   * debugging and maintenance purposes. Set by support team during store setup.
   */
  zerotierNetworkId?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

/** StoreCaperIds contains store IDs used by Caper. */
export type Instacart_Caper_Admin_V1_StoreCaperIds_Input = {
  /** Store IDs used by Caper. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Store information */
export type Instacart_Caper_Admin_V1_StoreInfo = {
  __typename?: 'instacart_caper_admin_v1_StoreInfo';
  id?: Maybe<Scalars['String']>;
  instacartWarehouseLocationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** StoreStaffBarcode represents a store staff member's barcode and associated metadata. */
export type Instacart_Caper_Admin_V1_StoreStaffBarcode = {
  __typename?: 'instacart_caper_admin_v1_StoreStaffBarcode';
  /** The barcode string (e.g., scanned at the device). */
  barcode?: Maybe<Scalars['String']>;
  /**
   * Symbology of the stored barcode value. Always set to an explicit type
   * on returned records; STORE_STAFF_BARCODE_TYPE_UNKNOWN is never emitted.
   */
  barcodeType?: Maybe<Instacart_Caper_Admin_V1_StoreStaffBarcodeType>;
  /** First name of the store staff member. */
  firstName?: Maybe<Scalars['String']>;
  /** Unique identifier for this barcode record. */
  id?: Maybe<Scalars['BigInt']>;
  /** Whether the barcode is currently active. */
  isActive?: Maybe<Scalars['Boolean']>;
  /** Last name of the store staff member. */
  lastName?: Maybe<Scalars['String']>;
  /** Permissions granted to the staff member. */
  permissions?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_StoreStaffPermission>>>;
  /** Role of the staff member. */
  role?: Maybe<Instacart_Caper_Admin_V1_StoreStaffRole>;
  /** Username for the staff member. */
  username?: Maybe<Scalars['String']>;
  /** IPP warehouse location ID associated with this barcode. */
  warehouseLocationId?: Maybe<Scalars['String']>;
};

/**
 * StoreStaffBarcodeType is the symbology used to encode a barcode value.
 * STORE_STAFF_BARCODE_TYPE_UNKNOWN is the proto3 default and carries
 * per-field semantics: stored records on StoreStaffBarcode always resolve
 * to an explicit type, while requests and filters may leave it unset (see
 * per-field comments for the specific contract).
 */
export enum Instacart_Caper_Admin_V1_StoreStaffBarcodeType {
  StoreStaffBarcodeTypeCode_128 = 'STORE_STAFF_BARCODE_TYPE_CODE_128',
  StoreStaffBarcodeTypeEan_8 = 'STORE_STAFF_BARCODE_TYPE_EAN_8',
  StoreStaffBarcodeTypeEan_13 = 'STORE_STAFF_BARCODE_TYPE_EAN_13',
  StoreStaffBarcodeTypeUnknown = 'STORE_STAFF_BARCODE_TYPE_UNKNOWN',
  StoreStaffBarcodeTypeUpcA = 'STORE_STAFF_BARCODE_TYPE_UPC_A'
}

/** StoreStaffFilter defines filtering criteria for listing store staff barcodes. */
export type Instacart_Caper_Admin_V1_StoreStaffFilter_Input = {
  /** Substring match against the barcode string (e.g., "123" matches "ABC123DEF"). */
  barcodeSubstring?: InputMaybe<Scalars['String']>;
  /**
   * Optional filter by barcode symbology. If unset or
   * STORE_STAFF_BARCODE_TYPE_UNKNOWN, the filter is disabled and barcodes
   * of every type are returned. Filtering by a specific type
   * (e.g. STORE_STAFF_BARCODE_TYPE_CODE_128) returns only records whose
   * stored type equals that value; stored records always carry an
   * explicit type, so no legacy UNKNOWN fallthrough applies.
   */
  barcodeType?: InputMaybe<Instacart_Caper_Admin_V1_StoreStaffBarcodeType>;
  /**
   * Roles to exclude from results. Barcodes matching any of these roles are omitted.
   * Mutually exclusive with the role field — only one of role or exclude_roles should be set.
   */
  excludeRoles?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_StoreStaffRole>>>;
  /**
   * Deprecated: use is_active_filter instead. A plain bool cannot express
   * "return both active and inactive" since unset is indistinguishable from false.
   */
  isActive?: InputMaybe<Scalars['Boolean']>;
  /** Filter by active/inactive status. If unset, both active and inactive barcodes are returned. */
  isActiveFilter?: InputMaybe<Scalars['Boolean']>;
  /** Case-insensitive substring match against first or last name (e.g., "john" matches "Johnson"). */
  nameSubstring?: InputMaybe<Scalars['String']>;
  /** Filter by granted permissions. */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_StoreStaffPermission>>>;
  /** Filter by staff role. */
  role?: InputMaybe<Instacart_Caper_Admin_V1_StoreStaffRole>;
  /** IPP warehouse location IDs to filter by. */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** StoreStaffPermission represents a permission that can be granted to store staff. */
export enum Instacart_Caper_Admin_V1_StoreStaffPermission {
  StoreStaffPermissionForceResolve = 'STORE_STAFF_PERMISSION_FORCE_RESOLVE',
  StoreStaffPermissionUnknown = 'STORE_STAFF_PERMISSION_UNKNOWN'
}

/** StoreStaffRole represents the role of a store staff member. */
export enum Instacart_Caper_Admin_V1_StoreStaffRole {
  StoreStaffRoleAssociate = 'STORE_STAFF_ROLE_ASSOCIATE',
  StoreStaffRoleBrandAmbassador = 'STORE_STAFF_ROLE_BRAND_AMBASSADOR',
  StoreStaffRoleFieldSalesRep = 'STORE_STAFF_ROLE_FIELD_SALES_REP',
  StoreStaffRoleManager = 'STORE_STAFF_ROLE_MANAGER',
  StoreStaffRoleUnknown = 'STORE_STAFF_ROLE_UNKNOWN'
}

/** A Caper store, a specific physical location of a store under a retailer */
export type Instacart_Caper_Admin_V1_Store_Input = {
  /** Smart cart availability hours (may differ from store hours) */
  cartHours?: InputMaybe<Instacart_Caper_Admin_V1_Schedule_Input>;
  city?: InputMaybe<Scalars['String']>;
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigValue_Input>>>;
  country?: InputMaybe<Scalars['String']>;
  /** ISO 4217 currency code for the store (e.g. "USD", "GBP"). Defaults to "USD" when unset. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** For record soft deletion if the field is set */
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated: Retained for wire compatibility. New clients must not use this field. */
  demoStore?: InputMaybe<Scalars['Boolean']>;
  deploymentState?: InputMaybe<Instacart_Caper_Admin_V1_Store_StoreDeploymentState>;
  devices?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_Device_Input>>>;
  /**
   * Esper blueprint defines the configuration template (apps, settings, policies) that will be
   * applied to carts for this specific store. Set by support team during store setup.
   */
  esperBlueprintId?: InputMaybe<Scalars['String']>;
  /**
   * Esper Group ID used for device organization. Groups in Esper allow organizing devices by
   * store for easier management and monitoring. Set by support team during store setup.
   */
  esperGroupId?: InputMaybe<Scalars['String']>;
  externalStoreId?: InputMaybe<Scalars['String']>;
  /** Features associated with this store */
  featureValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  flippStoreName?: InputMaybe<Scalars['String']>;
  /** Attributes of a store, separate from configs */
  id?: InputMaybe<Scalars['BigInt']>;
  instacartWarehouseLocationId?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  /** These fields are not required to be set when creating. They are used for display purposes */
  lastUpdatedAtAuthor?: InputMaybe<Scalars['String']>;
  /** This is the legacy_ngcp_store_id from the database */
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  pricingOverrideInstacartWarehouseLocationId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  /** Store operating hours (when front door is open to customers) */
  storeOpenHours?: InputMaybe<Instacart_Caper_Admin_V1_Schedule_Input>;
  street?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  /**
   * ZeroTier Network ID for store-specific cart networking used for cart maintenance only.
   * Each store has its own virtual network that carts join, allowing teams to connect remotely for
   * debugging and maintenance purposes. Set by support team during store setup.
   */
  zerotierNetworkId?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** The current deployment state of the store */
export enum Instacart_Caper_Admin_V1_Store_StoreDeploymentState {
  StoreDeploymentStateActive = 'STORE_DEPLOYMENT_STATE_ACTIVE',
  StoreDeploymentStateInactive = 'STORE_DEPLOYMENT_STATE_INACTIVE',
  StoreDeploymentStatePreLaunch = 'STORE_DEPLOYMENT_STATE_PRE_LAUNCH',
  StoreDeploymentStateUnknown = 'STORE_DEPLOYMENT_STATE_UNKNOWN'
}

/** Status of session summary generation process */
export enum Instacart_Caper_Admin_V1_SummaryStatus {
  SummaryStatusCompleted = 'SUMMARY_STATUS_COMPLETED',
  SummaryStatusFailed = 'SUMMARY_STATUS_FAILED',
  SummaryStatusPending = 'SUMMARY_STATUS_PENDING',
  SummaryStatusProcessing = 'SUMMARY_STATUS_PROCESSING',
  SummaryStatusUnknown = 'SUMMARY_STATUS_UNKNOWN'
}

/** SupportedLanguageCode is a supported BCP 47 primary language subtag. */
export enum Instacart_Caper_Admin_V1_SupportedLanguageCode {
  SupportedLanguageCodeEn = 'SUPPORTED_LANGUAGE_CODE_EN',
  SupportedLanguageCodeEs = 'SUPPORTED_LANGUAGE_CODE_ES',
  SupportedLanguageCodeFr = 'SUPPORTED_LANGUAGE_CODE_FR',
  SupportedLanguageCodeUnknown = 'SUPPORTED_LANGUAGE_CODE_UNKNOWN'
}

/** Dashboard status tabs for NOF items */
export enum Instacart_Caper_Admin_V1_Tab {
  TabEscalationFromRetailer = 'TAB_ESCALATION_FROM_RETAILER',
  TabExtNeedsAttentionFromInstacart = 'TAB_EXT_NEEDS_ATTENTION_FROM_INSTACART',
  TabExtNeedsMoreData = 'TAB_EXT_NEEDS_MORE_DATA',
  TabExtNeedsReview = 'TAB_EXT_NEEDS_REVIEW',
  TabExtResolved = 'TAB_EXT_RESOLVED',
  TabInternalEscalation = 'TAB_INTERNAL_ESCALATION',
  TabNeedsReview = 'TAB_NEEDS_REVIEW',
  TabReadyForRetesting = 'TAB_READY_FOR_RETESTING',
  TabResolved = 'TAB_RESOLVED',
  TabRetailerEscalation = 'TAB_RETAILER_ESCALATION',
  TabReviewed = 'TAB_REVIEWED',
  TabUnknown = 'TAB_UNKNOWN'
}

/** Error details for a terminal that failed to create. */
export type Instacart_Caper_Admin_V1_TerminalCreationError = {
  __typename?: 'instacart_caper_admin_v1_TerminalCreationError';
  /** The device ID that failed. */
  deviceId?: Maybe<Scalars['BigInt']>;
  /**
   * Error code for programmatic handling (e.g., "DEVICE_NOT_FOUND",
   * "DUPLICATE_TID", "WORLDLINE_ERROR").
   */
  errorCode?: Maybe<Scalars['String']>;
  /** Human-readable error message. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The Worldline TID that was attempted. */
  worldlineTid?: Maybe<Scalars['String']>;
};

/** Input data for a single terminal to be created. */
export type Instacart_Caper_Admin_V1_TerminalInput_Input = {
  /** The Caper device ID (cart). Must be a device in the specified store. */
  deviceId?: InputMaybe<Scalars['BigInt']>;
  /** Worldline Terminal Identification Number (TID) from VAR sheet. */
  worldlineTid?: InputMaybe<Scalars['String']>;
};

/**
 * Single time range [open, close) within a day. Times in store's local timezone.
 * Special case: when open equals close, represents a full 24-hour period (all day open)
 */
export type Instacart_Caper_Admin_V1_TimeRange = {
  __typename?: 'instacart_caper_admin_v1_TimeRange';
  /** Closing time with built-in validation */
  close?: Maybe<GoogleTypeTimeOfDay>;
  /** Opening time with built-in validation */
  open?: Maybe<GoogleTypeTimeOfDay>;
};

/**
 * Single time range [open, close) within a day. Times in store's local timezone.
 * Special case: when open equals close, represents a full 24-hour period (all day open)
 */
export type Instacart_Caper_Admin_V1_TimeRange_Input = {
  /** Closing time with built-in validation */
  close?: InputMaybe<GoogleTypeTimeOfDayInput>;
  /** Opening time with built-in validation */
  open?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

/**
 * A request to transfer terminal credentials from one device to another.
 * Used for device replacement scenarios (RMA, hardware failure).
 */
export type Instacart_Caper_Admin_V1_TransferTerminalRequest_Input = {
  /** Email of the CSC user making the request. Used for audit trail. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The source Caper device ID from which credentials are being transferred. */
  fromDeviceId?: InputMaybe<Scalars['BigInt']>;
  /** The payment terminal database ID to transfer. */
  paymentTerminalId?: InputMaybe<Scalars['BigInt']>;
  /** Human-readable reason for the transfer. */
  reason?: InputMaybe<Scalars['String']>;
  /** The target Caper device ID to receive the credentials. */
  toDeviceId?: InputMaybe<Scalars['BigInt']>;
};

/** Response from TransferTerminal. Returned with gRPC status OK on success. */
export type Instacart_Caper_Admin_V1_TransferTerminalResponse = {
  __typename?: 'instacart_caper_admin_v1_TransferTerminalResponse';
  /** The newly created terminal on the target device. */
  terminal?: Maybe<Instacart_Caper_Admin_V1_PaymentTerminal>;
  /** The audit record for this transfer. */
  transferRecord?: Maybe<Instacart_Caper_Admin_V1_PaymentTerminalTransfer>;
};

/**
 * Request to trigger a new device provisioning pipeline run.
 * The pipeline type is inferred from whichever config branch is set.
 */
export type Instacart_Caper_Admin_V1_TriggerPipelineRequest_Input = {
  /** Email of the IPP user triggering the run. */
  authorEmail?: InputMaybe<Scalars['String']>;
  cartReplacement?: InputMaybe<Instacart_Caper_Admin_V1_CartReplacementConfig_Input>;
  /** Physical charger location in the warehouse (e.g. "Charger 1", "Misc"). Empty if not set. */
  charger?: InputMaybe<Scalars['String']>;
  /** Target environment. Defaults to PIPELINE_ENVIRONMENT_PROD if unset. */
  env?: InputMaybe<Instacart_Caper_Admin_V1_PipelineEnvironment>;
  inWarehouseReplacement?: InputMaybe<Instacart_Caper_Admin_V1_InWarehouseReplacementConfig_Input>;
  /** Free-form note for this run, entered by the triggering user. Empty if not set. */
  note?: InputMaybe<Scalars['String']>;
  tuSwap?: InputMaybe<Instacart_Caper_Admin_V1_TuSwapConfig_Input>;
};

/** Response from TriggerPipeline. */
export type Instacart_Caper_Admin_V1_TriggerPipelineResponse = {
  __typename?: 'instacart_caper_admin_v1_TriggerPipelineResponse';
  /**
   * Newly created run record in PENDING status.
   * stages is empty in this response; use GetPipelineRun to retrieve them.
   */
  run?: Maybe<Instacart_Caper_Admin_V1_PipelineRun>;
};

/**
 * Inputs for the TU Swap pipeline.
 * Replaces the Top Unit of a single Caper Cart.
 */
export type Instacart_Caper_Admin_V1_TuSwapConfig_Input = {
  /** CSC name of the device being replaced (e.g. "P_WAKEFERN_15_M3_001"). */
  cscDeviceName?: InputMaybe<Scalars['String']>;
  /** Warehouse IPv4 address of the device (e.g. "192.168.1.100"). */
  ipAddress?: InputMaybe<Scalars['String']>;
  /** Store identifier the device belongs to (e.g. "prod-wakefern-25"). */
  storeId?: InputMaybe<Scalars['String']>;
};

/**
 * How a line's unit_cost is priced. Reflected in what `weight_milli_units`
 * means and how a client should render the qty / unit / total triple.
 */
export enum Instacart_Caper_Admin_V1_UnitOfMeasure {
  /**
   * Discrete count. unit_cost is $/item; qty × unit_cost = total;
   * weight_milli_units is unused (zero).
   */
  UnitOfMeasureEach = 'UNIT_OF_MEASURE_EACH',
  /**
   * Priced by the kilogram. unit_cost is $/kg; weight_milli_units is the
   * measured weight in grams (thousandths of a kilogram, e.g. 1175 for
   * 1.175 kg).
   */
  UnitOfMeasureKilogram = 'UNIT_OF_MEASURE_KILOGRAM',
  /**
   * Priced by the pound. unit_cost is $/lb; weight_milli_units is the
   * measured weight in thousandths of a pound (e.g. 2160 for 2.16 lb).
   */
  UnitOfMeasurePound = 'UNIT_OF_MEASURE_POUND',
  /**
   * Not set. Clients should treat this the same as UNIT_OF_MEASURE_EACH so
   * that receipts written before this field was introduced keep rendering
   * as "<qty> × <unit_cost>".
   */
  UnitOfMeasureUnknown = 'UNIT_OF_MEASURE_UNKNOWN'
}

/** Outcome of evaluating an unlock request against the cart-lock taxonomy. */
export type Instacart_Caper_Admin_V1_UnlockEvaluation = {
  __typename?: 'instacart_caper_admin_v1_UnlockEvaluation';
  /** Human-readable explanation of the outcome. */
  message?: Maybe<Scalars['String']>;
  /** Priority tier of the lock that was evaluated. */
  priority?: Maybe<Instacart_Caper_Admin_V1_LockPriority>;
  /** Reason type of the lock that was evaluated. */
  reasonType?: Maybe<Instacart_Caper_Admin_V1_CartLockReasonType>;
  /** The evaluation outcome. */
  result?: Maybe<Instacart_Caper_Admin_V1_UnlockEvaluationResult>;
};

/** Runtime outcome of evaluating an unlock request against the taxonomy. */
export enum Instacart_Caper_Admin_V1_UnlockEvaluationResult {
  /** Unlock permitted */
  UnlockEvaluationResultAllow = 'UNLOCK_EVALUATION_RESULT_ALLOW',
  /** Unlock denied */
  UnlockEvaluationResultBlock = 'UNLOCK_EVALUATION_RESULT_BLOCK',
  /** Permitted only with an override reason */
  UnlockEvaluationResultRequireOverrideReason = 'UNLOCK_EVALUATION_RESULT_REQUIRE_OVERRIDE_REASON',
  /** Not evaluated */
  UnlockEvaluationResultUnknown = 'UNLOCK_EVALUATION_RESULT_UNKNOWN'
}

/**
 * UpdateAccountRequest contains the complete mutable profile and permissions
 * for an existing account. Email is immutable and intentionally omitted.
 */
export type Instacart_Caper_Admin_V1_UpdateAccountRequest_Input = {
  /** Verified email address of the actor updating the account. */
  actorEmail?: InputMaybe<Scalars['String']>;
  /** Application the account may access. */
  appType?: InputMaybe<Instacart_Caper_Admin_V1_AppType>;
  /** Optional application-specific role metadata. */
  applicationRole?: InputMaybe<Instacart_Caper_Admin_V1_ApplicationRole_Input>;
  /** Stable Auth0 identifier of the account to update. */
  auth0UserId?: InputMaybe<Scalars['String']>;
  /** Store permissions for application types that support store-scoped access. */
  cartManagerPermissionScope?: InputMaybe<Instacart_Caper_Admin_V1_CartManagerPermissionScope_Input>;
  /** Application environments this user may access. */
  environments?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ApplicationEnvironment>>>;
  /** Updated display name for the account. */
  name?: InputMaybe<Scalars['String']>;
  /** Deprecated: use cart_manager_permission_scope.selected_partner. */
  partnerName?: InputMaybe<Scalars['String']>;
  /** Deprecated: use preferred_language_code. */
  preferredLanguage?: InputMaybe<Scalars['String']>;
  /** Optional preferred language represented as a supported language code. */
  preferredLanguageCode?: InputMaybe<Instacart_Caper_Admin_V1_SupportedLanguageCode>;
  /** Deprecated: use preferred_store_identifier. */
  preferredStoreId?: InputMaybe<Scalars['String']>;
  /** Optional default store context. This does not grant access to the store. */
  preferredStoreIdentifier?: InputMaybe<Instacart_Caper_Admin_V1_PreferredStoreIdentifier_Input>;
  /** Deprecated: use application_role. */
  role?: InputMaybe<Scalars['String']>;
};

/**
 * UpdateAccountResponse returns the account after its profile and permissions
 * are updated.
 */
export type Instacart_Caper_Admin_V1_UpdateAccountResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateAccountResponse';
  /** Updated account summary. */
  account?: Maybe<Instacart_Caper_Admin_V1_AccountSummary>;
};

/** UpdateAccountStatusRequest identifies an account and its desired status. */
export type Instacart_Caper_Admin_V1_UpdateAccountStatusRequest_Input = {
  /** Verified email address of the actor updating the account. */
  actorEmail?: InputMaybe<Scalars['String']>;
  /** Stable Auth0 identifier of the account to update. */
  auth0UserId?: InputMaybe<Scalars['String']>;
  /** Desired account status. Only ACTIVE and BLOCKED are accepted. */
  status?: InputMaybe<Instacart_Caper_Admin_V1_AccountStatus>;
};

/** UpdateAccountStatusResponse returns the account after its status is updated. */
export type Instacart_Caper_Admin_V1_UpdateAccountStatusResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateAccountStatusResponse';
  /** Updated account summary. */
  account?: Maybe<Instacart_Caper_Admin_V1_AccountSummary>;
};

/** Request for replacing barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_UpdateBarcodePluMappingsRequest_Input = {
  /**
   * Must contain at least one mapping.
   *
   * Update uses PUT semantics. Scope and barcode identify the existing
   * mapping and cannot change. PLU, expiration, name, and source completely
   * replace their stored values. An absent expires_at clears the expiration.
   */
  mappings?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_BarcodePluMapping_Input>>>;
};

/** Response for replacing barcode-to-PLU mappings. */
export type Instacart_Caper_Admin_V1_UpdateBarcodePluMappingsResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateBarcodePluMappingsResponse';
  /** Failed request items. May coexist with updated_mappings. */
  failedUpdates?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMappingError>>>;
  /** Successfully updated mappings. */
  updatedMappings?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_BarcodePluMapping>>>;
};

/** Requested changes to a config key */
export type Instacart_Caper_Admin_V1_UpdateConfigKeyRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Set the ID of the config key to update, and any fields you wish to change */
  configKey?: InputMaybe<Instacart_Caper_Admin_V1_ConfigKey_Input>;
};

/** Requested changes to configs */
export type Instacart_Caper_Admin_V1_UpdateConfigRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
  updates?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_ConfigUpdate_Input>>>;
};

/** Request for updating a device */
export type Instacart_Caper_Admin_V1_UpdateDeviceRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the device to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  device?: InputMaybe<Instacart_Caper_Admin_V1_Device_Input>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
};

/** Response for updating a device */
export type Instacart_Caper_Admin_V1_UpdateDeviceResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateDeviceResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request for updating an existing feature */
export type Instacart_Caper_Admin_V1_UpdateFeatureRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The full feature object, including the ID and all fields to update. */
  feature?: InputMaybe<Instacart_Caper_Admin_V1_Feature_Input>;
  /** Free-text reason; set on rejection, forwarded to Slack notification. */
  rejectionReason?: InputMaybe<Scalars['String']>;
};

/**
 * Response for updating a feature.
 * This RPC always returns gRPC OK (HTTP 200), even when the update is rejected.
 * Callers must inspect locked_feature_errors on every successful response:
 * - Empty list: the feature was updated successfully.
 * - Non-empty list: the update was rejected because one or more fields are locked.
 * The feature was not modified. Surface the error_message from the first entry to the user.
 * This matches the partial-failure convention used by UpdatePartnerResponse,
 * UpdateRetailerResponse, UpdateStoreResponse, and UpdateDeviceResponse.
 */
export type Instacart_Caper_Admin_V1_UpdateFeatureResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateFeatureResponse';
  /** Features that could not be modified due to being locked. */
  lockedFeatureErrors?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request for updating the global level */
export type Instacart_Caper_Admin_V1_UpdateGlobalRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * All features that should be set on the global level, including existing ones.
   * If you leave out features that are already set, they will be unset.
   */
  featuresValues?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_FeatureValue_Input>>>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
};

/** Request for updating an existing notification group. group.id is required. */
export type Instacart_Caper_Admin_V1_UpdateNotificationGroupRequest_Input = {
  /** The email of the person making the change. Must be a valid Instacart company email (format: firstname.lastname@instacart.com). */
  authorEmail?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Instacart_Caper_Admin_V1_NotificationGroup_Input>;
};

/** Request for updating a partner */
export type Instacart_Caper_Admin_V1_UpdatePartnerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the partner to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  partner?: InputMaybe<Instacart_Caper_Admin_V1_Partner_Input>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
};

/** Response for updating a partner */
export type Instacart_Caper_Admin_V1_UpdatePartnerResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdatePartnerResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request for updating a retailer */
export type Instacart_Caper_Admin_V1_UpdateRetailerRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the retailer to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  retailer?: InputMaybe<Instacart_Caper_Admin_V1_Retailer_Input>;
};

/** Response for updating a retailer */
export type Instacart_Caper_Admin_V1_UpdateRetailerResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateRetailerResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Request to update feedback and rating for an existing session summary */
export type Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackRequest_Input = {
  /**
   * Optional: Feedback text (empty string means no feedback update)
   * Business logic will only update feedback if non-empty
   */
  feedback?: InputMaybe<Scalars['String']>;
  /**
   * Optional: Rating from 1-5
   * Business logic will only update rating if not 0
   * Application logic will validate range and reject invalid values
   */
  rating?: InputMaybe<Scalars['Int']>;
  /** Required: The ID of the session summary to update */
  summaryId?: InputMaybe<Scalars['String']>;
};

/**
 * Response for updating session summary feedback and rating
 * Returns the updated session summary status with the newly applied feedback/rating
 */
export type Instacart_Caper_Admin_V1_UpdateSessionSummaryFeedbackResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateSessionSummaryFeedbackResponse';
  status?: Maybe<Instacart_Caper_Admin_V1_SessionSummaryCreationStatus>;
};

/** Request for updating a store */
export type Instacart_Caper_Admin_V1_UpdateStoreRequest_Input = {
  /** The email of the person making the change */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Reason for the change, e.g. incident link, JIRA ticket, or description of why this change is being made */
  reason?: InputMaybe<Scalars['String']>;
  /**
   * Set the ID of the store to update, and all of existing and updated fields.
   * If you do not include existing fields, they will be cleared.
   */
  store?: InputMaybe<Instacart_Caper_Admin_V1_Store_Input>;
};

/** Response for updating a store */
export type Instacart_Caper_Admin_V1_UpdateStoreResponse = {
  __typename?: 'instacart_caper_admin_v1_UpdateStoreResponse';
  /** Features that could not be modified due to being locked */
  lockedFeatureErrors?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_LockedFeatureError>>>;
};

/** Video audit event with timestamp */
export type Instacart_Caper_Admin_V1_VideoAuditEventData = {
  __typename?: 'instacart_caper_admin_v1_VideoAuditEventData';
  /** When this event occurred */
  eventTimestamp?: Maybe<Scalars['DateTime']>;
  /** Video audit properties */
  properties?: Maybe<Instacart_Caper_Admin_V1_VideoAuditProperties>;
};

/** Video audit event properties */
export type Instacart_Caper_Admin_V1_VideoAuditProperties = {
  __typename?: 'instacart_caper_admin_v1_VideoAuditProperties';
  /** Asset ID for the video */
  assetId?: Maybe<Scalars['String']>;
  /** When the video was created */
  createTimestamp?: Maybe<Scalars['String']>;
  /** Duration of the video in milliseconds */
  duration?: Maybe<Scalars['BigInt']>;
  /** Encoding duration in milliseconds */
  encodeDurationMillis?: Maybe<Scalars['BigInt']>;
  /** Whether this is a long-term upload */
  isLongTermUpload?: Maybe<Scalars['Boolean']>;
  /** URL to access the video */
  url?: Maybe<Scalars['String']>;
  /** Video duration in milliseconds */
  videoDuration?: Maybe<Scalars['BigInt']>;
};

/** VideoInspectorRole is the title assigned to a Video Inspector account. */
export enum Instacart_Caper_Admin_V1_VideoInspectorRole {
  VideoInspectorRoleQaInspector = 'VIDEO_INSPECTOR_ROLE_QA_INSPECTOR',
  VideoInspectorRoleShrinkProxyInspector = 'VIDEO_INSPECTOR_ROLE_SHRINK_PROXY_INSPECTOR',
  VideoInspectorRoleUnknown = 'VIDEO_INSPECTOR_ROLE_UNKNOWN',
  VideoInspectorRoleVideoInspector = 'VIDEO_INSPECTOR_ROLE_VIDEO_INSPECTOR'
}

/**
 * WarehouseLocationStore represents a Caper store associated with an IPP
 * warehouse location.
 */
export type Instacart_Caper_Admin_V1_WarehouseLocationStore = {
  __typename?: 'instacart_caper_admin_v1_WarehouseLocationStore';
  /** Caper store identifier (the store's legacy NGCP object ID). */
  caperStoreId?: Maybe<Scalars['String']>;
  /** IPP warehouse location ID this store maps to. */
  warehouseLocationId?: Maybe<Scalars['String']>;
};

/** Single day's schedule with type-safe day specification */
export type Instacart_Caper_Admin_V1_WeeklySchedule = {
  __typename?: 'instacart_caper_admin_v1_WeeklySchedule';
  day?: Maybe<GoogleTypeDayOfWeek>;
  ranges?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_TimeRange>>>;
};

/** Single day's schedule with type-safe day specification */
export type Instacart_Caper_Admin_V1_WeeklySchedule_Input = {
  day?: InputMaybe<GoogleTypeDayOfWeek>;
  ranges?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_TimeRange_Input>>>;
};

/** Request to transition a DRAFT experiment to ACTIVE. */
export type Instacart_Caper_Admin_V2_ActivateExperimentRequest_Input = {
  activatedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response for ActivateExperiment. */
export type Instacart_Caper_Admin_V2_ActivateExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_ActivateExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/** Request to apply a CSC snapshot to its entity. */
export type Instacart_Caper_Admin_V2_ApplyCscSnapshotRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Current-state preview that must still match the target entity when Apply begins. */
  expectedCurrentSnapshotId?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  snapshotId?: InputMaybe<Scalars['String']>;
};

/** Response summarizing an apply-snapshot operation. */
export type Instacart_Caper_Admin_V2_ApplyCscSnapshotResponse = {
  __typename?: 'instacart_caper_admin_v2_ApplyCscSnapshotResponse';
  appliedChangeSummary?: Maybe<Scalars['String']>;
  /** The newly created post-apply snapshot for audit and follow-up comparison. */
  appliedSnapshotId?: Maybe<Scalars['String']>;
  changedConfigCount?: Maybe<Scalars['Int']>;
  changedFeatureCount?: Maybe<Scalars['Int']>;
  /** The snapshot selected by the user. */
  sourceSnapshotId?: Maybe<Scalars['String']>;
};

/** Navigation-only fields. Do not add entity attributes here — use GetEntitiesDetails. */
export type Instacart_Caper_Admin_V2_BasicDeviceInfo = {
  __typename?: 'instacart_caper_admin_v2_BasicDeviceInfo';
  /**
   * Included at navigation level so consumers can distinguish and filter device purpose,
   * without fetching full details.
   */
  devicePurpose?: Maybe<Instacart_Caper_Admin_V1_Device_DevicePurpose>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Included at navigation level so consumers can filter or triage devices by availability
   * without fetching full details.
   */
  operationalState?: Maybe<Instacart_Caper_Admin_V1_Device_OperationalState>;
  storeId?: Maybe<Scalars['BigInt']>;
};

/** Navigation-only fields. Do not add entity attributes here — use GetEntitiesDetails. */
export type Instacart_Caper_Admin_V2_BasicPartnerInfo = {
  __typename?: 'instacart_caper_admin_v2_BasicPartnerInfo';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

/** Navigation-only fields. Do not add entity attributes here — use GetEntitiesDetails. */
export type Instacart_Caper_Admin_V2_BasicRetailerInfo = {
  __typename?: 'instacart_caper_admin_v2_BasicRetailerInfo';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
};

/** Navigation-only fields. Do not add entity attributes here — use GetEntitiesDetails. */
export type Instacart_Caper_Admin_V2_BasicStoreInfo = {
  __typename?: 'instacart_caper_admin_v2_BasicStoreInfo';
  /**
   * Included at navigation level so consumers can filter or group stores by launch status
   * without fetching full details.
   */
  deploymentState?: Maybe<Instacart_Caper_Admin_V1_Store_StoreDeploymentState>;
  /**
   * Some teams identify stores by retailer brand + external ID (e.g., "ShopRite 296")
   * rather than internal names (e.g., "prod-wakefern-...")
   */
  externalStoreId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** Request to cancel a DRAFT experiment. */
export type Instacart_Caper_Admin_V2_CancelExperimentRequest_Input = {
  cancelledBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  reason?: InputMaybe<Scalars['String']>;
};

/** Response for CancelExperiment. */
export type Instacart_Caper_Admin_V2_CancelExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_CancelExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/** Request to close an ACTIVE experiment as COMPLETED without reverting writes. */
export type Instacart_Caper_Admin_V2_CompleteExperimentRequest_Input = {
  completedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response for CompleteExperiment. */
export type Instacart_Caper_Admin_V2_CompleteExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_CompleteExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/** Config-write side of an ExperimentBinding: the value to write on activation. */
export type Instacart_Caper_Admin_V2_ConfigBindingDetail = {
  __typename?: 'instacart_caper_admin_v2_ConfigBindingDetail';
  configKeyId?: Maybe<Scalars['BigInt']>;
  /** Populated by the server on read; ignored on write. */
  configKeyName?: Maybe<Scalars['String']>;
  plannedValue?: Maybe<Scalars['String']>;
};

/** Config-write side of an ExperimentBinding: the value to write on activation. */
export type Instacart_Caper_Admin_V2_ConfigBindingDetail_Input = {
  configKeyId?: InputMaybe<Scalars['BigInt']>;
  /** Populated by the server on read; ignored on write. */
  configKeyName?: InputMaybe<Scalars['String']>;
  plannedValue?: InputMaybe<Scalars['String']>;
};

/**
 * Matches entities whose latest value for config_name equals config_value.
 * config_name corresponds to ConfigValue.name in v1. Exact match only on both fields.
 * Multiple ConfigFilter entries in the request are AND-ed: the entity must satisfy all pairs.
 */
export type Instacart_Caper_Admin_V2_ConfigFilter_Input = {
  configName?: InputMaybe<Scalars['String']>;
  configValue?: InputMaybe<Scalars['String']>;
};

/**
 * History-event detail for a config value write. old_value may be empty if the
 * entity had no prior value for the key.
 */
export type Instacart_Caper_Admin_V2_ConfigWriteDetail = {
  __typename?: 'instacart_caper_admin_v2_ConfigWriteDetail';
  configKeyId?: Maybe<Scalars['BigInt']>;
  configKeyName?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

/** Request to create an immutable CSC snapshot for one entity. */
export type Instacart_Caper_Admin_V2_CreateCscSnapshotRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Instacart_Caper_Admin_V2_EntityReference_Input>;
  note?: InputMaybe<Scalars['String']>;
  /** Manual snapshots must include at least one of tag or note. */
  tag?: InputMaybe<Scalars['String']>;
};

/** Response containing the created CSC snapshot. */
export type Instacart_Caper_Admin_V2_CreateCscSnapshotResponse = {
  __typename?: 'instacart_caper_admin_v2_CreateCscSnapshotResponse';
  snapshot?: Maybe<Instacart_Caper_Admin_V2_CscSnapshot>;
};

/** Request to create a new DRAFT experiment. */
export type Instacart_Caper_Admin_V2_CreateExperimentRequest_Input = {
  autoRevertEnabled?: InputMaybe<Scalars['Boolean']>;
  bindings?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_ExperimentBindingSpec_Input>>>;
  createdBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  driEmail?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  externalDependencies?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response for CreateExperiment. */
export type Instacart_Caper_Admin_V2_CreateExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_CreateExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/** Immutable CSC snapshot row plus mutable metadata. */
export type Instacart_Caper_Admin_V2_CscSnapshot = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshot';
  archived?: Maybe<Scalars['Boolean']>;
  authorEmail?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Final CSC state after resolving inheritance from parent entity levels. */
  effectiveSnapshot?: Maybe<Instacart_Caper_Admin_V2_CscSnapshotPayload>;
  entity?: Maybe<Instacart_Caper_Admin_V2_EntityReference>;
  entityName?: Maybe<Scalars['String']>;
  /** Configs/features directly applied to this entity. */
  localSnapshot?: Maybe<Instacart_Caper_Admin_V2_CscSnapshotPayload>;
  note?: Maybe<Scalars['String']>;
  /** SHA-256 digest over canonical local_snapshot and effective_snapshot payloads. */
  snapshotDigest?: Maybe<Scalars['String']>;
  /** Immutable id of this snapshot row. */
  snapshotId?: Maybe<Scalars['String']>;
  snapshotSource?: Maybe<Instacart_Caper_Admin_V2_CscSnapshotSource>;
  tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User who most recently updated mutable metadata. */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Config value captured in a CSC snapshot. */
export type Instacart_Caper_Admin_V2_CscSnapshotConfig = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshotConfig';
  configValue?: Maybe<Instacart_Caper_Admin_V1_ConfigValue>;
  /** Entity level where this config value came from. */
  sourceEntity?: Maybe<Instacart_Caper_Admin_V2_EntityReference>;
};

/** Feature state captured in a CSC snapshot. */
export type Instacart_Caper_Admin_V2_CscSnapshotFeature = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshotFeature';
  featureMetadata?: Maybe<Instacart_Caper_Admin_V2_CscSnapshotFeatureMetadata>;
  featureValue?: Maybe<Instacart_Caper_Admin_V1_FeatureValue>;
  /** Entity level where this feature enablement came from. */
  sourceEntity?: Maybe<Instacart_Caper_Admin_V2_EntityReference>;
};

/** Feature metadata captured in a CSC snapshot. */
export type Instacart_Caper_Admin_V2_CscSnapshotFeatureMetadata = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshotFeatureMetadata';
  /** Config keys associated with this feature at snapshot time. */
  configKeyNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  featureName?: Maybe<Scalars['String']>;
};

/** Pagination metadata for CSC snapshot list responses. */
export type Instacart_Caper_Admin_V2_CscSnapshotPagination = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshotPagination';
  currentPage?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/** Snapshot payload for one entity's CSC config and feature state. */
export type Instacart_Caper_Admin_V2_CscSnapshotPayload = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshotPayload';
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_CscSnapshotConfig>>>;
  features?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_CscSnapshotFeature>>>;
  /** Payload schema version for JSONB storage and future migrations. */
  schemaVersion?: Maybe<Scalars['Int']>;
};

/** Source that created a CSC snapshot. */
export enum Instacart_Caper_Admin_V2_CscSnapshotSource {
  CscSnapshotSourceApplySnapshot = 'CSC_SNAPSHOT_SOURCE_APPLY_SNAPSHOT',
  CscSnapshotSourceChangeTriggeredPost = 'CSC_SNAPSHOT_SOURCE_CHANGE_TRIGGERED_POST',
  CscSnapshotSourceChangeTriggeredPre = 'CSC_SNAPSHOT_SOURCE_CHANGE_TRIGGERED_PRE',
  CscSnapshotSourceManual = 'CSC_SNAPSHOT_SOURCE_MANUAL',
  CscSnapshotSourceScheduled = 'CSC_SNAPSHOT_SOURCE_SCHEDULED',
  CscSnapshotSourceUnknown = 'CSC_SNAPSHOT_SOURCE_UNKNOWN'
}

/** Metadata summary for one CSC snapshot, excluding payload fields. */
export type Instacart_Caper_Admin_V2_CscSnapshotSummary = {
  __typename?: 'instacart_caper_admin_v2_CscSnapshotSummary';
  archived?: Maybe<Scalars['Boolean']>;
  authorEmail?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entity?: Maybe<Instacart_Caper_Admin_V2_EntityReference>;
  entityName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  snapshotDigest?: Maybe<Scalars['String']>;
  snapshotId?: Maybe<Scalars['String']>;
  snapshotSource?: Maybe<Instacart_Caper_Admin_V2_CscSnapshotSource>;
  tag?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User who most recently updated mutable metadata. */
  updatedBy?: Maybe<Scalars['String']>;
};

/**
 * Full entity data for a single entity. Exactly one variant is set.
 * Nested children (retailers, stores, devices) are always empty; use GetAllEntitiesBasic for hierarchy traversal.
 */
export type Instacart_Caper_Admin_V2_EntityDetails = {
  __typename?: 'instacart_caper_admin_v2_EntityDetails';
  device?: Maybe<Instacart_Caper_Admin_V1_Device>;
  global?: Maybe<Instacart_Caper_Admin_V2_GlobalDetails>;
  partner?: Maybe<Instacart_Caper_Admin_V1_Partner>;
  retailer?: Maybe<Instacart_Caper_Admin_V1_Retailer>;
  store?: Maybe<Instacart_Caper_Admin_V1_Store>;
};

/**
 * EntityMatch is a single search result.
 * Exactly one entity variant is set. The `global` variant represents the root
 * configuration scope. Ancestor IDs locate the match within the hierarchy;
 * 0 indicates the ancestor level does not apply for the matched entity type.
 *
 * Ancestor IDs populated by entity type:
 * RETAILER → partner_id
 * STORE    → partner_id + retailer_id
 * DEVICE   → partner_id + retailer_id + store_id
 * PARTNER/GLOBAL → all zero (no ancestors)
 */
export type Instacart_Caper_Admin_V2_EntityMatch = {
  __typename?: 'instacart_caper_admin_v2_EntityMatch';
  device?: Maybe<Instacart_Caper_Admin_V2_BasicDeviceInfo>;
  global?: Maybe<Scalars['instacart_caper_admin_v2_BasicGlobalInfo']>;
  partner?: Maybe<Instacart_Caper_Admin_V2_BasicPartnerInfo>;
  partnerId?: Maybe<Scalars['BigInt']>;
  retailer?: Maybe<Instacart_Caper_Admin_V2_BasicRetailerInfo>;
  retailerId?: Maybe<Scalars['BigInt']>;
  store?: Maybe<Instacart_Caper_Admin_V2_BasicStoreInfo>;
  storeId?: Maybe<Scalars['BigInt']>;
};

/**
 * Identifies a specific entity. For ENTITY_TYPE_GLOBAL, set entity_id to 0
 * (the value is ignored). For all other types, entity_id is required and non-zero.
 */
export type Instacart_Caper_Admin_V2_EntityReference = {
  __typename?: 'instacart_caper_admin_v2_EntityReference';
  entityId?: Maybe<Scalars['BigInt']>;
  entityType?: Maybe<Instacart_Caper_Admin_V1_EntityType>;
};

/**
 * Identifies a specific entity. For ENTITY_TYPE_GLOBAL, set entity_id to 0
 * (the value is ignored). For all other types, entity_id is required and non-zero.
 */
export type Instacart_Caper_Admin_V2_EntityReference_Input = {
  entityId?: InputMaybe<Scalars['BigInt']>;
  entityType?: InputMaybe<Instacart_Caper_Admin_V1_EntityType>;
};

/**
 * A timeboxed rollout of config/feature writes to a set of target entities.
 * Transitions DRAFT → ACTIVE → (COMPLETED | REVERTED | CANCELLED | FAILED).
 */
export type Instacart_Caper_Admin_V2_Experiment = {
  __typename?: 'instacart_caper_admin_v2_Experiment';
  activatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * When true, the experiment is automatically reverted at end_at.
   * Servers may reject true if auto-revert is not supported.
   */
  autoRevertEnabled?: Maybe<Scalars['Boolean']>;
  bindings?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_ExperimentBinding>>>;
  cancelReason?: Maybe<Scalars['String']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  driEmail?: Maybe<Scalars['String']>;
  endAt?: Maybe<Scalars['DateTime']>;
  externalDependencies?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  revertReason?: Maybe<Scalars['String']>;
  startAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Instacart_Caper_Admin_V2_ExperimentStatus>;
};

/**
 * One config or feature write bound to a target entity, applied on activation
 * and reverted when the experiment closes. The binding oneof case discriminates
 * config vs feature; no separate action-type field.
 */
export type Instacart_Caper_Admin_V2_ExperimentBinding = {
  __typename?: 'instacart_caper_admin_v2_ExperimentBinding';
  appliedAt?: Maybe<Scalars['DateTime']>;
  applyError?: Maybe<Scalars['String']>;
  config?: Maybe<Instacart_Caper_Admin_V2_ConfigBindingDetail>;
  feature?: Maybe<Instacart_Caper_Admin_V2_FeatureBindingDetail>;
  id?: Maybe<Scalars['BigInt']>;
  revertError?: Maybe<Scalars['String']>;
  revertedAt?: Maybe<Scalars['DateTime']>;
  target?: Maybe<Instacart_Caper_Admin_V2_EntityReference>;
};

/** Input side for CreateExperiment / UpdateExperiment. */
export type Instacart_Caper_Admin_V2_ExperimentBindingSpec_Input = {
  config?: InputMaybe<Instacart_Caper_Admin_V2_ConfigBindingDetail_Input>;
  feature?: InputMaybe<Instacart_Caper_Admin_V2_FeatureBindingDetail_Input>;
  target?: InputMaybe<Instacart_Caper_Admin_V2_EntityReference_Input>;
};

/**
 * One entry in an experiment's activity timeline (a mutation caused by the
 * experiment, e.g. apply on activate, revert on close).
 */
export type Instacart_Caper_Admin_V2_ExperimentHistoryEvent = {
  __typename?: 'instacart_caper_admin_v2_ExperimentHistoryEvent';
  at?: Maybe<Scalars['DateTime']>;
  author?: Maybe<Scalars['String']>;
  configWrite?: Maybe<Instacart_Caper_Admin_V2_ConfigWriteDetail>;
  featureChange?: Maybe<Instacart_Caper_Admin_V2_FeatureChangeDetail>;
  reason?: Maybe<Scalars['String']>;
  target?: Maybe<Instacart_Caper_Admin_V2_EntityReference>;
};

export enum Instacart_Caper_Admin_V2_ExperimentStatus {
  ExperimentStatusActive = 'EXPERIMENT_STATUS_ACTIVE',
  ExperimentStatusCancelled = 'EXPERIMENT_STATUS_CANCELLED',
  ExperimentStatusCompleted = 'EXPERIMENT_STATUS_COMPLETED',
  ExperimentStatusDraft = 'EXPERIMENT_STATUS_DRAFT',
  ExperimentStatusFailed = 'EXPERIMENT_STATUS_FAILED',
  ExperimentStatusReverted = 'EXPERIMENT_STATUS_REVERTED',
  ExperimentStatusUnknown = 'EXPERIMENT_STATUS_UNKNOWN'
}

/**
 * Request to push an ACTIVE experiment's end_at forward. new_end_at must be
 * strictly after the current end_at.
 */
export type Instacart_Caper_Admin_V2_ExtendExperimentRequest_Input = {
  extendedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  newEndAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response for ExtendExperiment. */
export type Instacart_Caper_Admin_V2_ExtendExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_ExtendExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/** Feature-toggle side of an ExperimentBinding: enable or disable the feature on activation. */
export type Instacart_Caper_Admin_V2_FeatureBindingDetail = {
  __typename?: 'instacart_caper_admin_v2_FeatureBindingDetail';
  cscFeatureId?: Maybe<Scalars['BigInt']>;
  /** Populated by the server on read; ignored on write. */
  cscFeatureName?: Maybe<Scalars['String']>;
  featureAction?: Maybe<Instacart_Caper_Admin_V1_FeatureActionType>;
};

/** Feature-toggle side of an ExperimentBinding: enable or disable the feature on activation. */
export type Instacart_Caper_Admin_V2_FeatureBindingDetail_Input = {
  cscFeatureId?: InputMaybe<Scalars['BigInt']>;
  /** Populated by the server on read; ignored on write. */
  cscFeatureName?: InputMaybe<Scalars['String']>;
  featureAction?: InputMaybe<Instacart_Caper_Admin_V1_FeatureActionType>;
};

/** History-event detail for a feature enable/disable. */
export type Instacart_Caper_Admin_V2_FeatureChangeDetail = {
  __typename?: 'instacart_caper_admin_v2_FeatureChangeDetail';
  action?: Maybe<Instacart_Caper_Admin_V1_FeatureActionType>;
  cscFeatureId?: Maybe<Scalars['BigInt']>;
  cscFeatureName?: Maybe<Scalars['String']>;
};

/**
 * Matches entities that have this feature enabled.
 * Multiple FeatureFilter entries in the request are AND-ed: the entity must have all listed features enabled.
 */
export type Instacart_Caper_Admin_V2_FeatureFilter_Input = {
  featureName?: InputMaybe<Scalars['String']>;
};

/**
 * GetAllEntitiesBasicRequest scopes the entity hierarchy returned by GetAllEntitiesBasic.
 * Set exactly one scope field:
 * all         → returns all partners, retailers, and stores
 * partner_id  → returns retailers for the given partner
 * retailer_id → returns stores for the given retailer
 * store_id    → returns devices for the given store
 *
 * Only the lists relevant to the requested scope are populated in the response.
 * Configs and feature values are not included; use GetEntitiesDetails to retrieve them.
 */
export type Instacart_Caper_Admin_V2_GetAllEntitiesBasicRequest_Input = {
  all?: InputMaybe<Scalars['Boolean']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for GetAllEntitiesBasic. Only lists relevant to the request scope are populated. */
export type Instacart_Caper_Admin_V2_GetAllEntitiesBasicResponse = {
  __typename?: 'instacart_caper_admin_v2_GetAllEntitiesBasicResponse';
  devices?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_BasicDeviceInfo>>>;
  partners?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_BasicPartnerInfo>>>;
  retailers?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_BasicRetailerInfo>>>;
  stores?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_BasicStoreInfo>>>;
};

/** Request to fetch one CSC snapshot by id. */
export type Instacart_Caper_Admin_V2_GetCscSnapshotRequest_Input = {
  snapshotId?: InputMaybe<Scalars['String']>;
};

/** Response containing one CSC snapshot. */
export type Instacart_Caper_Admin_V2_GetCscSnapshotResponse = {
  __typename?: 'instacart_caper_admin_v2_GetCscSnapshotResponse';
  snapshot?: Maybe<Instacart_Caper_Admin_V2_CscSnapshot>;
};

/**
 * GetEntitiesDetailsRequest specifies a batch of entities whose full attributes,
 * configs, and feature values should be returned.
 */
export type Instacart_Caper_Admin_V2_GetEntitiesDetailsRequest_Input = {
  entities?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_EntityReference_Input>>>;
};

/** Response for GetEntitiesDetails. */
export type Instacart_Caper_Admin_V2_GetEntitiesDetailsResponse = {
  __typename?: 'instacart_caper_admin_v2_GetEntitiesDetailsResponse';
  entities?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_EntityDetails>>>;
};

/** Request for one experiment by id, including its bindings. */
export type Instacart_Caper_Admin_V2_GetExperimentRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response for GetExperiment. */
export type Instacart_Caper_Admin_V2_GetExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_GetExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/**
 * Full data for the global scope — configs and feature values only.
 * Global has no id, name, parent, or attributes (unlike Partner/Retailer/Store/Device),
 * so it gets its own message type that mirrors the global-level fields exposed by
 * v1 GetAllEntitiesResponse.
 */
export type Instacart_Caper_Admin_V2_GlobalDetails = {
  __typename?: 'instacart_caper_admin_v2_GlobalDetails';
  configs?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_ConfigValue>>>;
  featureValues?: Maybe<Array<Maybe<Instacart_Caper_Admin_V1_FeatureValue>>>;
};

/** Request to list CSC snapshots with optional filters. */
export type Instacart_Caper_Admin_V2_ListCscSnapshotsRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']>;
  entities?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_EntityReference_Input>>>;
  entityNameContains?: InputMaybe<Scalars['String']>;
  entityTypes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_EntityType>>>;
  includeArchived?: InputMaybe<Scalars['Boolean']>;
  /** 1-based page number. Defaults to 1 when unset. */
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  snapshotSources?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_CscSnapshotSource>>>;
  tag?: InputMaybe<Scalars['String']>;
};

/** Response containing a page of CSC snapshot summaries. */
export type Instacart_Caper_Admin_V2_ListCscSnapshotsResponse = {
  __typename?: 'instacart_caper_admin_v2_ListCscSnapshotsResponse';
  pagination?: Maybe<Instacart_Caper_Admin_V2_CscSnapshotPagination>;
  snapshots?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_CscSnapshotSummary>>>;
};

/** Request for the activity timeline of one experiment. */
export type Instacart_Caper_Admin_V2_ListExperimentHistoryRequest_Input = {
  experimentId?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};

/** Response for ListExperimentHistory. */
export type Instacart_Caper_Admin_V2_ListExperimentHistoryResponse = {
  __typename?: 'instacart_caper_admin_v2_ListExperimentHistoryResponse';
  events?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_ExperimentHistoryEvent>>>;
  nextPageToken?: Maybe<Scalars['String']>;
};

/** Filter for the ListExperiments query. All specified filters are AND-ed. */
export type Instacart_Caper_Admin_V2_ListExperimentsRequest_Input = {
  /** Matches experiments where start_at <= active_at < end_at. */
  activeAt?: InputMaybe<Scalars['DateTime']>;
  driEmail?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  /** Empty means all statuses. */
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_ExperimentStatus>>>;
};

/**
 * Response for ListExperiments. Bindings are omitted from each entry; use
 * GetExperiment for those.
 */
export type Instacart_Caper_Admin_V2_ListExperimentsResponse = {
  __typename?: 'instacart_caper_admin_v2_ListExperimentsResponse';
  experiments?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_Experiment>>>;
  nextPageToken?: Maybe<Scalars['String']>;
};

/** Request to manually revert an ACTIVE experiment to its captured baselines. */
export type Instacart_Caper_Admin_V2_RevertExperimentRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  reason?: InputMaybe<Scalars['String']>;
  revertedBy?: InputMaybe<Scalars['String']>;
};

/** Response for RevertExperiment. */
export type Instacart_Caper_Admin_V2_RevertExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_RevertExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

/**
 * SearchEntitiesRequest locates entities by name, config key/value, or enabled feature.
 *
 * Each match in the response contains a summary of the matched entity and ancestor IDs
 * that locate it within the hierarchy. Ancestor IDs are IDs only; full ancestor metadata
 * must be obtained via GetAllEntitiesBasic. Full configs and feature values must be
 * retrieved via GetEntitiesDetails.
 *
 * All specified filters are combined with AND. At least one filter should be provided.
 * Searches that would return more than 10,000 results are rejected.
 */
export type Instacart_Caper_Admin_V2_SearchEntitiesRequest_Input = {
  configs?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_ConfigFilter_Input>>>;
  /** Substring match on entity name (CONTAINS). */
  entityNameContains?: InputMaybe<Scalars['String']>;
  /** Exact-match list of entity names. Matches entities whose name equals any value in the list. */
  entityNamesIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** empty = all types */
  entityTypes?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V1_EntityType>>>;
  features?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_FeatureFilter_Input>>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
};

/** Response for SearchEntities. */
export type Instacart_Caper_Admin_V2_SearchEntitiesResponse = {
  __typename?: 'instacart_caper_admin_v2_SearchEntitiesResponse';
  matches?: Maybe<Array<Maybe<Instacart_Caper_Admin_V2_EntityMatch>>>;
  nextPageToken?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** Request to update mutable metadata on a CSC snapshot. */
export type Instacart_Caper_Admin_V2_UpdateCscSnapshotMetadataRequest_Input = {
  archived?: InputMaybe<Scalars['Boolean']>;
  authorEmail?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  snapshotId?: InputMaybe<Scalars['String']>;
  /** Only tag, note, and archived are mutable. */
  tag?: InputMaybe<Scalars['String']>;
  updateMask?: InputMaybe<Google_Protobuf_FieldMask_Input>;
};

/** Response containing the updated CSC snapshot metadata. */
export type Instacart_Caper_Admin_V2_UpdateCscSnapshotMetadataResponse = {
  __typename?: 'instacart_caper_admin_v2_UpdateCscSnapshotMetadataResponse';
  snapshot?: Maybe<Instacart_Caper_Admin_V2_CscSnapshot>;
};

/**
 * Request to edit a DRAFT experiment. Only fields listed in update_mask are
 * modified. bindings is a full replace when included in the mask.
 */
export type Instacart_Caper_Admin_V2_UpdateExperimentRequest_Input = {
  autoRevertEnabled?: InputMaybe<Scalars['Boolean']>;
  bindings?: InputMaybe<Array<InputMaybe<Instacart_Caper_Admin_V2_ExperimentBindingSpec_Input>>>;
  description?: InputMaybe<Scalars['String']>;
  driEmail?: InputMaybe<Scalars['String']>;
  endAt?: InputMaybe<Scalars['DateTime']>;
  externalDependencies?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  startAt?: InputMaybe<Scalars['DateTime']>;
  updateMask?: InputMaybe<Google_Protobuf_FieldMask_Input>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Response for UpdateExperiment. */
export type Instacart_Caper_Admin_V2_UpdateExperimentResponse = {
  __typename?: 'instacart_caper_admin_v2_UpdateExperimentResponse';
  experiment?: Maybe<Instacart_Caper_Admin_V2_Experiment>;
};

export enum Instacart_Care_Tools_V1_AccountType {
  AccountTypeIpp = 'ACCOUNT_TYPE_IPP',
  AccountTypeUnspecified = 'ACCOUNT_TYPE_UNSPECIFIED'
}

/**
 * Restriction state for a category of actions on a parent message. The
 * category is identified by the field name on the parent (e.g.
 * `intl_restriction`); the specific cause within that category is identified
 * by `reason`. Independent restriction categories live on independent fields
 * of this type.
 */
export type Instacart_Care_Tools_V1_ActionRestriction = {
  __typename?: 'instacart_care_tools_v1_ActionRestriction';
  /** Cause of the restriction. REASON_UNSPECIFIED when `restricted` is false. */
  reason?: Maybe<Instacart_Care_Tools_V1_ActionRestriction_Reason>;
  /**
   * True when actions in the parent's restriction category are unavailable
   * on this entity; false otherwise.
   */
  restricted?: Maybe<Scalars['Boolean']>;
};

/** Cause of an ActionRestriction. */
export enum Instacart_Care_Tools_V1_ActionRestriction_Reason {
  /**
   * Restriction applies because the order's market is in the EU Costco
   * restricted set.
   */
  ReasonEuCostcoOrder = 'REASON_EU_COSTCO_ORDER',
  /**
   * Restriction applies because the user's market is in the EU SMS
   * disabled set.
   */
  ReasonEuSmsDisabled = 'REASON_EU_SMS_DISABLED',
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_ActiveAttributesForCountry = {
  __typename?: 'instacart_care_tools_v1_ActiveAttributesForCountry';
  attributes?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_UserAttribute>>>;
  countryId?: Maybe<Scalars['BigInt']>;
};

/**
 * Actor identifies who is performing an action. IPP agents are keyed by their
 * IPP account id (int64) and may also carry an IPP canonical id (UUID) for
 * downstream requester-name resolution; IC agents and customers are keyed by
 * their int64 IC user id.
 */
export type Instacart_Care_Tools_V1_Actor_Input = {
  /** An Instacart agent, identified by their IC user id. */
  instacartAgent?: InputMaybe<Instacart_Care_Tools_V1_InstacartAgent_Input>;
  /** An Instacart customer (e.g. self-serve), identified by their IC user id. */
  instacartCustomer?: InputMaybe<Instacart_Care_Tools_V1_InstacartCustomer_Input>;
  /** An IPP agent. */
  ippAgent?: InputMaybe<Instacart_Care_Tools_V1_IppAgent_Input>;
};

export type Instacart_Care_Tools_V1_AddFreeMonthSubscriptionRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  caseId?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_AddFreeMonthSubscriptionResponse = {
  __typename?: 'instacart_care_tools_v1_AddFreeMonthSubscriptionResponse';
  membership?: Maybe<Instacart_Care_Tools_V1_InstacartPlusMembership>;
};

/**
 * Pass-through to
 * instacart.fulfillment.in_store.fulfillment_picking.v1.FulfillmentPickingService#AddOrUpdateFulfillmentOrderLine.
 * Scoped to the update operations care agents need (mark found / mark not found)
 * using CareTools-native types; the service layer maps these to the downstream
 * request.
 */
export type Instacart_Care_Tools_V1_AddOrUpdateFulfillmentOrderLineRequest_Input = {
  /** Optional free-text audit context (forwarded downstream as ActorMetadata.note). */
  actorNote?: InputMaybe<Scalars['String']>;
  /** Who is performing the action (forwarded downstream). */
  actorType?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentPickingActorType>;
  markFound?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentOrderLineMarkFound_Input>;
  markNotFound?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentOrderLineMarkNotFound_Input>;
  /** The order delivery the line belongs to. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  /** The order item to update. */
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  /** Optional work unit id. */
  workUnitId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_AddOrUpdateFulfillmentOrderLineResponse = {
  __typename?: 'instacart_care_tools_v1_AddOrUpdateFulfillmentOrderLineResponse';
  /** The id of the affected order item. */
  orderItemId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_AddressResponse = {
  __typename?: 'instacart_care_tools_v1_AddressResponse';
  apartmentNumber?: Maybe<Scalars['String']>;
  businessName?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['BigInt']>;
  floorNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  postalCode?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
  zoneId?: Maybe<Scalars['BigInt']>;
  zoneName?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_AdminAuditContext_Input = {
  accountId?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Instacart_Care_Tools_V1_AccountType>;
  remoteIp?: InputMaybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_AdminCancelSubscriptionRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  adminId?: InputMaybe<Scalars['BigInt']>;
  caseId?: InputMaybe<Scalars['String']>;
  hasElevatedRefundPermission?: InputMaybe<Scalars['Boolean']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  subscriptionId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_AdminCancelSubscriptionResponse = {
  __typename?: 'instacart_care_tools_v1_AdminCancelSubscriptionResponse';
  membership?: Maybe<Instacart_Care_Tools_V1_InstacartPlusMembership>;
  refundAmount?: Maybe<GoogleTypeMoney>;
  wasRefunded?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Care_Tools_V1_AdminRefundIneligibilityReason {
  AdminRefundIneligibilityReasonFreeSubscription = 'ADMIN_REFUND_INELIGIBILITY_REASON_FREE_SUBSCRIPTION',
  AdminRefundIneligibilityReasonGracePeriodExceeded = 'ADMIN_REFUND_INELIGIBILITY_REASON_GRACE_PERIOD_EXCEEDED',
  AdminRefundIneligibilityReasonOrdersPlaced = 'ADMIN_REFUND_INELIGIBILITY_REASON_ORDERS_PLACED',
  AdminRefundIneligibilityReasonPartnershipRedeemed = 'ADMIN_REFUND_INELIGIBILITY_REASON_PARTNERSHIP_REDEEMED',
  AdminRefundIneligibilityReasonUnspecified = 'ADMIN_REFUND_INELIGIBILITY_REASON_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_AppeasementDecision = {
  __typename?: 'instacart_care_tools_v1_AppeasementDecision';
  decision?: Maybe<Instacart_Care_Tools_V1_AppeasementDecision_Decision>;
  /**
   * Only relevant when decision is DENIED. Indicates whether the denial
   * was triggered by a rule that follows the GIFG (Get It Fresh Guarantee)
   * 3-step escalation system:
   * 1st violation: issue credits + send warning email
   * 2nd violation: issue credits + send ineligible email
   * 3rd violation: block (no credits, no email)
   * When true, the consumer should check CareEmailLog to determine
   * which step applies. When false or decision is not DENIED,
   * the denial should be treated as an immediate block.
   */
  eligibleForGifgCheck?: Maybe<Scalars['Boolean']>;
  /**
   * Authoritative final GIFG grace decision. An unset message indicates that no final GIFG grace decision was
   * provided.
   */
  gifgGraceDecision?: Maybe<Instacart_Care_Tools_V1_GifgGraceDecision>;
  /**
   * Whether product taxonomy permits this appeasement to receive GIFG grace. Consumers must treat an unset value as
   * eligible to preserve legacy behavior when product taxonomy eligibility was not evaluated.
   */
  gifgItemTaxonomyEligible?: Maybe<Scalars['Boolean']>;
  /**
   * A list of keys representing the rules that "failed" leading to the denial, if any - these can be used
   * to generate human-readable explanations
   */
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A list of strings to be added as tags to the ticket for both information and triggers when an appeasement
   * is denied - similar to reasons, but one reason could add zero, one, or multiple tags
   */
  ticketTags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Whether or not the appeasement is approved - this is an enum rather than a boolean to allow for options besides
 * just approve/deny, but we expect that the current "warning" level will (shortly) be handled in this service
 * rather than being passed back to the caller, and generally options here should be limited so the caller doesn't
 * have to implement additional business logic
 */
export enum Instacart_Care_Tools_V1_AppeasementDecision_Decision {
  Approved = 'APPROVED',
  DecisionUnspecified = 'DECISION_UNSPECIFIED',
  Denied = 'DENIED',
  Warning = 'WARNING'
}

/** A single banner returned by the service. */
export type Instacart_Care_Tools_V1_Banner = {
  __typename?: 'instacart_care_tools_v1_Banner';
  header?: Maybe<Scalars['String']>;
  /** Stable snake_case identifier for the banner type (e.g. "wine_shop", "fraud"). */
  id?: Maybe<Scalars['String']>;
  /** Absolute HTTPS URL for an optional banner image. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Absolute HTTPS URL for an optional "learn more" link. */
  infoLink?: Maybe<Scalars['String']>;
  /** Human-readable anchor text for info_link. Required when info_link is set. */
  infoLinkText?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  severity?: Maybe<Instacart_Care_Tools_V1_BannerSeverity>;
};

/** Severity level for a banner. */
export enum Instacart_Care_Tools_V1_BannerSeverity {
  BannerSeverityDanger = 'BANNER_SEVERITY_DANGER',
  BannerSeverityInfo = 'BANNER_SEVERITY_INFO',
  BannerSeverityPrimary = 'BANNER_SEVERITY_PRIMARY',
  BannerSeverityUnspecified = 'BANNER_SEVERITY_UNSPECIFIED',
  BannerSeverityWarning = 'BANNER_SEVERITY_WARNING'
}

export type Instacart_Care_Tools_V1_ChargeLog = {
  __typename?: 'instacart_care_tools_v1_ChargeLog';
  /** Deprecated, do not use, not populated. */
  amount?: Maybe<GoogleTypeMoney>;
  /** The amount we authed the card */
  authAmount?: Maybe<GoogleTypeMoney>;
  /** The timestamp of when the charge was authorized. */
  authedAt?: Maybe<Scalars['DateTime']>;
  /** The amount we submitted to the Payment Service Provider for capture */
  captureAmount?: Maybe<GoogleTypeMoney>;
  /** The timestamp when charge is planned to be captured. */
  captureAt?: Maybe<Scalars['DateTime']>;
  /** The amount we actually captured at the end. */
  capturedAmount?: Maybe<GoogleTypeMoney>;
  /** The timestamp when charge was actually captured. */
  capturedAt?: Maybe<Scalars['DateTime']>;
  /** The type of the charge */
  chargeType?: Maybe<Scalars['String']>;
  /** When the charge was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Description of the charge. */
  description?: Maybe<Scalars['String']>;
  /** Gateway transaction ID (e.g. Stripe charge ID, PayPal transaction ID). */
  gatewayTransactionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** The auth amount with overcapture. Say the order was $100, we overcapture by $5 to account for replacements and updated, so $105 total */
  initialCapturableAmount?: Maybe<GoogleTypeMoney>;
  /** The payment instrument associated to the charge log */
  instrumentDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail>;
  /** The name of the payment gateway */
  paymentGateway?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_ChatMessage = {
  __typename?: 'instacart_care_tools_v1_ChatMessage';
  /** The body of the message. */
  body?: Maybe<Scalars['String']>;
  /** The time of creation. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the message. */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * The URL of the image in the message.
   * e.g. https://d2syimmrmqkckt.cloudfront.net/chatmessage/image/254f4bf8-2d13-11ec-8d3d-0242ac130003.jpg
   */
  image?: Maybe<Scalars['String']>;
  /** The order delivery ID. */
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  /** Whether or not the message was read. */
  read?: Maybe<Scalars['Boolean']>;
  /** Time the message was read at. */
  readAt?: Maybe<Scalars['DateTime']>;
  /** The recipient ID. */
  recipientId?: Maybe<Scalars['BigInt']>;
  /** The type of recipient. */
  recipientType?: Maybe<Scalars['String']>;
  /** The sender ID. */
  senderId?: Maybe<Scalars['BigInt']>;
  /** The type of sender. */
  senderType?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_CheckAdminRefundEligibilityRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  subscriptionId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CheckAdminRefundEligibilityResponse = {
  __typename?: 'instacart_care_tools_v1_CheckAdminRefundEligibilityResponse';
  eligible?: Maybe<Scalars['Boolean']>;
  ineligibilityReason?: Maybe<Instacart_Care_Tools_V1_AdminRefundIneligibilityReason>;
};

export type Instacart_Care_Tools_V1_CommonIdentityUser = {
  __typename?: 'instacart_care_tools_v1_CommonIdentityUser';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isolationContext?: Maybe<Instacart_Care_Tools_V1_IsolationContext>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_CreateAddressForUserRequest_Input = {
  accessCode?: InputMaybe<Scalars['String']>;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  deliveryOption?: InputMaybe<Instacart_Care_Tools_V1_DeliveryOptionType>;
  floorNumber?: InputMaybe<Scalars['String']>;
  instructions?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  skipValidation?: InputMaybe<Scalars['Boolean']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  updateActiveAddress?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CreateAddressForUserResponse = {
  __typename?: 'instacart_care_tools_v1_CreateAddressForUserResponse';
  address?: Maybe<Instacart_Care_Tools_V1_AddressResponse>;
};

export type Instacart_Care_Tools_V1_CreateCustomerMiaIssueFailure = {
  __typename?: 'instacart_care_tools_v1_CreateCustomerMIAIssueFailure';
  errorMessage?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_CreateCustomerMiaIssueRequest_Input = {
  caseNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['BigInt']>;
  /** Delivery the MIA issue is written against. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  requester?: InputMaybe<Instacart_Care_Tools_V1_Actor_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  uiOrigin?: InputMaybe<Instacart_Care_Tools_V1_UiOrigin>;
};

export type Instacart_Care_Tools_V1_CreateCustomerMiaIssueResponse = {
  __typename?: 'instacart_care_tools_v1_CreateCustomerMIAIssueResponse';
  failure?: Maybe<Instacart_Care_Tools_V1_CreateCustomerMiaIssueFailure>;
  success?: Maybe<Instacart_Care_Tools_V1_CreateCustomerMiaIssueSuccess>;
};

export type Instacart_Care_Tools_V1_CreateCustomerMiaIssueSuccess = {
  __typename?: 'instacart_care_tools_v1_CreateCustomerMIAIssueSuccess';
  orderIssueId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CreateNoteForOrderRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  note?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_CreateNoteForOrderResponse = {
  __typename?: 'instacart_care_tools_v1_CreateNoteForOrderResponse';
  note?: Maybe<Instacart_Care_Tools_V1_Note>;
};

export type Instacart_Care_Tools_V1_CreateNoteForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  note?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CreateNoteForUserResponse = {
  __typename?: 'instacart_care_tools_v1_CreateNoteForUserResponse';
  note?: Maybe<Instacart_Care_Tools_V1_Note>;
};

export type Instacart_Care_Tools_V1_CreateOrderReturnRequest_Input = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  returnReasonCode?: InputMaybe<Instacart_Care_Tools_V1_ReturnReasonCode>;
  returnRequesterType?: InputMaybe<Instacart_Care_Tools_V1_ReturnRequesterType>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_CreateOrderReturnResponse = {
  __typename?: 'instacart_care_tools_v1_CreateOrderReturnResponse';
  returnId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CreateUserShopperBanRequest_Input = {
  appliesTo?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
  reason?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  userShopperBanReasonId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CreateUserShopperBanResponse = {
  __typename?: 'instacart_care_tools_v1_CreateUserShopperBanResponse';
  userShopperBan?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBan>;
};

/** Context for evaluating customer page banners. */
export type Instacart_Care_Tools_V1_CustomerContext_Input = {
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_CustomerSpendingMetrics = {
  __typename?: 'instacart_care_tools_v1_CustomerSpendingMetrics';
  /** Lifetime appeasements amount in USD. */
  appeasementsUsd?: Maybe<Scalars['Float']>;
  /** Percentage value, e.g. 12.34 means 12.34%. */
  creditToSpendRatioPct?: Maybe<Scalars['Float']>;
  /** Lifetime refunds amount in USD. */
  refundsUsd?: Maybe<Scalars['Float']>;
  /** Lifetime total order count. */
  totalOrderCount?: Maybe<Scalars['BigInt']>;
  /** Lifetime GMV / total spend in USD. */
  totalSpendUsd?: Maybe<Scalars['Float']>;
};

export type Instacart_Care_Tools_V1_DeleteUserShopperBanRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export enum Instacart_Care_Tools_V1_DeliveryOptionType {
  DeliveryOptionTypeCall = 'DELIVERY_OPTION_TYPE_CALL',
  DeliveryOptionTypeNoCommunication = 'DELIVERY_OPTION_TYPE_NO_COMMUNICATION',
  DeliveryOptionTypeRingDoorbell = 'DELIVERY_OPTION_TYPE_RING_DOORBELL',
  DeliveryOptionTypeUnspecified = 'DELIVERY_OPTION_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_DeliveryPhoto = {
  __typename?: 'instacart_care_tools_v1_DeliveryPhoto';
  /** ID of the delivery photo. */
  id?: Maybe<Scalars['BigInt']>;
  /** URL of the delivery photo. */
  url?: Maybe<Scalars['String']>;
};

/** Probably will use another enum in final version, but this is fine for dev. */
export enum Instacart_Care_Tools_V1_DeliveryStatus {
  AcknowledgedByFulfillment = 'ACKNOWLEDGED_BY_FULFILLMENT',
  Canceled = 'CANCELED',
  Delivered = 'DELIVERED',
  Delivering = 'DELIVERING',
  DeliveryStatusUnspecified = 'DELIVERY_STATUS_UNSPECIFIED',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Received = 'RECEIVED',
  Shopping = 'SHOPPING',
  ShoppingComplete = 'SHOPPING_COMPLETE'
}

export type Instacart_Care_Tools_V1_FindRelatedUsersRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_FindRelatedUsersResponse = {
  __typename?: 'instacart_care_tools_v1_FindRelatedUsersResponse';
  users?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_RelatedUser>>>;
};

export type Instacart_Care_Tools_V1_FindUsersError = {
  __typename?: 'instacart_care_tools_v1_FindUsersError';
  message?: Maybe<Scalars['String']>;
  reason?: Maybe<Instacart_Care_Tools_V1_FindUsersErrorReason>;
  searchType?: Maybe<Instacart_Care_Tools_V1_UserSearchType>;
};

export enum Instacart_Care_Tools_V1_FindUsersErrorReason {
  FindUsersErrorReasonNameTooManyTokens = 'FIND_USERS_ERROR_REASON_NAME_TOO_MANY_TOKENS',
  FindUsersErrorReasonUnavailable = 'FIND_USERS_ERROR_REASON_UNAVAILABLE',
  FindUsersErrorReasonUnspecified = 'FIND_USERS_ERROR_REASON_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_FindUsersRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  /** When true, name searches use exact match instead of prefix. */
  exactMatch?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  query?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_FindUsersResponse = {
  __typename?: 'instacart_care_tools_v1_FindUsersResponse';
  errors?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_FindUsersError>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  users?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_UserSearchResult>>>;
};

/**
 * Reason a care agent is force completing an order. Mirrors the values of
 * instacart.fulfillment.domains.dispatch.v1.ForceCompleteReason; the service
 * layer maps these to the downstream enum.
 */
export enum Instacart_Care_Tools_V1_ForceCompleteOrderReason {
  ForceCompleteOrderReasonAddressChanged = 'FORCE_COMPLETE_ORDER_REASON_ADDRESS_CHANGED',
  ForceCompleteOrderReasonAppBug = 'FORCE_COMPLETE_ORDER_REASON_APP_BUG',
  ForceCompleteOrderReasonCatalogError = 'FORCE_COMPLETE_ORDER_REASON_CATALOG_ERROR',
  ForceCompleteOrderReasonInvalidCustomerId = 'FORCE_COMPLETE_ORDER_REASON_INVALID_CUSTOMER_ID',
  ForceCompleteOrderReasonMarketplaceOps = 'FORCE_COMPLETE_ORDER_REASON_MARKETPLACE_OPS',
  ForceCompleteOrderReasonPickupOrder = 'FORCE_COMPLETE_ORDER_REASON_PICKUP_ORDER',
  ForceCompleteOrderReasonPoorConnectivity = 'FORCE_COMPLETE_ORDER_REASON_POOR_CONNECTIVITY',
  ForceCompleteOrderReasonReturnUndeliverable = 'FORCE_COMPLETE_ORDER_REASON_RETURN_UNDELIVERABLE',
  ForceCompleteOrderReasonShopperDidNotAttemptIdScan = 'FORCE_COMPLETE_ORDER_REASON_SHOPPER_DID_NOT_ATTEMPT_ID_SCAN',
  ForceCompleteOrderReasonUnspecified = 'FORCE_COMPLETE_ORDER_REASON_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_ForceCompleteOrderRequest_Input = {
  /** Free-text context for the force complete (e.g. case notes). */
  description?: InputMaybe<Scalars['String']>;
  /**
   * IPP account id of the agent performing the force complete. Sent downstream
   * as the acting actor id.
   */
  ippAccountId?: InputMaybe<Scalars['BigInt']>;
  /** The order delivery to force complete. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  /** Reason for force completing the order. */
  reason?: InputMaybe<Instacart_Care_Tools_V1_ForceCompleteOrderReason>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

/**
 * Mark an existing order line as found. Minimal mirror of
 * order_item_payloads.v1.MarkFound (only the fields care agents set).
 */
export type Instacart_Care_Tools_V1_FulfillmentOrderLineMarkFound_Input = {
  /** Quantity actually delivered. */
  deliveredQuantity?: InputMaybe<Scalars['BigInt']>;
  /** Weight actually delivered, for weighted items. */
  deliveredWeight?: InputMaybe<Scalars['Float']>;
};

/**
 * Mark an existing order line as not found. Minimal mirror of
 * order_item_payloads.v1.MarkNotFound (marked_at is set by the service layer).
 */
export type Instacart_Care_Tools_V1_FulfillmentOrderLineMarkNotFound_Input = {
  refundReason?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentOrderLineRefundReason>;
};

/**
 * Why an item was refunded / marked not found. Mirrors
 * instacart.fulfillment.public_apis.picking.order_item_payloads.v1.RefundReason.
 */
export enum Instacart_Care_Tools_V1_FulfillmentOrderLineRefundReason {
  FulfillmentOrderLineRefundReasonChangedMind = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_CHANGED_MIND',
  FulfillmentOrderLineRefundReasonDietaryRestrictions = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_DIETARY_RESTRICTIONS',
  FulfillmentOrderLineRefundReasonNotCarried = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_NOT_CARRIED',
  FulfillmentOrderLineRefundReasonNoAdequateReplacements = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_NO_ADEQUATE_REPLACEMENTS',
  FulfillmentOrderLineRefundReasonOther = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_OTHER',
  FulfillmentOrderLineRefundReasonOutOfStock = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_OUT_OF_STOCK',
  FulfillmentOrderLineRefundReasonPoorQuality = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_POOR_QUALITY',
  FulfillmentOrderLineRefundReasonPrescriptionNotReady = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_PRESCRIPTION_NOT_READY',
  FulfillmentOrderLineRefundReasonPrescriptionNotScannable = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_PRESCRIPTION_NOT_SCANNABLE',
  FulfillmentOrderLineRefundReasonUnknown = 'FULFILLMENT_ORDER_LINE_REFUND_REASON_UNKNOWN'
}

/**
 * Who is performing the picking action. Mirrors
 * instacart.fulfillment.in_store.fulfillment_picking.v1.ActorType; the service
 * layer maps these to the downstream enum.
 * Only the actor types care agents use are exposed here; the service layer maps
 * each to the corresponding downstream ActorType by name.
 */
export enum Instacart_Care_Tools_V1_FulfillmentPickingActorType {
  /** IPP Instacart agent */
  FulfillmentPickingActorTypeIppInternalUser = 'FULFILLMENT_PICKING_ACTOR_TYPE_IPP_INTERNAL_USER',
  /** Shopper Carebot agent */
  FulfillmentPickingActorTypeShopperCarebotUser = 'FULFILLMENT_PICKING_ACTOR_TYPE_SHOPPER_CAREBOT_USER',
  FulfillmentPickingActorTypeUnknown = 'FULFILLMENT_PICKING_ACTOR_TYPE_UNKNOWN'
}

export type Instacart_Care_Tools_V1_GetActiveBenefitsRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetActiveBenefitsResponse = {
  __typename?: 'instacart_care_tools_v1_GetActiveBenefitsResponse';
  benefits?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Care_Tools_V1_GetAppeasementValueGrantPolicyIdRequest_Input = {
  /**
   * Appeasement value currency (ISO 4217 code, e.g. "USD", "CAD"). Only consulted for
   * overrides whose resolution depends on currency; omit if unknown. Matched exactly;
   * lowercase or unexpected values are treated as if the field were unset (response
   * value_grant_policy_id will be unset for overrides that would have matched).
   */
  currency?: InputMaybe<Scalars['String']>;
  /**
   * Appeasement reason. Only consulted for overrides whose resolution depends on
   * reason; omit if unknown. Matched exactly; unexpected values are treated as if
   * the field were unset (response value_grant_policy_id will be unset for overrides
   * that would have matched).
   */
  reason?: InputMaybe<Scalars['String']>;
  /** Store configuration ID (required). */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetAppeasementValueGrantPolicyIdResponse = {
  __typename?: 'instacart_care_tools_v1_GetAppeasementValueGrantPolicyIdResponse';
  /**
   * The override VGP ID for the provided context. Unset when no applicable override
   * exists; callers should treat unset as "no override" (fall back to default VGP
   * resolution on the caller side) rather than as an error.
   */
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetCommonIdentityUsersRequest_Input = {
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetCommonIdentityUsersResponse = {
  __typename?: 'instacart_care_tools_v1_GetCommonIdentityUsersResponse';
  users?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_CommonIdentityUser>>>;
};

export type Instacart_Care_Tools_V1_GetCustomerSpendingSummaryRequest_Input = {
  countryId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetCustomerSpendingSummaryResponse = {
  __typename?: 'instacart_care_tools_v1_GetCustomerSpendingSummaryResponse';
  avgBasketSize?: Maybe<Scalars['Float']>;
  creditAvailable?: Maybe<Scalars['Float']>;
  creditRefundPct?: Maybe<Scalars['Float']>;
  creditSpendPct?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  lifetimeCredits?: Maybe<Scalars['Float']>;
  totalOrders?: Maybe<Scalars['BigInt']>;
  totalSpend?: Maybe<Scalars['Float']>;
};

export type Instacart_Care_Tools_V1_GetCustomerSpendingSummaryV2Request_Input = {
  /** Instacart user ID / customer ID. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetCustomerSpendingSummaryV2Response = {
  __typename?: 'instacart_care_tools_v1_GetCustomerSpendingSummaryV2Response';
  /** Metrics for the requested customer combined with linked customers. */
  combinedMetrics?: Maybe<Instacart_Care_Tools_V1_CustomerSpendingMetrics>;
  /** Metrics for the requested customer. */
  userMetrics?: Maybe<Instacart_Care_Tools_V1_CustomerSpendingMetrics>;
};

export type Instacart_Care_Tools_V1_GetHouseholdByUserRequest_Input = {
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetHouseholdByUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetHouseholdByUserResponse';
  household?: Maybe<Instacart_Care_Tools_V1_Household>;
};

export type Instacart_Care_Tools_V1_GetInstacartPlusMembershipRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetInstacartPlusMembershipResponse = {
  __typename?: 'instacart_care_tools_v1_GetInstacartPlusMembershipResponse';
  memberships?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_InstacartPlusMembership>>>;
};

export type Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetLatestActiveAttributeForUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetLatestActiveAttributeForUserResponse';
  activeAttribute?: Maybe<Instacart_Care_Tools_V1_LatestActiveAttributeForUser>;
};

export type Instacart_Care_Tools_V1_GetLifetimeSavingsForUserRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetLifetimeSavingsForUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetLifetimeSavingsForUserResponse';
  deliveryFeeSavings?: Maybe<GoogleTypeMoney>;
  serviceFeeSavings?: Maybe<GoogleTypeMoney>;
  totalSavings?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Care_Tools_V1_GetLinkedUserAccountsRequest_Input = {
  includeDeactivatedAccounts?: InputMaybe<Scalars['Boolean']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetLinkedUserAccountsResponse = {
  __typename?: 'instacart_care_tools_v1_GetLinkedUserAccountsResponse';
  linkedUserAccounts?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_LinkedUserAccount>>>;
};

export type Instacart_Care_Tools_V1_GetOrderByIdBasicRequest_Input = {
  /** Whether to include the customer name in the response. Adds a network request. */
  includeCustomerName?: InputMaybe<Scalars['Boolean']>;
  ippAccountUuid?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_GetOrderByIdBasicResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderByIdBasicResponse';
  order?: Maybe<Instacart_Care_Tools_V1_OrderSummary>;
};

export type Instacart_Care_Tools_V1_GetOrderByIdRequest_Input = {
  ippAccountUuid?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_GetOrderByIdResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderByIdResponse';
  order?: Maybe<Instacart_Care_Tools_V1_Order>;
};

/** The order date axis the date range applies to. */
export enum Instacart_Care_Tools_V1_GetOrderCountsByRetailerRequest_DateField {
  /** Filter on the order creation date. */
  DateFieldCreation = 'DATE_FIELD_CREATION',
  /** Filter on the order fulfillment window. */
  DateFieldFulfillment = 'DATE_FIELD_FULFILLMENT',
  DateFieldUnspecified = 'DATE_FIELD_UNSPECIFIED'
}

/**
 * Aggregated order counts grouped by status for a retailer over a bounded date
 * range. Reuses ListOrdersByRetailerRequest's OrderType/OrderSource/OrderStatus
 * vocabulary so the two retailer-scoped order endpoints share one filter model.
 */
export type Instacart_Care_Tools_V1_GetOrderCountsByRetailerRequest_Input = {
  /** Which date axis the range applies to - always required. */
  dateField?: InputMaybe<Instacart_Care_Tools_V1_GetOrderCountsByRetailerRequest_DateField>;
  /** Start of the date range, inclusive - always required. */
  from?: InputMaybe<Scalars['DateTime']>;
  /** The IPP account uuid of the person making the request. */
  ippAccountUuid?: InputMaybe<Scalars['String']>;
  /** Optionally filter by order source. UNSPECIFIED = all sources. */
  orderSource?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderSource>;
  /** Optionally filter by order type. UNSPECIFIED = all types. */
  orderType?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderType>;
  /**
   * The ID of the retailer to count orders for - required unless
   * retailer_ids is set.
   */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Retailer IDs to count orders across. Exactly one of this field and
   * retailer_id must be set; requests setting both are rejected. Empty /
   * unset falls back to retailer_id. Counts are summed across these
   * retailers.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally filter by retailer location IDs. Empty = all locations for the retailer. */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The user making the request. */
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  /** End of the date range, exclusive - always required. */
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Care_Tools_V1_GetOrderCountsByRetailerResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderCountsByRetailerResponse';
  /**
   * One entry per status bucket. Buckets with a zero count are still returned
   * so clients can render a stable panel across refreshes.
   */
  statusCounts?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_GetOrderCountsByRetailerResponse_StatusCount>>>;
  /** Total orders matching the request filters. */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** Count of orders in a single status bucket. */
export type Instacart_Care_Tools_V1_GetOrderCountsByRetailerResponse_StatusCount = {
  __typename?: 'instacart_care_tools_v1_GetOrderCountsByRetailerResponse_StatusCount';
  /** Number of orders in this bucket matching the request filters. */
  count?: Maybe<Scalars['BigInt']>;
  /** The order status bucket. */
  status?: Maybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderStatus>;
};

export type Instacart_Care_Tools_V1_GetOrderRequest_Input = {
  orderReference?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_GetOrderResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderResponse';
  order?: Maybe<Instacart_Care_Tools_V1_Order>;
};

export type Instacart_Care_Tools_V1_GetOrderReturnEligibilityRequest_Input = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  returnReasonCode?: InputMaybe<Instacart_Care_Tools_V1_ReturnReasonCode>;
  returnRequesterType?: InputMaybe<Instacart_Care_Tools_V1_ReturnRequesterType>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_GetOrderReturnEligibilityResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderReturnEligibilityResponse';
  eligible?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_ReturnItem>>>;
  /** Deprecated. Use GetOrderReturn instead. */
  returnBatchId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetOrderReturnRequest_Input = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_GetOrderReturnResponse = {
  __typename?: 'instacart_care_tools_v1_GetOrderReturnResponse';
  /** The ID of the return batch. Unset if no return exists. */
  returnBatchId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetUserRequest_Input = {
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_GetUserResponse = {
  __typename?: 'instacart_care_tools_v1_GetUserResponse';
  user?: Maybe<Instacart_Care_Tools_V1_User>;
};

export type Instacart_Care_Tools_V1_GifgGraceDecision = {
  __typename?: 'instacart_care_tools_v1_GifgGraceDecision';
  /**
   * Effective escalation step for the current request. First- or second-violation accompanies allowed grace;
   * third-or-more may accompany denied grace, while non-GIFG and taxonomy-blocked requests use unspecified.
   */
  escalationStep?: Maybe<Instacart_Customers_Order_Issues_V1_GifgEscalationStep>;
  /**
   * Final GIFG grace decision after applying escalation policy and taxonomy enforcement. True only when the current
   * request receives first- or second-violation grace.
   */
  graceAllowed?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_Household = {
  __typename?: 'instacart_care_tools_v1_Household';
  householdMembers?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_HouseholdUser>>>;
  id?: Maybe<Scalars['BigInt']>;
  isFull?: Maybe<Scalars['Boolean']>;
  ownerUserId?: Maybe<Scalars['BigInt']>;
  setupComplete?: Maybe<Scalars['Boolean']>;
  sharableInviteUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_HouseholdUser = {
  __typename?: 'instacart_care_tools_v1_HouseholdUser';
  avatarImageUrl?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isOwner?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_InstacartAgent_Input = {
  icUserId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_InstacartCustomer_Input = {
  icUserId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_InstacartPlusMembership = {
  __typename?: 'instacart_care_tools_v1_InstacartPlusMembership';
  autorenew?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  countryId?: Maybe<Scalars['BigInt']>;
  discount?: Maybe<GoogleTypeMoney>;
  endsOn?: Maybe<Scalars['DateTime']>;
  renewalPrice?: Maybe<GoogleTypeMoney>;
  startsOn?: Maybe<Scalars['DateTime']>;
  subscriptionId?: Maybe<Scalars['BigInt']>;
  termLength?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_IppAgent_Input = {
  /** Required. Identifies the agent; used directly as the requester id. */
  ippAccountId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional. Carried through to the appeasement site scope for downstream
   * requester-name resolution; not used to identify the agent.
   */
  ippCanonicalId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_IsolationContext = {
  __typename?: 'instacart_care_tools_v1_IsolationContext';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_IssueIcPlusFreeMonthFailure = {
  __typename?: 'instacart_care_tools_v1_IssueIcPlusFreeMonthFailure';
  decision?: Maybe<Instacart_Care_Tools_V1_AppeasementDecision>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_IssueIcPlusFreeMonthRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  caseNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  requester?: InputMaybe<Instacart_Care_Tools_V1_Actor_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  uiOrigin?: InputMaybe<Instacart_Care_Tools_V1_UiOrigin>;
};

export type Instacart_Care_Tools_V1_IssueIcPlusFreeMonthResponse = {
  __typename?: 'instacart_care_tools_v1_IssueIcPlusFreeMonthResponse';
  failure?: Maybe<Instacart_Care_Tools_V1_IssueIcPlusFreeMonthFailure>;
  success?: Maybe<Instacart_Care_Tools_V1_IssueIcPlusFreeMonthSuccess>;
};

export type Instacart_Care_Tools_V1_IssueIcPlusFreeMonthSuccess = {
  __typename?: 'instacart_care_tools_v1_IssueIcPlusFreeMonthSuccess';
  appeasementRequestId?: Maybe<Scalars['BigInt']>;
  decision?: Maybe<Instacart_Care_Tools_V1_AppeasementDecision>;
  subscriptionId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_IssuePoorServiceCreditFailure = {
  __typename?: 'instacart_care_tools_v1_IssuePoorServiceCreditFailure';
  decision?: Maybe<Instacart_Care_Tools_V1_AppeasementDecision>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_IssuePoorServiceCreditRequest_Input = {
  caseNumber?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  reason?: InputMaybe<Scalars['String']>;
  requester?: InputMaybe<Instacart_Care_Tools_V1_Actor_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  uiOrigin?: InputMaybe<Instacart_Care_Tools_V1_UiOrigin>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
};

export type Instacart_Care_Tools_V1_IssuePoorServiceCreditResponse = {
  __typename?: 'instacart_care_tools_v1_IssuePoorServiceCreditResponse';
  failure?: Maybe<Instacart_Care_Tools_V1_IssuePoorServiceCreditFailure>;
  success?: Maybe<Instacart_Care_Tools_V1_IssuePoorServiceCreditSuccess>;
};

export type Instacart_Care_Tools_V1_IssuePoorServiceCreditSuccess = {
  __typename?: 'instacart_care_tools_v1_IssuePoorServiceCreditSuccess';
  appeasementRequestId?: Maybe<Scalars['BigInt']>;
  decision?: Maybe<Instacart_Care_Tools_V1_AppeasementDecision>;
};

export type Instacart_Care_Tools_V1_LatestActiveAttributeForUser = {
  __typename?: 'instacart_care_tools_v1_LatestActiveAttributeForUser';
  addressId?: Maybe<Scalars['BigInt']>;
  countryId?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<Scalars['String']>;
  oauthApplicationId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  timeZoneName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_LinkIsolatedUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  isolatedUserId?: InputMaybe<Scalars['BigInt']>;
  marketplaceUserId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_LinkIsolatedUserResponse = {
  __typename?: 'instacart_care_tools_v1_LinkIsolatedUserResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_LinkedUserAccount = {
  __typename?: 'instacart_care_tools_v1_LinkedUserAccount';
  accountType?: Maybe<Instacart_Care_Tools_V1_LinkedUserAccount_AccountType>;
  active?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  identityStrategy?: Maybe<Instacart_Care_Tools_V1_LinkedUserAccount_IdentityStrategy>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_LinkedUserAccount_AccountType {
  AccountTypeUnknown = 'ACCOUNT_TYPE_UNKNOWN',
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export enum Instacart_Care_Tools_V1_LinkedUserAccount_IdentityStrategy {
  AuthDelegated = 'AUTH_DELEGATED',
  AuthRequired = 'AUTH_REQUIRED',
  IdentityStrategyUnknown = 'IDENTITY_STRATEGY_UNKNOWN'
}

export type Instacart_Care_Tools_V1_ListActiveAttributesByCountryRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListActiveAttributesByCountryResponse = {
  __typename?: 'instacart_care_tools_v1_ListActiveAttributesByCountryResponse';
  countries?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_ActiveAttributesForCountry>>>;
};

export type Instacart_Care_Tools_V1_ListAddressesForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListAddressesForUserResponse = {
  __typename?: 'instacart_care_tools_v1_ListAddressesForUserResponse';
  nodes?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_AddressResponse>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListAdminMoveOrAddChargesPaymentInstrumentsRequest_Input = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListAdminMoveOrAddChargesPaymentInstrumentsResponse = {
  __typename?: 'instacart_care_tools_v1_ListAdminMoveOrAddChargesPaymentInstrumentsResponse';
  paymentInstruments?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_PaymentInstrument>>>;
};

/**
 * Request for banners.
 * The context oneof must match the page_type:
 * PAGE_TYPE_CUSTOMER requires customer_context.
 * PAGE_TYPE_ORDER requires order_context.
 * The server returns INVALID_ARGUMENT if page_type does not match the context.
 */
export type Instacart_Care_Tools_V1_ListBannersRequest_Input = {
  customerContext?: InputMaybe<Instacart_Care_Tools_V1_CustomerContext_Input>;
  orderContext?: InputMaybe<Instacart_Care_Tools_V1_OrderContext_Input>;
  pageType?: InputMaybe<Instacart_Care_Tools_V1_PageType>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_ListBannersResponse = {
  __typename?: 'instacart_care_tools_v1_ListBannersResponse';
  banners?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Banner>>>;
};

export type Instacart_Care_Tools_V1_ListChargeLogsForOrderDeliveryRequest_Input = {
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListChargeLogsForOrderDeliveryResponse = {
  __typename?: 'instacart_care_tools_v1_ListChargeLogsForOrderDeliveryResponse';
  chargeLogs?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_ChargeLog>>>;
};

export type Instacart_Care_Tools_V1_ListNotesForUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListNotesForUserResponse = {
  __typename?: 'instacart_care_tools_v1_ListNotesForUserResponse';
  notes?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Note>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListOrderChatMessagesAndNotesResponse = {
  __typename?: 'instacart_care_tools_v1_ListOrderChatMessagesAndNotesResponse';
  chatMessages?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_ChatMessage>>>;
  notes?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Note>>>;
};

export type Instacart_Care_Tools_V1_ListOrderResolutionsAndAppeasementsRequest_Input = {
  /** The order_id to fetch resolutions and appeasements for. Required. */
  orderId?: InputMaybe<Scalars['BigInt']>;
  /** Service use of the request */
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  /** The user_id of the customer. Required. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListOrderResolutionsAndAppeasementsResponse = {
  __typename?: 'instacart_care_tools_v1_ListOrderResolutionsAndAppeasementsResponse';
  resolutionsAndAppeasements?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement>>>;
  /** Sum of value across all fulfilled entries, in the order's currency. */
  totalIssued?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Care_Tools_V1_ListOrdersByCustomerRequest_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  /** If true, the batch ID for each order will be included in the response. Adds a network request. */
  includeBatchId?: InputMaybe<Scalars['Boolean']>;
  /** If true, the customer's name will be included in the response. Adds a network request. */
  includeCustomerName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the store's name for each order will be included in the response. Adds a network request. */
  includeRetailerLocationName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the retailer's name for each order will be included in the response. Adds a network request. */
  includeRetailerName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the shopper's summary for each order will be included in the response. Adds a network request. */
  includeShopperSummary?: InputMaybe<Scalars['Boolean']>;
  /**
   * If order_id is provided, other filters will be ignored.
   * Used to get the order_delivery_id from the order_id.
   */
  orderId?: InputMaybe<Scalars['BigInt']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListOrdersByCustomerResponse = {
  __typename?: 'instacart_care_tools_v1_ListOrdersByCustomerResponse';
  orders?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderSummary>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_Input = {
  /** If true, the customer's name will be included in the response. Adds a network request. */
  includeCustomerName?: InputMaybe<Scalars['Boolean']>;
  /** If true, the retailer location's name for each order will be included in the response. Adds a network request. */
  includeRetailerLocationName?: InputMaybe<Scalars['Boolean']>;
  /** The IPP account uuid of the person making the request */
  ippAccountUuid?: InputMaybe<Scalars['String']>;
  /** Pagination details */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  /** The ID of the retailer to search by - required unless retailer_ids is set */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Retailer IDs to search across. Exactly one of this field and retailer_id
   * must be set; requests setting both are rejected. Empty / unset falls back
   * to retailer_id.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  scenarioByFulfillmentDate?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_ScenarioByFulfillmentDate_Input>;
  scenarioByOrderId?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_ScenarioByOrderId_Input>;
  /** The user making the request */
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export enum Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderSource {
  /**
   * Orders submitted programmatically by a third-party integrator via the
   * public Retailer API (Connect) rather than through an Instacart-hosted UI.
   */
  OrderSourceApi = 'ORDER_SOURCE_API',
  /**
   * Orders placed on the Instacart-branded consumer marketplace
   * (instacart.com / Instacart mobile apps).
   */
  OrderSourceMarketplace = 'ORDER_SOURCE_MARKETPLACE',
  /**
   * Orders placed on a retailer-branded white-label storefront. Covers
   * both the PBI (Powered By Instacart) platform and the modern SFX
   * (Storefront Pro) platform.
   */
  OrderSourceStorefront = 'ORDER_SOURCE_STOREFRONT',
  /**
   * Orders placed on the legacy Unata white-label platform (historically
   * also called "Storefront Pro" — distinct from the modern SFX platform,
   * which is part of ORDER_SOURCE_STOREFRONT).
   */
  OrderSourceStorefrontPro = 'ORDER_SOURCE_STOREFRONT_PRO',
  OrderSourceUnspecified = 'ORDER_SOURCE_UNSPECIFIED'
}

export enum Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderStatus {
  OrderStatusCanceled = 'ORDER_STATUS_CANCELED',
  OrderStatusComplete = 'ORDER_STATUS_COMPLETE',
  OrderStatusDelivering = 'ORDER_STATUS_DELIVERING',
  OrderStatusNew = 'ORDER_STATUS_NEW',
  OrderStatusProcessing = 'ORDER_STATUS_PROCESSING',
  OrderStatusReadyForPickup = 'ORDER_STATUS_READY_FOR_PICKUP',
  OrderStatusShopping = 'ORDER_STATUS_SHOPPING',
  OrderStatusUnspecified = 'ORDER_STATUS_UNSPECIFIED'
}

export enum Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderType {
  OrderTypeDelivery = 'ORDER_TYPE_DELIVERY',
  OrderTypePickup = 'ORDER_TYPE_PICKUP',
  OrderTypeUnspecified = 'ORDER_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_ScenarioByFulfillmentDate_Input = {
  /** Fulfillment timestamp - from date */
  fulfillmentFrom?: InputMaybe<Scalars['DateTime']>;
  /** Fulfillment timestamp - to date */
  fulfillmentTo?: InputMaybe<Scalars['DateTime']>;
  /** The source of the order, optional. */
  orderSource?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderSource>;
  /** Order statuses to filter by, optional. */
  orderStatuses?: InputMaybe<Array<InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderStatus>>>;
  /** The type of the order, required. */
  orderType?: InputMaybe<Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_OrderType>;
  /** Optionally filter by retailer location IDs */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Care_Tools_V1_ListOrdersByRetailerRequest_ScenarioByOrderId_Input = {
  orderId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListOrdersByRetailerResponse = {
  __typename?: 'instacart_care_tools_v1_ListOrdersByRetailerResponse';
  orders?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderSummary>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerRequest_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListRestaurantOrdersByCustomerResponse = {
  __typename?: 'instacart_care_tools_v1_ListRestaurantOrdersByCustomerResponse';
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  restaurantOrders?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_RestaurantOrder>>>;
};

export type Instacart_Care_Tools_V1_ListUserResolutionsAndAppeasementsRequest_Input = {
  /** Pagination information. Required. */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  /** Service use of the request */
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  /** The user_id of the customer. Required. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListUserResolutionsAndAppeasementsResponse = {
  __typename?: 'instacart_care_tools_v1_ListUserResolutionsAndAppeasementsResponse';
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  resolutionsAndAppeasements?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement>>>;
};

export type Instacart_Care_Tools_V1_ListUserShopperBanReasonsRequest_Input = {
  appliesTo?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_ListUserShopperBanReasonsResponse = {
  __typename?: 'instacart_care_tools_v1_ListUserShopperBanReasonsResponse';
  reasons?: Maybe<Array<Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanReason>>>;
};

export type Instacart_Care_Tools_V1_ListUserShopperBansRequest_Input = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_ListUserShopperBansResponse = {
  __typename?: 'instacart_care_tools_v1_ListUserShopperBansResponse';
  userShopperBans?: Maybe<Array<Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBan>>>;
};

export enum Instacart_Care_Tools_V1_MatchType {
  MatchTypeLoyalty = 'MATCH_TYPE_LOYALTY',
  MatchTypePayment = 'MATCH_TYPE_PAYMENT',
  MatchTypePhone = 'MATCH_TYPE_PHONE',
  MatchTypeUnspecified = 'MATCH_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_Note = {
  __typename?: 'instacart_care_tools_v1_Note';
  createdAt?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  lastName?: Maybe<Scalars['String']>;
  notableId?: Maybe<Scalars['BigInt']>;
  notableType?: Maybe<Instacart_Care_Tools_V1_Note_NotableType>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
  userType?: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_Note_NotableType {
  Order = 'ORDER',
  User = 'USER'
}

/**
 * This is a subset of fields from the full Order message in OrdersService, plus additional information, that we can show to external users.
 * Do not add any data that is meant to be internal only, like workflow_state.
 * It's the result of orchestrating calls to multiple different services to fetch data for the Order management page.
 */
export type Instacart_Care_Tools_V1_Order = {
  __typename?: 'instacart_care_tools_v1_Order';
  /** When the shopper arrived at the customer's location to hand off the order. */
  arrivedAtCustomerLocationAt?: Maybe<Scalars['DateTime']>;
  /** Customer's per-delivery bagging preference (e.g. default, bagless). */
  baggingOption?: Maybe<Instacart_Customers_Commerce_Types_V1_BaggingOption>;
  /** When the order's batch was assigned to a shopper (computed via Dispatch). */
  batchAssignedAt?: Maybe<Scalars['DateTime']>;
  batchIds?: Maybe<Instacart_Care_Tools_V1_Order_BatchIds>;
  /** Branded name of the website, e.g. "Instacart" */
  brandedName?: Maybe<Scalars['String']>;
  /** Indicates if the order is a certified delivery order. */
  certifiedDelivery?: Maybe<Scalars['Boolean']>;
  /** Store present at the time of customer's order checkout */
  checkoutRetailerLocation?: Maybe<Instacart_Customers_Partners_V1_RetailerLocation>;
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Closest Store determined by Instacart for shopping this order. */
  closestRetailerLocation?: Maybe<Instacart_Customers_Partners_V1_RetailerLocation>;
  /**
   * Customer's preferred locale for order chats and notifications.
   * POSIX identifier format (aa_BB):
   * https://en.wikipedia.org/wiki/Locale_(computer_software)
   * Ex. "en", "en_US", "fr_CA"
   */
  communicationLocale?: Maybe<Scalars['String']>;
  /** When the order was confirmed. */
  confirmedAt?: Maybe<Scalars['DateTime']>;
  /** Indicates if the order is a connect order. */
  connectOrder?: Maybe<Scalars['Boolean']>;
  /** The country for the order. */
  country?: Maybe<Instacart_Customers_Partners_V1_Country>;
  /** The client identifier that was used during order creation. */
  creationClientIdentifier?: Maybe<Scalars['String']>;
  /** The date the order was created */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** The different charges for the order upon creation. These denote the charges shown to the customer when they placed the order. */
  creationOrderChargeLines?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Order_OrderChargeLine>>>;
  /** How many bags the shopper purchased. */
  customerBagCount?: Maybe<Scalars['BigInt']>;
  /** The customer's Nth order. */
  customerOrderNumber?: Maybe<Scalars['BigInt']>;
  /** If delivery performed (delivered or picked up), timestamp of that event */
  deliveredAt?: Maybe<Scalars['DateTime']>;
  /** Delivery photo details. Nil if no photo exists for the order. */
  deliveryPhoto?: Maybe<Instacart_Care_Tools_V1_DeliveryPhoto>;
  /** If delivery started, timestamp of that event */
  deliveryStartedAt?: Maybe<Scalars['DateTime']>;
  /** The status of the order. */
  deliveryStatus?: Maybe<Instacart_Care_Tools_V1_DeliveryStatus>;
  /** The id of the Express membership subscribed by user that creates the order or any linked user. */
  expressSubscriptionId?: Maybe<Scalars['BigInt']>;
  /**
   * For delivered order, when the order got done with completion reconciliations
   * For canceled order, when the order can not be uncanceled
   */
  finalizedAt?: Maybe<Scalars['DateTime']>;
  /** Type of fulfillment service option. */
  fulfillmentType?: Maybe<Instacart_Customers_Shared_V1_FulfillmentTypeWrapper_FulfillmentType>;
  /** Scheduled fulfillment window. */
  fulfillmentWindow?: Maybe<Instacart_Care_Tools_V1_Order_OrderFulfillmentWindow>;
  /** Heavy pay information for this order and associated batch. */
  heavyPayInfo?: Maybe<Instacart_Care_Tools_V1_Order_HeavyPayInfo>;
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Restriction state for order-scoped actions whose availability depends
   * on international-market rules.
   */
  intlRestriction?: Maybe<Instacart_Care_Tools_V1_ActionRestriction>;
  /** Whether a "running late" email has already been sent for this delivery. */
  lateEmailSent?: Maybe<Scalars['Boolean']>;
  /** The latest different charges for the order. These denote the latest charges, which could be creation, shopping, completion, refund, etc. */
  latestOrderChargeLines?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Order_OrderChargeLine>>>;
  /** The loyalty number associated with this order. */
  loyaltyNumber?: Maybe<Scalars['String']>;
  /** Indicates if the order is a marketplace order. */
  marketplaceOrder?: Maybe<Scalars['Boolean']>;
  /** Order ahead flag */
  orderAhead?: Maybe<Scalars['Boolean']>;
  /** The different charges for the order. Deprecated. Use latest_order_charge_lines and creation_order_charge_lines. */
  orderChargeLines?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_Order_OrderChargeLine>>>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  /** Order handling details */
  orderHandlingDetails?: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails>;
  /** The order lines for the order. */
  orderLines?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderLine>>>;
  orderReference?: Maybe<Scalars['String']>;
  /** Any special requirements for the order (contains alcohol, rx, cannabis, etc.) */
  orderSpecialRequirements?: Maybe<Instacart_Care_Tools_V1_OrderSpecialRequirements>;
  /** Timestamped state changes of the order */
  orderStateChanges?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderStateChange>>>;
  /** When we expect the delivery will be completed at */
  plannedDeliveredAt?: Maybe<Scalars['DateTime']>;
  /** When we expect the shopper to start delivering */
  plannedDeliveryStartedAt?: Maybe<Scalars['DateTime']>;
  /** Link for the customer to rate this order. */
  ratingLink?: Maybe<Scalars['String']>;
  /** Whether receipt suppression is enabled for this delivery. */
  receiptSuppressionEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * Customer-facing receipt URL, authenticated by a resource token minted for
   * the order owner. Nil if the token could not be minted.
   */
  receiptUrl?: Maybe<Scalars['String']>;
  /** Indicates if the order is a redelivery order. */
  redelivery?: Maybe<Scalars['Boolean']>;
  /** The retailer the order belongs to. */
  retailer?: Maybe<Instacart_Customers_Partners_V1_Retailer>;
  /** This is the id used by retailer to identify an order. */
  retailerReferenceId?: Maybe<Scalars['String']>;
  /** DeliveryOption id */
  serviceOptionId?: Maybe<Scalars['BigInt']>;
  /** Service type of the order. */
  serviceType?: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** Indicates if the order is a sfx order. */
  sfxOrder?: Maybe<Scalars['Boolean']>;
  /** The store the order was shopped at. */
  shoppedRetailerLocation?: Maybe<Instacart_Customers_Partners_V1_RetailerLocation>;
  /** The shopper summary for the order. */
  shopperSummary?: Maybe<Instacart_Care_Tools_V1_ShopperSummary>;
  /** Source website of the order, e.g. instacart.com */
  sourceWebsite?: Maybe<Scalars['String']>;
  /** Store Configuration ID. (whitelabel_id) */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  /** The customer who placed the order. */
  user?: Maybe<Instacart_Care_Tools_V1_User>;
  /**
   * Order user's birthday.
   * Needed for alcoholic orders. Shopper presents this to the cashier.
   */
  userBirthday?: Maybe<Google_Type_Date>;
  /** The zone for the order. */
  zone?: Maybe<Instacart_Customers_Partners_V1_Zone>;
};

/** Context for evaluating order page banners. */
export type Instacart_Care_Tools_V1_OrderContext_Input = {
  orderReference?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_OrderHandlingDetails = {
  __typename?: 'instacart_care_tools_v1_OrderHandlingDetails';
  /** Delivery to customer. */
  delivery?: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails_Delivery>;
  /** Pickup from location. */
  pickup?: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails_Pickup>;
};

export enum Instacart_Care_Tools_V1_OrderHandlingDetails_AddressType {
  /** Business address. */
  AddressTypeBusiness = 'ADDRESS_TYPE_BUSINESS',
  /** Residential/home address. */
  AddressTypeResidential = 'ADDRESS_TYPE_RESIDENTIAL',
  AddressTypeUnspecified = 'ADDRESS_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_OrderHandlingDetails_Delivery = {
  __typename?: 'instacart_care_tools_v1_OrderHandlingDetails_Delivery';
  /** Address to deliver the order. */
  address?: Maybe<Google_Type_PostalAddress>;
  /** User's DB Address ID. */
  addressId?: Maybe<Scalars['BigInt']>;
  /** Address type. */
  addressType?: Maybe<Instacart_Care_Tools_V1_OrderHandlingDetails_AddressType>;
  /** Customer specified manual Lat/Lng coordinates. Unset if unspecified. */
  customerManualLatLng?: Maybe<Google_Type_LatLng>;
  /** Door code from Customer. Ex. "*1234" */
  doorCode?: Maybe<Scalars['String']>;
  /** Drop-off location instructions from Customer. Ex. "Front door" */
  dropoffLocation?: Maybe<Scalars['String']>;
  /**
   * Instructions associated with the delivery. This is specific to the
   * Order or falls back to the Address notes.
   */
  instructions?: Maybe<Scalars['String']>;
  /** Lat/Lng coordinates. */
  latLng?: Maybe<Google_Type_LatLng>;
  /** Persisted notes about the address. */
  notes?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_OrderHandlingDetails_Pickup = {
  __typename?: 'instacart_care_tools_v1_OrderHandlingDetails_Pickup';
  /** Address to pickup the order. */
  address?: Maybe<Google_Type_PostalAddress>;
  /** User's DB Address ID. */
  addressId?: Maybe<Scalars['BigInt']>;
  /** Instructions associated with the pickup. */
  instructions?: Maybe<Scalars['String']>;
  /** Lat/Lng coordinates. */
  latLng?: Maybe<Google_Type_LatLng>;
};

/** Order item for care tools */
export type Instacart_Care_Tools_V1_OrderItem = {
  __typename?: 'instacart_care_tools_v1_OrderItem';
  /** Item is alcoholic */
  alcoholic?: Maybe<Scalars['Boolean']>;
  /** Item is EBT-eligible */
  ebt?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Product category */
  productCategory?: Maybe<Instacart_Care_Tools_V1_OrderItem_ProductCategory>;
  productId?: Maybe<Scalars['BigInt']>;
  /** Quantity including units displayed to customer. */
  quantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Item is OTC */
  restrictedOtc?: Maybe<Scalars['Boolean']>;
  /** Item is rx */
  rx?: Maybe<Scalars['Boolean']>;
  /** Display size of item. */
  sizeDetails?: Maybe<Scalars['String']>;
  /** Price per unit displayed to customer. */
  unitPrice?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Care_Tools_V1_OrderItem_ProductCategory = {
  __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory';
  l1Category?: Maybe<Scalars['String']>;
  l2Category?: Maybe<Scalars['String']>;
  l3Category?: Maybe<Scalars['String']>;
  l4Category?: Maybe<Scalars['String']>;
  l5Category?: Maybe<Scalars['String']>;
  l6Category?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
};

/** Order line for care tools */
export type Instacart_Care_Tools_V1_OrderLine = {
  __typename?: 'instacart_care_tools_v1_OrderLine';
  /** Id of the shopper that added the order item. */
  addedByDriverId?: Maybe<Scalars['BigInt']>;
  /**
   * Specifies if the customer explicitly allowed a substitution.
   * Possible values:
   * nil - customer did not decide.
   * false - customer asked for no substitution.
   * true - customer asked for a substitute.
   */
  allowedSubstitution?: Maybe<Scalars['Boolean']>;
  /** The date the order line was created. */
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Price shown to customer at order time. */
  customerOrderedPrice?: Maybe<GoogleTypeMoney>;
  /** Price displayed at storefront. */
  customerPrice?: Maybe<GoogleTypeMoney>;
  /**
   * Customer specified replacement at checkout/post-checkout.
   * Available only when allowed_substitution is True.
   */
  customerSelectedReplacement?: Maybe<Instacart_Care_Tools_V1_OrderItem>;
  /** Full price for this item. */
  fullPrice?: Maybe<GoogleTypeMoney>;
  /** Original item requested at checkout. */
  item?: Maybe<Instacart_Care_Tools_V1_OrderItem>;
  /** A unique identifier for this OrderLine that can be exposed externally. */
  obfuscatedId?: Maybe<Scalars['String']>;
  /** The ID of the order item represented by the order line */
  orderItemId?: Maybe<Scalars['BigInt']>;
  /** Quantity including units ordered by customer. */
  orderedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity including units picked. */
  pickedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /**
   * Discrete count of units picked (whole "each" count). Populated for
   * normal and variable-weight items; 0 for loose-weight (by-weight) items.
   */
  pickedQuantityEach?: Maybe<Scalars['BigInt']>;
  productType?: Maybe<Instacart_Care_Tools_V1_OrderLine_ProductType>;
  /** Quantity including units refunded. */
  refundQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /**
   * Discrete count of units refunded (whole "each" count). Populated for
   * normal and variable-weight items; 0 for loose-weight (by-weight) items.
   */
  refundQuantityEach?: Maybe<Scalars['BigInt']>;
  /**
   * Remaining quantity (including units) that can still be refunded for this
   * order item. Computed server-side to exclude both prior refunds and prior
   * credit appeasements; prefer this over deriving a cap from
   * picked_quantity minus refund_quantity.
   */
  refundableQuantities?: Maybe<Array<Maybe<Instacart_Types_V1_MeasuredQuantity>>>;
  replacementPolicy?: Maybe<Instacart_Care_Tools_V1_OrderLine_ReplacementPolicy>;
  /** Special instructions about the order item. */
  specialInstructions?: Maybe<Scalars['String']>;
  /** Original requested item status. */
  status?: Maybe<Instacart_Care_Tools_V1_OrderLine_Status>;
  /** Substitute if replaced by shopper. If present, this is the current item on the order. */
  substitute?: Maybe<Instacart_Care_Tools_V1_OrderItem>;
  /** The current status of the substitution for this item, if it exists. */
  substitutionStatus?: Maybe<Instacart_Care_Tools_V1_OrderLine_SubstitutionStatus>;
};

/**
 * Product type of the order item, distinguishing normal, loose-weight
 * (by-weight), and variable-weight items.
 */
export enum Instacart_Care_Tools_V1_OrderLine_ProductType {
  ProductTypeLooseweight = 'PRODUCT_TYPE_LOOSEWEIGHT',
  ProductTypeNormal = 'PRODUCT_TYPE_NORMAL',
  ProductTypePromo = 'PRODUCT_TYPE_PROMO',
  ProductTypeUnknown = 'PRODUCT_TYPE_UNKNOWN',
  ProductTypeUnspecified = 'PRODUCT_TYPE_UNSPECIFIED',
  ProductTypeVariable = 'PRODUCT_TYPE_VARIABLE'
}

/** Chosen replacement policy for the order item. */
export enum Instacart_Care_Tools_V1_OrderLine_ReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE'
}

export enum Instacart_Care_Tools_V1_OrderLine_Status {
  /** Original item requested found by shopper. */
  Found = 'FOUND',
  /** Not yet picked. */
  NotPicked = 'NOT_PICKED',
  /** Item replaced. */
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  /** Item to be refunded. */
  ToRefund = 'TO_REFUND'
}

export enum Instacart_Care_Tools_V1_OrderLine_SubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_OrderResolutionAndAppeasement = {
  __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement';
  /** Timestamp at which the resolution/appeasement was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  fulfillmentStatus?: Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_FulfillmentStatus>;
  /** The order this entry belongs to. */
  orderId?: Maybe<Scalars['BigInt']>;
  /** Order issues linked to this resolution/appeasement. Empty when no issues were recorded. */
  orderIssues?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_OrderIssueInfo>>>;
  requester?: Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Requester>;
  /** Unset if no ticket is associated. */
  ticket?: Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Ticket>;
  /** Amount issued. Unset when not fulfilled. */
  value?: Maybe<GoogleTypeMoney>;
  valueType?: Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_ValueType>;
};

/** Fulfillment status for the Status column. */
export enum Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_FulfillmentStatus {
  FulfillmentStatusDenied = 'FULFILLMENT_STATUS_DENIED',
  FulfillmentStatusFulfilled = 'FULFILLMENT_STATUS_FULFILLED',
  FulfillmentStatusInProgress = 'FULFILLMENT_STATUS_IN_PROGRESS',
  FulfillmentStatusNotFulfilled = 'FULFILLMENT_STATUS_NOT_FULFILLED',
  FulfillmentStatusReversed = 'FULFILLMENT_STATUS_REVERSED',
  FulfillmentStatusUnspecified = 'FULFILLMENT_STATUS_UNSPECIFIED'
}

/** Details about a single order issue linked to this resolution/appeasement. */
export type Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_OrderIssueInfo = {
  __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement_OrderIssueInfo';
  /** True when the issue is item-level; false when it is a whole-order issue. */
  isItemLevel?: Maybe<Scalars['Boolean']>;
  /** Category of the issue type (e.g. ITEM_MISSING, DAMAGED, ENTIRE_DELIVERY_MISSING). */
  issueTypeCategory?: Maybe<Instacart_Customers_Order_Issues_V1_OrderIssueTypeCategory>;
  /** Human-readable name of the issue type as stored in the order issues service. Unset when not available. */
  issueTypeName?: Maybe<Scalars['String']>;
  /** The ID of the order issue. */
  orderIssueId?: Maybe<Scalars['BigInt']>;
};

/** Who initiated the action. */
export type Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Requester = {
  __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement_Requester';
  intRequesterId?: Maybe<Scalars['BigInt']>;
  /** Display name of the requester. */
  requesterName?: Maybe<Scalars['String']>;
  requesterType?: Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Requester_RequesterType>;
  stringRequesterId?: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Requester_RequesterType {
  /** When the request is self-serve */
  RequesterTypeCustomer = 'REQUESTER_TYPE_CUSTOMER',
  /** When an internal instacart BPO specialist performs the request */
  RequesterTypeInstacartAgent = 'REQUESTER_TYPE_INSTACART_AGENT',
  /** When a retailer user performs the request through IPP */
  RequesterTypeRetailerUser = 'REQUESTER_TYPE_RETAILER_USER',
  RequesterTypeUnspecified = 'REQUESTER_TYPE_UNSPECIFIED'
}

/** Zendesk or Salesforce ticket that triggered this action. */
export type Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Ticket = {
  __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement_Ticket';
  /** Direct link to the support ticket. Set only when ticket_type is TICKET_TYPE_SALESFORCE. */
  caseUrl?: Maybe<Scalars['String']>;
  /** Human-readable ticket ID (e.g. Zendesk ticket number string). */
  ticketId?: Maybe<Scalars['String']>;
  ticketType?: Maybe<Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Ticket_TicketType>;
};

export enum Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Ticket_TicketType {
  TicketTypeSalesforce = 'TICKET_TYPE_SALESFORCE',
  TicketTypeUnspecified = 'TICKET_TYPE_UNSPECIFIED',
  TicketTypeZendesk = 'TICKET_TYPE_ZENDESK'
}

/** Fine-grained type for the Detail column. */
export enum Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_ValueType {
  ValueTypeCredit = 'VALUE_TYPE_CREDIT',
  ValueTypeFreeDelivery = 'VALUE_TYPE_FREE_DELIVERY',
  ValueTypeFreeExpressMonth = 'VALUE_TYPE_FREE_EXPRESS_MONTH',
  ValueTypeRedelivery = 'VALUE_TYPE_REDELIVERY',
  ValueTypeRefund = 'VALUE_TYPE_REFUND',
  ValueTypeUnspecified = 'VALUE_TYPE_UNSPECIFIED',
  ValueTypeWaivedFees = 'VALUE_TYPE_WAIVED_FEES'
}

export type Instacart_Care_Tools_V1_OrderSpecialRequirements = {
  __typename?: 'instacart_care_tools_v1_OrderSpecialRequirements';
  /** Order should be treated as containing alcohol. */
  containsAlcohol?: Maybe<Scalars['Boolean']>;
  /** Order should be treated as containing hemp based cannabis */
  containsHempBasedCannabis?: Maybe<Scalars['Boolean']>;
  /** Order should be treated as containing restricted OTC. */
  containsRestrictedOtc?: Maybe<Scalars['Boolean']>;
  /** Order should be treated as containing RX. */
  containsRx?: Maybe<Scalars['Boolean']>;
  /** Order contains only RX and may not have non-RX items. */
  containsRxOnly?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_OrderStateChange = {
  __typename?: 'instacart_care_tools_v1_OrderStateChange';
  /** Extra data associated with the state change. */
  eventArgs?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The OrderDelivery's old state */
  fromState?: Maybe<Scalars['String']>;
  /** The ID of the corresponding OrderDeliveryEvent */
  orderDeliveryEventId?: Maybe<Scalars['BigInt']>;
  /** The order delivery ID itself */
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  /** The OrderDelivery's new state */
  toState?: Maybe<Scalars['String']>;
  /** The time at which the state change occurred. */
  transitionedAt?: Maybe<Scalars['DateTime']>;
  /** The proximate cause of the state change; optional. */
  trigger?: Maybe<Scalars['String']>;
};

/**
 * Less fields than the Order type, but includes additional fields like shopper and store info.
 * Mostly used for list/table views.
 */
export type Instacart_Care_Tools_V1_OrderSummary = {
  __typename?: 'instacart_care_tools_v1_OrderSummary';
  /** The batch ID of the order. Only included if include_batch_id request param is true. */
  batchId?: Maybe<Scalars['BigInt']>;
  /** The date the order was created. */
  confirmedAt?: Maybe<Scalars['DateTime']>;
  /** The customer's Nth order. */
  customerOrderNumber?: Maybe<Scalars['BigInt']>;
  /** The delivery status of the order. */
  deliveryStatus?: Maybe<Instacart_Care_Tools_V1_DeliveryStatus>;
  /** Customer/retailer display fulfillment window. */
  estimatedCustomerFulfillmentWindow?: Maybe<Instacart_Care_Tools_V1_Order_OrderFulfillmentWindow>;
  /** The id of the Express membership subscribed by the user at order time. */
  expressSubscriptionId?: Maybe<Scalars['BigInt']>;
  /**
   * This is the earliest date for fulfillment for new or in-progress orders.
   * For delivered orders, this is the date at which they got delivered.
   */
  fulfillmentDate?: Maybe<Scalars['DateTime']>;
  /** Consumers use this to distinguish PICKUP_ETA from other fulfillment types. */
  fulfillmentType?: Maybe<Instacart_Customers_Shared_V1_FulfillmentTypeWrapper_FulfillmentType>;
  /** The order ID. */
  id?: Maybe<Scalars['BigInt']>;
  /** Indicates if the order is a marketplace order. */
  marketplaceOrder?: Maybe<Scalars['Boolean']>;
  /** The order delivery ID. */
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  /** The order reference. */
  orderReference?: Maybe<Scalars['String']>;
  /** Any special requirements for the order (contains alcohol, rx, cannabis, etc.) */
  orderSpecialRequirements?: Maybe<Instacart_Care_Tools_V1_OrderSpecialRequirements>;
  /** The retailer ID of the order. */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** The retailer location ID of the order. */
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  /** The name of the store that the order was shopped at. Only included if include_retailer_location_name request param is true. */
  retailerLocationName?: Maybe<Scalars['String']>;
  /** The name of the retailer that the order was placed at. Only included if include_retailer_name request param is true. */
  retailerName?: Maybe<Scalars['String']>;
  /** The service type of the order (delivery, pickup, etc.) */
  serviceType?: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** The full profile of shoppers that shopped the order. Only included if include_shopper_summary request param is true. */
  shopperSummary?: Maybe<Instacart_Care_Tools_V1_ShopperSummary>;
  /** The total amount of the order. */
  totalAmount?: Maybe<GoogleTypeMoney>;
  /** The full name of the user. Only included if include_customer_name request param is true. */
  userFullName?: Maybe<Scalars['String']>;
  /** The user ID of the order. */
  userId?: Maybe<Scalars['BigInt']>;
};

/**
 * The batch IDs for the order.
 * Currently for some handoff cases, an order can be fulfilled by different batches (one for driving to the store, one for shopping and one for delivering).
 * Each phase can have multiple batches as well.
 */
export type Instacart_Care_Tools_V1_Order_BatchIds = {
  __typename?: 'instacart_care_tools_v1_Order_BatchIds';
  deliveringBatchIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  drivingToStoreBatchIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  shoppingBatchIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Care_Tools_V1_Order_HeavyPayInfo = {
  __typename?: 'instacart_care_tools_v1_Order_HeavyPayInfo';
  /** Total weight of 8lb+ items for the batch, in pounds. */
  batchHeavyPayLbs?: Maybe<Scalars['Float']>;
  /** Total weight of 8lb+ items for this order (delivery), in pounds. */
  orderHeavyPayLbs?: Maybe<Scalars['Float']>;
  /** Whether the shopper was paid heavy pay wage for the selected batch. */
  shopperPaidForHeavyPay?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_Order_OrderChargeLine = {
  __typename?: 'instacart_care_tools_v1_Order_OrderChargeLine';
  amount?: Maybe<GoogleTypeMoney>;
  /** eg: Sugar_tax, Delivery_fee, Bottle_deposit etc. */
  labelInEnglish?: Maybe<Scalars['String']>;
};

/**
 * Scheduled fulfillment window.
 * Time window used for notifications, view, and communication with customers
 */
export type Instacart_Care_Tools_V1_Order_OrderFulfillmentWindow = {
  __typename?: 'instacart_care_tools_v1_Order_OrderFulfillmentWindow';
  windowEnd?: Maybe<Scalars['DateTime']>;
  windowStart?: Maybe<Scalars['DateTime']>;
};

/** Page type for which banners are requested. */
export enum Instacart_Care_Tools_V1_PageType {
  PageTypeCustomer = 'PAGE_TYPE_CUSTOMER',
  PageTypeOrder = 'PAGE_TYPE_ORDER',
  PageTypeUnspecified = 'PAGE_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_PaymentInstrument = {
  __typename?: 'instacart_care_tools_v1_PaymentInstrument';
  creditCard?: Maybe<Instacart_Care_Tools_V1_PaymentInstrument_CreditCard>;
  debitCard?: Maybe<Instacart_Care_Tools_V1_PaymentInstrument_DebitCard>;
  disableInfo?: Maybe<Instacart_Customers_Payments_V1_RenderableInstrument_InstrumentDisableInfo>;
  id?: Maybe<Scalars['BigInt']>;
  isCurrentOnOrder?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_PaymentInstrument_CreditCard = {
  __typename?: 'instacart_care_tools_v1_PaymentInstrument_CreditCard';
  creditCardType?: Maybe<Instacart_Customers_Payments_V1_CreditCardType>;
  suffix?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_PaymentInstrument_DebitCard = {
  __typename?: 'instacart_care_tools_v1_PaymentInstrument_DebitCard';
  creditCardType?: Maybe<Instacart_Customers_Payments_V1_CreditCardType>;
  suffix?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_RelatedUser = {
  __typename?: 'instacart_care_tools_v1_RelatedUser';
  accountType?: Maybe<Instacart_Care_Tools_V1_RelatedUser_AccountType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  lastName?: Maybe<Scalars['String']>;
  matchTypes?: Maybe<Array<Maybe<Instacart_Care_Tools_V1_MatchType>>>;
  phone?: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_RelatedUser_AccountType {
  AccountTypeUnknown = 'ACCOUNT_TYPE_UNKNOWN',
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export type Instacart_Care_Tools_V1_RestaurantOrder = {
  __typename?: 'instacart_care_tools_v1_RestaurantOrder';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Estimated time of arrival. */
  eta?: Maybe<Scalars['DateTime']>;
  /** Time zone offset for the eta, eg: -04:00 */
  etaTimeZoneOffset?: Maybe<Scalars['String']>;
  /** External order id. */
  externalOrderId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** Name of the restaurant. */
  restaurantName?: Maybe<Scalars['String']>;
  /** Service type of the order. */
  serviceType?: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** Status of the order. */
  status?: Maybe<Scalars['String']>;
  /** The amount on the order (this is an estimate). */
  total?: Maybe<GoogleTypeMoney>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Care_Tools_V1_ReturnItem = {
  __typename?: 'instacart_care_tools_v1_ReturnItem';
  /** The action to take */
  itemAction?: Maybe<Scalars['String']>;
  /** The ID of the OrderItem */
  orderItemId?: Maybe<Scalars['BigInt']>;
};

/** Enum for returns reason codes */
export enum Instacart_Care_Tools_V1_ReturnReasonCode {
  ReturnReasonCodeBadWeather = 'RETURN_REASON_CODE_BAD_WEATHER',
  ReturnReasonCodeCustomerFailedSignature = 'RETURN_REASON_CODE_CUSTOMER_FAILED_SIGNATURE',
  ReturnReasonCodeCustomerMia = 'RETURN_REASON_CODE_CUSTOMER_MIA',
  ReturnReasonCodeCustomerMissing = 'RETURN_REASON_CODE_CUSTOMER_MISSING',
  ReturnReasonCodeCustomerRequested = 'RETURN_REASON_CODE_CUSTOMER_REQUESTED',
  ReturnReasonCodeDeliveredOutsideOfWindow = 'RETURN_REASON_CODE_DELIVERED_OUTSIDE_OF_WINDOW',
  ReturnReasonCodeDuplicateOrder = 'RETURN_REASON_CODE_DUPLICATE_ORDER',
  ReturnReasonCodeFailedIdVerification = 'RETURN_REASON_CODE_FAILED_ID_VERIFICATION',
  ReturnReasonCodeIncorrectCustomerInfo = 'RETURN_REASON_CODE_INCORRECT_CUSTOMER_INFO',
  ReturnReasonCodeOther = 'RETURN_REASON_CODE_OTHER',
  ReturnReasonCodeSafetyConcern = 'RETURN_REASON_CODE_SAFETY_CONCERN',
  ReturnReasonCodeTooManyOutOfStockItems = 'RETURN_REASON_CODE_TOO_MANY_OUT_OF_STOCK_ITEMS',
  ReturnReasonCodeTrafficConditions = 'RETURN_REASON_CODE_TRAFFIC_CONDITIONS',
  ReturnReasonCodeUnableToAccessDeliveryLocation = 'RETURN_REASON_CODE_UNABLE_TO_ACCESS_DELIVERY_LOCATION',
  ReturnReasonCodeUnspecified = 'RETURN_REASON_CODE_UNSPECIFIED',
  ReturnReasonCodeWrongAddress = 'RETURN_REASON_CODE_WRONG_ADDRESS'
}

/** Enum for returns requester types */
export enum Instacart_Care_Tools_V1_ReturnRequesterType {
  ReturnRequesterTypeCustomer = 'RETURN_REQUESTER_TYPE_CUSTOMER',
  ReturnRequesterTypeRetailer = 'RETURN_REQUESTER_TYPE_RETAILER',
  ReturnRequesterTypeShopper = 'RETURN_REQUESTER_TYPE_SHOPPER',
  ReturnRequesterTypeUnspecified = 'RETURN_REQUESTER_TYPE_UNSPECIFIED'
}

export enum Instacart_Care_Tools_V1_ServiceUser {
  ServiceUserFraudEngine = 'SERVICE_USER_FRAUD_ENGINE',
  ServiceUserGenesys = 'SERVICE_USER_GENESYS',
  ServiceUserIppCxAdmin = 'SERVICE_USER_IPP_CX_ADMIN',
  ServiceUserIppRetailerUser = 'SERVICE_USER_IPP_RETAILER_USER',
  ServiceUserSalesforce = 'SERVICE_USER_SALESFORCE',
  ServiceUserSierra = 'SERVICE_USER_SIERRA',
  ServiceUserUnspecified = 'SERVICE_USER_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_ShopperSummary = {
  __typename?: 'instacart_care_tools_v1_ShopperSummary';
  /** Current shopper */
  currentShopperProfile?: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
  /** Driver details */
  driverProfile?: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
  /** Full Service? */
  fullService?: Maybe<Scalars['Boolean']>;
  /** Picker details */
  pickerProfile?: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
  /** Runner details */
  runnerProfile?: Maybe<Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile>;
};

/** Shopper profile information relevant to an order. */
export type Instacart_Care_Tools_V1_ShopperSummary_ShopperProfile = {
  __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile';
  /** Avatar url of shopper. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** First name of the shopper. */
  firstName?: Maybe<Scalars['String']>;
  /** Id of the shopper. */
  id?: Maybe<Scalars['BigInt']>;
  /** Optional map icon url of shopper. */
  mapIconUrl?: Maybe<Scalars['String']>;
  /** Name of the shopper. */
  name?: Maybe<Scalars['String']>;
  /** Shopper start date. */
  startDate?: Maybe<Google_Type_Date>;
};

/**
 * UiOrigin identifies the CX Admin flow issuing the appeasement. The handler
 * rejects UI_ORIGIN_UNSPECIFIED and origins it does not know how to honour.
 *
 * The UI_ORIGIN_IPP_* variants identify appeasements issued from the IPP
 * (retailer platform) care-admin UIs. Each mirrors a CX Admin flow but carries
 * a distinct value so callers can tell the two issuance surfaces apart.
 */
export enum Instacart_Care_Tools_V1_UiOrigin {
  UiOriginCareAdminBentoPoorServiceCredits = 'UI_ORIGIN_CARE_ADMIN_BENTO_POOR_SERVICE_CREDITS',
  UiOriginCareAdminIcPlusFreeMonth = 'UI_ORIGIN_CARE_ADMIN_IC_PLUS_FREE_MONTH',
  UiOriginCareAdminPoorServiceCredits = 'UI_ORIGIN_CARE_ADMIN_POOR_SERVICE_CREDITS',
  /** Identifies delivery-issue resolution as the origin of the appeasement. */
  UiOriginCareAdminResolveDeliveryIssues = 'UI_ORIGIN_CARE_ADMIN_RESOLVE_DELIVERY_ISSUES',
  /** Identifies item-issue resolution as the origin of the appeasement. */
  UiOriginCareAdminResolveItemIssues = 'UI_ORIGIN_CARE_ADMIN_RESOLVE_ITEM_ISSUES',
  UiOriginIppCareAdminBentoPoorServiceCredits = 'UI_ORIGIN_IPP_CARE_ADMIN_BENTO_POOR_SERVICE_CREDITS',
  /** Identifies the IPP customer-MIA (customer missing) flow. */
  UiOriginIppCareAdminCustomerMia = 'UI_ORIGIN_IPP_CARE_ADMIN_CUSTOMER_MIA',
  UiOriginIppCareAdminIcPlusFreeMonth = 'UI_ORIGIN_IPP_CARE_ADMIN_IC_PLUS_FREE_MONTH',
  UiOriginIppCareAdminPoorServiceCredits = 'UI_ORIGIN_IPP_CARE_ADMIN_POOR_SERVICE_CREDITS',
  /** Identifies IPP delivery-issue resolution as the origin of the appeasement. */
  UiOriginIppCareAdminResolveDeliveryIssues = 'UI_ORIGIN_IPP_CARE_ADMIN_RESOLVE_DELIVERY_ISSUES',
  /** Identifies IPP item-issue resolution as the origin of the appeasement. */
  UiOriginIppCareAdminResolveItemIssues = 'UI_ORIGIN_IPP_CARE_ADMIN_RESOLVE_ITEM_ISSUES',
  UiOriginUnspecified = 'UI_ORIGIN_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_UnlinkIsolatedUserRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  isolatedUserId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_UnlinkIsolatedUserResponse = {
  __typename?: 'instacart_care_tools_v1_UnlinkIsolatedUserResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Care_Tools_V1_UpdateAddressForUserRequest_Input = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_UpdateAddressForUserResponse = {
  __typename?: 'instacart_care_tools_v1_UpdateAddressForUserResponse';
  address?: Maybe<Instacart_Care_Tools_V1_AddressResponse>;
};

export type Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  autorenew?: InputMaybe<Scalars['Boolean']>;
  caseId?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  subscriptionId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_UpdateSubscriptionAutorenewResponse = {
  __typename?: 'instacart_care_tools_v1_UpdateSubscriptionAutorenewResponse';
  membership?: Maybe<Instacart_Care_Tools_V1_InstacartPlusMembership>;
};

export type Instacart_Care_Tools_V1_UpdateUserNameRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_UpdateUserNameResponse = {
  __typename?: 'instacart_care_tools_v1_UpdateUserNameResponse';
  user?: Maybe<Instacart_Care_Tools_V1_User>;
};

export type Instacart_Care_Tools_V1_UpdateUserPhoneRequest_Input = {
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
  phone?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Care_Tools_V1_UpdateUserPhoneResponse = {
  __typename?: 'instacart_care_tools_v1_UpdateUserPhoneResponse';
  user?: Maybe<Instacart_Care_Tools_V1_User>;
};

export type Instacart_Care_Tools_V1_User = {
  __typename?: 'instacart_care_tools_v1_User';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /**
   * Restriction state for user-scoped actions whose availability depends on
   * international-market rules.
   */
  intlRestriction?: Maybe<Instacart_Care_Tools_V1_ActionRestriction>;
  isolationContext?: Maybe<Instacart_Care_Tools_V1_IsolationContext>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_UserAttribute = {
  __typename?: 'instacart_care_tools_v1_UserAttribute';
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  storeName?: Maybe<Scalars['String']>;
};

export type Instacart_Care_Tools_V1_UserSearchResult = {
  __typename?: 'instacart_care_tools_v1_UserSearchResult';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isolationContext?: Maybe<Instacart_Care_Tools_V1_IsolationContext>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export enum Instacart_Care_Tools_V1_UserSearchType {
  UserSearchTypeEmail = 'USER_SEARCH_TYPE_EMAIL',
  UserSearchTypeId = 'USER_SEARCH_TYPE_ID',
  UserSearchTypeName = 'USER_SEARCH_TYPE_NAME',
  UserSearchTypePhone = 'USER_SEARCH_TYPE_PHONE',
  UserSearchTypeUnspecified = 'USER_SEARCH_TYPE_UNSPECIFIED'
}

export type Instacart_Care_Tools_V1_ValidateSalesforceCaseRequest_Input = {
  caseId?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
};

export type Instacart_Care_Tools_V1_ValidateSalesforceCaseResponse = {
  __typename?: 'instacart_care_tools_v1_ValidateSalesforceCaseResponse';
  valid?: Maybe<Scalars['Boolean']>;
};

/** AuditFinding object */
export type Instacart_Cashflow_Nutella_V1_AuditFinding = {
  __typename?: 'instacart_cashflow_nutella_v1_AuditFinding';
  finding?: Maybe<Scalars['JSON']>;
  metadata?: Maybe<Scalars['JSON']>;
  uuid?: Maybe<Scalars['String']>;
};

/** AuditItem object */
export type Instacart_Cashflow_Nutella_V1_AuditItem = {
  __typename?: 'instacart_cashflow_nutella_v1_AuditItem';
  auditFindings?: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_AuditFinding>>>;
  createdDuringAuditReview?: Maybe<Scalars['Boolean']>;
  data?: Maybe<Scalars['JSON']>;
  entityType?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
};

/** AuditItemFindings object */
export type Instacart_Cashflow_Nutella_V1_AuditItemFindings_Input = {
  auditItemUuid?: InputMaybe<Scalars['String']>;
  findings?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  newAuditItem?: InputMaybe<Instacart_Cashflow_Nutella_V1_NewAuditItem_Input>;
};

/** AuditReview object */
export type Instacart_Cashflow_Nutella_V1_AuditReview = {
  __typename?: 'instacart_cashflow_nutella_v1_AuditReview';
  auditItems?: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_AuditItem>>>;
  dataSource?: Maybe<Scalars['String']>;
  escalationSourceAuditReview?: Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>;
  isCompleted?: Maybe<Scalars['Boolean']>;
  isEscalation?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  owner?: Maybe<Scalars['String']>;
  requestContext?: Maybe<Scalars['JSON']>;
  uuid?: Maybe<Scalars['String']>;
  workflowName?: Maybe<Scalars['String']>;
};

/** FeedbackAuditReview object */
export type Instacart_Cashflow_Nutella_V1_FeedbackAuditReview = {
  __typename?: 'instacart_cashflow_nutella_v1_FeedbackAuditReview';
  auditReviewCompletedAt?: Maybe<Scalars['String']>;
  auditReviewUuid?: Maybe<Scalars['String']>;
  escalatedAuditReviewCompletedAt?: Maybe<Scalars['String']>;
  escalatedAuditReviewUuid?: Maybe<Scalars['String']>;
};

/** FeedbackPagination object */
export type Instacart_Cashflow_Nutella_V1_FeedbackPagination = {
  __typename?: 'instacart_cashflow_nutella_v1_FeedbackPagination';
  pageNumber?: Maybe<Scalars['BigInt']>;
  pageSize?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['BigInt']>;
};

/** FeedbackPagination object */
export type Instacart_Cashflow_Nutella_V1_FeedbackPagination_Input = {
  pageNumber?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  totalPages?: InputMaybe<Scalars['BigInt']>;
};

/** Request object for GetAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewRequest_Input = {
  auditReviewUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
};

/** Response object for GetAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetAuditReviewResponse';
  auditReview?: Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>;
};

/** Request object for GetAuditReviewsWithFeedback API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackRequest_Input = {
  client?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<Instacart_Cashflow_Nutella_V1_FeedbackPagination_Input>;
  userId?: InputMaybe<Scalars['String']>;
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Response object for GetAuditReviewsWithFeedback API */
export type Instacart_Cashflow_Nutella_V1_GetAuditReviewsWithFeedbackResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetAuditReviewsWithFeedbackResponse';
  auditReviews?: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_FeedbackAuditReview>>>;
  pagination?: Maybe<Instacart_Cashflow_Nutella_V1_FeedbackPagination>;
};

/** Request object for GetNextAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetNextAuditReviewRequest_Input = {
  client?: InputMaybe<Scalars['String']>;
  dataSource?: InputMaybe<Scalars['String']>;
  isEscalation?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Response object for GetNextAuditReview API */
export type Instacart_Cashflow_Nutella_V1_GetNextAuditReviewResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetNextAuditReviewResponse';
  auditReview?: Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>;
};

/** Request object for GetWorkflowMetadata API */
export type Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataRequest_Input = {
  client?: InputMaybe<Scalars['String']>;
  dataSource?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  workflowName?: InputMaybe<Scalars['String']>;
};

/** Response object for GetWorkflowMetadata API */
export type Instacart_Cashflow_Nutella_V1_GetWorkflowMetadataResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_GetWorkflowMetadataResponse';
  metadata?: Maybe<Scalars['JSON']>;
};

/** Request object for ListAuditReviewSiblings API */
export type Instacart_Cashflow_Nutella_V1_ListAuditReviewSiblingsRequest_Input = {
  auditReviewUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
};

/** Response object for ListAuditReviewSiblings API */
export type Instacart_Cashflow_Nutella_V1_ListAuditReviewSiblingsResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_ListAuditReviewSiblingsResponse';
  siblings?: Maybe<Array<Maybe<Instacart_Cashflow_Nutella_V1_AuditReview>>>;
};

/** NewAuditItem object */
export type Instacart_Cashflow_Nutella_V1_NewAuditItem_Input = {
  data?: InputMaybe<Scalars['JSON']>;
  entityType?: InputMaybe<Scalars['String']>;
};

/** Request object for SetAuditFindings API */
export type Instacart_Cashflow_Nutella_V1_SetAuditFindingsRequest_Input = {
  auditItemFindings?: InputMaybe<Array<InputMaybe<Instacart_Cashflow_Nutella_V1_AuditItemFindings_Input>>>;
  /**
   * Free-form audit-review-level metadata. Shape is validated server-side against the
   * workflow's metadata schema. Set semantics — server replaces the stored value with
   * the contents of this struct.
   */
  auditReviewMetadata?: InputMaybe<Scalars['JSON']>;
  auditReviewUuid?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Scalars['String']>;
  isFinal?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** Response object for SetAuditFindings API */
export type Instacart_Cashflow_Nutella_V1_SetAuditFindingsResponse = {
  __typename?: 'instacart_cashflow_nutella_v1_SetAuditFindingsResponse';
  auditReviewUuid?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

/** ApplyChangeRequestRequest identifies the approved change request to apply to source_priorities. */
export type Instacart_Catalog_Admin_V1_ApplyChangeRequestRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
};

/** ApproveChangeRequestRequest identifies the change request to approve. */
export type Instacart_Catalog_Admin_V1_ApproveChangeRequestRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
};

/** CancelChangeRequestRequest identifies the change request to cancel. */
export type Instacart_Catalog_Admin_V1_CancelChangeRequestRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
};

/**
 * ChangeRequestSortField identifies which field to sort by in ListChangeRequests.
 * UNKNOWN defaults to submitted_at DESC.
 */
export enum Instacart_Catalog_Admin_V1_ChangeRequestSortField {
  ChangeRequestSortFieldAttribute = 'CHANGE_REQUEST_SORT_FIELD_ATTRIBUTE',
  ChangeRequestSortFieldRetailerId = 'CHANGE_REQUEST_SORT_FIELD_RETAILER_ID',
  ChangeRequestSortFieldSourceType = 'CHANGE_REQUEST_SORT_FIELD_SOURCE_TYPE',
  ChangeRequestSortFieldStatus = 'CHANGE_REQUEST_SORT_FIELD_STATUS',
  ChangeRequestSortFieldSubmittedAt = 'CHANGE_REQUEST_SORT_FIELD_SUBMITTED_AT',
  ChangeRequestSortFieldSubmittedBy = 'CHANGE_REQUEST_SORT_FIELD_SUBMITTED_BY',
  ChangeRequestSortFieldUnknown = 'CHANGE_REQUEST_SORT_FIELD_UNKNOWN'
}

/** ChangeRequestStatus represents the current state in the change request workflow. */
export enum Instacart_Catalog_Admin_V1_ChangeRequestStatus {
  ChangeRequestStatusAnalysisFailed = 'CHANGE_REQUEST_STATUS_ANALYSIS_FAILED',
  ChangeRequestStatusAnalysisRunning = 'CHANGE_REQUEST_STATUS_ANALYSIS_RUNNING',
  ChangeRequestStatusApplied = 'CHANGE_REQUEST_STATUS_APPLIED',
  ChangeRequestStatusApplied_10Pct = 'CHANGE_REQUEST_STATUS_APPLIED_10_PCT',
  ChangeRequestStatusApplied_50Pct = 'CHANGE_REQUEST_STATUS_APPLIED_50_PCT',
  ChangeRequestStatusAppliedPilot = 'CHANGE_REQUEST_STATUS_APPLIED_PILOT',
  ChangeRequestStatusApproved = 'CHANGE_REQUEST_STATUS_APPROVED',
  ChangeRequestStatusCancelled = 'CHANGE_REQUEST_STATUS_CANCELLED',
  ChangeRequestStatusPendingReview = 'CHANGE_REQUEST_STATUS_PENDING_REVIEW',
  ChangeRequestStatusRejected = 'CHANGE_REQUEST_STATUS_REJECTED',
  ChangeRequestStatusRolledBack = 'CHANGE_REQUEST_STATUS_ROLLED_BACK',
  ChangeRequestStatusUnknown = 'CHANGE_REQUEST_STATUS_UNKNOWN'
}

/** Lightweight summary of a change request for list views. */
export type Instacart_Catalog_Admin_V1_ChangeRequestSummary = {
  __typename?: 'instacart_catalog_admin_v1_ChangeRequestSummary';
  attribute?: Maybe<Scalars['String']>;
  changeReason?: Maybe<Scalars['String']>;
  changeRequestId?: Maybe<Scalars['BigInt']>;
  changeType?: Maybe<Instacart_Catalog_Admin_V1_ChangeType>;
  priorityAfter?: Maybe<Scalars['BigInt']>;
  priorityBefore?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Catalog_Admin_V1_ChangeRequestStatus>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
};

/**
 * UNKNOWN = 0 on request enums means "no filter" in list endpoints.
 * Deletes are not yet supported; planned for a future milestone.
 */
export enum Instacart_Catalog_Admin_V1_ChangeType {
  ChangeTypeCreate = 'CHANGE_TYPE_CREATE',
  ChangeTypeEdit = 'CHANGE_TYPE_EDIT',
  ChangeTypeUnknown = 'CHANGE_TYPE_UNKNOWN'
}

/** This is for auditing purposes, to record who made a change to the database. */
export type Instacart_Catalog_Admin_V1_Client_Input = {
  /**
   * Which service is requesting this change?
   * Possible values: "IPP", "CatalogAdmin", or "Storefront"
   */
  appName?: InputMaybe<Scalars['String']>;
  /** Any additional context needed for your particular API */
  contextJson?: InputMaybe<Scalars['String']>;
  /**
   * Deprecated
   * The remote user email of the user who is making the request
   * Deprecated because this potentially exposes PII and thus will not be used or stored in the future
   */
  userEmail?: InputMaybe<Scalars['String']>;
  /** The remote ID of the user who is making the request */
  userId?: InputMaybe<Scalars['String']>;
  /**
   * Deprecated
   * The remote user name of the user who is making the request
   * Deprecated because this potentially exposes PII and thus will not be used or stored in the future
   */
  userName?: InputMaybe<Scalars['String']>;
  /** The "type" of user ID being supplied. We currently support IPP and Instacart user types */
  userType?: InputMaybe<Scalars['String']>;
};

/** CreateChangeRequestRequest specifies the parameters for a new create or edit change request. */
export type Instacart_Catalog_Admin_V1_CreateChangeRequestRequest_Input = {
  attribute?: InputMaybe<Scalars['String']>;
  authorEmail?: InputMaybe<Scalars['String']>;
  changeReason?: InputMaybe<Scalars['String']>;
  changeType?: InputMaybe<Instacart_Catalog_Admin_V1_ChangeType>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  priorityAfter?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required for edits; omit for creates. */
  sourcePriorityId?: InputMaybe<Scalars['BigInt']>;
  sourceType?: InputMaybe<Scalars['String']>;
};

/** CreateChangeRequestResponse returns the ID of the newly created change request. */
export type Instacart_Catalog_Admin_V1_CreateChangeRequestResponse = {
  __typename?: 'instacart_catalog_admin_v1_CreateChangeRequestResponse';
  changeRequestId?: Maybe<Scalars['BigInt']>;
};

/** GetImpactAnalysisRequest identifies the change request to retrieve impact analysis for. */
export type Instacart_Catalog_Admin_V1_GetImpactAnalysisRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** Optional retailer filter for the sampled impact_results. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetImpactAnalysisResponse contains the full change request, sampled impact results, and aggregate counts. */
export type Instacart_Catalog_Admin_V1_GetImpactAnalysisResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetImpactAnalysisResponse';
  changeRequest?: Maybe<Instacart_Catalog_Admin_V1_SourcePriorityChangeRequest>;
  /** Sampled results (up to 50 rows). Empty when status is analysis_running or analysis_failed. */
  impactResults?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_ImpactResult>>>;
  /** Number of retailers not in top_retailers. */
  otherRetailersCount?: Maybe<Scalars['BigInt']>;
  /** Total products affected across retailers not in top_retailers. */
  otherRetailersProductsAffected?: Maybe<Scalars['BigInt']>;
  /** Retailers assigned to incremental rollout stages. Empty before applied_pilot. */
  stagedRetailers?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_StagedRetailer>>>;
  /** Top 5 retailers by products affected. */
  topRetailers?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_RetailerImpactBreakdown>>>;
  totalAttributesAffected?: Maybe<Scalars['BigInt']>;
  totalProductsAffected?: Maybe<Scalars['BigInt']>;
  totalRetailersAffected?: Maybe<Scalars['BigInt']>;
};

/** GetL2CategoriesRequest represents a request to retrieve all l2 categories belonging to the forcemark retailer reports for a list of retailer IDs */
export type Instacart_Catalog_Admin_V1_GetL2CategoriesRequest_Input = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetL2CategoriesResponse represents the response for all l2 categories belonging to the forcemark retailer reports for a list of retailer IDs */
export type Instacart_Catalog_Admin_V1_GetL2CategoriesResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetL2CategoriesResponse';
  l2Categories?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** GetMissingCodesForcemarksProductDetailsRequest represents a request to retrieve product details for a missing codes forcemark */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsRequest_Input = {
  missingCodeId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetMissingCodesForcemarkDetailsResponse represents the response containing missing codes forcemark details */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarkDetailsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMissingCodesForcemarkDetailsResponse';
  localeId?: Maybe<Scalars['BigInt']>;
  missingCode?: Maybe<Scalars['String']>;
  nextMissingCodeId?: Maybe<Scalars['BigInt']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  scannedCount?: Maybe<Scalars['BigInt']>;
  scannedImages?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_ScannedImage>>>;
};

/** GetMissingCodesForcemarksRequest represents a request to retrieve missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksRequest_Input = {
  l2Category?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFilter?: InputMaybe<Scalars['String']>;
};

/** GetMissingCodesForcemarksResponse represents the response containing missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesForcemarksResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMissingCodesForcemarksResponse';
  /** Number of forcemarks returned */
  forcemarkCount?: Maybe<Scalars['BigInt']>;
  /** Detailed list of forcemarks */
  forcemarks?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_MissingCodesForcemark>>>;
};

/** GetMissingCodesReviewedForcemarksRequest represents a request to retrieve reviewed missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksRequest_Input = {
  l2Category?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFilter?: InputMaybe<Scalars['String']>;
};

/** GetMissingCodesReviewedForcemarksResponse represents the response containing reviewed missing codes forcemarks. */
export type Instacart_Catalog_Admin_V1_GetMissingCodesReviewedForcemarksResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMissingCodesReviewedForcemarksResponse';
  /** Number of forcemarks returned */
  forcemarkCount?: Maybe<Scalars['BigInt']>;
  /** Detailed list of reviewed forcemarks */
  forcemarks?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_MissingCodesReviewedForcemark>>>;
};

/** GetMlPriceAnomalyProductDetailsRequest represents a request to retrieve detailed information about a specific ML price anomaly product. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsRequest_Input = {
  /** For pagination of items */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetMlPriceAnomalyProductDetailsResponse represents the response containing product-level and item-level details for an ML price anomaly product. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductDetailsResponse';
  anomalyGroup?: Maybe<Scalars['String']>;
  anomalyReason?: Maybe<Scalars['String']>;
  detectedAt?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse_MlPriceAnomalyItem>>>;
  mlExplanation?: Maybe<Scalars['String']>;
  productImageUrl?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  productSize?: Maybe<Scalars['String']>;
  productUnitCount?: Maybe<Scalars['String']>;
  sizeUom?: Maybe<Scalars['String']>;
  /** Total number of items for this product (for pagination) */
  totalItemCount?: Maybe<Scalars['BigInt']>;
};

/** MlPriceAnomalyItem represents an individual item within a product flagged by the ML price anomaly model. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductDetailsResponse_MlPriceAnomalyItem = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductDetailsResponse_MlPriceAnomalyItem';
  actualCppu?: Maybe<Scalars['String']>;
  actualLpp?: Maybe<Scalars['String']>;
  anomalyGroup?: Maybe<Scalars['String']>;
  costUnit?: Maybe<Scalars['String']>;
  cppuIsAnomaly?: Maybe<Scalars['Boolean']>;
  expectedCppuMax?: Maybe<Scalars['String']>;
  expectedCppuMin?: Maybe<Scalars['String']>;
  expectedLppMax?: Maybe<Scalars['String']>;
  expectedLppMin?: Maybe<Scalars['String']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  itemId?: Maybe<Scalars['BigInt']>;
  lppIsAnomaly?: Maybe<Scalars['Boolean']>;
  mlExplanation?: Maybe<Scalars['String']>;
};

/** GetMlPriceAnomalyProductsRequest represents a request to retrieve ML price anomaly products with optional filtering and pagination. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsRequest_Input = {
  /** Optional filter on anomaly group (e.g. "Base Price", "Sales", "Loyalty", "Promotion") */
  anomalyGroupFilter?: InputMaybe<Scalars['String']>;
  detectionEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional filter for detection date */
  detectionStartDate?: InputMaybe<Scalars['DateTime']>;
  /** For pagination */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** For sorting */
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional filter on product name */
  searchFilter?: InputMaybe<Scalars['String']>;
};

/** GetMlPriceAnomalyProductsResponse represents the response containing a list of ML price anomaly products and pagination metadata. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductsResponse';
  products?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse_MlPriceAnomalyProduct>>>;
  /** For pagination */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** MlPriceAnomalyProduct represents a product flagged by the ML price anomaly model. */
export type Instacart_Catalog_Admin_V1_GetMlPriceAnomalyProductsResponse_MlPriceAnomalyProduct = {
  __typename?: 'instacart_catalog_admin_v1_GetMlPriceAnomalyProductsResponse_MlPriceAnomalyProduct';
  anomalyGroup?: Maybe<Scalars['String']>;
  anomalyReason?: Maybe<Scalars['String']>;
  detectedAt?: Maybe<Scalars['DateTime']>;
  itemCount?: Maybe<Scalars['BigInt']>;
  mlExplanation?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productImageUrl?: Maybe<Scalars['String']>;
  /** These will be displayed in the table */
  productName?: Maybe<Scalars['String']>;
};

/** GetPriceAlertProductDetailsRequest represents a request to retrieve detailed information about a specific product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsRequest_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetPriceAlertProductDetailsResponse represents the response containing detailed item-level information for a product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductDetailsResponse';
  alertPercentage?: Maybe<Scalars['BigInt']>;
  detectionDate?: Maybe<Scalars['DateTime']>;
  discountLimit?: Maybe<Scalars['BigInt']>;
  items?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse_PriceAlertItem>>>;
};

/** PriceAlertItem represents an individual item within a product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductDetailsResponse_PriceAlertItem = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductDetailsResponse_PriceAlertItem';
  basePrice?: Maybe<Scalars['String']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  isOverriden?: Maybe<Scalars['Boolean']>;
  itemId?: Maybe<Scalars['BigInt']>;
  salePrice?: Maybe<Scalars['String']>;
};

/** GetPriceAlertProductsCategoriesRequest represents a request to retrieve categories for price alert products. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional. When non-empty, return categories that have price-alert products
   * for ALL of these retailers in a single call (multi-banner / multi-scope).
   * Mutually exclusive with the scalar `retailer_id` field. All entries must be
   * concrete, non-zero retailer ids that belong to the same partner; the mesh
   * authorizer verifies the caller is authorized for every entry.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetPriceAlertProductsCategoriesResponse represents the response containing a hierarchical list of L1 and L2 categories for filtering price alerts. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsCategoriesResponse';
  l1Categories?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L1Category>>>;
};

/** L1Category represents a Level 1 category that contains multiple L2 categories. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L1Category = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsCategoriesResponse_L1Category';
  l1CategoryName?: Maybe<Scalars['String']>;
  l2Categories?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L2Category>>>;
};

/** L2Category represents a Level 2 category. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsCategoriesResponse_L2Category = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsCategoriesResponse_L2Category';
  categoryId?: Maybe<Scalars['BigInt']>;
  l2CategoryName?: Maybe<Scalars['String']>;
};

/** GetPriceAlertProductsRequest represents a request to retrieve products that triggered price alerts with optional filtering and pagination. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsRequest_Input = {
  detectionEndDate?: InputMaybe<Scalars['DateTime']>;
  /** Optional filter for detection date, use to filter on updated_at */
  detectionStartDate?: InputMaybe<Scalars['DateTime']>;
  /** For pagination */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** For sorting */
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional. When non-empty, return price-alert products for ALL of these
   * retailers in a single call (multi-banner / multi-scope). Every returned row
   * is tagged with its own retailer_id via PriceAlertProduct.retailer_id.
   * Mutually exclusive with the scalar `retailer_id` field. All entries must be
   * concrete, non-zero retailer ids that belong to the same partner; the mesh
   * authorizer verifies the caller is authorized for every entry.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional filter on product name */
  searchFilter?: InputMaybe<Scalars['String']>;
  /** Optional filter param for displaying specific categories */
  selectedCategories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetPriceAlertProductsResponse represents the response containing a list of products that triggered price alerts and pagination metadata. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsResponse';
  products?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse_PriceAlertProduct>>>;
  /** For pagination */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** PriceAlertProduct represents a product that triggered a price alert. */
export type Instacart_Catalog_Admin_V1_GetPriceAlertProductsResponse_PriceAlertProduct = {
  __typename?: 'instacart_catalog_admin_v1_GetPriceAlertProductsResponse_PriceAlertProduct';
  itemCount?: Maybe<Scalars['BigInt']>;
  l2CategoryName?: Maybe<Scalars['String']>;
  lowestSalePricePercentage?: Maybe<Scalars['BigInt']>;
  productId?: Maybe<Scalars['BigInt']>;
  /** These will be displayed in the table */
  productName?: Maybe<Scalars['String']>;
  /**
   * The retailer this row belongs to. Populated on every row so multi-scope
   * callers (request used `retailer_ids`) can group results by retailer.
   * Also populated on the scalar path for consistency.
   */
  retailerId?: Maybe<Scalars['BigInt']>;
  threshold?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * GetRetailerDiscountInitialThresholdsRequest represents a request to retrieve global discount thresholds.
 * Provide either partner_id to get thresholds for all retailers under that partner, or retailer_id for a specific retailer.
 */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsRequest_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetRetailerDiscountInitialThresholdsResponse represents the response containing global threshold data. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountInitialThresholdsResponse';
  /** Returns list of retailer thresholds (single item when querying by retailer_id, multiple when querying by partner_id) */
  retailerThresholds?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse_RetailerGlobalThreshold>>>;
};

/** RetailerGlobalThreshold represents a retailer's global discount threshold. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountInitialThresholdsResponse_RetailerGlobalThreshold = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountInitialThresholdsResponse_RetailerGlobalThreshold';
  globalThreshold?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** GetRetailerDiscountThresholdsRequest represents a request to retrieve retailer discount thresholds with optional filtering and pagination. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsRequest_Input = {
  /** For pagination */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** For sorting */
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional search filter for category name, has priority over selected_categories */
  searchCategory?: InputMaybe<Scalars['String']>;
  /** Optional filter param for displaying specific categories (empty = display all categories) */
  selectedCategories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetRetailerDiscountThresholdsResponse represents the response containing a list of retailer discount thresholds and pagination metadata. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountThresholdsResponse';
  thresholds?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse_RetailerDiscountThreshold>>>;
  /** For pagination */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** RetailerDiscountThreshold represents a discount threshold configuration for a specific category. */
export type Instacart_Catalog_Admin_V1_GetRetailerDiscountThresholdsResponse_RetailerDiscountThreshold = {
  __typename?: 'instacart_catalog_admin_v1_GetRetailerDiscountThresholdsResponse_RetailerDiscountThreshold';
  categoryId?: Maybe<Scalars['BigInt']>;
  /** These will be displayed in the table */
  l1CategoryName?: Maybe<Scalars['String']>;
  l2CategoryName?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['BigInt']>;
  threshold?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** GetSourcePriorityFilterOptionsRequest is empty; all filter option data is returned unconditionally. */
export type Instacart_Catalog_Admin_V1_GetSourcePriorityFilterOptionsRequest_Input = {
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
};

/** GetSourcePriorityFilterOptionsResponse contains distinct attributes, source types, and retailers present in source priority rules. */
export type Instacart_Catalog_Admin_V1_GetSourcePriorityFilterOptionsResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetSourcePriorityFilterOptionsResponse';
  attributes?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailers?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_RetailerInfo>>>;
  sourceTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** GetSourcePriorityRuleRequest identifies a source priority rule to retrieve. */
export type Instacart_Catalog_Admin_V1_GetSourcePriorityRuleRequest_Input = {
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  sourcePriorityId?: InputMaybe<Scalars['BigInt']>;
};

/** GetSourcePriorityRuleResponse contains the requested source priority rule. */
export type Instacart_Catalog_Admin_V1_GetSourcePriorityRuleResponse = {
  __typename?: 'instacart_catalog_admin_v1_GetSourcePriorityRuleResponse';
  rule?: Maybe<Instacart_Catalog_Admin_V1_SourcePriorityRule>;
};

/** One row per affected product-retailer-attribute combination. */
export type Instacart_Catalog_Admin_V1_ImpactResult = {
  __typename?: 'instacart_catalog_admin_v1_ImpactResult';
  attribute?: Maybe<Scalars['String']>;
  currentPriority?: Maybe<Scalars['BigInt']>;
  currentSourceType?: Maybe<Scalars['String']>;
  currentValue?: Maybe<Scalars['String']>;
  newPriority?: Maybe<Scalars['BigInt']>;
  newSourceType?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** Make a request to bring back one or more items via a CSV file */
export type Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvRequest_Input = {
  /** Required: Client making the request, already existing message. But we will add validations */
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** optional. Reason why item needs to be taken down */
  createdWhy?: InputMaybe<Scalars['String']>;
  /** Required: Filestack key used to retrieve the CSV */
  fileZipKey?: InputMaybe<Scalars['String']>;
  /** Optional. stringified json. Can be used to pass any metadata specific to a client. */
  metadata?: InputMaybe<Scalars['String']>;
};

/** A uuid to keep track is sent in the response */
export type Instacart_Catalog_Admin_V1_ItemBringBackBatchCsvResponse = {
  __typename?: 'instacart_catalog_admin_v1_ItemBringBackBatchCsvResponse';
  bringBackBatchRequestUuid?: Maybe<Scalars['String']>;
};

/** ListChangeRequestsRequest specifies filters and pagination for listing change requests. */
export type Instacart_Catalog_Admin_V1_ListChangeRequestsRequest_Input = {
  attribute?: InputMaybe<Scalars['String']>;
  /** UNKNOWN means no filter. */
  changeType?: InputMaybe<Instacart_Catalog_Admin_V1_ChangeType>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** Only return requests submitted within the last N days. Unset means no time filter. */
  daysAgo?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sortDirection?: InputMaybe<Instacart_Catalog_Admin_V1_SortDirection>;
  sortField?: InputMaybe<Instacart_Catalog_Admin_V1_ChangeRequestSortField>;
  sourceType?: InputMaybe<Scalars['String']>;
  /** UNKNOWN means no filter; pending_review rows are always sorted first. */
  status?: InputMaybe<Instacart_Catalog_Admin_V1_ChangeRequestStatus>;
  /** When non-empty, filters by any of the given statuses. Takes precedence over the singular status field. */
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_ChangeRequestStatus>>>;
  submittedBy?: InputMaybe<Scalars['String']>;
};

/** ListChangeRequestsResponse contains a paginated list of change request summaries. */
export type Instacart_Catalog_Admin_V1_ListChangeRequestsResponse = {
  __typename?: 'instacart_catalog_admin_v1_ListChangeRequestsResponse';
  changeRequests?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_ChangeRequestSummary>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** ListSourcePriorityRulesRequest specifies filters and pagination for listing source priority rules. */
export type Instacart_Catalog_Admin_V1_ListSourcePriorityRulesRequest_Input = {
  attribute?: InputMaybe<Scalars['String']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sortDirection?: InputMaybe<Instacart_Catalog_Admin_V1_SortDirection>;
  sortField?: InputMaybe<Instacart_Catalog_Admin_V1_SourcePriorityRuleSortField>;
  sourceType?: InputMaybe<Scalars['String']>;
  /** UNKNOWN means no filter. */
  specificityLevel?: InputMaybe<Instacart_Catalog_Admin_V1_SpecificityLevel>;
};

/** ListSourcePriorityRulesResponse contains a paginated list of source priority rules. */
export type Instacart_Catalog_Admin_V1_ListSourcePriorityRulesResponse = {
  __typename?: 'instacart_catalog_admin_v1_ListSourcePriorityRulesResponse';
  rules?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_SourcePriorityRule>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** MakeMissingCodeDecisionRequest represents a request to submit a retailer decision on a missing codes forcemark */
export type Instacart_Catalog_Admin_V1_MakeMissingCodeDecisionRequest_Input = {
  decision?: InputMaybe<Scalars['String']>;
  localeId?: InputMaybe<Scalars['BigInt']>;
  missingCodeId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scanCode?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** MissingCodesForcemark represents a forcemark entry for products with missing codes. */
export type Instacart_Catalog_Admin_V1_MissingCodesForcemark = {
  __typename?: 'instacart_catalog_admin_v1_MissingCodesForcemark';
  createdAt?: Maybe<Scalars['String']>;
  forcemarkAuditCandidateId?: Maybe<Scalars['BigInt']>;
  l2Category?: Maybe<Scalars['String']>;
  missingCode?: Maybe<Scalars['String']>;
  missingCodeId?: Maybe<Scalars['BigInt']>;
  numberOfScans?: Maybe<Scalars['BigInt']>;
  productDisplayName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
};

/** MissingCodesReviewedForcemark represents a reviewed forcemark entry for products with missing codes. */
export type Instacart_Catalog_Admin_V1_MissingCodesReviewedForcemark = {
  __typename?: 'instacart_catalog_admin_v1_MissingCodesReviewedForcemark';
  actionTaken?: Maybe<Scalars['String']>;
  dateOfAction?: Maybe<Scalars['String']>;
  forcemarkAuditCandidateId?: Maybe<Scalars['BigInt']>;
  l2Category?: Maybe<Scalars['String']>;
  missingCode?: Maybe<Scalars['String']>;
  missingCodeId?: Maybe<Scalars['BigInt']>;
  productDisplayName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
};

/** RejectChangeRequestRequest identifies the change request to reject, with an optional reviewer note. */
export type Instacart_Catalog_Admin_V1_RejectChangeRequestRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  reviewerNote?: InputMaybe<Scalars['String']>;
};

/** Per-retailer summary of affected products for the top retailers. */
export type Instacart_Catalog_Admin_V1_RetailerImpactBreakdown = {
  __typename?: 'instacart_catalog_admin_v1_RetailerImpactBreakdown';
  productsAffected?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** RetailerInfo is a retailer ID and human-readable name. */
export type Instacart_Catalog_Admin_V1_RetailerInfo = {
  __typename?: 'instacart_catalog_admin_v1_RetailerInfo';
  name?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** RetryAnalysisRequest identifies the change request to re-trigger impact analysis for. */
export type Instacart_Catalog_Admin_V1_RetryAnalysisRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
};

/** RollbackChangeRequestRequest identifies the staged change request to roll back. */
export type Instacart_Catalog_Admin_V1_RollbackChangeRequestRequest_Input = {
  authorEmail?: InputMaybe<Scalars['String']>;
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
};

/** RolloutStage identifies which incremental rollout stage a retailer is assigned to. */
export enum Instacart_Catalog_Admin_V1_RolloutStage {
  RolloutStage_10Pct = 'ROLLOUT_STAGE_10_PCT',
  RolloutStage_50Pct = 'ROLLOUT_STAGE_50_PCT',
  RolloutStagePilot = 'ROLLOUT_STAGE_PILOT',
  RolloutStageUnknown = 'ROLLOUT_STAGE_UNKNOWN'
}

/** ScannedImage represents a scanned image with ranking and URL */
export type Instacart_Catalog_Admin_V1_ScannedImage = {
  __typename?: 'instacart_catalog_admin_v1_ScannedImage';
  ranking?: Maybe<Scalars['BigInt']>;
  url?: Maybe<Scalars['String']>;
};

/** Request to search for taxonomy nodes */
export type Instacart_Catalog_Admin_V1_SearchTaxonomyNodesRequest_Input = {
  /** Required. Client making the request */
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** Required. A string to match against the taxonomy path of a taxonomy node */
  taxonomyPathFuzzyWord?: InputMaybe<Scalars['String']>;
};

/** Response object from searching for taxonomy nodes */
export type Instacart_Catalog_Admin_V1_SearchTaxonomyNodesResponse = {
  __typename?: 'instacart_catalog_admin_v1_SearchTaxonomyNodesResponse';
  /** A list of matching taxonomy nodes */
  nodes?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_TaxonomyNode>>>;
};

/** SetRetailerDiscountThresholdBringBacksRequest represents a request to bring back items that were taken down due to discount thresholds or reverse a previous bring back. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_Input = {
  /** Indicates if it's a bringback or reversing a bringback */
  isBringback?: InputMaybe<Scalars['Boolean']>;
  itemIdsList?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ItemIds_Input>;
  productIdsList?: InputMaybe<Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ProductIds_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** ItemIds represents a list of item IDs to bring back. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ItemIds_Input = {
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  productId?: InputMaybe<Scalars['BigInt']>;
};

/** ProductIds represents a list of product IDs to bring back. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdBringBacksRequest_ProductIds_Input = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** SetRetailerDiscountThresholdsRequest represents a request to set or update retailer discount thresholds for specific categories or globally. */
export type Instacart_Catalog_Admin_V1_SetRetailerDiscountThresholdsRequest_Input = {
  /** A list of l2 category IDs */
  categories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** If this is true, instead update the global default threshold, ignore categories list */
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
  threshold?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['String']>;
};

/**
 * SortDirection controls ascending or descending order for list endpoints.
 * UNKNOWN defaults to DESC.
 */
export enum Instacart_Catalog_Admin_V1_SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnknown = 'SORT_DIRECTION_UNKNOWN'
}

/**
 * Full change request record, including all fields and current status.
 * Note: despite the name, this is a response record, not a request message.
 */
export type Instacart_Catalog_Admin_V1_SourcePriorityChangeRequest = {
  __typename?: 'instacart_catalog_admin_v1_SourcePriorityChangeRequest';
  appliedAt?: Maybe<Scalars['DateTime']>;
  attribute?: Maybe<Scalars['String']>;
  changeReason?: Maybe<Scalars['String']>;
  changeType?: Maybe<Instacart_Catalog_Admin_V1_ChangeType>;
  id?: Maybe<Scalars['BigInt']>;
  isSubmitter?: Maybe<Scalars['Boolean']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  priorityAfter?: Maybe<Scalars['BigInt']>;
  priorityBefore?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  reviewedBy?: Maybe<Scalars['String']>;
  reviewerNote?: Maybe<Scalars['String']>;
  sourcePriorityId?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Catalog_Admin_V1_ChangeRequestStatus>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
};

/** SourcePriorityCondition represents a conditional constraint associated with a source priority rule. */
export type Instacart_Catalog_Admin_V1_SourcePriorityCondition = {
  __typename?: 'instacart_catalog_admin_v1_SourcePriorityCondition';
  attribute?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** SourcePriorityRule represents a single source priority configuration record. */
export type Instacart_Catalog_Admin_V1_SourcePriorityRule = {
  __typename?: 'instacart_catalog_admin_v1_SourcePriorityRule';
  attribute?: Maybe<Scalars['String']>;
  conditions?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_SourcePriorityCondition>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  priority?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  sourcePriorityId?: Maybe<Scalars['BigInt']>;
  sourceType?: Maybe<Scalars['String']>;
  specificityLevel?: Maybe<Instacart_Catalog_Admin_V1_SpecificityLevel>;
};

/**
 * SourcePriorityRuleSortField identifies which field to sort by in ListSourcePriorityRules.
 * UNKNOWN defaults to priority DESC.
 */
export enum Instacart_Catalog_Admin_V1_SourcePriorityRuleSortField {
  SourcePriorityRuleSortFieldAttribute = 'SOURCE_PRIORITY_RULE_SORT_FIELD_ATTRIBUTE',
  SourcePriorityRuleSortFieldCreatedAt = 'SOURCE_PRIORITY_RULE_SORT_FIELD_CREATED_AT',
  SourcePriorityRuleSortFieldPriority = 'SOURCE_PRIORITY_RULE_SORT_FIELD_PRIORITY',
  SourcePriorityRuleSortFieldRetailerId = 'SOURCE_PRIORITY_RULE_SORT_FIELD_RETAILER_ID',
  SourcePriorityRuleSortFieldSourceType = 'SOURCE_PRIORITY_RULE_SORT_FIELD_SOURCE_TYPE',
  SourcePriorityRuleSortFieldSpecificityLevel = 'SOURCE_PRIORITY_RULE_SORT_FIELD_SPECIFICITY_LEVEL',
  SourcePriorityRuleSortFieldUnknown = 'SOURCE_PRIORITY_RULE_SORT_FIELD_UNKNOWN'
}

/** SpecificityLevel describes the scope of a source priority rule. */
export enum Instacart_Catalog_Admin_V1_SpecificityLevel {
  SpecificityLevelAttribute = 'SPECIFICITY_LEVEL_ATTRIBUTE',
  SpecificityLevelAttributeAndRetailer = 'SPECIFICITY_LEVEL_ATTRIBUTE_AND_RETAILER',
  SpecificityLevelGlobal = 'SPECIFICITY_LEVEL_GLOBAL',
  SpecificityLevelRetailer = 'SPECIFICITY_LEVEL_RETAILER',
  SpecificityLevelUnknown = 'SPECIFICITY_LEVEL_UNKNOWN'
}

/** A retailer assigned to an incremental rollout stage for a given change request. */
export type Instacart_Catalog_Admin_V1_StagedRetailer = {
  __typename?: 'instacart_catalog_admin_v1_StagedRetailer';
  productsAffected?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  rolloutStage?: Maybe<Instacart_Catalog_Admin_V1_RolloutStage>;
};

/** Taxonomy Node */
export type Instacart_Catalog_Admin_V1_TaxonomyNode = {
  __typename?: 'instacart_catalog_admin_v1_TaxonomyNode';
  /** Identifier for the node */
  id?: Maybe<Scalars['String']>;
  /** The name of the category for this node */
  productCategory?: Maybe<Scalars['String']>;
  /** Category path for the node */
  productCategoryPath?: Maybe<Scalars['String']>;
};

/** This is used to specify the attribute and value to override. */
export type Instacart_Catalog_Admin_V1_TempOverrideAttrInput_Input = {
  /**
   * This should be a JSON value in the form of { "<ATTRIBUTE_NAME>": ATTRIBUTE_VALUE }.
   * e.g. "{\"name\": \"Pickles\"}"
   * This form allows you to pass any type of value.
   * Only include one attribute per TempOverrideAttrInput.
   */
  attribute?: InputMaybe<Scalars['String']>;
  /**
   * This is field is required for updating some attributes.
   * For the "name" attribute, you must include the brand name here like this:
   * "{\"brand_name\": \"<BRAND_NAME>\"}"
   * e.g. "{\"brand_name\": \"Klaussen\"}"
   */
  metadata?: InputMaybe<Scalars['String']>;
  /**
   * Optional field. If true, the any override for the named attribute will be
   * tombstoned, regardless of metadata or value.
   */
  tombstone?: InputMaybe<Scalars['Boolean']>;
};

/** This is the output for a single temporary override attribute. */
export type Instacart_Catalog_Admin_V1_TempOverrideAttrOutput = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideAttrOutput';
  /** This is a JSON value in the form of { "<ATTRIBUTE_NAME>": ATTRIBUTE_VALUE }. */
  attribute?: Maybe<Scalars['String']>;
  /** This is when the override was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
};

/** This message is used to specify the entity for which the temporary override applies to. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityId = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideEntityId';
  /** Only required for Items. This should be left empty for retailer products. */
  itemId?: Maybe<Scalars['BigInt']>;
  /** Required */
  localeId?: Maybe<Scalars['BigInt']>;
  /** Required */
  productId?: Maybe<Scalars['BigInt']>;
  /** Required */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** Required */
  surfaceId?: Maybe<Scalars['BigInt']>;
};

/** This message is used to specify the entity for which the temporary override applies to. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input = {
  /** Only required for Items. This should be left empty for retailer products. */
  itemId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  localeId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  productId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required */
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

/** This is used to specify the entity and attrs for which the temporary override applies to. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityInput_Input = {
  /** Required */
  entityId?: InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input>;
  /**
   * Required
   * You can specify multiple attributes to override.
   */
  tempOverrideAttrs?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideAttrInput_Input>>>;
};

/** This is the output for the temporary overrides for a single entity. */
export type Instacart_Catalog_Admin_V1_TempOverrideEntityOutput = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideEntityOutput';
  /** This can be "pending", "applied", or "published" */
  currentState?: Maybe<Scalars['String']>;
  /** The entity the attribute data corresponds to. */
  entityId?: Maybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId>;
  /** The patch ID for the Temp Override. */
  patchId?: Maybe<Scalars['BigInt']>;
  /**
   * The attributes that have been overridden.
   * This is a combo of Pending Temp Overrides and Published Temp Overrides.
   */
  tempOverrideAttrs?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_TempOverrideAttrOutput>>>;
  /** The ID for the Temp Override. */
  tempOverrideId?: Maybe<Scalars['BigInt']>;
};

/** Used to create a temporary override for a retailer product or item. */
export type Instacart_Catalog_Admin_V1_TempOverrideServiceCreateRequest_Input = {
  /** Put the app name, user name, and user ID here. This will be added to the "created_why" field. */
  client?: InputMaybe<Instacart_Catalog_Admin_V1_Client_Input>;
  /** Required */
  tempOverrideEntities?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityInput_Input>>>;
};

/** Used to request a list of temporary overrides for a set of retailer products or items. */
export type Instacart_Catalog_Admin_V1_TempOverrideServiceListRequest_Input = {
  /**
   * Required
   * You need to specify at least one entity to get the overrides for.
   */
  entities?: InputMaybe<Array<InputMaybe<Instacart_Catalog_Admin_V1_TempOverrideEntityId_Input>>>;
  /**
   * Optional.
   * Set this to "item" if you specify an RP and you want the item overrides
   * All other values will default to match the same entity that you requested.
   */
  responseEntityType?: InputMaybe<Scalars['String']>;
};

/** Response for listing temporary overrides. */
export type Instacart_Catalog_Admin_V1_TempOverrideServiceListResponse = {
  __typename?: 'instacart_catalog_admin_v1_TempOverrideServiceListResponse';
  tempOverrideEntities?: Maybe<Array<Maybe<Instacart_Catalog_Admin_V1_TempOverrideEntityOutput>>>;
};

/** Representation of Create New Step Request */
export type Instacart_Catalog_Catflow_V1_CreateNewStepRequest_Input = {
  /** required */
  attributes?: InputMaybe<Scalars['JSON']>;
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  step?: InputMaybe<Instacart_Catalog_Catflow_V1_Step_Input>;
};

/** Representation of Create New Step Response */
export type Instacart_Catalog_Catflow_V1_CreateNewStepResponse = {
  __typename?: 'instacart_catalog_catflow_v1_CreateNewStepResponse';
  id?: Maybe<Scalars['BigInt']>;
};

/** Representation of Create New Step Version Request */
export type Instacart_Catalog_Catflow_V1_CreateNewStepVersionRequest_Input = {
  attributes?: InputMaybe<Scalars['JSON']>;
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  createdBy?: InputMaybe<Scalars['String']>;
  /** required */
  createdWhy?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  state?: InputMaybe<Scalars['String']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
};

/** Representation of Create New Step Version Response */
export type Instacart_Catalog_Catflow_V1_CreateNewStepVersionResponse = {
  __typename?: 'instacart_catalog_catflow_v1_CreateNewStepVersionResponse';
  id?: Maybe<Scalars['BigInt']>;
};

/** Input for DescribeSnowflakeTable endpoint */
export type Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required - fully qualified name of the table you wish to describe. */
  tableName?: InputMaybe<Scalars['String']>;
};

/** Output for DescribeSnowflakeTable endpoint */
export type Instacart_Catalog_Catflow_V1_DescribeSnowflakeTableResponse = {
  __typename?: 'instacart_catalog_catflow_v1_DescribeSnowflakeTableResponse';
  columns?: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_SnowflakeTableColumn>>>;
};

export type Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Catalog_Catflow_V1_GetPresignedUploadUrlResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetPresignedUploadUrlResponse';
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Representation of Get Step Run Results Request */
export type Instacart_Catalog_Catflow_V1_GetStepRunResultsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  stepRunId?: InputMaybe<Scalars['BigInt']>;
};

/** Representation of Get Step Run Results Response */
export type Instacart_Catalog_Catflow_V1_GetStepRunResultsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetStepRunResultsResponse';
  results?: Maybe<Scalars['String']>;
};

export type Instacart_Catalog_Catflow_V1_GetStepVersionHistoryRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_GetStepVersionHistoryResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetStepVersionHistoryResponse';
  stepVersion?: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_StepVersion>>>;
};

/** Representation of Get Step Version Request */
export type Instacart_Catalog_Catflow_V1_GetStepVersionRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

/** Representation of Get Step Version Response */
export type Instacart_Catalog_Catflow_V1_GetStepVersionResponse = {
  __typename?: 'instacart_catalog_catflow_v1_GetStepVersionResponse';
  stepVersion?: Maybe<Instacart_Catalog_Catflow_V1_StepVersion>;
};

/** Representation of List Step Runs Request */
export type Instacart_Catalog_Catflow_V1_ListStepRunsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  stepVersionId?: InputMaybe<Scalars['BigInt']>;
};

/** Representation of List Step Run Response */
export type Instacart_Catalog_Catflow_V1_ListStepRunsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_ListStepRunsResponse';
  currentPage?: Maybe<Scalars['BigInt']>;
  pageCount?: Maybe<Scalars['BigInt']>;
  stepRuns?: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_StepRun>>>;
};

export type Instacart_Catalog_Catflow_V1_ListStepVersionsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  stepId?: InputMaybe<Scalars['BigInt']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_ListStepVersionsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_ListStepVersionsResponse';
  stepVersions?: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_StepVersion>>>;
};

export type Instacart_Catalog_Catflow_V1_ListStepsRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  pageSize?: InputMaybe<Scalars['BigInt']>;
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  stepType?: InputMaybe<Scalars['String']>;
};

/** Representation of List Steps Response */
export type Instacart_Catalog_Catflow_V1_ListStepsResponse = {
  __typename?: 'instacart_catalog_catflow_v1_ListStepsResponse';
  steps?: Maybe<Array<Maybe<Instacart_Catalog_Catflow_V1_Step>>>;
  totalResultCount?: Maybe<Scalars['BigInt']>;
};

/** Representation of Revert To Step Version Request */
export type Instacart_Catalog_Catflow_V1_RevertToStepVersionRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  /** required */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_RunManualStepTestRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  createdBy?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  inputS3File?: InputMaybe<Scalars['String']>;
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** required */
  stepVersionId?: InputMaybe<Scalars['BigInt']>;
  /** required */
  testInputs?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Instacart_Catalog_Catflow_V1_RunManualStepTestResponse = {
  __typename?: 'instacart_catalog_catflow_v1_RunManualStepTestResponse';
  warningMessage?: Maybe<Scalars['String']>;
  workflowRunId?: Maybe<Scalars['String']>;
};

/** Representation of a column of a snowflake table */
export type Instacart_Catalog_Catflow_V1_SnowflakeTableColumn = {
  __typename?: 'instacart_catalog_catflow_v1_SnowflakeTableColumn';
  default?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nullable?: Maybe<Scalars['Boolean']>;
  primaryKey?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  uniqueKey?: Maybe<Scalars['Boolean']>;
};

/** Representation of Step Object */
export type Instacart_Catalog_Catflow_V1_Step = {
  __typename?: 'instacart_catalog_catflow_v1_Step';
  /** required */
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** required */
  name?: Maybe<Scalars['String']>;
  /** required */
  owner?: Maybe<Scalars['String']>;
  /** required */
  stepCategory?: Maybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  tombstoned?: Maybe<Scalars['Boolean']>;
  /** required */
  type?: Maybe<Scalars['String']>;
};

/**
 * CAMP Pipeline Step APIs                //
 *
 * Enum Representation for Step Category
 */
export enum Instacart_Catalog_Catflow_V1_StepCategory {
  ApiService = 'API_SERVICE',
  Audit = 'AUDIT',
  ExtractionModel = 'EXTRACTION_MODEL',
  Input = 'INPUT',
  Normalization = 'NORMALIZATION',
  Pipeline = 'PIPELINE',
  Publish = 'PUBLISH',
  Unknown = 'UNKNOWN',
  Validation = 'VALIDATION'
}

export type Instacart_Catalog_Catflow_V1_StepRun = {
  __typename?: 'instacart_catalog_catflow_v1_StepRun';
  /** required */
  createdAt?: Maybe<Scalars['DateTime']>;
  dashboardUrl?: Maybe<Scalars['String']>;
  failedReasons?: Maybe<Scalars['String']>;
  failedTaskCount?: Maybe<Scalars['BigInt']>;
  /** required */
  id?: Maybe<Scalars['BigInt']>;
  /** required */
  productCount?: Maybe<Scalars['BigInt']>;
  /** required */
  requester?: Maybe<Scalars['String']>;
  /** required */
  state?: Maybe<Scalars['String']>;
  stateMessage?: Maybe<Scalars['String']>;
  /** required */
  version?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_StepVersion = {
  __typename?: 'instacart_catalog_catflow_v1_StepVersion';
  /** required */
  attributes?: Maybe<Scalars['JSON']>;
  /** required */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** required */
  createdBy?: Maybe<Scalars['String']>;
  /** required */
  createdWhy?: Maybe<Scalars['String']>;
  /** required */
  id?: Maybe<Scalars['BigInt']>;
  /** required */
  state?: Maybe<Scalars['String']>;
  step?: Maybe<Instacart_Catalog_Catflow_V1_Step>;
  /** required */
  stepId?: Maybe<Scalars['BigInt']>;
  tombstoned?: Maybe<Scalars['Boolean']>;
  /** required */
  version?: Maybe<Scalars['BigInt']>;
};

/** Representation of Step Object */
export type Instacart_Catalog_Catflow_V1_Step_Input = {
  /** required */
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** required */
  name?: InputMaybe<Scalars['String']>;
  /** required */
  owner?: InputMaybe<Scalars['String']>;
  /** required */
  stepCategory?: InputMaybe<Instacart_Catalog_Catflow_V1_StepCategory>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
  /** required */
  type?: InputMaybe<Scalars['String']>;
};

export type Instacart_Catalog_Catflow_V1_UpdateStepRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Catalog_Catflow_V1_UpdateStepVersionStateRequest_Input = {
  /** required */
  clientId?: InputMaybe<Scalars['String']>;
  /** required */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** required */
  newState?: InputMaybe<Scalars['String']>;
  /** required */
  stepId?: InputMaybe<Scalars['BigInt']>;
  /** required */
  stepVersionId?: InputMaybe<Scalars['BigInt']>;
};

/** AddSchemaVersionRequest appends a new (input, output) schema pair to a bridge */
export type Instacart_Catalog_Data_Bridge_V1_AddSchemaVersionRequest_Input = {
  /** Required: bridge name to append to */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the creator */
  created_by?: InputMaybe<Scalars['String']>;
  /** Required: input schema */
  input_schema?: InputMaybe<Scalars['JSON']>;
  /** Required: output schema */
  output_schema?: InputMaybe<Scalars['JSON']>;
};

/** AddSchemaVersionResponse returns the newly appended schema version */
export type Instacart_Catalog_Data_Bridge_V1_AddSchemaVersionResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_AddSchemaVersionResponse';
  /** The appended version */
  schema_version?: Maybe<Instacart_Catalog_Data_Bridge_V1_SchemaVersion>;
};

/** ApiConfig configures direct API integration */
export type Instacart_Catalog_Data_Bridge_V1_ApiConfig = {
  __typename?: 'instacart_catalog_data_bridge_v1_ApiConfig';
  /** Required: API endpoint URL */
  endpoint?: Maybe<Scalars['String']>;
  /** Optional: request timeout in seconds (default: 30) */
  timeout_seconds?: Maybe<Scalars['Int']>;
};

/** ApiConfig configures direct API integration */
export type Instacart_Catalog_Data_Bridge_V1_ApiConfig_Input = {
  /** Required: API endpoint URL */
  endpoint?: InputMaybe<Scalars['String']>;
  /** Optional: request timeout in seconds (default: 30) */
  timeout_seconds?: InputMaybe<Scalars['Int']>;
};

/** Batch represents a single execution of a bridge */
export type Instacart_Catalog_Data_Bridge_V1_Batch = {
  __typename?: 'instacart_catalog_data_bridge_v1_Batch';
  /** UUID, unique identifier for this batch */
  batch_id?: Maybe<Scalars['String']>;
  /** Name of the bridge that created this batch */
  bridge_name?: Maybe<Scalars['String']>;
  /** When the batch was created */
  created_at?: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the creator (user or system) */
  created_by?: Maybe<Scalars['String']>;
  /** Whether batch fails on first validation error */
  fail_batch_on_validation_error?: Maybe<Scalars['Boolean']>;
  /** S3 path to input data */
  input_s3_location?: Maybe<Scalars['String']>;
  /** User-provided metadata */
  metadata?: Maybe<Scalars['JSON']>;
  /** Optional: S3 path where output should be written */
  output_s3_location?: Maybe<Scalars['String']>;
  /** Effective per-batch input size cap applied (0 = no cap) */
  resolved_batch_size?: Maybe<Scalars['Int']>;
  /** Schema version actually used for validation (0 = validation disabled) */
  resolved_schema_version?: Maybe<Scalars['Int']>;
  /** Current status of the batch */
  status?: Maybe<Scalars['String']>;
};

/** BatchEvent represents a single event in a batch's lifecycle (event-sourced status tracking) */
export type Instacart_Catalog_Data_Bridge_V1_BatchEvent = {
  __typename?: 'instacart_catalog_data_bridge_v1_BatchEvent';
  /** When the event occurred */
  created_at?: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the actor (user or system) */
  created_by?: Maybe<Scalars['String']>;
  /** Event-specific data */
  data?: Maybe<Scalars['JSON']>;
  /** Event type (e.g., "batch.submitted", "batch.started", "batch.completed") */
  type?: Maybe<Scalars['String']>;
};

/** Bridge represents a data connector between two systems */
export type Instacart_Catalog_Data_Bridge_V1_Bridge = {
  __typename?: 'instacart_catalog_data_bridge_v1_Bridge';
  /** Bridge configuration (schemas, execution, SLA, etc.) */
  config?: Maybe<Instacart_Catalog_Data_Bridge_V1_BridgeConfig>;
  /** When the bridge was created */
  created_at?: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the creator (user or system) */
  created_by?: Maybe<Scalars['String']>;
  /** Human-readable description of what this bridge does */
  description?: Maybe<Scalars['String']>;
  /** Bridge ID */
  id?: Maybe<Scalars['BigInt']>;
  /** Unique identifier (e.g., "product-tax-taxonomy-classification") */
  name?: Maybe<Scalars['String']>;
  /** Whether the bridge is deleted (false = active) */
  tombstoned?: Maybe<Scalars['Boolean']>;
  /** When the bridge was last updated */
  updated_at?: Maybe<Scalars['DateTime']>;
  /** Human-readable name of the last updater (user or system) */
  updated_by?: Maybe<Scalars['String']>;
  /** Reason for the last update */
  updated_why?: Maybe<Scalars['String']>;
};

/** BridgeConfig contains schemas and execution configuration for a bridge */
export type Instacart_Catalog_Data_Bridge_V1_BridgeConfig = {
  __typename?: 'instacart_catalog_data_bridge_v1_BridgeConfig';
  /** Direct API integration */
  api?: Maybe<Instacart_Catalog_Data_Bridge_V1_ApiConfig>;
  /** Required: input data schema (JSON Schema format) */
  input_schema?: Maybe<Scalars['JSON']>;
  /** ISC (Instacart Service Cloud) task execution */
  isc_task?: Maybe<Instacart_Catalog_Data_Bridge_V1_IscTaskConfig>;
  /** Optional: cap on per-batch input size; 0 = no cap */
  max_batch_size?: Maybe<Scalars['Int']>;
  /** Optional: maximum retry attempts on failure (default: 0) */
  max_retries?: Maybe<Scalars['Int']>;
  output_schema?: Maybe<Scalars['JSON']>;
  /** Optional: when true, validate input/output S3 files against input_schema/output_schema (default: false) */
  schema_validation_enabled?: Maybe<Scalars['Boolean']>;
  /** Required: SLA in hours (supports fractional, e.g., 0.5 = 30 min) */
  sla_hours?: Maybe<Scalars['Float']>;
};

/** BridgeConfig contains schemas and execution configuration for a bridge */
export type Instacart_Catalog_Data_Bridge_V1_BridgeConfig_Input = {
  /** Direct API integration */
  api?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_ApiConfig_Input>;
  /** Required: input data schema (JSON Schema format) */
  input_schema?: InputMaybe<Scalars['JSON']>;
  /** ISC (Instacart Service Cloud) task execution */
  isc_task?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_IscTaskConfig_Input>;
  /** Optional: cap on per-batch input size; 0 = no cap */
  max_batch_size?: InputMaybe<Scalars['Int']>;
  /** Optional: maximum retry attempts on failure (default: 0) */
  max_retries?: InputMaybe<Scalars['Int']>;
  output_schema?: InputMaybe<Scalars['JSON']>;
  /** Optional: when true, validate input/output S3 files against input_schema/output_schema (default: false) */
  schema_validation_enabled?: InputMaybe<Scalars['Boolean']>;
  /** Required: SLA in hours (supports fractional, e.g., 0.5 = 30 min) */
  sla_hours?: InputMaybe<Scalars['Float']>;
};

/** CreateBatchEventRequest contains parameters for creating a batch event */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchEventRequest_Input = {
  /** Required: batch ID to add event to */
  batch_id?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the event creator (user or system) */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: event-specific data */
  data?: InputMaybe<Scalars['JSON']>;
  /** Required: event type (e.g., "batch.processing_started", "batch.completed") */
  event_type?: InputMaybe<Scalars['String']>;
};

/** CreateBatchEventResponse returns the created batch event */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchEventResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_CreateBatchEventResponse';
  /** The created batch event */
  event?: Maybe<Instacart_Catalog_Data_Bridge_V1_BatchEvent>;
};

/** CreateBatchRequest contains parameters for creating a new batch execution */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchRequest_Input = {
  /** Optional: per-batch input size override; 0 = use bridge default */
  batch_size_override?: InputMaybe<Scalars['Int']>;
  /** Required: bridge name to execute */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the creator (user or system) */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: when true, whole batch fails if any input row fails validation */
  fail_batch_on_validation_error?: InputMaybe<Scalars['Boolean']>;
  /** Required: S3 path to input data */
  input_s3_location?: InputMaybe<Scalars['String']>;
  /** Optional: user-provided metadata (tags, labels, etc.) */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** Optional: S3 path where output should be written */
  output_s3_location?: InputMaybe<Scalars['String']>;
  /** Optional: schema version to validate against; 0 = latest */
  pinned_schema_version?: InputMaybe<Scalars['Int']>;
};

/** CreateBatchResponse returns the newly created batch */
export type Instacart_Catalog_Data_Bridge_V1_CreateBatchResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_CreateBatchResponse';
  /** The created batch */
  batch?: Maybe<Instacart_Catalog_Data_Bridge_V1_Batch>;
};

/** CreateBridgeRequest contains parameters for creating a new bridge */
export type Instacart_Catalog_Data_Bridge_V1_CreateBridgeRequest_Input = {
  /** Required: bridge configuration */
  config?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_BridgeConfig_Input>;
  /** Required: human-readable name of the creator (user or system) */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: human-readable description */
  description?: InputMaybe<Scalars['String']>;
  /** Required: unique bridge identifier (alphanumeric, lowercase, hyphens) */
  name?: InputMaybe<Scalars['String']>;
  /** Optional: whether bridge is active (default: false = active) */
  tombstoned?: InputMaybe<Scalars['Boolean']>;
};

/** CreateBridgeResponse returns the newly created bridge */
export type Instacart_Catalog_Data_Bridge_V1_CreateBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_CreateBridgeResponse';
  /** The created bridge */
  bridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** DeleteBridgeRequest contains parameters for soft deleting a bridge */
export type Instacart_Catalog_Data_Bridge_V1_DeleteBridgeRequest_Input = {
  /** Required: bridge name to delete (soft delete, sets tombstoned=true) */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the deleter (user or system) */
  deleted_by?: InputMaybe<Scalars['String']>;
  /** Required: reason for the deletion */
  deleted_why?: InputMaybe<Scalars['String']>;
};

/** DeleteBridgeResponse returns the soft-deleted bridge */
export type Instacart_Catalog_Data_Bridge_V1_DeleteBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_DeleteBridgeResponse';
  /** The deleted bridge (with tombstoned=true) */
  bridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** GetBatchRequest contains parameters for retrieving a batch */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchRequest_Input = {
  /** Required: batch ID to query */
  batch_id?: InputMaybe<Scalars['String']>;
};

/** GetBatchResponse returns batch information without event history */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_GetBatchResponse';
  /** Batch information without events */
  batch?: Maybe<Instacart_Catalog_Data_Bridge_V1_Batch>;
};

/** GetBatchStatusRequest contains parameters for retrieving batch status with event history */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchStatusRequest_Input = {
  /** Required: batch ID to query */
  batch_id?: InputMaybe<Scalars['String']>;
  /** Optional: limit number of events returned (default: 10) */
  max_events?: InputMaybe<Scalars['Int']>;
};

/** GetBatchStatusResponse returns the current status and event history */
export type Instacart_Catalog_Data_Bridge_V1_GetBatchStatusResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_GetBatchStatusResponse';
  /** Convenience: echoed from request */
  batch_id?: Maybe<Scalars['String']>;
  /** Event history (most recent first) */
  events?: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_BatchEvent>>>;
  /** Current status of the batch */
  status?: Maybe<Scalars['String']>;
};

/** GetBridgeRequest contains parameters for retrieving a bridge */
export type Instacart_Catalog_Data_Bridge_V1_GetBridgeRequest_Input = {
  /** Required: bridge name */
  bridge_name?: InputMaybe<Scalars['String']>;
};

/** GetBridgeResponse returns the requested bridge */
export type Instacart_Catalog_Data_Bridge_V1_GetBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_GetBridgeResponse';
  /** The requested bridge */
  bridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** IscTaskConfig configures ISC (Instacart Service Cloud) task execution */
export type Instacart_Catalog_Data_Bridge_V1_IscTaskConfig = {
  __typename?: 'instacart_catalog_data_bridge_v1_IscTaskConfig';
  /** Optional: key-value pairs for {additional_parameters} placeholder */
  additional_task_parameters?: Maybe<Scalars['JSON']>;
  /** Required: command template with placeholders {input_file}, {output_file}, {additional_parameters} */
  command_template?: Maybe<Scalars['String']>;
  /** Required: ISC app name for build lookup */
  isc_app_name?: Maybe<Scalars['String']>;
  /** Required: name of the ISC task to execute */
  isc_task_name?: Maybe<Scalars['String']>;
};

/** IscTaskConfig configures ISC (Instacart Service Cloud) task execution */
export type Instacart_Catalog_Data_Bridge_V1_IscTaskConfig_Input = {
  /** Optional: key-value pairs for {additional_parameters} placeholder */
  additional_task_parameters?: InputMaybe<Scalars['JSON']>;
  /** Required: command template with placeholders {input_file}, {output_file}, {additional_parameters} */
  command_template?: InputMaybe<Scalars['String']>;
  /** Required: ISC app name for build lookup */
  isc_app_name?: InputMaybe<Scalars['String']>;
  /** Required: name of the ISC task to execute */
  isc_task_name?: InputMaybe<Scalars['String']>;
};

/** ListBatchesRequest contains parameters for listing batches with optional filters */
export type Instacart_Catalog_Data_Bridge_V1_ListBatchesRequest_Input = {
  /** Optional: filter by bridge name */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Optional: filter by creator */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: start of date range filter */
  from_date?: InputMaybe<Scalars['DateTime']>;
  /** Optional: max results to return (default: 50) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional: pagination offset (default: 0) */
  offset?: InputMaybe<Scalars['Int']>;
  /** Optional: end of date range filter */
  to_date?: InputMaybe<Scalars['DateTime']>;
};

/** ListBatchesResponse returns a list of batches with total count */
export type Instacart_Catalog_Data_Bridge_V1_ListBatchesResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_ListBatchesResponse';
  /** List of batches */
  batches?: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_Batch>>>;
  /** Total number of batches matching the query */
  total_count?: Maybe<Scalars['Int']>;
};

/** ListBridgesRequest contains parameters for listing bridges */
export type Instacart_Catalog_Data_Bridge_V1_ListBridgesRequest_Input = {
  /** Optional: filter by creator */
  created_by?: InputMaybe<Scalars['String']>;
  /** Optional: include deleted bridges (default: false) */
  include_tombstoned?: InputMaybe<Scalars['Boolean']>;
  /** Optional: max results to return (default: 50) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional: pagination offset (default: 0) */
  offset?: InputMaybe<Scalars['Int']>;
};

/** ListBridgesResponse returns a list of bridges with total count */
export type Instacart_Catalog_Data_Bridge_V1_ListBridgesResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_ListBridgesResponse';
  /** List of bridges */
  bridges?: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>>>;
  /** Total number of bridges matching the query */
  total_count?: Maybe<Scalars['Int']>;
};

/** ListSchemaVersionsRequest lists schema versions for a bridge */
export type Instacart_Catalog_Data_Bridge_V1_ListSchemaVersionsRequest_Input = {
  /** Required: bridge name to list versions for */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Optional: max results to return (default: 50) */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional: pagination offset (default: 0) */
  offset?: InputMaybe<Scalars['Int']>;
};

/** ListSchemaVersionsResponse returns schema versions for a bridge */
export type Instacart_Catalog_Data_Bridge_V1_ListSchemaVersionsResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_ListSchemaVersionsResponse';
  /** Schema versions, newest first */
  schema_versions?: Maybe<Array<Maybe<Instacart_Catalog_Data_Bridge_V1_SchemaVersion>>>;
  /** Total number of schema versions for the bridge */
  total_count?: Maybe<Scalars['Int']>;
};

/** SchemaVersion represents one (input, output) schema pair at a version */
export type Instacart_Catalog_Data_Bridge_V1_SchemaVersion = {
  __typename?: 'instacart_catalog_data_bridge_v1_SchemaVersion';
  /** When this version was created */
  created_at?: Maybe<Scalars['DateTime']>;
  /** Input schema */
  input_schema?: Maybe<Scalars['JSON']>;
  /** Output schema */
  output_schema?: Maybe<Scalars['JSON']>;
  /** Version integer, unique per bridge */
  version?: Maybe<Scalars['Int']>;
};

/** UpdateBridgeRequest contains parameters for updating a bridge */
export type Instacart_Catalog_Data_Bridge_V1_UpdateBridgeRequest_Input = {
  /** Required: bridge name to update */
  bridge_name?: InputMaybe<Scalars['String']>;
  /** Optional: updated bridge configuration */
  config?: InputMaybe<Instacart_Catalog_Data_Bridge_V1_BridgeConfig_Input>;
  /** Optional: updated description */
  description?: InputMaybe<Scalars['String']>;
  /** Required: human-readable name of the updater (user or system) */
  updated_by?: InputMaybe<Scalars['String']>;
  /** Required: reason for the update */
  updated_why?: InputMaybe<Scalars['String']>;
};

/** UpdateBridgeResponse returns the updated bridge */
export type Instacart_Catalog_Data_Bridge_V1_UpdateBridgeResponse = {
  __typename?: 'instacart_catalog_data_bridge_v1_UpdateBridgeResponse';
  /** The updated bridge */
  bridge?: Maybe<Instacart_Catalog_Data_Bridge_V1_Bridge>;
};

/** GetProductCountsRequest is the request message for GetProductCounts. */
export type Instacart_Catalog_Health_V1_GetProductCountsRequest_Input = {
  /** The partner ID to filter queries that use partner_id (e.g. rejected_promotions). */
  partnerId?: InputMaybe<Scalars['String']>;
  /** The name of the query to run. Valid values: available_parity, file_ingestion_failures, items_on_sale_promo_loyalty, product_size_dimensions, unmatched_lead_codes, rejected_promotions, health_score */
  queryName?: InputMaybe<Scalars['String']>;
  /** Optional. If set, polls for result of a previous async request. */
  requestId?: InputMaybe<Scalars['String']>;
  /** The retailer ID to filter queries by. */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** GetProductCountsResponse is the response message for GetProductCounts. */
export type Instacart_Catalog_Health_V1_GetProductCountsResponse = {
  __typename?: 'instacart_catalog_health_v1_GetProductCountsResponse';
  /** Populated when status = STATUS_ERROR. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The list of product count metrics as key-value pairs. */
  productCounts?: Maybe<Array<Maybe<Instacart_Catalog_Health_V1_ProductCount>>>;
  /** The request ID for polling. */
  requestId?: Maybe<Scalars['String']>;
  /** The status of the async query. */
  status?: Maybe<Instacart_Catalog_Health_V1_Status>;
};

/** ProductCount represents a single key-value metric from the product counts query. */
export type Instacart_Catalog_Health_V1_ProductCount = {
  __typename?: 'instacart_catalog_health_v1_ProductCount';
  /** The name of the column or metric. */
  columnName?: Maybe<Scalars['String']>;
  /**
   * The value of the column or metric, represented as a string.
   * Values may be numeric, date, or text depending on the Snowflake query.
   */
  columnValue?: Maybe<Scalars['String']>;
};

/** Status of an async query. */
export enum Instacart_Catalog_Health_V1_Status {
  StatusComplete = 'STATUS_COMPLETE',
  StatusError = 'STATUS_ERROR',
  StatusPending = 'STATUS_PENDING',
  StatusUnknown = 'STATUS_UNKNOWN'
}

export enum Instacart_Communications_V2_DeliveryStatus {
  DeliveryStatusDelivered = 'DELIVERY_STATUS_DELIVERED',
  DeliveryStatusFailed = 'DELIVERY_STATUS_FAILED',
  DeliveryStatusPending = 'DELIVERY_STATUS_PENDING',
  DeliveryStatusUnspecified = 'DELIVERY_STATUS_UNSPECIFIED'
}

export type Instacart_Communications_V2_GetEmailBodyDownloadUrlRequest_Input = {
  /** Notification record whose stored email body should be fetched */
  notificationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Store configuration the caller is scoped to. Must match the notification's store_configuration_id;
   * otherwise the notification is treated as not found.
   */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Communications_V2_GetEmailBodyDownloadUrlResponse = {
  __typename?: 'instacart_communications_v2_GetEmailBodyDownloadUrlResponse';
  /** Short-lived URL to fetch the stored email body HTML. */
  downloadUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Communications_V2_GetNotificationsRequest_Input = {
  /** pagination info: items per page */
  currentPage?: InputMaybe<Scalars['Int']>;
  /** pagination info: items per page */
  limitValue?: InputMaybe<Scalars['Int']>;
  /** Parameters to filter by */
  parameters?: InputMaybe<Instacart_Communications_V2_NotificationParameters_Input>;
  /** After date */
  since?: InputMaybe<Scalars['DateTime']>;
  /** Sort by descending date (default is ascending) */
  sortDesc?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Communications_V2_GetNotificationsResponse = {
  __typename?: 'instacart_communications_v2_GetNotificationsResponse';
  /** pagination info: current page number */
  currentPage?: Maybe<Scalars['Int']>;
  /** pagination info: items per page */
  limitValue?: Maybe<Scalars['Int']>;
  notifications?: Maybe<Array<Maybe<Instacart_Communications_V2_Notification>>>;
  /** pagination info: total number of pages */
  totalPages?: Maybe<Scalars['Int']>;
};

export type Instacart_Communications_V2_Notification = {
  __typename?: 'instacart_communications_v2_Notification';
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Additional opaque key that refines the notification deduplication scope.
   * When unset, deduplication behavior is unchanged.
   */
  dedupKey?: Maybe<Scalars['String']>;
  deliveredAt?: Maybe<Scalars['DateTime']>;
  failedAt?: Maybe<Scalars['DateTime']>;
  /** id of DB record */
  id?: Maybe<Scalars['BigInt']>;
  /** Identifies the type of notification */
  key?: Maybe<Scalars['String']>;
  /** (Email only) The class name of the mailer */
  mailer?: Maybe<Scalars['String']>;
  /** (SMS only) The url of an image to be sent */
  mediaUrl?: Maybe<Scalars['String']>;
  /** Notification channel (email, sms, push, in_app_message) */
  medium?: Maybe<Scalars['String']>;
  /** (SMS and Push) The body of the message */
  message?: Maybe<Scalars['String']>;
  messageType?: Maybe<Scalars['String']>;
  /** An object the notification is associated with (i.e. topic) */
  notifier?: Maybe<Scalars['String']>;
  properties?: Maybe<Scalars['String']>;
  /** Links the notification to the corresponding push */
  pushUuid?: Maybe<Scalars['String']>;
  /** The person to whom the notification is sent */
  recipient?: Maybe<Scalars['String']>;
  /** S3 object key referencing the stored email body HTML */
  s3ObjectKey?: Maybe<Scalars['String']>;
  /**
   * (SMS only) The phone number to send from.
   * In E.164 format (e.g., +14155551234 for US).
   */
  sendFrom?: Maybe<Scalars['String']>;
  /**
   * The phone number, email, or device list (user_devices: 1, 2, 3, ....) of the recipient.
   * For SMS: Must be in E.164 format (e.g., +14155551234 for US).
   */
  sendTo?: Maybe<Scalars['String']>;
  /** The person the notification is from (currently must be a User) */
  sender?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  /** Store configuration ID for tenant-scoped email log queries */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  title?: Maybe<Scalars['String']>;
  /** UUID for correlating SendGrid webhook events back to this notification */
  trackingUuid?: Maybe<Scalars['String']>;
};

export type Instacart_Communications_V2_NotificationParameters_Input = {
  /** Filter notifications by delivery status */
  deliveryStatus?: InputMaybe<Instacart_Communications_V2_DeliveryStatus>;
  /** id of DB record */
  id?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Identifies the type of notification */
  key?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** (Email only) The class name of the mailer */
  mailer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** (SMS only) The url of an image to be sent */
  mediaUrl?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Notification channel (email, sms, push, in_app_message) */
  medium?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** (SMS and Push) The body of the message */
  message?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notifierIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An object the notification is associated with */
  notifierType?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['String']>;
  /** Links the notification to the corresponding push */
  pushUuid?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  recipientIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The person to whom the notification is sent */
  recipientType?: InputMaybe<Scalars['String']>;
  /**
   * (SMS only) The phone number to send from.
   * In E.164 format (e.g., +14155551234 for US).
   */
  sendFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The phone number, email, or device list (user_devices: 1, 2, 3, ....) of the recipient.
   * For SMS: Should be in E.164 format (e.g., +14155551234 for US).
   */
  sendTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  senderIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The person the notification is from (currently must be a User) */
  senderType?: InputMaybe<Scalars['String']>;
  /** Filter notifications to a single store configuration. */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** UUID for correlating SendGrid webhook events back to a notification */
  trackingUuid?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsReponse = {
  __typename?: 'instacart_customers_basket_products_orchestrators_v1_GetBasketProductsReponse';
  /** a list of BasketProduct */
  basketProducts?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct>>>;
};

export type Instacart_Customers_Basket_Products_Orchestrators_V1_GetBasketProductsRequest_Input = {
  includeComboPromotions?: InputMaybe<Scalars['Boolean']>;
  loadUnattachedCoupons?: InputMaybe<Scalars['Boolean']>;
  noUser?: InputMaybe<Scalars['instacart_customers_basket_products_orchestrators_v1_GetBasketProductsRequest_NoUser_Input']>;
  references?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  restrictUnpurchasable?: InputMaybe<Scalars['Boolean']>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  snapshottable?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentRequest_Input = {
  programContent?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent_Input>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_admin_v1_CreateBusinessProgramContentResponse';
  programContent?: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
  programOffer?: InputMaybe<Instacart_Customers_Business_Types_V1_ProgramOffer_Input>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramOfferResponse = {
  __typename?: 'instacart_customers_business_admin_v1_CreateBusinessProgramOfferResponse';
  programOffer?: Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>;
};

/** Requests & Responses */
export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramRequest_Input = {
  businessProgramWithoutOffers?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgram_Input>;
};

export type Instacart_Customers_Business_Admin_V1_CreateBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_CreateBusinessProgramResponse';
  businessProgramWithoutOffers?: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>;
};

export type Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramContentRequest_Input = {
  businessProgramContentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramOfferRequest_Input = {
  businessProgramOfferId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_DeleteBusinessProgramRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentByProgramIdResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramContentByProgramIdResponse';
  programContent?: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>>>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentRequest_Input = {
  programContentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramContentResponse';
  programContent?: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferRequest_Input = {
  businessProgramOfferId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOfferResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramOfferResponse';
  programOffer?: Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramOffersByProgramIdResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramOffersByProgramIdResponse';
  programOffers?: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>>>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramRequest_Input = {
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Business_Admin_V1_GetBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_GetBusinessProgramResponse';
  businessProgram?: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>;
};

export type Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_Input = {
  orderBy?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_ListBusinessProgramRequestOrderBy>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export enum Instacart_Customers_Business_Admin_V1_ListBusinessProgramRequest_ListBusinessProgramRequestOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  OrderByUnspecified = 'ORDER_BY_UNSPECIFIED'
}

export type Instacart_Customers_Business_Admin_V1_ListBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_ListBusinessProgramResponse';
  businessPrograms?: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessFilterSet_Input = {
  businessMemberEmail?: InputMaybe<Scalars['String']>;
  businessMemberId?: InputMaybe<Scalars['BigInt']>;
  businessMemberUserId?: InputMaybe<Scalars['BigInt']>;
  businessType?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessType>;
};

export enum Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  OrderByUnspecified = 'ORDER_BY_UNSPECIFIED'
}

export type Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_Input = {
  filters?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessFilterSet_Input>;
  orderBy?: InputMaybe<Instacart_Customers_Business_Admin_V1_ListBusinessesRequest_BusinessOrderBy>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Business_Admin_V1_ListBusinessesResponse = {
  __typename?: 'instacart_customers_business_admin_v1_ListBusinessesResponse';
  businesses?: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_Business>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentRequest_Input = {
  programContent?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent_Input>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_admin_v1_UpdateBusinessProgramContentResponse';
  programContent?: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferRequest_Input = {
  programOffer?: InputMaybe<Instacart_Customers_Business_Types_V1_ProgramOffer_Input>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramOfferResponse = {
  __typename?: 'instacart_customers_business_admin_v1_UpdateBusinessProgramOfferResponse';
  programOffer?: Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramRequest_Input = {
  businessProgramWithoutOffers?: InputMaybe<Instacart_Customers_Business_Types_V1_BusinessProgram_Input>;
};

export type Instacart_Customers_Business_Admin_V1_UpdateBusinessProgramResponse = {
  __typename?: 'instacart_customers_business_admin_v1_UpdateBusinessProgramResponse';
  businessProgramWithoutOffers?: Maybe<Instacart_Customers_Business_Types_V1_BusinessProgram>;
};

export type Instacart_Customers_Business_Types_V1_Business = {
  __typename?: 'instacart_customers_business_types_v1_Business';
  businessCategory?: Maybe<Scalars['String']>;
  businessType?: Maybe<Instacart_Customers_Business_Types_V1_BusinessType>;
  countryId?: Maybe<Scalars['BigInt']>;
  createdAtUtc?: Maybe<Scalars['DateTime']>;
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  updatedAtUtc?: Maybe<Scalars['DateTime']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgram = {
  __typename?: 'instacart_customers_business_types_v1_BusinessProgram';
  active?: Maybe<Scalars['Boolean']>;
  businessId?: Maybe<Scalars['BigInt']>;
  createdAtUtc?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  offers?: Maybe<Array<Maybe<Instacart_Customers_Business_Types_V1_ProgramOffer>>>;
  programCode?: Maybe<Scalars['String']>;
  programType?: Maybe<Instacart_Customers_Business_Types_V1_ProgramType>;
  updatedAtUtc?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgramContent = {
  __typename?: 'instacart_customers_business_types_v1_BusinessProgramContent';
  availabilityCondition?: Maybe<Scalars['String']>;
  businessProgramId?: Maybe<Scalars['BigInt']>;
  cobrandedLogoAlt?: Maybe<Scalars['String']>;
  cobrandedLogoUrl?: Maybe<Scalars['String']>;
  createdAtUtc?: Maybe<Scalars['DateTime']>;
  /** Optional formatted subtitle copy associated with the call to action. */
  ctaSubtitle?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<Instacart_Customers_Shared_V1_Locale>;
  offerImageUrl?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  updatedAtUtc?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgramContent_Input = {
  availabilityCondition?: InputMaybe<Scalars['String']>;
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
  cobrandedLogoAlt?: InputMaybe<Scalars['String']>;
  cobrandedLogoUrl?: InputMaybe<Scalars['String']>;
  createdAtUtc?: InputMaybe<Scalars['DateTime']>;
  /** Optional formatted subtitle copy associated with the call to action. */
  ctaSubtitle?: InputMaybe<Scalars['String']>;
  ctaText?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  heading?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locale?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  offerImageUrl?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['String']>;
  updatedAtUtc?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_BusinessProgram_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  businessId?: InputMaybe<Scalars['BigInt']>;
  createdAtUtc?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  offers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Business_Types_V1_ProgramOffer_Input>>>;
  programCode?: InputMaybe<Scalars['String']>;
  programType?: InputMaybe<Instacart_Customers_Business_Types_V1_ProgramType>;
  updatedAtUtc?: InputMaybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Business_Types_V1_BusinessType {
  /** Unspecified business type; accounts for protobuf enum defaults on the wire. */
  BusinessTypeUnspecified = 'BUSINESS_TYPE_UNSPECIFIED',
  /** Legacy business type; do not use. This stores old businesses we launched via a form. */
  Legacy = 'LEGACY',
  /** Employees of the same business organization */
  OrganizationBasic = 'ORGANIZATION_BASIC',
  /** Business Program that groups a set of Business users together, but not yet tied to the same business organization */
  Program = 'PROGRAM'
}

export type Instacart_Customers_Business_Types_V1_ProgramOffer = {
  __typename?: 'instacart_customers_business_types_v1_ProgramOffer';
  active?: Maybe<Scalars['Boolean']>;
  countryId?: Maybe<Scalars['BigInt']>;
  couponCode?: Maybe<Scalars['String']>;
  createdAtUtc?: Maybe<Scalars['DateTime']>;
  existingUsersEnabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  updatedAtUtc?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_Types_V1_ProgramOffer_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  couponCode?: InputMaybe<Scalars['String']>;
  createdAtUtc?: InputMaybe<Scalars['DateTime']>;
  existingUsersEnabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  updatedAtUtc?: InputMaybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Business_Types_V1_ProgramType {
  /** Business Program that is applicable to a business organization */
  Business = 'BUSINESS',
  /** BUsiness program that is applicable to a group of business users */
  Partnership = 'PARTNERSHIP',
  /** Unspecified program type; accounts for protobuf enum defaults on the wire. */
  ProgramTypeUnspecified = 'PROGRAM_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Business_V1_BusinessProgramContent = {
  __typename?: 'instacart_customers_business_v1_BusinessProgramContent';
  availabilityCondition?: Maybe<Scalars['String']>;
  businessProgramId?: Maybe<Scalars['BigInt']>;
  cobrandedLogoAlt?: Maybe<Scalars['String']>;
  cobrandedLogoUrl?: Maybe<Scalars['String']>;
  createdAtUtc?: Maybe<Scalars['DateTime']>;
  /** Optional formatted subtitle copy associated with the call to action. */
  ctaSubtitle?: Maybe<Scalars['String']>;
  ctaText?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  heading?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locale?: Maybe<Instacart_Customers_Shared_V1_Locale>;
  offerImageUrl?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  updatedAtUtc?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Business_V1_GetBusinessProgramContentRequest_Input = {
  /** Identifier of the business program whose content is being requested. */
  businessProgramId?: InputMaybe<Scalars['BigInt']>;
  /** Content for locale */
  locale?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  /** Request Context */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export type Instacart_Customers_Business_V1_GetBusinessProgramContentResponse = {
  __typename?: 'instacart_customers_business_v1_GetBusinessProgramContentResponse';
  /** The business program content */
  businessProgramContent?: Maybe<Instacart_Customers_Business_V1_BusinessProgramContent>;
};

export type Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingRequest_Input = {
  list?: InputMaybe<Array<InputMaybe<Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_BulkUpdateCampaignSlotRankingResponse = {
  __typename?: 'instacart_customers_campaigns_v1_BulkUpdateCampaignSlotRankingResponse';
  failedSlots?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters>>>;
  updatedSlots?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_Slot>>>;
};

export enum Instacart_Customers_Campaigns_V1_CsvKind {
  CsvKindEmail = 'CSV_KIND_EMAIL',
  CsvKindMember = 'CSV_KIND_MEMBER',
  CsvKindUnspecified = 'CSV_KIND_UNSPECIFIED'
}

export type Instacart_Customers_Campaigns_V1_CsvProcessingCount = {
  __typename?: 'instacart_customers_campaigns_v1_CsvProcessingCount';
  errorCount?: Maybe<Scalars['BigInt']>;
  fileName?: Maybe<Scalars['String']>;
  isProcessed?: Maybe<Scalars['Boolean']>;
  /** Processing status for this file. */
  status?: Maybe<Instacart_Customers_Campaigns_V1_CsvProcessingStatus>;
  successCount?: Maybe<Scalars['BigInt']>;
};

/** Processing status for an uploaded CSV file. */
export enum Instacart_Customers_Campaigns_V1_CsvProcessingStatus {
  /** File processing terminally failed; no rows were successfully processed. */
  CsvProcessingStatusFailed = 'CSV_PROCESSING_STATUS_FAILED',
  /** File processed with some rows succeeding and others failing. */
  CsvProcessingStatusPartialSuccess = 'CSV_PROCESSING_STATUS_PARTIAL_SUCCESS',
  /** File is queued or in progress; no terminal outcome yet. */
  CsvProcessingStatusProcessing = 'CSV_PROCESSING_STATUS_PROCESSING',
  /** File processed successfully with no row-level errors. */
  CsvProcessingStatusReady = 'CSV_PROCESSING_STATUS_READY',
  /** Status not set. */
  CsvProcessingStatusUnspecified = 'CSV_PROCESSING_STATUS_UNSPECIFIED'
}

export enum Instacart_Customers_Campaigns_V1_CsvReportType {
  Errors = 'ERRORS',
  Processed = 'PROCESSED',
  Results = 'RESULTS',
  Unknown = 'UNKNOWN'
}

export type Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlRequest_Input = {
  fileName?: InputMaybe<Scalars['String']>;
  reportType?: InputMaybe<Instacart_Customers_Campaigns_V1_CsvReportType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetBucketDownloadUrlResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetBucketDownloadUrlResponse';
  downloadUrl?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_GetBucketUploadUrlRequest_Input = {
  /** csv kind: controls filename prefix in S3 key (member_ vs no prefix). */
  csvKind?: InputMaybe<Instacart_Customers_Campaigns_V1_CsvKind>;
  fileName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** if dynamic csv feature is being used */
  useDynamicCsvUploadBucket?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Campaigns_V1_GetBucketUploadUrlResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetBucketUploadUrlResponse';
  expiresAt?: Maybe<Scalars['DateTime']>;
  key?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountRequest_Input = {
  fileNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvFoundEntriesCountResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetCsvFoundEntriesCountResponse';
  fileCounts?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_CsvProcessingCount>>>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryRequest_Input = {
  fileName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetCsvProcessingSummaryResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetCsvProcessingSummaryResponse';
  duplicateCount?: Maybe<Scalars['BigInt']>;
  incorrectFormatCount?: Maybe<Scalars['BigInt']>;
  isProcessed?: Maybe<Scalars['Boolean']>;
  matchedCount?: Maybe<Scalars['BigInt']>;
  unmatchedCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Filter_Input = {
  campaignActiveDate?: InputMaybe<Scalars['DateTime']>;
  campaignName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Input = {
  filter?: InputMaybe<Instacart_Customers_Campaigns_V1_GetGroupedSlotsRequest_Filter_Input>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetGroupedSlotsResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetGroupedSlotsResponse';
  groupedSlots?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_GroupedSlot>>>;
};

export type Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignRequest_Input = {
  marketingAgentCampaignId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_GetMarketingAgentCampaignResponse = {
  __typename?: 'instacart_customers_campaigns_v1_GetMarketingAgentCampaignResponse';
  marketingAgentCampaign?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>;
};

export type Instacart_Customers_Campaigns_V1_GroupedSlot = {
  __typename?: 'instacart_customers_campaigns_v1_GroupedSlot';
  slotId?: Maybe<Scalars['String']>;
  slots?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_Slot>>>;
};

export type Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsRequest_Input = {
  overwriteLocalChanges?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  sync?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Campaigns_V1_ListMarketingAgentCampaignsResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ListMarketingAgentCampaignsResponse';
  campaigns?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

/** BEGIN Marketing AI Agent */
export type Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsRequest_Input = {
  marketingAgentCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCalculatePerformanceMetricsResponse = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCalculatePerformanceMetricsResponse';
  performanceMetrics?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaignPerformanceMetrics>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign';
  brazeSegmentIds?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds>;
  campaignBucket?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  desiredAudienceSize?: Maybe<Scalars['Int']>;
  desiredBudget?: Maybe<GoogleTypeMoney>;
  desiredBudgetDollars?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['BigInt']>;
  locallyUpdatedAt?: Maybe<Scalars['DateTime']>;
  maxConversionPercentile?: Maybe<Instacart_Types_V1_BigDecimal>;
  maxRelevanceScore?: Maybe<Instacart_Types_V1_BigDecimal>;
  maxSpendPercentile?: Maybe<Instacart_Types_V1_BigDecimal>;
  maxUnsubscribePercentile?: Maybe<Instacart_Types_V1_BigDecimal>;
  minConversionPercentile?: Maybe<Instacart_Types_V1_BigDecimal>;
  minRelevanceScore?: Maybe<Instacart_Types_V1_BigDecimal>;
  minSpendPercentile?: Maybe<Instacart_Types_V1_BigDecimal>;
  minUnsubscribePercentile?: Maybe<Instacart_Types_V1_BigDecimal>;
  offerValue?: Maybe<GoogleTypeMoney>;
  performanceMetrics?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics>;
  sendDates?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates>;
  taasSegmentIds?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaignPerformanceMetrics = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaignPerformanceMetrics';
  errorMessage?: Maybe<Scalars['String']>;
  marketingAgentCampaignId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaignValidationResult';
  marketingAgentCampaign?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>;
  validationErrors?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult_ValidationError>>>;
};

export enum Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult_ValidationError {
  ValidationErrorAudienceMismatch = 'VALIDATION_ERROR_AUDIENCE_MISMATCH',
  ValidationErrorBrazeDataIsStale = 'VALIDATION_ERROR_BRAZE_DATA_IS_STALE',
  ValidationErrorBudgetMismatch = 'VALIDATION_ERROR_BUDGET_MISMATCH',
  ValidationErrorTooManyDailySends = 'VALIDATION_ERROR_TOO_MANY_DAILY_SENDS',
  ValidationErrorUnspecified = 'VALIDATION_ERROR_UNSPECIFIED'
}

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_BrazeSegmentIds';
  brazeSegmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds_Input = {
  brazeSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_Input = {
  brazeSegmentIds?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_BrazeSegmentIds_Input>;
  campaignBucket?: InputMaybe<Scalars['String']>;
  campaignName?: InputMaybe<Scalars['String']>;
  desiredAudienceSize?: InputMaybe<Scalars['Int']>;
  desiredBudget?: InputMaybe<GoogleTypeMoneyInput>;
  desiredBudgetDollars?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['BigInt']>;
  locallyUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  maxConversionPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  maxRelevanceScore?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  maxSpendPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  maxUnsubscribePercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minConversionPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minRelevanceScore?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minSpendPercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  minUnsubscribePercentile?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  offerValue?: InputMaybe<GoogleTypeMoneyInput>;
  performanceMetrics?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics_Input>;
  sendDates?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates_Input>;
  taasSegmentIds?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds_Input>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_PerformanceMetrics';
  avgConversionRate?: Maybe<Instacart_Types_V1_BigDecimal>;
  avgUnsubscribeRate?: Maybe<Instacart_Types_V1_BigDecimal>;
  estimatedAudienceSize?: Maybe<Scalars['Int']>;
  estimatedSpend?: Maybe<GoogleTypeMoney>;
  estimatedUnsubscribers?: Maybe<Scalars['Int']>;
  numSendDates?: Maybe<Scalars['Int']>;
  selectedSendDates?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_PerformanceMetrics_Input = {
  avgConversionRate?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  avgUnsubscribeRate?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  estimatedAudienceSize?: InputMaybe<Scalars['Int']>;
  estimatedSpend?: InputMaybe<GoogleTypeMoneyInput>;
  estimatedUnsubscribers?: InputMaybe<Scalars['Int']>;
  numSendDates?: InputMaybe<Scalars['Int']>;
  selectedSendDates?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates_Input>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_SendDates';
  sendDates?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_SendDates_Input = {
  sendDates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds = {
  __typename?: 'instacart_customers_campaigns_v1_MarketingAgentCampaign_TaasSegmentIds';
  taasSegmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_TaasSegmentIds_Input = {
  taasSegmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Campaigns_V1_ProcessEmailCsvRequest_Input = {
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** full path for the CSV file stored in S3 */
  csvPathKey?: InputMaybe<Scalars['String']>;
  /** email of the IPP user that uploaded the file, used to send an email once the processing is complete. */
  notifyUserEmail?: InputMaybe<Scalars['String']>;
  /** id of the IPP user that uploaded the file, used to send an email once the processing is complete. */
  notifyUserId?: InputMaybe<Scalars['BigInt']>;
  /** identifies the retailer that uploaded the file */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** description of the taas segment being created. */
  segmentDescription?: InputMaybe<Scalars['String']>;
  /** name of the taas segment being created. */
  segmentName?: InputMaybe<Scalars['String']>;
  /** if dynamic csv feature is being used */
  useDynamicCsvUploadBucket?: InputMaybe<Scalars['Boolean']>;
  /** whitelabel_id, use 1 for marketplace */
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_ProcessEmailCsvResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ProcessEmailCsvResponse';
  jobId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_ProcessMemberCsvRequest_Input = {
  context?: InputMaybe<Instacart_Ads_Platform_Taas_V1_ContextRestriction_Input>;
  /** full path for the member CSV file stored in S3 */
  csvPathKey?: InputMaybe<Scalars['String']>;
  /** email of the IPP user that uploaded the file */
  notifyUserEmail?: InputMaybe<Scalars['String']>;
  /** id of the IPP user that uploaded the file */
  notifyUserId?: InputMaybe<Scalars['BigInt']>;
  /** identifies the retailer that uploaded the file */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** description of the taas segment being created */
  segmentDescription?: InputMaybe<Scalars['String']>;
  /** name of the taas segment being created */
  segmentName?: InputMaybe<Scalars['String']>;
  /** whitelabel_id, use 1 for marketplace */
  whitelabelId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_ProcessMemberCsvResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ProcessMemberCsvResponse';
  jobId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignRequest_Input = {
  campaign?: InputMaybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign_Input>;
};

export type Instacart_Customers_Campaigns_V1_SaveMarketingAgentCampaignResponse = {
  __typename?: 'instacart_customers_campaigns_v1_SaveMarketingAgentCampaignResponse';
  campaign?: Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaign>;
};

export type Instacart_Customers_Campaigns_V1_Slot = {
  __typename?: 'instacart_customers_campaigns_v1_Slot';
  campaignId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  rank?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_TestOfflineCampaignRequest_Input = {
  campaignId?: InputMaybe<Scalars['BigInt']>;
  dryRun?: InputMaybe<Scalars['Boolean']>;
  generateHubEvent?: InputMaybe<Scalars['Boolean']>;
  offersExpireAt?: InputMaybe<Scalars['DateTime']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters = {
  __typename?: 'instacart_customers_campaigns_v1_UpdateCampaignSlotRankingParameters';
  rank?: Maybe<Scalars['BigInt']>;
  retailerCampaignId?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_UpdateCampaignSlotRankingParameters_Input = {
  rank?: InputMaybe<Scalars['BigInt']>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleRequest_Input = {
  marketingAgentCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Campaigns_V1_ValidateMarketingAgentScheduleResponse = {
  __typename?: 'instacart_customers_campaigns_v1_ValidateMarketingAgentScheduleResponse';
  marketingAgentCampaignValidationResults?: Maybe<Array<Maybe<Instacart_Customers_Campaigns_V1_MarketingAgentCampaignValidationResult>>>;
};

/**
 * AllocateDelegatedCheckoutCartRequest allocates a delegated checkout cart
 * for the given user and retailer.
 */
export type Instacart_Customers_Carts_V1_AllocateDelegatedCheckoutCartRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** AllocateDelegatedCheckoutCartResponse returns the allocated cart's id. */
export type Instacart_Customers_Carts_V1_AllocateDelegatedCheckoutCartResponse = {
  __typename?: 'instacart_customers_carts_v1_AllocateDelegatedCheckoutCartResponse';
  cartId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Carts_V1_AttributionMetadata_Input = {
  /** nested shop ID corresponding to a retailer whose cart is added to on another retailer's storefront. */
  nestedShopId?: InputMaybe<Scalars['String']>;
  /** overall shop ID on client surface that maps to multiple retailer context (i.e. parent shop id) or single retailer context */
  shopId?: InputMaybe<Scalars['String']>;
  /** specific surface that cart item was added from */
  surfaceType?: InputMaybe<Instacart_Customers_Shared_V1_SurfaceType>;
};

/** CancelDelegatedCheckoutLinkRequest cancels an existing delegated checkout link. */
export type Instacart_Customers_Carts_V1_CancelDelegatedCheckoutLinkRequest_Input = {
  /** Cart ID of the delegated checkout link to cancel */
  cartId?: InputMaybe<Scalars['BigInt']>;
  /** Request context */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** CancelDelegatedCheckoutLinkResponse confirms the cancellation. */
export type Instacart_Customers_Carts_V1_CancelDelegatedCheckoutLinkResponse = {
  __typename?: 'instacart_customers_carts_v1_CancelDelegatedCheckoutLinkResponse';
  /** The cancelled delegated checkout link */
  delegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLink>;
};

export type Instacart_Customers_Carts_V1_Cart = {
  __typename?: 'instacart_customers_carts_v1_Cart';
  cartEnum?: Maybe<Instacart_Customers_Carts_V1_CartEnum>;
  cartType?: Maybe<Instacart_Customers_Carts_V1_CartType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  householdId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  itemCount?: Maybe<Scalars['BigInt']>;
  partyId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userDescription?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Carts_V1_CartEnum {
  CartsEnumUnspecified = 'CARTS_ENUM_UNSPECIFIED',
  LegacyCart = 'LEGACY_CART',
  SharedLegacyCart = 'SHARED_LEGACY_CART',
  SingleRetailerCart = 'SINGLE_RETAILER_CART'
}

export type Instacart_Customers_Carts_V1_CartItem = {
  __typename?: 'instacart_customers_carts_v1_CartItem';
  basketProductReference?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference>;
  cartId?: Maybe<Scalars['BigInt']>;
  configType?: Maybe<Instacart_Customers_Carts_V1_ConfigType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  itemId?: Maybe<Scalars['BigInt']>;
  productId?: Maybe<Scalars['BigInt']>;
  quantity?: Maybe<Instacart_Types_V1_BigDecimal>;
  quantityType?: Maybe<Instacart_Customers_Carts_V1_QuantityType>;
  replacementPolicy?: Maybe<Scalars['String']>;
  specialInstructions?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Carts_V1_CartItemCollection = {
  __typename?: 'instacart_customers_carts_v1_CartItemCollection';
  cartId?: Maybe<Scalars['BigInt']>;
  cartItems?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_CartItem>>>;
  householdId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Carts_V1_CartItemPricing = {
  __typename?: 'instacart_customers_carts_v1_CartItemPricing';
  fullItemsPrice?: Maybe<GoogleTypeMoney>;
  itemsPrice?: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Customers_Carts_V1_CartItemUpdateOperationEnum {
  CartItemUpdateOperationAdd = 'CART_ITEM_UPDATE_OPERATION_ADD',
  CartItemUpdateOperationDecrement = 'CART_ITEM_UPDATE_OPERATION_DECREMENT',
  CartItemUpdateOperationIncrement = 'CART_ITEM_UPDATE_OPERATION_INCREMENT',
  CartItemUpdateOperationRemove = 'CART_ITEM_UPDATE_OPERATION_REMOVE',
  CartItemUpdateOperationUpdate = 'CART_ITEM_UPDATE_OPERATION_UPDATE'
}

export type Instacart_Customers_Carts_V1_CartItemUpdateResult = {
  __typename?: 'instacart_customers_carts_v1_CartItemUpdateResult';
  cartItemUpdateOperation?: Maybe<Instacart_Customers_Carts_V1_CartItemUpdateOperationEnum>;
  itemId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Carts_V1_CartItemUpdate_Input = {
  itemId?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  quantityType?: InputMaybe<Instacart_Customers_Shared_V1_QuantityType>;
  /** optional argument for configurable items */
  selectedOptions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Carts_V1_SelectedOption_Input>>>;
  specialInstructions?: InputMaybe<Scalars['String']>;
  trackingParams?: InputMaybe<Instacart_Customers_Carts_V1_CartUpdateItemTrackingParams_Input>;
};

export type Instacart_Customers_Carts_V1_CartLineItem = {
  __typename?: 'instacart_customers_carts_v1_CartLineItem';
  cartItemId?: Maybe<Scalars['BigInt']>;
  cartItemPricing?: Maybe<Instacart_Customers_Carts_V1_CartItemPricing>;
};

export enum Instacart_Customers_Carts_V1_CartType {
  Catering = 'CATERING',
  Community = 'COMMUNITY',
  DelegatedCheckout = 'DELEGATED_CHECKOUT',
  /** Cart Type Defaults to GROCERY */
  Grocery = 'GROCERY',
  List = 'LIST'
}

export type Instacart_Customers_Carts_V1_CartUpdateItemTrackingParams_Input = {
  /** used specifically for attributing the cart update to some workstream/effort */
  attributionMetadata?: InputMaybe<Instacart_Customers_Carts_V1_AttributionMetadata_Input>;
  /** other tracking params */
  trackingProperties?: InputMaybe<Scalars['JSON']>;
};

export enum Instacart_Customers_Carts_V1_ClientDependentExperimentType {
  CartSwitcherServerOrdering = 'CART_SWITCHER_SERVER_ORDERING',
  CheckoutV3StandaloneHoldout = 'CHECKOUT_V3_STANDALONE_HOLDOUT',
  CheckoutV4AdminOnly = 'CHECKOUT_V4_ADMIN_ONLY',
  CheckoutV4Standalone = 'CHECKOUT_V4_STANDALONE',
  CheckoutV4StandaloneHoldout = 'CHECKOUT_V4_STANDALONE_HOLDOUT',
  CheckoutV4StandaloneNonExpress = 'CHECKOUT_V4_STANDALONE_NON_EXPRESS',
  CheckoutV4StandalonePbi = 'CHECKOUT_V4_STANDALONE_PBI',
  CheckoutV4WebFirstPbiLaunch = 'CHECKOUT_V4_WEB_FIRST_PBI_LAUNCH',
  CheckoutV4WebSfxPbiLaunch = 'CHECKOUT_V4_WEB_SFX_PBI_LAUNCH',
  CobrandCheckoutV4Android = 'COBRAND_CHECKOUT_V4_ANDROID',
  CobrandCheckoutV4Ios = 'COBRAND_CHECKOUT_V4_IOS',
  CobrandCheckoutV4Web = 'COBRAND_CHECKOUT_V4_WEB',
  HighlightSavingsInCart = 'HIGHLIGHT_SAVINGS_IN_CART'
}

export enum Instacart_Customers_Carts_V1_ConfigType {
  Builder = 'BUILDER',
  ConfigTypeUnspecified = 'CONFIG_TYPE_UNSPECIFIED',
  Custom = 'CUSTOM',
  PrepStyle = 'PREP_STYLE',
  UnknownType = 'UNKNOWN_TYPE'
}

/** CreateDelegatedCheckoutLinkRequest persists a new delegated checkout link record without sending notifications. */
export type Instacart_Customers_Carts_V1_CreateDelegatedCheckoutLinkRequest_Input = {
  /** Cart to create the delegated checkout link for */
  cartId?: InputMaybe<Scalars['BigInt']>;
  /** How long the checkout link should be valid */
  expiresIn?: InputMaybe<Scalars['String']>;
  /** Per-item production notes keyed by item identifier */
  itemProductionNotes?: InputMaybe<Scalars['JSON']>;
  /** Request context (carries store_configuration_id, client_configuration_id, country_id) */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** Deprecated: resolved server-side from shop_id; ignored by the handler. */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  /** Shop associated with this checkout */
  shopId?: InputMaybe<Scalars['BigInt']>;
  /** User who will receive the checkout link */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** CreateDelegatedCheckoutLinkResponse returns the created delegated checkout link. */
export type Instacart_Customers_Carts_V1_CreateDelegatedCheckoutLinkResponse = {
  __typename?: 'instacart_customers_carts_v1_CreateDelegatedCheckoutLinkResponse';
  /** The created delegated checkout link */
  delegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLink>;
};

/** DelegatedCheckoutLink represents a persisted delegated checkout link record. */
export type Instacart_Customers_Carts_V1_DelegatedCheckoutLink = {
  __typename?: 'instacart_customers_carts_v1_DelegatedCheckoutLink';
  /** Associated cart ID */
  cartId?: Maybe<Scalars['BigInt']>;
  /** When the customer completed checkout */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Record timestamps */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When this delegated checkout link expires and becomes invalid */
  expiresAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier (UUID) */
  id?: Maybe<Scalars['String']>;
  /** Per-item production notes keyed by item identifier */
  itemProductionNotes?: Maybe<Scalars['JSON']>;
  /** Order ID created upon successful checkout */
  orderId?: Maybe<Scalars['BigInt']>;
  /** Retailer location snapshot at link creation time. */
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  /** When the checkout link was sent to the customer (set on successful send) */
  sentAt?: Maybe<Scalars['DateTime']>;
  /** Service type snapshot at link creation time. */
  serviceType?: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** Shop associated with this delegated checkout link */
  shopId?: Maybe<Scalars['BigInt']>;
  /** Current lifecycle status */
  status?: Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLinkStatus>;
  /** Store configuration under which this link was created */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** User who receives the checkout link */
  userId?: Maybe<Scalars['BigInt']>;
  /** When the customer first viewed the checkout link */
  viewedAt?: Maybe<Scalars['DateTime']>;
};

/** DelegatedCheckoutLinkStatus represents the lifecycle state of a delegated checkout link. */
export enum Instacart_Customers_Carts_V1_DelegatedCheckoutLinkStatus {
  DelegatedCheckoutLinkStatusCancelled = 'DELEGATED_CHECKOUT_LINK_STATUS_CANCELLED',
  DelegatedCheckoutLinkStatusCompleted = 'DELEGATED_CHECKOUT_LINK_STATUS_COMPLETED',
  /** Link has been persisted but not yet sent to the customer. */
  DelegatedCheckoutLinkStatusCreated = 'DELEGATED_CHECKOUT_LINK_STATUS_CREATED',
  DelegatedCheckoutLinkStatusExpired = 'DELEGATED_CHECKOUT_LINK_STATUS_EXPIRED',
  DelegatedCheckoutLinkStatusSent = 'DELEGATED_CHECKOUT_LINK_STATUS_SENT',
  DelegatedCheckoutLinkStatusUnknown = 'DELEGATED_CHECKOUT_LINK_STATUS_UNKNOWN',
  DelegatedCheckoutLinkStatusViewed = 'DELEGATED_CHECKOUT_LINK_STATUS_VIEWED'
}

/**
 * DelegatedCheckoutListItem is a row in the list view: a link plus
 * display-only enrichment.
 */
export type Instacart_Customers_Carts_V1_DelegatedCheckoutListItem = {
  __typename?: 'instacart_customers_carts_v1_DelegatedCheckoutListItem';
  /** Display name shown for the link's recipient. */
  customerName?: Maybe<Scalars['String']>;
  link?: Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLink>;
  /** Empty when the customer has no loyalty account on this retailer. */
  loyaltyId?: Maybe<Scalars['String']>;
  /** Cart total. */
  totalCharge?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Carts_V1_GetActiveCartIdForUserRequest_Input = {
  /** context for this request */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** retailer id */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** ID of user making the request */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Carts_V1_GetActiveCartIdForUserResponse = {
  __typename?: 'instacart_customers_carts_v1_GetActiveCartIdForUserResponse';
  /** cart id */
  cartId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Carts_V1_GetCartBasketTotalsRequest_Input = {
  cartId?: InputMaybe<Scalars['BigInt']>;
  clientEnabledExperiments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Carts_V1_ClientDependentExperimentType>>>;
  postalCode?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  userId?: InputMaybe<Scalars['BigInt']>;
  /** optional view request client */
  viewClient?: InputMaybe<Instacart_Customers_Carts_V1_RequestClient_Input>;
};

export type Instacart_Customers_Carts_V1_GetCartBasketTotalsResponse = {
  __typename?: 'instacart_customers_carts_v1_GetCartBasketTotalsResponse';
  cartLineItems?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_CartLineItem>>>;
  potentialLoyaltySavings?: Maybe<GoogleTypeMoney>;
  retailerTotal?: Maybe<GoogleTypeMoney>;
  savingsTotal?: Maybe<GoogleTypeMoney>;
  showSavings?: Maybe<Scalars['Boolean']>;
  undiscountedTotal?: Maybe<GoogleTypeMoney>;
  unpricedCartLineItems?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_UnpricedCartLineItem>>>;
  valueMealsEnabled?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Carts_V1_GetCartItemCollectionsRequest_Input = {
  cartIdCartEnumMapping?: InputMaybe<Scalars['JSON']>;
  cartIdHouseholdIdMapping?: InputMaybe<Scalars['JSON']>;
  cartIdRetailerIdMapping?: InputMaybe<Scalars['JSON']>;
  cartIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Carts_V1_GetCartItemCollectionsResponse = {
  __typename?: 'instacart_customers_carts_v1_GetCartItemCollectionsResponse';
  cartItemCollections?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_CartItemCollection>>>;
};

/** GetDelegatedCheckoutLinkRequest retrieves a single delegated checkout link by ID. */
export type Instacart_Customers_Carts_V1_GetDelegatedCheckoutLinkRequest_Input = {
  /** Cart ID of the delegated checkout link to retrieve */
  cartId?: InputMaybe<Scalars['BigInt']>;
  /** Request context */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** GetDelegatedCheckoutLinkResponse returns the requested delegated checkout link. */
export type Instacart_Customers_Carts_V1_GetDelegatedCheckoutLinkResponse = {
  __typename?: 'instacart_customers_carts_v1_GetDelegatedCheckoutLinkResponse';
  /** The delegated checkout link */
  delegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLink>;
};

/** ListDelegatedCheckoutLinksRequest retrieves delegated checkout links matching the given criteria. */
export type Instacart_Customers_Carts_V1_ListDelegatedCheckoutLinksRequest_Input = {
  /** Maximum number of results to return */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Opaque token for fetching the next page */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Request context */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** Optional retailer-location filter (applied on top of store_configuration_id scoping). */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional service-type filter (applied on top of store_configuration_id scoping). */
  serviceTypes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_V1_ServiceType>>>;
  /**
   * Filter by shop (optional; when omitted, results are scoped by
   * request_context.store_configuration_id).
   */
  shopId?: InputMaybe<Scalars['BigInt']>;
  /** Filter by status (omit to return all statuses) */
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLinkStatus>>>;
};

/**
 * ListDelegatedCheckoutLinksResponse returns matching delegated checkout links
 * with display-only enrichment for the admin list view.
 */
export type Instacart_Customers_Carts_V1_ListDelegatedCheckoutLinksResponse = {
  __typename?: 'instacart_customers_carts_v1_ListDelegatedCheckoutLinksResponse';
  /** Deprecated: use items, which wraps each link with display-only enrichment. */
  delegatedCheckoutLinks?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLink>>>;
  /** Matching rows with display-only enrichment. */
  items?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutListItem>>>;
  /** Token for fetching the next page (empty if no more results) */
  nextPageToken?: Maybe<Scalars['String']>;
};

/** NotificationChannel describes a delivery channel for the checkout link. */
export enum Instacart_Customers_Carts_V1_NotificationChannel {
  NotificationChannelEmail = 'NOTIFICATION_CHANNEL_EMAIL',
  NotificationChannelSms = 'NOTIFICATION_CHANNEL_SMS',
  NotificationChannelUnknown = 'NOTIFICATION_CHANNEL_UNKNOWN'
}

export enum Instacart_Customers_Carts_V1_QuantityType {
  Each = 'EACH',
  Weight = 'WEIGHT'
}

export type Instacart_Customers_Carts_V1_RequestClient_Input = {
  /** The app identifier - from HTTP Header x-client-identifier */
  identifier?: InputMaybe<Scalars['String']>;
  /** The user application/OS/vendor identifier - from HTTP Header user-agent. */
  userAgent?: InputMaybe<Scalars['String']>;
  /** The app version - from HTTP Header x-client-version. Required for iOS/Android, not required for Web. */
  version?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Carts_V1_SelectedOption_Input = {
  configOptionId?: InputMaybe<Scalars['String']>;
  configOptionItemId?: InputMaybe<Scalars['String']>;
};

/** SendDelegatedCheckoutLinkRequest sends notifications for an existing delegated checkout link. */
export type Instacart_Customers_Carts_V1_SendDelegatedCheckoutLinkRequest_Input = {
  /** Cart ID of the existing delegated checkout link to send */
  cartId?: InputMaybe<Scalars['BigInt']>;
  /** Deprecated: moved to CreateDelegatedCheckoutLinkRequest. */
  expiresIn?: InputMaybe<Scalars['String']>;
  /** Deprecated: moved to CreateDelegatedCheckoutLinkRequest. */
  itemProductionNotes?: InputMaybe<Scalars['JSON']>;
  /** Channels to deliver the checkout link through (e.g., EMAIL + SMS) */
  notificationChannels?: InputMaybe<Array<InputMaybe<Instacart_Customers_Carts_V1_NotificationChannel>>>;
  /** Request context (carries store_configuration_id, client_configuration_id, country_id) */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** Deprecated: moved to CreateDelegatedCheckoutLinkRequest. */
  shopId?: InputMaybe<Scalars['BigInt']>;
  /** Deprecated: moved to CreateDelegatedCheckoutLinkRequest. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** SendDelegatedCheckoutLinkResponse returns the created delegated checkout link. */
export type Instacart_Customers_Carts_V1_SendDelegatedCheckoutLinkResponse = {
  __typename?: 'instacart_customers_carts_v1_SendDelegatedCheckoutLinkResponse';
  /** The created delegated checkout link */
  delegatedCheckoutLink?: Maybe<Instacart_Customers_Carts_V1_DelegatedCheckoutLink>;
};

export type Instacart_Customers_Carts_V1_SetCartItemsRequest_Input = {
  /** Session ID that we can use to track user actions for particular session */
  ahoyVisitToken?: InputMaybe<Scalars['String']>;
  /** visitor ID for the ahoy session ID */
  ahoyVisitorToken?: InputMaybe<Scalars['String']>;
  /** list of cart item updates */
  cartItemUpdates?: InputMaybe<Array<InputMaybe<Instacart_Customers_Carts_V1_CartItemUpdate_Input>>>;
  /** cart type default is grocery */
  cartType?: InputMaybe<Instacart_Customers_Carts_V1_CartType>;
  /** household ID if applicable */
  householdId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** optional requested at timestamp */
  requestTimestamp?: InputMaybe<Scalars['Float']>;
  /** optional service type. Used when cart type alone doesn't pin a surface (e.g. DelegatedCheckout supports delivery/pickup/in-store); otherwise derived from cart_type. */
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  /** ID of user making the request */
  userId?: InputMaybe<Scalars['BigInt']>;
  /** # optional view request client. Needed by invoicing domain to build certain client-specific discounts */
  viewClient?: InputMaybe<Instacart_Customers_Carts_V1_RequestClient_Input>;
};

export type Instacart_Customers_Carts_V1_SetCartItemsResponse = {
  __typename?: 'instacart_customers_carts_v1_SetCartItemsResponse';
  cart?: Maybe<Instacart_Customers_Carts_V1_Cart>;
  requestTimestamp?: Maybe<Scalars['Float']>;
  updatedItemIds?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_CartItemUpdateResult>>>;
};

export type Instacart_Customers_Carts_V1_UnpricedCartLineItem = {
  __typename?: 'instacart_customers_carts_v1_UnpricedCartLineItem';
  cartItemId?: Maybe<Scalars['BigInt']>;
  reason?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Carts_V1_UpdateDelegatedCheckoutCartItemsRequest_Input = {
  cartId?: InputMaybe<Scalars['BigInt']>;
  cartItemUpdates?: InputMaybe<Array<InputMaybe<Instacart_Customers_Carts_V1_CartItemUpdate_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Carts_V1_UpdateDelegatedCheckoutCartItemsResponse = {
  __typename?: 'instacart_customers_carts_v1_UpdateDelegatedCheckoutCartItemsResponse';
  cart?: Maybe<Instacart_Customers_Carts_V1_Cart>;
  updatedItemIds?: Maybe<Array<Maybe<Instacart_Customers_Carts_V1_CartItemUpdateResult>>>;
};

export type Instacart_Customers_Commerce_Coupons_V1_BulkCreateChildCouponCodesRequest_Input = {
  couponCodePrefix?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  generateCount?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsRequest_Input = {
  code?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Coupons_V1_GetRedemptionCodeExistsResponse = {
  __typename?: 'instacart_customers_commerce_coupons_v1_GetRedemptionCodeExistsResponse';
  couponCodeExists?: Maybe<Scalars['Boolean']>;
};

/**
 * Class of external party IC bills for a given fund. Used together with a billing
 * entity ID (resolved per-scenario) to identify the counterparty in financial
 * settlement.
 */
export enum Instacart_Customers_Commerce_Discount_Types_V1_BillingEntityType {
  BillingEntityTypeUnspecified = 'BILLING_ENTITY_TYPE_UNSPECIFIED',
  /** IC bills a CPG offer network (e.g., Ibotta) directly. */
  CpgNetwork = 'CPG_NETWORK',
  /** IC bills a directed-spend / Fresh Funds partner (e.g., Ascension). */
  DirectedSpendPartner = 'DIRECTED_SPEND_PARTNER',
  /** IC bills a CPG advertiser via IC's ads platform. */
  IcCpgPartner = 'IC_CPG_PARTNER',
  /**
   * IC funds the policy from its own P&L (no external counterparty); the fund
   * is self-billed rather than settled with an outside party.
   */
  IcSelfBilled = 'IC_SELF_BILLED',
  /** IC bills a co-brand or financial-institution partner (e.g., Chase, BMO). */
  Partner = 'PARTNER',
  /** IC bills the retailer; specific retailer derived from order context. */
  Retailer = 'RETAILER'
}

/** When IC recognizes billing for a fund. */
export enum Instacart_Customers_Commerce_Discount_Types_V1_BillingTrigger {
  BillingTriggerUnspecified = 'BILLING_TRIGGER_UNSPECIFIED',
  /** Partner billed at order completion when funds are applied; expired-unused = no billing. */
  Consumption = 'CONSUMPTION',
  /** Partner billed at the moment funds are issued/deposited, regardless of usage. */
  Deposit = 'DEPOSIT'
}

/**
 * API representation of a financial funder — a description of a distinct funding
 * source with its billing characteristics.
 */
export type Instacart_Customers_Commerce_Discount_Types_V1_FinancialFunder = {
  __typename?: 'instacart_customers_commerce_discount_types_v1_FinancialFunder';
  /**
   * Specific entity IC bills. Nullable: resolved from order context for RETAILER;
   * populated for EXPLICIT_SETTLEMENT counterparties. Absent for self-funded.
   */
  billingEntityId?: Maybe<Scalars['BigInt']>;
  /** Class of party IC bills. */
  billingEntityType?: Maybe<Instacart_Customers_Commerce_Discount_Types_V1_BillingEntityType>;
  /** When IC recognizes billing (deposit vs. consumption). */
  billingTrigger?: Maybe<Instacart_Customers_Commerce_Discount_Types_V1_BillingTrigger>;
};

/**
 * API representation of a financial funder — a description of a distinct funding
 * source with its billing characteristics.
 */
export type Instacart_Customers_Commerce_Discount_Types_V1_FinancialFunder_Input = {
  /**
   * Specific entity IC bills. Nullable: resolved from order context for RETAILER;
   * populated for EXPLICIT_SETTLEMENT counterparties. Absent for self-funded.
   */
  billingEntityId?: InputMaybe<Scalars['BigInt']>;
  /** Class of party IC bills. */
  billingEntityType?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_BillingEntityType>;
  /** When IC recognizes billing (deposit vs. consumption). */
  billingTrigger?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_BillingTrigger>;
};

export enum Instacart_Customers_Commerce_Discount_Types_V1_RecurringBenefitTimePeriod {
  CalendarMonth = 'CALENDAR_MONTH',
  NonRecurringBenefit = 'NON_RECURRING_BENEFIT',
  RecurringBenefitTimePeriodUnspecified = 'RECURRING_BENEFIT_TIME_PERIOD_UNSPECIFIED',
  RollingMonth = 'ROLLING_MONTH'
}

export enum Instacart_Customers_Commerce_Discount_Types_V1_RewardPercentBase {
  RewardPercentBaseItemsTotalPrice = 'REWARD_PERCENT_BASE_ITEMS_TOTAL_PRICE',
  RewardPercentBaseUnspecified = 'REWARD_PERCENT_BASE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata = {
  __typename?: 'instacart_customers_commerce_discount_v1_AdditionalMetadata';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_ApiCallerDetails';
  callerId?: Maybe<Scalars['BigInt']>;
  callerPermissions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerPermission>>>;
  callerType?: Maybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerType>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerPermission {
  CallerPermissionUnspecified = 'CALLER_PERMISSION_UNSPECIFIED',
  Default = 'DEFAULT',
  OverrideBusinessRuleValidation = 'OVERRIDE_BUSINESS_RULE_VALIDATION'
}

export enum Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerType {
  CallerTypeIc = 'CALLER_TYPE_IC',
  CallerTypeIpp = 'CALLER_TYPE_IPP',
  CallerTypeUnspecified = 'CALLER_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_Input = {
  callerId?: InputMaybe<Scalars['BigInt']>;
  callerPermissions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerPermission>>>;
  callerType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_CallerType>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedCreditBackInCoupon';
  autoAppliedCreditBackExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditCouponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails>;
  creditCouponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditCouponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input = {
  autoAppliedCreditBackExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input>;
  creditCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedCreditBackInDigitalWallet';
  autoAppliedCreditBackExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  digitalWalletDepositDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails>;
  digitalWalletDepositIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input = {
  autoAppliedCreditBackExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  digitalWalletDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input>;
  digitalWalletDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedDiscount';
  autoAppliedDiscountExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input = {
  autoAppliedDiscountExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack = {
  __typename?: 'instacart_customers_commerce_discount_v1_AutoAppliedInKindBack';
  autoAppliedInKindBackExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  inKindDepositDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails>;
  inKindDepositIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export type Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input = {
  autoAppliedInKindBackExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  inKindDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input>;
  inKindDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
};

export enum Instacart_Customers_Commerce_Discount_V1_BusinessLogicValidationRule {
  AutoRedeemTargetingSegmentValidation = 'AUTO_REDEEM_TARGETING_SEGMENT_VALIDATION',
  BasketRewardIncludeConditionGroupValidation = 'BASKET_REWARD_INCLUDE_CONDITION_GROUP_VALIDATION',
  BusinessLogicValidationRuleUnspecified = 'BUSINESS_LOGIC_VALIDATION_RULE_UNSPECIFIED',
  CouponInstanceCountValidation = 'COUPON_INSTANCE_COUNT_VALIDATION',
  LowRiskConditionCriteriaExistsValidation = 'LOW_RISK_CONDITION_CRITERIA_EXISTS_VALIDATION',
  MaximumBasketDiscountValidation = 'MAXIMUM_BASKET_DISCOUNT_VALIDATION',
  MaximumBudgetValidation = 'MAXIMUM_BUDGET_VALIDATION',
  MinimumSpendValidation = 'MINIMUM_SPEND_VALIDATION',
  RetailerAgnosticValidation = 'RETAILER_AGNOSTIC_VALIDATION',
  UnlimitedOfferRedemptionLimitValidation = 'UNLIMITED_OFFER_REDEMPTION_LIMIT_VALIDATION'
}

export type Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_CheckoutBenefitCodeDiscount';
  checkoutBenefitCodeDiscountExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input = {
  checkoutBenefitCodeDiscountExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
};

/** Discount using Clippable Coupon */
export type Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_ClippableCouponBasedDiscount';
  couponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  couponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

/** Discount using Clippable Coupon */
export type Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input = {
  couponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  couponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

/**
 * Indicates offers contain in a request requires compatibility mode for processing,
 * and carries required legacy attributes.
 *
 * Compatibility mode is enabled on case by case bases, supported use cases can be
 * found in CompatibilityModeUseCase enum.
 */
export type Instacart_Customers_Commerce_Discount_V1_CompatibilityMode = {
  __typename?: 'instacart_customers_commerce_discount_v1_CompatibilityMode';
  alcohol?: Maybe<Scalars['Boolean']>;
  alcoholStateWhitelist?: Maybe<Array<Maybe<Scalars['String']>>>;
  cpgCampaignId?: Maybe<Scalars['BigInt']>;
  /** Some legacy attributes of V3 delivery fee discount */
  createMultipleCoupons?: Maybe<Scalars['BigInt']>;
  deliveryMinimum?: Maybe<Scalars['BigInt']>;
  discountPolicyRules?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Instacart fee in cents. */
  instacartFee?: Maybe<Scalars['BigInt']>;
  itemMinimum?: Maybe<Scalars['BigInt']>;
  maximumDiscount?: Maybe<GoogleTypeMoney>;
  /**
   * indicates the use case of compatibility mode.
   * `discount_policies.type` is derived from this attribute.
   */
  useCase?: Maybe<Instacart_Customers_Commerce_Discount_V1_CompatibilityModeUseCase>;
};

/** Contains supported use cases for compatibility mode */
export enum Instacart_Customers_Commerce_Discount_V1_CompatibilityModeUseCase {
  BasketCouponDiscountPolicy = 'BASKET_COUPON_DISCOUNT_POLICY',
  CompatibilityModeUseCaseUnspecified = 'COMPATIBILITY_MODE_USE_CASE_UNSPECIFIED',
  CpgProductDealPolicy = 'CPG_PRODUCT_DEAL_POLICY',
  CpgSpendPromotionPolicy = 'CPG_SPEND_PROMOTION_POLICY',
  IppLegacyCouponPolicy = 'IPP_LEGACY_COUPON_POLICY',
  RfmPolicy = 'RFM_POLICY',
  ServiceItemDiscountPolicy = 'SERVICE_ITEM_DISCOUNT_POLICY'
}

/**
 * This is a generic condition which can support different types of keys.
 * For the supported keys in ConditionKey, this will be used to check if the condition is met.
 * For example, quantity greater than 2 would be defined as:
 * {
 * key = ConditionKey.QUANTITY,
 * operator : ConditionOperator.GREATER_THAN
 * value: 2
 * }
 */
export type Instacart_Customers_Commerce_Discount_V1_Condition = {
  __typename?: 'instacart_customers_commerce_discount_v1_Condition';
  key?: Maybe<Instacart_Customers_Commerce_Discount_V1_ConditionKey>;
  operator?: Maybe<Instacart_Customers_Commerce_Discount_V1_ConditionOperator>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ConditionKey {
  /** Condition that checks if a user is an Instacart administrator. */
  AdminUser = 'ADMIN_USER',
  BenefitTier = 'BENEFIT_TIER',
  ConditionKeyUnspecified = 'CONDITION_KEY_UNSPECIFIED',
  DevicePlatform = 'DEVICE_PLATFORM',
  /** Condition that checks the directed spend program code in order benefit qualifier */
  DirectedSpendProgramCode = 'DIRECTED_SPEND_PROGRAM_CODE',
  DiscountTags = 'DISCOUNT_TAGS',
  FirstNOrders = 'FIRST_N_ORDERS',
  FulfillmentType = 'FULFILLMENT_TYPE',
  GiftOrder = 'GIFT_ORDER',
  IcPlusMember = 'IC_PLUS_MEMBER',
  ItemsTotalPrice = 'ITEMS_TOTAL_PRICE',
  LoyaltyMember = 'LOYALTY_MEMBER',
  LoyaltyTier = 'LOYALTY_TIER',
  NamedScenario = 'NAMED_SCENARIO',
  OfferEvaluationTags = 'OFFER_EVALUATION_TAGS',
  /** Condition that checks the day of the week of order creation. Valid values are Sun, Mon, Tue, Wed, Thu, Fri, Sat (case-insensitive) */
  OrderCreationDayOfWeek = 'ORDER_CREATION_DAY_OF_WEEK',
  OrderDeliveryTags = 'ORDER_DELIVERY_TAGS',
  PaymentInstrumentType = 'PAYMENT_INSTRUMENT_TYPE',
  Quantity = 'QUANTITY',
  RegularItemsPrice = 'REGULAR_ITEMS_PRICE',
  RetailerTotalPrice = 'RETAILER_TOTAL_PRICE',
  ServiceOptionType = 'SERVICE_OPTION_TYPE',
  UniqueProductsCount = 'UNIQUE_PRODUCTS_COUNT',
  WeightKg = 'WEIGHT_KG',
  WeightLb = 'WEIGHT_LB'
}

export enum Instacart_Customers_Commerce_Discount_V1_ConditionOperator {
  ConditionOperatorUnspecified = 'CONDITION_OPERATOR_UNSPECIFIED',
  ContainsAll = 'CONTAINS_ALL',
  ContainsAny = 'CONTAINS_ANY',
  Equal = 'EQUAL',
  Exclude = 'EXCLUDE',
  GreaterThan = 'GREATER_THAN',
  GreaterThanEqual = 'GREATER_THAN_EQUAL',
  LessThan = 'LESS_THAN',
  LessThanEqual = 'LESS_THAN_EQUAL'
}

/**
 * This is a generic condition which can support different types of keys.
 * For the supported keys in ConditionKey, this will be used to check if the condition is met.
 * For example, quantity greater than 2 would be defined as:
 * {
 * key = ConditionKey.QUANTITY,
 * operator : ConditionOperator.GREATER_THAN
 * value: 2
 * }
 */
export type Instacart_Customers_Commerce_Discount_V1_Condition_Input = {
  key?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ConditionKey>;
  operator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ConditionOperator>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedCreditBackInCoupon';
  creditBackCouponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  creditBackCouponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditBackCouponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  creditCouponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails>;
  creditCouponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input = {
  creditBackCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  creditBackCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditBackCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  creditCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input>;
  creditCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedCreditBackInDigitalWallet';
  creditBackCouponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  creditBackCouponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditBackCouponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  digitalWalletDepositDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input = {
  creditBackCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  creditBackCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditBackCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditBackCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  digitalWalletDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedDiscount';
  couponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  couponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  couponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input = {
  couponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  couponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  couponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  couponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponBasedInKindBack';
  inKindBackCouponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails>;
  inKindBackCouponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  inKindBackCouponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindBackCouponIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  inKindDepositDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails>;
};

export type Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input = {
  inKindBackCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input>;
  inKindBackCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  inKindBackCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindBackCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
  inKindDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_CouponCodeType {
  CouponCodeTypeUnspecified = 'COUPON_CODE_TYPE_UNSPECIFIED',
  SharedCode = 'SHARED_CODE',
  SingleUserAssignedCode = 'SINGLE_USER_ASSIGNED_CODE',
  SingleUserUnassignedCode = 'SINGLE_USER_UNASSIGNED_CODE'
}

/** Details of Coupon which will be granted. */
export type Instacart_Customers_Commerce_Discount_V1_CouponDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponDetails';
  couponCodeType?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponCodeType>;
  redeemableCouponGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo>;
  redemptionCondition?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** Details of Coupon which will be granted. */
export type Instacart_Customers_Commerce_Discount_V1_CouponDetails_Input = {
  couponCodeType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponCodeType>;
  redeemableCouponGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** Coupon's Grant which will be awarded/redeemed if condition satisfied */
export type Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_CouponGrantInfo';
  couponGrantMethod?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
  expiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  instanceCount?: Maybe<Scalars['BigInt']>;
  valueGrantGuaranteeBasis?: Maybe<Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis>;
};

/** Coupon's Grant which will be awarded/redeemed if condition satisfied */
export type Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo_Input = {
  couponGrantMethod?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
  expiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
  instanceCount?: InputMaybe<Scalars['BigInt']>;
  valueGrantGuaranteeBasis?: InputMaybe<Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis>;
};

export enum Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod {
  AutomatedCouponGrant = 'AUTOMATED_COUPON_GRANT',
  ClickToRedeem = 'CLICK_TO_REDEEM',
  CouponGrantMethodUnspecified = 'COUPON_GRANT_METHOD_UNSPECIFIED',
  ManualCodeRedemption = 'MANUAL_CODE_REDEMPTION'
}

export enum Instacart_Customers_Commerce_Discount_V1_CouponModelType {
  CouponModelTypeUnspecified = 'COUPON_MODEL_TYPE_UNSPECIFIED',
  GenericCoupon = 'GENERIC_COUPON',
  LegacyBasketCoupon = 'LEGACY_BASKET_COUPON',
  LegacyDeliveryCoupon = 'LEGACY_DELIVERY_COUPON',
  LegacyExpressCoupon = 'LEGACY_EXPRESS_COUPON'
}

export enum Instacart_Customers_Commerce_Discount_V1_CouponType {
  CouponTypeUnspecified = 'COUPON_TYPE_UNSPECIFIED',
  CreditBackCoupon = 'CREDIT_BACK_COUPON',
  CreditCoupon = 'CREDIT_COUPON',
  DiscountCoupon = 'DISCOUNT_COUPON'
}

export type Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyRequest_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input>>>;
  apiCallerDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_Input>;
  autoAppliedDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input>;
  autoCreditBackInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input>;
  autoCreditBackInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input>;
  autoInKindBack?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input>;
  checkoutBenefitCodeDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_Creator_Input>;
  creditBackInCouponUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input>;
  creditBackInDigitalWalletUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input>;
  creditInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input>;
  creditInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input>;
  /** any description for the policy */
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input>;
  discountUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: InputMaybe<Scalars['String']>;
  /**
   * Financial funder that will bill for value grants issued by this policy.
   * When absent, the funder is derived server-side from `funding_details` and `source`.
   */
  financialFunder?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_FinancialFunder_Input>;
  fundingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inKindBackUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input>;
  inKindDeposit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input>;
  /** name of the policy */
  name?: InputMaybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** Request id. */
  requestId?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  source?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userSegments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  validationRulesToSkip?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_BusinessLogicValidationRule>>>;
  valueGrantCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreateValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreateValueGrantPolicyResponse';
  valueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy>;
};

export type Instacart_Customers_Commerce_Discount_V1_Creator = {
  __typename?: 'instacart_customers_commerce_discount_v1_Creator';
  creatorId?: Maybe<Scalars['BigInt']>;
  creatorType?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreatorType>;
};

export enum Instacart_Customers_Commerce_Discount_V1_CreatorType {
  CreatorTypeAdsPlatform = 'CREATOR_TYPE_ADS_PLATFORM',
  CreatorTypeIc = 'CREATOR_TYPE_IC',
  CreatorTypeIpp = 'CREATOR_TYPE_IPP',
  CreatorTypeUnspecified = 'CREATOR_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_Creator_Input = {
  creatorId?: InputMaybe<Scalars['BigInt']>;
  creatorType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreatorType>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditBackGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditBackGrantCalculator';
  fixedValueCreditBackAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentCreditBackInfo?: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditCouponDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditCouponDetail';
  couponModelType?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponModelType>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
};

/** Credit in Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditCouponDetails';
  redeemableCreditCouponGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant>;
  redemptionCondition?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** Credit in Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input = {
  redeemableCreditCouponGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** Credit grant in form of Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditCouponGrant';
  credit?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo>;
  grant?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo>;
};

/** Credit grant in form of Coupon */
export type Instacart_Customers_Commerce_Discount_V1_CreditCouponGrant_Input = {
  credit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input>;
  grant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantInfo_Input>;
};

/** Credit in Digital wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditDigitalWalletDepositDetails';
  redeemableCreditDwDepositGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant>;
  redemptionCondition?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** Credit in Digital wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input = {
  redeemableCreditDwDepositGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** Credit grant in form of Digital Wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditDigitalWalletDepositGrant';
  creditDwDepositTargetDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail>;
  expiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  grant?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo>;
  storedValueService?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

/** Credit grant in form of Digital Wallet */
export type Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositGrant_Input = {
  creditDwDepositTargetDetail?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_Input>;
  expiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
  grant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input>;
  storedValueService?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditGrantCalculator';
  fixedValueCreditAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentCreditInfo?: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator_Input = {
  fixedValueCreditAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentCreditInfo?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input>;
};

/** Credit Grant (represent by coupon OR will store in Digital Wallet) */
export type Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditGrantInfo';
  grantQuantityDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  grantQuantityType?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityType>;
  refundExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
};

/** Credit Grant (represent by coupon OR will store in Digital Wallet) */
export type Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input = {
  grantQuantityDetail?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  grantQuantityType?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityType>;
  refundExpiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInCoupon = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditInCoupon';
  creditCouponDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails>;
  creditCouponExercisingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails>;
  creditCouponIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditCouponIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input = {
  creditCouponDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetails_Input>;
  creditCouponExercisingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input>;
  creditCouponIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  creditCouponIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet = {
  __typename?: 'instacart_customers_commerce_discount_v1_CreditInDigitalWallet';
  digitalWalletDepositDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails>;
  digitalWalletDepositIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  digitalWalletDepositIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input = {
  digitalWalletDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditDigitalWalletDepositDetails_Input>;
  digitalWalletDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  digitalWalletDepositIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_DiscountCouponDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_DiscountCouponDetail';
  couponApplicationLevel?: Maybe<Instacart_Customers_Commerce_Discount_V1_OfferApplicationType>;
  couponModelType?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponModelType>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_DiscountGrantCalculator';
  fixedPriceDiscount?: Maybe<GoogleTypeMoney>;
  fixedPricePerUnitDiscountInfo?: Maybe<Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo>;
  fixedValueDiscountAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  fixedValueDiscountAmountPerUnit?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentDiscountInfo?: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator_Input = {
  fixedPriceDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  fixedPricePerUnitDiscountInfo?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo_Input>;
  fixedValueDiscountAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  fixedValueDiscountAmountPerUnit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentDiscountInfo?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_DiscountTag {
  DiscountTagUnspecified = 'DISCOUNT_TAG_UNSPECIFIED',
  ServiceOptionDiscountGroupTagFivePercent = 'SERVICE_OPTION_DISCOUNT_GROUP_TAG_FIVE_PERCENT',
  /** tags to indicate service option discount groups */
  ServiceOptionDiscountGroupTagTwoDollar = 'SERVICE_OPTION_DISCOUNT_GROUP_TAG_TWO_DOLLAR',
  ValueMealSuperSaverFivePercentCreditBack = 'VALUE_MEAL_SUPER_SAVER_FIVE_PERCENT_CREDIT_BACK',
  ValueMealSuperSaverTenPercentCreditBack = 'VALUE_MEAL_SUPER_SAVER_TEN_PERCENT_CREDIT_BACK',
  ValueMealSuperSaverTwoPercentCreditBack = 'VALUE_MEAL_SUPER_SAVER_TWO_PERCENT_CREDIT_BACK'
}

export type Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria = {
  __typename?: 'instacart_customers_commerce_discount_v1_ExclusionCriteria';
  key?: Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteriaKey>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ExclusionCriteriaKey {
  /** Excludes items with any listed brand id from offer condition */
  ExcludedBrandId = 'EXCLUDED_BRAND_ID',
  /** Exclude items with any listed discount tag */
  ExcludedItemDiscountTag = 'EXCLUDED_ITEM_DISCOUNT_TAG',
  /** Excludes items that belong to one or more retailer-defined departments from offer condition */
  ExcludedRetailerDepartment = 'EXCLUDED_RETAILER_DEPARTMENT',
  /** Excludes items with any listed brand id from offer reward */
  ExcludedRewardBrandId = 'EXCLUDED_REWARD_BRAND_ID',
  /** Excludes items that belong to one or more retailer-defined departments from offer reward */
  ExcludedRewardRetailerDepartment = 'EXCLUDED_REWARD_RETAILER_DEPARTMENT',
  ExclusionCriteriaKeyUnspecified = 'EXCLUSION_CRITERIA_KEY_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria_Input = {
  key?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteriaKey>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_FixedPricePerUnitDiscountInfo';
  perUnitPrice?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_FixedPricePerUnitDiscountInfo_Input = {
  perUnitPrice?: InputMaybe<GoogleTypeMoneyInput>;
};

export enum Instacart_Customers_Commerce_Discount_V1_FulfillmentType {
  Delivery = 'DELIVERY',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  Instore = 'INSTORE',
  Pickup = 'PICKUP'
}

export type Instacart_Customers_Commerce_Discount_V1_FundingDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_FundingDetail';
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: Maybe<GoogleTypeMoney>;
  fundingProviderInfo?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input = {
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>;
  fundingProviderInfo?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation_Input>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation = {
  __typename?: 'instacart_customers_commerce_discount_v1_FundingProviderInformation';
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: Maybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: Maybe<Instacart_Customers_Commerce_Discount_V1_FundingSource>;
  /** name of the funding source */
  sourceName?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation_Input = {
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: InputMaybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingSource>;
  /** name of the funding source */
  sourceName?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

export type Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeRequest_Input = {
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyFacadeResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_GetValueGrantPolicyFacadeResponse';
  facade?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade>;
};

export type Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyRequest_Input = {
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_GetValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_GetValueGrantPolicyResponse';
  valueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy>;
};

/** Grant/Value (i.e. coupon/credit) Exercising */
export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails';
  attachmentLevel?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantAttachmentLevel>;
  conditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition>>>;
  exercisingLimits?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits>;
  reward?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward>>>;
  stackability?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStackability>;
  storeAvailability?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStoreAvailability>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantAttachmentLevel {
  GrantAttachmentBasketLevel = 'GRANT_ATTACHMENT_BASKET_LEVEL',
  GrantAttachmentFeeLevel = 'GRANT_ATTACHMENT_FEE_LEVEL',
  GrantAttachmentItemLevel = 'GRANT_ATTACHMENT_ITEM_LEVEL',
  GrantAttachmentLevelUnspecified = 'GRANT_ATTACHMENT_LEVEL_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantExercisingCondition';
  allowPartialApplication?: Maybe<Scalars['Boolean']>;
  conditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
  exclusionCriteria?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria>>>;
  groupCriteria?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition_Input = {
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
  exclusionCriteria?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria_Input>>>;
  groupCriteria?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria_Input>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantExercisingLimits';
  exercisingLimit?: Maybe<Scalars['BigInt']>;
  exercisingLimitPerOrder?: Maybe<Scalars['BigInt']>;
  exercisingLimitPerUser?: Maybe<Scalars['BigInt']>;
  recurringBenefitLimitPerUser?: Maybe<Instacart_Customers_Commerce_Discount_V1_RecurringBenefit>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits_Input = {
  exercisingLimit?: InputMaybe<Scalars['BigInt']>;
  exercisingLimitPerOrder?: InputMaybe<Scalars['BigInt']>;
  exercisingLimitPerUser?: InputMaybe<Scalars['BigInt']>;
  recurringBenefitLimitPerUser?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_RecurringBenefit_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStackability {
  /** Indicates the grant exercising is not stackable with other stackable and non-stackable grant exercising */
  GrantExercisingNonStackable = 'GRANT_EXERCISING_NON_STACKABLE',
  /** Indicates the grant exercising bypasses all stackability rules and always allowed to apply irrespective of other competing grant exercising */
  GrantExercisingPolicyAlwaysStackable = 'GRANT_EXERCISING_POLICY_ALWAYS_STACKABLE',
  GrantExercisingStackabilityUnspecified = 'GRANT_EXERCISING_STACKABILITY_UNSPECIFIED',
  /** Indicates the grant exercising is stackable with grant exercising */
  GrantExercisingStackable = 'GRANT_EXERCISING_STACKABLE'
}

export enum Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStoreAvailability {
  GrantExercisingStoreAvailabilityInStoreOnly = 'GRANT_EXERCISING_STORE_AVAILABILITY_IN_STORE_ONLY',
  GrantExercisingStoreAvailabilityOnlineOnly = 'GRANT_EXERCISING_STORE_AVAILABILITY_ONLINE_ONLY',
  GrantExercisingStoreAvailabilityUnspecified = 'GRANT_EXERCISING_STORE_AVAILABILITY_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward';
  credit?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward>;
  discount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward>;
  inKind?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward>;
  rewardGroup?: Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward_CreditReward';
  creditGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward_Input = {
  creditGrantCalculator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward_DiscountReward';
  discountCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward_Input = {
  discountCalculator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantExercisingDetails_GrantReward_InKindReward';
  inKindGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward_Input = {
  inKindGrantCalculator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_Input = {
  credit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_CreditReward_Input>;
  discount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_DiscountReward_Input>;
  inKind?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_InKindReward_Input>;
  rewardGroup?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup_Input>;
};

/** Grant/Value (i.e. coupon/credit) Exercising */
export type Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_Input = {
  attachmentLevel?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantAttachmentLevel>;
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingCondition_Input>>>;
  exercisingLimits?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingLimits_Input>;
  reward?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantReward_Input>>>;
  stackability?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStackability>;
  storeAvailability?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantExercisingDetails_GrantExercisingStoreAvailability>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantQuantityDetail';
  monetaryAmount?: Maybe<GoogleTypeMoney>;
  nonMonetaryAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input = {
  monetaryAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nonMonetaryAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantQuantityDetail_NonMonetaryAmount';
  fundTypeIdentifier?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['BigInt']>;
  unit?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_NonMonetaryUnit>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_Input = {
  fundTypeIdentifier?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['BigInt']>;
  unit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_NonMonetaryUnit>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_NonMonetaryAmount_NonMonetaryUnit {
  NonMonetaryChasePoints = 'NON_MONETARY_CHASE_POINTS',
  NonMonetaryUnitUnspecified = 'NON_MONETARY_UNIT_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_GrantQuantityType {
  Fixed = 'FIXED',
  GrantValueTypeUnspecified = 'GRANT_VALUE_TYPE_UNSPECIFIED',
  NotApplicable = 'NOT_APPLICABLE',
  Variable = 'VARIABLE'
}

export type Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_GrantTargetDetail';
  fundTypeIdentifier?: Maybe<Scalars['String']>;
  walletProduct?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_WalletProduct>;
};

export type Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_Input = {
  fundTypeIdentifier?: InputMaybe<Scalars['String']>;
  walletProduct?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_WalletProduct>;
};

/** This is currently defined as non shared type in payment service */
export enum Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_WalletProduct {
  BusinessContractualBenefit = 'BUSINESS_CONTRACTUAL_BENEFIT',
  CaperCredit = 'CAPER_CREDIT',
  ChaseCardCredit = 'CHASE_CARD_CREDIT',
  ChasePwp = 'CHASE_PWP',
  DirectedSpend = 'DIRECTED_SPEND',
  ExpressCredit = 'EXPRESS_CREDIT',
  GamificationCredit = 'GAMIFICATION_CREDIT',
  GeneralRetailerCredit = 'GENERAL_RETAILER_CREDIT',
  GiftCards = 'GIFT_CARDS',
  HappinessAppeasements = 'HAPPINESS_APPEASEMENTS',
  IcPromotionalCreditBack = 'IC_PROMOTIONAL_CREDIT_BACK',
  LegacyGiftCards = 'LEGACY_GIFT_CARDS',
  RefundCredit = 'REFUND_CREDIT',
  RetailerGiftCard = 'RETAILER_GIFT_CARD',
  ValueGrantCredit = 'VALUE_GRANT_CREDIT',
  WalletProductUnspecified = 'WALLET_PRODUCT_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_GroupCriteria = {
  __typename?: 'instacart_customers_commerce_discount_v1_GroupCriteria';
  key?: Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteriaKey>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_GroupCriteriaKey {
  /** Matches alcohol items that are allowed in the specified states */
  AlcoholStateAllowed = 'ALCOHOL_STATE_ALLOWED',
  /** Matches items with any listed brand name */
  BrandName = 'BRAND_NAME',
  /** Matches all items in cart */
  Cart = 'CART',
  /** Matches items with any listed commerce classifications */
  CommerceClassification = 'COMMERCE_CLASSIFICATION',
  GroupCriteriaKeyUnspecified = 'GROUP_CRITERIA_KEY_UNSPECIFIED',
  /** Matches items in any listed collection */
  ItemCollection = 'ITEM_COLLECTION',
  /** Matches items with any listed discount tag */
  ItemDiscountTag = 'ITEM_DISCOUNT_TAG',
  /** Matches items with any listed product id */
  ProductId = 'PRODUCT_ID',
  /** Matches items with any listed region */
  Region = 'REGION',
  /** Matches items that belong to one or more retailer-defined departments */
  RetailerDepartment = 'RETAILER_DEPARTMENT',
  /** Matches items that belong to one or more retailer-defined departments by ID (excluded) */
  RetailerDepartmentIdExcluded = 'RETAILER_DEPARTMENT_ID_EXCLUDED',
  /** Matches items that belong to one or more retailer-defined departments by ID (included) */
  RetailerDepartmentIdIncluded = 'RETAILER_DEPARTMENT_ID_INCLUDED',
  /** Matches retailer products in any listed collection */
  RetailerProductCollectionId = 'RETAILER_PRODUCT_COLLECTION_ID',
  /** Matches retailer products in any excluded listed collection */
  RetailerProductCollectionIdExcluded = 'RETAILER_PRODUCT_COLLECTION_ID_EXCLUDED',
  /** Matches retailer products in any included listed collection */
  RetailerProductCollectionIdIncluded = 'RETAILER_PRODUCT_COLLECTION_ID_INCLUDED',
  /** Matches items with any listed taxonomy node id */
  TaxonomyNodeId = 'TAXONOMY_NODE_ID',
  /** Matches items that have their cost_unit set to the specified unit(s) */
  WeightUnit = 'WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Discount_V1_GroupCriteria_Input = {
  key?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteriaKey>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindBackGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindBackGrantCalculator';
  fixedValueInKindBackAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  fixedValueInKindBackAmountPerUnit?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentInKindBackAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindDeposit = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindDeposit';
  inKindDepositDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails>;
  inKindDepositIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindDepositIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

/** In-kind deposit details */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindDepositDetails';
  inKindDepositGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant>;
  redemptionCondition?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
};

/** In-kind deposit details */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input = {
  inKindDepositGrant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant_Input>;
  redemptionCondition?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_Condition_Input>>>;
};

/** In-kind grant in form of deposit */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindDepositGrant';
  expiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  grant?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo>;
  inKindDepositTargetDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail>;
  storedValueService?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

/** In-kind grant in form of deposit */
export type Instacart_Customers_Commerce_Discount_V1_InKindDepositGrant_Input = {
  expiresIn?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input>;
  grant?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantInfo_Input>;
  inKindDepositTargetDetail?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail_Input>;
  storedValueService?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input = {
  inKindDepositDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDepositDetails_Input>;
  inKindDepositIssuingAuthority?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  inKindDepositIssuingFlow?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator = {
  __typename?: 'instacart_customers_commerce_discount_v1_InKindGrantCalculator';
  fixedValueInKindAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  fixedValueInKindAmountPerUnit?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentInKindAmount?: Maybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo>;
};

export type Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator_Input = {
  fixedValueInKindAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  fixedValueInKindAmountPerUnit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentInKindAmount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input>;
};

export enum Instacart_Customers_Commerce_Discount_V1_OfferApplicationType {
  BasketLevel = 'BASKET_LEVEL',
  FeeLevel = 'FEE_LEVEL',
  ItemLevel = 'ITEM_LEVEL',
  OfferApplicationTypeUnspecified = 'OFFER_APPLICATION_TYPE_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_OfferStackability {
  /** Indicates the offer bypasses all stackability rules and always allowed to apply irrespective of other competing offers */
  AlwaysStackable = 'ALWAYS_STACKABLE',
  /** Indicates the offer is not stackable with other stackable and non-stackable offers */
  NonStackable = 'NON_STACKABLE',
  OfferStackabilityUnspecified = 'OFFER_STACKABILITY_UNSPECIFIED',
  /** Indicates the offer is stackable with any offer */
  Stackable = 'STACKABLE'
}

export enum Instacart_Customers_Commerce_Discount_V1_OnOrderGrantType {
  OnOrderGrantTypeAutoApplyCreditBack = 'ON_ORDER_GRANT_TYPE_AUTO_APPLY_CREDIT_BACK',
  OnOrderGrantTypeAutoApplyDiscount = 'ON_ORDER_GRANT_TYPE_AUTO_APPLY_DISCOUNT',
  OnOrderGrantTypeAutoApplyInKindBack = 'ON_ORDER_GRANT_TYPE_AUTO_APPLY_IN_KIND_BACK',
  OnOrderGrantTypeCheckoutCodeBasedDiscount = 'ON_ORDER_GRANT_TYPE_CHECKOUT_CODE_BASED_DISCOUNT',
  OnOrderGrantTypeCouponBasedCreditBack = 'ON_ORDER_GRANT_TYPE_COUPON_BASED_CREDIT_BACK',
  OnOrderGrantTypeCouponBasedDiscount = 'ON_ORDER_GRANT_TYPE_COUPON_BASED_DISCOUNT',
  OnOrderGrantTypeCouponBasedInKindBack = 'ON_ORDER_GRANT_TYPE_COUPON_BASED_IN_KIND_BACK',
  OnOrderGrantTypePointsBasedDiscount = 'ON_ORDER_GRANT_TYPE_POINTS_BASED_DISCOUNT',
  OnOrderGrantTypeUnspecified = 'ON_ORDER_GRANT_TYPE_UNSPECIFIED',
  OnOrderGrantTypeValueIssuedInCoupon = 'ON_ORDER_GRANT_TYPE_VALUE_ISSUED_IN_COUPON',
  OnOrderGrantTypeValueIssuedInDigitalWallet = 'ON_ORDER_GRANT_TYPE_VALUE_ISSUED_IN_DIGITAL_WALLET',
  OnOrderGrantTypeValueIssuedInKind = 'ON_ORDER_GRANT_TYPE_VALUE_ISSUED_IN_KIND'
}

export type Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo = {
  __typename?: 'instacart_customers_commerce_discount_v1_PercentGrantInfo';
  maximumGrantQuantity?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  percentBase?: Maybe<Instacart_Customers_Commerce_Discount_Types_V1_RewardPercentBase>;
  percentValue?: Maybe<Instacart_Types_V1_BigDecimal>;
};

export type Instacart_Customers_Commerce_Discount_V1_PercentGrantInfo_Input = {
  maximumGrantQuantity?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail_Input>;
  percentBase?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_RewardPercentBase>;
  percentValue?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy';
  endsAt?: Maybe<Scalars['DateTime']>;
  presentableConditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition>>>;
  presentableGrantDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition';
  allValueGrantTags?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_AllValueGrantTags>;
  country?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_Country>;
  customTermsCondition?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition>;
  directedSpendProgramEnrollmentRequired?: Maybe<Scalars['instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_DirectedSpendProgramEnrollmentRequired']>;
  firstNOrders?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_FirstNOrders>;
  fulfillmentType?: Maybe<Instacart_Customers_Commerce_Discount_V1_FulfillmentType>;
  icMembershipExcluded?: Maybe<Scalars['instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipExcluded']>;
  icMembershipRequired?: Maybe<Scalars['instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ICMembershipRequired']>;
  itemCollection?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollection>;
  itemCollectionMinimumSpend?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollectionMinimumSpend>;
  minimumSpend?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_MinimumSpend>;
  notOneOfRetailers?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfRetailers>;
  notOneOfStoreConfigurations?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfStoreConfigurations>;
  oneOfPaymentInstruments?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfPaymentInstruments>;
  oneOfRegions?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRegions>;
  oneOfRetailers?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRetailers>;
  oneOfStoreConfigurations?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfStoreConfigurations>;
  taxonomyCollection?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_TaxonomyCollection>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_AllValueGrantTags = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_AllValueGrantTags';
  valueGrantTags?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountTag>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_Country = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_Country';
  countryId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition';
  localeTermsConditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition_LocaleTermsCondition>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition_LocaleTermsCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_CustomTermsCondition_LocaleTermsCondition';
  locale?: Maybe<Scalars['String']>;
  termsConditions?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_FirstNOrders = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_FirstNOrders';
  orderCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollection = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ItemCollection';
  collectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  minimumSpend?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_ItemCollectionMinimumSpend = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_ItemCollectionMinimumSpend';
  groupCriteria?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria>>>;
  minimumSpend?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_MinimumSpend = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_MinimumSpend';
  commerceClassifications?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_CommerceClassification>>>;
  exclusionCriteria?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria>>>;
  minimumSpend?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfRetailers = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfRetailers';
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfStoreConfigurations = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_NotOneOfStoreConfigurations';
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfPaymentInstruments = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfPaymentInstruments';
  paymentInstructions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_PaymentInstruction>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRegions = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfRegions';
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfRetailers = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfRetailers';
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_OneOfStoreConfigurations = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_OneOfStoreConfigurations';
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableCondition_TaxonomyCollection = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableCondition_TaxonomyCollection';
  collectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  minimumSpend?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail';
  couponDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CouponDetail>;
  couponGrantCount?: Maybe<Scalars['BigInt']>;
  creditBackGrantDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditBackGrantDetail>;
  creditGrantDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditGrantDetail>;
  discountGrantDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail>;
  grantStackability?: Maybe<Instacart_Customers_Commerce_Discount_V1_OfferStackability>;
  inKindBackGrantDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindBackGrantDetail>;
  inKindGrantDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindGrantDetail>;
  presentableGrantType?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_PresentableGrantType>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CouponDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_CouponDetail';
  couponGrantCount?: Maybe<Scalars['BigInt']>;
  couponGrantMaximumDuration?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  couponGrantMethod?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditBackGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditBackGrantDetail';
  creditBackGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditBackGrantCalculator>;
  grantExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  refundExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_CreditGrantDetail';
  creditGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditGrantCalculator>;
  grantExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  refundExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  storedValueService?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail';
  discountGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator>;
  discountedCollection?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCollection>;
  discountedCommerceClassifications?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCommerceClassifications>;
  discountedServiceItems?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedServiceItems>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCollection = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCollection';
  groupingKeys?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroupKey>>>;
  rewardGroups?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCommerceClassifications = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedCommerceClassifications';
  commerceClassifications?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_CommerceClassification>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedServiceItems = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_DiscountGrantDetail_DiscountedServiceItems';
  serviceItemTypes?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ServiceItemType>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindBackGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindBackGrantDetail';
  grantExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  inKindBackGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindBackGrantCalculator>;
  refundExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
};

export type Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindGrantDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_PresentableValueGrantPolicy_PresentableGrantDetail_InKindGrantDetail';
  grantExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  inKindGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindGrantCalculator>;
  refundExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  storedValueService?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export enum Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy_PresentableGrantDetail_PresentableGrantType {
  /** On order credit that is evaluated for all orders of a customer */
  GrantTypeAutoAppliedCreditBack = 'GRANT_TYPE_AUTO_APPLIED_CREDIT_BACK',
  /** Basket level discount that is evaluated for all orders of a customer. */
  GrantTypeAutoAppliedDiscount = 'GRANT_TYPE_AUTO_APPLIED_DISCOUNT',
  /** On order in-kind evaluated for all orders of a customer */
  GrantTypeAutoAppliedInKindBack = 'GRANT_TYPE_AUTO_APPLIED_IN_KIND_BACK',
  /** Checkout code based discount */
  GrantTypeCheckoutCodeBasedDiscount = 'GRANT_TYPE_CHECKOUT_CODE_BASED_DISCOUNT',
  /** On order credit backed evaluated for only customers having credit back coupon */
  GrantTypeCouponCreditBack = 'GRANT_TYPE_COUPON_CREDIT_BACK',
  /**
   * Basket level discount evaluated for only customers having discount coupon
   * Ex: Discount of $10 on order placed from Costco for customers having the coupon
   */
  GrantTypeCouponDiscount = 'GRANT_TYPE_COUPON_DISCOUNT',
  /** On order in-kind evaluated only for customers having in-kind back coupon */
  GrantTypeCouponInKindBack = 'GRANT_TYPE_COUPON_IN_KIND_BACK',
  /**
   * Off order credit that is granted independent of an order, Ex: $10 credit
   * when a customer places 3 orders in a week
   */
  GrantTypeCredit = 'GRANT_TYPE_CREDIT',
  /** Off order in-kind granted independent of an order, Ex: 500 miles */
  GrantTypeInKind = 'GRANT_TYPE_IN_KIND',
  PresentableGrantTypeUnspecified = 'PRESENTABLE_GRANT_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyRequest_Input = {
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_PublishValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_PublishValueGrantPolicyResponse';
  facade?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade>;
};

export type Instacart_Customers_Commerce_Discount_V1_RecurringBenefit = {
  __typename?: 'instacart_customers_commerce_discount_v1_RecurringBenefit';
  rewardCount?: Maybe<Scalars['BigInt']>;
  rewardMonetaryAmount?: Maybe<GoogleTypeMoney>;
  timePeriod?: Maybe<Instacart_Customers_Commerce_Discount_Types_V1_RecurringBenefitTimePeriod>;
};

export type Instacart_Customers_Commerce_Discount_V1_RecurringBenefit_Input = {
  rewardCount?: InputMaybe<Scalars['BigInt']>;
  rewardMonetaryAmount?: InputMaybe<GoogleTypeMoneyInput>;
  timePeriod?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_RecurringBenefitTimePeriod>;
};

export type Instacart_Customers_Commerce_Discount_V1_RewardGroup = {
  __typename?: 'instacart_customers_commerce_discount_v1_RewardGroup';
  includeConditionGroup?: Maybe<Scalars['Boolean']>;
  measuredQuantityLimit?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  quantityLimit?: Maybe<Scalars['BigInt']>;
  rewardGroupKey?: Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroupKey>;
  value?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_RewardGroupKey {
  /** Includes items whose brand name appears in the values list. */
  RewardBrandName = 'REWARD_BRAND_NAME',
  /** Includes all items in cart */
  RewardCart = 'REWARD_CART',
  /** Includes all items in the given commerce_classifications. */
  RewardCommerceClassification = 'REWARD_COMMERCE_CLASSIFICATION',
  RewardGroupKeyUnspecified = 'REWARD_GROUP_KEY_UNSPECIFIED',
  /** Includes all items in the specified collections. */
  RewardItemCollection = 'REWARD_ITEM_COLLECTION',
  /** Includes all items with specified discount tags. */
  RewardItemDiscountTag = 'REWARD_ITEM_DISCOUNT_TAG',
  /** Includes items whose product ID appears in the values list. */
  RewardProductId = 'REWARD_PRODUCT_ID',
  /** Includes items that belong to one or more retailer-defined departments */
  RewardRetailerDepartment = 'REWARD_RETAILER_DEPARTMENT',
  /** Includes items that belong to one or more retailer-defined departments by ID (excluded) */
  RewardRetailerDepartmentIdExcluded = 'REWARD_RETAILER_DEPARTMENT_ID_EXCLUDED',
  /** Includes items that belong to one or more retailer-defined departments by ID (included) */
  RewardRetailerDepartmentIdIncluded = 'REWARD_RETAILER_DEPARTMENT_ID_INCLUDED',
  /** Excludes all items with specified retailer product collection ids. */
  RewardRetailerProductCollectionIdExcluded = 'REWARD_RETAILER_PRODUCT_COLLECTION_ID_EXCLUDED',
  /** Includes all items with specified retailer product collection ids. */
  RewardRetailerProductCollectionIdIncluded = 'REWARD_RETAILER_PRODUCT_COLLECTION_ID_INCLUDED',
  /** Includes all service items */
  RewardServiceItem = 'REWARD_SERVICE_ITEM',
  /** Includes items whose (any) taxonomy node ID appears in the values list. */
  RewardTaxonomyNodeId = 'REWARD_TAXONOMY_NODE_ID',
  /** Matches items that have their cost_unit set to the specified unit(s) */
  RewardWeightUnit = 'REWARD_WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Discount_V1_RewardGroup_Input = {
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>;
  measuredQuantityLimit?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  quantityLimit?: InputMaybe<Scalars['BigInt']>;
  rewardGroupKey?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_RewardGroupKey>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ServiceItemType {
  /** alcohol service fee */
  AlcoholServiceFee = 'ALCOHOL_SERVICE_FEE',
  CancellationFee = 'CANCELLATION_FEE',
  DeliveryFee = 'DELIVERY_FEE',
  /** other service fee except alcohol and rx */
  GeneralServiceFee = 'GENERAL_SERVICE_FEE',
  HeavyDeliveryFee = 'HEAVY_DELIVERY_FEE',
  LongDistanceFee = 'LONG_DISTANCE_FEE',
  PriorityFee = 'PRIORITY_FEE',
  /** total service fee (general + alcohol + rx) */
  RegularServiceFee = 'REGULAR_SERVICE_FEE',
  /** rx service fee */
  RxServiceFee = 'RX_SERVICE_FEE',
  ServiceFee = 'SERVICE_FEE',
  ServiceItemTypeUnspecified = 'SERVICE_ITEM_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_StoredCouponGrantTemplate = {
  __typename?: 'instacart_customers_commerce_discount_v1_StoredCouponGrantTemplate';
  couponCodeType?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponCodeType>;
  couponGrantMethod?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponGrantMethod>;
  couponInitialValue?: Maybe<GoogleTypeMoney>;
  couponType?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponType>;
  creditCouponDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditCouponDetail>;
  discountCouponDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountCouponDetail>;
  grantExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  grantInstanceCount?: Maybe<Scalars['BigInt']>;
  grantQuantityType?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityType>;
  storedValueService?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
  valueGrantGuaranteeBasis?: Maybe<Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis>;
};

export type Instacart_Customers_Commerce_Discount_V1_StoredValueGrantTemplate = {
  __typename?: 'instacart_customers_commerce_discount_v1_StoredValueGrantTemplate';
  grantExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  grantQuantityDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityDetail>;
  grantQuantityType?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantQuantityType>;
  grantTargetDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_GrantTargetDetail>;
  refundExpiresIn?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration>;
  storedValueService?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueService>;
};

export enum Instacart_Customers_Commerce_Discount_V1_StoredValueService {
  StoredValueServiceCheddar = 'STORED_VALUE_SERVICE_CHEDDAR',
  StoredValueServiceCoupon = 'STORED_VALUE_SERVICE_COUPON',
  /** Represent 3PI layer as Store Value Service. 3PI layer will delegate call to right endpoint to store value */
  StoredValueServiceThirdParty = 'STORED_VALUE_SERVICE_THIRD_PARTY',
  StoredValueServiceUnspecified = 'STORED_VALUE_SERVICE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_TimeDuration = {
  __typename?: 'instacart_customers_commerce_discount_v1_TimeDuration';
  timePeriod?: Maybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_TimePeriod>;
  timePeriodCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Discount_V1_TimeDuration_Input = {
  timePeriod?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_TimeDuration_TimePeriod>;
  timePeriodCount?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_TimeDuration_TimePeriod {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  TimePeriodUnspecified = 'TIME_PERIOD_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyRequest_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input>>>;
  autoAppliedDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input>;
  autoCreditBackInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input>;
  autoCreditBackInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input>;
  autoInKindBack?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input>;
  checkoutBenefitCodeDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_Creator_Input>;
  creditBackInCouponUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input>;
  creditBackInDigitalWalletUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input>;
  creditInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input>;
  creditInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input>;
  /** any description for the policy */
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input>;
  discountUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: InputMaybe<Scalars['String']>;
  /**
   * Financial funder that will bill for value grants issued by this policy.
   * When absent, the funder is derived server-side from `funding_details` and `source`.
   */
  financialFunder?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_FinancialFunder_Input>;
  fundingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inKindBackUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input>;
  inKindDeposit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input>;
  /** name of the policy */
  name?: InputMaybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** Request id. */
  requestId?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  source?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userSegments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_UpdateValueGrantPolicyResponse = {
  __typename?: 'instacart_customers_commerce_discount_v1_UpdateValueGrantPolicyResponse';
  errors?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError>>>;
  valueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_PresentableValueGrantPolicy>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy';
  countryId?: Maybe<Scalars['BigInt']>;
  currencyCode?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  externalReference?: Maybe<Scalars['String']>;
  fundingProviderInformation?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_FundingProviderInformation>>>;
  orderCompletionGrantPolicyId?: Maybe<Scalars['BigInt']>;
  requestKey?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  source?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  userSegments?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueGrantPolicyDescription?: Maybe<Scalars['String']>;
  valueGrantPolicyDetail?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail>;
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: Maybe<Scalars['String']>;
  valueGrantPolicyName?: Maybe<Scalars['String']>;
  valueIssuingAuthority?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority>;
  valueIssuingFlow?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicyFacade';
  additionalMetadata?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata>>>;
  apiCallerDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails>;
  autoAppliedDiscount?: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount>;
  autoCreditBackInCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon>;
  autoCreditBackInDigitalWallet?: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet>;
  autoInKindBack?: Maybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack>;
  checkoutBenefitCodeDiscount?: Maybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount>;
  countryId?: Maybe<Scalars['BigInt']>;
  creator?: Maybe<Instacart_Customers_Commerce_Discount_V1_Creator>;
  creditBackInCouponUsingCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon>;
  creditBackInDigitalWalletUsingCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet>;
  creditInCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon>;
  creditInDigitalWallet?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet>;
  /** any description for the policy */
  description?: Maybe<Scalars['String']>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount>;
  discountUsingCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount>;
  endsAt?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: Maybe<Scalars['String']>;
  /**
   * Financial funder that will bill for value grants issued by this policy.
   * When absent, the funder is derived server-side from `funding_details` and `source`.
   */
  financialFunder?: Maybe<Instacart_Customers_Commerce_Discount_Types_V1_FinancialFunder>;
  fundingDetails?: Maybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail>;
  imageUrl?: Maybe<Scalars['String']>;
  inKindBackUsingCoupon?: Maybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack>;
  inKindDeposit?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit>;
  /** name of the policy */
  name?: Maybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: Maybe<Scalars['String']>;
  /** Request id. */
  requestId?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  source?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  userSegments?: Maybe<Array<Maybe<Scalars['String']>>>;
  valueGrantCode?: Maybe<Scalars['String']>;
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata_Input>>>;
  apiCallerDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ApiCallerDetails_Input>;
  autoAppliedDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedDiscount_Input>;
  autoCreditBackInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInCoupon_Input>;
  autoCreditBackInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedCreditBackInDigitalWallet_Input>;
  autoInKindBack?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_AutoAppliedInKindBack_Input>;
  checkoutBenefitCodeDiscount?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CheckoutBenefitCodeDiscount_Input>;
  countryId?: InputMaybe<Scalars['BigInt']>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_Creator_Input>;
  creditBackInCouponUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInCoupon_Input>;
  creditBackInDigitalWalletUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedCreditBackInDigitalWallet_Input>;
  creditInCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInCoupon_Input>;
  creditInDigitalWallet?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CreditInDigitalWallet_Input>;
  /** any description for the policy */
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountUsingClippableCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ClippableCouponBasedDiscount_Input>;
  discountUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedDiscount_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** reference key of the policy in the external system */
  externalReference?: InputMaybe<Scalars['String']>;
  /**
   * Financial funder that will bill for value grants issued by this policy.
   * When absent, the funder is derived server-side from `funding_details` and `source`.
   */
  financialFunder?: InputMaybe<Instacart_Customers_Commerce_Discount_Types_V1_FinancialFunder_Input>;
  fundingDetails?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  inKindBackUsingCoupon?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_CouponBasedInKindBack_Input>;
  inKindDeposit?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_InKindDeposit_Input>;
  /** name of the policy */
  name?: InputMaybe<Scalars['String']>;
  /** Any description of the policy which can be exposed to the end user */
  publicDescription?: InputMaybe<Scalars['String']>;
  /** Request id. */
  requestId?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationAdminAreas?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  source?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** status of the policy */
  status?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userSegments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  valueGrantCode?: InputMaybe<Scalars['String']>;
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyStatus {
  ValueGrantPolicyStatusActive = 'VALUE_GRANT_POLICY_STATUS_ACTIVE',
  /** Budget-related pause (e.g., rate limit reached) */
  ValueGrantPolicyStatusBudgetPaused = 'VALUE_GRANT_POLICY_STATUS_BUDGET_PAUSED',
  ValueGrantPolicyStatusDiscarded = 'VALUE_GRANT_POLICY_STATUS_DISCARDED',
  ValueGrantPolicyStatusDraft = 'VALUE_GRANT_POLICY_STATUS_DRAFT',
  ValueGrantPolicyStatusInactive = 'VALUE_GRANT_POLICY_STATUS_INACTIVE',
  ValueGrantPolicyStatusUnspecified = 'VALUE_GRANT_POLICY_STATUS_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicyUpdateError';
  requestId?: Maybe<Scalars['String']>;
  retriable?: Maybe<Scalars['Boolean']>;
  updateError?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError_UpdateError>;
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyUpdateError_UpdateError {
  /** end_at is invalid */
  UpdateErrorInvalidEndDate = 'UPDATE_ERROR_INVALID_END_DATE',
  /** update payload invalid */
  UpdateErrorInvalidPayload = 'UPDATE_ERROR_INVALID_PAYLOAD',
  /** indicates that moving to the new status is not allowed */
  UpdateErrorInvalidStatusTransition = 'UPDATE_ERROR_INVALID_STATUS_TRANSITION',
  UpdateErrorUnspecified = 'UPDATE_ERROR_UNSPECIFIED',
  /** indicates the current status does not allow edits */
  UpdateErrorUnsupportedStatusForUpdates = 'UPDATE_ERROR_UNSUPPORTED_STATUS_FOR_UPDATES',
  /** vgp needs to be published first */
  UpdateErrorVgpNotPublished = 'UPDATE_ERROR_VGP_NOT_PUBLISHED'
}

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail';
  couponRedemptionPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredCouponGrantTemplate>;
  onOrderPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy>;
  storedValueDepositPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_StoredValueGrantTemplate>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy';
  abstractOffer?: Maybe<Scalars['Boolean']>;
  couponCode?: Maybe<Scalars['String']>;
  groupingKey?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGroupingKey>;
  onOrderGrantType?: Maybe<Instacart_Customers_Commerce_Discount_V1_OnOrderGrantType>;
  onOrderPolicyApplicationType?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyApplicationType>;
  onOrderPolicyConditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyCondition>>>;
  onOrderPolicyGrants?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant>>>;
  onOrderPolicyMetadata?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyMetadata>;
  onOrderPolicyStackability?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyStackability>;
  policyPriorityValue?: Maybe<Scalars['BigInt']>;
  redemptionLimits?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyRedemptionLimits>;
  storeAvailability?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyStoreAvailability>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyApplicationType {
  OnOrderPolicyApplicationTypeBasketLevel = 'ON_ORDER_POLICY_APPLICATION_TYPE_BASKET_LEVEL',
  OnOrderPolicyApplicationTypeFeeLevel = 'ON_ORDER_POLICY_APPLICATION_TYPE_FEE_LEVEL',
  OnOrderPolicyApplicationTypeItemLevel = 'ON_ORDER_POLICY_APPLICATION_TYPE_ITEM_LEVEL',
  OnOrderPolicyApplicationTypeUnspecified = 'ON_ORDER_POLICY_APPLICATION_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyCondition = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyCondition';
  allowPartialApplication?: Maybe<Scalars['Boolean']>;
  conditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_Condition>>>;
  exclusionCriteria?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_ExclusionCriteria>>>;
  groupCriteria?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_GroupCriteria>>>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant';
  creditBackGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_CreditBackGrant>;
  discountGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_DiscountGrant>;
  inKindBackGrant?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_InKindBackGrant>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_CreditBackGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_CreditBackGrant';
  creditBackGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_CreditBackGrantCalculator>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_DiscountGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_DiscountGrant';
  discountGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_DiscountGrantCalculator>;
  rewardGroup?: Maybe<Instacart_Customers_Commerce_Discount_V1_RewardGroup>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_InKindBackGrant = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGrant_InKindBackGrant';
  inKindBackGrantCalculator?: Maybe<Instacart_Customers_Commerce_Discount_V1_InKindBackGrantCalculator>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyGroupingKey {
  OnOrderPolicyGroupingKeyOfferExternalReference = 'ON_ORDER_POLICY_GROUPING_KEY_OFFER_EXTERNAL_REFERENCE',
  OnOrderPolicyGroupingKeyOfferId = 'ON_ORDER_POLICY_GROUPING_KEY_OFFER_ID',
  OnOrderPolicyGroupingKeyUnspecified = 'ON_ORDER_POLICY_GROUPING_KEY_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyMetadata = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyMetadata';
  additionalMetadata?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Discount_V1_AdditionalMetadata>>>;
  /** instructs the calling API to use compatibility mode. */
  compatibilityMode?: Maybe<Instacart_Customers_Commerce_Discount_V1_CompatibilityMode>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  termsConditions?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyRedemptionLimits = {
  __typename?: 'instacart_customers_commerce_discount_v1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyRedemptionLimits';
  applicationLimitPerUser?: Maybe<Scalars['BigInt']>;
  recurringBenefitLimitPerUser?: Maybe<Instacart_Customers_Commerce_Discount_V1_RecurringBenefit>;
  redemptionLimit?: Maybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: Maybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyStackability {
  /** Indicates the policy bypasses all stackability rules and always allowed to apply irrespective of other competing policies */
  OnOrderPolicyAlwaysStackable = 'ON_ORDER_POLICY_ALWAYS_STACKABLE',
  /** Indicates the policy is not stackable with other stackable and non-stackable policies */
  OnOrderPolicyNonStackable = 'ON_ORDER_POLICY_NON_STACKABLE',
  OnOrderPolicyStackabilityUnspecified = 'ON_ORDER_POLICY_STACKABILITY_UNSPECIFIED',
  /** Indicates the offer is stackable with any policy */
  OnOrderPolicyStackable = 'ON_ORDER_POLICY_STACKABLE'
}

export enum Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicy_ValueGrantPolicyDetail_OnOrderPolicy_OnOrderPolicyStoreAvailability {
  OnOrderPolicyStoreAvailabilityInStoreOnly = 'ON_ORDER_POLICY_STORE_AVAILABILITY_IN_STORE_ONLY',
  OnOrderPolicyStoreAvailabilityOnlineOnly = 'ON_ORDER_POLICY_STORE_AVAILABILITY_ONLINE_ONLY',
  OnOrderPolicyStoreAvailabilityUnspecified = 'ON_ORDER_POLICY_STORE_AVAILABILITY_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_ValueIssuingAuthority {
  ValueIssuingAuthorityBenefitProgram = 'VALUE_ISSUING_AUTHORITY_BENEFIT_PROGRAM',
  ValueIssuingAuthorityCaper = 'VALUE_ISSUING_AUTHORITY_CAPER',
  ValueIssuingAuthorityChaseCobrandPwp = 'VALUE_ISSUING_AUTHORITY_CHASE_COBRAND_PWP',
  ValueIssuingAuthorityChaseCobrandSignupService = 'VALUE_ISSUING_AUTHORITY_CHASE_COBRAND_SIGNUP_SERVICE',
  ValueIssuingAuthorityCpg = 'VALUE_ISSUING_AUTHORITY_CPG',
  ValueIssuingAuthorityCx = 'VALUE_ISSUING_AUTHORITY_CX',
  ValueIssuingAuthorityDirectedSpend = 'VALUE_ISSUING_AUTHORITY_DIRECTED_SPEND',
  ValueIssuingAuthorityGiftCard = 'VALUE_ISSUING_AUTHORITY_GIFT_CARD',
  ValueIssuingAuthorityIcPlus = 'VALUE_ISSUING_AUTHORITY_IC_PLUS',
  ValueIssuingAuthorityInstacartEmployeeBenefit = 'VALUE_ISSUING_AUTHORITY_INSTACART_EMPLOYEE_BENEFIT',
  /** Authority will not be applicable for Policies that don't have any value part. */
  ValueIssuingAuthorityNotApplicable = 'VALUE_ISSUING_AUTHORITY_NOT_APPLICABLE',
  ValueIssuingAuthorityRetailer = 'VALUE_ISSUING_AUTHORITY_RETAILER',
  ValueIssuingAuthoritySuperSaver = 'VALUE_ISSUING_AUTHORITY_SUPER_SAVER',
  /** Keeping Authority name generic for 2 reason (1. Source field contain source of offer, 2. it helps to extend offer ingestion to new 3rd party without making code change here) */
  ValueIssuingAuthorityThirdPartyOffersIngestion = 'VALUE_ISSUING_AUTHORITY_THIRD_PARTY_OFFERS_INGESTION',
  ValueIssuingAuthorityTreatmentService = 'VALUE_ISSUING_AUTHORITY_TREATMENT_SERVICE',
  ValueIssuingAuthorityUnspecified = 'VALUE_ISSUING_AUTHORITY_UNSPECIFIED'
}

export enum Instacart_Customers_Commerce_Discount_V1_ValueIssuingFlow {
  ValueIssuingFlowAppeasements = 'VALUE_ISSUING_FLOW_APPEASEMENTS',
  ValueIssuingFlowCaperCredits = 'VALUE_ISSUING_FLOW_CAPER_CREDITS',
  ValueIssuingFlowCarebot = 'VALUE_ISSUING_FLOW_CAREBOT',
  ValueIssuingFlowCharm = 'VALUE_ISSUING_FLOW_CHARM',
  ValueIssuingFlowChaseCobrandPwp = 'VALUE_ISSUING_FLOW_CHASE_COBRAND_PWP',
  ValueIssuingFlowChaseCobrandSignup = 'VALUE_ISSUING_FLOW_CHASE_COBRAND_SIGNUP',
  ValueIssuingFlowCiao = 'VALUE_ISSUING_FLOW_CIAO',
  ValueIssuingFlowConversion = 'VALUE_ISSUING_FLOW_CONVERSION',
  ValueIssuingFlowCxContact = 'VALUE_ISSUING_FLOW_CX_CONTACT',
  ValueIssuingFlowDirectedSpendOnboarding = 'VALUE_ISSUING_FLOW_DIRECTED_SPEND_ONBOARDING',
  ValueIssuingFlowDirectedSpendTopUp = 'VALUE_ISSUING_FLOW_DIRECTED_SPEND_TOP_UP',
  ValueIssuingFlowEmployeeParentalBenefit = 'VALUE_ISSUING_FLOW_EMPLOYEE_PARENTAL_BENEFIT',
  ValueIssuingFlowGiftCardRedemption = 'VALUE_ISSUING_FLOW_GIFT_CARD_REDEMPTION',
  ValueIssuingFlowIcPlusPickup = 'VALUE_ISSUING_FLOW_IC_PLUS_PICKUP',
  ValueIssuingFlowManualRedemption = 'VALUE_ISSUING_FLOW_MANUAL_REDEMPTION',
  /** Flow name will not be applicable for Policies that don't have off order part. */
  ValueIssuingFlowNotApplicable = 'VALUE_ISSUING_FLOW_NOT_APPLICABLE',
  /** Growth system flow which is similar to CIAO, but use rule base system to make decision */
  ValueIssuingFlowOffline = 'VALUE_ISSUING_FLOW_OFFLINE',
  ValueIssuingFlowOrderCompletion = 'VALUE_ISSUING_FLOW_ORDER_COMPLETION',
  ValueIssuingFlowRetailerContact = 'VALUE_ISSUING_FLOW_RETAILER_CONTACT',
  ValueIssuingFlowRti = 'VALUE_ISSUING_FLOW_RTI',
  /** Order problem/appeasement resolution flows */
  ValueIssuingFlowSelfService = 'VALUE_ISSUING_FLOW_SELF_SERVICE',
  ValueIssuingFlowThirdPartyOffersIngestion = 'VALUE_ISSUING_FLOW_THIRD_PARTY_OFFERS_INGESTION',
  ValueIssuingFlowUnitedAccountLinking = 'VALUE_ISSUING_FLOW_UNITED_ACCOUNT_LINKING',
  ValueIssuingFlowUnspecified = 'VALUE_ISSUING_FLOW_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Garnish_V1_Assignment = {
  __typename?: 'instacart_customers_commerce_garnish_v1_Assignment';
  name?: Maybe<Instacart_Customers_Commerce_Garnish_V1_AssignmentType>;
  value?: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Garnish_V1_AssignmentType {
  /** Free form string representing where the string will be displayed, for example at checkout or homepage, etc. */
  AssignmentContext = 'ASSIGNMENT_CONTEXT',
  /** To override the string in a specific country */
  AssignmentCountry = 'ASSIGNMENT_COUNTRY',
  /** To override the string in a specific store config */
  AssignmentStoreConfiguration = 'ASSIGNMENT_STORE_CONFIGURATION',
  AssignmentUnknown = 'ASSIGNMENT_UNKNOWN'
}

export type Instacart_Customers_Commerce_Garnish_V1_Assignment_Input = {
  name?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_AssignmentType>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ContentAssignment = {
  __typename?: 'instacart_customers_commerce_garnish_v1_ContentAssignment';
  assignments?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_Assignment>>>;
  localizedContents?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_LocalizedContent>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ContentAssignment_Input = {
  assignments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Assignment_Input>>>;
  localizedContents?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_LocalizedContent_Input>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_CreateStringsRequest_Input = {
  contentAssignments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment_Input>>>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Creator_Input>;
  resource?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>;
};

export type Instacart_Customers_Commerce_Garnish_V1_CreateStringsResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_CreateStringsResponse';
  contentAssignments?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment>>>;
  resource?: Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>;
};

export enum Instacart_Customers_Commerce_Garnish_V1_CreatorType {
  CreatorTypeIpp = 'CREATOR_TYPE_IPP',
  CreatorTypeUnspecified = 'CREATOR_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Garnish_V1_Creator_Input = {
  creatorId?: InputMaybe<Scalars['BigInt']>;
  creatorType?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_CreatorType>;
};

export type Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesRequest_Input = {
  creator?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Creator_Input>;
  resources?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_DeleteResourcesResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_DeleteResourcesResponse';
  deletedCount?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_GetStringsRequest_Input = {
  resource?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>;
};

export type Instacart_Customers_Commerce_Garnish_V1_GetStringsResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_GetStringsResponse';
  contentAssignments?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment>>>;
  resource?: Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Filter_Input = {
  resourceIdentifier?: InputMaybe<Scalars['String']>;
  resourceName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Input = {
  filter?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ListResourcesRequest_Filter_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Commerce_Garnish_V1_ListResourcesResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_ListResourcesResponse';
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  resource?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>>>;
};

export type Instacart_Customers_Commerce_Garnish_V1_LocalizedContent = {
  __typename?: 'instacart_customers_commerce_garnish_v1_LocalizedContent';
  content?: Maybe<Scalars['String']>;
  locale?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_LocalizedContent_Input = {
  content?: InputMaybe<Scalars['String']>;
  locale?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_Resource = {
  __typename?: 'instacart_customers_commerce_garnish_v1_Resource';
  identifier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_Resource_Input = {
  identifier?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Garnish_V1_UpdateStringsRequest_Input = {
  contentAssignments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment_Input>>>;
  creator?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Creator_Input>;
  resource?: InputMaybe<Instacart_Customers_Commerce_Garnish_V1_Resource_Input>;
};

export type Instacart_Customers_Commerce_Garnish_V1_UpdateStringsResponse = {
  __typename?: 'instacart_customers_commerce_garnish_v1_UpdateStringsResponse';
  contentAssignments?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Garnish_V1_ContentAssignment>>>;
  resource?: Maybe<Instacart_Customers_Commerce_Garnish_V1_Resource>;
};

export type Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CreditsBalance = {
  __typename?: 'instacart_customers_commerce_stored_value_orchestrator_v1_CreditsBalance';
  amount?: Maybe<GoogleTypeMoney>;
  balanceAccountReference?: Maybe<Instacart_Customers_Value_Grant_V1_StoredValueAccountReference>;
  balanceAttributes?: Maybe<Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CreditsBalancesAttributes>;
  balanceType?: Maybe<Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CreditsBalanceType>;
};

export enum Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CreditsBalanceType {
  CreditsBalanceTypeCartCash = 'CREDITS_BALANCE_TYPE_CART_CASH',
  CreditsBalanceTypeFreshFunds = 'CREDITS_BALANCE_TYPE_FRESH_FUNDS',
  CreditsBalanceTypeGiftCards = 'CREDITS_BALANCE_TYPE_GIFT_CARDS',
  CreditsBalanceTypeUnspecified = 'CREDITS_BALANCE_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CreditsBalancesAttributes = {
  __typename?: 'instacart_customers_commerce_stored_value_orchestrator_v1_CreditsBalancesAttributes';
  freshFundsProgramName?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_GetAvailableCreditsBalancesRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_GetAvailableCreditsBalancesResponse = {
  __typename?: 'instacart_customers_commerce_stored_value_orchestrator_v1_GetAvailableCreditsBalancesResponse';
  creditsBalances?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Stored_Value_Orchestrator_V1_CreditsBalance>>>;
  totalBalance?: Maybe<GoogleTypeMoney>;
};

/**
 * Customer's per-delivery bag preference. DEFAULT means the customer
 * explicitly chose the retailer's default bagging; UNSPECIFIED means no
 * value was supplied (legacy / pre-feature) and consumers should fall back
 * to default behavior.
 */
export enum Instacart_Customers_Commerce_Types_V1_BaggingOption {
  BaggingOptionBagless = 'BAGGING_OPTION_BAGLESS',
  BaggingOptionDefault = 'BAGGING_OPTION_DEFAULT',
  BaggingOptionUnspecified = 'BAGGING_OPTION_UNSPECIFIED'
}

/** Represent basket item restrictions */
export type Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketItemRestrictions';
  attributes?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions_ItemRestrictionType>>>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions_ItemRestrictionType {
  Alcohol = 'ALCOHOL',
  ItemRestrictionTypeUnspecified = 'ITEM_RESTRICTION_TYPE_UNSPECIFIED',
  OverTheCounter = 'OVER_THE_COUNTER',
  SprayPaint = 'SPRAY_PAINT'
}

/**
 * BasketProduct representation.
 * NOTE: Currently basket_product.rb is not auto generated by this proto.
 * Fields defined in basket_product.rb that are not included here: [legacy_attributes, _legacy_basket_product]
 * Next ID: 109
 */
export type Instacart_Customers_Commerce_Types_V1_BasketProduct = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct';
  alcoholByVolume?: Maybe<Instacart_Types_V1_BigDecimal>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  artificiallyCarbonated?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['BigInt']>;
  brandName?: Maybe<Scalars['String']>;
  calories?: Maybe<Instacart_Types_V1_BigDecimal>;
  catalog?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_Catalog>;
  catalogEntityId?: Maybe<Scalars['BigInt']>;
  claimMedicinal?: Maybe<Scalars['Boolean']>;
  coldPrepared?: Maybe<Scalars['Boolean']>;
  comboPromotions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion>>>;
  /** commerce classfication */
  commerceClassification?: Maybe<Instacart_Customers_Commerce_Types_V1_CommerceClassification>;
  configurableProducts?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts>;
  configured?: Maybe<Scalars['Boolean']>;
  containerType?: Maybe<Scalars['String']>;
  containsFlour?: Maybe<Scalars['Boolean']>;
  costPricePerUnit?: Maybe<GoogleTypeMoney>;
  costUnit?: Maybe<Instacart_Types_V1_MeasurementUnit>;
  countryId?: Maybe<Scalars['BigInt']>;
  custom?: Maybe<Scalars['Boolean']>;
  customerSpecialRequest?: Maybe<Scalars['Boolean']>;
  departmentName?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  disallowedServiceTypes?: Maybe<Array<Maybe<Instacart_Customers_Shared_V1_ServiceType>>>;
  /**
   * Contains private data for discount services.
   * Message structure is defined in ::Orchestrators::Types::Commerce::Private::DiscountData
   */
  discountData?: Maybe<Scalars['String']>;
  displayScreenSize?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_DisplayScreenSize>;
  displaySize?: Maybe<Scalars['String']>;
  excludeMarkup?: Maybe<Scalars['Boolean']>;
  /** External retailer specific metadata is not intended for internal system consumption. */
  externalRetailerSpecificMetadata?: Maybe<Scalars['String']>;
  /** 0..100, eg. "12.30", nil means we don't know what fruit_juice_percent is */
  fruitJuicePercent?: Maybe<Instacart_Types_V1_BigDecimal>;
  fulfillExtraLongDistanceDelivery?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  isCatering?: Maybe<Scalars['Boolean']>;
  isHot?: Maybe<Scalars['Boolean']>;
  /** Create first class variables for basket_product */
  isMedicated?: Maybe<Scalars['Boolean']>;
  /** DEPRECATED use retailer_department_id */
  itemDepartmentId?: Maybe<Scalars['String']>;
  itemRestrictions?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketItemRestrictions>;
  /** Contains private data for items pricing services. */
  itemsPricingData?: Maybe<Scalars['String']>;
  /** 0..100 */
  juicePercent?: Maybe<Instacart_Types_V1_BigDecimal>;
  l1CategoryName?: Maybe<Scalars['String']>;
  l1TaxonomyNodeId?: Maybe<Scalars['BigInt']>;
  l2CategoryName?: Maybe<Scalars['String']>;
  l2TaxonomyNodeId?: Maybe<Scalars['BigInt']>;
  l3CategoryName?: Maybe<Scalars['String']>;
  l3TaxonomyNodeId?: Maybe<Scalars['BigInt']>;
  l4CategoryName?: Maybe<Scalars['String']>;
  l4TaxonomyNodeId?: Maybe<Scalars['BigInt']>;
  l5CategoryName?: Maybe<Scalars['String']>;
  l5TaxonomyNodeId?: Maybe<Scalars['BigInt']>;
  l6CategoryName?: Maybe<Scalars['String']>;
  l6TaxonomyNodeId?: Maybe<Scalars['BigInt']>;
  legacyFrozenItem?: Maybe<Scalars['Boolean']>;
  legacyItemId?: Maybe<Scalars['BigInt']>;
  legacyV3Id?: Maybe<Scalars['String']>;
  legacyV3IdInt?: Maybe<Scalars['BigInt']>;
  loyaltyAttributes?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_LoyaltyAttributes>;
  managedAttributeIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  name?: Maybe<Scalars['String']>;
  nonRegulatoryItemDeposit?: Maybe<GoogleTypeMoney>;
  normalizedDimensions?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_NormalizedDimensions>;
  normalizedWeightG?: Maybe<Instacart_Types_V1_BigDecimal>;
  orderLeadTime?: Maybe<Scalars['BigInt']>;
  parWeight?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  priceComparisonSize?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_LabeledQuantity>;
  priceMultiple?: Maybe<Instacart_Types_V1_BigDecimal>;
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productId?: Maybe<Scalars['BigInt']>;
  productLocale?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  /**
   * Indicates whether the item can be purchased based on catalog signals. Nullable when truly unknown,
   * but generally expected to be set by PRS. Depending on the use-case, callers can reasonably default nil to true.
   */
  purchasable?: Maybe<Scalars['Boolean']>;
  quantityAttributes?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes>;
  reference?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference>;
  regionId?: Maybe<Scalars['BigInt']>;
  requiresKeepFrozen?: Maybe<Scalars['Boolean']>;
  requiresRefrigeration?: Maybe<Scalars['Boolean']>;
  restrictedOtc?: Maybe<Scalars['Boolean']>;
  restrictedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** retailer department. */
  retailerDepartment?: Maybe<Scalars['String']>;
  retailerDepartmentId?: Maybe<Scalars['String']>;
  /** Data about flyers the item is subscribed to */
  retailerFlyerData?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerFlyerDatum>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  retailerOmsEligible?: Maybe<Scalars['Boolean']>;
  /** retailer product collection ids */
  retailerProductCollectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Retailer provided value to allow special size attributes to be displayed on storefront, i.e. Spirit Halloween's Costume sizes. */
  retailerProductSizeLabel?: Maybe<Scalars['String']>;
  retailerPromotionDetails?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  rx?: Maybe<Scalars['Boolean']>;
  /** rx_type is used to determine if the item is a prescription item, eg. rx_human, rx_pet */
  rxType?: Maybe<Scalars['String']>;
  saleAttributes?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_SaleAttributes>;
  selectedConfigurations?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_SelectedConfiguration>>>;
  sheetCount?: Maybe<Instacart_Types_V1_BigDecimal>;
  sizeMeasurement?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /**
   * Contains the label for the unit of size measurement (size_uom) provided by the retailer.
   * NOTE: This label is only for rendering purpose and should be used as-is.
   * Do not parse this value. To get the normalized unit of measure, use size_measurement.
   */
  sizeUomLabel?: Maybe<Scalars['String']>;
  storeBrand?: Maybe<Scalars['Boolean']>;
  /** Only to be used for offline auditing */
  surfaceId?: Maybe<Scalars['BigInt']>;
  /** Create TaxableAttributes group on basket_product */
  taxableAttributes?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes>;
  tobacco?: Maybe<Scalars['Boolean']>;
  unattachedCoupon?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_UnattachedCoupon>;
  unitCount?: Maybe<Scalars['BigInt']>;
  usaSnapEligible?: Maybe<Scalars['Boolean']>;
  v4ItemId?: Maybe<Scalars['String']>;
  /** Retailer provided value to display special size attributes for a variant group. */
  variantGroupDisplaySizeLabel?: Maybe<Scalars['String']>;
  /** 0..100 */
  vegetableJuicePercent?: Maybe<Instacart_Types_V1_BigDecimal>;
  zoneIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** BasketProduceReference representation. */
export type Instacart_Customers_Commerce_Types_V1_BasketProductReference = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference';
  configuredItem?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem>;
  item?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item>;
  pricedItemSnapshot?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot>;
  rxItem?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem>;
  specialRequest?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_ConfiguredItem';
  id?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** BasketProduceReference representation. */
export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_Input = {
  configuredItem?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_ConfiguredItem_Input>;
  item?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item_Input>;
  pricedItemSnapshot?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot_Input>;
  rxItem?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem_Input>;
  specialRequest?: InputMaybe<Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest_Input>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_Item';
  productId?: Maybe<Scalars['BigInt']>;
  productLocale?: Maybe<Scalars['String']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_Item_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
  productLocale?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_PricedItemSnapshot';
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_PricedItemSnapshot_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_RxItem';
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_RxItem_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProductReference_SpecialRequest';
  id?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProductReference_SpecialRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketProduct_Catalog {
  CatalogUnspecified = 'CATALOG_UNSPECIFIED',
  Configured = 'CONFIGURED',
  Custom = 'CUSTOM',
  Product = 'PRODUCT',
  Rx = 'RX'
}

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ComboPromotion';
  comboGroupId?: Maybe<Scalars['String']>;
  discountBeginsAt?: Maybe<Scalars['DateTime']>;
  discountEndsAt?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Metadata>;
  name?: Maybe<Scalars['String']>;
  promotionGroupId?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Metadata = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ComboPromotion_Metadata';
  comboRequirements?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Requirement>>>;
  discountValue?: Maybe<GoogleTypeMoney>;
  fixedPriceValue?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ComboPromotion_Requirement = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ComboPromotion_Requirement';
  comboGroupId?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts';
  configId?: Maybe<Scalars['String']>;
  configType?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigType>;
  optionGroups?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionGroup>>>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigOptionItem = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts_ConfigOptionItem';
  configOptionItemId?: Maybe<Scalars['String']>;
  costPricePerUnit?: Maybe<GoogleTypeMoney>;
  enabled?: Maybe<Scalars['Boolean']>;
  overrides?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionOverride>>>;
  saleAttributes?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_SaleAttributes>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigType {
  Builder = 'BUILDER',
  ConfigTypeUnspecified = 'CONFIG_TYPE_UNSPECIFIED',
  Custom = 'CUSTOM',
  Pack = 'PACK',
  PrepStyle = 'PREP_STYLE',
  UnknownType = 'UNKNOWN_TYPE'
}

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionGroup = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts_OptionGroup';
  configOptionItems?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_ConfigOptionItem>>>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_ConfigurableProducts_OptionOverride = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_ConfigurableProducts_OptionOverride';
  configOptionItemId?: Maybe<Scalars['String']>;
  costPricePerUnit?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_DisplayScreenSize = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_DisplayScreenSize';
  /** e.g. "in", "inches", "ft", "yd", "m", "cm", "mm" etc. */
  uom?: Maybe<Scalars['String']>;
  /** e.g., 15.6 */
  value?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Represents a quantity with a display label for its unit.
 * This is useful when dealing with retailer-provided units that may not map
 * cleanly to standardized measurement units.
 */
export type Instacart_Customers_Commerce_Types_V1_BasketProduct_LabeledQuantity = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_LabeledQuantity';
  /**
   * The label for the unit of the quantity.
   * This label is only for rendering purpose and should be used as-is. Do not parse this value.
   */
  label?: Maybe<Scalars['String']>;
  /** The quantity in relevant units. */
  quantity?: Maybe<Instacart_Types_V1_BigDecimal>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_LoyaltyAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_LoyaltyAttributes';
  loyaltyCostPricePerUnit?: Maybe<GoogleTypeMoney>;
  loyaltyPriceEndAt?: Maybe<Scalars['DateTime']>;
  loyaltyPriceStartAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_NormalizedDimensions = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_NormalizedDimensions';
  normalizedHeightCm?: Maybe<Instacart_Types_V1_BigDecimal>;
  normalizedLengthCm?: Maybe<Instacart_Types_V1_BigDecimal>;
  normalizedWidthCm?: Maybe<Instacart_Types_V1_BigDecimal>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_QuantityAttributes';
  increment?: Maybe<Instacart_Types_V1_BigDecimal>;
  max?: Maybe<Instacart_Types_V1_BigDecimal>;
  min?: Maybe<Instacart_Types_V1_BigDecimal>;
  produceOrderUnit?: Maybe<Scalars['String']>;
  quantityType?: Maybe<Instacart_Customers_Shared_V1_QuantityType>;
  requestUnit?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes_RequestUnit>;
  variableWeight?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Commerce_Types_V1_BasketProduct_QuantityAttributes_RequestUnit {
  Each = 'EACH',
  Kg = 'KG',
  Lb = 'LB',
  Package = 'PACKAGE',
  RequestUnitUnspecified = 'REQUEST_UNIT_UNSPECIFIED'
}

/** Data about a flyer the item is subscribed to */
export type Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerFlyerDatum = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_RetailerFlyerDatum';
  endsAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  /** The type of flyer (e.g. weekly, monthly, biweekly, summer splash, etc.) */
  tag?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_RetailerPromotionDetails';
  discountBeginsAt?: Maybe<Scalars['DateTime']>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
  discountEndsAt?: Maybe<Scalars['DateTime']>;
  loyaltyMembersOnly?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails_Metadata>;
  name?: Maybe<Scalars['String']>;
  promotionGroupId?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_RetailerPromotionDetails_Metadata = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_RetailerPromotionDetails_Metadata';
  bundlePrice?: Maybe<GoogleTypeMoney>;
  buy?: Maybe<Scalars['BigInt']>;
  discountPercentages?: Maybe<Array<Maybe<Instacart_Types_V1_BigDecimal>>>;
  discountValue?: Maybe<GoogleTypeMoney>;
  get?: Maybe<Scalars['BigInt']>;
  limitPerOrder?: Maybe<Scalars['BigInt']>;
  maxQty?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  minQty?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** If true, all items need to be purchased and fulfilled for pomo discount. */
  qtyEnforced?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_SaleAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_SaleAttributes';
  saleCostPricePerUnit?: Maybe<GoogleTypeMoney>;
  saleEndAt?: Maybe<Scalars['DateTime']>;
  saleStartAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_SelectedConfiguration = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_SelectedConfiguration';
  /** Only set when config_type is PACK. */
  catalogItemId?: Maybe<Scalars['BigInt']>;
  configOptionId?: Maybe<Scalars['String']>;
  configOptionItemId?: Maybe<Scalars['String']>;
  configOptionItemName?: Maybe<Scalars['String']>;
  configOptionItemPrice?: Maybe<GoogleTypeMoney>;
  configOptionName?: Maybe<Scalars['String']>;
  /**
   * Identifier of the sub-option the user selected within this config option item,
   * when the item exposes sub-options. Nil when no sub-option is selected.
   */
  configOptionSelectionId?: Maybe<Scalars['String']>;
  /**
   * Display name of the selected sub-option, denormalized so readers can render
   * without re-resolving the catalog. Nil when no sub-option is selected.
   */
  configOptionSelectionName?: Maybe<Scalars['String']>;
  /** Deprecated: use quantity_each instead. */
  quantity?: Maybe<Scalars['BigInt']>;
  /** Number of units of the catalog item selected. */
  quantityEach?: Maybe<Scalars['BigInt']>;
  textValue?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes';
  retailerProvidedTaxes?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax>>>;
  /** 0..1 */
  retailerSalesTaxRate?: Maybe<Instacart_Types_V1_BigDecimal>;
  vertexAttributes?: Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_VertexAttributes>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes_RetailerProvidedTax';
  /** indicates if the tax is already included in the price */
  priceEmbedded?: Maybe<Scalars['Boolean']>;
  taxImpositions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax_RetailerProvidedTaxImposition>>>;
  taxName?: Maybe<Scalars['String']>;
  /** 0..1 */
  taxRate?: Maybe<Instacart_Types_V1_BigDecimal>;
  taxRateType?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_RetailerProvidedTax_RetailerProvidedTaxImposition = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes_RetailerProvidedTax_RetailerProvidedTaxImposition';
  imposition?: Maybe<Scalars['String']>;
  isMpf?: Maybe<Scalars['Boolean']>;
  isTaxable?: Maybe<Scalars['Boolean']>;
  /** 0..1 */
  taxRate?: Maybe<Instacart_Types_V1_BigDecimal>;
  taxRateType?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_TaxableAttributes_VertexAttributes = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_TaxableAttributes_VertexAttributes';
  vertexCategoryTdc?: Maybe<Scalars['String']>;
  vertexTaxOverrideAttribute?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_BasketProduct_UnattachedCoupon = {
  __typename?: 'instacart_customers_commerce_types_v1_BasketProduct_UnattachedCoupon';
  adminOnly?: Maybe<Scalars['Boolean']>;
  countryId?: Maybe<Scalars['BigInt']>;
  description?: Maybe<Scalars['String']>;
  discountBeginsAt?: Maybe<Scalars['DateTime']>;
  discountEndsAt?: Maybe<Scalars['DateTime']>;
  exclusive?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  itemsPerDeal?: Maybe<Scalars['BigInt']>;
  maxRedemptionsPerOrder?: Maybe<Scalars['BigInt']>;
  maxRedemptionsTotal?: Maybe<Scalars['BigInt']>;
  promotionGroupId?: Maybe<Scalars['String']>;
  publicDescription?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<Scalars['String']>>>;
  sponsorName?: Maybe<Scalars['String']>;
  subtractValueCents?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Commerce_Types_V1_CommerceClassification {
  Alcoholic = 'ALCOHOLIC',
  CommerceClassificationUnknown = 'COMMERCE_CLASSIFICATION_UNKNOWN',
  DiscretionaryTip = 'DISCRETIONARY_TIP',
  GeneralMerchandise = 'GENERAL_MERCHANDISE',
  Rx = 'RX',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP'
}

/** Enumerates the reasons a customer may choose to cancel an order. */
export enum Instacart_Customers_Commerce_Types_V1_CustomerCancelReason_CustomerReason {
  /** Customer wants to cancel the current order and place a new one. */
  CancelAndReorder = 'CANCEL_AND_REORDER',
  /** Want to modify the delivery time. */
  ChangeDeliveryTime = 'CHANGE_DELIVERY_TIME',
  /** Want to modify the pickup time. */
  ChangePickupTime = 'CHANGE_PICKUP_TIME',
  /** Customer reason isn't specified. */
  CustomerReasonUnspecified = 'CUSTOMER_REASON_UNSPECIFIED',
  /** Customer no longer needs the specific order. */
  DoNotNeedThisOrderAnymore = 'DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Inventory items were not available. */
  ItemsWereOutOfStock = 'ITEMS_WERE_OUT_OF_STOCK',
  /** The order is duplicated by the customer. */
  ICreatedADuplicateOrder = 'I_CREATED_A_DUPLICATE_ORDER',
  /** Customer no longer requires the order. */
  IDoNotNeedThisOrderAnymore = 'I_DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Customer wants to change the order. */
  IWantToChangeMyOrder = 'I_WANT_TO_CHANGE_MY_ORDER',
  /** Order scheduled for delivery too late. */
  LateOrder = 'LATE_ORDER',
  /** Customer needs to modify the items in the order. */
  NeedToAddOrRemoveItems = 'NEED_TO_ADD_OR_REMOVE_ITEMS',
  /** Customer needs to reschedule the order. */
  NeedToReschedule = 'NEED_TO_RESCHEDULE',
  /** Rescheduled delivery time didn't work. */
  NewTimeDidNotWorkDelivery = 'NEW_TIME_DID_NOT_WORK_DELIVERY',
  /** Rescheduled pickup time didn't work. */
  NewTimeDidNotWorkPickup = 'NEW_TIME_DID_NOT_WORK_PICKUP',
  /** Delivery is taking too long. */
  OrderTakingTooLong = 'ORDER_TAKING_TOO_LONG',
  /** Order time no longer works. */
  OrderTimeNoLongerWorks = 'ORDER_TIME_NO_LONGER_WORKS',
  /** Other unspecified reasons. */
  Other = 'OTHER',
  /** Redirection for unspecified reason. */
  OtherRedirect = 'OTHER_REDIRECT',
  /** Switch to delivery instead of pickup. */
  SwitchToDelivery = 'SWITCH_TO_DELIVERY',
  /** Switch to pickup instead of delivery. */
  SwitchToPickup = 'SWITCH_TO_PICKUP',
  /** General issue with the order. */
  ThereIsAProblemWithMyOrder = 'THERE_IS_A_PROBLEM_WITH_MY_ORDER',
  /** Order is pricier than expected. */
  TooExpensve = 'TOO_EXPENSVE',
  /** Too many replacements in the order. */
  TooManyReplacements = 'TOO_MANY_REPLACEMENTS',
  /** Embedded Instacart order associated trip was canceled. */
  TripCanceled = 'TRIP_CANCELED',
  /** Incorrect delivery address in a different city. */
  WrongAddressDifferentCity = 'WRONG_ADDRESS_DIFFERENT_CITY',
  /** Incorrect delivery address within the same city. */
  WrongAddressSameCity = 'WRONG_ADDRESS_SAME_CITY',
  /** Wrong delivery location specified in the order. */
  WrongDeliveryLocation = 'WRONG_DELIVERY_LOCATION',
  /** Wrong payment method. */
  WrongPaymentMethod = 'WRONG_PAYMENT_METHOD',
  /** Wrong payment details or tip adjustment. */
  WrongPaymentOrChangeTip = 'WRONG_PAYMENT_OR_CHANGE_TIP',
  /** Wrong location for order pickup. */
  WrongPickupLocation = 'WRONG_PICKUP_LOCATION',
  /** Incorrect store location was chosen. */
  WrongRetailerLocation = 'WRONG_RETAILER_LOCATION'
}

/** Funding source */
export enum Instacart_Customers_Commerce_Types_V1_FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Partner = 'PARTNER',
  Retailer = 'RETAILER'
}

/** Order Cancellation Category */
export enum Instacart_Customers_Commerce_Types_V1_OrderCancellationCategory {
  CustomerResponsible = 'CUSTOMER_RESPONSIBLE',
  InstacartPolicyEnforcement = 'INSTACART_POLICY_ENFORCEMENT',
  IntacartUnbatchable = 'INTACART_UNBATCHABLE',
  OrderCancellationCategoryUnspecified = 'ORDER_CANCELLATION_CATEGORY_UNSPECIFIED',
  OtherCancellationCategory = 'OTHER_CANCELLATION_CATEGORY',
  RetailerStoreIssue = 'RETAILER_STORE_ISSUE',
  ShopperRequested = 'SHOPPER_REQUESTED'
}

/** The specific reason why the order is canceled. */
export enum Instacart_Customers_Commerce_Types_V1_OrderCancellationType {
  /** Admin Refund. */
  AdminRefund = 'ADMIN_REFUND',
  /** Audit failure in bypass checkout. */
  AuditFailureInBypassCheckout = 'AUDIT_FAILURE_IN_BYPASS_CHECKOUT',
  /** Auto cancellation from order management workflow */
  AutoCompletionCancellation = 'AUTO_COMPLETION_CANCELLATION',
  /** Unrecoverable error during BJS bypass. */
  BjsBypassUnrecoverableError = 'BJS_BYPASS_UNRECOVERABLE_ERROR',
  /** Cancellation due to blocked completion. */
  BlockedCompletionCancellation = 'BLOCKED_COMPLETION_CANCELLATION',
  /** Order canceled by the customer. */
  CanceledByCustomer = 'CANCELED_BY_CUSTOMER',
  /** Order canceled by the retailer. */
  CancelledByRetailer = 'CANCELLED_BY_RETAILER',
  /** Order canceled via script. */
  CancelledViaScript = 'CANCELLED_VIA_SCRIPT',
  /** Card declined during reauthorization. */
  CardDeclineOnReauth = 'CARD_DECLINE_ON_REAUTH',
  /** Cancellation due to a car accident. */
  CarAccident = 'CAR_ACCIDENT',
  /** Cancellation due to car issues. */
  CarIssue = 'CAR_ISSUE',
  /** Payment method needed to be changed. */
  ChangePaymentMethod = 'CHANGE_PAYMENT_METHOD',
  /** Customer faced issues with app navigation. */
  CustomerAppNavigationIssue = 'CUSTOMER_APP_NAVIGATION_ISSUE',
  /** Customer MIA. */
  CustomerMia = 'CUSTOMER_MIA',
  /** Customer is missing in action during drop-off. */
  CustomerMiaOnDropOffOrder = 'CUSTOMER_MIA_ON_DROP_OFF_ORDER',
  /** Customer requested cancellation because the order is early. */
  CustomerRequestedSinceOrderIsEarly = 'CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested cancellation because the order is late. */
  CustomerRequestedSinceOrderIsLate = 'CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Customer requested to cancel the order. */
  CustomerRequestToCancel = 'CUSTOMER_REQUEST_TO_CANCEL',
  /** Order delivered outside the scheduled window. */
  DeliveredOutsideOfWindow = 'DELIVERED_OUTSIDE_OF_WINDOW',
  /**
   * Order canceled due to cancellation of a related dependent order.
   * E.g. in the case of a party order, if the host order is canceled we may cancel the member orders.
   */
  DependentOrderCanceled = 'DEPENDENT_ORDER_CANCELED',
  /** Dispatcher canceled the order because the customer was unavailable. */
  DispatcherCancelledCustomerUnavailable = 'DISPATCHER_CANCELLED_CUSTOMER_UNAVAILABLE',
  /** Dispatcher canceled the order due to route issues. */
  DispatcherCancelledRouteIssues = 'DISPATCHER_CANCELLED_ROUTE_ISSUES',
  /** Dispatcher canceled the order because the shift is ending. */
  DispatcherCancelledShiftEnding = 'DISPATCHER_CANCELLED_SHIFT_ENDING',
  /** Driver canceled the order because the customer was unavailable. */
  DriverCancelledCustomerUnavailable = 'DRIVER_CANCELLED_CUSTOMER_UNAVAILABLE',
  /** Driver canceled the order due to route issues. */
  DriverCancelledRouteIssues = 'DRIVER_CANCELLED_ROUTE_ISSUES',
  /** Driver canceled the order because the shift is ending. */
  DriverCancelledShiftEnding = 'DRIVER_CANCELLED_SHIFT_ENDING',
  /** Duplicate order. */
  DuplicateOrder = 'DUPLICATE_ORDER',
  /** Cancellation due to an emergency. */
  Emergency = 'EMERGENCY',
  /** Empty Delivery. */
  EmptyDelivery = 'EMPTY_DELIVERY',
  /** Cancellation due to failed completion. */
  FailedCompletionCancellation = 'FAILED_COMPLETION_CANCELLATION',
  /** Fraudulent Customer. */
  FraudulentCustomer = 'FRAUDULENT_CUSTOMER',
  /** Fulfillment initiated due to out-of-stock items. */
  FulfillmentInitiatedDueToOutOfStock = 'FULFILLMENT_INITIATED_DUE_TO_OUT_OF_STOCK',
  /** Open IC+ renewal order cancelled due to subscription cancellation. */
  IcPlusSubscriptionCancelled = 'IC_PLUS_SUBSCRIPTION_CANCELLED',
  /** Open IC+ renewal order cancelled due to subscription extension. */
  IcPlusSubscriptionExtended = 'IC_PLUS_SUBSCRIPTION_EXTENDED',
  /** Open IC+ renewal order cancelled due to subscription plan change. */
  IcPlusSubscriptionPlanChanged = 'IC_PLUS_SUBSCRIPTION_PLAN_CHANGED',
  /** Incorrect accessibility information. */
  IncorrectAccessibilityInformation = 'INCORRECT_ACCESSIBILITY_INFORMATION',
  /** Incorrect customer information. */
  IncorrectCustomerInformation = 'INCORRECT_CUSTOMER_INFORMATION',
  /** All items refunded in an Instacart Connect order. */
  InstacartConnectOrderWithAllItemsRefunded = 'INSTACART_CONNECT_ORDER_WITH_ALL_ITEMS_REFUNDED',
  /** Failed to get a suspended transaction for Kroger Connect. */
  KrogerConnectFailedToGetSuspendedTransaction = 'KROGER_CONNECT_FAILED_TO_GET_SUSPENDED_TRANSACTION',
  /** Manual fraud. */
  ManualFraud = 'MANUAL_FRAUD',
  /** Mass cancellation of orders. */
  MassCancellation = 'MASS_CANCELLATION',
  /** Missing charge log for delivery. */
  MissingChargeLogForDelivery = 'MISSING_CHARGE_LOG_FOR_DELIVERY',
  /** No cancellation reason specified. */
  None = 'NONE',
  /** Online Payment Failure. */
  OnlinePayFailure = 'ONLINE_PAY_FAILURE',
  /** Unspecified cancellation type. */
  OrderCancellationTypeUnspecified = 'ORDER_CANCELLATION_TYPE_UNSPECIFIED',
  /** Cancellation due to other unspecified reasons. */
  OtherCancellationType = 'OTHER_CANCELLATION_TYPE',
  /** Order is in pre-picking stage. */
  PrePicking = 'PRE_PICKING',
  /** Cancellation due to related accounts fraud abuse. */
  RelatedAccountsAbuse = 'RELATED_ACCOUNTS_ABUSE',
  /** Retailer initiated cancellation because the customer is MIA. */
  RetailerInitiatedCustomerMia = 'RETAILER_INITIATED_CUSTOMER_MIA',
  /** Retailer initiated cancellation due to out-of-stock items. */
  RetailerInitiatedOutOfStock = 'RETAILER_INITIATED_OUT_OF_STOCK',
  /** Cancellation due to safety concerns. */
  SafetyConcerns = 'SAFETY_CONCERNS',
  /** Cancellation due to a severe weather event. */
  SevereWeatherEvent = 'SEVERE_WEATHER_EVENT',
  /** Shopper couldn't locate the delivery address. */
  ShopperCouldNotFindAddress = 'SHOPPER_COULD_NOT_FIND_ADDRESS',
  /** Shopper initiated cancellation due to out-of-stock items. */
  ShopperInitiatedOutOfStock = 'SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Shopper is unable to complete the order. */
  ShopperUnableToCompleteOrder = 'SHOPPER_UNABLE_TO_COMPLETE_ORDER',
  /** Single item order is out of stock. */
  SingleItemOrderOutOfStock = 'SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Early closure of store. */
  StoreEarlyClosure = 'STORE_EARLY_CLOSURE',
  /** Store experiencing an outage. */
  StoreOutage = 'STORE_OUTAGE',
  /** Too many items are out of stock. */
  TooManyOutOfStockItem = 'TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements in the order. */
  TooManyReplacements = 'TOO_MANY_REPLACEMENTS',
  /** Cancellation due to traffic conditions. */
  TrafficConditions = 'TRAFFIC_CONDITIONS',
  /** Unable to reschedule the order as no options were available. */
  UnableToRescheduleAsNoOptionFound = 'UNABLE_TO_RESCHEDULE_AS_NO_OPTION_FOUND',
  /** Unable to reschedule due to unbatchable order. */
  UnableToRescheduleUnbatchable = 'UNABLE_TO_RESCHEDULE_UNBATCHABLE',
  /** Order is unbatchable. */
  Unbatchable = 'UNBATCHABLE',
  /** Order cancelled because virtual (e.g. IC+ subscription) fulfillment failed. */
  VirtualFulfillmentFailed = 'VIRTUAL_FULFILLMENT_FAILED',
  /** Incorrect store operating hours. */
  WrongStoreHours = 'WRONG_STORE_HOURS'
}

export type Instacart_Customers_Commerce_Types_V1_PaymentInstruction = {
  __typename?: 'instacart_customers_commerce_types_v1_PaymentInstruction';
  /** Additional payment method specific data */
  additionalData?: Maybe<Instacart_Customers_Commerce_Types_V1_PaymentInstruction_AdditionalData>;
  default?: Maybe<Scalars['Boolean']>;
  instrumentReference?: Maybe<Scalars['String']>;
  /** instrument type used to match the existing v3 payment instruction field. */
  legacyPaymentInstrumentType?: Maybe<Instacart_Customers_Commerce_Types_V1_PaymentInstruction_LegacyPaymentInstrumentType>;
  /**
   * TODO: we should deprecate this and move to AdditionalData
   * payment method token id
   */
  paymentMethodTokenReference?: Maybe<Scalars['String']>;
  userSpecifiedMaximumAmount?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Commerce_Types_V1_PaymentInstruction_AdditionalData = {
  __typename?: 'instacart_customers_commerce_types_v1_PaymentInstruction_AdditionalData';
  /**
   * Payment transaction log ID for the InitiatePayment call
   * (This must be left as nil if not applicable.)
   * Currently, this is only required for Paysecure when creating a payment.
   */
  ebtInitiatePaymentTransactionLogId?: Maybe<Scalars['BigInt']>;
  /**
   * External reference to a PaymentsOneTimeCredential record.
   * Present for Apple Pay CITs.
   */
  oneTimeCredentialReference?: Maybe<Scalars['String']>;
  /** Preferred card network for routing. */
  preferredNetwork?: Maybe<Instacart_Customers_Commerce_Types_V1_PaymentNetwork>;
};

export enum Instacart_Customers_Commerce_Types_V1_PaymentInstruction_LegacyPaymentInstrumentType {
  ApplePay = 'APPLE_PAY',
  CashApp = 'CASH_APP',
  ChasePwp = 'CHASE_PWP',
  CreditCard = 'CREDIT_CARD',
  DigitalWallet = 'DIGITAL_WALLET',
  DirectedSpend = 'DIRECTED_SPEND',
  Ebt = 'EBT',
  GooglePay = 'GOOGLE_PAY',
  /** deprecated use 14 */
  Hsa = 'HSA',
  HsaFsaCard = 'HSA_FSA_CARD',
  IcbBalance = 'ICB_BALANCE',
  KlarnaMultiUse = 'KLARNA_MULTI_USE',
  KlarnaSingleUse = 'KLARNA_SINGLE_USE',
  LegacyPaymentInstrumentTypeUnspecified = 'LEGACY_PAYMENT_INSTRUMENT_TYPE_UNSPECIFIED',
  LoyaltyWallet = 'LOYALTY_WALLET',
  Medicare = 'MEDICARE',
  Paypal = 'PAYPAL',
  PaypalSingleUse = 'PAYPAL_SINGLE_USE',
  RetailerGiftCard = 'RETAILER_GIFT_CARD',
  Venmo = 'VENMO'
}

/**
 * Shared enum representing payment networks.
 * Values align with the PGS Network enum in
 * instacart/customers/payment_gateway/v1/card_network_transaction_data.proto
 * and with Stripe's card network identifiers
 * (see https://stripe.com/docs/api/charges/object#charge_object-payment_method_details-card-network).
 */
export enum Instacart_Customers_Commerce_Types_V1_PaymentNetwork {
  PaymentNetworkAmex = 'PAYMENT_NETWORK_AMEX',
  PaymentNetworkCartesBancaires = 'PAYMENT_NETWORK_CARTES_BANCAIRES',
  PaymentNetworkDiners = 'PAYMENT_NETWORK_DINERS',
  PaymentNetworkDiscover = 'PAYMENT_NETWORK_DISCOVER',
  PaymentNetworkInterac = 'PAYMENT_NETWORK_INTERAC',
  PaymentNetworkJcb = 'PAYMENT_NETWORK_JCB',
  PaymentNetworkMastercard = 'PAYMENT_NETWORK_MASTERCARD',
  PaymentNetworkUnionpay = 'PAYMENT_NETWORK_UNIONPAY',
  PaymentNetworkUnspecified = 'PAYMENT_NETWORK_UNSPECIFIED',
  PaymentNetworkVisa = 'PAYMENT_NETWORK_VISA'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer';
  buyComboGetNUnitsWithXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetNUnitsWithXPercentOffScenario>;
  buyComboGetXAmountOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetXAmountOffScenario>;
  buyMAmountGetNQtyWithXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario>;
  buyMAmountGetXAmountOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario>;
  buyMAmountGetXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario>;
  buyMAmountGetXPercentPointsBackScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentPointsBackScenario>;
  buyMAmountGetXPointsBackScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPointsBackScenario>;
  buyMAmountOfAGetBForXAmountPerUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOfAGetBForXAmountScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario>;
  buyMAmountOfAGetXAmountOffOnBScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario>;
  buyMAmountOfAGetXPercentOffOnBScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario>;
  buyMGetXPointsBackPerUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackPerUnitScenario>;
  buyMGetXPointsBackScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackScenario>;
  buyMOfAGetBForXAmountPerUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario>;
  buyMOrMoreOfAGetBForXAmountPerUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOrMoreOfAGetBForXAmountPerUnitScenario>;
  buyMQtyForXAmountScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario>;
  buyMQtyGetNForFreeScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario>;
  buyMQtyGetNQtyForXAmountScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario>;
  buyMQtyGetNQtyWithXAmountOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario>;
  buyMQtyGetNQtyWithXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario>;
  buyMQtyGetXAmountOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario>;
  buyMQtyGetXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario>;
  buyMQtyOfAGetBForXAmountScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario>;
  buyMQtyOfAGetXAmountOffOnBScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario>;
  buyMQtyOfAGetXPercentOffOnBScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario>;
  buyMQtyOrMoreForXAmountEachScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario>;
  buyMQtyOrMoreGetXAmountOffEachScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario>;
  buyMQtyOrMoreGetXAmountOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario>;
  buyMQtyOrMoreGetXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario>;
  buyMRangeQtyGetXPercentOffTieredScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario>;
  buyMUnitsGetNUnitsForFreeScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario>;
  buyMUnitsGetXAmountOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario>;
  buyMUnitsGetXPercentOffScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario>;
  buyMUnitsOfAGetXPercentOffOnBScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario>;
  buyMWeightForXAmountPerWeightUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario>;
  buyMWeightGetXAmountOffPerWeightUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario>;
  conditionRewardString?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  discountCategoryId?: Maybe<Scalars['BigInt']>;
  discountToken?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  exclusiveSpendMAmountOrMoreGetNForXPerUnitScenario?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_ExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario>;
  fundingDetail?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail>;
  imageUrl?: Maybe<Scalars['String']>;
  isLoyaltyOffer?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata>;
  name?: Maybe<Scalars['String']>;
  offerConditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition>>>;
  offerExternalReference?: Maybe<Scalars['String']>;
  offerId?: Maybe<Scalars['String']>;
  offerLabelString?: Maybe<Scalars['String']>;
  offerRequestKey?: Maybe<Scalars['String']>;
  offerRewards?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward>>>;
  offerSource?: Maybe<Scalars['String']>;
  offerStackability?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferStackability>;
  offerType?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferType>;
  promoCode?: Maybe<Scalars['String']>;
  redemptionLimits?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits>;
  startsAt?: Maybe<Scalars['DateTime']>;
  terms?: Maybe<Scalars['String']>;
  uncategorizedScenario?: Maybe<Scalars['instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_AdditionalMetadata = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_AdditionalMetadata';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_AdditionalMetadata_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/**
 * Buy a combo of eligible products and get N items at X percent off.
 * e.g. "Buy item A, B and C, Get 2 of D at 20% off"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetNUnitsWithXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyComboGetNUnitsWithXPercentOffScenario';
  nQty?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy a combo of eligible products and get N items at X percent off.
 * e.g. "Buy item A, B and C, Get 2 of D at 20% off"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetNUnitsWithXPercentOffScenario_Input = {
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy a combo of eligible products and get X amount off.
 * e.g. "Buy item A, B and C, Get $5 off"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyComboGetXAmountOffScenario';
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy a combo of eligible products and get X amount off.
 * e.g. "Buy item A, B and C, Get $5 off"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetXAmountOffScenario_Input = {
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M amount of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M amount of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M amount of eligible products and get X amount off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetXAmountOffScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M amount of eligible products and get X amount off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M amount of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetXPercentOffScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M amount of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Spend M amount of eligible products and earn X points per dollar spent.
 * e.g. "Spend $50, Get 2 pts/$"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentPointsBackScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetXPercentPointsBackScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Spend M amount of eligible products and earn X points per dollar spent.
 * e.g. "Spend $50, Get 2 pts/$"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentPointsBackScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Spend M amount of eligible products and earn X points.
 * e.g. "Spend $50, Get 1000 pts"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPointsBackScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountGetXPointsBackScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  xValue?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Spend M amount of eligible products and earn X points.
 * e.g. "Spend $50, Get 1000 pts"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPointsBackScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  xValue?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M amount of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M amount of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M amount or more of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M amount or more of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M amount or more of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M amount or more of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M measured units of eligible products and earn X points per unit.
 * e.g. "Buy 2 kg, Get 10 pts/kg"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMGetXPointsBackPerUnitScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xValue?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M measured units of eligible products and earn X points per unit.
 * e.g. "Buy 2 kg, Get 10 pts/kg"
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackPerUnitScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xValue?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M qty (or M measured units) of eligible products and earn X points.
 * m_qty for count-based (e.g. "Buy 2, Get 240 pts");
 * m_units for weight-based (e.g. "Buy 5 lbs, Get 300 pts").
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMGetXPointsBackScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xValue?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M qty (or M measured units) of eligible products and earn X points.
 * m_qty for count-based (e.g. "Buy 2, Get 240 pts");
 * m_units for weight-based (e.g. "Buy 5 lbs, Get 300 pts").
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xValue?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M units of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M units of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M (or more) of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 * M (m_unit) is a GTE threshold on group A expressed as a MeasuredQuantity, so it can
 * be either qty ("buy 2 or more packages") or weight ("buy 2 lb or more"). N is an
 * optional reward quantity/weight limit on B (e.g., "limit 5lb"); unset means unlimited.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOrMoreOfAGetBForXAmountPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMOrMoreOfAGetBForXAmountPerUnitScenario';
  mUnit?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nQty?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M (or more) of A and get B for amount X per unit (set price per unit).
 * A and B could be different groups of product, collection or something else.
 * M (m_unit) is a GTE threshold on group A expressed as a MeasuredQuantity, so it can
 * be either qty ("buy 2 or more packages") or weight ("buy 2 lb or more"). N is an
 * optional reward quantity/weight limit on B (e.g., "limit 5lb"); unset means unlimited.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOrMoreOfAGetBForXAmountPerUnitScenario_Input = {
  mUnit?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyForXAmountScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get additional N qty for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyForFreeScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty of eligible products and get additional N qty for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M qty of eligible products and be eligible to buy N eligible products for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and be eligible to buy N eligible products for a total price of X. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get additional N qty with X amount off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get additional N qty with X amount off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty of eligible products and get additional N qty with X percent off. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M qty of eligible products and get X (monetary value) off the original price. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetXAmountOffScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get X (monetary value) off the original price. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyGetXPercentOffScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M qty of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M qty of A and get B for amount X (set price).
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M qty of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Buy M qty of A and get X amount off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * Buy M qty of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  nQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M qty of A and get X% off the price on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  nQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M qty or more qty of eligible products for X amount each (set price per item). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty or more qty of eligible products for X amount each (set price per item). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty or more, get X dollars off each */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty or more, get X dollars off each */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty or more qty of eligible products and get X amount off the total price (of M or more). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty or more qty of eligible products and get X amount off the total price (of M or more). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M qty or more qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario';
  mQty?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M qty or more qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario_Input = {
  mQty?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M range qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario';
  mQtyMax?: Maybe<Instacart_Types_V1_BigDecimal>;
  mQtyMin?: Maybe<Instacart_Types_V1_BigDecimal>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M range qty of eligible products and get X% off the price (of M). */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario_Input = {
  mQtyMax?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  mQtyMin?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * An offer in a group of BuyMRangeQtyGetXPercentOffScenario offers that forms a tiered reward, where a higher quantity M
 * matches a higher ranked tier with a different reward percentage.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario';
  currentTier?: Maybe<Scalars['BigInt']>;
  tiers?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario>>>;
};

/**
 * An offer in a group of BuyMRangeQtyGetXPercentOffScenario offers that forms a tiered reward, where a higher quantity M
 * matches a higher ranked tier with a different reward percentage.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario_Input = {
  currentTier?: InputMaybe<Scalars['BigInt']>;
  tiers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffScenario_Input>>>;
};

/** Buy M units of eligible products and get additional N units for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
};

/** Buy M units of eligible products and get additional N units for free. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
};

/** Buy M units of eligible products for X amount off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetXAmountOffScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M units of eligible products for X amount off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M units of eligible products for X percent off per measurement unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M units of eligible products for X percent off per measurement unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M units of eligible products for X percent off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsGetXPercentOffScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/** Buy M units of eligible products for X percent off in it's entirety. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/**
 * Buy M units of A and get X percent off on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario';
  mUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  nUnits?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xPercent?: Maybe<Instacart_Types_V1_BigDecimal>;
};

/**
 * Buy M units of A and get X percent off on B.
 * A and B could be different groups of product, collection or something else.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario_Input = {
  mUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  nUnits?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xPercent?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario';
  mWeight?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario_Input = {
  mWeight?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario';
  mWeight?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M weight of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario_Input = {
  mWeight?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

/** Buy M weight or more of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario';
  mWeight?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M weight or more of eligible products for X amount per weight unit. */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario_Input = {
  mWeight?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_CategoryMetadata';
  retailerDepartmentTaxonomyCategories?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory>>>;
  taxonomyCategory?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata_Input = {
  retailerDepartmentTaxonomyCategories?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory_Input>>>;
  taxonomyCategory?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory_Input>>>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_DiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  /** Used to provide X dollars off per unit e.g buy 5 or more apples, get $1 off each apple */
  AmountPerUnit = 'AMOUNT_PER_UNIT',
  /** Used to provide X amount off per unit weight e.g buy 2 lb of chicken salad, get $3 off price-per-pound */
  AmountPerUnitWeight = 'AMOUNT_PER_UNIT_WEIGHT',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  /** Parts per 100,000. Used to represent fractional percent values (up to 3 decimal places) as an integer. i.e, 1.234 percent is 1234 per cent mille */
  PercentMille = 'PERCENT_MILLE',
  /**
   * Similar to amount and set price per unit, used to provide X percent off per measurement unit e.g. buy 5 lbs or more of apples, get 10% off each lb
   * This is required for measurement units because calculation of certain aspects of the discount
   * like share of discount are different from regular quantity based offers
   */
  PercentMillePerUnit = 'PERCENT_MILLE_PER_UNIT',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
  /** Used to set the specific price per unit e.g. buy 3 bananas or more for $2 each */
  SetPricePerUnit = 'SET_PRICE_PER_UNIT',
  /** Used to set the specific price per unit weight e.g buy 2 lb of chicken salad for $3.99 / lb */
  SetPricePerUnitWeight = 'SET_PRICE_PER_UNIT_WEIGHT'
}

/**
 * Spend $M or more on the basket where an excluded set does not count toward the threshold,
 * and get up to N units for amount X per unit.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_ExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_ExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario';
  mAmount?: Maybe<GoogleTypeMoney>;
  nQty?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  xAmount?: Maybe<GoogleTypeMoney>;
};

/**
 * Spend $M or more on the basket where an excluded set does not count toward the threshold,
 * and get up to N units for amount X per unit.
 */
export type Instacart_Customers_Commerce_Types_V1_SlimOffer_ExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario_Input = {
  mAmount?: InputMaybe<GoogleTypeMoneyInput>;
  nQty?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  xAmount?: InputMaybe<GoogleTypeMoneyInput>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_FundingDetail';
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: Maybe<GoogleTypeMoney>;
  fundingProviderInfo?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail_Input = {
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: InputMaybe<GoogleTypeMoneyInput>;
  fundingProviderInfo?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation_Input>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_FundingProviderInformation';
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: Maybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: Maybe<Instacart_Customers_Commerce_Types_V1_FundingSource>;
  /** name of the funding source */
  sourceName?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingProviderInformation_Input = {
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: InputMaybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: InputMaybe<Instacart_Customers_Commerce_Types_V1_FundingSource>;
  /** name of the funding source */
  sourceName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_Input = {
  buyComboGetNUnitsWithXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetNUnitsWithXPercentOffScenario_Input>;
  buyComboGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyComboGetXAmountOffScenario_Input>;
  buyMAmountGetNQtyWithXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetNQtyWithXPercentOffScenario_Input>;
  buyMAmountGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXAmountOffScenario_Input>;
  buyMAmountGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentOffScenario_Input>;
  buyMAmountGetXPercentPointsBackScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPercentPointsBackScenario_Input>;
  buyMAmountGetXPointsBackScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountGetXPointsBackScenario_Input>;
  buyMAmountOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountPerUnitScenario_Input>;
  buyMAmountOfAGetBForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetBForXAmountScenario_Input>;
  buyMAmountOfAGetXAmountOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXAmountOffOnBScenario_Input>;
  buyMAmountOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOfAGetXPercentOffOnBScenario_Input>;
  buyMAmountOrMoreOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetBForXAmountPerUnitScenario_Input>;
  buyMAmountOrMoreOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMAmountOrMoreOfAGetXPercentOffOnBScenario_Input>;
  buyMGetXPointsBackPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackPerUnitScenario_Input>;
  buyMGetXPointsBackScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMGetXPointsBackScenario_Input>;
  buyMOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOfAGetBForXAmountPerUnitScenario_Input>;
  buyMOrMoreOfAGetBForXAmountPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMOrMoreOfAGetBForXAmountPerUnitScenario_Input>;
  buyMQtyForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyForXAmountScenario_Input>;
  buyMQtyGetNForFreeScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForFreeScenario_Input>;
  buyMQtyGetNQtyForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyForXAmountScenario_Input>;
  buyMQtyGetNQtyWithXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXAmountOffScenario_Input>;
  buyMQtyGetNQtyWithXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetNQtyWithXPercentOffScenario_Input>;
  buyMQtyGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXAmountOffScenario_Input>;
  buyMQtyGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyGetXPercentOffScenario_Input>;
  buyMQtyOfAGetBForXAmountScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetBForXAmountScenario_Input>;
  buyMQtyOfAGetXAmountOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXAmountOffOnBScenario_Input>;
  buyMQtyOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOfAGetXPercentOffOnBScenario_Input>;
  buyMQtyOrMoreForXAmountEachScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreForXAmountEachScenario_Input>;
  buyMQtyOrMoreGetXAmountOffEachScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffEachScenario_Input>;
  buyMQtyOrMoreGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXAmountOffScenario_Input>;
  buyMQtyOrMoreGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMQtyOrMoreGetXPercentOffScenario_Input>;
  buyMRangeQtyGetXPercentOffTieredScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMRangeQtyGetXPercentOffTieredScenario_Input>;
  buyMUnitsGetNUnitsForFreeScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetNUnitsForFreeScenario_Input>;
  buyMUnitsGetXAmountOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXAmountOffScenario_Input>;
  buyMUnitsGetXPercentOffPerMeasurementUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffPerMeasurementUnitScenario_Input>;
  buyMUnitsGetXPercentOffScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsGetXPercentOffScenario_Input>;
  buyMUnitsOfAGetXPercentOffOnBScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMUnitsOfAGetXPercentOffOnBScenario_Input>;
  buyMWeightForXAmountPerWeightUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightForXAmountPerWeightUnitScenario_Input>;
  buyMWeightGetXAmountOffPerWeightUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightGetXAmountOffPerWeightUnitScenario_Input>;
  buyMWeightOrMoreForXAmountPerWeightUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_BuyMWeightOrMoreForXAmountPerWeightUnitScenario_Input>;
  conditionRewardString?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  discountCategoryId?: InputMaybe<Scalars['BigInt']>;
  discountToken?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  exclusiveSpendMAmountOrMoreGetNForXPerUnitScenario?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_ExclusiveSpendMAmountOrMoreGetNForXPerUnitScenario_Input>;
  fundingDetail?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_FundingDetail_Input>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isLoyaltyOffer?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata_Input>;
  name?: InputMaybe<Scalars['String']>;
  offerConditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition_Input>>>;
  offerExternalReference?: InputMaybe<Scalars['String']>;
  offerId?: InputMaybe<Scalars['String']>;
  offerLabelString?: InputMaybe<Scalars['String']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  offerRewards?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward_Input>>>;
  offerSource?: InputMaybe<Scalars['String']>;
  offerStackability?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferStackability>;
  offerType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferType>;
  promoCode?: InputMaybe<Scalars['String']>;
  redemptionLimits?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits_Input>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  terms?: InputMaybe<Scalars['String']>;
  uncategorizedScenario?: InputMaybe<Scalars['instacart_customers_commerce_types_v1_SlimOffer_UncategorizedScenario_Input']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_LocaleCategories';
  category?: Maybe<Array<Maybe<Scalars['String']>>>;
  locale?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories_Input = {
  category?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locale?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_Metadata';
  additionalMetadata?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_AdditionalMetadata>>>;
  categoryMetadata?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata>;
  termsAndConditions?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_Metadata_Input = {
  additionalMetadata?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_AdditionalMetadata_Input>>>;
  categoryMetadata?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_CategoryMetadata_Input>;
  termsAndConditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions_Input>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_OfferCondition';
  allowPartialApplication?: Maybe<Scalars['Boolean']>;
  collectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  conditionProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  excludedCollectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  maximumQuantity?: Maybe<Scalars['BigInt']>;
  minimumQuantity?: Maybe<Scalars['BigInt']>;
  minimumSpend?: Maybe<GoogleTypeMoney>;
  offerConditionType?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferConditionType>;
  retailerDepartments?: Maybe<Array<Maybe<Scalars['String']>>>;
  serviceType?: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
  taxonomyNodeIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeRetailerDepartments = 'OFFER_CONDITION_TYPE_RETAILER_DEPARTMENTS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED',
  OfferConditionTypeWeightUnit = 'OFFER_CONDITION_TYPE_WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferCondition_Input = {
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  conditionProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  excludedCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  maximumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumQuantity?: InputMaybe<Scalars['BigInt']>;
  minimumSpend?: InputMaybe<GoogleTypeMoneyInput>;
  offerConditionType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferConditionType>;
  retailerDepartments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  taxonomyNodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_OfferRedemptionLimits';
  redemptionLimit?: Maybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: Maybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRedemptionLimits_Input = {
  redemptionLimit?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerOrder?: InputMaybe<Scalars['BigInt']>;
  redemptionLimitPerUser?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_OfferReward';
  amountDiscount?: Maybe<GoogleTypeMoney>;
  discountRewardType?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_DiscountRewardType>;
  includeConditionGroup?: Maybe<Scalars['Boolean']>;
  maximumDiscount?: Maybe<GoogleTypeMoney>;
  offerPrice?: Maybe<GoogleTypeMoney>;
  offerRewardType?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRewardType>;
  percentDiscount?: Maybe<Instacart_Types_V1_BigDecimal>;
  quantityLimit?: Maybe<Scalars['BigInt']>;
  rewardProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  serviceItemType?: Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_ServiceItemType>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeRetailerDepartments = 'OFFER_REWARD_TYPE_RETAILER_DEPARTMENTS',
  OfferRewardTypeServiceItem = 'OFFER_REWARD_TYPE_SERVICE_ITEM',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED',
  OfferRewardTypeWeightUnit = 'OFFER_REWARD_TYPE_WEIGHT_UNIT'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferReward_Input = {
  amountDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  discountRewardType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_DiscountRewardType>;
  includeConditionGroup?: InputMaybe<Scalars['Boolean']>;
  maximumDiscount?: InputMaybe<GoogleTypeMoneyInput>;
  offerPrice?: InputMaybe<GoogleTypeMoneyInput>;
  offerRewardType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferRewardType>;
  percentDiscount?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  quantityLimit?: InputMaybe<Scalars['BigInt']>;
  rewardProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  serviceItemType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_ServiceItemType>;
};

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferStackability {
  /** Indicates the offer bypasses all stackability rules and always allowed to apply irrespective of other competing offers */
  AlwaysStackable = 'ALWAYS_STACKABLE',
  /** Indicates the offer is not stackable with other stackable and non-stackable offers */
  NonStackable = 'NON_STACKABLE',
  OfferStackabilityUnspecified = 'OFFER_STACKABILITY_UNSPECIFIED',
  /** Indicates the offer is stackable with any offer */
  Stackable = 'STACKABLE'
}

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_OfferType {
  AutoApply = 'AUTO_APPLY',
  /** Auto apply credit back */
  AutoApplyCreditBack = 'AUTO_APPLY_CREDIT_BACK',
  /** Auto apply in-kind back */
  AutoApplyInKindBack = 'AUTO_APPLY_IN_KIND_BACK',
  CheckoutCodeBasedDiscount = 'CHECKOUT_CODE_BASED_DISCOUNT',
  Coupon = 'COUPON',
  /** Coupon based credit back */
  CouponBasedCreditBack = 'COUPON_BASED_CREDIT_BACK',
  /** Coupon based in-kind back */
  CouponBasedInKindBack = 'COUPON_BASED_IN_KIND_BACK',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED',
  /** Discount that requires loyalty point redemption */
  PointsBasedDiscount = 'POINTS_BASED_DISCOUNT',
  /** In-kind (non-monetary) value */
  ValueIssuedInKind = 'VALUE_ISSUED_IN_KIND'
}

export enum Instacart_Customers_Commerce_Types_V1_SlimOffer_ServiceItemType {
  DeliveryFee = 'DELIVERY_FEE',
  ServiceItemTypeUnspecified = 'SERVICE_ITEM_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_TaxonomyCategory';
  localeCategories?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories>>>;
  taxonomyLevel?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TaxonomyCategory_Input = {
  localeCategories?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_LocaleCategories_Input>>>;
  taxonomyLevel?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions = {
  __typename?: 'instacart_customers_commerce_types_v1_SlimOffer_TermsAndConditions';
  locale?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Commerce_Types_V1_SlimOffer_TermsAndConditions_Input = {
  locale?: InputMaybe<Scalars['String']>;
  text?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Commerce_Types_V1_SupportRescheduleDeliveryReason {
  /** Shopper was in a car accident. */
  SupportRescheduleDeliveryReasonCarAccident = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CAR_ACCIDENT',
  /** Car issue preventing order completion. */
  SupportRescheduleDeliveryReasonCarIssue = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CAR_ISSUE',
  /**
   * Customer reasons.
   * Customer is missing in action.
   */
  SupportRescheduleDeliveryReasonCustomerMia = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_MIA',
  /** Customer is missing for a drop-off order. */
  SupportRescheduleDeliveryReasonCustomerMiaDropOff = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_MIA_DROP_OFF',
  /** Customer requested reschedule. */
  SupportRescheduleDeliveryReasonCustomerRequested = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_REQUESTED',
  /** Customer requested since order is early. */
  SupportRescheduleDeliveryReasonCustomerRequestedSinceOrderIsEarly = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested since order is late. */
  SupportRescheduleDeliveryReasonCustomerRequestedSinceOrderIsLate = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Customer placed a duplicate order. */
  SupportRescheduleDeliveryReasonDuplicateOrder = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_DUPLICATE_ORDER',
  /** Personal emergency for the shopper. */
  SupportRescheduleDeliveryReasonEmergency = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_EMERGENCY',
  /** Incorrect accessibility information provided. */
  SupportRescheduleDeliveryReasonIncorrectAccessibilityInfo = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_INCORRECT_ACCESSIBILITY_INFO',
  /** Incorrect customer information was provided. */
  SupportRescheduleDeliveryReasonIncorrectCustomerInformation = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_INCORRECT_CUSTOMER_INFORMATION',
  /**
   * Retailer/store reasons.
   * Retailer initiated out of stock.
   */
  SupportRescheduleDeliveryReasonRetailerInitiatedOutOfStock = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_RETAILER_INITIATED_OUT_OF_STOCK',
  /** Safety concerns reported by the shopper. */
  SupportRescheduleDeliveryReasonSafetyConcerns = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_SAFETY_CONCERNS',
  /**
   * Shopper reasons.
   * Shopper initiated out of stock.
   */
  SupportRescheduleDeliveryReasonShopperInitiatedOutOfStock = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Shopper is unable to complete the order. */
  SupportRescheduleDeliveryReasonShopperUnableToComplete = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_SHOPPER_UNABLE_TO_COMPLETE',
  /** Single item in the order was out of stock. */
  SupportRescheduleDeliveryReasonSingleItemOrderOutOfStock = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Store early closure. */
  SupportRescheduleDeliveryReasonStoreEarlyClosure = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_STORE_EARLY_CLOSURE',
  /** Store outage. */
  SupportRescheduleDeliveryReasonStoreOutage = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_STORE_OUTAGE',
  /**
   * Inventory/stock reasons.
   * Too many items out of stock.
   */
  SupportRescheduleDeliveryReasonTooManyOutOfStockItem = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements. */
  SupportRescheduleDeliveryReasonTooManyReplacements = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_TOO_MANY_REPLACEMENTS',
  /** Traffic conditions preventing order completion. */
  SupportRescheduleDeliveryReasonTrafficConditions = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_TRAFFIC_CONDITIONS',
  /** Shopper unable to access the delivery location. */
  SupportRescheduleDeliveryReasonUnableToAccessLocation = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_UNABLE_TO_ACCESS_LOCATION',
  /**
   * Logistics/system reasons.
   * Order could not be batched.
   */
  SupportRescheduleDeliveryReasonUnbatchable = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_UNBATCHABLE',
  /** Unspecified. */
  SupportRescheduleDeliveryReasonUnspecified = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_UNSPECIFIED',
  /** Wrong store hours. */
  SupportRescheduleDeliveryReasonWrongStoreHours = 'SUPPORT_RESCHEDULE_DELIVERY_REASON_WRONG_STORE_HOURS'
}

/** ValueGrantGuaranteeBasis defines the basis for guaranteeing that a value-grant is honoured at checkout. */
export enum Instacart_Customers_Commerce_Types_V1_ValueGrantGuaranteeBasis {
  /**
   * Available Budget: value-grant is only guaranteed if budget is available.
   * Budget IS checked at order confirmation time.
   */
  ValueGrantGuaranteeBasisAvailableBudget = 'VALUE_GRANT_GUARANTEE_BASIS_AVAILABLE_BUDGET',
  /**
   * Engaged User Action: value-grant is only guaranteed if the user has meaningfully performed an action intending to receive the value-grant.
   * Budget is NOT checked (commitment was made).
   */
  ValueGrantGuaranteeBasisEngagedUserAction = 'VALUE_GRANT_GUARANTEE_BASIS_ENGAGED_USER_ACTION',
  /**
   * Unconditional: value-grant will always be honoured and used for evaluation at checkout.
   * Budget is NOT checked (always honoured).
   */
  ValueGrantGuaranteeBasisUnconditional = 'VALUE_GRANT_GUARANTEE_BASIS_UNCONDITIONAL',
  /** Default unspecified value. Treated as VALUE_GRANT_GUARANTEE_BASIS_UNCONDITIONAL for backward compatibility. */
  ValueGrantGuaranteeBasisUnspecified = 'VALUE_GRANT_GUARANTEE_BASIS_UNSPECIFIED'
}

export type Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Connect_Platform_V1_GenerateBatchRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  batchType?: InputMaybe<Scalars['String']>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  orders?: InputMaybe<Array<InputMaybe<Instacart_Customers_Connect_Platform_V1_Order_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_GenerateBatchResponse = {
  __typename?: 'instacart_customers_connect_platform_v1_GenerateBatchResponse';
  id?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_Order_Input = {
  checkoutRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  shoppedRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Connect_Platform_V1_ShopperOrderItemScan_Input = {
  scannedString?: InputMaybe<Scalars['String']>;
  scannedStringType?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  deliveredCount?: InputMaybe<Scalars['BigInt']>;
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  lineNum?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  rrc?: InputMaybe<Scalars['String']>;
  scans?: InputMaybe<Array<InputMaybe<Instacart_Customers_Connect_Platform_V1_ShopperOrderItemScan_Input>>>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  substituteId?: InputMaybe<Scalars['BigInt']>;
  upc?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Connect_Platform_V1_UpdateShopperOrderItemResponse = {
  __typename?: 'instacart_customers_connect_platform_v1_UpdateShopperOrderItemResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Content_Management_Admin_V1_CartState {
  CartStateUnspecified = 'CART_STATE_UNSPECIFIED',
  Empty = 'EMPTY',
  InProgress = 'IN_PROGRESS',
  Qualified = 'QUALIFIED'
}

export type Instacart_Customers_Content_Management_Admin_V1_SlotCreative = {
  __typename?: 'instacart_customers_content_management_admin_v1_SlotCreative';
  cartState?: Maybe<Instacart_Customers_Content_Management_Admin_V1_CartState>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creativeId?: Maybe<Scalars['BigInt']>;
  creativeRank?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['BigInt']>;
  treatmentOfferState?: Maybe<Instacart_Customers_Content_Management_Admin_V1_TreatmentOfferState>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Content_Management_Admin_V1_SlotCreative_Input = {
  cartState?: InputMaybe<Instacart_Customers_Content_Management_Admin_V1_CartState>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  creativeId?: InputMaybe<Scalars['BigInt']>;
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['BigInt']>;
  treatmentOfferState?: InputMaybe<Instacart_Customers_Content_Management_Admin_V1_TreatmentOfferState>;
  treatmentPolicyId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Content_Management_Admin_V1_TreatmentOfferState {
  Activated = 'ACTIVATED',
  Applied = 'APPLIED',
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  Redeemed = 'REDEEMED',
  TreatmentOfferStateUnspecified = 'TREATMENT_OFFER_STATE_UNSPECIFIED',
  Unredeemable = 'UNREDEEMABLE'
}

export type Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsRequest_Input = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CreateRetailerCampaignTreatmentParams_Input>>>;
};

export type Instacart_Customers_Coupons_V1_AddRetailerCampaignTreatmentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_AddRetailerCampaignTreatmentsResponse';
  treatments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
};

export enum Instacart_Customers_Coupons_V1_CampaignField {
  OfferData = 'OFFER_DATA',
  RetailerData = 'RETAILER_DATA'
}

export type Instacart_Customers_Coupons_V1_CampaignFilter = {
  __typename?: 'instacart_customers_coupons_v1_CampaignFilter';
  filterType?: Maybe<Instacart_Customers_Coupons_V1_FilterType>;
  filterValue?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignFilter_Input = {
  filterType?: InputMaybe<Instacart_Customers_Coupons_V1_FilterType>;
  filterValue?: InputMaybe<Scalars['String']>;
};

/** Wrapper for repeated CampaignFilter to distinguish nil from empty array. */
export type Instacart_Customers_Coupons_V1_CampaignFilters_Input = {
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
};

/**
 * Filter selector for `ListRetailerCampaignsRequest.FilterSet.incentive_filters`.
 * Classifies a campaign by whether it carries an offer (incentive).
 */
export enum Instacart_Customers_Coupons_V1_CampaignIncentiveFilter {
  /** Campaign has at least one offer attached (non-empty discount_policy_ids). */
  CampaignIncentiveFilterIncentive = 'CAMPAIGN_INCENTIVE_FILTER_INCENTIVE',
  /** Campaign has no offer attached (empty discount_policy_ids). */
  CampaignIncentiveFilterNonIncentive = 'CAMPAIGN_INCENTIVE_FILTER_NON_INCENTIVE',
  CampaignIncentiveFilterUnspecified = 'CAMPAIGN_INCENTIVE_FILTER_UNSPECIFIED'
}

export enum Instacart_Customers_Coupons_V1_CampaignObjective {
  Acquisition = 'ACQUISITION',
  Activation = 'ACTIVATION',
  Awareness = 'AWARENESS',
  Custom = 'CUSTOM',
  Invalid = 'INVALID',
  Loyalty = 'LOYALTY',
  Merchandising = 'MERCHANDISING',
  Moment = 'MOMENT',
  Occasion = 'OCCASION',
  Reactivation = 'REACTIVATION',
  Resurrection = 'RESURRECTION',
  Retention = 'RETENTION'
}

export type Instacart_Customers_Coupons_V1_CampaignPropertyFilterOrList_Input = {
  orList?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignPropertyFilter_Input>>>;
};

export type Instacart_Customers_Coupons_V1_CampaignPropertyFilter_Input = {
  /** key can be campaign core property or metadata, not support custom property for now */
  key?: InputMaybe<Scalars['String']>;
  /** value is the serialized value of String or Enum, can also be any which means match any property value */
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignPropertyOverride_Input = {
  /**
   * Which campaign property this override targets. Valid values are the
   * serialized names of CampaignsDomain::Api::Types::Properties::Key on the
   * Ruby side (e.g. "finance_typology", "campaign_rollup_l1", "cost_center").
   * Unknown values are rejected by the server.
   */
  key?: InputMaybe<Scalars['String']>;
  /** Value to set for the property. Empty string clears the property. */
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignReference = {
  __typename?: 'instacart_customers_coupons_v1_CampaignReference';
  /** Unique identifier for a direct link campaign. Format: "ts_<uuid>". */
  directLink?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignReference_Input = {
  /** Unique identifier for a direct link campaign. Format: "ts_<uuid>". */
  directLink?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
  utmContent?: InputMaybe<Scalars['String']>;
  utmId?: InputMaybe<Scalars['String']>;
  utmMedium?: InputMaybe<Scalars['String']>;
  utmSource?: InputMaybe<Scalars['String']>;
  utmTerm?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignRouletteFeature = {
  __typename?: 'instacart_customers_coupons_v1_CampaignRouletteFeature';
  featureName?: Maybe<Scalars['String']>;
  /**
   * Roulette feature UUID. This may be omitted by older campaign records that
   * only persisted the feature name and selected variant.
   */
  featureUuid?: Maybe<Scalars['String']>;
  featureVariant?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input = {
  featureName?: InputMaybe<Scalars['String']>;
  /**
   * Roulette feature UUID. This may be omitted by older campaign records that
   * only persisted the feature name and selected variant.
   */
  featureUuid?: InputMaybe<Scalars['String']>;
  featureVariant?: InputMaybe<Scalars['String']>;
};

/**
 * Lightweight campaign data populated by Campaign Service, replacing raw_treatments.
 * Contains only the fields needed for serving-path filtering and treatment resolution.
 */
export type Instacart_Customers_Coupons_V1_CampaignServiceData = {
  __typename?: 'instacart_customers_coupons_v1_CampaignServiceData';
  cancelledAt?: Maybe<Scalars['DateTime']>;
  slotIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentPolicyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_CampaignTreatmentTask = {
  __typename?: 'instacart_customers_coupons_v1_CampaignTreatmentTask';
  /** [key: value] pairs matching the fields from TreatmentTaskSchema */
  definitionParams?: Maybe<Scalars['JSON']>;
  /** string value from TreatmentTaskTemplate message */
  definitionType?: Maybe<Scalars['String']>;
  /** this value is used in CRM and in app to tell the user how to complete the task */
  taskDescription?: Maybe<Scalars['String']>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams = {
  __typename?: 'instacart_customers_coupons_v1_CampaignTreatmentTaskRequestParams';
  /**
   * [key: value] pairs matching the fields from TreatmentTaskSchema
   * this value is used in CRM and in app to tell the user how to complete the task
   */
  definitionParams?: Maybe<Scalars['JSON']>;
  /** string value from TreatmentTaskTemplate message */
  definitionType?: Maybe<Scalars['String']>;
  taskDescription?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams_Input = {
  /**
   * [key: value] pairs matching the fields from TreatmentTaskSchema
   * this value is used in CRM and in app to tell the user how to complete the task
   */
  definitionParams?: InputMaybe<Scalars['JSON']>;
  /** string value from TreatmentTaskTemplate message */
  definitionType?: InputMaybe<Scalars['String']>;
  taskDescription?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CancelMomentRequest_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_CancelMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_CancelMomentResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_CancelRetailerCampaignRequest_Input = {
  /** Input whether to disable treatment policy, discount policy and coupon code, by default it will be true to make artifacts sync */
  disableOffer?: InputMaybe<Scalars['Boolean']>;
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is use to do authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_CancelRetailerCampaignResponse = {
  __typename?: 'instacart_customers_coupons_v1_CancelRetailerCampaignResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_Collection = {
  __typename?: 'instacart_customers_coupons_v1_Collection';
  id?: Maybe<Scalars['BigInt']>;
  products?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Product>>>;
};

export type Instacart_Customers_Coupons_V1_CreateMomentRequest_Input = {
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  templateId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CreateMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_CreateMomentResponse';
  moment?: Maybe<Instacart_Customers_Coupons_V1_Moment>;
};

export type Instacart_Customers_Coupons_V1_CreateRetailerCampaignRequest_Input = {
  /** When true, allows treatment offers to be created with future VGP start dates */
  allowFutureVgpStartDate?: InputMaybe<Scalars['Boolean']>;
  automaticBudgetCappingEnrolled?: InputMaybe<Scalars['Boolean']>;
  /** When true, the campaign is enrolled in automatic budget pausing (budget preference created in Nexus) */
  automaticBudgetPausingEnrolled?: InputMaybe<Scalars['Boolean']>;
  /** When true, enables budget pacing for the campaign (budget validation is enforced) */
  budgetPacingEnabled?: InputMaybe<Scalars['Boolean']>;
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  /** Campaign type for categorizing campaigns (e.g. sfx_activation, sfx_stale_activation, sfx_deep_churn) */
  campaignType?: InputMaybe<Scalars['String']>;
  /** This is a country_id that is a number, not to be confused with country code. */
  countryId?: InputMaybe<Scalars['String']>;
  countryIdValue?: InputMaybe<Scalars['BigInt']>;
  /** coupon_count, number of coupons to be created when redeeming the campaign */
  couponCount?: InputMaybe<Scalars['BigInt']>;
  creatorIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** Email of the person who created this campaign. */
  creatorUserEmail?: InputMaybe<Scalars['String']>;
  /**
   * Generic id of the person who created this campaign, resolved against
   * create_source to determine which system it belongs to.
   */
  creatorUserId?: InputMaybe<Scalars['BigInt']>;
  crmsIntentionConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional array of custom key-value properties */
  customProperties?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CustomProperty_Input>>>;
  discountPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /**
   * When true, an online (BROWSE) campaign is also eligible for direct-link
   * redemption in addition to its standard online serve.
   */
  enableDirectLinkForOnlineCampaign?: InputMaybe<Scalars['Boolean']>;
  /** Flag to indicate the campaign is enabled for offline serve */
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  /** When true, enables online CRM notifications for this campaign */
  enableOnlineCampaignCrm?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Exclusivity groups for the campaign */
  exclusivityGroups?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /** Flag to indicate the campaign is for internal testing only */
  forInternalTestingOnly?: InputMaybe<Scalars['Boolean']>;
  /** Indicates the campaign assignment is guaranteed (unconditional assignment) */
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  ippUserCanonicalUuid?: InputMaybe<Scalars['String']>;
  /** Deprecated: Use targeting_rules.lookback_window_days instead. */
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  marketingMessagingDetails?: InputMaybe<Instacart_Customers_Coupons_V1_MarketingMessagingDetails_Input>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Input>>>;
  /**
   * Estimated addressable audience snapshotted at creation time for CRM
   * campaigns (email/push). Used for capacity planning.
   */
  offlineCampaignEstimatedSizeWhenCreation?: InputMaybe<Scalars['BigInt']>;
  /** @deprecated use treatments instead */
  placements?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Placement_Input>>>;
  redemptionMethod?: InputMaybe<Instacart_Customers_Coupons_V1_RedemptionMethod>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** When true, allows treatment offers to be reissued after order delivery reconciliation */
  reissuable?: InputMaybe<Scalars['Boolean']>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardPolicy_Input>;
  retailerAgnostic?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  rouletteFeature?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  /** indicate whether the treatment policy should be created separately for each offer */
  separateTreatmentPolicies?: InputMaybe<Scalars['Boolean']>;
  skipCreateCouponCode?: InputMaybe<Scalars['Boolean']>;
  /** @deprecated use treatments instead */
  slotCreatives?: InputMaybe<Array<InputMaybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative_Input>>>;
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  /** @deprecated: Use store_configuration_ids instead */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of store_configuration_id */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Deprecated: Use targeting_rules instead. */
  targeting?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_TargetingRules_Input>>>;
  templateId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  treatmentTask?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams_Input>;
  treatments?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input>;
  /** @deprecated: Use offer_duration_in_days instead */
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_CreateRetailerCampaignTreatmentParams_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails_Input>>>;
  treatmentType?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType>;
};

export type Instacart_Customers_Coupons_V1_CustomProperty = {
  __typename?: 'instacart_customers_coupons_v1_CustomProperty';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_CustomProperty_Input = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Coupons_V1_Discoverability {
  /** ADMIN_ONLY means the campaign should not be discoverable on IC. It's only for IPP usage by internal users */
  AdminOnly = 'ADMIN_ONLY',
  /** AUTO_APPLY means the campaign's discount is applied automatically at checkout (redemption method AUTO_APPLY) rather than requiring the customer to clip or redeem it. */
  AutoApply = 'AUTO_APPLY',
  /** BROWSE means the campaign will be discoverable when user browse the app or web, it's the current behavior of RFM campaigns. */
  Browse = 'BROWSE',
  /** COUPON_CODE means the campaign will be discoverable only by a coupon code */
  CouponCode = 'COUPON_CODE',
  /** CRM means the campaign will be discoverable only by a CRM (eg. Braze) email send. */
  Crm = 'CRM',
  /** DIRECT_LINK means the campaign will be discoverable only when user click on a link, or scan a QR code. */
  DirectLink = 'DIRECT_LINK',
  DiscoverabilityUnknown = 'DISCOVERABILITY_UNKNOWN',
  /** EVENT_BASED_CRM means the campaign will be discoverable by a CRM (eg. Braze) email send triggered by activity events. */
  EventBasedCrm = 'EVENT_BASED_CRM',
  /** Offline: Campaign is assigned via an offline non ML flow (S3 CSV, SQL, etc.) */
  Offline = 'OFFLINE',
  /** Offline_ml: Campaign is evaluated and assigned via ML flow (Ciao, Charm, etc.) */
  OfflineMl = 'OFFLINE_ML',
  /** ONLINE_EVENT means the campaign will be discoverable when specific events occur (e.g. OrderDeliveryPlacedEvent). */
  OnlineEvent = 'ONLINE_EVENT',
  /** PARTNER_INITIATED means the campaign should only be assigned by a 3rd party partner (e.g. Airbnb). */
  PartnerInitiated = 'PARTNER_INITIATED',
  /**
   * TS_DIRECT_LINK means the campaign will be discoverable only when user click on a link, or scan a QR code.
   * and the redemption / lifecycle will be handled by Treatment Serving
   */
  TsDirectLink = 'TS_DIRECT_LINK'
}

export enum Instacart_Customers_Coupons_V1_FilterType {
  FilterTypeAdminOnly = 'FILTER_TYPE_ADMIN_ONLY',
  FilterTypeCollectionId = 'FILTER_TYPE_COLLECTION_ID',
  FilterTypeCollectionSlug = 'FILTER_TYPE_COLLECTION_SLUG',
  FilterTypeCreatedBy = 'FILTER_TYPE_CREATED_BY',
  FilterTypeMoment = 'FILTER_TYPE_MOMENT',
  FilterTypeMomentApproved = 'FILTER_TYPE_MOMENT_APPROVED',
  FilterTypeMomentRejected = 'FILTER_TYPE_MOMENT_REJECTED',
  FilterTypeMomentSubmitted = 'FILTER_TYPE_MOMENT_SUBMITTED',
  FilterTypeOccasion = 'FILTER_TYPE_OCCASION',
  FilterTypeOccasionApproved = 'FILTER_TYPE_OCCASION_APPROVED',
  FilterTypeOccasionRejected = 'FILTER_TYPE_OCCASION_REJECTED',
  FilterTypeOccasionSubmitted = 'FILTER_TYPE_OCCASION_SUBMITTED',
  FilterTypePartnershipOfferId = 'FILTER_TYPE_PARTNERSHIP_OFFER_ID',
  FilterTypeTag = 'FILTER_TYPE_TAG',
  FilterTypeUnknown = 'FILTER_TYPE_UNKNOWN'
}

/** Returns deep links and related URLs for a given campaign context */
export type Instacart_Customers_Coupons_V1_GetCampaignLinksRequest_Input = {
  /** IPP context provides retailer, store configuration, and auth context */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  /** Required campaign identifier */
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_GetCampaignLinksResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetCampaignLinksResponse';
  /** All links that can be used to access the campaign */
  links?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_GetCouponCodeExistsRequest_Input = {
  code?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_GetCouponCodeExistsResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetCouponCodeExistsResponse';
  couponCodeExists?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersRequest_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_GetMomentParticipatingRetailersResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetMomentParticipatingRetailersResponse';
  participatingRetailerCampaigns?: Maybe<Scalars['JSON']>;
  retailerMomentCampaigns?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerMomentCampaign>>>;
};

export type Instacart_Customers_Coupons_V1_GetMomentRequest_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_GetMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetMomentResponse';
  moment?: Maybe<Instacart_Customers_Coupons_V1_Moment>;
};

export type Instacart_Customers_Coupons_V1_GetMomentsRequest_Input = {
  momentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Coupons_V1_GetMomentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_GetMomentsResponse';
  moments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Moment>>>;
};

export type Instacart_Customers_Coupons_V1_GetRetailerCampaignRequest_Input = {
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is use to do authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_IppContext_Input = {
  ippUserId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: True if the user is admin, false otherwise */
  isAdminUser?: InputMaybe<Scalars['Boolean']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Coupons_V1_ListMomentsRequest_FilterSet_Input = {
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_ListMomentsRequest_Input = {
  filters?: InputMaybe<Instacart_Customers_Coupons_V1_ListMomentsRequest_FilterSet_Input>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Coupons_V1_ListMomentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_ListMomentsResponse';
  moments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Moment>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsRequest_Input = {
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is use to do authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignTreatmentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_ListRetailerCampaignTreatmentsResponse';
  treatments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_Input = {
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Exclude campaigns with FILTER_TYPE_ADMIN_ONLY = "true" */
  excludeAdminOnlyCampaigns?: InputMaybe<Scalars['Boolean']>;
  excludeRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /**
   * Filter campaigns by whether they have an offer (incentive) attached.
   * Empty or containing both values = no filter,
   * [INCENTIVE] = only campaigns with an offer,
   * [NON_INCENTIVE] = only campaigns without an offer.
   */
  incentiveFilters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignIncentiveFilter>>>;
  /** by default, the API will not return campaign from internal template */
  includeCampaignFromInternalTemplate?: InputMaybe<Scalars['Boolean']>;
  /** checks if this date is included in the campaign's active date range */
  isActiveOnDatetime?: InputMaybe<Scalars['DateTime']>;
  /**
   * Property filters for filtering by campaign properties (e.g. campaign_type).
   * AND-of-ORs semantics: each OrList is an OR group, all OrLists must match.
   */
  propertyFilters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignPropertyFilterOrList_Input>>>;
  queryFields?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_QueryField_Input>>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchFields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchValue?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  /** @deprecated: Use store_configuration_ids instead */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of store_configuration_id */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  uiStatus?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** by default, the API will not return campaign with enriched properties */
  withEnrichedProperties?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_QueryField_Input = {
  fieldName?: InputMaybe<Scalars['String']>;
  fieldValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_Input = {
  /** Optional filters. */
  filters?: InputMaybe<Instacart_Customers_Coupons_V1_ListRetailerCampaignsRequest_FilterSet_Input>;
  /** Optional includeFields. */
  includeFields?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignField>>>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_ListRetailerCampaignsResponse = {
  __typename?: 'instacart_customers_coupons_v1_ListRetailerCampaignsResponse';
  /** pagination info */
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  retailerCampaigns?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>>>;
  /** total number of unpaginated results */
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_MarketingMessagingDetails_Input = {
  experimentName?: InputMaybe<Scalars['String']>;
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  pushNotificationId?: InputMaybe<Scalars['String']>;
  templateId?: InputMaybe<Scalars['String']>;
  templateVariables?: InputMaybe<Scalars['JSON']>;
  userEmailOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_Moment = {
  __typename?: 'instacart_customers_coupons_v1_Moment';
  campaigns?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  momentCampaignId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  submissionDeadline?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Coupons_V1_MomentCampaignStatus_Input = {
  campaignId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_StatusMap_Input>>>;
};

export type Instacart_Customers_Coupons_V1_Placement = {
  __typename?: 'instacart_customers_coupons_v1_Placement';
  creativeRank?: Maybe<Scalars['BigInt']>;
  /** placement_id */
  id?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_Placement_Input = {
  creativeRank?: InputMaybe<Scalars['BigInt']>;
  /** placement_id */
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_Product = {
  __typename?: 'instacart_customers_coupons_v1_Product';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
};

/** redemption method includes method from serving, offer, and other system that controls redemption in the future. */
export enum Instacart_Customers_Coupons_V1_RedemptionMethod {
  RedemptionMethodAutoApply = 'REDEMPTION_METHOD_AUTO_APPLY',
  RedemptionMethodAutoRedeem = 'REDEMPTION_METHOD_AUTO_REDEEM',
  RedemptionMethodClickToRedeem = 'REDEMPTION_METHOD_CLICK_TO_REDEEM',
  RedemptionMethodCouponCode = 'REDEMPTION_METHOD_COUPON_CODE',
  RedemptionMethodRedeemOnCompletion = 'REDEMPTION_METHOD_REDEEM_ON_COMPLETION',
  RedemptionMethodUnknown = 'REDEMPTION_METHOD_UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_RestaurantRewardCondition = {
  __typename?: 'instacart_customers_coupons_v1_RestaurantRewardCondition';
  conditionType?: Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardConditionType>;
  value?: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Customers_Coupons_V1_RestaurantRewardConditionType {
  RestaurantRewardConditionTypeDeliveryFeeMaximumValue = 'RESTAURANT_REWARD_CONDITION_TYPE_DELIVERY_FEE_MAXIMUM_VALUE',
  RestaurantRewardConditionTypeMinimumSpend = 'RESTAURANT_REWARD_CONDITION_TYPE_MINIMUM_SPEND',
  RestaurantRewardConditionTypeUnknown = 'RESTAURANT_REWARD_CONDITION_TYPE_UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_RestaurantRewardCondition_Input = {
  conditionType?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardConditionType>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
};

export type Instacart_Customers_Coupons_V1_RestaurantRewardPolicy = {
  __typename?: 'instacart_customers_coupons_v1_RestaurantRewardPolicy';
  conditions?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardCondition>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  maxDiscountCents?: Maybe<Scalars['BigInt']>;
  rewardType?: Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardType>;
  secondsValid?: Maybe<Scalars['BigInt']>;
  value?: Maybe<GoogleTypeMoney>;
  valuePercentage?: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Coupons_V1_RestaurantRewardPolicy_Input = {
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardCondition_Input>>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  maxDiscountCents?: InputMaybe<Scalars['BigInt']>;
  rewardType?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardType>;
  secondsValid?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
  valuePercentage?: InputMaybe<Scalars['Float']>;
};

export enum Instacart_Customers_Coupons_V1_RestaurantRewardType {
  RestaurantRewardTypeDollarOff = 'RESTAURANT_REWARD_TYPE_DOLLAR_OFF',
  RestaurantRewardTypeFreeDelivery = 'RESTAURANT_REWARD_TYPE_FREE_DELIVERY',
  RestaurantRewardTypePercentOff = 'RESTAURANT_REWARD_TYPE_PERCENT_OFF',
  RestaurantRewardTypeUnknown = 'RESTAURANT_REWARD_TYPE_UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_Retailer = {
  __typename?: 'instacart_customers_coupons_v1_Retailer';
  id?: Maybe<Scalars['BigInt']>;
  logoUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaign = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaign';
  budget?: Maybe<GoogleTypeMoney>;
  campaignObjective?: Maybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: Maybe<Instacart_Customers_Coupons_V1_CampaignReference>;
  /** Data needed by Golang Campaign Service */
  campaignServiceData?: Maybe<Instacart_Customers_Coupons_V1_CampaignServiceData>;
  coreProperties?: Maybe<Scalars['JSON']>;
  countryIdValue?: Maybe<Scalars['BigInt']>;
  couponCount?: Maybe<Scalars['BigInt']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorIppUserId?: Maybe<Scalars['BigInt']>;
  /** Email of the person who created this campaign. */
  creatorUserEmail?: Maybe<Scalars['String']>;
  /**
   * Generic id of the person who created this campaign, resolved against
   * create_source to determine which system it belongs to.
   */
  creatorUserId?: Maybe<Scalars['BigInt']>;
  /** Optional array of custom key-value properties */
  customProperties?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CustomProperty>>>;
  discountPolicyIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  discoverability?: Maybe<Instacart_Customers_Coupons_V1_Discoverability>;
  endsAt?: Maybe<Scalars['DateTime']>;
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  filters?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CampaignFilter>>>;
  fundingDetails?: Maybe<Scalars['String']>;
  fundingSummaryDetails?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_SummaryDetails>>>;
  id?: Maybe<Scalars['BigInt']>;
  intentionConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  ippUserCanonicalUuid?: Maybe<Scalars['String']>;
  /** Deprecated: Use targeting_rules.lookback_window_days instead. */
  lookbackWindowDays?: Maybe<Scalars['BigInt']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  narrowSearchTerms?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Number of days the campaign offer is valid. If nil, valid until ends_at */
  offerDurationInDays?: Maybe<Scalars['BigInt']>;
  offerRequestKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  offerSummary?: Maybe<Scalars['String']>;
  offerSummaryDetails?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_SummaryDetails>>>;
  /** Domain-level treatment information with legacy slot_ids. Use 'treatments' field for display/rendering, only use this for filtering by slot_id or accessing treatment_policy_id. */
  rawTreatments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
  redemptionMethod?: Maybe<Instacart_Customers_Coupons_V1_RedemptionMethod>;
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  restaurantPromotionId?: Maybe<Scalars['String']>;
  restaurantRewardPolicy?: Maybe<Instacart_Customers_Coupons_V1_RestaurantRewardPolicy>;
  /** @deprecated: Use retailers_data instead */
  retailerData?: Maybe<Instacart_Customers_Coupons_V1_Retailer>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** replacement of retailer_data */
  retailersData?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Retailer>>>;
  rouletteFeature?: Maybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature>;
  /** Schedule is a cron expression string. ex "0 0 * * 2" */
  schedule?: Maybe<Scalars['String']>;
  segmentId?: Maybe<Scalars['String']>;
  /** @deprecated use treatments instead */
  slotCreatives?: Maybe<Array<Maybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative>>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated: Use store_configuration_ids instead */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  /** replacement of store_configuration_id */
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Deprecated: Use targeting_rules instead. */
  targeting?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Targeting>>>;
  targetingRules?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_TargetingRules>>>;
  templateId?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  treatmentTask?: Maybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTask>;
  treatments?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * @deprecated: Use offer_duration_in_days instead
   * TODO: Remove this
   * https://docs.google.com/document/d/1vbtlXVAoce6mkWwRib9mh5b_ZXtrUruFrNeRc13oJ78
   * Days the personal coupon will expire once assigned to the user
   */
  validForDays?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignCreativeTreatment';
  placementId?: Maybe<Scalars['BigInt']>;
  slotId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment_Input = {
  placementId?: InputMaybe<Scalars['BigInt']>;
  slotId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignOfferTreatment';
  offerDurationInDays?: Maybe<Scalars['BigInt']>;
  offerId?: Maybe<Scalars['BigInt']>;
  offerRequestKey?: Maybe<Scalars['String']>;
  slotId?: Maybe<Scalars['String']>;
  validForDays?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment_Input = {
  offerDurationInDays?: InputMaybe<Scalars['BigInt']>;
  offerId?: InputMaybe<Scalars['BigInt']>;
  offerRequestKey?: InputMaybe<Scalars['String']>;
  slotId?: InputMaybe<Scalars['String']>;
  validForDays?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignResponse = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignResponse';
  errors?: Maybe<Scalars['JSON']>;
  offers?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer>>>;
  retailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>;
  /** deprecated: opting to return slot_creatives as part of retailer_campaign instead */
  slotCreatives?: Maybe<Array<Maybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatment';
  active?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  retailerCampaignId?: Maybe<Scalars['BigInt']>;
  slotIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  treatmentDetails?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails>>>;
  treatmentPolicyId?: Maybe<Scalars['String']>;
  treatmentType?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatmentDetails';
  creativeTreatment?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment>;
  offerTreatment?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails_Input = {
  creativeTreatment?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignCreativeTreatment_Input>;
  offerTreatment?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignOfferTreatment_Input>;
};

export enum Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType {
  Creative = 'CREATIVE',
  InvalidTreatment = 'INVALID_TREATMENT',
  Offer = 'OFFER'
}

/**
 * When defined, this represents the slots a campaign will show in.
 * examples:
 * - Incentive campaign which shows in various GS slots
 * {
 * treatments: [
 *
 *
 * slot_id: 1, // slot_id references `content_slots.id`
 * placements: [], // incentive campaigns don't define placements as they have TrUX placement matching
 * treatment_visibility_conditions: [] // treatment_visibility_conditions: [] - means all states
 * }
 * proto arrays don't differ from nil, so placement, and treatment_visibility_conditions are the same as above
 * { slot_id: 2 }
 * ]
 * }
 * - Incentive campaign which only shows after it's been redeemd (CRM/CIAO)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * ]
 * }
 * - Incentive campaign which only shows after it's been DxGy Activated (CRM/CHARM + dxgy)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * }
 *
 * - A campaign that shows only in 1 slot
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: [] }
 * note how slot_id: 2 is missing - this is intentional as treatment_visibility_conditions: [] implies all states, not no-states
 * ]
 * }
 *
 * - A non-incentive campaign
 * {
 * treatments: [
 * non-incentives define a placement_id and creative_rank, but not treatment_visibility_conditions
 * { slot_id: 1, placements: [{ id: 456, creative_rank: 5 }] },
 * we can have multiple placements
 * --- but only 1 will be shown at a time - depending on the placement level VCs
 * { slot_id: 2, placements: [{ id: 789, creative_rank: 5 }, { id: 101, creative_rank: 4 }] },
 * ]
 * }
 * }
 */
export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatments';
  /** list of slots in which the campaign will show */
  treatments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment>>>;
};

/**
 * When defined, this represents the slots a campaign will show in.
 * examples:
 * - Incentive campaign which shows in various GS slots
 * {
 * treatments: [
 *
 *
 * slot_id: 1, // slot_id references `content_slots.id`
 * placements: [], // incentive campaigns don't define placements as they have TrUX placement matching
 * treatment_visibility_conditions: [] // treatment_visibility_conditions: [] - means all states
 * }
 * proto arrays don't differ from nil, so placement, and treatment_visibility_conditions are the same as above
 * { slot_id: 2 }
 * ]
 * }
 * - Incentive campaign which only shows after it's been redeemd (CRM/CIAO)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["redeemed"] }
 * ]
 * }
 * - Incentive campaign which only shows after it's been DxGy Activated (CRM/CHARM + dxgy)
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * { slot_id: 2, placements: [], treatment_visibility_conditions: ["activated", "redeemed"] }
 * }
 *
 * - A campaign that shows only in 1 slot
 * {
 * treatments: [
 * { slot_id: 1, placements: [], treatment_visibility_conditions: [] }
 * note how slot_id: 2 is missing - this is intentional as treatment_visibility_conditions: [] implies all states, not no-states
 * ]
 * }
 *
 * - A non-incentive campaign
 * {
 * treatments: [
 * non-incentives define a placement_id and creative_rank, but not treatment_visibility_conditions
 * { slot_id: 1, placements: [{ id: 456, creative_rank: 5 }] },
 * we can have multiple placements
 * --- but only 1 will be shown at a time - depending on the placement level VCs
 * { slot_id: 2, placements: [{ id: 789, creative_rank: 5 }, { id: 101, creative_rank: 4 }] },
 * ]
 * }
 * }
 */
export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input = {
  /** list of slots in which the campaign will show */
  treatments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment_Input>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment = {
  __typename?: 'instacart_customers_coupons_v1_RetailerCampaignTreatments_Treatment';
  /**
   * optional for both TS and awareness campaigns.
   * curently TS campaigns are either strictly non-incentive or incentive,
   * but that will change in the future.
   */
  placements?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_Placement>>>;
  /**
   * Required for all campaigns.
   *
   * Slots have both, there's a numeric id, and a "legacy_id".
   *
   * For GS - legacy ids are: 'uvc:home, tracker:store_front` etc.
   * For SFX - legacy ids are uuids
   * For GS future - we'll also have generated ids for each mrp/content page.
   *
   * The this is `campaign_slots.id` (in DB)
   * this is what's references by the underlying `content_slot_creatives` table,
   * and by `card_list_placement.data_query.slot_id`
   */
  slotId?: Maybe<Scalars['BigInt']>;
  /**
   * defined for TS campaigns, ignored for awareness campaigns
   * values of: TreatmentsDomain::Api::Types::RewardState
   * note: this is a string and not an enum because of restrictions on proto3 enums that don't play nice with GQL
   */
  treatmentVisibilityConditions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Treatment_Input = {
  /**
   * optional for both TS and awareness campaigns.
   * curently TS campaigns are either strictly non-incentive or incentive,
   * but that will change in the future.
   */
  placements?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Placement_Input>>>;
  /**
   * Required for all campaigns.
   *
   * Slots have both, there's a numeric id, and a "legacy_id".
   *
   * For GS - legacy ids are: 'uvc:home, tracker:store_front` etc.
   * For SFX - legacy ids are uuids
   * For GS future - we'll also have generated ids for each mrp/content page.
   *
   * The this is `campaign_slots.id` (in DB)
   * this is what's references by the underlying `content_slot_creatives` table,
   * and by `card_list_placement.data_query.slot_id`
   */
  slotId?: InputMaybe<Scalars['BigInt']>;
  /**
   * defined for TS campaigns, ignored for awareness campaigns
   * values of: TreatmentsDomain::Api::Types::RewardState
   * note: this is a string and not an enum because of restrictions on proto3 enums that don't play nice with GQL
   */
  treatmentVisibilityConditions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Coupons_V1_RetailerMomentCampaign = {
  __typename?: 'instacart_customers_coupons_v1_RetailerMomentCampaign';
  collectionData?: Maybe<Instacart_Customers_Coupons_V1_Collection>;
  offers?: Maybe<Array<Maybe<Instacart_Customers_Commerce_Types_V1_SlimOffer>>>;
  retailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>;
  retailerData?: Maybe<Instacart_Customers_Coupons_V1_Retailer>;
};

export type Instacart_Customers_Coupons_V1_StatusMap_Input = {
  momentId?: InputMaybe<Scalars['BigInt']>;
  momentStatus?: InputMaybe<Scalars['JSON']>;
  status?: InputMaybe<Instacart_Customers_Coupons_V1_FilterType>;
};

export type Instacart_Customers_Coupons_V1_SummaryDetails = {
  __typename?: 'instacart_customers_coupons_v1_SummaryDetails';
  details?: Maybe<Scalars['JSON']>;
};

export enum Instacart_Customers_Coupons_V1_Targeting {
  ActivatedCustomer = 'ACTIVATED_CUSTOMER',
  ChurnedCustomer = 'CHURNED_CUSTOMER',
  LoyaltyCustomer = 'LOYALTY_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  NonLoyaltyCustomer = 'NON_LOYALTY_CUSTOMER',
  Unknown = 'UNKNOWN'
}

export type Instacart_Customers_Coupons_V1_TargetingRules = {
  __typename?: 'instacart_customers_coupons_v1_TargetingRules';
  lookbackWindowDays?: Maybe<Scalars['BigInt']>;
  targetingType?: Maybe<Instacart_Customers_Coupons_V1_Targeting>;
};

export type Instacart_Customers_Coupons_V1_TargetingRules_Input = {
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  targetingType?: InputMaybe<Instacart_Customers_Coupons_V1_Targeting>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusRequest_Input = {
  momentCampaignStatus?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_MomentCampaignStatus_Input>>>;
  momentCampaigns?: InputMaybe<Scalars['JSON']>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentCampaignStatusResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateMomentCampaignStatusResponse';
  campaigns?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>>>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentRequest_Input = {
  campaignSubmissionDeadline?: InputMaybe<Scalars['DateTime']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  momentId?: InputMaybe<Scalars['BigInt']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Coupons_V1_UpdateMomentResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateMomentResponse';
  moment?: Maybe<Instacart_Customers_Coupons_V1_Moment>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetRequest_Input = {
  budget?: InputMaybe<GoogleTypeMoneyInput>;
  /** IPP will provide the context when calling this API */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignBudgetResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateRetailerCampaignBudgetResponse';
  errors?: Maybe<Scalars['JSON']>;
  retailerCampaign?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaign>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignRequest_Input = {
  budget?: InputMaybe<GoogleTypeMoneyInput>;
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  couponCount?: InputMaybe<Scalars['BigInt']>;
  /**
   * Flag to indicate whether to disable treatment policies when updating campaign status
   * When set to true, will disable all treatment policies associated with the campaign
   * Similar to CancelRetailerCampaign's disable_offer behavior but for update operations
   */
  disableTreatmentPolicy?: InputMaybe<Scalars['Boolean']>;
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /** Flag to indicate the campaign is enabled for offline serve */
  enableOfflineServe?: InputMaybe<Scalars['Boolean']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /** Nilable wrapper for filters; takes precedence over `filters` field when present. */
  filtersV2?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilters_Input>;
  /** Indicates the campaign assignment is guaranteed (unconditional assignment) */
  guaranteedAssignment?: InputMaybe<Scalars['Boolean']>;
  /**
   * IPP will provide the context when calling this API
   * if not called by IPP, we can set this field to nil
   * this field is used for authentication when called by IPP
   */
  ippContext?: InputMaybe<Instacart_Customers_Coupons_V1_IppContext_Input>;
  /** Deprecated: Use targeting_rules.lookback_window instead. */
  lookbackWindowDays?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  narrowSearchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offers?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Types_V1_SlimOffer_Input>>>;
  /**
   * Generic overrides for campaign properties (finance typology, cost center, etc.).
   * Absence of a key means "do not touch"; an empty string value clears the property.
   */
  propertyOverrides?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignPropertyOverride_Input>>>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  restaurantPromotionId?: InputMaybe<Scalars['String']>;
  restaurantRewardPolicy?: InputMaybe<Instacart_Customers_Coupons_V1_RestaurantRewardPolicy_Input>;
  /**
   * When true, resume the campaign after updating the redemption limit on offers.
   * Only takes effect when the campaign is in PAUSED_BY_GLOBAL_REDEMPTION_LIMIT status.
   * Mutually exclusive with `status`; setting both returns an error.
   */
  resumeAfterRedemptionLimitIncrease?: InputMaybe<Scalars['Boolean']>;
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  rouletteFeature?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input>;
  schedule?: InputMaybe<Scalars['String']>;
  segmentId?: InputMaybe<Scalars['String']>;
  /** @deprecated use treatments instead */
  slotCreatives?: InputMaybe<Array<InputMaybe<Instacart_Customers_Content_Management_Admin_V1_SlotCreative_Input>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** Deprecated: Use targeting_rules instead. */
  targeting?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_Targeting>>>;
  targetingRules?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_TargetingRules_Input>>>;
  treatments?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentParams_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  treatmentDetails?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentDetails_Input>>>;
  treatmentType?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatmentType>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsRequest_Input = {
  retailerCampaignId?: InputMaybe<Scalars['BigInt']>;
  /** @deprecated: Use retailer_ids instead */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** replacement of retailer_id */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  treatments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentParams_Input>>>;
};

export type Instacart_Customers_Coupons_V1_UpdateRetailerCampaignTreatmentsResponse = {
  __typename?: 'instacart_customers_coupons_v1_UpdateRetailerCampaignTreatmentsResponse';
  treatments?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatment>>>;
};

export type Instacart_Customers_Discovery_V1_RankingContext = {
  __typename?: 'instacart_customers_discovery_v1_RankingContext';
  /** Optional: Anchor Product */
  anchorProductId?: Maybe<Scalars['BigInt']>;
  /** Optional: Boolean indicating if Post Ranker should apply category diversification, default is false */
  applyCategoryDiversification?: Maybe<Scalars['Boolean']>;
  /** Optional: boolean indicating whether we should go through post ranking, default is true */
  applyMlRanker?: Maybe<Scalars['Boolean']>;
  /** Optional: Array of product IDs to re-rank and boost to top of list; maintained in order passed */
  boostedProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** PostRankerDomain::Api::Types::CallerSurface */
  caller?: Maybe<Scalars['String']>;
  /** Optional: Unique string to distinguish the carousel the request came from (category ID or collection slug) */
  categoryInfo?: Maybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking */
  disableRouletteTracking?: Maybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank low stock items, default is false */
  downrankLowStockItems?: Maybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank OOS items, default is false */
  downrankOutOfStockItems?: Maybe<Scalars['Boolean']>;
  /** Optional: Max number of products to return */
  limit?: Maybe<Scalars['BigInt']>;
  /** Optional: Limit of number of items to send for ML ranking */
  mlRankingLimit?: Maybe<Scalars['BigInt']>;
  /** Optional: Ranking model for ML ranking */
  mlRankingModel?: Maybe<Scalars['String']>;
  /** Optional: Requesting user's order_count */
  userOrderCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Discovery_V1_RankingContext_Input = {
  /** Optional: Anchor Product */
  anchorProductId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Boolean indicating if Post Ranker should apply category diversification, default is false */
  applyCategoryDiversification?: InputMaybe<Scalars['Boolean']>;
  /** Optional: boolean indicating whether we should go through post ranking, default is true */
  applyMlRanker?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Array of product IDs to re-rank and boost to top of list; maintained in order passed */
  boostedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** PostRankerDomain::Api::Types::CallerSurface */
  caller?: InputMaybe<Scalars['String']>;
  /** Optional: Unique string to distinguish the carousel the request came from (category ID or collection slug) */
  categoryInfo?: InputMaybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking */
  disableRouletteTracking?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank low stock items, default is false */
  downrankLowStockItems?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Boolean indicating if Post Ranker should downrank OOS items, default is false */
  downrankOutOfStockItems?: InputMaybe<Scalars['Boolean']>;
  /** Optional: Max number of products to return */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Limit of number of items to send for ML ranking */
  mlRankingLimit?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Ranking model for ML ranking */
  mlRankingModel?: InputMaybe<Scalars['String']>;
  /** Optional: Requesting user's order_count */
  userOrderCount?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalContext = {
  __typename?: 'instacart_customers_discovery_v1_RetrievalContext';
  /** Optional - alcohol allowed flag */
  alcoholAllowed?: Maybe<Scalars['Boolean']>;
  /** Optional - some retrieval sources may need anchor product ids to retrieve products */
  anchorProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: Brand IDs to filter by */
  brandIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: collection_slug of the collection we wish to query */
  collectionSlug?: Maybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking (currently does not take affect) */
  disableRouletteTracking?: Maybe<Scalars['Boolean']>;
  /** Optional - GetDiscoverItems API caller */
  discoverApiCaller?: Maybe<Scalars['String']>;
  /**
   * The followings are mostly used for item availability filtering
   * Optional - exclude BIA flag
   */
  excludeBia?: Maybe<Scalars['Boolean']>;
  /** Optional - Product category (Taxonomy) IDs to exclude */
  excludeProductCategoryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional - Product category (Taxonomy) IDs to include */
  includeProductCategoryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: Item filters to apply */
  itemFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: Limit for the number of items returned */
  limit?: Maybe<Scalars['BigInt']>;
  /** Optinoal: Minimum availabilty score for product filtering */
  minimumAvailabilityScore?: Maybe<Scalars['Float']>;
  /** Optional: Dedup item variants if from same group variant */
  onlyKeepUniqVariants?: Maybe<Scalars['Boolean']>;
  /** List of retrieval sources that caller wants to use to retrieve products */
  retrievalSources?: Maybe<Array<Maybe<Instacart_Customers_Discovery_V1_RetrievalSource>>>;
  /** Optional - version string used for unified product recommendations service */
  version?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalContext_Input = {
  /** Optional - alcohol allowed flag */
  alcoholAllowed?: InputMaybe<Scalars['Boolean']>;
  /** Optional - some retrieval sources may need anchor product ids to retrieve products */
  anchorProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: Brand IDs to filter by */
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: collection_slug of the collection we wish to query */
  collectionSlug?: InputMaybe<Scalars['String']>;
  /** Optional: boolean indicating whether we disable roulette tracking (currently does not take affect) */
  disableRouletteTracking?: InputMaybe<Scalars['Boolean']>;
  /** Optional - GetDiscoverItems API caller */
  discoverApiCaller?: InputMaybe<Scalars['String']>;
  /**
   * The followings are mostly used for item availability filtering
   * Optional - exclude BIA flag
   */
  excludeBia?: InputMaybe<Scalars['Boolean']>;
  /** Optional - Product category (Taxonomy) IDs to exclude */
  excludeProductCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional - Product category (Taxonomy) IDs to include */
  includeProductCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: Item filters to apply */
  itemFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: Limit for the number of items returned */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** Optinoal: Minimum availabilty score for product filtering */
  minimumAvailabilityScore?: InputMaybe<Scalars['Float']>;
  /** Optional: Dedup item variants if from same group variant */
  onlyKeepUniqVariants?: InputMaybe<Scalars['Boolean']>;
  /** List of retrieval sources that caller wants to use to retrieve products */
  retrievalSources?: InputMaybe<Array<InputMaybe<Instacart_Customers_Discovery_V1_RetrievalSource_Input>>>;
  /** Optional - version string used for unified product recommendations service */
  version?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalSource = {
  __typename?: 'instacart_customers_discovery_v1_RetrievalSource';
  limit?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Discovery_V1_RetrievalSource_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserParameters_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserParameters_Input>;
};

export type Instacart_Customers_Express_V1_GetCurrentExpressMemberStatusForUserResponse = {
  __typename?: 'instacart_customers_express_v1_GetCurrentExpressMemberStatusForUserResponse';
  isExpressMember?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Express_V1_GetLatestActiveOrInactiveSubscriptionForUserParameters_Input = {
  includeHouseholdUsers?: InputMaybe<Scalars['Boolean']>;
  includeLinkedUserAccounts?: InputMaybe<Scalars['Boolean']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userIdentity?: InputMaybe<Instacart_Customers_Express_V1_UserIdentity_Input>;
};

export type Instacart_Customers_Express_V1_GetLatestActiveOrInactiveSubscriptionForUserRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Express_V1_GetLatestActiveOrInactiveSubscriptionForUserParameters_Input>;
};

export type Instacart_Customers_Express_V1_GetLatestActiveOrInactiveSubscriptionForUserResponse = {
  __typename?: 'instacart_customers_express_v1_GetLatestActiveOrInactiveSubscriptionForUserResponse';
  /** Price that will be charged on renewal for the returned subscription's next plan */
  renewalPrice?: Maybe<GoogleTypeMoney>;
  subscription?: Maybe<Instacart_Customers_Express_V1_Subscription>;
  /** Term length of the current subscription plan (e.g., "MONTH", "YEAR") */
  termLength?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Express_V1_Subscription = {
  __typename?: 'instacart_customers_express_v1_Subscription';
  autorenew?: Maybe<Scalars['Boolean']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  discount?: Maybe<GoogleTypeMoney>;
  endsOn?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  startsOn?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Express_V1_UserIdentity_Input = {
  commonIdentityUserIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_AdvancedTextCluster_Debug';
  defaultDebug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_StubableDebugContext>;
};

export type Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_AdvancedTextCluster_Definition';
  /** Buffer is basically a grace for intersection */
  buffer?: Maybe<Scalars['BigInt']>;
  /** Minimum height in PDF points for at least one element in a price group to qualify as anchor (default: 24.0). */
  priceAnchorHeightThreshold?: Maybe<Scalars['Float']>;
  /** Minimum height in PDF points for text to be considered a potential price element (default: 20.0). */
  priceCompanionHeightThreshold?: Maybe<Scalars['Float']>;
  priceDetectionStrategy?: Maybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_PriceDetectionStrategy>;
};

export type Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_Input = {
  /** Buffer is basically a grace for intersection */
  buffer?: InputMaybe<Scalars['BigInt']>;
  /** Minimum height in PDF points for at least one element in a price group to qualify as anchor (default: 24.0). */
  priceAnchorHeightThreshold?: InputMaybe<Scalars['Float']>;
  /** Minimum height in PDF points for text to be considered a potential price element (default: 20.0). */
  priceCompanionHeightThreshold?: InputMaybe<Scalars['Float']>;
  priceDetectionStrategy?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_PriceDetectionStrategy>;
};

export enum Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_PriceDetectionStrategy {
  /** Looks at large fonts and its styles and searches around */
  FontStylePriceDetectionStrategy = 'FONT_STYLE_PRICE_DETECTION_STRATEGY',
  /** Look for symbols like $ % or cent signs */
  SymbolicPriceDetectionStrategy = 'SYMBOLIC_PRICE_DETECTION_STRATEGY'
}

export type Instacart_Customers_Flyer_Pdf_V1_BoundingBox = {
  __typename?: 'instacart_customers_flyer_pdf_v1_BoundingBox';
  /** ll, lr, ur, ul */
  corners?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>>>;
  /** The elements that are inside/intersecting the bounding box */
  elements?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  /** Should human verify */
  requiresReview?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationCondition';
  /** The left operand of the condition */
  left?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand>;
  /** Whether to negate the condition */
  not?: Maybe<Scalars['Boolean']>;
  /** The operator to use for the condition */
  operator?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ComparisonOperator>;
  /** The right operand of the condition */
  right?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Input = {
  /** The left operand of the condition */
  left?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand_Input>;
  /** Whether to negate the condition */
  not?: InputMaybe<Scalars['Boolean']>;
  /** The operator to use for the condition */
  operator?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ComparisonOperator>;
  /** The right operand of the condition */
  right?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand_Input>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationCondition_Operand';
  /** Specific classification count */
  classification?: Maybe<Scalars['String']>;
  /** The constant value */
  constantValue?: Maybe<Scalars['BigInt']>;
  /** all classifications count */
  totalCount?: Maybe<Scalars['google_protobuf_Empty']>;
  /** unique classifications count (includes unknown) */
  uniqueCount?: Maybe<Scalars['google_protobuf_Empty']>;
  /** unique classifications count (without unknown) */
  uniqueMinusUnknownCount?: Maybe<Scalars['google_protobuf_Empty']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Operand_Input = {
  /** Specific classification count */
  classification?: InputMaybe<Scalars['String']>;
  /** The constant value */
  constantValue?: InputMaybe<Scalars['BigInt']>;
  /** all classifications count */
  totalCount?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** unique classifications count (includes unknown) */
  uniqueCount?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** unique classifications count (without unknown) */
  uniqueMinusUnknownCount?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationFilter_Definition';
  /** Conditions that are AND together */
  conditions?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition_Input = {
  /** Conditions that are AND together */
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ClassificationFlagger_Definition';
  /** Conditions that are AND together */
  conditions?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition_Input = {
  /** Conditions that are AND together */
  conditions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationCondition_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_Color = {
  __typename?: 'instacart_customers_flyer_pdf_v1_Color';
  /** Color Space */
  colorSpace?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ColorSpace>;
  /** Color Values */
  values?: Maybe<Array<Maybe<Scalars['Float']>>>;
};

export enum Instacart_Customers_Flyer_Pdf_V1_ColorSpace {
  /** CMYK */
  Cmyk = 'CMYK',
  /** Gray */
  Gray = 'GRAY',
  /** RGB */
  Rgb = 'RGB',
  /** UJniversal */
  Universal = 'UNIVERSAL',
  /** Unknown */
  UnknownColorSpace = 'UNKNOWN_COLOR_SPACE'
}

export enum Instacart_Customers_Flyer_Pdf_V1_ComparisonOperator {
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN',
  Unknown = 'UNKNOWN'
}

export type Instacart_Customers_Flyer_Pdf_V1_ContextualAssociation_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ContextualAssociation_Debug';
  defaultDebug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_StubableDebugContext>;
};

/** Represents a debug context that can contain events and other contexts */
export type Instacart_Customers_Flyer_Pdf_V1_DebugContext = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugContext';
  /** Items in this context - can be events or nested contexts */
  items?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugItem>>>;
  /** Additional metadata for the context */
  metadata?: Maybe<Scalars['JSON']>;
  /** Name of the context */
  name?: Maybe<Scalars['String']>;
};

/** Represents a debug event with multiple shapes */
export type Instacart_Customers_Flyer_Pdf_V1_DebugEvent = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugEvent';
  /** Name of the event */
  name?: Maybe<Scalars['String']>;
  /** Shapes associated with this event */
  shapes?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugShape>>>;
};

/** Wrapper message for items that can appear in a context */
export type Instacart_Customers_Flyer_Pdf_V1_DebugItem = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugItem';
  context?: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugContext>;
  event?: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugEvent>;
};

/**
 * Represents a shape with attributes and category for debugging geometric
 * operations. Shape type is determined by number of vertices:
 */
export type Instacart_Customers_Flyer_Pdf_V1_DebugShape = {
  __typename?: 'instacart_customers_flyer_pdf_v1_DebugShape';
  /** Additional metadata for the shape */
  attributes?: Maybe<Scalars['JSON']>;
  /** Category for grouping/coloring shapes */
  category?: Maybe<Scalars['String']>;
  /** Optional associated PDF element */
  pdfElement?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>;
  /** The vertices that define the shape */
  vertices?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_Input = {
  /** flyer to target */
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: use singular evaluation instead */
  flyerPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Optional partial run, if provided we will resume from the offset of an
   * existing job
   */
  partialRun?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_PartialRun_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_PartialRun_Input = {
  offset?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_Input = {
  /**
   * flag to indicate if we should just run the rule set but not actually create
   * bounding boxes in flyer service
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /** retailer to target */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** List of flyer IDs to target */
  targets?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetRequest_EvaluateRuleSetTarget_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_EvaluateRuleSetResponse';
  references?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse_Reference>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_EvaluateRuleSetResponse_Reference = {
  __typename?: 'instacart_customers_flyer_pdf_v1_EvaluateRuleSetResponse_Reference';
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  ruleSetRunId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_FilterClassification_Definition';
  /** Use default filtering behavior (no specific include/exclude rules) */
  default?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default']>;
  /** Exclude these specific values from results */
  exclude?: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude>;
  /** Include only these specific values in results */
  include?: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include>;
  /** The type of PDF elements to target for filtering */
  target?: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Target>;
};

/** Excludes PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude = {
  __typename?: 'instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Exclude';
  /** Excludes PDF elements with these classifications */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Excludes PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude_Input = {
  /** Excludes PDF elements with these classifications */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Includes only PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include = {
  __typename?: 'instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Include';
  /** Includes only PDF elements with these classifications */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Includes only PDF elements with these classifications */
export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include_Input = {
  /** Includes only PDF elements with these classifications */
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Input = {
  /** Use default filtering behavior (no specific include/exclude rules) */
  default?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_FilterClassification_Definition_Default_Input']>;
  /** Exclude these specific values from results */
  exclude?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Exclude_Input>;
  /** Include only these specific values in results */
  include?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Include_Input>;
  /** The type of PDF elements to target for filtering */
  target?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Target>;
};

export enum Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Target {
  TargetAll = 'TARGET_ALL',
  TargetImage = 'TARGET_IMAGE',
  TargetImageLike = 'TARGET_IMAGE_LIKE',
  TargetText = 'TARGET_TEXT',
  TargetTextLike = 'TARGET_TEXT_LIKE'
}

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetResponse';
  ruleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet>;
  ruleSetJson?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  forcePresignedUrl?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
  stubRef?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunDebugResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunDebugResponse';
  debugContext?: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugContext>;
  presignedDownloadUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
  stubRef?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunImageResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunImageResponse';
  /** this is a presigned url to download the image in base64 format */
  imageDownloadUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunResponse';
  data?: Maybe<Scalars['String']>;
  presignedDownloadUrl?: Maybe<Scalars['String']>;
  /** This will never get populated, it's just here to help IPP generate types */
  run?: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSetRun>;
};

/** Run tracking messages */
export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_GetRuleSetRunStatusResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_GetRuleSetRunStatusResponse';
  details?: Maybe<Scalars['JSON']>;
  error?: Maybe<Scalars['String']>;
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  progress?: Maybe<Scalars['BigInt']>;
  result?: Maybe<Scalars['String']>;
  ruleSetRunId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageClassifier_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageClassifier_Debug';
  classificationSystemPrompt?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageCluster_Definition';
  /** Buffer is basically a grace for intersection */
  buffer?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition_Input = {
  /** Buffer is basically a grace for intersection */
  buffer?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ImageElement = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageElement';
  /** The generic data for the element */
  data?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /**
   * Form object_id stack, images can be part of a xobject form (PDF construct
   * not what you are thinking), forms can be nested in forms
   */
  formObjectIdStack?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** same as above except it tracks the names */
  formXobjectNameStack?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The image data in base64 format */
  image?: Maybe<Scalars['String']>;
  /** Randomly generated unique instance ID to be used for debugging */
  instanceId?: Maybe<Scalars['String']>;
  /** indirect object id from the PDF file of the image */
  objectId?: Maybe<Scalars['BigInt']>;
  /** smask form object id */
  smaskFormObjectId?: Maybe<Scalars['BigInt']>;
  /** The soft mask data in base64 format */
  softMask?: Maybe<Scalars['String']>;
  /**
   * The transformed image data in base64 format, this is image at it's location
   * in the page
   */
  transformedImage?: Maybe<Scalars['String']>;
  /**
   * The transformed soft mask data in base64 format, this is soft mask at it's
   * location in the page
   */
  transformedSmask?: Maybe<Scalars['String']>;
  /** The name of the xobject */
  xobjectName?: Maybe<Scalars['String']>;
};

/** A group of image elements */
export type Instacart_Customers_Flyer_Pdf_V1_ImageGroup = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ImageGroup';
  /** The generic data for the element */
  data?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /** The images in the group */
  images?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageElement>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_InitializationRuleDebug';
  pdfPageParser?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_PdfPageParser_Debug']>;
};

/** Base Rule Definitions */
export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_InitializationRuleDefinition';
  pdfPageParser?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition>;
};

/** Base Rule Definitions */
export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition_Input = {
  pdfPageParser?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition_Input>;
};

/** Base Rule Results */
export type Instacart_Customers_Flyer_Pdf_V1_InitializationRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_InitializationRuleResult';
  /** Implementation specific debug information */
  debug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition?: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition>;
  input?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPage>;
  /** Default page information */
  metadata?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageData>;
  output?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
};

/** This is ephermeral sidekiq-redis run status */
export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunStatusesResponse';
  runs?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse_RuleSetRunSummary>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunStatusesResponse_RuleSetRunSummary = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunStatusesResponse_RuleSetRunSummary';
  completedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  ruleSetRunId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunsResponse';
  /** We can't return the full rule set run because it's too big */
  items?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse_Result>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ListRuleSetRunsResponse_Result = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ListRuleSetRunsResponse_Result';
  createdAt?: Maybe<Scalars['String']>;
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  ruleSetRunId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Debug';
  /** Attempted row spans */
  candidateRowSpans?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans>>>;
  /** Attempted row spans */
  colSpans?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans>>>;
  /** Attempted column spans */
  selectedRowSpan?: Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans>;
  /** Test lines */
  testLines?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_TestLine>>>;
};

/**
 * Spans definition e.g. [2, 1, 1] means 5 equal sized rows/columns total
 * (sum of values) where first takes up 2 rows/cols and the rest take up 1.
 * Note that if it's a row span it starts from the bottom due to bottom-left
 * origin, so you'll see the results in reverse
 */
export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_Spans = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Debug_Spans';
  /**
   * Spans definition e.g. [2, 1, 1] means 5 equal sized rows/columns total
   * (sum of values) where first takes up 2 rows/cols and the rest take up 1.
   * Note that if it's a row span it starts from the bottom due to bottom-left
   * origin, so you'll see the results in reverse
   */
  values?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Lines used to test row/col spans */
export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug_TestLine = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Debug_TestLine';
  end?: Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>;
  intersectedElements?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  start?: Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>;
};

export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_MergeableGrid_Definition';
  buffer?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition_Input = {
  buffer?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfElement = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfElement';
  image?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageElement>;
  imageGroup?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageGroup>;
  text?: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextElement>;
  textGroup?: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextGroup>;
};

/**
 * Common data for all element types
 * The reason this is on the PdfElement base type is that we want to preserve
 * grouped elements data without adding a circular schema And reduces extra type
 * inference
 */
export type Instacart_Customers_Flyer_Pdf_V1_PdfElementData = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfElementData';
  /** flag that another rule is setting element an anchor point */
  anchorPoint?: Maybe<Scalars['Boolean']>;
  classification?: Maybe<Scalars['String']>;
  filtered?: Maybe<Scalars['Boolean']>;
  /**
   * If we think it might not be something rendered due to say blending options
   * We only process PDF data not render it so we don't handle all logic but
   * there are hints that it might not be rendered, this is a tip to ask a
   * VLM/LLM against an already rendered image to see if we actually have
   * anything there
   */
  possiblyNotRendered?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
  vertices?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_Point>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPage = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPage';
  /** The id of the flyer this page belongs to */
  flyerId?: Maybe<Scalars['BigInt']>;
  /** idf of the flyer page */
  flyerPageId?: Maybe<Scalars['BigInt']>;
  /** Page number of the PDF Page */
  pageNumber?: Maybe<Scalars['BigInt']>;
  /** Source of PDF Page */
  source?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageData = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPageData';
  /** Height of the PDF Page in points */
  height?: Maybe<Scalars['Float']>;
  /** the rasterized/rendered image of the page */
  image?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfPageData_Image>;
  /** Width of the PDF Page in points */
  width?: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageData_Image = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPageData_Image';
  /** Base64 data of the image */
  data?: Maybe<Scalars['String']>;
  /** Height of the image in pixels */
  height?: Maybe<Scalars['BigInt']>;
  /** Width of the image in pixels */
  width?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PdfPageParser_Definition';
  /**
   * Minimum area of a clipping polygon to be considered valid (i.e. not too
   * small) This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingMinPolygonArea?: Maybe<Scalars['BigInt']>;
  /**
   * Relative threshold factor for clipping polygon area
   * This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingRelativeThresholdFactor?: Maybe<Scalars['Float']>;
  /**
   * PDF reader will negative CYMK images from PDF if true
   * This is used when you are getting weird (dark negative looking) images
   * The current PDF parsing library does not handle CYMK images properly
   */
  cmykImageNegation?: Maybe<Scalars['Boolean']>;
  /** related to above  - the dpi to render the pdf page as */
  textHeightCorrectDpi?: Maybe<Scalars['BigInt']>;
  /** Attempts to correct text height by looking at the rendered pdf text */
  textHeightCorrectEnabled?: Maybe<Scalars['Boolean']>;
  /**
   * how much we should morph the width of the text to catch words/sentences
   * pts are 1/72 of an inch default should be 5 but check actual code
   */
  textHeightCorrectMorphWidthPts?: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PdfPageParser_Definition_Input = {
  /**
   * Minimum area of a clipping polygon to be considered valid (i.e. not too
   * small) This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingMinPolygonArea?: InputMaybe<Scalars['BigInt']>;
  /**
   * Relative threshold factor for clipping polygon area
   * This is used in our clipping heuristic to determine cut-outs as we
   * do not fully implement PDF rendering clipping logic
   */
  anamolousClippingRelativeThresholdFactor?: InputMaybe<Scalars['Float']>;
  /**
   * PDF reader will negative CYMK images from PDF if true
   * This is used when you are getting weird (dark negative looking) images
   * The current PDF parsing library does not handle CYMK images properly
   */
  cmykImageNegation?: InputMaybe<Scalars['Boolean']>;
  /** related to above  - the dpi to render the pdf page as */
  textHeightCorrectDpi?: InputMaybe<Scalars['BigInt']>;
  /** Attempts to correct text height by looking at the rendered pdf text */
  textHeightCorrectEnabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * how much we should morph the width of the text to catch words/sentences
   * pts are 1/72 of an inch default should be 5 but check actual code
   */
  textHeightCorrectMorphWidthPts?: InputMaybe<Scalars['Float']>;
};

/**
 * Basic Types
 * Bottom left origin - meaning (0, 0) is the bottom left of the image and not
 * the top left like in CSS or HTML Canvas
 */
export type Instacart_Customers_Flyer_Pdf_V1_Point = {
  __typename?: 'instacart_customers_flyer_pdf_v1_Point';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PostProcessingRuleDebug';
  classificationFilter?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ClassificationFilter_Debug']>;
  classificationFlagger?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ClassificationFlagger_Debug']>;
  promptFilter?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_PromptFilter_Debug']>;
  promptFlagger?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_PromptFlagger_Debug']>;
  qualityReviewer?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_QualityReviewer_Debug']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PostProcessingRuleDefinition';
  classificationFilter?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition>;
  classificationFlagger?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition>;
  promptFilter?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition>;
  promptFlagger?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition>;
  qualityReviewer?: Maybe<Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition_Input = {
  classificationFilter?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFilter_Definition_Input>;
  classificationFlagger?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ClassificationFlagger_Definition_Input>;
  promptFilter?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition_Input>;
  promptFlagger?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition_Input>;
  qualityReviewer?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition_Input>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PostProcessingRuleResult';
  /** Implementation specific debug information */
  debug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition>;
  input?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_BoundingBox>>>;
  output?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_BoundingBox>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PreProcessingRuleDebug';
  advancedTextCluster?: Maybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Debug>;
  filterClassification?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_FilterClassification_Debug']>;
  imageClassifier?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageClassifier_Debug>;
  imageCluster?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ImageCluster_Debug']>;
  textClassifier?: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextClassifier_Debug>;
  textCluster?: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextCluster_Debug>;
  textCorrect?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextCorrect_Debug']>;
  textHeightCorrect?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextHeightCorrect_Debug']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PreProcessingRuleDefinition';
  advancedTextCluster?: Maybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition>;
  filterClassification?: Maybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition>;
  imageClassifier?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ImageClassifier_Definition']>;
  imageCluster?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition>;
  textClassifier?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextClassifier_Definition']>;
  textCluster?: Maybe<Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition>;
  textCorrect?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextCorrect_Definition']>;
  textHeightCorrect?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition_Input = {
  advancedTextCluster?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_AdvancedTextCluster_Definition_Input>;
  filterClassification?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_FilterClassification_Definition_Input>;
  imageClassifier?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_ImageClassifier_Definition_Input']>;
  imageCluster?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ImageCluster_Definition_Input>;
  textClassifier?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_TextClassifier_Definition_Input']>;
  textCluster?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition_Input>;
  textCorrect?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_TextCorrect_Definition_Input']>;
  textHeightCorrect?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_TextHeightCorrect_Definition_Input']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PreProcessingRuleResult';
  /** Implementation specific debug information */
  debug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition>;
  input?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  output?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDebug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ProcessingRuleDebug';
  contextualAssociation?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ContextualAssociation_Debug>;
  mergeableGrid?: Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Debug>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ProcessingRuleDefinition';
  contextualAssociation?: Maybe<Scalars['instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition']>;
  mergeableGrid?: Maybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition_Input = {
  contextualAssociation?: InputMaybe<Scalars['instacart_customers_flyer_pdf_v1_ContextualAssociation_Definition_Input']>;
  mergeableGrid?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_MergeableGrid_Definition_Input>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ProcessingRuleResult';
  /** Implementation specific debug information */
  debug?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDebug>;
  /** This is for reference, to know which definition was used */
  definition?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition>;
  input?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElement>>>;
  output?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_BoundingBox>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PromptFilter_Definition';
  /** Conditions that we will use */
  prompts?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFilter_Definition_Input = {
  /** Conditions that we will use */
  prompts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PromptFlagger_Definition';
  /** prompts that we will use to flag bounding boxes */
  prompts?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PromptFlagger_Definition_Input = {
  /** prompts that we will use to flag bounding boxes */
  prompts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetRunId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_PublishRuleSetRunResultsResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_PublishRuleSetRunResultsResponse';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_QualityReviewer_Definition';
  flagOnly?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_QualityReviewer_Definition_Input = {
  flagOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Definition of a rule */
export type Instacart_Customers_Flyer_Pdf_V1_RuleDefinition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleDefinition';
  init?: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition>;
  postProcess?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition>;
  preProcess?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition>;
  process?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition>;
};

/** Definition of a rule */
export type Instacart_Customers_Flyer_Pdf_V1_RuleDefinition_Input = {
  init?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleDefinition_Input>;
  postProcess?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleDefinition_Input>;
  preProcess?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleDefinition_Input>;
  process?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleDefinition_Input>;
};

/**
 * Rule Evaluation Result - the result of a rule evaluation this is a wrapper
 * for a rule node
 */
export type Instacart_Customers_Flyer_Pdf_V1_RuleEvaluationResult = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleEvaluationResult';
  init?: Maybe<Instacart_Customers_Flyer_Pdf_V1_InitializationRuleResult>;
  postProcess?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PostProcessingRuleResult>;
  preProcess?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PreProcessingRuleResult>;
  process?: Maybe<Instacart_Customers_Flyer_Pdf_V1_ProcessingRuleResult>;
};

/** Rule Set - */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSet = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleSet';
  retailerId?: Maybe<Scalars['BigInt']>;
  ruleDefinitions?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleDefinition>>>;
};

/**
 * Rule Definition Evaluation - actual evaluation of rules works with a specific
 * pdf page
 */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSetEvaluation = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleSetEvaluation';
  /** The id of the flyer page */
  flyerPageId?: Maybe<Scalars['BigInt']>;
  /** The results of the rule evaluations */
  results?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleEvaluationResult>>>;
};

/**
 * Rule Run/Instance - works with a specific flyer 1-to-many PDF files, we
 * will use this for both runtime and debug/observability
 */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSetRun = {
  __typename?: 'instacart_customers_flyer_pdf_v1_RuleSetRun';
  evaluation?: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSetEvaluation>;
  /** DEPRECATED: use singular evaluation instead */
  evaluations?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSetEvaluation>>>;
  /** The input flyer */
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  /** The retailer id */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** Reference rule_set */
  ruleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet>;
  /** The id of the rule set run; uuid */
  ruleSetRunId?: Maybe<Scalars['String']>;
};

/** Rule Set - */
export type Instacart_Customers_Flyer_Pdf_V1_RuleSet_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleDefinitions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Flyer_Pdf_V1_RuleDefinition_Input>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_StubableDebugContext = {
  __typename?: 'instacart_customers_flyer_pdf_v1_StubableDebugContext';
  context?: Maybe<Instacart_Customers_Flyer_Pdf_V1_DebugContext>;
  stubRef?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextClassifier_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextClassifier_Debug';
  classificationSystemPrompt?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextCluster_Debug = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextCluster_Debug';
  correctionSystemPrompt?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextCluster_Definition';
  /** Buffer is basically a grace for intersection */
  buffer?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_TextCluster_Definition_Input = {
  /** Buffer is basically a grace for intersection */
  buffer?: InputMaybe<Scalars['BigInt']>;
};

/** A text element */
export type Instacart_Customers_Flyer_Pdf_V1_TextElement = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextElement';
  /** Block ID - BT/ET based on processing order - starts at 0 */
  blockId?: Maybe<Scalars['BigInt']>;
  /**
   * Block Instance ID - Each Tj/TJ  based on processing order - starts at 0,
   * resets each block
   */
  blockInstanceId?: Maybe<Scalars['BigInt']>;
  /** The generic data for the element */
  data?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /** Effective Height */
  effectiveHeight?: Maybe<Scalars['Float']>;
  /** Font Family */
  fontFamily?: Maybe<Scalars['String']>;
  /** Font Name */
  fontName?: Maybe<Scalars['String']>;
  /** font object id */
  fontObjectId?: Maybe<Scalars['BigInt']>;
  /** font resource name */
  fontResourceName?: Maybe<Scalars['String']>;
  /** Font Stretch */
  fontStretch?: Maybe<Scalars['String']>;
  /** Font Weight */
  fontWeight?: Maybe<Scalars['BigInt']>;
  /** Font Non-Stroking Alpha */
  nonStrokingAlpha?: Maybe<Scalars['Float']>;
  /** Font Non-Stroking Color (basically fill color) */
  nonStrokingColor?: Maybe<Instacart_Customers_Flyer_Pdf_V1_Color>;
  /**
   * Render mode
   * 0	Fill text (default, uses non-stroking color)
   * 1	Stroke text (uses stroking color)
   * 2	Fill, then stroke text (uses both)
   * 3	Invisible
   * 4	Fill text and add to clipping path
   * 5	Stroke text and add to clipping path
   * 6	Fill, stroke, and add to clipping path
   * 7	Add text to clipping path (no fill or stroke)
   */
  renderMode?: Maybe<Scalars['BigInt']>;
  /** Font Stroking Alpha */
  strokingAlpha?: Maybe<Scalars['Float']>;
  /** Font Non-Stroking Color (basically fill color) */
  strokingColor?: Maybe<Instacart_Customers_Flyer_Pdf_V1_Color>;
  /** The text of the element */
  text?: Maybe<Scalars['String']>;
  /** Transform Angle */
  transformAngle?: Maybe<Scalars['Float']>;
};

/** A group of text elements */
export type Instacart_Customers_Flyer_Pdf_V1_TextGroup = {
  __typename?: 'instacart_customers_flyer_pdf_v1_TextGroup';
  /** The combined text of the group */
  combinedText?: Maybe<Scalars['String']>;
  /** The generic data for the element */
  data?: Maybe<Instacart_Customers_Flyer_Pdf_V1_PdfElementData>;
  /** The text elements in the group */
  texts?: Maybe<Array<Maybe<Instacart_Customers_Flyer_Pdf_V1_TextElement>>>;
};

export type Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetEntity?: InputMaybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet_Input>;
  ruleSetJson?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_UpdateRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_UpdateRuleSetResponse';
  ruleSet?: Maybe<Instacart_Customers_Flyer_Pdf_V1_RuleSet>;
  ruleSetJson?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ruleSetJson?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Flyer_Pdf_V1_ValidateRuleSetResponse = {
  __typename?: 'instacart_customers_flyer_pdf_v1_ValidateRuleSetResponse';
  errorMessage?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Froth_V1_CompileTemplateRequest_Input = {
  /**
   * Optional values for each composable widget variable, keyed the same as
   * `content_schema`. Example: { "headline": "Celebrate with something sweet" }
   */
  content?: InputMaybe<Scalars['JSON']>;
  /**
   * Optional schema describing each composable widget variable, keyed by name.
   * Example: { "headline": { "type": "string", "displayName": "Headline" } }
   * When non-empty, every entry in `referenced_variables` must appear as a key.
   */
  contentSchema?: InputMaybe<Scalars['JSON']>;
  /** The template source string to compile. */
  template?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Froth_V1_CompileTemplateResponse = {
  __typename?: 'instacart_customers_froth_v1_CompileTemplateResponse';
  /** The compiled TreeNode[] AST as a JSON string. */
  astJson?: Maybe<Scalars['String']>;
  /**
   * Sorted, de-duplicated root variable names the template reads at render time.
   * Excludes locals (assign/capture/for-loop iterators) and built-ins (nil/true/false).
   */
  referencedVariables?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Request to create a new gift order digital card */
export type Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardRequest_Input = {
  /** Description of the digital card (e.g., "Happy Birthday") */
  description?: InputMaybe<Scalars['String']>;
  /** Image URL path for the digital card (e.g., "gifting/digital-card-happy-birthday.png") */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Locale for the digital card (e.g., "en_US") */
  locale?: InputMaybe<Scalars['String']>;
  /** Request context containing user and session information */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** Response containing the newly created gift order digital card */
export type Instacart_Customers_Gifting_V1_CreateGiftOrderDigitalCardResponse = {
  __typename?: 'instacart_customers_gifting_v1_CreateGiftOrderDigitalCardResponse';
  /** The created digital card */
  giftOrderDigitalCard?: Maybe<Instacart_Customers_Gifting_V1_GiftOrderDigitalCard>;
};

/** Request to get a gift order digital card by ID */
export type Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdRequest_Input = {
  /** ID of the digital card to retrieve */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Request context containing user and session information */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** Response containing the requested gift order digital card */
export type Instacart_Customers_Gifting_V1_GetGiftOrderDigitalCardByIdResponse = {
  __typename?: 'instacart_customers_gifting_v1_GetGiftOrderDigitalCardByIdResponse';
  /** The requested digital card */
  giftOrderDigitalCard?: Maybe<Instacart_Customers_Gifting_V1_GiftOrderDigitalCard>;
};

/** GiftOrderDigitalCard represents a digital card that can be attached to a gift order */
export type Instacart_Customers_Gifting_V1_GiftOrderDigitalCard = {
  __typename?: 'instacart_customers_gifting_v1_GiftOrderDigitalCard';
  /** CDN URL for the digital card image */
  cdnUrl?: Maybe<Scalars['String']>;
  /** Timestamp when the card was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Description of the digital card (e.g., "Happy Birthday") */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the digital card */
  id?: Maybe<Scalars['BigInt']>;
  /** Image URL path for the digital card (e.g., "gifting/digital-card-happy-birthday.png") */
  imageUrl?: Maybe<Scalars['String']>;
  /** Locale for the digital card (e.g., "en_US") */
  locale?: Maybe<Scalars['String']>;
  /** Timestamp when the card was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Request to update an existing gift order digital card */
export type Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardRequest_Input = {
  /** Optional: Updated description of the digital card */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the digital card to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Optional: Updated image URL path */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Optional: Updated locale */
  locale?: InputMaybe<Scalars['String']>;
  /** Request context containing user and session information */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

/** Response containing the updated gift order digital card */
export type Instacart_Customers_Gifting_V1_UpdateGiftOrderDigitalCardResponse = {
  __typename?: 'instacart_customers_gifting_v1_UpdateGiftOrderDigitalCardResponse';
  /** The updated digital card */
  giftOrderDigitalCard?: Maybe<Instacart_Customers_Gifting_V1_GiftOrderDigitalCard>;
};

export enum Instacart_Customers_Loyalty_Admin_V1_AccountDisplayMode {
  /** Account section is hidden. */
  AccountDisplayModeHidden = 'ACCOUNT_DISPLAY_MODE_HIDDEN',
  /** Unspecified account display mode. */
  AccountDisplayModeUnspecified = 'ACCOUNT_DISPLAY_MODE_UNSPECIFIED',
  /** Account section is visible. */
  AccountDisplayModeVisible = 'ACCOUNT_DISPLAY_MODE_VISIBLE'
}

export enum Instacart_Customers_Loyalty_Admin_V1_BarcodeDisplayMode {
  /** Barcode is hidden. */
  BarcodeDisplayModeHidden = 'BARCODE_DISPLAY_MODE_HIDDEN',
  /** Barcode is displayed inline. */
  BarcodeDisplayModeInline = 'BARCODE_DISPLAY_MODE_INLINE',
  /** Unspecified barcode display mode. */
  BarcodeDisplayModeUnspecified = 'BARCODE_DISPLAY_MODE_UNSPECIFIED'
}

/** DEPRECATED: This enum is no longer used. */
export enum Instacart_Customers_Loyalty_Admin_V1_BenefitType {
  AdditionalBenefits = 'ADDITIONAL_BENEFITS',
  /** Unspecified benefit type. */
  BenefitTypeUnspecified = 'BENEFIT_TYPE_UNSPECIFIED',
  DigitalCoupons = 'DIGITAL_COUPONS',
  LoyaltyPricing = 'LOYALTY_PRICING',
  PersonalizedDeals = 'PERSONALIZED_DEALS',
  PointsBalance = 'POINTS_BALANCE',
  PointsEarning = 'POINTS_EARNING',
  PointsRedemptionGas = 'POINTS_REDEMPTION_GAS',
  PointsRedemptionGrocery = 'POINTS_REDEMPTION_GROCERY'
}

/** Request to create a loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitRequest_Input = {
  /** Loyalty benefit to create. */
  loyaltyBenefit?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitCreate_Input>;
};

/** Response containing the created loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyBenefitResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_CreateLoyaltyBenefitResponse';
  /** Created loyalty benefit. */
  loyaltyBenefit?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit>;
};

/** Request to create a loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationRequest_Input = {
  /** Loyalty card validation to create. */
  loyaltyCardValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationCreate_Input>;
};

/** Response containing the created loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyCardValidationResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_CreateLoyaltyCardValidationResponse';
  /** Created loyalty card validation. */
  loyaltyCardValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation>;
};

/** Request to create a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramRequest_Input = {
  /** Loyalty program to create. */
  loyaltyProgram?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramCreate_Input>;
};

/** Response containing the created loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_CreateLoyaltyProgramResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_CreateLoyaltyProgramResponse';
  /** Created loyalty program. */
  loyaltyProgram?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram>;
};

/** Request to delete a loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_DeleteLoyaltyCardValidationRequest_Input = {
  /** ID of the card validation to delete. */
  loyaltyCardValidationId?: InputMaybe<Scalars['BigInt']>;
  /** Retailer ID the card validation belongs to. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Retailer-defined external URL with a display label. */
export type Instacart_Customers_Loyalty_Admin_V1_ExternalUrl = {
  __typename?: 'instacart_customers_loyalty_admin_v1_ExternalUrl';
  /** Display label for the URL. */
  label?: Maybe<Scalars['String']>;
  /** URL to navigate to. */
  url?: Maybe<Scalars['String']>;
};

/**
 * Wrapper for a list of external URLs, used in update messages to distinguish
 * "don't change URLs" (field absent) from "clear all URLs" (field present, urls empty).
 */
export type Instacart_Customers_Loyalty_Admin_V1_ExternalUrlList_Input = {
  urls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Loyalty_Admin_V1_ExternalUrl_Input>>>;
};

/** Retailer-defined external URL with a display label. */
export type Instacart_Customers_Loyalty_Admin_V1_ExternalUrl_Input = {
  /** Display label for the URL. */
  label?: InputMaybe<Scalars['String']>;
  /** URL to navigate to. */
  url?: InputMaybe<Scalars['String']>;
};

/** Request to get loyalty benefits for a program. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsRequest_Input = {
  /** Loyalty program the benefits belong to. */
  loyaltyProgramId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the loyalty benefits. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyBenefitsResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_GetLoyaltyBenefitsResponse';
  /** Loyalty benefits. */
  loyaltyBenefits?: Maybe<Array<Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit>>>;
};

/** Request to get loyalty card validations for a retailer. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsRequest_Input = {
  /** Retailer ID to get validations for. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the loyalty card validations. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyCardValidationsResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_GetLoyaltyCardValidationsResponse';
  /** Loyalty card validations. */
  loyaltyCardValidations?: Maybe<Array<Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation>>>;
};

/** Request to get a loyalty program by retailer and store configuration. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramRequest_Input = {
  /** Retailer ID the loyalty program is subject to. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Store configuration ID the loyalty program is subject to. */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_GetLoyaltyProgramResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_GetLoyaltyProgramResponse';
  /** Get loyalty program. */
  loyaltyProgram?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram>;
};

export enum Instacart_Customers_Loyalty_Admin_V1_HeaderDisplayMode {
  /** Background image only, no name or logo. */
  HeaderDisplayModeImageOnly = 'HEADER_DISPLAY_MODE_IMAGE_ONLY',
  /** Name and logo only, no background image. */
  HeaderDisplayModeNameAndLogoOnly = 'HEADER_DISPLAY_MODE_NAME_AND_LOGO_ONLY',
  /** Overlay layout with background image and logo overlaid. */
  HeaderDisplayModeOverlay = 'HEADER_DISPLAY_MODE_OVERLAY',
  /** Stacked layout with background image and logo. */
  HeaderDisplayModeStacked = 'HEADER_DISPLAY_MODE_STACKED',
  /** Unspecified header display mode. */
  HeaderDisplayModeUnspecified = 'HEADER_DISPLAY_MODE_UNSPECIFIED'
}

export type Instacart_Customers_Loyalty_Admin_V1_Image = {
  __typename?: 'instacart_customers_loyalty_admin_v1_Image';
  /** Alt text for accessibility. */
  altText?: Maybe<Scalars['String']>;
  /** Image URL. */
  imageUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Loyalty_Admin_V1_Image_Input = {
  /** Alt text for accessibility. */
  altText?: InputMaybe<Scalars['String']>;
  /** Image URL. */
  imageUrl?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Loyalty_Admin_V1_InputFieldType {
  /** Loyalty card number input. */
  CardNumber = 'CARD_NUMBER',
  /** Email address input. */
  Email = 'EMAIL',
  /** Unspecified input field type. */
  InputFieldTypeUnspecified = 'INPUT_FIELD_TYPE_UNSPECIFIED',
  /** Phone number input. */
  PhoneNumber = 'PHONE_NUMBER',
  /** Single Sign-On authentication. */
  Sso = 'SSO'
}

/** A benefit offered as part of a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyBenefit';
  /** Benefit description text. */
  benefitDescription?: Maybe<Scalars['String']>;
  /** Logo image for the benefit. */
  benefitLogo?: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Benefit name/heading. */
  benefitName?: Maybe<Scalars['String']>;
  /** Display rank/order for the benefit. */
  benefitRank?: Maybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  benefitType?: Maybe<Instacart_Customers_Loyalty_Admin_V1_BenefitType>;
  /** Whether this benefit is enabled. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Loyalty benefit ID */
  loyaltyBenefitId?: Maybe<Scalars['BigInt']>;
  /** Loyalty program ID this benefit belongs to. */
  loyaltyProgramId?: Maybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

/** Create payload for LoyaltyBenefit (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitCreate_Input = {
  benefitDescription?: InputMaybe<Scalars['String']>;
  benefitLogo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  benefitName?: InputMaybe<Scalars['String']>;
  benefitRank?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  benefitType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_BenefitType>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  loyaltyProgramId?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Update payload for LoyaltyBenefit (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitUpdate_Input = {
  benefitDescription?: InputMaybe<Scalars['String']>;
  benefitLogo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  benefitName?: InputMaybe<Scalars['String']>;
  benefitRank?: InputMaybe<Scalars['BigInt']>;
  /** DEPRECATED: This column is not used. */
  benefitType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_BenefitType>;
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/** A rule used to validate loyalty card numbers. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation';
  /** Validate that the card number begins with specific leading digits. */
  leadingDigitValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation>;
  /** Validate that the card number has an exact length. */
  lengthValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation>;
  /** Loyalty card validation ID. */
  loyaltyCardValidationId?: Maybe<Scalars['BigInt']>;
  /** Validate that the card number falls within a numeric range. */
  rangeValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation>;
  /** Validate that the card number matches a regular expression. */
  regex?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation>;
  /** Retailer ID this validation applies to. */
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** Create payload for LoyaltyCardValidation (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationCreate_Input = {
  leadingDigitValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation_Input>;
  lengthValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation_Input>;
  rangeValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation_Input>;
  regex?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Update payload for LoyaltyCardValidation (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationUpdate_Input = {
  leadingDigitValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation_Input>;
  lengthValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation_Input>;
  rangeValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation_Input>;
  regex?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation_Input>;
};

/** Validation based on the leading digits of the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_LeadingDigitValidation';
  /** Optional. Length condition for validation applicability. */
  forLength?: Maybe<Scalars['BigInt']>;
  /** Leading digits that the card number must start with. */
  leadingDigits?: Maybe<Scalars['String']>;
};

/** Validation based on the leading digits of the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LeadingDigitValidation_Input = {
  /** Optional. Length condition for validation applicability. */
  forLength?: InputMaybe<Scalars['BigInt']>;
  /** Leading digits that the card number must start with. */
  leadingDigits?: InputMaybe<Scalars['String']>;
};

/** Exact length required for the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_LengthValidation';
  /** Exact length to match. */
  length?: Maybe<Scalars['BigInt']>;
};

/** Exact length required for the card number. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_LengthValidation_Input = {
  /** Exact length to match. */
  length?: InputMaybe<Scalars['BigInt']>;
};

/** Inclusive numeric range for card numbers. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_RangeValidation';
  /** Optional. Length condition for validation applicability. */
  forLength?: Maybe<Scalars['BigInt']>;
  /** Inclusive upper bound of the range. */
  high?: Maybe<Scalars['String']>;
  /** Inclusive lower bound of the range. */
  low?: Maybe<Scalars['String']>;
};

/** Inclusive numeric range for card numbers. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RangeValidation_Input = {
  /** Optional. Length condition for validation applicability. */
  forLength?: InputMaybe<Scalars['BigInt']>;
  /** Inclusive upper bound of the range. */
  high?: InputMaybe<Scalars['String']>;
  /** Inclusive lower bound of the range. */
  low?: InputMaybe<Scalars['String']>;
};

/** Regex card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyCardValidation_RegexValidation';
  /** Regex pattern (this is used by Ruby's Regexp.new class to validate numbers). */
  regex?: Maybe<Scalars['String']>;
};

/** Regex card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation_RegexValidation_Input = {
  /** Regex pattern (this is used by Ruby's Regexp.new class to validate numbers). */
  regex?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram = {
  __typename?: 'instacart_customers_loyalty_admin_v1_LoyaltyProgram';
  /** Account display mode controlling account section visibility. */
  accountDisplayMode?: Maybe<Instacart_Customers_Loyalty_Admin_V1_AccountDisplayMode>;
  /** Whether this is an admin loyalty program. */
  admin?: Maybe<Scalars['Boolean']>;
  /** Background color theme for the UI. */
  backgroundColorTheme?: Maybe<Instacart_Customers_Loyalty_Admin_V1_Theme>;
  /** Background image for the loyalty program UI. */
  backgroundImage?: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Mobile-specific background image for the hub header. */
  backgroundImageMobile?: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Barcode display mode controlling barcode visibility. */
  barcodeDisplayMode?: Maybe<Instacart_Customers_Loyalty_Admin_V1_BarcodeDisplayMode>;
  /** Primary disclaimer text. */
  disclaimer_1?: Maybe<Scalars['String']>;
  /** Secondary disclaimer text. */
  disclaimer_2?: Maybe<Scalars['String']>;
  /** Whether this loyalty program earns points. */
  earnsPoints?: Maybe<Scalars['Boolean']>;
  /** Retailer-defined external URLs. */
  externalUrls?: Maybe<Array<Maybe<Instacart_Customers_Loyalty_Admin_V1_ExternalUrl>>>;
  /** Formatted description text displayed to users. */
  formattedDescriptionText?: Maybe<Scalars['String']>;
  /** Header display mode controlling the hub header layout. */
  headerDisplayMode?: Maybe<Instacart_Customers_Loyalty_Admin_V1_HeaderDisplayMode>;
  /** Input type for linking loyalty programs. Can be email, phone, card number, or SSO. */
  inputFieldType?: Maybe<Instacart_Customers_Loyalty_Admin_V1_InputFieldType>;
  /** Logo image for the loyalty program. */
  logo?: Maybe<Instacart_Customers_Loyalty_Admin_V1_Image>;
  /** Label text for loyalty input field. */
  loyaltyInputLabel?: Maybe<Scalars['String']>;
  /** Loyalty program ID */
  loyaltyProgramId?: Maybe<Scalars['BigInt']>;
  /** Loyalty program name. */
  loyaltyProgramName?: Maybe<Scalars['String']>;
  /** URL for loyalty program signup. */
  loyaltySignupUrl?: Maybe<Scalars['String']>;
  /** Privacy policy URL. */
  privacyPolicyUrl?: Maybe<Scalars['String']>;
  /** Retailer ID for the retailer the loyalty program is subject to. */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** SSO configuration for authentication. */
  ssoConfiguration?: Maybe<Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration>;
  /** Store configuration ID the loyalty program is subject to. */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Terms of service URL. */
  termsUrl?: Maybe<Scalars['String']>;
};

/** Create payload for LoyaltyProgram (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramCreate_Input = {
  admin?: InputMaybe<Scalars['Boolean']>;
  backgroundColorTheme?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Theme>;
  backgroundImage?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  disclaimer_1?: InputMaybe<Scalars['String']>;
  disclaimer_2?: InputMaybe<Scalars['String']>;
  earnsPoints?: InputMaybe<Scalars['Boolean']>;
  formattedDescriptionText?: InputMaybe<Scalars['String']>;
  inputFieldType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_InputFieldType>;
  logo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  loyaltyInputLabel?: InputMaybe<Scalars['String']>;
  loyaltyProgramName?: InputMaybe<Scalars['String']>;
  loyaltySignupUrl?: InputMaybe<Scalars['String']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  ssoConfiguration?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration_Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  termsUrl?: InputMaybe<Scalars['String']>;
};

/** Update payload for LoyaltyProgram (no ID included) */
export type Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramUpdate_Input = {
  /** Account display mode controlling account section visibility. */
  accountDisplayMode?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_AccountDisplayMode>;
  admin?: InputMaybe<Scalars['Boolean']>;
  backgroundColorTheme?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Theme>;
  backgroundImage?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  /** Mobile-specific background image for the hub header. */
  backgroundImageMobile?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  /** Barcode display mode controlling barcode visibility. */
  barcodeDisplayMode?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_BarcodeDisplayMode>;
  disclaimer_1?: InputMaybe<Scalars['String']>;
  disclaimer_2?: InputMaybe<Scalars['String']>;
  earnsPoints?: InputMaybe<Scalars['Boolean']>;
  /**
   * Retailer-defined external URLs. If absent, URLs are not changed.
   * If present (even with an empty list), URLs are replaced.
   */
  externalUrls?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_ExternalUrlList_Input>;
  formattedDescriptionText?: InputMaybe<Scalars['String']>;
  /** Header display mode controlling the hub header layout. */
  headerDisplayMode?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_HeaderDisplayMode>;
  inputFieldType?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_InputFieldType>;
  logo?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_Image_Input>;
  loyaltyInputLabel?: InputMaybe<Scalars['String']>;
  loyaltyProgramName?: InputMaybe<Scalars['String']>;
  loyaltySignupUrl?: InputMaybe<Scalars['String']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']>;
  ssoConfiguration?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration_Input>;
  termsUrl?: InputMaybe<Scalars['String']>;
};

/** SSO Configuration for authenticating and linking users to a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration = {
  __typename?: 'instacart_customers_loyalty_admin_v1_SsoConfiguration';
  /** Access token URI for SSO token exchange. */
  accessTokenUri?: Maybe<Scalars['String']>;
  /** Authorization URI for SSO flow. */
  authorizeUri?: Maybe<Scalars['String']>;
  /** Client ID for SSO authentication. */
  clientId?: Maybe<Scalars['String']>;
  /** Client secret for SSO authentication. */
  clientSecret?: Maybe<Scalars['String']>;
  /** Redirect URI for SSO callback. */
  redirectUri?: Maybe<Scalars['String']>;
  /** SSO response type (e.g., "code"). */
  responseType?: Maybe<Scalars['String']>;
  /** OAuth scope for SSO authentication. */
  scope?: Maybe<Scalars['String']>;
};

/** SSO Configuration for authenticating and linking users to a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_SsoConfiguration_Input = {
  /** Access token URI for SSO token exchange. */
  accessTokenUri?: InputMaybe<Scalars['String']>;
  /** Authorization URI for SSO flow. */
  authorizeUri?: InputMaybe<Scalars['String']>;
  /** Client ID for SSO authentication. */
  clientId?: InputMaybe<Scalars['String']>;
  /** Client secret for SSO authentication. */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** Redirect URI for SSO callback. */
  redirectUri?: InputMaybe<Scalars['String']>;
  /** SSO response type (e.g., "code"). */
  responseType?: InputMaybe<Scalars['String']>;
  /** OAuth scope for SSO authentication. */
  scope?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Loyalty_Admin_V1_Theme {
  /** Dark color theme. */
  Dark = 'DARK',
  /** Light color theme. */
  Light = 'LIGHT',
  /** Unspecified theme. */
  ThemeUnspecified = 'THEME_UNSPECIFIED'
}

/** Request to update a loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitRequest_Input = {
  /** Loyalty beneift subject to update */
  loyaltyBenefit?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefitUpdate_Input>;
  /** ID of the loyalty benefit to update. */
  loyaltyBenefitId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated loyalty benefit. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyBenefitResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_UpdateLoyaltyBenefitResponse';
  /** Updated loyalty benefit. */
  loyaltyBenefit?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyBenefit>;
};

/** Request to update a loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationRequest_Input = {
  /** Loyalty card validation to update */
  loyaltyCardValidation?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidationUpdate_Input>;
  /** ID of the card validation to update. */
  loyaltyCardValidationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated loyalty card validation. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyCardValidationResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_UpdateLoyaltyCardValidationResponse';
  /** Updated loyalty card validation. */
  loyaltyCardValidation?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyCardValidation>;
};

/** Request to update a loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramRequest_Input = {
  /** Updated Loyalty Program Data */
  loyaltyProgram?: InputMaybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgramUpdate_Input>;
  /** ID of the loyalty program to update. */
  loyaltyProgramId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated loyalty program. */
export type Instacart_Customers_Loyalty_Admin_V1_UpdateLoyaltyProgramResponse = {
  __typename?: 'instacart_customers_loyalty_admin_v1_UpdateLoyaltyProgramResponse';
  /** Updated loyalty program. */
  loyaltyProgram?: Maybe<Instacart_Customers_Loyalty_Admin_V1_LoyaltyProgram>;
};

/** Get loyalty cards by card number */
export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberRequest_Input = {
  /** Card number. */
  cardNumber?: InputMaybe<Scalars['String']>;
  /** Retailer IDs. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsByCardNumberResponse = {
  __typename?: 'instacart_customers_loyalty_v1_GetLoyaltyCardsByCardNumberResponse';
  /** Loyalty cards. */
  loyaltyCards?: Maybe<Array<Maybe<Instacart_Customers_Loyalty_V1_LoyaltyCard>>>;
};

/** Optional filters for the operation. */
export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Filter_Input = {
  /** Filter to Limit the loyalty card retrieval to the specified retailers. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Input = {
  /** Optional filters, if applicable. */
  filter?: InputMaybe<Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserRequest_Filter_Input>;
  /** This parameter is no longer used, it used to provide pagination controls for the request. */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  /** The Request Context. */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  /** Optional field to skip loyalty card status check. Defaults to false. */
  skipLoyaltyStatusCheck?: InputMaybe<Scalars['Boolean']>;
  /** The user ID of the user to query loyalty cards for. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Loyalty_V1_GetLoyaltyCardsForUserResponse = {
  __typename?: 'instacart_customers_loyalty_v1_GetLoyaltyCardsForUserResponse';
  /** Loyalty cards that were found. */
  loyaltyCards?: Maybe<Array<Maybe<Instacart_Customers_Loyalty_V1_LoyaltyCard>>>;
  /** This parameter is no longer used. It used to provide page info to work in conjunction with the pagination parameter. */
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Loyalty_V1_LoyaltyCard = {
  __typename?: 'instacart_customers_loyalty_v1_LoyaltyCard';
  /** Authentication type. */
  authenticatedType?: Maybe<Scalars['String']>;
  /** Loyalty card number. */
  cardNumber?: Maybe<Scalars['String']>;
  /** Loyalty card ID. */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Loyalty membership tier.
   * mirror the loyalty_tier in instacart.customers.commerce.types.v1.LoyaltyCard
   */
  loyaltyTier?: Maybe<Scalars['String']>;
  /** Retailer ID. */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** Loyalty card status. */
  status?: Maybe<Instacart_Customers_Loyalty_V1_LoyaltyCard_Status>;
  /** User ID. */
  userId?: Maybe<Scalars['BigInt']>;
};

/** Loyalty card status enum. */
export enum Instacart_Customers_Loyalty_V1_LoyaltyCard_Status {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
  NotFound = 'NOT_FOUND',
  PendingOtp = 'PENDING_OTP',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  Temp = 'TEMP',
  Valid = 'VALID'
}

/** RequestMeta provides optional metadata about the request source and debugging preferences. */
export type Instacart_Customers_Meals_RequestMeta_Input = {
  /**
   * Optional - Debug mode flag (default: false)
   * When true, enables verbose logging and additional diagnostic information
   */
  debug?: InputMaybe<Scalars['Boolean']>;
  /** Optional - Upstream source of the request (e.g. ipp_tooling, ads_tooling, idp_api) */
  src?: InputMaybe<Scalars['String']>;
};

/** ResponseMeta provides diagnostic information about the request execution. */
export type Instacart_Customers_Meals_ResponseMeta = {
  __typename?: 'instacart_customers_meals_ResponseMeta';
  /**
   * Optional - Debug information (only populated when RequestMeta.debug = true)
   * Can contain diagnostic data such as scope counts, cache hit/miss, etc.
   */
  debug?: Maybe<Scalars['JSON']>;
  /** Request ID for distributed tracing */
  requestId?: Maybe<Scalars['String']>;
};

/** CreatePublisherRequest creates a new publisher with associated metadata. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreatePublisherRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Publisher data to create */
  publisher?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_PublisherInput_Input>;
  /** Optional - Request metadata including source, variant, and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** CreatePublisherResponse contains the created publisher and response metadata. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreatePublisherResponse = {
  __typename?: 'instacart_customers_meals_endpoints_ingestion_v1_CreatePublisherResponse';
  /** Response metadata including request_id, duration, and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Created publisher data with generated ID and all associated fields */
  publisher?: Maybe<Instacart_Customers_Meals_Types_V1_Publisher>;
};

/** CreateRecipeRequest creates a new recipe with all associated data. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreateRecipeRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Recipe data to create */
  recipe?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_RecipeInput_Input>;
  /** Optional - Request metadata including source and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** CreateRecipeResponse contains the created recipe and response metadata. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_CreateRecipeResponse = {
  __typename?: 'instacart_customers_meals_endpoints_ingestion_v1_CreateRecipeResponse';
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Created recipe with generated ID and all associated data */
  recipe?: Maybe<Instacart_Customers_Meals_Types_V1_Recipe>;
};

/** PublisherInput contains provider/source data. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_PublisherInput_Input = {
  /** Optional - URL to the provider/source avatar image. */
  avatarUrl?: InputMaybe<Scalars['String']>;
  /** Deprecated. Client-configuration availability is represented by scopes. */
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** Optional - Provider/source description. */
  description?: InputMaybe<Scalars['String']>;
  /** Optional - Legacy content creator ID for migration tracking. */
  legacyContentCreatorId?: InputMaybe<Scalars['BigInt']>;
  /** Required - Provider/source display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Optional - Initial provider-level permission rules written atomically with the provider/source row. */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_PermissionRule_Input>>>;
  /** Optional - Explicit provider/source ID (KSUID string). If empty, a nanoid is generated on create. */
  publisherId?: InputMaybe<Scalars['String']>;
  /** Optional - Availability scopes for this provider/source. */
  scopes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_PublisherScope_Input>>>;
  /** Optional - URL-friendly identifier. If omitted, one may be generated from name. */
  slug?: InputMaybe<Scalars['String']>;
  /**
   * Required - Content source classification for this publisher. When a
   * publisher and recipe are created together via UnifiedCreateRecipe,
   * the recipe's content_type is used as the publisher source regardless.
   */
  source?: InputMaybe<Instacart_Customers_Meals_Types_V1_ContentType>;
  /** Deprecated. User recipe imports are represented separately from providers/sources. */
  userId?: InputMaybe<Scalars['BigInt']>;
  /** Optional - Provider/source website URL. */
  website?: InputMaybe<Scalars['String']>;
};

/** RecipeInput contains the data for creating a new recipe. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_RecipeInput_Input = {
  /** Optional - Active cooking time in minutes */
  activeTimeMinutes?: InputMaybe<Scalars['Int']>;
  /** Optional - Attribute IDs assigned to this recipe */
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional - Recipe author name */
  author?: InputMaybe<Scalars['String']>;
  /** Required - Content type classification */
  contentType?: InputMaybe<Instacart_Customers_Meals_Types_V1_ContentType>;
  /** Optional - Recipe textual description */
  description?: InputMaybe<Instacart_Customers_Meals_Types_V1_RecipeDescription_Input>;
  /**
   * Optional - When true, skips ingredient parsing after the recipe is written.
   * Parsed ingredient state from a prior version is preserved as-is.
   */
  disableIngredientParsing?: InputMaybe<Scalars['Boolean']>;
  /** Optional - Whether pantry ingredient identification is enabled for this recipe (default: true) */
  enablePantryItems?: InputMaybe<Scalars['Boolean']>;
  /** Optional - Time after which the recipe is no longer active */
  expiryTime?: InputMaybe<Scalars['DateTime']>;
  /** Optional - Frequently asked questions */
  faqs?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_Faq_Input>>>;
  /** Optional - Recipe images */
  images?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_RecipeImage_Input>>>;
  /** Optional - User account importing this recipe. */
  importerUserId?: InputMaybe<Scalars['BigInt']>;
  /** Optional - Preparation instructions */
  instructions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_Instruction_Input>>>;
  /** Optional - IPP account canonical identifier */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** Optional - Legacy recipe ID for migration tracking */
  legacyRecipeId?: InputMaybe<Scalars['BigInt']>;
  /** Required - Recipe display name */
  name?: InputMaybe<Scalars['String']>;
  /** Optional - Nutritional information */
  nutritionFacts?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_NutritionFact_Input>>>;
  /**
   * Optional - Initial recipe-level permission overrides written to recipe_permissions
   * atomically with the recipe row
   */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_PermissionRule_Input>>>;
  /** Optional - Preparation time in minutes */
  prepTimeMinutes?: InputMaybe<Scalars['Int']>;
  /** Optional - Provider's recipe identifier for deduplication */
  providerRecipeId?: InputMaybe<Scalars['String']>;
  /** Optional - Original recipe URL from provider */
  providerRecipeUrl?: InputMaybe<Scalars['String']>;
  /** Required - Provider/source for this recipe (KSUID string). */
  publisherId?: InputMaybe<Scalars['String']>;
  /** Optional - Ingredients list */
  rawIngredients?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_RawIngredient_Input>>>;
  /** Optional - Explicit recipe ID (KSUID string). If empty, a nanoid is generated on create. */
  recipeId?: InputMaybe<Scalars['String']>;
  /** Optional - Maximum servings */
  servingsMax?: InputMaybe<Scalars['Int']>;
  /** Optional - Minimum servings */
  servingsMin?: InputMaybe<Scalars['Int']>;
  /** Required - URL-friendly identifier, unique per publisher */
  slug?: InputMaybe<Scalars['String']>;
  /** Optional - Total time in minutes */
  totalTimeMinutes?: InputMaybe<Scalars['Int']>;
};

/**
 * SetPublisherPermissionsRequest upserts provider-level permission rules for an existing provider/source.
 * Each incoming rule is merged by action: if a rule with the same action already exists
 * it is replaced; rules for actions not present in the request are left unchanged.
 */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetPublisherPermissionsRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /**
   * Required - Permission rules to upsert. Each rule is keyed by action; an empty list
   * is valid and leaves existing permissions unchanged.
   */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_PermissionRule_Input>>>;
  /** Required - Provider/source to update permissions for (KSUID string, must be non-empty) */
  publisherId?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source, variant, and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** SetPublisherPermissionsResponse confirms the upsert and returns response metadata. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetPublisherPermissionsResponse = {
  __typename?: 'instacart_customers_meals_endpoints_ingestion_v1_SetPublisherPermissionsResponse';
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
};

/**
 * SetRecipePermissionsRequest upserts permission rules for an existing recipe.
 * Each incoming rule is merged by action: if a rule with the same action already exists
 * it is replaced; rules for actions not present in the request are left unchanged.
 */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetRecipePermissionsRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /**
   * Required - Permission rules to upsert. Each rule is keyed by action; an empty list
   * is valid and leaves existing permissions unchanged.
   */
  permissions?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_PermissionRule_Input>>>;
  /** Required - Recipe to update permissions for (KSUID string, must be non-empty) */
  recipeId?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source, variant, and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** SetRecipePermissionsResponse confirms the upsert and returns response metadata. */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_SetRecipePermissionsResponse = {
  __typename?: 'instacart_customers_meals_endpoints_ingestion_v1_SetRecipePermissionsResponse';
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
};

/**
 * UnifiedCreateRecipeRequest is shared by two RPCs:
 *
 * ResetPublisherAndRecipe — replaces all mutable publisher and recipe data
 * atomically. publisher.publisher_id identifies the publisher to reset;
 * recipe.recipe_id identifies the recipe to reset (must be owned by that
 * publisher). recipe_raw_ingredients rows are reset along with the recipe,
 * but parsed ingredient information is preserved. If reparsing is needed,
 * trigger it separately after the reset completes.
 *
 * UnifiedCreateRecipe — creates a publisher and recipe together. The
 * publisher is reused if one with the same avatar_url and source already
 * exists. The recipe is created only when no duplicate is found (matched
 * by content_hash or provider_recipe_id); otherwise the existing recipe is
 * returned unchanged.
 */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_UnifiedCreateRecipeRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /**
   * Optional - Parent recipe this recipe derives from. Null when the recipe has
   * no parent (KSUID string when set).
   */
  parentRecipeId?: InputMaybe<Scalars['String']>;
  /**
   * Required - Publisher data. For ResetPublisherAndRecipe, publisher_id must
   * identify an existing publisher. For UnifiedCreateRecipe, publisher is
   * created or reused if one with the same avatar_url and source already exists.
   */
  publisher?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_PublisherInput_Input>;
  /**
   * Required - Recipe data. For ResetPublisherAndRecipe, recipe_id must
   * identify an existing recipe owned by publisher.publisher_id; all mutable
   * fields except raw_ingredients are replaced. For UnifiedCreateRecipe,
   * the recipe is created unless a duplicate is detected, in which case the
   * existing recipe is returned unchanged.
   */
  recipe?: InputMaybe<Instacart_Customers_Meals_Endpoints_Ingestion_V1_RecipeInput_Input>;
  /** Optional - Request metadata */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/**
 * UnifiedCreateRecipeResponse is shared by ResetPublisherAndRecipe and
 * UnifiedCreateRecipe. For ResetPublisherAndRecipe it carries the updated
 * publisher and recipe after the atomic reset. For UnifiedCreateRecipe it
 * carries the resolved publisher (newly created or pre-existing) and the
 * created recipe (or the pre-existing duplicate if one was found).
 */
export type Instacart_Customers_Meals_Endpoints_Ingestion_V1_UnifiedCreateRecipeResponse = {
  __typename?: 'instacart_customers_meals_endpoints_ingestion_v1_UnifiedCreateRecipeResponse';
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  publisher?: Maybe<Instacart_Customers_Meals_Types_V1_Publisher>;
  recipe?: Maybe<Instacart_Customers_Meals_Types_V1_Recipe>;
};

/**
 * GetAllowedActionsByRecipeIDRequest evaluates all known actions for a single
 * recipe under the request scope. Two request shapes are supported:
 * - flow_context derives scope from shop data.
 * - internal_context carries an explicit provider/source ID.
 */
export type Instacart_Customers_Meals_Endpoints_Permissions_V1_GetAllowedActionsByRecipeIdRequest_Input = {
  /**
   * Provides scope through a shop block with retailer_id and store_configuration_id
   * in client.application.application_identifier.
   */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Provides explicit provider/source identity when FlowContext-derived scope is not used. */
  internalContext?: InputMaybe<Instacart_Customers_Meals_Endpoints_Permissions_V1_InternalContext_Input>;
  /** Required - Recipe to evaluate (KSUID string, must be non-empty). */
  recipeId?: InputMaybe<Scalars['String']>;
  /** Optional */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/**
 * GetAllowedActionsByRecipeIDResponse contains all actions that passed layered
 * permission evaluation. Denied actions are omitted. An empty allowed_actions
 * list is a valid success response when the recipe has no matching permission rows.
 */
export type Instacart_Customers_Meals_Endpoints_Permissions_V1_GetAllowedActionsByRecipeIdResponse = {
  __typename?: 'instacart_customers_meals_endpoints_permissions_v1_GetAllowedActionsByRecipeIDResponse';
  /**
   * All actions whose layered evaluation produced permitted = true.
   * Sorted by enum declaration order. Denied actions are omitted. May be empty.
   */
  allowedActions?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_Action>>>;
  /** Response metadata including request_id and optional debug info. */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
};

/** InternalContext carries explicit provider/source identity. */
export type Instacart_Customers_Meals_Endpoints_Permissions_V1_InternalContext_Input = {
  /** Required — provider/source ID for permission evaluation (KSUID string, must be non-empty). */
  publisherId?: InputMaybe<Scalars['String']>;
};

/** GetEligibleAttributesRequest retrieves all active, eligible recipe attributes. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetEligibleAttributesRequest_Input = {
  /** Required - Flow context for request tracking */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Optional - Request metadata including source and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** GetEligibleAttributesResponse contains all active, eligible recipe attributes. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetEligibleAttributesResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetEligibleAttributesResponse';
  /** Flat list of all active attributes (orphaned children excluded) */
  attributes?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_RecipeAttribute>>>;
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
};

/** GetPublisherByLegacyContentCreatorIdRequest retrieves a provider/source by its legacy content creator ID. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherByLegacyContentCreatorIdRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Legacy content creator ID to look up (must be greater than 0) */
  legacyContentCreatorId?: InputMaybe<Scalars['BigInt']>;
  /** Optional - Request metadata including source and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** GetPublisherByLegacyContentCreatorIdResponse contains provider/source details and response metadata. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherByLegacyContentCreatorIdResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetPublisherByLegacyContentCreatorIdResponse';
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Provider/source data with all associated scopes. */
  publisher?: Maybe<Instacart_Customers_Meals_Types_V1_Publisher>;
};

/** GetPublisherRequest retrieves a provider/source by ID with associated metadata and scopes. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Provider/source ID to retrieve (KSUID string, must be non-empty) */
  publisherId?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source, variant, and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** GetPublisherResponse contains provider/source details and response metadata. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetPublisherResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetPublisherResponse';
  /** Response metadata including request_id, duration, and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Provider/source data with all associated scopes. */
  publisher?: Maybe<Instacart_Customers_Meals_Types_V1_Publisher>;
};

/**
 * GetRecipeIdBySparkRecipeIdRequest retrieves the meals recipe ID corresponding
 * to a given Spark recipe ID.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeIdBySparkRecipeIdRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /**
   * Optional - When true, skips the parsed-ingredients check and returns the
   * recipe ID even if it has not yet been fully parsed. Used by migration jobs
   * that need to resolve IDs before parsing is complete. Default: false.
   */
  isMigration?: InputMaybe<Scalars['Boolean']>;
  /** Optional - Request metadata including source and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
  /** Required - Spark recipe ID to look up (must be greater than 0) */
  sparkRecipeId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * GetRecipeIdBySparkRecipeIdResponse contains the meals recipe ID that corresponds
 * to the requested Spark recipe ID.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeIdBySparkRecipeIdResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetRecipeIdBySparkRecipeIdResponse';
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Meals DB recipe ID corresponding to the supplied Spark recipe ID (KSUID string) */
  recipeId?: Maybe<Scalars['String']>;
};

/** GetRecipeRequest retrieves a single recipe by its ID. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Recipe ID to retrieve (KSUID string, must be non-empty) */
  recipeId?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source, variant, and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/** GetRecipeResponse contains the recipe with all associated child entities. */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetRecipeResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetRecipeResponse';
  /**
   * True if the recipe is favorited by the applicable consumer under the
   * applicable store scope. Left at the default (false) when the endpoint
   * has no consumer identity to resolve against.
   */
  favorite?: Maybe<Scalars['Boolean']>;
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Provider/source for this recipe. */
  publisher?: Maybe<Instacart_Customers_Meals_Types_V1_Publisher>;
  /** Recipe data with all child entities (descriptions, ingredients, instructions, nutrition facts, FAQs, images) */
  recipe?: Maybe<Instacart_Customers_Meals_Types_V1_Recipe>;
};

/**
 * GetShoppableProductsRequest retrieves the shoppable ingredients of a
 * recipe, grouped for presentation, scoped to the shop carried on the
 * flow context.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetShoppableProductsRequest_Input = {
  /**
   * Required - Flow context for request tracking and user identification.
   * The shop_id on the flow context determines which retailer's products are
   * returned.
   */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Recipe ID to get shoppable products for (KSUID string, must be non-empty). */
  recipeId?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source and debug flag. */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/**
 * GetShoppableProductsResponse contains the shoppable ingredients of a
 * recipe, grouped for presentation. An empty list is a valid success
 * response when the recipe has no parsed ingredients available at the shop.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetShoppableProductsResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetShoppableProductsResponse';
  /** Ingredient groups in display order. */
  ingredientGroups?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_IngredientGroup>>>;
  /** Response metadata including request_id and optional debug info. */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Version identifier for the ML process that produced these results. */
  mlProcessVersion?: Maybe<Scalars['String']>;
};

/**
 * GetSparkRecipeIdsByRecipeIdRequest retrieves the Spark (legacy) recipe IDs
 * corresponding to a given Meals DB recipe ID. A single Meals DB recipe can
 * map to multiple Spark recipe IDs.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetSparkRecipeIdsByRecipeIdRequest_Input = {
  /** Required - Flow context for request tracking and user identification */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Required - Meals DB recipe ID to look up (KSUID string, must be non-empty) */
  recipeId?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source and debug flag */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/**
 * GetSparkRecipeIdsByRecipeIdResponse contains the Spark (legacy) recipe IDs
 * that map to the requested Meals DB recipe ID. A single Meals recipe can
 * correspond to multiple Spark recipes (the mapping is 1->many), so this is
 * a list rather than a single value.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_GetSparkRecipeIdsByRecipeIdResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_GetSparkRecipeIdsByRecipeIdResponse';
  /** Response metadata including request_id and optional debug info */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /**
   * All Spark (legacy) recipe IDs mapped to the supplied Meals DB recipe ID.
   * May contain one or many entries; order is not guaranteed.
   */
  sparkRecipeIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * Int32Range is an inclusive integer range. Either bound may be omitted to
 * leave that side unbounded (e.g. min set + max nil = "at least min").
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int32Range_Input = {
  max?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Int']>;
};

/**
 * Int64Range is an inclusive 64-bit integer range. Either bound may be
 * omitted to leave that side unbounded (e.g. min set + max nil = "at least min").
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int64Range_Input = {
  max?: InputMaybe<Scalars['BigInt']>;
  min?: InputMaybe<Scalars['BigInt']>;
};

/**
 * RecipeSearchFilters constrains a unified recipe search by the same attribute
 * taxonomy that meals enrichment produces (see
 * instacart.algorithms.meals_enrichment.v1.EnrichmentAttributes). Each repeated
 * field is matched as OR within the field; different fields are combined with
 * AND. An empty/omitted field applies no constraint for that attribute.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_RecipeSearchFilters_Input = {
  chillSetTimeMinutes?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int32Range_Input>;
  /**
   * Inclusive bounds on a recipe's coarse price in cents, aggregated across its
   * ingredients. Recipes whose coarse-price aggregate falls outside the range
   * are excluded. Either bound may be omitted for an open-ended range;
   * omitting the field entirely applies no coarse-price constraint.
   */
  coarsePriceInCents?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int64Range_Input>;
  /**
   * Restrict results to these content types. Matched as OR within the field.
   * Empty = no content-type constraint.
   */
  contentTypes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_ContentType>>>;
  cookTimeMinutes?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int32Range_Input>;
  cookingMethods?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_CookingMethod>>>;
  cuisines?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_Cuisine>>>;
  dietaryLabels?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_DietaryLabel>>>;
  flavorProfiles?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_FlavorProfile>>>;
  mealTypes?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_MealType>>>;
  occasions?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_Occasion>>>;
  /**
   * Inclusive minute ranges over the corresponding EnrichmentAttributes time
   * fields. Omitted = no constraint on that dimension.
   */
  prepTimeMinutes?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int32Range_Input>;
  proteins?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_Protein>>>;
  /**
   * Restrict results to recipes from these providers/sources (KSUID strings).
   * Matched as OR within the field. Empty = no publisher constraint.
   */
  publisherIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skillLevels?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_SkillLevel>>>;
  speeds?: InputMaybe<Array<InputMaybe<Instacart_Algorithms_Meals_Enrichment_V1_Speed>>>;
  totalTimeMinutes?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_Int32Range_Input>;
};

/**
 * UnifiedRecipeSearchRequest searches recipes by free-text query and optional
 * attribute filters, returning a page of matching recipes.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_UnifiedRecipeSearchRequest_Input = {
  /** Optional - Attribute filters applied on top of the text query. */
  filters?: InputMaybe<Instacart_Customers_Meals_Endpoints_Retrieval_V1_RecipeSearchFilters_Input>;
  /**
   * Required - Flow context for request tracking and user identification. The
   * shop scope determines catalog/availability context.
   */
  flowContext?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input>;
  /** Optional - Free-text search query. Empty query returns filter-only results. */
  query?: InputMaybe<Scalars['String']>;
  /** Optional - Request metadata including source, variant, and debug flag. */
  requestMeta?: InputMaybe<Instacart_Customers_Meals_RequestMeta_Input>;
};

/**
 * UnifiedRecipeSearchResponse contains a page of recipes matching the query and
 * filters. An empty list is a valid success response when nothing matches.
 */
export type Instacart_Customers_Meals_Endpoints_Retrieval_V1_UnifiedRecipeSearchResponse = {
  __typename?: 'instacart_customers_meals_endpoints_retrieval_v1_UnifiedRecipeSearchResponse';
  /** Response metadata including request_id and optional debug info. */
  metadata?: Maybe<Instacart_Customers_Meals_ResponseMeta>;
  /** Matching recipes in relevance order. */
  recipes?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_Recipe>>>;
};

/**
 * Action enumerates all actions that can be evaluated against a recipe.
 * Adding a new value requires a code-plus-migration change — the CHECK
 * constraint on the action column must be extended alongside the new enum value.
 */
export enum Instacart_Customers_Meals_Types_V1_Action {
  /** Recipe may be rendered and surfaced to users. */
  ActionDisplay = 'ACTION_DISPLAY',
  /** Recipe may be saved or favorited by users. */
  ActionFavorite = 'ACTION_FAVORITE',
  /** Full step-by-step instructions may be shown. */
  ActionFullInstructions = 'ACTION_FULL_INSTRUCTIONS',
  /** Recipe may be rated by users. */
  ActionRating = 'ACTION_RATING',
  /** Recipe may appear in search and recommendation surfaces. */
  ActionSearchable = 'ACTION_SEARCHABLE',
  /** Recipe may appear in sitemaps and SEO surfaces. */
  ActionSeo = 'ACTION_SEO',
  /** Recipe may be shared via link or social surface. */
  ActionShare = 'ACTION_SHARE',
  /** Recipe ingredients may be added to cart. */
  ActionShoppable = 'ACTION_SHOPPABLE',
  ActionUnspecified = 'ACTION_UNSPECIFIED',
  /** Recipe data may be written or updated by the caller. */
  ActionWrite = 'ACTION_WRITE'
}

/** CodeType selects how `IngredientOverride.product_codes` are interpreted. */
export enum Instacart_Customers_Meals_Types_V1_CodeType {
  /** Stringified int64 product id; resolved directly with no external lookup. */
  CodeTypeProductId = 'CODE_TYPE_PRODUCT_ID',
  /** Retailer reference code (RRC) — retailer-private, requires retailer_id. */
  CodeTypeRrc = 'CODE_TYPE_RRC',
  CodeTypeUnspecified = 'CODE_TYPE_UNSPECIFIED',
  /** Universal product code (UPC) or GTIN. */
  CodeTypeUpcGtin = 'CODE_TYPE_UPC_GTIN'
}

/** ContentType categorizes the type of content for a recipe. */
export enum Instacart_Customers_Meals_Types_V1_ContentType {
  ContentTypeAgaveRecipe = 'CONTENT_TYPE_AGAVE_RECIPE',
  ContentTypeClementine = 'CONTENT_TYPE_CLEMENTINE',
  ContentTypeIcAiGenerated = 'CONTENT_TYPE_IC_AI_GENERATED',
  ContentTypeIdpRecipe = 'CONTENT_TYPE_IDP_RECIPE',
  ContentTypeIdpShoppingList = 'CONTENT_TYPE_IDP_SHOPPING_LIST',
  ContentTypeImportedRecipe = 'CONTENT_TYPE_IMPORTED_RECIPE',
  ContentTypeLicensedRecipe = 'CONTENT_TYPE_LICENSED_RECIPE',
  ContentTypeSponsoredRecipe = 'CONTENT_TYPE_SPONSORED_RECIPE',
  ContentTypeUnspecified = 'CONTENT_TYPE_UNSPECIFIED'
}

/** FAQ represents a frequently asked question about a recipe. */
export type Instacart_Customers_Meals_Types_V1_Faq = {
  __typename?: 'instacart_customers_meals_types_v1_FAQ';
  /** Required - FAQ answer text */
  answer?: Maybe<Scalars['String']>;
  /** Required - Display order */
  ordinal?: Maybe<Scalars['BigInt']>;
  /** Required - FAQ question text */
  question?: Maybe<Scalars['String']>;
};

/** FAQ represents a frequently asked question about a recipe. */
export type Instacart_Customers_Meals_Types_V1_Faq_Input = {
  /** Required - FAQ answer text */
  answer?: InputMaybe<Scalars['String']>;
  /** Required - Display order */
  ordinal?: InputMaybe<Scalars['BigInt']>;
  /** Required - FAQ question text */
  question?: InputMaybe<Scalars['String']>;
};

/**
 * IngredientGroup is a presentational grouping of ingredients (e.g. "Dressing",
 * "You may already have"). Groups are ordered as the response returns them.
 */
export type Instacart_Customers_Meals_Types_V1_IngredientGroup = {
  __typename?: 'instacart_customers_meals_types_v1_IngredientGroup';
  /** Ingredients in this group, in display order. */
  ingredientProducts?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_IngredientProduct>>>;
  /**
   * Whether the ingredients in this group are common pantry staples (e.g.
   * salt, water). The presentation layer decides how to react to this — for
   * example, combining it with cart state to derive whether the group is
   * pre-selected for bulk add-to-cart.
   */
  isCommon?: Maybe<Scalars['Boolean']>;
  /** Whether this group is sponsored (commercial partnership flag). */
  isSponsored?: Maybe<Scalars['Boolean']>;
  /** Display name for the group. Empty string when the group has no label. */
  name?: Maybe<Scalars['String']>;
};

/**
 * IngredientOverride is a publisher-supplied directive to bypass organic
 * product search for a single (raw_ingredient, retailer-scope, code_type) tuple.
 *
 * V1: if no override product is available at the shopping retailer, the
 * ingredient surfaces with empty retailer_products. No fallback to search.
 */
export type Instacart_Customers_Meals_Types_V1_IngredientOverride = {
  __typename?: 'instacart_customers_meals_types_v1_IngredientOverride';
  /** Required. */
  codeType?: Maybe<Instacart_Customers_Meals_Types_V1_CodeType>;
  /** Required, non-empty. Interpreted per code_type. */
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional. Unset means the override applies universally across all
   * retailers. A positive value scopes the override to that specific
   * retailer; a retailer-scoped override beats a universal override for the
   * same ingredient and code_type at read time.
   */
  retailerId?: Maybe<Scalars['BigInt']>;
};

/**
 * IngredientOverride is a publisher-supplied directive to bypass organic
 * product search for a single (raw_ingredient, retailer-scope, code_type) tuple.
 *
 * V1: if no override product is available at the shopping retailer, the
 * ingredient surfaces with empty retailer_products. No fallback to search.
 */
export type Instacart_Customers_Meals_Types_V1_IngredientOverride_Input = {
  /** Required. */
  codeType?: InputMaybe<Instacart_Customers_Meals_Types_V1_CodeType>;
  /** Required, non-empty. Interpreted per code_type. */
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional. Unset means the override applies universally across all
   * retailers. A positive value scopes the override to that specific
   * retailer; a retailer-scoped override beats a universal override for the
   * same ingredient and code_type at read time.
   */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * IngredientProduct is one recipe ingredient paired with the matching
 * retailer product ids at the requested shop.
 */
export type Instacart_Customers_Meals_Types_V1_IngredientProduct = {
  __typename?: 'instacart_customers_meals_types_v1_IngredientProduct';
  /** Display text for the ingredient (e.g. "1/4 cup butter"). */
  displayText?: Maybe<Scalars['String']>;
  /**
   * 0-indexed position within the raw_ingredient_id group, matching parser
   * expansion order. Always populated, so 0 is a real index, not "unset".
   */
  expansionIndex?: Maybe<Scalars['BigInt']>;
  /** Whether this ingredient is sponsored (commercial partnership flag). */
  isSponsored?: Maybe<Scalars['Boolean']>;
  /**
   * Retailer item ids corresponding to product_ids, in the same rank order.
   * Empty when no items were resolved.
   */
  itemIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Normalized quantity from the parser's canonical (lowest-ordinal)
   * recipe_ingredient_measurements row for this ingredient. 0 when the
   * ingredient has no parsed measurement or the parser produced no normalized
   * quantity (proto3 scalar; presence is not distinguished from a real 0).
   */
  normalizedQuantity?: Maybe<Scalars['Float']>;
  /**
   * Normalized unit paired with normalized_quantity (e.g. "cup", "tsp") from the
   * same canonical measurement row. Empty when there is no parsed measurement or
   * no normalized unit.
   */
  normalizedUnit?: Maybe<Scalars['String']>;
  /**
   * Retailer product ids that match this ingredient at the requested shop,
   * in rank order. Empty when no products were resolved.
   */
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * Per-item quantity and quantity type for add-to-cart, parallel to item_ids.
   * Absent for items where quantity could not be determined.
   */
  quantities?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_IngredientProduct_IngredientProductQuantity>>>;
  /**
   * Reference to recipe_raw_ingredients.id. Not unique within a response when
   * a compound raw line is expanded; key on (raw_ingredient_id, expansion_index).
   */
  rawIngredientId?: Maybe<Scalars['String']>;
  /**
   * Recall search query used to resolve this ingredient. Empty when the
   * ingredient came from a publisher override (no live search was performed).
   */
  searchQuery?: Maybe<Scalars['String']>;
};

/** IngredientProductQuantity pairs an item with its add-to-cart quantity. */
export type Instacart_Customers_Meals_Types_V1_IngredientProduct_IngredientProductQuantity = {
  __typename?: 'instacart_customers_meals_types_v1_IngredientProduct_IngredientProductQuantity';
  /** Retailer item id. */
  itemId?: Maybe<Scalars['String']>;
  /** Quantity to add (e.g. 2.0 for two units, 0.5 for half a pound). */
  quantity?: Maybe<Scalars['Float']>;
  /** How the item is priced/sold. QUANTITY_TYPE_UNSPECIFIED when classification is unknown. */
  quantityType?: Maybe<Instacart_Customers_Meals_Types_V1_QuantityType>;
};

/** Instruction represents a single step in a recipe. */
export type Instacart_Customers_Meals_Types_V1_Instruction = {
  __typename?: 'instacart_customers_meals_types_v1_Instruction';
  /** Optional - Instruction step text */
  description?: Maybe<Scalars['String']>;
  /** Optional - Step order */
  ordinal?: Maybe<Scalars['Int']>;
};

/** Instruction represents a single step in a recipe. */
export type Instacart_Customers_Meals_Types_V1_Instruction_Input = {
  /** Optional - Instruction step text */
  description?: InputMaybe<Scalars['String']>;
  /** Optional - Step order */
  ordinal?: InputMaybe<Scalars['Int']>;
};

/** NutritionFact represents a nutritional data point for a recipe. */
export type Instacart_Customers_Meals_Types_V1_NutritionFact = {
  __typename?: 'instacart_customers_meals_types_v1_NutritionFact';
  /** Optional - Nutrient amount */
  amount?: Maybe<Scalars['Int']>;
  /** Optional - Nutrient name (e.g. "Calories", "Total Fat") */
  name?: Maybe<Scalars['String']>;
  /** Optional - Unit of measurement */
  unit?: Maybe<Instacart_Customers_Meals_Types_V1_NutritionUnit>;
};

/** NutritionFact represents a nutritional data point for a recipe. */
export type Instacart_Customers_Meals_Types_V1_NutritionFact_Input = {
  /** Optional - Nutrient amount */
  amount?: InputMaybe<Scalars['Int']>;
  /** Optional - Nutrient name (e.g. "Calories", "Total Fat") */
  name?: InputMaybe<Scalars['String']>;
  /** Optional - Unit of measurement */
  unit?: InputMaybe<Instacart_Customers_Meals_Types_V1_NutritionUnit>;
};

/** NutritionUnit standardizes units of measurement for nutritional information. */
export enum Instacart_Customers_Meals_Types_V1_NutritionUnit {
  NutritionUnitCalorie = 'NUTRITION_UNIT_CALORIE',
  NutritionUnitGram = 'NUTRITION_UNIT_GRAM',
  NutritionUnitInternationalUnit = 'NUTRITION_UNIT_INTERNATIONAL_UNIT',
  NutritionUnitMicrogram = 'NUTRITION_UNIT_MICROGRAM',
  NutritionUnitMilligram = 'NUTRITION_UNIT_MILLIGRAM',
  NutritionUnitUnspecified = 'NUTRITION_UNIT_UNSPECIFIED'
}

/**
 * PermissionRule defines a single allow/deny rule for a given Action, optionally
 * scoped to specific store configs, retailers, and retailer types. Empty inclusion
 * lists mean "match all"; exclusions are subtracted from inclusions only.
 */
export type Instacart_Customers_Meals_Types_V1_PermissionRule_Input = {
  /** Required — action this rule governs. Must not be ACTION_UNSPECIFIED. */
  action?: InputMaybe<Instacart_Customers_Meals_Types_V1_Action>;
  /** Optional — retailers subtracted from this rule's includes only. */
  excludeRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional — retailer types subtracted from this rule's includes only. */
  excludeRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional — store configs subtracted from this rule's includes only. */
  excludeStoreConfigIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional — retailers this rule applies to. Empty means match all. */
  includeRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional — retailer types this rule applies to. Empty means match all. */
  includeRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional — store configs this rule applies to. Empty means match all. */
  includeStoreConfigIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Required — true for an allow rule, false for a deny rule. */
  permitted?: InputMaybe<Scalars['Boolean']>;
};

/**
 * Publisher represents a recipe provider/source such as a website,
 * licensed source, or recipe-generation system.
 */
export type Instacart_Customers_Meals_Types_V1_Publisher = {
  __typename?: 'instacart_customers_meals_types_v1_Publisher';
  /** Optional - URL to the provider/source avatar image. */
  avatarUrl?: Maybe<Scalars['String']>;
  /** Deprecated. Client-configuration availability is represented by scopes. */
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Optional - Provider/source description. */
  description?: Maybe<Scalars['String']>;
  /** Provider/source ID (KSUID string). */
  id?: Maybe<Scalars['String']>;
  /** Optional - Legacy content creator ID for migration tracking. */
  legacyContentCreatorId?: Maybe<Scalars['BigInt']>;
  /** Provider/source display name. */
  name?: Maybe<Scalars['String']>;
  /**
   * Availability scopes for this provider/source.
   * Empty array means the provider/source has no scope rows.
   */
  scopes?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_PublisherScope>>>;
  /** URL-friendly identifier. */
  slug?: Maybe<Scalars['String']>;
  /** Deprecated. User recipe imports are represented separately from providers/sources. */
  userId?: Maybe<Scalars['BigInt']>;
  /** Optional - Provider/source website URL. */
  website?: Maybe<Scalars['String']>;
};

/** PublisherScope defines a provider/source availability scope. */
export type Instacart_Customers_Meals_Types_V1_PublisherScope = {
  __typename?: 'instacart_customers_meals_types_v1_PublisherScope';
  /**
   * Optional - Retailer ID.
   * When set without store_configuration_id, indicates retailer-level scope.
   */
  retailerId?: Maybe<Scalars['BigInt']>;
  /**
   * Optional - Store configuration ID.
   * When set with retailer_id, indicates store-level scope.
   */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

/** PublisherScope defines a provider/source availability scope. */
export type Instacart_Customers_Meals_Types_V1_PublisherScope_Input = {
  /**
   * Optional - Retailer ID.
   * When set without store_configuration_id, indicates retailer-level scope.
   */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional - Store configuration ID.
   * When set with retailer_id, indicates store-level scope.
   */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * QuantityType classifies how an item is priced and sold, which drives the
 * add-to-cart quantity semantics. Sourced from PRS's priced_by_sold_by_type.
 */
export enum Instacart_Customers_Meals_Types_V1_QuantityType {
  /** Count-priced (sold by unit/package). Quantity is a whole-unit count. */
  QuantityTypeEach = 'QUANTITY_TYPE_EACH',
  /** Classification unknown or not yet populated by the caller. */
  QuantityTypeUnspecified = 'QUANTITY_TYPE_UNSPECIFIED',
  /** Weight-priced (sold by weight). Quantity is a weight measure in the item's cost unit. */
  QuantityTypeWeight = 'QUANTITY_TYPE_WEIGHT'
}

/** RawIngredient represents an ingredient line in a recipe. */
export type Instacart_Customers_Meals_Types_V1_RawIngredient = {
  __typename?: 'instacart_customers_meals_types_v1_RawIngredient';
  /** Optional - Brand preferences */
  brandFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional - Ingredient group label */
  groupName?: Maybe<Scalars['String']>;
  /** Optional - Health filters (e.g. "organic", "gluten-free") */
  healthFilters?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional. When set on ingest, the row is created with this id instead of a
   * server-generated nanoid. Used by the YDB backfill to preserve ids from the
   * old Meals DB cluster. Always populated on retrieval responses.
   */
  id?: Maybe<Scalars['String']>;
  /** Optional - Raw ingredient text (e.g. "all-purpose flour") */
  ingredient?: Maybe<Scalars['String']>;
  /** Required - Sponsored flag */
  isSponsored?: Maybe<Scalars['Boolean']>;
  /** Required - Display order */
  ordinal?: Maybe<Scalars['Int']>;
  /**
   * Optional - Publisher-supplied product-mapping overrides for this ingredient.
   * Each entry pins this ingredient to a specific product set for a given
   * retailer scope (universal or a specific retailer). When an override applies
   * at read time, organic product search is bypassed for the ingredient.
   */
  overrides?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_IngredientOverride>>>;
  /** Optional - Product codes for matching */
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional - Direct product references */
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Required - Product name for matching */
  productName?: Maybe<Scalars['String']>;
  /** Required - Ingredient quantity */
  quantity?: Maybe<Scalars['Float']>;
  /** Required - Unit of measurement (e.g. "cup", "tbsp") */
  unit?: Maybe<Scalars['String']>;
};

/** RawIngredient represents an ingredient line in a recipe. */
export type Instacart_Customers_Meals_Types_V1_RawIngredient_Input = {
  /** Optional - Brand preferences */
  brandFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional - Ingredient group label */
  groupName?: InputMaybe<Scalars['String']>;
  /** Optional - Health filters (e.g. "organic", "gluten-free") */
  healthFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional. When set on ingest, the row is created with this id instead of a
   * server-generated nanoid. Used by the YDB backfill to preserve ids from the
   * old Meals DB cluster. Always populated on retrieval responses.
   */
  id?: InputMaybe<Scalars['String']>;
  /** Optional - Raw ingredient text (e.g. "all-purpose flour") */
  ingredient?: InputMaybe<Scalars['String']>;
  /** Required - Sponsored flag */
  isSponsored?: InputMaybe<Scalars['Boolean']>;
  /** Required - Display order */
  ordinal?: InputMaybe<Scalars['Int']>;
  /**
   * Optional - Publisher-supplied product-mapping overrides for this ingredient.
   * Each entry pins this ingredient to a specific product set for a given
   * retailer scope (universal or a specific retailer). When an override applies
   * at read time, organic product search is bypassed for the ingredient.
   */
  overrides?: InputMaybe<Array<InputMaybe<Instacart_Customers_Meals_Types_V1_IngredientOverride_Input>>>;
  /** Optional - Product codes for matching */
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional - Direct product references */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Required - Product name for matching */
  productName?: InputMaybe<Scalars['String']>;
  /** Required - Ingredient quantity */
  quantity?: InputMaybe<Scalars['Float']>;
  /** Required - Unit of measurement (e.g. "cup", "tbsp") */
  unit?: InputMaybe<Scalars['String']>;
};

/** Recipe represents a complete recipe with all associated data. */
export type Instacart_Customers_Meals_Types_V1_Recipe = {
  __typename?: 'instacart_customers_meals_types_v1_Recipe';
  activeTimeMinutes?: Maybe<Scalars['Int']>;
  /** Optional - Attribute IDs assigned to this recipe */
  attributeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  author?: Maybe<Scalars['String']>;
  /** Generated content hash for deduplication */
  contentHash?: Maybe<Scalars['String']>;
  contentType?: Maybe<Instacart_Customers_Meals_Types_V1_ContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Instacart_Customers_Meals_Types_V1_RecipeDescription>;
  /** Whether pantry ingredient identification is enabled for this recipe */
  enablePantryItems?: Maybe<Scalars['Boolean']>;
  /** Optional - Time after which the recipe is no longer active */
  expiryTime?: Maybe<Scalars['DateTime']>;
  faqs?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_Faq>>>;
  /** Generated recipe ID (KSUID string). */
  id?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_RecipeImage>>>;
  instructions?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_Instruction>>>;
  /** IPP account canonical identifier */
  ippAccountCanonicalId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nutritionFacts?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_NutritionFact>>>;
  prepTimeMinutes?: Maybe<Scalars['Int']>;
  providerRecipeId?: Maybe<Scalars['String']>;
  providerRecipeUrl?: Maybe<Scalars['String']>;
  /** Provider/source for this recipe. */
  publisherId?: Maybe<Scalars['String']>;
  rawIngredients?: Maybe<Array<Maybe<Instacart_Customers_Meals_Types_V1_RawIngredient>>>;
  servingsMax?: Maybe<Scalars['Int']>;
  servingsMin?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  totalTimeMinutes?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** RecipeAttribute represents a single active recipe attribute eligible for assignment. */
export type Instacart_Customers_Meals_Types_V1_RecipeAttribute = {
  __typename?: 'instacart_customers_meals_types_v1_RecipeAttribute';
  /** Human-readable label (e.g., "Vegan", "Gluten-Free") */
  description?: Maybe<Scalars['String']>;
  /** Attribute ID (KSUID string, references recipe_attributes.id) */
  id?: Maybe<Scalars['String']>;
  /** Whether this attribute is visible in the Meal Details Page */
  mdpVisible?: Maybe<Scalars['Boolean']>;
  /** Parent attribute ID; empty string if this is a root attribute */
  parentId?: Maybe<Scalars['String']>;
};

/** RecipeDescription holds textual content fields for a recipe. */
export type Instacart_Customers_Meals_Types_V1_RecipeDescription = {
  __typename?: 'instacart_customers_meals_types_v1_RecipeDescription';
  /** Optional - Recipe description */
  description?: Maybe<Scalars['String']>;
  /** Optional - Recipe history/background */
  history?: Maybe<Scalars['String']>;
  /** Optional - SEO meta description */
  metaDescription?: Maybe<Scalars['String']>;
  /** Optional - SEO meta title */
  metaTitle?: Maybe<Scalars['String']>;
  /** Optional - Professional cooking tips */
  proTip?: Maybe<Scalars['String']>;
  /** Optional - Raw ingredient list text */
  rawIngredients?: Maybe<Scalars['String']>;
  /** Optional - Recipe recommendations */
  recommendations?: Maybe<Scalars['String']>;
  /** Optional - SEO source keyword */
  seoSourceKeyword?: Maybe<Scalars['String']>;
};

/** RecipeDescription holds textual content fields for a recipe. */
export type Instacart_Customers_Meals_Types_V1_RecipeDescription_Input = {
  /** Optional - Recipe description */
  description?: InputMaybe<Scalars['String']>;
  /** Optional - Recipe history/background */
  history?: InputMaybe<Scalars['String']>;
  /** Optional - SEO meta description */
  metaDescription?: InputMaybe<Scalars['String']>;
  /** Optional - SEO meta title */
  metaTitle?: InputMaybe<Scalars['String']>;
  /** Optional - Professional cooking tips */
  proTip?: InputMaybe<Scalars['String']>;
  /** Optional - Raw ingredient list text */
  rawIngredients?: InputMaybe<Scalars['String']>;
  /** Optional - Recipe recommendations */
  recommendations?: InputMaybe<Scalars['String']>;
  /** Optional - SEO source keyword */
  seoSourceKeyword?: InputMaybe<Scalars['String']>;
};

/** RecipeImage represents an image associated with a recipe. */
export type Instacart_Customers_Meals_Types_V1_RecipeImage = {
  __typename?: 'instacart_customers_meals_types_v1_RecipeImage';
  /** Required - URL to the image file */
  imageUrl?: Maybe<Scalars['String']>;
  /** Required - Image size variant */
  size?: Maybe<Instacart_Customers_Meals_Types_V1_RecipeImageSize>;
};

/** RecipeImageSize categorizes the size variant of a recipe image. */
export enum Instacart_Customers_Meals_Types_V1_RecipeImageSize {
  RecipeImageSizeLarge = 'RECIPE_IMAGE_SIZE_LARGE',
  RecipeImageSizeMedium = 'RECIPE_IMAGE_SIZE_MEDIUM',
  RecipeImageSizeSmall = 'RECIPE_IMAGE_SIZE_SMALL',
  RecipeImageSizeThumbnail = 'RECIPE_IMAGE_SIZE_THUMBNAIL',
  RecipeImageSizeUnspecified = 'RECIPE_IMAGE_SIZE_UNSPECIFIED'
}

/** RecipeImage represents an image associated with a recipe. */
export type Instacart_Customers_Meals_Types_V1_RecipeImage_Input = {
  /** Required - URL to the image file */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Required - Image size variant */
  size?: InputMaybe<Instacart_Customers_Meals_Types_V1_RecipeImageSize>;
};

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetailExpanded = {
  __typename?: 'instacart_customers_offers_tooling_orchestrator_v1_CollectionDetailExpanded';
  collectionId?: Maybe<Scalars['BigInt']>;
  /** Member ids that make up the collection. */
  collectionMemberIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  collectionType?: Maybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionType>;
};

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetail_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  collectionType?: InputMaybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionType>;
};

export enum Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionType {
  CollectionTypeUnspecified = 'COLLECTION_TYPE_UNSPECIFIED',
  /** Department collections are IC defined collections (i.e. Produce, Dairy, etc). */
  Department = 'DEPARTMENT'
}

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadRequest_Input = {
  /** Create Offer collection details. */
  collectionsDetails?: InputMaybe<Array<InputMaybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetail_Input>>>;
};

export type Instacart_Customers_Offers_Tooling_Orchestrator_V1_PrepareCreateOfferPayloadResponse = {
  __typename?: 'instacart_customers_offers_tooling_orchestrator_v1_PrepareCreateOfferPayloadResponse';
  collectionsDetailsExpanded?: Maybe<Array<Maybe<Instacart_Customers_Offers_Tooling_Orchestrator_V1_CollectionDetailExpanded>>>;
};

/** GIFG (Get It Fresh Guarantee) escalation step for the current appeasement. */
export enum Instacart_Customers_Order_Issues_V1_GifgEscalationStep {
  GifgEscalationStepFirstViolation = 'GIFG_ESCALATION_STEP_FIRST_VIOLATION',
  GifgEscalationStepSecondViolation = 'GIFG_ESCALATION_STEP_SECOND_VIOLATION',
  GifgEscalationStepThirdOrMore = 'GIFG_ESCALATION_STEP_THIRD_OR_MORE',
  GifgEscalationStepUnspecified = 'GIFG_ESCALATION_STEP_UNSPECIFIED'
}

export enum Instacart_Customers_Order_Issues_V1_OrderIssueTypeCategory {
  /** Order cancellation issue. */
  Cancellation = 'CANCELLATION',
  /** Catalog related issue. */
  Catalog = 'CATALOG',
  /** Incorrectly charged issue. */
  ChargedIncorrectly = 'CHARGED_INCORRECTLY',
  /** Customer ID verification failed issue. */
  CustomerIdVerificationFailed = 'CUSTOMER_ID_VERIFICATION_FAILED',
  /** Customer missing issue. */
  CustomerMia = 'CUSTOMER_MIA',
  /** Customer returns issue. */
  CustomerReturns = 'CUSTOMER_RETURNS',
  /** Damaged order issue. */
  Damaged = 'DAMAGED',
  /** Order edit issue. */
  Edit = 'EDIT',
  /** Entire delivery missing issue. */
  EntireDeliveryMissing = 'ENTIRE_DELIVERY_MISSING',
  /** Item missing issue. */
  ItemMissing = 'ITEM_MISSING',
  /** Other issue related to item. */
  ItemOther = 'ITEM_OTHER',
  /** Non-shopper related issue. */
  NonShopperIssue = 'NON_SHOPPER_ISSUE',
  /** General order issue. */
  OrderIssue = 'ORDER_ISSUE',
  /** Unspecified */
  OrderIssueTypeCategoryUnspecified = 'ORDER_ISSUE_TYPE_CATEGORY_UNSPECIFIED',
  /** Other category of issue. */
  OtherIssue = 'OTHER_ISSUE',
  /** Pick up missing issue. */
  PickUpMissing = 'PICK_UP_MISSING',
  /** Poor handoff issue. */
  PoorHandoff = 'POOR_HANDOFF',
  /** Poor replacement issue. */
  PoorReplacement = 'POOR_REPLACEMENT',
  /** Poor service issue. */
  PoorService = 'POOR_SERVICE',
  /** Poor service - shopper communication issue. */
  PoorServiceShopperCommunication = 'POOR_SERVICE_SHOPPER_COMMUNICATION',
  /** Poor service - shopper friendliness issue. */
  PoorServiceShopperFriendliness = 'POOR_SERVICE_SHOPPER_FRIENDLINESS',
  /** Poor service - shopper professionalism issue. */
  PoorServiceShopperProfessionalism = 'POOR_SERVICE_SHOPPER_PROFESSIONALISM',
  /** Poor shopper chat issue. */
  PoorShopperChat = 'POOR_SHOPPER_CHAT',
  /** Uncategorized issue. */
  Uncategorized = 'UNCATEGORIZED',
  /** Wrong item issue. */
  WrongItem = 'WRONG_ITEM',
  /** Wrong order issue. */
  WrongOrder = 'WRONG_ORDER'
}

export type Instacart_Customers_Orders_V1_GetOrderLinesRequest_Input = {
  /** Single order reference. */
  orderReference?: InputMaybe<Scalars['String']>;
  /**
   * Batched order reference call.
   * Limit: 20.
   */
  orderReferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** RequestContext. */
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse';
  /** If a single order_reference is passed, the single order item summary. */
  orderLines?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLines>;
  /** Mapped by input order_reference values. */
  orderLinesByOrderReference?: Maybe<Scalars['JSON']>;
};

/** See OrdersDomain::Api::Responses::ItemResponse. */
export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderItem';
  /** Item is alcoholic */
  alcoholic?: Maybe<Scalars['Boolean']>;
  /** Additional item external data provided by the retailer. */
  externalData?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItemExternalData>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Product category */
  productCategory?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem_ProductCategory>;
  /** Product codes */
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productId?: Maybe<Scalars['BigInt']>;
  /** Quantity including units displayed to customer. */
  quantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Item is OTC */
  restrictedOtc?: Maybe<Scalars['Boolean']>;
  /** Retailer lookup code. */
  retailerLookupCode?: Maybe<Scalars['String']>;
  /**
   * Retailer reference code.
   * The current/actual RRC value (may be catalog-derived).
   * For original retailer-submitted values, use external_retailer_rrc in OrderItemExternalData.
   */
  retailerReferenceCode?: Maybe<Scalars['String']>;
  /** Item is rx */
  rx?: Maybe<Scalars['Boolean']>;
  /** Display size of item. */
  sizeDetails?: Maybe<Scalars['String']>;
  /** Price per unit displayed to customer. */
  unitPrice?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItemExternalData = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderItemExternalData';
  externalRetailerRrc?: Maybe<Scalars['String']>;
  /**
   * These fields reflect the values passed by the caller (e.g. Connect retailers)
   * and are guaranteed to match what was sent by the retailer.
   * In contrast, retailer_upc / retailer_rrc reflect catalog-derived values and
   * may differ from what the retailer originally submitted.
   */
  externalRetailerUpc?: Maybe<Scalars['String']>;
  lineNum?: Maybe<Scalars['String']>;
  lineNumSource?: Maybe<Scalars['String']>;
  /**
   * DEPRECATED: Use external_retailer_rrc for original retailer-submitted values,
   * or retailer_reference_code for current/actual catalog-derived values.
   */
  retailerRrc?: Maybe<Scalars['String']>;
  /**
   * DEPRECATED: Use external_retailer_upc for original retailer-submitted values,
   * or retailer_lookup_code for current/actual catalog-derived values.
   */
  retailerUpc?: Maybe<Scalars['String']>;
  /** DEPRECATED: Use scan_info on OrderLine instead. */
  scanCode?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem_ProductCategory = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderItem_ProductCategory';
  l1Category?: Maybe<Scalars['String']>;
  l1CategoryId?: Maybe<Scalars['BigInt']>;
  l2Category?: Maybe<Scalars['String']>;
  l2CategoryId?: Maybe<Scalars['BigInt']>;
  l3Category?: Maybe<Scalars['String']>;
  l3CategoryId?: Maybe<Scalars['BigInt']>;
  l4Category?: Maybe<Scalars['String']>;
  l4CategoryId?: Maybe<Scalars['BigInt']>;
  l5Category?: Maybe<Scalars['String']>;
  l5CategoryId?: Maybe<Scalars['BigInt']>;
  l6Category?: Maybe<Scalars['String']>;
  l6CategoryId?: Maybe<Scalars['BigInt']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryId?: Maybe<Scalars['BigInt']>;
};

/** See OrdersDomain::Api::Responses::OrderItemResponse. */
export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderLine';
  /** Id of the shopper that added the order item. */
  addedByDriverId?: Maybe<Scalars['BigInt']>;
  /**
   * Specifies if the customer explicitly allowed a substitution.
   * Possible values:
   * nil - customer did not decide.
   * false - customer asked for no substitution.
   * true - customer asked for a substitute.
   */
  allowedSubstitution?: Maybe<Scalars['Boolean']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  /** Price shown to customer at order time. */
  customerOrderedPrice?: Maybe<GoogleTypeMoney>;
  /** Price displayed at storefront. */
  customerPrice?: Maybe<GoogleTypeMoney>;
  /**
   * Customer specificed replacement at checkout/post-checkout.
   * Available only when allowed_substitution is True.
   */
  customerSelectedReplacement?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem>;
  /** When it is set, the current order line is added as a partial qty replacement for the order line with this id. */
  forOrderLineId?: Maybe<Scalars['BigInt']>;
  /** Full price for this item. */
  fullPrice?: Maybe<GoogleTypeMoney>;
  /** The Orders order item ID represented by this line. */
  id?: Maybe<Scalars['BigInt']>;
  /** Original item requested at checkout. */
  item?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem>;
  /** A unique identifier for this OrderLine that can be exposed externally. */
  obfuscatedId?: Maybe<Scalars['String']>;
  /** Quantity including units ordered by customer. */
  orderedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity including units picked. */
  pickedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity picked expressed in each-units. */
  pickedQuantityEach?: Maybe<Scalars['BigInt']>;
  productType?: Maybe<Instacart_Customers_Orders_V1_ProductType>;
  /** Quantity including units refunded. */
  refundQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Quantity refunded expressed in each-units. */
  refundQuantityEach?: Maybe<Scalars['BigInt']>;
  /** Quantity including units remaining that can be refunded. */
  refundableQuantities?: Maybe<Array<Maybe<Instacart_Types_V1_MeasuredQuantity>>>;
  /** Deprecated: use refundable_quantities instead. */
  refundableQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  replacementPolicy?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_ReplacementPolicy>;
  /** Scan info for the item picked for this line. */
  scanInfo?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_ScanInfo>;
  /** Special instructions about the order item. */
  specialInstructions?: Maybe<Scalars['String']>;
  /** Original requested item status. */
  status?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_Status>;
  /**
   * Substitute if replaced by shopper. If present, this is the current item
   * on the order.
   */
  substitute?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderItem>;
  /** The current status of the substitution for this item, if it exists. */
  substitutionStatus?: Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_SubstitutionStatus>;
};

/** Chosen replacement policy for the order item. */
export enum Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_ReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE'
}

export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_ScanInfo = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderLine_ScanInfo';
  /** The product code scanned by the shopper (e.g. UPC, PLU value). */
  scannedString?: Maybe<Scalars['String']>;
  /** The type of code scanned (e.g. "UPC", "PLU"). */
  scannedStringType?: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_Status {
  /**
   * DEPRECATED
   * Replacement approved by customer.
   */
  DeprecatedApproved = 'DEPRECATED_APPROVED',
  /**
   * DEPRECATED
   * Replacement rejected by customer.
   */
  DeprecatedRejected = 'DEPRECATED_REJECTED',
  /** Original item requested found by shopper. */
  Found = 'FOUND',
  /** Not yet picked. */
  NotPicked = 'NOT_PICKED',
  /** Item replaced. */
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  /** Item to be refunded. */
  ToRefund = 'TO_REFUND'
}

export enum Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine_SubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED'
}

/** Represents result set for an order. */
export type Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLines = {
  __typename?: 'instacart_customers_orders_v1_GetOrderLinesResponse_OrderLines';
  lineItems?: Maybe<Array<Maybe<Instacart_Customers_Orders_V1_GetOrderLinesResponse_OrderLine>>>;
};

export enum Instacart_Customers_Orders_V1_ProductType {
  ProductTypeLooseweight = 'PRODUCT_TYPE_LOOSEWEIGHT',
  ProductTypeNormal = 'PRODUCT_TYPE_NORMAL',
  /** Unused since 2017 */
  ProductTypePromo = 'PRODUCT_TYPE_PROMO',
  ProductTypeUnknown = 'PRODUCT_TYPE_UNKNOWN',
  ProductTypeUnspecified = 'PRODUCT_TYPE_UNSPECIFIED',
  ProductTypeVariable = 'PRODUCT_TYPE_VARIABLE'
}

/** Country API Objects // */
export type Instacart_Customers_Partners_V1_Country = {
  __typename?: 'instacart_customers_partners_v1_Country';
  /** two-letter country abbreviation */
  alpha_2?: Maybe<Scalars['String']>;
  /** three-letter country abbreviation */
  alpha_3?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequestParameters_Input = {
  expansionOwnerUserId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  partnerType?: InputMaybe<Scalars['String']>;
  partnershipType?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  salesforceId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_CreateOrUpdatePartnerRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_CreateOrUpdatePartnerResponse = {
  __typename?: 'instacart_customers_partners_v1_CreateOrUpdatePartnerResponse';
  partner?: Maybe<Instacart_Customers_Partners_V1_Partner>;
};

/**
 * Environment a Retailer operates in. A sandbox Retailer is an isolated, non-production
 * instance used for validation before going live; a production Retailer is live.
 */
export enum Instacart_Customers_Partners_V1_Environment {
  EnvironmentProduction = 'ENVIRONMENT_PRODUCTION',
  EnvironmentSandbox = 'ENVIRONMENT_SANDBOX',
  EnvironmentUnspecified = 'ENVIRONMENT_UNSPECIFIED'
}

export type Instacart_Customers_Partners_V1_GetCountriesRequestParameters_Input = {
  /**
   * For searching by ID
   * If a search string is provided and a number or list of numbers can be extracted from it, search for those numbers as ids as well.
   */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** For searching by name or abbreviation */
  name?: InputMaybe<Scalars['String']>;
};

/** Country API Request // */
export type Instacart_Customers_Partners_V1_GetCountriesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetCountriesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** Countries API Response // */
export type Instacart_Customers_Partners_V1_GetCountriesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetCountriesResponse';
  countries?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Country>>>;
};

export type Instacart_Customers_Partners_V1_GetPartnersRequestParameters_Input = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Case-insensitive substring match against the partner name. Mutually exclusive with `ids` and `retailer_id`. */
  name?: InputMaybe<Scalars['String']>;
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  updatedLastSec?: InputMaybe<Scalars['BigInt']>;
};

/** Partners API Request // */
export type Instacart_Customers_Partners_V1_GetPartnersRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetPartnersRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/**
 * ---------------------------------------- Responses ---------------------------------------
 * Partners API Response //
 */
export type Instacart_Customers_Partners_V1_GetPartnersResponse = {
  __typename?: 'instacart_customers_partners_v1_GetPartnersResponse';
  limitValue?: Maybe<Scalars['BigInt']>;
  offsetValue?: Maybe<Scalars['BigInt']>;
  partners?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Partner>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequestParameters_Input = {
  /** For searching by code, optional, fuzzy search */
  code?: InputMaybe<Scalars['String']>;
  /** will become a required field in the future as we go global */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /** For searching by exact postal code, optional */
  exactCode?: InputMaybe<Scalars['String']>;
  /** For searching by ID */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  /** Required, we will only show a subset of postal codes by zone */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesByZonesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesByZonesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetPostalCodesByZonesResponse';
  limitValue?: Maybe<Scalars['BigInt']>;
  offsetValue?: Maybe<Scalars['BigInt']>;
  postalCodes?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_PostalCode>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetPostalCodesRequestParameters_Input = {
  /** For searching by code, optional, fuzzy search */
  code?: InputMaybe<Scalars['String']>;
  /** For searching by multiple codes, optional. Suffixed with _array to avoid confusion with other param `code` */
  codesArray?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** will become a required field in the future as we go global */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /** For searching by exact postal code, optional */
  exactCode?: InputMaybe<Scalars['String']>;
  /** Codes that are unserviceable won't be included if set to true */
  excludeUnserviceable?: InputMaybe<Scalars['Boolean']>;
  /**
   * For searching by ID, optional
   * If a search string is provided and a number or list of numbers can be extracted from it, search for those numbers as ids as well.
   */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
};

/** PostalCodes API Request // */
export type Instacart_Customers_Partners_V1_GetPostalCodesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetPostalCodesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** PostalCodes API Response // */
export type Instacart_Customers_Partners_V1_GetPostalCodesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetPostalCodesResponse';
  limitValue?: Maybe<Scalars['BigInt']>;
  offsetValue?: Maybe<Scalars['BigInt']>;
  postalCodes?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_PostalCode>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRegionsRequestParameters_Input = {
  /** For searching by ID */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** For searching by name */
  name?: InputMaybe<Scalars['String']>;
};

/** Regions API Request // */
export type Instacart_Customers_Partners_V1_GetRegionsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRegionsRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** Regions API Response // */
export type Instacart_Customers_Partners_V1_GetRegionsResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRegionsResponse';
  regions?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Region>>>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequestParameters_Input = {
  activeOnly?: InputMaybe<Scalars['Boolean']>;
  includePhysicalZone?: InputMaybe<Scalars['Boolean']>;
  includeTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /** Optionally pass in the location_codes to filter by */
  locationCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optionally pass in the name to filter by */
  name?: InputMaybe<Scalars['String']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsByRetailerResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailerLocationsByRetailerResponse';
  limitValue?: Maybe<Scalars['BigInt']>;
  offsetValue?: Maybe<Scalars['BigInt']>;
  retailerLocations?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_RetailerLocation>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerLocationsRequestParameters_Input = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  includePhysicalZone?: InputMaybe<Scalars['Boolean']>;
  includeTimeZone?: InputMaybe<Scalars['Boolean']>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
};

/** RetailerLocations API Request // */
export type Instacart_Customers_Partners_V1_GetRetailerLocationsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerLocationsRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** RetailerLocations API Response // */
export type Instacart_Customers_Partners_V1_GetRetailerLocationsResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailerLocationsResponse';
  limitValue?: Maybe<Scalars['BigInt']>;
  offsetValue?: Maybe<Scalars['BigInt']>;
  retailerLocations?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_RetailerLocation>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerZonesRequestParameters_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional for searching multiple retailers */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  visibleOnly?: InputMaybe<Scalars['Boolean']>;
  /** Optional for getting all retailers within particular zones */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Partners_V1_GetRetailerZonesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailerZonesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailerZonesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailerZonesResponse';
  retailerZones?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_RetailerZone>>>;
};

export type Instacart_Customers_Partners_V1_GetRetailersRequestParameters_Input = {
  /** For searching by IDs */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optionally pass in the limit to reduce the number of records returned */
  limitValue?: InputMaybe<Scalars['BigInt']>;
  /**
   * For searching by name
   * Optional to only include retailers with visible=true AND at least one WHL with active=true
   */
  name?: InputMaybe<Scalars['String']>;
  /** Optionally pass in the offset to reduce the number of records returned */
  offsetValue?: InputMaybe<Scalars['BigInt']>;
  onlyVisibleAndActive?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Partners_V1_GetRetailersRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetRetailersRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetRetailersResponse = {
  __typename?: 'instacart_customers_partners_v1_GetRetailersResponse';
  limitValue?: Maybe<Scalars['BigInt']>;
  offsetValue?: Maybe<Scalars['BigInt']>;
  retailers?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Retailer>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetZonesByRegionRequestParameters_Input = {
  /** For searching by ID */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** For searching by name */
  name?: InputMaybe<Scalars['String']>;
  /** Required, we will only show a subset of zones by region */
  regionId?: InputMaybe<Scalars['BigInt']>;
};

/** Zones API Request // */
export type Instacart_Customers_Partners_V1_GetZonesByRegionRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesByRegionRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partners_V1_GetZonesByRegionResponse = {
  __typename?: 'instacart_customers_partners_v1_GetZonesByRegionResponse';
  zones?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Zone>>>;
};

export type Instacart_Customers_Partners_V1_GetZonesRequestParameters_Input = {
  /** For searching by IDs, optional */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * For searching by name, optional
   * If a search string is provided and a number or list of numbers can be extracted from it, search for those numbers as ids as well.
   */
  name?: InputMaybe<Scalars['String']>;
};

/** Zones API Request // */
export type Instacart_Customers_Partners_V1_GetZonesRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Partners_V1_GetZonesRequestParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

/** Zones API Response // */
export type Instacart_Customers_Partners_V1_GetZonesResponse = {
  __typename?: 'instacart_customers_partners_v1_GetZonesResponse';
  zones?: Maybe<Array<Maybe<Instacart_Customers_Partners_V1_Zone>>>;
};

/** Partners API Objects // */
export type Instacart_Customers_Partners_V1_Partner = {
  __typename?: 'instacart_customers_partners_v1_Partner';
  expansionOwnerUserId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  partnerType?: Maybe<Scalars['String']>;
  partnershipType?: Maybe<Scalars['String']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  salesforceId?: Maybe<Scalars['String']>;
};

/** PostalCode API Objects // */
export type Instacart_Customers_Partners_V1_PostalCode = {
  __typename?: 'instacart_customers_partners_v1_PostalCode';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Region API Objects // */
export type Instacart_Customers_Partners_V1_Region = {
  __typename?: 'instacart_customers_partners_v1_Region';
  countryId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Partners_V1_Retailer = {
  __typename?: 'instacart_customers_partners_v1_Retailer';
  adminOnly?: Maybe<Scalars['Boolean']>;
  aliasName?: Maybe<Scalars['String']>;
  allowAlcohol?: Maybe<Scalars['Boolean']>;
  allowSpecialRequests?: Maybe<Scalars['Boolean']>;
  backgroundColorHex?: Maybe<Scalars['String']>;
  backgroundImagePath?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  countrySlug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** Environment this Retailer runs in. Defaults to production when unspecified. */
  environment?: Maybe<Instacart_Customers_Partners_V1_Environment>;
  franchiseeId?: Maybe<Scalars['BigInt']>;
  franchisorId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  /** For a sandbox Retailer: the id of the production Retailer it is paired with. Unset otherwise. */
  linkedWarehouseId?: Maybe<Scalars['BigInt']>;
  logoBackgroundColor?: Maybe<Scalars['String']>;
  logoImagePath?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  priceParity?: Maybe<Scalars['Boolean']>;
  priceTransparencyDescription?: Maybe<Scalars['String']>;
  priceTransparencyFlag?: Maybe<Scalars['String']>;
  retailerType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** RetailerLocations API Objects // */
export type Instacart_Customers_Partners_V1_RetailerLocation = {
  __typename?: 'instacart_customers_partners_v1_RetailerLocation';
  active?: Maybe<Scalars['Boolean']>;
  addressCounty?: Maybe<Scalars['String']>;
  addressId?: Maybe<Scalars['BigInt']>;
  bagFeeRateCents?: Maybe<Scalars['BigInt']>;
  city?: Maybe<Scalars['String']>;
  curbsidePickup?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  issEnabled?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  locationCode?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  partnerPickup?: Maybe<Scalars['Boolean']>;
  physicalZone?: Maybe<Instacart_Customers_Partners_V1_Zone>;
  pickup?: Maybe<Scalars['Boolean']>;
  pickupOnly?: Maybe<Scalars['Boolean']>;
  postalCode?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  timeZone?: Maybe<Scalars['String']>;
  unavailable?: Maybe<Scalars['Boolean']>;
  zipPlusFour?: Maybe<Scalars['String']>;
};

/** RetailerZone API Objects // */
export type Instacart_Customers_Partners_V1_RetailerZone = {
  __typename?: 'instacart_customers_partners_v1_RetailerZone';
  allowLocationInventory?: Maybe<Scalars['Boolean']>;
  delivery?: Maybe<Scalars['Boolean']>;
  handoffBatchingOnly?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  pickup?: Maybe<Scalars['Boolean']>;
  promote?: Maybe<Scalars['Boolean']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  salePriceAllowed?: Maybe<Scalars['Boolean']>;
  visible?: Maybe<Scalars['Boolean']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Zone API Objects // */
export type Instacart_Customers_Partners_V1_Zone = {
  __typename?: 'instacart_customers_partners_v1_Zone';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsRequest_Input = {
  churnedDays?: InputMaybe<Scalars['BigInt']>;
  count?: InputMaybe<Scalars['BigInt']>;
  createdBy?: InputMaybe<Scalars['String']>;
  discountPolicyId?: InputMaybe<Scalars['BigInt']>;
  jobName?: InputMaybe<Scalars['String']>;
  omitUuid?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
  userSegment?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Partnership_Offer_V1_CreateRedemptionUrlsResponse = {
  __typename?: 'instacart_customers_partnership_offer_v1_CreateRedemptionUrlsResponse';
  urlJob?: Maybe<Instacart_Customers_Partnership_Offer_V1_PartnershipManagementUrl>;
};

export type Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkRequest_Input = {
  partnershipManagementUrlId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partnership_Offer_V1_GetPartnershipManagementUrlDownloadLinkResponse = {
  __typename?: 'instacart_customers_partnership_offer_v1_GetPartnershipManagementUrlDownloadLinkResponse';
  filePath?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsRequest_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Partnership_Offer_V1_ListPartnershipManagementUrlsResponse = {
  __typename?: 'instacart_customers_partnership_offer_v1_ListPartnershipManagementUrlsResponse';
  urlJobs?: Maybe<Array<Maybe<Instacart_Customers_Partnership_Offer_V1_PartnershipManagementUrl>>>;
};

export type Instacart_Customers_Partnership_Offer_V1_PartnershipManagementUrl = {
  __typename?: 'instacart_customers_partnership_offer_v1_PartnershipManagementUrl';
  createdBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uniqueUrl?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Payments_V1_CardProductCode = {
  __typename?: 'instacart_customers_payments_v1_CardProductCode';
  code?: Maybe<Scalars['String']>;
  source?: Maybe<Instacart_Customers_Payments_V1_CardProductCode_CardProductCodeSource>;
};

export enum Instacart_Customers_Payments_V1_CardProductCode_CardProductCodeSource {
  /** CPC came from the credit card network via a payment authorization */
  CardNetwork = 'CARD_NETWORK',
  CardProductCodeSourceUnspecified = 'CARD_PRODUCT_CODE_SOURCE_UNSPECIFIED',
  /** CPC was determined by Stripe based on their heuristics, not 100% reliable */
  StripeHeuristic = 'STRIPE_HEURISTIC'
}

export type Instacart_Customers_Payments_V1_CreateStripeConnectedAccountOnboardingLinkRequest_Input = {
  /** The type of account to onboard. */
  accountType?: InputMaybe<Instacart_Customers_Payments_V1_RetailerPaymentGatewayAccountType>;
  /**
   * Optional email address to notify when the Stripe connected account
   * is updated (e.g., when onboarding completes or account status changes).
   */
  email?: InputMaybe<Scalars['String']>;
  entity?: InputMaybe<Instacart_Customers_Payments_V1_RetailerPaymentGatewayAccountEntity_Input>;
};

export type Instacart_Customers_Payments_V1_CreateStripeConnectedAccountOnboardingLinkResponse = {
  __typename?: 'instacart_customers_payments_v1_CreateStripeConnectedAccountOnboardingLinkResponse';
  /** The onboarding link URL for the Stripe connected account. */
  onboardingLink?: Maybe<Scalars['String']>;
};

/** https://blazer.instacart.tools/blazer/queries/246541-distinct-credit_card_types-for-credit-cards */
export enum Instacart_Customers_Payments_V1_CreditCardType {
  AmericanExpress = 'AMERICAN_EXPRESS',
  CartesBancaires = 'CARTES_BANCAIRES',
  CreditCardTypeUnspecified = 'CREDIT_CARD_TYPE_UNSPECIFIED',
  DinersClub = 'DINERS_CLUB',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  MasterCard = 'MASTER_CARD',
  Scb = 'SCB',
  UnionPay = 'UNION_PAY',
  Visa = 'VISA'
}

export type Instacart_Customers_Payments_V1_DirectedSpendData = {
  __typename?: 'instacart_customers_payments_v1_DirectedSpendData';
  /** Program code. */
  programCode?: Maybe<Scalars['String']>;
  /** Program type. */
  programType?: Maybe<Instacart_Customers_Payments_V1_DirectedSpendData_ProgramType>;
};

/** Program type. */
export enum Instacart_Customers_Payments_V1_DirectedSpendData_ProgramType {
  FreshFunds = 'FRESH_FUNDS',
  ProgramTypeUnspecified = 'PROGRAM_TYPE_UNSPECIFIED'
}

/** Next ID: 12 */
export type Instacart_Customers_Payments_V1_InstrumentDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail';
  applePayDetail?: Maybe<Scalars['instacart_customers_payments_v1_InstrumentDetail_ApplePayDetail']>;
  cashAppDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_CashAppDetail>;
  creditCardDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardDetail>;
  creditCardError?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardError>;
  digitalWalletDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_DigitalWalletDetail>;
  ebtCardDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_EbtCardDetail>;
  externalInstrumentDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_ExternalInstrumentDetail>;
  /** instrument reference. */
  instrumentReference?: Maybe<Scalars['String']>;
  klarnaDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_KlarnaDetail>;
  paypalDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_PaypalDetail>;
  /**
   * Instrument is restricted to only be used in these countries (ISO 3166-1).
   * Optional: if null or empty, no restriction is applied.
   */
  permittedCountryCodes?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  subwallet?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_Subwallet>;
  /**
   * The last time the instrument was updated.
   * This field can be used for Fraud detection.
   */
  updatedAt?: Maybe<Scalars['DateTime']>;
  venmoDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_VenmoDetail>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_CashAppDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CashAppDetail';
  username?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CreditCardDetail';
  cardProductCode?: Maybe<Instacart_Customers_Payments_V1_CardProductCode>;
  chaseCardDetail?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardDetail_ChaseCardDetail>;
  creditCardType?: Maybe<Instacart_Customers_Payments_V1_CreditCardType>;
  issuerIdentificationNumber?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
};

/** These fields are to be used by Chase Embedded partnership (CS-55177). */
export type Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardDetail_ChaseCardDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CreditCardDetail_ChaseCardDetail';
  chaseCardType?: Maybe<Scalars['String']>;
  chaseReferenceIdentifier?: Maybe<Scalars['String']>;
  isTestCard?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardError = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CreditCardError';
  chaseCardError?: Maybe<Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardError_ChaseCardError>;
};

/** These fields are to be used by Chase Embedded partnership (CS-55177). */
export type Instacart_Customers_Payments_V1_InstrumentDetail_CreditCardError_ChaseCardError = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CreditCardError_ChaseCardError';
  errorDescription?: Maybe<Scalars['String']>;
  serviceErrorCode?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_DigitalWalletDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_DigitalWalletDetail';
  /** The digital wallet's currency. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Directed Spend data for the digital wallet, if applicable (optional). */
  directedSpendData?: Maybe<Instacart_Customers_Payments_V1_DirectedSpendData>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_EbtCardDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_EbtCardDetail';
  lastFour?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_ExternalInstrumentDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_ExternalInstrumentDetail';
  /**
   * Custom label to display for this instrument.
   * If empty or nil, there is no custom label set.
   */
  customDisplayLabel?: Maybe<Scalars['String']>;
  externalInstrumentToken?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_KlarnaDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_KlarnaDetail';
  email?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Payments_V1_InstrumentDetail_PaypalDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_PaypalDetail';
  email?: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Payments_V1_InstrumentDetail_Subwallet {
  HsaFsa = 'HSA_FSA',
  SubwalletUnspecified = 'SUBWALLET_UNSPECIFIED'
}

export type Instacart_Customers_Payments_V1_InstrumentDetail_VenmoDetail = {
  __typename?: 'instacart_customers_payments_v1_InstrumentDetail_VenmoDetail';
  username?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Payments_V1_RenderableInstrument_InstrumentDisableInfo = {
  __typename?: 'instacart_customers_payments_v1_RenderableInstrument_InstrumentDisableInfo';
  disabledForAlcoholic?: Maybe<Scalars['Boolean']>;
  disabledForCbdOrThc?: Maybe<Scalars['Boolean']>;
  disabledForDeprecation?: Maybe<Scalars['Boolean']>;
  disabledForEbt?: Maybe<Scalars['Boolean']>;
  disabledForMaintenance?: Maybe<Scalars['Boolean']>;
  disabledForMastercardScenario?: Maybe<Scalars['Boolean']>;
  disabledForRx?: Maybe<Scalars['Boolean']>;
};

/**
 * The entity that owns a payment gateway account (e.g. a retailer or a
 * retailer location).
 */
export type Instacart_Customers_Payments_V1_RetailerPaymentGatewayAccountEntity_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Payments_V1_RetailerPaymentGatewayAccountType {
  RetailerPaymentGatewayAccountTypeAlcohol = 'RETAILER_PAYMENT_GATEWAY_ACCOUNT_TYPE_ALCOHOL',
  RetailerPaymentGatewayAccountTypeRetailerDirectPay = 'RETAILER_PAYMENT_GATEWAY_ACCOUNT_TYPE_RETAILER_DIRECT_PAY',
  RetailerPaymentGatewayAccountTypeRx = 'RETAILER_PAYMENT_GATEWAY_ACCOUNT_TYPE_RX',
  RetailerPaymentGatewayAccountTypeUnspecified = 'RETAILER_PAYMENT_GATEWAY_ACCOUNT_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Product_Retrieval_V1_DeprecatedItemsDenormalizedsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_DeprecatedItemsDenormalizedsAttributes';
  blackoutTimes?: Maybe<Scalars['String']>;
  buyNGetN?: Maybe<Scalars['String']>;
  catalogEntityId?: Maybe<Scalars['BigInt']>;
  comboPromotions?: Maybe<Scalars['String']>;
  comboPromotionsJsonb?: Maybe<Scalars['String']>;
  configurableProducts?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
  displaySize?: Maybe<Scalars['String']>;
  elasticItemId?: Maybe<Scalars['BigInt']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  inStoreLocation?: Maybe<Scalars['String']>;
  inventoryAreaId?: Maybe<Scalars['Int']>;
  itemId?: Maybe<Scalars['BigInt']>;
  itemTaxData?: Maybe<Scalars['String']>;
  mentosItemPartialRowId?: Maybe<Scalars['BigInt']>;
  productId?: Maybe<Scalars['Int']>;
  promotionsDetails?: Maybe<Scalars['String']>;
  retailerDepartment?: Maybe<Scalars['String']>;
  retailerFlyerData?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['Int']>;
  retailerLookupCode?: Maybe<Scalars['String']>;
  retailerPromotionDetails?: Maybe<Scalars['String']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  retailerSalesTaxCode?: Maybe<Scalars['String']>;
  retailerSpecificMetadata?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  storageTemp?: Maybe<Scalars['String']>;
  surfaceId?: Maybe<Scalars['BigInt']>;
  temporaryOverrideElasticItemId?: Maybe<Scalars['BigInt']>;
  unataFulfillmentTypes?: Maybe<Scalars['String']>;
  vertexTaxCode?: Maybe<Scalars['String']>;
  zoneIds?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_DeprecatedRetailerProductsCpgsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_DeprecatedRetailerProductsCpgsAttributes';
  cpgElasticRetailerProductId?: Maybe<Scalars['BigInt']>;
  data?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  retailerId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Parameters_Input>;
  /** Used for passing information about the request. */
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersRequest_Parameters_Input = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  hasImage?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  /** IDs of products to get */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Text search query for product name and brand */
  query?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  searchable?: InputMaybe<Scalars['Boolean']>;
  /** Attributes to select */
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_GetLegacyProductsWithFiltersResponse';
  responseMeta?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results?: Maybe<Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_GetLegacyProductsWithFiltersResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_GetLegacyProductsWithFiltersResponse_Results';
  products?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_InventoryAreaAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_InventoryAreaAttributes';
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['BigInt']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

/**
 * An item is currently represented by a union of all the tables joined in the get items query.
 * This is because a generic select parameter exists that allows clients to request any <table>.<column>
 * that exists in the final result set. This is unfortunate because currently that means we'll have a 500 field
 * protobuf message. We should consider a v2 of what an item is by grouping cohesive fields together into nested messages.
 */
export type Instacart_Customers_Product_Retrieval_V1_Item = {
  __typename?: 'instacart_customers_product_retrieval_v1_Item';
  deprecatedItemsDenormalizedsAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_DeprecatedItemsDenormalizedsAttributes>;
  deprecatedRetailerProductsCpgsAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_DeprecatedRetailerProductsCpgsAttributes>;
  inventoryAreaAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_InventoryAreaAttributes>;
  itemAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_ItemAttributes>;
  itemId?: Maybe<Scalars['BigInt']>;
  otherAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_OtherAttributes>;
  productAvailabilitiesAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_ProductAvailabilitiesAttributes>;
  retailerProductRetailerCollectionsV2Attributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_RetailerProductRetailerCollectionsV2Attributes>;
  retailerProductsAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_RetailerProductsAttributes>;
  retailerProductsCpgsAttributes?: Maybe<Instacart_Customers_Product_Retrieval_V1_RetailerProductsCpgsAttributes>;
};

export type Instacart_Customers_Product_Retrieval_V1_ItemAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_ItemAttributes';
  alcoholic?: Maybe<Scalars['Boolean']>;
  availabilityEndDate?: Maybe<Scalars['DateTime']>;
  availabilityStartDate?: Maybe<Scalars['DateTime']>;
  available?: Maybe<Scalars['Boolean']>;
  balanceOnHandQty?: Maybe<Scalars['Int']>;
  bogoBuy?: Maybe<Scalars['Int']>;
  bogoGet?: Maybe<Scalars['Int']>;
  bottleDepositBankId?: Maybe<Scalars['Int']>;
  bottleDepositCents?: Maybe<Scalars['Int']>;
  bottleDepositCurrency?: Maybe<Scalars['String']>;
  cancelLeadTime?: Maybe<Scalars['Int']>;
  carrotAdsCategoryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  catalogEntityId?: Maybe<Scalars['BigInt']>;
  codeSetVersion?: Maybe<Scalars['Int']>;
  cost?: Maybe<Scalars['String']>;
  costPricePerCase?: Maybe<Scalars['String']>;
  costPricePerUnit?: Maybe<Scalars['String']>;
  costUnit?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  digitalScaleRequired?: Maybe<Scalars['Boolean']>;
  elasticItemId?: Maybe<Scalars['BigInt']>;
  eversightPricing?: Maybe<Scalars['String']>;
  excludeMarkup?: Maybe<Scalars['Boolean']>;
  fizzEligible?: Maybe<Scalars['Boolean']>;
  fulfillDelivery?: Maybe<Scalars['Boolean']>;
  fulfillExtraLongDistanceDelivery?: Maybe<Scalars['Boolean']>;
  fulfillInstore?: Maybe<Scalars['Boolean']>;
  fulfillPickup?: Maybe<Scalars['Boolean']>;
  fullPrice?: Maybe<Scalars['String']>;
  fullText?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  hasRetailerPromotion?: Maybe<Scalars['Boolean']>;
  inAssortment?: Maybe<Scalars['Boolean']>;
  inventoryAreaId?: Maybe<Scalars['Int']>;
  isAlcoholic?: Maybe<Scalars['Boolean']>;
  isCatering?: Maybe<Scalars['Boolean']>;
  isHot?: Maybe<Scalars['Boolean']>;
  isPackagedByWeight?: Maybe<Scalars['Boolean']>;
  itemDepartmentId?: Maybe<Scalars['String']>;
  itemId?: Maybe<Scalars['BigInt']>;
  itemType?: Maybe<Scalars['String']>;
  localeCode?: Maybe<Scalars['String']>;
  loyaltyAllowed?: Maybe<Scalars['Boolean']>;
  loyaltyCostPriceCents?: Maybe<Scalars['Int']>;
  loyaltyCostPriceCurrency?: Maybe<Scalars['String']>;
  loyaltyCostPriceEndAt?: Maybe<Scalars['DateTime']>;
  loyaltyCostPricePerUnit?: Maybe<Scalars['String']>;
  loyaltyCostPriceStartAt?: Maybe<Scalars['DateTime']>;
  loyaltyMembersOnly?: Maybe<Scalars['Boolean']>;
  loyaltyPrice?: Maybe<Scalars['String']>;
  loyaltyPriceActive?: Maybe<Scalars['Boolean']>;
  loyaltyPriceEndAt?: Maybe<Scalars['DateTime']>;
  loyaltyPriceStartAt?: Maybe<Scalars['DateTime']>;
  maxCart?: Maybe<Scalars['Float']>;
  maxInCart?: Maybe<Scalars['Int']>;
  mentosItemPartialRowId?: Maybe<Scalars['BigInt']>;
  onSale?: Maybe<Scalars['Boolean']>;
  orderLeadTime?: Maybe<Scalars['Int']>;
  packagedAs?: Maybe<Array<Maybe<Scalars['String']>>>;
  palletQuantity?: Maybe<Scalars['BigInt']>;
  parWeight?: Maybe<Scalars['Float']>;
  previewEndDate?: Maybe<Scalars['DateTime']>;
  previewStartDate?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Scalars['String']>;
  priceMultiple?: Maybe<Scalars['Float']>;
  pricePerUnit?: Maybe<Scalars['String']>;
  pricedBySoldByType?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productType?: Maybe<Scalars['String']>;
  promotionDiscountBeginsAt?: Maybe<Scalars['DateTime']>;
  promotionDiscountEndsAt?: Maybe<Scalars['DateTime']>;
  promotionGroupId?: Maybe<Scalars['String']>;
  proviDistributorIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  recentlyShoppedAt?: Maybe<Scalars['DateTime']>;
  regionId?: Maybe<Scalars['Int']>;
  retailerDepartment?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['Int']>;
  retailerProductExperimentVariantId?: Maybe<Scalars['Int']>;
  retailerProductScoreBrowseCtrPopV0?: Maybe<Scalars['Float']>;
  retailerPromotionFractionApproximation?: Maybe<Scalars['Float']>;
  retailerSalesTaxRate?: Maybe<Scalars['Float']>;
  retailerSpecificKeyword?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerSpecifiedAlcoholic?: Maybe<Scalars['Boolean']>;
  rewardProgram?: Maybe<Scalars['String']>;
  rewardUnit?: Maybe<Scalars['String']>;
  rewardValue?: Maybe<Scalars['Float']>;
  saleAllowed?: Maybe<Scalars['Boolean']>;
  saleCostPricePerUnit?: Maybe<Scalars['String']>;
  saleEndAt?: Maybe<Scalars['DateTime']>;
  salePriceCents?: Maybe<Scalars['Int']>;
  saleStartAt?: Maybe<Scalars['DateTime']>;
  salesType?: Maybe<Scalars['String']>;
  searchable?: Maybe<Scalars['Boolean']>;
  sfBbTempFlag?: Maybe<Scalars['Boolean']>;
  sizeUomVariable?: Maybe<Scalars['String']>;
  surfaceId?: Maybe<Scalars['BigInt']>;
  taxable?: Maybe<Scalars['Boolean']>;
  temporaryOverrideElasticItemId?: Maybe<Scalars['BigInt']>;
  unataAvailable?: Maybe<Scalars['Boolean']>;
  unataInAssortment?: Maybe<Scalars['Boolean']>;
  unit?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['Int']>;
  unitPrice?: Maybe<Scalars['Float']>;
  unitsPerCase?: Maybe<Scalars['BigInt']>;
  unlisted?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usaEbtcashEligible?: Maybe<Scalars['Boolean']>;
  usaSnapEligible?: Maybe<Scalars['Boolean']>;
  useWeight?: Maybe<Scalars['Boolean']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute = {
  __typename?: 'instacart_customers_product_retrieval_v1_ItemPriceAttribute';
  cents?: Maybe<Scalars['BigInt']>;
  endDate?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['DateTime']>;
  subtype?: Maybe<Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeSubtype>;
  type?: Maybe<Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeType>;
};

export enum Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeSubtype {
  ItemPriceAttributeSubtypeLoyalty = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_LOYALTY',
  ItemPriceAttributeSubtypeRegular = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_REGULAR',
  ItemPriceAttributeSubtypeSale = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_SALE',
  ItemPriceAttributeSubtypeUnspecified = 'ITEM_PRICE_ATTRIBUTE_SUBTYPE_UNSPECIFIED'
}

export enum Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute_ItemPriceAttributeType {
  ItemPriceAttributeTypeOcr = 'ITEM_PRICE_ATTRIBUTE_TYPE_OCR',
  ItemPriceAttributeTypeUnspecified = 'ITEM_PRICE_ATTRIBUTE_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct';
  /** aisle_ids integer[] DEFAULT '{}'::integer[] */
  aisleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** aislefinity_retailer_aisles jsonb */
  aislefinityRetailerAisles?: Maybe<Scalars['String']>;
  /** antibiotic_free boolean */
  antibioticFree?: Maybe<Scalars['Boolean']>;
  /** available_inventory_area_ids integer[] DEFAULT '{}'::integer[] */
  availableInventoryAreaIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** available_items_count integer */
  availableItemsCount?: Maybe<Scalars['Int']>;
  /** available_region_ids integer[] DEFAULT '{}'::integer[] */
  availableRegionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** available_warehouse_ids integer[] DEFAULT '{}'::integer[] */
  availableWarehouseIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** available_zone_ids integer[] DEFAULT '{}'::integer[] */
  availableZoneIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** brand jsonb */
  brand?: Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_Brand>;
  /** brand_name character varying */
  brandName?: Maybe<Scalars['String']>;
  /** breed_angus boolean */
  breedAngus?: Maybe<Scalars['Boolean']>;
  /** breed_berkshire boolean */
  breedBerkshire?: Maybe<Scalars['Boolean']>;
  /** breed_duroc_pork boolean */
  breedDurocPork?: Maybe<Scalars['Boolean']>;
  /** breed_gloucestershire boolean */
  breedGloucestershire?: Maybe<Scalars['Boolean']>;
  /** breed_kobe_wagyu boolean */
  breedKobeWagyu?: Maybe<Scalars['Boolean']>;
  /** breed_kurobata_berkshire boolean */
  breedKurobataBerkshire?: Maybe<Scalars['Boolean']>;
  /** breed_mangalitsapork boolean */
  breedMangalitsapork?: Maybe<Scalars['Boolean']>;
  /** breed_piedmontese boolean */
  breedPiedmontese?: Maybe<Scalars['Boolean']>;
  /** breed_veal boolean */
  breedVeal?: Maybe<Scalars['Boolean']>;
  /** breed_wagyu boolean */
  breedWagyu?: Maybe<Scalars['Boolean']>;
  /** cage_free boolean */
  cageFree?: Maybe<Scalars['Boolean']>;
  /** color character varying */
  color?: Maybe<Scalars['String']>;
  /** color_brown boolean */
  colorBrown?: Maybe<Scalars['Boolean']>;
  /** color_hex_code character varying */
  colorHexCode?: Maybe<Scalars['String']>;
  /** color_white boolean */
  colorWhite?: Maybe<Scalars['Boolean']>;
  /** common_aisle character varying */
  commonAisle?: Maybe<Scalars['String']>;
  /** contains_probiotics boolean */
  containsProbiotics?: Maybe<Scalars['Boolean']>;
  /** conversions jsonb */
  conversions?: Maybe<Scalars['String']>;
  /** cooking_method_braise boolean */
  cookingMethodBraise?: Maybe<Scalars['Boolean']>;
  /** cooking_method_grill boolean */
  cookingMethodGrill?: Maybe<Scalars['Boolean']>;
  /** cooking_method_pan_fry boolean */
  cookingMethodPanFry?: Maybe<Scalars['Boolean']>;
  /** cooking_method_roast boolean */
  cookingMethodRoast?: Maybe<Scalars['Boolean']>;
  /** country_ids integer[] DEFAULT '{}'::integer[] */
  countryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** cuisine_tropical boolean */
  cuisineTropical?: Maybe<Scalars['Boolean']>;
  /** dairy_free boolean */
  dairyFree?: Maybe<Scalars['Boolean']>;
  /** department_ids integer[] DEFAULT '{}'::integer[] */
  departmentIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** department_names character varying[] DEFAULT '{}'::character varying[] */
  departmentNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** depth_uom character varying */
  depthUom?: Maybe<Scalars['String']>;
  /** depth_value character varying */
  depthValue?: Maybe<Scalars['String']>;
  /** display_name character varying */
  displayName?: Maybe<Scalars['String']>;
  /** elastic_product_id bigint */
  elasticProductId?: Maybe<Scalars['BigInt']>;
  /** farm character varying */
  farm?: Maybe<Scalars['String']>;
  /** farmed boolean */
  farmed?: Maybe<Scalars['Boolean']>;
  /** flavor character varying */
  flavor?: Maybe<Scalars['String']>;
  /** fortified boolean */
  fortified?: Maybe<Scalars['Boolean']>;
  /** free_range boolean */
  freeRange?: Maybe<Scalars['Boolean']>;
  /** full_text tsvector */
  fullText?: Maybe<Scalars['String']>;
  /** generated_at timestamp without time zone NOT NULL */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** global_scan_codes character varying[] DEFAULT '{}'::character varying[] */
  globalScanCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** grade character varying */
  grade?: Maybe<Scalars['String']>;
  /** grade_a boolean */
  gradeA?: Maybe<Scalars['Boolean']>;
  /** grade_aa boolean */
  gradeAa?: Maybe<Scalars['Boolean']>;
  /** grade_b boolean */
  gradeB?: Maybe<Scalars['Boolean']>;
  /** grass_fed boolean */
  grassFed?: Maybe<Scalars['Boolean']>;
  /** halal boolean */
  halal?: Maybe<Scalars['Boolean']>;
  /** has_global_product_code boolean */
  hasGlobalProductCode?: Maybe<Scalars['Boolean']>;
  /** has_image boolean */
  hasImage?: Maybe<Scalars['Boolean']>;
  /** height_uom character varying */
  heightUom?: Maybe<Scalars['String']>;
  /** height_value character varying */
  heightValue?: Maybe<Scalars['String']>;
  /** high_protein boolean */
  highProtein?: Maybe<Scalars['Boolean']>;
  /** hormone_free boolean */
  hormoneFree?: Maybe<Scalars['Boolean']>;
  idpAttributeSourceOptedOut?: Maybe<Array<Maybe<Scalars['String']>>>;
  idpWinningSourceData?: Maybe<Scalars['String']>;
  /** image_list jsonb */
  imageList?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ImageList>>>;
  /** image_url character varying */
  imageUrl?: Maybe<Scalars['String']>;
  /** infinity_weights jsonb */
  infinityWeights?: Maybe<Scalars['String']>;
  /** inventory_area_ids integer[] DEFAULT '{}'::integer[] */
  inventoryAreaIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** is_catering boolean */
  isCatering?: Maybe<Scalars['Boolean']>;
  /** keywords character varying[] DEFAULT '{}'::character varying[] */
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** lactose_free boolean */
  lactoseFree?: Maybe<Scalars['Boolean']>;
  /** landing_param character varying */
  landingParam?: Maybe<Scalars['String']>;
  /** large_image_url character varying */
  largeImageUrl?: Maybe<Scalars['String']>;
  /** locale_code character varying */
  localeCode?: Maybe<Scalars['String']>;
  /** meat_state text */
  meatState?: Maybe<Scalars['String']>;
  /** milk_type_almond boolean */
  milkTypeAlmond?: Maybe<Scalars['Boolean']>;
  /** milk_type_buffalo boolean */
  milkTypeBuffalo?: Maybe<Scalars['Boolean']>;
  /** milk_type_camel boolean */
  milkTypeCamel?: Maybe<Scalars['Boolean']>;
  /** milk_type_cashew boolean */
  milkTypeCashew?: Maybe<Scalars['Boolean']>;
  /** milk_type_coconut boolean */
  milkTypeCoconut?: Maybe<Scalars['Boolean']>;
  /** milk_type_cow boolean */
  milkTypeCow?: Maybe<Scalars['Boolean']>;
  /** milk_type_donkey boolean */
  milkTypeDonkey?: Maybe<Scalars['Boolean']>;
  /** milk_type_flax boolean */
  milkTypeFlax?: Maybe<Scalars['Boolean']>;
  /** milk_type_goat boolean */
  milkTypeGoat?: Maybe<Scalars['Boolean']>;
  /** milk_type_hazelnut boolean */
  milkTypeHazelnut?: Maybe<Scalars['Boolean']>;
  /** milk_type_hemp boolean */
  milkTypeHemp?: Maybe<Scalars['Boolean']>;
  /** milk_type_mare boolean */
  milkTypeMare?: Maybe<Scalars['Boolean']>;
  /** milk_type_moose boolean */
  milkTypeMoose?: Maybe<Scalars['Boolean']>;
  /** milk_type_oat boolean */
  milkTypeOat?: Maybe<Scalars['Boolean']>;
  /** milk_type_reindeer boolean */
  milkTypeReindeer?: Maybe<Scalars['Boolean']>;
  /** milk_type_rice boolean */
  milkTypeRice?: Maybe<Scalars['Boolean']>;
  /** milk_type_sheep boolean */
  milkTypeSheep?: Maybe<Scalars['Boolean']>;
  /** milk_type_soy boolean */
  milkTypeSoy?: Maybe<Scalars['Boolean']>;
  /** milk_type_sunflower boolean */
  milkTypeSunflower?: Maybe<Scalars['Boolean']>;
  /** milk_type_waterbuffalo boolean */
  milkTypeWaterbuffalo?: Maybe<Scalars['Boolean']>;
  /** milk_type_whole_grain boolean */
  milkTypeWholeGrain?: Maybe<Scalars['Boolean']>;
  /** milk_type_yak boolean */
  milkTypeYak?: Maybe<Scalars['Boolean']>;
  /** no_added_sugar boolean */
  noAddedSugar?: Maybe<Scalars['Boolean']>;
  /** non_gmo boolean */
  nonGmo?: Maybe<Scalars['Boolean']>;
  /** nutritional_info jsonb */
  nutritionalInfo?: Maybe<Scalars['JSON']>;
  /** omega3_enriched boolean */
  omega3Enriched?: Maybe<Scalars['Boolean']>;
  /** origin character varying */
  origin?: Maybe<Scalars['String']>;
  /** original_name character varying */
  originalName?: Maybe<Scalars['String']>;
  /** packaging character varying */
  packaging?: Maybe<Scalars['String']>;
  /** packaging_bagged boolean */
  packagingBagged?: Maybe<Scalars['Boolean']>;
  /** packaging_bunched boolean */
  packagingBunched?: Maybe<Scalars['Boolean']>;
  /** pasture_raised boolean */
  pastureRaised?: Maybe<Scalars['Boolean']>;
  /** prep_breaded_crusted boolean */
  prepBreadedCrusted?: Maybe<Scalars['Boolean']>;
  /** prep_chopped boolean */
  prepChopped?: Maybe<Scalars['Boolean']>;
  /** prep_chunks boolean */
  prepChunks?: Maybe<Scalars['Boolean']>;
  /** prep_core boolean */
  prepCore?: Maybe<Scalars['Boolean']>;
  /** prep_cured boolean */
  prepCured?: Maybe<Scalars['Boolean']>;
  /** prep_cut boolean */
  prepCut?: Maybe<Scalars['Boolean']>;
  /** prep_diced boolean */
  prepDiced?: Maybe<Scalars['Boolean']>;
  /** prep_dry_aged boolean */
  prepDryAged?: Maybe<Scalars['Boolean']>;
  /** prep_glazed boolean */
  prepGlazed?: Maybe<Scalars['Boolean']>;
  /** prep_grilled boolean */
  prepGrilled?: Maybe<Scalars['Boolean']>;
  /** prep_instructions character varying */
  prepInstructions?: Maybe<Scalars['String']>;
  /** prep_marinated boolean */
  prepMarinated?: Maybe<Scalars['Boolean']>;
  /** prep_party_tray boolean */
  prepPartyTray?: Maybe<Scalars['Boolean']>;
  /** prep_roasted boolean */
  prepRoasted?: Maybe<Scalars['Boolean']>;
  /** prep_rubbed boolean */
  prepRubbed?: Maybe<Scalars['Boolean']>;
  /** prep_seasoned boolean */
  prepSeasoned?: Maybe<Scalars['Boolean']>;
  /** prep_smoked boolean */
  prepSmoked?: Maybe<Scalars['Boolean']>;
  /** prep_spirals boolean */
  prepSpirals?: Maybe<Scalars['Boolean']>;
  /** prep_uncured boolean */
  prepUncured?: Maybe<Scalars['Boolean']>;
  /** prep_washed boolean */
  prepWashed?: Maybe<Scalars['Boolean']>;
  /** primal_cut text */
  primalCut?: Maybe<Scalars['String']>;
  /** product_category jsonb */
  productCategory?: Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCategory>;
  /** product_category_path character varying */
  productCategoryPath?: Maybe<Scalars['String']>;
  /** product_codes jsonb */
  productCodes?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCode>>>;
  /** product_enrichment_keywords character varying[] DEFAULT '{}'::character varying[] */
  productEnrichmentKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** product_id bigint NOT NULL */
  productId?: Maybe<Scalars['BigInt']>;
  /** product_info jsonb */
  productInfo?: Maybe<Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductInfo>;
  /** region_ids integer[] DEFAULT '{}'::integer[] */
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** retailer_ids integer[] DEFAULT '{}'::integer[] */
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** retailer_image_list character varying[] DEFAULT '{}'::character varying[] */
  retailerImageList?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** retailer_product_score_smoothed_count_v0 double precision */
  retailerProductScoreSmoothedCountV0?: Maybe<Scalars['Float']>;
  /** retailer_reference_codes jsonb */
  retailerReferenceCodes?: Maybe<Scalars['String']>;
  /** retailer_variant_group_code character varying */
  retailerVariantGroupCode?: Maybe<Scalars['String']>;
  /** romance_copy character varying */
  romanceCopy?: Maybe<Scalars['String']>;
  /** searchable boolean NOT NULL */
  searchable?: Maybe<Scalars['Boolean']>;
  /** seasonality jsonb */
  seasonality?: Maybe<Scalars['String']>;
  /** seedless boolean */
  seedless?: Maybe<Scalars['Boolean']>;
  /** size character varying */
  size?: Maybe<Scalars['String']>;
  /** size_baby boolean */
  sizeBaby?: Maybe<Scalars['Boolean']>;
  /** size_extra_large boolean */
  sizeExtraLarge?: Maybe<Scalars['Boolean']>;
  /** size_jumbo boolean */
  sizeJumbo?: Maybe<Scalars['Boolean']>;
  /** size_large boolean */
  sizeLarge?: Maybe<Scalars['Boolean']>;
  /** size_medium boolean */
  sizeMedium?: Maybe<Scalars['Boolean']>;
  /** size_small boolean */
  sizeSmall?: Maybe<Scalars['Boolean']>;
  /** size_uom character varying */
  sizeUom?: Maybe<Scalars['String']>;
  /** size_value double precision */
  sizeValue?: Maybe<Scalars['Float']>;
  /** sliced boolean */
  sliced?: Maybe<Scalars['Boolean']>;
  /** store_brand boolean */
  storeBrand?: Maybe<Scalars['Boolean']>;
  /** trim_bone_in boolean */
  trimBoneIn?: Maybe<Scalars['Boolean']>;
  /** trim_boneless boolean */
  trimBoneless?: Maybe<Scalars['Boolean']>;
  /** trim_deveined boolean */
  trimDeveined?: Maybe<Scalars['Boolean']>;
  /** trim_dressed boolean */
  trimDressed?: Maybe<Scalars['Boolean']>;
  /** trim_frenched boolean */
  trimFrenched?: Maybe<Scalars['Boolean']>;
  /** trim_head_on boolean */
  trimHeadOn?: Maybe<Scalars['Boolean']>;
  /** trim_peeled boolean */
  trimPeeled?: Maybe<Scalars['Boolean']>;
  /** trim_shell_on boolean */
  trimShellOn?: Maybe<Scalars['Boolean']>;
  /** trim_shredded boolean */
  trimShredded?: Maybe<Scalars['Boolean']>;
  /** trim_skin_on boolean */
  trimSkinOn?: Maybe<Scalars['Boolean']>;
  /** trim_skinless boolean */
  trimSkinless?: Maybe<Scalars['Boolean']>;
  /** trim_stuffed boolean */
  trimStuffed?: Maybe<Scalars['Boolean']>;
  /** trim_tail_off boolean */
  trimTailOff?: Maybe<Scalars['Boolean']>;
  /** trim_thick_cut boolean */
  trimThickCut?: Maybe<Scalars['Boolean']>;
  /** trim_thin_cut boolean */
  trimThinCut?: Maybe<Scalars['Boolean']>;
  /** unit_count character varying */
  unitCount?: Maybe<Scalars['String']>;
  /** usa_snap_eligible boolean */
  usaSnapEligible?: Maybe<Scalars['Boolean']>;
  /** variant_attributes character varying */
  variantAttributes?: Maybe<Scalars['String']>;
  /** variant_dimensions character varying */
  variantDimensions?: Maybe<Scalars['String']>;
  /** variant_group_code character varying */
  variantGroupCode?: Maybe<Scalars['String']>;
  /** variant_salted boolean */
  variantSalted?: Maybe<Scalars['Boolean']>;
  /** variant_unsalted boolean */
  variantUnsalted?: Maybe<Scalars['Boolean']>;
  /** variant_with_fruit boolean */
  variantWithFruit?: Maybe<Scalars['Boolean']>;
  /** variant_with_toppings boolean */
  variantWithToppings?: Maybe<Scalars['Boolean']>;
  /** vegan boolean */
  vegan?: Maybe<Scalars['Boolean']>;
  /** vegetarian boolean */
  vegetarian?: Maybe<Scalars['Boolean']>;
  /** visible_items_count integer */
  visibleItemsCount?: Maybe<Scalars['Int']>;
  /** warehouses_count integer */
  warehousesCount?: Maybe<Scalars['Int']>;
  /** width_uom character varying */
  widthUom?: Maybe<Scalars['String']>;
  /** width_value character varying */
  widthValue?: Maybe<Scalars['String']>;
  /** wild_caught boolean */
  wildCaught?: Maybe<Scalars['Boolean']>;
  /** yogurt_type_drinkable boolean */
  yogurtTypeDrinkable?: Maybe<Scalars['Boolean']>;
  /** yogurt_type_goat_milk boolean */
  yogurtTypeGoatMilk?: Maybe<Scalars['Boolean']>;
  /** yogurt_type_greek boolean */
  yogurtTypeGreek?: Maybe<Scalars['Boolean']>;
  /** yogurt_type_icelandic boolean */
  yogurtTypeIcelandic?: Maybe<Scalars['Boolean']>;
  /** yogurt_type_sheep_milk boolean */
  yogurtTypeSheepMilk?: Maybe<Scalars['Boolean']>;
  /** yogurt_type_traditional boolean */
  yogurtTypeTraditional?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_Brand = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_Brand';
  id?: Maybe<Scalars['BigInt']>;
  warehouseIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ImageList = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ImageList';
  cacheType?: Maybe<Scalars['String']>;
  imageId?: Maybe<Scalars['String']>;
  imageType?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCategory = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ProductCategory';
  l1Category?: Maybe<Scalars['String']>;
  l1CategoryId?: Maybe<Scalars['Int']>;
  l2Category?: Maybe<Scalars['String']>;
  l2CategoryId?: Maybe<Scalars['Int']>;
  l3Category?: Maybe<Scalars['String']>;
  l3CategoryId?: Maybe<Scalars['Int']>;
  l4Category?: Maybe<Scalars['String']>;
  l4CategoryId?: Maybe<Scalars['Int']>;
  l5Category?: Maybe<Scalars['String']>;
  l5CategoryId?: Maybe<Scalars['Int']>;
  l6Category?: Maybe<Scalars['String']>;
  l6CategoryId?: Maybe<Scalars['Int']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryId?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductCode = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ProductCode';
  code?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_LegacyProduct_ProductInfo = {
  __typename?: 'instacart_customers_product_retrieval_v1_LegacyProduct_ProductInfo';
  alcoholByVolume?: Maybe<Scalars['Float']>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  bottleDepositWhitelisted?: Maybe<Scalars['Boolean']>;
  cchGroupCode?: Maybe<Scalars['String']>;
  cchItemCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  fatFree?: Maybe<Scalars['Boolean']>;
  glutenFree?: Maybe<Scalars['Boolean']>;
  ingredients?: Maybe<Scalars['String']>;
  ingredientsSource?: Maybe<Scalars['String']>;
  kosher?: Maybe<Scalars['Boolean']>;
  lactoseFree?: Maybe<Scalars['Boolean']>;
  lowFat?: Maybe<Scalars['Boolean']>;
  orderUnit?: Maybe<Scalars['String']>;
  organic?: Maybe<Scalars['Boolean']>;
  specialInstructions?: Maybe<Scalars['String']>;
  sugarFree?: Maybe<Scalars['Boolean']>;
  vegan?: Maybe<Scalars['Boolean']>;
  vegetarian?: Maybe<Scalars['Boolean']>;
  warnings?: Maybe<Scalars['String']>;
};

/** Anything not direct from a table, i.e. derived at runtime or something */
export type Instacart_Customers_Product_Retrieval_V1_OtherAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_OtherAttributes';
  availabilityRank?: Maybe<Scalars['Float']>;
  availabilityScoreUpdatedAt?: Maybe<Scalars['DateTime']>;
  availabilitySource?: Maybe<Scalars['String']>;
  buyItAgainScore?: Maybe<Scalars['Float']>;
  dynamicLowStockThreshold?: Maybe<Scalars['Float']>;
  dynamicOutOfStockThreshold?: Maybe<Scalars['Float']>;
  itemPriceAttributes?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_ItemPriceAttribute>>>;
  managedAttributeValues?: Maybe<Scalars['String']>;
  purchasable?: Maybe<Scalars['Boolean']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  stockLevel?: Maybe<Scalars['String']>;
  variantDimensionValues?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_ProductAvailabilitiesAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_ProductAvailabilitiesAttributes';
  availabilityScore?: Maybe<Scalars['Float']>;
  availabilityScore_1?: Maybe<Scalars['Float']>;
  availabilityScore_2?: Maybe<Scalars['Float']>;
  availabilityScore_3?: Maybe<Scalars['Float']>;
  availabilityScore_4?: Maybe<Scalars['Float']>;
  availabilityScore_5?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  inventoryAreaId?: Maybe<Scalars['Int']>;
  productId?: Maybe<Scalars['Int']>;
  retailerLocationId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RequestFlags_Input = {
  /** Used for shadow testing. Do not set this flag in your request */
  isShadowTestingReplay?: InputMaybe<Scalars['Boolean']>;
  strategyId?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RequestMeta_Debug_Input = {
  includeNode?: InputMaybe<Scalars['Boolean']>;
  includeParameterizedSql?: InputMaybe<Scalars['Boolean']>;
  includeRawSql?: InputMaybe<Scalars['Boolean']>;
};

/**
 * used for passing information about the request.  This data should NEVER be
 * used to modify a query and should only be used for logging and rate limiting.
 */
export type Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input = {
  /** The debug information requested for the request */
  debug?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Debug_Input>;
  requestFlags?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestFlags_Input>;
  /** The tier of the request indicating its business criticality level */
  requestTier?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_RequestTier>;
  /**
   * The call source of the request.  This is used for rate limiting and event
   * logging. This should be a STATIC string that can be searched for in a code repository.
   * Do NOT dynamically change this value as it will break rate limiting.
   */
  src?: InputMaybe<Scalars['String']>;
  /**
   * The variant of the src used for tracking different variations of an API call. You can use this
   * to track request counts/latency differences across different variations of a query.
   */
  srcVariant?: InputMaybe<Scalars['String']>;
};

/**
 * RequestTier represents the business criticality level of the request
 * Please see https://instacart.atlassian.net/wiki/spaces/Customers/pages/4879451337/Request+Tiers for more details
 */
export enum Instacart_Customers_Product_Retrieval_V1_RequestMeta_RequestTier {
  /**
   * Tier 0 - Highest priority, critical requests that must be served
   * Examples: Order placement, checkout flows
   */
  RequestTier_0 = 'REQUEST_TIER_0',
  /** Tier 1 - High priority requests */
  RequestTier_1 = 'REQUEST_TIER_1',
  /** Tier 2 - Medium priority requests */
  RequestTier_2 = 'REQUEST_TIER_2',
  /** Tier 3 - Low priority requests */
  RequestTier_3 = 'REQUEST_TIER_3',
  /** Tier 4 - Lowest priority requests */
  RequestTier_4 = 'REQUEST_TIER_4',
  /** Default value - should not be used explicitly, helps us uncover requests not setting the tier */
  RequestTierUnspecified = 'REQUEST_TIER_UNSPECIFIED'
}

/** used for future use cases where we want to pass information back to the client */
export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta';
  debug?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug>;
};

export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta_Debug';
  /** The node information for the query */
  node?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Node>;
  /** The SQL information for the query */
  sql?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Sql>;
};

export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Node = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta_Debug_Node';
  /** The cluster that the query was executed on */
  cluster?: Maybe<Scalars['String']>;
  /** The replica that the query was executed on */
  replica?: Maybe<Scalars['Int']>;
  /** The shard that the query was executed on */
  shard?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Product_Retrieval_V1_ResponseMeta_Debug_Sql = {
  __typename?: 'instacart_customers_product_retrieval_v1_ResponseMeta_Debug_SQL';
  /** The parameterized SQL that was executed, has the parameters replaced with placeholders */
  parameterizedSql?: Maybe<Scalars['String']>;
  /** The parameters that were used in the parameterized SQL */
  parameters?: Maybe<Array<Maybe<Google_Protobuf_Value>>>;
  /** The raw SQL that was executed, has the parameters directly in the SQL */
  rawSql?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RetailerProductRetailerCollectionsV2Attributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductRetailerCollectionsV2Attributes';
  collectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  productId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RetailerProductsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductsAttributes';
  aisleId?: Maybe<Scalars['Int']>;
  aisleIds?: Maybe<Scalars['String']>;
  aisleName?: Maybe<Scalars['String']>;
  aisleNames?: Maybe<Scalars['String']>;
  aisleSortOrder?: Maybe<Scalars['Int']>;
  aisleSortOrders?: Maybe<Scalars['String']>;
  alcoholAttributes?: Maybe<Scalars['String']>;
  alcoholByVolume?: Maybe<Scalars['Float']>;
  alcoholRating?: Maybe<Scalars['Float']>;
  alcoholType?: Maybe<Scalars['String']>;
  alcoholVarietal?: Maybe<Scalars['String']>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  allergensKeywords?: Maybe<Scalars['String']>;
  antibioticFree?: Maybe<Scalars['Boolean']>;
  artificiallyCarbonated?: Maybe<Scalars['Boolean']>;
  atkinsDiet?: Maybe<Scalars['Boolean']>;
  bottle?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['Int']>;
  brandName?: Maybe<Scalars['String']>;
  breedAngus?: Maybe<Scalars['Boolean']>;
  breedBerkshire?: Maybe<Scalars['Boolean']>;
  breedDurocPork?: Maybe<Scalars['Boolean']>;
  breedGloucestershire?: Maybe<Scalars['Boolean']>;
  breedKobeWagyu?: Maybe<Scalars['Boolean']>;
  breedKurobataBerkshire?: Maybe<Scalars['Boolean']>;
  breedMangalitsapork?: Maybe<Scalars['Boolean']>;
  breedPiedmontese?: Maybe<Scalars['Boolean']>;
  breedVeal?: Maybe<Scalars['Boolean']>;
  breedWagyu?: Maybe<Scalars['Boolean']>;
  caEwasteCed?: Maybe<Scalars['Boolean']>;
  cageFree?: Maybe<Scalars['Boolean']>;
  calories?: Maybe<Scalars['Float']>;
  canonicalProduct?: Maybe<Scalars['String']>;
  carbFree?: Maybe<Scalars['Boolean']>;
  carbohydrate?: Maybe<Scalars['Float']>;
  cchGroupCode?: Maybe<Scalars['String']>;
  cchItemCode?: Maybe<Scalars['String']>;
  cholesterol?: Maybe<Scalars['Int']>;
  claimMedicinal?: Maybe<Scalars['Boolean']>;
  classifiedCode?: Maybe<Scalars['String']>;
  coldPrepared?: Maybe<Scalars['Boolean']>;
  color?: Maybe<Scalars['String']>;
  colorBrown?: Maybe<Scalars['Boolean']>;
  colorHexCode?: Maybe<Scalars['String']>;
  colorWhite?: Maybe<Scalars['Boolean']>;
  commonWeight?: Maybe<Scalars['Float']>;
  containerType?: Maybe<Scalars['String']>;
  containsFlour?: Maybe<Scalars['Boolean']>;
  containsProbiotics?: Maybe<Scalars['Boolean']>;
  cookingMethodBraise?: Maybe<Scalars['Boolean']>;
  cookingMethodGrill?: Maybe<Scalars['Boolean']>;
  cookingMethodPanFry?: Maybe<Scalars['Boolean']>;
  cookingMethodRoast?: Maybe<Scalars['Boolean']>;
  countryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cuisineTropical?: Maybe<Scalars['Boolean']>;
  dairyFree?: Maybe<Scalars['Boolean']>;
  departmentId?: Maybe<Scalars['Int']>;
  departmentIds?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  departmentNames?: Maybe<Scalars['String']>;
  deptSortOrder?: Maybe<Scalars['Float']>;
  deptSortOrders?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameVariants?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayScreenSize?: Maybe<Scalars['Float']>;
  displayScreenSizeUom?: Maybe<Scalars['String']>;
  edible?: Maybe<Scalars['Boolean']>;
  elasticRetailerProductId?: Maybe<Scalars['BigInt']>;
  enrolledInExperiments?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  experimentVariantId?: Maybe<Scalars['Int']>;
  farm?: Maybe<Scalars['String']>;
  farmed?: Maybe<Scalars['Boolean']>;
  fat?: Maybe<Scalars['Float']>;
  fatCalories?: Maybe<Scalars['Float']>;
  fatFree?: Maybe<Scalars['Boolean']>;
  fiber?: Maybe<Scalars['Float']>;
  flavor?: Maybe<Scalars['String']>;
  formFactor?: Maybe<Scalars['String']>;
  formFactorDescriptor?: Maybe<Scalars['String']>;
  fortified?: Maybe<Scalars['Boolean']>;
  freeRange?: Maybe<Scalars['Boolean']>;
  fruitJuicePercent?: Maybe<Scalars['Float']>;
  fullTextV1?: Maybe<Scalars['String']>;
  fullTextV2?: Maybe<Scalars['String']>;
  generatedAt?: Maybe<Scalars['DateTime']>;
  glutenFree?: Maybe<Scalars['Boolean']>;
  grade?: Maybe<Scalars['String']>;
  gradeA?: Maybe<Scalars['Boolean']>;
  gradeAa?: Maybe<Scalars['Boolean']>;
  gradeB?: Maybe<Scalars['Boolean']>;
  grassFed?: Maybe<Scalars['Boolean']>;
  halal?: Maybe<Scalars['Boolean']>;
  hasImage?: Maybe<Scalars['Boolean']>;
  highCarb?: Maybe<Scalars['Boolean']>;
  highFat?: Maybe<Scalars['Boolean']>;
  highProtein?: Maybe<Scalars['Boolean']>;
  hormoneFree?: Maybe<Scalars['Boolean']>;
  imageList?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  images?: Maybe<Scalars['String']>;
  inAssortment?: Maybe<Scalars['Boolean']>;
  inSeason?: Maybe<Scalars['Boolean']>;
  ingredients?: Maybe<Scalars['String']>;
  isCatering?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  isMedicated?: Maybe<Scalars['Boolean']>;
  isOrganic?: Maybe<Scalars['Boolean']>;
  isPackaged?: Maybe<Scalars['Boolean']>;
  juicePercent?: Maybe<Scalars['Float']>;
  ketoDiet?: Maybe<Scalars['Boolean']>;
  keywords?: Maybe<Scalars['String']>;
  kidFriendly?: Maybe<Scalars['Boolean']>;
  kosher?: Maybe<Scalars['Boolean']>;
  lactoseFree?: Maybe<Scalars['Boolean']>;
  largeImageUrl?: Maybe<Scalars['String']>;
  localeCode?: Maybe<Scalars['String']>;
  lowCarb?: Maybe<Scalars['Boolean']>;
  lowFat?: Maybe<Scalars['Boolean']>;
  lowSodium?: Maybe<Scalars['Boolean']>;
  lowSugar?: Maybe<Scalars['Boolean']>;
  managedAttributeIdArray?: Maybe<Array<Maybe<Scalars['Int']>>>;
  managedAttributeValueIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  marginMix?: Maybe<Scalars['Int']>;
  meatState?: Maybe<Scalars['String']>;
  mentosRetailerProductPartialRowId?: Maybe<Scalars['BigInt']>;
  milkTypeAlmond?: Maybe<Scalars['Boolean']>;
  milkTypeBuffalo?: Maybe<Scalars['Boolean']>;
  milkTypeCamel?: Maybe<Scalars['Boolean']>;
  milkTypeCashew?: Maybe<Scalars['Boolean']>;
  milkTypeCoconut?: Maybe<Scalars['Boolean']>;
  milkTypeCow?: Maybe<Scalars['Boolean']>;
  milkTypeDonkey?: Maybe<Scalars['Boolean']>;
  milkTypeFlax?: Maybe<Scalars['Boolean']>;
  milkTypeGoat?: Maybe<Scalars['Boolean']>;
  milkTypeHazelnut?: Maybe<Scalars['Boolean']>;
  milkTypeHemp?: Maybe<Scalars['Boolean']>;
  milkTypeMare?: Maybe<Scalars['Boolean']>;
  milkTypeMoose?: Maybe<Scalars['Boolean']>;
  milkTypeOat?: Maybe<Scalars['Boolean']>;
  milkTypeReindeer?: Maybe<Scalars['Boolean']>;
  milkTypeRice?: Maybe<Scalars['Boolean']>;
  milkTypeSheep?: Maybe<Scalars['Boolean']>;
  milkTypeSoy?: Maybe<Scalars['Boolean']>;
  milkTypeSunflower?: Maybe<Scalars['Boolean']>;
  milkTypeWaterbuffalo?: Maybe<Scalars['Boolean']>;
  milkTypeWholeGrain?: Maybe<Scalars['Boolean']>;
  milkTypeYak?: Maybe<Scalars['Boolean']>;
  minPickedWeight?: Maybe<Scalars['Float']>;
  monounsaturatedFat?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  noAddedSugar?: Maybe<Scalars['Boolean']>;
  nonGmo?: Maybe<Scalars['Boolean']>;
  nonenumeratedManagedAttributes?: Maybe<Scalars['String']>;
  normalizedHeightCm?: Maybe<Scalars['Float']>;
  normalizedLengthCm?: Maybe<Scalars['Float']>;
  normalizedWeightG?: Maybe<Scalars['Float']>;
  normalizedWidthCm?: Maybe<Scalars['Float']>;
  nutritionSources?: Maybe<Scalars['String']>;
  omega3Enriched?: Maybe<Scalars['Boolean']>;
  organic?: Maybe<Scalars['Boolean']>;
  origin?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  packagingBagged?: Maybe<Scalars['Boolean']>;
  packagingBunched?: Maybe<Scalars['Boolean']>;
  paleoDiet?: Maybe<Scalars['Boolean']>;
  paperTowelBenefitClaim?: Maybe<Scalars['String']>;
  paperTowelSizeClaim?: Maybe<Scalars['String']>;
  pastureRaised?: Maybe<Scalars['Boolean']>;
  polyunsaturatedFat?: Maybe<Scalars['Float']>;
  potassium?: Maybe<Scalars['Float']>;
  ppuNormalizedSizeValue?: Maybe<Scalars['Float']>;
  prepBreadedCrusted?: Maybe<Scalars['Boolean']>;
  prepChopped?: Maybe<Scalars['Boolean']>;
  prepChunks?: Maybe<Scalars['Boolean']>;
  prepCore?: Maybe<Scalars['Boolean']>;
  prepCured?: Maybe<Scalars['Boolean']>;
  prepCut?: Maybe<Scalars['Boolean']>;
  prepDiced?: Maybe<Scalars['Boolean']>;
  prepDryAged?: Maybe<Scalars['Boolean']>;
  prepGlazed?: Maybe<Scalars['Boolean']>;
  prepGrilled?: Maybe<Scalars['Boolean']>;
  prepInstructions?: Maybe<Scalars['String']>;
  prepMarinated?: Maybe<Scalars['Boolean']>;
  prepPartyTray?: Maybe<Scalars['Boolean']>;
  prepRoasted?: Maybe<Scalars['Boolean']>;
  prepRubbed?: Maybe<Scalars['Boolean']>;
  prepSeasoned?: Maybe<Scalars['Boolean']>;
  prepSlicedRepackagedPasteurizedByRetailer?: Maybe<Scalars['Boolean']>;
  prepSmoked?: Maybe<Scalars['Boolean']>;
  prepSpirals?: Maybe<Scalars['Boolean']>;
  prepUncured?: Maybe<Scalars['Boolean']>;
  prepWashed?: Maybe<Scalars['Boolean']>;
  primalCut?: Maybe<Scalars['String']>;
  primaryAisleId?: Maybe<Scalars['Int']>;
  primaryDepartmentId?: Maybe<Scalars['Int']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryL1Id?: Maybe<Scalars['Int']>;
  productCategoryL1Name?: Maybe<Scalars['String']>;
  productCategoryL2Id?: Maybe<Scalars['Int']>;
  productCategoryL2Name?: Maybe<Scalars['String']>;
  productCategoryL3Id?: Maybe<Scalars['Int']>;
  productCategoryL3Name?: Maybe<Scalars['String']>;
  productCategoryL4Id?: Maybe<Scalars['Int']>;
  productCategoryL4Name?: Maybe<Scalars['String']>;
  productCategoryL5Id?: Maybe<Scalars['Int']>;
  productCategoryL5Name?: Maybe<Scalars['String']>;
  productCategoryL6Id?: Maybe<Scalars['Int']>;
  productCategoryL6Name?: Maybe<Scalars['String']>;
  productCategoryTaxonomy?: Maybe<Scalars['String']>;
  productCategoryTaxonomyL4?: Maybe<Scalars['String']>;
  productCodes?: Maybe<Scalars['String']>;
  productCodesArray?: Maybe<Array<Maybe<Scalars['String']>>>;
  productEnrichmentKeywords?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['Int']>;
  productTags?: Maybe<Scalars['String']>;
  prop65Chemicals?: Maybe<Scalars['String']>;
  prop65Text?: Maybe<Scalars['String']>;
  protein?: Maybe<Scalars['Float']>;
  requireReheating?: Maybe<Scalars['Boolean']>;
  requiresKeepFrozen?: Maybe<Scalars['Boolean']>;
  requiresRefrigeration?: Maybe<Scalars['Boolean']>;
  restrictedOtc?: Maybe<Scalars['Boolean']>;
  restrictedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerId?: Maybe<Scalars['Int']>;
  retailerOmsEligible?: Maybe<Scalars['Boolean']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  retailerWidePrepackaging?: Maybe<Scalars['Boolean']>;
  romanceCopy?: Maybe<Scalars['String']>;
  saturatedFat?: Maybe<Scalars['Float']>;
  scent?: Maybe<Scalars['String']>;
  seasonality?: Maybe<Scalars['String']>;
  seasonalityDescription?: Maybe<Scalars['String']>;
  secondaryAisleIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  secondaryDepartmentIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  seedless?: Maybe<Scalars['Boolean']>;
  servingSize?: Maybe<Scalars['String']>;
  servingsPerContainer?: Maybe<Scalars['String']>;
  sheetCount?: Maybe<Scalars['Float']>;
  shopperHeroImageUrl?: Maybe<Scalars['String']>;
  shopperHeroLargeImageUrl?: Maybe<Scalars['String']>;
  shouldScan?: Maybe<Scalars['Boolean']>;
  similarName?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sizeBaby?: Maybe<Scalars['Boolean']>;
  sizeExtraLarge?: Maybe<Scalars['Boolean']>;
  sizeJumbo?: Maybe<Scalars['Boolean']>;
  sizeLarge?: Maybe<Scalars['Boolean']>;
  sizeMedium?: Maybe<Scalars['Boolean']>;
  sizeSmall?: Maybe<Scalars['Boolean']>;
  sizeUom?: Maybe<Scalars['String']>;
  sizeValue?: Maybe<Scalars['Float']>;
  sodium?: Maybe<Scalars['Float']>;
  storageTemp?: Maybe<Scalars['String']>;
  storeBrand?: Maybe<Scalars['Boolean']>;
  sugarFree?: Maybe<Scalars['Boolean']>;
  sugars?: Maybe<Scalars['Float']>;
  suggestedIncrementalWeight?: Maybe<Scalars['Float']>;
  surfaceId?: Maybe<Scalars['BigInt']>;
  syntheticCodes?: Maybe<Scalars['String']>;
  temporaryOverrideElasticRetailerProductId?: Maybe<Scalars['BigInt']>;
  thumbImageUrl?: Maybe<Scalars['String']>;
  tobacco?: Maybe<Scalars['Boolean']>;
  transFat?: Maybe<Scalars['Float']>;
  trimBoneIn?: Maybe<Scalars['Boolean']>;
  trimBoneless?: Maybe<Scalars['Boolean']>;
  trimDeveined?: Maybe<Scalars['Boolean']>;
  trimDressed?: Maybe<Scalars['Boolean']>;
  trimFrenched?: Maybe<Scalars['Boolean']>;
  trimHeadOn?: Maybe<Scalars['Boolean']>;
  trimPeeled?: Maybe<Scalars['Boolean']>;
  trimShellOn?: Maybe<Scalars['Boolean']>;
  trimShredded?: Maybe<Scalars['Boolean']>;
  trimSkinOn?: Maybe<Scalars['Boolean']>;
  trimSkinless?: Maybe<Scalars['Boolean']>;
  trimSliced?: Maybe<Scalars['Boolean']>;
  trimStuffed?: Maybe<Scalars['Boolean']>;
  trimTailOff?: Maybe<Scalars['Boolean']>;
  trimThickCut?: Maybe<Scalars['Boolean']>;
  trimThinCut?: Maybe<Scalars['Boolean']>;
  unataL1CategoryId?: Maybe<Scalars['String']>;
  unataL2CategoryId?: Maybe<Scalars['String']>;
  unataL3CategoryId?: Maybe<Scalars['String']>;
  unataL4CategoryId?: Maybe<Scalars['String']>;
  unitAttributes?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['Int']>;
  unitValue?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usaSnapEligible?: Maybe<Scalars['Boolean']>;
  variantAttributes?: Maybe<Scalars['String']>;
  variantGroupId?: Maybe<Scalars['BigInt']>;
  variantSalted?: Maybe<Scalars['Boolean']>;
  variantUnsalted?: Maybe<Scalars['Boolean']>;
  variantWithFruit?: Maybe<Scalars['Boolean']>;
  variantWithToppings?: Maybe<Scalars['Boolean']>;
  vegan?: Maybe<Scalars['Boolean']>;
  vegetableJuicePercent?: Maybe<Scalars['Float']>;
  vegetarian?: Maybe<Scalars['Boolean']>;
  vertexTaxOverrideAttribute?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['Int']>;
  warnings?: Maybe<Scalars['String']>;
  washload?: Maybe<Scalars['Float']>;
  weightWatchers?: Maybe<Scalars['Boolean']>;
  wholeGrain?: Maybe<Scalars['Boolean']>;
  wildCaught?: Maybe<Scalars['Boolean']>;
  yogurtTypeDrinkable?: Maybe<Scalars['Boolean']>;
  yogurtTypeGoatMilk?: Maybe<Scalars['Boolean']>;
  yogurtTypeGreek?: Maybe<Scalars['Boolean']>;
  yogurtTypeIcelandic?: Maybe<Scalars['Boolean']>;
  yogurtTypeSheepMilk?: Maybe<Scalars['Boolean']>;
  yogurtTypeTraditional?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_RetailerProductsCpgsAttributes = {
  __typename?: 'instacart_customers_product_retrieval_v1_RetailerProductsCpgsAttributes';
  cpgElasticRetailerProductId?: Maybe<Scalars['BigInt']>;
  cpgOfferRequestKeys?: Maybe<Array<Maybe<Scalars['String']>>>;
  cpgPromotionId?: Maybe<Scalars['BigInt']>;
  hasDeal?: Maybe<Scalars['Boolean']>;
  possibleDeliveryPromotionIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
  productId?: Maybe<Scalars['Int']>;
  retailerId?: Maybe<Scalars['Int']>;
  unattachedCouponDiscountBeginsAt?: Maybe<Scalars['DateTime']>;
  unattachedCouponDiscountEndsAt?: Maybe<Scalars['DateTime']>;
  unattachedCouponId?: Maybe<Scalars['BigInt']>;
  unattachedCouponItemsPerDeal?: Maybe<Scalars['Int']>;
  unattachedCouponSubtractValueCents?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * Enum used to identify the client and source type of the request.
 * Will be used to determine whether custom behaviour is required for the request.
 */
export enum Instacart_Customers_Product_Retrieval_V1_Catalog_V1_ClientSourceType {
  CaperNativeFeed = 'CAPER_NATIVE_FEED',
  /** Default/unset value */
  ClientSourceTypeUnspecified = 'CLIENT_SOURCE_TYPE_UNSPECIFIED',
  CommerceDiscountIcBirdzi = 'COMMERCE_DISCOUNT_IC_BIRDZI',
  CommerceDiscountIcLms = 'COMMERCE_DISCOUNT_IC_LMS'
}

export enum Instacart_Customers_Product_Retrieval_V1_Catalog_V1_CodeType {
  /** Default value */
  CodeTypeUnspecified = 'CODE_TYPE_UNSPECIFIED',
  ExternalIntegrationId = 'EXTERNAL_INTEGRATION_ID',
  LookupCodeNormalized = 'LOOKUP_CODE_NORMALIZED',
  LookupCodeRaw = 'LOOKUP_CODE_RAW',
  RetailerReferenceCode = 'RETAILER_REFERENCE_CODE'
}

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_Brand = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_Brand';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataRequest_Parameters_Input = {
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  productId?: InputMaybe<Scalars['BigInt']>;
  /** Batch of product IDs. When non-empty, takes precedence over singular product_id. */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetAggregatedItemDataResponse';
  responseMeta?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_AggregatedItemData = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetAggregatedItemDataResponse_AggregatedItemData';
  availableItemsCount?: Maybe<Scalars['BigInt']>;
  maxPriceCents?: Maybe<Scalars['BigInt']>;
  minPriceCents?: Maybe<Scalars['BigInt']>;
  /** Identifies the product this aggregation is for. */
  productId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetAggregatedItemDataResponse_Results';
  aggregatedItemData?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetAggregatedItemDataResponse_AggregatedItemData>>>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsRequest_Parameters_Input = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Filters items by availability. Tri-state: unset = no filter (all items);
   * true = only rows explicitly marked available; false = only rows explicitly
   * marked unavailable. The predicate is an exact `available = <bool>` match, so
   * rows with NULL availability are excluded from BOTH the true and false filters
   * (this mirrors available_items_count's FILTER (WHERE available = true)). Pushed
   * into the SQL WHERE so total_count and pagination reflect the filtered population.
   */
  available?: InputMaybe<Scalars['Boolean']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inventoryAreaIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  offset?: InputMaybe<Scalars['BigInt']>;
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  surfaceId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsResponse';
  responseMeta?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetItemsResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetItemsResponse_Results';
  items?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Item>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** A range of time based on specifying two dates */
export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_DateTimeRange_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** This query will execute across all shards for a given retailer */
export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_Parameters_Input = {
  aisleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Optional: scope search results to products within a specific retailer collection.
   * When present, only products whose collection membership includes this ID are returned.
   */
  collectionId?: InputMaybe<Scalars['BigInt']>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  hasPrimaryImageUrl?: InputMaybe<Scalars['Boolean']>;
  includeEscp?: InputMaybe<Scalars['Boolean']>;
  includeManagedAttributeValues?: InputMaybe<Scalars['Boolean']>;
  /**
   * When false, omits the full match count from results.total_count; the field
   * then reflects only the rows returned in this page. Unset (nil) computes the
   * full count (default).
   */
  includeTotalCount?: InputMaybe<Scalars['Boolean']>;
  isStoreBrandProduct?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  /**
   * Optional: filter by dietary preference. Supported values: "vegan", "gluten_free",
   * "organic", "fat_free", "kosher", "sugar_free", "low_fat", "vegetarian".
   * When non-empty, only products matching ALL specified attributes are returned.
   */
  nutrition?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['BigInt']>;
  omniSearchTerm?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  orderBy?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  primaryAisleId?: InputMaybe<Scalars['BigInt']>;
  primaryDepartmentId?: InputMaybe<Scalars['BigInt']>;
  productCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  productCreationDateRange?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_DateTimeRange_Input>;
  query?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional: list of retailer_ids for batch product search across multiple retailers.
   * When non-empty, the service fans out queries to the appropriate shards for each
   * retailer_id and merges results. This avoids N separate RPC calls from the client.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerProductIds?: InputMaybe<Array<InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_RetailerProductId_Input>>>;
  retailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  select?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  subjectIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  surfaceIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  withUnclassifiedProducts?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsRequest_RetailerProductId_Input = {
  productId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetRetailerProductsResponse';
  responseMeta?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_GetRetailerProductsResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_GetRetailerProductsResponse_Results';
  retailerProducts?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerProduct';
  _score?: Maybe<Scalars['Float']>;
  aisleId?: Maybe<Scalars['BigInt']>;
  aisleIds?: Maybe<Scalars['String']>;
  aisleName?: Maybe<Scalars['String']>;
  aisleNames?: Maybe<Scalars['String']>;
  alcoholic?: Maybe<Scalars['Boolean']>;
  atkinsDiet?: Maybe<Scalars['Boolean']>;
  bottle?: Maybe<Scalars['Boolean']>;
  brandId?: Maybe<Scalars['BigInt']>;
  brandName?: Maybe<Scalars['String']>;
  calories?: Maybe<Scalars['Float']>;
  carbFree?: Maybe<Scalars['Boolean']>;
  carbohydrate?: Maybe<Scalars['Float']>;
  cchGroupCode?: Maybe<Scalars['String']>;
  cchItemCode?: Maybe<Scalars['String']>;
  coldPrepared?: Maybe<Scalars['Boolean']>;
  containsFlour?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dairyFree?: Maybe<Scalars['Boolean']>;
  departmentId?: Maybe<Scalars['BigInt']>;
  departmentIds?: Maybe<Scalars['String']>;
  departmentNames?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  details?: Maybe<Scalars['String']>;
  directions?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  fatFree?: Maybe<Scalars['Boolean']>;
  glutenFree?: Maybe<Scalars['Boolean']>;
  hasImage?: Maybe<Scalars['Boolean']>;
  highCarb?: Maybe<Scalars['Boolean']>;
  highFat?: Maybe<Scalars['Boolean']>;
  highProtein?: Maybe<Scalars['Boolean']>;
  imageList?: Maybe<Scalars['String']>;
  ingredients?: Maybe<Scalars['String']>;
  isOrganic?: Maybe<Scalars['Boolean']>;
  ketoDiet?: Maybe<Scalars['Boolean']>;
  kidFriendly?: Maybe<Scalars['Boolean']>;
  kosher?: Maybe<Scalars['Boolean']>;
  lactoseFree?: Maybe<Scalars['Boolean']>;
  localeCode?: Maybe<Scalars['String']>;
  lowCarb?: Maybe<Scalars['Boolean']>;
  lowFat?: Maybe<Scalars['Boolean']>;
  lowSodium?: Maybe<Scalars['Boolean']>;
  lowSugar?: Maybe<Scalars['Boolean']>;
  managedAttributeValues?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct_ManagedAttributeValueMap>;
  name?: Maybe<Scalars['String']>;
  organic?: Maybe<Scalars['Boolean']>;
  originalName?: Maybe<Scalars['String']>;
  paleoDiet?: Maybe<Scalars['Boolean']>;
  prepSlicedRepackagedPasteurizedByRetailer?: Maybe<Scalars['Boolean']>;
  primaryAisleId?: Maybe<Scalars['BigInt']>;
  primaryDepartmentId?: Maybe<Scalars['BigInt']>;
  primaryImageUrl?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryTaxonomy?: Maybe<Scalars['String']>;
  productCodes?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
  productTags?: Maybe<Scalars['String']>;
  prop65Text?: Maybe<Scalars['String']>;
  requireReheating?: Maybe<Scalars['Boolean']>;
  requiresKeepFrozen?: Maybe<Scalars['Boolean']>;
  requiresRefrigeration?: Maybe<Scalars['Boolean']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  seasonality?: Maybe<Scalars['String']>;
  secondaryAisleIds?: Maybe<Scalars['String']>;
  secondaryDepartmentIds?: Maybe<Scalars['String']>;
  servingSize?: Maybe<Scalars['String']>;
  servingsPerContainer?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  sizeUom?: Maybe<Scalars['String']>;
  storeBrand?: Maybe<Scalars['Boolean']>;
  sugarFree?: Maybe<Scalars['Boolean']>;
  suggestedIncrementalWeight?: Maybe<Scalars['Float']>;
  syntheticCodes?: Maybe<Scalars['String']>;
  unitCount?: Maybe<Scalars['BigInt']>;
  vegan?: Maybe<Scalars['Boolean']>;
  vegetarian?: Maybe<Scalars['Boolean']>;
  vertexTaxOverrideAttribute?: Maybe<Scalars['String']>;
  weightWatchers?: Maybe<Scalars['Boolean']>;
  wholeGrain?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_RetailerProduct_ManagedAttributeValueMap = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_RetailerProduct_ManagedAttributeValueMap';
  rawValues?: Maybe<Scalars['JSON']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Parameters_Input>;
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsRequest_Parameters_Input = {
  brandIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_SearchRetailerBrandsResponse';
  responseMeta?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  results?: Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse_Results>;
};

export type Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_SearchRetailerBrandsResponse_Results = {
  __typename?: 'instacart_customers_product_retrieval_v1_retailer_tools_v1_SearchRetailerBrandsResponse_Results';
  brands?: Maybe<Array<Maybe<Instacart_Customers_Product_Retrieval_V1_Retailer_Tools_V1_Brand>>>;
};

export enum Instacart_Customers_Recipes_V1_BulkRecipeAction {
  BulkRecipeActionArchive = 'BULK_RECIPE_ACTION_ARCHIVE',
  BulkRecipeActionDelete = 'BULK_RECIPE_ACTION_DELETE',
  BulkRecipeActionPublish = 'BULK_RECIPE_ACTION_PUBLISH',
  BulkRecipeActionUnarchive = 'BULK_RECIPE_ACTION_UNARCHIVE',
  BulkRecipeActionUnspecified = 'BULK_RECIPE_ACTION_UNSPECIFIED'
}

export type Instacart_Customers_Recipes_V1_BulkUpdateRecipesRequest_Input = {
  action?: InputMaybe<Instacart_Customers_Recipes_V1_BulkRecipeAction>;
  recipeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_BulkUpdateRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_BulkUpdateRecipesResponse';
  failureCount?: Maybe<Scalars['Int']>;
  results?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeUpdateResult>>>;
  successCount?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Recipes_V1_Category = {
  __typename?: 'instacart_customers_recipes_v1_Category';
  contentCreatorId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_CoreIngredient = {
  __typename?: 'instacart_customers_recipes_v1_CoreIngredient';
  id?: Maybe<Scalars['BigInt']>;
  term?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_CoreIngredientUpdate_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Recipes_V1_GetCategoriesByNameRequest_Input = {
  /** content creator ID */
  contentCreatorId?: InputMaybe<Scalars['BigInt']>;
  /** limit the number of results */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** name of the recipe category */
  name?: InputMaybe<Scalars['String']>;
  /** offset the results */
  offset?: InputMaybe<Scalars['BigInt']>;
  /** retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Recipes_V1_GetCategoriesByNameResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetCategoriesByNameResponse';
  /** list of recipe categories */
  categories?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Category>>>;
};

export type Instacart_Customers_Recipes_V1_GetCoreIngredientsResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetCoreIngredientsResponse';
  coreIngredients?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_CoreIngredient>>>;
};

export type Instacart_Customers_Recipes_V1_GetRecipeByIdRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Recipes_V1_GetRecipeByIdResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetRecipeByIdResponse';
  recipe?: Maybe<Instacart_Customers_Recipes_V1_Recipe>;
};

export type Instacart_Customers_Recipes_V1_GetRecipesRequest_Input = {
  contentCreatorId?: InputMaybe<Scalars['BigInt']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offPlatform?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  term?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Recipes_V1_GetRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_GetRecipesResponse';
  recipes?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Recipe>>>;
};

export type Instacart_Customers_Recipes_V1_Ingredient = {
  __typename?: 'instacart_customers_recipes_v1_Ingredient';
  coreIngredient?: Maybe<Instacart_Customers_Recipes_V1_CoreIngredient>;
  id?: Maybe<Scalars['BigInt']>;
  imageUrl?: Maybe<Scalars['String']>;
  isKeyIngredient?: Maybe<Scalars['Boolean']>;
  note?: Maybe<Scalars['String']>;
  quantityHigh?: Maybe<Scalars['Float']>;
  quantityLow?: Maybe<Scalars['Float']>;
  retailerUpcs?: Maybe<Array<Maybe<Scalars['String']>>>;
  shoppingTerm?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  upcProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_IngredientGroup = {
  __typename?: 'instacart_customers_recipes_v1_IngredientGroup';
  id?: Maybe<Scalars['BigInt']>;
  ingredients?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Ingredient>>>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_IngredientGroupUpdate_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  ingredients?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_IngredientUpdate_Input>>>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_IngredientUpdate_Input = {
  coreIngredient?: InputMaybe<Instacart_Customers_Recipes_V1_CoreIngredientUpdate_Input>;
  id?: InputMaybe<Scalars['BigInt']>;
  isKeyIngredient?: InputMaybe<Scalars['Boolean']>;
  quantityHigh?: InputMaybe<Scalars['Float']>;
  quantityLow?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipeItem = {
  __typename?: 'instacart_customers_recipes_v1_ListRecipeItem';
  banner?: Maybe<Instacart_Customers_Recipes_V1_RecipeBanner>;
  categories?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeCategory>>>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeImage>>>;
  name?: Maybe<Scalars['String']>;
  parsed?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Instacart_Customers_Recipes_V1_RecipeStatus>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesFilters_Input = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parsed?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_RecipeStatus>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesPagination_Input = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesRequest_Input = {
  filters?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesFilters_Input>;
  pagination?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesPagination_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sorting?: InputMaybe<Instacart_Customers_Recipes_V1_ListRecipesSorting_Input>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_ListRecipesResponse';
  recipes?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_ListRecipeItem>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Recipes_V1_ListRecipesSorting_Input = {
  orderBy?: InputMaybe<Instacart_Customers_Recipes_V1_SortOrderBy>;
  orderDirection?: InputMaybe<Instacart_Customers_Recipes_V1_SortDirection>;
};

export type Instacart_Customers_Recipes_V1_Recipe = {
  __typename?: 'instacart_customers_recipes_v1_Recipe';
  activeTimeMinutes?: Maybe<Scalars['BigInt']>;
  adminVisible?: Maybe<Scalars['Boolean']>;
  banner?: Maybe<Instacart_Customers_Recipes_V1_RecipeBanner>;
  categories?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeCategory>>>;
  contentCreatorId?: Maybe<Scalars['BigInt']>;
  description?: Maybe<Scalars['String']>;
  history?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  images?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeImage>>>;
  ingredientGroups?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_IngredientGroup>>>;
  instructions?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_RecipeInstruction>>>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  prepTimeMinutes?: Maybe<Scalars['BigInt']>;
  private?: Maybe<Scalars['Boolean']>;
  proTip?: Maybe<Scalars['String']>;
  /** New fields for GetRecipeById API */
  providerRecipeId?: Maybe<Scalars['String']>;
  recipeSourceName?: Maybe<Scalars['String']>;
  recipeSummary?: Maybe<Scalars['String']>;
  recommendations?: Maybe<Scalars['String']>;
  seoApproved?: Maybe<Scalars['Boolean']>;
  servingsHigh?: Maybe<Scalars['BigInt']>;
  servingsLow?: Maybe<Scalars['BigInt']>;
  sourceKeyword?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Customers_Recipes_V1_RecipeStatus>;
  totalTimeMinutes?: Maybe<Scalars['BigInt']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Recipes_V1_RecipeBanner = {
  __typename?: 'instacart_customers_recipes_v1_RecipeBanner';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_RecipeCategory = {
  __typename?: 'instacart_customers_recipes_v1_RecipeCategory';
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_RecipeImage = {
  __typename?: 'instacart_customers_recipes_v1_RecipeImage';
  height?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

/** A single step in the recipe instructions */
export type Instacart_Customers_Recipes_V1_RecipeInstruction = {
  __typename?: 'instacart_customers_recipes_v1_RecipeInstruction';
  description?: Maybe<Scalars['String']>;
  stepNumber?: Maybe<Scalars['BigInt']>;
};

/** Recipe publication status */
export enum Instacart_Customers_Recipes_V1_RecipeStatus {
  RecipeStatusArchived = 'RECIPE_STATUS_ARCHIVED',
  RecipeStatusDraft = 'RECIPE_STATUS_DRAFT',
  RecipeStatusPublished = 'RECIPE_STATUS_PUBLISHED',
  RecipeStatusUnspecified = 'RECIPE_STATUS_UNSPECIFIED'
}

export type Instacart_Customers_Recipes_V1_RecipeUpdateResult = {
  __typename?: 'instacart_customers_recipes_v1_RecipeUpdateResult';
  errorMessage?: Maybe<Scalars['String']>;
  recipeId?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Please keep the RecipeUpdate message a subset of the Recipe message
 * The idea is you should be able to mutate the Recipe message and send it back
 * as a RecipeUpdate message
 */
export type Instacart_Customers_Recipes_V1_RecipeUpdate_Input = {
  adminVisible?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  ingredientGroups?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_IngredientGroupUpdate_Input>>>;
  name?: InputMaybe<Scalars['String']>;
  private?: InputMaybe<Scalars['Boolean']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export enum Instacart_Customers_Recipes_V1_SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

export enum Instacart_Customers_Recipes_V1_SortOrderBy {
  SortOrderByCreatedAt = 'SORT_ORDER_BY_CREATED_AT',
  SortOrderByUnspecified = 'SORT_ORDER_BY_UNSPECIFIED',
  SortOrderByUpdatedAt = 'SORT_ORDER_BY_UPDATED_AT'
}

export type Instacart_Customers_Recipes_V1_UpdateRecipesRequest_Input = {
  recipes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Recipes_V1_RecipeUpdate_Input>>>;
};

export type Instacart_Customers_Recipes_V1_UpdateRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_UpdateRecipesResponse';
  recipes?: Maybe<Array<Maybe<Instacart_Customers_Recipes_V1_Recipe>>>;
};

export type Instacart_Customers_Recipes_V1_UploadError = {
  __typename?: 'instacart_customers_recipes_v1_UploadError';
  errorCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_UploadSuccess = {
  __typename?: 'instacart_customers_recipes_v1_UploadSuccess';
  message?: Maybe<Scalars['String']>;
  recipeCount?: Maybe<Scalars['Int']>;
  uploadId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Recipes_V1_UploadValidationError = {
  __typename?: 'instacart_customers_recipes_v1_UploadValidationError';
  message?: Maybe<Scalars['String']>;
  validationErrors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesRequest_Input = {
  autoPublish?: InputMaybe<Scalars['Boolean']>;
  recipesData?: InputMaybe<Scalars['String']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Recipes_V1_ValidateAndUploadRecipesResponse = {
  __typename?: 'instacart_customers_recipes_v1_ValidateAndUploadRecipesResponse';
  success?: Maybe<Instacart_Customers_Recipes_V1_UploadSuccess>;
  uploadError?: Maybe<Instacart_Customers_Recipes_V1_UploadError>;
  validationError?: Maybe<Instacart_Customers_Recipes_V1_UploadValidationError>;
};

/** Retailer-facing view of an active featured collection set. */
export type Instacart_Customers_Retailer_Collections_Admin_V1_ActiveFeaturedCollectionSet = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ActiveFeaturedCollectionSet';
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  retailerCollectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  startDate?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_BulkEditResult = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_BulkEditResult';
  skippedFlyers?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerInfo>>>;
  updatedFlyers?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerInfo>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusRequest_Input = {
  jobId?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CheckBulkEditStatusResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CheckBulkEditStatusResponse';
  result?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_BulkEditResult>;
  status?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CloneFlyerContentPageRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sourceFlyerId?: InputMaybe<Scalars['BigInt']>;
  subsetRetailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CloneFlyerContentPageResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CloneFlyerContentPageResponse';
  newContentPageId?: Maybe<Scalars['BigInt']>;
  newFlyerId?: Maybe<Scalars['BigInt']>;
  sourceFlyerId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Collection = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Collection';
  archivedAt?: Maybe<Scalars['DateTime']>;
  collectionInsights?: Maybe<Scalars['String']>;
  collectionType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultSortOrder?: Maybe<Scalars['String']>;
  dynamicallyFedStatic?: Maybe<Scalars['Boolean']>;
  endDate?: Maybe<Scalars['DateTime']>;
  filters?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter>>>;
  id?: Maybe<Scalars['BigInt']>;
  includedRetailerTypes?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList>;
  internalName?: Maybe<Scalars['String']>;
  inventoryFileMappings?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_InventoryFileMapping>>>;
  isGlobalTemplatePublished?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  partnerMapping?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_PartnerMapping>;
  productCount?: Maybe<Scalars['BigInt']>;
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  retailerId?: Maybe<Scalars['BigInt']>;
  scopeType?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceCollectionId?: Maybe<Scalars['BigInt']>;
  startDate?: Maybe<Scalars['DateTime']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  translations?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_CollectionStatus {
  Active = 'ACTIVE',
  ActiveAdminOnly = 'ACTIVE_ADMIN_ONLY',
  EnumTypeStatusUnspecified = 'ENUM_TYPE_STATUS_UNSPECIFIED',
  Inactive = 'INACTIVE'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CollectionTranslation';
  localeCode?: Maybe<Instacart_Customers_Shared_V1_Locale>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input = {
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sourceFlyerId?: InputMaybe<Scalars['BigInt']>;
  sourceFlyerPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  targetFlyerId?: InputMaybe<Scalars['BigInt']>;
  targetFlyerPageIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  withFlyerActions?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CopyFlyerClickableAreasResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CopyFlyerClickableAreasResponse';
  success?: Maybe<Scalars['Boolean']>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionRequest_Input = {
  collectionInsights?: InputMaybe<Scalars['String']>;
  collectionType?: InputMaybe<Scalars['String']>;
  copyProductsExcludedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  copyProductsFromCollection?: InputMaybe<Scalars['BigInt']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  dynamicallyFedStatic?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  internalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productEvaluation?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  replicateMappingPartnerId?: InputMaybe<Scalars['BigInt']>;
  replicateToRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  sourceCollectionId?: InputMaybe<Scalars['BigInt']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateCollectionResponse';
  collection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFeaturedCollectionSetRequest_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Mutually exclusive with included_retailer_types. */
  excludedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Mutually exclusive with excluded_retailer_types. */
  includedRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  internalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFeaturedCollectionSetResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateFeaturedCollectionSetResponse';
  featuredCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionSet>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  description?: InputMaybe<Scalars['String']>;
  extActivityId?: InputMaybe<Scalars['String']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  flyerRetailerLocationId?: InputMaybe<Scalars['BigInt']>;
  productCategories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerActivityResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateFlyerActivityResponse';
  flyerActivity?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaRequest_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  altText?: InputMaybe<Scalars['String']>;
  bulkEdit?: InputMaybe<Scalars['Boolean']>;
  dimensions?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension_Input>;
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  navigateToCollection?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection_Input>;
  navigateToFlyerPage?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage_Input>;
  navigateToRecipe?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe_Input>;
  navigateToUrl?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl_Input>;
  openFlyerActivity?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity_Input>;
  requiresReview?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateFlyerClickableAreaResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateFlyerClickableAreaResponse';
  bulkEditJobId?: Maybe<Scalars['String']>;
  flyerClickableArea?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionRequest_Input = {
  collectionType?: InputMaybe<Scalars['String']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  dynamicallyFedStatic?: InputMaybe<Scalars['Boolean']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  includedRetailerTypes?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input>;
  internalName?: InputMaybe<Scalars['String']>;
  isGlobalTemplatePublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  productEvaluation?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateGlobalCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateGlobalCollectionResponse';
  collection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  collectionSlug?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateInvfMappingResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateInvfMappingResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataRequest_Input = {
  endDate?: InputMaybe<Scalars['String']>;
  flyerTag?: InputMaybe<Scalars['String']>;
  metadataId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  previewNumDaysBefore?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduleId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  updateFrequency?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerUpdateFrequency>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateOrUpdateFlyerMetadataResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateOrUpdateFlyerMetadataResponse';
  metadataId?: Maybe<Scalars['BigInt']>;
  scheduleId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_CreateRootNodeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_CreateRootNodeResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteCollectionResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFeaturedCollectionSetRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFeaturedCollectionSetResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteFeaturedCollectionSetResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteFlyerClickableAreasResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteFlyerClickableAreasResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteGlobalCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteGlobalCollectionResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteInvfMappingResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteInvfMappingResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DeleteNavigationNodeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DeleteNavigationNodeResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentRequest_Input = {
  destinationStoreConfigurations?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  sourceDepartmentId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_DuplicateDepartmentResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_DuplicateDepartmentResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionProductPreview = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FeaturedCollectionProductPreview';
  imageUrl?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionSet = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FeaturedCollectionSet';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Whether the set is active and eligible to be shown. */
  enabled?: Maybe<Scalars['Boolean']>;
  /** When to stop showing the featured collection set. */
  endDate?: Maybe<Scalars['DateTime']>;
  /** Retailer types to exclude. Mutually exclusive with included_retailer_types. Empty means no filter. */
  excludedRetailerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['BigInt']>;
  /** Retailer types to include. Mutually exclusive with excluded_retailer_types. Empty means no filter. */
  includedRetailerTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Internal name, written once from the admin UI for identification. */
  internalName?: Maybe<Scalars['String']>;
  /** Display name for the set. */
  name?: Maybe<Scalars['String']>;
  /** Ordered list of retailer collection IDs in this set (up to 3 shown). */
  retailerCollectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** When to start showing the featured collection set. */
  startDate?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Filter = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Filter';
  collectionId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  intersectionGroup?: Maybe<Scalars['BigInt']>;
  ruleId?: Maybe<Scalars['BigInt']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  intersectionGroup?: InputMaybe<Scalars['BigInt']>;
  ruleId?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Flyer = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Flyer';
  contentPageId?: Maybe<Scalars['BigInt']>;
  fileIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** groups flyers fanned out from a single multi-retailer upload; nil for ungrouped flyers */
  flyerGroupId?: Maybe<Scalars['BigInt']>;
  flyerPages?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPage>>>;
  flyerRetailerLocation?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerRetailerLocation>;
  id?: Maybe<Scalars['BigInt']>;
  metadataId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  tag?: Maybe<Scalars['String']>;
  termsApproved?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerActivity';
  collectionId?: Maybe<Scalars['BigInt']>;
  description?: Maybe<Scalars['String']>;
  extActivityId?: Maybe<Scalars['String']>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  productCategories?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  title?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerAreaDimension';
  height?: Maybe<Scalars['Float']>;
  heightPercent?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  widthPercent?: Maybe<Scalars['Float']>;
  xCoord?: Maybe<Scalars['Float']>;
  xPercent?: Maybe<Scalars['Float']>;
  yCoord?: Maybe<Scalars['Float']>;
  yPercent?: Maybe<Scalars['Float']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension_Input = {
  height?: InputMaybe<Scalars['Float']>;
  heightPercent?: InputMaybe<Scalars['Float']>;
  width?: InputMaybe<Scalars['Float']>;
  widthPercent?: InputMaybe<Scalars['Float']>;
  xCoord?: InputMaybe<Scalars['Float']>;
  xPercent?: InputMaybe<Scalars['Float']>;
  yCoord?: InputMaybe<Scalars['Float']>;
  yPercent?: InputMaybe<Scalars['Float']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerClickableArea';
  active?: Maybe<Scalars['Boolean']>;
  altText?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension>;
  flyerPageId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  navigateToCollection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection>;
  navigateToFlyerPage?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage>;
  navigateToRecipe?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe>;
  navigateToUrl?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl>;
  openFlyerActivity?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity>;
  requiresReview?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileError = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerFileError';
  count?: Maybe<Scalars['BigInt']>;
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileErrorType>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileErrorType {
  ParseError = 'PARSE_ERROR',
  RecordError = 'RECORD_ERROR',
  RejectedMapError = 'REJECTED_MAP_ERROR',
  UnmappedLocationCodes = 'UNMAPPED_LOCATION_CODES'
}

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType {
  AssetsFile = 'ASSETS_FILE',
  DataFile = 'DATA_FILE',
  PdfFile = 'PDF_FILE',
  VersionFile = 'VERSION_FILE'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadDetails = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerFileUploadDetails';
  errors?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileError>>>;
  fileId?: Maybe<Scalars['BigInt']>;
  filename?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadStatus>;
  type?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadStatus {
  LoadedIntoStream = 'LOADED_INTO_STREAM',
  Normalized = 'NORMALIZED',
  Unknown = 'UNKNOWN',
  UploadedToS3 = 'UPLOADED_TO_S3',
  UploadFailed = 'UPLOAD_FAILED'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerInfo = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerInfo';
  id?: Maybe<Scalars['BigInt']>;
  versionCode?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerMetadata = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerMetadata';
  collectionId?: Maybe<Scalars['BigInt']>;
  collectionSlug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locales?: Maybe<Array<Maybe<Instacart_Customers_Shared_V1_Locale>>>;
  name?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  scheduleId?: Maybe<Scalars['BigInt']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  tag?: Maybe<Scalars['String']>;
  updateFrequency?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerUpdateFrequency>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPage = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerPage';
  flyerId?: Maybe<Scalars['BigInt']>;
  height?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  image?: Maybe<Scalars['String']>;
  pageNumber?: Maybe<Scalars['BigInt']>;
  sourcePdf?: Maybe<Scalars['String']>;
  /** Whether the page is visible on the storefront. */
  visible?: Maybe<Scalars['Boolean']>;
  /** Start of the page's visibility window, if scheduled. */
  visibleFrom?: Maybe<Scalars['DateTime']>;
  /** End of the page's visibility window, if scheduled. */
  visibleUntil?: Maybe<Scalars['DateTime']>;
  width?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerPresignedUrl';
  fileId?: Maybe<Scalars['BigInt']>;
  filename?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  submissionPath?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input = {
  fileId?: InputMaybe<Scalars['BigInt']>;
  filename?: InputMaybe<Scalars['String']>;
  presignedUrl?: InputMaybe<Scalars['String']>;
  submissionPath?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileType>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerRetailerLocation = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerRetailerLocation';
  endsAt?: Maybe<Scalars['DateTime']>;
  flyerId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  previewsAt?: Maybe<Scalars['DateTime']>;
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  versionCode?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_FlyerStats = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_FlyerStats';
  flyerActivityCount?: Maybe<Scalars['BigInt']>;
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerPageCount?: Maybe<Scalars['BigInt']>;
  numAssignedFlyerClickableAreas?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  totalFlyerClickableAreas?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_FlyerUpdateFrequency {
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  Seasonal = 'SEASONAL',
  Weekly = 'WEEKLY'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsRequest_Input = {
  inputFilters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_InputFilter_Input>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionPreviewProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetCollectionPreviewProductsResponse';
  productIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRequest_Input = {
  globalCollectionRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  includePublishedGlobalTemplateCollections?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetCollectionResponse';
  collection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesRequest_Input = {
  dynamicFeedEligible?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetCollectionRulesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetCollectionRulesResponse';
  rules?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Rule>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionProductPreviewRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionProductPreviewResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFeaturedCollectionProductPreviewResponse';
  products?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionProductPreview>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionSetRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFeaturedCollectionSetResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFeaturedCollectionSetResponse';
  featuredCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionSet>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerActivitiesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerActivitiesResponse';
  flyerActivities?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerClickableAreasResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerClickableAreasResponse';
  flyerClickableAreas?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerMetadataResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerMetadataResponse';
  flyerMetadata?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerMetadata>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPageEditPresignedUrlRequest_Input = {
  /** MIME type of the image to upload. Only "image/jpeg" and "image/png" are accepted. */
  contentType?: InputMaybe<Scalars['String']>;
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPageEditPresignedUrlResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerPageEditPresignedUrlResponse';
  /** Canonical served URL of the uploaded page image. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Signed form fields that must accompany the multipart upload. */
  uploadFields?: Maybe<Scalars['JSON']>;
  /** URL the signed multipart image upload is POSTed to. */
  uploadUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugRequest_Input = {
  /** Optional: debug a specific flyer from IPP list */
  flyerId?: InputMaybe<Scalars['BigInt']>;
  /** Whether to list S3 files (slower) */
  includeS3Files?: InputMaybe<Scalars['Boolean']>;
  /** FlyerMetadata ID (required if flyer_id not provided) */
  metadataId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: specific flyer date */
  startDate?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPipelineDebugResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerPipelineDebugResponse';
  airflowDagName?: Maybe<Scalars['String']>;
  /** Human-readable context for the debug state */
  debugContext?: Maybe<Scalars['String']>;
  /** Upcoming flyer context (helps distinguish pending jobs vs actual issues) */
  expectedFlyerDate?: Maybe<Scalars['String']>;
  failureSummary?: Maybe<Scalars['String']>;
  flyerEndDate?: Maybe<Scalars['String']>;
  /** Flyer info (when debugging a specific flyer) */
  flyerId?: Maybe<Scalars['BigInt']>;
  flyerStartDate?: Maybe<Scalars['String']>;
  flyerStatus?: Maybe<Scalars['String']>;
  flyerTag?: Maybe<Scalars['String']>;
  /** Health summary - helps differentiate API errors vs flyer issues */
  hasCriticalFailure?: Maybe<Scalars['Boolean']>;
  /** Any stage WARNING */
  hasWarnings?: Maybe<Scalars['Boolean']>;
  intermediateFiles?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_S3FolderContents>;
  /** True if expected_flyer_date is in the future */
  isUpcoming?: Maybe<Scalars['Boolean']>;
  /** "healthy", "degraded", "critical" */
  overallHealth?: Maybe<Scalars['String']>;
  /** e.g., "FlyerParser", "SaleDatesParser" */
  parserType?: Maybe<Scalars['String']>;
  /** For S3 URL building */
  partnerFolder?: Maybe<Scalars['String']>;
  /** S3 file listings (if requested) */
  partnersFiles?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_S3FolderContents>;
  /** Metadata for frontend to build URLs and display */
  retailerName?: Maybe<Scalars['String']>;
  scheduleInfo?: Maybe<Scalars['String']>;
  /** DAG stages (14 nodes) */
  stages?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStage>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsRequest_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  presignedUrls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerPresignedUrlsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerPresignedUrlsResponse';
  presignedUrls?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerResponse';
  flyer?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Flyer>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsRequest_Input = {
  flyerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerStatsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerStatsResponse';
  flyerCount?: Maybe<Scalars['BigInt']>;
  flyerStats?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerStats>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerTagsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerTagsResponse';
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsRequest_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  presignedUrls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetFlyerUploadDetailsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetFlyerUploadDetailsResponse';
  fileUploadDetails?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerFileUploadDetails>>>;
  flyerCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsRequest_Input = {
  onlyActive?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetLowerPriceDefinitionsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetLowerPriceDefinitionsResponse';
  definitions?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetNavigationTreeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetNavigationTreeResponse';
  navigationConfiguration?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration>;
  nodes?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_GetRetailerCsvResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_GetRetailerCsvResponse';
  filePath?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_InputFilter_Input = {
  intersectionGroup?: InputMaybe<Scalars['BigInt']>;
  ruleId?: InputMaybe<Scalars['BigInt']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Int64List_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_InventoryFileMapping = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_InventoryFileMapping';
  collectionSlug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  retailerCollectionId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListActiveFeaturedCollectionSetsRequest_Input = {
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  /**
   * Deprecated: use retailer_ids (field 3) instead. Kept declared (not
   * reserved) so the change is wire- and JSON-compatible for buf breaking
   * checks. The server-side handler ignores this field; callers should
   * populate retailer_ids exclusively.
   */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListActiveFeaturedCollectionSetsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListActiveFeaturedCollectionSetsResponse';
  featuredCollectionSets?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_ActiveFeaturedCollectionSet>>>;
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  isPinned?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListCollectionProductsResponse';
  products?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsRequest_Input = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  collectionStatus?: InputMaybe<Scalars['String']>;
  excludedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  globalTemplateCollectionsOnly?: InputMaybe<Scalars['Boolean']>;
  includePublishedGlobalTemplateCollections?: InputMaybe<Scalars['Boolean']>;
  includedArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  includedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  productIdLimit?: InputMaybe<Scalars['BigInt']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional. When present, only return collections that are visible to ALL of the specified retailer types.
   * A collection matches if its included_retailer_types is empty (universal) or contains every type in this list.
   */
  visibleForRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  withoutAdminCollections?: InputMaybe<Scalars['Boolean']>;
  withoutNavigationCollections?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListCollectionsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListCollectionsResponse';
  collections?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFeaturedCollectionSetsRequest_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFeaturedCollectionSetsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListFeaturedCollectionSetsResponse';
  featuredCollectionSets?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionSet>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_Input = {
  filter?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_OptionalFilter_Input>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersRequest_OptionalFilter_Input = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListFlyersResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListFlyersResponse';
  flyers?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Flyer>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsRequest_Input = {
  collectionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  collectionStatus?: InputMaybe<Scalars['String']>;
  excludedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  globalTemplateCollectionsOnly?: InputMaybe<Scalars['Boolean']>;
  includePublishedGlobalTemplateCollections?: InputMaybe<Scalars['Boolean']>;
  includedArchivedCollections?: InputMaybe<Scalars['Boolean']>;
  includedSourceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBy?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional. When present, only return collections that are visible to ALL of the specified retailer types.
   * A collection matches if its included_retailer_types is empty (universal) or contains every type in this list.
   */
  visibleForRetailerTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListGlobalCollectionsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListGlobalCollectionsResponse';
  collections?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ListRetailerDepartmentsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ListRetailerDepartmentsResponse';
  departments?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_LowerPriceDefinition';
  active?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  lookbackPeriodDays?: Maybe<Scalars['Int']>;
  priceType?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition_PriceType>;
  requiredDropPct?: Maybe<Scalars['Float']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_LowerPriceDefinition_PriceType {
  Average = 'AVERAGE',
  PriceTypeUnspecified = 'PRICE_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToCollection';
  collectionSlug?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection_Input = {
  collectionSlug?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToFlyerPage';
  flyerPageId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage_Input = {
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToRecipe';
  recipeId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe_Input = {
  recipeId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigateToUrl';
  url?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl_Input = {
  url?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigationConfiguration';
  additionalStoreConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  alwaysPinned?: Maybe<Scalars['Boolean']>;
  inventoryCountDisabled?: Maybe<Scalars['Boolean']>;
  isSyncedFromSource?: Maybe<Scalars['Boolean']>;
  maxTopLevelNodes?: Maybe<Scalars['BigInt']>;
  sourceDomain?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration_Input = {
  additionalStoreConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  alwaysPinned?: InputMaybe<Scalars['Boolean']>;
  inventoryCountDisabled?: InputMaybe<Scalars['Boolean']>;
  isSyncedFromSource?: InputMaybe<Scalars['Boolean']>;
  maxTopLevelNodes?: InputMaybe<Scalars['BigInt']>;
  sourceDomain?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_NavigationNode';
  alcoholic?: Maybe<Scalars['Boolean']>;
  alwaysShow?: Maybe<Scalars['Boolean']>;
  children?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode>>>;
  contentType?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode_ContentType>;
  endDate?: Maybe<Scalars['DateTime']>;
  externallyManaged?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  isDynamic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['BigInt']>;
  productCount?: Maybe<Scalars['BigInt']>;
  retailerCollectionId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionStatus>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  tileImageUrl?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Translation>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode_ContentType {
  Collections = 'COLLECTIONS',
  Products = 'PRODUCTS',
  Root = 'ROOT',
  Unspecified = 'UNSPECIFIED'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_OpenFlyerActivity';
  flyerActivityId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity_Input = {
  flyerActivityId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesRequest_Input = {
  nodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_OrderNavigationNodesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_OrderNavigationNodesResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_PartnerMapping = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_PartnerMapping';
  collectionSlug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStage = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_PipelineStage';
  /** stage_ids this depends on */
  dependsOn?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** deprecated: use label instead */
  displayName?: Maybe<Scalars['String']>;
  /** e.g., "File Upload", "Parse & Normalize" */
  label?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  /** 1=data, 2=asset, 3=validation */
  row?: Maybe<Scalars['Int']>;
  /** e.g., "sftp_upload", "parser_execution" */
  stageId?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStageStatus>;
  /** e.g., "8 files", "FAILED - Timeout" */
  statusDetail?: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Retailer_Collections_Admin_V1_PipelineStageStatus {
  PipelineStageStatusBlocked = 'PIPELINE_STAGE_STATUS_BLOCKED',
  PipelineStageStatusComplete = 'PIPELINE_STAGE_STATUS_COMPLETE',
  PipelineStageStatusFailed = 'PIPELINE_STAGE_STATUS_FAILED',
  PipelineStageStatusQueued = 'PIPELINE_STAGE_STATUS_QUEUED',
  PipelineStageStatusRunning = 'PIPELINE_STAGE_STATUS_RUNNING',
  /** Stage not applicable for this retailer's data source */
  PipelineStageStatusSkipped = 'PIPELINE_STAGE_STATUS_SKIPPED',
  PipelineStageStatusUnspecified = 'PIPELINE_STAGE_STATUS_UNSPECIFIED',
  PipelineStageStatusWarning = 'PIPELINE_STAGE_STATUS_WARNING'
}

export type Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadRequest_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  presignedUrls?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ProcessFlyerIngestionFileUploadResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ProcessFlyerIngestionFileUploadResponse';
  presignedUrls?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPresignedUrl>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Product = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Product';
  cachedProductId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  lookupCode?: Maybe<Scalars['String']>;
  pinned?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['BigInt']>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ProductCategories_Input = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input = {
  cachedProductId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  lookupCode?: InputMaybe<Scalars['String']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['BigInt']>;
  retailerReferenceCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_QueueNavigationMigrationResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_QueueNavigationMigrationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Rule = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Rule';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  valueSource?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSource>;
  valueType?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSource = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_RuleValueSource';
  options?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSourceOption>>>;
  query?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_RuleValueSourceOption = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_RuleValueSourceOption';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_S3File = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_S3File';
  /** "queued", "archived", "failed", "pdfs" */
  folder?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  lastModified?: Maybe<Scalars['DateTime']>;
  sizeBytes?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_S3FolderContents = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_S3FolderContents';
  files?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_S3File>>>;
  folderPath?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsRequest_Input = {
  collectionId?: InputMaybe<Scalars['BigInt']>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_SearchCollectionProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_SearchCollectionProductsResponse';
  products?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_StringList = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_StringList';
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Translation = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_Translation';
  localeCode?: Maybe<Instacart_Customers_Shared_V1_Locale>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_Translation_Input = {
  localeCode?: InputMaybe<Instacart_Customers_Shared_V1_Locale>;
  name?: InputMaybe<Scalars['String']>;
};

/**
 * One explicit sync target per selected banner. The frontend guarantees each target already
 * has a real metadata (and schedule) row for the chosen cadence; the job simply loops them.
 */
export type Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncRequest_FlyerSyncTarget_Input = {
  metadataId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** nilable */
  scheduleId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncRequest_Input = {
  csvFileIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  metadataId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Explicit partner for the multi-scope (targets) upload; required when targets is set and ignored
   * on the legacy scalar path. Unset (nil) = derive from the retailer's flyer metadata config.
   */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduleId?: InputMaybe<Scalars['BigInt']>;
  startDate?: InputMaybe<Scalars['String']>;
  syncFlyerAssets?: InputMaybe<Scalars['Boolean']>;
  syncFlyerData?: InputMaybe<Scalars['Boolean']>;
  syncFlyerDigital?: InputMaybe<Scalars['Boolean']>;
  /** one per selected banner; empty = legacy single-retailer (retailer_id/metadata_id/schedule_id) */
  targets?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncRequest_FlyerSyncTarget_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_TriggerFlyerSyncResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_TriggerFlyerSyncResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  productsToAdd?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  productsToDelete?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  source?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionProductsResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateCollectionProductsResponse';
  collection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionRequest_Input = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  collectionInsights?: InputMaybe<Scalars['String']>;
  collectionType?: InputMaybe<Scalars['String']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  internalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  productsToAdd?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  productsToDelete?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Product_Input>>>;
  replicateMappingPartnerId?: InputMaybe<Scalars['BigInt']>;
  replicateToRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  resetAllProducts?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateCollectionResponse';
  collection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

/** All fields except id are optional — only provided fields are updated. */
export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFeaturedCollectionSetRequest_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Replaces the full list when present. Mutually exclusive with included_retailer_types. */
  excludedRetailerTypes?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** Replaces the full list when present. Mutually exclusive with excluded_retailer_types. */
  includedRetailerTypes?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input>;
  name?: InputMaybe<Scalars['String']>;
  /** Replaces the full list when present. */
  retailerCollectionIds?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Int64List_Input>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFeaturedCollectionSetResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFeaturedCollectionSetResponse';
  featuredCollectionSet?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FeaturedCollectionSet>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityRequest_Input = {
  collectionId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  extActivityId?: InputMaybe<Scalars['String']>;
  flyerPageId?: InputMaybe<Scalars['String']>;
  flyerRetailerLocationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  productCategories?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_ProductCategories_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerActivityResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyerActivityResponse';
  flyerActivity?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerActivity>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaRequest_Input = {
  active?: InputMaybe<Scalars['Boolean']>;
  altText?: InputMaybe<Scalars['String']>;
  bulkEdit?: InputMaybe<Scalars['Boolean']>;
  dimensions?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerAreaDimension_Input>;
  flyerId?: InputMaybe<Scalars['BigInt']>;
  flyerPageId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  navigateToCollection?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToCollection_Input>;
  navigateToFlyerPage?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToFlyerPage_Input>;
  navigateToRecipe?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToRecipe_Input>;
  navigateToUrl?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigateToUrl_Input>;
  openFlyerActivity?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_OpenFlyerActivity_Input>;
  requiresReview?: InputMaybe<Scalars['Boolean']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerClickableAreaResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyerClickableAreaResponse';
  bulkEditJobId?: Maybe<Scalars['String']>;
  flyerClickableArea?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerClickableArea>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerPagesRequest_Input = {
  flyerId?: InputMaybe<Scalars['BigInt']>;
  /** Full desired page list for the flyer. Existing pages omitted here are removed. */
  pages?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerPagesRequest_PageUpdate_Input>>>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** A single page's desired final state. */
export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerPagesRequest_PageUpdate_Input = {
  /** Existing FlyerPage id. Absent means the entry is a new page (ADD). */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Served URL of the page image. Present on ADD or REPLACE; absent otherwise. */
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Desired 1-indexed final position of the page. */
  pageNumber?: InputMaybe<Scalars['BigInt']>;
  /**
   * Whether the page is visible on the storefront. Required: a full desired-state update must state
   * each page's visibility, so an absent value is rejected rather than defaulted.
   */
  visible?: InputMaybe<Scalars['Boolean']>;
  /** Start of the page's visibility window. Absent clears any scheduled start. */
  visibleFrom?: InputMaybe<Scalars['DateTime']>;
  /** End of the page's visibility window. Absent clears any scheduled end. */
  visibleUntil?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyerPagesResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyerPagesResponse';
  /** Full ordered page list after the update. */
  flyerPages?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_FlyerPage>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersRequest_Input = {
  contentPageId?: InputMaybe<Scalars['BigInt']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  name?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
  /** DEPRECATED, this had the wrong type. Use terms_approved_v2 instead */
  termsApproved?: InputMaybe<Scalars['Boolean']>;
  termsApprovedV2?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateFlyersResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateFlyersResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionRequest_Input = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  collectionInsights?: InputMaybe<Scalars['String']>;
  collectionType?: InputMaybe<Scalars['String']>;
  defaultSortOrder?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Filter_Input>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  includedRetailerTypes?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_StringList_Input>;
  internalName?: InputMaybe<Scalars['String']>;
  isGlobalTemplatePublished?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionTranslation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateGlobalCollectionResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateGlobalCollectionResponse';
  collection?: Maybe<Instacart_Customers_Retailer_Collections_Admin_V1_Collection>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationRequest_Input = {
  navigationConfiguration?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationConfiguration_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpdateNavigationConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpdateNavigationConfigurationResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeRequest_Input = {
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  alwaysShow?: InputMaybe<Scalars['Boolean']>;
  contentType?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_NavigationNode_ContentType>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['BigInt']>;
  pinned?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['BigInt']>;
  retailerCollectionId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_CollectionStatus>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  tileImageUrl?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Collections_Admin_V1_Translation_Input>>>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_UpsertNavigationNodeResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_UpsertNavigationNodeResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugRequest_Input = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  slug?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Collections_Admin_V1_ValidateCollectionSlugResponse = {
  __typename?: 'instacart_customers_retailer_collections_admin_v1_ValidateCollectionSlugResponse';
  valid?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** namespace entity id of the draft */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** status of the draft */
  status?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_IppDraftStatus>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_DeleteIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_orchestrator_v1_DeleteIppDraftResponse';
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

/** Represent reasons for failure */
export enum Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason {
  /** Request context or payload incomplete or invalid */
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  /** Unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** No error */
  NoError = 'NO_ERROR'
}

export enum Instacart_Customers_Retailer_Management_Orchestrator_V1_IppDraftStatus {
  Deleted = 'DELETED',
  DeleteError = 'DELETE_ERROR',
  Published = 'PUBLISHED',
  PublishError = 'PUBLISH_ERROR',
  Working = 'WORKING'
}

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** namespace entity id of the draft */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** status of the draft */
  status?: InputMaybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_IppDraftStatus>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_PublishIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_orchestrator_v1_PublishIppDraftResponse';
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_Orchestrator_V1_RevertIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_orchestrator_v1_RevertIppDraftResponse';
  /** the draft id of the reverted draft that was created */
  draftId?: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_Orchestrator_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

/** ClientConfiguration response message */
export type Instacart_Customers_Retailer_Management_V1_ClientConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_ClientConfigurationResponse';
  /** Comma-separated origins */
  allowedOrigins?: Maybe<Scalars['String']>;
  applicationType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  idpSpoofValue?: Maybe<Scalars['BigInt']>;
  idpTier?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  oauthApplicationId?: Maybe<Scalars['BigInt']>;
  slug?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewRequest_Input = {
  /** draft id to create the preview from */
  draftId?: InputMaybe<Scalars['String']>;
  /** redirect url */
  redirectUrl?: InputMaybe<Scalars['String']>;
  /** retailer id */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftPreviewResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_CreateIppDraftPreviewResponse';
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  /** auth token for the preview */
  previewAuthToken?: Maybe<Scalars['String']>;
  /** password for the preview */
  previewPassword?: Maybe<Scalars['String']>;
  /** url of the preview */
  previewUrl?: Maybe<Scalars['String']>;
  /** redirect url */
  redirectUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftRequest_Input = {
  /** optional a list of draft content that represents the draft */
  contents?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input>>>;
  /** list of draft components associated with the draft. */
  draftIds?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftComponent_Input>>>;
  /** the name of the draft */
  name?: InputMaybe<Scalars['String']>;
  /** a short description of a draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** the ID of the entity being drafted */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** partion of the draft (i.e. store_configuration, warehouse, contentpage, etc.) */
  partition?: InputMaybe<Scalars['String']>;
  /** associated partition id */
  partitionId?: InputMaybe<Scalars['BigInt']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_CreateIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_CreateIppDraftResponse';
  /** the draft id that was created */
  draftId?: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_DeleteIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** the ID of the entity being drafted */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_DeleteIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_DeleteIppDraftResponse';
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

/** Request to enable CMS site widgets */
export type Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsRequest_Input = {
  /** Required: Partner ID */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Required: Store configuration ID */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for enable CMS site widgets */
export type Instacart_Customers_Retailer_Management_V1_EnableCmsSiteWidgetsResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_EnableCmsSiteWidgetsResponse';
  /** Whether client configuration was newly created */
  clientConfigurationCreated?: Maybe<Scalars['Boolean']>;
  /** Client configuration ID (created or existing) */
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Created at timestamp */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Whether OAuth application was newly created */
  oauthApplicationCreated?: Maybe<Scalars['Boolean']>;
  /** OAuth application ID (always newly created) */
  oauthApplicationId?: Maybe<Scalars['BigInt']>;
  /** Partner name from client configuration */
  partnerName?: Maybe<Scalars['String']>;
  /** Store configuration ID */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Updated at timestamp */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Represent reasons for failure */
export enum Instacart_Customers_Retailer_Management_V1_ErrorReason {
  /** Request context or payload incomplete or invalid */
  ErrorReasonBadRequest = 'ERROR_REASON_BAD_REQUEST',
  /** Request is unauthorized */
  ErrorReasonUnauthorized = 'ERROR_REASON_UNAUTHORIZED',
  /** Unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** No error */
  NoError = 'NO_ERROR'
}

export type Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdRequest_Input = {
  /** the draft id to retrieve */
  draftId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetIppDraftByIdResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetIppDraftByIdResponse';
  /** the draft based on the id */
  draft?: Maybe<Instacart_Customers_Retailer_Management_V1_IppDraft>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenRequest_Input = {
  /** encoded preview auth token to get preview */
  authToken?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetIppPreviewByAuthTokenResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetIppPreviewByAuthTokenResponse';
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  /** draft associated with preview */
  ippDraft?: Maybe<Instacart_Customers_Retailer_Management_V1_IppDraft>;
  /** preview object */
  ippPreview?: Maybe<Instacart_Customers_Retailer_Management_V1_IppPreview>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenRequest_Input = {
  /** passcode for preview */
  passcode?: InputMaybe<Scalars['String']>;
  /** preview_token for request */
  previewToken?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetPreviewAuthTokenResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetPreviewAuthTokenResponse';
  /** auth_token */
  authToken?: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

/** Get widget configuration request */
export type Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationRequest_Input = {
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailer_Management_V1_GetWidgetConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_GetWidgetConfigurationResponse';
  clientConfiguration?: Maybe<Instacart_Customers_Retailer_Management_V1_ClientConfigurationResponse>;
  exists?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraft = {
  __typename?: 'instacart_customers_retailer_management_v1_IppDraft';
  /** date of creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** IPP user id of the user who created the draft */
  createdBy?: Maybe<Scalars['String']>;
  /** draft id that this draft was created from (for revert purposes) */
  createdFrom?: Maybe<Scalars['String']>;
  /** date of deletion */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** IPP user id that deleted the draft */
  deletedBy?: Maybe<Scalars['String']>;
  /** draft id */
  draftId?: Maybe<Scalars['String']>;
  /** list of draft components associated with the draft. */
  ippDraftComponents?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Management_V1_IppDraftComponent>>>;
  /** name of the draft */
  name?: Maybe<Scalars['String']>;
  /** namespace of the draft */
  namespace?: Maybe<Scalars['String']>;
  /** partion of the draft (i.e. store_configuration, warehouse, contentpage, etc.) */
  partition?: Maybe<Scalars['String']>;
  /** associated partition id */
  partitionId?: Maybe<Scalars['BigInt']>;
  /** date of publish */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** IPP user id that published the draft */
  publishedBy?: Maybe<Scalars['String']>;
  /** date last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftComponent = {
  __typename?: 'instacart_customers_retailer_management_v1_IppDraftComponent';
  /** the domain's configuration draft id */
  configurationDraftId?: Maybe<Scalars['String']>;
  /** the draft blob */
  content?: Maybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent>;
  /** the domain associated with the draft */
  domain?: Maybe<Scalars['String']>;
  /** the associated draft id */
  draftId?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftComponent_Input = {
  /** the domain's configuration draft id */
  configurationDraftId?: InputMaybe<Scalars['String']>;
  /** the draft blob */
  content?: InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input>;
  /** the domain associated with the draft */
  domain?: InputMaybe<Scalars['String']>;
  /** the associated draft id */
  draftId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftContent = {
  __typename?: 'instacart_customers_retailer_management_v1_IppDraftContent';
  /** the json blob representation of the draft */
  content?: Maybe<Scalars['String']>;
  /** content id */
  contentId?: Maybe<Scalars['BigInt']>;
  /** the type of draft content */
  contentType?: Maybe<Scalars['String']>;
  /** the version of the draft content */
  version?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input = {
  /** the json blob representation of the draft */
  content?: InputMaybe<Scalars['String']>;
  /** content id */
  contentId?: InputMaybe<Scalars['BigInt']>;
  /** the type of draft content */
  contentType?: InputMaybe<Scalars['String']>;
  /** the version of the draft content */
  version?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Customers_Retailer_Management_V1_IppDraftStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Published = 'PUBLISHED',
  Unknown = 'UNKNOWN',
  Working = 'WORKING'
}

export type Instacart_Customers_Retailer_Management_V1_IppPreview = {
  __typename?: 'instacart_customers_retailer_management_v1_IppPreview';
  /** draft id associated with preview */
  draftId?: Maybe<Scalars['String']>;
  /** passcode for the preview */
  passcode?: Maybe<Scalars['String']>;
  /** token associated with preview */
  previewToken?: Maybe<Scalars['String']>;
  /** url of the preview */
  previewUrl?: Maybe<Scalars['String']>;
};

export enum Instacart_Customers_Retailer_Management_V1_ListIppDraftsColumns {
  CreatedAt = 'CREATED_AT',
  DeletedAt = 'DELETED_AT',
  PublishedAt = 'PUBLISHED_AT',
  UpdatedAt = 'UPDATED_AT'
}

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsFilterBy_Input = {
  /** author id of the draft */
  authorId?: InputMaybe<Scalars['String']>;
  /** created end date of the draft */
  createdEndDate?: InputMaybe<Scalars['DateTime']>;
  /** created start date of the draft */
  createdStartDate?: InputMaybe<Scalars['DateTime']>;
  /** deleted end date of the draft */
  deletedEndDate?: InputMaybe<Scalars['DateTime']>;
  /** deleted start date of the draft */
  deletedStartDate?: InputMaybe<Scalars['DateTime']>;
  /** id of the draft */
  draftId?: InputMaybe<Scalars['String']>;
  /** namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** the ID of the entity being drafted */
  namespaceEntityId?: InputMaybe<Scalars['String']>;
  /** partition of the draft */
  partition?: InputMaybe<Scalars['String']>;
  /** id of the partition */
  partitionId?: InputMaybe<Scalars['BigInt']>;
  /** published end date of the draft */
  publishedEndDate?: InputMaybe<Scalars['DateTime']>;
  /** published start date of the draft */
  publishedStartDate?: InputMaybe<Scalars['DateTime']>;
  /** query for searching drafts by name */
  query?: InputMaybe<Scalars['String']>;
  /** status of the draft */
  status?: InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftStatus>;
};

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsOrderBy_Input = {
  column?: InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsColumns>;
  direction?: InputMaybe<Instacart_Customers_Retailer_Management_V1_OrderByDirection>;
};

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsRequest_Input = {
  /** filters for the draft list */
  filterBy?: InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsFilterBy_Input>;
  /** order drafts list by certain criteria */
  orderBy?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_ListIppDraftsOrderBy_Input>>>;
  /** pagination info */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

export type Instacart_Customers_Retailer_Management_V1_ListIppDraftsResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_ListIppDraftsResponse';
  /** list of drafts */
  drafts?: Maybe<Array<Maybe<Instacart_Customers_Retailer_Management_V1_IppDraft>>>;
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
  /** page info for pagination */
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  /** drafts total count */
  totalCount?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Retailer_Management_V1_OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Instacart_Customers_Retailer_Management_V1_PublishIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_PublishIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_PublishIppDraftResponse';
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_RevertIppDraftRequest_Input = {
  /** the draft id that was created */
  draftId?: InputMaybe<Scalars['String']>;
  /** the namespace of the draft */
  namespace?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_RevertIppDraftResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_RevertIppDraftResponse';
  /** the draft id of the reverted draft that was created */
  draftId?: Maybe<Scalars['String']>;
  /** Error message, if applicable */
  errorMessage?: Maybe<Scalars['String']>;
  /** Structured error code, if applicable */
  errorReason?: Maybe<Instacart_Customers_Retailer_Management_V1_ErrorReason>;
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

/** Request to update client configuration */
export type Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationRequest_Input = {
  clientConfigurationId?: InputMaybe<Scalars['BigInt']>;
  settings?: InputMaybe<Scalars['JSON']>;
};

/** Response for update client configuration */
export type Instacart_Customers_Retailer_Management_V1_UpdateClientConfigurationResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_UpdateClientConfigurationResponse';
  clientConfiguration?: Maybe<Instacart_Customers_Retailer_Management_V1_ClientConfigurationResponse>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentRequest_Input = {
  /** a list of draft content that represents the draft */
  contents?: InputMaybe<Array<InputMaybe<Instacart_Customers_Retailer_Management_V1_IppDraftContent_Input>>>;
  /** the draft id to update */
  draftId?: InputMaybe<Scalars['String']>;
  /** the name of the draft */
  draftName?: InputMaybe<Scalars['String']>;
  /** User ID used in audit */
  userId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Retailer_Management_V1_UpdateIppDraftContentResponse = {
  __typename?: 'instacart_customers_retailer_management_v1_UpdateIppDraftContentResponse';
  isSuccessful?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionRequest_GetShopCollectionParameters_Input = {
  addressId?: InputMaybe<Scalars['BigInt']>;
  allowCanonicalRetailerLocationFallback?: InputMaybe<Scalars['Boolean']>;
  callerSource?: InputMaybe<Scalars['String']>;
  clientPlatform?: InputMaybe<Scalars['String']>;
  clientUserAgent?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Google_Type_LatLng_Input>;
  forceCanonicalRetailerLocationFallback?: InputMaybe<Scalars['Boolean']>;
  forceLegacyRetailersDomainSearch?: InputMaybe<Scalars['Boolean']>;
  forceNilRetailerIds?: InputMaybe<Scalars['Boolean']>;
  includeAdminOnlyShops?: InputMaybe<Scalars['Boolean']>;
  includeAllRetailerLocations?: InputMaybe<Scalars['Boolean']>;
  includeInStoreShops?: InputMaybe<Scalars['Boolean']>;
  postalCode?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  returnMultiplePickupShops?: InputMaybe<Scalars['Boolean']>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  sortBy?: InputMaybe<Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionRequest_GetShopCollectionParameters_Sort_By>;
  userId?: InputMaybe<Scalars['BigInt']>;
  viewClient?: InputMaybe<Instacart_Customers_Retailers_Orchestrator_V1_RequestClient_Input>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionRequest_GetShopCollectionParameters_Sort_By {
  Default = 'DEFAULT',
  Distance = 'DISTANCE',
  LastOrdered = 'LAST_ORDERED',
  LastVisited = 'LAST_VISITED',
  MachineLearning = 'MACHINE_LEARNING'
}

export type Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionRequest_Input = {
  parameters?: InputMaybe<Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionRequest_GetShopCollectionParameters_Input>;
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionResponse = {
  __typename?: 'instacart_customers_retailers_orchestrator_v1_GetShopCollectionResponse';
  shopCollection?: Maybe<Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionResponse_ShopCollection>;
};

export type Instacart_Customers_Retailers_Orchestrator_V1_GetShopCollectionResponse_ShopCollection = {
  __typename?: 'instacart_customers_retailers_orchestrator_v1_GetShopCollectionResponse_ShopCollection';
  shopCollectionRequestId?: Maybe<Scalars['String']>;
  shops?: Maybe<Array<Maybe<Instacart_Customers_Shared_V1_Shop>>>;
};

export type Instacart_Customers_Retailers_Orchestrator_V1_RequestClient_Input = {
  /** The app identifier - from HTTP Header x-client-identifier */
  identifier?: InputMaybe<Scalars['String']>;
  /** The user application/OS/vendor identifier - from HTTP Header user-agent. */
  userAgent?: InputMaybe<Scalars['String']>;
  /** The app version - from HTTP Header x-client-version. Required for iOS/Android, not required for Web. */
  version?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Sage_V1_CreateSessionPreviewTokenRequest_Input = {
  /** Identifier for the retailer the session belongs to. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Identifier for the session to preview. */
  sessionId?: InputMaybe<Scalars['String']>;
  /** Identifier for the store configuration the session belongs to. */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Sage_V1_CreateSessionPreviewTokenResponse = {
  __typename?: 'instacart_customers_sage_v1_CreateSessionPreviewTokenResponse';
  /** One-time token with a short TTL. */
  authToken?: Maybe<Scalars['String']>;
};

export type Instacart_Customers_Search_Results_V2_GetProductEsciLabelRequest_Input = {
  /** product ids */
  productIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** query */
  query?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Search_Results_V2_GetProductEsciLabelResponse = {
  __typename?: 'instacart_customers_search_results_v2_GetProductEsciLabelResponse';
  productLabels?: Maybe<Array<Maybe<Instacart_Customers_Search_Results_V2_ProductEsciLabel>>>;
};

export type Instacart_Customers_Search_Results_V2_ProductEsciLabel = {
  __typename?: 'instacart_customers_search_results_v2_ProductEsciLabel';
  /** product label */
  esciLabel?: Maybe<Instacart_Customers_Search_V1_ItemClassifierLabel>;
  /** product_id */
  productId?: Maybe<Scalars['BigInt']>;
  /** confidence score */
  score?: Maybe<Scalars['Float']>;
};

export enum Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesFailureReason {
  /** Conflicts with existing rules */
  ConflictWithExistingRule = 'CONFLICT_WITH_EXISTING_RULE',
  /** No error or unspecified */
  FailureReasonUnspecified = 'FAILURE_REASON_UNSPECIFIED',
  /** Unexpected server error */
  InternalError = 'INTERNAL_ERROR',
  /** Invalid request parameters */
  InvalidParameters = 'INVALID_PARAMETERS'
}

export type Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesParameters_Input = {
  /** Optional: aisle id blacklist for term */
  aisleIdBlacklist?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: autocorrection override for term */
  autocorrectionOverride?: InputMaybe<Scalars['String']>;
  /** Optional: boost type */
  boostType?: InputMaybe<Scalars['String']>;
  /** Optional: category id boosting for term */
  boostedCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: product id boosting for term */
  boostedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: category id blacklist for term */
  categoryIdBlacklist?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: disable autocorrection for term */
  disableAutocorrection?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable EBR for term */
  disableEmbeddingRecall?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable expansion for term */
  disableExpansion?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable reformulation for term */
  disableReformulation?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable sections for term */
  disableSearchSections?: InputMaybe<Scalars['Boolean']>;
  /** Optional: expansion override for term */
  expansionOverride?: InputMaybe<Scalars['String']>;
  /** Optional： expire time */
  expireAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional: id for override scope, useful when update existing overrides */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Optional: oauth_application_id for override scope */
  oauthApplicationId?: InputMaybe<Scalars['BigInt']>;
  /** Optional: override reason for term */
  overrideReason?: InputMaybe<Scalars['String']>;
  /** Optional: reformulation override for term */
  reformulationOverride?: InputMaybe<Scalars['String']>;
  /** Optional: section product ids for term */
  relatedProductIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: section product labels (ESCI) for term */
  relatedProductLabels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: section product labels for term */
  relatedProductSections?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: brand first smart refinements for term */
  smartRefinementsBrandFirst?: InputMaybe<Scalars['Boolean']>;
  /** Optional: disable smart refinements for term */
  smartRefinementsDisable?: InputMaybe<Scalars['Boolean']>;
  /** Optional: exclude smart refinements for term */
  smartRefinementsExclude?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: include smart refinements for term */
  smartRefinementsInclude?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Optional: store_configuration_id for override scope */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** term: the target query term */
  term?: InputMaybe<Scalars['String']>;
  /** Optional: updated by for term */
  updatedBy?: InputMaybe<Scalars['BigInt']>;
  /** Optional: warehouse_id for override scope */
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesRequest_Input = {
  /** parameters: CreateOrUpdateSearchTermOverridesParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesResponse = {
  __typename?: 'instacart_customers_search_v1_CreateOrUpdateSearchTermOverridesResponse';
  /** failure reason */
  failureReason?: Maybe<Instacart_Customers_Search_V1_CreateOrUpdateSearchTermOverridesFailureReason>;
  /** present the overrides that has been successfully updated */
  overrides?: Maybe<Instacart_Customers_Search_V1_SearchTermOverrides>;
  /** indicate success or failure */
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdParameters_Input = {
  /** id: the target override id */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Optional: updated by user_id */
  updatedBy?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdRequest_Input = {
  /** parameters: DeleteSearchTermOverridesByIdParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_DeleteSearchTermOverridesByIdParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesByIdParameters_Input = {
  /** id: the target override id */
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesByIdRequest_Input = {
  /** parameters: GetSearchTermOverridesByIdParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesByIdParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesByIdResponse = {
  __typename?: 'instacart_customers_search_v1_GetSearchTermOverridesByIdResponse';
  /** present the overrides that has been successfully updated */
  overrides?: Maybe<Instacart_Customers_Search_V1_SearchTermOverrides>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesParameters_Input = {
  /** limit: the max amount of overrides could be returned by request */
  limit?: InputMaybe<Scalars['BigInt']>;
  /** offset:for pagination */
  offset?: InputMaybe<Scalars['BigInt']>;
  /** Optional: retailer_id for filtering overrides */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional: list of retailer_ids for batch fetching across multiple retailers.
   * When non-empty, takes precedence over singular retailer_id.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: store_configuration_id for filtering overrides */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesRequest_Input = {
  /** parameters: GetSearchTermOverridesParameters */
  parameters?: InputMaybe<Instacart_Customers_Search_V1_GetSearchTermOverridesParameters_Input>;
  /** Optional parameter: partner_id. This is required for IPP requests */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional parameter: retailer_id. This is required for IPP requests */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional: list of retailer_ids for batch fetching across multiple retailers.
   * When non-empty, takes precedence over singular retailer_id.
   */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** proactively error out when timeout exceeded */
  timeoutMs?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Search_V1_GetSearchTermOverridesResponse = {
  __typename?: 'instacart_customers_search_v1_GetSearchTermOverridesResponse';
  data?: Maybe<Array<Maybe<Instacart_Customers_Search_V1_SearchTermOverrides>>>;
};

export enum Instacart_Customers_Search_V1_ItemClassifierLabel {
  Complementary = 'COMPLEMENTARY',
  Exact = 'EXACT',
  None = 'NONE',
  Related = 'RELATED',
  Substitute = 'SUBSTITUTE'
}

export type Instacart_Customers_Search_V1_SearchTermOverrides = {
  __typename?: 'instacart_customers_search_v1_SearchTermOverrides';
  /** Optional: aisle id blacklist for term */
  aisleIdBlacklist?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: autocorrection override for term */
  autocorrectionOverride?: Maybe<Scalars['String']>;
  /** Optional: boost type */
  boostType?: Maybe<Scalars['String']>;
  /** Optional: category id boosting for term */
  boostedCategoryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: product id boosting for term */
  boostedProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: category id blacklist for term */
  categoryIdBlacklist?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: created at for term */
  createdAt?: Maybe<Scalars['String']>;
  /** Optional: disable autocorrection for term */
  disableAutocorrection?: Maybe<Scalars['Boolean']>;
  /** Optional: disable EBR for term */
  disableEmbeddingRecall?: Maybe<Scalars['Boolean']>;
  /** Optional: disable expansion for term */
  disableExpansion?: Maybe<Scalars['Boolean']>;
  /** Optional: disable reformulation for term */
  disableReformulation?: Maybe<Scalars['Boolean']>;
  /** Optional: disable sections for term */
  disableSearchSections?: Maybe<Scalars['Boolean']>;
  /** Optional: expansion override for term */
  expansionOverride?: Maybe<Scalars['String']>;
  /** Optional： expire time */
  expireAt?: Maybe<Scalars['DateTime']>;
  /** id: identifier for a search term overrides record */
  id?: Maybe<Scalars['BigInt']>;
  /** Optional: oauth_application_id for override scope */
  oauthApplicationId?: Maybe<Scalars['BigInt']>;
  /** Optional: override reason for term */
  overrideReason?: Maybe<Scalars['String']>;
  /** Optional: reformulation override for term */
  reformulationOverride?: Maybe<Scalars['String']>;
  /** Optional: section product ids for term */
  relatedProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Optional: section product labels (ESCI) for term */
  relatedProductLabels?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: section product labels for term */
  relatedProductSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: brand first smart refinements for term */
  smartRefinementsBrandFirst?: Maybe<Scalars['Boolean']>;
  /** Optional: disable smart refinements for term */
  smartRefinementsDisable?: Maybe<Scalars['Boolean']>;
  /** Optional: exclude smart refinements for term */
  smartRefinementsExclude?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: include smart refinements for term */
  smartRefinementsInclude?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Optional: store_configuration_id for override scope */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  /** term: the target query term */
  term?: Maybe<Scalars['String']>;
  /** Optional: updated at for term */
  updatedAt?: Maybe<Scalars['String']>;
  /** Optional: updated by for term */
  updatedBy?: Maybe<Scalars['BigInt']>;
  /** Optional: warehouse_id for override scope */
  warehouseId?: Maybe<Scalars['BigInt']>;
};

/** Versioned identifier for the shop entity */
export type Instacart_Customers_Shared_Entities_Shop_Identifier_Input = {
  /** This is deprecated. Use v2 instead. */
  v1?: InputMaybe<Instacart_Customers_Shared_Entities_Shop_V1_Identifier_Input>;
  v2?: InputMaybe<Instacart_Customers_Shared_Entities_Shop_V2_Identifier_Input>;
};

/** V1 identifier for the shop entity */
export type Instacart_Customers_Shared_Entities_Shop_V1_Identifier_Input = {
  shopId?: InputMaybe<Scalars['BigInt']>;
};

/** V2 identifier for the shop entity */
export type Instacart_Customers_Shared_Entities_Shop_V2_Identifier_Input = {
  /** whether the shop is alcohol browsable */
  alcoholBrowsable?: InputMaybe<Scalars['Boolean']>;
  /** the inventory area id */
  inventoryAreaId?: InputMaybe<Scalars['String']>;
  /** nested shop for store in store context */
  nestedShops?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_Entities_Shop_V2_Identifier_Input>>>;
  /** the id of the shop. */
  retailerId?: InputMaybe<Scalars['Int']>;
  /** the retailer location id */
  retailerLocationId?: InputMaybe<Scalars['Int']>;
};

/**
 * Identity information for one or more actors associated with a request
 * (e.g., a logged-in consumer or a logged-out browser session).
 */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ActorContext_Input = {
  actors?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Input>>>;
  userlessIdentifier?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ActorContext_UserlessIdentifier>;
};

/**
 * Internal QA/env deployment-tier override, sourced from Ruby's
 * `UserlessIdentifierMiddleware` (`HTTP_X_USERLESS_IDENTIFIER` header /
 * cookie). Absent in prod. Lives on ActorContext because the middleware
 * stamps it once per request regardless of how many actors it represents.
 */
export enum Instacart_Customers_Shared_Rpc_Flowcontext_V1_ActorContext_UserlessIdentifier {
  UserlessIdentifierBeta = 'USERLESS_IDENTIFIER_BETA',
  UserlessIdentifierDev = 'USERLESS_IDENTIFIER_DEV',
  UserlessIdentifierQa1 = 'USERLESS_IDENTIFIER_QA1',
  UserlessIdentifierQa2 = 'USERLESS_IDENTIFIER_QA2',
  UserlessIdentifierStaging = 'USERLESS_IDENTIFIER_STAGING',
  UserlessIdentifierUnspecified = 'USERLESS_IDENTIFIER_UNSPECIFIED'
}

/** Actor describes the request initiator and how they are identified. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Input = {
  role?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Input>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_AccountHistory_Input = {
  daysSinceActivation?: InputMaybe<Scalars['Int']>;
  daysSinceSignup?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_Identifier_Input = {
  /**
   * The ID of the consumer. Alias for `user_id`.
   * This is extracted from the auth token.
   */
  consumerId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_Input = {
  accountHistory?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_AccountHistory_Input>;
  consumerIdentifier?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_Identifier_Input>;
  locationHistory?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LocationHistory_Input>;
  /** The consumer's loyalty-card enrollments across retailers. */
  loyaltyCards?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LoyaltyCards_Input>;
  orderHistory?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_OrderHistory_Input>;
  serviceType?: InputMaybe<Instacart_Customers_Shared_V1_ServiceType>;
  /**
   * Permission groups the consumer's user account belongs to.
   * Empty when none apply. Never contains USER_ROLE_UNKNOWN —
   * unrecognized upstream values are dropped at the populator boundary.
   */
  userRoles?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_UserRole>>>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LocationHistory_Input = {
  residencyStates?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * Pairs a retailer with the consumer's loyalty card at that
 * retailer.
 */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LoyaltyCards_Enrollment_Input = {
  /** The consumer's loyalty card at `retailer_id`. */
  card?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LoyaltyCards_LoyaltyCard_Input>;
  /** Retailer whose loyalty program this enrollment covers. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** The consumer's loyalty-card enrollments across retailers. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LoyaltyCards_Input = {
  /**
   * One entry per retailer the consumer is enrolled with. A
   * retailer appears at most once.
   */
  enrollments?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LoyaltyCards_Enrollment_Input>>>;
};

/** A loyalty card issued to a consumer by a retailer. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_LoyaltyCards_LoyaltyCard_Input = {
  /**
   * Retailer-issued card number the consumer presents at
   * checkout, for programs that issue one and where the number
   * is known for this consumer.
   */
  cardNumber?: InputMaybe<Scalars['String']>;
  /** Instacart-side loyalty card identifier. */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Tier label from the retailer's loyalty program (e.g.,
   * "gold"), for tiered programs where the consumer's current
   * tier is known.
   */
  loyaltyTier?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_OrderHistory_Input = {
  avgDaysBetweenOrders?: InputMaybe<Scalars['Float']>;
  daysSincePreviousOrder?: InputMaybe<Scalars['Int']>;
  medianDaysBetweenOrders?: InputMaybe<Scalars['Int']>;
  totalOrders?: InputMaybe<Scalars['Int']>;
};

/**
 * Permission groups attached to this consumer's user account.
 * A consumer has exactly one Role but may simultaneously hold zero
 * or more UserRoles. Populated from the inbound `Ic-User-Roles`
 * header; downstream services read these values for permission
 * checks and targeting/filtering decisions (e.g., suppressing
 * internal testing accounts from production analytics).
 */
export enum Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_UserRole {
  UserRoleAdmin = 'USER_ROLE_ADMIN',
  UserRoleConnectAdmin = 'USER_ROLE_CONNECT_ADMIN',
  UserRoleUnknown = 'USER_ROLE_UNKNOWN'
}

/**
 * High-level role for the actor in this request.
 * Can be various different roles, e.g., consumer, driver, etc.
 */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Input = {
  consumer?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Actor_Role_Consumer_Input>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_AdsContext_Input = {
  /** True when the request is a shadow/comparison run, false otherwise. */
  isShadowMode?: InputMaybe<Scalars['Boolean']>;
  /**
   * Identifies the source of the request.
   * Valid values:
   * - "Instacart": Requests originating from the Instacart platform
   * - "Connect": Requests originating from Connect platform
   */
  promotionSource?: InputMaybe<Scalars['String']>;
};

/** various identifiers for the application */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_ApplicationIdentifier_Input = {
  clientConfigPartnerId?: InputMaybe<Scalars['BigInt']>;
  /** Hostname-derived identifier (e.g., store configuration) */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whiteLabelId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_Input = {
  applicationIdentifier?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_ApplicationIdentifier_Input>;
  /** Extracted from `x-client-version`. */
  applicationVersion?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_LocationContext_Input>;
  pageViewId?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_PageViewIdentifier_Input>;
  /**
   * Extracted from `ahoy_visit`/`visit_token` (represents the current
   * session). Alias for `device_token`.
   */
  sessionId?: InputMaybe<Scalars['String']>;
};

/** Geographic coordinates from the user's service location. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_LocationContext_Coordinates_Input = {
  /**
   * Latitude from GPS or address geocoding.
   * Zero indicates unknown/not provided.
   */
  latitude?: InputMaybe<Scalars['Float']>;
  /**
   * Longitude from GPS or address geocoding.
   * Zero indicates unknown/not provided.
   */
  longitude?: InputMaybe<Scalars['Float']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_LocationContext_Input = {
  /**
   * User's service location coordinates (GPS or address geocoding).
   * Nil when coordinates are not available.
   */
  coordinates?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_LocationContext_Coordinates_Input>;
  /**
   * Country ID determined via IP → hostname/DB lookup.
   * This is always the country where order is being fulfilled from
   */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Postal code from the incoming request (e.g., GraphQL request
   * variables).
   */
  postalCode?: InputMaybe<Scalars['String']>;
  /**
   * Region ID of the consumer's zone (postal code → zone → region).
   * Zero when unresolved.
   */
  regionId?: InputMaybe<Scalars['BigInt']>;
  /** State code inferred via lookup (e.g., from postal code). */
  stateCode?: InputMaybe<Scalars['String']>;
  /** Zone ID from the incoming request (e.g., GraphQL request variables). */
  zoneId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_PageViewIdentifier_Input = {
  /** Unique to each page view (e.g., `x-page-view-id`). */
  v1?: InputMaybe<Scalars['String']>;
  /**
   * Migration field (currently same as `page_view_id`)
   * We require both of them to be present at the moment
   */
  v2?: InputMaybe<Scalars['String']>;
};

/** Device attributes derived from headers. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_DeviceContext_Input = {
  /** Extracted from `ahoy_visitor`/`visitor_token` (represents the device). */
  deviceToken?: InputMaybe<Scalars['String']>;
  /** From the `accept-language` header. */
  locales?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  location?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_DeviceContext_LocationContext_Input>;
  /** Strongly typed from the client identifier. */
  platform?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_DeviceContext_Platform>;
  /** Extracted from `x-forwarded-user-agent` / `user-agent`. */
  userAgent?: InputMaybe<Scalars['String']>;
};

export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_DeviceContext_LocationContext_Input = {
  /** Extracted from `x-forwarded-for` / `x-real-ip`. */
  requestIp?: InputMaybe<Scalars['String']>;
  /**
   * IANA timezone identifier (e.g. "America/New_York") derived from the
   * user's current active address via UpdateLocation → zone_id →
   * BatchGetZonesByIds. Not sent by the client directly.
   */
  timezone?: InputMaybe<Scalars['String']>;
};

/** Client platform the request originated from. */
export enum Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_DeviceContext_Platform {
  ClientPlatformAndroid = 'CLIENT_PLATFORM_ANDROID',
  ClientPlatformIos = 'CLIENT_PLATFORM_IOS',
  ClientPlatformMobileWeb = 'CLIENT_PLATFORM_MOBILE_WEB',
  ClientPlatformUnknown = 'CLIENT_PLATFORM_UNKNOWN',
  ClientPlatformWeb = 'CLIENT_PLATFORM_WEB'
}

/** Request tracking and analytics context for the device/app. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_Input = {
  application?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_ApplicationContext_Input>;
  device?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_DeviceContext_Input>;
};

/**
 * FlowContext represents common request-level metadata that spans across
 * different IC services.
 *
 * It captures contextual information about:
 * - The client making the request (device, platform, version)
 * - The actor involved (e.g., consumer, driver)
 * - The shop context (virtual representation of store that may map to multiple retailer stores)
 * - The ads context (used for personalization, compliance, and attribution)
 *
 * This message is meant to be passed through RPCs and backend services
 * to avoid re-extraction and provide consistent context enrichment.
 */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_FlowContext_Input = {
  actor?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ActorContext_Input>;
  ads?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_AdsContext_Input>;
  client?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ClientContext_Input>;
  shop?: InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_ShopContext_Input>;
};

/** Multiple shops can be present in the request for cross-retailer workflows. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_ShopContext_Input = {
  /** Multiple shops can be present in the request for cross-retailer workflows. */
  shops?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_Rpc_Flowcontext_V1_Shop_Input>>>;
};

/** Captures the store scope for a request. */
export type Instacart_Customers_Shared_Rpc_Flowcontext_V1_Shop_Input = {
  shopIdentifier?: InputMaybe<Instacart_Customers_Shared_Entities_Shop_Identifier_Input>;
};

/** The model of Fulfillment we've promised to the customer. Formerly known as delivery_type. */
export enum Instacart_Customers_Shared_V1_FulfillmentTypeWrapper_FulfillmentType {
  AffordableDelivery = 'AFFORDABLE_DELIVERY',
  Asap = 'ASAP',
  Delivery = 'DELIVERY',
  DeliveryOnly = 'DELIVERY_ONLY',
  DirectToConsumer = 'DIRECT_TO_CONSUMER',
  Eta = 'ETA',
  FiveHour = 'FIVE_HOUR',
  FulfillmentTypeUnspecified = 'FULFILLMENT_TYPE_UNSPECIFIED',
  HyperFast = 'HYPER_FAST',
  InstoreOrderAheadAsap = 'INSTORE_ORDER_AHEAD_ASAP',
  InstoreOrderAheadScheduled = 'INSTORE_ORDER_AHEAD_SCHEDULED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  OneHour = 'ONE_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  RetailerInstore = 'RETAILER_INSTORE',
  RetailerManaged = 'RETAILER_MANAGED',
  ScanAndPay = 'SCAN_AND_PAY',
  Scheduled = 'SCHEDULED',
  ThreeHour = 'THREE_HOUR',
  TwoHour = 'TWO_HOUR',
  Ultrafast = 'ULTRAFAST',
  /** Express subscription fulfillment (non-physical) */
  VirtualExpress = 'VIRTUAL_EXPRESS',
  VirtualRetailerMembership = 'VIRTUAL_RETAILER_MEMBERSHIP'
}

export enum Instacart_Customers_Shared_V1_Locale {
  DeAt = 'DE_AT',
  EnAt = 'EN_AT',
  EnAu = 'EN_AU',
  EnCa = 'EN_CA',
  EnGb = 'EN_GB',
  /** Soft deprecated Use EN_GB instead */
  EnUk = 'EN_UK',
  EnUs = 'EN_US',
  EsEs = 'ES_ES',
  /** Soft deprecated Use ES_ES instead */
  EsSp = 'ES_SP',
  EsUs = 'ES_US',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  LocaleUnspecified = 'LOCALE_UNSPECIFIED'
}

/** An order by direction. */
export enum Instacart_Customers_Shared_V1_Order_Attribute_Direction {
  /** Ascending. */
  Asc = 'ASC',
  /** Descending. */
  Desc = 'DESC'
}

export type Instacart_Customers_Shared_V1_Order_Attribute_Input = {
  /** The direction to order by */
  direction?: InputMaybe<Instacart_Customers_Shared_V1_Order_Attribute_Direction>;
  /** The attribute to order by */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * Container for ordering parameters implemented
 * using the Domain::Api::OrderBy functionality
 */
export type Instacart_Customers_Shared_V1_Order_Input = {
  attributes?: InputMaybe<Array<InputMaybe<Instacart_Customers_Shared_V1_Order_Attribute_Input>>>;
};

export enum Instacart_Customers_Shared_V1_QuantityType {
  Each = 'EACH',
  Unspecified = 'UNSPECIFIED',
  Weight = 'WEIGHT'
}

/**
 * Contextual information used for identifying the
 * marketplace/pbi/connect configurations associated
 * with a request
 *
 * see Domain::Shared::RequestContext
 */
export type Instacart_Customers_Shared_V1_RequestContext_Input = {
  /**
   * Known as `oauth_application_id` in the corresponding domain object
   * But refers to the primary key on the `client_configurations` table.
   */
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  /** The ID associated with a specific country, represented as an ISO numeric code */
  countryId?: InputMaybe<Scalars['Int']>;
  /** The ID associated with a particular store configuration */
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

export enum Instacart_Customers_Shared_V1_ServiceType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  Pickup = 'PICKUP',
  ScanAndPay = 'SCAN_AND_PAY',
  ServiceTypeUnspecified = 'SERVICE_TYPE_UNSPECIFIED',
  /** Used for non-physical services */
  Virtual = 'VIRTUAL'
}

export type Instacart_Customers_Shared_V1_Shop = {
  __typename?: 'instacart_customers_shared_v1_Shop';
  /** whether the shop is alcohol browsable */
  alcoholBrowsable?: Maybe<Scalars['Boolean']>;
  /** does the shop only support extra long delivery */
  extraLongDistanceDeliveryOnly?: Maybe<Scalars['Boolean']>;
  /**
   * The fulfillment provider id for the shop. This id corresponds to the primary key in the fulfillment_providers table
   * in Main DB, which represents external fulfillment providers (e.g. not Instacart) used by retailers to fulfill orders.
   * Currently, this value is only used and populated in the Restaurant Depot SFP, as it's the only store using that table.
   * When the value is set, it means that the shop configuration is serviced by the corresponding fulfillment provider.
   */
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  /** the id of the shop. */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * The inventory area ID for the shop's primary retailer location.
   * Derived from warehouse_locations.inventory_area_id via the first retailer_location_id.
   */
  inventoryAreaId?: Maybe<Scalars['BigInt']>;
  /** nested shop for store in store context */
  nestedShops?: Maybe<Array<Maybe<Instacart_Customers_Shared_V1_Shop>>>;
  /** the id of the shop. */
  retailerId?: Maybe<Scalars['Int']>;
  /** the retailer location id */
  retailerLocationId?: Maybe<Scalars['Int']>;
  /** service type of the shop */
  serviceType?: Maybe<Instacart_Customers_Shared_V1_ServiceType>;
};

export enum Instacart_Customers_Shared_V1_SurfaceType {
  Aisle = 'AISLE',
  Brands = 'BRANDS',
  BrandPage = 'BRAND_PAGE',
  BrowsePostAtc = 'BROWSE_POST_ATC',
  BundleCard = 'BUNDLE_CARD',
  BundleDetails = 'BUNDLE_DETAILS',
  /** cart */
  Cart = 'CART',
  Category = 'CATEGORY',
  CategoryHeroDepartment = 'CATEGORY_HERO_DEPARTMENT',
  /** checkout */
  Checkout = 'CHECKOUT',
  Collection = 'COLLECTION',
  CollectionSubject = 'COLLECTION_SUBJECT',
  ComboModal = 'COMBO_MODAL',
  /** composable placement preview (enterprise storefront CMS preview) */
  ComposablePlacementPreview = 'COMPOSABLE_PLACEMENT_PREVIEW',
  CouponsDepartment = 'COUPONS_DEPARTMENT',
  /** cross-retailer product detail page (X-Retailer PDP) */
  CrossRetailerProductDetail = 'CROSS_RETAILER_PRODUCT_DETAIL',
  CrossRetailerSearch = 'CROSS_RETAILER_SEARCH',
  /** unclassified */
  Deeplink = 'DEEPLINK',
  /** ads */
  DeliveryPromotionCheckoutModal = 'DELIVERY_PROMOTION_CHECKOUT_MODAL',
  DeliveryPromotionGuidedQual = 'DELIVERY_PROMOTION_GUIDED_QUAL',
  Department = 'DEPARTMENT',
  Departments = 'DEPARTMENTS',
  DidYouForget = 'DID_YOU_FORGET',
  /** health/dietary landing pages */
  Dietary = 'DIETARY',
  DynamicListCartBased = 'DYNAMIC_LIST_CART_BASED',
  /** connnect external shopping API */
  ExternalShoppingApi = 'EXTERNAL_SHOPPING_API',
  Favorites = 'FAVORITES',
  FinishMyCart = 'FINISH_MY_CART',
  /** finish my cart */
  FinishMyCartModal = 'FINISH_MY_CART_MODAL',
  /** flyers destination page */
  Flyers = 'FLYERS',
  HighRiskMoreOptions = 'HIGH_RISK_MORE_OPTIONS',
  HomeFeed = 'HOME_FEED',
  /** household */
  HouseholdCart = 'HOUSEHOLD_CART',
  /** home */
  Hub = 'HUB',
  InspirationFeed = 'INSPIRATION_FEED',
  ItemDetails = 'ITEM_DETAILS',
  /** item details */
  ItemDetailPostAtc = 'ITEM_DETAIL_POST_ATC',
  ItemForwardList = 'ITEM_FORWARD_LIST',
  ItemLinkSharing = 'ITEM_LINK_SHARING',
  /** landing/growth */
  Landing = 'LANDING',
  /** lists */
  List = 'LIST',
  ListCard = 'LIST_CARD',
  /** lists */
  ListDetails = 'LIST_DETAILS',
  LowStockMoreOptions = 'LOW_STOCK_MORE_OPTIONS',
  /** multi_retailer_page on home */
  MultiRetailerPage = 'MULTI_RETAILER_PAGE',
  OrderHistory = 'ORDER_HISTORY',
  OrderItemChanges = 'ORDER_ITEM_CHANGES',
  OrderStatus = 'ORDER_STATUS',
  /** use other if you can't definitively map surface value */
  Other = 'OTHER',
  OtherOptions = 'OTHER_OPTIONS',
  /** collections and departments */
  ParentCollection = 'PARENT_COLLECTION',
  Partnerrecipe = 'PARTNERRECIPE',
  /** recipes */
  Partnerrecipes = 'PARTNERRECIPES',
  /** post checkout */
  PostCheckoutRecommendations = 'POST_CHECKOUT_RECOMMENDATIONS',
  Potluck = 'POTLUCK',
  ReadyMealsComboModal = 'READY_MEALS_COMBO_MODAL',
  Recipes = 'RECIPES',
  RecipeBox = 'RECIPE_BOX',
  RecipeCollection = 'RECIPE_COLLECTION',
  RecipeDetail = 'RECIPE_DETAIL',
  RecipeSet = 'RECIPE_SET',
  RecipeTab = 'RECIPE_TAB',
  RecommendedRecipesStorefront = 'RECOMMENDED_RECIPES_STOREFRONT',
  /** REDEMPTION_MODAL modal */
  RedemptionModal = 'REDEMPTION_MODAL',
  /** recommendations */
  RelatedItems = 'RELATED_ITEMS',
  RelatedPromotionItems = 'RELATED_PROMOTION_ITEMS',
  ReorderModal = 'REORDER_MODAL',
  /** sage chat page (/:retailerSlug/chat) */
  Sage = 'SAGE',
  /** savings */
  Savings = 'SAVINGS',
  SavingsSalesDepartment = 'SAVINGS_SALES_DEPARTMENT',
  /** search */
  Search = 'SEARCH',
  SearchPostAtc = 'SEARCH_POST_ATC',
  SearchRecommendation = 'SEARCH_RECOMMENDATION',
  /** content pages */
  ShopContentPage = 'SHOP_CONTENT_PAGE',
  /** shop flyer destination page */
  ShopFlyer = 'SHOP_FLYER',
  /** special requests */
  SpecialRequest = 'SPECIAL_REQUEST',
  Storefront = 'STOREFRONT',
  StorefrontPostAtc = 'STOREFRONT_POST_ATC',
  /** store directory */
  StoreDirectory = 'STORE_DIRECTORY',
  StoreForwardSection = 'STORE_FORWARD_SECTION',
  StoreRoot = 'STORE_ROOT',
  /** storefront */
  StoreRootDepartment = 'STORE_ROOT_DEPARTMENT',
  SurfaceTypeUnspecified = 'SURFACE_TYPE_UNSPECIFIED',
  Tiktokrecipes = 'TIKTOKRECIPES',
  /** BIA */
  YourItems = 'YOUR_ITEMS',
  YourLists = 'YOUR_LISTS'
}

export type Instacart_Customers_Value_Grant_Types_V1_GrantQuantityDetail = {
  __typename?: 'instacart_customers_value_grant_types_v1_GrantQuantityDetail';
  monetaryAmount?: Maybe<GoogleTypeMoney>;
  nonMonetaryAmount?: Maybe<Instacart_Customers_Value_Grant_Types_V1_NonMonetaryAmount>;
};

export type Instacart_Customers_Value_Grant_Types_V1_NonMonetaryAmount = {
  __typename?: 'instacart_customers_value_grant_types_v1_NonMonetaryAmount';
  quantity?: Maybe<Scalars['BigInt']>;
  unit?: Maybe<Instacart_Customers_Value_Grant_Types_V1_NonMonetaryAmount_NonMonetaryUnit>;
};

export enum Instacart_Customers_Value_Grant_Types_V1_NonMonetaryAmount_NonMonetaryUnit {
  NonMonetaryChasePoints = 'NON_MONETARY_CHASE_POINTS',
  NonMonetaryUnitUnspecified = 'NON_MONETARY_UNIT_UNSPECIFIED'
}

export type Instacart_Customers_Value_Grant_Types_V1_StoredValueOrDiscount = {
  __typename?: 'instacart_customers_value_grant_types_v1_StoredValueOrDiscount';
  amount?: Maybe<Instacart_Customers_Value_Grant_Types_V1_GrantQuantityDetail>;
  clipped?: Maybe<Scalars['Boolean']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Instacart_Customers_Value_Grant_Types_V1_StoredValueOrDiscount_StoredValueOrDiscountType>;
  valueGrantId?: Maybe<Scalars['String']>;
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Customers_Value_Grant_Types_V1_StoredValueOrDiscount_StoredValueOrDiscountType {
  StoredValueOrDiscountTypeCoupon = 'STORED_VALUE_OR_DISCOUNT_TYPE_COUPON',
  StoredValueOrDiscountTypeCredit = 'STORED_VALUE_OR_DISCOUNT_TYPE_CREDIT',
  StoredValueOrDiscountTypeUnspecified = 'STORED_VALUE_OR_DISCOUNT_TYPE_UNSPECIFIED'
}

export type Instacart_Customers_Value_Grant_V1_GetStoredValueAndDiscountsRequest_FilterContext_Input = {
  countryId?: InputMaybe<Scalars['BigInt']>;
  offersClipped?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Value_Grant_V1_GetStoredValueAndDiscountsRequest_Input = {
  filterContext?: InputMaybe<Instacart_Customers_Value_Grant_V1_GetStoredValueAndDiscountsRequest_FilterContext_Input>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Value_Grant_V1_GetStoredValueAndDiscountsResponse = {
  __typename?: 'instacart_customers_value_grant_v1_GetStoredValueAndDiscountsResponse';
  storedValues?: Maybe<Array<Maybe<Instacart_Customers_Value_Grant_Types_V1_StoredValueOrDiscount>>>;
};

export type Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryRequest_FilterSet_Input = {
  accountReference?: InputMaybe<Instacart_Customers_Value_Grant_V1_StoredValueAccountReference_Input>;
  timeRange?: InputMaybe<Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryRequest_FilterSet_TimeRange_Input>;
};

export type Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryRequest_FilterSet_TimeRange_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryRequest_Input = {
  filterSet?: InputMaybe<Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryRequest_FilterSet_Input>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Value_Grant_V1_GetStoredValueTransactionHistoryResponse = {
  __typename?: 'instacart_customers_value_grant_v1_GetStoredValueTransactionHistoryResponse';
  transaction?: Maybe<Array<Maybe<Instacart_Customers_Value_Grant_V1_Transaction>>>;
};

export type Instacart_Customers_Value_Grant_V1_StoredValueAccountReference = {
  __typename?: 'instacart_customers_value_grant_v1_StoredValueAccountReference';
  balanceId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Value_Grant_V1_StoredValueAccountReference_Input = {
  balanceId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Customers_Value_Grant_V1_StoredValueBalanceAmount = {
  __typename?: 'instacart_customers_value_grant_v1_StoredValueBalanceAmount';
  monetaryAmount?: Maybe<GoogleTypeMoney>;
  nonMonetaryAmount?: Maybe<Instacart_Customers_Value_Grant_Types_V1_NonMonetaryAmount>;
};

export type Instacart_Customers_Value_Grant_V1_Transaction = {
  __typename?: 'instacart_customers_value_grant_v1_Transaction';
  amountDelta?: Maybe<Instacart_Customers_Value_Grant_V1_StoredValueBalanceAmount>;
  executedAt?: Maybe<Scalars['DateTime']>;
  transactionAccountReference?: Maybe<Instacart_Customers_Value_Grant_V1_StoredValueAccountReference>;
  transactionAttributes?: Maybe<Instacart_Customers_Value_Grant_V1_TransactionAttributes>;
  transactionId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Instacart_Customers_Value_Grant_V1_TransactionType>;
};

export type Instacart_Customers_Value_Grant_V1_TransactionAttributes = {
  __typename?: 'instacart_customers_value_grant_v1_TransactionAttributes';
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  orderId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  transactionReason?: Maybe<Instacart_Customers_Value_Grant_V1_TransactionReason>;
  valueExpiresAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Customers_Value_Grant_V1_TransactionReason {
  TransactionReasonBusinessContractualBenefit = 'TRANSACTION_REASON_BUSINESS_CONTRACTUAL_BENEFIT',
  TransactionReasonCaperCredit = 'TRANSACTION_REASON_CAPER_CREDIT',
  TransactionReasonChaseCardCredit = 'TRANSACTION_REASON_CHASE_CARD_CREDIT',
  TransactionReasonChasePwp = 'TRANSACTION_REASON_CHASE_PWP',
  TransactionReasonDirectedSpend = 'TRANSACTION_REASON_DIRECTED_SPEND',
  TransactionReasonExpressCredit = 'TRANSACTION_REASON_EXPRESS_CREDIT',
  TransactionReasonGamificationCredit = 'TRANSACTION_REASON_GAMIFICATION_CREDIT',
  TransactionReasonGeneralRetailerCredit = 'TRANSACTION_REASON_GENERAL_RETAILER_CREDIT',
  TransactionReasonGiftCards = 'TRANSACTION_REASON_GIFT_CARDS',
  TransactionReasonHappinessAppeasements = 'TRANSACTION_REASON_HAPPINESS_APPEASEMENTS',
  TransactionReasonIcPromotionalCreditBack = 'TRANSACTION_REASON_IC_PROMOTIONAL_CREDIT_BACK',
  TransactionReasonLegacyGiftCards = 'TRANSACTION_REASON_LEGACY_GIFT_CARDS',
  TransactionReasonPoints = 'TRANSACTION_REASON_POINTS',
  TransactionReasonPromotionalPoints = 'TRANSACTION_REASON_PROMOTIONAL_POINTS',
  TransactionReasonRefundCredit = 'TRANSACTION_REASON_REFUND_CREDIT',
  TransactionReasonRetailerGiftCard = 'TRANSACTION_REASON_RETAILER_GIFT_CARD',
  TransactionReasonUnspecified = 'TRANSACTION_REASON_UNSPECIFIED',
  TransactionReasonValueGrantCredit = 'TRANSACTION_REASON_VALUE_GRANT_CREDIT'
}

export enum Instacart_Customers_Value_Grant_V1_TransactionType {
  /** Cancel account remaining balance. */
  TransactionTypeBalanceCancellation = 'TRANSACTION_TYPE_BALANCE_CANCELLATION',
  /** Charge to the account. */
  TransactionTypeCharge = 'TRANSACTION_TYPE_CHARGE',
  /** Credit clawed back from product. Ex. on refund earned % may be deducted. */
  TransactionTypeClawback = 'TRANSACTION_TYPE_CLAWBACK',
  /** Credit earn from product. Ex. Express credit back. */
  TransactionTypeDeposit = 'TRANSACTION_TYPE_DEPOSIT',
  /** Refund to the account. */
  TransactionTypeRefund = 'TRANSACTION_TYPE_REFUND',
  TransactionTypeUnspecified = 'TRANSACTION_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoRequest_Input = {
  orderId?: InputMaybe<Scalars['BigInt']>;
  /** used for graphql authorization */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Boba_Core_Offers_V1_GetOrderDiscountInfoResponse = {
  __typename?: 'instacart_enterprise_boba_core_offers_v1_GetOrderDiscountInfoResponse';
  orderDiscountInfo?: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo>>>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails';
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyForXAmountScenario?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyForXAmountScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetNForFreeScenario?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForFreeScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetNQtyForXAmountScenario?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForXAmountScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetXAmountOffScenario?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXAmountOffScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyGetXPercentOffScenario?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXPercentOffScenario>;
  /** When present, it indicates this offer is categorized into this scenario. */
  buyMQtyOrMoreGetXPercentOffScenario?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyOrMoreGetXPercentOffScenario>;
  /** Human readable condition and reward string for the discount */
  conditionRewardString?: Maybe<Scalars['String']>;
  /** Internal description of the discount */
  description?: Maybe<Scalars['String']>;
  /** Legacy discount_category_id */
  discountCategoryId?: Maybe<Scalars['BigInt']>;
  /** Discount end time */
  endsAt?: Maybe<Scalars['DateTime']>;
  /** Details about the funding information for this offer */
  fundingDetail?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingDetail>;
  /** Internal name of the discount */
  name?: Maybe<Scalars['String']>;
  /** List of offer conditions */
  offerConditions?: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferCondition>>>;
  /** Reference to the offer in any external system */
  offerExternalReference?: Maybe<Scalars['String']>;
  /** Unique offer identifier, will map to discount_policy_id post Unified Discounting Platform */
  offerId?: Maybe<Scalars['String']>;
  /** The offer request key */
  offerRequestKey?: Maybe<Scalars['String']>;
  /** List of offer rewards */
  offerRewards?: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferReward>>>;
  /** The source system which is ingesting this offer */
  offerSource?: Maybe<Scalars['String']>;
  /** Type of offer: coupon, auto apply etc */
  offerType?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferType>;
  /** Optional promo code for the discount */
  promoCode?: Maybe<Scalars['String']>;
  /** Indicates the maximum allowed redemptions of this offer */
  redemptionLimits?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRedemptionLimits>;
  /** Discount start time */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Legal terms and condition for the discount */
  terms?: Maybe<Scalars['String']>;
  /** When present, it indicates this offer cannot be categorized into any known scenario. */
  uncategorizedScenario?: Maybe<Scalars['instacart_enterprise_boba_core_types_v1_OfferDetails_UncategorizedScenario']>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BigDecimal';
  /**
   * Nano units of the amount (10^-9)
   * Must be same sign as units
   * Example: The value -1.25 is represented as units=-1 and nanos=-250000000
   */
  nanos?: Maybe<Scalars['Int']>;
  /** Whole units part of the amount */
  units?: Maybe<Scalars['BigInt']>;
};

/** Buy M qty of eligible products and for a total price of X. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyForXAmountScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyForXAmountScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_amount referred in the scenario name */
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get additional N qty for free. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForFreeScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetNQtyForFreeScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter n_qty referred in the scenario name */
  nQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
};

/** Buy M qty of eligible products and be eligible to buy N eligible products for a total price of X. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetNQtyForXAmountScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetNQtyForXAmountScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter n_qty referred in the scenario name */
  nQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_amount referred in the scenario name */
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get X (monetary value) off the original price. */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXAmountOffScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetXAmountOffScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_amount referred in the scenario name */
  xAmount?: Maybe<GoogleTypeMoney>;
};

/** Buy M qty of eligible products and get X% off the price (of M). */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyGetXPercentOffScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyGetXPercentOffScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_percent referred in the scenario name */
  xPercent?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
};

/** Buy M or more qty of eligible products and get X% off the price (of M). */
export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BuyMQtyOrMoreGetXPercentOffScenario = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_BuyMQtyOrMoreGetXPercentOffScenario';
  /** Value of parameter m_qty referred in the scenario name */
  mQty?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Value of parameter x_percent referred in the scenario name */
  xPercent?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_DiscountRewardType {
  AmountOff = 'AMOUNT_OFF',
  DiscountRewardTypeUnspecified = 'DISCOUNT_REWARD_TYPE_UNSPECIFIED',
  PercentMille = 'PERCENT_MILLE',
  PercentOff = 'PERCENT_OFF',
  SetPrice = 'SET_PRICE',
  SetPricePerUnit = 'SET_PRICE_PER_UNIT'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingDetail = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_FundingDetail';
  /** the amount of budget available before the offer is exhausted */
  budgetLimit?: Maybe<GoogleTypeMoney>;
  fundingProviderInfo?: Maybe<Array<Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingProviderInformation>>>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingProviderInformation = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_FundingProviderInformation';
  /** percentage of funding for discount by the source. Can range from 0-100 */
  percent?: Maybe<Scalars['BigInt']>;
  /** who is funding this part */
  source?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingSource>;
  /** name of the funding source */
  sourceName?: Maybe<Scalars['String']>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_FundingSource {
  Cpg = 'CPG',
  FundingSourceUnspecified = 'FUNDING_SOURCE_UNSPECIFIED',
  Instacart = 'INSTACART',
  Others = 'OTHERS',
  Retailer = 'RETAILER'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferCondition = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_OfferCondition';
  /** Indicates if offer can be applied partially when quantity conditions are not met */
  allowPartialApplication?: Maybe<Scalars['Boolean']>;
  /** List of collection ids for the condition */
  collectionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** List of product ids for the condition */
  conditionProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * Maximum quantity allowed in a single application of this offer.
   * Same value as minimum_quantity is used to indicate exact quantity matching, whereas nil value is used when no upper limit is set.
   */
  maximumQuantity?: Maybe<Scalars['BigInt']>;
  /** Minimum quantity to have in cart (with any mix of the products) to qualify for discount */
  minimumQuantity?: Maybe<Scalars['BigInt']>;
  /** Minimum amount to spend to qualify for discount */
  minimumSpend?: Maybe<GoogleTypeMoney>;
  offerConditionType?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferConditionType>;
  /** List of taxonomy node ids for the condition */
  taxonomyNodeIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferConditionType {
  OfferConditionTypeBasket = 'OFFER_CONDITION_TYPE_BASKET',
  OfferConditionTypeBrands = 'OFFER_CONDITION_TYPE_BRANDS',
  OfferConditionTypeCategories = 'OFFER_CONDITION_TYPE_CATEGORIES',
  OfferConditionTypeCollections = 'OFFER_CONDITION_TYPE_COLLECTIONS',
  OfferConditionTypeCommerceClassifications = 'OFFER_CONDITION_TYPE_COMMERCE_CLASSIFICATIONS',
  OfferConditionTypeFees = 'OFFER_CONDITION_TYPE_FEES',
  OfferConditionTypeProducts = 'OFFER_CONDITION_TYPE_PRODUCTS',
  OfferConditionTypeRegions = 'OFFER_CONDITION_TYPE_REGIONS',
  OfferConditionTypeRetailerDepartments = 'OFFER_CONDITION_TYPE_RETAILER_DEPARTMENTS',
  OfferConditionTypeUnspecified = 'OFFER_CONDITION_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRedemptionLimits = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_OfferRedemptionLimits';
  /** Total number of redemptions allowed on offers in the same group. */
  redemptionLimit?: Maybe<Scalars['BigInt']>;
  /** Number of redemptions allowed per order on offers in the same group */
  redemptionLimitPerOrder?: Maybe<Scalars['BigInt']>;
  /** Number of redemptions allowed per user on offers in the same group. */
  redemptionLimitPerUser?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferReward = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OfferDetails_OfferReward';
  /** Discount amount */
  amountDiscount?: Maybe<GoogleTypeMoney>;
  discountRewardType?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_DiscountRewardType>;
  /** Indicates if the reward group can include items in the condition group */
  includeConditionGroup?: Maybe<Scalars['Boolean']>;
  /** Discount sets price for the item */
  offerPrice?: Maybe<GoogleTypeMoney>;
  offerRewardType?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRewardType>;
  /** Discount percent value between 1-100. */
  percentDiscount?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_BigDecimal>;
  /** Maximum quantity allowed to receive the reward in a single offer application */
  quantityLimit?: Maybe<Scalars['BigInt']>;
  /** List of reward product ids" */
  rewardProductIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferRewardType {
  OfferRewardTypeBasket = 'OFFER_REWARD_TYPE_BASKET',
  OfferRewardTypeBrands = 'OFFER_REWARD_TYPE_BRANDS',
  OfferRewardTypeCategories = 'OFFER_REWARD_TYPE_CATEGORIES',
  OfferRewardTypeCollections = 'OFFER_REWARD_TYPE_COLLECTIONS',
  OfferRewardTypeProducts = 'OFFER_REWARD_TYPE_PRODUCTS',
  OfferRewardTypeRetailerDepartments = 'OFFER_REWARD_TYPE_RETAILER_DEPARTMENTS',
  OfferRewardTypeServiceItem = 'OFFER_REWARD_TYPE_SERVICE_ITEM',
  OfferRewardTypeUnspecified = 'OFFER_REWARD_TYPE_UNSPECIFIED'
}

export enum Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails_OfferType {
  AutoApply = 'AUTO_APPLY',
  CheckoutCodeBasedDiscount = 'CHECKOUT_CODE_BASED_DISCOUNT',
  Coupon = 'COUPON',
  OfferTypeUnspecified = 'OFFER_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo = {
  __typename?: 'instacart_enterprise_boba_core_types_v1_OrderDiscountInfo';
  /** Discount amount resutling from the evaluation of the offer */
  appliedAmount?: Maybe<GoogleTypeMoney>;
  /** ID of the discount_discountables record */
  discountDiscountableId?: Maybe<Scalars['BigInt']>;
  /** ID of the target the offer applies to */
  discountableId?: Maybe<Scalars['BigInt']>;
  /** Discountable entity: basket, item, customer fee etc. */
  discountableType?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo_DiscountableType>;
  /** Discount policy data */
  offer?: Maybe<Instacart_Enterprise_Boba_Core_Types_V1_OfferDetails>;
  /** ID of the target order */
  orderId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Enterprise_Boba_Core_Types_V1_OrderDiscountInfo_DiscountableType {
  BasketLevelOffer = 'BASKET_LEVEL_OFFER',
  CustomerFeeOffer = 'CUSTOMER_FEE_OFFER',
  DiscountableTypeUnspecified = 'DISCOUNTABLE_TYPE_UNSPECIFIED',
  ItemLevelOffer = 'ITEM_LEVEL_OFFER'
}

/** Address information with coordinates. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_AddressInformation = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_AddressInformation';
  /** City */
  city?: Maybe<Scalars['String']>;
  /** Geographic coordinates */
  coordinates?: Maybe<Google_Type_LatLng>;
  /** State/province */
  state?: Maybe<Scalars['String']>;
  /** Street address */
  streetName?: Maybe<Scalars['String']>;
  /** Unit/apartment number */
  unitNumber?: Maybe<Scalars['String']>;
  /** ZIP/postal code */
  zipCode?: Maybe<Scalars['String']>;
};

/** Failure response after attempting to cancel a partner bulk delivery route */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelDeliveryRouteFailure = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_CancelDeliveryRouteFailure';
  failureReason?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteChangeFailureReason>;
};

/** Request to cancel a partner bulk delivery route */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelPartnerBulkDeliveryRouteRequest_Input = {
  /** Authorization context of the IPP user making the request */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** The batch/route ID to cancel */
  batchId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Current route version for optimistic concurrency control
   * Backend will reject the request if this doesn't match the current version
   */
  routeVersion?: InputMaybe<Scalars['BigInt']>;
  /**
   * Transfer operations specifying where all orders should go
   * Required: dispatcher must explicitly specify destination for all orders
   * Can transfer to other routes or back to Instacart
   */
  transfers?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransfers_Input>>>;
};

/** Response after attempting to cancel a partner bulk delivery route */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelPartnerBulkDeliveryRouteResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_CancelPartnerBulkDeliveryRouteResponse';
  failure?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CancelDeliveryRouteFailure>;
  success?: Maybe<Scalars['instacart_enterprise_frigate_delivery_software_v1_CancelDeliveryRouteSuccess']>;
};

/** Unit of measurement for vehicle capacity. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit {
  CapacityUnitTotes = 'CAPACITY_UNIT_TOTES',
  CapacityUnitUnknown = 'CAPACITY_UNIT_UNKNOWN'
}

/** Request message for creating a new warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleRequest_Input = {
  capacityAmount?: InputMaybe<Scalars['Int']>;
  capacityUnit?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  color?: InputMaybe<Scalars['String']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for creating a warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_CreateWarehouseLocationVehicleResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_CreateWarehouseLocationVehicleResponse';
  vehicle?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle>;
};

export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteChangeFailureReason {
  DeliveryRouteChangeFailureReasonBatchNotFound = 'DELIVERY_ROUTE_CHANGE_FAILURE_REASON_BATCH_NOT_FOUND',
  DeliveryRouteChangeFailureReasonExceededMaxTransfers = 'DELIVERY_ROUTE_CHANGE_FAILURE_REASON_EXCEEDED_MAX_TRANSFERS',
  DeliveryRouteChangeFailureReasonInvalidBatchState = 'DELIVERY_ROUTE_CHANGE_FAILURE_REASON_INVALID_BATCH_STATE',
  DeliveryRouteChangeFailureReasonUnknown = 'DELIVERY_ROUTE_CHANGE_FAILURE_REASON_UNKNOWN',
  DeliveryRouteChangeFailureReasonVersionConflict = 'DELIVERY_ROUTE_CHANGE_FAILURE_REASON_VERSION_CONFLICT'
}

/** Reasons for delivery failures. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderFailureReason {
  DeliveryRouteOrderFailureReasonAskedToWait = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_ASKED_TO_WAIT',
  DeliveryRouteOrderFailureReasonCustomerNoAnswer = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_CUSTOMER_NO_ANSWER',
  DeliveryRouteOrderFailureReasonCustomerReusedOrCanceled = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_CUSTOMER_REUSED_OR_CANCELED',
  DeliveryRouteOrderFailureReasonIncorrectAddress = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_INCORRECT_ADDRESS',
  DeliveryRouteOrderFailureReasonUnknown = 'DELIVERY_ROUTE_ORDER_FAILURE_REASON_UNKNOWN'
}

/** Order delivery statuses. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderState {
  DeliveryRouteOrderStateAssigned = 'DELIVERY_ROUTE_ORDER_STATE_ASSIGNED',
  /** Order was canceled after the driver left the store, but wasn't marked as failed */
  DeliveryRouteOrderStateCanceled = 'DELIVERY_ROUTE_ORDER_STATE_CANCELED',
  DeliveryRouteOrderStateDelivered = 'DELIVERY_ROUTE_ORDER_STATE_DELIVERED',
  DeliveryRouteOrderStateDelivering = 'DELIVERY_ROUTE_ORDER_STATE_DELIVERING',
  DeliveryRouteOrderStateFailed = 'DELIVERY_ROUTE_ORDER_STATE_FAILED',
  DeliveryRouteOrderStateOnVehicle = 'DELIVERY_ROUTE_ORDER_STATE_ON_VEHICLE',
  DeliveryRouteOrderStatePendingDeliveryReattempt = 'DELIVERY_ROUTE_ORDER_STATE_PENDING_DELIVERY_REATTEMPT',
  DeliveryRouteOrderStatePicking = 'DELIVERY_ROUTE_ORDER_STATE_PICKING',
  DeliveryRouteOrderStateStaged = 'DELIVERY_ROUTE_ORDER_STATE_STAGED',
  DeliveryRouteOrderStateUnknown = 'DELIVERY_ROUTE_ORDER_STATE_UNKNOWN'
}

/** Failure response after attempting to update a partner bulk delivery route */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteUpdateFailure = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_DeliveryRouteUpdateFailure';
  failedOrderDeliveryIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  failureReason?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteChangeFailureReason>;
};

/** A delivery route with its associated issue scenarios. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteWithIssues = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_DeliveryRouteWithIssues';
  /** The delivery route details */
  deliveryRoute?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoute>;
  /** Issue scenarios affecting this route */
  scenarios?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryIssueScenario>>>;
  /** Shift information associated with this delivery route */
  shift?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerManagedShift>;
};

/** Request message for retrieving bulk delivery configurations for multiple locations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListRequest_Input = {
  /** The retailer ID to fetch configurations for */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer location IDs to fetch configurations for */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response message containing bulk delivery configurations for multiple locations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsListResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryConfigurationsListResponse';
  /** Configurations for each requested retailer location */
  configurations?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryConfigurationsEntry>>>;
};

/** Request message for retrieving bulk delivery configurations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsRequest_Input = {
  /** The retailer ID to fetch configurations for */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer location ID to fetch configurations for */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing bulk delivery configurations. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryConfigurationsResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryConfigurationsResponse';
  /** Maximum number of orders allowed per route */
  maxOrdersPerRoute?: Maybe<Scalars['Int']>;
  /** Whether partner bulk delivery is enabled for this retailer location */
  partnerBulkDeliveryEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of hours before route start time that manual edits are allowed */
  routeEditLeadTimeHours?: Maybe<Scalars['Int']>;
};

/** Request message for retrieving partner bulk delivery issues at a retailer location. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryIssuesRequest_Input = {
  /** The date to fetch issues for */
  date?: InputMaybe<Google_Type_Date_Input>;
  /** The retailer location ID to fetch issues for */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing delivery routes with detected issues. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryIssuesResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryIssuesResponse';
  /** Delivery routes that have active issues */
  deliveryRoutesWithIssues?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteWithIssues>>>;
};

/** Request message for retrieving an overview of order statuses for a retailer location on a given date. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewRequest_Input = {
  /** The date to fetch the overview for */
  date?: InputMaybe<Google_Type_Date_Input>;
  /** The retailer location ID to fetch the overview for */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing order status counts. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryOrderOverviewResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryOrderOverviewResponse';
  /** Order counts grouped by delivery route order state */
  orderStatusCounts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderStatusCount>>>;
};

/** Request message for retrieving a list of partner bulk delivery routes. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListRequest_Input = {
  /** The date to fetch routes for */
  date?: InputMaybe<Google_Type_Date_Input>;
  /** Pagination information */
  pagination?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationInfo_Input>;
  /** The retailer location ID to filter routes by */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of bulk delivery routes */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteListResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryRouteListResponse';
  /** List of delivery routes with associated shift information */
  deliveryRouteShifts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteShift>>>;
  /** Pagination information for the response */
  pagination?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationResponse>;
};

/** Request message for retrieving detailed information about a single delivery route. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteRequest_Input = {
  /** The delivery route ID (batch_id) */
  batchId?: InputMaybe<Scalars['BigInt']>;
  /** The retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing detailed route information with orders. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetPartnerBulkDeliveryRouteResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetPartnerBulkDeliveryRouteResponse';
  /** Route and shift information */
  routeShift?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteShift>;
  /** Orders sorted in intended delivery sequence */
  sortedOrders?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryOrder>>>;
  /** Store address information */
  storeAddress?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_AddressInformation>;
};

/** Filter criteria for querying warehouse location vehicles. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListFilter_Input = {
  status?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_VehicleStatus>;
};

/** Request message for retrieving a list of warehouse location vehicles. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListRequest_Input = {
  filter?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListFilter_Input>;
  pagination?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationInfo_Input>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of warehouse location vehicles. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_GetWarehouseLocationVehicleListResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_GetWarehouseLocationVehicleListResponse';
  pagination?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationResponse>;
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** Destination options for transferred order deliveries */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransferDestination {
  /** Transfer to a specific route/device identified by target_batch_id */
  OrderDeliveryTransferDestinationDevice = 'ORDER_DELIVERY_TRANSFER_DESTINATION_DEVICE',
  /**
   * Unassign orders from this route, and let batching service automatically
   * decide what to do with them
   */
  OrderDeliveryTransferDestinationInstacart = 'ORDER_DELIVERY_TRANSFER_DESTINATION_INSTACART',
  OrderDeliveryTransferDestinationUnknown = 'ORDER_DELIVERY_TRANSFER_DESTINATION_UNKNOWN'
}

/** Defines a transfer operation for a group of order deliveries */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransfers_Input = {
  /** Where these order deliveries should be transferred */
  destination?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransferDestination>;
  /** The order delivery IDs to transfer out of the current route */
  orderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Target batch/route ID (required when destination = DEVICE)
   * The route receiving these transferred orders
   */
  targetBatchId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Target route version (required when destination = DEVICE)
   * Version of the receiving route for consistency validation
   */
  targetRouteVersion?: InputMaybe<Scalars['BigInt']>;
};

/** Order count for a specific order state. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderStatusCount = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_OrderStatusCount';
  /** Number of orders in this state */
  count?: Maybe<Scalars['Int']>;
  /** The delivery route order state */
  deliveryRouteOrderState?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderState>;
};

/** Pagination information for requests */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Pagination information for responses */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PaginationResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PaginationResponse';
  /** Cursor for the next page */
  after?: Maybe<Scalars['String']>;
  /** Whether there are more results available */
  hasNext?: Maybe<Scalars['Boolean']>;
};

/** A single entry in the bulk delivery configurations list response. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryConfigurationsEntry = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryConfigurationsEntry';
  /** Maximum number of orders allowed per route */
  maxOrdersPerRoute?: Maybe<Scalars['Int']>;
  /**
   * When editing a route and transferring orders to target devices, the maximum number
   * of unique target devices in a single edit session
   */
  maxTargetDevicesPerEditSession?: Maybe<Scalars['Int']>;
  /** Whether partner bulk delivery is enabled for this retailer location */
  partnerBulkDeliveryEnabled?: Maybe<Scalars['Boolean']>;
  /** The retailer location ID this configuration applies to */
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  /** Number of hours before route start time that manual edits are allowed */
  routeEditLeadTimeHours?: Maybe<Scalars['Int']>;
};

/** A wrapper for a single issue scenario affecting a delivery route. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryIssueScenario = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryIssueScenario';
  /** The delivery batch has not been accepted past the shift start time */
  driverDelayedScenario?: Maybe<Scalars['instacart_enterprise_frigate_delivery_software_v1_DriverDelayedScenario']>;
  /** Orders in the route have not been staged for pickup */
  pickingDelayedScenario?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PickingDelayedScenario>;
};

/** Represents a single order in a delivery route. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryOrder = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryOrder';
  /** Actual delivery time (null if not yet delivered) */
  actualDeliveryTime?: Maybe<Scalars['DateTime']>;
  /** Client configuration ID for the order */
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Country ID for the order */
  countryId?: Maybe<Scalars['BigInt']>;
  /** Customer delivery address */
  customerAddress?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_AddressInformation>;
  /** Customer name */
  customerName?: Maybe<Scalars['String']>;
  /**
   * Delivery contact attempts for this order, sorted by created_at ascending.
   * Empty if no attempts were made.
   */
  deliveryAttempts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryAttempt>>>;
  /** Deprecated: use delivery_failures instead. */
  deliveryFailureReason?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderFailureReason>;
  /**
   * Delivery failure records for this order, sorted by not_delivered_at ascending.
   * Populated when delivery_route_order_state is FAILED.
   */
  deliveryFailures?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryFailure>>>;
  /** Current status of the order delivery */
  deliveryRouteOrderState?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteOrderState>;
  /** Unique identifier for the order delivery */
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  /** Unique identifier for the order */
  orderId?: Maybe<Scalars['BigInt']>;
  /** Number of packages staged for this order. If the order is not staged yet, this value will be the estimated number of packages. */
  packageCount?: Maybe<Scalars['Int']>;
  /** Planned delivery time when the batch is created */
  plannedDeliveryEta?: Maybe<Scalars['DateTime']>;
  /** Real-time delivery ETA after delivery starts, computed based on shopper location. */
  realtimeDeliveryEta?: Maybe<Scalars['DateTime']>;
  /** Store configuration ID for the order */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  /** End of delivery window */
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  /** Start of delivery window */
  windowStartsAt?: Maybe<Scalars['DateTime']>;
};

/** Represents a single bulk delivery route with associated metadata. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoute = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRoute';
  /** non-canceled total order count for the route. may be null if no orders are assigned yet */
  activeOrderCount?: Maybe<Scalars['Int']>;
  /** List of allowed edit actions for this route */
  allowedRouteEditActions?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkRouteEditAction>>>;
  /** delivery routes are modeled as delivery batches. batch_id is the unique identifier for a delivery route. */
  batchId?: Maybe<Scalars['BigInt']>;
  /** same as warehouse_location_id. Assuming a delivery route always have an associated warehouse location */
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  /** Will be shown as a percentage on IPP. may be null if no orders are assigned yet */
  routeCapacityUsed?: Maybe<Scalars['Int']>;
  /** whether the route has been manually edited */
  routeManuallyEdited?: Maybe<Scalars['Boolean']>;
  /** Planned completion time for the route */
  routePlannedCompletionTime?: Maybe<Scalars['DateTime']>;
  /** Planned start time for the route */
  routePlannedStartTime?: Maybe<Scalars['DateTime']>;
  /** Current status of the route */
  routeStatus?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteStatus>;
  /** Version number for optimistic concurrency control */
  routeVersion?: Maybe<Scalars['BigInt']>;
  /** The total (estimated) package count across all active orders on the route. */
  totalPackageCount?: Maybe<Scalars['Int']>;
  /** Raw package capacity of the vehicle assigned to this route. */
  vehicleCapacity?: Maybe<Scalars['Int']>;
};

/** Delivery route with associated shift information. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteShift = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkDeliveryRouteShift';
  /** The delivery route details */
  deliveryRoute?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRoute>;
  /** Shift information associated with this delivery route. Needed as we are displaying shift information on the delivery routes page */
  shift?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerManagedShift>;
};

export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryRouteStatus {
  PartnerBulkDeliveryRouteStatusCanceled = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_CANCELED',
  PartnerBulkDeliveryRouteStatusCompleted = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_COMPLETED',
  PartnerBulkDeliveryRouteStatusDelivering = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_DELIVERING',
  PartnerBulkDeliveryRouteStatusLoadingVehicle = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_LOADING_VEHICLE',
  PartnerBulkDeliveryRouteStatusPlanned = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_PLANNED',
  PartnerBulkDeliveryRouteStatusUnknown = 'PARTNER_BULK_DELIVERY_ROUTE_STATUS_UNKNOWN'
}

/** A single delivery attempt for a partner bulk order. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryAttempt = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkOrderDeliveryAttempt';
  /** Timestamp when this attempt was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Customer's response to the contact attempt. */
  customerResponse?: Maybe<Instacart_Fulfillment_Shared_V1_CustomerResponse>;
};

/** A delivery failure record for a partner bulk order. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkOrderDeliveryFailure = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerBulkOrderDeliveryFailure';
  /** Timestamp when the delivery was marked as not delivered. */
  notDeliveredAt?: Maybe<Scalars['DateTime']>;
  /** The reason the delivery was not completed. */
  reason?: Maybe<Instacart_Fulfillment_Shared_V1_NotDeliveredReason>;
};

export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkRouteEditAction {
  PartnerBulkRouteEditActionAddOrder = 'PARTNER_BULK_ROUTE_EDIT_ACTION_ADD_ORDER',
  /** Indicates the route can be deactivated (canceled). */
  PartnerBulkRouteEditActionDeactivate = 'PARTNER_BULK_ROUTE_EDIT_ACTION_DEACTIVATE',
  PartnerBulkRouteEditActionRemoveOrder = 'PARTNER_BULK_ROUTE_EDIT_ACTION_REMOVE_ORDER',
  PartnerBulkRouteEditActionShuffle = 'PARTNER_BULK_ROUTE_EDIT_ACTION_SHUFFLE',
  PartnerBulkRouteEditActionUnknown = 'PARTNER_BULK_ROUTE_EDIT_ACTION_UNKNOWN'
}

/** Information about the shift associated with delivery routes. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerManagedShift = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PartnerManagedShift';
  /** Shopper/driver phone number */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Shift end time */
  shiftEndsAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for the shift */
  shiftId?: Maybe<Scalars['BigInt']>;
  /** Shift start time */
  shiftStartsAt?: Maybe<Scalars['DateTime']>;
  /** Shopper/driver ID assigned to the shift */
  shopperId?: Maybe<Scalars['BigInt']>;
  /** Shopper/driver name */
  shopperName?: Maybe<Scalars['String']>;
};

/** Scenario when orders in a delivery route have picking delays. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_PickingDelayedScenario = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_PickingDelayedScenario';
  /** Orders that have not been staged for pickup */
  orders?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_PartnerBulkDeliveryOrder>>>;
};

/** Request to update a partner bulk delivery route with reordering and/or transfers */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdatePartnerBulkDeliveryRouteRequest_Input = {
  /** Authorization context of the IPP user making the request */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** The batch/route ID being edited (delivery routes are modeled as delivery batches) */
  batchId?: InputMaybe<Scalars['BigInt']>;
  /**
   * The final order sequence after all edits (reordering)
   * Contains all order_delivery_ids that should remain on this route
   * Order matters: first ID = first delivery, last ID = last delivery
   */
  finalRouteOrderDeliveryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Current route version for optimistic concurrency control
   * Backend will reject the request if this doesn't match the current version
   */
  routeVersion?: InputMaybe<Scalars['BigInt']>;
  /** List of transfer operations to move orders off this route */
  transfers?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_OrderDeliveryTransfers_Input>>>;
};

/** Response after attempting to update a partner bulk delivery route */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdatePartnerBulkDeliveryRouteResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_UpdatePartnerBulkDeliveryRouteResponse';
  failure?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_DeliveryRouteUpdateFailure>;
  success?: Maybe<Scalars['instacart_enterprise_frigate_delivery_software_v1_DeliveryRouteUpdateSuccess']>;
};

/** Request message for updating an existing warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleRequest_Input = {
  /** Authorization context of the IPP user making the request. */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  capacityAmount?: InputMaybe<Scalars['Int']>;
  capacityUnit?: InputMaybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  color?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  licensePlate?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for updating a warehouse location vehicle. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_UpdateWarehouseLocationVehicleResponse = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_UpdateWarehouseLocationVehicleResponse';
  vehicle?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle>;
};

/** Status filter for querying vehicles. */
export enum Instacart_Enterprise_Frigate_Delivery_Software_V1_VehicleStatus {
  VehicleStatusActive = 'VEHICLE_STATUS_ACTIVE',
  VehicleStatusInactive = 'VEHICLE_STATUS_INACTIVE',
  VehicleStatusUnknown = 'VEHICLE_STATUS_UNKNOWN'
}

/** Represents a vehicle associated with a warehouse location. */
export type Instacart_Enterprise_Frigate_Delivery_Software_V1_WarehouseLocationVehicle = {
  __typename?: 'instacart_enterprise_frigate_delivery_software_v1_WarehouseLocationVehicle';
  capacityAmount?: Maybe<Scalars['Int']>;
  capacityUnit?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  isActive?: Maybe<Scalars['Boolean']>;
  licensePlate?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Information about the delivery or pickup address. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_AddressInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AddressInformation';
  city?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Google_Type_LatLng>;
  state?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  unitNumber?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  /** Items permitted for refund processing. */
  permitted?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** User ID. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AdjustDashboardOrderResponse';
  /** TODO(FUL-174701): deprecate after downstream migration */
  isSuccess?: Maybe<Scalars['Boolean']>;
  operation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AdjustmentNotPermitted';
  /** List of denial policy IDs. */
  denialPolicyIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Reason why refund is not permitted. */
  reason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted_Reason {
  AdjustmentRequestPreviouslyProcessed = 'ADJUSTMENT_REQUEST_PREVIOUSLY_PROCESSED',
  BusinessEntityNotAuthorized = 'BUSINESS_ENTITY_NOT_AUTHORIZED',
  FailedIncompatibleStateChange = 'FAILED_INCOMPATIBLE_STATE_CHANGE',
  LineAdjustmentAmountsConflictWithCurrentState = 'LINE_ADJUSTMENT_AMOUNTS_CONFLICT_WITH_CURRENT_STATE',
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_AdjustmentPermitted';
  /** Adjustment input. */
  adjustmentInput?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput>;
  /** List of approval policy IDs. */
  approvalPolicyIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted_Input = {
  /** Adjustment input. */
  adjustmentInput?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput_Input>;
  /** List of approval policy IDs. */
  approvalPolicyIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  description?: InputMaybe<Scalars['String']>;
  /** OrderCancellationPolicyInput from GetOrderCancellationPolicyListResponse */
  orderCancellationPolicyInput?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput_Input>;
  /** OrderChange token from GetOrderCancellationPolicyListResponse. Optional for certain policy inputs. */
  orderChangeToken?: InputMaybe<Scalars['String']>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer App ID. */
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_CancelDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_CancelDashboardOrderResponse';
  /** TODO(FUL-174701): deprecate after downstream migration */
  isSuccess?: Maybe<Scalars['Boolean']>;
  operation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** Context information about the customer's environment. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerContext = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_CustomerContext';
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  countryId?: Maybe<Scalars['BigInt']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
};

/** Information about the customer who placed the order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_CustomerInformation';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  /** Actual id for the loyalty card: orders may store one or both */
  loyaltyCardId?: Maybe<Scalars['BigInt']>;
  /** Alternately called loyalty_card_number, but can technically be a string */
  loyaltyIdentifier?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrder = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardOrder';
  /** Information about the address. */
  addressInformation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AddressInformation>;
  /** Customer context. Do we need this? */
  customerContext?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerContext>;
  /** Information about the customer. */
  customerInformation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_CustomerInformation>;
  /** The external ID. */
  externalId?: Maybe<Scalars['String']>;
  /** Fulfillment metadata. */
  fulfillmentDetails?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_FulfillmentDetails>;
  /** The tip amount from the latest invoice. */
  latestTip?: Maybe<GoogleTypeMoney>;
  /** The tip amount from the latest invoice, string-formatted. */
  latestTipFormatted?: Maybe<Scalars['String']>;
  loyaltyInformation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_LoyaltyInformation>;
  /** Details about the cancellation. */
  orderCancellationDetails?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails>;
  /** Photos of the order delivery's dropoff. */
  orderDeliveryPhotoList?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhotoList>;
  /** Events about the order lifecycle */
  orderHistoryEvents?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent>>>;
  orderId?: Maybe<Scalars['BigInt']>;
  orderState?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderState>;
  /** Information about the shopper. */
  shopperInformation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_ShopperInformation>;
  /** The timezone of the sender. */
  timezone?: Maybe<Scalars['String']>;
  /** The user ID. */
  userId?: Maybe<Scalars['BigInt']>;
};

/** The following are mirrored from orders_service.proto */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input = {
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_CreationDateScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  creationDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_FulfillmentDateScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  fulfillmentDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** TODO: rename to fulfillment_date_range */
  windowEndsAtRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Scenario parameter is used to indicate the type of search criterias applied */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  creationDateScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_CreationDateScenario_Input>;
  fulfillmentDateScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_FulfillmentDateScenario_Input>;
  loyaltySearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_LoyaltySearchScenario_Input>;
  orderDeliveryIdScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderDeliveryIdScenario_Input>;
  orderIdScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderIdScenario_Input>;
  ordersSortBy?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Input>;
  /** TODO(FUL-174701): fully deprecate once downstreams are migrated to Pagination */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  paginationInfo?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_PaginationInfo_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  userIdScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_UserIdScenario_Input>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria {
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Delivering = 'DELIVERING',
  IppOrderStatusCriteriaUnspecified = 'IPP_ORDER_STATUS_CRITERIA_UNSPECIFIED',
  New = 'NEW',
  Processing = 'PROCESSING',
  ReadyForPickup = 'READY_FOR_PICKUP',
  Shopping = 'SHOPPING'
}

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType {
  Delivery = 'DELIVERY',
  IppOrderTypeUnspecified = 'IPP_ORDER_TYPE_UNSPECIFIED',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  Pickup = 'PICKUP'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_LoyaltySearchScenario_Input = {
  creationDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  fulfillmentDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  loyaltyId?: InputMaybe<Scalars['BigInt']>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderDeliveryIdScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrderIdScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  orderIdentifier?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Direction {
  Asc = 'ASC',
  Desc = 'DESC',
  DirectionUnspecified = 'DIRECTION_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Input = {
  direction?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_Direction>;
  name?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_OrdersAttributes>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_OrdersSortBy_OrdersAttributes {
  OrdersAttributesUnspecified = 'ORDERS_ATTRIBUTES_UNSPECIFIED',
  OrderDeliveryId = 'ORDER_DELIVERY_ID',
  WindowEndsAt = 'WINDOW_ENDS_AT'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_UserIdScenario_Input = {
  adminRequestContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_AdminRequestContext_Input>;
  creationDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  fulfillmentDateRange?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input>;
  orderStatusCriteria?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderStatusCriteria>>>;
  orderType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListRequest_IppOrderType>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardOrderSearchResultListResponse';
  /** TODO(FUL-174701): deprecate for `pagination` */
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  paginationInfo?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse_PaginationInfo>;
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrderSearchResultListResponse_PaginationInfo = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardOrderSearchResultListResponse_PaginationInfo';
  /** The last cursor of the current page */
  after?: Maybe<Scalars['String']>;
  /** Indicates if there is a next page */
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

/**
 * A subset or Order that is used for search results on IPP order search page
 * TODO: rename to DashboardOrderSearchResult
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_DashboardSearchOrder';
  checkoutRetailerLocationId?: Maybe<Scalars['BigInt']>;
  clientConfigurationId?: Maybe<Scalars['BigInt']>;
  /** From Order.communication_locale */
  communicationLocale?: Maybe<Scalars['String']>;
  countryId?: Maybe<Scalars['BigInt']>;
  customerName?: Maybe<Scalars['String']>;
  /** From Order.fulfillment_window.window_start */
  fulfillmentDate?: Maybe<Scalars['DateTime']>;
  legacyOrderId?: Maybe<Scalars['BigInt']>;
  loyaltyInformation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_LoyaltyInformation>;
  /** From Order.creation_date */
  orderDate?: Maybe<Scalars['DateTime']>;
  orderId?: Maybe<Scalars['BigInt']>;
  orderReference?: Maybe<Scalars['String']>;
  orderState?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderState>;
  orderType?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder_OrderType>;
  plannedDeliveredAt?: Maybe<Scalars['DateTime']>;
  retailerExternalOrderId?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerProvidedBagsCount?: Maybe<Scalars['Int']>;
  retailerReferenceId?: Maybe<Scalars['String']>;
  shoppedRetailerLocationId?: Maybe<Scalars['BigInt']>;
  /** Mapped Order.workflow_state */
  status?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  timezone?: Maybe<Scalars['String']>;
  totalCharge?: Maybe<GoogleTypeMoney>;
  userId?: Maybe<Scalars['BigInt']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardSearchOrder_OrderType {
  Delivery = 'DELIVERY',
  Instore = 'INSTORE',
  LastMileDelivery = 'LAST_MILE_DELIVERY',
  OrderTypeUnspecified = 'ORDER_TYPE_UNSPECIFIED',
  Pickup = 'PICKUP'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_ForceCompleteDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  description?: InputMaybe<Scalars['String']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Reason the order is being force-completed, selected by the dispatcher in the
   * confirmation modal. Required (UNSPECIFIED is rejected).
   */
  reason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Force_Completes_ForceCompleteReason>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_ForceCompleteDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_ForceCompleteDashboardOrderResponse';
  operation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** Details about order fulfillment. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_FulfillmentDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_FulfillmentDetails';
  addressId?: Maybe<Scalars['BigInt']>;
  estimatedDeliveryTime?: Maybe<Scalars['DateTime']>;
  estimatedPickupTime?: Maybe<Scalars['DateTime']>;
  isAlcoholic?: Maybe<Scalars['Boolean']>;
  numOfBags?: Maybe<Scalars['BigInt']>;
  orderHandlingDetails?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails>;
  previouslyRescheduled?: Maybe<Scalars['Boolean']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  retailerLocationName?: Maybe<Scalars['String']>;
  retailerProvidedAmounts?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_RetailerProvidedAmounts>;
  serviceOptionId?: Maybe<Scalars['BigInt']>;
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  windowStartsAt?: Maybe<Scalars['DateTime']>;
};

/** Request to get a dashboard order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** also known as `warehouse_id` internally */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing a dashboard order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetDashboardOrderResponse';
  dashboardOrder?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_DashboardOrder>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListRequest_Input = {
  /** Adjustment input. */
  adjustmentInput?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput_Input>;
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** User ID. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderAdjustmentPolicyListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderAdjustmentPolicyListResponse';
  /** Result of adjustment request. */
  result?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicy>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer App ID. */
  retailerAppId?: InputMaybe<Scalars['BigInt']>;
  /** Optional user ID to speed up Orders sharded query. */
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderCancellationPolicyListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderCancellationPolicyListResponse';
  /** The list of OrderCancellationPolicies. */
  cancellationPolicies?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy>>>;
  /**
   * Force-complete ("Mark as complete") eligibility for the order. Unlike the
   * cancellation/reschedule policies (sourced from the upstream ICApp
   * order-change policy API), this is computed within Frigate from the order's
   * state, since the upstream API does not model force-complete. Unset when the
   * caller does not request it or it cannot be determined.
   */
  forceCompletePolicy?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy>;
  /** OrderChange policy token. */
  orderChangeToken?: Maybe<Scalars['String']>;
  /** The list of ReschedulePolicies. */
  reschedulePolicies?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy>>>;
  /**
   * The list of OrderCancellationPolicies.
   * TODO(FUL-174701): deprecated naming: use `cancellation_policies` instead.
   */
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListRequest_Input = {
  orderReference?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderLineListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderLineListResponse';
  results?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetOrderStateChangeListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetOrderStateChangeListResponse';
  /** tracks the current order fulfillment state change */
  currentOrderFulfillmentStateChange?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange>;
  /** tracks the current return state change (if the order has returns) */
  currentOrderReturnStateChange?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange>;
  orderFulfillmentStateGroups?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup>>>;
  orderReturnStateGroups?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup>>>;
};

/** Request for getting retailer product details */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Input = {
  /** Combined request parameters */
  parameters?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Parameters_Input>;
  /**
   * Metadata for the request
   * TODO(FUL-174701): deprecate for `request_metadata`
   */
  requestMeta?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_RequestMeta_Input>;
  /** Metadata for the request */
  requestMetadata?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Input>;
};

/** Query parameters for retrieving retailer product details. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsRequest_Parameters_Input = {
  /** TODO(FUL-174701): deprecate for `client_source_type` */
  clientSourceType?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Catalog_V1_ClientSourceType>;
  codeType?: InputMaybe<Instacart_Customers_Product_Retrieval_V1_Catalog_V1_CodeType>;
  /**
   * List of input codes (e.g., RRCS/Input)
   * TODO(FUL-174701): deprecate for `code_type`
   */
  codes?: InputMaybe<Scalars['String']>;
  /** Optional flag, defaults to false */
  favorEscpCodes?: InputMaybe<Scalars['Boolean']>;
  /** Client source */
  productClientSourceType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ClientSourceType>;
  /** Type of the code (e.g., RETAILER_REFERENCE_CODE) */
  productCodeType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_CodeType>;
  /** Retailer ID */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing retailer product details */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetRetailerProductDetailsResponse';
  /** List of products with complete details */
  products?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse_RetailerProductDetail>>>;
  /**
   * Metadata for the response
   * TODO(FUL-174701): deprecate for `response_metadata`
   */
  responseMeta?: Maybe<Instacart_Customers_Product_Retrieval_V1_ResponseMeta>;
  responseMetadata?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata>;
};

/** Detailed information about a single retailer product. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_GetRetailerProductDetailsResponse_RetailerProductDetail = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_GetRetailerProductDetailsResponse_RetailerProductDetail';
  /** URL of the product image */
  imageUrl?: Maybe<Scalars['String']>;
  /** Name of the product */
  name?: Maybe<Scalars['String']>;
  /** Product ID from matching logic */
  productId?: Maybe<Scalars['BigInt']>;
  /** Retailer's Reference Code */
  rrc?: Maybe<Scalars['String']>;
  /** Universal Product Code */
  upc?: Maybe<Scalars['String']>;
};

/** Information about customer loyalty programs. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_LoyaltyInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_LoyaltyInformation';
  /** numeric id stored in orders */
  loyaltyCardId?: Maybe<Scalars['BigInt']>;
  /** e.g., printed/program number or identifier string */
  loyaltyIdentifier?: Maybe<Scalars['String']>;
};

/** Refund reason for a not-found item, as reported by the store manager. */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRefundReason {
  MarkOrderItemStatusRefundReasonNotCarried = 'MARK_ORDER_ITEM_STATUS_REFUND_REASON_NOT_CARRIED',
  MarkOrderItemStatusRefundReasonOther = 'MARK_ORDER_ITEM_STATUS_REFUND_REASON_OTHER',
  MarkOrderItemStatusRefundReasonOutOfStock = 'MARK_ORDER_ITEM_STATUS_REFUND_REASON_OUT_OF_STOCK',
  MarkOrderItemStatusRefundReasonUnspecified = 'MARK_ORDER_ITEM_STATUS_REFUND_REASON_UNSPECIFIED'
}

/** Request to mark an individual order item as found or not found. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  markFound?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRequest_MarkFound_Input>;
  markNotFound?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRequest_MarkNotFound_Input>;
  /** The order this item belongs to. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  /** The specific item being marked. */
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

/** Item was located in the store. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRequest_MarkFound_Input = {
  /** Quantity the associate confirmed (whole units). */
  deliveredQuantity?: InputMaybe<Scalars['BigInt']>;
  /** Weight in store units for variable-weight items; omit for unit-priced items. */
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  /** When the item was picked. */
  pickedAt?: InputMaybe<Scalars['DateTime']>;
};

/** Item could not be located in the store. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRequest_MarkNotFound_Input = {
  /** When the item was marked not found. */
  markedAt?: InputMaybe<Scalars['DateTime']>;
  /** How the customer will be refunded. */
  refundReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusRefundReason>;
};

/** Response after marking an order item's status. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_MarkOrderItemStatusResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_MarkOrderItemStatusResponse';
  /** ID of the item that was updated. */
  orderItemId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentDetails';
  /** Individual item refunds. */
  basketContext?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext>;
  /** Funds destination preference. */
  fundsDestinationPreference?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_FundsDestinationPreference>;
};

/** Individual item adjustment context. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentDetails_BasketContext';
  basketAdjustmentDetails?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails';
  /** The quantity expected after applying the requested adjustment. */
  expectedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  /** Order line ID. */
  orderLineId?: Maybe<Scalars['BigInt']>;
  /** Reason for the adjustment. Required in AdjustDashboardOrderRequest. */
  reason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason>;
  /** The requested quantity to be adjusted. */
  requestedAdjustmentQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails_Input = {
  /** The quantity expected after applying the requested adjustment. */
  expectedQuantity?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  /** Order line ID. */
  orderLineId?: InputMaybe<Scalars['BigInt']>;
  /** Reason for the adjustment. Required in AdjustDashboardOrderRequest. */
  reason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Input>;
  /** The requested quantity to be adjusted. */
  requestedAdjustmentQuantity?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
};

/** Individual item adjustment context. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_Input = {
  basketAdjustmentDetails?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_BasketAdjustmentDetails_Input>>>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_FundsDestinationPreference {
  FundsDestinationUnspecified = 'FUNDS_DESTINATION_UNSPECIFIED',
  OnlyOriginalPaymentMethod = 'ONLY_ORIGINAL_PAYMENT_METHOD',
  PreferInternalCredits = 'PREFER_INTERNAL_CREDITS'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_Input = {
  /** Individual item refunds. */
  basketContext?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_BasketContext_Input>;
  /** Funds destination preference. */
  fundsDestinationPreference?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_FundsDestinationPreference>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentInput';
  adjustmentDetails?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentInput_Input = {
  adjustmentDetails?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentDetails_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentPolicy';
  notPermitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentNotPermitted>;
  permitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_AdjustmentPermitted>;
  reasons?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderAdjustmentPolicyReason';
  label?: Maybe<Scalars['String']>;
  reason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Reason>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Input = {
  label?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderAdjustmentPolicyReason_Reason {
  ReasonCustomerIdVerificationFailed = 'REASON_CUSTOMER_ID_VERIFICATION_FAILED',
  ReasonDamagedOrPoorQualityItem = 'REASON_DAMAGED_OR_POOR_QUALITY_ITEM',
  ReasonMissingItem = 'REASON_MISSING_ITEM',
  ReasonPoorReplacement = 'REASON_POOR_REPLACEMENT',
  ReasonUnspecified = 'REASON_UNSPECIFIED',
  ReasonWrongItemOrAmount = 'REASON_WRONG_ITEM_OR_AMOUNT'
}

/** Details about an order cancellation. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationDetails';
  /** TODO(FUL-174701): deprecate for `order_cancellation_category` */
  cancellationCategory?: Maybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationCategory>;
  cancellationOrigin?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails_CancellationOrigin>;
  /** TODO(FUL-174701): deprecate for `order_cancellation_type` */
  cancellationType?: Maybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationType>;
  orderCancellationCategory?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationCategory>;
  orderCancellationType?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationDetails_CancellationOrigin {
  Customer = 'CUSTOMER',
  Instacart = 'INSTACART',
  Other = 'OTHER',
  Retailer = 'RETAILER',
  Shopper = 'SHOPPER'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicy';
  /** Selection details. */
  inputs?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput>>>;
  notPermitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted>;
  permitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_Permitted>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicyInput';
  /**
   * https://github.com/instacart/carrot/blob/e48992991a1c6a1a850511251ae7965a9ab19b39/shared/protos/instacart/customers/commerce/types/v1/order_cancellations.proto#L140
   * TODO(FUL-174701): deprecate for `order_cancellation_reason`
   */
  customerReason?: Maybe<Instacart_Customers_Commerce_Types_V1_CustomerCancelReason_CustomerReason>;
  label?: Maybe<Scalars['String']>;
  orderCancellationReason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason>;
  orderCancellationType?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType>;
  /** TODO(FUL-174701): deprecate for `order_cancellation_type` */
  reasonType?: Maybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationType>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicyInput_Input = {
  /**
   * https://github.com/instacart/carrot/blob/e48992991a1c6a1a850511251ae7965a9ab19b39/shared/protos/instacart/customers/commerce/types/v1/order_cancellations.proto#L140
   * TODO(FUL-174701): deprecate for `order_cancellation_reason`
   */
  customerReason?: InputMaybe<Instacart_Customers_Commerce_Types_V1_CustomerCancelReason_CustomerReason>;
  label?: InputMaybe<Scalars['String']>;
  orderCancellationReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_Input>;
  orderCancellationType?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType>;
  /** TODO(FUL-174701): deprecate for `order_cancellation_type` */
  reasonType?: InputMaybe<Instacart_Customers_Commerce_Types_V1_OrderCancellationType>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicy_NotPermitted';
  /** Reason not permitted. Defaults to UNKNOWN. */
  reason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_NotPermitted_Reason {
  ReasonUnspecified = 'REASON_UNSPECIFIED',
  /** if an unrecognized reason is added upstream, it will be converted to UNKNOWN */
  Unknown = 'UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderCancellationPolicy_Permitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderCancellationPolicy_Permitted';
  /** Fees associated with the action. */
  cancelFee?: Maybe<GoogleTypeMoney>;
  /** When true, requires a customer_cancel_reason with input. */
  isCustomerCancelReasonRequired?: Maybe<Scalars['Boolean']>;
};

/** A photo taken during order delivery. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhoto = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderDeliveryPhoto';
  id?: Maybe<Scalars['BigInt']>;
  photoUrl?: Maybe<Scalars['String']>;
};

/** A list of photos taken during order delivery. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhotoList = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderDeliveryPhotoList';
  areOrderDeliveryPhotosExpired?: Maybe<Scalars['Boolean']>;
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderDeliveryPhoto>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderForceCompletePolicy';
  /** Not permitted action result. */
  notPermitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy_NotPermitted>;
  /** Permitted action result. */
  permitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy_Permitted>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy_NotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderForceCompletePolicy_NotPermitted';
  /** Reason not permitted. Defaults to REASON_UNSPECIFIED. */
  reason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy_NotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy_NotPermitted_Reason {
  /**
   * The order is not in transit; only Delivering orders can be
   * force-completed today.
   */
  OrderNotInTransit = 'ORDER_NOT_IN_TRANSIT',
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderForceCompletePolicy_Permitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderForceCompletePolicy_Permitted';
  /**
   * Reserved for future use (e.g. requiring a force-complete reason once more
   * than one reason is supported). Always false today, since the single
   * supported reason is applied automatically.
   */
  isReasonRequired?: Maybe<Scalars['Boolean']>;
};

/** Details about how an order should be handled. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHandlingDetails';
  acceptableRetailerLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Delivery to customer. */
  delivery?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_DeliveryDetails>;
  /** Pickup from location. */
  pickup?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_PickupDetails>;
  specialRequirements?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Details specific to delivery orders. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_DeliveryDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHandlingDetails_DeliveryDetails';
  address?: Maybe<Google_Type_PostalAddress>;
  addressId?: Maybe<Scalars['BigInt']>;
  addressType?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Google_Type_LatLng>;
  customerManualLatLng?: Maybe<Google_Type_LatLng>;
  doorCode?: Maybe<Scalars['String']>;
  dropoffLocation?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Details specific to pickup orders. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHandlingDetails_PickupDetails = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHandlingDetails_PickupDetails';
  address?: Maybe<Google_Type_PostalAddress>;
  addressId?: Maybe<Scalars['BigInt']>;
  coordinates?: Maybe<Google_Type_LatLng>;
  instructions?: Maybe<Scalars['String']>;
};

/** An event in the order's history. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderHistoryEvent';
  action?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent_OrderHistoryEventAction>;
  actionedAt?: Maybe<Scalars['DateTime']>;
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  windowStartsAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderHistoryEvent_OrderHistoryEventAction {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Delivered = 'DELIVERED',
  Rescheduled = 'RESCHEDULED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList';
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderItem';
  alcoholic?: Maybe<Scalars['Boolean']>;
  externalData?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_OrderItemExternalData>;
  imageUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productCategory?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_ProductCategory>;
  productCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  productId?: Maybe<Scalars['BigInt']>;
  quantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  retailerLookupCode?: Maybe<Scalars['String']>;
  sizeDetails?: Maybe<Scalars['String']>;
  unitPrice?: Maybe<GoogleTypeMoney>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_OrderItemExternalData = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderItem_OrderItemExternalData';
  lineNum?: Maybe<Scalars['String']>;
  retailerRrc?: Maybe<Scalars['String']>;
  retailerUpc?: Maybe<Scalars['String']>;
  scanCode?: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem_ProductCategory = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderItem_ProductCategory';
  l1Category?: Maybe<Scalars['String']>;
  l1CategoryId?: Maybe<Scalars['BigInt']>;
  l2Category?: Maybe<Scalars['String']>;
  l2CategoryId?: Maybe<Scalars['BigInt']>;
  l3Category?: Maybe<Scalars['String']>;
  l3CategoryId?: Maybe<Scalars['BigInt']>;
  l4Category?: Maybe<Scalars['String']>;
  l4CategoryId?: Maybe<Scalars['BigInt']>;
  l5Category?: Maybe<Scalars['String']>;
  l5CategoryId?: Maybe<Scalars['BigInt']>;
  l6Category?: Maybe<Scalars['String']>;
  l6CategoryId?: Maybe<Scalars['BigInt']>;
  productCategory?: Maybe<Scalars['String']>;
  productCategoryId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderLinesList_OrderLine';
  addedByDriverId?: Maybe<Scalars['BigInt']>;
  allowedSubstitution?: Maybe<Scalars['Boolean']>;
  creationDate?: Maybe<Scalars['DateTime']>;
  customerOrderedPrice?: Maybe<GoogleTypeMoney>;
  customerPrice?: Maybe<GoogleTypeMoney>;
  customerSelectedReplacement?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem>;
  fullPrice?: Maybe<GoogleTypeMoney>;
  id?: Maybe<Scalars['BigInt']>;
  item?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem>;
  obfuscatedId?: Maybe<Scalars['String']>;
  orderedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  pickedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  refundQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  refundableQuantities?: Maybe<Array<Maybe<Instacart_Types_V1_MeasuredQuantity>>>;
  replacementPolicy?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_ReplacementPolicy>;
  specialInstructions?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_Status>;
  substitute?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderItem>;
  substitutionStatus?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_SubstitutionStatus>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_ReplacementPolicy {
  NoReplacements = 'NO_REPLACEMENTS',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ShoppersChoice = 'SHOPPERS_CHOICE',
  UsersChoice = 'USERS_CHOICE'
}

/** Mirrored from Orders Service */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_Status {
  DeprecatedApproved = 'DEPRECATED_APPROVED',
  DeprecatedRejected = 'DEPRECATED_REJECTED',
  Found = 'FOUND',
  NotPicked = 'NOT_PICKED',
  Replaced = 'REPLACED',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  ToRefund = 'TO_REFUND'
}

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderLinesList_OrderLine_SubstitutionStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SubstitutionStatusUnspecified = 'SUBSTITUTION_STATUS_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicy';
  /** Selection details. */
  inputs?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicyInput>>>;
  /** Not permitted action result. */
  notPermitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted>;
  /** Permitted action result. */
  permitted?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_Permitted>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicyInput = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicyInput';
  label?: Maybe<Scalars['String']>;
  orderRescheduleReason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Reschedules_OrderRescheduleReason>;
  /** TODO(FUL-174701): deprecate for `order_reschedule_reason` */
  reason?: Maybe<Instacart_Customers_Commerce_Types_V1_SupportRescheduleDeliveryReason>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicy_NotPermitted';
  /** Reason not permitted. Defaults to REASON_UNSPECIFIED. */
  reason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted_Reason>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_NotPermitted_Reason {
  /** Reason not specified. */
  ReasonUnspecified = 'REASON_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderReschedulePolicy_Permitted = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderReschedulePolicy_Permitted';
  /** When true, requires a reschedule_reason with input. */
  isRescheduleReasonRequired?: Maybe<Scalars['Boolean']>;
  /** Fees associated with the action. */
  rescheduleFee?: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderState {
  Acknowledged = 'ACKNOWLEDGED',
  AcknowledgedForDelivery = 'ACKNOWLEDGED_FOR_DELIVERY',
  AcknowledgedForRunning = 'ACKNOWLEDGED_FOR_RUNNING',
  AtStore = 'AT_STORE',
  BagsCheck = 'BAGS_CHECK',
  BagsCheckStaged = 'BAGS_CHECK_STAGED',
  BagsVerified = 'BAGS_VERIFIED',
  BrandNew = 'BRAND_NEW',
  Checkout = 'CHECKOUT',
  Completed = 'COMPLETED',
  Delivering = 'DELIVERING',
  OrderStateUnspecified = 'ORDER_STATE_UNSPECIFIED',
  Picking = 'PICKING',
  ReceiptSanityCheck = 'RECEIPT_SANITY_CHECK',
  RunnerAwaiting = 'RUNNER_AWAITING',
  RunnerNotFound = 'RUNNER_NOT_FOUND',
  Staged = 'STAGED',
  StagedForDelivery = 'STAGED_FOR_DELIVERY',
  VerifyingReplacements = 'VERIFYING_REPLACEMENTS'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateChange';
  /** optional entity directly responsible for the state change */
  actor?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Actor>;
  /** issues that happened at the state transition */
  issues?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Issue>>>;
  /** the display name of the state showed in the UI */
  label?: Maybe<Scalars['String']>;
  /** actual time of the transition */
  transitionedAtActual?: Maybe<Scalars['DateTime']>;
  /** estimated time of the transition */
  transitionedAtEta?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_OrderStateChangeType>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Actor = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateChange_Actor';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_ActorType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_ActorType {
  /** aka "Driver" */
  ActorTypeShopper = 'ACTOR_TYPE_SHOPPER',
  ActorTypeShopperDriver = 'ACTOR_TYPE_SHOPPER_DRIVER',
  ActorTypeShopperPicker = 'ACTOR_TYPE_SHOPPER_PICKER',
  ActorTypeShopperRunner = 'ACTOR_TYPE_SHOPPER_RUNNER',
  ActorTypeUnknown = 'ACTOR_TYPE_UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_Issue = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateChange_Issue';
  /** more details into the issue, mainly used for the tooltip in the UI */
  issueDescription?: Maybe<Scalars['String']>;
  /** field that describes the type of the issue, e.g. "Delayed", "Partially Delivered" */
  issueType?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_IssueType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_IssueType {
  IssueTypeCanceled = 'ISSUE_TYPE_CANCELED',
  IssueTypeDelayed = 'ISSUE_TYPE_DELAYED',
  IssueTypeFailedDelivery = 'ISSUE_TYPE_FAILED_DELIVERY',
  IssueTypePartiallyDelivered = 'ISSUE_TYPE_PARTIALLY_DELIVERED',
  IssueTypeUnknown = 'ISSUE_TYPE_UNKNOWN'
}

/**
 * not necessarily in order; different order types e.g. PPDO, LMD
 * can use a different combination of state change types
 */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange_OrderStateChangeType {
  /** arrived at the customer location */
  OrderStateChangeTypeArrived = 'ORDER_STATE_CHANGE_TYPE_ARRIVED',
  OrderStateChangeTypeAssigned = 'ORDER_STATE_CHANGE_TYPE_ASSIGNED',
  OrderStateChangeTypeAssignedForDelivery = 'ORDER_STATE_CHANGE_TYPE_ASSIGNED_FOR_DELIVERY',
  /**
   * runner is on the way to the customer car
   * TODO: move numbers around?
   */
  OrderStateChangeTypeAssignedForRunning = 'ORDER_STATE_CHANGE_TYPE_ASSIGNED_FOR_RUNNING',
  OrderStateChangeTypeAtStore = 'ORDER_STATE_CHANGE_TYPE_AT_STORE',
  /** return related */
  OrderStateChangeTypeAwaitingReturn = 'ORDER_STATE_CHANGE_TYPE_AWAITING_RETURN',
  OrderStateChangeTypeBagsPickedUp = 'ORDER_STATE_CHANGE_TYPE_BAGS_PICKED_UP',
  OrderStateChangeTypeCanceled = 'ORDER_STATE_CHANGE_TYPE_CANCELED',
  OrderStateChangeTypeCheckingOut = 'ORDER_STATE_CHANGE_TYPE_CHECKING_OUT',
  OrderStateChangeTypeDelivered = 'ORDER_STATE_CHANGE_TYPE_DELIVERED',
  /** shopper attempted delivery */
  OrderStateChangeTypeDeliveryAttempted = 'ORDER_STATE_CHANGE_TYPE_DELIVERY_ATTEMPTED',
  OrderStateChangeTypeInTransit = 'ORDER_STATE_CHANGE_TYPE_IN_TRANSIT',
  OrderStateChangeTypeOrderPlaced = 'ORDER_STATE_CHANGE_TYPE_ORDER_PLACED',
  OrderStateChangeTypePicking = 'ORDER_STATE_CHANGE_TYPE_PICKING',
  OrderStateChangeTypeReturnCompleted = 'ORDER_STATE_CHANGE_TYPE_RETURN_COMPLETED',
  OrderStateChangeTypeReturnInProgress = 'ORDER_STATE_CHANGE_TYPE_RETURN_IN_PROGRESS',
  OrderStateChangeTypeStagedForDelivery = 'ORDER_STATE_CHANGE_TYPE_STAGED_FOR_DELIVERY',
  OrderStateChangeTypeStagedForPickup = 'ORDER_STATE_CHANGE_TYPE_STAGED_FOR_PICKUP',
  OrderStateChangeTypeStaging = 'ORDER_STATE_CHANGE_TYPE_STAGING',
  OrderStateChangeTypeUnknown = 'ORDER_STATE_CHANGE_TYPE_UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_OrderStateGroup';
  label?: Maybe<Scalars['String']>;
  orderStateChanges?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateChange>>>;
  type?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup_OrderStateGroupType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_OrderStateGroup_OrderStateGroupType {
  OrderStateGroupTypeOrderCompleted = 'ORDER_STATE_GROUP_TYPE_ORDER_COMPLETED',
  OrderStateGroupTypeOrderInTransit = 'ORDER_STATE_GROUP_TYPE_ORDER_IN_TRANSIT',
  OrderStateGroupTypeOrderPicking = 'ORDER_STATE_GROUP_TYPE_ORDER_PICKING',
  OrderStateGroupTypeOrderPlaced = 'ORDER_STATE_GROUP_TYPE_ORDER_PLACED',
  OrderStateGroupTypeOrderReturnCompleted = 'ORDER_STATE_GROUP_TYPE_ORDER_RETURN_COMPLETED',
  OrderStateGroupTypeOrderReturnInProgress = 'ORDER_STATE_GROUP_TYPE_ORDER_RETURN_IN_PROGRESS',
  OrderStateGroupTypeOrderReturnPlaced = 'ORDER_STATE_GROUP_TYPE_ORDER_RETURN_PLACED',
  OrderStateGroupTypeUnknown = 'ORDER_STATE_GROUP_TYPE_UNKNOWN'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderRequest_Input = {
  /** Authorization context. */
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** OrderChange token from GetOrderCancellationPolicyListResponse. Optional for certain policy inputs. */
  orderChangeToken?: InputMaybe<Scalars['String']>;
  /** Order Delivery ID. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  orderRescheduleReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Reschedules_OrderRescheduleReason>;
  /**
   * OrderReschedulePolicyInput from GetOrderCancellationPolicyListResponse.
   * TODO(FUL-174701): deprecate for `order_reschedule_reason`
   */
  reason?: InputMaybe<Instacart_Customers_Commerce_Types_V1_SupportRescheduleDeliveryReason>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Service option token to reschedule to. */
  serviceOptionToken?: InputMaybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_RescheduleDashboardOrderResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_RescheduleDashboardOrderResponse';
  operation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** Amounts provided by the retailer. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_RetailerProvidedAmounts = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_RetailerProvidedAmounts';
  bagLabel?: Maybe<Scalars['String']>;
};

/** Information about the shopper assigned to the order. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_ShopperInformation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_ShopperInformation';
  avatarUrl?: Maybe<Scalars['String']>;
  carModelAndColor?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  /** Parent shopper name (Device Name), populated only for bulk (e.g. truck) delivery made by partner managed drivers. */
  partnerManagedShopperDeviceName?: Maybe<Scalars['String']>;
  /** Device phone number, populated only for bulk (e.g. truck) delivery made by partner managed drivers. */
  partnerManagedShopperPhoneNumber?: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_DashboardUserSearchResult = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_dashboard_users_DashboardUserSearchResult';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_EmailSearchScenario_Input = {
  emailIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * For email/phone, we map 1:1 to ListUsersByPersonalIdentifiersRequest from
 * carrot/shared/protos/instacart/customers/users/v1/users.proto
 * For Loyalty ID, we handle by translating User IDs <-> Loyalty IDs in the Loyalty Service.
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_Input = {
  emailSearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_EmailSearchScenario_Input>;
  loyaltySearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_LoyaltySearchScenario_Input>;
  paginationInfo?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PaginationInfo_Input>;
  phoneSearchScenario?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PhoneSearchScenario_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_LoyaltySearchScenario_Input = {
  loyaltyCardIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListRequest_PhoneSearchScenario_Input = {
  phoneIdentifier?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing a list of user search results. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_dashboard_users_get_dashboard_user_search_result_list_DashboardUserSearchResultListResponse';
  paginationInfo?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse_PaginationInfo>;
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_DashboardUserSearchResult>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Dashboard_Users_Get_Dashboard_User_Search_Result_List_DashboardUserSearchResultListResponse_PaginationInfo = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_dashboard_users_get_dashboard_user_search_result_list_DashboardUserSearchResultListResponse_PaginationInfo';
  /** The last cursor of the current page */
  after?: Maybe<Scalars['String']>;
  /** Indicates if there is a next page */
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_EnterpriseServiceOption';
  asapWindow?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  availability?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_OptionAvailability>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  immediateWindow?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ImmediateWindow>;
  priorityEtaWindow?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  scheduledWindow?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  serviceOptionReference?: Maybe<Scalars['String']>;
  standardEtaWindow?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow>;
  type?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOptionType>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOptionType {
  EnterpriseServiceOptionTypeAsap = 'ENTERPRISE_SERVICE_OPTION_TYPE_ASAP',
  EnterpriseServiceOptionTypeImmediate = 'ENTERPRISE_SERVICE_OPTION_TYPE_IMMEDIATE',
  EnterpriseServiceOptionTypePriorityEta = 'ENTERPRISE_SERVICE_OPTION_TYPE_PRIORITY_ETA',
  EnterpriseServiceOptionTypeScheduled = 'ENTERPRISE_SERVICE_OPTION_TYPE_SCHEDULED',
  EnterpriseServiceOptionTypeStandardEta = 'ENTERPRISE_SERVICE_OPTION_TYPE_STANDARD_ETA',
  EnterpriseServiceOptionTypeUnspecified = 'ENTERPRISE_SERVICE_OPTION_TYPE_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ImmediateWindow = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_EnterpriseServiceOption_ImmediateWindow';
  endsAt?: Maybe<Scalars['DateTime']>;
  immediateHour?: Maybe<Scalars['BigInt']>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption_ScheduledWindow = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_EnterpriseServiceOption_ScheduledWindow';
  asap?: Maybe<Scalars['Boolean']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_OptionAvailability = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_OptionAvailability';
  isAvailable?: Maybe<Scalars['Boolean']>;
  itemCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  unavailabilityReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_DeliveryServiceOption_Input = {
  address?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedAddress_Input>;
  /** optional location_code; if not provided, we will use `address` to find the closest retailer location */
  locationCode?: InputMaybe<Scalars['String']>;
  requestedWindowsWrapper?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindowsWrapper_Input>;
  withPriorityEtaOptions?: InputMaybe<Scalars['Boolean']>;
  withStandardEtaOptions?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  delivery?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_DeliveryServiceOption_Input>;
  earliestOptionStartsAt?: InputMaybe<Scalars['DateTime']>;
  orderItems?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Input>>>;
  pickup?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_PickupServiceOption_Input>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_get_enterprise_service_option_list_GetEnterpriseServiceOptionListResponse';
  flags?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse_Flags>;
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_EnterpriseServiceOption>>>;
  warnings?: Maybe<Array<Maybe<Scalars['String']>>>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_GetEnterpriseServiceOptionListResponse_Flags = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_enterprise_service_options_get_enterprise_service_option_list_GetEnterpriseServiceOptionListResponse_Flags';
  isLongDistanceDelivery?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_PickupServiceOption_Input = {
  locationCode?: InputMaybe<Scalars['String']>;
  /** TODO: why is this needed for pickup? */
  withStandardEtaOptions?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedAddress_Input = {
  addressLinePrimary?: InputMaybe<Scalars['String']>;
  addressLineSecondary?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Input = {
  /**
   * Depending on the item's catalog configuration, either this field or 'count' is required.
   * The API interprets this value as whatever unit of measure is defined for the item in the catalog,
   * such as lb or kg. Must be a non-negative number.
   * https://docs.instacart.com/connect/fulfillment_guide/concepts/product_quantity#specifying-product-quantity-for-an-order
   */
  count?: InputMaybe<Scalars['BigInt']>;
  /** The item being requested. */
  item?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Item_Input>;
  /** The item's line number in the order. */
  lineNum?: InputMaybe<Scalars['String']>;
  /** The item-level metadata. */
  metadata?: InputMaybe<Scalars['JSON']>;
  /**
   * A list of requested replacement items if the original item could not be found.
   * This field needs to be enabled via Retailer configuration.
   */
  replacementItems?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Item_Input>>>;
  /** The policy for handling item replacements. */
  replacementPolicy?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_ReplacementPolicy>;
  /** Any special instructions about the item selection. */
  specialInstructions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_Item_Input = {
  /** The Retailer Reference Code (RRC) of the item. */
  rrc?: InputMaybe<Scalars['String']>;
  /** The Universal Product Code (UPC) of the item. */
  upc?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedItem_ReplacementPolicy {
  ReplacementPolicyNoReplacement = 'REPLACEMENT_POLICY_NO_REPLACEMENT',
  ReplacementPolicyShopperChoice = 'REPLACEMENT_POLICY_SHOPPER_CHOICE',
  ReplacementPolicyUnspecified = 'REPLACEMENT_POLICY_UNSPECIFIED',
  ReplacementPolicyUserChoice = 'REPLACEMENT_POLICY_USER_CHOICE'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindow_Input = {
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

/**
 * Copied from instacart/customers/availability/v1/availability.proto
 * Want this wrapper so that we can differentiate between nil and empty array:
 * * Passing in nil means that the caller doesn't want to utilize desired windows filtering; returns default options.
 * * Passing in empty array means that there is something wrong with the input, which results in returning blackouts
 * and errors. This input should be purposefully avoided and only utilized for unsuspected error catching.
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindowsWrapper_Input = {
  requestedWindows?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Enterprise_Service_Options_Get_Enterprise_Service_Option_List_RequestedWindow_Input>>>;
};

/**
 * Reason a dispatcher force-completes an order from the Operational Dashboard.
 * Frigate-local enum: only the reasons OOD exposes today. Mapped to Dispatch's
 * `instacart.fulfillment.domains.dispatch.v1.ForceCompleteReason` in the domain
 * layer, so the OOD-facing contract stays decoupled from the Dispatch type.
 */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Force_Completes_ForceCompleteReason {
  /**
   * "Customer ID Verification Failed" — dispatcher force-completes a delivering
   * order after ID verification could not be completed.
   */
  ForceCompleteReasonInvalidCustomerId = 'FORCE_COMPLETE_REASON_INVALID_CUSTOMER_ID',
  /** Unspecified. Rejected as invalid (a reason is required). */
  ForceCompleteReasonUnspecified = 'FORCE_COMPLETE_REASON_UNSPECIFIED'
}

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_operations_Operation';
  error?: Maybe<Instacart_Enterprise_Frigate_Types_V1_TypedErrorsResponse>;
  isDone?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_ResultValue>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_ResultValue = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_operations_ResultValue';
  /** Reference to the delivery. */
  deliveryReference?: Maybe<Scalars['String']>;
  /** Reference to the new revision. */
  revisionReference?: Maybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationRequest_Input = {
  /** The name of the operation resource. This is passed back in an Operation response. */
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Get_Operation_GetOperationResponse = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_operations_get_operation_GetOperationResponse';
  operation?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Operations_Operation>;
};

/** mirrors `instacart.customers.commerce.types.v1.OrderCancellationCategory` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationCategory {
  OrderCancellationCategoryCustomerResponsible = 'ORDER_CANCELLATION_CATEGORY_CUSTOMER_RESPONSIBLE',
  OrderCancellationCategoryInstacartPolicyEnforcement = 'ORDER_CANCELLATION_CATEGORY_INSTACART_POLICY_ENFORCEMENT',
  OrderCancellationCategoryIntacartUnbatchable = 'ORDER_CANCELLATION_CATEGORY_INTACART_UNBATCHABLE',
  OrderCancellationCategoryOtherCancellationCategory = 'ORDER_CANCELLATION_CATEGORY_OTHER_CANCELLATION_CATEGORY',
  OrderCancellationCategoryRetailerStoreIssue = 'ORDER_CANCELLATION_CATEGORY_RETAILER_STORE_ISSUE',
  OrderCancellationCategoryShopperRequested = 'ORDER_CANCELLATION_CATEGORY_SHOPPER_REQUESTED',
  OrderCancellationCategoryUnspecified = 'ORDER_CANCELLATION_CATEGORY_UNSPECIFIED'
}

/**
 * Contains a reason and optional comment for customer-initiated cancellations.
 * mirrors `instacart.customers.commerce.types.v1.CustomerCancelReason`
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_order_cancellations_OrderCancellationReason';
  /** The main reason why the cancellation was performed */
  customerReason?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_CustomerReason>;
  /** Specific comment added by the customer, used only when customer_reason is 'other' */
  otherComment?: Maybe<Scalars['String']>;
};

/** Enumerates the reasons a customer may choose to cancel an order. */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_CustomerReason {
  /** Customer wants to cancel the current order and place a new one. */
  CustomerReasonCancelAndReorder = 'CUSTOMER_REASON_CANCEL_AND_REORDER',
  /** Want to modify the delivery time. */
  CustomerReasonChangeDeliveryTime = 'CUSTOMER_REASON_CHANGE_DELIVERY_TIME',
  /** Want to modify the pickup time. */
  CustomerReasonChangePickupTime = 'CUSTOMER_REASON_CHANGE_PICKUP_TIME',
  /** Customer no longer needs the specific order. */
  CustomerReasonDoNotNeedThisOrderAnymore = 'CUSTOMER_REASON_DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Inventory items were not available. */
  CustomerReasonItemsWereOutOfStock = 'CUSTOMER_REASON_ITEMS_WERE_OUT_OF_STOCK',
  /** The order is duplicated by the customer. */
  CustomerReasonICreatedADuplicateOrder = 'CUSTOMER_REASON_I_CREATED_A_DUPLICATE_ORDER',
  /** Customer no longer requires the order. */
  CustomerReasonIDoNotNeedThisOrderAnymore = 'CUSTOMER_REASON_I_DO_NOT_NEED_THIS_ORDER_ANYMORE',
  /** Customer wants to change the order. */
  CustomerReasonIWantToChangeMyOrder = 'CUSTOMER_REASON_I_WANT_TO_CHANGE_MY_ORDER',
  /** Order scheduled for delivery too late. */
  CustomerReasonLateOrder = 'CUSTOMER_REASON_LATE_ORDER',
  /** Customer needs to modify the items in the order. */
  CustomerReasonNeedToAddOrRemoveItems = 'CUSTOMER_REASON_NEED_TO_ADD_OR_REMOVE_ITEMS',
  /** Customer needs to reschedule the order. */
  CustomerReasonNeedToReschedule = 'CUSTOMER_REASON_NEED_TO_RESCHEDULE',
  /** Rescheduled delivery time didn't work. */
  CustomerReasonNewTimeDidNotWorkDelivery = 'CUSTOMER_REASON_NEW_TIME_DID_NOT_WORK_DELIVERY',
  /** Rescheduled pickup time didn't work. */
  CustomerReasonNewTimeDidNotWorkPickup = 'CUSTOMER_REASON_NEW_TIME_DID_NOT_WORK_PICKUP',
  /** Delivery is taking too long. */
  CustomerReasonOrderTakingTooLong = 'CUSTOMER_REASON_ORDER_TAKING_TOO_LONG',
  /** Other unspecified reasons. */
  CustomerReasonOther = 'CUSTOMER_REASON_OTHER',
  /** Redirection for unspecified reason. */
  CustomerReasonOtherRedirect = 'CUSTOMER_REASON_OTHER_REDIRECT',
  /** Switch to delivery instead of pickup. */
  CustomerReasonSwitchToDelivery = 'CUSTOMER_REASON_SWITCH_TO_DELIVERY',
  /** Switch to pickup instead of delivery. */
  CustomerReasonSwitchToPickup = 'CUSTOMER_REASON_SWITCH_TO_PICKUP',
  /** General issue with the order. */
  CustomerReasonThereIsAProblemWithMyOrder = 'CUSTOMER_REASON_THERE_IS_A_PROBLEM_WITH_MY_ORDER',
  /** Order is pricier than expected. */
  CustomerReasonTooExpensive = 'CUSTOMER_REASON_TOO_EXPENSIVE',
  /** Too many replacements in the order. */
  CustomerReasonTooManyReplacements = 'CUSTOMER_REASON_TOO_MANY_REPLACEMENTS',
  /** Customer reason isn't specified. */
  CustomerReasonUnspecified = 'CUSTOMER_REASON_UNSPECIFIED',
  /** Incorrect delivery address in a different city. */
  CustomerReasonWrongAddressDifferentCity = 'CUSTOMER_REASON_WRONG_ADDRESS_DIFFERENT_CITY',
  /** Incorrect delivery address within the same city. */
  CustomerReasonWrongAddressSameCity = 'CUSTOMER_REASON_WRONG_ADDRESS_SAME_CITY',
  /** Wrong delivery location specified in the order. */
  CustomerReasonWrongDeliveryLocation = 'CUSTOMER_REASON_WRONG_DELIVERY_LOCATION',
  /** Wrong payment method. */
  CustomerReasonWrongPaymentMethod = 'CUSTOMER_REASON_WRONG_PAYMENT_METHOD',
  /** Wrong payment details or tip adjustment. */
  CustomerReasonWrongPaymentOrChangeTip = 'CUSTOMER_REASON_WRONG_PAYMENT_OR_CHANGE_TIP',
  /** Wrong location for order pickup. */
  CustomerReasonWrongPickupLocation = 'CUSTOMER_REASON_WRONG_PICKUP_LOCATION',
  /** Incorrect store location was chosen. */
  CustomerReasonWrongRetailerLocation = 'CUSTOMER_REASON_WRONG_RETAILER_LOCATION'
}

/**
 * Contains a reason and optional comment for customer-initiated cancellations.
 * mirrors `instacart.customers.commerce.types.v1.CustomerCancelReason`
 */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_Input = {
  /** The main reason why the cancellation was performed */
  customerReason?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationReason_CustomerReason>;
  /** Specific comment added by the customer, used only when customer_reason is 'other' */
  otherComment?: InputMaybe<Scalars['String']>;
};

/**
 * The specific reason why the order is canceled.
 * mirrors `instacart.customers.commerce.types.v1.OrderCancellationType`
 */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Cancellations_OrderCancellationType {
  /** Admin Refund. */
  OrderCancellationTypeAdminRefund = 'ORDER_CANCELLATION_TYPE_ADMIN_REFUND',
  /** Audit failure in bypass checkout. */
  OrderCancellationTypeAuditFailureInBypassCheckout = 'ORDER_CANCELLATION_TYPE_AUDIT_FAILURE_IN_BYPASS_CHECKOUT',
  /** Auto cancellation from order management workflow */
  OrderCancellationTypeAutoCompletionCancellation = 'ORDER_CANCELLATION_TYPE_AUTO_COMPLETION_CANCELLATION',
  /** Unrecoverable error during BJS bypass. */
  OrderCancellationTypeBjsBypassUnrecoverableError = 'ORDER_CANCELLATION_TYPE_BJS_BYPASS_UNRECOVERABLE_ERROR',
  /** Cancellation due to blocked completion. */
  OrderCancellationTypeBlockedCompletionCancellation = 'ORDER_CANCELLATION_TYPE_BLOCKED_COMPLETION_CANCELLATION',
  /** Order canceled by the customer. */
  OrderCancellationTypeCanceledByCustomer = 'ORDER_CANCELLATION_TYPE_CANCELED_BY_CUSTOMER',
  /** Order canceled by the retailer. */
  OrderCancellationTypeCancelledByRetailer = 'ORDER_CANCELLATION_TYPE_CANCELLED_BY_RETAILER',
  /** Order canceled via script. */
  OrderCancellationTypeCancelledViaScript = 'ORDER_CANCELLATION_TYPE_CANCELLED_VIA_SCRIPT',
  /** Card declined during reauthorization. */
  OrderCancellationTypeCardDeclineOnReauth = 'ORDER_CANCELLATION_TYPE_CARD_DECLINE_ON_REAUTH',
  /** Cancellation due to a car accident. */
  OrderCancellationTypeCarAccident = 'ORDER_CANCELLATION_TYPE_CAR_ACCIDENT',
  /** Cancellation due to car issues. */
  OrderCancellationTypeCarIssue = 'ORDER_CANCELLATION_TYPE_CAR_ISSUE',
  /** Payment method needed to be changed. */
  OrderCancellationTypeChangePaymentMethod = 'ORDER_CANCELLATION_TYPE_CHANGE_PAYMENT_METHOD',
  /** Customer faced issues with app navigation. */
  OrderCancellationTypeCustomerAppNavigationIssue = 'ORDER_CANCELLATION_TYPE_CUSTOMER_APP_NAVIGATION_ISSUE',
  /** Customer MIA. */
  OrderCancellationTypeCustomerMia = 'ORDER_CANCELLATION_TYPE_CUSTOMER_MIA',
  /** Customer is missing in action during drop-off. */
  OrderCancellationTypeCustomerMiaOnDropOffOrder = 'ORDER_CANCELLATION_TYPE_CUSTOMER_MIA_ON_DROP_OFF_ORDER',
  /** Customer requested cancellation because the order is early. */
  OrderCancellationTypeCustomerRequestedSinceOrderIsEarly = 'ORDER_CANCELLATION_TYPE_CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested cancellation because the order is late. */
  OrderCancellationTypeCustomerRequestedSinceOrderIsLate = 'ORDER_CANCELLATION_TYPE_CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Customer requested to cancel the order. */
  OrderCancellationTypeCustomerRequestToCancel = 'ORDER_CANCELLATION_TYPE_CUSTOMER_REQUEST_TO_CANCEL',
  /** Order delivered outside the scheduled window. */
  OrderCancellationTypeDeliveredOutsideOfWindow = 'ORDER_CANCELLATION_TYPE_DELIVERED_OUTSIDE_OF_WINDOW',
  /**
   * Order canceled due to cancellation of a related dependent order.
   * E.g. in the case of a party order, if the host order is canceled we may cancel the member orders.
   */
  OrderCancellationTypeDependentOrderCanceled = 'ORDER_CANCELLATION_TYPE_DEPENDENT_ORDER_CANCELED',
  /** Dispatcher canceled the order because the customer was unavailable. */
  OrderCancellationTypeDispatcherCancelledCustomerUnavailable = 'ORDER_CANCELLATION_TYPE_DISPATCHER_CANCELLED_CUSTOMER_UNAVAILABLE',
  /** Dispatcher canceled the order due to route issues. */
  OrderCancellationTypeDispatcherCancelledRouteIssues = 'ORDER_CANCELLATION_TYPE_DISPATCHER_CANCELLED_ROUTE_ISSUES',
  /** Dispatcher canceled the order because the shift is ending. */
  OrderCancellationTypeDispatcherCancelledShiftEnding = 'ORDER_CANCELLATION_TYPE_DISPATCHER_CANCELLED_SHIFT_ENDING',
  /** Driver canceled the order because the customer was unavailable. */
  OrderCancellationTypeDriverCancelledCustomerUnavailable = 'ORDER_CANCELLATION_TYPE_DRIVER_CANCELLED_CUSTOMER_UNAVAILABLE',
  /** Driver canceled the order due to route issues. */
  OrderCancellationTypeDriverCancelledRouteIssues = 'ORDER_CANCELLATION_TYPE_DRIVER_CANCELLED_ROUTE_ISSUES',
  /** Driver canceled the order because the shift is ending. */
  OrderCancellationTypeDriverCancelledShiftEnding = 'ORDER_CANCELLATION_TYPE_DRIVER_CANCELLED_SHIFT_ENDING',
  /** Duplicate order. */
  OrderCancellationTypeDuplicateOrder = 'ORDER_CANCELLATION_TYPE_DUPLICATE_ORDER',
  /** Cancellation due to an emergency. */
  OrderCancellationTypeEmergency = 'ORDER_CANCELLATION_TYPE_EMERGENCY',
  /** Empty Delivery. */
  OrderCancellationTypeEmptyDelivery = 'ORDER_CANCELLATION_TYPE_EMPTY_DELIVERY',
  /** Cancellation due to failed completion. */
  OrderCancellationTypeFailedCompletionCancellation = 'ORDER_CANCELLATION_TYPE_FAILED_COMPLETION_CANCELLATION',
  /** Fraudulent Customer. */
  OrderCancellationTypeFraudulentCustomer = 'ORDER_CANCELLATION_TYPE_FRAUDULENT_CUSTOMER',
  /** Fulfillment initiated due to out-of-stock items. */
  OrderCancellationTypeFulfillmentInitiatedDueToOutOfStock = 'ORDER_CANCELLATION_TYPE_FULFILLMENT_INITIATED_DUE_TO_OUT_OF_STOCK',
  /** Incorrect accessibility information. */
  OrderCancellationTypeIncorrectAccessibilityInformation = 'ORDER_CANCELLATION_TYPE_INCORRECT_ACCESSIBILITY_INFORMATION',
  /** Incorrect customer information. */
  OrderCancellationTypeIncorrectCustomerInformation = 'ORDER_CANCELLATION_TYPE_INCORRECT_CUSTOMER_INFORMATION',
  /** All items refunded in an Instacart Connect order. */
  OrderCancellationTypeInstacartConnectOrderWithAllItemsRefunded = 'ORDER_CANCELLATION_TYPE_INSTACART_CONNECT_ORDER_WITH_ALL_ITEMS_REFUNDED',
  /** Failed to get a suspended transaction for Kroger Connect. */
  OrderCancellationTypeKrogerConnectFailedToGetSuspendedTransaction = 'ORDER_CANCELLATION_TYPE_KROGER_CONNECT_FAILED_TO_GET_SUSPENDED_TRANSACTION',
  /** Manual fraud. */
  OrderCancellationTypeManualFraud = 'ORDER_CANCELLATION_TYPE_MANUAL_FRAUD',
  /** Mass cancellation of orders. */
  OrderCancellationTypeMassCancellation = 'ORDER_CANCELLATION_TYPE_MASS_CANCELLATION',
  /** Missing charge log for delivery. */
  OrderCancellationTypeMissingChargeLogForDelivery = 'ORDER_CANCELLATION_TYPE_MISSING_CHARGE_LOG_FOR_DELIVERY',
  /** No cancellation reason specified. */
  OrderCancellationTypeNone = 'ORDER_CANCELLATION_TYPE_NONE',
  /** Online Payment Failure. */
  OrderCancellationTypeOnlinePayFailure = 'ORDER_CANCELLATION_TYPE_ONLINE_PAY_FAILURE',
  /** Cancellation due to other unspecified reasons. */
  OrderCancellationTypeOtherCancellationType = 'ORDER_CANCELLATION_TYPE_OTHER_CANCELLATION_TYPE',
  /** Order is in pre-picking stage. */
  OrderCancellationTypePrePicking = 'ORDER_CANCELLATION_TYPE_PRE_PICKING',
  /** Cancellation due to related accounts fraud abuse. */
  OrderCancellationTypeRelatedAccountsAbuse = 'ORDER_CANCELLATION_TYPE_RELATED_ACCOUNTS_ABUSE',
  /** Retailer initiated cancellation because the customer is MIA. */
  OrderCancellationTypeRetailerInitiatedCustomerMia = 'ORDER_CANCELLATION_TYPE_RETAILER_INITIATED_CUSTOMER_MIA',
  /** Retailer initiated cancellation due to out-of-stock items. */
  OrderCancellationTypeRetailerInitiatedOutOfStock = 'ORDER_CANCELLATION_TYPE_RETAILER_INITIATED_OUT_OF_STOCK',
  /** Cancellation due to safety concerns. */
  OrderCancellationTypeSafetyConcerns = 'ORDER_CANCELLATION_TYPE_SAFETY_CONCERNS',
  /** Cancellation due to a severe weather event. */
  OrderCancellationTypeSevereWeatherEvent = 'ORDER_CANCELLATION_TYPE_SEVERE_WEATHER_EVENT',
  /** Shopper couldn't locate the delivery address. */
  OrderCancellationTypeShopperCouldNotFindAddress = 'ORDER_CANCELLATION_TYPE_SHOPPER_COULD_NOT_FIND_ADDRESS',
  /** Shopper initiated cancellation due to out-of-stock items. */
  OrderCancellationTypeShopperInitiatedOutOfStock = 'ORDER_CANCELLATION_TYPE_SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Shopper is unable to complete the order. */
  OrderCancellationTypeShopperUnableToCompleteOrder = 'ORDER_CANCELLATION_TYPE_SHOPPER_UNABLE_TO_COMPLETE_ORDER',
  /** Single item order is out of stock. */
  OrderCancellationTypeSingleItemOrderOutOfStock = 'ORDER_CANCELLATION_TYPE_SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Early closure of store. */
  OrderCancellationTypeStoreEarlyClosure = 'ORDER_CANCELLATION_TYPE_STORE_EARLY_CLOSURE',
  /** Store experiencing an outage. */
  OrderCancellationTypeStoreOutage = 'ORDER_CANCELLATION_TYPE_STORE_OUTAGE',
  /** Too many items are out of stock. */
  OrderCancellationTypeTooManyOutOfStockItem = 'ORDER_CANCELLATION_TYPE_TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements in the order. */
  OrderCancellationTypeTooManyReplacements = 'ORDER_CANCELLATION_TYPE_TOO_MANY_REPLACEMENTS',
  /** Cancellation due to traffic conditions. */
  OrderCancellationTypeTrafficConditions = 'ORDER_CANCELLATION_TYPE_TRAFFIC_CONDITIONS',
  /** Unable to reschedule the order as no options were available. */
  OrderCancellationTypeUnableToRescheduleAsNoOptionFound = 'ORDER_CANCELLATION_TYPE_UNABLE_TO_RESCHEDULE_AS_NO_OPTION_FOUND',
  /** Unable to reschedule due to unbatchable order. */
  OrderCancellationTypeUnableToRescheduleUnbatchable = 'ORDER_CANCELLATION_TYPE_UNABLE_TO_RESCHEDULE_UNBATCHABLE',
  /** Order is unbatchable. */
  OrderCancellationTypeUnbatchable = 'ORDER_CANCELLATION_TYPE_UNBATCHABLE',
  /** Unspecified cancellation type. */
  OrderCancellationTypeUnspecified = 'ORDER_CANCELLATION_TYPE_UNSPECIFIED',
  /** Incorrect store operating hours. */
  OrderCancellationTypeWrongStoreHours = 'ORDER_CANCELLATION_TYPE_WRONG_STORE_HOURS'
}

/** mirrors `instacart.customers.commerce.types.v1.SupportRescheduleDeliveryReason` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Order_Reschedules_OrderRescheduleReason {
  /** Customer is missing in action. */
  OrderRescheduleReasonCustomerMia = 'ORDER_RESCHEDULE_REASON_CUSTOMER_MIA',
  /** Customer requested since order is early. */
  OrderRescheduleReasonCustomerRequestedSinceOrderIsEarly = 'ORDER_RESCHEDULE_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_EARLY',
  /** Customer requested since order is late. */
  OrderRescheduleReasonCustomerRequestedSinceOrderIsLate = 'ORDER_RESCHEDULE_REASON_CUSTOMER_REQUESTED_SINCE_ORDER_IS_LATE',
  /** Incorrect customer information was provided. */
  OrderRescheduleReasonIncorrectCustomerInformation = 'ORDER_RESCHEDULE_REASON_INCORRECT_CUSTOMER_INFORMATION',
  /** Retailer initiated out of stock. */
  OrderRescheduleReasonRetailerInitiatedOutOfStock = 'ORDER_RESCHEDULE_REASON_RETAILER_INITIATED_OUT_OF_STOCK',
  /** Shopper initiated out of stock. */
  OrderRescheduleReasonShopperInitiatedOutOfStock = 'ORDER_RESCHEDULE_REASON_SHOPPER_INITIATED_OUT_OF_STOCK',
  /** Single item in the order was out of stock. */
  OrderRescheduleReasonSingleItemOrderOutOfStock = 'ORDER_RESCHEDULE_REASON_SINGLE_ITEM_ORDER_OUT_OF_STOCK',
  /** Store early closure. */
  OrderRescheduleReasonStoreEarlyClosure = 'ORDER_RESCHEDULE_REASON_STORE_EARLY_CLOSURE',
  /** Store outage. */
  OrderRescheduleReasonStoreOutage = 'ORDER_RESCHEDULE_REASON_STORE_OUTAGE',
  /** Too many items out of stock. */
  OrderRescheduleReasonTooManyOutOfStockItem = 'ORDER_RESCHEDULE_REASON_TOO_MANY_OUT_OF_STOCK_ITEM',
  /** Too many replacements. */
  OrderRescheduleReasonTooManyReplacements = 'ORDER_RESCHEDULE_REASON_TOO_MANY_REPLACEMENTS',
  /** Unspecified. */
  OrderRescheduleReasonUnspecified = 'ORDER_RESCHEDULE_REASON_UNSPECIFIED',
  /** Wrong store hours. */
  OrderRescheduleReasonWrongStoreHours = 'ORDER_RESCHEDULE_REASON_WRONG_STORE_HOURS'
}

/** mirrors `instacart.customers.product_retrieval.v1.catalog.v1.ClientSourceType` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ClientSourceType {
  CaperNativeFeed = 'CAPER_NATIVE_FEED',
  ClientSourceTypeUnspecified = 'CLIENT_SOURCE_TYPE_UNSPECIFIED',
  CommerceDiscountIcBirdzi = 'COMMERCE_DISCOUNT_IC_BIRDZI',
  CommerceDiscountIcLms = 'COMMERCE_DISCOUNT_IC_LMS'
}

/** mirrors `instacart.customers.product_retrieval.v1.catalog.v1.CodeType` */
export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_CodeType {
  CodeTypeUnspecified = 'CODE_TYPE_UNSPECIFIED',
  ExternalIntegrationId = 'EXTERNAL_INTEGRATION_ID',
  LookupCodeNormalized = 'LOOKUP_CODE_NORMALIZED',
  LookupCodeRaw = 'LOOKUP_CODE_RAW',
  RetailerReferenceCode = 'RETAILER_REFERENCE_CODE'
}

/** Debug options for including additional query information in responses. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Debug_Input = {
  shouldIncludeNode?: InputMaybe<Scalars['Boolean']>;
  shouldIncludeParameterizedSql?: InputMaybe<Scalars['Boolean']>;
  shouldIncludeRawSql?: InputMaybe<Scalars['Boolean']>;
};

/** mirrors `instacart.customers.product_retrieval.v1.RequestMeta`, see for more domain context */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Input = {
  /** The debug information requested for the request */
  debug?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_Debug_Input>;
  /** The tier of the request indicating its business criticality level */
  requestTier?: InputMaybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_RequestTier>;
  /**
   * The call source of the request.  This is used for rate limiting and event
   * logging. This should be a STATIC string that can be searched for in a code repository.
   * Do NOT dynamically change this value as it will break rate limiting.
   */
  src?: InputMaybe<Scalars['String']>;
  /**
   * The variant of the src used for tracking different variations of an API call. You can use this
   * to track request counts/latency differences across different variations of a query.
   */
  srcVariant?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_RequestMetadata_RequestTier {
  /**
   * Tier 0 - Highest priority, critical requests that must be served
   * Examples: Order placement, checkout flows
   */
  RequestTier_0 = 'REQUEST_TIER_0',
  /** Tier 1 - High priority requests */
  RequestTier_1 = 'REQUEST_TIER_1',
  /** Tier 2 - Medium priority requests */
  RequestTier_2 = 'REQUEST_TIER_2',
  /** Tier 3 - Low priority requests */
  RequestTier_3 = 'REQUEST_TIER_3',
  /** Tier 4 - Lowest priority requests */
  RequestTier_4 = 'REQUEST_TIER_4',
  /** Default value - should not be used explicitly, helps us uncover requests not setting the tier */
  RequestTierUnspecified = 'REQUEST_TIER_UNSPECIFIED'
}

/** mirrors `instacart.customers.product_retrieval.v1.ResponseMeta`, see for more domain context */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata';
  debug?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug>;
};

/** Debug information included in the response when requested. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata_Debug';
  /** The node information for the query */
  node?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Node>;
  /** The SQL information for the query */
  sql?: Maybe<Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Sql>;
};

/** Information about the database node that executed the query. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Node = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata_Debug_Node';
  /** The cluster that the query was executed on */
  cluster?: Maybe<Scalars['String']>;
  /** The replica that the query was executed on */
  replica?: Maybe<Scalars['Int']>;
  /** The shard that the query was executed on */
  shard?: Maybe<Scalars['Int']>;
};

/** Information about the SQL query that was executed. */
export type Instacart_Enterprise_Frigate_Fulfillment_V1_Product_Retrieval_Retailer_Product_Details_ResponseMetadata_Debug_Sql = {
  __typename?: 'instacart_enterprise_frigate_fulfillment_v1_product_retrieval_retailer_product_details_ResponseMetadata_Debug_SQL';
  /** The parameterized SQL that was executed, has the parameters replaced with placeholders */
  parameterizedSql?: Maybe<Scalars['String']>;
  /** The parameters that were used in the parameterized SQL */
  parameters?: Maybe<Array<Maybe<Google_Protobuf_Value>>>;
  /** The raw SQL that was executed, has the parameters directly in the SQL */
  rawSql?: Maybe<Scalars['String']>;
};

/** Represents a single message in an enterprise chat conversation. */
export type Instacart_Enterprise_Frigate_Post_Checkout_V1_EnterpriseChatMessage = {
  __typename?: 'instacart_enterprise_frigate_post_checkout_v1_EnterpriseChatMessage';
  /** The body of the message. */
  body?: Maybe<Scalars['String']>;
  /** The time of creation. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the message. */
  id?: Maybe<Scalars['BigInt']>;
  /**
   * The URL of the image in the message.
   * e.g. https://d2syimmrmqkckt.cloudfront.net/chatmessage/image/254f4bf8-2d13-11ec-8d3d-0242ac130003.jpg
   */
  image?: Maybe<Scalars['String']>;
  /** The order delivery ID. */
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  /** Whether or not the message was read. */
  read?: Maybe<Scalars['Boolean']>;
  /** Time the message was read at. */
  readAt?: Maybe<Scalars['DateTime']>;
  /** The recipient ID. */
  recipientId?: Maybe<Scalars['BigInt']>;
  /** The type of recipient. */
  recipientType?: Maybe<Scalars['String']>;
  /** The avatar URL of the sender. */
  senderAvatarUrl?: Maybe<Scalars['String']>;
  /** The display name of the sender. */
  senderDisplayName?: Maybe<Scalars['String']>;
  /** The sender ID. */
  senderId?: Maybe<Scalars['BigInt']>;
  /** The type of sender. */
  senderType?: Maybe<Scalars['String']>;
};

/** Request message for retrieving enterprise chat messages for a specific order delivery. */
export type Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input>;
  /** The order delivery ID associated with the conversation. */
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
};

/** Response message containing the list of chat messages for an order delivery conversation. */
export type Instacart_Enterprise_Frigate_Post_Checkout_V1_GetEnterpriseChatMessageListResponse = {
  __typename?: 'instacart_enterprise_frigate_post_checkout_v1_GetEnterpriseChatMessageListResponse';
  /** If the messages are from an order too old/expired */
  isExpired?: Maybe<Scalars['Boolean']>;
  /** The messages of the conversation. */
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Post_Checkout_V1_EnterpriseChatMessage>>>;
};

/** Request message for creating a new partner-managed shift (either recurring or single). */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_Input = {
  deleteConflictingShifts?: InputMaybe<Scalars['Boolean']>;
  driverId?: InputMaybe<Scalars['BigInt']>;
  equipmentAssignment?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_EquipmentAssignment_Input>;
  isOnCall?: InputMaybe<Scalars['Boolean']>;
  recurringShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_RecurringShiftRequest_Input>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shiftType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  singleShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_SingleShiftRequest_Input>;
};

/** Request details for creating a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_RecurringShiftRequest_Input = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  recurEndDate?: InputMaybe<Google_Type_Date_Input>;
  recurStartDate?: InputMaybe<Google_Type_Date_Input>;
  shiftLengthSeconds?: InputMaybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['BigInt']>;
};

/** Request details for creating a single shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftRequest_SingleShiftRequest_Input = {
  date?: InputMaybe<Google_Type_Date_Input>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response message after creating a partner-managed shift, including any conflicts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_CreatePartnerManagedShiftResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_CreatePartnerManagedShiftResponse';
  createShiftConflicts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftConflict>>>;
  shiftId?: Maybe<Scalars['BigInt']>;
};

/** Request message for deleting a partner-managed shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_Input = {
  recurringShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_RecurringShiftRequest_Input>;
  shiftId?: InputMaybe<Scalars['BigInt']>;
  singleShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_SingleShiftRequest_Input>;
};

/** Request details for deleting a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_RecurringShiftRequest_Input = {
  deleteShiftsFromDate?: InputMaybe<Google_Type_Date_Input>;
};

/** Request details for deleting a single shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftRequest_SingleShiftRequest_Input = {
  driverId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message after deleting a partner-managed shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_DeletePartnerManagedShiftResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_DeletePartnerManagedShiftResponse';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

/** A piece of equipment (e.g. a vehicle) assigned to a shift, along with attributes specific to its equipment_type. */
export type Instacart_Enterprise_Frigate_Shifts_V1_Equipment = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_Equipment';
  capacityAmount?: Maybe<Scalars['Int']>;
  capacityUnit?: Maybe<Instacart_Enterprise_Frigate_Delivery_Software_V1_CapacityUnit>;
  equipmentId?: Maybe<Scalars['BigInt']>;
  equipmentType?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_EquipmentType>;
  /** The following fields are only populated when equipment_type is EQUIPMENT_TYPE_VEHICLE. */
  licensePlate?: Maybe<Scalars['String']>;
};

/** A reference to a piece of equipment assigned to a shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_EquipmentAssignment_Input = {
  equipmentId?: InputMaybe<Scalars['BigInt']>;
  equipmentType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_EquipmentType>;
};

/** The kind of equipment referenced by an Equipment message. */
export enum Instacart_Enterprise_Frigate_Shifts_V1_EquipmentType {
  EquipmentTypeUnknown = 'EQUIPMENT_TYPE_UNKNOWN',
  EquipmentTypeVehicle = 'EQUIPMENT_TYPE_VEHICLE'
}

/** Request to get presigned file upload URL */
export type Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlRequest_Input = {
  fileContentType?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for getting presigned file upload URL */
export type Instacart_Enterprise_Frigate_Shifts_V1_GeneratePresignedFileUploadUrlResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GeneratePresignedFileUploadUrlResponse';
  /** StringValue instead of Struct to avoid automatic key transforms (e.g. x-amz-signature -> xAmzSignature) */
  uploadFieldsJson?: Maybe<Scalars['String']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

/** Request message for generating shifts report */
export type Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportRequest_Input = {
  /** End date for the report period (optional) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Abandoned do not use. Should use retailer_id */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional. Canonical ID (UUID) of the enterprise account that requested this operation */
  requestedByCanonicalId?: InputMaybe<Scalars['String']>;
  /** User ID of the person requesting the report */
  requestedByUserId?: InputMaybe<Scalars['BigInt']>;
  /** (Required) Identifies the retailer making the request. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Type of schedule to include in the report */
  scheduleType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Start date for the report period (required) */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Uses incorrect naming convention. This field will be removed once the service code is updated. */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** List of warehouse location IDs to include in the report (optional) */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response message for generating shifts report */
export type Instacart_Enterprise_Frigate_Shifts_V1_GenerateShiftsReportResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GenerateShiftsReportResponse';
  /**
   * URL to download the generated report file (S3 link)
   * This become optional since we move to a async approach.
   */
  downloadedFileUrl?: Maybe<Scalars['String']>;
  /** Shift management operations record ID */
  shiftManagementOpsRecordId?: Maybe<Scalars['BigInt']>;
};

/** Request message for retrieving a list of partner-managed shifts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListRequest_Input = {
  date?: InputMaybe<Google_Type_Date_Input>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shiftType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
};

/** Response message containing a list of shoppers with their associated shifts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShiftListResponse';
  shopperWithShifts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperWithShifts>>>;
};

/** Request message for retrieving specified partner-managed shifts along with their assigned equipment. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftsWithEquipmentRequest_Input = {
  /** Retailer location that all requested shifts must belong to. */
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  /** Shift identifiers whose equipment should be retrieved. */
  shiftIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response message containing partner-managed shifts along with their assigned equipment. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShiftsWithEquipmentResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShiftsWithEquipmentResponse';
  shiftsWithEquipment?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ShiftWithEquipment>>>;
};

/** Cursor for paginating through the shopper list. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShopperListCursor';
  shopperId?: Maybe<Scalars['String']>;
};

/** Cursor for paginating through the shopper list. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor_Input = {
  shopperId?: InputMaybe<Scalars['String']>;
};

/** Filter criteria for querying partner-managed shoppers. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListFilter_Input = {
  /** Filter by device type. UNSPECIFIED means no filtering. */
  deviceType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedDeviceType>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isInactive?: InputMaybe<Scalars['Boolean']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  isPartnerPickStoreManager?: InputMaybe<Scalars['Boolean']>;
  isWifiOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Request message for retrieving a paginated list of partner-managed shoppers. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListRequest_Input = {
  cursor?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor_Input>;
  filter?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListFilter_Input>;
  limit?: InputMaybe<Scalars['Int']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of partner-managed shoppers and pagination info. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPartnerManagedShopperListResponse';
  cursor?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_GetPartnerManagedShopperListCursor>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  shoppers?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopper>>>;
};

/** Request message for getting presigned download URL for cloud file */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlRequest_Input = {
  objectKey?: InputMaybe<Scalars['String']>;
  /** Required. The request context */
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer ID associated with this operation */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for getting presigned download URL for cloud file */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetPresignedDownloadUrlResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetPresignedDownloadUrlResponse';
  signedDownloadUrl?: Maybe<Scalars['String']>;
};

/** Request message for getting shift management operation record list */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListRequest_Input = {
  /** Required. Filter by job type. */
  jobType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_JobType>;
  /** Pagination information */
  pagination?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PaginationInfo_Input>;
  /** Required. The retailer ID to filter records by */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required. Filter by schedule type. */
  scheduleType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Optional. Filter by operation status. If empty, returns all statuses. */
  status?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus>>>;
};

/** Response message for getting shift management operation record list */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetShiftManagementOperationRecordListResponse';
  /** Pagination information for the response */
  pagination?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PaginationResponse>;
  /** The list of shift management operation records */
  results?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationRecord>>>;
  /** Total count of records matching the filter (if available) */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** Request message for getting a shift management operation record by ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordRequest_Input = {
  /** Required. The ID of the operation record to retrieve */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Required. The request context */
  requestContext?: InputMaybe<Instacart_Types_V1_RequestContext_Input>;
  /** Retailer ID associated with this operation */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for getting a shift management operation record by ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetShiftManagementOperationRecordResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetShiftManagementOperationRecordResponse';
  /** The shift management operation record */
  record?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationRecord>;
};

/** Request message for retrieving staffing allocation data. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListRequest_Input = {
  endDate?: InputMaybe<Google_Type_Date_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  shiftType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  startDate?: InputMaybe<Google_Type_Date_Input>;
};

/** Response message containing staffing allocations by date and performance metrics. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingAllocationListResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetStaffingAllocationListResponse';
  staffingAllocationsByDate?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationByDate>>>;
  staffingPerformanceMetrics?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationMetrics>;
};

/** Request message for retrieving staffing hours by date. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateRequest_Input = {
  date?: InputMaybe<Google_Type_Date_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing a list of staffing hours. */
export type Instacart_Enterprise_Frigate_Shifts_V1_GetStaffingHoursListByDateResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_GetStaffingHoursListByDateResponse';
  staffingHours?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingHours>>>;
};

/** Job type enum */
export enum Instacart_Enterprise_Frigate_Shifts_V1_JobType {
  JobTypeDownload = 'JOB_TYPE_DOWNLOAD',
  JobTypeUnknown = 'JOB_TYPE_UNKNOWN',
  JobTypeUpload = 'JOB_TYPE_UPLOAD',
  JobTypeVersionDeployment = 'JOB_TYPE_VERSION_DEPLOYMENT'
}

/** Metadata about Marqeta cards associated with a shopper. */
export type Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadata = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_MarqetaCardMetadata';
  count?: Maybe<Scalars['Int']>;
  type?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadataType>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadataType {
  MarqetaCardMetadataTypeDigital = 'MARQETA_CARD_METADATA_TYPE_DIGITAL',
  MarqetaCardMetadataTypeInactive = 'MARQETA_CARD_METADATA_TYPE_INACTIVE',
  MarqetaCardMetadataTypePhysical = 'MARQETA_CARD_METADATA_TYPE_PHYSICAL',
  MarqetaCardMetadataTypeSuspended = 'MARQETA_CARD_METADATA_TYPE_SUSPENDED',
  MarqetaCardMetadataTypeTerminated = 'MARQETA_CARD_METADATA_TYPE_TERMINATED',
  MarqetaCardMetadataTypeUnknown = 'MARQETA_CARD_METADATA_TYPE_UNKNOWN'
}

/** Operation status enum */
export enum Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus {
  OperationStatusFailed = 'OPERATION_STATUS_FAILED',
  OperationStatusInit = 'OPERATION_STATUS_INIT',
  OperationStatusProcessing = 'OPERATION_STATUS_PROCESSING',
  OperationStatusSuccess = 'OPERATION_STATUS_SUCCESS',
  OperationStatusTimeout = 'OPERATION_STATUS_TIMEOUT',
  OperationStatusUnknown = 'OPERATION_STATUS_UNKNOWN',
  OperationStatusValidated = 'OPERATION_STATUS_VALIDATED',
  OperationStatusValidating = 'OPERATION_STATUS_VALIDATING',
  OperationStatusValidationFailed = 'OPERATION_STATUS_VALIDATION_FAILED'
}

/** Container for vertical-specific overrides to staffing hours. */
export type Instacart_Enterprise_Frigate_Shifts_V1_Overrides = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_Overrides';
  pickupOverrides?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PickupOverrides>;
};

/** Pagination information for requests */
export type Instacart_Enterprise_Frigate_Shifts_V1_PaginationInfo_Input = {
  /** Cursor to start from when fetching */
  after?: InputMaybe<Scalars['String']>;
  /** Count to return */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Pagination information for responses */
export type Instacart_Enterprise_Frigate_Shifts_V1_PaginationResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PaginationResponse';
  /** Cursor for the next page */
  after?: Maybe<Scalars['String']>;
  /** Whether there are more results available */
  hasNext?: Maybe<Scalars['Boolean']>;
};

/** Scenario data returned when shift_type is PARTNER_BULK_DELIVERY_ONLY. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryOnlyScenario = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerBulkDeliveryOnlyScenario';
  routes?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryRoute>>>;
};

/** Delivery route information for a delivery shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryRoute = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerBulkDeliveryRoute';
  batchId?: Maybe<Scalars['BigInt']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  orderCount?: Maybe<Scalars['BigInt']>;
  routeAcceptsOrders?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedDeviceType {
  PartnerManagedDeviceTypePhone = 'PARTNER_MANAGED_DEVICE_TYPE_PHONE',
  PartnerManagedDeviceTypeUnknown = 'PARTNER_MANAGED_DEVICE_TYPE_UNKNOWN',
  PartnerManagedDeviceTypeWifi = 'PARTNER_MANAGED_DEVICE_TYPE_WIFI'
}

/**
 * Common representation of a shift that encapsulates both driver and recurring shifts.
 * This will be used on the UI to display shift grid.
 */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShift = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShift';
  partnerBulkDeliveryOnlyScenario?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerBulkDeliveryOnlyScenario>;
  recurringShiftProperties?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_RecurringShiftProperties>;
  shiftType?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  singleShiftProperties?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_SingleShiftProperties>;
};

/** Represents a conflict when attempting to create or update a shift that overlaps with an existing shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftConflict = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShiftConflict';
  conflictingShiftId?: Maybe<Scalars['BigInt']>;
  date?: Maybe<Google_Type_Date>;
  daysOfWeek?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  endsAt?: Maybe<Scalars['DateTime']>;
  shiftLengthSeconds?: Maybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight?: Maybe<Scalars['BigInt']>;
  shiftType?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftType {
  /** full service maps to legacy `normal` shift type */
  PartnerManagedShiftTypeFullService = 'PARTNER_MANAGED_SHIFT_TYPE_FULL_SERVICE',
  /** partner_bulk_delivery_only */
  PartnerManagedShiftTypePartnerBulkDeliveryOnly = 'PARTNER_MANAGED_SHIFT_TYPE_PARTNER_BULK_DELIVERY_ONLY',
  /** picking_only */
  PartnerManagedShiftTypePickingOnly = 'PARTNER_MANAGED_SHIFT_TYPE_PICKING_ONLY',
  /** runner */
  PartnerManagedShiftTypeRunner = 'PARTNER_MANAGED_SHIFT_TYPE_RUNNER',
  PartnerManagedShiftTypeUnknown = 'PARTNER_MANAGED_SHIFT_TYPE_UNKNOWN'
}

/** Represents a partner-managed shopper with their details and metadata. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopper = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShopper';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  isActive?: Maybe<Scalars['Boolean']>;
  isPartnerPickStoreManager?: Maybe<Scalars['Boolean']>;
  isWifiOnly?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  /** Marqeta card metadata is used in the IPP devices page */
  marqetaCardsMetadata?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_MarqetaCardMetadata>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  warehouseLocationName?: Maybe<Scalars['String']>;
};

/** Sending only a subset of the shopper data to reduce the payload size */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperSummary = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShopperSummary';
  shopperId?: Maybe<Scalars['BigInt']>;
  shopperName?: Maybe<Scalars['String']>;
};

/** Represents a shopper along with their assigned shifts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperWithShifts = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PartnerManagedShopperWithShifts';
  shifts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShift>>>;
  shopper?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShopperSummary>;
};

/** Overrides specific to pickup hours. */
export type Instacart_Enterprise_Frigate_Shifts_V1_PickupOverrides = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_PickupOverrides';
  earlyPickingTime?: Maybe<Scalars['DateTime']>;
};

/** Process type enum for CSV processing */
export enum Instacart_Enterprise_Frigate_Shifts_V1_ProcessType {
  ProcessTypeOneOff = 'PROCESS_TYPE_ONE_OFF',
  ProcessTypeRecurring = 'PROCESS_TYPE_RECURRING',
  ProcessTypeUnknown = 'PROCESS_TYPE_UNKNOWN'
}

/** Request to process uploaded CSV file */
export type Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvRequest_Input = {
  /** Required. Type of processing (one-off or recurring) */
  processType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ProcessType>;
  /** Required. Retailer ID for the CSV processing */
  retailerId?: InputMaybe<Scalars['BigInt']>;
  /** Required. Shift management operations record ID */
  shiftManagementOpsRecordId?: InputMaybe<Scalars['BigInt']>;
  /** Optional. User ID initiating the request */
  userId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for CSV processing request */
export type Instacart_Enterprise_Frigate_Shifts_V1_ProcessUploadedCsvResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ProcessUploadedCsvResponse';
  /** Shift management operations record ID */
  shiftManagementOpsRecordId?: Maybe<Scalars['BigInt']>;
  /** Acknowledgment status of the request */
  statusMessage?: Maybe<Scalars['String']>;
};

/** Properties specific to a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_RecurringShiftProperties = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_RecurringShiftProperties';
  /** the days of week that a recurring_shift recurs on */
  daysOfWeek?: Maybe<Array<Maybe<GoogleTypeDayOfWeek>>>;
  recurEndDate?: Maybe<Scalars['DateTime']>;
  recurStartDate?: Maybe<Scalars['DateTime']>;
  recurringShiftId?: Maybe<Scalars['BigInt']>;
  shiftLengthSeconds?: Maybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight?: Maybe<Scalars['BigInt']>;
};

/** Enum for schedule type */
export enum Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType {
  ScheduleTypeOneOff = 'SCHEDULE_TYPE_ONE_OFF',
  ScheduleTypeRecurring = 'SCHEDULE_TYPE_RECURRING',
  ScheduleTypeUnknown = 'SCHEDULE_TYPE_UNKNOWN'
}

/** Represents a shift management operation record */
export type Instacart_Enterprise_Frigate_Shifts_V1_ShiftManagementOperationRecord = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ShiftManagementOperationRecord';
  /** Timestamp when the record was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Error message if the operation failed (optional) */
  errorMessage?: Maybe<Scalars['String']>;
  /** Number of rows that failed processing (optional) */
  failedRows?: Maybe<Scalars['Int']>;
  /** Unique identifier for the operation record */
  id?: Maybe<Scalars['BigInt']>;
  /** Type of operation */
  jobType?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_JobType>;
  /** Cloud file system key for the original file associated with this operation (optional) */
  orgFileLoc?: Maybe<Scalars['String']>;
  /** Cloud file system key for the output file (optional) */
  outputFileLoc?: Maybe<Scalars['String']>;
  /** End timestamp of the requested date range (optional) */
  requestDateRangeEndsAt?: Maybe<Scalars['DateTime']>;
  /** Start timestamp of the requested date range (optional) */
  requestDateRangeStartsAt?: Maybe<Scalars['DateTime']>;
  /** Canonical ID (UUID) of the enterprise account that requested this operation (optional) */
  requestedByCanonicalId?: Maybe<Scalars['String']>;
  /** ID of the user who requested this operation (optional) */
  requestedById?: Maybe<Scalars['BigInt']>;
  /** Name of the user who requested this operation (optional) */
  requestedByUserName?: Maybe<Scalars['String']>;
  /** Retailer ID associated with this operation */
  retailerId?: Maybe<Scalars['BigInt']>;
  /** Schedule type (one-off or recurring) */
  scheduleType?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Current status of the operation */
  status?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus>;
  /** Number of rows successfully processed (optional) */
  successfulRows?: Maybe<Scalars['Int']>;
  /** Summary of the operation (optional) */
  summary?: Maybe<Scalars['String']>;
  /** Total number of rows in the operation (optional) */
  totalRows?: Maybe<Scalars['Int']>;
  /** Timestamp when the record was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** List of warehouse location IDs associated with this operation */
  warehouseLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** The equipment (e.g. vehicle) assigned to a shift, if any. */
export type Instacart_Enterprise_Frigate_Shifts_V1_ShiftWithEquipment = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ShiftWithEquipment';
  equipment?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_Equipment>;
  shiftId?: Maybe<Scalars['BigInt']>;
};

/** Properties specific to a single (non-recurring) shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_SingleShiftProperties = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_SingleShiftProperties';
  endsAt?: Maybe<Scalars['DateTime']>;
  onCall?: Maybe<Scalars['Boolean']>;
  singleShiftId?: Maybe<Scalars['BigInt']>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

/** Represents a staffing allocation time slot with recommended and actual staffing levels. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocation = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingAllocation';
  actual?: Maybe<Scalars['Float']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  recommended?: Maybe<Scalars['Float']>;
  startsAt?: Maybe<Scalars['DateTime']>;
};

/** Staffing allocations for a specific date, split by dedicated and on-call. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationByDate = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingAllocationByDate';
  date?: Maybe<Google_Type_Date>;
  dedicatedAllocations?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocation>>>;
  oncallAllocations?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocation>>>;
};

/** Performance metrics for staffing allocation. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingAllocationMetrics = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingAllocationMetrics';
  matchRate?: Maybe<Scalars['Float']>;
  overstaffedHours?: Maybe<Scalars['Float']>;
  recommendedHours?: Maybe<Scalars['Float']>;
  scheduledDevices?: Maybe<Scalars['Float']>;
  scheduledGaps?: Maybe<Scalars['Float']>;
  totalHours?: Maybe<Scalars['Float']>;
  understaffedHours?: Maybe<Scalars['Float']>;
};

/** Represents staffing hours for a specific vertical type with optional overrides. */
export type Instacart_Enterprise_Frigate_Shifts_V1_StaffingHours = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_StaffingHours';
  closesAt?: Maybe<Scalars['DateTime']>;
  opensAt?: Maybe<Scalars['DateTime']>;
  overrides?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_Overrides>;
  timezoneName?: Maybe<Scalars['String']>;
  verticalType?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_VerticalType>;
};

/** Request message for unlocking a partner-managed driver's device. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceRequest_Input = {
  shopperId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message after attempting to unlock a driver's device. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UnlockPartnerManagedDriverDeviceResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_UnlockPartnerManagedDriverDeviceResponse';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

/** Request message for updating an existing partner-managed shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_Input = {
  deleteConflictingShifts?: InputMaybe<Scalars['Boolean']>;
  equipmentAssignment?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_EquipmentAssignment_Input>;
  isOnCall?: InputMaybe<Scalars['Boolean']>;
  recurringShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_RecurringShiftRequest_Input>;
  shiftId?: InputMaybe<Scalars['BigInt']>;
  singleShiftRequest?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_SingleShiftRequest_Input>;
};

/** Request details for updating a recurring shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_RecurringShiftRequest_Input = {
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  recurEndDate?: InputMaybe<Google_Type_Date_Input>;
  recurStartDate?: InputMaybe<Google_Type_Date_Input>;
  shiftLengthSeconds?: InputMaybe<Scalars['BigInt']>;
  shiftStartSecondsSinceMidnight?: InputMaybe<Scalars['BigInt']>;
};

/** Request details for updating a single shift. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftRequest_SingleShiftRequest_Input = {
  driverId?: InputMaybe<Scalars['BigInt']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

/** Response message after updating a partner-managed shift, including any conflicts. */
export type Instacart_Enterprise_Frigate_Shifts_V1_UpdatePartnerManagedShiftResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_UpdatePartnerManagedShiftResponse';
  updateShiftConflicts?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_PartnerManagedShiftConflict>>>;
};

/** Request to validate an already-uploaded bulk shift file */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileRequest_Input = {
  /** request without the record ID */
  followupScenario?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestFollowupScenario_Input>;
  /** request with the record ID */
  initialScenario?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestInitialScenario_Input>;
  /** Required request context */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for validating a bulk shift file */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse';
  /** Error payload containing validation errors */
  error?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_ErrorPayload>;
  /** Success payload containing operation record ID */
  success?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_SuccessPayload>;
};

/** Error details for validation failures */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse_Error';
  /** Human-readable error message */
  message?: Maybe<Scalars['String']>;
  /** Type of error that occurred during validation */
  type?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error_ErrorType>;
};

/** Error payload returned when validation fails */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_ErrorPayload = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse_ErrorPayload';
  /** List of validation errors */
  errors?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error>>>;
};

export enum Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_Error_ErrorType {
  ErrorTypeCsvMalformed = 'ERROR_TYPE_CSV_MALFORMED',
  ErrorTypeShopperAssignedToClosedStore = 'ERROR_TYPE_SHOPPER_ASSIGNED_TO_CLOSED_STORE',
  ErrorTypeShopperAssignedToMultipleWhls = 'ERROR_TYPE_SHOPPER_ASSIGNED_TO_MULTIPLE_WHLS',
  ErrorTypeShopperNotAssignedToProvidedWhl = 'ERROR_TYPE_SHOPPER_NOT_ASSIGNED_TO_PROVIDED_WHL',
  ErrorTypeShopperShiftOutsideOfStoreHours = 'ERROR_TYPE_SHOPPER_SHIFT_OUTSIDE_OF_STORE_HOURS',
  ErrorTypeUnknown = 'ERROR_TYPE_UNKNOWN',
  ErrorTypeWarehouseLocationDoesNotMatchRetailerId = 'ERROR_TYPE_WAREHOUSE_LOCATION_DOES_NOT_MATCH_RETAILER_ID'
}

/** Success payload returned when validation succeeds */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftFileResponse_SuccessPayload = {
  __typename?: 'instacart_enterprise_frigate_shifts_v1_ValidateBulkShiftFileResponse_SuccessPayload';
  /** operation status */
  recordStatus?: Maybe<Instacart_Enterprise_Frigate_Shifts_V1_OperationStatus>;
  /** ID of the shift management operation record created */
  shiftManagementOperationRecordId?: Maybe<Scalars['BigInt']>;
};

/** Validate request with the record ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestFollowupScenario_Input = {
  recordId?: InputMaybe<Scalars['BigInt']>;
};

/** Validate request without the record ID */
export type Instacart_Enterprise_Frigate_Shifts_V1_ValidateBulkShiftRequestInitialScenario_Input = {
  bulkShiftFileS3Key?: InputMaybe<Scalars['String']>;
  /** Optional. Canonical ID (UUID) of the enterprise account that requested this operation */
  requestedByCanonicalId?: InputMaybe<Scalars['String']>;
  requestedById?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  scheduleType?: InputMaybe<Instacart_Enterprise_Frigate_Shifts_V1_ScheduleType>;
  /** Optional. Target start date for when the shifts should begin */
  targetStartAt?: InputMaybe<Scalars['DateTime']>;
};

/** This will map to the vertical type in shared/protos/instacart/availability/v1/availability.proto, we only support pickup hours from IPP right now. */
export enum Instacart_Enterprise_Frigate_Shifts_V1_VerticalType {
  PickupHours = 'PICKUP_HOURS',
  VerticalTypeUnknown = 'VERTICAL_TYPE_UNKNOWN'
}

/** Values come from: https://instacart.atlassian.net/wiki/spaces/Catalog/pages/3541893127/Request+injection+with+request+data */
export type Instacart_Enterprise_Frigate_Types_V1_AuthorizationContext_Input = {
  /** The account ID of the initiating user. */
  accountId?: InputMaybe<Scalars['BigInt']>;
  /** The canonical ID of the initiating user. */
  canonicalId?: InputMaybe<Scalars['String']>;
  /** The email of the initiating user. */
  email?: InputMaybe<Scalars['String']>;
};

/** TimestampRange represents a time window with start and end times */
export type Instacart_Enterprise_Frigate_Types_V1_TimestampRange_Input = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

/** TypedError is designed to capture any error with its type represented as a string and any related data captured in the payload */
export type Instacart_Enterprise_Frigate_Types_V1_TypedError = {
  __typename?: 'instacart_enterprise_frigate_types_v1_TypedError';
  /** error_type defines the type or category of the error */
  errorType?: Maybe<Scalars['String']>;
  /**
   * payload may contain any additional information that relates to the error. It could be details about the error or context data that could help debug the error cause
   * ex: OrderValidationError
   */
  payload?: Maybe<Scalars['GoogleProtobufAnyScalar']>;
};

/** mirrors the Customers TypedErrorsResponse. */
export type Instacart_Enterprise_Frigate_Types_V1_TypedErrorsResponse = {
  __typename?: 'instacart_enterprise_frigate_types_v1_TypedErrorsResponse';
  typedErrors?: Maybe<Array<Maybe<Instacart_Enterprise_Frigate_Types_V1_TypedError>>>;
};

/** Request to create a new response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigRequest_Input = {
  /**
   * Body matchers for filtering requests (optional)
   * Map of JSON path expressions to regex patterns
   * All matchers must match for the config to be selected
   * Example: {"$.request_context.retailer_id": "^279$"}
   */
  bodyMatchers?: InputMaybe<Scalars['JSON']>;
  /**
   * Human-readable description (optional)
   * Example: "Mock for 1-800-Flowers order acceptance"
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Whether this configuration is active (required)
   * Set to false to disable without deleting
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Fulfillment provider ID filter
   * At least one of retailer_id or fulfillment_provider_id must be provided; both may be provided together
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /**
   * Path pattern for matching request method (required)
   * Regular expression pattern (RE2 syntax)
   * Examples: "forward_order_.*", "^v1/orders/[0-9]+$", "(create|update)_order"
   */
  pathPattern?: InputMaybe<Scalars['String']>;
  /**
   * Response payload in JSON format (required)
   * Supports JSON path references starting with "$."
   * Example: {"order_id": "$.request_context.order_id"}
   */
  responsePayload?: InputMaybe<Scalars['String']>;
  /**
   * gRPC status code to return (optional, defaults to "ok")
   * Examples: "ok", "internal", "not_found", "unavailable"
   * See pumpkin status codes for complete list
   */
  responseStatus?: InputMaybe<Scalars['String']>;
  /**
   * Retailer ID filter
   * At least one of retailer_id or fulfillment_provider_id must be provided; both may be provided together
   */
  retailerId?: InputMaybe<Scalars['String']>;
  /**
   * Optional retailer location IDs filter
   * If specified, config only matches requests from these locations
   * If empty, matches all locations
   */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Optional TTL as Unix epoch seconds
   * Configuration auto-deletes after this time
   * If 0 or not set, persists indefinitely
   */
  ttl?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the created response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_CreateResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_CreateResponseConfigResponse';
  /** The created response configuration */
  responseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>;
};

/**
 * Request to delete a response configuration.
 * WARNING: This is a destructive action and cannot be undone. Consider using
 * UpdateResponseConfig with enabled = false instead.
 */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigRequest_Input = {
  /**
   * Must match the fulfillment_provider_id of the configuration being deleted
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Configuration UUID */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Must match the retailer_id of the configuration being deleted
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** Response confirming deletion */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_DeleteResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_DeleteResponseConfigResponse';
  /** Success indicator */
  success?: Maybe<Scalars['Boolean']>;
};

/** Request to get a response configuration by ID */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigRequest_Input = {
  /**
   * Must match the fulfillment_provider_id of the configuration being retrieved
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Configuration UUID */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Must match the retailer_id of the configuration being retrieved
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** Response containing the retrieved response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_GetResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_GetResponseConfigResponse';
  /** The retrieved response configuration */
  responseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>;
};

/** Request to list response configurations with filters */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsRequest_Input = {
  /**
   * Optional filter by enabled status
   * If not set, returns both enabled and disabled
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /** Optional filter by fulfillment provider ID */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Maximum number of results per page (default 50, max 100) */
  pageSize?: InputMaybe<Scalars['Int']>;
  /**
   * Opaque cursor token for pagination
   * Empty string for first page
   * Use next_page_token from previous response for subsequent pages
   */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Optional filter by retailer ID */
  retailerId?: InputMaybe<Scalars['String']>;
  /** Optional filter by retailer location ID */
  retailerLocationId?: InputMaybe<Scalars['String']>;
};

/** Response containing list of response configurations with pagination */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ListResponseConfigsResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_ListResponseConfigsResponse';
  /**
   * Opaque cursor token for fetching the next page
   * Empty string if this is the last page
   * Pass this value as page_token in the next request
   */
  nextPageToken?: Maybe<Scalars['String']>;
  /** List of response configurations */
  responseConfigs?: Maybe<Array<Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>>>;
};

/** Complete response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_ResponseConfig';
  /**
   * Map of JSON path → regex pattern for request body matching
   * All matchers must match for config to apply
   * Key: JSON path expression (e.g., "$.request_context.retailer_id")
   * Value: Regex pattern (Go regex syntax) (e.g., "^[0-9]+$")
   */
  bodyMatchers?: Maybe<Scalars['JSON']>;
  /** Timestamp when configuration was created (ISO8601 format, e.g., "2025-01-01T00:00:00Z") */
  createdAt?: Maybe<Scalars['String']>;
  /** String identifier of user who created this configuration */
  createdBy?: Maybe<Scalars['String']>;
  /** Human-readable description of what this mock is for */
  description?: Maybe<Scalars['String']>;
  /** Whether this configuration is active */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Fulfillment provider ID to match
   * At least one of retailer_id or fulfillment_provider_id must be provided; both may be provided together
   */
  fulfillmentProviderId?: Maybe<Scalars['String']>;
  /** Unique configuration identifier (UUID format) */
  id?: Maybe<Scalars['String']>;
  /**
   * Regular expression pattern (RE2 syntax) for matching request path/method
   *
   * Common patterns:
   * - "forward_order_.*" - matches any forward_order method
   * - "^v1/.*" - must start with v1/
   * - "(create|update|delete)_order" - matches any of the verbs
   * - "(?i)forward_order" - case insensitive matching
   */
  pathPattern?: Maybe<Scalars['String']>;
  /**
   * Response payload in JSON format
   * String values starting with "$." are JSON path references
   */
  responsePayload?: Maybe<Scalars['String']>;
  /**
   * gRPC status code to return (e.g., "ok", "internal", "not_found", "unavailable")
   * See pumpkin status codes: https://github.com/instacart/carrot/blob/master/pumpkin/pumpkin-go/status/rpc_status.go
   * Uses string type for flexibility - can support HTTP codes in future (e.g., "200", "404", "500")
   */
  responseStatus?: Maybe<Scalars['String']>;
  /**
   * Retailer ID to match
   * At least one of retailer_id or fulfillment_provider_id must be provided; both may be provided together
   */
  retailerId?: Maybe<Scalars['String']>;
  /**
   * Optional list of retailer location IDs to match
   * If specified, config only applies to these locations
   * If empty, applies to all locations
   */
  retailerLocationIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Optional TTL as Unix epoch seconds
   * Configuration will be automatically deleted after this time
   * If 0, configuration persists indefinitely (defaults to 0)
   */
  ttl?: Maybe<Scalars['BigInt']>;
  /**
   * Timestamp when configuration was last updated (ISO8601 format)
   * Same as created_at if never updated
   */
  updatedAt?: Maybe<Scalars['String']>;
};

/** Request to trigger an inbound event from partner/retailer to Relay */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventRequest_Input = {
  /**
   * Event payload in JSON format (required)
   * Free-form JSON matching the shape that a partner/retailer would send to Instacart
   *
   * Example for updating order status event:
   *
   * {
   * "event": "order_status",
   * "data": {
   * "order_id": "abc123def456",
   * "status": "shipped"
   * }
   * }
   */
  eventPayload?: InputMaybe<Scalars['String']>;
  /**
   * DEPRECATED: Use fulfillment_provider_id instead
   * Kept for backward compatibility
   */
  fulfillmentPartnerId?: InputMaybe<Scalars['String']>;
  /**
   * Fulfillment provider ID for the event
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /**
   * Retailer ID for the event
   * At least one of retailer_id or fulfillment_provider_id must be provided
   */
  retailerId?: InputMaybe<Scalars['String']>;
};

/** Response from triggering an inbound event */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_TriggerInboundEventResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_TriggerInboundEventResponse';
  /** Indicates whether the event was successfully received and queued for processing */
  successfullyReceived?: Maybe<Scalars['Boolean']>;
};

/** Request to update an existing response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigRequest_Input = {
  /**
   * Updated body matchers for filtering requests (optional)
   * Map of JSON path expressions to regex patterns
   * All matchers must match for the config to be selected
   * Example: {"$.request_context.retailer_id": "^279$"}
   */
  bodyMatchers?: InputMaybe<Scalars['JSON']>;
  /**
   * Updated human-readable description (optional)
   * Example: "Mock for 1-800-Flowers order acceptance"
   */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Updated enabled status (required)
   * Set to false to disable without deleting
   */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Updated fulfillment provider ID filter
   * At least one of retailer_id or fulfillment_provider_id must be provided; both may be provided together
   */
  fulfillmentProviderId?: InputMaybe<Scalars['String']>;
  /** Configuration UUID to update (required) */
  id?: InputMaybe<Scalars['String']>;
  /**
   * Updated path pattern for matching request method (required)
   * Regular expression pattern (RE2 syntax)
   * Examples: "forward_order_.*", "^v1/orders/[0-9]+$", "(create|update)_order"
   */
  pathPattern?: InputMaybe<Scalars['String']>;
  /**
   * Updated response payload in JSON format (required)
   * Supports JSON path references starting with "$."
   * Example: {"order_id": "$.request_context.order_id"}
   */
  responsePayload?: InputMaybe<Scalars['String']>;
  /**
   * Updated gRPC status code to return (optional, defaults to "ok")
   * Examples: "ok", "internal", "not_found", "unavailable"
   * See pumpkin status codes for complete list
   */
  responseStatus?: InputMaybe<Scalars['String']>;
  /**
   * Updated retailer ID filter
   * At least one of retailer_id or fulfillment_provider_id must be provided; both may be provided together
   */
  retailerId?: InputMaybe<Scalars['String']>;
  /**
   * Updated retailer location IDs filter (optional)
   * If specified, config only matches requests from these locations
   * If empty, matches all locations
   */
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Updated TTL as Unix epoch seconds (optional)
   * Configuration auto-deletes after this time
   * If 0, persists indefinitely
   */
  ttl?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the updated response configuration */
export type Instacart_Enterprise_Fulfillment_Partner_Testing_V1_UpdateResponseConfigResponse = {
  __typename?: 'instacart_enterprise_fulfillment_partner_testing_v1_UpdateResponseConfigResponse';
  /** The updated response configuration */
  responseConfig?: Maybe<Instacart_Enterprise_Fulfillment_Partner_Testing_V1_ResponseConfig>;
};

/** Request payload for the Advance Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchRequest_Input = {
  alcoholic?: InputMaybe<Scalars['Boolean']>;
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['String']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Advance Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AdvanceBatchResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_AdvanceBatchResponse';
  workflowState?: Maybe<Scalars['String']>;
};

/**
 * AuthContext stores the account ID for the request,
 * making it possible to gate feature requests based on the logged in user.
 */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input = {
  accountId?: InputMaybe<Scalars['BigInt']>;
};

/** Request payload for the Create Shopper call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperRequest_Input = {
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  email?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Create Shopper call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_CreateShopperResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_CreateShopperResponse';
  /** Response payload for the Create Shopper call */
  id?: Maybe<Scalars['BigInt']>;
};

/** Request payload for the Generate Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  batchType?: InputMaybe<Scalars['String']>;
  /**
   * Total staged bag count for the generated batch. Must be non-negative.
   * If unset, no staged bag count override is requested.
   */
  numberOfBags?: InputMaybe<Scalars['BigInt']>;
  orders?: InputMaybe<Array<InputMaybe<Instacart_Customers_Connect_Platform_V1_Order_Input>>>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  workflowState?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Generate Batch call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GenerateBatchResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GenerateBatchResponse';
  id?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Scalars['String']>;
};

/** The response of the get barcode request. */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetBarcodeResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GetBarcodeResponse';
  /** Null if checkout has not started yet. */
  barcode?: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_Barcode>;
};

/** Request payload for the Get Checkout State and Barcode call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeRequest_Input = {
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
};

/** Response payload for the Get Checkout State and Barcode call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateAndBarcodeResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GetCheckoutStateAndBarcodeResponse';
  barcode?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetBarcodeResponse>;
  checkoutState?: Maybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateResponse>;
};

/** The response to get the checkout state. */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_GetCheckoutStateResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_GetCheckoutStateResponse';
  checkoutState?: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutState>;
};

/** Entiry representing a scanned string from a Shopper Order Item */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperOrderItemScan_Input = {
  scannedString?: InputMaybe<Scalars['String']>;
  scannedStringType?: InputMaybe<Scalars['String']>;
};

/** Request payload for the Update Shopper Order Item call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemRequest_Input = {
  adminRequestContext?: InputMaybe<Instacart_Customers_Connect_Platform_V1_AdminRequestContext_Input>;
  authContext?: InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_AuthContext_Input>;
  deliveredCount?: InputMaybe<Scalars['BigInt']>;
  deliveredWeight?: InputMaybe<Scalars['Float']>;
  lineNum?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['String']>;
  orderItemId?: InputMaybe<Scalars['BigInt']>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  rrc?: InputMaybe<Scalars['String']>;
  scans?: InputMaybe<Array<InputMaybe<Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_ShopperOrderItemScan_Input>>>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Scalars['String']>;
  substituteId?: InputMaybe<Scalars['BigInt']>;
  upc?: InputMaybe<Scalars['String']>;
};

/** Response payload for the Update Shopper Order Item call */
export type Instacart_Enterprise_Fulfillment_Simulation_Engine_V1_UpdateShopperOrderItemResponse = {
  __typename?: 'instacart_enterprise_fulfillment_simulation_engine_v1_UpdateShopperOrderItemResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * AddChangeRequestReviewRequest posts a review (approve/reject/cancel) to the AMS approval request
 * associated with a change request.
 */
export type Instacart_Eversight_Item_Price_Management_V1_AddChangeRequestReviewRequest_Input = {
  /** The review action to take. */
  action?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequestReviewAction>;
  /**
   * AMS approval request ID associated with the change request. Used by the
   * GraphQL Mesh to resource-scope authorization against the approval request
   * before forwarding the call; the handler does not read this field.
   */
  approvalRequestId?: InputMaybe<Scalars['String']>;
  /** User identity injected by Mesh. Do not set from the client. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** The ID of the change request being reviewed. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Optional reviewer comment. */
  comment?: InputMaybe<Scalars['String']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** AddChangeRequestReviewResponse returns identifiers for the review and approval request. */
export type Instacart_Eversight_Item_Price_Management_V1_AddChangeRequestReviewResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_AddChangeRequestReviewResponse';
  /** The AMS approval request ID the review was posted to. */
  approvalRequestId?: Maybe<Scalars['String']>;
  /** The newly-posted review ID. */
  reviewId?: Maybe<Scalars['String']>;
};

/** AdminMarkupPartner is one partner-level summary row. */
export type Instacart_Eversight_Item_Price_Management_V1_AdminMarkupPartner = {
  __typename?: 'instacart_eversight_item_price_management_v1_AdminMarkupPartner';
  /**
   * average_markup_rate is the trailing 7-day markup rate calculated from
   * total sales dollars (SUM(markup_usd)/SUM(pre_markup_usd), e.g. 0.15 = 15%).
   * DoubleValue so "no data" is distinguishable from 0%. Null when any active
   * rule for the partner is missing a required dollar value, so no partial
   * aggregate is shown.
   */
  averageMarkupRate?: Maybe<Scalars['Float']>;
  /**
   * last_rule_updated_at is MAX(rules.last_updated_at) for the partner's active
   * rules. Null when no active rule has a set value.
   */
  lastRuleUpdatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * markup_refreshed_at is MAX(rules.markup_refreshed_at) over the partner's
   * active rules: the most recent trailing-7-day refresh. Null when no active
   * rule has a set value.
   */
  markupRefreshedAt?: Maybe<Scalars['DateTime']>;
  /**
   * markup_usd_total is the trailing 7-day total markup dollars across the
   * partner's active rules. DoubleValue so null is distinguishable from $0.
   */
  markupUsdTotal?: Maybe<Scalars['Float']>;
  /** partner_id is the brand partner ID. */
  partnerId?: Maybe<Scalars['BigInt']>;
  /** partner_name is hydrated from the partners service; empty when unresolved. */
  partnerName?: Maybe<Scalars['String']>;
  /**
   * pre_markup_usd_total is the trailing 7-day total pre-markup charge dollars
   * (the denominator of average_markup_rate). DoubleValue; null when incomplete.
   */
  preMarkupUsdTotal?: Maybe<Scalars['Float']>;
  /** rule_count is the number of active rules contributing to the summary. */
  ruleCount?: Maybe<Scalars['BigInt']>;
};

/** AdminMarkupRule is one rule-level row. */
export type Instacart_Eversight_Item_Price_Management_V1_AdminMarkupRule = {
  __typename?: 'instacart_eversight_item_price_management_v1_AdminMarkupRule';
  /**
   * average_markup_rate is the trailing 7-day markup rate calculated from total
   * sales dollars (0.15 = 15%). DoubleValue; null when no data is available.
   */
  averageMarkupRate?: Maybe<Scalars['Float']>;
  /**
   * channel is the storefront scope: "marketplace" or "storefront", or empty
   * (for all channels). "all" is a display alias for the unrestricted case,
   * not a stored value.
   */
  channel?: Maybe<Scalars['String']>;
  /** id is IPM's database primary key for this rule version. */
  id?: Maybe<Scalars['BigInt']>;
  /** last_updated_at is the user-meaningful last edit time for this rule. */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /** markup_multiple is the target multiple (e.g. 1.15). DoubleValue; null when unset. */
  markupMultiple?: Maybe<Scalars['Float']>;
  /**
   * markup_refreshed_at is when this rule's trailing-7-day markup values were
   * last refreshed. Null until the first refresh run.
   */
  markupRefreshedAt?: Maybe<Scalars['DateTime']>;
  /**
   * markup_type is the stored strategy: maintain_target, flat_markup,
   * post_discount_flat_markup, or no_markup.
   */
  markupType?: Maybe<Scalars['String']>;
  /**
   * markup_usd_total is the rule's trailing 7-day markup dollars. DoubleValue;
   * null when unset.
   */
  markupUsdTotal?: Maybe<Scalars['Float']>;
  /** membership is the rule's membership filter (empty/"all" means unrestricted). */
  membership?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  /** partner_name is hydrated from the partners service; empty when unresolved. */
  partnerName?: Maybe<Scalars['String']>;
  /**
   * pre_markup_usd_total is the rule's trailing 7-day pre-markup dollars.
   * DoubleValue; null when unset.
   */
  preMarkupUsdTotal?: Maybe<Scalars['Float']>;
  /** priority is the server-derived rule priority (lower ranks first). */
  priority?: Maybe<Scalars['BigInt']>;
  productGroupId?: Maybe<Scalars['BigInt']>;
  /**
   * product_group_name is the display name of the rule's product group,
   * hydrated from the product group row. Empty when the rule has no product
   * group.
   */
  productGroupName?: Maybe<Scalars['String']>;
  /**
   * product_group_type is the Type of the rule's product group, hydrated from
   * the product group row. Empty when the rule has no product group.
   */
  productGroupType?: Maybe<Scalars['String']>;
  /** service_type is the rule's service filter (empty means unrestricted). */
  serviceType?: Maybe<Scalars['String']>;
  storeGroupId?: Maybe<Scalars['BigInt']>;
  /**
   * store_group_name is the display name of the rule's store group, hydrated
   * from the store group row. Empty when the rule has no store group.
   */
  storeGroupName?: Maybe<Scalars['String']>;
  /**
   * store_group_type is the Type of the rule's store group, hydrated from the
   * store group row. Empty when the rule has no store group.
   */
  storeGroupType?: Maybe<Scalars['String']>;
};

/**
 * AuthorizationContext carries user identity injected by the GraphQL Mesh
 * request-data-injection transform. Required because pumpkin auth headers
 * are not forwarded through Mesh, so auth.GetCurrentUser returns anonymous.
 */
export type Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input = {
  /**
   * account_id is the user's numeric account ID. IPM uses this only for
   * runtime feature gating; it is never persisted in audit fields.
   */
  accountId?: InputMaybe<Scalars['String']>;
  /** canonical_id is the user's canonical UUID. */
  canonicalId?: InputMaybe<Scalars['String']>;
  /** Legacy field. IPM no longer injects or uses email for audit attribution. */
  email?: InputMaybe<Scalars['String']>;
  /** Legacy field. IPM no longer injects or uses IP address for audit attribution. */
  ipAddress?: InputMaybe<Scalars['String']>;
};

/** ChangeRequest represents a batch of proposed rule changes. */
export type Instacart_Eversight_Item_Price_Management_V1_ChangeRequest = {
  __typename?: 'instacart_eversight_item_price_management_v1_ChangeRequest';
  /** Timestamp when this CR was set to active (NULL if never activated). */
  activatedAt?: Maybe<Scalars['DateTime']>;
  /** AMS approval request ID once the CR has been submitted for multi-layer review. Empty for drafts. */
  amsApprovalRequestId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Display name of the user who created this CR. */
  createdBy?: Maybe<Scalars['String']>;
  dateImplemented?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Timestamp when this CR was superseded into the inactive state by a newer
   * active CR (NULL while still active or never activated).
   */
  inactivatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * ID of the CR that replaced this one (set when this CR transitioned from
   * active → inactive). Zero if not applicable.
   */
  inactivatedByChangeRequestId?: Maybe<Scalars['BigInt']>;
  /** Display name of the CR that replaced this one. Empty if not applicable. */
  inactivatedByChangeRequestName?: Maybe<Scalars['String']>;
  /** Natural key — set at creation, immutable after. Identifies the project in the UI. */
  name?: Maybe<Scalars['String']>;
  /** Partner that owns this change request. */
  partnerId?: Maybe<Scalars['BigInt']>;
  /** Number of rules where the proposed state differs from the baseline. */
  rulesModified?: Maybe<Scalars['Int']>;
  /**
   * Scope drift between this CR's captured creation scope and the active
   * CR's last-published scope (retailer_ids + SFP store_config_ids).
   * Unset when the CR has no captured scope or when there is no drift.
   */
  scopeDiff?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeDiff>;
  status?: Maybe<Scalars['String']>;
  /**
   * Timestamp at which this CR was submitted (i.e. left draft and entered
   * the admin_review tier). NULL while still draft and for any CR created
   * before submit existed; non-NULL once submitted, even after subsequent
   * review-tier advances or terminal transitions.
   */
  submittedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Display name of the user who submitted this CR. Empty until first submit;
   * not overwritten when the CR is re-submitted from a later state.
   */
  submittedBy?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Timestamp at which this CR entered the withdrawn terminal state. NULL
   * until the CR is withdrawn. Withdrawal has two attribution shapes,
   * discriminated by which of (withdrawn_by_change_request_id, withdrawn_by)
   * is populated; exactly one is set when withdrawn_at is non-NULL.
   */
  withdrawnAt?: Maybe<Scalars['DateTime']>;
  /**
   * Display name of the user who explicitly withdrew this CR. Empty when
   * this CR is not withdrawn or when withdrawal was system-driven; mutually
   * exclusive with withdrawn_by_change_request_id.
   */
  withdrawnBy?: Maybe<Scalars['String']>;
  /**
   * Identifies the withdrawing CR when this CR was withdrawn as part of
   * another CR's promotion to active (an automatic, system-driven
   * withdrawal). Zero when this CR is not withdrawn or was withdrawn by a
   * user action; mutually exclusive with withdrawn_by.
   */
  withdrawnByChangeRequestId?: Maybe<Scalars['BigInt']>;
  /**
   * Display name of the withdrawing CR at the moment of withdrawal,
   * snapshotted so the attribution stays stable even if that CR is later
   * renamed. Empty when withdrawn_by_change_request_id is zero.
   */
  withdrawnByChangeRequestName?: Maybe<Scalars['String']>;
};

/**
 * ChangeRequestReviewAction enumerates the actions a reviewer can take on a change request.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Eversight_Item_Price_Management_V1_ChangeRequestReviewAction {
  ChangeRequestReviewActionApprove = 'CHANGE_REQUEST_REVIEW_ACTION_APPROVE',
  ChangeRequestReviewActionCancel = 'CHANGE_REQUEST_REVIEW_ACTION_CANCEL',
  ChangeRequestReviewActionReject = 'CHANGE_REQUEST_REVIEW_ACTION_REJECT',
  ChangeRequestReviewActionUnknown = 'CHANGE_REQUEST_REVIEW_ACTION_UNKNOWN'
}

/** ChangeRequestRule represents a single rule snapshot within a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_ChangeRequestRule = {
  __typename?: 'instacart_eversight_item_price_management_v1_ChangeRequestRule';
  /** Change request this rule belongs to. */
  changeRequestId?: Maybe<Scalars['BigInt']>;
  /** Channel filter (e.g. "marketplace", "storefront", "all"). */
  channel?: Maybe<Scalars['String']>;
  /** Creation timestamp. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Edit state of this rule within the change request. */
  editState?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleEditState>;
  /**
   * Fulfillment provider filter. Unset means all fulfillment providers.
   * Int64Value (not bare int64) preserves the unset/zero distinction.
   */
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  /** Rule primary key. */
  id?: Maybe<Scalars['BigInt']>;
  /** Serialized markup action JSON. */
  markupAction?: Maybe<Scalars['String']>;
  /** Maximum markup in dollars (e.g. "10.00"). Empty means no cap. */
  markupDollarMax?: Maybe<Scalars['String']>;
  /** Maximum price change in dollars constraint (e.g. "5" means $5.00). */
  maxPriceChangeDollars?: Maybe<Scalars['String']>;
  /** Membership filter (e.g. "all", "instacart_plus", "loyalty"). */
  membership?: Maybe<Scalars['String']>;
  /** Rule name. */
  name?: Maybe<Scalars['String']>;
  /** Original item_pricing_rule_id for version tracking. */
  originalItemPricingRuleId?: Maybe<Scalars['BigInt']>;
  /** Baseline rule for diff highlighting. Null if no previous version (new rule). */
  originalRule?: Maybe<Instacart_Eversight_Item_Price_Management_V1_OriginalRule>;
  /** ID of the previous version of this rule (self-referencing FK). */
  previousRuleId?: Maybe<Scalars['BigInt']>;
  /** Maximum markup percent constraint (e.g. "20" means 20%). Display string, stored as a ratio. */
  priceMaxPercent?: Maybe<Scalars['String']>;
  /** Minimum markup percent constraint (e.g. "9" means 9%). Display string, stored as a ratio. */
  priceMinPercent?: Maybe<Scalars['String']>;
  /** Price tier rows for "price_tier" markup rules. Empty for all other markup types. */
  priceTiers?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_PriceTier>>>;
  /**
   * Implied priority within the CR's rule set, derived server-side from scope
   * specificity. Lower numbers rank first; gapped (10, 20, 30…). 0 is
   * unassigned and ranks after assigned priorities. Inferred, never client-set.
   */
  priority?: Maybe<Scalars['BigInt']>;
  /** Product group referenced by this rule (resolved from FK). */
  productGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>;
  /** Rounding strategy, IPM-owned enum. */
  roundingType?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  /** Service type filter (e.g. "delivery", "pickup", "all"). */
  serviceType?: Maybe<Scalars['String']>;
  /** Store group referenced by this rule (resolved from FK). */
  storeGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>;
  /** Last update timestamp. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/**
 * ConflictType classifies why a rule's implied priority cannot be resolved
 * against the existing rule set. Returned with a RuleConflict.
 */
export enum Instacart_Eversight_Item_Price_Management_V1_ConflictType {
  /**
   * The candidate overlaps an existing rule but neither is strictly more
   * specific, so there is no implied order between them.
   */
  ConflictTypeAmbiguous = 'CONFLICT_TYPE_AMBIGUOUS',
  /** The candidate has the exact same scope as an existing rule. */
  ConflictTypeDuplicate = 'CONFLICT_TYPE_DUPLICATE',
  /** Default; not a conflict. */
  ConflictTypeUnknown = 'CONFLICT_TYPE_UNKNOWN'
}

/** CreateChangeRequestRequest is the request for creating a new change request. */
export type Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  dateImplemented?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Partner that owns this change request. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Full product group definitions to create atomically with the CR.
   * When set, takes precedence over the clone flow (item_pricing_rule_ids / clone_all_rules).
   */
  productGroups?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupPayload_Input>>>;
  /** Full rule definitions to create atomically with the CR. */
  rules?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RulePayload_Input>>>;
  /** Full store group definitions to create atomically with the CR. */
  storeGroups?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupPayload_Input>>>;
};

/** CreateChangeRequestResponse is the response for creating a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_CreateChangeRequestResponse';
  changeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequest>;
  /**
   * Prioritization conflicts in the proposed rule set. When non-empty, no
   * change request was created: the full set could not be assigned unambiguous
   * priorities (duplicate or ambiguous overlap). change_request is unset.
   */
  conflicts?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleConflict>>>;
};

/** CreateChangeRequestRuleRequest creates a new rule within a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestRuleRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** ID of the change request to add the rule to. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Channel filter: "all", "marketplace", or "storefront". */
  channel?: InputMaybe<Scalars['String']>;
  /** Fulfillment provider filter. Unset means all fulfillment providers. */
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  /** Maximum markup in dollars (e.g. "10.00"). */
  markupDollarMax?: InputMaybe<Scalars['String']>;
  /** Markup percentage as a decimal string (e.g. "15" means 15%). */
  markupPercent?: InputMaybe<Scalars['String']>;
  /** Markup type: "maintain_target", "no_markup", "flat_markup", or "price_tier". */
  markupType?: InputMaybe<Scalars['String']>;
  /** Maximum price change in dollars (e.g. "5.00"). */
  maxPriceChangeDollars?: InputMaybe<Scalars['String']>;
  /** Membership filter: "all", "instacart_plus", or "loyalty". */
  membership?: InputMaybe<Scalars['String']>;
  /** Rule name — required, must be non-empty. */
  name?: InputMaybe<Scalars['String']>;
  /** Partner ID for tenant scoping. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Maximum price as percent of catalog price (e.g. "110" means 110%). */
  priceMaxPercent?: InputMaybe<Scalars['String']>;
  /** Minimum price as percent of catalog price (e.g. "90" means 90%). */
  priceMinPercent?: InputMaybe<Scalars['String']>;
  /** Price tier rows for "price_tier" markup rules. Empty for all other markup types. */
  priceTiers?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_PriceTier_Input>>>;
  /** Product group FK — 0 means no product group restriction. */
  productGroupId?: InputMaybe<Scalars['BigInt']>;
  /** Rounding strategy, IPM-owned enum. */
  roundingType?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  /** Service type filter: "all", "delivery", or "pickup". */
  serviceType?: InputMaybe<Scalars['String']>;
  /** Store group FK — 0 means no store group restriction. */
  storeGroupId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * CreateChangeRequestRuleResponse returns the newly created rule, or a conflict
 * if the prioritization check rejected the save.
 */
export type Instacart_Eversight_Item_Price_Management_V1_CreateChangeRequestRuleResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_CreateChangeRequestRuleResponse';
  /**
   * Set when the save was rejected by the prioritization check: every existing
   * rule the candidate conflicts with. When non-empty, rule is null and nothing
   * was persisted.
   */
  conflicts?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleConflict>>>;
  /** The newly created rule snapshot within the change request. Null if conflicts is set. */
  rule?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequestRule>;
};

/**
 * DebugAdvanceChangeRequestRequest advances a draft or review-tier change request
 * by one debug lifecycle step without creating or mutating an AMS approval request.
 */
export type Instacart_Eversight_Item_Price_Management_V1_DebugAdvanceChangeRequestRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** ID of the change request to advance. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** DebugAdvanceChangeRequestResponse returns the change request after it was advanced. */
export type Instacart_Eversight_Item_Price_Management_V1_DebugAdvanceChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_DebugAdvanceChangeRequestResponse';
  changeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequest>;
};

/** DeleteChangeRequestRequest is the request for deleting a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_DeleteChangeRequestRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** DeleteChangeRequestResponse is the response for deleting a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_DeleteChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_DeleteChangeRequestResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/** DeleteChangeRequestRuleRequest removes a rule from a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_DeleteChangeRequestRuleRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** ID of the change request the rule belongs to. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** ID of the rule to delete. */
  ruleId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * DimensionExplanation names a scope dimension that contributes to an ambiguous
 * conflict, with a human-readable explanation of why it is ambiguous.
 */
export type Instacart_Eversight_Item_Price_Management_V1_DimensionExplanation = {
  __typename?: 'instacart_eversight_item_price_management_v1_DimensionExplanation';
  /** Scope dimension, e.g. "store_group", "product_group", "service_type". */
  dimension?: Maybe<Scalars['String']>;
  /** Human-readable reason this dimension leaves the pair ambiguous. */
  explanation?: Maybe<Scalars['String']>;
};

/** GetChangeRequestRequest is the request for getting a single change request. */
export type Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional presentation hint that narrows returned rules to retailer scopes
   * relevant to the caller. The handler bounds these IDs to the CR's trusted
   * partner topology; this field is never authorization input.
   */
  ruleResourceScopeFilter?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RuleResourceScopeFilter_Input>;
};

/** GetChangeRequestResponse is the response for getting a single change request with rules and group changes. */
export type Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_GetChangeRequestResponse';
  /** The change request metadata. */
  changeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequest>;
  /** Proposed product group changes within this CR. */
  productGroupChanges?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupChange>>>;
  /** Rule snapshots within this CR. */
  rules?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequestRule>>>;
  /** Proposed store group changes within this CR. */
  storeGroupChanges?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupChange>>>;
};

/** GetChangeRequestSamplePricesRequest fetches sample price impact for a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestSamplePricesRequest_Input = {
  /** ID of the change request. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Number of sample items to generate per rule (default 5). */
  sampleSize?: InputMaybe<Scalars['Int']>;
};

/** GetChangeRequestSamplePricesResponse contains sample price changes for review. */
export type Instacart_Eversight_Item_Price_Management_V1_GetChangeRequestSamplePricesResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_GetChangeRequestSamplePricesResponse';
  /**
   * True when at least one child rule / store_group / product_group of the
   * change request has been updated after snapshot_taken_at, meaning the
   * snapshot no longer reflects the CR's current state. Always false when
   * snapshot_taken_at is unset.
   */
  rulesDirtySinceSnapshot?: Maybe<Scalars['Boolean']>;
  /** List of sample price changes across all rules. */
  samplePriceChanges?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_SamplePriceChange>>>;
  /**
   * When the persisted snapshot for this change request was captured. Unset
   * when no snapshot exists (rows were computed live from the current rule
   * set). When set, sample_price_changes was read from the snapshot table
   * instead of recomputed.
   */
  snapshotTakenAt?: Maybe<Scalars['DateTime']>;
  /** Total number of sample price change items. */
  totalItems?: Maybe<Scalars['Int']>;
};

/** GetPartnerAlcoholMarkupProhibitedStatesRequest identifies a brand partner. */
export type Instacart_Eversight_Item_Price_Management_V1_GetPartnerAlcoholMarkupProhibitedStatesRequest_Input = {
  /**
   * partner_id is the brand partner whose retailers are being queried.
   * The server derives the retailer set from this ID via the partners
   * service (CP-918 trust boundary); callers do NOT supply retailer IDs.
   */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * GetPartnerAlcoholMarkupProhibitedStatesResponse returns one entry per
 * retailer owned by the partner. Retailers with no prohibited-states row
 * in retailer_settings return an empty list (expected pre-sync state).
 */
export type Instacart_Eversight_Item_Price_Management_V1_GetPartnerAlcoholMarkupProhibitedStatesResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_GetPartnerAlcoholMarkupProhibitedStatesResponse';
  /**
   * entries lists prohibited state/province codes per retailer owned by
   * the requested partner.
   */
  entries?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_RetailerAlcoholMarkupProhibitedStates>>>;
};

/** GetProductGroupRequest identifies a product group by ID within a partner. */
export type Instacart_Eversight_Item_Price_Management_V1_GetProductGroupRequest_Input = {
  /** Product group primary key. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Partner scope for access control. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetProductGroupResponse returns a single product group. */
export type Instacart_Eversight_Item_Price_Management_V1_GetProductGroupResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_GetProductGroupResponse';
  /** The requested product group. */
  productGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>;
};

/** GetStoreGroupRequest fetches a single store group by ID. */
export type Instacart_Eversight_Item_Price_Management_V1_GetStoreGroupRequest_Input = {
  /** id is the store group ID. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** partner_id is used to scope the lookup to the correct partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** GetStoreGroupResponse returns a single store group with its elements. */
export type Instacart_Eversight_Item_Price_Management_V1_GetStoreGroupResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_GetStoreGroupResponse';
  /** store_group is the requested store group. */
  storeGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>;
};

/**
 * ListAdminMarkupPartnersRequest filters and paginates a cross-partner,
 * partner-level markup summary. Requires item_price_management.view plus
 * all_partners_full_access; the backend returns all active partners and does
 * not apply per-caller partner filtering in this revision.
 */
export type Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupPartnersRequest_Input = {
  /**
   * authorization_context carries the caller identity and account used by the
   * runtime feature gate. Not used for audit attribution on this read-only RPC.
   */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** page is the 1-based page number. */
  page?: InputMaybe<Scalars['Int']>;
  /** page_size is the number of partners per page. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /**
   * partner_ids optionally restricts the summary to the listed partners.
   * Empty means all partners with at least one active rule.
   */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * sort_by is the partner summary sort field, whitelisted server-side.
   * Allowed: partner_id, average_markup_rate, last_rule_updated_at, rule_count.
   */
  sortBy?: InputMaybe<Scalars['String']>;
  /** sort_direction is "asc" or "desc" (case-insensitive). Defaults to "asc". */
  sortDirection?: InputMaybe<Scalars['String']>;
};

/** ListAdminMarkupPartnersResponse contains one page of partner summaries. */
export type Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupPartnersResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListAdminMarkupPartnersResponse';
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  partners?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_AdminMarkupPartner>>>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/**
 * ListAdminMarkupRulesRequest filters and paginates a cross-partner, rule-level
 * view of active rules. Requires item_price_management.view plus
 * all_partners_full_access; the backend returns active rules across all partners
 * and does not apply per-caller partner filtering in this revision.
 */
export type Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupRulesRequest_Input = {
  /**
   * authorization_context carries the caller identity and account used by the
   * runtime feature gate. Not used for audit attribution on this read-only RPC.
   */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /**
   * channels filters by exact rules.channel (storefront scope): "marketplace"
   * or "storefront". Does NOT match "all"/null.
   */
  channels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** markup_types filters by exact rules.markup_type values (OR within the set). */
  markupTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * memberships filters by exact rules.membership values. Does NOT match
   * "all"/null.
   */
  memberships?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** page is the 1-based page number. */
  page?: InputMaybe<Scalars['Int']>;
  /** page_size is the number of rules per page. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /**
   * partner_ids optionally restricts rules to the listed partners. Empty means
   * all partners.
   */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * product_group_types filters by the Type of the rule's product group. Rules
   * without a product group are excluded.
   */
  productGroupTypes?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupType>>>;
  /**
   * service_types filters by exact rules.service_type: "delivery" or "pickup".
   * Does NOT match unrestricted (null) rules.
   */
  serviceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * sort_by is the rule sort field, whitelisted server-side. Allowed:
   * partner_id, name, markup_type, priority, last_updated_at, average_markup_rate.
   */
  sortBy?: InputMaybe<Scalars['String']>;
  /** sort_direction is "asc" or "desc" (case-insensitive). Defaults to "asc". */
  sortDirection?: InputMaybe<Scalars['String']>;
  /**
   * store_group_types filters by the Type of the rule's store group. Rules
   * without a store group are excluded.
   */
  storeGroupTypes?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupType>>>;
};

/** ListAdminMarkupRulesResponse contains one page of admin rule rows. */
export type Instacart_Eversight_Item_Price_Management_V1_ListAdminMarkupRulesResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListAdminMarkupRulesResponse';
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  rules?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_AdminMarkupRule>>>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/** ListChangeRequestsRequest is the request for listing change requests with filters. */
export type Instacart_Eversight_Item_Price_Management_V1_ListChangeRequestsRequest_Input = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Partner ID for tenant scoping. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  /**
   * Deprecated as of CP-764: superseded by `statuses` (field 11). The field
   * number is reserved here so the wire format stays stable — removing or
   * repurposing field 6 would break protobuf deserialization for any retained
   * binary log of older requests. The handler does NOT read this field; old
   * callers that send only field 6 will get unfiltered results. There is no
   * functional fallback: all callers (FE + mesh) ship `statuses` in this PR.
   */
  statusFilter?: InputMaybe<Scalars['String']>;
  /**
   * Lifecycle status filter. Multi-valued so the list page can ask for
   * sibling/peer sets (e.g. all in-flight statuses) in one call. Empty list
   * means "no status filter". Replaces the deprecated singleton field 6.
   */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ListChangeRequestsResponse is the response for listing change requests. */
export type Instacart_Eversight_Item_Price_Management_V1_ListChangeRequestsResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListChangeRequestsResponse';
  changeRequests?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequest>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** ListProductGroupsRequest fetches paginated product groups for a partner. */
export type Instacart_Eversight_Item_Price_Management_V1_ListProductGroupsRequest_Input = {
  /**
   * change_request_id, when set, returns only groups belonging to this draft CR.
   * Used in CR edit mode so newly-staged groups are visible before the CR is activated.
   */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** 1-based page number. */
  page?: InputMaybe<Scalars['Int']>;
  /** Number of records per page. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Partner to list groups for. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Optional name search filter. */
  search?: InputMaybe<Scalars['String']>;
};

/** ListProductGroupsResponse contains paginated product groups. */
export type Instacart_Eversight_Item_Price_Management_V1_ListProductGroupsResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListProductGroupsResponse';
  /** Product groups for the requested page. */
  productGroups?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>>>;
  /** Total number of matching product groups. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** ListRulesRequest filters rules by IDs and name, scoped by partner. */
export type Instacart_Eversight_Item_Price_Management_V1_ListRulesRequest_Input = {
  itemPricingRuleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  nameFilter?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_PaginationRequest_Input>;
  /** Partner ID for multi-tenant scoping. Required. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** ListRulesResponse contains paginated rules. */
export type Instacart_Eversight_Item_Price_Management_V1_ListRulesResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListRulesResponse';
  pagination?: Maybe<Instacart_Eversight_Item_Price_Management_V1_PaginationResponse>;
  rules?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_Rule>>>;
};

/** ListStoreGroupsRequest fetches paginated store groups for a partner. */
export type Instacart_Eversight_Item_Price_Management_V1_ListStoreGroupsRequest_Input = {
  /**
   * change_request_id, when set, returns only groups belonging to this draft CR.
   * Used in CR edit mode so newly-staged groups are visible before the CR is activated.
   */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** page is the 1-based page number. */
  page?: InputMaybe<Scalars['Int']>;
  /** page_size is the number of results per page. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** partner_id filters groups to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** ListStoreGroupsResponse returns paginated store groups with total count. */
export type Instacart_Eversight_Item_Price_Management_V1_ListStoreGroupsResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListStoreGroupsResponse';
  /** store_groups is the list of store groups for the requested page. */
  storeGroups?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>>>;
  /** total_count is the total number of store groups for the partner. */
  totalCount?: Maybe<Scalars['Int']>;
};

/** ListStoresRequest fetches stores for a given retailer (banner) or partner. */
export type Instacart_Eversight_Item_Price_Management_V1_ListStoresRequest_Input = {
  /**
   * partner_id fetches stores across all banners under the partner.
   * Used when no specific banner is selected. Ignored if retailer_id is set.
   */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** retailer_id fetches stores for a single banner. Takes precedence over partner_id. */
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** ListStoresResponse returns all stores for the requested retailer or partner. */
export type Instacart_Eversight_Item_Price_Management_V1_ListStoresResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ListStoresResponse';
  stores?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_Store>>>;
};

/** OriginalRule contains the baseline rule data for diff comparison. */
export type Instacart_Eversight_Item_Price_Management_V1_OriginalRule = {
  __typename?: 'instacart_eversight_item_price_management_v1_OriginalRule';
  /** Channel filter. */
  channel?: Maybe<Scalars['String']>;
  /** Fulfillment provider filter of the original rule. Unset = "all". */
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  /** Serialized markup action JSON. */
  markupAction?: Maybe<Scalars['String']>;
  /** Membership filter. */
  membership?: Maybe<Scalars['String']>;
  /** Rule name. */
  name?: Maybe<Scalars['String']>;
  /** Product group referenced by the original rule. */
  productGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>;
  /** Baseline rounding strategy, IPM-owned enum. */
  roundingType?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  /** Service type filter. */
  serviceType?: Maybe<Scalars['String']>;
  /** Store group referenced by the original rule. */
  storeGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>;
};

/** PaginationRequest specifies page number and page size for list queries. */
export type Instacart_Eversight_Item_Price_Management_V1_PaginationRequest_Input = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};

/** PaginationResponse returns total count and current page info. */
export type Instacart_Eversight_Item_Price_Management_V1_PaginationResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_PaginationResponse';
  page?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

/** PriceTier defines a single tier in a price-tier markup rule. */
export type Instacart_Eversight_Item_Price_Management_V1_PriceTier = {
  __typename?: 'instacart_eversight_item_price_management_v1_PriceTier';
  /** Dollar markup applied within this tier (e.g. "2.50"). */
  dollarMarkup?: Maybe<Scalars['String']>;
  /** Upper price boundary for this tier in dollars (e.g. "10.00"). Empty means no upper bound. */
  priceTo?: Maybe<Scalars['String']>;
};

/** PriceTier defines a single tier in a price-tier markup rule. */
export type Instacart_Eversight_Item_Price_Management_V1_PriceTier_Input = {
  /** Dollar markup applied within this tier (e.g. "2.50"). */
  dollarMarkup?: InputMaybe<Scalars['String']>;
  /** Upper price boundary for this tier in dollars (e.g. "10.00"). Empty means no upper bound. */
  priceTo?: InputMaybe<Scalars['String']>;
};

/** ProductGroup defines a named collection of products used to scope a pricing rule. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroup = {
  __typename?: 'instacart_eversight_item_price_management_v1_ProductGroup';
  /** Attribute flag; set when type is PRODUCT_GROUP_TYPE_ATTRIBUTE. */
  attribute?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupAttribute>;
  /** Set when type = "category": taxonomy nodes selected for this group. */
  categories?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupCategory>>>;
  /** Creation timestamp. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Optional free-text description. */
  description?: Maybe<Scalars['String']>;
  /** Database primary key. */
  id?: Maybe<Scalars['BigInt']>;
  /** Number of categories or products in this group (0 for attribute groups). */
  itemCount?: Maybe<Scalars['Int']>;
  /** Display name of the user who last modified this group. */
  lastModifiedBy?: Maybe<Scalars['String']>;
  /** Human-readable name; natural key — immutable after creation. */
  name?: Maybe<Scalars['String']>;
  /** Partner this group belongs to. */
  partnerId?: Maybe<Scalars['BigInt']>;
  /** Set when type = "specific_products": explicit products in this group. */
  products?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupProduct>>>;
  /** Number of active rules referencing this product group. */
  ruleCount?: Maybe<Scalars['Int']>;
  /** Categorization approach for this group. */
  type?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupType>;
  /** Last update timestamp. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** ProductGroupAttribute identifies the boolean product flag for attribute-type groups. */
export enum Instacart_Eversight_Item_Price_Management_V1_ProductGroupAttribute {
  /** PRODUCT_GROUP_ATTRIBUTE_IS_ALCOHOL selects alcoholic products. */
  ProductGroupAttributeIsAlcohol = 'PRODUCT_GROUP_ATTRIBUTE_IS_ALCOHOL',
  /** PRODUCT_GROUP_ATTRIBUTE_IS_EXCLUDED_FROM_MARKUP selects items flagged to skip markup downstream. */
  ProductGroupAttributeIsExcludedFromMarkup = 'PRODUCT_GROUP_ATTRIBUTE_IS_EXCLUDED_FROM_MARKUP',
  /** PRODUCT_GROUP_ATTRIBUTE_IS_FLYER selects flyer/promotional products. */
  ProductGroupAttributeIsFlyer = 'PRODUCT_GROUP_ATTRIBUTE_IS_FLYER',
  /**
   * PRODUCT_GROUP_ATTRIBUTE_IS_NON_ALCOHOL selects non-alcoholic products (the
   * opposite polarity of IS_ALCOHOL, backed by the same is_alcohol column).
   */
  ProductGroupAttributeIsNonAlcohol = 'PRODUCT_GROUP_ATTRIBUTE_IS_NON_ALCOHOL',
  /** PRODUCT_GROUP_ATTRIBUTE_IS_RX selects pharmacy (Rx) products. */
  ProductGroupAttributeIsRx = 'PRODUCT_GROUP_ATTRIBUTE_IS_RX',
  /** PRODUCT_GROUP_ATTRIBUTE_IS_STORE_BRAND selects store-brand products. */
  ProductGroupAttributeIsStoreBrand = 'PRODUCT_GROUP_ATTRIBUTE_IS_STORE_BRAND',
  /** PRODUCT_GROUP_ATTRIBUTE_UNKNOWN is the default, unset value. */
  ProductGroupAttributeUnknown = 'PRODUCT_GROUP_ATTRIBUTE_UNKNOWN'
}

/** ProductGroupCategory represents a selected taxonomy node. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupCategory = {
  __typename?: 'instacart_eversight_item_price_management_v1_ProductGroupCategory';
  /** Taxonomy node identifier. */
  taxonomyId?: Maybe<Scalars['String']>;
  /** Human-readable path (e.g. "Produce > Fruit > Apples"). */
  taxonomyPath?: Maybe<Scalars['String']>;
};

/** ProductGroupCategory represents a selected taxonomy node. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupCategory_Input = {
  /** Taxonomy node identifier. */
  taxonomyId?: InputMaybe<Scalars['String']>;
  /** Human-readable path (e.g. "Produce > Fruit > Apples"). */
  taxonomyPath?: InputMaybe<Scalars['String']>;
};

/** ProductGroupChange represents a proposed product group change within a CR. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupChange = {
  __typename?: 'instacart_eversight_item_price_management_v1_ProductGroupChange';
  /** Edit state of this group within the CR. */
  editState?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleEditState>;
  /** The original (active) version, for diff display. Null for new groups. */
  original?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>;
  /** The proposed version of the product group. */
  proposed?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>;
};

/** ProductGroupPayload carries a full product group definition for use in CreateChangeRequest. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupPayload_Input = {
  /** Description. */
  description?: InputMaybe<Scalars['String']>;
  /** edit_state: "new", "edited", "unchanged", or "removed". */
  editState?: InputMaybe<Scalars['String']>;
  /** Attribute flags (for type="attribute"). */
  isAlcohol?: InputMaybe<Scalars['Boolean']>;
  isCustomItem?: InputMaybe<Scalars['Boolean']>;
  /** When true, items in this group are flagged so downstream pricing skips markup for them. */
  isExcludedFromMarkup?: InputMaybe<Scalars['Boolean']>;
  isExcludedItem?: InputMaybe<Scalars['Boolean']>;
  isFlyer?: InputMaybe<Scalars['Boolean']>;
  /**
   * When true, this attribute group selects non-alcoholic products (the opposite
   * polarity of is_alcohol, backed by the same is_alcohol column; the two are
   * mutually exclusive).
   */
  isNonAlcohol?: InputMaybe<Scalars['Boolean']>;
  isRx?: InputMaybe<Scalars['Boolean']>;
  isStoreBrand?: InputMaybe<Scalars['Boolean']>;
  /** Name of the product group. */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the corresponding group in the active CR (for diff matching). 0 means no previous group. */
  previousGroupId?: InputMaybe<Scalars['BigInt']>;
  /** JSONB payload for type="category" — serialized list of taxonomy categories. */
  productCategories?: InputMaybe<Scalars['String']>;
  /** JSONB payload for type="specific_products" — serialized list of product IDs. */
  productIds?: InputMaybe<Scalars['String']>;
  /**
   * Client-assigned temp ID for brand-new groups. Used to reference this group
   * from rule payloads (via product_group_temp_id) within the same request.
   */
  tempId?: InputMaybe<Scalars['String']>;
  /** Group type: "attribute", "category", or "specific_products". */
  type?: InputMaybe<Scalars['String']>;
};

/** ProductGroupProduct represents a specific product added to a group. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupProduct = {
  __typename?: 'instacart_eversight_item_price_management_v1_ProductGroupProduct';
  /** Cached display name. */
  name?: Maybe<Scalars['String']>;
  /** Global product identifier (cross-banner). */
  productId?: Maybe<Scalars['BigInt']>;
  /** Cached UPC. */
  upc?: Maybe<Scalars['String']>;
};

/** ProductGroupProduct represents a specific product added to a group. */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupProduct_Input = {
  /** Cached display name. */
  name?: InputMaybe<Scalars['String']>;
  /** Global product identifier (cross-banner). */
  productId?: InputMaybe<Scalars['BigInt']>;
  /** Cached UPC. */
  upc?: InputMaybe<Scalars['String']>;
};

/** ProductGroupType identifies the categorization approach for a product group. */
export enum Instacart_Eversight_Item_Price_Management_V1_ProductGroupType {
  /** PRODUCT_GROUP_TYPE_ATTRIBUTE selects products by a boolean flag (e.g. is_rx, is_alcohol). */
  ProductGroupTypeAttribute = 'PRODUCT_GROUP_TYPE_ATTRIBUTE',
  /** PRODUCT_GROUP_TYPE_CATEGORY selects products by taxonomy category. */
  ProductGroupTypeCategory = 'PRODUCT_GROUP_TYPE_CATEGORY',
  /** PRODUCT_GROUP_TYPE_SPECIFIC_PRODUCTS selects an explicit list of products. */
  ProductGroupTypeSpecificProducts = 'PRODUCT_GROUP_TYPE_SPECIFIC_PRODUCTS',
  /** PRODUCT_GROUP_TYPE_UNKNOWN is the default, unset value. */
  ProductGroupTypeUnknown = 'PRODUCT_GROUP_TYPE_UNKNOWN'
}

/**
 * ProductGroupUpdate carries the fields to update for a single product group within a CR.
 * change_request_id is omitted because it is implicit (taken from the request's id field).
 */
export type Instacart_Eversight_Item_Price_Management_V1_ProductGroupUpdate_Input = {
  /** Attribute flags (for type=attribute groups). */
  attribute?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupAttribute>;
  /** Taxonomy categories (for type=category groups). */
  categories?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupCategory_Input>>>;
  /** New description for the group. */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the product group to update (active group or existing CR clone). */
  id?: InputMaybe<Scalars['BigInt']>;
  /** New name for the group. */
  name?: InputMaybe<Scalars['String']>;
  /** Specific products (for type=specific_products groups). */
  products?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupProduct_Input>>>;
  /** Group type (attribute, category, specific_products). */
  type?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupType>;
  /** Fields to update. Accepted keys: "name", "description", "type", "attribute", "categories", "products". */
  updateMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * PublishChangeRequestRequest publishes a pending change request to ItemPricingService.
 * On success the CR transitions from "pending" to "active".
 */
export type Instacart_Eversight_Item_Price_Management_V1_PublishChangeRequestRequest_Input = {
  /** authorization_context carries the publishing user's identity (recorded as last_modified_by). */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** id is the change_request_id to publish. */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * partner_id scopes the publish to the caller's partner; the handler rejects any mismatch
   * with the CR's stored partner_id so a caller cannot publish another partner's CR by id alone.
   */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** PublishChangeRequestResponse returns the published CR id and the resulting IPS policy ids. */
export type Instacart_Eversight_Item_Price_Management_V1_PublishChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_PublishChangeRequestResponse';
  /** change_request_id is the id of the published change request. */
  changeRequestId?: Maybe<Scalars['BigInt']>;
  /** policy_ids are the ItemPricingService policy ids returned by CommitPricingStrategyUpdate. */
  policyIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * RegenerateChangeRequestSamplePricesSnapshotRequest triggers a fresh
 * sample-price snapshot for the given change request. The existing snapshot
 * (if any) is deleted and replaced with rows freshly computed against the
 * CR's current rules and groups. Restricted to admins on the CR's partner.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RegenerateChangeRequestSamplePricesSnapshotRequest_Input = {
  /** User identity injected by Mesh. Do not set from the client. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** ID of the change request whose snapshot should be regenerated. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Partner ID for tenant scoping. The handler verifies the CR belongs to
   * this partner and rejects the call otherwise.
   */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * RegenerateChangeRequestSamplePricesSnapshotResponse returns the freshly
 * written snapshot's capture time and row count.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RegenerateChangeRequestSamplePricesSnapshotResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_RegenerateChangeRequestSamplePricesSnapshotResponse';
  /**
   * When the freshly written snapshot was captured. Same value stamped on
   * every persisted row of the snapshot; subsequent
   * GetChangeRequestSamplePrices calls surface this value verbatim.
   */
  snapshotTakenAt?: Maybe<Scalars['DateTime']>;
  /** Number of sample-price rows persisted in the newly written snapshot. */
  totalItems?: Maybe<Scalars['Int']>;
};

/**
 * RetailerAlcoholMarkupProhibitedStates carries the prohibited state list
 * for a single retailer.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RetailerAlcoholMarkupProhibitedStates = {
  __typename?: 'instacart_eversight_item_price_management_v1_RetailerAlcoholMarkupProhibitedStates';
  /**
   * prohibited_states lists the state/province codes (e.g. "LA", "ON")
   * where markup is prohibited for this retailer. Empty means no
   * prohibited states apply.
   */
  prohibitedStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** retailer_id is the Instacart retailer (warehouse) ID. */
  retailerId?: Maybe<Scalars['BigInt']>;
};

/**
 * RoundingType is IPM's own enum for the rounding strategies exposed on the
 * change-request CRUD surface. The enum name string is stored on
 * `rules.rounding_type` (text column, e.g. "ROUNDING_TYPE_ROUND_TO_NEAREST_NINE"),
 * same pattern as `edit_state`. Sourcing owns the actual rounder implementations,
 * IPM just passes the chosen strategy through.
 *
 * This enum intentionally does NOT mirror
 * instacart.customers.commerce_item_pricing.types.v1.RoundingType (Sourcing's
 * enum). IPM owns its own numbering so Sourcing can add/remove variants
 * without affecting the retailer-facing CRUD surface. The value set currently
 * covers every strategy Sourcing supports; the LEGACY_SMART_ROUNDING_* family
 * are one-off implementations Sourcing has flagged for eventual consolidation.
 */
export enum Instacart_Eversight_Item_Price_Management_V1_RoundingType {
  RoundingTypeLegacyRoundToNine = 'ROUNDING_TYPE_LEGACY_ROUND_TO_NINE',
  RoundingTypeLegacySmartRounding = 'ROUNDING_TYPE_LEGACY_SMART_ROUNDING',
  RoundingTypeLegacySmartRoundingGiantEagle = 'ROUNDING_TYPE_LEGACY_SMART_ROUNDING_GIANT_EAGLE',
  RoundingTypeLegacySmartRoundingNearestNineFallback = 'ROUNDING_TYPE_LEGACY_SMART_ROUNDING_NEAREST_NINE_FALLBACK',
  RoundingTypeLegacySmartRoundingPrioritizeDown = 'ROUNDING_TYPE_LEGACY_SMART_ROUNDING_PRIORITIZE_DOWN',
  RoundingTypeLegacySmartRoundingPrioritizeUp = 'ROUNDING_TYPE_LEGACY_SMART_ROUNDING_PRIORITIZE_UP',
  RoundingTypeLegacySmartRoundingRoundUpFallback = 'ROUNDING_TYPE_LEGACY_SMART_ROUNDING_ROUND_UP_FALLBACK',
  RoundingTypeLegacyStorefrontRounding = 'ROUNDING_TYPE_LEGACY_STOREFRONT_ROUNDING',
  RoundingTypeRoundToNearestCent = 'ROUNDING_TYPE_ROUND_TO_NEAREST_CENT',
  RoundingTypeRoundToNearestNine = 'ROUNDING_TYPE_ROUND_TO_NEAREST_NINE',
  RoundingTypeRoundUpToCents = 'ROUNDING_TYPE_ROUND_UP_TO_CENTS',
  RoundingTypeRoundUpToNine = 'ROUNDING_TYPE_ROUND_UP_TO_NINE',
  RoundingTypeStorefrontRounding = 'ROUNDING_TYPE_STOREFRONT_ROUNDING',
  RoundingTypeThreeTierStorefrontRounding = 'ROUNDING_TYPE_THREE_TIER_STOREFRONT_ROUNDING',
  RoundingTypeUnknown = 'ROUNDING_TYPE_UNKNOWN'
}

/** Rule represents an active pricing rule with markup action and rounding strategy. */
export type Instacart_Eversight_Item_Price_Management_V1_Rule = {
  __typename?: 'instacart_eversight_item_price_management_v1_Rule';
  /** Realized markup multiple from observed prices (display-only; complements the target markup_multiple inside markup_action). Absent for proposed CR-cloned rules. DoubleValue is used (not bare double) so "no data" is distinguishable from a 0% realized markup. */
  actualMarkupMultiple?: Maybe<Scalars['Float']>;
  /** Channel filter (e.g. "marketplace", "storefront", "all"). */
  channel?: Maybe<Scalars['String']>;
  /** Edit state of this rule within a change request. */
  editState?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleEditState>;
  /**
   * Fulfillment provider ID filter. Unset means any provider. Int64Value
   * (not bare int64) is used so "any provider" is distinguishable from a
   * literal 0 — see actual_markup_multiple for the same pattern.
   */
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  itemPricingRuleId?: Maybe<Scalars['BigInt']>;
  /** User-meaningful last-edit time (distinct from updated_at which tracks any row touch). */
  lastUpdatedAt?: Maybe<Scalars['DateTime']>;
  /**
   * Legacy response field containing the display name of the user who last
   * modified this rule.
   */
  lastUpdatedByName?: Maybe<Scalars['String']>;
  markupAction?: Maybe<Scalars['String']>;
  /** Maximum price change in dollars allowed by rounding (e.g. "2.00"). Empty means no ceiling. */
  markupDollarMax?: Maybe<Scalars['String']>;
  /** Maximum price change in dollars (e.g. "5.00"). Empty means unconstrained. */
  maxPriceChangeDollars?: Maybe<Scalars['String']>;
  /** Membership filter (e.g. "all", "instacart_plus", "loyalty"). */
  membership?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** ID of the previous version of this rule (self-referencing FK). */
  previousRuleId?: Maybe<Scalars['BigInt']>;
  /** Maximum price as a percent of catalog price (e.g. "110" means 110%). Empty means no ceiling. */
  priceMaxPercent?: Maybe<Scalars['String']>;
  /** Minimum price as a percent of catalog price (e.g. "110" means 110%). Prices cannot fall below catalog price; this sets an additional floor above that implicit minimum. Empty means no additional floor. */
  priceMinPercent?: Maybe<Scalars['String']>;
  /**
   * Price tier rows for a "price_tier" markup rule. Empty for all other
   * markup types. When non-empty, markup_action is {"type":"price_tier"};
   * the two always agree.
   */
  priceTiers?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_PriceTier>>>;
  /**
   * Implied priority within the partner's rule set, derived server-side from
   * scope specificity. Lower numbers rank first; gapped (10, 20, 30…) so an
   * insert slots between neighbours without renumbering. 0 is unassigned and
   * ranks after assigned priorities. Inferred, never client-set.
   */
  priority?: Maybe<Scalars['BigInt']>;
  /** Product group referenced by this rule. */
  productGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroup>;
  /** Rounding strategy, IPM-owned enum. */
  roundingType?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  /** Service type filter (e.g. "delivery", "pickup", "all"). */
  serviceType?: Maybe<Scalars['String']>;
  /** Store group referenced by this rule. */
  storeGroup?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>;
  versionId?: Maybe<Scalars['BigInt']>;
};

/**
 * RuleConflict describes why a rule's implied priority could not be resolved
 * against the existing rule set. A non-empty conflicts field on a save response
 * means no rule was persisted; the client should present the details and keep
 * the pending edit open.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RuleConflict = {
  __typename?: 'instacart_eversight_item_price_management_v1_RuleConflict';
  /**
   * Scope summary of the candidate rule. Present alongside other_rule_id /
   * other_rule_name so callers can render both sides of the conflict.
   */
  candidateScope?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleScopeSummary>;
  /** Offending dimensions (populated for ambiguous conflicts). */
  dimensions?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_DimensionExplanation>>>;
  /** The existing rule the candidate conflicts with. */
  otherRuleId?: Maybe<Scalars['BigInt']>;
  /** Display name of the conflicting rule (snapshot for the message). */
  otherRuleName?: Maybe<Scalars['String']>;
  /**
   * Scope summary of the conflicting (other) rule. Additive; absent for
   * callers on the older shape.
   */
  otherScope?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleScopeSummary>;
  /** Why the priority could not be resolved. */
  type?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ConflictType>;
};

/**
 * RuleEditState tracks the status of a rule or group within a change request.
 * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
 */
export enum Instacart_Eversight_Item_Price_Management_V1_RuleEditState {
  RuleEditStateEdited = 'RULE_EDIT_STATE_EDITED',
  RuleEditStateNew = 'RULE_EDIT_STATE_NEW',
  RuleEditStateRemoved = 'RULE_EDIT_STATE_REMOVED',
  RuleEditStateUnchanged = 'RULE_EDIT_STATE_UNCHANGED',
  RuleEditStateUnknown = 'RULE_EDIT_STATE_UNKNOWN'
}

/** RulePayload carries a full rule definition for use in CreateChangeRequest. */
export type Instacart_Eversight_Item_Price_Management_V1_RulePayload_Input = {
  /** Inline conditions. */
  channel?: InputMaybe<Scalars['String']>;
  /** edit_state: "new", "edited", "unchanged", or "removed". */
  editState?: InputMaybe<Scalars['String']>;
  /** Fulfillment provider filter. Unset means all fulfillment providers. */
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  /** Maximum markup in dollars (e.g. "10.00"). Empty means no cap. */
  markupDollarMax?: InputMaybe<Scalars['String']>;
  /** Markup percentage as a decimal string (e.g. "15" means 15%). */
  markupPercent?: InputMaybe<Scalars['String']>;
  /** Markup type: "maintain_target", "no_markup", "flat_markup", or "price_tier". */
  markupType?: InputMaybe<Scalars['String']>;
  maxPriceChangeDollars?: InputMaybe<Scalars['String']>;
  membership?: InputMaybe<Scalars['String']>;
  /** Rule name. */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the previous rule version (for cloned rules). 0 means no previous rule. */
  previousRuleId?: InputMaybe<Scalars['BigInt']>;
  priceMaxPercent?: InputMaybe<Scalars['String']>;
  /** Guardrails. */
  priceMinPercent?: InputMaybe<Scalars['String']>;
  /** Price tier rows for "price_tier" markup rules. Empty for all other markup types. */
  priceTiers?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_PriceTier_Input>>>;
  /**
   * Group FKs — reference groups by their ID in the before-CR (active CR at save time).
   * Backend re-maps these to the newly created group copies within the new CR.
   */
  productGroupId?: InputMaybe<Scalars['BigInt']>;
  /**
   * References a brand-new product group by its temp_id in the same request's product_groups.
   * Set instead of product_group_id when the rule references a pending new group.
   */
  productGroupTempId?: InputMaybe<Scalars['String']>;
  /** Rounding strategy, IPM-owned enum. */
  roundingType?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  serviceType?: InputMaybe<Scalars['String']>;
  storeGroupId?: InputMaybe<Scalars['BigInt']>;
  /**
   * References a brand-new store group by its temp_id in the same request's store_groups.
   * Set instead of store_group_id when the rule references a pending new group.
   */
  storeGroupTempId?: InputMaybe<Scalars['String']>;
};

/**
 * RuleResourceScopeFilter selects rule snapshots whose retailer-level resource
 * scope intersects at least one supplied retailer. Presence is significant: an
 * absent filter returns all rules, while a present filter with no IDs returns no
 * rules.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RuleResourceScopeFilter_Input = {
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/**
 * RuleScopeSummary summarizes pricing-specificity dimensions for conflict
 * display. It is not a retailer resource scope and must not be used for access
 * control or partner-review filtering.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RuleScopeSummary = {
  __typename?: 'instacart_eversight_item_price_management_v1_RuleScopeSummary';
  /**
   * Fulfillment provider dimension. Additive; absent on the older shape,
   * which callers should treat as the unrestricted "all" scope.
   */
  fulfillmentProvider?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary>;
  /** Membership dimension. */
  membership?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary>;
  /** Product group dimension. */
  products?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary>;
  /** Service type dimension. */
  serviceType?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary>;
  /** Storefront / channel dimension. */
  storefront?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary>;
  /** Store group dimension. */
  stores?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary>;
};

/**
 * RuleUpdatePayload carries the mutable fields for a single existing rule
 * update within an UpdateChangeRequest bulk save. Mirrors the field set of
 * UpdateChangeRequestRuleRequest so the two paths remain interchangeable:
 * full replacement semantics (no per-field mask), scoped by rule id.
 */
export type Instacart_Eversight_Item_Price_Management_V1_RuleUpdatePayload_Input = {
  /** Channel filter: "all", "marketplace", or "storefront". */
  channel?: InputMaybe<Scalars['String']>;
  /** Fulfillment provider filter. Unset means all fulfillment providers. */
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  /** ID of the rule to update. Required. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Maximum markup in dollars (e.g. "10.00"). Empty means no cap. */
  markupDollarMax?: InputMaybe<Scalars['String']>;
  /** Markup percentage as a decimal string (e.g. "15" means 15%). */
  markupPercent?: InputMaybe<Scalars['String']>;
  /** Markup type: "maintain_target", "no_markup", "flat_markup", or "price_tier". */
  markupType?: InputMaybe<Scalars['String']>;
  /** Maximum price change in dollars (e.g. "5.00"). */
  maxPriceChangeDollars?: InputMaybe<Scalars['String']>;
  /** Membership filter: "all", "instacart_plus", or "loyalty". */
  membership?: InputMaybe<Scalars['String']>;
  /** Rule name. */
  name?: InputMaybe<Scalars['String']>;
  /** Maximum markup percent constraint as a decimal string (e.g. "20" means 20%). */
  priceMaxPercent?: InputMaybe<Scalars['String']>;
  /** Minimum markup percent constraint as a decimal string (e.g. "9" means 9%). */
  priceMinPercent?: InputMaybe<Scalars['String']>;
  /** Price tier rows for "price_tier" markup rules. Empty for all other markup types. */
  priceTiers?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_PriceTier_Input>>>;
  /** Product group FK — 0 means no product group restriction (all products). */
  productGroupId?: InputMaybe<Scalars['BigInt']>;
  /**
   * References a brand-new product group by its temp_id in the enclosing
   * UpdateChangeRequestRequest's product_group_creates. Set instead of
   * product_group_id when the rule references a pending new group.
   */
  productGroupTempId?: InputMaybe<Scalars['String']>;
  /** Rounding strategy, IPM-owned enum. */
  roundingType?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  /** Service type filter: "all", "delivery", or "pickup". */
  serviceType?: InputMaybe<Scalars['String']>;
  /** Store group FK — 0 means no store group restriction (all stores). */
  storeGroupId?: InputMaybe<Scalars['BigInt']>;
  /**
   * References a brand-new store group by its temp_id in the enclosing
   * UpdateChangeRequestRequest's store_group_creates. Set instead of
   * store_group_id when the rule references a pending new group.
   */
  storeGroupTempId?: InputMaybe<Scalars['String']>;
};

/** SamplePriceChange represents a single sample item's before/after pricing for one rule. */
export type Instacart_Eversight_Item_Price_Management_V1_SamplePriceChange = {
  __typename?: 'instacart_eversight_item_price_management_v1_SamplePriceChange';
  /** Catalog (base) price before any markup or rounding. */
  catalogPrice?: Maybe<Scalars['String']>;
  /** Channel (e.g. "Marketplace"). */
  channel?: Maybe<Scalars['String']>;
  /** Edit state of the rule (edited, new, removed, unchanged). */
  editState?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleEditState>;
  /** True when the sampled product is alcoholic. */
  isAlcoholic?: Maybe<Scalars['Boolean']>;
  /**
   * True when the row's (product, store) combination is subject to
   * prohibited-alcohol jurisdiction restrictions.
   */
  isSensitiveAlcohol?: Maybe<Scalars['Boolean']>;
  /** Membership condition (e.g. "IC+", "Non-member"). */
  membership?: Maybe<Scalars['String']>;
  /** Price after the rule change. */
  newPrice?: Maybe<Scalars['String']>;
  /**
   * Stable per-policy identifier for the policy that priced this row.
   * Empty when no CR rule applies.
   */
  policyReference?: Maybe<Scalars['String']>;
  /** Price before the rule change. */
  previousPrice?: Maybe<Scalars['String']>;
  /** Whether the price changed. */
  priceChanged?: Maybe<Scalars['Boolean']>;
  /** Product category for display. */
  productCategory?: Maybe<Scalars['String']>;
  /** Product group name (resolved from FK). */
  productGroupName?: Maybe<Scalars['String']>;
  /** Product identifier. */
  productId?: Maybe<Scalars['String']>;
  /** Product name for display. */
  productName?: Maybe<Scalars['String']>;
  /** Product display size (e.g. "12 oz", "1 lb"). Empty when not populated. */
  productSize?: Maybe<Scalars['String']>;
  /** Rule ID within the change request. */
  ruleId?: Maybe<Scalars['BigInt']>;
  /** Rule name for display. */
  ruleName?: Maybe<Scalars['String']>;
  /** Service type condition (e.g. "Delivery", "Pickup"). */
  serviceType?: Maybe<Scalars['String']>;
  /** Store group name (resolved from FK). */
  storeGroupName?: Maybe<Scalars['String']>;
  /** Store identifier for the sample row. Empty when not populated. */
  storeId?: Maybe<Scalars['String']>;
};

/**
 * ScopeDiff describes the added and removed retailer and store-config IDs
 * between a CR's captured creation scope and the partner's currently-active
 * CR scope.
 */
export type Instacart_Eversight_Item_Price_Management_V1_ScopeDiff = {
  __typename?: 'instacart_eversight_item_price_management_v1_ScopeDiff';
  /** Retailer (banner) IDs present in this CR's scope but not the active CR's. */
  addedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** SFP store_configuration_ids present in this CR's scope but not the active CR's. */
  addedStoreConfigIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Retailer (banner) IDs present in the active CR's scope but not this CR's. */
  removedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** SFP store_configuration_ids present in the active CR's scope but not this CR's. */
  removedStoreConfigIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** ScopeValueKind discriminates how a ScopeValueSummary should be rendered. */
export enum Instacart_Eversight_Item_Price_Management_V1_ScopeValueKind {
  /** Dimension is unrestricted; render "All <dimension>". */
  ScopeValueKindAll = 'SCOPE_VALUE_KIND_ALL',
  /**
   * Persisted group whose display name was not resolved; values[0] holds its id;
   * render "<Group> <id>".
   */
  ScopeValueKindIdFallback = 'SCOPE_VALUE_KIND_ID_FALLBACK',
  /** Concrete value; render label (a group name or enum value such as "delivery"). */
  ScopeValueKindNamed = 'SCOPE_VALUE_KIND_NAMED',
  /** Default; treat as unknown. */
  ScopeValueKindUnknown = 'SCOPE_VALUE_KIND_UNKNOWN',
  /** Opaque/unresolvable group; render "Unresolved <group>". */
  ScopeValueKindUnresolved = 'SCOPE_VALUE_KIND_UNRESOLVED'
}

/**
 * ScopeValueSummary describes one scope dimension's value for conflict
 * reporting. Each summary is one dimension of a RuleScopeSummary.
 */
export type Instacart_Eversight_Item_Price_Management_V1_ScopeValueSummary = {
  __typename?: 'instacart_eversight_item_price_management_v1_ScopeValueSummary';
  /** Display discriminator. */
  kind?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ScopeValueKind>;
  /**
   * Concrete display value for the NAMED kind (a group name or enum value).
   * Empty for ALL, ID_FALLBACK, and UNRESOLVED kinds.
   */
  label?: Maybe<Scalars['String']>;
  /**
   * Optional compact values: the group id for the ID_FALLBACK kind, or a
   * small member list when cheaply available. Never an expensive expansion of
   * a large group's membership.
   */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Store represents a single retailer location (physical store). */
export type Instacart_Eversight_Item_Price_Management_V1_Store = {
  __typename?: 'instacart_eversight_item_price_management_v1_Store';
  active?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  locationCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  /** region_code is the ISO country code for this store (e.g., "US", "CA"). */
  regionCode?: Maybe<Scalars['String']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
};

/** StoreGroup is a named, reusable collection of stores scoped to a partner. */
export type Instacart_Eversight_Item_Price_Management_V1_StoreGroup = {
  __typename?: 'instacart_eversight_item_price_management_v1_StoreGroup';
  /** created_at is the timestamp when the group was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** description is an optional description of the store group. */
  description?: Maybe<Scalars['String']>;
  /**
   * elem_values holds the group's selection criteria: state codes, store IDs, or retailer_ids
   * (for "banner" type).
   */
  elemValues?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** group_type is the type of group membership. */
  groupType?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupType>;
  /** id is the unique identifier for the store group. */
  id?: Maybe<Scalars['BigInt']>;
  /** Display name of the user who last modified this group. */
  lastModifiedBy?: Maybe<Scalars['String']>;
  /** name is the human-readable name of the store group. */
  name?: Maybe<Scalars['String']>;
  /** partner_id is the partner this group belongs to. */
  partnerId?: Maybe<Scalars['BigInt']>;
  /** rule_count is the number of active rules referencing this store group. */
  ruleCount?: Maybe<Scalars['Int']>;
  /** updated_at is the timestamp when the group was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** StoreGroupChange represents a proposed store group change within a CR. */
export type Instacart_Eversight_Item_Price_Management_V1_StoreGroupChange = {
  __typename?: 'instacart_eversight_item_price_management_v1_StoreGroupChange';
  /** Edit state of this group within the CR. */
  editState?: Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleEditState>;
  /** The original (active) version, for diff display. Null for new groups. */
  original?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>;
  /** The proposed version of the store group. */
  proposed?: Maybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroup>;
};

/** StoreGroupElemPayload is a single element in a StoreGroupPayload. */
export type Instacart_Eversight_Item_Price_Management_V1_StoreGroupElemPayload_Input = {
  /** Store/region identifier value (store ID, country code, administrative area code, etc.). */
  elemValue?: InputMaybe<Scalars['String']>;
};

/** StoreGroupPayload carries a full store group definition for use in CreateChangeRequest. */
export type Instacart_Eversight_Item_Price_Management_V1_StoreGroupPayload_Input = {
  /** Description. */
  description?: InputMaybe<Scalars['String']>;
  /** edit_state: "new", "edited", "unchanged", or "removed". */
  editState?: InputMaybe<Scalars['String']>;
  /** Store group elements (stores/regions). */
  elems?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupElemPayload_Input>>>;
  /** Group type: "administrative_area", "banner", or "explicit_stores". */
  groupType?: InputMaybe<Scalars['String']>;
  /** Name of the store group. */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the corresponding group in the active CR (for diff matching). 0 means no previous group. */
  previousGroupId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Client-assigned temp ID for brand-new groups. Used to reference this group
   * from rule payloads (via store_group_temp_id) within the same request.
   */
  tempId?: InputMaybe<Scalars['String']>;
};

/** StoreGroupType defines the type of group membership. */
export enum Instacart_Eversight_Item_Price_Management_V1_StoreGroupType {
  /** STORE_GROUP_TYPE_ADMINISTRATIVE_AREA groups stores by state/province code. */
  StoreGroupTypeAdministrativeArea = 'STORE_GROUP_TYPE_ADMINISTRATIVE_AREA',
  /** STORE_GROUP_TYPE_BANNER groups stores by banner (retailer). */
  StoreGroupTypeBanner = 'STORE_GROUP_TYPE_BANNER',
  /** STORE_GROUP_TYPE_EXPLICIT_STORES groups stores by explicit store ID. */
  StoreGroupTypeExplicitStores = 'STORE_GROUP_TYPE_EXPLICIT_STORES',
  /** STORE_GROUP_TYPE_UNKNOWN is the default, unset value. */
  StoreGroupTypeUnknown = 'STORE_GROUP_TYPE_UNKNOWN'
}

/**
 * StoreGroupUpdate carries the fields to update for a single store group within a CR.
 * change_request_id is omitted because it is implicit (taken from the request's id field).
 */
export type Instacart_Eversight_Item_Price_Management_V1_StoreGroupUpdate_Input = {
  /** New description for the group. */
  description?: InputMaybe<Scalars['String']>;
  /** Store/region identifier values. */
  elemValues?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Group type (country, administrative_area, banner, explicit_stores). */
  groupType?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupType>;
  /** ID of the store group to update (active group or existing CR clone). */
  id?: InputMaybe<Scalars['BigInt']>;
  /** New name for the group. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Fields to update. Accepted keys: "name", "description", "group_type", "elem_values".
   * When omitted, all fields are replaced.
   */
  updateMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** SubmitChangeRequestForReviewRequest submits a draft change request for AMS multi-layer approval. */
export type Instacart_Eversight_Item_Price_Management_V1_SubmitChangeRequestForReviewRequest_Input = {
  /** User identity injected by Mesh. Do not set from the client. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** The ID of the change request to submit for review. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /**
   * The partner that owns this change request. Required for tenant scoping:
   * Mesh authorizes the caller against this partner and the handler rejects
   * the request if it does not match the CR's owning partner, so a caller
   * cannot submit another partner's change request by ID.
   */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** The absolute URL to the change request review page (constructed by the frontend). */
  reviewUrl?: InputMaybe<Scalars['String']>;
};

/** SubmitChangeRequestForReviewResponse returns the AMS approval request ID created for the change request. */
export type Instacart_Eversight_Item_Price_Management_V1_SubmitChangeRequestForReviewResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_SubmitChangeRequestForReviewResponse';
  /** The AMS approval request ID created for this change request. */
  amsApprovalRequestId?: Maybe<Scalars['String']>;
  /**
   * The AMS create outcome (CreateApprovalRequestResult), e.g.
   * "CREATE_AR_RESULT_CREATED" or "...ALREADY_CREATED". This is the result of
   * the create call, not the approval-request lifecycle state.
   */
  createResult?: Maybe<Scalars['String']>;
};

/** UpdateChangeRequestRequest is the request for updating change request metadata. */
export type Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  dateImplemented?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['BigInt']>;
  /** Reserved for future rule management within a change request. */
  itemPricingRuleIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  name?: InputMaybe<Scalars['String']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** New product groups to create within this CR on save (deferred from sub-drawer creates). */
  productGroupCreates?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupPayload_Input>>>;
  /**
   * IDs of product group CR clones to delete on save. NEW groups are hard-deleted;
   * EDITED/UNCHANGED groups are soft-deleted (removal intent preserved for CR commit).
   */
  productGroupIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Proposed product group updates to apply on save (deferred from sub-drawer edits). */
  productGroupUpdates?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupUpdate_Input>>>;
  /**
   * New rules to create within this CR on save, persisted atomically with the
   * rest of the update. Rules may reference staged groups by temp_id.
   */
  ruleCreates?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RulePayload_Input>>>;
  /**
   * IDs of rules within this CR to delete on save. Rules are removed with the
   * same semantics as DeleteChangeRequestRule (soft delete + rule_ids stitch).
   */
  ruleIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Existing rule updates to apply on save. Full replacement of the mutable
   * fields per rule id, matching UpdateChangeRequestRule semantics.
   */
  ruleUpdates?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RuleUpdatePayload_Input>>>;
  /** New store groups to create within this CR on save (deferred from sub-drawer creates). */
  storeGroupCreates?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupPayload_Input>>>;
  /**
   * IDs of store group CR clones to delete on save. NEW groups are hard-deleted;
   * EDITED/UNCHANGED groups are soft-deleted (removal intent preserved for CR commit).
   */
  storeGroupIdsToDelete?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Proposed store group updates to apply on save (deferred from sub-drawer edits). */
  storeGroupUpdates?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupUpdate_Input>>>;
  /**
   * Fields to update. Only fields listed here are written.
   * Accepted mask keys: "name", "description", "date_implemented", "rule_ids".
   * Note: "rule_ids" is a legacy mask alias (pre-CP-764) for updates to the
   * item_pricing_rule_ids field — the handler maps "rule_ids" → item_pricing_rule_ids
   * when applying the mask. The convention of matching snake_case field names is
   * followed for the other three keys.
   */
  updateMask?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** UpdateChangeRequestResponse is the response for updating a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_UpdateChangeRequestResponse';
  /** The updated change request snapshot. Null if conflicts is set. */
  changeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequest>;
  /**
   * Prioritization conflicts in the post-save draft rule set. When non-empty,
   * change_request is null and nothing is written.
   */
  conflicts?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleConflict>>>;
  /** Maps temp_id to newly assigned DB ID for groups created via product_group_creates. */
  createdProductGroupIds?: Maybe<Scalars['JSON']>;
  /**
   * Newly assigned DB IDs for rules created via rule_creates, in the same
   * order as the request's rule_creates. Empty when rule_creates was empty.
   * The FE uses this to reconcile local RuleRow identities against the
   * persisted rules (mirrors the temp_id → id map used for groups).
   */
  createdRuleIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Maps temp_id to newly assigned DB ID for groups created via store_group_creates. */
  createdStoreGroupIds?: Maybe<Scalars['JSON']>;
};

/** UpdateChangeRequestRuleRequest updates an existing rule within a change request. */
export type Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestRuleRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** ID of the change request the rule belongs to. */
  changeRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Channel filter: "all", "marketplace", or "storefront". */
  channel?: InputMaybe<Scalars['String']>;
  /** Fulfillment provider filter. Unset means all fulfillment providers. */
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  /** Maximum markup in dollars (e.g. "10.00"). */
  markupDollarMax?: InputMaybe<Scalars['String']>;
  /** Markup percentage as a decimal string (e.g. "15" means 15%). */
  markupPercent?: InputMaybe<Scalars['String']>;
  /** Markup type: "maintain_target", "no_markup", or "flat_markup". */
  markupType?: InputMaybe<Scalars['String']>;
  /** Maximum price change in dollars (e.g. "5.00"). */
  maxPriceChangeDollars?: InputMaybe<Scalars['String']>;
  /** Membership filter: "all", "instacart_plus", or "loyalty". */
  membership?: InputMaybe<Scalars['String']>;
  /** Rule name — required, must be non-empty. */
  name?: InputMaybe<Scalars['String']>;
  /** Partner ID for tenant scoping. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Maximum price as percent of catalog price (e.g. "110" means 110%). */
  priceMaxPercent?: InputMaybe<Scalars['String']>;
  /** Minimum price as percent of catalog price (e.g. "90" means 90%). */
  priceMinPercent?: InputMaybe<Scalars['String']>;
  /** Price tier rows for "price_tier" markup rules. Empty for all other markup types. */
  priceTiers?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_PriceTier_Input>>>;
  /** Product group FK — 0 means no product group restriction (all products). */
  productGroupId?: InputMaybe<Scalars['BigInt']>;
  /** Rounding strategy, IPM-owned enum. */
  roundingType?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RoundingType>;
  /** ID of the rule to update. */
  ruleId?: InputMaybe<Scalars['BigInt']>;
  /** Service type filter: "all", "delivery", or "pickup". */
  serviceType?: InputMaybe<Scalars['String']>;
  /** Store group FK — 0 means no store group restriction (all stores). */
  storeGroupId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * UpdateChangeRequestRuleResponse returns the updated rule, or a conflict if the
 * prioritization check rejected the save.
 */
export type Instacart_Eversight_Item_Price_Management_V1_UpdateChangeRequestRuleResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_UpdateChangeRequestRuleResponse';
  /**
   * Set when the save was rejected by the prioritization check: every existing
   * rule the candidate conflicts with. When non-empty, rule is null and nothing
   * was persisted.
   */
  conflicts?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleConflict>>>;
  /** The updated rule snapshot within the change request. Null if conflicts is set. */
  rule?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequestRule>;
};

/**
 * ValidateAndPrioritizeRulesRequest asks whether a candidate rule can be placed in a
 * rule set without conflict. The candidate is described via RulePayload; staged,
 * not-yet-persisted groups are referenced from rules by temp_id and resolved from
 * the inline product_groups/store_groups; persisted groups are loaded by id from
 * the database. Only the scope-relevant fields of each payload are consumed (markup
 * and rounding are a rule's effect, not its scope). No rule is persisted.
 */
export type Instacart_Eversight_Item_Price_Management_V1_ValidateAndPrioritizeRulesRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /**
   * The candidate rule being added or edited. Only its scope fields are read; it
   * references staged groups by product_group_temp_id/store_group_temp_id (resolved
   * from product_groups/store_groups) or persisted groups by product_group_id/
   * store_group_id. A temp id takes precedence over the corresponding persisted id.
   */
  candidate?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RulePayload_Input>;
  /**
   * The candidate rule's own id when editing an existing rule, so it is not compared
   * against its own prior version (self-skip). 0 for a brand-new rule. This is the
   * only self-skip identity — comparison rules are excluded by the caller, not by id.
   */
  candidateRuleId?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Staged (not-yet-persisted) product group definitions referenced by rules via
   * product_group_temp_id. Only the scope-relevant fields are consumed.
   */
  productGroups?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_ProductGroupPayload_Input>>>;
  /**
   * The comparison set: every other rule in the draft grid, the candidate excluded.
   * Empty means the candidate is the first rule. Each rule resolves its groups the
   * same way the candidate does (temp id, else persisted id).
   */
  rules?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_RulePayload_Input>>>;
  /**
   * Staged (not-yet-persisted) store group definitions referenced by rules via
   * store_group_temp_id. Only the scope-relevant fields are consumed.
   */
  storeGroups?: InputMaybe<Array<InputMaybe<Instacart_Eversight_Item_Price_Management_V1_StoreGroupPayload_Input>>>;
};

/** ValidateAndPrioritizeRulesResponse reports the outcome of a prioritization check. */
export type Instacart_Eversight_Item_Price_Management_V1_ValidateAndPrioritizeRulesResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_ValidateAndPrioritizeRulesResponse';
  /**
   * Every existing rule the candidate conflicts with (duplicate or ambiguous).
   * Empty means the candidate is valid and may be saved.
   */
  conflicts?: Maybe<Array<Maybe<Instacart_Eversight_Item_Price_Management_V1_RuleConflict>>>;
  /**
   * The priority slot the candidate would occupy if persisted. Meaningless when
   * conflicts is non-empty.
   */
  priority?: Maybe<Scalars['BigInt']>;
};

/**
 * WithdrawChangeRequestRequest withdraws a change request manually. The CR's
 * status must NOT already be terminal (active, inactive, withdrawn, rejected);
 * terminal statuses return FAILED_PRECONDITION. On success the change request
 * transitions to withdrawn status, with the withdrawal time and acting user
 * recorded for audit.
 */
export type Instacart_Eversight_Item_Price_Management_V1_WithdrawChangeRequestRequest_Input = {
  /** Identity of the user performing the request. Populated server-side for auditing. */
  authorizationContext?: InputMaybe<Instacart_Eversight_Item_Price_Management_V1_AuthorizationContext_Input>;
  /** ID of the change request to withdraw. */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Partner ID for tenant scoping. The handler verifies the CR belongs to this partner. */
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** WithdrawChangeRequestResponse returns the change request after withdrawal. */
export type Instacart_Eversight_Item_Price_Management_V1_WithdrawChangeRequestResponse = {
  __typename?: 'instacart_eversight_item_price_management_v1_WithdrawChangeRequestResponse';
  changeRequest?: Maybe<Instacart_Eversight_Item_Price_Management_V1_ChangeRequest>;
};

/** Request to get detailed information about a single job. */
export type Instacart_Flawless_Inventory_V1_GetJobDetailsRequest_Input = {
  /** The job ID to get details for. */
  job_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing full details about a single job. */
export type Instacart_Flawless_Inventory_V1_GetJobDetailsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobDetailsResponse';
  /** Source identifier (e.g., "isc:flawless.inventory"). */
  ai_gateway_source?: Maybe<Scalars['String']>;
  /** AI model used (e.g., "gpt-4o"). */
  ai_model?: Maybe<Scalars['String']>;
  /** Number of batches completed (batch jobs only). */
  batches_completed?: Maybe<Scalars['Int']>;
  /** Total number of batches (batch jobs only). */
  batches_total?: Maybe<Scalars['Int']>;
  /** When the job finished (null if still running, ISO 8601 format). */
  completed_at?: Maybe<Scalars['String']>;
  /** Progress percentage (0-100). */
  completion_percentage?: Maybe<Scalars['Int']>;
  /** Total cost in USD. */
  cost?: Maybe<Scalars['Float']>;
  /** When the job was created/started (ISO 8601 format). */
  created_at?: Maybe<Scalars['String']>;
  /** Error message if the job failed. */
  error_message?: Maybe<Scalars['String']>;
  /** Unique job identifier. */
  job_id?: Maybe<Scalars['BigInt']>;
  /** Processing mode: "batch" or "sync". */
  processing_mode?: Maybe<Scalars['String']>;
  /** User/service that initiated the job (e.g., "user@instacart.com"). */
  requester?: Maybe<Scalars['String']>;
  /** How long the job has been running or ran (in seconds). */
  runtime_seconds?: Maybe<Scalars['BigInt']>;
  /** Job status: "in_progress", "completed", "failed". */
  status?: Maybe<Scalars['String']>;
  /** Number of tasks completed. */
  tasks_completed?: Maybe<Scalars['Int']>;
  /** Number of tasks that failed. */
  tasks_failed?: Maybe<Scalars['Int']>;
  /** Number of tasks that succeeded. */
  tasks_succeeded?: Maybe<Scalars['Int']>;
  /** Total number of tasks in the job. */
  tasks_total?: Maybe<Scalars['Int']>;
  /**
   * Temporal workflow ID for linking to Temporal UI.
   * This is the workflow ID of the MapleJobStartWorkflow that runs the job.
   */
  temporal_workflow_id?: Maybe<Scalars['String']>;
  /** Total tokens consumed by the job. */
  total_tokens?: Maybe<Scalars['BigInt']>;
};

/** Request to retrieve job results */
export type Instacart_Flawless_Inventory_V1_GetJobResultsRequest_Input = {
  /** Id of the job created in the database for the job run. */
  job_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the complete results of a job */
export type Instacart_Flawless_Inventory_V1_GetJobResultsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobResultsResponse';
  /** Timestamp of job completion - when all the job workflows for the job have been completed. */
  completed_at?: Maybe<Scalars['String']>;
  /** Cost in USD for the job. */
  cost?: Maybe<Scalars['Float']>;
  /** Timestamp of job creation. */
  created_at?: Maybe<Scalars['String']>;
  /** Total input tokens used for the job. */
  input_tokens?: Maybe<Scalars['BigInt']>;
  /** Id of the job created in the database for the job run. */
  job_id?: Maybe<Scalars['BigInt']>;
  /** Name of the job created in the database for the job run. */
  job_name?: Maybe<Scalars['String']>;
  /** Version of the job created in the database for the job run. */
  job_version?: Maybe<Scalars['Int']>;
  /** List of details about the job workflows associated with the job. */
  job_workflows?: Maybe<Array<Maybe<Instacart_Flawless_Inventory_V1_JobWorkflow>>>;
  /** Number of batches processed for the job. */
  num_batches?: Maybe<Scalars['Int']>;
  /** Total output tokens used for the job. */
  output_tokens?: Maybe<Scalars['BigInt']>;
  /** Aggregate status of all the job workflows for the job. This will be one of ['completed', 'in_progress', 'failed']. */
  status?: Maybe<Scalars['String']>;
  /** Total tokens processed for the job. */
  total_tokens?: Maybe<Scalars['BigInt']>;
};

/** Response containing all unique AI Gateway sources. */
export type Instacart_Flawless_Inventory_V1_GetJobSourcesResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobSourcesResponse';
  /** List of unique AI Gateway source identifiers (e.g., "isc:flawless.inventory", "isc:camp"). */
  sources?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Request to retrieve the completion status of a job */
export type Instacart_Flawless_Inventory_V1_GetJobStatusRequest_Input = {
  /** Id of the job created in the database for the job run. */
  job_id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional - Id of the job workflow created in the database for the job run.
   * If not provided, the status of all job workflows for the job will be returned.
   */
  job_workflow_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the completion status of a job */
export type Instacart_Flawless_Inventory_V1_GetJobStatusResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobStatusResponse';
  /** Status of the job (completed, in_progress, failed) */
  status?: Maybe<Scalars['String']>;
};

/** Request to list MAPLE jobs with optional filtering and pagination. */
export type Instacart_Flawless_Inventory_V1_GetJobsRequest_Input = {
  /** Optional - Filter by AI Gateway source (e.g., "isc:camp"). */
  ai_gateway_source?: InputMaybe<Scalars['String']>;
  /**
   * Optional - Only return jobs created on or after this time (ISO 8601 format).
   * Useful for filtering out old stuck jobs from the dashboard.
   */
  created_after?: InputMaybe<Scalars['String']>;
  /** Optional - Filter by specific job ID. */
  job_id?: InputMaybe<Scalars['BigInt']>;
  /** Optional - Filter by job name (partial match). */
  job_name?: InputMaybe<Scalars['String']>;
  /** Optional - Page number for pagination (default: 1). */
  page?: InputMaybe<Scalars['Int']>;
  /** Optional - Number of items per page (default: 50, max: 100). */
  page_size?: InputMaybe<Scalars['Int']>;
  /** Optional - Filter by requester (user email or service name). */
  requester?: InputMaybe<Scalars['String']>;
  /** Optional - Filter by job status: "in_progress", "completed", "failed". */
  status_filter?: InputMaybe<Scalars['String']>;
};

/** Response containing a paginated list of jobs. */
export type Instacart_Flawless_Inventory_V1_GetJobsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetJobsResponse';
  /** List of job summaries. */
  jobs?: Maybe<Array<Maybe<Instacart_Flawless_Inventory_V1_JobSummary>>>;
  /** Current page number. */
  page?: Maybe<Scalars['Int']>;
  /** Total number of jobs matching the filter. */
  total_count?: Maybe<Scalars['Int']>;
  /** Total number of pages available. */
  total_pages?: Maybe<Scalars['Int']>;
};

/** Response for supported AI models */
export type Instacart_Flawless_Inventory_V1_GetMapleSupportedModelsResponse = {
  __typename?: 'instacart_flawless_inventory_v1_GetMapleSupportedModelsResponse';
  /**
   * Map of AI vendors to their models as JSON string.
   * Example: `{"openai": ["gpt-4o", "gpt-4o-mini"]}`
   */
  supported_models?: Maybe<Scalars['String']>;
};

/** Summary information for a single job in the list view. */
export type Instacart_Flawless_Inventory_V1_JobSummary = {
  __typename?: 'instacart_flawless_inventory_v1_JobSummary';
  /** Source identifier (e.g., "isc:flawless.inventory"). */
  ai_gateway_source?: Maybe<Scalars['String']>;
  /** AI model used (e.g., "gpt-4o"). */
  ai_model?: Maybe<Scalars['String']>;
  /** When the job finished (null if still running, ISO 8601 format). */
  completed_at?: Maybe<Scalars['String']>;
  /** When the job was created/started (ISO 8601 format). */
  created_at?: Maybe<Scalars['String']>;
  /** Unique job identifier. */
  job_id?: Maybe<Scalars['BigInt']>;
  /** Name of the job. */
  job_name?: Maybe<Scalars['String']>;
  /** Processing mode: "batch" or "sync". */
  processing_mode?: Maybe<Scalars['String']>;
  /** User/service that initiated the job (e.g., "user@instacart.com"). */
  requester?: Maybe<Scalars['String']>;
  /** Job status: "in_progress", "completed", "failed". */
  status?: Maybe<Scalars['String']>;
  /** Number of tasks in the job. */
  total_tasks?: Maybe<Scalars['Int']>;
};

/** A single workflow within a job */
export type Instacart_Flawless_Inventory_V1_JobWorkflow = {
  __typename?: 'instacart_flawless_inventory_v1_JobWorkflow';
  /**
   * Response codes for AI batches. This is a list of response codes for the AI batches that were sent to the AI model.
   * Response codes are the codes returned by the AI model for the batch.
   */
  ai_batch_response_codes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** AI model used in this workflow */
  ai_model?: Maybe<Scalars['String']>;
  /** If true, task data was appended to the prompt before sending to the AI model. */
  append_task_data?: Maybe<Scalars['Boolean']>;
  /** This is the number of tasks that were sent to the AI model in a single batch. */
  batch_size?: Maybe<Scalars['Int']>;
  /** Timestamp of workflow completion */
  completed_at?: Maybe<Scalars['String']>;
  /** Cost for this workflow in USD */
  cost?: Maybe<Scalars['Float']>;
  /** Timestamp of workflow creation */
  created_at?: Maybe<Scalars['String']>;
  /**
   * Detailed status of the job workflow. This will be a more detailed status of the job workflow.
   * For all states, see: https://instacart.atlassian.net/wiki/spaces/Catalog/pages/4707778561/How+to+Use+the+Maple+Batch+API
   */
  detailed_status?: Maybe<Scalars['String']>;
  /** Indicates whether this was a dry run. If true, no data was sent to the AI model. */
  dry_run?: Maybe<Scalars['Boolean']>;
  /** Error message for this workflow, if any. This is the error message encountered by MAPLE during the job workflow. */
  error_message?: Maybe<Scalars['String']>;
  /** Input tokens for this workflow */
  input_tokens?: Maybe<Scalars['BigInt']>;
  /** Id of the job workflow created in the database for the job run. */
  job_workflow_id?: Maybe<Scalars['BigInt']>;
  /** Output tokens for this workflow */
  output_tokens?: Maybe<Scalars['BigInt']>;
  /**
   * Presigned URL of the results file. This is the s3 file that was used as input for the job workflow.
   * Presigned URL will be valid for min(7 days AND when the AWS token expires). After this time, the presigned URL will be invalid.
   */
  results_file?: Maybe<Scalars['String']>;
  /** S3 URL and object ID of the results file. This is the raw s3 url and object id of the results file. */
  results_file_s3?: Maybe<Instacart_Flawless_Inventory_V1_S3ResultFile>;
  /** Sample prompt used for the AI request. This is the prompt that was used for the AI request for the job workflow. */
  sample_prompt?: Maybe<Scalars['String']>;
  /** Status of the job workflow. This will be one of ['completed', 'in_progress', 'failed']. */
  status?: Maybe<Scalars['String']>;
  /** Path to the input S3 file containing the task data. */
  task_file?: Maybe<Scalars['String']>;
  /**
   * This is a number used for testing. It is the total number of tasks that were sent to the AI model for the job workflow.
   * 0 means all tasks were sent to the AI model.
   */
  total_tasks?: Maybe<Scalars['Int']>;
  /** Total tokens processed in this workflow */
  total_tokens?: Maybe<Scalars['BigInt']>;
};

/** S3 result file with raw s3 url and object id of the result file */
export type Instacart_Flawless_Inventory_V1_S3ResultFile = {
  __typename?: 'instacart_flawless_inventory_v1_S3ResultFile';
  /** S3 result file object ID. This is the object id of the results file in s3. */
  object_id?: Maybe<Scalars['String']>;
  /** S3 result file URL. This is the raw s3 url of the results file. */
  url?: Maybe<Scalars['String']>;
};

/** The barcode of the checkout process. */
export type Instacart_Fulfillment_Domains_Checkout_V1_Barcode = {
  __typename?: 'instacart_fulfillment_domains_checkout_v1_Barcode';
  batchId?: Maybe<Scalars['BigInt']>;
  displayValue?: Maybe<Scalars['String']>;
  encodedValue?: Maybe<Scalars['String']>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  type?: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_BarcodeType>;
};

/** Barcode type. */
export enum Instacart_Fulfillment_Domains_Checkout_V1_BarcodeType {
  BarcodeTypeAztec = 'BARCODE_TYPE_AZTEC',
  BarcodeTypeCode25Interleaved = 'BARCODE_TYPE_CODE25_INTERLEAVED',
  BarcodeTypeCode39 = 'BARCODE_TYPE_CODE39',
  BarcodeTypeCode128 = 'BARCODE_TYPE_CODE128',
  BarcodeTypeDatamatrix = 'BARCODE_TYPE_DATAMATRIX',
  BarcodeTypeEan8 = 'BARCODE_TYPE_EAN8',
  BarcodeTypeEan13 = 'BARCODE_TYPE_EAN13',
  BarcodeTypeGs1Databar = 'BARCODE_TYPE_GS1_DATABAR',
  BarcodeTypeGs1DatabarExpanded = 'BARCODE_TYPE_GS1_DATABAR_EXPANDED',
  BarcodeTypeGs1DatabarLimited = 'BARCODE_TYPE_GS1_DATABAR_LIMITED',
  BarcodeTypePdf417 = 'BARCODE_TYPE_PDF417',
  BarcodeTypeQr = 'BARCODE_TYPE_QR',
  BarcodeTypeUnknown = 'BARCODE_TYPE_UNKNOWN',
  BarcodeTypeUpca = 'BARCODE_TYPE_UPCA',
  BarcodeTypeUpce = 'BARCODE_TYPE_UPCE'
}

/** The type of checkout process. */
export enum Instacart_Fulfillment_Domains_Checkout_V1_CheckoutProcessType {
  TypeBypassCheckout = 'TYPE_BYPASS_CHECKOUT',
  TypeBypassPayment = 'TYPE_BYPASS_PAYMENT',
  TypeRegularCheckout = 'TYPE_REGULAR_CHECKOUT',
  TypeUnknown = 'TYPE_UNKNOWN'
}

/** The checkout state of the checkout process. */
export type Instacart_Fulfillment_Domains_Checkout_V1_CheckoutState = {
  __typename?: 'instacart_fulfillment_domains_checkout_v1_CheckoutState';
  batchId?: Maybe<Scalars['BigInt']>;
  checkoutCreatedAt?: Maybe<Scalars['DateTime']>;
  checkoutFinalizedAt?: Maybe<Scalars['DateTime']>;
  /** The dynamic checkout process type of the order. This can either be the same as checkout_process_static_type or TYPE_CHECKOUT_GROCERIES if the order has become ineligible for bypass */
  checkoutProcessDynamicType?: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutProcessType>;
  /** The static checkout process type of the order. This stays static throughout an order's lifecycle */
  checkoutProcessStaticEnabledType?: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutProcessType>;
  checkoutUpdatedAt?: Maybe<Scalars['DateTime']>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
  workflowState?: Maybe<Instacart_Fulfillment_Domains_Checkout_V1_CheckoutWorkflowState>;
};

/** The workflow state of the checkout process. */
export enum Instacart_Fulfillment_Domains_Checkout_V1_CheckoutWorkflowState {
  /** The bypass attempt has been approved. */
  StateApproved = 'STATE_APPROVED',
  /** The bypass checkout attempt is being audited. */
  StateAuditingInProgress = 'STATE_AUDITING_IN_PROGRESS',
  /** The checkout has not started yet. */
  StateCheckoutNotStarted = 'STATE_CHECKOUT_NOT_STARTED',
  /** The bypass checkout attempt is in progress. */
  StateInProgress = 'STATE_IN_PROGRESS',
  /** The order has been cancelled. */
  StateOrderCancelled = 'STATE_ORDER_CANCELLED',
  /** The bypass attempt has been rejected. */
  StateRejected = 'STATE_REJECTED',
  StateUnknown = 'STATE_UNKNOWN'
}

/** The request to read order items after picking */
export type Instacart_Fulfillment_Domains_Picking_V1_GetPickingItemsRequest_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
};

/** The response to read order items after picking */
export type Instacart_Fulfillment_Domains_Picking_V1_GetPickingItemsResponse = {
  __typename?: 'instacart_fulfillment_domains_picking_v1_GetPickingItemsResponse';
  orderItems?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Picking_V1_PickingOrderItem>>>;
};

export enum Instacart_Fulfillment_Domains_Picking_V1_OrderItemStatus {
  OrderItemStatusFound = 'ORDER_ITEM_STATUS_FOUND',
  OrderItemStatusReplaced = 'ORDER_ITEM_STATUS_REPLACED',
  OrderItemStatusToRefund = 'ORDER_ITEM_STATUS_TO_REFUND',
  OrderItemStatusUnknown = 'ORDER_ITEM_STATUS_UNKNOWN'
}

/** A Picking Order Item */
export type Instacart_Fulfillment_Domains_Picking_V1_PickingOrderItem = {
  __typename?: 'instacart_fulfillment_domains_picking_v1_PickingOrderItem';
  costPricePerUnitCents?: Maybe<Scalars['BigInt']>;
  deliveredQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  orderedQuantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  price?: Maybe<Scalars['Float']>;
  productId?: Maybe<Scalars['String']>;
  shopperOrderItemId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Instacart_Fulfillment_Domains_Picking_V1_OrderItemStatus>;
};

/**
 * A single dive-and-catch request: items caught for an order delivery.
 * The order delivery is identified via each LineItem's `source.order_delivery_id`.
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Components_V1_DiveAndCatchRequest = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_components_v1_DiveAndCatchRequest';
  caughtItems?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
};

/** AuditLog represents an audit log entry */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditLog = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_AuditLog';
  /** JSON string from jsonb column */
  action?: Maybe<Scalars['String']>;
  actionType?: Maybe<Scalars['String']>;
  batchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  traceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** AuditQuestion defines the questions asked during step log audits */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditQuestion {
  AuditQuestionHasFalseNegatives = 'AUDIT_QUESTION_HAS_FALSE_NEGATIVES',
  AuditQuestionHasFalsePositives = 'AUDIT_QUESTION_HAS_FALSE_POSITIVES',
  AuditQuestionIsGood = 'AUDIT_QUESTION_IS_GOOD',
  AuditQuestionTaxonomyFilterHasFalseNegatives = 'AUDIT_QUESTION_TAXONOMY_FILTER_HAS_FALSE_NEGATIVES',
  /** Taxonomy filter specific questions */
  AuditQuestionTaxonomyFilterHasFalsePositives = 'AUDIT_QUESTION_TAXONOMY_FILTER_HAS_FALSE_POSITIVES',
  AuditQuestionTaxonomyFilterReplacementDataGood = 'AUDIT_QUESTION_TAXONOMY_FILTER_REPLACEMENT_DATA_GOOD',
  AuditQuestionUnknown = 'AUDIT_QUESTION_UNKNOWN'
}

/** AuditResponse represents a single question-answer pair in an audit. */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_AuditResponse';
  answer?: Maybe<Scalars['Boolean']>;
  /** Items missing from step output that should be there. */
  falseNegatives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  /** Items in step output that should not be there. */
  falsePositives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  question?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditQuestion>;
  /** Items correctly excluded from step output. */
  trueNegatives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  /** Items correctly included in step output. */
  truePositives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
};

/** AuditResponse represents a single question-answer pair in an audit. */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse_Input = {
  answer?: InputMaybe<Scalars['Boolean']>;
  /** Items missing from step output that should be there. */
  falseNegatives?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification_Input>;
  /** Items in step output that should not be there. */
  falsePositives?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification_Input>;
  question?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditQuestion>;
  /** Items correctly excluded from step output. */
  trueNegatives?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification_Input>;
  /** Items correctly included in step output. */
  truePositives?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification_Input>;
};

/** CategorizationAnalysis compares GDS audit vs transaction integrity system categorizations */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_CategorizationAnalysis';
  batchId?: Maybe<Scalars['BigInt']>;
  /** Line items where system and audit agree on ALL categorizations */
  matches?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
  /** All mismatched line items grouped by category type */
  mismatches?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches>;
};

/** CategorizationAnalysis compares GDS audit vs transaction integrity system categorizations */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  /** Line items where system and audit agree on ALL categorizations */
  matches?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
  /** All mismatched line items grouped by category type */
  mismatches?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches_Input>;
};

/** CategoryMismatch represents mismatched categorizations for a specific category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_CategoryMismatch';
  auditOnly?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
  systemOnly?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
};

/** CategoryMismatch represents mismatched categorizations for a specific category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch_Input = {
  auditOnly?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
  systemOnly?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
};

/** DataQualityFlag */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_DataQualityFlag = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_DataQualityFlag';
  experimentalCode?: Maybe<Scalars['String']>;
};

/** DataQualityFlag */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_DataQualityFlag_Input = {
  experimentalCode?: InputMaybe<Scalars['String']>;
};

/** LineItem */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_LineItem';
  isIllicit?: Maybe<Scalars['Boolean']>;
  matchingQuality?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality>;
  product?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product>;
  /** What the line is: a product or a specific non-product category. */
  productType?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ProductType>;
  quantity?: Maybe<Instacart_Types_V1_MeasuredQuantity>;
  rawPosData?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_RawPosData>;
  roi?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Roi>;
  source?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source>;
  taxonomyMatches?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatch>>>;
};

/**
 * LineItemClassification holds the count, dollar amount, and optional per-item
 * breakdown for a single classification bucket (FP, FN, TP, or TN).
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_LineItemClassification';
  amountCents?: Maybe<Scalars['BigInt']>;
  count?: Maybe<Scalars['BigInt']>;
  /** Per-item breakdown. May be empty for TP/TN when only aggregates are needed. */
  lineItems?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
};

/**
 * LineItemClassification holds the count, dollar amount, and optional per-item
 * breakdown for a single classification bucket (FP, FN, TP, or TN).
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification_Input = {
  amountCents?: InputMaybe<Scalars['BigInt']>;
  count?: InputMaybe<Scalars['BigInt']>;
  /** Per-item breakdown. May be empty for TP/TN when only aggregates are needed. */
  lineItems?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input>>>;
};

/** LineItem */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem_Input = {
  isIllicit?: InputMaybe<Scalars['Boolean']>;
  matchingQuality?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality_Input>;
  product?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product_Input>;
  /** What the line is: a product or a specific non-product category. */
  productType?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ProductType>;
  quantity?: InputMaybe<Instacart_Types_V1_MeasuredQuantity_Input>;
  rawPosData?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_RawPosData_Input>;
  roi?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Roi_Input>;
  source?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source_Input>;
  taxonomyMatches?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatch_Input>>>;
};

/** MatchingQuality */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_MatchingQuality';
  accuracy?: Maybe<Scalars['Float']>;
  flags?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_DataQualityFlag>>>;
  precision?: Maybe<Scalars['Float']>;
  recall?: Maybe<Scalars['Float']>;
};

/** MatchingQuality */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_MatchingQuality_Input = {
  accuracy?: InputMaybe<Scalars['Float']>;
  flags?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_DataQualityFlag_Input>>>;
  precision?: InputMaybe<Scalars['Float']>;
  recall?: InputMaybe<Scalars['Float']>;
};

/** Mismatches contains all mismatched line items grouped by category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Mismatches';
  refundedButCheckedOut?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch>;
};

/** Mismatches contains all mismatched line items grouped by category */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Mismatches_Input = {
  refundedButCheckedOut?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategoryMismatch_Input>;
};

export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_NonProductType {
  NonProductTypeBagFee = 'NON_PRODUCT_TYPE_BAG_FEE',
  NonProductTypeBottleDeposit = 'NON_PRODUCT_TYPE_BOTTLE_DEPOSIT',
  NonProductTypeGiftCard = 'NON_PRODUCT_TYPE_GIFT_CARD',
  NonProductTypeOther = 'NON_PRODUCT_TYPE_OTHER',
  NonProductTypeTobacco = 'NON_PRODUCT_TYPE_TOBACCO',
  NonProductTypeUnknown = 'NON_PRODUCT_TYPE_UNKNOWN'
}

/** Product */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Product';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  restrictedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  retailerReferenceCode?: Maybe<Scalars['String']>;
  unit?: Maybe<Instacart_Types_V1_MeasurementUnit>;
  unitPriceCents?: Maybe<Scalars['BigInt']>;
  universalProductCode?: Maybe<Scalars['String']>;
};

/**
 * ProductType classifies what a line item is: PRODUCT for merchandise lines,
 * or a specific non-product category. Every line has a type.
 * PRODUCT_TYPE_UNKNOWN means the type is unavailable or unclassified.
 */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ProductType {
  ProductTypeBagFee = 'PRODUCT_TYPE_BAG_FEE',
  ProductTypeBottleDeposit = 'PRODUCT_TYPE_BOTTLE_DEPOSIT',
  ProductTypeGiftCard = 'PRODUCT_TYPE_GIFT_CARD',
  ProductTypeOther = 'PRODUCT_TYPE_OTHER',
  ProductTypeProduct = 'PRODUCT_TYPE_PRODUCT',
  ProductTypeTobacco = 'PRODUCT_TYPE_TOBACCO',
  ProductTypeUnknown = 'PRODUCT_TYPE_UNKNOWN'
}

/** Product */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Product_Input = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  restrictedReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  retailerReferenceCode?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Instacart_Types_V1_MeasurementUnit_Input>;
  unitPriceCents?: InputMaybe<Scalars['BigInt']>;
  universalProductCode?: InputMaybe<Scalars['String']>;
};

/** Raw POS line item data from the retailer transaction. */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_RawPosData = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_RawPosData';
  isNonProduct?: Maybe<Scalars['Boolean']>;
  /** Deprecated: use LineItem.product_type. */
  nonProductType?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_NonProductType>;
  rawDescription?: Maybe<Scalars['String']>;
  rawItemPriceCents?: Maybe<Scalars['BigInt']>;
  rawPricePerUnitCents?: Maybe<Scalars['BigInt']>;
};

/** Raw POS line item data from the retailer transaction. */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_RawPosData_Input = {
  isNonProduct?: InputMaybe<Scalars['Boolean']>;
  /** Deprecated: use LineItem.product_type. */
  nonProductType?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_NonProductType>;
  rawDescription?: InputMaybe<Scalars['String']>;
  rawItemPriceCents?: InputMaybe<Scalars['BigInt']>;
  rawPricePerUnitCents?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Roi holds return-on-investment financial data for a line item.
 * Grouped as a message to allow additional ROI-related fields in the future.
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Roi = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Roi';
  /** Total ROI value in cents. */
  totalCents?: Maybe<Scalars['BigInt']>;
};

/**
 * Roi holds return-on-investment financial data for a line item.
 * Grouped as a message to allow additional ROI-related fields in the future.
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Roi_Input = {
  /** Total ROI value in cents. */
  totalCents?: InputMaybe<Scalars['BigInt']>;
};

/** SecondaryStepLogAudit represents a secondary review of a primary audit */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_SecondaryStepLogAudit = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_SecondaryStepLogAudit';
  auditedBy?: Maybe<Scalars['String']>;
  /** JSON string of corrected output provided by reviewer. */
  correctedOutputData?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  primaryAuditId?: Maybe<Scalars['String']>;
  stepType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  validationDecision?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ValidationDecision>;
};

/** Source */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_Source';
  batchId?: Maybe<Scalars['BigInt']>;
  orderDeliveryId?: Maybe<Scalars['BigInt']>;
  retailerTransactionId?: Maybe<Scalars['String']>;
  retailerTransactionLineItemIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  shopperOrderItemId?: Maybe<Scalars['BigInt']>;
  shopperOrderItemIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * Identifiers from source line items contributing to this entry.
   * Tracks which distinct products were merged when items are combined.
   */
  sourceProductIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceRetailerReferenceCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceUniversalProductCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

/** Source */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_Source_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
  retailerTransactionId?: InputMaybe<Scalars['String']>;
  retailerTransactionLineItemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  shopperOrderItemId?: InputMaybe<Scalars['BigInt']>;
  shopperOrderItemIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Identifiers from source line items contributing to this entry.
   * Tracks which distinct products were merged when items are combined.
   */
  sourceProductIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceRetailerReferenceCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceUniversalProductCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** StepLog represents a step execution log entry */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLog = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_StepLog';
  batchId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  /** JSON string from jsonb column */
  inputData?: Maybe<Scalars['String']>;
  /** JSON string from jsonb column */
  outputData?: Maybe<Scalars['String']>;
  stepType?: Maybe<Scalars['String']>;
  traceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** StepLogAudit represents an audit record for a step log */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAudit = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_StepLogAudit';
  auditResponses?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse>>>;
  auditedBy?: Maybe<Scalars['String']>;
  auditorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  hasFalseNegatives?: Maybe<Scalars['Boolean']>;
  hasFalsePositives?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isGood?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  stepLog?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLog>;
  stepLogId?: Maybe<Scalars['String']>;
  stepType?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
};

/** StepLogAuditStatus defines the filter for step log audit state in queries */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAuditStatus {
  /** Return only audited step logs */
  StepLogAuditStatusAudited = 'STEP_LOG_AUDIT_STATUS_AUDITED',
  /** Return only unaudited step logs */
  StepLogAuditStatusUnaudited = 'STEP_LOG_AUDIT_STATUS_UNAUDITED',
  /** Unknown/unspecified: no filtering applied, returns all step logs */
  StepLogAuditStatusUnknown = 'STEP_LOG_AUDIT_STATUS_UNKNOWN'
}

/**
 * TaxonomyMatch records a counterpart product that this line item was matched
 * against during taxonomy filtering, along with the score and which matching
 * pass produced the match.
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatch = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_shared_v1_TaxonomyMatch';
  matchType?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatchType>;
  matchedProductId?: Maybe<Scalars['String']>;
  matchedProductName?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Float']>;
};

/** TaxonomyMatchType identifies which taxonomy-matching pass produced a TaxonomyMatch. */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatchType {
  TaxonomyMatchTypeReplacementScore = 'TAXONOMY_MATCH_TYPE_REPLACEMENT_SCORE',
  TaxonomyMatchTypeStringSimilarity = 'TAXONOMY_MATCH_TYPE_STRING_SIMILARITY',
  TaxonomyMatchTypeUnknown = 'TAXONOMY_MATCH_TYPE_UNKNOWN'
}

/**
 * TaxonomyMatch records a counterpart product that this line item was matched
 * against during taxonomy filtering, along with the score and which matching
 * pass produced the match.
 */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatch_Input = {
  matchType?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_TaxonomyMatchType>;
  matchedProductId?: InputMaybe<Scalars['String']>;
  matchedProductName?: InputMaybe<Scalars['String']>;
  score?: InputMaybe<Scalars['Float']>;
};

/** ValidationDecision defines the outcome of a secondary review */
export enum Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ValidationDecision {
  ValidationDecisionAgree = 'VALIDATION_DECISION_AGREE',
  ValidationDecisionDisagree = 'VALIDATION_DECISION_DISAGREE',
  ValidationDecisionPartiallyAgree = 'VALIDATION_DECISION_PARTIALLY_AGREE',
  ValidationDecisionUnknown = 'VALIDATION_DECISION_UNKNOWN'
}

/** CreateSecondaryStepLogAuditRequest */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_CreateSecondaryStepLogAuditRequest_Input = {
  auditResponses?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse_Input>>>;
  /** User ID of the secondary reviewer */
  auditedBy?: InputMaybe<Scalars['String']>;
  /** Optional JSON string of corrected output. */
  correctedOutputData?: InputMaybe<Scalars['String']>;
  /** ID of the primary audit being reviewed */
  primaryAuditId?: InputMaybe<Scalars['String']>;
  /** Step type (denormalized for filtering) */
  stepType?: InputMaybe<Scalars['String']>;
  validationDecision?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_ValidationDecision>;
};

/** CreateSecondaryStepLogAuditResponse */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_CreateSecondaryStepLogAuditResponse = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_v1_CreateSecondaryStepLogAuditResponse';
  errorMessage?: Maybe<Scalars['String']>;
  secondaryAudit?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_SecondaryStepLogAudit>;
  succeeded?: Maybe<Scalars['Boolean']>;
};

/** GetStepLogAuditMetricsRequest */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogAuditMetricsRequest_Input = {
  /** Optional: filter audits created after this time */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** Optional: filter audits created before this time */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** Required: step type to get metrics for */
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** GetStepLogAuditMetricsResponse */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogAuditMetricsResponse = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_v1_GetStepLogAuditMetricsResponse';
  falseNegatives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  /**
   * Aggregated across all step_log_audits in scope. `line_items` empty here;
   * unset for step types that don't support line-item metrics.
   */
  falsePositives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  stepType?: Maybe<Scalars['String']>;
  totalNumAudits?: Maybe<Scalars['Int']>;
  totalNumFalseNegatives?: Maybe<Scalars['Int']>;
  totalNumFalsePositives?: Maybe<Scalars['Int']>;
  totalNumGoodResponses?: Maybe<Scalars['Int']>;
  trueNegatives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  truePositives?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItemClassification>;
  version?: Maybe<Scalars['Int']>;
};

/** GetStepLogsRequest */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogsRequest_Input = {
  /** Optional: filter by audit status (default: UNAUDITED) */
  auditStatus?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAuditStatus>;
  /** Optional: filter by batch_id */
  batchId?: InputMaybe<Scalars['String']>;
  /** Optional: filter step logs created after this time */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  /** Optional: filter step logs created before this time */
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** Optional: maximum number of logs to return */
  limit?: InputMaybe<Scalars['Int']>;
  /** Optional: filter by step type */
  stepType?: InputMaybe<Scalars['String']>;
};

/** GetStepLogsResponse */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepLogsResponse = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_v1_GetStepLogsResponse';
  stepLogs?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLog>>>;
};

/** GetStepTypesResponse */
export type Instacart_Fulfillment_Domains_Transaction_Integrity_V1_GetStepTypesResponse = {
  __typename?: 'instacart_fulfillment_domains_transaction_integrity_v1_GetStepTypesResponse';
  stepTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Match an order's address against zips, cities, regions, or exact addresses.
 * Exactly one match arm is set per criterion.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AddressMatch = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_AddressMatch';
  cities?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList>;
  exactAddresses?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList>;
  regions?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList>;
  zips?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList>;
};

/**
 * Match an order's address against zips, cities, regions, or exact addresses.
 * Exactly one match arm is set per criterion.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AddressMatch_Input = {
  cities?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList_Input>;
  exactAddresses?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList_Input>;
  regions?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList_Input>;
  zips?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList_Input>;
};

/**
 * Caller identity carried on every RPC.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AuthorizationContext_Input = {
  canonicalId?: InputMaybe<Scalars['String']>;
};

/**
 * A boolean predicate. Matches when the attribute equals `value`.
 *
 * value is a BoolValue so unset, true, and false stay distinct on the wire:
 * false is a meaningful match (e.g. a non-loyalty customer) and proto3 scalar
 * bools cannot separate an omitted value from an explicit false. The server
 * rejects unset so match intent is never inferred from a default.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_BoolMatch';
  value?: Maybe<Scalars['Boolean']>;
};

/**
 * A boolean predicate. Matches when the attribute equals `value`.
 *
 * value is a BoolValue so unset, true, and false stay distinct on the wire:
 * false is a meaningful match (e.g. a non-loyalty customer) and proto3 scalar
 * bools cannot separate an omitted value from an explicit false. The server
 * rejects unset so match intent is never inferred from a default.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch_Input = {
  value?: InputMaybe<Scalars['Boolean']>;
};

/**
 * How a lowest-cost guardrail's `target` is interpreted.
 * Next id = 3
 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ComparisonType {
  /** `target` is the raw attribute value (e.g. an acceptance rate of 0.95). */
  ComparisonTypeAbsolute = 'COMPARISON_TYPE_ABSOLUTE',
  /**
   * `target` is a percentile rank in [0, 100] across eligible providers
   * (e.g. operator GREATER_THAN + target 90 means "in the top 10%").
   */
  ComparisonTypeRelative = 'COMPARISON_TYPE_RELATIVE',
  ComparisonTypeUnknown = 'COMPARISON_TYPE_UNKNOWN'
}

/** Next id = 7 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentRuleConfigurationsRequest_Input = {
  /** Must be non-empty and all entries must share the same EntityScope oneof arm. */
  attachedScopes?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input>>>;
  /**
   * Required. Opaque audit identifier of the principal performing this create.
   * Persisted as the rule's created_by and updated_by.
   */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Optional free text. Empty means no description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * UUID. Client-supplied opaque token for idempotent retries. If a Create
   * with the same key has already succeeded, the server returns the
   * previously-created rule instead of inserting a duplicate. Recommended: a
   * UUID generated per logical create attempt and reused across network
   * retries. Keys are retained for the rule's lifetime. Empty means no
   * idempotency guarantee -- the server will treat the call as a fresh create.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRulePayload_Input>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentRuleConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_CreateFulfillmentRuleConfigurationsResponse';
  rule?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRule>;
};

/** Next id = 8 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentStrategyRequest_Input = {
  /** Must be non-empty and all entries must share the same EntityScope oneof arm. */
  attachedScopes?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input>>>;
  /**
   * Required. Opaque audit identifier of the principal performing this create.
   * Persisted as the strategy's created_by and updated_by.
   */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Optional free text. Empty means no description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * UUID. Client-supplied opaque token for idempotent retries. If a Create with
   * the same key has already succeeded, the server returns the previously
   * created strategy instead of inserting a duplicate. Empty means no
   * idempotency guarantee.
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Type-specific parameters. The set arm must match `type`. Optional for
   * parameterless types (e.g. lowest cost).
   */
  payload?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategyPayload_Input>;
  type?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StrategyType>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CreateFulfillmentStrategyResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_CreateFulfillmentStrategyResponse';
  strategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategy>;
};

/**
 * One branch of a RuleExpression: a conjunction of Criteria paired with the
 * providers it applies to and an inclusion flag.
 *
 * `include = true` means the matched providers are added to the eligible set.
 * `include = false` means matched providers are removed from the eligible set
 * (block semantics).
 * Next id = 6
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CriteriaSet = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_CriteriaSet';
  /** All criteria must be satisfied for this set to match (AND logic). */
  criteria?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Criterion>>>;
  /** Longer explanation of what this set represents. */
  description?: Maybe<Scalars['String']>;
  /**
   * Fulfillment providers this set applies to (added to or removed from the
   * eligible set). Each value is an opaque fulfillment-provider identifier.
   */
  fulfillmentProviderIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * True = include matched providers; false = block matched providers.
   * Required field. BoolValue gives a tri-state on the wire (unset / true /
   * false); the server rejects unset so include vs block intent is never
   * inferred from a default.
   */
  include?: Maybe<Scalars['Boolean']>;
  /** Human-readable label for this branch. */
  name?: Maybe<Scalars['String']>;
};

/**
 * One branch of a RuleExpression: a conjunction of Criteria paired with the
 * providers it applies to and an inclusion flag.
 *
 * `include = true` means the matched providers are added to the eligible set.
 * `include = false` means matched providers are removed from the eligible set
 * (block semantics).
 * Next id = 6
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CriteriaSet_Input = {
  /** All criteria must be satisfied for this set to match (AND logic). */
  criteria?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Criterion_Input>>>;
  /** Longer explanation of what this set represents. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Fulfillment providers this set applies to (added to or removed from the
   * eligible set). Each value is an opaque fulfillment-provider identifier.
   */
  fulfillmentProviderIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * True = include matched providers; false = block matched providers.
   * Required field. BoolValue gives a tri-state on the wire (unset / true /
   * false); the server rejects unset so include vs block intent is never
   * inferred from a default.
   */
  include?: InputMaybe<Scalars['Boolean']>;
  /** Human-readable label for this branch. */
  name?: InputMaybe<Scalars['String']>;
};

/**
 * One predicate over an order or customer attribute. Negation is
 * expressed via the comparison Operator (e.g. NOT_EQUAL) rather than a
 * separate is_negated flag.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Criterion = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_Criterion';
  customer?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerAttribute>;
  order?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderAttribute>;
};

/**
 * One predicate over an order or customer attribute. Negation is
 * expressed via the comparison Operator (e.g. NOT_EQUAL) rather than a
 * separate is_negated flag.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Criterion_Input = {
  customer?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerAttribute_Input>;
  order?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderAttribute_Input>;
};

/**
 * Customer-based predicates.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerAttribute = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_CustomerAttribute';
  customerType?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerTypeMatch>;
  /** Whether the customer is a loyalty program member. */
  loyaltyMember?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch>;
};

/**
 * Customer-based predicates.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerAttribute_Input = {
  customerType?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerTypeMatch_Input>;
  /** Whether the customer is a loyalty program member. */
  loyaltyMember?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch_Input>;
};

/** Next id = 3 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerType {
  CustomerTypeCommercial = 'CUSTOMER_TYPE_COMMERCIAL',
  CustomerTypeResidential = 'CUSTOMER_TYPE_RESIDENTIAL',
  CustomerTypeUnknown = 'CUSTOMER_TYPE_UNKNOWN'
}

/**
 * Match a customer's type. Matches when the customer's type equals `type`.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerTypeMatch = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_CustomerTypeMatch';
  type?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerType>;
};

/**
 * Match a customer's type. Matches when the customer's type equals `type`.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerTypeMatch_Input = {
  type?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CustomerType>;
};

/** Next id = 5 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethod {
  DeliveryVerificationMethodIdCheck = 'DELIVERY_VERIFICATION_METHOD_ID_CHECK',
  DeliveryVerificationMethodPhoto = 'DELIVERY_VERIFICATION_METHOD_PHOTO',
  DeliveryVerificationMethodPin = 'DELIVERY_VERIFICATION_METHOD_PIN',
  DeliveryVerificationMethodSignature = 'DELIVERY_VERIFICATION_METHOD_SIGNATURE',
  DeliveryVerificationMethodUnknown = 'DELIVERY_VERIFICATION_METHOD_UNKNOWN'
}

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethods = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_DeliveryVerificationMethods';
  methods?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethod>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethods_Input = {
  methods?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethod>>>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Distance = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_Distance';
  unit?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceUnit>;
  value?: Maybe<Scalars['Float']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceComparison = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_DistanceComparison';
  operator?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Distance>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceComparison_Input = {
  operator?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Distance_Input>;
};

/** Next id = 4 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceUnit {
  DistanceUnitKilometer = 'DISTANCE_UNIT_KILOMETER',
  DistanceUnitMeter = 'DISTANCE_UNIT_METER',
  DistanceUnitMile = 'DISTANCE_UNIT_MILE',
  DistanceUnitUnknown = 'DISTANCE_UNIT_UNKNOWN'
}

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Distance_Input = {
  unit?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceUnit>;
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * Identifies where in the hierarchy a rule is scoped.
 * Hierarchy: partner → retailer → retailer location.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_EntityScope';
  partner?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PartnerScope>;
  retailer?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerScope>;
  retailerLocation?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationScope>;
};

/**
 * Identifies where in the hierarchy a rule is scoped.
 * Hierarchy: partner → retailer → retailer location.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input = {
  partner?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PartnerScope_Input>;
  retailer?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerScope_Input>;
  retailerLocation?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationScope_Input>;
};

/**
 * A position within the incoming payload or a related stored rule. Names the
 * affected criteria set; the enclosing finding's `message` carries any
 * finer-grained context.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FindingLocation = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FindingLocation';
  /** CriteriaSet.name from the payload (or from a related rule). */
  criteriaSetName?: Maybe<Scalars['String']>;
};

/** Next id = 5 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderEntity = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentProviderEntity';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

/**
 * Wrappers are absent on Get for fields the caller may not read.
 * Next id = 14
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerCapabilities = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentProviderPartnerCapabilities';
  deliveryVerificationMethods?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDeliveryVerificationMethods>;
  maxDistance?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDistance>;
  /** Max total order weight, summed across all items in a single order. */
  maxOrderWeight?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedWeight>;
  /**
   * Minimum lead time between hand-off to the provider and the order's
   * expected pickup-window start. Unset = no minimum.
   */
  minDispatchLeadTime?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDuration>;
  pickupVerificationMethods?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPickupVerificationMethods>;
  supportedPackageSizes?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPackageSizeSet>;
  supportsAlcohol?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
  supportsFrozen?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
  supportsLongDistanceDelivery?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
  supportsOtc?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
  supportsReturns?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
  supportsRx?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
  supportsUnattended?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool>;
};

/**
 * Wrappers are absent on Get for fields the caller may not read.
 * Next id = 14
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerCapabilities_Input = {
  deliveryVerificationMethods?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDeliveryVerificationMethods_Input>;
  maxDistance?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDistance_Input>;
  /** Max total order weight, summed across all items in a single order. */
  maxOrderWeight?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedWeight_Input>;
  /**
   * Minimum lead time between hand-off to the provider and the order's
   * expected pickup-window start. Unset = no minimum.
   */
  minDispatchLeadTime?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDuration_Input>;
  pickupVerificationMethods?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPickupVerificationMethods_Input>;
  supportedPackageSizes?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPackageSizeSet_Input>;
  supportsAlcohol?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
  supportsFrozen?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
  supportsLongDistanceDelivery?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
  supportsOtc?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
  supportsReturns?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
  supportsRx?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
  supportsUnattended?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input>;
};

/** Next id = 11 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfiguration = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentProviderPartnerConfiguration';
  capabilities?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerCapabilities>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  /**
   * Human-readable display name of the fulfillment provider identified by
   * fulfillment_provider_id. May be unset on responses that do not resolve it.
   */
  fulfillmentProviderName?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfigurationStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  /**
   * Round-trip the last-read value as expected_version on writes; a mismatch
   * returns ABORTED.
   */
  version?: Maybe<Scalars['BigInt']>;
};

/** Next id = 3 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfigurationStatus {
  FulfillmentProviderPartnerConfigurationStatusDisabled = 'FULFILLMENT_PROVIDER_PARTNER_CONFIGURATION_STATUS_DISABLED',
  FulfillmentProviderPartnerConfigurationStatusEnabled = 'FULFILLMENT_PROVIDER_PARTNER_CONFIGURATION_STATUS_ENABLED',
  FulfillmentProviderPartnerConfigurationStatusUnknown = 'FULFILLMENT_PROVIDER_PARTNER_CONFIGURATION_STATUS_UNKNOWN'
}

/** Next id = 12 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRule = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentRule';
  /** All entries must share the same EntityScope oneof arm. */
  attachedScopes?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Opaque audit identifier of the principal who created the rule. */
  createdBy?: Maybe<Scalars['String']>;
  /** Optional free text. Empty string means no description set. */
  description?: Maybe<Scalars['String']>;
  /** Server-assigned at create time. Stable for the rule's lifetime. */
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  payload?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRulePayload>;
  status?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Opaque audit identifier of the principal who last updated the rule. */
  updatedBy?: Maybe<Scalars['String']>;
  /**
   * Sequential optimistic-concurrency token. Starts at 1 on create and is
   * incremented by the server on every successful content or status update.
   * Clients round-trip the value from the last read as `expected_version` on
   * writes; mismatch returns ABORTED.
   */
  version?: Maybe<Scalars['BigInt']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRulePayload = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentRulePayload';
  /**
   * Field number reused from the previous EvaluationRule shape; safe because
   * there is no live data on the prior schema.
   */
  expression?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleExpression>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRulePayload_Input = {
  /**
   * Field number reused from the previous EvaluationRule shape; safe because
   * there is no live data on the prior schema.
   */
  expression?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleExpression_Input>;
};

/**
 * Targets one or more hierarchy nodes for rule validation.
 * Next id = 7
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRuleScope_Input = {
  partner?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PartnerScope_Input>;
  retailer?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerScope_Input>;
  retailerLocation?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationScope_Input>;
  retailerLocationsUnderPartner?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationsUnderPartnerScope_Input>;
  retailerLocationsUnderRetailer?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationsUnderRetailerScope_Input>;
  retailersUnderPartner?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailersUnderPartnerScope_Input>;
};

/**
 * A Strategy is a single editable entity identified by a server-assigned int64
 * id, with one payload and an attachment set of scopes where it applies. All
 * attachments must share scope type (all partner, OR all retailer, OR all
 * retailer_location). Status transitions mirror Rules: ENABLED ↔ DISABLED
 * reversible; → DELETED terminal; setting to current value is a no-op.
 * Next id = 13
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategy = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentStrategy';
  /** All entries must share the same EntityScope oneof arm. */
  attachedScopes?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Opaque audit identifier of the principal who created the strategy. */
  createdBy?: Maybe<Scalars['String']>;
  /** Optional free text. Empty string means no description set. */
  description?: Maybe<Scalars['String']>;
  /** Server-assigned at create time. Stable for the strategy's lifetime. */
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  payload?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategyPayload>;
  status?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleStatus>;
  type?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StrategyType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Opaque audit identifier of the principal who last updated the strategy. */
  updatedBy?: Maybe<Scalars['String']>;
  /**
   * Sequential optimistic-concurrency token. Starts at 1 on create, bumped by
   * the server on every successful content or status update. Clients round-trip
   * it as `expected_version` on writes; mismatch returns ABORTED.
   */
  version?: Maybe<Scalars['BigInt']>;
};

/**
 * Type-specific configuration for a strategy. Exactly one arm is set and it
 * must correspond to the strategy's `type`. Conditions for conditionally-applied
 * strategies, if introduced later, will be added here alongside the parameters.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategyPayload = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_FulfillmentStrategyPayload';
  historicalPerformance?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_HistoricalPerformanceStrategyParameters>;
  lowestCost?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostStrategyParameters>;
  volumeMix?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderVolumeMixStrategyParameters>;
};

/**
 * Type-specific configuration for a strategy. Exactly one arm is set and it
 * must correspond to the strategy's `type`. Conditions for conditionally-applied
 * strategies, if introduced later, will be added here alongside the parameters.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategyPayload_Input = {
  historicalPerformance?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_HistoricalPerformanceStrategyParameters_Input>;
  lowestCost?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostStrategyParameters_Input>;
  volumeMix?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderVolumeMixStrategyParameters_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderPartnerConfigurationsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AuthorizationContext_Input>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderPartnerConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_GetFulfillmentProviderPartnerConfigurationsResponse';
  configurations?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfiguration>>>;
};

/**
 * All fields are optional; set any combination to filter.
 * Multiple fields are ANDed together.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentProviderResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_GetFulfillmentProviderResponse';
  fulfillmentProviders?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderEntity>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentRuleConfigurationsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentRuleConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_GetFulfillmentRuleConfigurationsResponse';
  rule?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRule>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentStrategyRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_GetFulfillmentStrategyResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_GetFulfillmentStrategyResponse';
  strategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategy>;
};

/**
 * Parameters for STRATEGY_TYPE_HISTORICAL_PERFORMANCE: the relative weights the
 * strategy scores providers on, computed over the given lookback window. Each
 * weight is in the inclusive range [0, 100] and the five weights must sum to
 * 100. Weights may be fractional (e.g. 33.3 each).
 * Next id = 7
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_HistoricalPerformanceStrategyParameters = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_HistoricalPerformanceStrategyParameters';
  /** Weight on the provider's order-acceptance rate, in [0, 100]. */
  acceptanceRateWeight?: Maybe<Scalars['Float']>;
  /** Weight on the provider's cancellation rate, in [0, 100]. */
  cancellationRateWeight?: Maybe<Scalars['Float']>;
  /** Weight on the provider's customer-satisfaction score, in [0, 100]. */
  csatScoreWeight?: Maybe<Scalars['Float']>;
  /** Trailing window over which provider performance attributes are computed. */
  lookbackPeriod?: Maybe<Scalars['String']>;
  /** Weight on the provider's perfect-order rate, in [0, 100]. */
  perfectOrderRateWeight?: Maybe<Scalars['Float']>;
  /** Weight on the provider's refund rate, in [0, 100]. */
  refundRateWeight?: Maybe<Scalars['Float']>;
};

/**
 * Parameters for STRATEGY_TYPE_HISTORICAL_PERFORMANCE: the relative weights the
 * strategy scores providers on, computed over the given lookback window. Each
 * weight is in the inclusive range [0, 100] and the five weights must sum to
 * 100. Weights may be fractional (e.g. 33.3 each).
 * Next id = 7
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_HistoricalPerformanceStrategyParameters_Input = {
  /** Weight on the provider's order-acceptance rate, in [0, 100]. */
  acceptanceRateWeight?: InputMaybe<Scalars['Float']>;
  /** Weight on the provider's cancellation rate, in [0, 100]. */
  cancellationRateWeight?: InputMaybe<Scalars['Float']>;
  /** Weight on the provider's customer-satisfaction score, in [0, 100]. */
  csatScoreWeight?: InputMaybe<Scalars['Float']>;
  /** Trailing window over which provider performance attributes are computed. */
  lookbackPeriod?: InputMaybe<Scalars['String']>;
  /** Weight on the provider's perfect-order rate, in [0, 100]. */
  perfectOrderRateWeight?: InputMaybe<Scalars['Float']>;
  /** Weight on the provider's refund rate, in [0, 100]. */
  refundRateWeight?: InputMaybe<Scalars['Float']>;
};

/** Next id = 6 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategory {
  ItemCategoryAlcohol = 'ITEM_CATEGORY_ALCOHOL',
  ItemCategoryFrozen = 'ITEM_CATEGORY_FROZEN',
  ItemCategoryHotAndReady = 'ITEM_CATEGORY_HOT_AND_READY',
  ItemCategoryRx = 'ITEM_CATEGORY_RX',
  ItemCategoryUnknown = 'ITEM_CATEGORY_UNKNOWN'
}

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategoryList = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ItemCategoryList';
  categories?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategory>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategoryList_Input = {
  categories?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategory>>>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCountComparison = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ItemCountComparison';
  operator?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: Maybe<Scalars['BigInt']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCountComparison_Input = {
  operator?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Returns rules attached at the given scope. Set include_children to also
 * include rules attached at any descendant scope.
 * Pagination defaults: page_size default and cap are both 1000.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentRulesConfigurationsRequest_Input = {
  /** When true, also include rules attached at any descendant scope. */
  includeChildren?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentRulesConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ListFulfillmentRulesConfigurationsResponse';
  nextPageToken?: Maybe<Scalars['String']>;
  rules?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRule>>>;
};

/**
 * Returns strategies attached at the given scope. Set include_children to also
 * include strategies attached at any descendant scope.
 * Pagination defaults: page_size default and cap are both 1000.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentStrategiesRequest_Input = {
  /** When true, also include strategies attached at any descendant scope. */
  includeChildren?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  pageToken?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ListFulfillmentStrategiesResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ListFulfillmentStrategiesResponse';
  nextPageToken?: Maybe<Scalars['String']>;
  strategies?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategy>>>;
};

/**
 * A single bound applied to a provider's performance attribute while a
 * lowest-cost strategy selects on price. A provider must satisfy every
 * guardrail to be eligible.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrail = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_LowestCostGuardrail';
  /** The provider attribute this guardrail bounds. Required (non-UNKNOWN). */
  attribute?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrailAttribute>;
  /**
   * Whether `target` is an absolute value or a relative percentile. Required
   * (non-UNKNOWN).
   */
  comparisonType?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ComparisonType>;
  /**
   * Comparison operator (from the fulfillment rule proto), e.g. GREATER_THAN
   * for a floor or LESS_THAN for a ceiling. Required (non-UNKNOWN).
   */
  operator?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  /**
   * The threshold `attribute` is compared against. Interpreted per
   * `comparison_type`: a raw attribute value when ABSOLUTE, or a percentile
   * rank in [0, 100] when RELATIVE.
   */
  target?: Maybe<Scalars['Float']>;
};

/**
 * The provider attribute a lowest-cost guardrail is expressed against. All
 * attributes are provider performance rates the guardrail bounds while the
 * strategy otherwise selects on price.
 * Next id = 6
 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrailAttribute {
  /** Fraction of offered orders the provider accepted. */
  LowestCostGuardrailAttributeAcceptanceRate = 'LOWEST_COST_GUARDRAIL_ATTRIBUTE_ACCEPTANCE_RATE',
  /** Fraction of orders cancelled. */
  LowestCostGuardrailAttributeCancellationRate = 'LOWEST_COST_GUARDRAIL_ATTRIBUTE_CANCELLATION_RATE',
  /** Customer satisfaction score. */
  LowestCostGuardrailAttributeCsatScore = 'LOWEST_COST_GUARDRAIL_ATTRIBUTE_CSAT_SCORE',
  /** Fraction of orders delivered without any issue (perfect-order rate). */
  LowestCostGuardrailAttributePerfectOrderRate = 'LOWEST_COST_GUARDRAIL_ATTRIBUTE_PERFECT_ORDER_RATE',
  /** Fraction of orders refunded. */
  LowestCostGuardrailAttributeRefundRate = 'LOWEST_COST_GUARDRAIL_ATTRIBUTE_REFUND_RATE',
  LowestCostGuardrailAttributeUnknown = 'LOWEST_COST_GUARDRAIL_ATTRIBUTE_UNKNOWN'
}

/**
 * A single bound applied to a provider's performance attribute while a
 * lowest-cost strategy selects on price. A provider must satisfy every
 * guardrail to be eligible.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrail_Input = {
  /** The provider attribute this guardrail bounds. Required (non-UNKNOWN). */
  attribute?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrailAttribute>;
  /**
   * Whether `target` is an absolute value or a relative percentile. Required
   * (non-UNKNOWN).
   */
  comparisonType?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ComparisonType>;
  /**
   * Comparison operator (from the fulfillment rule proto), e.g. GREATER_THAN
   * for a floor or LESS_THAN for a ceiling. Required (non-UNKNOWN).
   */
  operator?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  /**
   * The threshold `attribute` is compared against. Interpreted per
   * `comparison_type`: a raw attribute value when ABSOLUTE, or a percentile
   * rank in [0, 100] when RELATIVE.
   */
  target?: InputMaybe<Scalars['Float']>;
};

/**
 * Parameters for STRATEGY_TYPE_LOWEST_COST: select the cheapest eligible
 * provider, subject to zero or more performance guardrails, computed over the
 * given lookback window.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostStrategyParameters = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_LowestCostStrategyParameters';
  /**
   * Performance bounds every eligible provider must satisfy. May be empty
   * (pure lowest-cost selection with no guardrails).
   */
  guardrails?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrail>>>;
  /** Trailing window over which provider performance attributes are computed. */
  lookbackPeriod?: Maybe<Scalars['String']>;
};

/**
 * Parameters for STRATEGY_TYPE_LOWEST_COST: select the cheapest eligible
 * provider, subject to zero or more performance guardrails, computed over the
 * given lookback window.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostStrategyParameters_Input = {
  /**
   * Performance bounds every eligible provider must satisfy. May be empty
   * (pure lowest-cost selection with no guardrails).
   */
  guardrails?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_LowestCostGuardrail_Input>>>;
  /** Trailing window over which provider performance attributes are computed. */
  lookbackPeriod?: InputMaybe<Scalars['String']>;
};

/**
 * Comparison operator for scalar attribute predicates.
 * Next id = 7
 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator {
  OperatorEqual = 'OPERATOR_EQUAL',
  OperatorGreaterThan = 'OPERATOR_GREATER_THAN',
  OperatorGreaterThanOrEqual = 'OPERATOR_GREATER_THAN_OR_EQUAL',
  OperatorLessThan = 'OPERATOR_LESS_THAN',
  OperatorLessThanOrEqual = 'OPERATOR_LESS_THAN_OR_EQUAL',
  OperatorNotEqual = 'OPERATOR_NOT_EQUAL',
  OperatorUnknown = 'OPERATOR_UNKNOWN'
}

/**
 * Order-based predicates.
 * Next id = 11
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderAttribute = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_OrderAttribute';
  address?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AddressMatch>;
  /** Whether the order contains a big-and-bulky item. */
  bigAndBulky?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch>;
  /**
   * Order creation time-of-day, evaluated in the candidate store's local
   * timezone.
   */
  creationTimeOfDay?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_TimeOfDayRange>;
  deliveryDistance?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceComparison>;
  /** Whether the order requires verified (certified or age-verified) delivery. */
  deliveryVerificationRequired?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch>;
  itemCategories?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategoryList>;
  /** Number of items in the order. */
  itemCount?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCountComparison>;
  /** Order grand total (items + fees + taxes + tip − discounts). */
  price?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PriceComparison>;
  /** Whether the order is an unattended delivery. */
  unattendedDelivery?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch>;
  weight?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightComparison>;
};

/**
 * Order-based predicates.
 * Next id = 11
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderAttribute_Input = {
  address?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AddressMatch_Input>;
  /** Whether the order contains a big-and-bulky item. */
  bigAndBulky?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch_Input>;
  /**
   * Order creation time-of-day, evaluated in the candidate store's local
   * timezone.
   */
  creationTimeOfDay?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_TimeOfDayRange_Input>;
  deliveryDistance?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DistanceComparison_Input>;
  /** Whether the order requires verified (certified or age-verified) delivery. */
  deliveryVerificationRequired?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch_Input>;
  itemCategories?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCategoryList_Input>;
  /** Number of items in the order. */
  itemCount?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ItemCountComparison_Input>;
  /** Order grand total (items + fees + taxes + tip − discounts). */
  price?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PriceComparison_Input>;
  /** Whether the order is an unattended delivery. */
  unattendedDelivery?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_BoolMatch_Input>;
  weight?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightComparison_Input>;
};

/**
 * Parameters for STRATEGY_TYPE_ORDER_VOLUME_MIX. Exactly one parameterization is
 * set: either a target percentage split across providers, or a strict
 * preference ordering over providers.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderVolumeMixStrategyParameters = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_OrderVolumeMixStrategyParameters';
  /**
   * Trailing window over which realized order volume is measured to steer the
   * mix. Ignored for `ordered_preference`, which is a static priority list.
   */
  lookbackPeriod?: Maybe<Scalars['String']>;
  orderedPreference?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderedPreference>;
  percentMix?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderOrderPercentMix>;
};

/**
 * Parameters for STRATEGY_TYPE_ORDER_VOLUME_MIX. Exactly one parameterization is
 * set: either a target percentage split across providers, or a strict
 * preference ordering over providers.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderVolumeMixStrategyParameters_Input = {
  /**
   * Trailing window over which realized order volume is measured to steer the
   * mix. Ignored for `ordered_preference`, which is a static priority list.
   */
  lookbackPeriod?: InputMaybe<Scalars['String']>;
  orderedPreference?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderedPreference_Input>;
  percentMix?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderOrderPercentMix_Input>;
};

/**
 * A strict ordering of providers by preference: the strategy prefers the
 * earliest available provider in the list.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderedPreference = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_OrderedPreference';
  /**
   * Opaque fulfillment-provider identifiers, most preferred first. Must be
   * non-empty and contain no duplicates.
   */
  fulfillmentProviderIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * A strict ordering of providers by preference: the strategy prefers the
 * earliest available provider in the list.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_OrderedPreference_Input = {
  /**
   * Opaque fulfillment-provider identifiers, most preferred first. Must be
   * non-empty and contain no duplicates.
   */
  fulfillmentProviderIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Next id = 4 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSize {
  PackageSizeLarge = 'PACKAGE_SIZE_LARGE',
  PackageSizeNormal = 'PACKAGE_SIZE_NORMAL',
  PackageSizeSmall = 'PACKAGE_SIZE_SMALL',
  PackageSizeUnknown = 'PACKAGE_SIZE_UNKNOWN'
}

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSizeSet = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PackageSizeSet';
  sizes?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSize>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSizeSet_Input = {
  sizes?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSize>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PartnerScope = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PartnerScope';
  partnerId?: Maybe<Scalars['BigInt']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PartnerScope_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedBool';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Boolean']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedBool_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDeliveryVerificationMethods = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedDeliveryVerificationMethods';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethods>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDeliveryVerificationMethods_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_DeliveryVerificationMethods_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDistance = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedDistance';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Distance>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDistance_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Distance_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDuration = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedDuration';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedDuration_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPackageSizeSet = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedPackageSizeSet';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSizeSet>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPackageSizeSet_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PackageSizeSet_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPickupVerificationMethods = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedPickupVerificationMethods';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethods>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedPickupVerificationMethods_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethods_Input>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedWeight = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PermissionedWeight';
  partnerWritable?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Weight>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PermissionedWeight_Input = {
  partnerWritable?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Weight_Input>;
};

/** Next id = 2 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethod {
  PickupVerificationMethodQrCode = 'PICKUP_VERIFICATION_METHOD_QR_CODE',
  PickupVerificationMethodUnknown = 'PICKUP_VERIFICATION_METHOD_UNKNOWN'
}

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethods = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PickupVerificationMethods';
  methods?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethod>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethods_Input = {
  methods?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PickupVerificationMethod>>>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PriceComparison = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_PriceComparison';
  operator?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: Maybe<GoogleTypeMoney>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_PriceComparison_Input = {
  operator?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: InputMaybe<GoogleTypeMoneyInput>;
};

/**
 * A target split of order volume across providers (e.g. 80% provider A, 20%
 * provider B). Each provider appears at most once and the percentages sum to
 * 100.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderOrderPercentMix = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ProviderOrderPercentMix';
  /** One entry per fulfillment provider in the mix. Must be non-empty. */
  providerPercents?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderPercentShare>>>;
};

/**
 * A target split of order volume across providers (e.g. 80% provider A, 20%
 * provider B). Each provider appears at most once and the percentages sum to
 * 100.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderOrderPercentMix_Input = {
  /** One entry per fulfillment provider in the mix. Must be non-empty. */
  providerPercents?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderPercentShare_Input>>>;
};

/**
 * Target share of order volume for a single provider, as a percentage. May be
 * fractional (e.g. 10.5).
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderPercentShare = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ProviderPercentShare';
  /** Opaque fulfillment-provider identifier. */
  fulfillmentProviderId?: Maybe<Scalars['BigInt']>;
  /**
   * Percentage of orders to allocate to this provider, in [0, 100]. May be
   * fractional (e.g. 10.5).
   */
  percent?: Maybe<Scalars['Float']>;
};

/**
 * Target share of order volume for a single provider, as a percentage. May be
 * fractional (e.g. 10.5).
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ProviderPercentShare_Input = {
  /** Opaque fulfillment-provider identifier. */
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Percentage of orders to allocate to this provider, in [0, 100]. May be
   * fractional (e.g. 10.5).
   */
  percent?: InputMaybe<Scalars['Float']>;
};

/** Next id = 4 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationScope = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_RetailerLocationScope';
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
};

/** Next id = 4 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationScope_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * A retailer location identified by its retailer.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocation_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Retailer locations from different retailers under the same partner.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationsUnderPartnerScope_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocations?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocation_Input>>>;
};

/**
 * Multiple retailer locations under one retailer.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerLocationsUnderRetailerScope_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerScope = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_RetailerScope';
  partnerId?: Maybe<Scalars['BigInt']>;
  retailerId?: Maybe<Scalars['BigInt']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailerScope_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Multiple retailers under one partner.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RetailersUnderPartnerScope_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/**
 * A complete rule expression: a disjunction of CriteriaSets. The expression
 * matches if any of its CriteriaSets match (OR across sets). Within a set,
 * all criteria must match (AND across criteria).
 *
 * Block semantics are expressed by setting `include = false` on a CriteriaSet
 * rather than via a separate exclusion list.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleExpression = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_RuleExpression';
  criteriaSets?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CriteriaSet>>>;
};

/**
 * A complete rule expression: a disjunction of CriteriaSets. The expression
 * matches if any of its CriteriaSets match (OR across sets). Within a set,
 * all criteria must match (AND across criteria).
 *
 * Block semantics are expressed by setting `include = false` on a CriteriaSet
 * rather than via a separate exclusion list.
 * Next id = 2
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleExpression_Input = {
  criteriaSets?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_CriteriaSet_Input>>>;
};

/**
 * Reference to a stored rule that participated in a finding. Carries the
 * rule's name and scope so attribution can be rendered without an extra
 * lookup.
 * Next id = 4
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleRef = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_RuleRef';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  scope?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope>;
};

/**
 * Lifecycle status of a rule. ENABLED ↔ DISABLED is reversible; transition to
 * DELETED is terminal (soft delete). Setting status to its current value is a
 * no-op.
 * Next id = 4
 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleStatus {
  RuleStatusDeleted = 'RULE_STATUS_DELETED',
  RuleStatusDisabled = 'RULE_STATUS_DISABLED',
  RuleStatusEnabled = 'RULE_STATUS_ENABLED',
  RuleStatusUnknown = 'RULE_STATUS_UNKNOWN'
}

/**
 * The selection algorithm a strategy applies.
 * Next id = 4
 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StrategyType {
  /**
   * Choose the eligible provider with the best historical performance
   * (on-time delivery, cancellations).
   */
  StrategyTypeHistoricalPerformance = 'STRATEGY_TYPE_HISTORICAL_PERFORMANCE',
  /** Choose the eligible provider with the lowest quoted fee. */
  StrategyTypeLowestCost = 'STRATEGY_TYPE_LOWEST_COST',
  /**
   * Choose a provider so realized volume tracks a configured mix
   * (e.g. 80% provider A, 20% provider B).
   */
  StrategyTypeOrderVolumeMix = 'STRATEGY_TYPE_ORDER_VOLUME_MIX',
  StrategyTypeUnknown = 'STRATEGY_TYPE_UNKNOWN'
}

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_StringList';
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StringList_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * A half-open wall-clock range [start, end). If end < start the range wraps
 * midnight (e.g. 22:00 → 06:00). Carries no timezone; the criterion arm using
 * it specifies which timezone the range is interpreted in.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_TimeOfDayRange = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_TimeOfDayRange';
  end?: Maybe<GoogleTypeTimeOfDay>;
  start?: Maybe<GoogleTypeTimeOfDay>;
};

/**
 * A half-open wall-clock range [start, end). If end < start the range wraps
 * midnight (e.g. 22:00 → 06:00). Carries no timezone; the criterion arm using
 * it specifies which timezone the range is interpreted in.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_TimeOfDayRange_Input = {
  end?: InputMaybe<GoogleTypeTimeOfDayInput>;
  start?: InputMaybe<GoogleTypeTimeOfDayInput>;
};

/**
 * Full-replacement update.
 * Next id = 7
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AuthorizationContext_Input>;
  capabilities?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerCapabilities_Input>;
  expectedVersion?: InputMaybe<Scalars['BigInt']>;
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** Required. Opaque audit identifier of the principal performing this update. */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_UpdateFulfillmentProviderPartnerConfigurationResponse';
  configuration?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfiguration>;
};

/** Next id = 7 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationStatusRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_AuthorizationContext_Input>;
  expectedVersion?: InputMaybe<Scalars['BigInt']>;
  fulfillmentProviderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfigurationStatus>;
  /**
   * Required. Opaque audit identifier of the principal performing this
   * status change.
   */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentProviderPartnerConfigurationStatusResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_UpdateFulfillmentProviderPartnerConfigurationStatusResponse';
  configuration?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentProviderPartnerConfiguration>;
};

/**
 * Combined content + attachment update for a single rule. Client sends the
 * COMPLETE desired state of name/description/payload/attached_scopes.
 * All entries in attached_scopes must share the same EntityScope oneof arm.
 * Next id = 8
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleConfigurationsRequest_Input = {
  attachedScopes?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input>>>;
  /** Optional free text. Empty means no description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Sequential version read from the rule's current `version`; mismatch
   * returns ABORTED.
   */
  expectedVersion?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRulePayload_Input>;
  /**
   * Required. Opaque audit identifier of the principal performing this update.
   * Persisted as the rule's updated_by.
   */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_UpdateFulfillmentRuleConfigurationsResponse';
  rule?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRule>;
};

/**
 * One-click status toggle from the rule list. ENABLED ↔ DISABLED is
 * reversible; setting to DELETED is a soft delete (terminal). Setting to the
 * current status is a no-op.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleStatusConfigurationsRequest_Input = {
  /**
   * Sequential version read from the rule's current `version`; mismatch
   * returns ABORTED.
   */
  expectedVersion?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleStatus>;
  /**
   * Required. Opaque audit identifier of the principal performing this status
   * change. Persisted as the rule's updated_by.
   */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentRuleStatusConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_UpdateFulfillmentRuleStatusConfigurationsResponse';
  rule?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRule>;
};

/**
 * Combined content + attachment update for a single strategy. Client sends the
 * COMPLETE desired state of name/description/type/payload/attached_scopes.
 * All entries in attached_scopes must share the same EntityScope oneof arm.
 * Next id = 9
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyRequest_Input = {
  attachedScopes?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope_Input>>>;
  /** Optional free text. Empty means no description. */
  description?: InputMaybe<Scalars['String']>;
  /**
   * Sequential version read from the strategy's current `version`; mismatch
   * returns ABORTED.
   */
  expectedVersion?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * Type-specific parameters. The set arm must match `type`. Must be set when
   * `type` is changing.
   */
  payload?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategyPayload_Input>;
  type?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_StrategyType>;
  /**
   * Required. Opaque audit identifier of the principal performing this update.
   * Persisted as the strategy's updated_by.
   */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_UpdateFulfillmentStrategyResponse';
  strategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategy>;
};

/**
 * One-click status toggle from the strategy list. ENABLED ↔ DISABLED is
 * reversible; setting to DELETED is a soft delete (terminal). Setting to the
 * current status is a no-op.
 * Next id = 5
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyStatusRequest_Input = {
  /**
   * Sequential version read from the strategy's current `version`; mismatch
   * returns ABORTED.
   */
  expectedVersion?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['BigInt']>;
  status?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleStatus>;
  /**
   * Required. Opaque audit identifier of the principal performing this status
   * change. Persisted as the strategy's updated_by.
   */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_UpdateFulfillmentStrategyStatusResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_UpdateFulfillmentStrategyStatusResponse';
  strategy?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentStrategy>;
};

/** Next id = 4 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidateFulfillmentRuleConfigurationsRequest_Input = {
  /** The proposed rule contents. Set for Create and Update; omitted for Delete. */
  payload?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRulePayload_Input>;
  /**
   * ID of the existing rule being updated or deleted. Operation is inferred:
   * payload set, rule_id unset  -> Create
   * payload set, rule_id set    -> Update (rule_id excluded from same-scope
   * duplicate check against itself)
   * payload unset, rule_id set  -> Delete (validates the post-delete state)
   * neither set                 -> InvalidArgument
   */
  ruleId?: InputMaybe<Scalars['BigInt']>;
  /**
   * For Create/Update: the (new) scopes to attach this rule at.
   * For Delete: required only when the operation context needs to be made
   * explicit; otherwise derivable from the rule's attached_scopes.
   */
  scope?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FulfillmentRuleScope_Input>;
};

/** Next id = 2 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidateFulfillmentRuleConfigurationsResponse = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ValidateFulfillmentRuleConfigurationsResponse';
  results?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidateFulfillmentRuleConfigurationsScopedResult>>>;
};

/**
 * Per-node validation result. Empty findings = rule is valid at this scope.
 * Next id = 3
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidateFulfillmentRuleConfigurationsScopedResult = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ValidateFulfillmentRuleConfigurationsScopedResult';
  findings?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidationFinding>>>;
  scope?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_EntityScope>;
};

/**
 * One validation finding. Validators must emit one finding per
 * (severity, category, message) tuple rather than coalescing unrelated issues.
 * Next id = 6
 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidationFinding = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_ValidationFinding';
  category?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidationFinding_Category>;
  /**
   * Positions within the incoming payload (or within a related stored rule)
   * that the finding refers to. Empty when the finding has no specific
   * location.
   */
  locations?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_FindingLocation>>>;
  /**
   * Human-readable summary. Illustrative only -- consumers must not branch
   * on the string. Subject to change and (future) localization.
   */
  message?: Maybe<Scalars['String']>;
  /**
   * Stored rules whose interaction with the incoming write produced this
   * finding. Empty for payload-only findings (CATEGORY_INVALID / _MISSING).
   */
  relatedRules?: Maybe<Array<Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_RuleRef>>>;
  severity?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidationFinding_Severity>;
};

/** Next id = 7 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidationFinding_Category {
  /**
   * Incoming write would leave a descendant scope with no eligible
   * providers for some slice. WARN -- the author at the writing scope can
   * proceed; the descendant rule's owner can fix it separately.
   */
  CategoryDescendantNoProviders = 'CATEGORY_DESCENDANT_NO_PROVIDERS',
  /** Exact duplicate of an existing rule at the same scope. BLOCK. */
  CategoryDuplicate = 'CATEGORY_DUPLICATE',
  /**
   * Bad field values, structural mistakes, malformed request, uncontracted
   * provider. BLOCK.
   */
  CategoryInvalid = 'CATEGORY_INVALID',
  /**
   * Required structure absent (name, include flag, provider ids, ...).
   * BLOCK.
   */
  CategoryMissing = 'CATEGORY_MISSING',
  /** Redundant inclusion. WARN. */
  CategoryNoEffect = 'CATEGORY_NO_EFFECT',
  /**
   * No eligible providers for some slice after composition with ancestor
   * state. BLOCK.
   */
  CategoryNoProviders = 'CATEGORY_NO_PROVIDERS',
  CategoryUnknown = 'CATEGORY_UNKNOWN'
}

/** Next id = 3 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_ValidationFinding_Severity {
  SeverityBlock = 'SEVERITY_BLOCK',
  SeverityUnknown = 'SEVERITY_UNKNOWN',
  SeverityWarn = 'SEVERITY_WARN'
}

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Weight = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_Weight';
  unit?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightUnit>;
  value?: Maybe<Scalars['Float']>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightComparison = {
  __typename?: 'instacart_fulfillment_fulfillment_providers_fulfillment_constraints_v1_WeightComparison';
  operator?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: Maybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Weight>;
};

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightComparison_Input = {
  operator?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Operator>;
  value?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Weight_Input>;
};

/** Next id = 5 */
export enum Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightUnit {
  WeightUnitGram = 'WEIGHT_UNIT_GRAM',
  WeightUnitKilogram = 'WEIGHT_UNIT_KILOGRAM',
  WeightUnitOunce = 'WEIGHT_UNIT_OUNCE',
  WeightUnitPound = 'WEIGHT_UNIT_POUND',
  WeightUnitUnknown = 'WEIGHT_UNIT_UNKNOWN'
}

/** Next id = 3 */
export type Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_Weight_Input = {
  unit?: InputMaybe<Instacart_Fulfillment_Fulfillment_Providers_Fulfillment_Constraints_V1_WeightUnit>;
  value?: InputMaybe<Scalars['Float']>;
};

/**
 * How the customer responded to the shopper.
 * Duplicated here from public_apis to avoid internal services depending on public_apis.
 * Keep in sync with instacart/fulfillment/public_apis/delivery/order_delivery_transitions/v1/unattended_order_delivery_transitions.proto.
 */
export enum Instacart_Fulfillment_Shared_V1_CustomerResponse {
  CustomerResponseAskedToCancel = 'CUSTOMER_RESPONSE_ASKED_TO_CANCEL',
  CustomerResponseAskedToWait = 'CUSTOMER_RESPONSE_ASKED_TO_WAIT',
  CustomerResponseFound = 'CUSTOMER_RESPONSE_FOUND',
  CustomerResponseIncorrectAddress = 'CUSTOMER_RESPONSE_INCORRECT_ADDRESS',
  CustomerResponseLeaveAtDoor = 'CUSTOMER_RESPONSE_LEAVE_AT_DOOR',
  CustomerResponseNoResponse = 'CUSTOMER_RESPONSE_NO_RESPONSE',
  CustomerResponseUnknown = 'CUSTOMER_RESPONSE_UNKNOWN'
}

/** GetTenderTransactionsByWhlIdsRequest */
export type Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsRequest_Input = {
  fromDate?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<Instacart_Fulfillment_Shared_V1_TenderTransaction_TenderTransactionState>;
  toDate?: InputMaybe<Scalars['DateTime']>;
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** GetTenderTransactionsByStoreIdsResponse */
export type Instacart_Fulfillment_Shared_V1_GetTenderTransactionsByWhlIdsResponse = {
  __typename?: 'instacart_fulfillment_shared_v1_GetTenderTransactionsByWhlIdsResponse';
  tenderTransactions?: Maybe<Array<Maybe<Instacart_Fulfillment_Shared_V1_TenderTransaction>>>;
};

/**
 * Reasons why a delivery could not be completed.
 * Used across multiple services for consistency.
 */
export enum Instacart_Fulfillment_Shared_V1_NotDeliveredReason {
  NotDeliveredReasonCustomerUnavailable = 'NOT_DELIVERED_REASON_CUSTOMER_UNAVAILABLE',
  NotDeliveredReasonDispatcherCanceled = 'NOT_DELIVERED_REASON_DISPATCHER_CANCELED',
  NotDeliveredReasonOther = 'NOT_DELIVERED_REASON_OTHER',
  NotDeliveredReasonRouteIssues = 'NOT_DELIVERED_REASON_ROUTE_ISSUES',
  NotDeliveredReasonShiftEnding = 'NOT_DELIVERED_REASON_SHIFT_ENDING',
  NotDeliveredReasonUnknown = 'NOT_DELIVERED_REASON_UNKNOWN'
}

/** Tender Merchant */
export type Instacart_Fulfillment_Shared_V1_TenderMerchant = {
  __typename?: 'instacart_fulfillment_shared_v1_TenderMerchant';
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
  warehouseLocationId?: Maybe<Scalars['BigInt']>;
  zip?: Maybe<Scalars['String']>;
};

/** Tender Transaction */
export type Instacart_Fulfillment_Shared_V1_TenderTransaction = {
  __typename?: 'instacart_fulfillment_shared_v1_TenderTransaction';
  amount?: Maybe<GoogleTypeMoney>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  state?: Maybe<Instacart_Fulfillment_Shared_V1_TenderTransaction_TenderTransactionState>;
  tenderMerchant?: Maybe<Instacart_Fulfillment_Shared_V1_TenderMerchant>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Fulfillment_Shared_V1_TenderTransaction_TenderTransactionState {
  TenderTransactionStateCleared = 'TENDER_TRANSACTION_STATE_CLEARED',
  TenderTransactionStateCompletion = 'TENDER_TRANSACTION_STATE_COMPLETION',
  TenderTransactionStateDeclined = 'TENDER_TRANSACTION_STATE_DECLINED',
  TenderTransactionStateError = 'TENDER_TRANSACTION_STATE_ERROR',
  TenderTransactionStatePending = 'TENDER_TRANSACTION_STATE_PENDING',
  TenderTransactionStateUnknown = 'TENDER_TRANSACTION_STATE_UNKNOWN'
}

/** CatalogCandidate is a catalog product match for a receipt line item. */
export type Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_CatalogCandidate = {
  __typename?: 'instacart_fulfillment_shopper_checkout_receipt_understanding_v1_CatalogCandidate';
  /** ai_reasoning is the AI's explanation for the assigned tier; empty if AI scoring was not performed */
  aiReasoning?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  /** shopper_order_item_id links this candidate to a specific item in the shopper's order */
  shopperOrderItemId?: Maybe<Scalars['String']>;
  /** tier is populated by AI scoring; unknown if AI is unavailable */
  tier?: Maybe<Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_CatalogCandidateTier>;
  /** upc_matched is true when this candidate was identified via barcode scan at register */
  upcMatched?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_CatalogCandidateTier {
  CatalogCandidateTierHigh = 'CATALOG_CANDIDATE_TIER_HIGH',
  CatalogCandidateTierLow = 'CATALOG_CANDIDATE_TIER_LOW',
  CatalogCandidateTierMedium = 'CATALOG_CANDIDATE_TIER_MEDIUM',
  CatalogCandidateTierUnknown = 'CATALOG_CANDIDATE_TIER_UNKNOWN'
}

/** GetReceiptItemCatalogCandidatesRequest is the request message for GetReceiptItemCatalogCandidates. */
export type Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_GetReceiptItemCatalogCandidatesRequest_Input = {
  /**
   * enable_ai_scoring controls whether AI tier scoring is performed.
   * Defaults to false — candidates are returned without AI scores.
   * Set to true to enrich candidates with high/medium/low confidence tiers.
   */
  enableAiScoring?: InputMaybe<Scalars['Boolean']>;
  orderDeliveryId?: InputMaybe<Scalars['String']>;
  posReceiptsClassifierOutputId?: InputMaybe<Scalars['String']>;
};

/** GetReceiptItemCatalogCandidatesResponse is the response message for GetReceiptItemCatalogCandidates. */
export type Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_GetReceiptItemCatalogCandidatesResponse = {
  __typename?: 'instacart_fulfillment_shopper_checkout_receipt_understanding_v1_GetReceiptItemCatalogCandidatesResponse';
  orderDeliveryId?: Maybe<Scalars['String']>;
  posReceiptsClassifierOutputId?: Maybe<Scalars['String']>;
  receiptItems?: Maybe<Array<Maybe<Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_ReceiptItemCatalogCandidates>>>;
};

/** ReceiptItemCatalogCandidates holds all catalog candidates for one receipt line item. */
export type Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_ReceiptItemCatalogCandidates = {
  __typename?: 'instacart_fulfillment_shopper_checkout_receipt_understanding_v1_ReceiptItemCatalogCandidates';
  candidates?: Maybe<Array<Maybe<Instacart_Fulfillment_Shopper_Checkout_Receipt_Understanding_V1_CatalogCandidate>>>;
  shortName?: Maybe<Scalars['String']>;
};

/** Approval decision for pending override intent. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideDecision {
  BudgetOverrideDecisionApprove = 'BUDGET_OVERRIDE_DECISION_APPROVE',
  BudgetOverrideDecisionReject = 'BUDGET_OVERRIDE_DECISION_REJECT',
  BudgetOverrideDecisionUnknown = 'BUDGET_OVERRIDE_DECISION_UNKNOWN'
}

/** Current effectiveness of an override event's concrete targets. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideEffectiveness {
  BudgetOverrideEffectivenessCanceled = 'BUDGET_OVERRIDE_EFFECTIVENESS_CANCELED',
  BudgetOverrideEffectivenessEffective = 'BUDGET_OVERRIDE_EFFECTIVENESS_EFFECTIVE',
  BudgetOverrideEffectivenessPartiallySuperseded = 'BUDGET_OVERRIDE_EFFECTIVENESS_PARTIALLY_SUPERSEDED',
  BudgetOverrideEffectivenessPending = 'BUDGET_OVERRIDE_EFFECTIVENESS_PENDING',
  BudgetOverrideEffectivenessRejected = 'BUDGET_OVERRIDE_EFFECTIVENESS_REJECTED',
  BudgetOverrideEffectivenessSuperseded = 'BUDGET_OVERRIDE_EFFECTIVENESS_SUPERSEDED',
  BudgetOverrideEffectivenessUnknown = 'BUDGET_OVERRIDE_EFFECTIVENESS_UNKNOWN'
}

/** Monetary override intent, mutable lifecycle state, and immutable targets. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideEvent = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_BudgetOverrideEvent';
  /** Deprecated event-level amount retained for wire compatibility; inspect targets for canonical per-target values. */
  amountCents?: Maybe<Scalars['BigInt']>;
  /** Approval-management request identifier. */
  approvalRequestId?: Maybe<Scalars['String']>;
  /** Immutable approval timestamp, retained if the approved event is later canceled. */
  approvedAt?: Maybe<Scalars['DateTime']>;
  /** Canonical account ID of the actor who approved the event, retained after cancellation. */
  approvedByCanonicalId?: Maybe<Scalars['String']>;
  /** Immutable cancellation timestamp. */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** Canonical account ID of the actor who canceled the event. */
  canceledByCanonicalId?: Maybe<Scalars['String']>;
  /** Time the intent was recorded. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Authenticated creator canonical account ID. */
  createdByCanonicalId?: Maybe<Scalars['String']>;
  /** Deprecated event-level currency retained for wire compatibility; inspect targets for canonical per-target values. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Number of targets effective at the response's resolution cutoff. */
  effectiveTargetCount?: Maybe<Scalars['Int']>;
  /** Aggregate effectiveness of the concrete targets. */
  effectiveness?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideEffectiveness>;
  /** Caller-generated idempotency key. */
  idempotencyKey?: Maybe<Scalars['String']>;
  /** Incentive program whose budget is adjusted. */
  incentiveProgram?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideIncentiveProgram>;
  /** Deprecated event-level multiplier retained for wire compatibility; inspect targets for canonical per-target values. */
  multiplierBasisPoints?: Maybe<Scalars['BigInt']>;
  /** Resource name formatted as incentiveBudgetOverrideEvents/{id}. */
  name?: Maybe<Scalars['String']>;
  /** Optional operational context. */
  notes?: Maybe<Scalars['String']>;
  /** Canonical persisted operation: SET is absolute and locked, while MULTIPLY and ADD are relative to the final projection. */
  operation?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideOperation>;
  /** Structured business reason. */
  reason?: Maybe<Scalars['String']>;
  /** Immutable rejection timestamp. */
  rejectedAt?: Maybe<Scalars['DateTime']>;
  /** Canonical account ID of the actor who rejected the event. */
  rejectedByCanonicalId?: Maybe<Scalars['String']>;
  /** Stable source namespace. */
  sourceKind?: Maybe<Scalars['String']>;
  /** Non-queryable authoring and source provenance. */
  sourceMetadata?: Maybe<Scalars['JSON']>;
  /** Current lifecycle state. */
  state?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideState>;
  /** Time of the most recent lifecycle-state change. */
  stateChangedAt?: Maybe<Scalars['DateTime']>;
  /** Authenticated actor who most recently changed lifecycle state. */
  stateChangedByCanonicalId?: Maybe<Scalars['String']>;
  /** Number of targets displaced by approved successors at the response's resolution cutoff. */
  supersededTargetCount?: Maybe<Scalars['Int']>;
  /** Deprecated event-level lineage retained for wire compatibility; target lineage is returned on targets. */
  supersedesEventName?: Maybe<Scalars['String']>;
  /** Concrete immutable target snapshot. */
  targets?: Maybe<Array<Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideTarget>>>;
  /** Time the event row was most recently updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Incentive program whose monetary budget is adjusted. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideIncentiveProgram {
  BudgetOverrideIncentiveProgramDayAheadPositioningIncentive = 'BUDGET_OVERRIDE_INCENTIVE_PROGRAM_DAY_AHEAD_POSITIONING_INCENTIVE',
  BudgetOverrideIncentiveProgramRealTimePositioningIncentive = 'BUDGET_OVERRIDE_INCENTIVE_PROGRAM_REAL_TIME_POSITIONING_INCENTIVE',
  BudgetOverrideIncentiveProgramUnknown = 'BUDGET_OVERRIDE_INCENTIVE_PROGRAM_UNKNOWN'
}

/** Canonical operation persisted for an override. The operation determines whether its result is absolute or projection-relative. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideOperation {
  /** Floating relative adjustment: add amount_cents to the final projection selected during plan resolution. */
  BudgetOverrideOperationAdd = 'BUDGET_OVERRIDE_OPERATION_ADD',
  /** Floating relative adjustment: multiply the final projection selected during plan resolution by multiplier_basis_points. */
  BudgetOverrideOperationMultiply = 'BUDGET_OVERRIDE_OPERATION_MULTIPLY',
  /** Locked absolute adjustment: use each target's exact set budget even if a later final projection changes. */
  BudgetOverrideOperationSet = 'BUDGET_OVERRIDE_OPERATION_SET',
  BudgetOverrideOperationUnknown = 'BUDGET_OVERRIDE_OPERATION_UNKNOWN'
}

/** Current lifecycle state of override intent. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideState {
  BudgetOverrideStateApproved = 'BUDGET_OVERRIDE_STATE_APPROVED',
  BudgetOverrideStateCanceled = 'BUDGET_OVERRIDE_STATE_CANCELED',
  BudgetOverrideStatePending = 'BUDGET_OVERRIDE_STATE_PENDING',
  BudgetOverrideStateRejected = 'BUDGET_OVERRIDE_STATE_REJECTED',
  /** Reserved for compatibility with clients generated before supersession moved to concrete targets. */
  BudgetOverrideStateSuperseded = 'BUDGET_OVERRIDE_STATE_SUPERSEDED',
  BudgetOverrideStateUnknown = 'BUDGET_OVERRIDE_STATE_UNKNOWN'
}

/** Concrete immutable zone-window target returned for audit. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideTarget = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_BudgetOverrideTarget';
  /** Per-target signed ADD amount or nonnegative SET budget; absent for MULTIPLY. */
  amountCents?: Maybe<Scalars['BigInt']>;
  /** Projected budget shown at authoring time, in currency_code minor units, when projection-backed. */
  basisBudgetCents?: Maybe<Scalars['BigInt']>;
  /** Exact immutable projection used as this target's authoring basis, when projection-backed. */
  basisProjectionName?: Maybe<Scalars['String']>;
  /** ISO 4217 currency for basis_budget_cents and amount_cents. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Time this target first became effective through event approval. */
  effectiveAt?: Maybe<Scalars['DateTime']>;
  /** Effectiveness at the response's resolution cutoff. */
  effectiveness?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideTargetEffectiveness>;
  /** Time this target became ineffective through supersession or cancellation. */
  ineffectiveAt?: Maybe<Scalars['DateTime']>;
  /** Per-target multiplier in basis points for MULTIPLY; absent for ADD and SET. */
  multiplierBasisPoints?: Maybe<Scalars['BigInt']>;
  /** Resource name formatted as incentiveBudgetOverrideTargets/{id}. */
  name?: Maybe<Scalars['String']>;
  /** Zone-local operating date. */
  operatingDate?: Maybe<Google_Type_Date>;
  /** Effective approved target that currently replaces this target, when any. */
  supersededByTargetName?: Maybe<Scalars['String']>;
  /** Exact prior target this target replaces once its event is approved. */
  supersedesTargetName?: Maybe<Scalars['String']>;
  /** Exclusive UTC end of the target window. */
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  /** Inclusive UTC start of the target window. */
  windowStartsAt?: Maybe<Scalars['DateTime']>;
  /** Concrete shopper zone. */
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Current effectiveness of one concrete override target. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideTargetEffectiveness {
  BudgetOverrideTargetEffectivenessCanceled = 'BUDGET_OVERRIDE_TARGET_EFFECTIVENESS_CANCELED',
  BudgetOverrideTargetEffectivenessEffective = 'BUDGET_OVERRIDE_TARGET_EFFECTIVENESS_EFFECTIVE',
  BudgetOverrideTargetEffectivenessPending = 'BUDGET_OVERRIDE_TARGET_EFFECTIVENESS_PENDING',
  BudgetOverrideTargetEffectivenessRejected = 'BUDGET_OVERRIDE_TARGET_EFFECTIVENESS_REJECTED',
  BudgetOverrideTargetEffectivenessSuperseded = 'BUDGET_OVERRIDE_TARGET_EFFECTIVENESS_SUPERSEDED',
  BudgetOverrideTargetEffectivenessUnknown = 'BUDGET_OVERRIDE_TARGET_EFFECTIVENESS_UNKNOWN'
}

/** One authoring scope whose targeting and operation values are copied to every concrete target it produces. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideTargetScope_Input = {
  /** Per-target signed ADD amount or nonnegative SET budget in minor currency units; required only for ADD and SET. */
  amountCents?: InputMaybe<Scalars['BigInt']>;
  /** Exact immutable projection shown during authoring; geographic and window fields must be omitted when this is set. */
  basisProjectionName?: InputMaybe<Scalars['String']>;
  /** ISO 4217 currency for amount_cents; required only for ADD and SET. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Derives a complete zone-local operating-day window for every resolved zone; window timestamps must be omitted when true. */
  fullOperatingDay?: InputMaybe<Scalars['Boolean']>;
  /** Per-target multiplier in basis points; required only for MULTIPLY and applied to every concrete target produced by this scope. */
  multiplierBasisPoints?: InputMaybe<Scalars['BigInt']>;
  /** Zone-local operating date for this window; cross-midnight windows must be split. */
  operatingDate?: InputMaybe<Google_Type_Date_Input>;
  /** Regions selected by the author and expanded to current concrete zones server-side. */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Exclusive UTC end of the target window. */
  windowEndsAt?: InputMaybe<Scalars['DateTime']>;
  /** Inclusive UTC start of the target window. */
  windowStartsAt?: InputMaybe<Scalars['DateTime']>;
  /** Explicit shopper zones selected by the author. */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Creates one monetary budget override event. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_CreateBudgetOverrideRequest_Input = {
  /** Deprecated event-level amount retained for wire compatibility; callers must use target_scopes.amount_cents. */
  amountCents?: InputMaybe<Scalars['BigInt']>;
  /** Approval-management request identifier, when already available. */
  approvalRequestId?: InputMaybe<Scalars['String']>;
  /** Canonical account ID of the creator. */
  createdByCanonicalId?: InputMaybe<Scalars['String']>;
  /** Deprecated event-level currency retained for wire compatibility; callers must use target_scopes.currency_code. */
  currencyCode?: InputMaybe<Scalars['String']>;
  /** Caller-generated key, unique within source_kind. */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  /** Incentive program whose budget is adjusted. */
  incentiveProgram?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideIncentiveProgram>;
  /** Deprecated event-level multiplier retained for wire compatibility; callers must use target_scopes.multiplier_basis_points. */
  multiplierBasisPoints?: InputMaybe<Scalars['BigInt']>;
  /** Optional operational context for reviewers. */
  notes?: InputMaybe<Scalars['String']>;
  /** Canonical persisted operation: SET is absolute and locked, while MULTIPLY and ADD are relative to the final projection. */
  operation?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideOperation>;
  /** Structured business reason suitable for reporting. */
  reason?: InputMaybe<Scalars['String']>;
  /** Stable source namespace such as ipp_manual or apollo. */
  sourceKind?: InputMaybe<Scalars['String']>;
  /** Deprecated event-level replacement input retained for wire compatibility; callers must use supersedes_target_names. */
  supersedesEventName?: InputMaybe<Scalars['String']>;
  /** Exact existing target resources replaced after this event is approved. */
  supersedesTargetNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Authoring inputs expanded and snapshotted as concrete targets; use separate scopes when targets require different operation values. */
  targetScopes?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideTargetScope_Input>>>;
};

/** Result of creating override intent. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_CreateBudgetOverrideResponse = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_CreateBudgetOverrideResponse';
  /** Created event, or the original event for an idempotent retry. */
  budgetOverrideEvent?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideEvent>;
};

/** Lists budget override events. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ListBudgetOverridesRequest_Input = {
  /** Optional incentive-program filter. */
  incentiveProgram?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideIncentiveProgram>;
  /** Optional inclusive operating-date lower bound. */
  operatingDateFrom?: InputMaybe<Google_Type_Date_Input>;
  /** Optional inclusive operating-date upper bound. */
  operatingDateTo?: InputMaybe<Google_Type_Date_Input>;
  /** Optional exclusive UTC end for half-open overlap filtering; must accompany overlap_window_starts_at. */
  overlapWindowEndsAt?: InputMaybe<Scalars['DateTime']>;
  /** Optional inclusive UTC start for half-open overlap filtering; must accompany overlap_window_ends_at. */
  overlapWindowStartsAt?: InputMaybe<Scalars['DateTime']>;
  /** Maximum number of events to return; defaults to 100 and is capped at 500. */
  pageSize?: InputMaybe<Scalars['Int']>;
  /** Opaque token returned by a prior call. */
  pageToken?: InputMaybe<Scalars['String']>;
  /** Optional region filter expanded server-side. */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional cutoff used to resolve target effectiveness consistently across pages; defaults to server time on the first page. */
  resolvedAsOf?: InputMaybe<Scalars['DateTime']>;
  /** Optional lifecycle-state filters. */
  states?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideState>>>;
  /** Optional concrete zone filter. */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Page of budget override events. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ListBudgetOverridesResponse = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_ListBudgetOverridesResponse';
  /** Events with concrete target snapshots. */
  budgetOverrideEvents?: Maybe<Array<Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideEvent>>>;
  /** Opaque token for the next page, or empty when complete. */
  nextPageToken?: Maybe<Scalars['String']>;
  /** Cutoff used to resolve target effectiveness for this page and encoded into next_page_token. */
  resolvedAsOf?: Maybe<Scalars['DateTime']>;
};

/** Selects projected budgets from one complete run, ordered by generated_at descending then numeric projection-run resource ID descending. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ListProjectionBudgetsRequest_Input = {
  /** Incentive program whose complete run should be selected. */
  incentiveProgram?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionIncentiveProgram>;
  /** First zone-local operating date to return, inclusive; the full range may contain at most 31 calendar dates. */
  operatingDateFrom?: InputMaybe<Google_Type_Date_Input>;
  /** Last zone-local operating date to return, inclusive; reversed or wider ranges fail with INVALID_ARGUMENT. */
  operatingDateTo?: InputMaybe<Google_Type_Date_Input>;
};

/** Every matching zone-window projection from the selected complete run in one intentionally unpaginated snapshot. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ListProjectionBudgetsResponse = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_ListProjectionBudgetsResponse';
  /** Matching budgets ordered by operating date, zone, then window start. */
  projectionBudgets?: Maybe<Array<Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionBudget>>>;
  /** Complete run selected for this response. */
  projectionRun?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionRun>;
};

/** One immutable projected budget returned to a consumer. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionBudget = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_ProjectionBudget';
  /** Projected baseline spend in the currency's minor unit. */
  baselineBudgetCents?: Maybe<Scalars['BigInt']>;
  /** ISO 4217 currency code for the monetary fields. */
  currencyCode?: Maybe<Scalars['String']>;
  /** Optional estimated cost per offer in millionths of the currency unit. */
  estimatedCostPerOfferMicros?: Maybe<Scalars['BigInt']>;
  /** Exact immutable projection resource used when authoring a projection-backed SET override. */
  name?: Maybe<Scalars['String']>;
  /** Zone-local date used to group and filter the window. */
  operatingDate?: Maybe<Google_Type_Date>;
  /** Exclusive UTC end of the budget window. */
  windowEndsAt?: Maybe<Scalars['DateTime']>;
  /** Inclusive UTC start of the budget window. */
  windowStartsAt?: Maybe<Scalars['DateTime']>;
  /** Concrete shopper zone receiving the projected budget. */
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Incentive programs that can receive an operational projection budget. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionIncentiveProgram {
  ProjectionIncentiveProgramDayAheadPositioningIncentive = 'PROJECTION_INCENTIVE_PROGRAM_DAY_AHEAD_POSITIONING_INCENTIVE',
  ProjectionIncentiveProgramRealTimePositioningIncentive = 'PROJECTION_INCENTIVE_PROGRAM_REAL_TIME_POSITIONING_INCENTIVE',
  ProjectionIncentiveProgramUnknown = 'PROJECTION_INCENTIVE_PROGRAM_UNKNOWN'
}

/** Projection run metadata, publication counts, and lifecycle state. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionRun = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_ProjectionRun';
  /** Time when this run became eligible for downstream reads. */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** Latest source-data timestamp included in the run. */
  dataFreshnessAt?: Maybe<Scalars['DateTime']>;
  /** Expected final row count, absent until completion begins. */
  expectedProjectionCount?: Maybe<Scalars['BigInt']>;
  /** Time when the producer generated this run. */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** Incentive program receiving the projected budget. */
  incentiveProgram?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionIncentiveProgram>;
  /** Version of the model or calculation that produced this run. */
  modelVersion?: Maybe<Scalars['String']>;
  /** Resource name formatted as `incentiveBudgetProjectionRuns/{id}`. */
  name?: Maybe<Scalars['String']>;
  /** Number of unique projection rows accepted so far. */
  publishedProjectionCount?: Maybe<Scalars['BigInt']>;
  /** Stable producer namespace. */
  sourceKind?: Maybe<Scalars['String']>;
  /** Non-queryable producer provenance and diagnostics. */
  sourceMetadata?: Maybe<Scalars['JSON']>;
  /** Stable producer-generated run key. */
  sourceRunKey?: Maybe<Scalars['String']>;
  /** URI of the complete source artifacts retained for replay and debugging. */
  sourceUri?: Maybe<Scalars['String']>;
  /** Current publication lifecycle state. */
  status?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionRunStatus>;
};

/** Lifecycle state of an immutable projection publication. */
export enum Instacart_Fulfillment_Shopper_Incentives_V1_ProjectionRunStatus {
  ProjectionRunStatusComplete = 'PROJECTION_RUN_STATUS_COMPLETE',
  ProjectionRunStatusFailed = 'PROJECTION_RUN_STATUS_FAILED',
  ProjectionRunStatusPublishing = 'PROJECTION_RUN_STATUS_PUBLISHING',
  ProjectionRunStatusUnknown = 'PROJECTION_RUN_STATUS_UNKNOWN'
}

/** Records one review decision for an override event. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ReviewBudgetOverrideRequest_Input = {
  /** Approval-management request identifier associated with this decision. */
  approvalRequestId?: InputMaybe<Scalars['String']>;
  /** Approve or reject decision. */
  decision?: InputMaybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideDecision>;
  /** Override event resource name. */
  name?: InputMaybe<Scalars['String']>;
  /** Canonical account ID of the reviewer. */
  reviewedByCanonicalId?: InputMaybe<Scalars['String']>;
};

/** Result of applying an approval decision. */
export type Instacart_Fulfillment_Shopper_Incentives_V1_ReviewBudgetOverrideResponse = {
  __typename?: 'instacart_fulfillment_shopper_incentives_v1_ReviewBudgetOverrideResponse';
  /** Event after the lifecycle transition. */
  budgetOverrideEvent?: Maybe<Instacart_Fulfillment_Shopper_Incentives_V1_BudgetOverrideEvent>;
};

/** CategorizeByBatchRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchRequest_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
};

/** CategorizeByBatchResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CategorizeByBatchResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CategorizeByBatchResponse';
  refundedButCheckedOutLineItems?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_LineItem>>>;
};

/** CreateCategorizationAnalysisRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisRequest_Input = {
  analysis?: InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis_Input>;
};

/** CreateCategorizationAnalysisResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateCategorizationAnalysisResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CreateCategorizationAnalysisResponse';
  succeeded?: Maybe<Scalars['Boolean']>;
};

/** CreateStepLogAuditRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditRequest_Input = {
  auditResponses?: InputMaybe<Array<InputMaybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditResponse_Input>>>;
  auditedBy?: InputMaybe<Scalars['String']>;
  stepLogId?: InputMaybe<Scalars['String']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** CreateStepLogAuditResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_CreateStepLogAuditResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_CreateStepLogAuditResponse';
  audit?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAudit>;
  errorMessage?: Maybe<Scalars['String']>;
  succeeded?: Maybe<Scalars['Boolean']>;
};

/** GetAuditLogsRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsRequest_Input = {
  actionType?: InputMaybe<Scalars['String']>;
  batchId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
};

/** GetAuditLogsResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetAuditLogsResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetAuditLogsResponse';
  auditLogs?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_AuditLog>>>;
};

/** GetCategorizationAnalysisRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisRequest_Input = {
  batchId?: InputMaybe<Scalars['BigInt']>;
};

/** GetCategorizationAnalysisResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetCategorizationAnalysisResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetCategorizationAnalysisResponse';
  analysis?: Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_CategorizationAnalysis>;
};

/** GetStepLogAuditsRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsRequest_Input = {
  auditorType?: InputMaybe<Scalars['String']>;
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['Int']>;
  stepType?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

/** GetStepLogAuditsResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_GetStepLogAuditsResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_GetStepLogAuditsResponse';
  audits?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Shared_V1_StepLogAudit>>>;
  version?: Maybe<Scalars['Int']>;
};

/** ReplayDiveAndCatchRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayDiveAndCatchRequest_Input = {
  batchId?: InputMaybe<Scalars['String']>;
};

/** ReplayDiveAndCatchResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayDiveAndCatchResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_ReplayDiveAndCatchResponse';
  desiredDiveAndCatchRequests?: Maybe<Array<Maybe<Instacart_Fulfillment_Domains_Transaction_Integrity_Components_V1_DiveAndCatchRequest>>>;
  totalRoiCents?: Maybe<Scalars['BigInt']>;
};

/** ReplayReconciliationRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationRequest_Input = {
  batchId?: InputMaybe<Scalars['String']>;
};

/** ReplayReconciliationResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_ReplayReconciliationResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_ReplayReconciliationResponse';
  succeeded?: Maybe<Scalars['Boolean']>;
};

/** RunDecisionRequest */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionRequest_Input = {
  decisionType?: InputMaybe<Scalars['String']>;
  inputJson?: InputMaybe<Scalars['String']>;
};

/** RunDecisionResponse */
export type Instacart_Fulfillment_Shopper_Transaction_Integrity_V1_RunDecisionResponse = {
  __typename?: 'instacart_fulfillment_shopper_transaction_integrity_v1_RunDecisionResponse';
  errorMessage?: Maybe<Scalars['String']>;
  outputJson?: Maybe<Scalars['String']>;
  succeeded?: Maybe<Scalars['Boolean']>;
};

/** Indicates which side of the shopper-customer relationship a ban or reason applies to. */
export enum Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType {
  /** The ban or reason applies to the customer side. */
  AppliesToTypeCustomer = 'APPLIES_TO_TYPE_CUSTOMER',
  /** The ban or reason applies to the shopper side. */
  AppliesToTypeShopper = 'APPLIES_TO_TYPE_SHOPPER',
  /** Unspecified; must not be used in requests. */
  AppliesToTypeUnknown = 'APPLIES_TO_TYPE_UNKNOWN'
}

/** Request to create a ban between a user and a shopper. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_CreateUserShopperBanRequest_Input = {
  /** Which side initiated the ban. */
  appliesTo?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
  reason?: InputMaybe<Scalars['String']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
  userShopperBanReasonId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the newly created ban. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_CreateUserShopperBanResponse = {
  __typename?: 'instacart_fulfillment_user_shopper_ban_v1_CreateUserShopperBanResponse';
  userShopperBan?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBan>;
};

/** Request to hard-delete a ban by ID (callbacks are skipped). */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_DeleteUserShopperBanRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Request to list predefined ban reasons. Results are sorted with "Other" last.
 * Optional applies_to filter to retrieve reasons for a specific side only.
 */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBanReasonsRequest_Input = {
  /** Filter by side. Omit or set to UNSPECIFIED to return all. */
  appliesTo?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
};

/** Response containing the list of ban reasons. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBanReasonsResponse = {
  __typename?: 'instacart_fulfillment_user_shopper_ban_v1_ListUserShopperBanReasonsResponse';
  reasons?: Maybe<Array<Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanReason>>>;
};

/** Request to list bans for a given shopper, with optional pagination. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBansRequest_Input = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  shopperId?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing a list of user-shopper bans. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_ListUserShopperBansResponse = {
  __typename?: 'instacart_fulfillment_user_shopper_ban_v1_ListUserShopperBansResponse';
  userShopperBans?: Maybe<Array<Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBan>>>;
};

/** Represents a ban between a specific shopper and customer. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBan = {
  __typename?: 'instacart_fulfillment_user_shopper_ban_v1_UserShopperBan';
  /** Which side initiated the ban. */
  appliesTo?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
  banReasonDescription?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  reason?: Maybe<Scalars['String']>;
  shopperId?: Maybe<Scalars['BigInt']>;
  userId?: Maybe<Scalars['BigInt']>;
  userName?: Maybe<Scalars['String']>;
  userShopperBanReasonId?: Maybe<Scalars['BigInt']>;
};

/** A predefined reason that can be associated with a ban. */
export type Instacart_Fulfillment_User_Shopper_Ban_V1_UserShopperBanReason = {
  __typename?: 'instacart_fulfillment_user_shopper_ban_v1_UserShopperBanReason';
  /** Which side the reason applies to. */
  appliesTo?: Maybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
  id?: Maybe<Scalars['BigInt']>;
  reason?: Maybe<Scalars['String']>;
};

/** An error response message for the service */
export type Instacart_Growth_Crm_Messaging_Service_V1_CrmsError = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CRMSError';
  /** Contains a detailed, human readable error about the message. */
  message?: Maybe<Scalars['String']>;
  /** Stacktrace if applicable */
  stacktrace?: Maybe<Scalars['String']>;
  /** The type of error that was originated within the node. */
  type?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsErrorType>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_CrmsErrorType {
  /**
   * An error was registered while trying to interact with an
   * external provider such as S3 or Braze. Client can retry.
   */
  CrmsErrorTypeExternal = 'CRMS_ERROR_TYPE_EXTERNAL',
  /**
   * The message intent failed the idempotency check
   * The message intent should not be retried by client
   */
  CrmsErrorTypeIdempotency = 'CRMS_ERROR_TYPE_IDEMPOTENCY',
  /**
   * An error was registered within the CRMS system when trying to
   * perform the request. Client can retry.
   */
  CrmsErrorTypeInternal = 'CRMS_ERROR_TYPE_INTERNAL',
  /** Unknown error. See message for more details */
  CrmsErrorTypeUnknown = 'CRMS_ERROR_TYPE_UNKNOWN'
}

/** An experiment to filter on for the CRM request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input = {
  /** The experiment variant to use; defaults to control */
  experiment?: InputMaybe<Scalars['String']>;
  /**
   * The experiment name to use for the CRM Campaign
   * Will map to a Roulette experiment
   */
  providedExperimentName?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_CampaignStatus {
  CampaignStatusCancelled = 'CAMPAIGN_STATUS_CANCELLED',
  CampaignStatusCompleted = 'CAMPAIGN_STATUS_COMPLETED',
  CampaignStatusExportingSegment = 'CAMPAIGN_STATUS_EXPORTING_SEGMENT',
  CampaignStatusFailed = 'CAMPAIGN_STATUS_FAILED',
  CampaignStatusInProgress = 'CAMPAIGN_STATUS_IN_PROGRESS',
  CampaignStatusLoadingSegment = 'CAMPAIGN_STATUS_LOADING_SEGMENT',
  CampaignStatusPartiallyCompleted = 'CAMPAIGN_STATUS_PARTIALLY_COMPLETED',
  CampaignStatusPending = 'CAMPAIGN_STATUS_PENDING',
  CampaignStatusUnknown = 'CAMPAIGN_STATUS_UNKNOWN'
}

/** Attributes necessary for making the cancel marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignRequest_Input = {
  /** Associated GS campaign ID */
  extId?: InputMaybe<Scalars['BigInt']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response for a cancel marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CancelMarketingCampaignResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CancelMarketingCampaignResponse';
  /** whether or not the cancelation was successful */
  cancelationSuccessful?: Maybe<Scalars['Boolean']>;
  /** the error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
};

/** Attributes representing a Canvas Template */
export type Instacart_Growth_Crm_Messaging_Service_V1_CanvasTemplate = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CanvasTemplate';
  brazeCanvasId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
};

/** Specify configuration for future message intentions */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationRequest_Input = {
  /** Braze Canvas Id */
  brazeCanvasId?: InputMaybe<Scalars['String']>;
  /** Custom event name */
  customEventName?: InputMaybe<Scalars['String']>;
  /** The end time for the email to send. A null value indicates indefinitely */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /**
   * DEPRECATED: Experiment to be applied for message intents
   * Experiments are applied via experiment_variants
   */
  experiment?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>;
  /** Experiment variants to be applied for message intents */
  experimentVariants?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ExperimentVariant_Input>>>;
  /** list of holdouts to apply for the intent */
  holdouts?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>>>;
  /**
   * DEPRECATED: Idempotency key used for message intents
   * Current State: Only one Idempotency Key is accepted
   */
  idempotencyKey?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_IdempotencyKey_Input>;
  /** Inline email and push content assembled directly without a pre-existing template. */
  inlineContent?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineContent_Input>;
  /** Intent type */
  intentType?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_IntentType>;
  /**
   * Properties to be utilizes by the CRMS that have
   * Not yet been designated their own field
   */
  intentionMeta?: InputMaybe<Scalars['JSON']>;
  /** Properties to forward to our External Messaging Provider */
  intentionProperties?: InputMaybe<Scalars['JSON']>;
  /** The personalization properties of the intention configuration */
  personalizationProperties?: InputMaybe<Scalars['JSON']>;
  /** The scheduled send configuration for the campaign */
  scheduledSendConfiguration?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration_Input>;
  /** Map to specify which send type i.e. email and/or push_notification OR canvas */
  sendTypeTemplateMap?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap_Input>;
  /** The sentry team that created the intent configuration eg. crm-platform */
  sentryTeam?: InputMaybe<Scalars['String']>;
  /** The upstream system that created the intent eg. CIAO */
  sourceSystem?: InputMaybe<Scalars['String']>;
  /** The start time for the email to send. A null value indicates immediately */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The store configuration id for the campaign */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** The message intent configuration after creation */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CreateIntentionConfigurationResponse';
  /** The unique CRMS intenal intent configuration */
  crmIntentConfigurationId?: Maybe<Scalars['String']>;
  /** the error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
};

/** Attributes necessary for making the marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignRequest_Input = {
  /** The id of the campaign returned from the campaign domain */
  campaignId?: InputMaybe<Scalars['String']>;
  /** The user friendly name of the campaign returned from the campaign domain */
  campaignName?: InputMaybe<Scalars['String']>;
  /**
   * The experiment name to use for the CRM Campaign
   * We provide a default if none is provide for Marketing Campaigns
   */
  experiment?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>;
  /** Whether or not to create a split experiment */
  includeExperiment?: InputMaybe<Scalars['Boolean']>;
  /** The external id of the push notification template returned */
  pushNotificationId?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the segment. Currently for Braze's API */
  segmentId?: InputMaybe<Scalars['String']>;
  /** The start time for the email to send. A null value indicates immediately */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The store configuration id for the campaign */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The external id of the template returned */
  templateId?: InputMaybe<Scalars['String']>;
  /** Variables to append to the Braze template */
  templateVariables?: InputMaybe<Scalars['JSON']>;
  /** The email of the campaign initiator */
  userEmailOverrides?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The warehouse id to run the campaign for */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response for a marketing campaign request */
export type Instacart_Growth_Crm_Messaging_Service_V1_CreateMarketingCampaignResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_CreateMarketingCampaignResponse';
  /** whether or not the creation was successful */
  creationSuccessful?: Maybe<Scalars['Boolean']>;
  /** the error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
};

/** Attributes representing an Editable Template Variable */
export type Instacart_Growth_Crm_Messaging_Service_V1_EditableTemplateVariable = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_EditableTemplateVariable';
  channels?: Maybe<Array<Maybe<Scalars['String']>>>;
  inputType?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
};

/** Attributes representing an Email Template */
export type Instacart_Growth_Crm_Messaging_Service_V1_EmailTemplate = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_EmailTemplate';
  body?: Maybe<Scalars['String']>;
  externalTemplateId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** Structured metadata associated with the email template. */
  metadata?: Maybe<Scalars['JSON']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

/** Attributes representing an Email Unsubscribes list */
export type Instacart_Growth_Crm_Messaging_Service_V1_EmailUnsubscribeList = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_EmailUnsubscribeList';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  listName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  warehouseId?: Maybe<Scalars['String']>;
};

/** Specify experiment variant */
export type Instacart_Growth_Crm_Messaging_Service_V1_ExperimentVariant_Input = {
  /** Link to the intent configuration to be triggered */
  crmIntentConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Experiment to be applied for message intents
   * CRMSExperiment specifies variant name
   */
  experiment?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsExperiment_Input>;
  /**
   * Whether or not variant delay is ML driven
   * If so `seconds_to_wait` is ignored and
   * we'll make a request to ML service?
   * All parent and child seconds to wait could be set on creation?
   * Able to be personalized to user because IntentConfiguration is
   * mapped to user via CreateIntentRequest
   */
  mlDriven?: InputMaybe<Scalars['Boolean']>;
  /**
   * Number of seconds to wait before activation
   * Start time of parent + seconds_to_wait
   */
  secondsToWait?: InputMaybe<Scalars['BigInt']>;
};

/** Request object to fetch the status of a campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusRequest_Input = {
  /** Whether or not to return additional details, e.g. campaign template variables */
  detailed?: InputMaybe<Scalars['Boolean']>;
  /** Associated GS campaign ID */
  extId?: InputMaybe<Scalars['BigInt']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The store configuration id to fetch the campaign status for */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch the status of a campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetCampaignStatusResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetCampaignStatusResponse';
  brazeCanvasId?: Maybe<Scalars['String']>;
  experimentName?: Maybe<Scalars['String']>;
  failedUserCount?: Maybe<Scalars['BigInt']>;
  pendingUserCount?: Maybe<Scalars['BigInt']>;
  sendTypeTemplateMap?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap>;
  sentUserCount?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CampaignStatus>;
  templateVariables?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables>;
  totalUserCount?: Maybe<Scalars['BigInt']>;
};

/** Request to get email unsubscribe lists */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsRequest_Input = {
  /** Search term to filter the list names */
  searchTerm?: InputMaybe<Scalars['String']>;
  /**
   * Optional filter: return only lists whose status is one of the provided values.
   * Empty or absent = no status filter (returns all statuses).
   */
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UnsubscribeListStatus>>>;
  /** The store configuration ids to check context */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The warehouse ids context for the request */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Response to get email unsubscribe lists */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetEmailUnsubscribeListsResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetEmailUnsubscribeListsResponse';
  /** the error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The unsubscribe lists that have been uploaded */
  lists?: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_EmailUnsubscribeList>>>;
};

/** Request to get an IntentionConfiguration by id */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationRequest_Input = {
  /** Associated GS campaign ID */
  extId?: InputMaybe<Scalars['BigInt']>;
  /** Internal ID */
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Used to validate authorization for the request from IPP tooling
   * The store configuration id for the configuration
   */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse id for the configuration */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to get an IntentionConfiguration by id */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetIntentionConfigurationResponse';
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The internal id of the intention configuration */
  intentionConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_IntentionConfiguration>;
};

/** Request to get a single retailer configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationRequest_Input = {
  /** The retailer's store configuration ID */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The retailer ID */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response for getting a single retailer configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetRetailerConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetRetailerConfigurationResponse';
  /** The error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The retailer configuration object returned */
  retailerConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfiguration>;
};

/** Request object to fetch the size of a segment */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeRequest_Input = {
  /** The segment id to get the size for */
  segmentId?: InputMaybe<Scalars['String']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch the size of a segment */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetSegmentSizeResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetSegmentSizeResponse';
  /** The size of the segment */
  size?: Maybe<Scalars['BigInt']>;
};

/** Request object to fetch a template */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateRequest_Input = {
  /**
   * Optional connected content mock overrides for preview rendering.
   * Keys map to connected content endpoint names (e.g. "presentable_treatment_offers").
   */
  connectedContentMockResponseData?: InputMaybe<Scalars['JSON']>;
  /** Which types of templates to include */
  includedSendTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  /** The store configuration id for the configuration */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The template id to get */
  templateId?: InputMaybe<Scalars['String']>;
  /** Template Variables to inject in preview */
  templateVariables?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch a template */
export type Instacart_Growth_Crm_Messaging_Service_V1_GetTemplateResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_GetTemplateResponse';
  template?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_Template>;
};

/**
 * Parameters used in conjunction with the user_id to dictate
 * idempotency for the message intent
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_IdempotencyKey_Input = {
  /** eg. [offer_id, discount_id] */
  idempotencyParameterKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * InlineContent contains email and push content assembled directly by the caller
 * without requiring pre-existing external templates.
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlineContent = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_InlineContent';
  emailContent?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineEmailContent>;
  pushContent?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_InlinePushContent>;
};

/**
 * InlineContent contains email and push content assembled directly by the caller
 * without requiring pre-existing external templates.
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlineContent_Input = {
  emailContent?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineEmailContent_Input>;
  pushContent?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_InlinePushContent_Input>;
};

/**
 * InlineEmailContent contains email content assembled directly by the caller
 * without requiring a pre-existing template.
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlineEmailContent = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_InlineEmailContent';
  /** Email body content (HTML with inline CSS and template expressions). */
  body?: Maybe<Scalars['String']>;
  /**
   * Structured configuration for the email builder UI (blocks and settings).
   * Deprecated: use metadata instead.
   */
  emailConfig?: Maybe<Scalars['JSON']>;
  /** Structured configuration for the email builder UI (blocks and settings). */
  metadata?: Maybe<Scalars['JSON']>;
  preheader?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

/**
 * InlineEmailContent contains email content assembled directly by the caller
 * without requiring a pre-existing template.
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlineEmailContent_Input = {
  /** Email body content (HTML with inline CSS and template expressions). */
  body?: InputMaybe<Scalars['String']>;
  /**
   * Structured configuration for the email builder UI (blocks and settings).
   * Deprecated: use metadata instead.
   */
  emailConfig?: InputMaybe<Scalars['JSON']>;
  /** Structured configuration for the email builder UI (blocks and settings). */
  metadata?: InputMaybe<Scalars['JSON']>;
  preheader?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
};

/**
 * Inline (unsaved) intention configuration for test sends.
 * Bundles raw content with per-send template variables; no pre-existing
 * template or IntentionConfiguration record is required.
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlineIntentionConfiguration_Input = {
  /** Raw email and/or push content to send directly, bypassing template lookup. */
  inlineContent?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineContent_Input>;
  /** Per-send template variables forwarded to the messaging provider. */
  intentionProperties?: InputMaybe<Scalars['JSON']>;
};

/** InlinePushContent contains push notification content assembled directly by the caller. */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlinePushContent = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_InlinePushContent';
  body?: Maybe<Scalars['String']>;
  /** Resolved URI for the push notification click destination. */
  customUri?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  /** Structured metadata for the push builder UI re-hydration on edit. */
  metadata?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

/** InlinePushContent contains push notification content assembled directly by the caller. */
export type Instacart_Growth_Crm_Messaging_Service_V1_InlinePushContent_Input = {
  body?: InputMaybe<Scalars['String']>;
  /** Resolved URI for the push notification click destination. */
  customUri?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  /** Structured metadata for the push builder UI re-hydration on edit. */
  metadata?: InputMaybe<Scalars['JSON']>;
  title?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_IntentType {
  IntentTypeCanvas = 'INTENT_TYPE_CANVAS',
  IntentTypeCustomEvent = 'INTENT_TYPE_CUSTOM_EVENT',
  IntentTypeInlineContent = 'INTENT_TYPE_INLINE_CONTENT',
  IntentTypeTemplate = 'INTENT_TYPE_TEMPLATE',
  IntentTypeUnknown = 'INTENT_TYPE_UNKNOWN'
}

/** Object representing an intention configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_IntentionConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_IntentionConfiguration';
  campaignId?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  canvasId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  /** Deprecated. Inline content is no longer provided here; use referenced templates in send_type_template_map instead. */
  inlineContent?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineContent>;
  meta?: Maybe<Scalars['JSON']>;
  personalizationProperties?: Maybe<Scalars['JSON']>;
  retailerConfigurationId?: Maybe<Scalars['BigInt']>;
  scheduledSendConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration>;
  sendTypeTemplateMap?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap>;
  sendTypes?: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  templateVariables?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables>;
};

/** The lifecycle-specific settings for the retailer */
export type Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_LifecycleSettings';
  /** Whether the retailer has opted-into the Lifecycle CRM program via IPP */
  optInStatus?: Maybe<Scalars['Boolean']>;
  /** The terms and conditions for each of the various incentive types offered */
  termsAndConditions?: Maybe<Scalars['JSON']>;
};

/** The lifecycle-specific settings for the retailer */
export type Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings_Input = {
  /** Whether the retailer has opted-into the Lifecycle CRM program via IPP */
  optInStatus?: InputMaybe<Scalars['Boolean']>;
  /** The terms and conditions for each of the various incentive types offered */
  termsAndConditions?: InputMaybe<Scalars['JSON']>;
};

/** Request to list supported editable template variables */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesRequest_Input = {
  /** The store configuration id to check context */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to list supported editable template variables */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListEditableTemplateVariablesResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ListEditableTemplateVariablesResponse';
  /** The list of supported editable template variables */
  variables?: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_EditableTemplateVariable>>>;
};

/** Request object to fetch list of segments */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsRequest_Input = {
  /** The warehouse id to list segments for */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch list of segments */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListSegmentsResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ListSegmentsResponse';
  /** The list of segments for the warehouse */
  segments?: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_Segment>>>;
};

/** Request object to fetch list of templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesRequest_Input = {
  /**
   * Optional connected content mock overrides for preview rendering.
   * Keys map to connected content endpoint names (e.g. "presentable_treatment_offers").
   */
  connectedContentMockResponseData?: InputMaybe<Scalars['JSON']>;
  /** Whether or not to force write templates to cache */
  forceWriteToCache?: InputMaybe<Scalars['Boolean']>;
  /** Which types of templates to include */
  includedSendTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  /** The store configuration id for the request */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** Template Variables to inject in previews */
  templateVariables?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input>;
  /** The warehouse id context for the request */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response object to fetch list of templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_ListTemplatesResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ListTemplatesResponse';
  templates?: Maybe<Array<Maybe<Instacart_Growth_Crm_Messaging_Service_V1_Template>>>;
};

/** The scheduled send configuration for a personalized campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_PersonalizedCampaignConfiguration';
  /** Minimum items required for the campaign to send */
  minimumItemsRequired?: Maybe<Scalars['BigInt']>;
  /** The ranking context */
  rankingContext?: Maybe<Instacart_Customers_Discovery_V1_RankingContext>;
  /** The retrieval context */
  retrievalContext?: Maybe<Instacart_Customers_Discovery_V1_RetrievalContext>;
  /** Whether or not to use the optimized warehouse location */
  useOptimizedWarehouseLocation?: Maybe<Scalars['Boolean']>;
};

/** The scheduled send configuration for a personalized campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration_Input = {
  /** Minimum items required for the campaign to send */
  minimumItemsRequired?: InputMaybe<Scalars['BigInt']>;
  /** The ranking context */
  rankingContext?: InputMaybe<Instacart_Customers_Discovery_V1_RankingContext_Input>;
  /** The retrieval context */
  retrievalContext?: InputMaybe<Instacart_Customers_Discovery_V1_RetrievalContext_Input>;
  /** Whether or not to use the optimized warehouse location */
  useOptimizedWarehouseLocation?: InputMaybe<Scalars['Boolean']>;
};

/** Attributes representing a Push Notification Template */
export type Instacart_Growth_Crm_Messaging_Service_V1_PushNotifcationTemplate = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_PushNotifcationTemplate';
  body?: Maybe<Scalars['String']>;
  /** URI for the push notification click destination. */
  customUri?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** Image URL associated with the push notification template. */
  imageUrl?: Maybe<Scalars['String']>;
  /** Structured metadata associated with the push notification template. */
  metadata?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
};

/** A retailer configuration object */
export type Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_RetailerConfiguration';
  /** Whether the retailer_configuration has all credentials needed to send email */
  emailCapable?: Maybe<Scalars['Boolean']>;
  /** The id of the retailer_configuration */
  id?: Maybe<Scalars['String']>;
  /** The name of the retailer_configuration */
  name?: Maybe<Scalars['String']>;
  /** Whether the retailer_configuration has all credentials needed to send push */
  pushCapable?: Maybe<Scalars['Boolean']>;
  /** The settings on the retailer_configuration */
  settings?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings>;
  /** The id of the associated store_configuration */
  storeConfigurationId?: Maybe<Scalars['String']>;
  /** The id of the associated warehouse */
  warehouseId?: Maybe<Scalars['String']>;
};

/** The settings on the retailer_configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_RetailerConfigurationSettings';
  /** The lifecycle-specific settings for the retailer */
  lifecycle?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings>;
  /** Retailer-level template variables to be appended */
  templateVariables?: Maybe<Scalars['JSON']>;
};

/** The settings on the retailer_configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings_Input = {
  /** The lifecycle-specific settings for the retailer */
  lifecycle?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_LifecycleSettings_Input>;
  /** Retailer-level template variables to be appended */
  templateVariables?: InputMaybe<Scalars['JSON']>;
};

/** The scheduled send configuration for the campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_ScheduledSendConfiguration';
  /** The configuration for a personalized campaign */
  personalizedCampaignConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration>;
  /** The configuration for a PNE campaign */
  personalizedNotificationEngineConfiguration?: Maybe<Scalars['JSON']>;
};

/** The scheduled send configuration for the campaign */
export type Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration_Input = {
  /** The configuration for a personalized campaign */
  personalizedCampaignConfiguration?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_PersonalizedCampaignConfiguration_Input>;
  /** The configuration for a PNE campaign */
  personalizedNotificationEngineConfiguration?: InputMaybe<Scalars['JSON']>;
};

/** Attributes representing a user Segment */
export type Instacart_Growth_Crm_Messaging_Service_V1_Segment = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_Segment';
  accessibleWarehouseIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  externalSegmentId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  segmentName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_SendType {
  SendTypeCanvas = 'SEND_TYPE_CANVAS',
  SendTypeEmail = 'SEND_TYPE_EMAIL',
  SendTypePush = 'SEND_TYPE_PUSH',
  SendTypeUnknown = 'SEND_TYPE_UNKNOWN'
}

/** Object mapping send type to template id */
export type Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_SendTypeTemplateMap';
  canvas?: Maybe<Scalars['BigInt']>;
  email?: Maybe<Scalars['BigInt']>;
  /**
   * DEPRECATED: push stores id from the push_notification_template table
   * Use push_notification instead to store id from templates table for consistency with email/canvas
   */
  push?: Maybe<Scalars['BigInt']>;
  pushNotification?: Maybe<Scalars['BigInt']>;
};

/** Object mapping send type to template id */
export type Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap_Input = {
  canvas?: InputMaybe<Scalars['BigInt']>;
  email?: InputMaybe<Scalars['BigInt']>;
  /**
   * DEPRECATED: push stores id from the push_notification_template table
   * Use push_notification instead to store id from templates table for consistency with email/canvas
   */
  push?: InputMaybe<Scalars['BigInt']>;
  pushNotification?: InputMaybe<Scalars['BigInt']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_SubscriptionStatus {
  SubscriptionStatusUnknown = 'SUBSCRIPTION_STATUS_UNKNOWN',
  SubscriptionStatusUnsubscribed = 'SUBSCRIPTION_STATUS_UNSUBSCRIBED'
}

/** Attributes representing our internal template object */
export type Instacart_Growth_Crm_Messaging_Service_V1_Template = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_Template';
  canvasTemplate?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CanvasTemplate>;
  emailTemplate?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_EmailTemplate>;
  id?: Maybe<Scalars['BigInt']>;
  pushNotificationTemplate?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_PushNotifcationTemplate>;
  templateName?: Maybe<Scalars['String']>;
};

/** Set of variables we allow injecting into templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_TemplateVariables';
  couponCode?: Maybe<Scalars['String']>;
  daysValid?: Maybe<Scalars['String']>;
  editableTemplateVariables?: Maybe<Scalars['JSON']>;
  expiresAtUnix?: Maybe<Scalars['String']>;
  offerDetails?: Maybe<Scalars['JSON']>;
  offerDetailsDollarOff?: Maybe<Scalars['String']>;
  offerDetailsIncentiveType?: Maybe<Scalars['String']>;
  offerDetailsMinimumOrder?: Maybe<Scalars['String']>;
  retailerLogoUrl?: Maybe<Scalars['String']>;
  retailerName?: Maybe<Scalars['String']>;
  retailerSlug?: Maybe<Scalars['String']>;
  storeType?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStoreType>;
  storefrontType?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStorefrontType>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStoreType {
  TemplateVariablesStoreTypeOneHour = 'TEMPLATE_VARIABLES_STORE_TYPE_ONE_HOUR',
  TemplateVariablesStoreTypeThirtyMin = 'TEMPLATE_VARIABLES_STORE_TYPE_THIRTY_MIN',
  TemplateVariablesStoreTypeUnknown = 'TEMPLATE_VARIABLES_STORE_TYPE_UNKNOWN'
}

export enum Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStorefrontType {
  TemplateVariablesStorefrontTypeInstacart = 'TEMPLATE_VARIABLES_STOREFRONT_TYPE_INSTACART',
  TemplateVariablesStorefrontTypePbi = 'TEMPLATE_VARIABLES_STOREFRONT_TYPE_PBI',
  TemplateVariablesStorefrontTypeUnknown = 'TEMPLATE_VARIABLES_STOREFRONT_TYPE_UNKNOWN'
}

/** Set of variables we allow injecting into templates */
export type Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input = {
  couponCode?: InputMaybe<Scalars['String']>;
  daysValid?: InputMaybe<Scalars['String']>;
  editableTemplateVariables?: InputMaybe<Scalars['JSON']>;
  expiresAtUnix?: InputMaybe<Scalars['String']>;
  offerDetails?: InputMaybe<Scalars['JSON']>;
  offerDetailsDollarOff?: InputMaybe<Scalars['String']>;
  offerDetailsIncentiveType?: InputMaybe<Scalars['String']>;
  offerDetailsMinimumOrder?: InputMaybe<Scalars['String']>;
  retailerLogoUrl?: InputMaybe<Scalars['String']>;
  retailerName?: InputMaybe<Scalars['String']>;
  retailerSlug?: InputMaybe<Scalars['String']>;
  storeType?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStoreType>;
  storefrontType?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariablesStorefrontType>;
};

/**
 * Request to send a test message using a real or inline intention configuration.
 * Exactly one of ext_user_ids / email_addresses should be set to identify recipients.
 */
export type Instacart_Growth_Crm_Messaging_Service_V1_TestSendIntentionConfigurationRequest_Input = {
  connectedContentMockResponseData?: InputMaybe<Scalars['JSON']>;
  /** Target recipients by email address (mutually exclusive with ext_user_ids). */
  emailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Target recipients by Instacart external user ID. */
  extUserIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  inlineIntentionConfiguration?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineIntentionConfiguration_Input>;
  intentionConfigurationId?: InputMaybe<Scalars['BigInt']>;
  intentionProperties?: InputMaybe<Scalars['JSON']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for a test send */
export type Instacart_Growth_Crm_Messaging_Service_V1_TestSendIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_TestSendIntentionConfigurationResponse';
  dispatchId?: Maybe<Scalars['String']>;
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  sendSuccessful?: Maybe<Scalars['Boolean']>;
};

export enum Instacart_Growth_Crm_Messaging_Service_V1_UnsubscribeListStatus {
  UnsubscribeListStatusComplete = 'UNSUBSCRIBE_LIST_STATUS_COMPLETE',
  UnsubscribeListStatusError = 'UNSUBSCRIBE_LIST_STATUS_ERROR',
  UnsubscribeListStatusProcessing = 'UNSUBSCRIBE_LIST_STATUS_PROCESSING',
  UnsubscribeListStatusUnknown = 'UNSUBSCRIBE_LIST_STATUS_UNKNOWN'
}

/** Request to update intention configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationRequest_Input = {
  /** The enabled send types for the intention configuration */
  enabledSendTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendType>>>;
  /** The intention configuration to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The intention properties to update */
  intentionProperties?: InputMaybe<Scalars['JSON']>;
  /** The store_configuration_id of the intention configuration */
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /** The warehouse_id of the intention configuration */
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response to update intention configuration */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateIntentionConfigurationResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpdateIntentionConfigurationResponse';
  /** The error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** Whether or not the update was successful */
  updateSuccessful?: Maybe<Scalars['Boolean']>;
};

/** Request for updating retailer configuration settings */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsRequest_Input = {
  /** The settings to update */
  settings?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfigurationSettings_Input>;
  /** store_configuration_id of the retailer_config to update */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** warehouse_id of the retailer_config to update */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response for updating retailer configuration settings */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpdateRetailerConfigurationSettingsResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpdateRetailerConfigurationSettingsResponse';
  /** The error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** The updated retailer configuration object */
  retailerConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_RetailerConfiguration>;
};

/** Request to upsert email unsubscribers */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersRequest_Input = {
  /** The email addresses to upsert */
  emailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  listName?: InputMaybe<Scalars['String']>;
  /** DEPRECATED: The retailer slug to upsert */
  retailerSlug?: InputMaybe<Scalars['String']>;
  /** The store configuration id to upsert */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The warehouse id to upsert */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to upsert email unsubscribers */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpsertEmailUnsubscribersResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpsertEmailUnsubscribersResponse';
  /** The error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** Whether or not the upsert was successful */
  upsertSuccessful?: Maybe<Scalars['Boolean']>;
};

/** Request to upsert user subscription status (email + push) from a 3-column CSV */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpsertUserSubscriptionStatusRequest_Input = {
  /** The name of the list */
  listName?: InputMaybe<Scalars['String']>;
  /** The rows of user subscription status updates */
  rows?: InputMaybe<Array<InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_UserSubscriptionRow_Input>>>;
  /** The store configuration id to upsert */
  storeConfigurationId?: InputMaybe<Scalars['String']>;
  /** The warehouse id to upsert */
  warehouseId?: InputMaybe<Scalars['String']>;
};

/** Response to upsert user subscription status */
export type Instacart_Growth_Crm_Messaging_Service_V1_UpsertUserSubscriptionStatusResponse = {
  __typename?: 'instacart_growth_crm_messaging_service_v1_UpsertUserSubscriptionStatusResponse';
  /** The error message if one occurs */
  error?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_CrmsError>;
  /** Whether or not the upsert was successful */
  upsertSuccessful?: Maybe<Scalars['Boolean']>;
};

/** A single row of user subscription status */
export type Instacart_Growth_Crm_Messaging_Service_V1_UserSubscriptionRow_Input = {
  /** The user's email address */
  email?: InputMaybe<Scalars['String']>;
  /** The email subscription status; UNKNOWN is a no-op */
  emailStatus?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SubscriptionStatus>;
  /** The push subscription status; UNKNOWN is a no-op */
  pushStatus?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SubscriptionStatus>;
};

/**
 * AuthorizationClaims carries authorization claims about the requesting user.
 * Each field is a single claim that downstream services enforce.
 */
export type Instacart_Growth_Marketing_Tooling_V1_AuthorizationClaims_Input = {
  /**
   * Authorized to override high-risk business-rule validation
   * (maps to VGP OVERRIDE_BUSINESS_RULE_VALIDATION).
   */
  highRiskCampaignOverride?: InputMaybe<Scalars['Boolean']>;
  /** Authorized to create Segment API audiences. */
  segmentApiCreate?: InputMaybe<Scalars['Boolean']>;
  /** Authorized to clear Segment API audience membership. */
  segmentApiMembershipClear?: InputMaybe<Scalars['Boolean']>;
  /** Authorized to inspect Segment API readiness, timelines, and match explanations. */
  segmentApiMembershipRead?: InputMaybe<Scalars['Boolean']>;
  /** Authorized to add or remove Segment API audience membership. */
  segmentApiMembershipUpdate?: InputMaybe<Scalars['Boolean']>;
};

/**
 * AuthorizationContext provides the user identity and the retailer/store context
 * for a campaign operation within the Instacart Partner Platform (IPP). Every request
 * must include this context. It is validated against the user's authorized resources
 * and enforced in GraphQL Mesh.
 */
export type Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input = {
  /**
   * Authorization claims about the requesting user. Populated upstream and
   * authoritative; clients cannot set these.
   */
  claims?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationClaims_Input>;
  /**
   * When true, the caller is explicitly authorized for all retailers and
   * retailer_ids must be empty. This is the opt-in escape hatch for retailer-agnostic
   * operations. When false (default), retailer_ids must be non-empty.
   */
  retailerAgnostic?: InputMaybe<Scalars['Boolean']>;
  /** Retailer IDs that define the scope of the request. These should be authorized for the user upstream */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Identifies the external system that supplied the authorization context.
   * CALLER_SOURCE_UNKNOWN is invalid where actor resolution is required.
   */
  source?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CallerSource>;
  /** Store Configuration IDs that define the scope of the request. These should be authorized for the user upstream */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Canonical UUID uniquely identifying the user across the Instacart Partner Platform. */
  userCanonicalUuid?: InputMaybe<Scalars['String']>;
  /** Numeric user ID for the authenticated user. */
  userId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Whether the requesting actor is internal to Instacart or an external
   * retailer/partner. USER_SCOPE_UNKNOWN (the default) means the scope was
   * not resolved.
   */
  userScope?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_UserScope>;
  /** Business-logic validation rules to skip when creating the downstream Value Grant Policy. */
  vgpValidationRulesToSkip?: InputMaybe<Array<InputMaybe<Instacart_Customers_Commerce_Discount_V1_BusinessLogicValidationRule>>>;
};

/** BasketRewardInput defines a discount applied to the customer's order basket. */
export type Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_BasketRewardInput';
  /** Discount amount as a string (e.g., "5.00" for $5 off, "10" for 10% off). */
  amount?: Maybe<Scalars['String']>;
  /**
   * Number of days before the credit-back grant expires in the customer's wallet.
   * Only meaningful when discount_type is DISCOUNT_TYPE_CREDIT_BACK; must be empty
   * otherwise. When credit-back and empty, the backend defaults to 90 days for
   * backward compatibility; this default will be removed once the frontend always
   * supplies the value, at which point the field becomes required.
   */
  creditBackExpiryDays?: Maybe<Scalars['String']>;
  /** Type of discount (dollar off, percentage off, or credit back). */
  discountType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_DiscountType>;
  /** Maximum discount amount for percentage-based discounts (caps the discount). */
  maxDiscountAmount?: Maybe<Scalars['String']>;
  /** Whether the reward applies to the same departments as the condition or different ones. */
  rewardApplication?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RewardApplication>;
  /** Department IDs the reward applies to when reward_application is set. */
  rewardDepartmentIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** BasketRewardInput defines a discount applied to the customer's order basket. */
export type Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput_Input = {
  /** Discount amount as a string (e.g., "5.00" for $5 off, "10" for 10% off). */
  amount?: InputMaybe<Scalars['String']>;
  /**
   * Number of days before the credit-back grant expires in the customer's wallet.
   * Only meaningful when discount_type is DISCOUNT_TYPE_CREDIT_BACK; must be empty
   * otherwise. When credit-back and empty, the backend defaults to 90 days for
   * backward compatibility; this default will be removed once the frontend always
   * supplies the value, at which point the field becomes required.
   */
  creditBackExpiryDays?: InputMaybe<Scalars['String']>;
  /** Type of discount (dollar off, percentage off, or credit back). */
  discountType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_DiscountType>;
  /** Maximum discount amount for percentage-based discounts (caps the discount). */
  maxDiscountAmount?: InputMaybe<Scalars['String']>;
  /** Whether the reward applies to the same departments as the condition or different ones. */
  rewardApplication?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RewardApplication>;
  /** Department IDs the reward applies to when reward_application is set. */
  rewardDepartmentIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * BudgetCapping controls whether the system automatically caps spending
 * when the budget is exhausted.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_BudgetCapping {
  BudgetCappingAutomatic = 'BUDGET_CAPPING_AUTOMATIC',
  BudgetCappingNone = 'BUDGET_CAPPING_NONE',
  BudgetCappingUnknown = 'BUDGET_CAPPING_UNKNOWN'
}

/**
 * BudgetRestrictionsInput defines budget caps and funding split configuration
 * for the offer.
 */
export type Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_BudgetRestrictionsInput';
  /** Whether budget capping is automatic or disabled. */
  budgetCapping?: Maybe<Instacart_Growth_Marketing_Tooling_V1_BudgetCapping>;
  /**
   * How the offer cost is split between Instacart and the retailer (or partner,
   * for Embedded Instacart campaigns).
   */
  fundingType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_FundingType>;
  /** Instacart's share of the funding as a percentage string (e.g., "50"). */
  instacartFundingPercent?: Maybe<Scalars['String']>;
  /** Total lifetime budget for this offer as a string (e.g., "10000.00"). */
  lifetimeBudget?: Maybe<Scalars['String']>;
  /**
   * Partner's share of the funding as a percentage string (e.g., "50"). Used
   * for Embedded Instacart campaigns, where the counterparty is a partner
   * rather than a retailer. Mutually exclusive with retailer_funding_percent.
   */
  partnerFundingPercent?: Maybe<Scalars['String']>;
  /**
   * Retailer's share of the funding as a percentage string (e.g., "50").
   * Mutually exclusive with partner_funding_percent — set one or the other
   * depending on funding_type.
   */
  retailerFundingPercent?: Maybe<Scalars['String']>;
};

/**
 * BudgetRestrictionsInput defines budget caps and funding split configuration
 * for the offer.
 */
export type Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput_Input = {
  /** Whether budget capping is automatic or disabled. */
  budgetCapping?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_BudgetCapping>;
  /**
   * How the offer cost is split between Instacart and the retailer (or partner,
   * for Embedded Instacart campaigns).
   */
  fundingType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FundingType>;
  /** Instacart's share of the funding as a percentage string (e.g., "50"). */
  instacartFundingPercent?: InputMaybe<Scalars['String']>;
  /** Total lifetime budget for this offer as a string (e.g., "10000.00"). */
  lifetimeBudget?: InputMaybe<Scalars['String']>;
  /**
   * Partner's share of the funding as a percentage string (e.g., "50"). Used
   * for Embedded Instacart campaigns, where the counterparty is a partner
   * rather than a retailer. Mutually exclusive with retailer_funding_percent.
   */
  partnerFundingPercent?: InputMaybe<Scalars['String']>;
  /**
   * Retailer's share of the funding as a percentage string (e.g., "50").
   * Mutually exclusive with partner_funding_percent — set one or the other
   * depending on funding_type.
   */
  retailerFundingPercent?: InputMaybe<Scalars['String']>;
};

/**
 * CRMConfiguration defines how the campaign integrates with the CRM messaging system
 * to send communications (emails, push notifications, SMS, etc.) to targeted users.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CRMConfiguration';
  /**
   * ID of a canvas workflow for orchestrating multi-step customer journeys.
   * Canvases allow complex messaging flows with conditional logic and timing.
   */
  canvasId?: Maybe<Scalars['String']>;
  /** Inline content with email and push configuration assembled directly by the caller. */
  inlineContent?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineContent>;
  /** Freeform personalization metadata forwarded to the CRM messaging system. */
  personalizationProperties?: Maybe<Scalars['JSON']>;
  /** Retrieval and ranking configuration for personalized scheduled campaigns. */
  scheduledSendConfiguration?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration>;
  /** Mapping of communication channels (email, push, SMS) to their respective message templates. */
  sendTypeTemplateMap?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap>;
  /**
   * Dynamic variables to populate in message templates (e.g., user name, discount amount).
   * These are merged with templates at send time to personalize messages.
   * Imported from CRM Proto.
   */
  templateVariables?: Maybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables>;
};

/**
 * CRMConfiguration defines how the campaign integrates with the CRM messaging system
 * to send communications (emails, push notifications, SMS, etc.) to targeted users.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input = {
  /**
   * ID of a canvas workflow for orchestrating multi-step customer journeys.
   * Canvases allow complex messaging flows with conditional logic and timing.
   */
  canvasId?: InputMaybe<Scalars['String']>;
  /** Inline content with email and push configuration assembled directly by the caller. */
  inlineContent?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_InlineContent_Input>;
  /** Freeform personalization metadata forwarded to the CRM messaging system. */
  personalizationProperties?: InputMaybe<Scalars['JSON']>;
  /** Retrieval and ranking configuration for personalized scheduled campaigns. */
  scheduledSendConfiguration?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_ScheduledSendConfiguration_Input>;
  /** Mapping of communication channels (email, push, SMS) to their respective message templates. */
  sendTypeTemplateMap?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_SendTypeTemplateMap_Input>;
  /**
   * Dynamic variables to populate in message templates (e.g., user name, discount amount).
   * These are merged with templates at send time to personalize messages.
   * Imported from CRM Proto.
   */
  templateVariables?: InputMaybe<Instacart_Growth_Crm_Messaging_Service_V1_TemplateVariables_Input>;
};

/** CRMDeliveryMode declares whether a variant sends CRM content. */
export enum Instacart_Growth_Marketing_Tooling_V1_CrmDeliveryMode {
  CrmDeliveryModeNoSend = 'CRM_DELIVERY_MODE_NO_SEND',
  CrmDeliveryModeSend = 'CRM_DELIVERY_MODE_SEND',
  CrmDeliveryModeUnknown = 'CRM_DELIVERY_MODE_UNKNOWN'
}

/**
 * CRMSequenceStep is one message in a same-campaign follow-up sequence.
 * The campaign's primary CRMConfiguration (or a SEND variant's crm_configuration)
 * is always Message 1 (`initial`). Additional steps (v1: at most one
 * `follow_up_1`) are created as sibling IntentionConfigurations. Campaigns
 * Domain still joins only the initial / parent IC id.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CRMSequenceStep';
  /** Inline (or template/canvas) content for this step. */
  crmConfiguration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration>;
  /**
   * Whole calendar days after campaign starts_at in the campaign timezone.
   * Must be >= 1.
   */
  delayDays?: Maybe<Scalars['Int']>;
  /** `follow_up_1` in v1. Must not be `initial`. */
  stepId?: Maybe<Scalars['String']>;
};

/**
 * CRMSequenceStep is one message in a same-campaign follow-up sequence.
 * The campaign's primary CRMConfiguration (or a SEND variant's crm_configuration)
 * is always Message 1 (`initial`). Additional steps (v1: at most one
 * `follow_up_1`) are created as sibling IntentionConfigurations. Campaigns
 * Domain still joins only the initial / parent IC id.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep_Input = {
  /** Inline (or template/canvas) content for this step. */
  crmConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input>;
  /**
   * Whole calendar days after campaign starts_at in the campaign timezone.
   * Must be >= 1.
   */
  delayDays?: InputMaybe<Scalars['Int']>;
  /** `follow_up_1` in v1. Must not be `initial`. */
  stepId?: InputMaybe<Scalars['String']>;
};

/** CRMVariantConfiguration maps one experiment variant to its CRM behavior. */
export type Instacart_Growth_Marketing_Tooling_V1_CrmVariantConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CRMVariantConfiguration';
  /**
   * Required for SEND and absent for NO_SEND. This is the initial (Message 1)
   * payload Campaigns Domain joins via the parent router.
   */
  crmConfiguration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration>;
  deliveryMode?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmDeliveryMode>;
  /** Must agree with ExperimentVariant.is_default for this variant. */
  isControl?: Maybe<Scalars['Boolean']>;
  /**
   * Follow-up steps for this SEND arm. Ignored (and must be empty) for NO_SEND.
   * v1 allows at most one step (`follow_up_1`).
   */
  sequenceSteps?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep>>>;
  /** Must exactly match one ExperimentDefinition variant name. */
  variantName?: Maybe<Scalars['String']>;
};

/** CRMVariantConfiguration maps one experiment variant to its CRM behavior. */
export type Instacart_Growth_Marketing_Tooling_V1_CrmVariantConfiguration_Input = {
  /**
   * Required for SEND and absent for NO_SEND. This is the initial (Message 1)
   * payload Campaigns Domain joins via the parent router.
   */
  crmConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input>;
  deliveryMode?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmDeliveryMode>;
  /** Must agree with ExperimentVariant.is_default for this variant. */
  isControl?: InputMaybe<Scalars['Boolean']>;
  /**
   * Follow-up steps for this SEND arm. Ignored (and must be empty) for NO_SEND.
   * v1 allows at most one step (`follow_up_1`).
   */
  sequenceSteps?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep_Input>>>;
  /** Must exactly match one ExperimentDefinition variant name. */
  variantName?: InputMaybe<Scalars['String']>;
};

/**
 * CallerSource identifies which system is making the API call.
 * Every UMB request must include a non-UNKNOWN source so the backend
 * can resolve the caller to an internal actor identity.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_CallerSource {
  CallerSourceConnect = 'CALLER_SOURCE_CONNECT',
  CallerSourceIpp = 'CALLER_SOURCE_IPP',
  CallerSourceSaffronCrms = 'CALLER_SOURCE_SAFFRON_CRMS',
  CallerSourceUnknown = 'CALLER_SOURCE_UNKNOWN'
}

/**
 * CampaignConfiguration contains all operational settings for a marketing campaign,
 * including scheduling, budget management, treatment assignments, and tracking parameters.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration';
  /**
   * Flexible key-value metadata (placement keys, notes) carried alongside the
   * configuration so embedded types (MarketingCampaign, CampaignBrief) share it.
   * This replaces the deprecated MarketingCampaign.meta.
   */
  campaignMetadata?: Maybe<Scalars['JSON']>;
  /** Primary objective or goal of the campaign (e.g., increase orders, drive engagement). */
  campaignObjective?: Maybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  /**
   * UTM parameters and other tracking references for attributing campaign performance.
   * Imported from Campaigns Proto.
   */
  campaignReference?: Maybe<Instacart_Customers_Coupons_V1_CampaignReference>;
  /** Custom key-value properties for extending campaign metadata with arbitrary data. */
  customProperties?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CustomProperty>>>;
  /** Settings controlling how and where the campaign can be discovered or accessed. */
  discoverability?: Maybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /**
   * Declared distribution intent. Authoritative input for discoverability
   * derivation; when set, supersedes payload-shape inference.
   */
  distributionChannels?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_DistributionChannels>;
  /** Engineering-only campaign flags. */
  engMetadata?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_EngMetadata>;
  /**
   * Additional filters on the campaign to further refine behaviour
   * Imported from Campaigns Proto.
   */
  filters?: Maybe<Array<Maybe<Instacart_Customers_Coupons_V1_CampaignFilter>>>;
  /**
   * Deprecated: superseded by eng_metadata.for_internal_testing_only. Kept for
   * backward compatibility with clients that still write this field on create.
   */
  forInternalTestingOnly?: Maybe<Scalars['Boolean']>;
  /**
   * If true, this campaign is hidden from retailer-facing dashboards and reports.
   * Used for internal or test campaigns.
   */
  hideFromRetailer?: Maybe<Scalars['Boolean']>;
  /** When this campaign is scheduled to run. */
  schedule?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule>;
  /** Current status of the campaign (e.g., "draft", "active", "paused", "completed"). */
  status?: Maybe<Scalars['String']>;
  /** Configuration for how treatments are assigned and delivered to users. */
  treatmentConfiguration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration>;
  /** Type of campaign (e.g., "promotional", "retention", "acquisition"). */
  type?: Maybe<Scalars['String']>;
};

/** CampaignSchedule defines when a campaign is active and how it recurs over time. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration_CampaignSchedule';
  /** End timestamp for when the campaign stops being active. */
  endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Optional recurring schedule pattern (e.g., "daily", "weekly", cron expression).
   * If set, the campaign will repeat according to this schedule.
   */
  recurringSchedule?: Maybe<Scalars['String']>;
  /** Start timestamp for when the campaign becomes active. */
  startsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Timezone for interpreting the schedule timestamps (e.g., "America/Los_Angeles").
   * Important for ensuring campaigns activate at the correct local time.
   */
  timezone?: Maybe<Scalars['String']>;
};

/** CampaignSchedule defines when a campaign is active and how it recurs over time. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule_Input = {
  /** End timestamp for when the campaign stops being active. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Optional recurring schedule pattern (e.g., "daily", "weekly", cron expression).
   * If set, the campaign will repeat according to this schedule.
   */
  recurringSchedule?: InputMaybe<Scalars['String']>;
  /** Start timestamp for when the campaign becomes active. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /**
   * Timezone for interpreting the schedule timestamps (e.g., "America/Los_Angeles").
   * Important for ensuring campaigns activate at the correct local time.
   */
  timezone?: InputMaybe<Scalars['String']>;
};

/**
 * DistributionChannels declares the channels through which a campaign is
 * distributed. Internal channels (onsite/email/push/canvas) are boolean flags.
 * onsite/email/push may be combined freely. canvas is mutually exclusive with
 * email and push (delivery is orchestrated by the Braze Canvas identified in
 * CRMConfiguration.canvas_id, not by inline per-channel content). External
 * channels (coupon_code/direct_link/partner_initiated) are mutually exclusive
 * with each other (oneof) AND with any internal channel: a message that sets
 * an external channel together with any internal channel, or sets no channel
 * at all, is invalid.
 *
 * Channel combinations map to campaign discoverability as follows:
 * any combination containing onsite     -> BROWSE
 * email and/or push (without onsite)    -> CRM
 * canvas (without onsite)               -> CRM
 * coupon_code (alone)                   -> COUPON_CODE
 * direct_link (alone)                   -> TS_DIRECT_LINK
 * partner_initiated (alone)             -> PARTNER_INITIATED
 * offline (alone)                       -> OFFLINE
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_DistributionChannels = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration_DistributionChannels';
  /** Delegates CRM delivery to a Braze Canvas. */
  canvas?: Maybe<Scalars['Boolean']>;
  couponCode?: Maybe<Scalars['google_protobuf_Empty']>;
  directLink?: Maybe<Scalars['google_protobuf_Empty']>;
  /** Internal CRM channels. */
  email?: Maybe<Scalars['Boolean']>;
  /** campaign is assigned to users via offline job. Mutually exclusive with others. */
  offline?: Maybe<Scalars['Boolean']>;
  /** Internal on-site treatment serving. */
  onsite?: Maybe<Scalars['Boolean']>;
  /**
   * Campaign is assigned to users by a 3rd party partner (e.g. Grubhub,
   * Airbnb — Embedded Instacart store configurations). Shares the same
   * slot/treatment behaviour as onsite: campaigns are served on-site once
   * the partner triggers assignment. Only meaningful on Embedded Instacart
   * store configurations.
   */
  partnerInitiated?: Maybe<Scalars['google_protobuf_Empty']>;
  push?: Maybe<Scalars['Boolean']>;
};

/**
 * DistributionChannels declares the channels through which a campaign is
 * distributed. Internal channels (onsite/email/push/canvas) are boolean flags.
 * onsite/email/push may be combined freely. canvas is mutually exclusive with
 * email and push (delivery is orchestrated by the Braze Canvas identified in
 * CRMConfiguration.canvas_id, not by inline per-channel content). External
 * channels (coupon_code/direct_link/partner_initiated) are mutually exclusive
 * with each other (oneof) AND with any internal channel: a message that sets
 * an external channel together with any internal channel, or sets no channel
 * at all, is invalid.
 *
 * Channel combinations map to campaign discoverability as follows:
 * any combination containing onsite     -> BROWSE
 * email and/or push (without onsite)    -> CRM
 * canvas (without onsite)               -> CRM
 * coupon_code (alone)                   -> COUPON_CODE
 * direct_link (alone)                   -> TS_DIRECT_LINK
 * partner_initiated (alone)             -> PARTNER_INITIATED
 * offline (alone)                       -> OFFLINE
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_DistributionChannels_Input = {
  /** Delegates CRM delivery to a Braze Canvas. */
  canvas?: InputMaybe<Scalars['Boolean']>;
  couponCode?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  directLink?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  /** Internal CRM channels. */
  email?: InputMaybe<Scalars['Boolean']>;
  /** campaign is assigned to users via offline job. Mutually exclusive with others. */
  offline?: InputMaybe<Scalars['Boolean']>;
  /** Internal on-site treatment serving. */
  onsite?: InputMaybe<Scalars['Boolean']>;
  /**
   * Campaign is assigned to users by a 3rd party partner (e.g. Grubhub,
   * Airbnb — Embedded Instacart store configurations). Shares the same
   * slot/treatment behaviour as onsite: campaigns are served on-site once
   * the partner triggers assignment. Only meaningful on Embedded Instacart
   * store configurations.
   */
  partnerInitiated?: InputMaybe<Scalars['google_protobuf_Empty_Input']>;
  push?: InputMaybe<Scalars['Boolean']>;
};

/** EngMetadata groups engineering-only campaign flags. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_EngMetadata = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration_EngMetadata';
  /** When true, marks the campaign as for internal testing only. */
  forInternalTestingOnly?: Maybe<Scalars['Boolean']>;
  /** When true, the campaign opts out of automated CRM campaign launch. */
  optOutAutomateCampaignLaunch?: Maybe<Scalars['Boolean']>;
};

/** EngMetadata groups engineering-only campaign flags. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_EngMetadata_Input = {
  /** When true, marks the campaign as for internal testing only. */
  forInternalTestingOnly?: InputMaybe<Scalars['Boolean']>;
  /** When true, the campaign opts out of automated CRM campaign launch. */
  optOutAutomateCampaignLaunch?: InputMaybe<Scalars['Boolean']>;
};

/**
 * CampaignConfiguration contains all operational settings for a marketing campaign,
 * including scheduling, budget management, treatment assignments, and tracking parameters.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_Input = {
  /**
   * Flexible key-value metadata (placement keys, notes) carried alongside the
   * configuration so embedded types (MarketingCampaign, CampaignBrief) share it.
   * This replaces the deprecated MarketingCampaign.meta.
   */
  campaignMetadata?: InputMaybe<Scalars['JSON']>;
  /** Primary objective or goal of the campaign (e.g., increase orders, drive engagement). */
  campaignObjective?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>;
  /**
   * UTM parameters and other tracking references for attributing campaign performance.
   * Imported from Campaigns Proto.
   */
  campaignReference?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignReference_Input>;
  /** Custom key-value properties for extending campaign metadata with arbitrary data. */
  customProperties?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CustomProperty_Input>>>;
  /** Settings controlling how and where the campaign can be discovered or accessed. */
  discoverability?: InputMaybe<Instacart_Customers_Coupons_V1_Discoverability>;
  /**
   * Declared distribution intent. Authoritative input for discoverability
   * derivation; when set, supersedes payload-shape inference.
   */
  distributionChannels?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_DistributionChannels_Input>;
  /** Engineering-only campaign flags. */
  engMetadata?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_EngMetadata_Input>;
  /**
   * Additional filters on the campaign to further refine behaviour
   * Imported from Campaigns Proto.
   */
  filters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignFilter_Input>>>;
  /**
   * Deprecated: superseded by eng_metadata.for_internal_testing_only. Kept for
   * backward compatibility with clients that still write this field on create.
   */
  forInternalTestingOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * If true, this campaign is hidden from retailer-facing dashboards and reports.
   * Used for internal or test campaigns.
   */
  hideFromRetailer?: InputMaybe<Scalars['Boolean']>;
  /** When this campaign is scheduled to run. */
  schedule?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_CampaignSchedule_Input>;
  /** Current status of the campaign (e.g., "draft", "active", "paused", "completed"). */
  status?: InputMaybe<Scalars['String']>;
  /** Configuration for how treatments are assigned and delivered to users. */
  treatmentConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration_Input>;
  /** Type of campaign (e.g., "promotional", "retention", "acquisition"). */
  type?: InputMaybe<Scalars['String']>;
};

/** TreatmentConfiguration defines how users are assigned to different campaign treatments */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignConfiguration_TreatmentConfiguration';
  /**
   * If true, each treatment has its own policy for determining eligibility and delivery.
   * If false, treatments share a common policy.
   */
  separateTreatmentPolicies?: Maybe<Scalars['Boolean']>;
  /**
   * Slot IDs represent placements or channels where this campaign's treatments can appear
   * (e.g., email slots, in-app banner slots, etc.).
   */
  slotIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Parameters for the treatment task */
  treatmentTask?: Maybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams>;
  /** The actual treatment definitions including variations, content, and delivery rules. */
  treatments?: Maybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments>;
};

/** TreatmentConfiguration defines how users are assigned to different campaign treatments */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_TreatmentConfiguration_Input = {
  /**
   * If true, each treatment has its own policy for determining eligibility and delivery.
   * If false, treatments share a common policy.
   */
  separateTreatmentPolicies?: InputMaybe<Scalars['Boolean']>;
  /**
   * Slot IDs represent placements or channels where this campaign's treatments can appear
   * (e.g., email slots, in-app banner slots, etc.).
   */
  slotIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Parameters for the treatment task */
  treatmentTask?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignTreatmentTaskRequestParams_Input>;
  /** The actual treatment definitions including variations, content, and delivery rules. */
  treatments?: InputMaybe<Instacart_Customers_Coupons_V1_RetailerCampaignTreatments_Input>;
};

/**
 * CampaignContext defines the scope of a marketing campaign.
 * It specifies which retailers, sites, and countries the campaign applies to.
 * This is the source of truth and propogated to all downstream systems.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignContext = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CampaignContext';
  /** Country ID where this campaign is active. Used for international campaign management. */
  countryId?: Maybe<Scalars['BigInt']>;
  /** internal IPP user ID of the person who created this campaign. Used for audit trails and permissions. */
  creatorIppUserId?: Maybe<Scalars['BigInt']>;
  /** Email of the person who created this campaign. Human-readable companion to creator_user_id. */
  creatorUserEmail?: Maybe<Scalars['String']>;
  /**
   * Generic id of the person who created this campaign, resolved against create_source
   * to determine which system it belongs to (e.g. the Saffron user for saffron-built campaigns).
   */
  creatorUserId?: Maybe<Scalars['BigInt']>;
  /** List of retailer IDs to explicitly exclude from this campaign. */
  excludedRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Canonical UUID of the IPP (Instacart Partner Platform) user context. */
  ippUserCanonicalUuid?: Maybe<Scalars['String']>;
  /** List of retailer IDs that this campaign targets. */
  retailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** List of store configuration IDs that this campaign targets. */
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * CampaignContext defines the scope of a marketing campaign.
 * It specifies which retailers, sites, and countries the campaign applies to.
 * This is the source of truth and propogated to all downstream systems.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignContext_Input = {
  /** Country ID where this campaign is active. Used for international campaign management. */
  countryId?: InputMaybe<Scalars['BigInt']>;
  /** internal IPP user ID of the person who created this campaign. Used for audit trails and permissions. */
  creatorIppUserId?: InputMaybe<Scalars['BigInt']>;
  /** Email of the person who created this campaign. Human-readable companion to creator_user_id. */
  creatorUserEmail?: InputMaybe<Scalars['String']>;
  /**
   * Generic id of the person who created this campaign, resolved against create_source
   * to determine which system it belongs to (e.g. the Saffron user for saffron-built campaigns).
   */
  creatorUserId?: InputMaybe<Scalars['BigInt']>;
  /** List of retailer IDs to explicitly exclude from this campaign. */
  excludedRetailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Canonical UUID of the IPP (Instacart Partner Platform) user context. */
  ippUserCanonicalUuid?: InputMaybe<Scalars['String']>;
  /** List of retailer IDs that this campaign targets. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** List of store configuration IDs that this campaign targets. */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** CampaignFilters defines optional filters for listing campaigns. */
export type Instacart_Growth_Marketing_Tooling_V1_CampaignFilters_Input = {
  /** Filter by campaign objective. */
  campaignObjectives?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignObjective>>>;
  /** Filter campaigns ending on or before this timestamp. */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** Filter by whether campaigns carry an offer or not. */
  incentiveFilters?: InputMaybe<Array<InputMaybe<Instacart_Customers_Coupons_V1_CampaignIncentiveFilter>>>;
  /** Filter by retailer IDs. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Search value for text-based search across campaign fields. */
  searchValue?: InputMaybe<Scalars['String']>;
  /** Filter campaigns starting on or after this timestamp. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** Filter by campaign status (e.g., "active", "draft", "completed"). */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by store configuration IDs. */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** CancelMarketingCampaignRequest cancels one or more marketing campaigns by ID. */
export type Instacart_Growth_Marketing_Tooling_V1_CancelMarketingCampaignRequest_Input = {
  /** Authorization context of the user cancelling the campaign. */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The unique identifier of one campaign to cancel. */
  campaignId?: InputMaybe<Scalars['BigInt']>;
  /**
   * The unique identifiers of multiple campaigns to cancel.
   * Set either campaign_id or campaign_ids, but not both.
   */
  campaignIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Human-readable reason or external reference associated with the cancellation.
   * This is retained for audit and observability and does not change cancellation behavior.
   */
  cancellationReason?: InputMaybe<Scalars['String']>;
  /**
   * Whether associated coupon, checkout-benefit, auto-apply, and treatment
   * policy artifacts should also be disabled. When omitted, this defaults to true.
   */
  disableOffer?: InputMaybe<Scalars['Boolean']>;
};

/** CancelMarketingCampaignResponse returns the result of one or more cancel operations. */
export type Instacart_Growth_Marketing_Tooling_V1_CancelMarketingCampaignResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CancelMarketingCampaignResponse';
  /** Individual result for each requested campaign. */
  results?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CancelMarketingCampaignResult>>>;
  /** Overall status. Success is true only when every requested cancellation succeeds. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/** CancelMarketingCampaignResult contains the result for one campaign cancellation. */
export type Instacart_Growth_Marketing_Tooling_V1_CancelMarketingCampaignResult = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CancelMarketingCampaignResult';
  /** The unique identifier of the campaign. */
  campaignId?: Maybe<Scalars['BigInt']>;
  /** Status for this campaign cancellation. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/**
 * CollectionInput represents a collection reference with its type information.
 * Used to distinguish between different collection types (e.g., Instacart departments
 * vs retailer collections) when they are passed together in a single list.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CollectionInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CollectionInput';
  /** The type of collection (e.g., "department", "retailer_collection_v2"). */
  collectionType?: Maybe<Scalars['String']>;
  /** The collection ID (numeric string, e.g., "26", "19533300777018032"). */
  id?: Maybe<Scalars['String']>;
};

/**
 * CollectionInput represents a collection reference with its type information.
 * Used to distinguish between different collection types (e.g., Instacart departments
 * vs retailer collections) when they are passed together in a single list.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CollectionInput_Input = {
  /** The type of collection (e.g., "department", "retailer_collection_v2"). */
  collectionType?: InputMaybe<Scalars['String']>;
  /** The collection ID (numeric string, e.g., "26", "19533300777018032"). */
  id?: InputMaybe<Scalars['String']>;
};

/**
 * CreateMarketingCampaignRequest initiates the creation of a new marketing campaign
 * across all relevant Instacart systems (TaaS, CRM, Commerce, Campaigns, Roulette).
 */
export type Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignRequest_Input = {
  /**
   * Authorization context of the user creating the campaign.
   * Ensures the user has permission to create campaigns for the specified retailers.
   */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /**
   * When true, constructs all downstream service request payloads and returns them
   * without executing any real service calls. The response will contain a dry_run_result
   * with the serialized request proto for each active step, keyed by step ID.
   */
  dryRun?: InputMaybe<Scalars['Boolean']>;
  /** Campaign definition to create. The ID field should not be set as it will be auto-generated. */
  marketingCampaign?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign_Input>;
};

/**
 * CreateMarketingCampaignResponse returns the created campaign with its assigned ID
 * and any system-generated fields, along with status information about the operation.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CreateMarketingCampaignResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CreateMarketingCampaignResponse';
  /**
   * Populated only when dry_run=true on the request. Contains the constructed payloads
   * for each downstream service call without any real service calls having been made.
   */
  dryRunResult?: Maybe<Instacart_Growth_Marketing_Tooling_V1_DryRunResult>;
  /**
   * The created campaign with all fields populated, including the auto-generated ID.
   * Will be null/empty if the creation failed.
   */
  marketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign>;
  /** Status indicating whether the creation succeeded or failed, with error details if applicable. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/**
 * CustomCheckoutLabelInput carries a custom checkout label for a single locale.
 * Repeat one entry per locale on OfferRestrictionsInput.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CustomCheckoutLabelInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CustomCheckoutLabelInput';
  /** The custom checkout label text for this locale. */
  label?: Maybe<Scalars['String']>;
  /** BCP 47-style locale identifier (e.g., "en_US", "es_US", "en_CA", "fr_CA"). */
  locale?: Maybe<Scalars['String']>;
};

/**
 * CustomCheckoutLabelInput carries a custom checkout label for a single locale.
 * Repeat one entry per locale on OfferRestrictionsInput.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CustomCheckoutLabelInput_Input = {
  /** The custom checkout label text for this locale. */
  label?: InputMaybe<Scalars['String']>;
  /** BCP 47-style locale identifier (e.g., "en_US", "es_US", "en_CA", "fr_CA"). */
  locale?: InputMaybe<Scalars['String']>;
};

/**
 * CustomTermsAndConditionsInput carries custom T&Cs text for a single locale.
 * Repeat one entry per locale on OfferRestrictionsInput.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CustomTermsAndConditionsInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_CustomTermsAndConditionsInput';
  /** BCP 47-style locale identifier (e.g., "en_US", "es_US", "en_CA", "fr_CA"). */
  locale?: Maybe<Scalars['String']>;
  /** The custom terms and conditions text for this locale. */
  terms?: Maybe<Scalars['String']>;
};

/**
 * CustomTermsAndConditionsInput carries custom T&Cs text for a single locale.
 * Repeat one entry per locale on OfferRestrictionsInput.
 */
export type Instacart_Growth_Marketing_Tooling_V1_CustomTermsAndConditionsInput_Input = {
  /** BCP 47-style locale identifier (e.g., "en_US", "es_US", "en_CA", "fr_CA"). */
  locale?: InputMaybe<Scalars['String']>;
  /** The custom terms and conditions text for this locale. */
  terms?: InputMaybe<Scalars['String']>;
};

/** DiscountType specifies the kind of discount applied to the basket. */
export enum Instacart_Growth_Marketing_Tooling_V1_DiscountType {
  DiscountTypeCreditBack = 'DISCOUNT_TYPE_CREDIT_BACK',
  DiscountTypeDollarOff = 'DISCOUNT_TYPE_DOLLAR_OFF',
  DiscountTypePercentageOff = 'DISCOUNT_TYPE_PERCENTAGE_OFF',
  DiscountTypeUnknown = 'DISCOUNT_TYPE_UNKNOWN'
}

/**
 * DryRunResult contains the constructed service payloads from a dry-run execution.
 * Payloads are keyed by step ID (e.g. "create_segment", "create_vgp", "create_campaign")
 * and contain the serialized request proto for each step.
 */
export type Instacart_Growth_Marketing_Tooling_V1_DryRunResult = {
  __typename?: 'instacart_growth_marketing_tooling_v1_DryRunResult';
  /**
   * Constructed service payloads keyed by step ID.
   * Values are the serialized request protos for each downstream service call.
   */
  payloads?: Maybe<Scalars['JSON']>;
};

/**
 * Experiment defines A/B test or multivariate test configuration for the campaign.
 * Allows testing different campaign variations to determine optimal performance.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Experiment';
  /** Reference to an existing Roulette feature flag experiment by its configuration. */
  existing?: Maybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature>;
  /** Define a new experiment with its own variants and preconditions. */
  new?: Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition>;
};

/**
 * ExperimentDefinition contains the complete configuration for a new experiment,
 * including preconditions and all variants to be tested.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Experiment_ExperimentDefinition';
  /**
   * Percentage of traffic sent to the control arm (0-100). Variant weight is
   * inferred as 100 - this. 0 means full-variant; 10 means a 90/10 split test.
   */
  controlWeightPercentage?: Maybe<Scalars['Int']>;
  /** If true, adds a Comarketing (retailer-holdout) precondition to the experiment. */
  includeComarketingHoldout?: Maybe<Scalars['Boolean']>;
  /** Human-readable name for this experiment feature in Roulette. */
  name?: Maybe<Scalars['String']>;
  /** UUID of a Roulette feature required as a precondition for this experiment. */
  preconditionFeatureUuid?: Maybe<Scalars['String']>;
  /** Variant name required on the precondition Roulette feature. */
  preconditionFeatureVariant?: Maybe<Scalars['String']>;
  /**
   * Roulette features that must be assigned for users to be eligible for this experiment.
   * These are preconditions checked before variant assignment.
   */
  roulettePreconditions?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition>>>;
  /**
   * If true, do not inject the hardcoded marketplace Braze holdout UUID.
   * Caller-supplied roulette_preconditions are still kept. Default false
   * preserves today's always-on inject for legacy clients.
   */
  skipBrazeHoldout?: Maybe<Scalars['Boolean']>;
  /** Whether Roulette should emit exposure events for every assignment. */
  trackAllExposures?: Maybe<Scalars['Boolean']>;
  /**
   * List of variants in this experiment. Users are randomly assigned to one variant
   * based on the weights specified. Weights must sum to 100.
   */
  variants?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant>>>;
};

/**
 * ExperimentDefinition contains the complete configuration for a new experiment,
 * including preconditions and all variants to be tested.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition_Input = {
  /**
   * Percentage of traffic sent to the control arm (0-100). Variant weight is
   * inferred as 100 - this. 0 means full-variant; 10 means a 90/10 split test.
   */
  controlWeightPercentage?: InputMaybe<Scalars['Int']>;
  /** If true, adds a Comarketing (retailer-holdout) precondition to the experiment. */
  includeComarketingHoldout?: InputMaybe<Scalars['Boolean']>;
  /** Human-readable name for this experiment feature in Roulette. */
  name?: InputMaybe<Scalars['String']>;
  /** UUID of a Roulette feature required as a precondition for this experiment. */
  preconditionFeatureUuid?: InputMaybe<Scalars['String']>;
  /** Variant name required on the precondition Roulette feature. */
  preconditionFeatureVariant?: InputMaybe<Scalars['String']>;
  /**
   * Roulette features that must be assigned for users to be eligible for this experiment.
   * These are preconditions checked before variant assignment.
   */
  roulettePreconditions?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition_Input>>>;
  /**
   * If true, do not inject the hardcoded marketplace Braze holdout UUID.
   * Caller-supplied roulette_preconditions are still kept. Default false
   * preserves today's always-on inject for legacy clients.
   */
  skipBrazeHoldout?: InputMaybe<Scalars['Boolean']>;
  /** Whether Roulette should emit exposure events for every assignment. */
  trackAllExposures?: InputMaybe<Scalars['Boolean']>;
  /**
   * List of variants in this experiment. Users are randomly assigned to one variant
   * based on the weights specified. Weights must sum to 100.
   */
  variants?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant_Input>>>;
};

/** ExperimentVariant represents a single variation in an A/B or multivariate test. */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Experiment_ExperimentVariant';
  /** Whether this variant is the default/control variant. */
  isDefault?: Maybe<Scalars['Boolean']>;
  /** Human-readable name for this variant (e.g., "Control", "Treatment A", "20% Discount"). */
  name?: Maybe<Scalars['String']>;
  /**
   * Weight for traffic allocation as a percentage (0-100). All variant weights must sum to 100.
   * For example, weights of [50, 50] split traffic evenly, [80, 20] gives 80% to the first variant.
   */
  weight?: Maybe<Scalars['BigInt']>;
};

/** ExperimentVariant represents a single variation in an A/B or multivariate test. */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentVariant_Input = {
  /** Whether this variant is the default/control variant. */
  isDefault?: InputMaybe<Scalars['Boolean']>;
  /** Human-readable name for this variant (e.g., "Control", "Treatment A", "20% Discount"). */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Weight for traffic allocation as a percentage (0-100). All variant weights must sum to 100.
   * For example, weights of [50, 50] split traffic evenly, [80, 20] gives 80% to the first variant.
   */
  weight?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Experiment defines A/B test or multivariate test configuration for the campaign.
 * Allows testing different campaign variations to determine optimal performance.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Experiment_Input = {
  /** Reference to an existing Roulette feature flag experiment by its configuration. */
  existing?: InputMaybe<Instacart_Customers_Coupons_V1_CampaignRouletteFeature_Input>;
  /** Define a new experiment with its own variants and preconditions. */
  new?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_ExperimentDefinition_Input>;
};

/** FeeRewardInput defines a fee waiver reward. */
export type Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_FeeRewardInput';
  /** Which fee is waived. */
  feeType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_FeeType>;
};

/** FeeRewardInput defines a fee waiver reward. */
export type Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput_Input = {
  /** Which fee is waived. */
  feeType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FeeType>;
};

/** FeeType specifies which fulfillment fee is waived by the offer. */
export enum Instacart_Growth_Marketing_Tooling_V1_FeeType {
  FeeTypeDelivery = 'FEE_TYPE_DELIVERY',
  FeeTypePickup = 'FEE_TYPE_PICKUP',
  FeeTypePickupOrDelivery = 'FEE_TYPE_PICKUP_OR_DELIVERY',
  FeeTypePriority = 'FEE_TYPE_PRIORITY',
  FeeTypeService = 'FEE_TYPE_SERVICE',
  FeeTypeUnknown = 'FEE_TYPE_UNKNOWN'
}

/**
 * FirstNOrdersRestriction restricts the offer to the customer's first N
 * orders. The wrapping message's presence on OfferRestrictionsInput signals
 * that this restriction is active; max_order_count must be > 0.
 */
export type Instacart_Growth_Marketing_Tooling_V1_FirstNOrdersRestriction = {
  __typename?: 'instacart_growth_marketing_tooling_v1_FirstNOrdersRestriction';
  /** Maximum order index (1-based) at which the offer is still applicable. */
  maxOrderCount?: Maybe<Scalars['UnsignedInt']>;
};

/**
 * FirstNOrdersRestriction restricts the offer to the customer's first N
 * orders. The wrapping message's presence on OfferRestrictionsInput signals
 * that this restriction is active; max_order_count must be > 0.
 */
export type Instacart_Growth_Marketing_Tooling_V1_FirstNOrdersRestriction_Input = {
  /** Maximum order index (1-based) at which the offer is still applicable. */
  maxOrderCount?: InputMaybe<Scalars['UnsignedInt']>;
};

/** FulfillmentType specifies a single supported fulfillment type. */
export enum Instacart_Growth_Marketing_Tooling_V1_FulfillmentType {
  FulfillmentTypeDelivery = 'FULFILLMENT_TYPE_DELIVERY',
  FulfillmentTypePickup = 'FULFILLMENT_TYPE_PICKUP',
  FulfillmentTypeUnknown = 'FULFILLMENT_TYPE_UNKNOWN'
}

/** FulfillmentTypeRestriction restricts the offer to a single fulfillment type. */
export type Instacart_Growth_Marketing_Tooling_V1_FulfillmentTypeRestriction = {
  __typename?: 'instacart_growth_marketing_tooling_v1_FulfillmentTypeRestriction';
  fulfillmentType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_FulfillmentType>;
};

/** FulfillmentTypeRestriction restricts the offer to a single fulfillment type. */
export type Instacart_Growth_Marketing_Tooling_V1_FulfillmentTypeRestriction_Input = {
  fulfillmentType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FulfillmentType>;
};

/**
 * FundingType specifies how the offer cost is split between Instacart and the
 * retailer (or, for Embedded Instacart campaigns, the partner).
 */
export enum Instacart_Growth_Marketing_Tooling_V1_FundingType {
  /** Instacart + Retailer, arbitrary split */
  FundingTypeCustomSplit = 'FUNDING_TYPE_CUSTOM_SPLIT',
  /** Embedded Instacart: Instacart + Partner, arbitrary split */
  FundingTypeCustomSplitPartner = 'FUNDING_TYPE_CUSTOM_SPLIT_PARTNER',
  /** Instacart + Retailer, 50/50 */
  FundingTypeFiftyFifty = 'FUNDING_TYPE_FIFTY_FIFTY',
  /** Embedded Instacart: Instacart + Partner, 50/50 */
  FundingTypeFiftyFiftyPartner = 'FUNDING_TYPE_FIFTY_FIFTY_PARTNER',
  FundingTypeFullyInstacart = 'FUNDING_TYPE_FULLY_INSTACART',
  /** Embedded Instacart: counterparty is a partner */
  FundingTypeFullyPartner = 'FUNDING_TYPE_FULLY_PARTNER',
  FundingTypeFullyRetailer = 'FUNDING_TYPE_FULLY_RETAILER',
  FundingTypeUnknown = 'FUNDING_TYPE_UNKNOWN'
}

/** GetMarketingCampaignRequest retrieves a marketing campaign by its ID. */
export type Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignRequest_Input = {
  /**
   * Authorization context of the user requesting the campaign.
   * Ensures the user has permission to view campaigns for the specified retailers.
   */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The unique identifier of the campaign to retrieve. */
  campaignId?: InputMaybe<Scalars['BigInt']>;
};

/**
 * GetMarketingCampaignResponse returns the campaign with all its associated entities.
 * Returns partial data if some entity fetches fail, with errors indicating which failed.
 */
export type Instacart_Growth_Marketing_Tooling_V1_GetMarketingCampaignResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_GetMarketingCampaignResponse';
  /**
   * The retrieved campaign with all associated entities that were successfully fetched.
   * May contain partial data if some entity fetches failed.
   */
  marketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign>;
  /** Status indicating success or partial success with error details for any failed entity fetches. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/** ListMarketingCampaignsRequest retrieves a paginated list of marketing campaigns. */
export type Instacart_Growth_Marketing_Tooling_V1_ListMarketingCampaignsRequest_Input = {
  /**
   * Authorization context of the user requesting the campaigns.
   * Filters results to campaigns the user has permission to view.
   */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** Filters to apply when listing campaigns. */
  filters?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignFilters_Input>;
  /** Ordering parameters for the results. */
  order?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  /**
   * Pagination parameters for the request.
   *
   * NOTE: This RPC proxies to customers-backend's ListCampaigns, which
   * implements `after` as a stringified integer OFFSET (passed directly
   * to ActiveRecord `.offset(...)`), not an opaque cursor. Both styles
   * work in practice:
   * - Cursor-style: pass `pageInfo.endCursor` from the previous response.
   * - Offset-style: pass `((page - 1) * limit).toString()` to jump to
   * an arbitrary page.
   * The returned `endCursor` is computed as `previous_offset + nodes_returned`.
   */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

/** ListMarketingCampaignsResponse returns a paginated list of marketing campaigns. */
export type Instacart_Growth_Marketing_Tooling_V1_ListMarketingCampaignsResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ListMarketingCampaignsResponse';
  /**
   * List of campaigns matching the filter criteria.
   * Note: These are basic campaign representations without enriched entities.
   */
  marketingCampaigns?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign>>>;
  /** Pagination info for navigating results. */
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  /** Status indicating success or failure with error details. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
  /** Total count of campaigns matching the filter criteria (before pagination). */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/**
 * MarketingCampaign is the unified representation of a marketing campaign across all Instacart
 * marketing systems. It combines context (who/where), configuration (what/when),
 * targeting (audience), experimentation (variants), messaging (CRM), and incentives (discounts).
 */
export type Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign = {
  __typename?: 'instacart_growth_marketing_tooling_v1_MarketingCampaign';
  /** Operational settings: schedule, budget, treatments, tracking, and custom properties. */
  configuration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration>;
  /** Scope: which retailers, sites, and countries this campaign applies to. */
  context?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignContext>;
  /** UTC timestamp when the campaign was first created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Messaging configuration for delivering communications through various CRM channels. */
  crmConfiguration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration>;
  /**
   * Follow-up CRM steps for a non-experiment campaign. The primary
   * crm_configuration remains Message 1. Must be empty when
   * crm_variant_configurations is set (put follow-ups on each SEND route).
   */
  crmSequenceSteps?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep>>>;
  /**
   * Explicit per-variant CRM routing. When set, this replaces the legacy
   * singular crm_configuration/control_weight_percentage composition path.
   */
  crmVariantConfigurations?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmVariantConfiguration>>>;
  /** A/B testing configuration for comparing different campaign variations. */
  experiment?: Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment>;
  /**
   * Unique identifier for this campaign. Auto-generated on creation.
   * Not required when creating a new campaign.
   */
  id?: Maybe<Scalars['BigInt']>;
  /** Deprecated: use configuration.campaign_metadata. */
  meta?: Maybe<Scalars['JSON']>;
  /** Human-readable name for this campaign. */
  name?: Maybe<Scalars['String']>;
  /** Offer input representing reward, requirements, redemption, and budget. */
  offer?: Maybe<Instacart_Growth_Marketing_Tooling_V1_OfferInput>;
  /**
   * Audience-size snapshot captured when submitting the campaign. Only
   * meaningful when the campaign distributes through email or push.
   */
  offlineEstimatedAudienceSize?: Maybe<Scalars['BigInt']>;
  /** Reporting and attribution metadata for the campaign (tags, cost center, finance typology, etc.). */
  reporting?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput>;
  /** Audience criteria: geographic regions and behavioral segments that define eligibility. */
  targeting?: Maybe<Instacart_Growth_Marketing_Tooling_V1_Targeting>;
  /** UTC timestamp when the campaign was last modified. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Value grant policy data for discounts, credits, and rewards. */
  valueGrantPolicy?: Maybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade>;
};

/**
 * MarketingCampaign is the unified representation of a marketing campaign across all Instacart
 * marketing systems. It combines context (who/where), configuration (what/when),
 * targeting (audience), experimentation (variants), messaging (CRM), and incentives (discounts).
 */
export type Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign_Input = {
  /** Operational settings: schedule, budget, treatments, tracking, and custom properties. */
  configuration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_Input>;
  /** Scope: which retailers, sites, and countries this campaign applies to. */
  context?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignContext_Input>;
  /** UTC timestamp when the campaign was first created. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Messaging configuration for delivering communications through various CRM channels. */
  crmConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input>;
  /**
   * Follow-up CRM steps for a non-experiment campaign. The primary
   * crm_configuration remains Message 1. Must be empty when
   * crm_variant_configurations is set (put follow-ups on each SEND route).
   */
  crmSequenceSteps?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep_Input>>>;
  /**
   * Explicit per-variant CRM routing. When set, this replaces the legacy
   * singular crm_configuration/control_weight_percentage composition path.
   */
  crmVariantConfigurations?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmVariantConfiguration_Input>>>;
  /** A/B testing configuration for comparing different campaign variations. */
  experiment?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_Input>;
  /**
   * Unique identifier for this campaign. Auto-generated on creation.
   * Not required when creating a new campaign.
   */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Deprecated: use configuration.campaign_metadata. */
  meta?: InputMaybe<Scalars['JSON']>;
  /** Human-readable name for this campaign. */
  name?: InputMaybe<Scalars['String']>;
  /** Offer input representing reward, requirements, redemption, and budget. */
  offer?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_OfferInput_Input>;
  /**
   * Audience-size snapshot captured when submitting the campaign. Only
   * meaningful when the campaign distributes through email or push.
   */
  offlineEstimatedAudienceSize?: InputMaybe<Scalars['BigInt']>;
  /** Reporting and attribution metadata for the campaign (tags, cost center, finance typology, etc.). */
  reporting?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_Input>;
  /** Audience criteria: geographic regions and behavioral segments that define eligibility. */
  targeting?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Targeting_Input>;
  /** UTC timestamp when the campaign was last modified. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  /** Value grant policy data for discounts, credits, and rewards. */
  valueGrantPolicy?: InputMaybe<Instacart_Customers_Commerce_Discount_V1_ValueGrantPolicyFacade_Input>;
};

/**
 * MinimumQuantityLimitType controls whether the requirement is met by any
 * quantity or a specific quantity of qualifying units.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityLimitType {
  MinimumQuantityLimitTypeAny = 'MINIMUM_QUANTITY_LIMIT_TYPE_ANY',
  MinimumQuantityLimitTypeSpecific = 'MINIMUM_QUANTITY_LIMIT_TYPE_SPECIFIC',
  MinimumQuantityLimitTypeUnknown = 'MINIMUM_QUANTITY_LIMIT_TYPE_UNKNOWN'
}

/**
 * MinimumQuantityRequirementInput requires the customer to purchase a minimum
 * number of qualifying units.
 */
export type Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_MinimumQuantityRequirementInput';
  /**
   * Whether the offer can be partially applied when the customer's basket
   * contains fewer qualifying units than the required quantity.
   */
  allowPartialApplication?: Maybe<Scalars['Boolean']>;
  /** Collections (each entry carries its own collection_type). */
  collections?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementCollections>;
  /** Specific products by product id. */
  products?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementProducts>;
  /**
   * Number of units required as a string to support decimal values for
   * weight-based units (e.g., "3", "1.5"). Populated when
   * quantity_limit_type = MINIMUM_QUANTITY_LIMIT_TYPE_SPECIFIC. Maps to the
   * string value passed in the downstream CommerceDiscount Condition.value.
   */
  quantityLimit?: Maybe<Scalars['String']>;
  /** Whether any quantity qualifies or a specific quantity is required. */
  quantityLimitType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityLimitType>;
  /** Whether the requirement applies to the same departments as the reward or different ones. */
  requirementCondition?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput_RequirementCondition>;
  /** Retailer departments by slug id. */
  retailerDepartments?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementRetailerDepartments>;
  /**
   * Unit of measure for the quantity (each unit or pounds). Maps to the
   * downstream CommerceDiscount ConditionKey (QUANTITY for UNIT, WEIGHT_LB
   * for LBS). Populated when
   * quantity_limit_type = MINIMUM_QUANTITY_LIMIT_TYPE_SPECIFIC.
   */
  unit?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityUnit>;
};

/**
 * MinimumQuantityRequirementInput requires the customer to purchase a minimum
 * number of qualifying units.
 */
export type Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput_Input = {
  /**
   * Whether the offer can be partially applied when the customer's basket
   * contains fewer qualifying units than the required quantity.
   */
  allowPartialApplication?: InputMaybe<Scalars['Boolean']>;
  /** Collections (each entry carries its own collection_type). */
  collections?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementCollections_Input>;
  /** Specific products by product id. */
  products?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementProducts_Input>;
  /**
   * Number of units required as a string to support decimal values for
   * weight-based units (e.g., "3", "1.5"). Populated when
   * quantity_limit_type = MINIMUM_QUANTITY_LIMIT_TYPE_SPECIFIC. Maps to the
   * string value passed in the downstream CommerceDiscount Condition.value.
   */
  quantityLimit?: InputMaybe<Scalars['String']>;
  /** Whether any quantity qualifies or a specific quantity is required. */
  quantityLimitType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityLimitType>;
  /** Whether the requirement applies to the same departments as the reward or different ones. */
  requirementCondition?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput_RequirementCondition>;
  /** Retailer departments by slug id. */
  retailerDepartments?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementRetailerDepartments_Input>;
  /**
   * Unit of measure for the quantity (each unit or pounds). Maps to the
   * downstream CommerceDiscount ConditionKey (QUANTITY for UNIT, WEIGHT_LB
   * for LBS). Populated when
   * quantity_limit_type = MINIMUM_QUANTITY_LIMIT_TYPE_SPECIFIC.
   */
  unit?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityUnit>;
};

/**
 * RequirementCondition controls whether the requirement applies to the same
 * or different departments as the reward.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput_RequirementCondition {
  RequirementConditionDifferentFromReward = 'REQUIREMENT_CONDITION_DIFFERENT_FROM_REWARD',
  RequirementConditionSameAsReward = 'REQUIREMENT_CONDITION_SAME_AS_REWARD',
  RequirementConditionUnknown = 'REQUIREMENT_CONDITION_UNKNOWN'
}

/**
 * MinimumQuantityUnit specifies the unit of measure for the minimum quantity.
 * Mirrors the supported downstream CommerceDiscount ConditionKey values
 * (QUANTITY and WEIGHT_LB) for this API.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityUnit {
  MinimumQuantityUnitLbs = 'MINIMUM_QUANTITY_UNIT_LBS',
  MinimumQuantityUnitUnit = 'MINIMUM_QUANTITY_UNIT_UNIT',
  MinimumQuantityUnitUnknown = 'MINIMUM_QUANTITY_UNIT_UNKNOWN'
}

/**
 * MinimumSpendRequirementInput requires the customer to spend a minimum amount,
 * optionally scoped to specific departments with exclusions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_MinimumSpendRequirementInput';
  /** Minimum spend amount as a string (e.g., "25.00"). */
  amount?: Maybe<Scalars['String']>;
  /**
   * Collections that define the scope of the minimum spend requirement.
   * Each entry carries its own collection type, allowing different kinds of
   * collections (departments, retailer collections, etc.) to coexist in a single list.
   * Populated when scope = REQUIREMENT_SCOPE_COLLECTION or
   * REQUIREMENT_SCOPE_INSTACART_DEPARTMENT.
   */
  collections?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CollectionInput>>>;
  /** Whether to exclude alcohol items from the minimum spend calculation. */
  excludeAlcohol?: Maybe<Scalars['Boolean']>;
  /** Whether to exclude brand items from the minimum spend calculation. */
  excludeBrands?: Maybe<Scalars['Boolean']>;
  /** Whether to exclude collection items from the minimum spend calculation. */
  excludeCollections?: Maybe<Scalars['Boolean']>;
  /** Specific brand IDs to exclude from the minimum spend calculation. */
  excludedBrandIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Specific collection IDs to exclude from the minimum spend calculation. */
  excludedCollectionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * Specific products the minimum spend is scoped to. Populated when
   * scope = REQUIREMENT_SCOPE_PRODUCT.
   */
  products?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementProducts>;
  /**
   * Retailer departments the minimum spend is scoped to. Populated when
   * scope = REQUIREMENT_SCOPE_RETAILER_DEPARTMENT.
   */
  retailerDepartments?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementRetailerDepartments>;
  /**
   * Whether the minimum spend applies to the full basket or specific departments,
   * collections, products, or retailer departments.
   */
  scope?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementScope>;
};

/**
 * MinimumSpendRequirementInput requires the customer to spend a minimum amount,
 * optionally scoped to specific departments with exclusions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput_Input = {
  /** Minimum spend amount as a string (e.g., "25.00"). */
  amount?: InputMaybe<Scalars['String']>;
  /**
   * Collections that define the scope of the minimum spend requirement.
   * Each entry carries its own collection type, allowing different kinds of
   * collections (departments, retailer collections, etc.) to coexist in a single list.
   * Populated when scope = REQUIREMENT_SCOPE_COLLECTION or
   * REQUIREMENT_SCOPE_INSTACART_DEPARTMENT.
   */
  collections?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CollectionInput_Input>>>;
  /** Whether to exclude alcohol items from the minimum spend calculation. */
  excludeAlcohol?: InputMaybe<Scalars['Boolean']>;
  /** Whether to exclude brand items from the minimum spend calculation. */
  excludeBrands?: InputMaybe<Scalars['Boolean']>;
  /** Whether to exclude collection items from the minimum spend calculation. */
  excludeCollections?: InputMaybe<Scalars['Boolean']>;
  /** Specific brand IDs to exclude from the minimum spend calculation. */
  excludedBrandIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specific collection IDs to exclude from the minimum spend calculation. */
  excludedCollectionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Specific products the minimum spend is scoped to. Populated when
   * scope = REQUIREMENT_SCOPE_PRODUCT.
   */
  products?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementProducts_Input>;
  /**
   * Retailer departments the minimum spend is scoped to. Populated when
   * scope = REQUIREMENT_SCOPE_RETAILER_DEPARTMENT.
   */
  retailerDepartments?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementRetailerDepartments_Input>;
  /**
   * Whether the minimum spend applies to the full basket or specific departments,
   * collections, products, or retailer departments.
   */
  scope?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementScope>;
};

/**
 * OfferInput is the top-level offer definition containing reward, requirements,
 * redemption rules, and budget restrictions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_OfferInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_OfferInput';
  /** Budget caps and funding split configuration. */
  budgetRestrictions?: Maybe<Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput>;
  /** How many times and under what conditions the offer can be redeemed. */
  redemption?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RedemptionInput>;
  /** Conditions the customer must meet to be eligible for the offer. */
  requirements?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementInput>;
  /** What the customer receives (discount or fee waiver). */
  reward?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RewardInput>;
  /**
   * Output-only: the numeric value grant policy ID backing this offer. Populated
   * on reads; ignored on writes.
   */
  valueGrantPolicyId?: Maybe<Scalars['BigInt']>;
  /**
   * Output-only: the value grant policy key backing this offer. Populated on
   * reads; ignored on writes.
   */
  valueGrantPolicyKey?: Maybe<Scalars['String']>;
};

/**
 * OfferInput is the top-level offer definition containing reward, requirements,
 * redemption rules, and budget restrictions.
 */
export type Instacart_Growth_Marketing_Tooling_V1_OfferInput_Input = {
  /** Budget caps and funding split configuration. */
  budgetRestrictions?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_BudgetRestrictionsInput_Input>;
  /** How many times and under what conditions the offer can be redeemed. */
  redemption?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RedemptionInput_Input>;
  /** Conditions the customer must meet to be eligible for the offer. */
  requirements?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementInput_Input>;
  /** What the customer receives (discount or fee waiver). */
  reward?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RewardInput_Input>;
  /**
   * Output-only: the numeric value grant policy ID backing this offer. Populated
   * on reads; ignored on writes.
   */
  valueGrantPolicyId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Output-only: the value grant policy key backing this offer. Populated on
   * reads; ignored on writes.
   */
  valueGrantPolicyKey?: InputMaybe<Scalars['String']>;
};

/** OfferRestrictionsInput bundles all applicability rules for an offer. */
export type Instacart_Growth_Marketing_Tooling_V1_OfferRestrictionsInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_OfferRestrictionsInput';
  /** Per-locale custom label shown at checkout. Empty = no custom label. */
  customCheckoutLabel?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CustomCheckoutLabelInput>>>;
  /** Per-locale custom terms and conditions. Empty = no custom T&Cs. */
  customTermsAndConditions?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CustomTermsAndConditionsInput>>>;
  /** Restrict the offer to the customer's first N orders. */
  firstNOrders?: Maybe<Instacart_Growth_Marketing_Tooling_V1_FirstNOrdersRestriction>;
  /** Restrict the offer to a single fulfillment type (delivery or pickup). */
  fulfillmentType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_FulfillmentTypeRestriction>;
  /** Presence restricts the offer to IC+ members. */
  icPlusMember?: Maybe<Scalars['instacart_growth_marketing_tooling_v1_IcPlusMemberRestriction']>;
  /** Presence restricts the offer to loyalty program members. */
  loyaltyMember?: Maybe<Scalars['instacart_growth_marketing_tooling_v1_LoyaltyMemberRestriction']>;
  /** Restrict the offer to one or more payment instrument types. */
  paymentType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_PaymentTypeRestriction>;
  /** Whether this offer can stack with other offers. */
  stackability?: Maybe<Instacart_Growth_Marketing_Tooling_V1_Stackability>;
};

/** OfferRestrictionsInput bundles all applicability rules for an offer. */
export type Instacart_Growth_Marketing_Tooling_V1_OfferRestrictionsInput_Input = {
  /** Per-locale custom label shown at checkout. Empty = no custom label. */
  customCheckoutLabel?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CustomCheckoutLabelInput_Input>>>;
  /** Per-locale custom terms and conditions. Empty = no custom T&Cs. */
  customTermsAndConditions?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CustomTermsAndConditionsInput_Input>>>;
  /** Restrict the offer to the customer's first N orders. */
  firstNOrders?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FirstNOrdersRestriction_Input>;
  /** Restrict the offer to a single fulfillment type (delivery or pickup). */
  fulfillmentType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FulfillmentTypeRestriction_Input>;
  /** Presence restricts the offer to IC+ members. */
  icPlusMember?: InputMaybe<Scalars['instacart_growth_marketing_tooling_v1_IcPlusMemberRestriction_Input']>;
  /** Presence restricts the offer to loyalty program members. */
  loyaltyMember?: InputMaybe<Scalars['instacart_growth_marketing_tooling_v1_LoyaltyMemberRestriction_Input']>;
  /** Restrict the offer to one or more payment instrument types. */
  paymentType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_PaymentTypeRestriction_Input>;
  /** Whether this offer can stack with other offers. */
  stackability?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Stackability>;
};

/**
 * PaymentInstrumentType enumerates the supported payment instruments. Extend
 * as new instruments are supported.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_PaymentInstrumentType {
  PaymentInstrumentTypeApplePay = 'PAYMENT_INSTRUMENT_TYPE_APPLE_PAY',
  PaymentInstrumentTypeCashApp = 'PAYMENT_INSTRUMENT_TYPE_CASH_APP',
  PaymentInstrumentTypeCreditCard = 'PAYMENT_INSTRUMENT_TYPE_CREDIT_CARD',
  PaymentInstrumentTypeEbt = 'PAYMENT_INSTRUMENT_TYPE_EBT',
  PaymentInstrumentTypeGooglePay = 'PAYMENT_INSTRUMENT_TYPE_GOOGLE_PAY',
  PaymentInstrumentTypeHsaFsaCard = 'PAYMENT_INSTRUMENT_TYPE_HSA_FSA_CARD',
  PaymentInstrumentTypeKlarnaMultiUse = 'PAYMENT_INSTRUMENT_TYPE_KLARNA_MULTI_USE',
  PaymentInstrumentTypeMedicare = 'PAYMENT_INSTRUMENT_TYPE_MEDICARE',
  PaymentInstrumentTypePaypal = 'PAYMENT_INSTRUMENT_TYPE_PAYPAL',
  PaymentInstrumentTypeUnknown = 'PAYMENT_INSTRUMENT_TYPE_UNKNOWN',
  PaymentInstrumentTypeVenmo = 'PAYMENT_INSTRUMENT_TYPE_VENMO'
}

/**
 * PaymentTypeRestriction restricts the offer to one or more payment
 * instrument types. The offer is applicable if the customer pays with any of
 * the listed instruments.
 */
export type Instacart_Growth_Marketing_Tooling_V1_PaymentTypeRestriction = {
  __typename?: 'instacart_growth_marketing_tooling_v1_PaymentTypeRestriction';
  paymentInstrumentTypes?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_PaymentInstrumentType>>>;
};

/**
 * PaymentTypeRestriction restricts the offer to one or more payment
 * instrument types. The offer is applicable if the customer pays with any of
 * the listed instruments.
 */
export type Instacart_Growth_Marketing_Tooling_V1_PaymentTypeRestriction_Input = {
  paymentInstrumentTypes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_PaymentInstrumentType>>>;
};

/**
 * ProductDiscountApplication specifies whether a dollar-off discount applies
 * to the basket in total or per unit.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_ProductDiscountApplication {
  ProductDiscountApplicationInTotal = 'PRODUCT_DISCOUNT_APPLICATION_IN_TOTAL',
  ProductDiscountApplicationPerUnit = 'PRODUCT_DISCOUNT_APPLICATION_PER_UNIT',
  ProductDiscountApplicationUnknown = 'PRODUCT_DISCOUNT_APPLICATION_UNKNOWN'
}

/** ProductDiscountCalculation specifies how the product discount is calculated. */
export enum Instacart_Growth_Marketing_Tooling_V1_ProductDiscountCalculation {
  ProductDiscountCalculationDollarOff = 'PRODUCT_DISCOUNT_CALCULATION_DOLLAR_OFF',
  ProductDiscountCalculationPercentageOff = 'PRODUCT_DISCOUNT_CALCULATION_PERCENTAGE_OFF',
  ProductDiscountCalculationUnknown = 'PRODUCT_DISCOUNT_CALCULATION_UNKNOWN'
}

/** ProductDiscountConfig configures a product discount reward. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductDiscountConfig = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ProductDiscountConfig';
  /** Dollar amount (DOLLAR_OFF) or percentage value (PERCENTAGE_OFF), as a string. */
  amount?: Maybe<Scalars['String']>;
  /** For DOLLAR_OFF (when shown): whether the dollar amount applies to the basket in total or per unit. */
  application?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductDiscountApplication>;
  /** Dollar off vs percentage off. */
  calculation?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductDiscountCalculation>;
  /** For PERCENTAGE_OFF: optional cap on the reward per transaction. */
  maxRewardPerTransaction?: Maybe<Scalars['String']>;
};

/** ProductDiscountConfig configures a product discount reward. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductDiscountConfig_Input = {
  /** Dollar amount (DOLLAR_OFF) or percentage value (PERCENTAGE_OFF), as a string. */
  amount?: InputMaybe<Scalars['String']>;
  /** For DOLLAR_OFF (when shown): whether the dollar amount applies to the basket in total or per unit. */
  application?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductDiscountApplication>;
  /** Dollar off vs percentage off. */
  calculation?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductDiscountCalculation>;
  /** For PERCENTAGE_OFF: optional cap on the reward per transaction. */
  maxRewardPerTransaction?: InputMaybe<Scalars['String']>;
};

/** ProductRewardCollections scopes the reward to a set of collections. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardCollections = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ProductRewardCollections';
  collections?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CollectionInput>>>;
};

/** ProductRewardCollections scopes the reward to a set of collections. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardCollections_Input = {
  collections?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CollectionInput_Input>>>;
};

/**
 * ProductRewardInput defines a product-level reward: a discount on products,
 * a set price for products, or a free product.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ProductRewardInput';
  /** Collections (each entry carries its own collection_type). */
  collections?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardCollections>;
  /** Discount configuration. Populated when type = PRODUCT_REWARD_TYPE_DISCOUNT. */
  discount?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductDiscountConfig>;
  /** Specific products by product id. */
  products?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardProducts>;
  /**
   * Number of units the reward applies to. Populated when
   * quantity_limit_type = PRODUCT_REWARD_QUANTITY_LIMIT_TYPE_SPECIFIC.
   */
  quantityLimit?: Maybe<Scalars['UnsignedInt']>;
  /** Whether the reward applies to any quantity or a specific quantity. */
  quantityLimitType?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardQuantityLimitType>;
  /** Retailer departments by slug id. */
  retailerDepartments?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardRetailerDepartments>;
  /** Set-price configuration. Populated when type = PRODUCT_REWARD_TYPE_SET_PRICE. */
  setPrice?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceConfig>;
  /** The kind of product reward (discount, set price, or free product). */
  type?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardType>;
};

/**
 * ProductRewardInput defines a product-level reward: a discount on products,
 * a set price for products, or a free product.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardInput_Input = {
  /** Collections (each entry carries its own collection_type). */
  collections?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardCollections_Input>;
  /** Discount configuration. Populated when type = PRODUCT_REWARD_TYPE_DISCOUNT. */
  discount?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductDiscountConfig_Input>;
  /** Specific products by product id. */
  products?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardProducts_Input>;
  /**
   * Number of units the reward applies to. Populated when
   * quantity_limit_type = PRODUCT_REWARD_QUANTITY_LIMIT_TYPE_SPECIFIC.
   */
  quantityLimit?: InputMaybe<Scalars['UnsignedInt']>;
  /** Whether the reward applies to any quantity or a specific quantity. */
  quantityLimitType?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardQuantityLimitType>;
  /** Retailer departments by slug id. */
  retailerDepartments?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardRetailerDepartments_Input>;
  /** Set-price configuration. Populated when type = PRODUCT_REWARD_TYPE_SET_PRICE. */
  setPrice?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceConfig_Input>;
  /** The kind of product reward (discount, set price, or free product). */
  type?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardType>;
};

/** ProductRewardProducts scopes the reward to a set of specific products. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardProducts = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ProductRewardProducts';
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ProductRewardProducts scopes the reward to a set of specific products. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardProducts_Input = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * ProductRewardQuantityLimitType controls whether the reward applies to any
 * quantity or a specific quantity of units.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_ProductRewardQuantityLimitType {
  ProductRewardQuantityLimitTypeAny = 'PRODUCT_REWARD_QUANTITY_LIMIT_TYPE_ANY',
  ProductRewardQuantityLimitTypeSpecific = 'PRODUCT_REWARD_QUANTITY_LIMIT_TYPE_SPECIFIC',
  ProductRewardQuantityLimitTypeUnknown = 'PRODUCT_REWARD_QUANTITY_LIMIT_TYPE_UNKNOWN'
}

/**
 * ProductRewardRetailerDepartments scopes the reward to a set of retailer
 * departments identified by slug id.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardRetailerDepartments = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ProductRewardRetailerDepartments';
  retailerDepartmentSlugIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * ProductRewardRetailerDepartments scopes the reward to a set of retailer
 * departments identified by slug id.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ProductRewardRetailerDepartments_Input = {
  retailerDepartmentSlugIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ProductRewardType specifies the kind of product-level reward. */
export enum Instacart_Growth_Marketing_Tooling_V1_ProductRewardType {
  ProductRewardTypeDiscount = 'PRODUCT_REWARD_TYPE_DISCOUNT',
  ProductRewardTypeFreeProduct = 'PRODUCT_REWARD_TYPE_FREE_PRODUCT',
  ProductRewardTypeSetPrice = 'PRODUCT_REWARD_TYPE_SET_PRICE',
  ProductRewardTypeUnknown = 'PRODUCT_REWARD_TYPE_UNKNOWN'
}

/** ProductSetPriceCalculation specifies how the set price is interpreted. */
export enum Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceCalculation {
  ProductSetPriceCalculationPerUnitPrice = 'PRODUCT_SET_PRICE_CALCULATION_PER_UNIT_PRICE',
  ProductSetPriceCalculationTotalPrice = 'PRODUCT_SET_PRICE_CALCULATION_TOTAL_PRICE',
  ProductSetPriceCalculationUnknown = 'PRODUCT_SET_PRICE_CALCULATION_UNKNOWN'
}

/** ProductSetPriceConfig configures a set-price product reward. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceConfig = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ProductSetPriceConfig';
  /** Price amount as a string. */
  amount?: Maybe<Scalars['String']>;
  /** Total price vs price per unit/lb. */
  calculation?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceCalculation>;
};

/** ProductSetPriceConfig configures a set-price product reward. */
export type Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceConfig_Input = {
  /** Price amount as a string. */
  amount?: InputMaybe<Scalars['String']>;
  /** Total price vs price per unit/lb. */
  calculation?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductSetPriceCalculation>;
};

/**
 * RedemptionInput controls how many times and under what conditions the offer
 * can be redeemed by customers.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RedemptionInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RedemptionInput';
  /** Whether this offer is available on the Instacart marketplace (non-retailer-specific). */
  allowMarketplace?: Maybe<Scalars['Boolean']>;
  /** Coupon code customers must enter to redeem the offer. */
  couponCode?: Maybe<Scalars['String']>;
  /** Total number of coupons available for this offer. */
  couponCount?: Maybe<Scalars['String']>;
  /** Maximum number of times a single customer can redeem this offer. */
  customerRedemptionLimit?: Maybe<Scalars['String']>;
  /**
   * Number of days the offer remains redeemable after being issued/granted to the
   * customer, independent of the campaign's configured schedule starts_at/ends_at
   * window. If unset, the offer is valid until the campaign's ends_at (or
   * indefinitely if ends_at is also unset).
   */
  expireInDays?: Maybe<Scalars['BigInt']>;
  /**
   * Maximum total number of times this offer can be redeemed across all
   * customers. Decimal string representation of a positive integer. Empty
   * means unlimited (no offer-level cap).
   */
  offerRedemptionLimit?: Maybe<Scalars['String']>;
  /**
   * How the offer is redeemed. Leave as REDEMPTION_METHOD_UNKNOWN (the
   * proto3 default) for offers that don't need to distinguish auto-redeem
   * from click-to-redeem; backend treats UNKNOWN as "no preference".
   */
  redemptionMethod?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RedemptionMethod>;
  /**
   * Controls how coupon_code is distributed to customers. When false (the
   * default), coupon_code is a single shared code that every eligible
   * customer uses. When true, coupon_code is treated as a prefix and each
   * customer redeems a unique, single-use code derived from it. Only
   * meaningful when coupon_code is set.
   */
  useBulkCouponCodes?: Maybe<Scalars['Boolean']>;
  /** UTM parameters for tracking offer attribution. */
  utmParams?: Maybe<Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput>;
};

/**
 * RedemptionInput controls how many times and under what conditions the offer
 * can be redeemed by customers.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RedemptionInput_Input = {
  /** Whether this offer is available on the Instacart marketplace (non-retailer-specific). */
  allowMarketplace?: InputMaybe<Scalars['Boolean']>;
  /** Coupon code customers must enter to redeem the offer. */
  couponCode?: InputMaybe<Scalars['String']>;
  /** Total number of coupons available for this offer. */
  couponCount?: InputMaybe<Scalars['String']>;
  /** Maximum number of times a single customer can redeem this offer. */
  customerRedemptionLimit?: InputMaybe<Scalars['String']>;
  /**
   * Number of days the offer remains redeemable after being issued/granted to the
   * customer, independent of the campaign's configured schedule starts_at/ends_at
   * window. If unset, the offer is valid until the campaign's ends_at (or
   * indefinitely if ends_at is also unset).
   */
  expireInDays?: InputMaybe<Scalars['BigInt']>;
  /**
   * Maximum total number of times this offer can be redeemed across all
   * customers. Decimal string representation of a positive integer. Empty
   * means unlimited (no offer-level cap).
   */
  offerRedemptionLimit?: InputMaybe<Scalars['String']>;
  /**
   * How the offer is redeemed. Leave as REDEMPTION_METHOD_UNKNOWN (the
   * proto3 default) for offers that don't need to distinguish auto-redeem
   * from click-to-redeem; backend treats UNKNOWN as "no preference".
   */
  redemptionMethod?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RedemptionMethod>;
  /**
   * Controls how coupon_code is distributed to customers. When false (the
   * default), coupon_code is a single shared code that every eligible
   * customer uses. When true, coupon_code is treated as a prefix and each
   * customer redeems a unique, single-use code derived from it. Only
   * meaningful when coupon_code is set.
   */
  useBulkCouponCodes?: InputMaybe<Scalars['Boolean']>;
  /** UTM parameters for tracking offer attribution. */
  utmParams?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput_Input>;
};

/** RedemptionMethod specifies how the customer redeems the offer. */
export enum Instacart_Growth_Marketing_Tooling_V1_RedemptionMethod {
  /** Offer is applied automatically when the customer qualifies. */
  RedemptionMethodAutoRedeem = 'REDEMPTION_METHOD_AUTO_REDEEM',
  /** Offer requires the customer to click to redeem before it applies. */
  RedemptionMethodClickToRedeem = 'REDEMPTION_METHOD_CLICK_TO_REDEEM',
  RedemptionMethodUnknown = 'REDEMPTION_METHOD_UNKNOWN'
}

/**
 * ReportingInput contains reporting and attribution metadata for the campaign,
 * including tags, cost center, finance typology, and custom properties.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ReportingInput';
  /** Campaign rollup identifier for aggregating related campaigns in reports. */
  campaignRollup?: Maybe<Scalars['String']>;
  /** Tags for categorizing and filtering campaigns in reports. */
  campaignTags?: Maybe<Scalars['String']>;
  /** Cost center responsible for this campaign's spend. */
  costCenterOwner?: Maybe<Scalars['String']>;
  /** Additional custom key-value properties for extending reporting metadata. */
  customProperties?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty>>>;
  /** Finance typology classification for accounting and billing. */
  financeTypology?: Maybe<Scalars['String']>;
  /** Marketing ID for cross-system attribution. */
  marketingId?: Maybe<Scalars['String']>;
};

/** Custom property for reporting metadata. */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ReportingInput_CustomProperty';
  /** Property key. */
  key?: Maybe<Scalars['String']>;
  /** Property value. */
  value?: Maybe<Scalars['String']>;
};

/** Custom property for reporting metadata. */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty_Input = {
  /** Property key. */
  key?: InputMaybe<Scalars['String']>;
  /** Property value. */
  value?: InputMaybe<Scalars['String']>;
};

/**
 * ReportingInput contains reporting and attribution metadata for the campaign,
 * including tags, cost center, finance typology, and custom properties.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ReportingInput_Input = {
  /** Campaign rollup identifier for aggregating related campaigns in reports. */
  campaignRollup?: InputMaybe<Scalars['String']>;
  /** Tags for categorizing and filtering campaigns in reports. */
  campaignTags?: InputMaybe<Scalars['String']>;
  /** Cost center responsible for this campaign's spend. */
  costCenterOwner?: InputMaybe<Scalars['String']>;
  /** Additional custom key-value properties for extending reporting metadata. */
  customProperties?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_CustomProperty_Input>>>;
  /** Finance typology classification for accounting and billing. */
  financeTypology?: InputMaybe<Scalars['String']>;
  /** Marketing ID for cross-system attribution. */
  marketingId?: InputMaybe<Scalars['String']>;
};

/** RequirementCollections scopes the requirement to a set of collections. */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementCollections = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RequirementCollections';
  collections?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CollectionInput>>>;
};

/** RequirementCollections scopes the requirement to a set of collections. */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementCollections_Input = {
  collections?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CollectionInput_Input>>>;
};

/**
 * RequirementInput defines conditions the customer must meet to qualify for the offer.
 * Multiple sub-messages may be set simultaneously (the schema does not enforce
 * exclusivity). The type field indicates the primary requirement intent.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RequirementInput';
  /** Customer must purchase a minimum number of qualifying units. */
  minimumQuantity?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput>;
  /** Customer must spend a minimum amount (optionally scoped to specific departments). */
  minimumSpend?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput>;
  /**
   * Applicability rules layered on top of the requirement (stackability,
   * fulfillment type, payment type, first-N orders, IC+/loyalty membership,
   * custom T&Cs). Each sub-field is optional; absent or unspecified = no
   * restriction.
   */
  offerRestrictions?: Maybe<Instacart_Growth_Marketing_Tooling_V1_OfferRestrictionsInput>;
  /** Customer must complete a specific task (e.g., sign up, complete a survey). */
  taskRequired?: Maybe<Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput>;
  /** The primary requirement type selected by the user. */
  type?: Maybe<Instacart_Growth_Marketing_Tooling_V1_RequirementType>;
};

/**
 * RequirementInput defines conditions the customer must meet to qualify for the offer.
 * Multiple sub-messages may be set simultaneously (the schema does not enforce
 * exclusivity). The type field indicates the primary requirement intent.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementInput_Input = {
  /** Customer must purchase a minimum number of qualifying units. */
  minimumQuantity?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MinimumQuantityRequirementInput_Input>;
  /** Customer must spend a minimum amount (optionally scoped to specific departments). */
  minimumSpend?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MinimumSpendRequirementInput_Input>;
  /**
   * Applicability rules layered on top of the requirement (stackability,
   * fulfillment type, payment type, first-N orders, IC+/loyalty membership,
   * custom T&Cs). Each sub-field is optional; absent or unspecified = no
   * restriction.
   */
  offerRestrictions?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_OfferRestrictionsInput_Input>;
  /** Customer must complete a specific task (e.g., sign up, complete a survey). */
  taskRequired?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput_Input>;
  /** The primary requirement type selected by the user. */
  type?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_RequirementType>;
};

/** RequirementProducts scopes the requirement to a set of specific products. */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementProducts = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RequirementProducts';
  productIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** RequirementProducts scopes the requirement to a set of specific products. */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementProducts_Input = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * RequirementRetailerDepartments scopes the requirement to a set of retailer
 * departments identified by slug id.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementRetailerDepartments = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RequirementRetailerDepartments';
  retailerDepartmentSlugIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * RequirementRetailerDepartments scopes the requirement to a set of retailer
 * departments identified by slug id.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RequirementRetailerDepartments_Input = {
  retailerDepartmentSlugIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * RequirementScope defines whether the minimum spend applies to the full basket
 * or is scoped to specific Instacart departments, collections, products, or
 * retailer departments.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_RequirementScope {
  RequirementScopeBasket = 'REQUIREMENT_SCOPE_BASKET',
  RequirementScopeCollection = 'REQUIREMENT_SCOPE_COLLECTION',
  RequirementScopeInstacartDepartment = 'REQUIREMENT_SCOPE_INSTACART_DEPARTMENT',
  RequirementScopeProduct = 'REQUIREMENT_SCOPE_PRODUCT',
  RequirementScopeRetailerDepartment = 'REQUIREMENT_SCOPE_RETAILER_DEPARTMENT',
  RequirementScopeUnknown = 'REQUIREMENT_SCOPE_UNKNOWN'
}

/** RequirementType indicates which requirement fields are populated. */
export enum Instacart_Growth_Marketing_Tooling_V1_RequirementType {
  RequirementTypeMinimumQuantity = 'REQUIREMENT_TYPE_MINIMUM_QUANTITY',
  RequirementTypeMinimumSpend = 'REQUIREMENT_TYPE_MINIMUM_SPEND',
  RequirementTypeTaskRequired = 'REQUIREMENT_TYPE_TASK_REQUIRED',
  RequirementTypeUnknown = 'REQUIREMENT_TYPE_UNKNOWN'
}

/**
 * ResponseStatus provides standardized success/failure information for all API responses.
 * It includes detailed error information when operations fail, making it easier to debug
 * and handle errors programmatically.
 */
export type Instacart_Growth_Marketing_Tooling_V1_ResponseStatus = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ResponseStatus';
  /** Error details if success is false. Null/empty if the operation succeeded. */
  errors?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error>>>;
  /** Whether the operation completed successfully. */
  success?: Maybe<Scalars['Boolean']>;
};

/** Error contains detailed information about what went wrong during request processing. */
export type Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error = {
  __typename?: 'instacart_growth_marketing_tooling_v1_ResponseStatus_Error';
  /** Machine-readable error code for programmatic error handling. */
  code?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorCode>;
  /**
   * Specific field in the request that caused the error, if applicable.
   * Useful for validation errors to indicate which input was problematic.
   */
  field?: Maybe<Scalars['String']>;
  /** Human-readable error message describing what went wrong. */
  message?: Maybe<Scalars['String']>;
  /**
   * Categorized cause of the error. ERROR_REASON_UNKNOWN when the underlying
   * cause does not map to any recognized reason.
   */
  reason?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorReason>;
  /** Which downstream system or service caused the error. */
  source?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorSource>;
};

/** ErrorCode categorizes the type of error that occurred. */
export enum Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorCode {
  /** Server encountered an unexpected condition (server error). */
  ErrorCodeInternalServerError = 'ERROR_CODE_INTERNAL_SERVER_ERROR',
  /** Request was malformed or contained invalid data (client error). */
  ErrorCodeInvalidRequest = 'ERROR_CODE_INVALID_REQUEST',
  /**
   * A downstream service call required to build the request payload failed
   * before the main action could be executed.
   */
  ErrorCodeRequestResolverError = 'ERROR_CODE_REQUEST_RESOLVER_ERROR',
  /** Caller is not authorized to access or mutate the requested resource. */
  ErrorCodeUnauthorized = 'ERROR_CODE_UNAUTHORIZED',
  /** Unknown or unclassified error. */
  ErrorCodeUnknown = 'ERROR_CODE_UNKNOWN'
}

/**
 * Categorizes the underlying cause of an error into a bounded set of
 * recognized failure modes.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorReason {
  /** Storefront CRM campaign's audience exceeds the maximum size permitted for its channels. */
  ErrorReasonSfxCrmAudienceSizeExceedsLimit = 'ERROR_REASON_SFX_CRM_AUDIENCE_SIZE_EXCEEDS_LIMIT',
  /** Storefront CRM campaign's launch time falls inside a launch blackout window reserved for recurring high-volume batches. */
  ErrorReasonSfxCrmBlackoutWindow = 'ERROR_REASON_SFX_CRM_BLACKOUT_WINDOW',
  /** Storefront CRM campaign shares a 24h window with an existing large campaign on the same retailer. */
  ErrorReasonSfxCrmConcurrentLargeCampaignWithin24H = 'ERROR_REASON_SFX_CRM_CONCURRENT_LARGE_CAMPAIGN_WITHIN24H',
  /** Storefront CRM campaign shares a 24h window with an existing large email campaign on the same retailer. */
  ErrorReasonSfxCrmConcurrentLargeEmailCampaignWithin24H = 'ERROR_REASON_SFX_CRM_CONCURRENT_LARGE_EMAIL_CAMPAIGN_WITHIN24H',
  /** Storefront CRM campaign's launch window already holds the maximum number of concurrent launches. */
  ErrorReasonSfxCrmLaunchWindowTooCrowded = 'ERROR_REASON_SFX_CRM_LAUNCH_WINDOW_TOO_CROWDED',
  /** Storefront CRM campaign is missing the starts_at that centers its concurrency windows. */
  ErrorReasonSfxCrmMissingStartsAt = 'ERROR_REASON_SFX_CRM_MISSING_STARTS_AT',
  /** Campaign with a CRM distribution channel (email, push, or canvas) has a start date at or in the past. */
  ErrorReasonStartDateMustBeInFuture = 'ERROR_REASON_START_DATE_MUST_BE_IN_FUTURE',
  /** The underlying cause does not map to any recognized reason. */
  ErrorReasonUnknown = 'ERROR_REASON_UNKNOWN'
}

/**
 * ErrorSource identifies which downstream service or system caused the error,
 * helping with troubleshooting and monitoring.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_ResponseStatus_Error_ErrorSource {
  /** Error from Campaigns service - campaign management system. */
  ErrorSourceCampaigns = 'ERROR_SOURCE_CAMPAIGNS',
  /** Error from Commerce - discount and promotion system. */
  ErrorSourceCommerce = 'ERROR_SOURCE_COMMERCE',
  /** Error from CRMS (CRM Messaging Service) - message delivery system. */
  ErrorSourceCrms = 'ERROR_SOURCE_CRMS',
  /**
   * Error from GarnishService - localized-string storage backing
   * discount-policy checkout labels and similar assets.
   */
  ErrorSourceGarnish = 'ERROR_SOURCE_GARNISH',
  /** Error from Roulette - feature flag and experimentation system. */
  ErrorSourceRoulette = 'ERROR_SOURCE_ROULETTE',
  /** Error from TaaS (Targeting as a Service) - audience segmentation system. */
  ErrorSourceTaas = 'ERROR_SOURCE_TAAS',
  /** Unknown source or error originated in this service. */
  ErrorSourceUnknown = 'ERROR_SOURCE_UNKNOWN'
}

/**
 * RewardApplication controls whether the reward applies to the same or different
 * departments as the requirement condition.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_RewardApplication {
  RewardApplicationDifferentFromCondition = 'REWARD_APPLICATION_DIFFERENT_FROM_CONDITION',
  RewardApplicationSameAsCondition = 'REWARD_APPLICATION_SAME_AS_CONDITION',
  RewardApplicationUnknown = 'REWARD_APPLICATION_UNKNOWN'
}

/**
 * RewardInput defines what the customer receives. Either a basket-level
 * discount or a fee waiver.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RewardInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RewardInput';
  /** A discount applied to the customer's basket (dollar off, percentage off, or credit back). */
  basket?: Maybe<Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput>;
  /** A fee waiver (delivery, pickup, service, or priority fee). */
  fee?: Maybe<Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput>;
  /** A product-level reward (discount on products, set price for products, or free product). */
  product?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardInput>;
};

/**
 * RewardInput defines what the customer receives. Either a basket-level
 * discount or a fee waiver.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RewardInput_Input = {
  /** A discount applied to the customer's basket (dollar off, percentage off, or credit back). */
  basket?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_BasketRewardInput_Input>;
  /** A fee waiver (delivery, pickup, service, or priority fee). */
  fee?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_FeeRewardInput_Input>;
  /** A product-level reward (discount on products, set price for products, or free product). */
  product?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ProductRewardInput_Input>;
};

/**
 * RoulettePrecondition defines a prerequisite Roulette feature that must be assigned
 * before this experiment is evaluated. Used to chain experiments or gate on feature flags.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition = {
  __typename?: 'instacart_growth_marketing_tooling_v1_RoulettePrecondition';
  /**
   * Optional list of variant names that must be assigned for the precondition to pass.
   * If empty, the precondition passes if the feature is assigned to any variant.
   */
  allowedVariants?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UUID of the prerequisite Roulette feature. */
  featureUuid?: Maybe<Scalars['String']>;
};

/**
 * RoulettePrecondition defines a prerequisite Roulette feature that must be assigned
 * before this experiment is evaluated. Used to chain experiments or gate on feature flags.
 */
export type Instacart_Growth_Marketing_Tooling_V1_RoulettePrecondition_Input = {
  /**
   * Optional list of variant names that must be assigned for the precondition to pass.
   * If empty, the precondition passes if the feature is assigned to any variant.
   */
  allowedVariants?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UUID of the prerequisite Roulette feature. */
  featureUuid?: InputMaybe<Scalars['String']>;
};

/**
 * Stackability controls whether the offer can stack with other offers.
 * Numeric values match the downstream commerce_discount OfferStackability
 * enum so symbolic and positional translations both produce correct results.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_Stackability {
  /**
   * Always stackable regardless of other offers' stackability settings.
   * Admin-only: surfaced in the API for completeness; non-admin callers
   * must not set this and downstream gating will reject it.
   */
  StackabilityAlwaysStackable = 'STACKABILITY_ALWAYS_STACKABLE',
  StackabilityNonStackable = 'STACKABILITY_NON_STACKABLE',
  StackabilityStackable = 'STACKABILITY_STACKABLE',
  StackabilityUnknown = 'STACKABILITY_UNKNOWN'
}

/**
 * Targeting defines the audience criteria for a campaign, specifying which users
 * should be eligible to receive it based on geography and behavioral segments.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Targeting = {
  __typename?: 'instacart_growth_marketing_tooling_v1_Targeting';
  /**
   * Geographic regions where this campaign is active (e.g., specific metro areas, states).
   * Region IDs correspond to Instacart's internal region taxonomy.
   */
  regionIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /**
   * Audience segment definition from TaaS (Targeting as a Service).
   * Defines behavioral, demographic, or transactional criteria for user selection.
   */
  targetingSegment?: Maybe<Instacart_Ads_Platform_Taas_V1_SegmentState>;
};

/**
 * Targeting defines the audience criteria for a campaign, specifying which users
 * should be eligible to receive it based on geography and behavioral segments.
 */
export type Instacart_Growth_Marketing_Tooling_V1_Targeting_Input = {
  /**
   * Geographic regions where this campaign is active (e.g., specific metro areas, states).
   * Region IDs correspond to Instacart's internal region taxonomy.
   */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /**
   * Audience segment definition from TaaS (Targeting as a Service).
   * Defines behavioral, demographic, or transactional criteria for user selection.
   */
  targetingSegment?: InputMaybe<Instacart_Ads_Platform_Taas_V1_SegmentState_Input>;
};

/** TaskRequiredRequirementInput requires the customer to complete a specific task. */
export type Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_TaskRequiredRequirementInput';
  /** Identifier of the task the customer must complete. */
  taskId?: Maybe<Scalars['String']>;
  /** Task-specific parameters passed to the task handler. */
  taskParams?: Maybe<Scalars['JSON']>;
};

/** TaskRequiredRequirementInput requires the customer to complete a specific task. */
export type Instacart_Growth_Marketing_Tooling_V1_TaskRequiredRequirementInput_Input = {
  /** Identifier of the task the customer must complete. */
  taskId?: InputMaybe<Scalars['String']>;
  /** Task-specific parameters passed to the task handler. */
  taskParams?: InputMaybe<Scalars['JSON']>;
};

/**
 * UpdateMarketingCampaignRequest updates an existing marketing campaign and its associated
 * entities. The campaign is identified by campaign_id; the marketing_campaign payload
 * carries the desired new state. The orchestrator captures the prior state of every entity
 * it mutates so a downstream failure can roll back the saga via LIFO compensation.
 */
export type Instacart_Growth_Marketing_Tooling_V1_UpdateMarketingCampaignRequest_Input = {
  /**
   * Authorization context of the user updating the campaign.
   * Ensures the user has permission to update campaigns for the specified retailers.
   */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The unique identifier of the campaign to update. */
  campaignId?: InputMaybe<Scalars['BigInt']>;
  /**
   * The desired new state of the campaign. Any fields populated here are propagated to
   * the corresponding downstream systems. The id field on this payload is ignored;
   * campaign_id is authoritative.
   */
  marketingCampaign?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign_Input>;
  /**
   * When true, resume the campaign after updating the redemption limit on offers.
   * Only takes effect when the campaign is in PAUSED_BY_GLOBAL_REDEMPTION_LIMIT status.
   * Mutually exclusive with `status`; setting both returns an error.
   */
  resumeAfterRedemptionLimitIncrease?: InputMaybe<Scalars['Boolean']>;
};

/**
 * UpdateMarketingCampaignResponse returns the updated campaign with all system-generated
 * fields refreshed, along with status information about the operation.
 */
export type Instacart_Growth_Marketing_Tooling_V1_UpdateMarketingCampaignResponse = {
  __typename?: 'instacart_growth_marketing_tooling_v1_UpdateMarketingCampaignResponse';
  /**
   * The updated campaign with all fields populated post-update.
   * Will be null/empty if the update failed and rollback restored prior state.
   */
  marketingCampaign?: Maybe<Instacart_Growth_Marketing_Tooling_V1_MarketingCampaign>;
  /** Status indicating whether the update succeeded or failed, with error details if applicable. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/**
 * UserScope identifies whether the requesting actor is internal to Instacart
 * or an external retailer/partner.
 */
export enum Instacart_Growth_Marketing_Tooling_V1_UserScope {
  /** External retailer/partner actor. */
  UserScopeExternal = 'USER_SCOPE_EXTERNAL',
  /** Internal Instacart actor. */
  UserScopeInternal = 'USER_SCOPE_INTERNAL',
  /** Scope was not resolved. */
  UserScopeUnknown = 'USER_SCOPE_UNKNOWN'
}

/** UtmParamsInput defines UTM tracking parameters for offer attribution. */
export type Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput = {
  __typename?: 'instacart_growth_marketing_tooling_v1_UtmParamsInput';
  /** UTM campaign values for campaign-level attribution. */
  campaign?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM content values for creative-level attribution. */
  content?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM medium values (e.g., "email", "social"). */
  medium?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM source values (e.g., "newsletter", "facebook"). */
  source?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** UTM term values for keyword-level attribution. */
  term?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** UtmParamsInput defines UTM tracking parameters for offer attribution. */
export type Instacart_Growth_Marketing_Tooling_V1_UtmParamsInput_Input = {
  /** UTM campaign values for campaign-level attribution. */
  campaign?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM content values for creative-level attribution. */
  content?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM medium values (e.g., "email", "social"). */
  medium?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM source values (e.g., "newsletter", "facebook"). */
  source?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** UTM term values for keyword-level attribution. */
  term?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * CampaignBrief is the marketer-facing workflow object that precedes and surrounds
 * downstream campaign creation: target audience, offer/treatment intent, channel
 * execution plan, approval/publish state, and correlation/audit identity. It is not
 * a Campaigns Domain serving record; downstream systems keep owning their domain
 * records after the brief is built, approved, launched, or synced.
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief = {
  __typename?: 'instacart_growth_unified_marketing_backend_v1_CampaignBrief';
  /** Output-only. UMB orchestration identifier. Auto-generated on creation. */
  campaignBriefId?: Maybe<Scalars['String']>;
  /** Source client that created this brief (IPP, Saffron/CRMS, Connect). */
  campaignBriefSource?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefSource>;
  /**
   * Campaigns Domain identifier once this brief has been created or synced
   * downstream. Unset while the brief is in DRAFT/TEST/PENDING_APPROVAL.
   */
  campaignId?: Maybe<Scalars['BigInt']>;
  /** Sandbox, creator-scoped, audience-of-one, retailer-scoped, or auto-approval cohort. */
  cohortScope?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CohortScope>;
  /**
   * Full campaign configuration: schedule, distribution channels,
   * discoverability, treatment config, and downstream execution parameters.
   */
  configuration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration>;
  /** Retailer/store/country scope. */
  context?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CampaignContext>;
  /** End-to-end trace ID across UMB and downstream services. */
  correlationId?: Maybe<Scalars['String']>;
  /** Output-only. UTC timestamp when the brief was first created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Channel execution plan. */
  crmConfiguration?: Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration>;
  /**
   * Follow-up CRM steps for a non-experiment brief. The primary
   * crm_configuration remains Message 1. Campaigns Domain still joins only
   * the initial IntentionConfiguration.
   */
  crmSequenceSteps?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep>>>;
  crmVariantConfigurations?: Maybe<Array<Maybe<Instacart_Growth_Marketing_Tooling_V1_CrmVariantConfiguration>>>;
  /** A/B variant configuration. */
  experiment?: Maybe<Instacart_Growth_Marketing_Tooling_V1_Experiment>;
  /**
   * Output-only. Approval gate handle while pending. Set by the approval gating system;
   * not writable by clients.
   */
  hitlRequestId?: Maybe<Scalars['String']>;
  /** Human-readable name for this brief. */
  name?: Maybe<Scalars['String']>;
  /** Offer/treatment intent: reward, requirements, redemption, and budget. */
  offer?: Maybe<Instacart_Growth_Marketing_Tooling_V1_OfferInput>;
  /** Reporting and attribution metadata. */
  reporting?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput>;
  /** Freeform metadata for the source client's own use. Not interpreted by UMB. */
  sourceMetadata?: Maybe<Scalars['JSON']>;
  /**
   * Current lifecycle state. On InitializeCampaignBrief this field is
   * output-only; the initial state is controlled by initial_state on the
   * request. On UpdateCampaignBrief this field is ignored — state changes
   * must go through TransitionCampaignBrief.
   */
  state?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefState>;
  /** Audience criteria. */
  targeting?: Maybe<Instacart_Growth_Marketing_Tooling_V1_Targeting>;
  /**
   * Output-only. Actor that performed the most recent state transition.
   * Derived from the authorization_context on each mutating request.
   */
  transitionedBy?: Maybe<Scalars['String']>;
  /** Output-only. UTC timestamp when the brief was last modified. */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** CampaignBriefFilters defines optional filters for listing campaign briefs. */
export type Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefFilters_Input = {
  /** Filter by cohort scope. */
  cohortScopes?: InputMaybe<Array<InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CohortScope>>>;
  /**
   * Created-within window: briefs with created_at >= created_after and
   * created_at < created_before. Either bound may be omitted.
   */
  createdAfter?: InputMaybe<Scalars['DateTime']>;
  createdBefore?: InputMaybe<Scalars['DateTime']>;
  /** Filter by the internal actor id of the brief creator. */
  createdByActorId?: InputMaybe<Scalars['BigInt']>;
  /** Filter by retailer IDs. */
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Search value for text-based search across brief fields (e.g., name). */
  searchValue?: InputMaybe<Scalars['String']>;
  /** Filter by lifecycle state. */
  states?: InputMaybe<Array<InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefState>>>;
  /**
   * Updated-within window: briefs with updated_at >= updated_after and
   * updated_at < updated_before. Either bound may be omitted.
   */
  updatedAfter?: InputMaybe<Scalars['DateTime']>;
  updatedBefore?: InputMaybe<Scalars['DateTime']>;
};

/** CampaignBriefSource identifies which source client created the brief. */
export enum Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefSource {
  CampaignBriefSourceConnect = 'CAMPAIGN_BRIEF_SOURCE_CONNECT',
  CampaignBriefSourceIpp = 'CAMPAIGN_BRIEF_SOURCE_IPP',
  CampaignBriefSourceSaffronCrms = 'CAMPAIGN_BRIEF_SOURCE_SAFFRON_CRMS',
  CampaignBriefSourceUnknown = 'CAMPAIGN_BRIEF_SOURCE_UNKNOWN'
}

/**
 * CampaignBriefState is the brief lifecycle: creation (DRAFT), submission
 * review (PROPOSAL_REVIEW, CHANGES_REQUESTED, PENDING_APPROVAL), planning
 * (APPROVED, CAMPAIGN_DRAFT), build and QA (BUILDING, TEST,
 * QA_CHANGES_REQUESTED, FAILED), delivery (SCHEDULED, LIVE, LAUNCHED), and
 * completion (COMPLETED, ARCHIVED). CANCELLED is reachable from any
 * non-terminal state.
 *
 * PUBLISHED is retained for wire compatibility; briefs use SCHEDULED, LIVE,
 * and LAUNCHED for delivery instead. PAUSED and ROLLBACK_REQUESTED are
 * reserved for future use.
 */
export enum Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefState {
  CampaignBriefStateApproved = 'CAMPAIGN_BRIEF_STATE_APPROVED',
  CampaignBriefStateArchived = 'CAMPAIGN_BRIEF_STATE_ARCHIVED',
  CampaignBriefStateBuilding = 'CAMPAIGN_BRIEF_STATE_BUILDING',
  CampaignBriefStateCampaignDraft = 'CAMPAIGN_BRIEF_STATE_CAMPAIGN_DRAFT',
  CampaignBriefStateCancelled = 'CAMPAIGN_BRIEF_STATE_CANCELLED',
  CampaignBriefStateChangesRequested = 'CAMPAIGN_BRIEF_STATE_CHANGES_REQUESTED',
  CampaignBriefStateCompleted = 'CAMPAIGN_BRIEF_STATE_COMPLETED',
  CampaignBriefStateDraft = 'CAMPAIGN_BRIEF_STATE_DRAFT',
  CampaignBriefStateFailed = 'CAMPAIGN_BRIEF_STATE_FAILED',
  CampaignBriefStateLaunched = 'CAMPAIGN_BRIEF_STATE_LAUNCHED',
  CampaignBriefStateLive = 'CAMPAIGN_BRIEF_STATE_LIVE',
  CampaignBriefStatePaused = 'CAMPAIGN_BRIEF_STATE_PAUSED',
  CampaignBriefStatePendingApproval = 'CAMPAIGN_BRIEF_STATE_PENDING_APPROVAL',
  CampaignBriefStateProposalReview = 'CAMPAIGN_BRIEF_STATE_PROPOSAL_REVIEW',
  CampaignBriefStatePublished = 'CAMPAIGN_BRIEF_STATE_PUBLISHED',
  CampaignBriefStateQaChangesRequested = 'CAMPAIGN_BRIEF_STATE_QA_CHANGES_REQUESTED',
  CampaignBriefStateRejected = 'CAMPAIGN_BRIEF_STATE_REJECTED',
  CampaignBriefStateRollbackRequested = 'CAMPAIGN_BRIEF_STATE_ROLLBACK_REQUESTED',
  CampaignBriefStateScheduled = 'CAMPAIGN_BRIEF_STATE_SCHEDULED',
  CampaignBriefStateTest = 'CAMPAIGN_BRIEF_STATE_TEST',
  CampaignBriefStateUnknown = 'CAMPAIGN_BRIEF_STATE_UNKNOWN'
}

/**
 * CampaignBrief is the marketer-facing workflow object that precedes and surrounds
 * downstream campaign creation: target audience, offer/treatment intent, channel
 * execution plan, approval/publish state, and correlation/audit identity. It is not
 * a Campaigns Domain serving record; downstream systems keep owning their domain
 * records after the brief is built, approved, launched, or synced.
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief_Input = {
  /** Output-only. UMB orchestration identifier. Auto-generated on creation. */
  campaignBriefId?: InputMaybe<Scalars['String']>;
  /** Source client that created this brief (IPP, Saffron/CRMS, Connect). */
  campaignBriefSource?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefSource>;
  /**
   * Campaigns Domain identifier once this brief has been created or synced
   * downstream. Unset while the brief is in DRAFT/TEST/PENDING_APPROVAL.
   */
  campaignId?: InputMaybe<Scalars['BigInt']>;
  /** Sandbox, creator-scoped, audience-of-one, retailer-scoped, or auto-approval cohort. */
  cohortScope?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CohortScope>;
  /**
   * Full campaign configuration: schedule, distribution channels,
   * discoverability, treatment config, and downstream execution parameters.
   */
  configuration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignConfiguration_Input>;
  /** Retailer/store/country scope. */
  context?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignContext_Input>;
  /** End-to-end trace ID across UMB and downstream services. */
  correlationId?: InputMaybe<Scalars['String']>;
  /** Output-only. UTC timestamp when the brief was first created. */
  createdAt?: InputMaybe<Scalars['DateTime']>;
  /** Channel execution plan. */
  crmConfiguration?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmConfiguration_Input>;
  /**
   * Follow-up CRM steps for a non-experiment brief. The primary
   * crm_configuration remains Message 1. Campaigns Domain still joins only
   * the initial IntentionConfiguration.
   */
  crmSequenceSteps?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmSequenceStep_Input>>>;
  crmVariantConfigurations?: InputMaybe<Array<InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CrmVariantConfiguration_Input>>>;
  /** A/B variant configuration. */
  experiment?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Experiment_Input>;
  /**
   * Output-only. Approval gate handle while pending. Set by the approval gating system;
   * not writable by clients.
   */
  hitlRequestId?: InputMaybe<Scalars['String']>;
  /** Human-readable name for this brief. */
  name?: InputMaybe<Scalars['String']>;
  /** Offer/treatment intent: reward, requirements, redemption, and budget. */
  offer?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_OfferInput_Input>;
  /** Reporting and attribution metadata. */
  reporting?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_ReportingInput_Input>;
  /** Freeform metadata for the source client's own use. Not interpreted by UMB. */
  sourceMetadata?: InputMaybe<Scalars['JSON']>;
  /**
   * Current lifecycle state. On InitializeCampaignBrief this field is
   * output-only; the initial state is controlled by initial_state on the
   * request. On UpdateCampaignBrief this field is ignored — state changes
   * must go through TransitionCampaignBrief.
   */
  state?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefState>;
  /** Audience criteria. */
  targeting?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_Targeting_Input>;
  /**
   * Output-only. Actor that performed the most recent state transition.
   * Derived from the authorization_context on each mutating request.
   */
  transitionedBy?: InputMaybe<Scalars['String']>;
  /** Output-only. UTC timestamp when the brief was last modified. */
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

/**
 * CohortScope defines who/what a campaign brief is currently scoped to reach,
 * from sandbox testing through full retailer-scoped publish.
 */
export enum Instacart_Growth_Unified_Marketing_Backend_V1_CohortScope {
  CohortScopeAudienceOfOne = 'COHORT_SCOPE_AUDIENCE_OF_ONE',
  CohortScopeAutoApproval = 'COHORT_SCOPE_AUTO_APPROVAL',
  CohortScopeCreatorScoped = 'COHORT_SCOPE_CREATOR_SCOPED',
  CohortScopeRetailerScoped = 'COHORT_SCOPE_RETAILER_SCOPED',
  CohortScopeSandbox = 'COHORT_SCOPE_SANDBOX',
  CohortScopeUnknown = 'COHORT_SCOPE_UNKNOWN'
}

/**
 * GetCampaignBriefRequest retrieves a campaign brief by either its brief ID or
 * its downstream Campaigns Domain campaign ID.
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_GetCampaignBriefRequest_Input = {
  /** Authorization context of the user requesting the brief. */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The unique identifier of the brief to retrieve. */
  campaignBriefId?: InputMaybe<Scalars['String']>;
  /**
   * The Campaigns Domain campaign identifier; resolves to the brief whose
   * campaigns_domain_id matches.
   */
  campaignId?: InputMaybe<Scalars['BigInt']>;
};

/** GetCampaignBriefResponse returns the requested brief. */
export type Instacart_Growth_Unified_Marketing_Backend_V1_GetCampaignBriefResponse = {
  __typename?: 'instacart_growth_unified_marketing_backend_v1_GetCampaignBriefResponse';
  /** The retrieved brief. Will be null/empty if not found or not authorized. */
  campaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief>;
  /** Status indicating success or failure, with error details if applicable. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/**
 * InitializeCampaignBriefRequest creates a new campaign brief and places it at
 * the requested initial state. Downstream entity provisioning (retailer
 * campaign, TaaS segment, VGP entry, Roulette feature, CRM intention config)
 * is performed atomically as part of the call whenever the initial state is
 * not CAMPAIGN_BRIEF_STATE_DRAFT.
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_InitializeCampaignBriefRequest_Input = {
  /** Authorization context of the user creating the brief. */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /**
   * Brief definition to create. Output-only fields on this message are ignored:
   * campaign_brief_id (auto-generated), state (see initial_state),
   * hitl_request_id, transitioned_by, created_at, updated_at.
   */
  campaignBrief?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief_Input>;
  /**
   * The state at which to place the new brief. Must be one of:
   * CAMPAIGN_BRIEF_STATE_DRAFT
   * CAMPAIGN_BRIEF_STATE_TEST
   * CAMPAIGN_BRIEF_STATE_PENDING_APPROVAL
   * CAMPAIGN_BRIEF_STATE_PUBLISHED
   * Any other enum value (including UNKNOWN) is rejected with INVALID_ARGUMENT.
   */
  initialState?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefState>;
};

/**
 * InitializeCampaignBriefResponse returns the persisted brief after the
 * initialization Saga completes.
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_InitializeCampaignBriefResponse = {
  __typename?: 'instacart_growth_unified_marketing_backend_v1_InitializeCampaignBriefResponse';
  /**
   * The persisted brief with all fields populated post-initialization,
   * including auto-generated identifiers and downstream correlation IDs
   * (campaign_id, and any additional linkage set on the campaign_briefs row).
   */
  campaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief>;
  /**
   * Success/error details; on failure, no brief row is persisted and any
   * partially-provisioned downstream entities are rolled back.
   */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/** ListCampaignBriefsRequest retrieves a paginated list of campaign briefs. */
export type Instacart_Growth_Unified_Marketing_Backend_V1_ListCampaignBriefsRequest_Input = {
  /** Authorization context of the user requesting the briefs. */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /**
   * Campaign-domain filters. When present, listing starts from Campaigns and
   * returns only provisioned briefs backed by matching retailer campaigns.
   */
  campaignFilters?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_CampaignFilters_Input>;
  /** Filters to apply when listing locally persisted briefs. */
  filters?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefFilters_Input>;
  /** Ordering parameters for the results. */
  order?: InputMaybe<Instacart_Customers_Shared_V1_Order_Input>;
  /** Pagination parameters for the request. */
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
};

/** ListCampaignBriefsResponse returns a paginated list of campaign briefs. */
export type Instacart_Growth_Unified_Marketing_Backend_V1_ListCampaignBriefsResponse = {
  __typename?: 'instacart_growth_unified_marketing_backend_v1_ListCampaignBriefsResponse';
  /** List of briefs matching the filter criteria. */
  campaignBriefs?: Maybe<Array<Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief>>>;
  /** Pagination info for navigating results. */
  pageInfo?: Maybe<InstacartCustomersSharedV1PageInfo>;
  /** Status indicating success or failure with error details. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
  /** Total count of briefs matching the filter criteria (before pagination). */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/**
 * TransitionCampaignBriefRequest advances an existing brief to a new state.
 * The transition must be forward in the CampaignBrief state machine, with
 * CAMPAIGN_BRIEF_STATE_CANCELLED reachable from any non-terminal state (and
 * from PUBLISHED).
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_TransitionCampaignBriefRequest_Input = {
  /** Authorization context of the user performing the transition. */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The unique identifier of the brief to transition. */
  campaignBriefId?: InputMaybe<Scalars['String']>;
  /**
   * Additional data specific to the requested state transition. Keys are
   * interpreted per target state; unknown keys are ignored.
   */
  stateMeta?: InputMaybe<Scalars['JSON']>;
  /**
   * The requested new state. Target ordinal must be strictly greater than the
   * current state's ordinal (skips are legal), or CAMPAIGN_BRIEF_STATE_CANCELLED.
   */
  targetState?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBriefState>;
  /**
   * Optional free-text reason accompanying the transition. Stored on the row
   * for audit. May be required in a future revision for approver-facing
   * transitions (e.g. explicit rejection notes).
   */
  transitionReason?: InputMaybe<Scalars['String']>;
};

/**
 * TransitionCampaignBriefResponse returns the brief after the transition Saga
 * completes.
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_TransitionCampaignBriefResponse = {
  __typename?: 'instacart_growth_unified_marketing_backend_v1_TransitionCampaignBriefResponse';
  /**
   * The brief after transition, with updated state, transitioned_by, and any
   * downstream correlation identifiers set during Saga execution.
   */
  campaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief>;
  /**
   * Success/error details. On failure, the brief remains at its prior state
   * and any partially-provisioned or partially-torn-down entities are rolled
   * back.
   */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/**
 * UpdateCampaignBriefRequest updates mutable fields on an existing brief
 * WITHOUT changing its state. The brief is identified by campaign_brief_id;
 * the campaign_brief_id on the payload is ignored. State changes are NOT
 * permitted through this RPC and must go through TransitionCampaignBrief;
 * the state field on the payload is ignored, and a field_mask that includes
 * "state" is rejected with INVALID_ARGUMENT.
 *
 * Output-only fields in campaign_brief are ignored: campaign_brief_id,
 * state, hitl_request_id, transitioned_by, created_at, updated_at. Mutable
 * fields depend on lifecycle position (see design doc §6.3).
 */
export type Instacart_Growth_Unified_Marketing_Backend_V1_UpdateCampaignBriefRequest_Input = {
  /** Authorization context of the user updating the brief. */
  authorizationContext?: InputMaybe<Instacart_Growth_Marketing_Tooling_V1_AuthorizationContext_Input>;
  /** The desired new field values. */
  campaignBrief?: InputMaybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief_Input>;
  /** The unique identifier of the brief to update. */
  campaignBriefId?: InputMaybe<Scalars['String']>;
  /**
   * Patch mask controlling which fields are applied. When set, only the listed
   * field paths are written to the stored brief; omitted paths are left unchanged
   * (patch semantics). When unset, all mutable fields on campaign_brief are
   * applied (full-replace semantics). Output-only fields are always ignored
   * regardless of whether they appear in the mask. If the mask includes
   * "state", the request is rejected with INVALID_ARGUMENT.
   */
  fieldMask?: InputMaybe<Google_Protobuf_FieldMask_Input>;
};

/** UpdateCampaignBriefResponse returns the updated brief. */
export type Instacart_Growth_Unified_Marketing_Backend_V1_UpdateCampaignBriefResponse = {
  __typename?: 'instacart_growth_unified_marketing_backend_v1_UpdateCampaignBriefResponse';
  /** The updated brief with all fields populated post-update. */
  campaignBrief?: Maybe<Instacart_Growth_Unified_Marketing_Backend_V1_CampaignBrief>;
  /** Status indicating whether the update succeeded or failed, with error details if applicable. */
  status?: Maybe<Instacart_Growth_Marketing_Tooling_V1_ResponseStatus>;
};

/** Request to create a new module */
export type Instacart_Infra_Instaform_V1_CreateModuleRequest_Input = {
  billTo?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  environment?: InputMaybe<Scalars['String']>;
  keyValuePair?: InputMaybe<Array<InputMaybe<Instacart_Infra_Instaform_V1_KeyValuePair_Input>>>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  /** time when the user started creating a module in ISO 8601 format */
  startedAt?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
  totemSystem?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Instacart_Infra_Instaform_V1_ModuleType>;
};

/** Success if module creation is successful */
export type Instacart_Infra_Instaform_V1_CreateModuleResponse = {
  __typename?: 'instacart_infra_instaform_v1_CreateModuleResponse';
  errorMessage?: Maybe<Scalars['String']>;
  moduleId?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Request to fetch module by module id or module_name */
export type Instacart_Infra_Instaform_V1_GetModuleByNameRequest_Input = {
  moduleName?: InputMaybe<Scalars['String']>;
};

/** Returns Success if module creation is successful */
export type Instacart_Infra_Instaform_V1_GetModuleByNameResponse = {
  __typename?: 'instacart_infra_instaform_v1_GetModuleByNameResponse';
  module?: Maybe<Instacart_Infra_Instaform_V1_Module>;
};

/** Request to fetch module based on name, environment or team */
export type Instacart_Infra_Instaform_V1_GetModulesRequest_Input = {
  environment?: InputMaybe<Scalars['String']>;
  moduleName?: InputMaybe<Scalars['String']>;
  team?: InputMaybe<Scalars['String']>;
};

/** Response list of modules */
export type Instacart_Infra_Instaform_V1_GetModulesResponse = {
  __typename?: 'instacart_infra_instaform_v1_GetModulesResponse';
  modules?: Maybe<Array<Maybe<Instacart_Infra_Instaform_V1_Module>>>;
};

/** Key value pair collected from UI */
export type Instacart_Infra_Instaform_V1_KeyValuePair_Input = {
  elementKey?: InputMaybe<Scalars['String']>;
  elementValue?: InputMaybe<Scalars['String']>;
};

/** Module definition to fetch from backend */
export type Instacart_Infra_Instaform_V1_Module = {
  __typename?: 'instacart_infra_instaform_v1_Module';
  billTo?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Instacart_Infra_Instaform_V1_User>;
  description?: Maybe<Scalars['String']>;
  environment?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Infra_Instaform_V1_Module_ModuleStatus>;
  team?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Infra_Instaform_V1_ModuleType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Instacart_Infra_Instaform_V1_User>;
  version?: Maybe<Scalars['String']>;
};

/** List of supported Module types */
export enum Instacart_Infra_Instaform_V1_ModuleType {
  ModuleTypePbi = 'MODULE_TYPE_PBI',
  ModuleTypeRds = 'MODULE_TYPE_RDS',
  ModuleTypeRdsSharded = 'MODULE_TYPE_RDS_SHARDED',
  ModuleTypeS3 = 'MODULE_TYPE_S3',
  ModuleTypeUnknown = 'MODULE_TYPE_UNKNOWN'
}

export enum Instacart_Infra_Instaform_V1_Module_ModuleStatus {
  ModuleStatusActive = 'MODULE_STATUS_ACTIVE',
  ModuleStatusCreating = 'MODULE_STATUS_CREATING',
  ModuleStatusDeleted = 'MODULE_STATUS_DELETED',
  ModuleStatusDeleting = 'MODULE_STATUS_DELETING',
  ModuleStatusInactive = 'MODULE_STATUS_INACTIVE',
  ModuleStatusLocking = 'MODULE_STATUS_LOCKING',
  ModuleStatusUnknown = 'MODULE_STATUS_UNKNOWN',
  ModuleStatusUpdating = 'MODULE_STATUS_UPDATING'
}

/** Info about instaform users */
export type Instacart_Infra_Instaform_V1_User = {
  __typename?: 'instacart_infra_instaform_v1_User';
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** Contact details for a team/user */
export type Instacart_Infra_Totem_V1_ContactDetails = {
  __typename?: 'instacart_infra_totem_v1_ContactDetails';
  alert_slack_channels?: Maybe<Instacart_Infra_Totem_V1_SlackChannelList>;
  email?: Maybe<Scalars['String']>;
  general_slack_channels?: Maybe<Instacart_Infra_Totem_V1_SlackChannelList>;
  jira_issue_fields?: Maybe<Instacart_Infra_Totem_V1_JiraIssueFields>;
  linear_team?: Maybe<Instacart_Infra_Totem_V1_LinearTeam>;
  name?: Maybe<Scalars['String']>;
  oncall_slack_group?: Maybe<Instacart_Infra_Totem_V1_SlackChannel>;
  opsgenie_responder?: Maybe<Instacart_Infra_Totem_V1_OpsgenieResponder>;
};

export enum Instacart_Infra_Totem_V1_EmploymentType {
  EmploymentTypeAgencyContractor = 'EMPLOYMENT_TYPE_AGENCY_CONTRACTOR',
  EmploymentTypeDirectEngagedContractor = 'EMPLOYMENT_TYPE_DIRECT_ENGAGED_CONTRACTOR',
  EmploymentTypeFullTimeEmployee = 'EMPLOYMENT_TYPE_FULL_TIME_EMPLOYEE',
  EmploymentTypeIndependentConsultant = 'EMPLOYMENT_TYPE_INDEPENDENT_CONSULTANT',
  EmploymentTypeUnknown = 'EMPLOYMENT_TYPE_UNKNOWN',
  EmploymentTypeVendor = 'EMPLOYMENT_TYPE_VENDOR'
}

/** Entity details */
export type Instacart_Infra_Totem_V1_Entity = {
  __typename?: 'instacart_infra_totem_v1_Entity';
  created_at?: Maybe<Scalars['DateTime']>;
  external_id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  system_name?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Infra_Totem_V1_EntityType>;
  typed_metadata?: Maybe<Scalars['JSON']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

/** Information describing the type of entity */
export type Instacart_Infra_Totem_V1_EntityType = {
  __typename?: 'instacart_infra_totem_v1_EntityType';
  display_name?: Maybe<Scalars['String']>;
  is_totem_managed?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  ownership_policies?: Maybe<Array<Maybe<Instacart_Infra_Totem_V1_OwnershipPolicy>>>;
  /** The name of the entity relationship type for the entity that the system is inherited from */
  system_inheritance_relationship_type?: Maybe<Scalars['String']>;
};

/** Request the Entity with a given name */
export type Instacart_Infra_Totem_V1_GetEntityRequest_Input = {
  external_id?: InputMaybe<Scalars['String']>;
  type_name?: InputMaybe<Scalars['String']>;
};

/** The returned Entity */
export type Instacart_Infra_Totem_V1_GetEntityResponse = {
  __typename?: 'instacart_infra_totem_v1_GetEntityResponse';
  entity?: Maybe<Instacart_Infra_Totem_V1_Entity>;
};

/** Request the System with a given name */
export type Instacart_Infra_Totem_V1_GetSystemRequest_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** The returned System */
export type Instacart_Infra_Totem_V1_GetSystemResponse = {
  __typename?: 'instacart_infra_totem_v1_GetSystemResponse';
  system?: Maybe<Instacart_Infra_Totem_V1_System>;
};

/** Information related to a JIRA issue */
export type Instacart_Infra_Totem_V1_JiraIssueFields = {
  __typename?: 'instacart_infra_totem_v1_JiraIssueFields';
  assignee?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Maybe<Scalars['String']>>>;
  project?: Maybe<Instacart_Infra_Totem_V1_JiraProject>;
};

/** JIRA project information */
export type Instacart_Infra_Totem_V1_JiraProject = {
  __typename?: 'instacart_infra_totem_v1_JiraProject';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  valid_components?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Linear team information */
export type Instacart_Infra_Totem_V1_LinearTeam = {
  __typename?: 'instacart_infra_totem_v1_LinearTeam';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum Instacart_Infra_Totem_V1_ManagementLevel {
  ManagementLevelDirector = 'MANAGEMENT_LEVEL_DIRECTOR',
  ManagementLevelExecutive = 'MANAGEMENT_LEVEL_EXECUTIVE',
  ManagementLevelIndividualContributor = 'MANAGEMENT_LEVEL_INDIVIDUAL_CONTRIBUTOR',
  ManagementLevelManager = 'MANAGEMENT_LEVEL_MANAGER',
  ManagementLevelSeniorDirector = 'MANAGEMENT_LEVEL_SENIOR_DIRECTOR',
  ManagementLevelSeniorManager = 'MANAGEMENT_LEVEL_SENIOR_MANAGER',
  ManagementLevelUnknown = 'MANAGEMENT_LEVEL_UNKNOWN',
  ManagementLevelVicePresident = 'MANAGEMENT_LEVEL_VICE_PRESIDENT'
}

export enum Instacart_Infra_Totem_V1_OpsgeniePriority {
  OpsgeniePriorityP1 = 'OPSGENIE_PRIORITY_P1',
  OpsgeniePriorityP2 = 'OPSGENIE_PRIORITY_P2',
  OpsgeniePriorityP3 = 'OPSGENIE_PRIORITY_P3',
  OpsgeniePriorityP4 = 'OPSGENIE_PRIORITY_P4',
  OpsgeniePriorityP5 = 'OPSGENIE_PRIORITY_P5',
  OpsgeniePriorityUnknown = 'OPSGENIE_PRIORITY_UNKNOWN'
}

/** Information to find the responder in Opsgenie */
export type Instacart_Infra_Totem_V1_OpsgenieResponder = {
  __typename?: 'instacart_infra_totem_v1_OpsgenieResponder';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Instacart_Infra_Totem_V1_OpsgeniePriority>;
  type?: Maybe<Instacart_Infra_Totem_V1_OpsgenieResponderType>;
};

export enum Instacart_Infra_Totem_V1_OpsgenieResponderType {
  OpsgenieResponderTypeEscalation = 'OPSGENIE_RESPONDER_TYPE_ESCALATION',
  OpsgenieResponderTypeSchedule = 'OPSGENIE_RESPONDER_TYPE_SCHEDULE',
  OpsgenieResponderTypeTeam = 'OPSGENIE_RESPONDER_TYPE_TEAM',
  OpsgenieResponderTypeUnknown = 'OPSGENIE_RESPONDER_TYPE_UNKNOWN',
  OpsgenieResponderTypeUser = 'OPSGENIE_RESPONDER_TYPE_USER'
}

export enum Instacart_Infra_Totem_V1_OwnerType {
  OwnerTypeTeam = 'OWNER_TYPE_TEAM',
  OwnerTypeUnknown = 'OWNER_TYPE_UNKNOWN',
  OwnerTypeUser = 'OWNER_TYPE_USER'
}

/** An entity's ownership policy */
export type Instacart_Infra_Totem_V1_OwnershipPolicy = {
  __typename?: 'instacart_infra_totem_v1_OwnershipPolicy';
  name?: Maybe<Scalars['String']>;
  owner_type?: Maybe<Instacart_Infra_Totem_V1_OwnerType>;
  required_contact_fields?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Details to lookup a channel in Slack */
export type Instacart_Infra_Totem_V1_SlackChannel = {
  __typename?: 'instacart_infra_totem_v1_SlackChannel';
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Infra_Totem_V1_SlackChannelType>;
};

/** A list of SlackChannels */
export type Instacart_Infra_Totem_V1_SlackChannelList = {
  __typename?: 'instacart_infra_totem_v1_SlackChannelList';
  channels?: Maybe<Array<Maybe<Instacart_Infra_Totem_V1_SlackChannel>>>;
};

export enum Instacart_Infra_Totem_V1_SlackChannelType {
  SlackChannelTypePrivate = 'SLACK_CHANNEL_TYPE_PRIVATE',
  SlackChannelTypePublic = 'SLACK_CHANNEL_TYPE_PUBLIC',
  SlackChannelTypeUnknown = 'SLACK_CHANNEL_TYPE_UNKNOWN',
  SlackChannelTypeUser = 'SLACK_CHANNEL_TYPE_USER',
  SlackChannelTypeUserGroup = 'SLACK_CHANNEL_TYPE_USER_GROUP'
}

/** System details */
export type Instacart_Infra_Totem_V1_System = {
  __typename?: 'instacart_infra_totem_v1_System';
  contact_details?: Maybe<Instacart_Infra_Totem_V1_ContactDetails>;
  created_at?: Maybe<Scalars['DateTime']>;
  display_name?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  owner_team?: Maybe<Instacart_Infra_Totem_V1_Team>;
  owner_user?: Maybe<Instacart_Infra_Totem_V1_User>;
  typed_metadata?: Maybe<Scalars['JSON']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

/** Details related to a Team at instacart */
export type Instacart_Infra_Totem_V1_Team = {
  __typename?: 'instacart_infra_totem_v1_Team';
  cost_center?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['DateTime']>;
  default_contact_card_name?: Maybe<Scalars['String']>;
  default_system_name?: Maybe<Scalars['String']>;
  lead_username?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  parent_team_name?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Infra_Totem_V1_TeamStatus>;
  updated_at?: Maybe<Scalars['DateTime']>;
  workday_id?: Maybe<Scalars['String']>;
  workday_org_name?: Maybe<Scalars['String']>;
};

export enum Instacart_Infra_Totem_V1_TeamStatus {
  TeamStatusActive = 'TEAM_STATUS_ACTIVE',
  TeamStatusInactive = 'TEAM_STATUS_INACTIVE',
  TeamStatusUnknown = 'TEAM_STATUS_UNKNOWN'
}

/** Details of a user */
export type Instacart_Infra_Totem_V1_User = {
  __typename?: 'instacart_infra_totem_v1_User';
  created_at?: Maybe<Scalars['DateTime']>;
  default_system_name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  employment_type?: Maybe<Instacart_Infra_Totem_V1_EmploymentType>;
  first_name?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  github_username?: Maybe<Scalars['String']>;
  hire_date?: Maybe<Scalars['String']>;
  job_family?: Maybe<Scalars['String']>;
  job_title?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  management_level?: Maybe<Instacart_Infra_Totem_V1_ManagementLevel>;
  manager_username?: Maybe<Scalars['String']>;
  opsgenie_responder?: Maybe<Instacart_Infra_Totem_V1_OpsgenieResponder>;
  slack_channel?: Maybe<Instacart_Infra_Totem_V1_SlackChannel>;
  status?: Maybe<Instacart_Infra_Totem_V1_UserStatus>;
  team_name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['DateTime']>;
  username?: Maybe<Scalars['String']>;
  work_location?: Maybe<Scalars['String']>;
};

export enum Instacart_Infra_Totem_V1_UserStatus {
  UserStatusActive = 'USER_STATUS_ACTIVE',
  UserStatusInactive = 'USER_STATUS_INACTIVE',
  UserStatusUnknown = 'USER_STATUS_UNKNOWN'
}

export type Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestRequest_Input = {
  /** ID of the associated OpsEscalationRequest */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** contains all the required information to update a request note record */
  requestNote?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_AddRequestNoteToOpsEscalationRequestResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_AddRequestNoteToOpsEscalationRequestResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  requestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusRequest_Input = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  updateOpsEscalationRequestStatusRequests?: InputMaybe<Array<InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusRequest_Input>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_BulkUpdateOpsEscalationRequestStatusResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_BulkUpdateOpsEscalationRequestStatusResponse';
  /** Any error messages that occurred during the update */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether all operations succeeded or not */
  success?: Maybe<Scalars['Boolean']>;
};

/** attributes needed to create an OpsEscalationRequest record and its associated RequestNotes */
export type Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestInput_Input = {
  opsEscalationRequestInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestInput_Input>;
  requestNoteInputs?: InputMaybe<Array<InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsRequest_Input = {
  /** Array of objects with data for creating/updating an OpsEscalationRequest record and its associated request notes */
  opsEscalationRequests?: InputMaybe<Array<InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestInput_Input>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_CreateOpsEscalationRequestsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteRequest_Input = {
  /** Content of the request note */
  requestNoteInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInputData_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_CreateRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_CreateRequestNoteResponse';
  /** Any erors from the operation */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new request note */
  requestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>;
  /** Whether the create succeeded or not */
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesRequest_Input = {
  /** IDs of the request notes to be deleted */
  requestNoteIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestRequestNotesResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_DeleteOpsEscalationRequestRequestNotesResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsRequest_Input = {
  /** List of OpsEscalationRequest IDs to be deleted */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the DeleteOpsEscalationRequests request */
export type Instacart_Logistics_Marketplace_Ops_V1_DeleteOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_DeleteOpsEscalationRequestsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Did the operation succeed? */
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteRequest_Input = {
  /** IPP canonical ID of the person who created the request note. Must match to be ablet to delete the note. */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** ID of the note to delete */
  id?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_DeleteRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_DeleteRequestNoteResponse';
  /** Any erors from the operation */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Whether the delete succeeded or not */
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestRequest_Input = {
  /** ID of the OpsEscalationRequest to fetch. */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_GetOpsEscalationRequestResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_GetOpsEscalationRequestResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The OpsEscalationRequest data, returned if found. */
  opsEscalationRequest?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>;
};

/**
 * Request for listing duplicate OpsEscalationRequests based on matching by
 * multiple existing escalation request IDs
 */
export type Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsRequest_Input = {
  /** ID of the OpsEscalationRequest for which we are looking for duplicates */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the BulkListDuplicateOpsEscalationRequests request */
export type Instacart_Logistics_Marketplace_Ops_V1_ListBulkDuplicateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_ListBulkDuplicateOpsEscalationRequestsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** List of duplicate requests found per OpsEscalationRequest ID */
  opsEscalationRequestDuplicates?: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestDuplicates>>>;
};

/**
 * Request for listing duplicate OpsEscalationRequests based on matching by
 * existing escalation request ID OR warehouse location IDs.
 */
export type Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsRequest_Input = {
  /** ID of the OpsEscalationRequest for which we are looking for duplicates */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** ID of warehouse location IDs to find duplicate requests for */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the ListDuplicateOpsEscalationRequests request. */
export type Instacart_Logistics_Marketplace_Ops_V1_ListDuplicateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_ListDuplicateOpsEscalationRequestsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  opsEscalationRequests?: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>>>;
};

/** Request for listing OpsEscalationRequests with filters and pagination. */
export type Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsRequest_Input = {
  /** Select ops_escalation_requests assigned to users with provided IPP canonical ids */
  assignedToIppAccountCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Select ops_escalation_requests created by users with provided IPP canonical ids */
  createdByIppAccountCanonicalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Time in UTC for filtering requests that are created between the from and to datetimes */
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  /** Find ops_escalation_requests that end after this date. */
  endsAfter?: InputMaybe<Scalars['DateTime']>;
  /** Select ops_escalation_requests with provided ops escalation request ids */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Information on how to paginate the results of a list/filter operation. This feeds into the will_paginate gem */
  paginationInstruction?: InputMaybe<Instacart_Logistics_V1_PaginationInstruction_Input>;
  /**
   * Select ops_escalation_requests with provided priorities
   * Deprecated: Use request_priorities instead.
   */
  priorities?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Select ops_escalation_requests with provided priorities */
  requestPriorities?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Select ops_escalation_requests with provided request_reasons */
  requestReasons?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Information on how to sort the results (list of attribute and direction) */
  sortingInstruction?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_SortingInstruction_Input>>>;
  /** Find ops_escalation_requests that start before this date. */
  startsBefore?: InputMaybe<Scalars['DateTime']>;
  /** Select ops_escalation_requests with provided statuses */
  statuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Select ops_escalation_requests with provided warehouse_ids */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Select ops_escalation_requests with provided warehouse_location_ids */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Select ops_escalation_requests with provided zone_ids */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for the ListOpsEscalationRequests request. */
export type Instacart_Logistics_Marketplace_Ops_V1_ListOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_ListOpsEscalationRequestsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  opsEscalationRequests?: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>>>;
  /** How many total events match the criteria */
  opsEscalationRequestsCount?: Maybe<Scalars['Int']>;
  /** How the results are paginated */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Valid noteable types */
export enum Instacart_Logistics_Marketplace_Ops_V1_NoteableType {
  NoteableTypeUnspecified = 'NOTEABLE_TYPE_UNSPECIFIED',
  OpsEscalationRequest = 'OPS_ESCALATION_REQUEST'
}

/**
 * OpsEscalationRequestData captures the details necessary for handling an operational escalation request,
 * such as a store closure or a system outage. It includes identification, timing, and categorization of the request.
 */
export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_OpsEscalationRequestData';
  /** IPP canonical ID of the person assigned to handle the request. */
  assignedToIppAccountCanonicalId?: Maybe<Scalars['String']>;
  /** Standard Rails timestamps */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** IPP canonical ID of the person who created the request. */
  createdByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  /** DB row id */
  id?: Maybe<Scalars['BigInt']>;
  /** List of location IDs that are part of this request. */
  locationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Type of location associated with the escalation request. */
  locationType?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsLocationType>;
  /** Metadata related to the request in JSON format. */
  metadata?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata>;
  /** Optional URL to the issue/ticket associated with the request. */
  optionalIssueUrl?: Maybe<Scalars['String']>;
  /** If this request has been “intervened”, it will have a parent fulfillment event id */
  parentFulfillmentEventId?: Maybe<Scalars['BigInt']>;
  /**
   * Priority level of the escalation request.
   * Deprecated: Use request_priority instead.
   */
  priority?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestPriority>;
  /** Additional configurations related to the request in JSON format. */
  requestConfigurations?: Maybe<Scalars['JSON']>;
  /** Array of request notes associated with the OpsEscalationRequest. */
  requestNotes?: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>>>;
  /** Priority level of the escalation request. */
  requestPriority?: Maybe<Scalars['BigInt']>;
  /** Specific reason for the escalation request. */
  requestReason?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestReason>;
  /** Type of escalation request. */
  requestType?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestType>;
  /** Time in UTC for start_at and end_at of the ops escalation request. */
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Current status of the escalation request. */
  status?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Used for handling duplicate requests per OpsEscalationRequest ID */
export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestDuplicates = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_OpsEscalationRequestDuplicates';
  /** List of duplicate OpsEscalationRequests found for the given ID */
  duplicateRequests?: Maybe<Array<Maybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestData>>>;
  /** ID of the OpsEscalationRequest for which we are looking for duplicates */
  opsEscalationRequestId?: Maybe<Scalars['BigInt']>;
};

/** OpsEscalationRequestInput represents the input data for creating or updating an OpsEscalationRequest. */
export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestInput_Input = {
  /** IPP canonical ID of the person assigned to handle the request. */
  assignedToIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IPP canonical ID of the person who created the request. */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  endsAt?: InputMaybe<Scalars['DateTime']>;
  /** List of location IDs that are part of this request. */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Type of location associated with the escalation request. */
  locationType?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsLocationType>;
  /** Metadata related to the request. Currently includes only warehouse_id */
  metadata?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata_Input>;
  /** Optional URL to the issue/ticket associated with the request. */
  optionalIssueUrl?: InputMaybe<Scalars['String']>;
  /**
   * Priority level of the escalation request.
   * Deprecated: Use request_priority instead.
   */
  priority?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestPriority>;
  /** Additional configurations related to the request in JSON format. */
  requestConfigurations?: InputMaybe<Scalars['JSON']>;
  /** Priority level of the escalation request. */
  requestPriority?: InputMaybe<Scalars['BigInt']>;
  /** Specific reason for the escalation request. */
  requestReason?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestReason>;
  /** Type of escalation request. */
  requestType?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestType>;
  /** Time in UTC for start_at and end_at of the ops escalation request. */
  startsAt?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_OpsEscalationRequestMetadata';
  additionalRequestContext?: Maybe<Scalars['String']>;
  warehouseId?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestMetadata_Input = {
  additionalRequestContext?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Definitions of enums for location types, statuses, request types, reasons, and priorities. */
export enum Instacart_Logistics_Marketplace_Ops_V1_OpsLocationType {
  LocationTypeUnspecified = 'LOCATION_TYPE_UNSPECIFIED',
  WarehouseLocation = 'WAREHOUSE_LOCATION'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestPriority {
  CrtRequest = 'CRT_REQUEST',
  PriorityUnspecified = 'PRIORITY_UNSPECIFIED',
  TempStoreClosure = 'TEMP_STORE_CLOSURE'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestReason {
  AdminConfigurationIssue = 'ADMIN_CONFIGURATION_ISSUE',
  BdWhlRequest = 'BD_WHL_REQUEST',
  CityEvent = 'CITY_EVENT',
  CrtIncident = 'CRT_INCIDENT',
  EmergencyClosure = 'EMERGENCY_CLOSURE',
  HolidayHours = 'HOLIDAY_HOURS',
  IncorrectGeolocationAddress = 'INCORRECT_GEOLOCATION_ADDRESS',
  IncorrectStoreHours = 'INCORRECT_STORE_HOURS',
  MaintenanceClosure = 'MAINTENANCE_CLOSURE',
  PermanentClosure = 'PERMANENT_CLOSURE',
  PickupDeviceIssues = 'PICKUP_DEVICE_ISSUES',
  PosOutageHours = 'POS_OUTAGE_HOURS',
  PowerOutage = 'POWER_OUTAGE',
  ReopenStore = 'REOPEN_STORE',
  RequestReasonUnspecified = 'REQUEST_REASON_UNSPECIFIED',
  TemporaryStoreClosure = 'TEMPORARY_STORE_CLOSURE',
  WhlIssuesExtremeWeather = 'WHL_ISSUES_EXTREME_WEATHER'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestStatus {
  Duplicate = 'DUPLICATE',
  Expired = 'EXPIRED',
  InterventionCompleted = 'INTERVENTION_COMPLETED',
  InterventionCreated = 'INTERVENTION_CREATED',
  InterventionInProgress = 'INTERVENTION_IN_PROGRESS',
  NewRequest = 'NEW_REQUEST',
  StatusUnspecified = 'STATUS_UNSPECIFIED',
  WontDo = 'WONT_DO'
}

export enum Instacart_Logistics_Marketplace_Ops_V1_OpsRequestType {
  IncorrectGeolocationAddressRequest = 'INCORRECT_GEOLOCATION_ADDRESS_REQUEST',
  IncorrectStoreHoursRequest = 'INCORRECT_STORE_HOURS_REQUEST',
  PermanentClosureRequest = 'PERMANENT_CLOSURE_REQUEST',
  ReopenStoreRequest = 'REOPEN_STORE_REQUEST',
  RequestTypeUnspecified = 'REQUEST_TYPE_UNSPECIFIED',
  StoreClosure = 'STORE_CLOSURE'
}

/** A request note object */
export type Instacart_Logistics_Marketplace_Ops_V1_RequestNote = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_RequestNote';
  /** Content of the request note */
  content?: Maybe<Scalars['String']>;
  /** Standard Rails timestamps */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** IPP canonical ID of the person who created the request note */
  createdByIppAccountCanonicalId?: Maybe<Scalars['String']>;
  /** DB row id */
  id?: Maybe<Scalars['BigInt']>;
  /** IDs of IPP accounts tagged in the request note. */
  ippAccountCanonicalTaggedIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The ID of the ops escalation request note is assigned to */
  opsEscalationRequestId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** input data to create a new RequestNote record */
export type Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInputData_Input = {
  /** Content of the request note */
  content?: InputMaybe<Scalars['String']>;
  /** IPP canonical ID of the person who created the request */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IPP canonical IDs of users tagged in the request note */
  ippAccountCanonicalTaggedIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** ID of the record associated with the note */
  noteableId?: InputMaybe<Scalars['BigInt']>;
  /** IPP canonical IDs of users tagged in the request note */
  noteableType?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_NoteableType>;
};

/** input data to create a RequestNote record when creating an OpsEscalationRequest */
export type Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input = {
  /** Content of the request note */
  content?: InputMaybe<Scalars['String']>;
  /** IPP canonical ID of the person who created the request */
  createdByIppAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IPP canonical IDs of users tagged in the request note */
  ippAccountCanonicalTaggedIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteRequest_Input = {
  /** contains all the required information to update a request note record */
  requestNote?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>;
  /** ID of the request note to be updated */
  requestNoteId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateOpsEscalationRequestRequestNoteResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusRequest_Input = {
  /** Optional - The user who is performing the request */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** The new status to set */
  newStatus?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsRequestStatus>;
  /** The ID of the OpsEscalationRequest to update */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Optional note to add to the updated OpsEscalationRequest */
  requestNote?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInput_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestStatusResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateOpsEscalationRequestStatusResponse';
  /** Any error messages that occurred during the update */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsRequest_Input = {
  /** Optional - the user who is performing the request */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** IDs of OpsEscalationRequests to be updated */
  opsEscalationRequestIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** basic data for creating/updating an OpsEscalationRequest record */
  opsEscalationRequestInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_OpsEscalationRequestInput_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateOpsEscalationRequestsResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateOpsEscalationRequestsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteRequest_Input = {
  /** ID of the note to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Content of the request note. Created by must match the existing user */
  requestNoteInput?: InputMaybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNoteInputData_Input>;
};

export type Instacart_Logistics_Marketplace_Ops_V1_UpdateRequestNoteResponse = {
  __typename?: 'instacart_logistics_marketplace_ops_v1_UpdateRequestNoteResponse';
  /** Any erors from the operation */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The update request note */
  requestNote?: Maybe<Instacart_Logistics_Marketplace_Ops_V1_RequestNote>;
  /** Whether the update succeeded or not */
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_V1_AddLocationsToParentEventRequest_Input = {
  /** Email of the creator */
  creator?: InputMaybe<Scalars['String']>;
  /** Array of IDs to be added (they will be of the same type as the parent event) */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The ID of the parent event that locations will be added to */
  parentFulfillmentEventId?: InputMaybe<Scalars['BigInt']>;
  /** For restricted availability events, we might have new warehouses that are impacted */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_AddLocationsToParentEventResponse = {
  __typename?: 'instacart_logistics_v1_AddLocationsToParentEventResponse';
  /** Error message that occured during operation */
  error?: Maybe<Scalars['String']>;
  /** Did the operation succeed? */
  success?: Maybe<Scalars['Boolean']>;
};

/** Data shared by all types of fulfillment events */
export type Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input = {
  /** Free-text reason supplied by the operator for this change. Persisted to audit_logs.comment. */
  changeReason?: InputMaybe<Scalars['String']>;
  /** The email of the creator of the event, this will also be the first owner */
  creator?: InputMaybe<Scalars['String']>;
  /** The end time of the event (deprecated, use ends_at_string instead) */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  endsAtString?: InputMaybe<Scalars['String']>;
  /** The type of the event */
  eventType?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>;
  /** A link, typically a Jira link, to the reason for the event */
  infoUrl?: InputMaybe<Scalars['String']>;
  /** Location ids, a child event will be created for each location id */
  locationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Location type, which will apply to all location ids */
  locationType?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name/description of the event */
  name?: InputMaybe<Scalars['String']>;
  /** The severity level of the event */
  severityLevel?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  /** The start time of the event (deprecated, use starts_at_string instead) */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** to avoid timezone issues we are going to set starts_at and ends_at as strings */
  startsAtString?: InputMaybe<Scalars['String']>;
  /** Any tags associated with the event, optional */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Request to cancel a list of fulfillment events */
export type Instacart_Logistics_V1_CancelFulfillmentEventsRequest_Input = {
  /** Email of the creator (user cancelling the events) */
  creator?: InputMaybe<Scalars['String']>;
  /** List of fulfillment event ids to cancel */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be cancelled asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to cancel a list of fulfillment events */
export type Instacart_Logistics_V1_CancelFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_CancelFulfillmentEventsResponse';
  /** List of canceled fulfillment event ids */
  canceledFulfillmentEventIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Values specific to a fulfillment capacity-impacting event */
export type Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input = {
  /** Expected rate of increasing of delivery time */
  deliveryMultiple?: InputMaybe<Instacart_Types_V1_BigDecimal_Input>;
  /** The percentage by which to adjust capacity for the location, a negative number */
  suggestedCapacityLevel?: InputMaybe<Scalars['Int']>;
};

/**
 * Values specific to a store closure event
 * More documentation here https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Closure-event%3A-Level-4
 */
export type Instacart_Logistics_V1_ClosureFulfillmentEventData = {
  __typename?: 'instacart_logistics_v1_ClosureFulfillmentEventData';
  addDeliveryBlock?: Maybe<Scalars['Boolean']>;
  /** Allow staged delivery orders to be batched instead of reassigning to alternative open stores */
  batchStagedBatches?: Maybe<Scalars['Boolean']>;
  /** Cancel shifts */
  cancelAllPartnerShifts?: Maybe<Scalars['Boolean']>;
  /** Disable delivery options */
  disableDeliveryOptions?: Maybe<Scalars['Boolean']>;
  disableIssOptions?: Maybe<Scalars['Boolean']>;
  disablePickupOptions?: Maybe<Scalars['Boolean']>;
  /** Keep shifts */
  keepAllIssShifts?: Maybe<Scalars['Boolean']>;
  keepIssShiftsForPickup?: Maybe<Scalars['Boolean']>;
  keepWarehouseLocationEnabled?: Maybe<Scalars['Boolean']>;
  setWarehouseLocationsToPickupOnly?: Maybe<Scalars['Boolean']>;
  /**
   * Reschedule orders
   * Skip rescheduling impacted orders except staged orders
   */
  skipDeliveriesRescheduling?: Maybe<Scalars['Boolean']>;
  /** Zero out staffing levels */
  zeroOutStaffing?: Maybe<Scalars['Boolean']>;
};

/**
 * Values specific to a store closure event
 * More documentation here https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Closure-event%3A-Level-4
 */
export type Instacart_Logistics_V1_ClosureFulfillmentEventData_Input = {
  addDeliveryBlock?: InputMaybe<Scalars['Boolean']>;
  /** Allow staged delivery orders to be batched instead of reassigning to alternative open stores */
  batchStagedBatches?: InputMaybe<Scalars['Boolean']>;
  /** Cancel shifts */
  cancelAllPartnerShifts?: InputMaybe<Scalars['Boolean']>;
  /** Disable delivery options */
  disableDeliveryOptions?: InputMaybe<Scalars['Boolean']>;
  disableIssOptions?: InputMaybe<Scalars['Boolean']>;
  disablePickupOptions?: InputMaybe<Scalars['Boolean']>;
  /** Keep shifts */
  keepAllIssShifts?: InputMaybe<Scalars['Boolean']>;
  keepIssShiftsForPickup?: InputMaybe<Scalars['Boolean']>;
  keepWarehouseLocationEnabled?: InputMaybe<Scalars['Boolean']>;
  setWarehouseLocationsToPickupOnly?: InputMaybe<Scalars['Boolean']>;
  /**
   * Reschedule orders
   * Skip rescheduling impacted orders except staged orders
   */
  skipDeliveriesRescheduling?: InputMaybe<Scalars['Boolean']>;
  /** Zero out staffing levels */
  zeroOutStaffing?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Logistics_V1_CreateClosureEventApprovalRequestRequest_Input = {
  /** The closure event request to create an approval request for */
  eventRequest?: InputMaybe<Instacart_Logistics_V1_CreateClosureEventRequest_Input>;
};

export type Instacart_Logistics_V1_CreateClosureEventApprovalRequestResponse = {
  __typename?: 'instacart_logistics_v1_CreateClosureEventApprovalRequestResponse';
  /** The ID of the created approval request */
  createdApprovalRequestId?: Maybe<Scalars['String']>;
  /** Error message that occurred during operation */
  error?: Maybe<Scalars['String']>;
};

/** Request to create a new closure event */
export type Instacart_Logistics_V1_CreateClosureEventRequest_Input = {
  /** The event data that is specific to closure events */
  closureData?: InputMaybe<Instacart_Logistics_V1_ClosureFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** Whether event should be created asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to create a new closure event */
export type Instacart_Logistics_V1_CreateClosureEventResponse = {
  __typename?: 'instacart_logistics_v1_CreateClosureEventResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new parent event, includes paginated child events */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /**
   * Impact data for the created child events
   * Key is one of: shifts staffing delivery_blocks delivery_options pickup_options order_deliveries
   */
  impactData?: Maybe<Scalars['JSON']>;
  /** The pagination information for the child events */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Parameters needed for creating new fulfillment capacity impacting events */
export type Instacart_Logistics_V1_CreateFulfillmentEventRequest_Input = {
  /** The event data that is specific to capacity-impacting events */
  capacityImpactData?: InputMaybe<Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** Whether event should be created asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Returns the created event and any errors */
export type Instacart_Logistics_V1_CreateFulfillmentEventResponse = {
  __typename?: 'instacart_logistics_v1_CreateFulfillmentEventResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new parent event, includes paginated child events */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestRequest_Input = {
  /** The restricted availability event request to create an approval request for */
  eventRequest?: InputMaybe<Instacart_Logistics_V1_CreateRestrictedAvailabilityEventRequest_Input>;
};

export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventApprovalRequestResponse = {
  __typename?: 'instacart_logistics_v1_CreateRestrictedAvailabilityEventApprovalRequestResponse';
  /** The ID of the created approval request (deprecated, use created_approval_request_id instead) */
  approvalRequestId?: Maybe<Scalars['BigInt']>;
  /** The ID of the created approval request */
  createdApprovalRequestId?: Maybe<Scalars['String']>;
  /** Error message that occurred during operation */
  error?: Maybe<Scalars['String']>;
};

/** Request to create a new restricted availability event */
export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** The IPP account canonical ID of the user performing the request */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** The ID of the associated OpsEscalationRequest (optional) */
  opsEscalationRequestId?: InputMaybe<Scalars['BigInt']>;
  /** Whether event should be created asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
  /** The event data that is specific to restricted availability events */
  restrictedAvailabilityData?: InputMaybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input>;
  /** The warehouse_ids that will be impacted (optional) */
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response to create a new restricted availability event */
export type Instacart_Logistics_V1_CreateRestrictedAvailabilityEventResponse = {
  __typename?: 'instacart_logistics_v1_CreateRestrictedAvailabilityEventResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The new parent event, includes paginated child events */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Request to create an SLA exclusion record */
export type Instacart_Logistics_V1_CreateSlaExclusionRequest_Input = {
  /** Email of the ops user creating this record */
  createdBy?: InputMaybe<Scalars['String']>;
  /** Event end time (deprecated, use ends_at_string instead) */
  endsAt?: InputMaybe<Scalars['DateTime']>;
  endsAtString?: InputMaybe<Scalars['String']>;
  /** Weather event type */
  eventType?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>;
  /** FK to the originating fulfillment_event (set for copies, null for manual) */
  fulfillmentEventId?: InputMaybe<Scalars['BigInt']>;
  /** Free text justification for why this exclusion exists */
  justification?: InputMaybe<Scalars['String']>;
  /** Specific location ID */
  locationId?: InputMaybe<Scalars['BigInt']>;
  /** Location type */
  locationType?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name/description of the event */
  name?: InputMaybe<Scalars['String']>;
  /** Severity level (L1-L4) */
  severityLevel?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  /** How this record was created: 'manual' or 'copy' */
  source?: InputMaybe<Scalars['String']>;
  /** Event start time (deprecated, use starts_at_string instead) */
  startsAt?: InputMaybe<Scalars['DateTime']>;
  /** To avoid timezone issues, set starts_at and ends_at as strings */
  startsAtString?: InputMaybe<Scalars['String']>;
  /** The zone affected by the weather event */
  zoneId?: InputMaybe<Scalars['BigInt']>;
};

/** Response to create an SLA exclusion record */
export type Instacart_Logistics_V1_CreateSlaExclusionResponse = {
  __typename?: 'instacart_logistics_v1_CreateSlaExclusionResponse';
  /** Error messages, if any */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The created SLA exclusion record */
  slaExclusion?: Maybe<Instacart_Logistics_V1_SlaExclusionData>;
};

/** A fulfillment event is a temporary event that affects the capacity of a location. */
export type Instacart_Logistics_V1_FulfillmentEventData = {
  __typename?: 'instacart_logistics_v1_FulfillmentEventData';
  /**
   * The percentage by which to adjust staffing for the location.
   * When there are overlapping events affecting the same location, the lowest value is used.
   */
  adjustStaffingPercentage?: Maybe<Scalars['Int']>;
  /** The number of children for this event */
  childCount?: Maybe<Scalars['Int']>;
  /** Child events, if this is a parent event */
  childEvents?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
  /** A list of the location ids associated with the event's child events, if this is a parent event */
  childLocationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Additional data for closure events */
  closureData?: Maybe<Instacart_Logistics_V1_ClosureFulfillmentEventData>;
  closureEventDataMetadata?: Maybe<Instacart_Logistics_V1_ClosureFulfillmentEventData>;
  /** Standard Rails timestamps */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Original creator of the event - email address if it was a person, system name if it's a system, e.g. "apollo" */
  creator?: Maybe<Scalars['String']>;
  /** Message shown to customers about the event */
  customerMessage?: Maybe<Scalars['String']>;
  /** Deleted time, if the event was cancelled before it started */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Expected rate of increasing of delivery time */
  deliveryMultiple?: Maybe<Instacart_Types_V1_BigDecimal>;
  endsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Identifier linking related fulfillment events into a phase family.
   * For the anchor event of the family, this equals its own id. Null when not applicable.
   */
  eventFamilyId?: Maybe<Scalars['BigInt']>;
  /** Lifecycle phase (if applicable) */
  eventPhase?: Maybe<Instacart_Logistics_V1_FulfillmentEventPhase>;
  /** General type of event (see enum above) */
  eventType?: Maybe<Instacart_Logistics_V1_FulfillmentEventType>;
  /** Whether we should forgive shoppers for cancelling shifts */
  forgiveReliabilityIncident?: Maybe<Scalars['Boolean']>;
  /** DB row id */
  id?: Maybe<Scalars['BigInt']>;
  /** Link to a Jira ticket or other documentation for the event */
  infoUrl?: Maybe<Scalars['String']>;
  /** Location data, if this is a child event */
  location?: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>;
  /**
   * When a list of parent events is retrieved, we only need to know the location type and count of children
   * When a single parent event is retrieved, we need to know the full details of the children
   */
  locationType?: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name of the event */
  name?: Maybe<Scalars['String']>;
  /** Most recent updater of the event - email address if it was a person, system name if it's a system, e.g. "apollo" */
  owner?: Maybe<Scalars['String']>;
  /**
   * Parent event id, if this is a child event
   * Note: some historical events are child events but do not have a parent event id
   */
  parentFulfillmentEventId?: Maybe<Scalars['BigInt']>;
  /** Additional data for restricted availability events */
  restrictedAvailabilityData?: Maybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData>;
  restrictedAvailabilityEventDataMetadata?: Maybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData>;
  /** A comma-separated list of shift types for looking up staffing_levels */
  roleTypes?: Maybe<Scalars['String']>;
  /** Severity (see enum above) */
  severityLevel?: Maybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  /** Start and end time */
  startsAt?: Maybe<Scalars['DateTime']>;
  /**
   * Event status as computed from the start and end times of the event relative to the current time.
   * Status is DELETED if the event has been soft-deleted.
   */
  status?: Maybe<Instacart_Logistics_V1_FulfillmentEventStatus>;
  /**
   * The percentage by which to adjust capacity for the location.
   * When there are overlapping events affecting the same location, the highest value is used.
   */
  suggestedCapacityLevel?: Maybe<Scalars['Int']>;
  /** Tags associated by the events */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Timezone as it turns out google.protobuf.Timestamp is only in UTC, so we need this to do conversions */
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Whether or not this event was automatically created by weather data */
  weatherEvent?: Maybe<Scalars['Boolean']>;
  /** Zone for the event */
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Rich(er) data about the location associated with the fulfillment event */
export type Instacart_Logistics_V1_FulfillmentEventLocationData = {
  __typename?: 'instacart_logistics_v1_FulfillmentEventLocationData';
  /** DB row id */
  id?: Maybe<Scalars['BigInt']>;
  locationType?: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  /** Name from association table */
  name?: Maybe<Scalars['String']>;
};

/** Possible types of locations associated with a fulfillment event */
export enum Instacart_Logistics_V1_FulfillmentEventLocationType {
  Country = 'COUNTRY',
  LocationTypeUnspecified = 'LOCATION_TYPE_UNSPECIFIED',
  PostalCode = 'POSTAL_CODE',
  Region = 'REGION',
  WarehouseLocation = 'WAREHOUSE_LOCATION',
  WarehouseZone = 'WAREHOUSE_ZONE',
  Zone = 'ZONE'
}

/**
 * Phase within a fulfillment event lifecycle.
 * EVENT_PHASE_UNSPECIFIED when no lifecycle phase is known or applicable.
 */
export enum Instacart_Logistics_V1_FulfillmentEventPhase {
  EventPhaseUnspecified = 'EVENT_PHASE_UNSPECIFIED',
  Recovering = 'RECOVERING',
  Stocking = 'STOCKING',
  Surviving = 'SURVIVING'
}

/**
 * Event severities, see more at
 * https://docs.google.com/document/d/1lSGwGQU-0_ED55yH9P-TDFaCxVdXqaLV/edit#heading=h.994m78oh6kur
 *
 * Fulfillment capacity-impacting events (severities 1-3, formerly "Weather events")
 * These types of events cause a reduction in the number of orders we can fulfill. The capacity level (reduction)
 * for these events can be set to anything from -5 to -100. We can also customize the delivery multiple
 * (the factor indicating expected delivery time increase) and customer facing messages for these events.
 *
 * Closure event/extreme weather event (severity 4)
 * This severity causes closure of specific stores (WarehouseLocation).
 *
 * Restricted availability (severity 5, previous known as "safe mode")
 * This severity causes the system to restrict available service options, e.g. disallow all delivery orders.
 *
 * Note that while levels 1-3 and 6 are related, the severity levels are not necessarily contiguous or strictly
 * ordered.
 */
export enum Instacart_Logistics_V1_FulfillmentEventSeverityLevel {
  EventSeverityUnspecified = 'EVENT_SEVERITY_UNSPECIFIED',
  HighCapacityImpact = 'HIGH_CAPACITY_IMPACT',
  LowCapacityImpact = 'LOW_CAPACITY_IMPACT',
  MediumCapacityImpact = 'MEDIUM_CAPACITY_IMPACT',
  RestrictedServiceOptions = 'RESTRICTED_SERVICE_OPTIONS',
  StoreClosure = 'STORE_CLOSURE',
  /**
   * this is a new severity level that is used to indicate that the event has no capacity impact;
   * since 0 is reserved for "unspecified", and other values were already defined, we use 6 here.
   */
  ZeroCapacityImpact = 'ZERO_CAPACITY_IMPACT'
}

/**
 * Event status, computed from the start and end times of the event relative to the current time. Status is
 * DELETED if the event has been soft-deleted.
 */
export enum Instacart_Logistics_V1_FulfillmentEventStatus {
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  EventStatusUnspecified = 'EVENT_STATUS_UNSPECIFIED',
  InProgress = 'IN_PROGRESS',
  Upcoming = 'UPCOMING'
}

/**
 * Event types, see more at
 * https://docs.google.com/document/d/1lSGwGQU-0_ED55yH9P-TDFaCxVdXqaLV/edit#heading=h.rs2ipnbn0urn
 * Note: We are expecting a new and more comprehensive list of types in the future.
 */
export enum Instacart_Logistics_V1_FulfillmentEventType {
  AirQuality = 'AIR_QUALITY',
  CityEvent = 'CITY_EVENT',
  Cold = 'COLD',
  Cultural = 'CULTURAL',
  EventTypeUnspecified = 'EVENT_TYPE_UNSPECIFIED',
  Experiment = 'EXPERIMENT',
  Flood = 'FLOOD',
  Heatwave = 'HEATWAVE',
  Holiday = 'HOLIDAY',
  Hurricane = 'HURRICANE',
  Other = 'OTHER',
  Outage = 'OUTAGE',
  Rain = 'RAIN',
  Snow = 'SNOW',
  Tornado = 'TORNADO',
  Tropical = 'TROPICAL',
  TropicalStorm = 'TROPICAL_STORM',
  Wildfire = 'WILDFIRE',
  Wind = 'WIND',
  WinterStorm = 'WINTER_STORM'
}

export type Instacart_Logistics_V1_GetFulfillmentEventRequest_Input = {
  fulfillmentEventId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Logistics_V1_GetFulfillmentEventResponse = {
  __typename?: 'instacart_logistics_v1_GetFulfillmentEventResponse';
  createdAt?: Maybe<Scalars['DateTime']>;
  customerMessage?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Expected rate of increasing of delivery time */
  deliveryMultiple?: Maybe<Scalars['Float']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Instacart_Logistics_V1_GetFulfillmentEventResponse_EventType>;
  /** Whether we should forgive shoppers for cancelling shifts */
  forgiveReliabilityIncident?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  locationId?: Maybe<Scalars['BigInt']>;
  locationType?: Maybe<Instacart_Logistics_V1_GetFulfillmentEventResponse_LocationType>;
  locked?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  /** Author of the event */
  owner?: Maybe<Scalars['String']>;
  roleTypes?: Maybe<Scalars['String']>;
  /** Level of the fulfillment event */
  severityLevel?: Maybe<Scalars['Int']>;
  shopperMessage?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  /** Adjustment of the capacity level */
  suggestedCapacityLevel?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  weatherEvent?: Maybe<Scalars['Boolean']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

export enum Instacart_Logistics_V1_GetFulfillmentEventResponse_EventType {
  Cultural = 'CULTURAL',
  Experiment = 'EXPERIMENT',
  Other = 'OTHER',
  Rain = 'RAIN',
  Snow = 'SNOW'
}

export enum Instacart_Logistics_V1_GetFulfillmentEventResponse_LocationType {
  Country = 'COUNTRY',
  PostalCode = 'POSTAL_CODE',
  Region = 'REGION',
  WarehouseLocation = 'WAREHOUSE_LOCATION',
  WarehouseZone = 'WAREHOUSE_ZONE',
  Zone = 'ZONE'
}

export type Instacart_Logistics_V1_GetFulfillmentEventsByIdRequest_Input = {
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_GetFulfillmentEventsByIdResponse = {
  __typename?: 'instacart_logistics_v1_GetFulfillmentEventsByIdResponse';
  fulfillmentEvents?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
};

export type Instacart_Logistics_V1_ListChildFulfillmentEventsRequest_Input = {
  /** Find events created by these users */
  creators?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events which end after this date. */
  endsAfter?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these statuses */
  eventStatuses?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventStatus>>>;
  /** Select events with these event types */
  eventTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>>>;
  /** Find an event with one of these owners (most recent updater) */
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Information on how to paginate the results of a list/filter operation. This feeds into the will_paginate gem. */
  paginationInstruction?: InputMaybe<Instacart_Logistics_V1_PaginationInstruction_Input>;
  /**
   * The parent event id from which a set of location-specific events were generated; this will return
   * a list of only the child events for that parent.
   */
  parentEventId?: InputMaybe<Scalars['BigInt']>;
  /** Find events with these postal codes */
  postalCodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events with these regions */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** A search string that matches the event name or link content (e.g. Jira ticket id). */
  searchString?: InputMaybe<Scalars['String']>;
  /** Select events with these severity levels */
  severityLevels?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>>>;
  /**
   * Information on how to sort the results (list of attribute and direction); currently the front-end only
   * supports a single sort attribute but this is a list in case users ask for more nuance in future.
   */
  sortingInstruction?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_SortingInstruction_Input>>>;
  /** Find events which start before this date. */
  startsBefore?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these tags */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events with these warehouse locations */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events with these zones */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_ListChildFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_ListChildFulfillmentEventsResponse';
  /** How many total events match the criteria */
  eventCount?: Maybe<Scalars['Int']>;
  /** Paginated and sorted array of child fulfillment events for a specified parent event that match the given criteria. */
  fulfillmentEvents?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
  /** How the results are paginated */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Return all creators, sorted alphabetically */
export type Instacart_Logistics_V1_ListCreatorsResponse = {
  __typename?: 'instacart_logistics_v1_ListCreatorsResponse';
  /** List of creators */
  creators?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Request fulfillment events according to specified criteria. All parameters are optional. */
export type Instacart_Logistics_V1_ListFulfillmentEventsRequest_Input = {
  /** Find events with these countries */
  countryIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events created by these users */
  creators?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events which end after this date. */
  endsAfter?: InputMaybe<Scalars['DateTime']>;
  /** Find events belonging to this event family. */
  eventFamilyId?: InputMaybe<Scalars['BigInt']>;
  /** Select events with these statuses */
  eventStatuses?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventStatus>>>;
  /** Select events with these event types */
  eventTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventType>>>;
  /** Select only events where the location_type matches this value (typically WarehouseLocation is selected here) */
  locationTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventLocationType>>>;
  /** Find an event with one of these owners (most recent updater) */
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Information on how to paginate the results of a list/filter operation. This feeds into the will_paginate gem. */
  paginationInstruction?: InputMaybe<Instacart_Logistics_V1_PaginationInstruction_Input>;
  /**
   * The parent event id from which a set of location-specific events were generated; this will return
   * a list of only the child events for that parent.
   */
  parentEventId?: InputMaybe<Scalars['BigInt']>;
  /** Find events with these postal codes */
  postalCodeIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events in selected region (not used, see region_ids) */
  regionId?: InputMaybe<Scalars['BigInt']>;
  /** Find events with these regions */
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** A search string that matches the event name or link content (e.g. Jira ticket id). */
  searchString?: InputMaybe<Scalars['String']>;
  /** Select events with these severity levels */
  severityLevels?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>>>;
  /**
   * Information on how to sort the results (list of attribute and direction); currently the front-end only
   * supports a single sort attribute but this is a list in case users ask for more nuance in future.
   */
  sortingInstruction?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_SortingInstruction_Input>>>;
  /** Find events which start before this date. */
  startsBefore?: InputMaybe<Scalars['DateTime']>;
  /** Select events with these tags */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Find events with these warehouse locations */
  warehouseLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Find events with these zones */
  zoneIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Logistics_V1_ListFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_ListFulfillmentEventsResponse';
  /** How many total events match the criteria */
  eventCount?: Maybe<Scalars['Int']>;
  /**
   * Paginated and sorted array of fulfillment events that match the given criteria.
   *
   * If a parent event id was not specified in the search criteria, this ia a list of parent events
   * where each parent event contains a list of location-specific child events.
   *
   * If the search criteria includes a parent_event_id, then this will return just that parent, with
   * child events nested as usual.
   */
  fulfillmentEvents?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventData>>>;
  /** How the results are paginated */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Return all tags, sorted alphabetically */
export type Instacart_Logistics_V1_ListTagsResponse = {
  __typename?: 'instacart_logistics_v1_ListTagsResponse';
  /** List of creators */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Commonly used data structures for pagination */
export type Instacart_Logistics_V1_PaginationInstruction = {
  __typename?: 'instacart_logistics_v1_PaginationInstruction';
  /** The page of results to show, will default if nil */
  page?: Maybe<Scalars['Int']>;
  /** The number of results to show per page, will default if nil */
  perPage?: Maybe<Scalars['Int']>;
};

/** Commonly used data structures for pagination */
export type Instacart_Logistics_V1_PaginationInstruction_Input = {
  /** The page of results to show, will default if nil */
  page?: InputMaybe<Scalars['Int']>;
  /** The number of results to show per page, will default if nil */
  perPage?: InputMaybe<Scalars['Int']>;
};

/**
 * Restricted availability event data
 * More documentation here:https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Safe-Mode
 */
export type Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData = {
  __typename?: 'instacart_logistics_v1_RestrictedAvailabilityFulfillmentEventData';
  /**
   * Optional narrowing: only restrict options where the potential order's
   * delivery DSP (Delivery Service Provider) id matches one of these ids.
   * Blank = match all.
   */
  deliveryDspIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  isWarehouseAndZoneScoped?: Maybe<Scalars['Boolean']>;
  isWarehouseScoped?: Maybe<Scalars['Boolean']>;
  restrictServiceOptionTypes?: Maybe<Array<Maybe<Instacart_Logistics_V1_RestrictedServiceOptionType>>>;
  storeCloseBuffer?: Maybe<Scalars['Int']>;
  /**
   * Optional narrowing: only restrict options where the potential order's
   * store_configuration_id matches one of these ids. Blank = match all.
   */
  storeConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  warehouseIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/**
 * Restricted availability event data
 * More documentation here:https://instacart.atlassian.net/wiki/spaces/OPS/pages/3781492737/Fulfillment+Event+Tool+SOP+Updated#Safe-Mode
 */
export type Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input = {
  /**
   * Optional narrowing: only restrict options where the potential order's
   * delivery DSP (Delivery Service Provider) id matches one of these ids.
   * Blank = match all.
   */
  deliveryDspIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  isWarehouseAndZoneScoped?: InputMaybe<Scalars['Boolean']>;
  isWarehouseScoped?: InputMaybe<Scalars['Boolean']>;
  restrictServiceOptionTypes?: InputMaybe<Array<InputMaybe<Instacart_Logistics_V1_RestrictedServiceOptionType>>>;
  storeCloseBuffer?: InputMaybe<Scalars['Int']>;
  /**
   * Optional narrowing: only restrict options where the potential order's
   * store_configuration_id matches one of these ids. Blank = match all.
   */
  storeConfigurationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  warehouseIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Types of service options that can be restricted */
export enum Instacart_Logistics_V1_RestrictedServiceOptionType {
  Asap = 'ASAP',
  /** WHL specific restrictions */
  BatchingForDelivery = 'BATCHING_FOR_DELIVERY',
  BatchingForInflightOrders = 'BATCHING_FOR_INFLIGHT_ORDERS',
  BatchingForPickup = 'BATCHING_FOR_PICKUP',
  FiveHour = 'FIVE_HOUR',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  LimitedAvailabilityFiveHour = 'LIMITED_AVAILABILITY_FIVE_HOUR',
  LimitedAvailabilityFourHour = 'LIMITED_AVAILABILITY_FOUR_HOUR',
  LimitedAvailabilityThreeHour = 'LIMITED_AVAILABILITY_THREE_HOUR',
  LimitedAvailabilityTwoHour = 'LIMITED_AVAILABILITY_TWO_HOUR',
  Pickup = 'PICKUP',
  PickupEta = 'PICKUP_ETA',
  PriorityEta = 'PRIORITY_ETA',
  PriorityEtaByEndAt = 'PRIORITY_ETA_BY_END_AT',
  PriorityEtaPickup = 'PRIORITY_ETA_PICKUP',
  RetailerLocationAvailabilityForDeliveryAndPickup = 'RETAILER_LOCATION_AVAILABILITY_FOR_DELIVERY_AND_PICKUP',
  /** Restrict Rx (prescription) scheduled delivery options, by option window */
  RxScheduled = 'RX_SCHEDULED',
  ScheduledAvailabilityOneHour = 'SCHEDULED_AVAILABILITY_ONE_HOUR',
  StandardEta = 'STANDARD_ETA',
  StandardEtaByEndAt = 'STANDARD_ETA_BY_END_AT',
  ThreeHourScheduledDelivery = 'THREE_HOUR_SCHEDULED_DELIVERY',
  TwoHour = 'TWO_HOUR',
  UnspecifiedRestrictedServiceOptionType = 'UNSPECIFIED_RESTRICTED_SERVICE_OPTION_TYPE'
}

/** Data representation of an SLA exclusion record */
export type Instacart_Logistics_V1_SlaExclusionData = {
  __typename?: 'instacart_logistics_v1_SlaExclusionData';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<Instacart_Logistics_V1_FulfillmentEventType>;
  fulfillmentEventId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  justification?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['BigInt']>;
  locationType?: Maybe<Instacart_Logistics_V1_FulfillmentEventLocationType>;
  name?: Maybe<Scalars['String']>;
  severityLevel?: Maybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  source?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
  zoneId?: Maybe<Scalars['BigInt']>;
};

/** Information on how to sort the results of a list/filter operation */
export enum Instacart_Logistics_V1_SortingDirection {
  Ascending = 'ASCENDING',
  Descending = 'DESCENDING',
  SortingDirectionUnspecified = 'SORTING_DIRECTION_UNSPECIFIED'
}

export type Instacart_Logistics_V1_SortingInstruction_Input = {
  /** The direction to sort, defaults to ascending */
  direction?: InputMaybe<Instacart_Logistics_V1_SortingDirection>;
  /** The name of the field to sort on, e.g. starts_at */
  fieldName?: InputMaybe<Scalars['String']>;
};

/**
 * Request to update one or more closure events
 * All events must be children of the same parent
 */
export type Instacart_Logistics_V1_UpdateClosureEventsRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** IDs of the events to update */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be updated asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to update one or more closure events */
export type Instacart_Logistics_V1_UpdateClosureEventsResponse = {
  __typename?: 'instacart_logistics_v1_UpdateClosureEventsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated parent event, includes paginated child events */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/**
 * Request to update one or more fulfillment events
 * All events must be children of the same parent
 */
export type Instacart_Logistics_V1_UpdateFulfillmentEventsRequest_Input = {
  /** The event data that is specific to capacity-impacting events */
  capacityImpactData?: InputMaybe<Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** IDs of the events to update */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be update asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
};

/** Response to update one or more fulfillment events */
export type Instacart_Logistics_V1_UpdateFulfillmentEventsResponse = {
  __typename?: 'instacart_logistics_v1_UpdateFulfillmentEventsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated parent event, includes paginated child events */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/**
 * Request to update one or more restricted availability events
 * All events must be children of the same parent
 */
export type Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** IDs of the events to update */
  fulfillmentEventIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Whether event should be updated asynchronously */
  performAsync?: InputMaybe<Scalars['Boolean']>;
  /** The event data that is specific to restricted availability events */
  restrictedAvailabilityData?: InputMaybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input>;
};

/** Response to update a restricted availability event */
export type Instacart_Logistics_V1_UpdateRestrictedAvailabilityEventsResponse = {
  __typename?: 'instacart_logistics_v1_UpdateRestrictedAvailabilityEventsResponse';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated parent event, includes paginated child events */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** The pagination information for the child events */
  paginationInstruction?: Maybe<Instacart_Logistics_V1_PaginationInstruction>;
};

/** Request to update an existing SLA exclusion record */
export type Instacart_Logistics_V1_UpdateSlaExclusionRequest_Input = {
  /** The ID of the SLA exclusion to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** Updated severity level */
  severityLevel?: InputMaybe<Instacart_Logistics_V1_FulfillmentEventSeverityLevel>;
  /** Email of the ops user making the update */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Response to update an SLA exclusion record */
export type Instacart_Logistics_V1_UpdateSlaExclusionResponse = {
  __typename?: 'instacart_logistics_v1_UpdateSlaExclusionResponse';
  /** Error messages, if any */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The updated SLA exclusion record */
  slaExclusion?: Maybe<Instacart_Logistics_V1_SlaExclusionData>;
};

/** Request to validate a closure event */
export type Instacart_Logistics_V1_ValidateNewClosureEventRequest_Input = {
  /** The event data that is specific to closure events */
  closureData?: InputMaybe<Instacart_Logistics_V1_ClosureFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
};

/** Response to validate a closure event */
export type Instacart_Logistics_V1_ValidateNewClosureEventResponse = {
  __typename?: 'instacart_logistics_v1_ValidateNewClosureEventResponse';
  /** Any errors that occurred during validation */
  errors?: Maybe<Array<Maybe<Instacart_Logistics_V1_ValidationError>>>;
  /** The validated or created event */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** A list of locations, with names and ids */
  locations?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>>>;
  /** Does the event require approval? */
  requiresApproval?: Maybe<Scalars['Boolean']>;
  /** Is the event valid? */
  valid?: Maybe<Scalars['Boolean']>;
};

/** Parameters needed for validating new fulfillment capacity impacting events */
export type Instacart_Logistics_V1_ValidateNewFulfillmentEventRequest_Input = {
  /** The event data that is specific to capacity-impacting events */
  capacityImpactData?: InputMaybe<Instacart_Logistics_V1_CapacityImpactFulfillmentEventData_Input>;
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
};

/** Returns the validated or created event and any errors */
export type Instacart_Logistics_V1_ValidateNewFulfillmentEventResponse = {
  __typename?: 'instacart_logistics_v1_ValidateNewFulfillmentEventResponse';
  /** Any errors that occurred during validation */
  errors?: Maybe<Array<Maybe<Instacart_Logistics_V1_ValidationError>>>;
  /** Data for the new parent event */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** A list of locations, with names and ids */
  locations?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>>>;
  /** Does the event require approval? */
  requiresApproval?: Maybe<Scalars['Boolean']>;
  /** Is the event valid? */
  valid?: Maybe<Scalars['Boolean']>;
};

/** Request to validate a restricted availability event */
export type Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventRequest_Input = {
  /** The event data that is shared among all events */
  eventData?: InputMaybe<Instacart_Logistics_V1_BasicNewFulfillmentEventData_Input>;
  /** The event data that is specific to restricted availability events */
  restrictedAvailabilityData?: InputMaybe<Instacart_Logistics_V1_RestrictedAvailabilityFulfillmentEventData_Input>;
};

/** Response to validate a restricted availability event */
export type Instacart_Logistics_V1_ValidateNewRestrictedAvailabilityEventResponse = {
  __typename?: 'instacart_logistics_v1_ValidateNewRestrictedAvailabilityEventResponse';
  /** Any errors that occurred during validation */
  errors?: Maybe<Array<Maybe<Instacart_Logistics_V1_ValidationError>>>;
  /** The validated or created event */
  event?: Maybe<Instacart_Logistics_V1_FulfillmentEventData>;
  /** A list of locations, with names and ids */
  locations?: Maybe<Array<Maybe<Instacart_Logistics_V1_FulfillmentEventLocationData>>>;
  /** Does the event require approval? */
  requiresApproval?: Maybe<Scalars['Boolean']>;
  /** Is the event valid? */
  valid?: Maybe<Scalars['Boolean']>;
};

/** Validation error messages for a field, one field might have more than one error */
export type Instacart_Logistics_V1_ValidationError = {
  __typename?: 'instacart_logistics_v1_ValidationError';
  /** The error messages */
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The name of the field with the error, corresponds to the field name in FulfillmentEventData */
  fieldName?: Maybe<Scalars['String']>;
};

/** AgentToolCall describes a single tool invocation by the MassOps AI agent. */
export type Instacart_Massops_V1_AgentToolCall = {
  __typename?: 'instacart_massops_v1_AgentToolCall';
  /** Summary of the tool's output */
  result?: Maybe<Scalars['String']>;
  /** Name of the tool called (e.g. "list_intervention_types") */
  toolName?: Maybe<Scalars['String']>;
};

/** AggregationPeriod defines the time period for data aggregation. */
export enum Instacart_Massops_V1_AggregationPeriod {
  /** Aggregate by month */
  AggregationPeriodMonth = 'AGGREGATION_PERIOD_MONTH',
  /** Aggregate by quarter */
  AggregationPeriodQuarter = 'AGGREGATION_PERIOD_QUARTER',
  /** Default unknown value */
  AggregationPeriodUnknown = 'AGGREGATION_PERIOD_UNKNOWN',
  /** Aggregate by week */
  AggregationPeriodWeek = 'AGGREGATION_PERIOD_WEEK'
}

/**
 * AllowedValueOption represents a single allowed value option for a allowed value.
 * It pairs a display label (for UI presentation) with the underlying value that will be used in execution.
 */
export type Instacart_Massops_V1_AllowedValueOption = {
  __typename?: 'instacart_massops_v1_AllowedValueOption';
  /** Display label for the allowed value */
  description?: Maybe<Scalars['String']>;
  /** Arbitrary key-value pairs for option-specific display hints (e.g. "is_unexpiring": "true") */
  metadata?: Maybe<Scalars['JSON']>;
  /** The underlying value (can be string, number, boolean, etc.) */
  value?: Maybe<Scalars['String']>;
};

/** Artifact represents an external reference or artifact associated with an intervention. */
export type Instacart_Massops_V1_Artifact = {
  __typename?: 'instacart_massops_v1_Artifact';
  /** The artifact reference (e.g., ticket ID, incident ID) */
  reference?: Maybe<Scalars['String']>;
  /** The type of artifact */
  type?: Maybe<Instacart_Massops_V1_ArtifactType>;
};

/** ArtifactType defines the type of artifact associated with an intervention. */
export enum Instacart_Massops_V1_ArtifactType {
  /** Incident report */
  ArtifactTypeIncident = 'ARTIFACT_TYPE_INCIDENT',
  /** JIRA ticket */
  ArtifactTypeJira = 'ARTIFACT_TYPE_JIRA',
  /** Other artifact type */
  ArtifactTypeOther = 'ARTIFACT_TYPE_OTHER',
  /** Default unknown value */
  ArtifactTypeUnknown = 'ARTIFACT_TYPE_UNKNOWN'
}

/** ArtifactTypeCounts contains the count of interventions for each artifact type. */
export type Instacart_Massops_V1_ArtifactTypeCounts = {
  __typename?: 'instacart_massops_v1_ArtifactTypeCounts';
  /** Count of incident-related interventions */
  incident?: Maybe<Scalars['BigInt']>;
  /** Count of JIRA-related interventions */
  jira?: Maybe<Scalars['BigInt']>;
  /** Count of other artifact type interventions */
  other?: Maybe<Scalars['BigInt']>;
  /** Count of interventions with unknown artifact type */
  unknown?: Maybe<Scalars['BigInt']>;
};

/** ArtifactTypeTimeSeries represents counts by artifact type for a single time period. */
export type Instacart_Massops_V1_ArtifactTypeTimeSeries = {
  __typename?: 'instacart_massops_v1_ArtifactTypeTimeSeries';
  /** Counts for each artifact type in this period */
  counts?: Maybe<Instacart_Massops_V1_ArtifactTypeCounts>;
  /** The end of the time period */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The start of the time period (e.g., start of week, month, or quarter) */
  startDate?: Maybe<Scalars['DateTime']>;
};

/** Artifact represents an external reference or artifact associated with an intervention. */
export type Instacart_Massops_V1_Artifact_Input = {
  /** The artifact reference (e.g., ticket ID, incident ID) */
  reference?: InputMaybe<Scalars['String']>;
  /** The type of artifact */
  type?: InputMaybe<Instacart_Massops_V1_ArtifactType>;
};

/** BundleApprovalRequest describes one approval request associated with a bundle. */
export type Instacart_Massops_V1_BundleApprovalRequest = {
  __typename?: 'instacart_massops_v1_BundleApprovalRequest';
  /** Identifier of the approval request. */
  approvalRequestId?: Maybe<Scalars['String']>;
  /** Current state of the approval as reported by the approval service. */
  approvalState?: Maybe<Scalars['String']>;
  /** Version of the specific dimension this request approved. */
  approvedVersion?: Maybe<Scalars['BigInt']>;
  /** Kind of resource the approval targets. */
  resourceType?: Maybe<Instacart_Massops_V1_BundleResourceType>;
  /** Bundle version the request was raised against. */
  resourceVersion?: Maybe<Scalars['BigInt']>;
};

/** BundleResourceType identifies what kind of resource an approval request targets. */
export enum Instacart_Massops_V1_BundleResourceType {
  BundleResourceTypeIntervention = 'BUNDLE_RESOURCE_TYPE_INTERVENTION',
  BundleResourceTypeInterventionBundle = 'BUNDLE_RESOURCE_TYPE_INTERVENTION_BUNDLE',
  BundleResourceTypeUnknown = 'BUNDLE_RESOURCE_TYPE_UNKNOWN'
}

/** BundleState is the approval lifecycle of an intervention bundle. */
export enum Instacart_Massops_V1_BundleState {
  /** All required approvals granted; usable. */
  BundleStateApproved = 'BUNDLE_STATE_APPROVED',
  /** Created; no approval requested yet. */
  BundleStateDraft = 'BUNDLE_STATE_DRAFT',
  /** Approval requested; awaiting decision. */
  BundleStatePendingApproval = 'BUNDLE_STATE_PENDING_APPROVAL',
  /** At least one required approval was rejected. */
  BundleStateRejected = 'BUNDLE_STATE_REJECTED',
  BundleStateUnknown = 'BUNDLE_STATE_UNKNOWN'
}

/** CancelInterventionRequest is the request message for canceling an intervention. */
export type Instacart_Massops_V1_CancelInterventionRequest_Input = {
  /** The UUID of the intervention to cancel */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** CancelInterventionResponse is the response message for successful cancellation. */
export type Instacart_Massops_V1_CancelInterventionResponse = {
  __typename?: 'instacart_massops_v1_CancelInterventionResponse';
  /** The canceled intervention with updated state and canceled_at timestamp */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/** ChatWithAgentRequest is the request message for interacting with the MassOps AI agent. */
export type Instacart_Massops_V1_ChatWithAgentRequest_Input = {
  /** Conversation ID for multi-turn continuity (caller-managed) */
  conversationId?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** The user's message text */
  userMessage?: InputMaybe<Scalars['String']>;
};

/** ChatWithAgentResponse contains the agent's reply and metadata for follow-up turns. */
export type Instacart_Massops_V1_ChatWithAgentResponse = {
  __typename?: 'instacart_massops_v1_ChatWithAgentResponse';
  /** Conversation ID for multi-turn continuity (caller-managed) */
  conversationId?: Maybe<Scalars['String']>;
  /** The agent's natural-language reply to the user */
  response?: Maybe<Scalars['String']>;
  /** Tools invoked during processing, for transparency and debugging */
  toolCalls?: Maybe<Array<Maybe<Instacart_Massops_V1_AgentToolCall>>>;
};

/**
 * CommunicationSettings configures notification settings for an intervention.
 * It includes email and SMS notification configurations with multi-locale support.
 */
export type Instacart_Massops_V1_CommunicationSettings = {
  __typename?: 'instacart_massops_v1_CommunicationSettings';
  /** Email notification configuration */
  email?: Maybe<Instacart_Massops_V1_EmailSettings>;
  /** SMS notification configuration */
  sms?: Maybe<Instacart_Massops_V1_SmsSettings>;
};

/**
 * CommunicationSettings configures notification settings for an intervention.
 * It includes email and SMS notification configurations with multi-locale support.
 */
export type Instacart_Massops_V1_CommunicationSettings_Input = {
  /** Email notification configuration */
  email?: InputMaybe<Instacart_Massops_V1_EmailSettings_Input>;
  /** SMS notification configuration */
  sms?: InputMaybe<Instacart_Massops_V1_SmsSettings_Input>;
};

/** CommunicationTemplate is one versioned, independently-approvable communication within a bundle. */
export type Instacart_Massops_V1_CommunicationTemplate = {
  __typename?: 'instacart_massops_v1_CommunicationTemplate';
  /** Identifier of the approval request for this template, if any. */
  approvalRequestUuid?: Maybe<Scalars['String']>;
  /** Reviewable content and delivery configuration. */
  communicationSettings?: Maybe<Instacart_Massops_V1_CommunicationSettings>;
  /** Subset of the bundle's intervention_type_ids this template applies to. */
  impactedInterventionTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Stable identifier for this template within its bundle. */
  key?: Maybe<Scalars['String']>;
  /** Whether this template requires legal review. */
  legalRequired?: Maybe<Scalars['Boolean']>;
  /** Incremented when communication_settings change. */
  version?: Maybe<Scalars['BigInt']>;
};

/** CommunicationTemplate is one versioned, independently-approvable communication within a bundle. */
export type Instacart_Massops_V1_CommunicationTemplate_Input = {
  /** Identifier of the approval request for this template, if any. */
  approvalRequestUuid?: InputMaybe<Scalars['String']>;
  /** Reviewable content and delivery configuration. */
  communicationSettings?: InputMaybe<Instacart_Massops_V1_CommunicationSettings_Input>;
  /** Subset of the bundle's intervention_type_ids this template applies to. */
  impactedInterventionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Stable identifier for this template within its bundle. */
  key?: InputMaybe<Scalars['String']>;
  /** Whether this template requires legal review. */
  legalRequired?: InputMaybe<Scalars['Boolean']>;
  /** Incremented when communication_settings change. */
  version?: InputMaybe<Scalars['BigInt']>;
};

/** CreateInterventionBundleRequest is the request message for creating a new intervention bundle in draft state. */
export type Instacart_Massops_V1_CreateInterventionBundleRequest_Input = {
  /** Communication templates carried by this bundle. */
  communicationTemplates?: InputMaybe<Array<InputMaybe<Instacart_Massops_V1_CommunicationTemplate_Input>>>;
  /** Description of the bundle's purpose and remediation. */
  description?: InputMaybe<Scalars['String']>;
  /** Estimated total financial impact used for approval routing. */
  estimatedFinancialImpactTotal?: InputMaybe<GoogleTypeMoneyInput>;
  /** Whether the bundle impacts customers, shoppers, etc. */
  impactedUserTypes?: InputMaybe<Instacart_Massops_V1_ImpactedUserTypes>;
  /** Intervention type IDs the bundle can spawn from. */
  interventionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** User opt-in for legal review (in addition to legal_required templates). */
  legalApprovalOptIn?: InputMaybe<Scalars['Boolean']>;
  /** Human-readable name of the bundle. */
  name?: InputMaybe<Scalars['String']>;
  /** Non-communication configuration for the bundle. */
  params?: InputMaybe<Scalars['JSON']>;
  /** Required context for the request. */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** CreateInterventionBundleResponse is the response message for a successful bundle creation. */
export type Instacart_Massops_V1_CreateInterventionBundleResponse = {
  __typename?: 'instacart_massops_v1_CreateInterventionBundleResponse';
  /** The UUID of the newly created bundle. */
  bundleUuid?: Maybe<Scalars['String']>;
  /** When the bundle was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
};

/** CreateInterventionFromBundleRequest is the request message for spawning a concrete intervention from an approved bundle. */
export type Instacart_Massops_V1_CreateInterventionFromBundleRequest_Input = {
  /**
   * The UUID of the source bundle.
   * The intervention type to instantiate; must be one of the source bundle's allowed intervention_type_ids.
   */
  bundleUuid?: InputMaybe<Scalars['String']>;
  /** Description of the spawned intervention. */
  description?: InputMaybe<Scalars['String']>;
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** User-friendly name for the spawned intervention. */
  name?: InputMaybe<Scalars['String']>;
  /** Required context for the request. */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** CSV content containing the task rows for the spawned intervention. */
  taskData?: InputMaybe<Scalars['String']>;
};

/** CreateInterventionFromBundleResponse contains the spawned intervention's metadata. */
export type Instacart_Massops_V1_CreateInterventionFromBundleResponse = {
  __typename?: 'instacart_massops_v1_CreateInterventionFromBundleResponse';
  /** When the intervention was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the newly spawned intervention. */
  interventionUuid?: Maybe<Scalars['String']>;
};

/** CreateInterventionRequest is the request message for creating a new intervention. */
export type Instacart_Massops_V1_CreateInterventionRequest_Input = {
  /** Artifact associated with this intervention */
  artifact?: InputMaybe<Instacart_Massops_V1_Artifact_Input>;
  /** Description of what this intervention will do */
  description?: InputMaybe<Scalars['String']>;
  /** The type of intervention to create */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** User-friendly name for the intervention */
  name?: InputMaybe<Scalars['String']>;
  /** Parameters for the intervention (must match required_intervention_params) */
  params?: InputMaybe<Scalars['JSON']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** skipped step ids */
  skippedStepIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** CreateInterventionResponse contains the created intervention's metadata. */
export type Instacart_Massops_V1_CreateInterventionResponse = {
  __typename?: 'instacart_massops_v1_CreateInterventionResponse';
  /** When the intervention was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The UUID of the newly created intervention */
  interventionUuid?: Maybe<Scalars['String']>;
};

/** DownloadInterventionDataRequest is the request message for downloading intervention CSV data. */
export type Instacart_Massops_V1_DownloadInterventionDataRequest_Input = {
  /** The UUID of the intervention to download data for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** DownloadInterventionDataResponse contains the presigned URL to download the full CSV data. */
export type Instacart_Massops_V1_DownloadInterventionDataResponse = {
  __typename?: 'instacart_massops_v1_DownloadInterventionDataResponse';
  /** Presigned URL to download the CSV data file */
  url?: Maybe<Scalars['String']>;
};

/** Filter to apply to the task export */
export type Instacart_Massops_V1_DownloadInterventionTasksCsvRequest_Filter_Input = {
  /**
   * Filter by task states
   * If multiple states are provided, filters using OR logic
   * If none is provided, no state filter is applied
   */
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * Filter by specific task param names to export
   * If multiple param names are provided, filters using OR logic
   * If none is provided, no task param name filter is applied
   * When combined with states, applies AND semantics: only tasks matching both a state and a param name are exported
   */
  taskParamNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** DownloadInterventionTasksCSVRequest is the request message for downloading intervention tasks as a CSV. */
export type Instacart_Massops_V1_DownloadInterventionTasksCsvRequest_Input = {
  /** Optional filter to apply to the task export */
  filter?: InputMaybe<Instacart_Massops_V1_DownloadInterventionTasksCsvRequest_Filter_Input>;
  /** When true, the exported CSV includes only task parameter columns, omitting execution detail columns (e.g. state, timestamps, step results) */
  includeTaskParamOnly?: InputMaybe<Scalars['Boolean']>;
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** DownloadInterventionTasksCSVResponse contains the presigned URL to download the tasks CSV. */
export type Instacart_Massops_V1_DownloadInterventionTasksCsvResponse = {
  __typename?: 'instacart_massops_v1_DownloadInterventionTasksCSVResponse';
  /** Presigned URL to download the tasks CSV file */
  url?: Maybe<Scalars['String']>;
};

/** DownloadValidationFailuresRequest is the request message for downloading full validation failure records. */
export type Instacart_Massops_V1_DownloadValidationFailuresRequest_Input = {
  /** The name of the validation check to download failures for */
  checkName?: InputMaybe<Scalars['String']>;
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** DownloadValidationFailuresResponse contains the presigned URL to download the full violations CSV. */
export type Instacart_Massops_V1_DownloadValidationFailuresResponse = {
  __typename?: 'instacart_massops_v1_DownloadValidationFailuresResponse';
  /** Presigned S3 URL to download the violations CSV */
  url?: Maybe<Scalars['String']>;
};

/**
 * DropFailingRowsAndRegenRequest is the request message for dropping the CSV rows flagged
 * by drop-eligible validation checks and re-triggering validation.
 */
export type Instacart_Massops_V1_DropFailingRowsAndRegenRequest_Input = {
  /** The UUID of the intervention whose failing rows should be dropped */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** If set, only rows failing these specific validation steps are dropped; if empty, all drop-eligible failing rows are dropped */
  selectedValidationSteps?: InputMaybe<Array<InputMaybe<Instacart_Massops_V1_ValidationFinding_Input>>>;
};

/** DropFailingRowsAndRegenResponse reports how many CSV rows were dropped and how many remain. */
export type Instacart_Massops_V1_DropFailingRowsAndRegenResponse = {
  __typename?: 'instacart_massops_v1_DropFailingRowsAndRegenResponse';
  /** Number of CSV data rows dropped */
  rowsDropped?: Maybe<Scalars['BigInt']>;
  /** Number of CSV data rows remaining after the drop */
  rowsRemaining?: Maybe<Scalars['BigInt']>;
};

/** EmailSettings configures email notifications with multi-locale support. */
export type Instacart_Massops_V1_EmailSettings = {
  __typename?: 'instacart_massops_v1_EmailSettings';
  /**
   * Locale-specific email content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content?: Maybe<Scalars['JSON']>;
  /** Whether email notifications are enabled */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Whitelabel-specific email content override
   * Key = whitelabel_id as a string (e.g., "2"), value overrides default content for that whitelabel
   */
  whitelabelContent?: Maybe<Scalars['JSON']>;
};

/** EmailSettings configures email notifications with multi-locale support. */
export type Instacart_Massops_V1_EmailSettings_Input = {
  /**
   * Locale-specific email content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content?: InputMaybe<Scalars['JSON']>;
  /** Whether email notifications are enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Whitelabel-specific email content override
   * Key = whitelabel_id as a string (e.g., "2"), value overrides default content for that whitelabel
   */
  whitelabelContent?: InputMaybe<Scalars['JSON']>;
};

/**
 * EstimatedImpact contains pre-execution estimates for an intervention.
 * Populated from the pre-execution summary; present when computed.
 */
export type Instacart_Massops_V1_EstimatedImpact = {
  __typename?: 'instacart_massops_v1_EstimatedImpact';
  /** Estimated financial impact; present only when intervention type has financial impact */
  financialImpact?: Maybe<Instacart_Massops_V1_FinancialImpactSummary>;
  /** Number of unique orders affected; 0 if not applicable */
  impactedOrderCount?: Maybe<Scalars['BigInt']>;
  /** Number of unique users affected; 0 if not applicable */
  impactedUserCount?: Maybe<Scalars['BigInt']>;
};

/** ExecuteInterventionQueryRequest is the request message for executing a query for an intervention. */
export type Instacart_Massops_V1_ExecuteInterventionQueryRequest_Input = {
  /** The UUID of the intervention to associate the query with */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** The query to execute; may contain :name and :name[] placeholders */
  query?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** Values for :name placeholders in the query template */
  variables?: InputMaybe<Scalars['JSON']>;
};

/** ExecuteInterventionQueryResponse contains the refreshed intervention and query execution status. */
export type Instacart_Massops_V1_ExecuteInterventionQueryResponse = {
  __typename?: 'instacart_massops_v1_ExecuteInterventionQueryResponse';
  /** Current status of the query execution */
  executionStatus?: Maybe<Instacart_Massops_V1_QueryExecutionStatus>;
  /** The refreshed intervention after query execution */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/** ExecuteInterventionRequest is the request message for starting an intervention's execution. */
export type Instacart_Massops_V1_ExecuteInterventionRequest_Input = {
  /** The UUID of the intervention to execute */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ExecuteInterventionResponse is the response message for successful execution start. */
export type Instacart_Massops_V1_ExecuteInterventionResponse = {
  __typename?: 'instacart_massops_v1_ExecuteInterventionResponse';
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * ExecutionMetadata tracks the progress and status of an intervention's execution.
 * It provides counters for tasks in various states.
 */
export type Instacart_Massops_V1_ExecutionMetadata = {
  __typename?: 'instacart_massops_v1_ExecutionMetadata';
  /** Average duration per task in milliseconds */
  avgDurationPerTaskMs?: Maybe<Scalars['Float']>;
  /** Number of tasks that are brand new */
  brandNewTasksCount?: Maybe<Scalars['BigInt']>;
  /** Number of tasks successfully completed */
  completedTasksCount?: Maybe<Scalars['BigInt']>;
  /** Number of tasks currently being executed */
  executingTasksCount?: Maybe<Scalars['BigInt']>;
  /** Number of tasks that failed during execution */
  failedTasksCount?: Maybe<Scalars['BigInt']>;
  /** Number of tasks that were skipped */
  skippedTasksCount?: Maybe<Scalars['BigInt']>;
  /** Total execution duration in milliseconds */
  totalDurationMs?: Maybe<Scalars['BigInt']>;
  /** Total number of tasks in the intervention */
  totalTasksCount?: Maybe<Scalars['BigInt']>;
};

/**
 * ExecutionSummary contains post-execution results for an intervention.
 * Populated after execution completes; reflects actual realized impact.
 */
export type Instacart_Massops_V1_ExecutionSummary = {
  __typename?: 'instacart_massops_v1_ExecutionSummary';
  /** Actual financial impact from completed tasks; present when intervention type has financial impact */
  financialImpact?: Maybe<Instacart_Massops_V1_FinancialImpactSummary>;
  /** Timestamp when this summary was generated */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** List of locale codes affected (e.g., "en_US", "fr_CA") from actual execution data */
  impactedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Actual number of unique orders affected */
  impactedOrderCount?: Maybe<Scalars['BigInt']>;
  /** Actual number of unique users affected */
  impactedUserCount?: Maybe<Scalars['BigInt']>;
  /** Post-execution warning messages (e.g., "financial impact exceeded estimate by 20%") */
  warningMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** FinancialImpactStatus defines the status of financial impact for an intervention. */
export enum Instacart_Massops_V1_FinancialImpactStatus {
  /** Financial impact known and estimated amounts are populated */
  FinancialImpactStatusEstimated = 'FINANCIAL_IMPACT_STATUS_ESTIMATED',
  /** Has financial impact but cannot be estimated pre-execution */
  FinancialImpactStatusIndeterminate = 'FINANCIAL_IMPACT_STATUS_INDETERMINATE',
  /** No financial impact */
  FinancialImpactStatusNone = 'FINANCIAL_IMPACT_STATUS_NONE',
  /** Default unknown value */
  FinancialImpactStatusUnknown = 'FINANCIAL_IMPACT_STATUS_UNKNOWN'
}

/**
 * FinancialSummary contains monetary impact analysis for the intervention.
 * This provides a pre-execution estimate based on uploaded data and intervention parameters.
 */
export type Instacart_Massops_V1_FinancialImpactSummary = {
  __typename?: 'instacart_massops_v1_FinancialImpactSummary';
  /** Estimated financial impact grouped by currency code (e.g., "USD", "CAD") */
  estimatedImpactByCurrency?: Maybe<Scalars['JSON']>;
  /** Financial impact status (none/estimated/indeterminate) */
  status?: Maybe<Instacart_Massops_V1_FinancialImpactStatus>;
  /** Total estimated financial impact converted to USD across all currencies */
  totalEstimatedImpact?: Maybe<GoogleTypeMoney>;
  /** warning message for financial impact */
  warningMessage?: Maybe<Scalars['String']>;
};

/** IncidentFilter contains essential query parameters for filtering incidents. */
export type Instacart_Massops_V1_GetIncidentRequest_IncidentFilter_Input = {
  /** Slack channel filter */
  slackChannelName?: InputMaybe<Scalars['String']>;
};

/** GetIncidentRequest is the request message for getting a single incident from the incident service. */
export type Instacart_Massops_V1_GetIncidentRequest_Input = {
  /** Filter criteria for incidents */
  filter?: InputMaybe<Instacart_Massops_V1_GetIncidentRequest_IncidentFilter_Input>;
  /** Request context */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetIncidentResponse contains a single incident. */
export type Instacart_Massops_V1_GetIncidentResponse = {
  __typename?: 'instacart_massops_v1_GetIncidentResponse';
  /** The incident matching the filter */
  incident?: Maybe<Instacart_Massops_V1_Incident>;
};

/** GetInterventionBundleRequest is the request message for retrieving a single intervention bundle. */
export type Instacart_Massops_V1_GetInterventionBundleRequest_Input = {
  /** The UUID of the bundle to retrieve. */
  bundleUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request. */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionBundleResponse contains the requested intervention bundle. */
export type Instacart_Massops_V1_GetInterventionBundleResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionBundleResponse';
  /** Active approval requests associated with the bundle. */
  approvalRequests?: Maybe<Array<Maybe<Instacart_Massops_V1_BundleApprovalRequest>>>;
  /** The requested bundle with all its details. */
  interventionBundle?: Maybe<Instacart_Massops_V1_InterventionBundle>;
};

/** GetInterventionCommunicationSettingsRequest is the request message for retrieving communication settings. */
export type Instacart_Massops_V1_GetInterventionCommunicationSettingsRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCommunicationSettingsResponse contains the communication settings for an intervention. */
export type Instacart_Massops_V1_GetInterventionCommunicationSettingsResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCommunicationSettingsResponse';
  /** The communication settings for the intervention */
  communicationSettings?: Maybe<Instacart_Massops_V1_CommunicationSettings>;
};

/** GetInterventionCountsByArtifactTypeRequest is the request message for retrieving intervention counts by artifact type. */
export type Instacart_Massops_V1_GetInterventionCountsByArtifactTypeRequest_Input = {
  /** Filter for time range and aggregation period */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCountsByArtifactTypeResponse contains intervention counts grouped by artifact type over time. */
export type Instacart_Massops_V1_GetInterventionCountsByArtifactTypeResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCountsByArtifactTypeResponse';
  /** Time series data points, one for each aggregation period */
  timeSeries?: Maybe<Array<Maybe<Instacart_Massops_V1_ArtifactTypeTimeSeries>>>;
};

/** GetInterventionCountsByIncidentRequest is the request message for retrieving incident-related intervention counts. */
export type Instacart_Massops_V1_GetInterventionCountsByIncidentRequest_Input = {
  /** Filter for time range and aggregation period */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCountsByIncidentResponse contains incident-related intervention counts grouped by incident. */
export type Instacart_Massops_V1_GetInterventionCountsByIncidentResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCountsByIncidentResponse';
  /** Time series data points, one for each aggregation period */
  timeSeries?: Maybe<Array<Maybe<Instacart_Massops_V1_IncidentEventTimeSeries>>>;
  /** Total incident-related interventions across the entire selected time range */
  totalIncidentRelated?: Maybe<Scalars['BigInt']>;
};

/** GetInterventionCountsByInterventionTypeRequest is the request message for retrieving intervention counts by intervention type. */
export type Instacart_Massops_V1_GetInterventionCountsByInterventionTypeRequest_Input = {
  /** Filter for time range and aggregation period */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionCountsByInterventionTypeResponse contains intervention counts categorized by incident-related and non-incident-related types over time. */
export type Instacart_Massops_V1_GetInterventionCountsByInterventionTypeResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionCountsByInterventionTypeResponse';
  /** Time series data points, one for each aggregation period */
  timeSeries?: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionCategoryTimeSeries>>>;
  /** Overall totals across the entire selected time range */
  totalIncidentRelated?: Maybe<Scalars['BigInt']>;
  totalNonIncidentRelated?: Maybe<Scalars['BigInt']>;
};

/** GetInterventionEmailContentUsageRequest carries the intervention UUID to look up. */
export type Instacart_Massops_V1_GetInterventionEmailContentUsageRequest_Input = {
  interventionUuid?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/**
 * GetInterventionEmailContentUsageResponse indicates which email template types the intervention requires.
 * Both fields may be true when the intervention requires both Instacart-based and retailer-based email templates.
 */
export type Instacart_Massops_V1_GetInterventionEmailContentUsageResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionEmailContentUsageResponse';
  useInstacartBasedEmail?: Maybe<Scalars['Boolean']>;
  useRetailerBasedEmail?: Maybe<Scalars['Boolean']>;
};

/**
 * GetInterventionPreExecutionSummaryRequest is the request message for retrieving
 * the pre-execution summary for a specific intervention.
 */
export type Instacart_Massops_V1_GetInterventionPreExecutionSummaryRequest_Input = {
  /** The UUID of the intervention to retrieve the summary for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionPreExecutionSummaryResponse contains the pre-execution summary for an intervention. */
export type Instacart_Massops_V1_GetInterventionPreExecutionSummaryResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionPreExecutionSummaryResponse';
  /** The pre-execution summary with estimated impact and validation results */
  preExecutionSummary?: Maybe<Instacart_Massops_V1_PreExecutionSummary>;
};

/**
 * GetInterventionQueryExecutionDetailRequest is the request message for retrieving
 * the latest query execution detail for an intervention.
 */
export type Instacart_Massops_V1_GetInterventionQueryExecutionDetailRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionQueryExecutionDetailResponse contains the executed query string and its current execution status. */
export type Instacart_Massops_V1_GetInterventionQueryExecutionDetailResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionQueryExecutionDetailResponse';
  /** Error returned by when execution_status is FAILED */
  executionError?: Maybe<Scalars['String']>;
  /** Current status of the query execution */
  executionStatus?: Maybe<Instacart_Massops_V1_QueryExecutionStatus>;
  /** The query string that was executed */
  query?: Maybe<Scalars['String']>;
  /** Error from query validation, e.g. PII checks */
  validationError?: Maybe<Scalars['String']>;
};

/** GetInterventionRequest is the request message for retrieving a specific intervention. */
export type Instacart_Massops_V1_GetInterventionRequest_Input = {
  /** The UUID of the intervention to retrieve */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionResponse contains the requested intervention details. */
export type Instacart_Massops_V1_GetInterventionResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionResponse';
  /** The requested intervention with all its details */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/** GetInterventionStatisticsRequest is the request message for retrieving intervention statistics. */
export type Instacart_Massops_V1_GetInterventionStatisticsRequest_Input = {
  /** Optional filter for statistics */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionStatisticsResponse contains aggregate statistics about interventions. */
export type Instacart_Massops_V1_GetInterventionStatisticsResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionStatisticsResponse';
  /** Total counts for each intervention workflow state */
  stateCounts?: Maybe<Instacart_Massops_V1_InterventionStateCounts>;
  timeSeries?: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionStateTimeSeries>>>;
  /**
   * Total number of interventions in the date range
   * Time series data points, one for each aggregation period
   */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/**
 * GetInterventionTypeIdForInterventionRequest is the request message for retrieving
 * the intervention type ID for an intervention UUID.
 */
export type Instacart_Massops_V1_GetInterventionTypeIdForInterventionRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionTypeIdForInterventionResponse contains the intervention type ID. */
export type Instacart_Massops_V1_GetInterventionTypeIdForInterventionResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionTypeIdForInterventionResponse';
  /** The intervention type ID */
  interventionTypeId?: Maybe<Scalars['String']>;
};

/** GetInterventionTypeRequest is the request message for retrieving a specific intervention type. */
export type Instacart_Massops_V1_GetInterventionTypeRequest_Input = {
  /** The ID of the intervention type to retrieve */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetInterventionTypeResponse contains the requested intervention type details. */
export type Instacart_Massops_V1_GetInterventionTypeResponse = {
  __typename?: 'instacart_massops_v1_GetInterventionTypeResponse';
  /** The requested intervention type */
  interventionType?: Maybe<Instacart_Massops_V1_InterventionType>;
};

/** GetNotificationTemplateRequest is the request message for retrieving a notification template. */
export type Instacart_Massops_V1_GetNotificationTemplateRequest_Input = {
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
  /** Template ID to retrieve */
  templateId?: InputMaybe<Scalars['String']>;
};

/** GetNotificationTemplateResponse contains the full notification template details. */
export type Instacart_Massops_V1_GetNotificationTemplateResponse = {
  __typename?: 'instacart_massops_v1_GetNotificationTemplateResponse';
  /** Full template details */
  template?: Maybe<Instacart_Massops_V1_NotificationTemplate>;
};

/**
 * GetTotalFinancialImpactRequest is the request message for retrieving
 * the total financial impact across interventions.
 */
export type Instacart_Massops_V1_GetTotalFinancialImpactRequest_Input = {
  /** Optional filter for time range (e.g., start_date, end_date) */
  filter?: InputMaybe<Instacart_Massops_V1_InterventionStatisticFilter_Input>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** GetTotalFinancialImpactResponse contains the total financial impact. */
export type Instacart_Massops_V1_GetTotalFinancialImpactResponse = {
  __typename?: 'instacart_massops_v1_GetTotalFinancialImpactResponse';
  /** Breakdown by currency code (e.g., "USD", "CAD") */
  impactByCurrency?: Maybe<Scalars['JSON']>;
  /** Threshold values for monthly, quarterly, yearly periods */
  threshold?: Maybe<Instacart_Massops_V1_Threshold>;
  /** Total aggregated financial impact (typically in USD) */
  totalFinancialImpact?: Maybe<GoogleTypeMoney>;
};

/** ImpactedUserTypes classifies who a bundle's remediation impacts. */
export enum Instacart_Massops_V1_ImpactedUserTypes {
  ImpactedUserTypesCustomer = 'IMPACTED_USER_TYPES_CUSTOMER',
  ImpactedUserTypesShopper = 'IMPACTED_USER_TYPES_SHOPPER',
  ImpactedUserTypesUnknown = 'IMPACTED_USER_TYPES_UNKNOWN'
}

/** Incident represents an incident from the incident service. */
export type Instacart_Massops_V1_Incident = {
  __typename?: 'instacart_massops_v1_Incident';
  /** Timestamps */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Core incident fields */
  id?: Maybe<Scalars['String']>;
  incidentName?: Maybe<Scalars['String']>;
  incidentStatus?: Maybe<Scalars['String']>;
  /** URL to view the incident */
  incidentUrl?: Maybe<Scalars['String']>;
  severity?: Maybe<Scalars['Int']>;
  /** Slack integration */
  slackChannelName?: Maybe<Scalars['String']>;
};

/** IncidentEventCounts contains the count of events for a specific incident. */
export type Instacart_Massops_V1_IncidentEventCounts = {
  __typename?: 'instacart_massops_v1_IncidentEventCounts';
  /** The incident name/reference (e.g., incident ID or Jira key) */
  incidentReference?: Maybe<Scalars['String']>;
  /** Total interventions for this specific incident */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** IncidentEventTimeSeries represents incident-related counts for a single time period. */
export type Instacart_Massops_V1_IncidentEventTimeSeries = {
  __typename?: 'instacart_massops_v1_IncidentEventTimeSeries';
  endDate?: Maybe<Scalars['DateTime']>;
  incidentCounts?: Maybe<Array<Maybe<Instacart_Massops_V1_IncidentEventCounts>>>;
  startDate?: Maybe<Scalars['DateTime']>;
};

/**
 * Intervention represents an instance of a mass operation that can be executed.
 * It contains the configuration, state, and execution metadata.
 */
export type Instacart_Massops_V1_Intervention = {
  __typename?: 'instacart_massops_v1_Intervention';
  /** Artifact associated with this intervention */
  artifact?: Maybe<Instacart_Massops_V1_Artifact>;
  /** When the intervention execution canceled */
  canceledAt?: Maybe<Scalars['DateTime']>;
  /** When the intervention execution completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** When the intervention was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** ID of the user who created this intervention */
  creatorId?: Maybe<Scalars['String']>;
  /** A flag that shows if intervention has data uploaded */
  dataUploaded?: Maybe<Scalars['Boolean']>;
  /** User-provided description of the intervention's purpose */
  description?: Maybe<Scalars['String']>;
  /** IDs of users who edited or re-uploaded data for this intervention (deduplicated, in first-edit order); distinct from creator_id and executor_id */
  editorIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Pre-execution estimates (impacted users/orders, estimated financial impact); present when computed */
  estimatedImpact?: Maybe<Instacart_Massops_V1_EstimatedImpact>;
  /** When the intervention execution started */
  executedAt?: Maybe<Scalars['DateTime']>;
  /** Execution progress and statistics */
  executionMetadata?: Maybe<Instacart_Massops_V1_ExecutionMetadata>;
  /** Post-execution summary (actual impact); present when execution has completed */
  executionSummary?: Maybe<Instacart_Massops_V1_ExecutionSummary>;
  /** ID of the user who executed this intervention */
  executorId?: Maybe<Scalars['String']>;
  /** The type of intervention this instance is based on */
  interventionTypeId?: Maybe<Scalars['String']>;
  /** User-provided name for this intervention */
  name?: Maybe<Scalars['String']>;
  /** Intervention params */
  params?: Maybe<Scalars['JSON']>;
  /** Intervention execution results */
  result?: Maybe<Scalars['JSON']>;
  /** Step IDs that were skipped during intervention creation */
  skippedStepIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Current state (e.g., pending, executing, completed, failed) */
  state?: Maybe<Scalars['String']>;
  /** When the intervention was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this intervention instance */
  uuid?: Maybe<Scalars['String']>;
};

/**
 * InterventionApprovalRequest represents an approval request associated with an intervention.
 * It matches the database schema for the approval_requests table.
 */
export type Instacart_Massops_V1_InterventionApprovalRequest = {
  __typename?: 'instacart_massops_v1_InterventionApprovalRequest';
  /** Whether this approval request is currently active (boolean) */
  active?: Maybe<Scalars['Boolean']>;
  /** Internal approval request ID */
  approvalRequestId?: Maybe<Scalars['String']>;
  /** When the approval request was created (timestamp) */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Related intervention UUID (varchar) */
  interventionUuid?: Maybe<Scalars['String']>;
  /** When the approval request was last updated (timestamp) */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** InterventionBundle is a reusable intervention template gated on approval before use. */
export type Instacart_Massops_V1_InterventionBundle = {
  __typename?: 'instacart_massops_v1_InterventionBundle';
  bundleState?: Maybe<Instacart_Massops_V1_BundleState>;
  communicationTemplates?: Maybe<Array<Maybe<Instacart_Massops_V1_CommunicationTemplate>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creatorId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estimatedFinancialImpactTotal?: Maybe<GoogleTypeMoney>;
  /** Version scoped to the financial dimension. */
  financialVersion?: Maybe<Scalars['BigInt']>;
  impactedUserTypes?: Maybe<Instacart_Massops_V1_ImpactedUserTypes>;
  interventionTypeIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  /** Non-communication configuration for the bundle. */
  params?: Maybe<Scalars['JSON']>;
  requiresLegalApproval?: Maybe<Scalars['Boolean']>;
  /** When the bundle was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['String']>;
  /** Bundle-wide version, incremented on any change. */
  version?: Maybe<Scalars['BigInt']>;
};

/** InterventionCategoryCounts contains the count of interventions categorized by incident-related and non-incident-related types. */
export type Instacart_Massops_V1_InterventionCategoryCounts = {
  __typename?: 'instacart_massops_v1_InterventionCategoryCounts';
  /** intervention_type_id -> count for incident-related interventions */
  incidentRelated?: Maybe<Scalars['JSON']>;
  /** intervention_type_id -> count for non-incident-related interventions */
  nonIncidentRelated?: Maybe<Scalars['JSON']>;
};

/** InterventionCategoryTimeSeries represents counts by intervention category for a single time period. */
export type Instacart_Massops_V1_InterventionCategoryTimeSeries = {
  __typename?: 'instacart_massops_v1_InterventionCategoryTimeSeries';
  counts?: Maybe<Instacart_Massops_V1_InterventionCategoryCounts>;
  endDate?: Maybe<Scalars['DateTime']>;
  /** Totals for this specific time period */
  periodTotalIncidentRelated?: Maybe<Scalars['BigInt']>;
  periodTotalNonIncidentRelated?: Maybe<Scalars['BigInt']>;
  startDate?: Maybe<Scalars['DateTime']>;
};

/** InterventionStateCounts contains the count of interventions in each workflow state. */
export type Instacart_Massops_V1_InterventionStateCounts = {
  __typename?: 'instacart_massops_v1_InterventionStateCounts';
  approved?: Maybe<Scalars['BigInt']>;
  canceled?: Maybe<Scalars['BigInt']>;
  completed?: Maybe<Scalars['BigInt']>;
  completedWithFailure?: Maybe<Scalars['BigInt']>;
  createdTasks?: Maybe<Scalars['BigInt']>;
  creatingTasks?: Maybe<Scalars['BigInt']>;
  draft?: Maybe<Scalars['BigInt']>;
  executing?: Maybe<Scalars['BigInt']>;
  failed?: Maybe<Scalars['BigInt']>;
  pendingApproval?: Maybe<Scalars['BigInt']>;
  rejected?: Maybe<Scalars['BigInt']>;
  scheduled?: Maybe<Scalars['BigInt']>;
  taskCreationFailed?: Maybe<Scalars['BigInt']>;
};

/** InterventionStateTimeSeries represents intervention state counts for a single time period. */
export type Instacart_Massops_V1_InterventionStateTimeSeries = {
  __typename?: 'instacart_massops_v1_InterventionStateTimeSeries';
  /** The end of the time period */
  endDate?: Maybe<Scalars['DateTime']>;
  /** The start of the time period (e.g., start of week, month, or quarter) */
  startDate?: Maybe<Scalars['DateTime']>;
  /** Counts for each intervention state in this period */
  stateCounts?: Maybe<Instacart_Massops_V1_InterventionStateCounts>;
};

/** InterventionStatisticFilter defines filter criteria for intervention statistics queries. */
export type Instacart_Massops_V1_InterventionStatisticFilter_Input = {
  /** The time period to aggregate by (week, month, or quarter) */
  aggregation?: InputMaybe<Instacart_Massops_V1_AggregationPeriod>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /** Filter by created at time range (inclusive) */
  startDate?: InputMaybe<Scalars['DateTime']>;
};

/**
 * InterventionType defines a template for creating interventions.
 * It specifies what parameters are required and what kind of operations will be performed.
 */
export type Instacart_Massops_V1_InterventionType = {
  __typename?: 'instacart_massops_v1_InterventionType';
  /** Whether approval is required for this intervention type */
  approvalRequired?: Maybe<Scalars['Boolean']>;
  /** Whether customer communication is supported for this intervention type */
  customerCommunicationSupported?: Maybe<Scalars['Boolean']>;
  /** Detailed description of what this intervention type does */
  description?: Maybe<Scalars['String']>;
  /** Whether this intervention_type has financial_impact */
  hasFinancialImpact?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for this intervention type */
  interventionTypeId?: Maybe<Scalars['String']>;
  /** Human-readable name of the intervention type */
  name?: Maybe<Scalars['String']>;
  /** Parameters required at the intervention level */
  requiredInterventionParams?: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
  /** Parameters required for each task in the intervention */
  requiredTaskParams?: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
  /** Steps that define the workflow of this intervention type */
  steps?: Maybe<Array<Maybe<Instacart_Massops_V1_StepDefinition>>>;
};

/** InterventionTypeQueryTemplates groups query templates by intervention type. */
export type Instacart_Massops_V1_InterventionTypeQueryTemplates = {
  __typename?: 'instacart_massops_v1_InterventionTypeQueryTemplates';
  /** The intervention type these templates belong to */
  interventionTypeId?: Maybe<Scalars['String']>;
  /** Query templates defined by this intervention type's plugin */
  templates?: Maybe<Array<Maybe<Instacart_Massops_V1_QueryTemplate>>>;
};

/** Filter to apply to the list of approval requests */
export type Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Filter_Input = {
  /**
   * Filter by active status. If true, returns only active approval requests.
   * If false, returns only inactive approval requests.
   * If not set, returns all approval requests.
   */
  active?: InputMaybe<Scalars['Boolean']>;
};

/** ListInterventionApprovalRequestsRequest is the request message for listing approval requests. */
export type Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Input = {
  /** Optional filter to apply to the approval request list */
  filter?: InputMaybe<Instacart_Massops_V1_ListInterventionApprovalRequestsRequest_Filter_Input>;
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionApprovalRequestsResponse contains the list of approval requests. */
export type Instacart_Massops_V1_ListInterventionApprovalRequestsResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionApprovalRequestsResponse';
  /** List of approval requests */
  approvalRequests?: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionApprovalRequest>>>;
};

/** Filter to apply to the list of intervention bundles. */
export type Instacart_Massops_V1_ListInterventionBundlesRequest_Filter_Input = {
  /** Filter by bundle state. If BUNDLE_STATE_UNKNOWN, no filter is applied on state. */
  bundleState?: InputMaybe<Instacart_Massops_V1_BundleState>;
  /** Filter by creator user ID. If none is provided, no filter is applied on creator. */
  creatorId?: InputMaybe<Scalars['String']>;
  /**
   * Filter by intervention type IDs the bundle can spawn from.
   * If multiple IDs are provided, filters using OR logic.
   * If empty, no filter is applied on intervention_type_id.
   */
  interventionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ListInterventionBundlesRequest is the request message for listing intervention bundles with pagination. */
export type Instacart_Massops_V1_ListInterventionBundlesRequest_Input = {
  /** Optional filter to apply to the bundle list. */
  filter?: InputMaybe<Instacart_Massops_V1_ListInterventionBundlesRequest_Filter_Input>;
  /** Number of bundles to return per page (optional). */
  pageSize?: InputMaybe<Scalars['BigInt']>;
  pageToken?: InputMaybe<Scalars['String']>;
  /** Required context for the request. */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionBundlesResponse contains a paginated list of intervention bundles. */
export type Instacart_Massops_V1_ListInterventionBundlesResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionBundlesResponse';
  /** List of bundles for the current page. */
  bundles?: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionBundle>>>;
  /** Token to retrieve the next page (optional). */
  nextPageToken?: Maybe<Scalars['String']>;
};

/** ListInterventionQueryTemplatesRequest is the request message for listing query templates. */
export type Instacart_Massops_V1_ListInterventionQueryTemplatesRequest_Input = {
  /** Optional: filter results to a single intervention type */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionQueryTemplatesResponse contains query templates grouped by intervention type. */
export type Instacart_Massops_V1_ListInterventionQueryTemplatesResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionQueryTemplatesResponse';
  /** Query templates per intervention type */
  templates?: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionTypeQueryTemplates>>>;
};

/**
 * ListInterventionTemplateVariablesRequest is the request message for listing template variable names
 * allowed for a specific intervention's communication settings.
 */
export type Instacart_Massops_V1_ListInterventionTemplateVariablesRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/**
 * ListInterventionTemplateVariablesResponse contains the template variable names allowed
 * for a specific intervention's communication settings.
 */
export type Instacart_Massops_V1_ListInterventionTemplateVariablesResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionTemplateVariablesResponse';
  /** List of allowed template variable names */
  templateVariableNames?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** ListInterventionTypesRequest is the request message for listing all available intervention types. */
export type Instacart_Massops_V1_ListInterventionTypesRequest_Input = {
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionTypesResponse contains all available intervention types. */
export type Instacart_Massops_V1_ListInterventionTypesResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionTypesResponse';
  /** List of all available intervention types */
  interventionTypes?: Maybe<Array<Maybe<Instacart_Massops_V1_InterventionType>>>;
};

/** Filter to apply to the list of interventions */
export type Instacart_Massops_V1_ListInterventionsRequest_Filter_Input = {
  /** Filter by artifact reference containing the keywords */
  artifactReference?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Filter by intervention type IDs
   * If multiple IDs are provided, filters using OR logic
   * If none is provided, it will not apply a filter on intervention_type_id
   */
  interventionTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter by name containing the keywords */
  name?: InputMaybe<Scalars['String']>;
  /** Filter by created at time range */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * Filter by workflow states (e.g., "pending", "executing", "completed", "failed")
   * If multiple states are provided, filters using OR logic
   * If none is provided, it will not apply a filter on state
   */
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ListInterventionsRequest is the request message for listing interventions with pagination. */
export type Instacart_Massops_V1_ListInterventionsRequest_Input = {
  /** Optional filter to apply to the intervention list */
  filter?: InputMaybe<Instacart_Massops_V1_ListInterventionsRequest_Filter_Input>;
  /** Number of interventions to return per page (optional) */
  pageSize?: InputMaybe<Scalars['BigInt']>;
  pageToken?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListInterventionsResponse contains a paginated list of interventions. */
export type Instacart_Massops_V1_ListInterventionsResponse = {
  __typename?: 'instacart_massops_v1_ListInterventionsResponse';
  /** List of interventions for the current page */
  interventions?: Maybe<Array<Maybe<Instacart_Massops_V1_Intervention>>>;
  /** Token to retrieve the next page (optional) */
  nextPageToken?: Maybe<Scalars['String']>;
  /** Total number of interventions across all pages */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** ListNotificationTemplatesRequest is the request message for listing notification templates. */
export type Instacart_Massops_V1_ListNotificationTemplatesRequest_Input = {
  /** Optional filter by intervention type */
  interventionTypeId?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListNotificationTemplatesResponse contains all available notification templates. */
export type Instacart_Massops_V1_ListNotificationTemplatesResponse = {
  __typename?: 'instacart_massops_v1_ListNotificationTemplatesResponse';
  /** List of available templates */
  templates?: Maybe<Array<Maybe<Instacart_Massops_V1_NotificationTemplateMetaData>>>;
};

/** Filter to apply to the list of tasks */
export type Instacart_Massops_V1_ListTasksRequest_Filter_Input = {
  /**
   * Filter by task states
   * If multiple states are provided, filters using OR logic
   * If none is provided, it will not apply a filter on state
   */
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** ListTasksRequest is the request message for listing tasks within an intervention. */
export type Instacart_Massops_V1_ListTasksRequest_Input = {
  /** Optional filter to apply to the task list */
  filter?: InputMaybe<Instacart_Massops_V1_ListTasksRequest_Filter_Input>;
  /** The UUID of the intervention whose tasks to list */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Number of tasks to return per page (optional) */
  pageSize?: InputMaybe<Scalars['BigInt']>;
  /** Token for retrieving the next page (optional) */
  pageToken?: InputMaybe<Scalars['String']>;
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListTasksResponse contains a paginated list of tasks for an intervention. */
export type Instacart_Massops_V1_ListTasksResponse = {
  __typename?: 'instacart_massops_v1_ListTasksResponse';
  /** Token to retrieve the next page (optional) */
  nextPageToken?: Maybe<Scalars['String']>;
  /** List of tasks for the current page */
  tasks?: Maybe<Array<Maybe<Instacart_Massops_V1_Task>>>;
  /** Total number of tasks across all pages */
  totalCount?: Maybe<Scalars['BigInt']>;
};

/** ListTemplateVariablesRequest is the request message for listing template variables. */
export type Instacart_Massops_V1_ListTemplateVariablesRequest_Input = {
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** ListTemplateVariablesResponse contains all supported template variables. */
export type Instacart_Massops_V1_ListTemplateVariablesResponse = {
  __typename?: 'instacart_massops_v1_ListTemplateVariablesResponse';
  /** List of all supported variables */
  variables?: Maybe<Array<Maybe<Instacart_Massops_V1_TemplateVariable>>>;
};

/** NotificationChannel defines the communication channels for notifications. */
export enum Instacart_Massops_V1_NotificationChannel {
  /** Email channel */
  NotificationChannelEmail = 'NOTIFICATION_CHANNEL_EMAIL',
  /** SMS channel */
  NotificationChannelSms = 'NOTIFICATION_CHANNEL_SMS',
  /** Default unknown value */
  NotificationChannelUnknown = 'NOTIFICATION_CHANNEL_UNKNOWN'
}

/** NotificationTemplate represents a full notification template with all details. */
export type Instacart_Massops_V1_NotificationTemplate = {
  __typename?: 'instacart_massops_v1_NotificationTemplate';
  /** Content for all locales, keyed by locale code */
  content?: Maybe<Scalars['JSON']>;
  /** Description of when to use */
  description?: Maybe<Scalars['String']>;
  /** Whether Legal approval is required before sending */
  legalApprovalRequired?: Maybe<Scalars['Boolean']>;
  /** Human-readable name */
  name?: Maybe<Scalars['String']>;
  /** Supported channels (EMAIL, SMS) */
  supportedChannels?: Maybe<Array<Maybe<Instacart_Massops_V1_NotificationChannel>>>;
  /** Available locale codes */
  supportedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Unique identifier */
  templateId?: Maybe<Scalars['String']>;
  /** Warnings for template usage */
  warnings?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** NotificationTemplateMetaData represents metadata of a notification template. */
export type Instacart_Massops_V1_NotificationTemplateMetaData = {
  __typename?: 'instacart_massops_v1_NotificationTemplateMetaData';
  /** Human-readable name of the template */
  name?: Maybe<Scalars['String']>;
  /** Unique identifier for the template */
  templateId?: Maybe<Scalars['String']>;
};

/**
 * ParamDefinition describes a parameter that can be used in an intervention type.
 * It defines the parameter's metadata including name, type, and description.
 */
export type Instacart_Massops_V1_ParamDefinition = {
  __typename?: 'instacart_massops_v1_ParamDefinition';
  /** The allowed values for the parameter */
  allowedValues?: Maybe<Array<Maybe<Instacart_Massops_V1_AllowedValueOption>>>;
  /** Default value for the parameter */
  defaultValue?: Maybe<Scalars['String']>;
  /** Human-readable description of the parameter */
  description?: Maybe<Scalars['String']>;
  /** The parameter name */
  name?: Maybe<Scalars['String']>;
  /** Whether this parameter is required */
  required?: Maybe<Scalars['Boolean']>;
  /** NEW - param required only if ANY of these steps is included */
  requiredIfStepIncluded?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The data type: string, integer, or boolean */
  type?: Maybe<Scalars['String']>;
};

/** ParameterSummary contains count and distribution analysis for a specific parameter. */
export type Instacart_Massops_V1_ParameterSummary = {
  __typename?: 'instacart_massops_v1_ParameterSummary';
  /** Name of the parameter (e.g., "user_id", "order_id") */
  paramName?: Maybe<Scalars['String']>;
  /** Value distribution across defined ranges (optional) */
  rangeCounts?: Maybe<Array<Maybe<Instacart_Massops_V1_RangeCount>>>;
  /** Sum of all values for this parameter (only applicable when param is monetary value or quantity value) */
  sum?: Maybe<Scalars['Float']>;
  /** Total count of unique values for this parameter */
  uniqueCount?: Maybe<Scalars['BigInt']>;
  /** Warning message for this parameter (e.g., "5 invalid values detected") */
  warningMessage?: Maybe<Scalars['String']>;
};

/**
 * PreExecutionSummary contains pre-run analysis for an intervention.
 * This provides estimates and validation results before execution begins.
 * It matches the PreExecutionSummary struct in massops/internal/data_access.
 */
export type Instacart_Massops_V1_PreExecutionSummary = {
  __typename?: 'instacart_massops_v1_PreExecutionSummary';
  /** Error message when status is FAILED */
  errorMessage?: Maybe<Scalars['String']>;
  /** Monetary impact analysis (present only if intervention involves amounts) */
  financialImpactSummary?: Maybe<Instacart_Massops_V1_FinancialImpactSummary>;
  /** Timestamp when this summary was generated */
  generatedAt?: Maybe<Scalars['DateTime']>;
  /** True if any parameter has a warning */
  hasWarnings?: Maybe<Scalars['Boolean']>;
  /** List of locale codes affected (e.g., "en-US", "fr-CA") */
  impactedLocales?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Number of unique orders affected; from order_delivery_id param UniqueCount, or 0 if not applicable */
  impactedOrderCount?: Maybe<Scalars['BigInt']>;
  /** Number of unique users affected; from user_id param UniqueCount, or 0 if not applicable */
  impactedUserCount?: Maybe<Scalars['BigInt']>;
  /** Distinct whitelabel_id values present in the CSV; empty means the intervention is "IC only" (whitelabel_id=1) */
  impactedWhitelabelIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  /** Count and distribution analysis per parameter */
  parameterSummaries?: Maybe<Array<Maybe<Instacart_Massops_V1_ParameterSummary>>>;
  /** Status of the pre-execution summary computation (computing, success, failed) */
  status?: Maybe<Instacart_Massops_V1_PreExecutionSummaryStatus>;
  /** Total number of tasks that will be created from the uploaded data */
  totalTasks?: Maybe<Scalars['BigInt']>;
  /** Optional; present only when the validation workflow ran for this intervention */
  validationSummary?: Maybe<Instacart_Massops_V1_ValidationSummary>;
  /** List of warning messages */
  warningMessages?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** PreExecutionSummaryStatus defines the status of pre-execution summary computation. */
export enum Instacart_Massops_V1_PreExecutionSummaryStatus {
  /** Summary is currently being computed */
  PreExecutionSummaryStatusComputing = 'PRE_EXECUTION_SUMMARY_STATUS_COMPUTING',
  /** Summary computation failed */
  PreExecutionSummaryStatusFailed = 'PRE_EXECUTION_SUMMARY_STATUS_FAILED',
  /** Summary computation completed successfully */
  PreExecutionSummaryStatusSuccess = 'PRE_EXECUTION_SUMMARY_STATUS_SUCCESS',
  /** Default unknown value */
  PreExecutionSummaryStatusUnknown = 'PRE_EXECUTION_SUMMARY_STATUS_UNKNOWN'
}

/** PreviewInterventionDataRequest is the request message for previewing intervention CSV data. */
export type Instacart_Massops_V1_PreviewInterventionDataRequest_Input = {
  /** The UUID of the intervention to preview data for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** PreviewInterventionDataResponse contains the preview of CSV data for the intervention. */
export type Instacart_Massops_V1_PreviewInterventionDataResponse = {
  __typename?: 'instacart_massops_v1_PreviewInterventionDataResponse';
  /** Column names from the CSV */
  columns?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Data rows as key-value pairs (up to 10 rows) */
  rows?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** QueryExecutionStatus defines the possible execution states of a query. */
export enum Instacart_Massops_V1_QueryExecutionStatus {
  /** Query completed successfully */
  QueryExecutionStatusCompleted = 'QUERY_EXECUTION_STATUS_COMPLETED',
  /** Query is currently executing */
  QueryExecutionStatusExecuting = 'QUERY_EXECUTION_STATUS_EXECUTING',
  /** Query execution failed */
  QueryExecutionStatusFailed = 'QUERY_EXECUTION_STATUS_FAILED',
  /** Default unknown value */
  QueryExecutionStatusUnknown = 'QUERY_EXECUTION_STATUS_UNKNOWN',
  /** Query results are being validated */
  QueryExecutionStatusValidating = 'QUERY_EXECUTION_STATUS_VALIDATING',
  /** Query validation failed */
  QueryExecutionStatusValidationFailed = 'QUERY_EXECUTION_STATUS_VALIDATION_FAILED'
}

/** QueryTemplate represents a named query template defined by a plugin. */
export type Instacart_Massops_V1_QueryTemplate = {
  __typename?: 'instacart_massops_v1_QueryTemplate';
  allowedVariableNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Description of what the query does */
  description?: Maybe<Scalars['String']>;
  /** Human-readable name of the query template */
  name?: Maybe<Scalars['String']>;
  /**
   * The query template string (may contain placeholders)
   * Names of variables that operators may supply when executing this template.
   * Each name matches the placeholder as written in the query without the leading ':' (e.g. "delivery_id" for ":delivery_id").
   * Kept for back-compat; populated from variables[*].name.
   */
  query?: Maybe<Scalars['String']>;
  /** Full variable definitions for the template. FE renders input controls from this list. */
  variables?: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
};

/** RangeCount represents a single bucket in a value distribution histogram. */
export type Instacart_Massops_V1_RangeCount = {
  __typename?: 'instacart_massops_v1_RangeCount';
  /** Number of items falling within this range */
  count?: Maybe<Scalars['BigInt']>;
  /** Upper bound of the range (exclusive, except for last bucket) */
  maxValue?: Maybe<Scalars['Float']>;
  /** Lower bound of the range (inclusive) */
  minValue?: Maybe<Scalars['Float']>;
  /** Display label for the range (e.g., "1-100", "100-1000", ">1000") */
  rangeLabel?: Maybe<Scalars['String']>;
};

/** RequestContext provides context information for requests. */
export type Instacart_Massops_V1_RequestContext_Input = {
  /** Resource name identifying the calling client, e.g. "clients/1" */
  client?: InputMaybe<Scalars['String']>;
  /** Integer DB ID of the IPP user; distinct from user_id (string auth ID), required for refund operations */
  ippUserId?: InputMaybe<Scalars['BigInt']>;
  /** Email of the user making the request that used by slackbot */
  userEmail?: InputMaybe<Scalars['String']>;
  /** The ID of the user making the request */
  userId?: InputMaybe<Scalars['String']>;
};

/** RequestInterventionApprovalRequest is the request message for requesting approval of an intervention. */
export type Instacart_Massops_V1_RequestInterventionApprovalRequest_Input = {
  /** The UUID of the intervention to request approval for */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** RequestInterventionApprovalResponse is the response message for successful approval request. */
export type Instacart_Massops_V1_RequestInterventionApprovalResponse = {
  __typename?: 'instacart_massops_v1_RequestInterventionApprovalResponse';
  /** The approval request id (optional) */
  approvalRequestId?: Maybe<Scalars['String']>;
  /** The intervention with updated state (pending_approval) */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * RequestInterventionBundleApprovalRequest is the request message for requesting approval of an intervention bundle.
 * The set of approvals raised is derived server-side from the bundle's contents
 * (e.g. financial impact, communication templates, legal-approval flag).
 */
export type Instacart_Massops_V1_RequestInterventionBundleApprovalRequest_Input = {
  /** The UUID of the bundle to request approval for. */
  bundleUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request. */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** RequestInterventionBundleApprovalResponse is the response message for a successful bundle approval request. */
export type Instacart_Massops_V1_RequestInterventionBundleApprovalResponse = {
  __typename?: 'instacart_massops_v1_RequestInterventionBundleApprovalResponse';
  /** The approval requests raised for the bundle. */
  approvalRequests?: Maybe<Array<Maybe<Instacart_Massops_V1_BundleApprovalRequest>>>;
  /** The bundle's updated state (typically pending_approval). */
  bundleState?: Maybe<Instacart_Massops_V1_BundleState>;
  /** The UUID of the bundle. */
  bundleUuid?: Maybe<Scalars['String']>;
};

/** SmsSettings configures SMS notifications with multi-locale support. */
export type Instacart_Massops_V1_SmsSettings = {
  __typename?: 'instacart_massops_v1_SmsSettings';
  /**
   * Locale-specific SMS content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content?: Maybe<Scalars['JSON']>;
  /** Whether SMS notifications are enabled */
  enabled?: Maybe<Scalars['Boolean']>;
};

/** SmsSettings configures SMS notifications with multi-locale support. */
export type Instacart_Massops_V1_SmsSettings_Input = {
  /**
   * Locale-specific SMS content
   * Key = locale code (e.g., "en_US", "es_MX", "fr_CA")
   */
  content?: InputMaybe<Scalars['JSON']>;
  /** Whether SMS notifications are enabled */
  enabled?: InputMaybe<Scalars['Boolean']>;
};

/**
 * StepDefinition describes a step in an intervention type.
 * It defines the step's metadata including unique identifier, name, and description.
 */
export type Instacart_Massops_V1_StepDefinition = {
  __typename?: 'instacart_massops_v1_StepDefinition';
  /** Human-readable description of the step */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for this step */
  id?: Maybe<Scalars['String']>;
  /** The step name */
  name?: Maybe<Scalars['String']>;
  /** NEW */
  optional?: Maybe<Scalars['Boolean']>;
  /** Output parameters produced by this step */
  outputParams?: Maybe<Array<Maybe<Instacart_Massops_V1_ParamDefinition>>>;
};

/** StepExecutionResult represents the execution result of a single step in a task. */
export type Instacart_Massops_V1_StepExecutionResult = {
  __typename?: 'instacart_massops_v1_StepExecutionResult';
  /** Step execution duration in milliseconds */
  durationMs?: Maybe<Scalars['BigInt']>;
  /** Error message (only populated on failure) */
  error?: Maybe<Scalars['String']>;
  /** Step's output values (only populated on success) */
  outputs?: Maybe<Scalars['JSON']>;
  /** Unique identifier of the step */
  stepId?: Maybe<Scalars['String']>;
  /** Human-readable name of the step */
  stepName?: Maybe<Scalars['String']>;
  /** Whether the step executed successfully */
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * SyncInterventionApprovalResultRequest receives approval callback from external systems.
 * This endpoint syncs the approval decision state from external approval workflows.
 */
export type Instacart_Massops_V1_SyncInterventionApprovalResultRequest_Input = {
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** SyncInterventionApprovalResultResponse contains the updated intervention after syncing approval result. */
export type Instacart_Massops_V1_SyncInterventionApprovalResultResponse = {
  __typename?: 'instacart_massops_v1_SyncInterventionApprovalResultResponse';
  /** The intervention with updated state based on approval decision */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * SyncInterventionBundleApprovalResultRequest is the request message for reconciling a bundle's approval state
 * with the latest decisions reported by the external approval service.
 */
export type Instacart_Massops_V1_SyncInterventionBundleApprovalResultRequest_Input = {
  /** The UUID of the bundle to sync. */
  bundleUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request. */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** SyncInterventionBundleApprovalResultResponse contains the bundle's reconciled approval state. */
export type Instacart_Massops_V1_SyncInterventionBundleApprovalResultResponse = {
  __typename?: 'instacart_massops_v1_SyncInterventionBundleApprovalResultResponse';
  /** The latest approval requests and their states. */
  approvalRequests?: Maybe<Array<Maybe<Instacart_Massops_V1_BundleApprovalRequest>>>;
  /** The bundle's updated state after sync. */
  bundleState?: Maybe<Instacart_Massops_V1_BundleState>;
  /** The UUID of the bundle. */
  bundleUuid?: Maybe<Scalars['String']>;
};

/**
 * Task represents an individual unit of work within an intervention.
 * Each task operates on a specific entity or performs a specific action.
 */
export type Instacart_Massops_V1_Task = {
  __typename?: 'instacart_massops_v1_Task';
  /** When the task execution completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** When the task was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** When the task execution started */
  executedAt?: Maybe<Scalars['DateTime']>;
  /** Financial impact of this task (may be null if intervention type has no financial impact or step hasn't executed yet) */
  financialImpact?: Maybe<GoogleTypeMoney>;
  /** Task-specific params and parameters */
  params?: Maybe<Scalars['JSON']>;
  /** Task execution results */
  result?: Maybe<Scalars['JSON']>;
  /** Current state (e.g., pending, executing, completed, failed) */
  state?: Maybe<Scalars['String']>;
  /** Array of step execution results for this task */
  stepResults?: Maybe<Array<Maybe<Instacart_Massops_V1_StepExecutionResult>>>;
  /** When the task was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this task */
  uuid?: Maybe<Scalars['String']>;
};

/** TemplateVariable represents a variable that can be used in notification templates. */
export type Instacart_Massops_V1_TemplateVariable = {
  __typename?: 'instacart_massops_v1_TemplateVariable';
  /** Human-readable description */
  description?: Maybe<Scalars['String']>;
  /** Variable name (e.g., "first_name") */
  name?: Maybe<Scalars['String']>;
};

/** Threshold contains threshold values for monthly, quarterly, and yearly periods. */
export type Instacart_Massops_V1_Threshold = {
  __typename?: 'instacart_massops_v1_Threshold';
  /** Threshold value for monthly period */
  monthlyThreshold?: Maybe<Scalars['BigInt']>;
  /** Threshold value for quarterly period */
  quarterlyThreshold?: Maybe<Scalars['BigInt']>;
  /** Threshold value for yearly period */
  yearlyThreshold?: Maybe<Scalars['BigInt']>;
};

/** UpdateInterventionCommunicationSettingsRequest is the request message for updating communication settings for an intervention. */
export type Instacart_Massops_V1_UpdateInterventionCommunicationSettingsRequest_Input = {
  /** The communication settings to update */
  communicationSettings?: InputMaybe<Instacart_Massops_V1_CommunicationSettings_Input>;
  /** The UUID of the intervention */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** UpdateInterventionCommunicationSettingsResponse contains the updated intervention with new communication settings. */
export type Instacart_Massops_V1_UpdateInterventionCommunicationSettingsResponse = {
  __typename?: 'instacart_massops_v1_UpdateInterventionCommunicationSettingsResponse';
  /** The intervention with updated communication settings */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/** UpdateInterventionRequest is the request message for updating an intervention. */
export type Instacart_Massops_V1_UpdateInterventionRequest_Input = {
  /** Artifact associated with this intervention */
  artifact?: InputMaybe<Instacart_Massops_V1_Artifact_Input>;
  /** Optional: new description for the intervention */
  description?: InputMaybe<Scalars['String']>;
  /** The UUID of the intervention to update */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Optional: new name for the intervention */
  name?: InputMaybe<Scalars['String']>;
  /** Optional: new parameters/inputs for the intervention (maps to inputs field) */
  params?: InputMaybe<Scalars['JSON']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** UpdateInterventionResponse contains the updated intervention details. */
export type Instacart_Massops_V1_UpdateInterventionResponse = {
  __typename?: 'instacart_massops_v1_UpdateInterventionResponse';
  /** The updated intervention with all its details */
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/** UploadInterventionDataRequest is the request message for uploading task data to an intervention. */
export type Instacart_Massops_V1_UploadInterventionDataRequest_Input = {
  /** CSV data containing tasks to be processed */
  csvContent?: InputMaybe<Scalars['String']>;
  /** The UUID of the intervention to upload data to */
  interventionUuid?: InputMaybe<Scalars['String']>;
  /** Required context for the request */
  requestContext?: InputMaybe<Instacart_Massops_V1_RequestContext_Input>;
};

/** UploadInterventionDataResponse is the response message for successful data upload. */
export type Instacart_Massops_V1_UploadInterventionDataResponse = {
  __typename?: 'instacart_massops_v1_UploadInterventionDataResponse';
  intervention?: Maybe<Instacart_Massops_V1_Intervention>;
};

/**
 * ValidationFinding is the per-check aggregate produced by the validation workflow.
 * One entry per check that ran, regardless of pass/fail, so clients can render a full checklist.
 */
export type Instacart_Massops_V1_ValidationFinding = {
  __typename?: 'instacart_massops_v1_ValidationFinding';
  /** S3 key for full violations CSV; empty for old interventions */
  allViolationsS3Key?: Maybe<Scalars['String']>;
  /** Identifier of the validation check */
  checkName?: Maybe<Scalars['String']>;
  /** Human-readable purpose of the check */
  description?: Maybe<Scalars['String']>;
  /** Whether failing rows for this check can be automatically dropped on regen */
  dropOnRegen?: Maybe<Scalars['Boolean']>;
  /** How to fix violations of this check */
  remediation?: Maybe<Scalars['String']>;
  /** First N violation rows for display (capped for payload size) */
  sampleViolations?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Severity classification for this check (blocking vs. warning) */
  severity?: Maybe<Instacart_Massops_V1_ValidationSeverity>;
  /** Pass/fail result for this check */
  status?: Maybe<Instacart_Massops_V1_ValidationStatus>;
  /** Total violation rows; 0 when status == SUCCESS */
  violationCount?: Maybe<Scalars['BigInt']>;
};

/**
 * ValidationFinding is the per-check aggregate produced by the validation workflow.
 * One entry per check that ran, regardless of pass/fail, so clients can render a full checklist.
 */
export type Instacart_Massops_V1_ValidationFinding_Input = {
  /** S3 key for full violations CSV; empty for old interventions */
  allViolationsS3Key?: InputMaybe<Scalars['String']>;
  /** Identifier of the validation check */
  checkName?: InputMaybe<Scalars['String']>;
  /** Human-readable purpose of the check */
  description?: InputMaybe<Scalars['String']>;
  /** Whether failing rows for this check can be automatically dropped on regen */
  dropOnRegen?: InputMaybe<Scalars['Boolean']>;
  /** How to fix violations of this check */
  remediation?: InputMaybe<Scalars['String']>;
  /** First N violation rows for display (capped for payload size) */
  sampleViolations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Severity classification for this check (blocking vs. warning) */
  severity?: InputMaybe<Instacart_Massops_V1_ValidationSeverity>;
  /** Pass/fail result for this check */
  status?: InputMaybe<Instacart_Massops_V1_ValidationStatus>;
  /** Total violation rows; 0 when status == SUCCESS */
  violationCount?: InputMaybe<Scalars['BigInt']>;
};

/**
 * ValidationSeverity classifies how a validation finding should gate execution.
 * BLOCKING findings prevent execution; WARNING findings surface to operators but do not block.
 */
export enum Instacart_Massops_V1_ValidationSeverity {
  ValidationSeverityBlocking = 'VALIDATION_SEVERITY_BLOCKING',
  ValidationSeverityUnknown = 'VALIDATION_SEVERITY_UNKNOWN',
  ValidationSeverityWarning = 'VALIDATION_SEVERITY_WARNING'
}

/** ValidationStatus represents the lifecycle state of a validation workflow or individual check. */
export enum Instacart_Massops_V1_ValidationStatus {
  /** One or more violations found, or the workflow errored */
  ValidationStatusFailed = 'VALIDATION_STATUS_FAILED',
  /** All checks passed / this check returned zero violations */
  ValidationStatusSuccess = 'VALIDATION_STATUS_SUCCESS',
  /** Default unknown value */
  ValidationStatusUnknown = 'VALIDATION_STATUS_UNKNOWN',
  /** Anti-queries are still running (summary-level only) */
  ValidationStatusValidating = 'VALIDATION_STATUS_VALIDATING'
}

/** ValidationSummary captures the outcome of the validation workflow nested inside PreExecutionSummary. */
export type Instacart_Massops_V1_ValidationSummary = {
  __typename?: 'instacart_massops_v1_ValidationSummary';
  /** Total number of violations from BLOCKING-severity findings across all checks */
  blockingViolationCount?: Maybe<Scalars['BigInt']>;
  /** Set when the validation workflow itself errored before per-check findings could be produced */
  errorMsg?: Maybe<Scalars['String']>;
  /** Per-check results; passed checks are included with status SUCCESS */
  findings?: Maybe<Array<Maybe<Instacart_Massops_V1_ValidationFinding>>>;
  /** Overall validation lifecycle state */
  status?: Maybe<Instacart_Massops_V1_ValidationStatus>;
  /** Total number of violations from WARNING-severity findings across all checks */
  warningViolationCount?: Maybe<Scalars['BigInt']>;
};

/** ComparisonInstance */
export type Instacart_Medusa_V1_ComparisonInstance = {
  __typename?: 'instacart_medusa_v1_ComparisonInstance';
  absolute_value_change?: Maybe<Instacart_Medusa_V1_QueryResponseValue>;
  comparison_date?: Maybe<Scalars['DateTime']>;
  comparison_value?: Maybe<Instacart_Medusa_V1_QueryResponseValue>;
  method?: Maybe<Instacart_Medusa_V1_ComparisonMethod>;
  percent_change?: Maybe<Scalars['Float']>;
};

/** ComparisonMethod */
export enum Instacart_Medusa_V1_ComparisonMethod {
  ComparisonMethodLastPeriod = 'COMPARISON_METHOD_LAST_PERIOD',
  ComparisonMethodLastPeriodDayOfWeekMatch = 'COMPARISON_METHOD_LAST_PERIOD_DAY_OF_WEEK_MATCH',
  ComparisonMethodLastYear = 'COMPARISON_METHOD_LAST_YEAR',
  ComparisonMethodLastYearDayOfWeekMatch = 'COMPARISON_METHOD_LAST_YEAR_DAY_OF_WEEK_MATCH',
  ComparisonMethodUnknown = 'COMPARISON_METHOD_UNKNOWN'
}

/** ComparisonPeriod */
export type Instacart_Medusa_V1_ComparisonPeriod_Input = {
  method?: InputMaybe<Instacart_Medusa_V1_ComparisonMethod>;
};

/** DimensionValue */
export type Instacart_Medusa_V1_DimensionValue = {
  __typename?: 'instacart_medusa_v1_DimensionValue';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

/** DimensionValuesQuery */
export type Instacart_Medusa_V1_DimensionValuesQuery_Input = {
  dimension?: InputMaybe<Scalars['String']>;
  /** Optional related dimension whose values are returned as labels; empty = no label. */
  label_dimension?: InputMaybe<Scalars['String']>;
  /** Cap on returned values; 0 = server default. */
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

/** DimensionValuesResult */
export type Instacart_Medusa_V1_DimensionValuesResult = {
  __typename?: 'instacart_medusa_v1_DimensionValuesResult';
  dimension?: Maybe<Scalars['String']>;
  truncated?: Maybe<Scalars['Boolean']>;
  values?: Maybe<Array<Maybe<Instacart_Medusa_V1_DimensionValue>>>;
};

/** ExecuteMetricsQueryRequest. This should align with GetMedusaQueryRequest by convention. */
export type Instacart_Medusa_V1_ExecuteMetricsQueryRequest_Input = {
  comparisons?: InputMaybe<Array<InputMaybe<Instacart_Medusa_V1_ComparisonPeriod_Input>>>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Medusa_V1_QueryFilter_Input>>>;
  limit?: InputMaybe<Scalars['BigInt']>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['BigInt']>;
  order_bys?: InputMaybe<Array<InputMaybe<Instacart_Medusa_V1_OrderBy_Input>>>;
};

/**
 * ExecuteMetricsQueryResponse
 * No AuthorizationStatus — auth enforced at execution. Mirrors ExecuteMedusaQuery.
 */
export type Instacart_Medusa_V1_ExecuteMetricsQueryResponse = {
  __typename?: 'instacart_medusa_v1_ExecuteMetricsQueryResponse';
  columns?: Maybe<Array<Maybe<Instacart_Medusa_V1_QueryResponseColumn>>>;
  rows?: Maybe<Array<Maybe<Instacart_Medusa_V1_QueryResponseRow>>>;
};

/**
 * GetDimensionValuesRequest
 * Distinct-value lookups only.
 */
export type Instacart_Medusa_V1_GetDimensionValuesRequest_Input = {
  filters?: InputMaybe<Array<InputMaybe<Instacart_Medusa_V1_QueryFilter_Input>>>;
  measure_source_name?: InputMaybe<Scalars['String']>;
  queries?: InputMaybe<Array<InputMaybe<Instacart_Medusa_V1_DimensionValuesQuery_Input>>>;
};

/** GetDimensionValuesResponse */
export type Instacart_Medusa_V1_GetDimensionValuesResponse = {
  __typename?: 'instacart_medusa_v1_GetDimensionValuesResponse';
  results?: Maybe<Array<Maybe<Instacart_Medusa_V1_DimensionValuesResult>>>;
};

/** OrderBy */
export type Instacart_Medusa_V1_OrderBy_Input = {
  direction?: InputMaybe<Instacart_Medusa_V1_SortDirection>;
  /** Metric or dimension name to sort by; must be one of the query's metrics or dimensions */
  name?: InputMaybe<Scalars['String']>;
};

/** MedusaFilters */
export type Instacart_Medusa_V1_QueryFilter_Input = {
  dimension_left?: InputMaybe<Scalars['String']>;
  dimension_right?: InputMaybe<Scalars['String']>;
  event_left?: InputMaybe<Scalars['String']>;
  event_right?: InputMaybe<Scalars['String']>;
  literal_left?: InputMaybe<Scalars['String']>;
  literal_right?: InputMaybe<Scalars['String']>;
  metric_left?: InputMaybe<Scalars['String']>;
  metric_right?: InputMaybe<Scalars['String']>;
  /** The operator */
  operator?: InputMaybe<Scalars['String']>;
  partition_left?: InputMaybe<Scalars['String']>;
  partition_right?: InputMaybe<Scalars['String']>;
};

/** QueryResponseColumn */
export type Instacart_Medusa_V1_QueryResponseColumn = {
  __typename?: 'instacart_medusa_v1_QueryResponseColumn';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Instacart_Medusa_V1_QueryResponseColumnType>;
};

/** QueryResponseColumnType */
export enum Instacart_Medusa_V1_QueryResponseColumnType {
  QueryResponseColumnTypeBlob = 'QUERY_RESPONSE_COLUMN_TYPE_BLOB',
  QueryResponseColumnTypeDate = 'QUERY_RESPONSE_COLUMN_TYPE_DATE',
  QueryResponseColumnTypeDouble = 'QUERY_RESPONSE_COLUMN_TYPE_DOUBLE',
  QueryResponseColumnTypeInteger = 'QUERY_RESPONSE_COLUMN_TYPE_INTEGER',
  QueryResponseColumnTypeJson = 'QUERY_RESPONSE_COLUMN_TYPE_JSON',
  QueryResponseColumnTypeString = 'QUERY_RESPONSE_COLUMN_TYPE_STRING',
  QueryResponseColumnTypeTimestamp = 'QUERY_RESPONSE_COLUMN_TYPE_TIMESTAMP',
  QueryResponseColumnTypeUnknown = 'QUERY_RESPONSE_COLUMN_TYPE_UNKNOWN'
}

/** QueryResponseRow */
export type Instacart_Medusa_V1_QueryResponseRow = {
  __typename?: 'instacart_medusa_v1_QueryResponseRow';
  values?: Maybe<Array<Maybe<Instacart_Medusa_V1_QueryResponseValue>>>;
};

/** QueryResponseValue */
export type Instacart_Medusa_V1_QueryResponseValue = {
  __typename?: 'instacart_medusa_v1_QueryResponseValue';
  comparisons?: Maybe<Array<Maybe<Instacart_Medusa_V1_ComparisonInstance>>>;
  date_value?: Maybe<Google_Type_Date>;
  double_value?: Maybe<Scalars['Float']>;
  int_value?: Maybe<Scalars['BigInt']>;
  is_null?: Maybe<Scalars['Boolean']>;
  json_value?: Maybe<Scalars['JSON']>;
  string_value?: Maybe<Scalars['String']>;
  timestamp_value?: Maybe<Scalars['DateTime']>;
  /** DEPRECATED; get the type info from the corresponding column */
  type?: Maybe<Instacart_Medusa_V1_QueryResponseColumnType>;
};

/** SortDirection for an OrderBy clause */
export enum Instacart_Medusa_V1_SortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnknown = 'SORT_DIRECTION_UNKNOWN'
}

/**
 * Represents an approvable record, which can be of different types
 * Currently only ColumnMapRecord is used, but this structure allows for future extension, i.e. ValidationMaps
 */
export type Instacart_Partners_Data_Ingestion_V1_ApprovableRecord = {
  __typename?: 'instacart_partners_data_ingestion_v1_ApprovableRecord';
  columnMap?: Maybe<Instacart_Partners_Data_Ingestion_V1_ColumnMapRecord>;
};

/** Represents a change approval request */
export type Instacart_Partners_Data_Ingestion_V1_ChangeApprovalRequest = {
  __typename?: 'instacart_partners_data_ingestion_v1_ChangeApprovalRequest';
  changeType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  latestRevision?: Maybe<Instacart_Partners_Data_Ingestion_V1_ApprovableRecord>;
  recordType?: Maybe<Scalars['String']>;
  sourceRecord?: Maybe<Instacart_Partners_Data_Ingestion_V1_ApprovableRecord>;
  sourceRecordId?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

/** Represents a column map record */
export type Instacart_Partners_Data_Ingestion_V1_ColumnMapRecord = {
  __typename?: 'instacart_partners_data_ingestion_v1_ColumnMapRecord';
  fileNameMatcher?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  ingestionType?: Maybe<Scalars['String']>;
  map?: Maybe<Scalars['JSON']>;
  mapType?: Maybe<Scalars['String']>;
  normalizedSchema?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  rawSchema?: Maybe<Scalars['String']>;
  tombstone?: Maybe<Scalars['Boolean']>;
};

/** Request message for getting a change approval request by its ID */
export type Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response message containing the requested change approval request and includes relevant approvable records */
export type Instacart_Partners_Data_Ingestion_V1_GetChangeApprovalRequestResponse = {
  __typename?: 'instacart_partners_data_ingestion_v1_GetChangeApprovalRequestResponse';
  changeApprovalRequest?: Maybe<Instacart_Partners_Data_Ingestion_V1_ChangeApprovalRequest>;
};

/** Request to bulk create configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsRequest_Input = {
  /** The configurations to create */
  partnerConfigurationsToCreate?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_CreatePartnerConfigurationInput_Input>>>;
};

/** Response to bulk create partner configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_BulkCreatePartnerConfigurationsResponse';
  /** The configurations created */
  partnerConfigurations?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/** Request to bulk delete configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsRequest_Input = {
  /** The user or system who deleted the configuration */
  deletedBy?: InputMaybe<Scalars['String']>;
  /** The IDs of the configurations to delete */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response to bulk delete partner configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_BulkDeletePartnerConfigurationsResponse';
  /** Whether the delete was successful. It is an all-or-nothing operation */
  success?: Maybe<Scalars['Boolean']>;
};

/** Request to bulk update configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsRequest_Input = {
  /** The configurations to update */
  partnerConfigurationsToUpdate?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_UpdatePartnerConfigurationInput_Input>>>;
};

/** Response to bulk update partner configurations for given configuration information. */
export type Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_BulkUpdatePartnerConfigurationsResponse';
  /** The configurations updated */
  partnerConfigurations?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/**
 * Maps to Csv::ColumnProfile on backend
 * Represents profiling statistics for a single column
 */
export type Instacart_Partners_Partners_V1_ColumnProfile = {
  __typename?: 'instacart_partners_partners_v1_ColumnProfile';
  cardinality?: Maybe<Scalars['BigInt']>;
  max?: Maybe<Scalars['Float']>;
  mean?: Maybe<Scalars['Float']>;
  /** Numeric statistics (only present for numeric columns) */
  min?: Maybe<Scalars['Float']>;
  mode?: Maybe<Array<Maybe<Scalars['Float']>>>;
  name?: Maybe<Scalars['String']>;
  sampleSize?: Maybe<Scalars['BigInt']>;
  /** "numeric", "text", "unknown" */
  type?: Maybe<Scalars['String']>;
  uniqueValues?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Enum to represent the configurable type of partner configuration model. */
export enum Instacart_Partners_Partners_V1_ConfigurableType {
  ConfigurableTypeHierarchy = 'CONFIGURABLE_TYPE_HIERARCHY',
  ConfigurableTypeRetailer = 'CONFIGURABLE_TYPE_RETAILER',
  ConfigurableTypeRetailerLocation = 'CONFIGURABLE_TYPE_RETAILER_LOCATION',
  ConfigurableTypeUnknown = 'CONFIGURABLE_TYPE_UNKNOWN',
  ConfigurableTypeZone = 'CONFIGURABLE_TYPE_ZONE'
}

/**
 * Object to represent a configuration setting.
 * The configuration setting could be either a string, boolean or integer
 * While there exists a value_jsonb column in the table, it should not be used for new configurations
 */
export type Instacart_Partners_Partners_V1_ConfigurationSetting = {
  __typename?: 'instacart_partners_partners_v1_ConfigurationSetting';
  /** boolean_setting represents the setting value if the config is a boolean */
  booleanSetting?: Maybe<Scalars['Boolean']>;
  /** json_setting represents the setting value if the config is jsonb */
  jsonSetting?: Maybe<Scalars['JSON']>;
  /** key_value_settings is deprecated and should not be used */
  keyValueSettings?: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap>;
  /**
   * number_setting represents the setting value if the config is an number (integer or float)
   * Note that protobuf will default this to 0.0 if it is not provided
   */
  numberSetting?: Maybe<Scalars['Float']>;
  /** string_setting represents the setting value if the config is a string */
  stringSetting?: Maybe<Scalars['String']>;
};

/**
 * Object to represent a configuration setting.
 * The configuration setting could be either a string, boolean or integer
 * While there exists a value_jsonb column in the table, it should not be used for new configurations
 */
export type Instacart_Partners_Partners_V1_ConfigurationSetting_Input = {
  /** boolean_setting represents the setting value if the config is a boolean */
  booleanSetting?: InputMaybe<Scalars['Boolean']>;
  /** json_setting represents the setting value if the config is jsonb */
  jsonSetting?: InputMaybe<Scalars['JSON']>;
  /** key_value_settings is deprecated and should not be used */
  keyValueSettings?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap_Input>;
  /**
   * number_setting represents the setting value if the config is an number (integer or float)
   * Note that protobuf will default this to 0.0 if it is not provided
   */
  numberSetting?: InputMaybe<Scalars['Float']>;
  /** string_setting represents the setting value if the config is a string */
  stringSetting?: InputMaybe<Scalars['String']>;
};

/** Object to represent key-value pairs. Should no longer be used. */
export type Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap = {
  __typename?: 'instacart_partners_partners_v1_ConfigurationSetting_SettingsMap';
  settings?: Maybe<Scalars['JSON']>;
};

/** Object to represent key-value pairs. Should no longer be used. */
export type Instacart_Partners_Partners_V1_ConfigurationSetting_SettingsMap_Input = {
  settings?: InputMaybe<Scalars['JSON']>;
};

/** Wraps a BulkCreatePartnerConfigurationsRequest so it can be submitted for approval. */
export type Instacart_Partners_Partners_V1_CreateBulkCreatePartnerConfigurationsApprovalRequestRequest_Input = {
  /** The bulk-create request to submit for approval. */
  bulkRequest?: InputMaybe<Instacart_Partners_Partners_V1_BulkCreatePartnerConfigurationsRequest_Input>;
};

/** Result of submitting a BulkCreatePartnerConfigurations change for approval. */
export type Instacart_Partners_Partners_V1_CreateBulkCreatePartnerConfigurationsApprovalRequestResponse = {
  __typename?: 'instacart_partners_partners_v1_CreateBulkCreatePartnerConfigurationsApprovalRequestResponse';
  /** The ID of the created approval request. */
  createdApprovalRequestId?: Maybe<Scalars['String']>;
  /** Error message that occurred during operation. */
  error?: Maybe<Scalars['String']>;
};

/** Wraps a BulkDeletePartnerConfigurationsRequest so it can be submitted for approval. */
export type Instacart_Partners_Partners_V1_CreateBulkDeletePartnerConfigurationsApprovalRequestRequest_Input = {
  /** The bulk-delete request to submit for approval. */
  bulkRequest?: InputMaybe<Instacart_Partners_Partners_V1_BulkDeletePartnerConfigurationsRequest_Input>;
};

/** Result of submitting a BulkDeletePartnerConfigurations change for approval. */
export type Instacart_Partners_Partners_V1_CreateBulkDeletePartnerConfigurationsApprovalRequestResponse = {
  __typename?: 'instacart_partners_partners_v1_CreateBulkDeletePartnerConfigurationsApprovalRequestResponse';
  /** The ID of the created approval request. */
  createdApprovalRequestId?: Maybe<Scalars['String']>;
  /** Error message that occurred during operation. */
  error?: Maybe<Scalars['String']>;
};

/** Wraps a BulkUpdatePartnerConfigurationsRequest so it can be submitted for approval. */
export type Instacart_Partners_Partners_V1_CreateBulkUpdatePartnerConfigurationsApprovalRequestRequest_Input = {
  /** The bulk-update request to submit for approval. */
  bulkRequest?: InputMaybe<Instacart_Partners_Partners_V1_BulkUpdatePartnerConfigurationsRequest_Input>;
};

/** Result of submitting a BulkUpdatePartnerConfigurations change for approval. */
export type Instacart_Partners_Partners_V1_CreateBulkUpdatePartnerConfigurationsApprovalRequestResponse = {
  __typename?: 'instacart_partners_partners_v1_CreateBulkUpdatePartnerConfigurationsApprovalRequestResponse';
  /** The ID of the created approval request. */
  createdApprovalRequestId?: Maybe<Scalars['String']>;
  /** Error message that occurred during operation. */
  error?: Maybe<Scalars['String']>;
};

/** --- CreateFlipNote --- */
export type Instacart_Partners_Partners_V1_CreateFlipNoteRequest_Input = {
  body?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  featureId?: InputMaybe<Scalars['BigInt']>;
  productEnrollmentId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for CreateFlipNote: the newly created note. */
export type Instacart_Partners_Partners_V1_CreateFlipNoteResponse = {
  __typename?: 'instacart_partners_partners_v1_CreateFlipNoteResponse';
  note?: Maybe<Instacart_Partners_Partners_V1_FlipNote>;
};

/** Input to create a configuration for a given configuration information. */
export type Instacart_Partners_Partners_V1_CreatePartnerConfigurationInput_Input = {
  /** Key used for the hierarchical configuration.  If this is set, the service will assume it is a hierarchical config */
  compositeKey?: InputMaybe<Scalars['String']>;
  /** The ID of the entity to create a configuration for */
  configurableId?: InputMaybe<Scalars['BigInt']>;
  /** The type of configurable entity to create a configuration for */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The user or system who created the configuration */
  createdBy?: InputMaybe<Scalars['String']>;
  /** The end time of the configuration */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Deprecated - The type of partner configuration to create. Use partner_configuration_type_id instead */
  partnerConfigurationType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** The ID of the partner configuration type to create a configuration for */
  partnerConfigurationTypeId?: InputMaybe<Scalars['BigInt']>;
  /** The configuration setting to create */
  setting?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurationSetting_Input>;
  /** The start time of the configuration */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Request to create a new partner configuration type. */
export type Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeRequest_Input = {
  /** The configurable type (e.g. RetailerLocation) that can be assigned the configuration */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The user or system who created the configuration type */
  createdBy?: InputMaybe<Scalars['String']>;
  /** The data type of the configuration type */
  dataType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeDataType>;
  /** The description of the configuration type */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the configuration type */
  name?: InputMaybe<Scalars['String']>;
};

/** Response to create a new partner configuration type. */
export type Instacart_Partners_Partners_V1_CreatePartnerConfigurationTypeResponse = {
  __typename?: 'instacart_partners_partners_v1_CreatePartnerConfigurationTypeResponse';
  /** The configuration type created */
  partnerConfigurationType?: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>;
};

/** Request to provision a sandbox whitelabel site linked to a production store configuration */
export type Instacart_Partners_Partners_V1_CreateSandboxWhitelabelSiteRequest_Input = {
  /** Whether the IP allowlist is enforced. False = all IPs allowed regardless of ip_cidrs. */
  ipAllowlistEnabled?: InputMaybe<Scalars['Boolean']>;
  ipCidrs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * IPP user performing the action
   * Initial IP CIDR allowlist for the sandbox. Ignored when ip_allowlist_enabled is false.
   */
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /** prod StoreConfiguration the sandbox lineage links to */
  linkedStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for provisioning a sandbox whitelabel site */
export type Instacart_Partners_Partners_V1_CreateSandboxWhitelabelSiteResponse = {
  __typename?: 'instacart_partners_partners_v1_CreateSandboxWhitelabelSiteResponse';
  /** Sandbox-level state for the newly provisioned sandbox. */
  sandbox?: Maybe<Instacart_Partners_Partners_V1_SandboxWhitelabelSiteSummary>;
  /** Per-platform site entities (web, ios, android) created under this sandbox. */
  sandboxWhitelabelSites?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_SandboxWhitelabelSite>>>;
  waterfallEffectId?: Maybe<Scalars['BigInt']>;
};

/** Maps to Csv::CsvDebug on backend */
export type Instacart_Partners_Partners_V1_CsvDebug = {
  __typename?: 'instacart_partners_partners_v1_CsvDebug';
  columnCount?: Maybe<Scalars['BigInt']>;
  /**
   * Maps expected column names to actual CSV headers (e.g., {"email": "Email Address"})
   * Used by FuzzyHeaders mixin and potentially other header mapping strategies
   */
  detectedHeaderMappings?: Maybe<Scalars['JSON']>;
  profile?: Maybe<Instacart_Partners_Partners_V1_CsvProfile>;
  rowCount?: Maybe<Scalars['BigInt']>;
};

/** Maps to Csv::CsvIssue on backend */
export type Instacart_Partners_Partners_V1_CsvIssue = {
  __typename?: 'instacart_partners_partners_v1_CsvIssue';
  code?: Maybe<Scalars['String']>;
  column?: Maybe<Scalars['BigInt']>;
  message?: Maybe<Scalars['String']>;
  row?: Maybe<Scalars['BigInt']>;
  severity?: Maybe<Instacart_Partners_Partners_V1_CsvIssue_Severity>;
};

export enum Instacart_Partners_Partners_V1_CsvIssue_Severity {
  SeverityError = 'SEVERITY_ERROR',
  SeverityUnknown = 'SEVERITY_UNKNOWN',
  SeverityWarning = 'SEVERITY_WARNING'
}

/**
 * Maps to Csv::CsvProfile on backend
 * Contains metadata about the CSV structure and column-level statistics
 */
export type Instacart_Partners_Partners_V1_CsvProfile = {
  __typename?: 'instacart_partners_partners_v1_CsvProfile';
  columns?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_ColumnProfile>>>;
};

/** Maps to Csv::CsvValidationResult on backend */
export type Instacart_Partners_Partners_V1_CsvValidationResult = {
  __typename?: 'instacart_partners_partners_v1_CsvValidationResult';
  debugInfo?: Maybe<Instacart_Partners_Partners_V1_DebugInfo>;
  errors?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_CsvIssue>>>;
  warnings?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_CsvIssue>>>;
};

/** Maps to Csv::DebugInfo on backend */
export type Instacart_Partners_Partners_V1_DebugInfo = {
  __typename?: 'instacart_partners_partners_v1_DebugInfo';
  csvDebug?: Maybe<Instacart_Partners_Partners_V1_CsvDebug>;
  custom?: Maybe<Scalars['JSON']>;
};

/** --- DeleteFlipNote --- */
export type Instacart_Partners_Partners_V1_DeleteFlipNoteRequest_Input = {
  deletedBy?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for DeleteFlipNote: whether the soft-delete succeeded. */
export type Instacart_Partners_Partners_V1_DeleteFlipNoteResponse = {
  __typename?: 'instacart_partners_partners_v1_DeleteFlipNoteResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/** Request to delete an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeRequest_Input = {
  /** The ID of the configuration type to delete */
  id?: InputMaybe<Scalars['BigInt']>;
};

/** Response to delete an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_DeletePartnerConfigurationTypeResponse = {
  __typename?: 'instacart_partners_partners_v1_DeletePartnerConfigurationTypeResponse';
  /** Whether the delete was successful */
  success?: Maybe<Scalars['Boolean']>;
};

/** Request to tear down a previously provisioned sandbox whitelabel site */
export type Instacart_Partners_Partners_V1_DeleteSandboxWhitelabelSiteRequest_Input = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /**
   * Optional identifier of the production StoreConfiguration this sandbox was
   * created from. Optional at the wire level for compatibility with requests
   * that predate the field, but authorization checks will require it; when
   * set, it must match the store configuration of a production site the
   * sandbox was copied from, otherwise the request is rejected.
   */
  linkedStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Canonical key for the sandbox; the warehouse / store_configuration IDs are
   * supplied for cross-referencing only.
   */
  routingRuleId?: InputMaybe<Scalars['String']>;
  sandboxStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  sandboxWarehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for tearing down a sandbox whitelabel site */
export type Instacart_Partners_Partners_V1_DeleteSandboxWhitelabelSiteResponse = {
  __typename?: 'instacart_partners_partners_v1_DeleteSandboxWhitelabelSiteResponse';
  /** Human-readable detail (e.g. failure reason) when success is false. */
  message?: Maybe<Scalars['String']>;
  /**
   * Lifecycle snapshot of the sandbox. Present whenever the sandbox row
   * exists, independent of the outcome of this call, so prior terminal
   * operations remain visible even when this one failed.
   */
  status?: Maybe<Instacart_Partners_Partners_V1_SandboxStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Request to tear down routing metadata for a sandbox whitelabel site.
 * Idempotent: a request whose routing_rule_id no longer resolves to an
 * active routing rule is treated as a no-op success.
 */
export type Instacart_Partners_Partners_V1_DeprovisionSandboxWhitelabelSiteRequest_Input = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /**
   * Prod StoreConfiguration the sandbox lineage links to; used for
   * cross-referencing against the sandbox warehouse.
   */
  linkedStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Canonical key for the sandbox routing rule; the warehouse /
   * store_configuration IDs are supplied for cross-referencing only.
   */
  routingRuleId?: InputMaybe<Scalars['String']>;
  /**
   * Sandbox StoreConfiguration id; used for cross-referencing against the
   * sandbox warehouse's whitelabel sites so end-to-end validation matches
   * the pattern used by Delete / UpdateMetadata.
   */
  sandboxStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  sandboxWarehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for tearing down routing metadata on a sandbox whitelabel site. */
export type Instacart_Partners_Partners_V1_DeprovisionSandboxWhitelabelSiteResponse = {
  __typename?: 'instacart_partners_partners_v1_DeprovisionSandboxWhitelabelSiteResponse';
  /** Human-readable detail (e.g. failure reason) when success is false. */
  message?: Maybe<Scalars['String']>;
  /**
   * Lifecycle snapshot of the sandbox. Present whenever the sandbox row
   * exists, independent of the outcome of this call, so prior terminal
   * operations remain visible even when this one failed.
   */
  status?: Maybe<Instacart_Partners_Partners_V1_SandboxStatus>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Feature column metadata (sent once per feature in response). */
export type Instacart_Partners_Partners_V1_FlipDashboardColumn = {
  __typename?: 'instacart_partners_partners_v1_FlipDashboardColumn';
  displayName?: Maybe<Scalars['String']>;
  featureGroupDisplayName?: Maybe<Scalars['String']>;
  featureGroupName?: Maybe<Scalars['String']>;
  featureId?: Maybe<Scalars['BigInt']>;
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** A single row in the dashboard matrix (one enrollment). */
export type Instacart_Partners_Partners_V1_FlipDashboardRow = {
  __typename?: 'instacart_partners_partners_v1_FlipDashboardRow';
  /** Enrollment info */
  enrollmentId?: Maybe<Scalars['BigInt']>;
  enrollmentStatus?: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>;
  /** Feature statuses: key = feature name, value = cell data */
  features?: Maybe<Scalars['JSON']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  partnerName?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  /** Retailer's current SFX version data (synced from Store Configurations RPC) */
  sfxVersion?: Maybe<Instacart_Partners_Partners_V1_FlipSfxVersion>;
  /** Retailer's site identity metadata (synced from Store Configurations RPC) */
  siteInfo?: Maybe<Instacart_Partners_Partners_V1_FlipSiteInfo>;
  /** Store configuration ID from the retailer's whitelabel site */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  tierDisplayName?: Maybe<Scalars['String']>;
  tierKey?: Maybe<Scalars['String']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
};

/** Summary statistics for the dashboard. */
export type Instacart_Partners_Partners_V1_FlipDashboardSummary = {
  __typename?: 'instacart_partners_partners_v1_FlipDashboardSummary';
  enabledCount?: Maybe<Scalars['Int']>;
  totalEnrollments?: Maybe<Scalars['Int']>;
  totalFeatures?: Maybe<Scalars['Int']>;
};

/** Tooltip detail for a dashboard cell (e.g., Carrot Ads rev share breakdown). */
export type Instacart_Partners_Partners_V1_FlipDisplayDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipDisplayDetail';
  entries?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipDisplayDetailEntry>>>;
};

/** A single label:value row in a display detail tooltip. */
export type Instacart_Partners_Partners_V1_FlipDisplayDetailEntry = {
  __typename?: 'instacart_partners_partners_v1_FlipDisplayDetailEntry';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** How feature items contribute to the overall feature status. */
export enum Instacart_Partners_Partners_V1_FlipEnabledLogic {
  /** ON only if ALL items are ON */
  FlipEnabledLogicAllEnabled = 'FLIP_ENABLED_LOGIC_ALL_ENABLED',
  /** ON if ANY item is ON */
  FlipEnabledLogicAnyEnabled = 'FLIP_ENABLED_LOGIC_ANY_ENABLED',
  FlipEnabledLogicUnknown = 'FLIP_ENABLED_LOGIC_UNKNOWN'
}

/** Status of a feature enablement or feature item enablement. */
export enum Instacart_Partners_Partners_V1_FlipEnablementStatus {
  FlipEnablementStatusDisabled = 'FLIP_ENABLEMENT_STATUS_DISABLED',
  FlipEnablementStatusEnabled = 'FLIP_ENABLEMENT_STATUS_ENABLED',
  FlipEnablementStatusFailed = 'FLIP_ENABLEMENT_STATUS_FAILED',
  FlipEnablementStatusPendingDisable = 'FLIP_ENABLEMENT_STATUS_PENDING_DISABLE',
  FlipEnablementStatusPendingEnable = 'FLIP_ENABLEMENT_STATUS_PENDING_ENABLE',
  FlipEnablementStatusSuspended = 'FLIP_ENABLEMENT_STATUS_SUSPENDED',
  FlipEnablementStatusUnknown = 'FLIP_ENABLEMENT_STATUS_UNKNOWN'
}

/** Enrollment info for the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentDetail';
  id?: Maybe<Scalars['BigInt']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  partnerName?: Maybe<Scalars['String']>;
  productDisplayName?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  /** Retailer's current SFX version data (synced from Store Configurations RPC) */
  sfxVersion?: Maybe<Instacart_Partners_Partners_V1_FlipSfxVersion>;
  /** Retailer's site identity metadata (synced from Store Configurations RPC) */
  siteInfo?: Maybe<Instacart_Partners_Partners_V1_FlipSiteInfo>;
  status?: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>;
  /** Store configuration ID from the retailer's whitelabel site */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  tierDisplayName?: Maybe<Scalars['String']>;
  tierKey?: Maybe<Scalars['String']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
};

/** A single feature in the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentFeatureDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentFeatureDetail';
  description?: Maybe<Scalars['String']>;
  /** Resolved detail entries for enabled items when a feature defines detail-style display values. */
  displayDetail?: Maybe<Instacart_Partners_Partners_V1_FlipDisplayDetail>;
  /** Resolved display labels for enabled items when a feature defines label-style display values. */
  displayItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  displayName?: Maybe<Scalars['String']>;
  enabledLogic?: Maybe<Instacart_Partners_Partners_V1_FlipEnabledLogic>;
  items?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentItemDetail>>>;
  minimumTierDisplayName?: Maybe<Scalars['String']>;
  minimumTierKey?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  showItems?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Instacart_Partners_Partners_V1_FlipEnablementStatus>;
};

/** A group of features for the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentFeatureGroup = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentFeatureGroup';
  collapsedByDefault?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentFeatureDetail>>>;
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** A single feature item in the detail view. */
export type Instacart_Partners_Partners_V1_FlipEnrollmentItemDetail = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentItemDetail';
  attributeName?: Maybe<Scalars['String']>;
  /** Included when show_value is true */
  currentValue?: Maybe<Scalars['String']>;
  expectedValue?: Maybe<Scalars['String']>;
  /** item display name */
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Instacart_Partners_Partners_V1_FlipEnablementStatus>;
  valueLogic?: Maybe<Instacart_Partners_Partners_V1_FlipValueLogic>;
};

/** A single enrollment with site metadata (no feature matrix). */
export type Instacart_Partners_Partners_V1_FlipEnrollmentRow = {
  __typename?: 'instacart_partners_partners_v1_FlipEnrollmentRow';
  /** When the enrollment was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  enrollmentId?: Maybe<Scalars['BigInt']>;
  enrollmentStatus?: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>;
  /** When the enrollment was activated */
  onboardedAt?: Maybe<Scalars['DateTime']>;
  partnerId?: Maybe<Scalars['BigInt']>;
  partnerName?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  /** Retailer's current SFX version data (synced from Store Configurations RPC) */
  sfxVersion?: Maybe<Instacart_Partners_Partners_V1_FlipSfxVersion>;
  /** Retailer's site identity metadata (synced from Store Configurations RPC) */
  siteInfo?: Maybe<Instacart_Partners_Partners_V1_FlipSiteInfo>;
  /** Store configuration ID from the retailer's whitelabel site */
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  tierDisplayName?: Maybe<Scalars['String']>;
  tierKey?: Maybe<Scalars['String']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
};

/** Status of a product enrollment. */
export enum Instacart_Partners_Partners_V1_FlipEnrollmentStatus {
  FlipEnrollmentStatusActive = 'FLIP_ENROLLMENT_STATUS_ACTIVE',
  FlipEnrollmentStatusChurned = 'FLIP_ENROLLMENT_STATUS_CHURNED',
  FlipEnrollmentStatusInactive = 'FLIP_ENROLLMENT_STATUS_INACTIVE',
  FlipEnrollmentStatusOnboarding = 'FLIP_ENROLLMENT_STATUS_ONBOARDING',
  FlipEnrollmentStatusPaused = 'FLIP_ENROLLMENT_STATUS_PAUSED',
  FlipEnrollmentStatusUnknown = 'FLIP_ENROLLMENT_STATUS_UNKNOWN'
}

/** A product capability (e.g., IC+, Loyalty, $0 Delivery Fee). */
export type Instacart_Partners_Partners_V1_FlipFeature = {
  __typename?: 'instacart_partners_partners_v1_FlipFeature';
  description?: Maybe<Scalars['String']>;
  displayConfig?: Maybe<Scalars['JSON']>;
  displayName?: Maybe<Scalars['String']>;
  enabledLogic?: Maybe<Instacart_Partners_Partners_V1_FlipEnabledLogic>;
  featureGroupId?: Maybe<Scalars['BigInt']>;
  featureGroupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Optionally included
   * Minimum SFX version required for this feature (e.g., "R2024_11_0").
   * Nil means available on all SFX versions.
   */
  items?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipFeatureItem>>>;
  /** snake_case identifier */
  name?: Maybe<Scalars['String']>;
  releaseVersion?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
  status?: Maybe<Instacart_Partners_Partners_V1_FlipFeatureStatus>;
};

/** A logical grouping of features for dashboard organization. */
export type Instacart_Partners_Partners_V1_FlipFeatureGroup = {
  __typename?: 'instacart_partners_partners_v1_FlipFeatureGroup';
  collapsedByDefault?: Maybe<Scalars['Boolean']>;
  displayName?: Maybe<Scalars['String']>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** snake_case identifier */
  name?: Maybe<Scalars['String']>;
  sortOrder?: Maybe<Scalars['Int']>;
};

/** Links a feature to an OnboardingAttribute with evaluation logic. */
export type Instacart_Partners_Partners_V1_FlipFeatureItem = {
  __typename?: 'instacart_partners_partners_v1_FlipFeatureItem';
  /** OnboardingAttribute.attribute_name */
  attributeName?: Maybe<Scalars['String']>;
  expectedValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  itemName?: Maybe<Scalars['String']>;
  /** Stable snake_case identifier for programmatic use (e.g., "icplus_gift_cards", "loyalty_provider"). */
  name?: Maybe<Scalars['String']>;
  showValue?: Maybe<Scalars['Boolean']>;
  sortOrder?: Maybe<Scalars['Int']>;
  valueLogic?: Maybe<Instacart_Partners_Partners_V1_FlipValueLogic>;
};

/** Status of a feature in the catalog. */
export enum Instacart_Partners_Partners_V1_FlipFeatureStatus {
  FlipFeatureStatusDeprecated = 'FLIP_FEATURE_STATUS_DEPRECATED',
  FlipFeatureStatusDraft = 'FLIP_FEATURE_STATUS_DRAFT',
  FlipFeatureStatusReleased = 'FLIP_FEATURE_STATUS_RELEASED',
  FlipFeatureStatusUnknown = 'FLIP_FEATURE_STATUS_UNKNOWN'
}

/** A user-created text annotation on a site × feature intersection. */
export type Instacart_Partners_Partners_V1_FlipNote = {
  __typename?: 'instacart_partners_partners_v1_FlipNote';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  /** When the note was soft-deleted (not set for active notes). */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Reason the note was deleted. */
  deletionReason?: Maybe<Instacart_Partners_Partners_V1_FlipNoteDeletionReason>;
  featureId?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  /** Whether this note has been soft-deleted. */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** Whether this note has been edited (has revisions or is itself a revision). */
  isEdited?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSON']>;
  productEnrollmentId?: Maybe<Scalars['BigInt']>;
  /** ID of the original root note (0 for root notes, non-zero for revisions). */
  rootNoteId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<Scalars['String']>;
};

/** Reason a note was soft-deleted. */
export enum Instacart_Partners_Partners_V1_FlipNoteDeletionReason {
  FlipNoteDeletionReasonUnknown = 'FLIP_NOTE_DELETION_REASON_UNKNOWN',
  FlipNoteDeletionReasonUserDeleted = 'FLIP_NOTE_DELETION_REASON_USER_DELETED',
  FlipNoteDeletionReasonVersioned = 'FLIP_NOTE_DELETION_REASON_VERSIONED'
}

/**
 * SFX release version data for a retailer's enrollment.
 * Synced from Store Configurations RPC by SyncVersionService.
 */
export type Instacart_Partners_Partners_V1_FlipSfxVersion = {
  __typename?: 'instacart_partners_partners_v1_FlipSfxVersion';
  /** Current SFX release version (e.g., "2024.40"). Nil for fastlane retailers. */
  current?: Maybe<Scalars['String']>;
  /** Whether the retailer has delayed release enabled. */
  delayedRelease?: Maybe<Scalars['Boolean']>;
  /** "fastlane" (latest version) or "slowlane" (pinned/delayed release). */
  track?: Maybe<Scalars['String']>;
  /** When the version data was last synced (ISO 8601). */
  updatedAt?: Maybe<Scalars['String']>;
};

/**
 * Site identity metadata for a retailer's enrollment.
 * Synced from Store Configurations RPC (settings + branding domains) by SyncVersionService.
 */
export type Instacart_Partners_Partners_V1_FlipSiteInfo = {
  __typename?: 'instacart_partners_partners_v1_FlipSiteInfo';
  /** The retailer's branded display name (e.g., "ALDI"). */
  brandedName?: Maybe<Scalars['String']>;
  /** The retailer's storefront domain (e.g., "shop.aldi.us"). */
  domainName?: Maybe<Scalars['String']>;
  /** URL of the retailer's default logo (light variant). */
  logoUrl?: Maybe<Scalars['String']>;
  /** When the site info was last synced (ISO 8601). */
  updatedAt?: Maybe<Scalars['String']>;
};

/** Value logic for evaluating a feature item. */
export enum Instacart_Partners_Partners_V1_FlipValueLogic {
  FlipValueLogicEquals = 'FLIP_VALUE_LOGIC_EQUALS',
  FlipValueLogicFalsy = 'FLIP_VALUE_LOGIC_FALSY',
  FlipValueLogicNotEquals = 'FLIP_VALUE_LOGIC_NOT_EQUALS',
  FlipValueLogicPresent = 'FLIP_VALUE_LOGIC_PRESENT',
  FlipValueLogicTruthy = 'FLIP_VALUE_LOGIC_TRUTHY',
  FlipValueLogicUnknown = 'FLIP_VALUE_LOGIC_UNKNOWN'
}

/** GetCsvValidationResult rpc request */
export type Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_Input = {
  /** unique identifier for the validation result */
  id?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  /** response type */
  responseType?: InputMaybe<Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_ResponseType>;
};

export enum Instacart_Partners_Partners_V1_GetCsvValidationResultRequest_ResponseType {
  ResponseTypePresignedUrl = 'RESPONSE_TYPE_PRESIGNED_URL',
  ResponseTypeResult = 'RESPONSE_TYPE_RESULT',
  ResponseTypeUnknown = 'RESPONSE_TYPE_UNKNOWN'
}

/** GetCsvValidationResult rpc response */
export type Instacart_Partners_Partners_V1_GetCsvValidationResultResponse = {
  __typename?: 'instacart_partners_partners_v1_GetCsvValidationResultResponse';
  presignedUrl?: Maybe<Scalars['String']>;
  result?: Maybe<Instacart_Partners_Partners_V1_CsvValidationResult>;
};

/** Request for GetFlipDashboard: paginated enrollments with feature statuses for a product. */
export type Instacart_Partners_Partners_V1_GetFlipDashboardRequest_Input = {
  /** Date range filter */
  enabledSince?: InputMaybe<Scalars['DateTime']>;
  enabledUntil?: InputMaybe<Scalars['DateTime']>;
  enablementStatusFilter?: InputMaybe<Instacart_Partners_Partners_V1_FlipEnablementStatus>;
  /**
   * Filter enrollments by lifecycle status (e.g., active, onboarding, inactive).
   * Distinct from enablement_status_filter, which filters by per-feature ON/OFF state.
   * When empty, enrollments of all statuses are returned.
   */
  enrollmentStatuses?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>>>;
  /**
   * Filter status evaluation to specific configurations (feature items).
   * When populated, enablement_status_filter applies at the FeatureItemEnablement
   * level for items matching these names, instead of at the FeatureEnablement level.
   * Values correspond to FlipFeatureItem.name (e.g., "icplus_gift_cards", "loyalty_provider").
   */
  featureItemNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Filter columns to specific features */
  featureNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Pagination (uses common.proto) */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** Filter enrollments to specific partners */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Required: which product to show the dashboard for */
  productName?: InputMaybe<Scalars['String']>;
  /** Filters */
  search?: InputMaybe<Scalars['String']>;
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
  /** Filter enrollments to specific whitelabel sites */
  whitelabelSiteIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for GetFlipDashboard: rows, columns, summary, and pagination metadata. */
export type Instacart_Partners_Partners_V1_GetFlipDashboardResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipDashboardResponse';
  /** Columns: feature metadata for column headers (sent once, not per row) */
  columns?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipDashboardColumn>>>;
  /** Pagination metadata */
  paginationInstruction?: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  /** Rows: one per product enrollment */
  rows?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipDashboardRow>>>;
  /** Summary metrics */
  summary?: Maybe<Instacart_Partners_Partners_V1_FlipDashboardSummary>;
};

/** Request for GetFlipEnrollmentDetail: fetch a single enrollment's feature matrix. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailRequest_Input = {
  productEnrollmentId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for GetFlipEnrollmentDetail: enrollment info with grouped features and items. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentDetailResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipEnrollmentDetailResponse';
  enrollment?: Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentDetail>;
  featureGroups?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentFeatureGroup>>>;
};

/** Request for GetFlipEnrollments: paginated enrollments with site metadata. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentsRequest_Input = {
  /** Pagination (uses common.proto) */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** Filter to specific partners */
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Optional: filter by product name (e.g., "whitelabel") */
  productName?: InputMaybe<Scalars['String']>;
  /** Filters */
  search?: InputMaybe<Scalars['String']>;
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
  /** Filter by enrollment status (multiple allowed) */
  statuses?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_FlipEnrollmentStatus>>>;
  /** Filter to specific whitelabel sites */
  whitelabelSiteIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Response for GetFlipEnrollments: enrollment rows with pagination metadata. */
export type Instacart_Partners_Partners_V1_GetFlipEnrollmentsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipEnrollmentsResponse';
  enrollments?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipEnrollmentRow>>>;
  paginationInstruction?: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
};

/** Response for GetFlipFeatureGroups: list of feature groups ordered by sort_order. */
export type Instacart_Partners_Partners_V1_GetFlipFeatureGroupsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipFeatureGroupsResponse';
  featureGroups?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipFeatureGroup>>>;
};

/** Request for GetFlipFeatures: optional filters for the feature catalog. */
export type Instacart_Partners_Partners_V1_GetFlipFeaturesRequest_Input = {
  /** Optional: filter by feature group name */
  featureGroupName?: InputMaybe<Scalars['String']>;
  /** Optional: include draft features (default: false, only released) */
  includeDraft?: InputMaybe<Scalars['Boolean']>;
  /** Optional: filter by product name (only features available for this product) */
  productName?: InputMaybe<Scalars['String']>;
};

/** Response for GetFlipFeatures: list of features with items and metadata. */
export type Instacart_Partners_Partners_V1_GetFlipFeaturesResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipFeaturesResponse';
  features?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipFeature>>>;
};

/** --- GetFlipNoteHistory --- */
export type Instacart_Partners_Partners_V1_GetFlipNoteHistoryRequest_Input = {
  /** Any note ID (root or revision). The response contains the full version chain. */
  noteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for GetFlipNoteHistory: all versions of a note ordered by created_at ASC. */
export type Instacart_Partners_Partners_V1_GetFlipNoteHistoryResponse = {
  __typename?: 'instacart_partners_partners_v1_GetFlipNoteHistoryResponse';
  notes?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipNote>>>;
};

/** Request to get paginated partner configuration types. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedRequest_Input = {
  /** The type of configurables to filter by */
  configurableTypes?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>>>;
  /** Information on how to paginate the results of the request. */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** Information on how to sort the results (list of attribute and direction) */
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
};

/** Response to get paginated partner configuration types. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationTypesPaginatedResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationTypesPaginatedResponse';
  /** How many total configuration types match the criteria */
  count?: Maybe<Scalars['BigInt']>;
  /** How the results are paginated */
  paginationInstruction?: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  partnerConfigurationTypes?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>>>;
};

/**
 * Request to get partner configurations for given composite keys.
 * This only works on hierarchical configs
 */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsByCompositeKeyRequest_Input = {
  /** The IDs of the configurable entities to get configurations for */
  compositeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The type of configurable entity to get configurations for */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** If true, disable auto creation of configurations */
  disableAutoCreation?: InputMaybe<Scalars['Boolean']>;
  /** The type of partner configuration to get */
  partnerConfigurationType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** If false, return only merged config.  If true, return merge, base, and override configs */
  verbose?: InputMaybe<Scalars['Boolean']>;
};

/** Response to get partner configurations for given composite keys. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsByCompositeKeyResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationsByCompositeKeyResponse';
  partnerConfigurations?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationsByCompositeKey>>>;
};

/** Used to filter by multiple configurable types at once */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_ConfigurableTypeIdsMap_Input = {
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/** Request to get paginated configurations. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_Input = {
  /** Fetches only hierarchical configs that are childern of the given prefix */
  compositeKeyPrefix?: InputMaybe<Scalars['String']>;
  /** Fetches only hierarchical configs with one of these composite keys */
  compositeKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The IDs of the entities to get configurations for, optional */
  configurableIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Used to filter by multiple configurable types at once. Cannot be provided together with configurable_types */
  configurableTypeIdsMap?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedRequest_ConfigurableTypeIdsMap_Input>>>;
  /**
   * The types of configurable entities to get configurations for, optional.
   * Only supports one configurable_type at a time.
   * If multiple configurable_types are provided, the request will fail.
   * Cannot be provided together with configurable_type_ids_map.
   */
  configurableTypes?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>>>;
  /** This will filter for configurations that start before the end_time */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Filters out auto generated configurations */
  excludeAutoGeneratedConfigs?: InputMaybe<Scalars['Boolean']>;
  /** Fetches only hierarchical configs with value_jsonb not matching given value */
  excludeJson?: InputMaybe<Scalars['JSON']>;
  /**
   * Fetches only configs where value_jsonb does not match the given JSON path expression.
   * Expected structure: { "path": "$[.**].some.path", "value": "some_value" }
   * "path" (required): a PostgreSQL JSONPath expression. The `$[.**]` prefix performs a
   * recursive descent over all array elements and object values in value_jsonb.
   * "value" (optional): when present, filters out configs where the value at "path" equals
   * this scalar (string, number, boolean, or null). Omit to filter by path existence only.
   * An absent field disables this filter.
   */
  excludeJsonPath?: InputMaybe<Scalars['JSON']>;
  /** The IDs of the partner configurations to fetch, optional */
  ids?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** Fetches only hierarchical configs with value_jsonb matching given value */
  includeJson?: InputMaybe<Scalars['JSON']>;
  /**
   * Fetches only configs where value_jsonb matches the given JSON path expression.
   * Expected structure: { "path": "$[.**].some.path", "value": "some_value" }
   * "path" (required): a PostgreSQL JSONPath expression. The `$[.**]` prefix performs a
   * recursive descent over all array elements and object values in value_jsonb.
   * "value" (optional): when present, filters to configs where the value at "path" equals
   * this scalar (string, number, boolean, or null). Omit to filter by path existence only.
   * An absent field disables this filter.
   */
  includeJsonPath?: InputMaybe<Scalars['JSON']>;
  /** Whether to include the partner configuration type association object in the response */
  includePartnerConfigurationTypeData?: InputMaybe<Scalars['Boolean']>;
  /** Information on how to paginate the results of a list/filter operation */
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  /** The types of partner configurations to get, optional */
  partnerConfigurationTypes?: InputMaybe<Array<InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>>>;
  /** Information on how to sort the results (attribute and direction) */
  sortingInstruction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDetails_Input>;
  /** This will filter for configurations that end after the start_time */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** Fetches only configs where value_jsonb contains all the specified key-value pairs (JSONB @> containment) */
  valueJsonbContains?: InputMaybe<Scalars['JSON']>;
};

/** Response to get paginated partner configurations for given configurable information. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsPaginatedResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationsPaginatedResponse';
  /** How many total configurations are returned */
  count?: Maybe<Scalars['BigInt']>;
  /** How the results are paginated */
  paginationInstruction?: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  /** Data found for the request */
  partnerConfigurations?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/** Request to get configurations for a given configurable type with a list of configurable ids. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsRequest_Input = {
  /** The IDs of the configurable entities to get configurations for */
  configurableIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  /** The type of configurable entity to get configurations for */
  configurableType?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** This will filter for configurations that start before the end_time */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** Whether to include the partner configuration type association object in the response */
  includePartnerConfigurationTypeData?: InputMaybe<Scalars['Boolean']>;
  /** The type of partner configuration to get */
  partnerConfigurationType?: InputMaybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** This will filter for configurations that end after the start_time */
  startTime?: InputMaybe<Scalars['DateTime']>;
};

/** Response to get partner configurations for given configurable information. */
export type Instacart_Partners_Partners_V1_GetPartnerConfigurationsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetPartnerConfigurationsResponse';
  /** The configurations found for the request */
  partnerConfigurations?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerConfiguration>>>;
};

/** Request message for GetWhitelabelApp (single app by ID) */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppRequest_Input = {
  whitelabelAppId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for GetWhitelabelApp (single app by ID) */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppResponse = {
  __typename?: 'instacart_partners_partners_v1_GetWhitelabelAppResponse';
  whitelabelApp?: Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>;
};

/** Request message for GetWhitelabelApps */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppsRequest_Input = {
  betaReleaseStatus?: InputMaybe<Scalars['String']>;
  buildsEnabled?: InputMaybe<Scalars['Boolean']>;
  inProgressStatus?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  platform?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for GetWhitelabelApps */
export type Instacart_Partners_Partners_V1_GetWhitelabelAppsResponse = {
  __typename?: 'instacart_partners_partners_v1_GetWhitelabelAppsResponse';
  pagination?: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
  whitelabelApps?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>>>;
};

/** Wrapper so `ip_cidrs` can distinguish "not set" (nil) from "set to an empty list". */
export type Instacart_Partners_Partners_V1_IpCidrsList_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** --- ListFlipNotes --- */
export type Instacart_Partners_Partners_V1_ListFlipNotesRequest_Input = {
  featureId?: InputMaybe<Scalars['BigInt']>;
  /** When true, includes user-deleted notes alongside active notes. */
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
  paginationInstruction?: InputMaybe<Instacart_Partners_Partners_V1_PaginationDetails_Input>;
  productEnrollmentId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for ListFlipNotes: paginated notes for the requested site × feature intersection. */
export type Instacart_Partners_Partners_V1_ListFlipNotesResponse = {
  __typename?: 'instacart_partners_partners_v1_ListFlipNotesResponse';
  notes?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_FlipNote>>>;
  paginationInstruction?: Maybe<Instacart_Partners_Partners_V1_PaginationDetails>;
};

/** Request to list all sandbox whitelabel sites associated with a retailer. */
export type Instacart_Partners_Partners_V1_ListSandboxWhitelabelSitesByRetailerRequest_Input = {
  retailerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for listing sandbox whitelabel sites for a retailer */
export type Instacart_Partners_Partners_V1_ListSandboxWhitelabelSitesByRetailerResponse = {
  __typename?: 'instacart_partners_partners_v1_ListSandboxWhitelabelSitesByRetailerResponse';
  sandboxes?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_SandboxWhitelabelSiteSummary>>>;
};

/**
 * Request to list all sandbox whitelabel sites associated with a partner.
 * `partner_id` is the V4 partner id (LaunchOnboardingPartner.external_id).
 */
export type Instacart_Partners_Partners_V1_ListSandboxesWhitelabelSitesByPartnerRequest_Input = {
  partnerId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for listing sandbox whitelabel sites for a partner */
export type Instacart_Partners_Partners_V1_ListSandboxesWhitelabelSitesByPartnerResponse = {
  __typename?: 'instacart_partners_partners_v1_ListSandboxesWhitelabelSitesByPartnerResponse';
  sandboxWhitelabelSites?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_PartnerSandboxSummary>>>;
};

/** Generic object to represent pagination details */
export type Instacart_Partners_Partners_V1_PaginationDetails = {
  __typename?: 'instacart_partners_partners_v1_PaginationDetails';
  page?: Maybe<Scalars['BigInt']>;
  perPage?: Maybe<Scalars['BigInt']>;
  totalCount?: Maybe<Scalars['BigInt']>;
  totalPages?: Maybe<Scalars['BigInt']>;
};

/** Generic object to represent pagination details */
export type Instacart_Partners_Partners_V1_PaginationDetails_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  perPage?: InputMaybe<Scalars['BigInt']>;
  totalCount?: InputMaybe<Scalars['BigInt']>;
  totalPages?: InputMaybe<Scalars['BigInt']>;
};

/** Object to represent a partner configuration. */
export type Instacart_Partners_Partners_V1_PartnerConfiguration = {
  __typename?: 'instacart_partners_partners_v1_PartnerConfiguration';
  /** Key used to query a node in the hierarchical config */
  compositeKey?: Maybe<Scalars['String']>;
  /** The ID of the configuration */
  configurableId?: Maybe<Scalars['BigInt']>;
  /** The type of configurable entity */
  configurableType?: Maybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The user or system who created the configuration */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The user or system who created the configuration */
  createdBy?: Maybe<Scalars['String']>;
  /** The end time of the configuration */
  endTime?: Maybe<Scalars['DateTime']>;
  /** The ID of the configuration */
  id?: Maybe<Scalars['BigInt']>;
  /** The type of partner configuration */
  partnerConfigurationType?: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationType>;
  /** The associated partner configuration type record; requires request to specify whether to include it or not via include_partner_configuration_type_data field */
  partnerConfigurationTypeData?: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>;
  /** The configuration setting */
  setting?: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting>;
  /** The start time of the configuration */
  startTime?: Maybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Enum to represent the type of partner configuration. */
export enum Instacart_Partners_Partners_V1_PartnerConfigurationType {
  PartnerConfigurationTypeBatching = 'PARTNER_CONFIGURATION_TYPE_BATCHING',
  PartnerConfigurationTypeCxOrderPolicies = 'PARTNER_CONFIGURATION_TYPE_CX_ORDER_POLICIES',
  PartnerConfigurationTypeFulfillmentGroupIndex = 'PARTNER_CONFIGURATION_TYPE_FULFILLMENT_GROUP_INDEX',
  PartnerConfigurationTypeFulfillmentHierarchy = 'PARTNER_CONFIGURATION_TYPE_FULFILLMENT_HIERARCHY',
  PartnerConfigurationTypeHomeStrategicRetailerBoost = 'PARTNER_CONFIGURATION_TYPE_HOME_STRATEGIC_RETAILER_BOOST',
  PartnerConfigurationTypeIsSaverStore = 'PARTNER_CONFIGURATION_TYPE_IS_SAVER_STORE',
  PartnerConfigurationTypeServiceOptionAvailability = 'PARTNER_CONFIGURATION_TYPE_SERVICE_OPTION_AVAILABILITY',
  PartnerConfigurationTypeUnknown = 'PARTNER_CONFIGURATION_TYPE_UNKNOWN'
}

/** Object to represent a partner configuration type. */
export type Instacart_Partners_Partners_V1_PartnerConfigurationTypeData = {
  __typename?: 'instacart_partners_partners_v1_PartnerConfigurationTypeData';
  /** The configurable type (e.g. RetailerLocation) that can be assigned the configuration */
  configurableType?: Maybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The date the configuration type was created */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** The user or system who created the configuration type */
  createdBy?: Maybe<Scalars['String']>;
  /** The data type of the configuration type */
  dataType?: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeDataType>;
  /** The description of the configuration type */
  description?: Maybe<Scalars['String']>;
  /** The ID of the configuration type */
  id?: Maybe<Scalars['BigInt']>;
  /** The name of the configuration type */
  name?: Maybe<Scalars['String']>;
  /** The date the configuration type was updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration type */
  updatedBy?: Maybe<Scalars['String']>;
};

/** Enum to represent the data type of partner configuration type. */
export enum Instacart_Partners_Partners_V1_PartnerConfigurationTypeDataType {
  PartnerConfigurationTypeDataTypeBoolean = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_BOOLEAN',
  PartnerConfigurationTypeDataTypeJsonb = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_JSONB',
  PartnerConfigurationTypeDataTypeNumber = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_NUMBER',
  PartnerConfigurationTypeDataTypeString = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_STRING',
  PartnerConfigurationTypeDataTypeUnknown = 'PARTNER_CONFIGURATION_TYPE_DATA_TYPE_UNKNOWN'
}

/** Object to represent a hierarchical configuration. */
export type Instacart_Partners_Partners_V1_PartnerConfigurationsByCompositeKey = {
  __typename?: 'instacart_partners_partners_v1_PartnerConfigurationsByCompositeKey';
  /** Configuration of the parent config */
  base?: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting>;
  /** The ID of the configuration */
  compositeKey?: Maybe<Scalars['String']>;
  /** The ID of the configurable entity */
  configurableId?: Maybe<Scalars['BigInt']>;
  /** The type of configurable entity */
  configurableType?: Maybe<Instacart_Partners_Partners_V1_ConfigurableType>;
  /** The ID of the configuration */
  id?: Maybe<Scalars['BigInt']>;
  /** Merged config. Parent config with the overrides applied */
  merged?: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting>;
  /** Overrides. These are the values the the hierarchical overrides */
  overrides?: Maybe<Instacart_Partners_Partners_V1_ConfigurationSetting>;
};

/**
 * Summary of a sandbox warehouse and its linked production warehouse. Carries
 * display metadata only; operational fields such as the IP allowlist and
 * enabled state are returned by the sandbox detail RPCs. Web-specific fields
 * carry the `web_` prefix. The sandbox's iOS / Android whitelabel apps are
 * returned in `apps`.
 */
export type Instacart_Partners_Partners_V1_PartnerSandboxSummary = {
  __typename?: 'instacart_partners_partners_v1_PartnerSandboxSummary';
  /**
   * Mobile whitelabel apps (iOS / Android) belonging to the sandbox
   * warehouse's whitelabel sites. Empty when the sandbox has no mobile apps.
   */
  apps?: Maybe<Array<Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>>>;
  /** Timestamp when the sandbox was created. */
  createdAt?: Maybe<Scalars['DateTime']>;
  /**
   * Identifier of the actor that created the sandbox. Unset for sandboxes
   * created before audit metadata was captured.
   */
  createdByUserId?: Maybe<Scalars['String']>;
  /** Display name of the linked production web WhitelabelSite. */
  linkedSiteName?: Maybe<Scalars['String']>;
  /**
   * Store configuration id for the linked production warehouse. Wrapped for
   * the same reason as `sandbox_store_configuration_id`.
   */
  linkedStoreConfigurationId?: Maybe<Scalars['BigInt']>;
  /**
   * Production warehouse this sandbox was copied from (LaunchOnboardingWarehouse
   * id on the Partners side / warehouse row on V4).
   */
  linkedWarehouseId?: Maybe<Scalars['BigInt']>;
  /** Public URL of the linked production web WhitelabelSite. */
  linkedWebUrl?: Maybe<Scalars['String']>;
  /** Display name of the sandbox web WhitelabelSite. */
  name?: Maybe<Scalars['String']>;
  /** Identifier of the sandbox retailer. Unset until one is assigned. */
  sandboxRetailerExternalId?: Maybe<Scalars['BigInt']>;
  /**
   * Store configuration id for the sandbox warehouse. Wrapped so a warehouse
   * whose store configuration has not been resolved yet can be represented
   * without emitting a bogus 0.
   */
  sandboxStoreConfigurationId?: Maybe<Scalars['BigInt']>;
  /** Sandbox warehouse row (LaunchOnboardingWarehouse on the Partners side). */
  sandboxWarehouseId?: Maybe<Scalars['BigInt']>;
  /**
   * Lifecycle snapshot of the sandbox across the five operations
   * (create / delete / provision / deprovision / resync). A per-operation
   * field is unset when that operation has never terminated on this sandbox.
   */
  status?: Maybe<Instacart_Partners_Partners_V1_SandboxStatus>;
  /** Timestamp when the sandbox was most recently updated. */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Identifier of the actor that most recently updated the sandbox. */
  updatedByUserId?: Maybe<Scalars['String']>;
  /** Public URL of the sandbox web WhitelabelSite. */
  webUrl?: Maybe<Scalars['String']>;
};

/**
 * Request to provision routing metadata for a sandbox whitelabel site whose
 * warehouse / store configuration lineage already exists.
 */
export type Instacart_Partners_Partners_V1_ProvisionSandboxWhitelabelSiteRequest_Input = {
  /** Whether the IP allowlist is enforced. False = all IPs allowed regardless of ip_cidrs. */
  ipAllowlistEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Initial IP CIDR allowlist for the sandbox. Ignored when ip_allowlist_enabled is false. */
  ipCidrs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /**
   * Prod StoreConfiguration the sandbox lineage links to; used for
   * cross-referencing against the sandbox warehouse.
   */
  linkedStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Sandbox StoreConfiguration id; used for cross-referencing against the
   * sandbox warehouse's whitelabel sites so end-to-end validation matches
   * the pattern used by Delete / UpdateMetadata.
   */
  sandboxStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  sandboxWarehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for provisioning routing metadata on a sandbox whitelabel site. */
export type Instacart_Partners_Partners_V1_ProvisionSandboxWhitelabelSiteResponse = {
  __typename?: 'instacart_partners_partners_v1_ProvisionSandboxWhitelabelSiteResponse';
  /**
   * Sandbox summary with routing metadata (routing_rule_id, sandbox_url,
   * enabled, ip_cidrs, ip_allowlist_enabled) populated post-provision.
   */
  sandbox?: Maybe<Instacart_Partners_Partners_V1_SandboxWhitelabelSiteSummary>;
  waterfallEffectId?: Maybe<Scalars['BigInt']>;
};

/** Request message for Releasing an WhitelabelApp to Production. */
export type Instacart_Partners_Partners_V1_ReleaseAppToProductionRequest_Input = {
  scheduledReleaseDate?: InputMaybe<Scalars['String']>;
  versionNumber?: InputMaybe<Scalars['String']>;
  whitelabelAppId?: InputMaybe<Scalars['String']>;
};

/** Response message for Releasing a WhitelabelApp */
export type Instacart_Partners_Partners_V1_ReleaseAppToProductionResponse = {
  __typename?: 'instacart_partners_partners_v1_ReleaseAppToProductionResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Request to re-copy approved-or-later attribute values from the linked
 * production warehouse into an existing sandbox. Idempotent: safe to call
 * even when a prior sync partially completed.
 */
export type Instacart_Partners_Partners_V1_ResyncSandboxAttributeValuesRequest_Input = {
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /**
   * Optional identifier of the production StoreConfiguration this sandbox was
   * created from. Optional at the wire level for compatibility with requests
   * that predate the field, but authorization checks will require it; when
   * set, it must match the store configuration of a production site the
   * sandbox was copied from, otherwise the request is rejected.
   */
  linkedStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional identifier of a StoreConfiguration belonging to this sandbox.
   * When supplied, the id must belong to a whitelabel site under the
   * sandbox warehouse; otherwise the request is rejected. When omitted,
   * the server derives the sandbox StoreConfiguration from the sandbox's
   * whitelabel sites and the response's embedded
   * `SandboxWhitelabelSiteSummary.sandbox_store_configuration_id` (plain
   * `int64`) serializes as `0` (proto3 default) if it cannot be resolved
   * — read that as "not yet resolved", not as a real id.
   */
  sandboxStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  sandboxWarehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for re-syncing sandbox attribute values from production. */
export type Instacart_Partners_Partners_V1_ResyncSandboxAttributeValuesResponse = {
  __typename?: 'instacart_partners_partners_v1_ResyncSandboxAttributeValuesResponse';
  /** Sandbox summary with the post-resync lifecycle status embedded. */
  sandbox?: Maybe<Instacart_Partners_Partners_V1_SandboxWhitelabelSiteSummary>;
  waterfallEffectId?: Maybe<Scalars['BigInt']>;
};

/**
 * Terminal state of a single sandbox lifecycle operation. UNKNOWN is the
 * proto3 default and means the operation has never been recorded for this
 * sandbox.
 */
export enum Instacart_Partners_Partners_V1_SandboxOperationState {
  SandboxOperationStateFailed = 'SANDBOX_OPERATION_STATE_FAILED',
  SandboxOperationStateSucceeded = 'SANDBOX_OPERATION_STATE_SUCCEEDED',
  SandboxOperationStateUnknown = 'SANDBOX_OPERATION_STATE_UNKNOWN'
}

/**
 * Per-operation status entry. Only recorded on terminal transitions
 * (succeeded / failed); an operation still in flight has no entry.
 */
export type Instacart_Partners_Partners_V1_SandboxOperationStatus = {
  __typename?: 'instacart_partners_partners_v1_SandboxOperationStatus';
  completedAt?: Maybe<Scalars['DateTime']>;
  /**
   * User-safe failure reason. Set only when state is FAILED. Sanitized on
   * the server; never a raw exception message or stack trace.
   */
  failureReason?: Maybe<Scalars['String']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Instacart_Partners_Partners_V1_SandboxOperationState>;
};

/**
 * Snapshot of the sandbox lifecycle across all five independently-driven
 * operations. Fields are unset for operations that have never terminated
 * on this sandbox, letting callers distinguish e.g. "create succeeded but
 * provision never ran" from "provision failed". `resync` records the last
 * attempt to re-copy attribute values from prod into an existing sandbox.
 */
export type Instacart_Partners_Partners_V1_SandboxStatus = {
  __typename?: 'instacart_partners_partners_v1_SandboxStatus';
  create?: Maybe<Instacart_Partners_Partners_V1_SandboxOperationStatus>;
  delete?: Maybe<Instacart_Partners_Partners_V1_SandboxOperationStatus>;
  deprovision?: Maybe<Instacart_Partners_Partners_V1_SandboxOperationStatus>;
  provision?: Maybe<Instacart_Partners_Partners_V1_SandboxOperationStatus>;
  resync?: Maybe<Instacart_Partners_Partners_V1_SandboxOperationStatus>;
};

/**
 * A sandbox whitelabel site entity. One provisioning yields multiple of these,
 * split by platform type (web, ios, android).
 */
export type Instacart_Partners_Partners_V1_SandboxWhitelabelSite = {
  __typename?: 'instacart_partners_partners_v1_SandboxWhitelabelSite';
  id?: Maybe<Scalars['BigInt']>;
  type?: Maybe<Scalars['String']>;
};

/** Summary of a sandbox whitelabel site, returned by list queries. */
export type Instacart_Partners_Partners_V1_SandboxWhitelabelSiteSummary = {
  __typename?: 'instacart_partners_partners_v1_SandboxWhitelabelSiteSummary';
  /**
   * Whether the sandbox is serving traffic. False = sandbox is provisioned but
   * temporarily taken offline. Independent of ip_allowlist_enabled.
   */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Whether the IP allowlist is enforced. False = all IPs allowed regardless of ip_cidrs. */
  ipAllowlistEnabled?: Maybe<Scalars['Boolean']>;
  /** Allowlisted CIDRs. Only meaningful when ip_allowlist_enabled is true. */
  ipCidrs?: Maybe<Array<Maybe<Scalars['String']>>>;
  routingRuleId?: Maybe<Scalars['String']>;
  sandboxStoreConfigurationId?: Maybe<Scalars['BigInt']>;
  /** URL slug of the sandbox store configuration. */
  sandboxStoreConfigurationSlug?: Maybe<Scalars['String']>;
  sandboxUrl?: Maybe<Scalars['String']>;
  sandboxWarehouseId?: Maybe<Scalars['BigInt']>;
  /**
   * Lifecycle snapshot of the sandbox across the five operations
   * (create / delete / provision / deprovision / resync). A per-operation
   * field is unset when that operation has never terminated on this sandbox.
   */
  status?: Maybe<Instacart_Partners_Partners_V1_SandboxStatus>;
};

/** Generic object to represent sorting details */
export type Instacart_Partners_Partners_V1_SortingDetails_Input = {
  /** The direction to sort, defaults to ascending */
  direction?: InputMaybe<Instacart_Partners_Partners_V1_SortingDirection>;
  /** The name of the field to sort on, e.g. starts_at */
  fieldName?: InputMaybe<Scalars['String']>;
};

/** Sorting direction enum */
export enum Instacart_Partners_Partners_V1_SortingDirection {
  SortingDirectionAsc = 'SORTING_DIRECTION_ASC',
  SortingDirectionDesc = 'SORTING_DIRECTION_DESC',
  SortingDirectionUnknown = 'SORTING_DIRECTION_UNKNOWN'
}

/** --- UpdateFlipNote --- */
export type Instacart_Partners_Partners_V1_UpdateFlipNoteRequest_Input = {
  body?: InputMaybe<Scalars['String']>;
  noteId?: InputMaybe<Scalars['BigInt']>;
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Response for UpdateFlipNote: the updated note. */
export type Instacart_Partners_Partners_V1_UpdateFlipNoteResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdateFlipNoteResponse';
  note?: Maybe<Instacart_Partners_Partners_V1_FlipNote>;
};

/** Input to update a configuration for a given configuration information. */
export type Instacart_Partners_Partners_V1_UpdatePartnerConfigurationInput_Input = {
  /** The end time of the configuration */
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** The ID of the configuration to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The configuration setting to update */
  setting?: InputMaybe<Instacart_Partners_Partners_V1_ConfigurationSetting_Input>;
  /** The start time of the configuration */
  startTime?: InputMaybe<Scalars['DateTime']>;
  /** The user or system who updated the configuration */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Request to update an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeRequest_Input = {
  /** The description of the configuration type */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the configuration type to update */
  id?: InputMaybe<Scalars['BigInt']>;
  /** The user or system who updated the configuration type */
  updatedBy?: InputMaybe<Scalars['String']>;
};

/** Response to update an existing partner configuration type. */
export type Instacart_Partners_Partners_V1_UpdatePartnerConfigurationTypeResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdatePartnerConfigurationTypeResponse';
  /** The configuration type updated */
  partnerConfigurationType?: Maybe<Instacart_Partners_Partners_V1_PartnerConfigurationTypeData>;
};

/**
 * Request to update metadata on an existing sandbox whitelabel site. Unset
 * fields are left unchanged.
 */
export type Instacart_Partners_Partners_V1_UpdateSandboxWhitelabelSiteMetadataRequest_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  ipAllowlistEnabled?: InputMaybe<Scalars['Boolean']>;
  ipCidrs?: InputMaybe<Instacart_Partners_Partners_V1_IpCidrsList_Input>;
  ippAccountCanonicalId?: InputMaybe<Scalars['String']>;
  /**
   * Optional identifier of the production StoreConfiguration this sandbox was
   * created from. Optional at the wire level for compatibility with requests
   * that predate the field, but authorization checks will require it; when
   * set, it must match the store configuration of a production site the
   * sandbox was copied from, otherwise the request is rejected.
   */
  linkedStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  /**
   * Canonical key for the sandbox; the warehouse / store_configuration IDs are
   * supplied for cross-referencing only.
   */
  routingRuleId?: InputMaybe<Scalars['String']>;
  sandboxStoreConfigurationId?: InputMaybe<Scalars['BigInt']>;
  sandboxWarehouseId?: InputMaybe<Scalars['BigInt']>;
};

/** Response for updating sandbox whitelabel site metadata */
export type Instacart_Partners_Partners_V1_UpdateSandboxWhitelabelSiteMetadataResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdateSandboxWhitelabelSiteMetadataResponse';
  /** Human-readable detail (e.g. failure reason) when success is false. */
  message?: Maybe<Scalars['String']>;
  /** The sandbox's full state after the update was applied. Unset when success is false. */
  sandbox?: Maybe<Instacart_Partners_Partners_V1_SandboxWhitelabelSiteSummary>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Request message for updating a WhitelabelApp */
export type Instacart_Partners_Partners_V1_UpdateWhitelabelAppRequest_Input = {
  accountId?: InputMaybe<Scalars['String']>;
  appId?: InputMaybe<Scalars['String']>;
  appStoreId?: InputMaybe<Scalars['String']>;
  betaReleaseDate?: InputMaybe<Scalars['DateTime']>;
  betaReleaseStatus?: InputMaybe<Scalars['String']>;
  betaReleaseVersion?: InputMaybe<Scalars['String']>;
  buildsEnabled?: InputMaybe<Scalars['Boolean']>;
  currentReleaseDate?: InputMaybe<Scalars['DateTime']>;
  currentReleaseVersion?: InputMaybe<Scalars['String']>;
  inProgressDate?: InputMaybe<Scalars['DateTime']>;
  inProgressStatus?: InputMaybe<Scalars['String']>;
  inProgressVersion?: InputMaybe<Scalars['String']>;
  isLive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<Scalars['String']>;
  scheme?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  updatedByUserUuid?: InputMaybe<Scalars['String']>;
  whitelabelAppId?: InputMaybe<Scalars['BigInt']>;
  whitelabelSiteId?: InputMaybe<Scalars['BigInt']>;
};

/** Response message for updating a WhitelabelApp */
export type Instacart_Partners_Partners_V1_UpdateWhitelabelAppResponse = {
  __typename?: 'instacart_partners_partners_v1_UpdateWhitelabelAppResponse';
  whitelabelApp?: Maybe<Instacart_Partners_Partners_V1_WhitelabelApp>;
};

/** Object to represent a WhitelabelApp */
export type Instacart_Partners_Partners_V1_WhitelabelApp = {
  __typename?: 'instacart_partners_partners_v1_WhitelabelApp';
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  appId?: Maybe<Scalars['String']>;
  appStoreId?: Maybe<Scalars['String']>;
  betaReleaseDate?: Maybe<Scalars['DateTime']>;
  betaReleaseStatus?: Maybe<Scalars['String']>;
  betaReleaseVersion?: Maybe<Scalars['String']>;
  buildsEnabled?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByUserUuid?: Maybe<Scalars['String']>;
  currentReleaseDate?: Maybe<Scalars['DateTime']>;
  currentReleaseVersion?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['BigInt']>;
  inProgressDate?: Maybe<Scalars['DateTime']>;
  inProgressStatus?: Maybe<Scalars['String']>;
  inProgressVersion?: Maybe<Scalars['String']>;
  isLive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  scheme?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedByUserUuid?: Maybe<Scalars['String']>;
  whitelabelSiteId?: Maybe<Scalars['BigInt']>;
};

/** CheckHealthRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_CheckHealthRequest_Input = {
  storeId?: InputMaybe<Scalars['BigInt']>;
};

/** GetAutomationsResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetAutomationsResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetAutomationsResponse';
  /** GetAutomationsResponse */
  automations?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetConnectionsResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetConnectionsResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetConnectionsResponse';
  connections?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetStoresResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetStoresResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetStoresResponse';
  stores?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetSyncStrategiesResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_GetSyncStrategiesResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_GetSyncStrategiesResponse';
  syncStrategies?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** PutAutomationRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationRequest_Input = {
  automation?: InputMaybe<Scalars['JSON']>;
};

/** PutAutomationResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutAutomationResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutAutomationResponse';
  /** PutAutomationResponse */
  automation?: Maybe<Scalars['JSON']>;
};

/** PutConnectionRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionRequest_Input = {
  connection?: InputMaybe<Scalars['JSON']>;
};

/** PutConnectionResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutConnectionResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutConnectionResponse';
  /** PutConnectionResponse */
  connection?: Maybe<Scalars['JSON']>;
};

/** PutStoreRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreRequest_Input = {
  /** PutStoreRequest */
  store?: InputMaybe<Scalars['JSON']>;
};

/** PutStoreResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutStoreResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutStoreResponse';
  /** PutStoreResponse */
  store?: Maybe<Scalars['JSON']>;
};

/** PutSyncStrategyRequest */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyRequest_Input = {
  syncStrategy?: InputMaybe<Scalars['JSON']>;
};

/** PutSyncStrategyResponse */
export type Instacart_Retailer_Os_Shelf_Labels_Admin_V1_PutSyncStrategyResponse = {
  __typename?: 'instacart_retailer_os_shelf_labels_admin_v1_PutSyncStrategyResponse';
  /** PutSyncStrategyResponse */
  syncStrategy?: Maybe<Scalars['JSON']>;
};

export type Instacart_Retailer_Tools_Growth_Targeting_V1_GetTargetingFeaturesRequest_Input = {
  isWholesaler?: InputMaybe<Scalars['Boolean']>;
  parameters?: InputMaybe<Instacart_Ads_Platform_Taas_V1_GetAllSupportedFeaturesRequest_Input>;
  sfxVersion?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** PRIMITIVES */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Entitlement = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_Entitlement';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** which environment was this entitlement from */
  fromEnv?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment>;
  /** true if the entitlement is integrated into IPP and that entitlement changes are expected to near immediately change the Retailer UX on IPP, false otherwise. */
  hasIppIntegration?: Maybe<Scalars['Boolean']>;
  /** the main identifier for this entitlement */
  id?: Maybe<Scalars['String']>;
  /** more human readable name / display string */
  name?: Maybe<Scalars['String']>;
  /** the slack handle to contact for the team/individual that owns the entitlement */
  ownerSlackHandle?: Maybe<Scalars['String']>;
  /** true if the entitlement requires some form of manual effort in order to unlock the feature gated, false otherise. */
  requiresManualMigration?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_EntitlementShallowDetails';
  entitlement?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Entitlement>;
  /** how many packages use this entitlement */
  numReferencingPackages?: Maybe<Scalars['Int']>;
  /** how many retailers reference this entitlement */
  numReferencingRetailerAdditionalEntitlements?: Maybe<Scalars['Int']>;
};

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementsSearchByType {
  EntitlementIdOrName = 'ENTITLEMENT_ID_OR_NAME',
  EnumEntitlementUsagesSearchTypeUnspecified = 'ENUM_ENTITLEMENT_USAGES_SEARCH_TYPE_UNSPECIFIED'
}

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment {
  DevelopmentEnvironment = 'DEVELOPMENT_ENVIRONMENT',
  ProductionEnvironment = 'PRODUCTION_ENVIRONMENT',
  StagingEnvironment = 'STAGING_ENVIRONMENT',
  UnspecifiedEnvironment = 'UNSPECIFIED_ENVIRONMENT'
}

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsRequest_Input = {
  byEntitlementId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementDetailsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetEntitlementDetailsResponse';
  entitlement?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Entitlement>;
  packages?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails>>>;
  retailerEntitlementProfiles?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails>>>;
};

/** ENTITLEMENTS API */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsRequest_Input = {
  searchBy?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementsSearchByType>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetEntitlementsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetEntitlementsResponse';
  entitlements?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails>>>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsRequest_Input = {
  byPackageId?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackageDetailsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetPackageDetailsResponse';
  entitlements?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails>>>;
  package?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Package>;
  retailerEntitlementProfiles?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails>>>;
};

/** PACKAGES API */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesRequest_Input = {
  searchBy?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackagesSearchByType>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetPackagesResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetPackagesResponse';
  packages?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails>>>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsRequest_Input = {
  byRetailerId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfileDetailsResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetRetailerEntitlementProfileDetailsResponse';
  additionalEntitlements?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_EntitlementShallowDetails>>>;
  packages?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails>>>;
  retailerEntitlementProfile?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfile>;
};

/** RETAILER ENTITLEMENT PROFILES API */
export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesRequest_Input = {
  searchBy?: InputMaybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfilesSearchByType>;
  searchText?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_GetRetailerEntitlementProfilesResponse = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_GetRetailerEntitlementProfilesResponse';
  retailerEntitlementProfiles?: Maybe<Array<Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails>>>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Package = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_Package';
  createdAt?: Maybe<Scalars['DateTime']>;
  /** a list of the entitlement IDs that are included in this package */
  entitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** which environment was this package from */
  fromEnv?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment>;
  /** the main identifier for this package */
  id?: Maybe<Scalars['String']>;
  /** more human readable name / display string */
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackageShallowDetails = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_PackageShallowDetails';
  /** how many entitlements are in this package */
  numEntitlements?: Maybe<Scalars['Int']>;
  /** how many retailers reference this package */
  numReferencingRetailerEntitlementProfiles?: Maybe<Scalars['Int']>;
  package?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_Package>;
};

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_PackagesSearchByType {
  EnumPackagesSearchTypeUnspecified = 'ENUM_PACKAGES_SEARCH_TYPE_UNSPECIFIED',
  PackageIdOrName = 'PACKAGE_ID_OR_NAME'
}

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfile = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_RetailerEntitlementProfile';
  /** the list of a la carte entitlements given to this retailer profile */
  additionalEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** the denormalized list of IDs this retailer is entitled to. this destructures the packages referenced entitlements. */
  denormalizedEntitlementIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** which environment was this retailer profile from */
  fromEnv?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_FromEnvironment>;
  /** the list of packages applied to this retailer profile */
  packageIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** the canonical warehouse model */
  warehouseId?: Maybe<Scalars['BigInt']>;
  /** the canonical warehouse model */
  warehouseName?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfileShallowDetails = {
  __typename?: 'instacart_retailer_tools_retailer_platform_api_v1_RetailerEntitlementProfileShallowDetails';
  /** how many custom additional entitlements are used by this retailer (not included via packages) */
  numAdditionalEntitlements?: Maybe<Scalars['Int']>;
  /** how many packages are used by this retailer */
  numPackages?: Maybe<Scalars['Int']>;
  retailerEntitlementProfile?: Maybe<Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfile>;
};

export enum Instacart_Retailer_Tools_Retailer_Platform_Api_V1_RetailerEntitlementProfilesSearchByType {
  EnumRetailerEntitlementProfilesSearchTypeUnspecified = 'ENUM_RETAILER_ENTITLEMENT_PROFILES_SEARCH_TYPE_UNSPECIFIED',
  RetalerId = 'RETALER_ID'
}

/**
 * Defines partners, retailers, and retailer locations that the current user is
 * authorized to access
 */
export type Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input = {
  accountId?: InputMaybe<Scalars['BigInt']>;
  partnerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
  retailerLocationIds?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCreateCustomExportResponse';
  customExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filterSelectionOptionsList?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions_Input>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalCreateCustomReportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCreateCustomReportResponse';
  customReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
  success?: Maybe<Scalars['Boolean']>;
};

/** CSV Exports */
export type Instacart_Retailer_Tools_V2_InsightsPortalCustomExport = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCustomExport';
  createdAt?: Maybe<Scalars['DateTime']>;
  dashboardSlug?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  downloadUrl?: Maybe<Scalars['String']>;
  filters?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection>>>;
  generationState?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport_GenerationState>;
  id?: Maybe<Scalars['BigInt']>;
  metrics?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  orderBys?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy>>>;
  schema?: Maybe<Scalars['String']>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalCustomExport_GenerationState {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

/** Custom Reports */
export type Instacart_Retailer_Tools_V2_InsightsPortalCustomReport = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalCustomReport';
  createdAt?: Maybe<Scalars['DateTime']>;
  dashboardSlug?: Maybe<Scalars['String']>;
  dimensions?: Maybe<Array<Maybe<Scalars['String']>>>;
  filterSelectionOptionsList?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions>>>;
  filters?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection>>>;
  id?: Maybe<Scalars['BigInt']>;
  metrics?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  orderBys?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy>>>;
  schema?: Maybe<Scalars['String']>;
};

/** Controls which data source the query is executed on */
export enum Instacart_Retailer_Tools_V2_InsightsPortalDataSource {
  Clickhouse = 'CLICKHOUSE',
  Default = 'DEFAULT',
  Snowflake = 'SNOWFLAKE'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalDeleteCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalDeleteCustomExportResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalDownloadCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalDownloadCustomExportResponse';
  customExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>;
  downloadUrl?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dataSource?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDataSource>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  owner?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOwner>;
  queryTags?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalQueryTag_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
  whitelistFilterOptions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterOptionsResponse';
  filterOptions?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOptions>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOption = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterOptionsResponse_FilterOption';
  displayValue?: Maybe<Scalars['String']>;
  idValue?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOptions = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterOptionsResponse_FilterOptions';
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterOptionsResponse_FilterOption>>>;
};

/** Defines selected values for a filter to be applied to schema metrics. */
export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelection';
  dateFilter?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter>;
  dimFilter?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter>;
  name?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelectionOption';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption_Input = {
  label?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelectionOptions';
  dimension?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions_Input = {
  dimension?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOption_Input>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelection_DateFilter';
  comparisonEnd?: Maybe<Scalars['DateTime']>;
  comparisonPeriod?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_ComparisonPeriod>;
  comparisonStart?: Maybe<Scalars['DateTime']>;
  dateRange?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_DateRange>;
  end?: Maybe<Scalars['DateTime']>;
  start?: Maybe<Scalars['DateTime']>;
  weekStartDay?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Weekday>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_ComparisonPeriod {
  LastPeriod = 'LAST_PERIOD',
  LastPeriodDayOfWeekMatch = 'LAST_PERIOD_DAY_OF_WEEK_MATCH',
  LastYear = 'LAST_YEAR',
  LastYearDayOfWeekMatch = 'LAST_YEAR_DAY_OF_WEEK_MATCH',
  None = 'NONE'
}

export enum Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_DateRange {
  FiveWeeksAgo = 'FIVE_WEEKS_AGO',
  FourWeeksAgo = 'FOUR_WEEKS_AGO',
  Last_1Year = 'LAST_1_YEAR',
  Last_2Years = 'LAST_2_YEARS',
  Last_7Days = 'LAST_7_DAYS',
  Last_28Days = 'LAST_28_DAYS',
  Last_30Days = 'LAST_30_DAYS',
  Last_84Days = 'LAST_84_DAYS',
  Last_90Days = 'LAST_90_DAYS',
  Last_120Days = 'LAST_120_DAYS',
  LastMonth = 'LAST_MONTH',
  LastWeek = 'LAST_WEEK',
  QuarterToDate = 'QUARTER_TO_DATE',
  ThreeWeeksAgo = 'THREE_WEEKS_AGO',
  TwoWeeksAgo = 'TWO_WEEKS_AGO',
  Undefined = 'UNDEFINED',
  YearToDate = 'YEAR_TO_DATE',
  Yesterday = 'YESTERDAY'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Input = {
  comparisonEnd?: InputMaybe<Scalars['DateTime']>;
  comparisonPeriod?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_ComparisonPeriod>;
  comparisonStart?: InputMaybe<Scalars['DateTime']>;
  dateRange?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_DateRange>;
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
  weekStartDay?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Weekday>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalFilterSelection_DimensionFilter';
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter_Input = {
  values?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** Defines selected values for a filter to be applied to schema metrics. */
export type Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input = {
  dateFilter?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DateFilter_Input>;
  dimFilter?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_DimensionFilter_Input>;
  name?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalGetCustomExportResponse';
  customExport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalGetCustomReportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalGetCustomReportResponse';
  customReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomExportsResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalListCustomExportsResponse';
  customExports?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomExport>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dashboardSlug?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<Scalars['DateTime']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalListCustomReportsResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalListCustomReportsResponse';
  customReports?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>>>;
};

/** Multi Dimension Dataset */
export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dataSource?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalDataSource>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  includeCount?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  offset?: InputMaybe<Scalars['BigInt']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  owner?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOwner>;
  queryTags?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalQueryTag_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse';
  headers?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Header>>>;
  rows?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Row>>>;
  totalRows?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Header = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Header';
  dimensionName?: Maybe<Scalars['String']>;
  metricName?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Item';
  comparison?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item_InsightsPortalComparison>;
  dimensionName?: Maybe<Scalars['String']>;
  metricName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item_InsightsPortalComparison = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Item_InsightsPortalComparison';
  absoluteChange?: Maybe<Scalars['String']>;
  percentChange?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Row = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalMultiDimensionDatasetResponse_Row';
  items?: Maybe<Array<Maybe<Instacart_Retailer_Tools_V2_InsightsPortalMultiDimensionDatasetResponse_Item>>>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalOrderBy = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalOrderBy';
  columnName?: Maybe<Scalars['String']>;
  orderDirection?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input = {
  columnName?: InputMaybe<Scalars['String']>;
  orderDirection?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection>;
};

export enum Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE'
}

/**
 * Pre-defined list of query "owners". Each owner manages their own connection
 * to Snowflake/Clickhouse using isc env vars.
 */
export enum Instacart_Retailer_Tools_V2_InsightsPortalOwner {
  Async = 'ASYNC',
  RetailerTools = 'RETAILER_TOOLS',
  Unspecified = 'UNSPECIFIED'
}

/** Used for tagging query logs and metrics in Datadog. */
export type Instacart_Retailer_Tools_V2_InsightsPortalQueryTag_Input = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customExportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalRegenerateCustomExportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalRegenerateCustomExportResponse';
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * The name of a pre-defined schema.
 * Each schema defines certain metrics that can be queried and
 * filters that can be applied to those metrics.
 */
export enum Instacart_Retailer_Tools_V2_InsightsPortalSchema {
  AdsCoupon = 'ADS_COUPON',
  AdsDisplay = 'ADS_DISPLAY',
  AdsDisplayBanner = 'ADS_DISPLAY_BANNER',
  AdsOverview = 'ADS_OVERVIEW',
  AdsSponsoredProduct = 'ADS_SPONSORED_PRODUCT',
  AdsSponsoredProductV2 = 'ADS_SPONSORED_PRODUCT_V2',
  AggAwarenessCampaigns = 'AGG_AWARENESS_CAMPAIGNS',
  AggAwarenessCampaignsStitchOrderDelivery = 'AGG_AWARENESS_CAMPAIGNS_STITCH_ORDER_DELIVERY',
  AggMerchCollections = 'AGG_MERCH_COLLECTIONS',
  AggMerchCollectionsRollup = 'AGG_MERCH_COLLECTIONS_ROLLUP',
  AggMerchFlyers = 'AGG_MERCH_FLYERS',
  AggMerchPlacements = 'AGG_MERCH_PLACEMENTS',
  AggSageSessionMetrics = 'AGG_SAGE_SESSION_METRICS',
  AggWarehouseLocationPerformance = 'AGG_WAREHOUSE_LOCATION_PERFORMANCE',
  AggWarehousePerformance = 'AGG_WAREHOUSE_PERFORMANCE',
  CancelledOrders = 'CANCELLED_ORDERS',
  DeliveryDriverPerformance = 'DELIVERY_DRIVER_PERFORMANCE',
  DeliveryPerformance = 'DELIVERY_PERFORMANCE',
  DeliveryProviderPerformance = 'DELIVERY_PROVIDER_PERFORMANCE',
  DimUserDailyCaper = 'DIM_USER_DAILY_CAPER',
  FactCampaignImpressionsPerformance = 'FACT_CAMPAIGN_IMPRESSIONS_PERFORMANCE',
  FactCampaignPerformance = 'FACT_CAMPAIGN_PERFORMANCE',
  FactCampaignPerformanceStitchFactCampaignImpressionsPerformance = 'FACT_CAMPAIGN_PERFORMANCE_STITCH_FACT_CAMPAIGN_IMPRESSIONS_PERFORMANCE',
  FactCampaignPerformanceStitchOrderDelivery = 'FACT_CAMPAIGN_PERFORMANCE_STITCH_ORDER_DELIVERY',
  FactCaperItemEngagement = 'FACT_CAPER_ITEM_ENGAGEMENT',
  FactCaperSessionPerformance = 'FACT_CAPER_SESSION_PERFORMANCE',
  FactCaperSessionPerformanceAdsRevenue = 'FACT_CAPER_SESSION_PERFORMANCE_ADS_REVENUE',
  FactCaperSessionPerformanceAuditPerformance = 'FACT_CAPER_SESSION_PERFORMANCE_AUDIT_PERFORMANCE',
  FactCaperSessionPerformanceCartOperations = 'FACT_CAPER_SESSION_PERFORMANCE_CART_OPERATIONS',
  FactCartAvailabilityCaper = 'FACT_CART_AVAILABILITY_CAPER',
  FutureScheduledOrders = 'FUTURE_SCHEDULED_ORDERS',
  ImageCoverage = 'IMAGE_COVERAGE',
  IntegrationsRejectedOffers = 'INTEGRATIONS_REJECTED_OFFERS',
  InventoryIntelligenceOosSignalsAgg = 'INVENTORY_INTELLIGENCE_OOS_SIGNALS_AGG',
  MissingImage_90DayRetailerInsights = 'MISSING_IMAGE_90DAY_RETAILER_INSIGHTS',
  OrderDelivery = 'ORDER_DELIVERY',
  OrderItem = 'ORDER_ITEM',
  OrderItemStitchProductByCategoryBenchmark = 'ORDER_ITEM_STITCH_PRODUCT_BY_CATEGORY_BENCHMARK',
  PickupWarehouseLocation = 'PICKUP_WAREHOUSE_LOCATION',
  ProductByCategoryBenchmark = 'PRODUCT_BY_CATEGORY_BENCHMARK',
  ProductByPartnerBenchmark = 'PRODUCT_BY_PARTNER_BENCHMARK',
  SearchTerm = 'SEARCH_TERM',
  SearchTermByPartnerBenchmark = 'SEARCH_TERM_BY_PARTNER_BENCHMARK',
  SearchTermByTermBenchmark = 'SEARCH_TERM_BY_TERM_BENCHMARK',
  SearchTermStitchSearchTermByTermBenchmark = 'SEARCH_TERM_STITCH_SEARCH_TERM_BY_TERM_BENCHMARK',
  Unknown = 'UNKNOWN'
}

export type Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  customReportId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalSetCustomReportDisabledResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalSetCustomReportDisabledResponse';
  customReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportRequest_Input = {
  authorizationContext?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalAuthorizationContext_Input>;
  dimensions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filterSelectionOptionsList?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelectionOptions_Input>>>;
  filters?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalFilterSelection_Input>>>;
  id?: InputMaybe<Scalars['String']>;
  metrics?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBys?: InputMaybe<Array<InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalOrderBy_Input>>>;
  schema?: InputMaybe<Instacart_Retailer_Tools_V2_InsightsPortalSchema>;
};

export type Instacart_Retailer_Tools_V2_InsightsPortalUpdateCustomReportResponse = {
  __typename?: 'instacart_retailer_tools_v2_InsightsPortalUpdateCustomReportResponse';
  customReport?: Maybe<Instacart_Retailer_Tools_V2_InsightsPortalCustomReport>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Retailers_V1_AppeasementDetail = {
  __typename?: 'instacart_retailers_v1_AppeasementDetail';
  /** The response status of the appeasement request (clear, warning, danger) */
  appeasementRequestResponse?: Maybe<Instacart_Retailers_V1_AppeasementRequestResponse>;
  appeasementType?: Maybe<Instacart_Retailers_V1_AppeasementType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** IPP account ID, when available. */
  ippAccountId?: Maybe<Scalars['BigInt']>;
  /** IPP account name returned by lookup, when available; not an appeasement-time snapshot. */
  ippAccountName?: Maybe<Scalars['String']>;
  /** IPP requester ID */
  ippRequesterId?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['BigInt']>;
  reason?: Maybe<Scalars['String']>;
  /** customer ID */
  recipientId?: Maybe<Scalars['BigInt']>;
  /** partner ID */
  requesterId?: Maybe<Scalars['BigInt']>;
  storeConfigurationId?: Maybe<Scalars['BigInt']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<GoogleTypeMoney>;
};

export enum Instacart_Retailers_V1_AppeasementRequestResponse {
  AppeasementRequestResponseClear = 'APPEASEMENT_REQUEST_RESPONSE_CLEAR',
  AppeasementRequestResponseDanger = 'APPEASEMENT_REQUEST_RESPONSE_DANGER',
  AppeasementRequestResponseUnspecified = 'APPEASEMENT_REQUEST_RESPONSE_UNSPECIFIED',
  AppeasementRequestResponseWarning = 'APPEASEMENT_REQUEST_RESPONSE_WARNING'
}

export enum Instacart_Retailers_V1_AppeasementResponseStatus {
  DeniedAppeasementResponseStatus = 'DENIED_APPEASEMENT_RESPONSE_STATUS',
  ErrorAppeasementResponseStatus = 'ERROR_APPEASEMENT_RESPONSE_STATUS',
  SuccessAppeasementResponseStatus = 'SUCCESS_APPEASEMENT_RESPONSE_STATUS',
  TooManyRequestsAppeasementResponseStatus = 'TOO_MANY_REQUESTS_APPEASEMENT_RESPONSE_STATUS',
  /** Default value */
  UnknownAppeasementResponseStatus = 'UNKNOWN_APPEASEMENT_RESPONSE_STATUS'
}

/** The type of appeasement being requested/offered */
export enum Instacart_Retailers_V1_AppeasementType {
  AppeasementTypeUnspecified = 'APPEASEMENT_TYPE_UNSPECIFIED',
  Credit = 'CREDIT',
  FreeDelivery = 'FREE_DELIVERY',
  FreeExpress = 'FREE_EXPRESS',
  Redelivery = 'REDELIVERY',
  Refund = 'REFUND'
}

export type Instacart_Retailers_V1_GetAppeasementsByUserRequest_Input = {
  /** Filter by appeasement type. An empty list means no type filter. */
  appeasementTypes?: InputMaybe<Array<InputMaybe<Instacart_Retailers_V1_AppeasementType>>>;
  /** Whether to enrich appeasements with IPP account names on a best-effort basis. */
  includeIppAccountName?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
  /** Filter by the order associated with the appeasement request. */
  orderId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetAppeasementsByUserResponse = {
  __typename?: 'instacart_retailers_v1_GetAppeasementsByUserResponse';
  appeasements?: Maybe<Array<Maybe<Instacart_Retailers_V1_AppeasementDetail>>>;
  /** Limit of the appeasements */
  limit?: Maybe<Scalars['BigInt']>;
  /** Offset of the appeasements */
  offset?: Maybe<Scalars['BigInt']>;
  status?: Maybe<Instacart_Retailers_V1_AppeasementResponseStatus>;
  /** Total count of appeasements */
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetCreditsByUserRequest_Input = {
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetCreditsByUserResponse = {
  __typename?: 'instacart_retailers_v1_GetCreditsByUserResponse';
  totalBalance?: Maybe<GoogleTypeMoney>;
};

/** To get all StoreConfigurations with pagination and filtering options for IPP admin consumption */
export type Instacart_Retailers_V1_GetStoreConfigurationsForRetailersRequest_Input = {
  filters?: InputMaybe<Instacart_Retailers_V1_StoreConfigurationFilters_Input>;
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetWidgetsConfigRequest_Input = {
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GetWidgetsConfigResponse = {
  __typename?: 'instacart_retailers_v1_GetWidgetsConfigResponse';
  config?: Maybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_GiveAppeasementsRequest_Input = {
  amountInCents?: InputMaybe<Scalars['BigInt']>;
  ippAccountId?: InputMaybe<Scalars['BigInt']>;
  ippRequesterId?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  reason?: InputMaybe<Scalars['String']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
  uiOrigin?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_GiveAppeasementsResponse = {
  __typename?: 'instacart_retailers_v1_GiveAppeasementsResponse';
  status?: Maybe<Instacart_Retailers_V1_AppeasementResponseStatus>;
};

export type Instacart_Retailers_V1_PartnerAccessModificationRules = {
  __typename?: 'instacart_retailers_v1_PartnerAccessModificationRules';
  /**
   * Consumers should be able to enforce rules on either or both of these fields being present.
   * If both are present, the rules should be applied as an OR.
   * If both are absent/empty, the rules should be ignored.
   * If either contains a -1, every access is denied.
   */
  allowlistPartnerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  allowlistRetailerIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Retailers_V1_PartnerAccessSettings = {
  __typename?: 'instacart_retailers_v1_PartnerAccessSettings';
  modificationRules?: Maybe<Instacart_Retailers_V1_PartnerAccessModificationRules>;
  /** OPTIONAL version of visible_to_partners_on_ipp */
  optionalVisibleToPartnersOnIpp?: Maybe<Scalars['Boolean']>;
  visibleToPartnersOnIpp?: Maybe<Scalars['Boolean']>;
};

/** Filters to be applied to the StoreConfigurations */
export type Instacart_Retailers_V1_StoreConfigurationFilters_Input = {
  /** active flag in SC */
  active?: InputMaybe<Scalars['Boolean']>;
  /** branded_name in SC settings */
  brandedNameIncludes?: InputMaybe<Scalars['String']>;
  /** domain_name in SC settings */
  domainNameIncludes?: InputMaybe<Scalars['String']>;
  /** search term that could be matched to branded_name, domain_name, or more */
  searchTerm?: InputMaybe<Scalars['String']>;
};

/** A model specifically for IPP's consumption, to surface to retailers */
export type Instacart_Retailers_V1_StoreConfigurationForRetailers = {
  __typename?: 'instacart_retailers_v1_StoreConfigurationForRetailers';
  active?: Maybe<Scalars['Boolean']>;
  allowAllWarehouses?: Maybe<Scalars['Boolean']>;
  brandedName?: Maybe<Scalars['String']>;
  clientConfigurationIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deApplicationPlatform?: Maybe<Scalars['String']>;
  domainName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  legal?: Maybe<Instacart_Retailers_V1_StoreConfigurationLegal>;
  logoUrl?: Maybe<Scalars['String']>;
  /** Indicates this store configuration should use Marketplace-default behavior in eligible flows. */
  marketplaceDefaultBehavior?: Maybe<Scalars['Boolean']>;
  partnerAccessSettings?: Maybe<Instacart_Retailers_V1_PartnerAccessSettings>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userIsolationContextId?: Maybe<Scalars['BigInt']>;
  whitelistedWarehouseIds?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

export type Instacart_Retailers_V1_StoreConfigurationLegal = {
  __typename?: 'instacart_retailers_v1_StoreConfigurationLegal';
  shortName?: Maybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_StoreConfigurationsForRetailersResponse = {
  __typename?: 'instacart_retailers_v1_StoreConfigurationsForRetailersResponse';
  storeConfigs?: Maybe<Array<Maybe<Instacart_Retailers_V1_StoreConfigurationForRetailers>>>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_UpsertWidgetsConfigRequest_Input = {
  config?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['BigInt']>;
  retailerId?: InputMaybe<Scalars['BigInt']>;
  storeConfigurationId?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Retailers_V1_UpsertWidgetsConfigResponse = {
  __typename?: 'instacart_retailers_v1_UpsertWidgetsConfigResponse';
  config?: Maybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_ValidateWidgetsConfigRequest_Input = {
  config?: InputMaybe<Scalars['String']>;
};

export type Instacart_Retailers_V1_ValidateWidgetsConfigResponse = {
  __typename?: 'instacart_retailers_v1_ValidateWidgetsConfigResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A |Criterion| is a specification for a boolean function of one value.
 * Values can be evaluated by criteria, yielding either "true" or "false".
 * There several kinds of criteria - exact matches (e.g. "value == 42"),
 * ranges ("0 < value < 50"), even regex matches.  More kinds can and will
 * be added in the future.
 */
export type Instacart_Roulette_V1_Criterion = {
  __typename?: 'instacart_roulette_v1_Criterion';
  boolMatch?: Maybe<Instacart_Roulette_V1_Criterion_BoolCriterion>;
  caperVersion?: Maybe<Instacart_Roulette_V1_Criterion_CaperVersionCriterion>;
  dayOfWeek?: Maybe<Instacart_Roulette_V1_Criterion_DayOfWeekCriterion>;
  group?: Maybe<Instacart_Roulette_V1_Criterion_GroupCriterion>;
  numberRange?: Maybe<Instacart_Roulette_V1_Criterion_NumberRangeCriterion>;
  numericMatch?: Maybe<Instacart_Roulette_V1_Criterion_NumberCriterion>;
  semver?: Maybe<Instacart_Roulette_V1_Criterion_SemverCriterion>;
  stringMatch?: Maybe<Instacart_Roulette_V1_Criterion_StringCriterion>;
};

/** A criterion expecting a boolean value. */
export type Instacart_Roulette_V1_Criterion_BoolCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_BoolCriterion';
  expected?: Maybe<Scalars['Boolean']>;
};

/** A criterion expecting a boolean value. */
export type Instacart_Roulette_V1_Criterion_BoolCriterion_Input = {
  expected?: InputMaybe<Scalars['Boolean']>;
};

/**
 * A Caper version criterion makes a claim about a Caper version string,
 * in an expression language identical to that of |SemverCriterion|.
 *
 * A Caper version is nearly the same as a semantic version, but with
 * important differences.  It contains major, minor, and patch components,
 * along with tags denoting the type of release.  For example:
 * 2025.8.2-v01
 *
 * Where they differ from semvers is in their comparison semantics.  Semver
 * specifies that 1.0.0 < 1.0.0-alpha, whereas in Caper versions,
 * tagged releases are considered as having _higher_ precedence than untagged
 * versions.  The tags are constrained, and not arbitrary.  Store-specific
 * builds are indicated by a semver "build tag" (e.g. "+kroger"), and are
 * ignored in criterion evaluation.
 *
 * The release types, in lesser-to-greater order:
 * 1.0.0
 * 1.0.0-nightly01
 * 1.0.0-nightly02
 * 1.0.0-r01       // "r" is a beta release
 * 1.0.0-rc01      // release candidates going through QA
 * 1.0.0-v01       // official releases
 *
 * Valid operators, as with semvers, are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_CaperVersionCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_CaperVersionCriterion';
  expression?: Maybe<Scalars['String']>;
};

/**
 * A Caper version criterion makes a claim about a Caper version string,
 * in an expression language identical to that of |SemverCriterion|.
 *
 * A Caper version is nearly the same as a semantic version, but with
 * important differences.  It contains major, minor, and patch components,
 * along with tags denoting the type of release.  For example:
 * 2025.8.2-v01
 *
 * Where they differ from semvers is in their comparison semantics.  Semver
 * specifies that 1.0.0 < 1.0.0-alpha, whereas in Caper versions,
 * tagged releases are considered as having _higher_ precedence than untagged
 * versions.  The tags are constrained, and not arbitrary.  Store-specific
 * builds are indicated by a semver "build tag" (e.g. "+kroger"), and are
 * ignored in criterion evaluation.
 *
 * The release types, in lesser-to-greater order:
 * 1.0.0
 * 1.0.0-nightly01
 * 1.0.0-nightly02
 * 1.0.0-r01       // "r" is a beta release
 * 1.0.0-rc01      // release candidates going through QA
 * 1.0.0-v01       // official releases
 *
 * Valid operators, as with semvers, are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_CaperVersionCriterion_Input = {
  expression?: InputMaybe<Scalars['String']>;
};

/**
 * A criteron which is satisfied on the specified days of the week.
 *
 * TODO: I'm not happy with the placement of this check as a Criterion;
 * it's not really a function of request input.  Not sure what would
 * be better.
 */
export type Instacart_Roulette_V1_Criterion_DayOfWeekCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_DayOfWeekCriterion';
  days?: Maybe<Array<Maybe<Instacart_Roulette_V1_DayOfWeek>>>;
};

/**
 * A criteron which is satisfied on the specified days of the week.
 *
 * TODO: I'm not happy with the placement of this check as a Criterion;
 * it's not really a function of request input.  Not sure what would
 * be better.
 */
export type Instacart_Roulette_V1_Criterion_DayOfWeekCriterion_Input = {
  days?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_DayOfWeek>>>;
};

/**
 * A group criterion makes a claim that a given value is present
 * within the group.
 */
export type Instacart_Roulette_V1_Criterion_GroupCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_GroupCriterion';
  groupId?: Maybe<Scalars['String']>;
};

/**
 * A group criterion makes a claim that a given value is present
 * within the group.
 */
export type Instacart_Roulette_V1_Criterion_GroupCriterion_Input = {
  groupId?: InputMaybe<Scalars['String']>;
};

/**
 * A |Criterion| is a specification for a boolean function of one value.
 * Values can be evaluated by criteria, yielding either "true" or "false".
 * There several kinds of criteria - exact matches (e.g. "value == 42"),
 * ranges ("0 < value < 50"), even regex matches.  More kinds can and will
 * be added in the future.
 */
export type Instacart_Roulette_V1_Criterion_Input = {
  boolMatch?: InputMaybe<Instacart_Roulette_V1_Criterion_BoolCriterion_Input>;
  caperVersion?: InputMaybe<Instacart_Roulette_V1_Criterion_CaperVersionCriterion_Input>;
  dayOfWeek?: InputMaybe<Instacart_Roulette_V1_Criterion_DayOfWeekCriterion_Input>;
  group?: InputMaybe<Instacart_Roulette_V1_Criterion_GroupCriterion_Input>;
  numberRange?: InputMaybe<Instacart_Roulette_V1_Criterion_NumberRangeCriterion_Input>;
  numericMatch?: InputMaybe<Instacart_Roulette_V1_Criterion_NumberCriterion_Input>;
  semver?: InputMaybe<Instacart_Roulette_V1_Criterion_SemverCriterion_Input>;
  stringMatch?: InputMaybe<Instacart_Roulette_V1_Criterion_StringCriterion_Input>;
};

/** A criterion expecting a specific integer value. */
export type Instacart_Roulette_V1_Criterion_NumberCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_NumberCriterion';
  expected?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** A criterion expecting a specific integer value. */
export type Instacart_Roulette_V1_Criterion_NumberCriterion_Input = {
  expected?: InputMaybe<Array<InputMaybe<Scalars['BigInt']>>>;
};

/**
 * A numeric-range criterion, containing an inclusive minimum value
 * and an exclusive maximum value.  It evaluates to true if the value
 * given is numeric and falls within the range defined.
 */
export type Instacart_Roulette_V1_Criterion_NumberRangeCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_NumberRangeCriterion';
  maxExclusive?: Maybe<Scalars['BigInt']>;
  minInclusive?: Maybe<Scalars['BigInt']>;
};

/**
 * A numeric-range criterion, containing an inclusive minimum value
 * and an exclusive maximum value.  It evaluates to true if the value
 * given is numeric and falls within the range defined.
 */
export type Instacart_Roulette_V1_Criterion_NumberRangeCriterion_Input = {
  maxExclusive?: InputMaybe<Scalars['BigInt']>;
  minInclusive?: InputMaybe<Scalars['BigInt']>;
};

/**
 * A semantic version criterion makes a claim about a version string;
 * for details of semantic versions see https://semver.org/.
 *
 * A SemverCriterion consists of an expression.  An expression is a
 * combination of a comparison operator and a semantic version, for
 * example ">= 0.1.0".  In this example, the criterion is satisfied
 * by any semantic version comparing greater-than or equal-to version
 * "0.1.0".
 *
 * Valid operators are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_SemverCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_SemverCriterion';
  expression?: Maybe<Scalars['String']>;
};

/**
 * A semantic version criterion makes a claim about a version string;
 * for details of semantic versions see https://semver.org/.
 *
 * A SemverCriterion consists of an expression.  An expression is a
 * combination of a comparison operator and a semantic version, for
 * example ">= 0.1.0".  In this example, the criterion is satisfied
 * by any semantic version comparing greater-than or equal-to version
 * "0.1.0".
 *
 * Valid operators are ">", "<", ">=", "<=", "=", and "!=".
 */
export type Instacart_Roulette_V1_Criterion_SemverCriterion_Input = {
  expression?: InputMaybe<Scalars['String']>;
};

/**
 * A criterion for a string value.
 * It may be an exact match (case sensitive or insensitive), or
 * it may be a regular expression.
 */
export type Instacart_Roulette_V1_Criterion_StringCriterion = {
  __typename?: 'instacart_roulette_v1_Criterion_StringCriterion';
  caseSensitive?: Maybe<Scalars['Boolean']>;
  expected?: Maybe<Array<Maybe<Scalars['String']>>>;
  regex?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A criterion for a string value.
 * It may be an exact match (case sensitive or insensitive), or
 * it may be a regular expression.
 */
export type Instacart_Roulette_V1_Criterion_StringCriterion_Input = {
  caseSensitive?: InputMaybe<Scalars['Boolean']>;
  expected?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  regex?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/**
 * HACK: copied verbatim from instacart.types.v1 to avoid
 * go's ridiculous habit of panicking when > 1 package
 * relies on the same enum.
 */
export enum Instacart_Roulette_V1_DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  ReservedDay = 'RESERVED_DAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type Instacart_Roulette_V1_Feature = {
  __typename?: 'instacart_roulette_v1_Feature';
  /**
   * When a feature is archived, it should be hidden from user interfaces but
   * may still be enabled.
   */
  archived?: Maybe<Scalars['Boolean']>;
  /** Zero or more request IDs may be manually assigned to a named variant. */
  assignments?: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature_StaticAssignment>>>;
  /** Zero or more request IDs may be explicitly opted in to a feature. */
  deprecatedStaticAssignments?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * A domain is a logical grouping of features, e.g. "customers" or "ads".
   * It is useful in that requests to list features may be scoped to one or
   * more domains, potentially making feature assignment faster on those
   * clients by avoiding
   */
  domain?: Maybe<Scalars['String']>;
  /** When false, the feature is disabled and no assignments to it will be made. */
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * Defines the particular method used to compute hashes when evaluating
   * this feature.
   */
  hashSpec?: Maybe<Instacart_Roulette_V1_HashSpec>;
  /** Is this feature a rollback of another feature? */
  isRollback?: Maybe<Scalars['Boolean']>;
  /**
   * The metadata field can be used to store data for extensions that are not
   * related to core Roulette functionality, e.g. canary configuration.
   */
  metadata?: Maybe<Instacart_Roulette_V1_Feature_Metadata>;
  /** A human-readable name for the feature. */
  name?: Maybe<Scalars['String']>;
  /**
   * Text describing the feature.  It might be a description of the related
   * experiment, a JIRA link, an Expy link, or nothing.
   */
  notes?: Maybe<Scalars['String']>;
  /**
   * The date after which the owner of this Feature should be nudged in order
   * to perform some cleanup, perhaps removing this Feature from Roulette
   */
  notifyDate?: Maybe<Scalars['DateTime']>;
  /**
   * A PartitionKind identifies on which kind of input partitioning will be
   * performed.
   */
  partitionKind?: Maybe<Instacart_Roulette_V1_Feature_PartitionKind>;
  /** A pending approval is a request to approve or reject a feature update */
  pendingApproval?: Maybe<Instacart_Roulette_V1_PendingApproval>;
  /**
   * Whether the feature is marked as "permanent".
   * Permanent features won't get notified if the feature/toggle has been fully enabled for a predefined period of time
   */
  permanent?: Maybe<Instacart_Roulette_V1_Feature_Permanent>;
  /**
   * The Precondition associated with this feature, if any.  This field is
   * optional.
   *
   * This field is deprecated; use [preconditions] instead.
   */
  precondition?: Maybe<Instacart_Roulette_V1_Feature_Precondition>;
  /**
   * The Preconditions associated with this feature, if any.  This field is
   * optional.
   */
  preconditions?: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature_Precondition>>>;
  rollback?: Maybe<Instacart_Roulette_V1_Feature_Rollback>;
  /**
   * The rules by which the feature will be assigned.
   * A feature will always have at least one ruleset, and at most one ruleset
   * at a time will be enabled.
   */
  rulesets?: Maybe<Array<Maybe<Instacart_Roulette_V1_Ruleset>>>;
  /**
   * A randomly-generated value that will be incorporated into the request-ID
   * hash.  This value must be strongly random, as it is what ensures the even
   * distribution of feature assignments.
   */
  salt?: Maybe<Scalars['BigInt']>;
  /** Specifies the totem system name under which we will create an entity */
  systemName?: Maybe<Scalars['String']>;
  /**
   * When true, every single exposure of this feature will be recorded
   * and available for analysis.  When false (the default), only aggregated
   * exposure statistics will be reported.
   */
  trackAllExposures?: Maybe<Scalars['Boolean']>;
  /** The user who created this feature version */
  user?: Maybe<Instacart_Roulette_V1_User>;
  /** A string uniquely identifying this feature.  This is an immutable identifier. */
  uuid?: Maybe<Scalars['String']>;
  variantValueType?: Maybe<Instacart_Roulette_V1_VariantValueType>;
  /**
   * A feature has one or more variants into which users will be assigned;
   * a variant represents an observable difference in the experience of the
   * feature (e.g. "teal button" vs "turquoise button" in the "blue button" feature).
   * Of the variants defined, different percentages of assigned users can be
   * slotted.  By default, users will be evenly distributed across variants,
   * but this is configurable for each ruleset.
   *
   * Exactly one variant in each feature must be the "default" variant - that is,
   * the control group.  This variant serves as the "fall-through" - when a user
   * is not assigned to a variant by any ruleset in the feature, they will "fall through"
   * to this default variant.
   */
  variants?: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature_Variant>>>;
  /**
   * Any modification to the feature or to its rulesets will result in its
   * version being incremented.
   */
  version?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Input = {
  /**
   * When a feature is archived, it should be hidden from user interfaces but
   * may still be enabled.
   */
  archived?: InputMaybe<Scalars['Boolean']>;
  /** Zero or more request IDs may be manually assigned to a named variant. */
  assignments?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Feature_StaticAssignment_Input>>>;
  /** Zero or more request IDs may be explicitly opted in to a feature. */
  deprecatedStaticAssignments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * A domain is a logical grouping of features, e.g. "customers" or "ads".
   * It is useful in that requests to list features may be scoped to one or
   * more domains, potentially making feature assignment faster on those
   * clients by avoiding
   */
  domain?: InputMaybe<Scalars['String']>;
  /** When false, the feature is disabled and no assignments to it will be made. */
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * Defines the particular method used to compute hashes when evaluating
   * this feature.
   */
  hashSpec?: InputMaybe<Instacart_Roulette_V1_HashSpec_Input>;
  /** Is this feature a rollback of another feature? */
  isRollback?: InputMaybe<Scalars['Boolean']>;
  /**
   * The metadata field can be used to store data for extensions that are not
   * related to core Roulette functionality, e.g. canary configuration.
   */
  metadata?: InputMaybe<Instacart_Roulette_V1_Feature_Metadata_Input>;
  /** A human-readable name for the feature. */
  name?: InputMaybe<Scalars['String']>;
  /**
   * Text describing the feature.  It might be a description of the related
   * experiment, a JIRA link, an Expy link, or nothing.
   */
  notes?: InputMaybe<Scalars['String']>;
  /**
   * The date after which the owner of this Feature should be nudged in order
   * to perform some cleanup, perhaps removing this Feature from Roulette
   */
  notifyDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * A PartitionKind identifies on which kind of input partitioning will be
   * performed.
   */
  partitionKind?: InputMaybe<Instacart_Roulette_V1_Feature_PartitionKind_Input>;
  /** A pending approval is a request to approve or reject a feature update */
  pendingApproval?: InputMaybe<Instacart_Roulette_V1_PendingApproval_Input>;
  /**
   * Whether the feature is marked as "permanent".
   * Permanent features won't get notified if the feature/toggle has been fully enabled for a predefined period of time
   */
  permanent?: InputMaybe<Instacart_Roulette_V1_Feature_Permanent_Input>;
  /**
   * The Precondition associated with this feature, if any.  This field is
   * optional.
   *
   * This field is deprecated; use [preconditions] instead.
   */
  precondition?: InputMaybe<Instacart_Roulette_V1_Feature_Precondition_Input>;
  /**
   * The Preconditions associated with this feature, if any.  This field is
   * optional.
   */
  preconditions?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Feature_Precondition_Input>>>;
  rollback?: InputMaybe<Instacart_Roulette_V1_Feature_Rollback_Input>;
  /**
   * The rules by which the feature will be assigned.
   * A feature will always have at least one ruleset, and at most one ruleset
   * at a time will be enabled.
   */
  rulesets?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Ruleset_Input>>>;
  /**
   * A randomly-generated value that will be incorporated into the request-ID
   * hash.  This value must be strongly random, as it is what ensures the even
   * distribution of feature assignments.
   */
  salt?: InputMaybe<Scalars['BigInt']>;
  /** Specifies the totem system name under which we will create an entity */
  systemName?: InputMaybe<Scalars['String']>;
  /**
   * When true, every single exposure of this feature will be recorded
   * and available for analysis.  When false (the default), only aggregated
   * exposure statistics will be reported.
   */
  trackAllExposures?: InputMaybe<Scalars['Boolean']>;
  /** The user who created this feature version */
  user?: InputMaybe<Instacart_Roulette_V1_User_Input>;
  /** A string uniquely identifying this feature.  This is an immutable identifier. */
  uuid?: InputMaybe<Scalars['String']>;
  variantValueType?: InputMaybe<Instacart_Roulette_V1_VariantValueType_Input>;
  /**
   * A feature has one or more variants into which users will be assigned;
   * a variant represents an observable difference in the experience of the
   * feature (e.g. "teal button" vs "turquoise button" in the "blue button" feature).
   * Of the variants defined, different percentages of assigned users can be
   * slotted.  By default, users will be evenly distributed across variants,
   * but this is configurable for each ruleset.
   *
   * Exactly one variant in each feature must be the "default" variant - that is,
   * the control group.  This variant serves as the "fall-through" - when a user
   * is not assigned to a variant by any ruleset in the feature, they will "fall through"
   * to this default variant.
   */
  variants?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Feature_Variant_Input>>>;
  /**
   * Any modification to the feature or to its rulesets will result in its
   * version being incremented.
   */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Metadata = {
  __typename?: 'instacart_roulette_v1_Feature_Metadata';
  /**
   * Each extension should have its own top-level key, with its schema
   * defined outside Roulette.
   */
  extensions?: Maybe<Scalars['JSON']>;
};

export type Instacart_Roulette_V1_Feature_Metadata_Input = {
  /**
   * Each extension should have its own top-level key, with its schema
   * defined outside Roulette.
   */
  extensions?: InputMaybe<Scalars['JSON']>;
};

export type Instacart_Roulette_V1_Feature_PartitionKind = {
  __typename?: 'instacart_roulette_v1_Feature_PartitionKind';
  idDayKind?: Maybe<Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod>;
  idKind?: Maybe<Instacart_Roulette_V1_Feature_PartitionKind_IdMod>;
};

/**
 * An ::IdDayMod feature will ensure that, within a single day, a
 * consistent set of requestors will be assigned to the feature, but that
 * set will be different on each weekday.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod = {
  __typename?: 'instacart_roulette_v1_Feature_PartitionKind_IdDayMod';
  /** A JSON Path, as in PartitionKind::IdMod#selector. */
  selector?: Maybe<Scalars['String']>;
};

/**
 * An ::IdDayMod feature will ensure that, within a single day, a
 * consistent set of requestors will be assigned to the feature, but that
 * set will be different on each weekday.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod_Input = {
  /** A JSON Path, as in PartitionKind::IdMod#selector. */
  selector?: InputMaybe<Scalars['String']>;
};

/**
 * A PartitionKind::IdMod represents ID-based partitioning.  It identifies
 * a single attribute from the input object to serve as the request ID,
 * which will subsequently be hashed and used for bucketing.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdMod = {
  __typename?: 'instacart_roulette_v1_Feature_PartitionKind_IdMod';
  /**
   * A JSON Path identifying an input value to serve as the "request ID".
   * This may in practice be a shopper ID (e.g. "$.shopper_id"), customer
   * ID, Kochava identifier, Ahoy visitor token, or any other input.
   *
   * If a given request does not include the expected attribute, it will
   * not be assigned the feature.
   */
  selector?: Maybe<Scalars['String']>;
};

/**
 * A PartitionKind::IdMod represents ID-based partitioning.  It identifies
 * a single attribute from the input object to serve as the request ID,
 * which will subsequently be hashed and used for bucketing.
 */
export type Instacart_Roulette_V1_Feature_PartitionKind_IdMod_Input = {
  /**
   * A JSON Path identifying an input value to serve as the "request ID".
   * This may in practice be a shopper ID (e.g. "$.shopper_id"), customer
   * ID, Kochava identifier, Ahoy visitor token, or any other input.
   *
   * If a given request does not include the expected attribute, it will
   * not be assigned the feature.
   */
  selector?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_PartitionKind_Input = {
  idDayKind?: InputMaybe<Instacart_Roulette_V1_Feature_PartitionKind_IdDayMod_Input>;
  idKind?: InputMaybe<Instacart_Roulette_V1_Feature_PartitionKind_IdMod_Input>;
};

export type Instacart_Roulette_V1_Feature_Permanent = {
  __typename?: 'instacart_roulette_v1_Feature_Permanent';
  /** Is the feature permanent */
  isPermanent?: Maybe<Scalars['Boolean']>;
  /** The reason for marking the feature as permanent */
  reason?: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_Permanent_Input = {
  /** Is the feature permanent */
  isPermanent?: InputMaybe<Scalars['Boolean']>;
  /** The reason for marking the feature as permanent */
  reason?: InputMaybe<Scalars['String']>;
};

/**
 * A Precondition in a Feature means that evaluations of the feature are
 * predicated on the evaluation of another feature, identified by the
 * given feature_uuid.  If that feature evaluates to a positive assignment,
 * or to a specific variant, then evaluation of _this_ feature proceeds.
 *
 * If the Precondition is not satisfied, then this feature is deemed not
 * to match - both rulesets and static assignments are ignored.
 */
export type Instacart_Roulette_V1_Feature_Precondition = {
  __typename?: 'instacart_roulette_v1_Feature_Precondition';
  /**
   * The variant(s) expected to have been assigned.
   *
   * If present, may not be empty.
   */
  allowedVariants?: Maybe<Instacart_Roulette_V1_VariantList>;
  /** Set if the precondition depends on a percentage of the target feature's traffic */
  exclusiveGroup?: Maybe<Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition>;
  /** The UUID identifying the feature targeted by this precondition. */
  featureUuid?: Maybe<Scalars['String']>;
  /** Whether or not the target feature should have been assigned. */
  shouldBeAssigned?: Maybe<Scalars['Boolean']>;
};

export type Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition = {
  __typename?: 'instacart_roulette_v1_Feature_Precondition_ExclusiveGroupPrecondition';
  /**
   * The variant(s) that have been assigned.
   * This should be treated as read-only by the clients; the server will ignore this
   * and assign allowed_variants strictly based on `percentage`.
   */
  allowedVariants?: Maybe<Instacart_Roulette_V1_VariantList>;
  /**
   * For what percentage of the Exclusive Group's traffic should this
   * precondition pass?
   */
  percentage?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition_Input = {
  /**
   * The variant(s) that have been assigned.
   * This should be treated as read-only by the clients; the server will ignore this
   * and assign allowed_variants strictly based on `percentage`.
   */
  allowedVariants?: InputMaybe<Instacart_Roulette_V1_VariantList_Input>;
  /**
   * For what percentage of the Exclusive Group's traffic should this
   * precondition pass?
   */
  percentage?: InputMaybe<Scalars['BigInt']>;
};

/**
 * A Precondition in a Feature means that evaluations of the feature are
 * predicated on the evaluation of another feature, identified by the
 * given feature_uuid.  If that feature evaluates to a positive assignment,
 * or to a specific variant, then evaluation of _this_ feature proceeds.
 *
 * If the Precondition is not satisfied, then this feature is deemed not
 * to match - both rulesets and static assignments are ignored.
 */
export type Instacart_Roulette_V1_Feature_Precondition_Input = {
  /**
   * The variant(s) expected to have been assigned.
   *
   * If present, may not be empty.
   */
  allowedVariants?: InputMaybe<Instacart_Roulette_V1_VariantList_Input>;
  /** Set if the precondition depends on a percentage of the target feature's traffic */
  exclusiveGroup?: InputMaybe<Instacart_Roulette_V1_Feature_Precondition_ExclusiveGroupPrecondition_Input>;
  /** The UUID identifying the feature targeted by this precondition. */
  featureUuid?: InputMaybe<Scalars['String']>;
  /** Whether or not the target feature should have been assigned. */
  shouldBeAssigned?: InputMaybe<Scalars['Boolean']>;
};

export type Instacart_Roulette_V1_Feature_Rollback = {
  __typename?: 'instacart_roulette_v1_Feature_Rollback';
  /** The note specified when the feature is rolled back */
  note?: Maybe<Scalars['String']>;
  /** The version of the feature this feature is a rollback of */
  version?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_Rollback_Input = {
  /** The note specified when the feature is rolled back */
  note?: InputMaybe<Scalars['String']>;
  /** The version of the feature this feature is a rollback of */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_Feature_StaticAssignment = {
  __typename?: 'instacart_roulette_v1_Feature_StaticAssignment';
  requestId?: Maybe<Scalars['String']>;
  variantName?: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_StaticAssignment_Input = {
  requestId?: InputMaybe<Scalars['String']>;
  variantName?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_Variant = {
  __typename?: 'instacart_roulette_v1_Feature_Variant';
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Instacart_Roulette_V1_Feature_VariantValue>;
};

/** The Value of the variant */
export type Instacart_Roulette_V1_Feature_VariantValue = {
  __typename?: 'instacart_roulette_v1_Feature_VariantValue';
  encoding?: Maybe<Instacart_Roulette_V1_Feature_VariantValue_Encoding>;
  raw?: Maybe<Scalars['String']>;
};

/** The encoding method of the variant value */
export enum Instacart_Roulette_V1_Feature_VariantValue_Encoding {
  Json = 'JSON',
  Unspecified = 'UNSPECIFIED'
}

/** The Value of the variant */
export type Instacart_Roulette_V1_Feature_VariantValue_Input = {
  encoding?: InputMaybe<Instacart_Roulette_V1_Feature_VariantValue_Encoding>;
  raw?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Feature_Variant_Input = {
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Instacart_Roulette_V1_Feature_VariantValue_Input>;
};

export type Instacart_Roulette_V1_GetFeatureByNameAndVersionRequest_Input = {
  /** Include the associated fields, e.g., Preconditions, Rulesets, etc */
  includeAssociations?: InputMaybe<Scalars['Boolean']>;
  /** The name of the feature */
  name?: InputMaybe<Scalars['String']>;
  /**
   * The version of the feature to fetch
   * If 0 is passed in, the latest version of the feature will be returned.
   */
  version?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_GetFeatureByNameAndVersionResponse = {
  __typename?: 'instacart_roulette_v1_GetFeatureByNameAndVersionResponse';
  feature?: Maybe<Instacart_Roulette_V1_Feature>;
};

export type Instacart_Roulette_V1_GetFeaturesRequest_Input = {
  /**
   * A pagination token which, when set, will cause the next batch of features to be returned.
   * This value is expected to be empty for initial fetches, and for subsequent fetches will be
   * the value most recently provided by the server in a |GetFeaturesResponse|.
   */
  cursor?: InputMaybe<Scalars['String']>;
  /**
   * A list of domains for which features are requested.  If no domains are
   * given, features from all domains will be returned.
   */
  domain?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /**
   * The maximum number of features to return for this request.  If zero or unset,
   * all features will be returned.
   */
  limit?: InputMaybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_GetFeaturesResponse = {
  __typename?: 'instacart_roulette_v1_GetFeaturesResponse';
  /**
   * A pagination token.  Should be provided verbatim in the next |GetFeaturesRequest|.
   *
   * Notes on pagination:
   *
   * Pagination is of |Feature| only.  Each response will contain all groups depended on by
   * the features contained within that response.  Consequently, the same group may appear
   * many times in a series of responses; clients *MUST* dedupliate accordingly.
   *
   * In this design, pagination takes advantage of Roulette's append-only dataset.
   * Cursors identify the most-recently-modified feature that has yet been returned to a client.
   * Because all changes to existing features result in a new version, it's guaranteed that a
   * given cursor will always incorporate updates, without the need to maintain any kind of
   * additional state on the back end.
   */
  cursor?: Maybe<Scalars['String']>;
  features?: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature>>>;
  groups?: Maybe<Array<Maybe<Instacart_Roulette_V1_Group>>>;
  status?: Maybe<Instacart_Roulette_V1_ResultStatus>;
};

/**
 * A |Group| is a named collection of values, used in criteria to
 * assert a user's membership in that group.  For example we might
 * have a group called 'west_coast_zones', containing every zone
 * that we deem to be on the West Coast; this can be used in multiple
 * features to filter requests to only those pertaining to those zones.
 * Another obvious group would be 'admins'.
 */
export type Instacart_Roulette_V1_Group = {
  __typename?: 'instacart_roulette_v1_Group';
  /** The unique human-readable name of the group. */
  id?: Maybe<Scalars['String']>;
  /** The group's members. */
  values?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Any modification to a Group will cause its version to be incremented. */
  version?: Maybe<Scalars['BigInt']>;
};

/** Specifies a hash function for use when evaluating a feature. */
export type Instacart_Roulette_V1_HashSpec = {
  __typename?: 'instacart_roulette_v1_HashSpec';
  simple?: Maybe<Instacart_Roulette_V1_HashSpec_Simple>;
  weightedRendezvous?: Maybe<Instacart_Roulette_V1_HashSpec_WeightedRendezvous>;
};

/**
 * Spells out particular hashing algorithms.  All algorithms here
 * are, unless otherwise specified, the 64-bit variant.
 */
export enum Instacart_Roulette_V1_HashSpec_HashPrimitive {
  Unspecified = 'UNSPECIFIED',
  /**
   * xxhash is an extremely fast non-cryptographic hash algorithm.
   * see https://cyan4973.github.io/xxHash/
   *
   * This is currently the only supported hash primitive.
   */
  Xxhash = 'XXHASH'
}

/** Specifies a hash function for use when evaluating a feature. */
export type Instacart_Roulette_V1_HashSpec_Input = {
  simple?: InputMaybe<Instacart_Roulette_V1_HashSpec_Simple_Input>;
  weightedRendezvous?: InputMaybe<Instacart_Roulette_V1_HashSpec_WeightedRendezvous_Input>;
};

/**
 * The Simple specification is just the application of the bare primitive
 * to an identifier, and the 64-bit output is used as-is.
 *
 * Generally should never be used for new features.
 */
export type Instacart_Roulette_V1_HashSpec_Simple = {
  __typename?: 'instacart_roulette_v1_HashSpec_Simple';
  hashPrimitive?: Maybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/**
 * The Simple specification is just the application of the bare primitive
 * to an identifier, and the 64-bit output is used as-is.
 *
 * Generally should never be used for new features.
 */
export type Instacart_Roulette_V1_HashSpec_Simple_Input = {
  hashPrimitive?: InputMaybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/**
 * Specifies that the "Weighted Rendezvous Hash" approach should be used.
 * This is a variant of consistent hashing that allows for changing variant
 * weights without unduly disrupting existing assignments.
 *
 * Note for implementers:
 * There are numerous variants of WRH; we've settled on the following particulars:
 * - Logarithmic approach to applying weights; the precise equation for scoring is
 * `score = -nodeWeight / ln(combineHashes(hash(key), hash(node)) / MAX_UINT64)`
 * - xorshift* to combine key and node hashcodes
 * - nodes traversed in ascending lexicographic order
 *
 * For example: https://github.com/benjamin-bader/rendezvous/blob/v0.2.0/rendezvous.go
 */
export type Instacart_Roulette_V1_HashSpec_WeightedRendezvous = {
  __typename?: 'instacart_roulette_v1_HashSpec_WeightedRendezvous';
  hashPrimitive?: Maybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/**
 * Specifies that the "Weighted Rendezvous Hash" approach should be used.
 * This is a variant of consistent hashing that allows for changing variant
 * weights without unduly disrupting existing assignments.
 *
 * Note for implementers:
 * There are numerous variants of WRH; we've settled on the following particulars:
 * - Logarithmic approach to applying weights; the precise equation for scoring is
 * `score = -nodeWeight / ln(combineHashes(hash(key), hash(node)) / MAX_UINT64)`
 * - xorshift* to combine key and node hashcodes
 * - nodes traversed in ascending lexicographic order
 *
 * For example: https://github.com/benjamin-bader/rendezvous/blob/v0.2.0/rendezvous.go
 */
export type Instacart_Roulette_V1_HashSpec_WeightedRendezvous_Input = {
  hashPrimitive?: InputMaybe<Instacart_Roulette_V1_HashSpec_HashPrimitive>;
};

/** Override feature update approval rules */
export type Instacart_Roulette_V1_Override_Input = {
  /** JIRA/Linear ticket link for the override */
  link?: InputMaybe<Scalars['String']>;
  /** The reason for the override */
  reason?: InputMaybe<Scalars['String']>;
  /** The email of the user who is overriding the feature update approval rules */
  userEmail?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Pagination_Input = {
  limit?: InputMaybe<Scalars['BigInt']>;
  offset?: InputMaybe<Scalars['BigInt']>;
};

/** A pending approval is a request to approve or reject a feature update */
export type Instacart_Roulette_V1_PendingApproval = {
  __typename?: 'instacart_roulette_v1_PendingApproval';
  /** Whether this feature has a pending approval */
  hasPendingApproval?: Maybe<Scalars['Boolean']>;
  /** The request id of the pending approval */
  requestId?: Maybe<Scalars['String']>;
};

/** A pending approval is a request to approve or reject a feature update */
export type Instacart_Roulette_V1_PendingApproval_Input = {
  /** Whether this feature has a pending approval */
  hasPendingApproval?: InputMaybe<Scalars['Boolean']>;
  /** The request id of the pending approval */
  requestId?: InputMaybe<Scalars['String']>;
};

/** A ResultStatus struct describes the outcome of a RouletteService RPC operation. */
export type Instacart_Roulette_V1_ResultStatus = {
  __typename?: 'instacart_roulette_v1_ResultStatus';
  /**
   * If the request was unsuccessful, may contain useful diagnostic information.
   * It's not safe to assume this will be available or useful in the general case.
   */
  data?: Maybe<Scalars['JSON']>;
  /** Indicates the disposition of the request */
  status?: Maybe<Instacart_Roulette_V1_ResultStatus_Status>;
};

export enum Instacart_Roulette_V1_ResultStatus_Status {
  /**
   * Indicates that some mutating operation failed due to a versioning conflict -
   * someone else touched the feature before you did, and your version was consequently
   * out-of-date.
   */
  Conflict = 'CONFLICT',
  /** The server got itself into trouble. */
  InternalError = 'INTERNAL_ERROR',
  /** Indicates that the request was invalid. */
  InvalidRequest = 'INVALID_REQUEST',
  /** Indicates that the resource was not found. */
  NotFound = 'NOT_FOUND',
  /** Indicates that all went as requested. */
  Ok = 'OK',
  /** Indicates that the developers forgot to set a status code :( */
  Unknown = 'UNKNOWN'
}

/**
 * A Ruleset defines the rules governing how a feature is assigned.
 *
 * A ruleset may be enabled or disabled; if the latter, it will not be used
 * for assignment at all.
 *
 * The process of ruleset evaluation is as follows:
 * As input, a ruleset is applied to an associative array (hash, object, map, etc)
 * and a hashed identifier (see [Feature.request_id_selector]).  Based on the hash,
 * an exposure percentage is applied - whatever the exposure percentage is, that
 * proportion of requests are considered for assignment.  (Another way to say that
 * is that 1.0 - [exposure_percentage] percent of requests are excluded.)
 *
 * Of the requests included in the exposure, the population is further winnowed by
 * any defined rules
 */
export type Instacart_Roulette_V1_Ruleset = {
  __typename?: 'instacart_roulette_v1_Ruleset';
  enabled?: Maybe<Scalars['Boolean']>;
  /**
   * A value between zero and one.  This is the "top of the funnel",
   * and represents the proportion of requests considered for assignment.
   * For example, given an |exposure_percentage| of 0.3, 30% of requests
   * would proceed to be evaluated against the ruleset, and 70% would
   * be screened out.
   */
  exposurePercentage?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  /**
   * The rules to be evaulated for each request.
   * The input to a rule is a structured document (e.g. a JSON object);
   * consequently, a rule consists of a |path| and some criteria.
   * Paths are JSON Path (https://github.com/json-path/JsonPath) strings
   * denoting a specific value in the input, and criteria are one or more
   * well-defined conditions.
   *
   * Successive rules have a logical "AND" relationship.
   */
  rules?: Maybe<Array<Maybe<Instacart_Roulette_V1_Ruleset_Rule>>>;
  /**
   * A ruleset can define proportional weights for each of the feature's
   * variants.  By default, all variants are equally-weighted; if no variant
   * weights are specified, it is assumed that all have an equal default
   * weight.
   *
   * If weights are provided, then there must be one weight for every variant
   * defined for the featue; it is an error to provide any fewer or any more
   * weights.
   *
   * Weights are positive integers.  The sum of all weights must equal
   * 10,000.  This is an arbitrary constraint intended to make it easy to
   * reason about weights in terms of percentages.
   *
   * For example, given three variants "a", "b", and "c", if we wanted
   * 50% of assignments in "a", 30% in "b", and 20% in "c", the corresponding
   * weights would be:
   * {
   * "a": 5000,
   * "b": 3000,
   * "c": 2000,
   * }
   */
  variantWeights?: Maybe<Array<Maybe<Instacart_Roulette_V1_Ruleset_VariantWeight>>>;
};

/**
 * A Ruleset defines the rules governing how a feature is assigned.
 *
 * A ruleset may be enabled or disabled; if the latter, it will not be used
 * for assignment at all.
 *
 * The process of ruleset evaluation is as follows:
 * As input, a ruleset is applied to an associative array (hash, object, map, etc)
 * and a hashed identifier (see [Feature.request_id_selector]).  Based on the hash,
 * an exposure percentage is applied - whatever the exposure percentage is, that
 * proportion of requests are considered for assignment.  (Another way to say that
 * is that 1.0 - [exposure_percentage] percent of requests are excluded.)
 *
 * Of the requests included in the exposure, the population is further winnowed by
 * any defined rules
 */
export type Instacart_Roulette_V1_Ruleset_Input = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  /**
   * A value between zero and one.  This is the "top of the funnel",
   * and represents the proportion of requests considered for assignment.
   * For example, given an |exposure_percentage| of 0.3, 30% of requests
   * would proceed to be evaluated against the ruleset, and 70% would
   * be screened out.
   */
  exposurePercentage?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * The rules to be evaulated for each request.
   * The input to a rule is a structured document (e.g. a JSON object);
   * consequently, a rule consists of a |path| and some criteria.
   * Paths are JSON Path (https://github.com/json-path/JsonPath) strings
   * denoting a specific value in the input, and criteria are one or more
   * well-defined conditions.
   *
   * Successive rules have a logical "AND" relationship.
   */
  rules?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Ruleset_Rule_Input>>>;
  /**
   * A ruleset can define proportional weights for each of the feature's
   * variants.  By default, all variants are equally-weighted; if no variant
   * weights are specified, it is assumed that all have an equal default
   * weight.
   *
   * If weights are provided, then there must be one weight for every variant
   * defined for the featue; it is an error to provide any fewer or any more
   * weights.
   *
   * Weights are positive integers.  The sum of all weights must equal
   * 10,000.  This is an arbitrary constraint intended to make it easy to
   * reason about weights in terms of percentages.
   *
   * For example, given three variants "a", "b", and "c", if we wanted
   * 50% of assignments in "a", 30% in "b", and 20% in "c", the corresponding
   * weights would be:
   * {
   * "a": 5000,
   * "b": 3000,
   * "c": 2000,
   * }
   */
  variantWeights?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Ruleset_VariantWeight_Input>>>;
};

export type Instacart_Roulette_V1_Ruleset_Rule = {
  __typename?: 'instacart_roulette_v1_Ruleset_Rule';
  /**
   * Multiple criteria have a logical "OR" relationship.
   * If any of the criteria in the list are satisfied by
   * the rule input, then the rule evaluates successfully.
   *
   * For example, given a rule of the form
   * {
   * "path": "$.email", criteria: [
   * {"type": "string", "expected": "foo"},
   * {"type": "string", "expected": "bar"},
   * ]
   * },
   *
   * the rule would match input like {"email": "foo"}.
   */
  criteria?: Maybe<Array<Maybe<Instacart_Roulette_V1_Criterion>>>;
  /** A |path| is a JSON Path notation descr */
  path?: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Ruleset_Rule_Input = {
  /**
   * Multiple criteria have a logical "OR" relationship.
   * If any of the criteria in the list are satisfied by
   * the rule input, then the rule evaluates successfully.
   *
   * For example, given a rule of the form
   * {
   * "path": "$.email", criteria: [
   * {"type": "string", "expected": "foo"},
   * {"type": "string", "expected": "bar"},
   * ]
   * },
   *
   * the rule would match input like {"email": "foo"}.
   */
  criteria?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_Criterion_Input>>>;
  /** A |path| is a JSON Path notation descr */
  path?: InputMaybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_Ruleset_VariantWeight = {
  __typename?: 'instacart_roulette_v1_Ruleset_VariantWeight';
  variant?: Maybe<Scalars['String']>;
  weight?: Maybe<Scalars['Int']>;
};

export type Instacart_Roulette_V1_Ruleset_VariantWeight_Input = {
  variant?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Int']>;
};

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Operator {
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Operator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Operator {
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Operator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Operator>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Operator {
  Equals = 'EQUALS'
}

/** `Criterion` represents a single filter criterion on a feature attribute */
export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_Input = {
  domainName?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_DomainNameFilter_Input>;
  featureName?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureNameFilter_Input>;
  featureUuid?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_FeatureUuidFilter_Input>;
  groupId?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_GroupIdFilter_Input>;
  hasPendingApproval?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_HasPendingApprovalFilter_Input>;
  preconditionName?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Input>;
  preconditionUuid?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Input>;
};

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionNameFilter_Operator {
  Contains = 'CONTAINS',
  Equals = 'EQUALS'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Input = {
  operator?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Operator>;
  value?: InputMaybe<Scalars['String']>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_PreconditionUuidFilter_Operator {
  Equals = 'EQUALS'
}

/**
 * `Filters` is a collection of criteria to be applied to the feature search
 * The criteria are AND'ed
 */
export type Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Input = {
  criteria?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Criterion_Input>>>;
};

export type Instacart_Roulette_V1_SearchFeaturesRequest_Input = {
  filters?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Filters_Input>;
  pagination?: InputMaybe<Instacart_Roulette_V1_Pagination_Input>;
  sort?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Input>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Attribute {
  ByName = 'BY_NAME'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Sort_By_Input = {
  attribute?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Attribute>;
  direction?: InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Direction>;
};

export enum Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Direction {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Instacart_Roulette_V1_SearchFeaturesRequest_Sort_Input = {
  attributes?: InputMaybe<Array<InputMaybe<Instacart_Roulette_V1_SearchFeaturesRequest_Sort_By_Input>>>;
};

export type Instacart_Roulette_V1_SearchFeaturesResponse = {
  __typename?: 'instacart_roulette_v1_SearchFeaturesResponse';
  features?: Maybe<Array<Maybe<Instacart_Roulette_V1_Feature>>>;
  status?: Maybe<Instacart_Roulette_V1_ResultStatus>;
  totalCount?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_StoreFeatureRequest_Input = {
  /**
   * The feature to be stored.
   *
   * If this feature (identified by UUID) does not exist, it will be stored
   * as is.  If it does exist, then this feature's version must match the stored
   * version exactly.  If it does not, the request fails and |ResultStatus.CONFICT|
   * will be returned.  If it does match, then the feature will be stored and its
   * version will be incremented.
   *
   * Note that for a brand-new feature, the version must be explicitly set to zero.
   */
  feature?: InputMaybe<Instacart_Roulette_V1_Feature_Input>;
  /** Override feature update approval rules */
  override?: InputMaybe<Instacart_Roulette_V1_Override_Input>;
};

export type Instacart_Roulette_V1_StoreFeatureResponse = {
  __typename?: 'instacart_roulette_v1_StoreFeatureResponse';
  status?: Maybe<Instacart_Roulette_V1_ResultStatus>;
  /**
   * If |status| is OK or CONFLICT, this field will contain the current version
   * of the stored feature.
   */
  version?: Maybe<Scalars['BigInt']>;
};

export type Instacart_Roulette_V1_User = {
  __typename?: 'instacart_roulette_v1_User';
  /** User's email */
  email?: Maybe<Scalars['String']>;
};

export type Instacart_Roulette_V1_User_Input = {
  /** User's email */
  email?: InputMaybe<Scalars['String']>;
};

/**
 * A list of zero or more variants.
 *
 * NOTE:
 * Useful only in that it allows embedding a repeated value
 * within a oneof.  If that's not your use-case, just use
 * a repeated field.
 */
export type Instacart_Roulette_V1_VariantList = {
  __typename?: 'instacart_roulette_v1_VariantList';
  variantName?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * A list of zero or more variants.
 *
 * NOTE:
 * Useful only in that it allows embedding a repeated value
 * within a oneof.  If that's not your use-case, just use
 * a repeated field.
 */
export type Instacart_Roulette_V1_VariantList_Input = {
  variantName?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The configuration associated with a variant */
export type Instacart_Roulette_V1_VariantValueType = {
  __typename?: 'instacart_roulette_v1_VariantValueType';
  /** Is the type user defined or predefined */
  isUserDefined?: Maybe<Scalars['Boolean']>;
  /** The name of the variant value type */
  typeName?: Maybe<Instacart_Roulette_V1_VariantValueType_TypeName>;
};

/** The configuration associated with a variant */
export type Instacart_Roulette_V1_VariantValueType_Input = {
  /** Is the type user defined or predefined */
  isUserDefined?: InputMaybe<Scalars['Boolean']>;
  /** The name of the variant value type */
  typeName?: InputMaybe<Instacart_Roulette_V1_VariantValueType_TypeName>;
};

/** The variant value type names */
export enum Instacart_Roulette_V1_VariantValueType_TypeName {
  Boolean = 'BOOLEAN',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  ListOfBooleans = 'LIST_OF_BOOLEANS',
  ListOfFloats = 'LIST_OF_FLOATS',
  ListOfIntegers = 'LIST_OF_INTEGERS',
  ListOfStrings = 'LIST_OF_STRINGS',
  String = 'STRING',
  Unspecified = 'UNSPECIFIED'
}

/**
 * Represents an accurate fractional value
 * Similar to google.type.Money
 */
export type Instacart_Types_V1_BigDecimal = {
  __typename?: 'instacart_types_v1_BigDecimal';
  /**
   * Nano units of the amount (10^-9)
   * Must be same sign as units
   * Example: The value -1.25 is represented as units=-1 and nanos=-250000000
   */
  nanos?: Maybe<Scalars['Int']>;
  /** Whole units part of the amount */
  units?: Maybe<Scalars['BigInt']>;
};

/**
 * Represents an accurate fractional value
 * Similar to google.type.Money
 */
export type Instacart_Types_V1_BigDecimal_Input = {
  /**
   * Nano units of the amount (10^-9)
   * Must be same sign as units
   * Example: The value -1.25 is represented as units=-1 and nanos=-250000000
   */
  nanos?: InputMaybe<Scalars['Int']>;
  /** Whole units part of the amount */
  units?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasuredQuantity = {
  __typename?: 'instacart_types_v1_MeasuredQuantity';
  /**
   * The quantity in relevant units. Quantity may be positive, negative or zero in a message.
   * The semantics of negative quantities are application-specific.
   */
  quantity?: Maybe<Scalars['Float']>;
  /**
   * The measurement unit for this quantity. If this is the unknown MeasurementUnit
   * then the quantity field cannot be deterministically interpreted without
   * outside knowledge or heuristics. Valid MeasurementUnits should be used for all
   * new data.
   */
  unit?: Maybe<Instacart_Types_V1_MeasurementUnit>;
};

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasuredQuantity_Input = {
  /**
   * The quantity in relevant units. Quantity may be positive, negative or zero in a message.
   * The semantics of negative quantities are application-specific.
   */
  quantity?: InputMaybe<Scalars['Float']>;
  /**
   * The measurement unit for this quantity. If this is the unknown MeasurementUnit
   * then the quantity field cannot be deterministically interpreted without
   * outside knowledge or heuristics. Valid MeasurementUnits should be used for all
   * new data.
   */
  unit?: InputMaybe<Instacart_Types_V1_MeasurementUnit_Input>;
};

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasurementUnit = {
  __typename?: 'instacart_types_v1_MeasurementUnit';
  /** Cost unit of the item. */
  costUnit?: Maybe<Instacart_Types_V1_MeasurementUnit_CostUnit>;
  /**
   * Represents the case-sensitive symbols (c/s) defined by the
   * UCUM specification. Non-matching MeasurementUnits *might* be
   * convertible within the UCUM system by an application that
   * understands the semantics of UCUM symbols, base units, and
   * derived units.
   *
   * Simple equality comparison of a MeasurementUnit requires only
   * a case-sensitive comparison of `unit_code`.
   * Confirming that a `unit_code` is valid in the UCUM system requires
   * a full understanding the specification.
   * The protobuf default string value is explicitly *not* a valid symbol
   * in the UCUM system and represents an unknown MeasurementUnit
   * rather than a literal code. An unknown unit code does not match any
   * other unit code (including unknown).
   *
   * Note that the Arbitrary Unit code "[arb'U]" is used to represent "per each" quantities
   * where the concept of "each" is relative to an identified thing.
   * See: https://en.wikipedia.org/wiki/Arbitrary_unit
   *
   * Common unit_codes used in Instacart flows include:
   * Arbitrary Unit (per each):               "[arb'U]"
   * US Fluid Ounce (fluid volume):           "[foz_us]"
   * Avoirdupois Pound (mass aka weight):     "[lb_av]"
   */
  unitCode?: Maybe<Scalars['String']>;
};

export enum Instacart_Types_V1_MeasurementUnit_CostUnit {
  CostUnitUnspecified = 'COST_UNIT_UNSPECIFIED',
  /** Unit is measured as each */
  Each = 'EACH',
  /** Fluid Ounce */
  FlOz = 'FL_OZ',
  /** Gallons */
  Gallon = 'GALLON',
  /** grams, 1/1000 of a KG */
  Gram = 'GRAM',
  /** Kilogram */
  Kg = 'KG',
  /** Pounds */
  Lb = 'LB',
  /** 1 L = 1 Liter = 1_000 MilliLiter */
  Liter = 'LITER',
  /** MilliLiter, and not MegaLiter */
  Ml = 'ML',
  /** Ounce */
  Oz = 'OZ',
  /** Pint; 1/2 of a Gallon */
  Pint = 'PINT',
  /** Quart; 1/4 of a Gallon */
  Quart = 'QUART'
}

/**
 * Expresses a measurement unit based on the UCUM standard
 * which builds on ANSI_X3_50 and ISO_2955_1983 with explicit
 * emphasis on machine-to-machine interoperability.
 * See: http://unitsofmeasure.org/ucum.html.
 *
 * Services should document the unit_codes they support.
 * They should raise clear errors if unsupported unit_codes are passed.
 */
export type Instacart_Types_V1_MeasurementUnit_Input = {
  /** Cost unit of the item. */
  costUnit?: InputMaybe<Instacart_Types_V1_MeasurementUnit_CostUnit>;
  /**
   * Represents the case-sensitive symbols (c/s) defined by the
   * UCUM specification. Non-matching MeasurementUnits *might* be
   * convertible within the UCUM system by an application that
   * understands the semantics of UCUM symbols, base units, and
   * derived units.
   *
   * Simple equality comparison of a MeasurementUnit requires only
   * a case-sensitive comparison of `unit_code`.
   * Confirming that a `unit_code` is valid in the UCUM system requires
   * a full understanding the specification.
   * The protobuf default string value is explicitly *not* a valid symbol
   * in the UCUM system and represents an unknown MeasurementUnit
   * rather than a literal code. An unknown unit code does not match any
   * other unit code (including unknown).
   *
   * Note that the Arbitrary Unit code "[arb'U]" is used to represent "per each" quantities
   * where the concept of "each" is relative to an identified thing.
   * See: https://en.wikipedia.org/wiki/Arbitrary_unit
   *
   * Common unit_codes used in Instacart flows include:
   * Arbitrary Unit (per each):               "[arb'U]"
   * US Fluid Ounce (fluid volume):           "[foz_us]"
   * Avoirdupois Pound (mass aka weight):     "[lb_av]"
   */
  unitCode?: InputMaybe<Scalars['String']>;
};

/**
 * Contextual information used for identifying the
 * marketplace/pbi/connect configurations associated
 * with a request
 */
export type Instacart_Types_V1_RequestContext_Input = {
  /**
   * NOTE: this ID is still a proposal/wip
   * for replacing the multiple identifiers long term
   */
  applicationId?: InputMaybe<Scalars['Int']>;
  clientConfigurationId?: InputMaybe<Scalars['Int']>;
  /** ISO numeric code */
  countryId?: InputMaybe<Scalars['Int']>;
  storeConfigurationId?: InputMaybe<Scalars['Int']>;
};

/** AuditContext */
export type Instacart_Upos_Config_V1_AuditContext = {
  __typename?: 'instacart_upos_config_v1_AuditContext';
  agentId?: Maybe<Scalars['String']>;
};

/** AuditContext */
export type Instacart_Upos_Config_V1_AuditContext_Input = {
  agentId?: InputMaybe<Scalars['String']>;
};

/** GetIntegrationVersionsRequest */
export type Instacart_Upos_Config_V1_GetIntegrationVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetIntegrationVersionsResponse */
export type Instacart_Upos_Config_V1_GetIntegrationVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetIntegrationVersionsResponse';
  versions?: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetIntegrationsResponse */
export type Instacart_Upos_Config_V1_GetIntegrationsResponse = {
  __typename?: 'instacart_upos_config_v1_GetIntegrationsResponse';
  integrations?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetProfileVersionsRequest */
export type Instacart_Upos_Config_V1_GetProfileVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetProfileVersionsResponse */
export type Instacart_Upos_Config_V1_GetProfileVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetProfileVersionsResponse';
  versions?: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetProfilesResponse */
export type Instacart_Upos_Config_V1_GetProfilesResponse = {
  __typename?: 'instacart_upos_config_v1_GetProfilesResponse';
  profiles?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetRetailerVersionsRequest */
export type Instacart_Upos_Config_V1_GetRetailerVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetRetailerVersionsResponse */
export type Instacart_Upos_Config_V1_GetRetailerVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetRetailerVersionsResponse';
  versions?: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetRetailersResponse */
export type Instacart_Upos_Config_V1_GetRetailersResponse = {
  __typename?: 'instacart_upos_config_v1_GetRetailersResponse';
  retailers?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** GetStoreVersionsRequest */
export type Instacart_Upos_Config_V1_GetStoreVersionsRequest_Input = {
  id?: InputMaybe<Scalars['BigInt']>;
};

/** GetStoreVersionsResponse */
export type Instacart_Upos_Config_V1_GetStoreVersionsResponse = {
  __typename?: 'instacart_upos_config_v1_GetStoreVersionsResponse';
  versions?: Maybe<Array<Maybe<Instacart_Upos_Config_V1_Version>>>;
};

/** GetStoresResponse */
export type Instacart_Upos_Config_V1_GetStoresResponse = {
  __typename?: 'instacart_upos_config_v1_GetStoresResponse';
  stores?: Maybe<Array<Maybe<Scalars['JSON']>>>;
};

/** PutIntegrationRequest */
export type Instacart_Upos_Config_V1_PutIntegrationRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  integration?: InputMaybe<Scalars['JSON']>;
};

/** PutIntegrationResponse */
export type Instacart_Upos_Config_V1_PutIntegrationResponse = {
  __typename?: 'instacart_upos_config_v1_PutIntegrationResponse';
  integration?: Maybe<Scalars['JSON']>;
};

/** PutProfileRequest */
export type Instacart_Upos_Config_V1_PutProfileRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  profile?: InputMaybe<Scalars['JSON']>;
};

/** PutProfileResponse */
export type Instacart_Upos_Config_V1_PutProfileResponse = {
  __typename?: 'instacart_upos_config_v1_PutProfileResponse';
  profile?: Maybe<Scalars['JSON']>;
};

/** PutRetailerRequest */
export type Instacart_Upos_Config_V1_PutRetailerRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  retailer?: InputMaybe<Scalars['JSON']>;
};

/** PutRetailerResponse */
export type Instacart_Upos_Config_V1_PutRetailerResponse = {
  __typename?: 'instacart_upos_config_v1_PutRetailerResponse';
  retailer?: Maybe<Scalars['JSON']>;
};

/** PutStoreRequest */
export type Instacart_Upos_Config_V1_PutStoreRequest_Input = {
  auditContext?: InputMaybe<Instacart_Upos_Config_V1_AuditContext_Input>;
  store?: InputMaybe<Scalars['JSON']>;
};

/** PutStoreResponse */
export type Instacart_Upos_Config_V1_PutStoreResponse = {
  __typename?: 'instacart_upos_config_v1_PutStoreResponse';
  store?: Maybe<Scalars['JSON']>;
};

/** Version */
export type Instacart_Upos_Config_V1_Version = {
  __typename?: 'instacart_upos_config_v1_Version';
  auditContext?: Maybe<Instacart_Upos_Config_V1_AuditContext>;
  create?: Maybe<Scalars['instacart_upos_config_v1_Version_Create']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  update?: Maybe<Instacart_Upos_Config_V1_Version_Update>;
};

/** Update */
export type Instacart_Upos_Config_V1_Version_Update = {
  __typename?: 'instacart_upos_config_v1_Version_Update';
  record?: Maybe<Scalars['JSON']>;
};

/** GetIntegrationStatusesResponse */
export type Instacart_Upos_Status_V1_GetIntegrationStatusesResponse = {
  __typename?: 'instacart_upos_status_v1_GetIntegrationStatusesResponse';
  statuses?: Maybe<Array<Maybe<Instacart_Upos_Status_V1_IntegrationStatus>>>;
};

/** The status of a retailer location integration */
export type Instacart_Upos_Status_V1_IntegrationStatus = {
  __typename?: 'instacart_upos_status_v1_IntegrationStatus';
  comment?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  emails?: Maybe<Array<Maybe<Scalars['String']>>>;
  healthyStatus?: Maybe<Instacart_Upos_Status_V1_IntegrationStatus_Healthy>;
  integrationName?: Maybe<Scalars['String']>;
  links?: Maybe<Scalars['JSON']>;
  restartable?: Maybe<Scalars['Boolean']>;
  retailerLocationId?: Maybe<Scalars['BigInt']>;
  retailerName?: Maybe<Scalars['String']>;
  undeterminedStatus?: Maybe<Scalars['instacart_upos_status_v1_IntegrationStatus_Undetermined']>;
  unhealthyStatus?: Maybe<Instacart_Upos_Status_V1_IntegrationStatus_Unhealthy>;
};

/** Returned if status is healthy */
export type Instacart_Upos_Status_V1_IntegrationStatus_Healthy = {
  __typename?: 'instacart_upos_status_v1_IntegrationStatus_Healthy';
  debugInfo?: Maybe<Scalars['JSON']>;
  firstCheckedAt?: Maybe<Scalars['DateTime']>;
  healthySince?: Maybe<Scalars['DateTime']>;
  lastCheckedAt?: Maybe<Scalars['DateTime']>;
};

/** Returned if status is unhealthy */
export type Instacart_Upos_Status_V1_IntegrationStatus_Unhealthy = {
  __typename?: 'instacart_upos_status_v1_IntegrationStatus_Unhealthy';
  debugInfo?: Maybe<Scalars['JSON']>;
  firstCheckedAt?: Maybe<Scalars['DateTime']>;
  lastCheckedAt?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<Scalars['String']>;
  unhealthySince?: Maybe<Scalars['DateTime']>;
};

/** A single child step currently in progress inside a pipeline run */
export type Instacart_Waves_V1_ActiveStep = {
  __typename?: 'instacart_waves_v1_ActiveStep';
  step_id?: Maybe<Scalars['BigInt']>;
  step_name?: Maybe<Scalars['String']>;
};

/** Alert priority. Drives Datadog downtime schedule (p1 = 24/7, p2/p3 = silenced off-hours). */
export enum Instacart_Waves_V1_AlertPriority {
  AlertPriorityP1 = 'ALERT_PRIORITY_P1',
  AlertPriorityP2 = 'ALERT_PRIORITY_P2',
  AlertPriorityP3 = 'ALERT_PRIORITY_P3',
  AlertPriorityUnknown = 'ALERT_PRIORITY_UNKNOWN'
}

/** Request to cancel an in-progress async step preview. */
export type Instacart_Waves_V1_CancelPreviewRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  preview_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after cancelling an async step preview. */
export type Instacart_Waves_V1_CancelPreviewResponse = {
  __typename?: 'instacart_waves_v1_CancelPreviewResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/**
 * Request to claim ownership of a pipeline that has no Sesame actions yet.
 * Creates view and edit Sesame Actions and sets the caller as maintainer.
 */
export type Instacart_Waves_V1_ClaimPipelineOwnershipRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/**
 * Response after claiming pipeline ownership.
 * Returns the newly created Sesame action IDs for view and edit access.
 */
export type Instacart_Waves_V1_ClaimPipelineOwnershipResponse = {
  __typename?: 'instacart_waves_v1_ClaimPipelineOwnershipResponse';
  message?: Maybe<Scalars['String']>;
  sesame_edit_action_id?: Maybe<Scalars['BigInt']>;
  sesame_view_action_id?: Maybe<Scalars['BigInt']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to create a new step with its initial version */
export type Instacart_Waves_V1_CreateNewStepRequest_Input = {
  /** required: step configuration (JSONB) */
  attributes?: InputMaybe<Scalars['JSON']>;
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  /**
   * Generic step-level metadata (stable, version-independent). Pipeline
   * managed-attribute identity is nested under the `sentinel` key:
   * { sentinel: { entities: [{ type, id, name }] } }.
   */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** required: name, owner, type, step_category */
  step?: InputMaybe<Instacart_Waves_V1_Step_Input>;
};

/** Response after creating a new step */
export type Instacart_Waves_V1_CreateNewStepResponse = {
  __typename?: 'instacart_waves_v1_CreateNewStepResponse';
  /** created step ID */
  id?: Maybe<Scalars['BigInt']>;
  message?: Maybe<Scalars['String']>;
  sesame_edit_action_id?: Maybe<Scalars['BigInt']>;
  sesame_view_action_id?: Maybe<Scalars['BigInt']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to create a new step version */
export type Instacart_Waves_V1_CreateNewStepVersionRequest_Input = {
  attributes?: InputMaybe<Scalars['JSON']>;
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_why?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
};

/** Response after creating a new step version */
export type Instacart_Waves_V1_CreateNewStepVersionResponse = {
  __typename?: 'instacart_waves_v1_CreateNewStepVersionResponse';
  id?: Maybe<Scalars['BigInt']>;
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  /**
   * Per-step validation errors. Populated when status_code is 400 and the
   * failure was a structured validation rejection. See StepValidationErrors
   * for grouping semantics.
   */
  step_errors?: Maybe<Array<Maybe<Instacart_Waves_V1_StepValidationErrors>>>;
};

/** Request to create or update a scheduled workflow (upsert operation). */
export type Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  spec?: InputMaybe<Instacart_Waves_V1_ScheduleSpec_Input>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  workflow_input?: InputMaybe<Instacart_Waves_V1_WorkflowLoopInput_Input>;
};

/** Response containing the result of creating or updating a scheduled workflow. */
export type Instacart_Waves_V1_CreateOrUpdateScheduledWorkflowResponse = {
  __typename?: 'instacart_waves_v1_CreateOrUpdateScheduledWorkflowResponse';
  message?: Maybe<Scalars['String']>;
  schedule_id?: Maybe<Scalars['String']>;
};

/** Request to create (upsert) a pipeline alert config. */
export type Instacart_Waves_V1_CreatePipelineAlertConfigRequest_Input = {
  alert_threshold_max_duration?: InputMaybe<Scalars['BigInt']>;
  alert_threshold_minutes_between_runs?: InputMaybe<Scalars['BigInt']>;
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Instacart_Waves_V1_AlertPriority>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after creating a pipeline alert config. */
export type Instacart_Waves_V1_CreatePipelineAlertConfigResponse = {
  __typename?: 'instacart_waves_v1_CreatePipelineAlertConfigResponse';
  config?: Maybe<Instacart_Waves_V1_PipelineAlertConfig>;
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to submit a new async step preview. */
export type Instacart_Waves_V1_CreatePreviewRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  steps?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

/** Response after submitting a new async step preview. */
export type Instacart_Waves_V1_CreatePreviewResponse = {
  __typename?: 'instacart_waves_v1_CreatePreviewResponse';
  message?: Maybe<Scalars['String']>;
  preview_id?: Maybe<Scalars['BigInt']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to create a new step filter tag */
export type Instacart_Waves_V1_CreateStepFilterTagRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  filter_metadata?: InputMaybe<Scalars['JSON']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tag_name?: InputMaybe<Scalars['String']>;
  /** Optional */
  tag_value?: InputMaybe<Scalars['String']>;
};

/** Response after creating a step filter tag */
export type Instacart_Waves_V1_CreateStepFilterTagResponse = {
  __typename?: 'instacart_waves_v1_CreateStepFilterTagResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  tag?: Maybe<Instacart_Waves_V1_StepFilterTag>;
};

/** Request to soft-delete a pipeline alert config (and its child thresholds). */
export type Instacart_Waves_V1_DeletePipelineAlertConfigRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after deleting a pipeline alert config. */
export type Instacart_Waves_V1_DeletePipelineAlertConfigResponse = {
  __typename?: 'instacart_waves_v1_DeletePipelineAlertConfigResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to delete an existing scheduled workflow. */
export type Instacart_Waves_V1_DeleteScheduledWorkflowRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response confirming the deletion of a scheduled workflow. */
export type Instacart_Waves_V1_DeleteScheduledWorkflowResponse = {
  __typename?: 'instacart_waves_v1_DeleteScheduledWorkflowResponse';
  message?: Maybe<Scalars['String']>;
};

/** Request to soft-delete a per-step threshold. */
export type Instacart_Waves_V1_DeleteStepAlertThresholdRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  pipeline_step_id?: InputMaybe<Scalars['BigInt']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after deleting a step threshold. */
export type Instacart_Waves_V1_DeleteStepAlertThresholdResponse = {
  __typename?: 'instacart_waves_v1_DeleteStepAlertThresholdResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to delete a step filter tag */
export type Instacart_Waves_V1_DeleteStepFilterTagRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tag_name?: InputMaybe<Scalars['String']>;
};

/** Response after deleting a step filter tag */
export type Instacart_Waves_V1_DeleteStepFilterTagResponse = {
  __typename?: 'instacart_waves_v1_DeleteStepFilterTagResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to describe snowflake table's schema */
export type Instacart_Waves_V1_DescribeSnowflakeTableRequest_Input = {
  /** Format: database.schema.table */
  table_name?: InputMaybe<Scalars['String']>;
};

/** Response containing snowflake table schema information */
export type Instacart_Waves_V1_DescribeSnowflakeTableResponse = {
  __typename?: 'instacart_waves_v1_DescribeSnowflakeTableResponse';
  columns?: Maybe<Array<Maybe<Instacart_Waves_V1_SnowflakeColumn>>>;
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to fetch a pipeline alert config and its child step thresholds. */
export type Instacart_Waves_V1_GetPipelineAlertConfigRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the pipeline alert config and child step thresholds. */
export type Instacart_Waves_V1_GetPipelineAlertConfigResponse = {
  __typename?: 'instacart_waves_v1_GetPipelineAlertConfigResponse';
  config?: Maybe<Instacart_Waves_V1_PipelineAlertConfig>;
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  step_thresholds?: Maybe<Array<Maybe<Instacart_Waves_V1_StepAlertThreshold>>>;
};

/** Response containing the presigned upload URL and S3 location */
export type Instacart_Waves_V1_GetPresignedUploadUrlResponse = {
  __typename?: 'instacart_waves_v1_GetPresignedUploadUrlResponse';
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
};

/** Request to poll an async step preview by id. */
export type Instacart_Waves_V1_GetPreviewRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  preview_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the state, context, and result rows for an async step preview. */
export type Instacart_Waves_V1_GetPreviewResponse = {
  __typename?: 'instacart_waves_v1_GetPreviewResponse';
  context?: Maybe<Scalars['JSON']>;
  message?: Maybe<Scalars['String']>;
  /**
   * One entry per result row, keyed by column name. Values are
   * stringified by the backend; SQL NULL is explicit "col": null.
   */
  results?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  state?: Maybe<Instacart_Waves_V1_PreviewState>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to get paginated step version history */
export type Instacart_Waves_V1_GetStepVersionHistoryRequest_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing step version history */
export type Instacart_Waves_V1_GetStepVersionHistoryResponse = {
  __typename?: 'instacart_waves_v1_GetStepVersionHistoryResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  step_versions?: Maybe<Array<Maybe<Instacart_Waves_V1_StepVersion>>>;
};

/** Request to get a specific step version */
export type Instacart_Waves_V1_GetStepVersionRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the requested step version */
export type Instacart_Waves_V1_GetStepVersionResponse = {
  __typename?: 'instacart_waves_v1_GetStepVersionResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  step_version?: Maybe<Instacart_Waves_V1_StepVersion>;
};

/** Request for GetWorkflowRun endpoint */
export type Instacart_Waves_V1_GetWorkflowRunRequest_Input = {
  workflow_run_id?: InputMaybe<Scalars['String']>;
};

/** Response for GetWorkflowRun endpoint */
export type Instacart_Waves_V1_GetWorkflowRunResponse = {
  __typename?: 'instacart_waves_v1_GetWorkflowRunResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  step_run_details?: Maybe<Array<Maybe<Instacart_Waves_V1_StepRunDetail>>>;
  workflow_status?: Maybe<Scalars['String']>;
};

/** Request to invalidate deduplication for tasks */
export type Instacart_Waves_V1_InvalidateDeduplicationRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<Scalars['String']>;
  created_why?: InputMaybe<Scalars['String']>;
  workflow_run_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing the result of invalidating deduplication for tasks. */
export type Instacart_Waves_V1_InvalidateDeduplicationResponse = {
  __typename?: 'instacart_waves_v1_InvalidateDeduplicationResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  tasks_updated?: Maybe<Scalars['BigInt']>;
};

/**
 * Response: distinct tag_name values, sorted ascending.
 * Use ListStepFilterTags(step_id) to fetch full StepFilterTag rows for a specific step.
 */
export type Instacart_Waves_V1_ListAllStepFilterTagsResponse = {
  __typename?: 'instacart_waves_v1_ListAllStepFilterTagsResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  tag_names?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Request to list step filter tags for a given step */
export type Instacart_Waves_V1_ListStepFilterTagsRequest_Input = {
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing list of step filter tags */
export type Instacart_Waves_V1_ListStepFilterTagsResponse = {
  __typename?: 'instacart_waves_v1_ListStepFilterTagsResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  tags?: Maybe<Array<Maybe<Instacart_Waves_V1_StepFilterTag>>>;
};

/** Request to list step runs with pagination */
export type Instacart_Waves_V1_ListStepRunsRequest_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  step_version_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing step runs with pagination info */
export type Instacart_Waves_V1_ListStepRunsResponse = {
  __typename?: 'instacart_waves_v1_ListStepRunsResponse';
  current_page?: Maybe<Scalars['BigInt']>;
  message?: Maybe<Scalars['String']>;
  page_count?: Maybe<Scalars['BigInt']>;
  status_code?: Maybe<Scalars['Int']>;
  step_runs?: Maybe<Array<Maybe<Instacart_Waves_V1_StepRun>>>;
};

/** Request to list step versions with filters */
export type Instacart_Waves_V1_ListStepVersionsRequest_Input = {
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  step_type?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['BigInt']>;
};

/** Response containing filtered step versions */
export type Instacart_Waves_V1_ListStepVersionsResponse = {
  __typename?: 'instacart_waves_v1_ListStepVersionsResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  step_versions?: Maybe<Array<Maybe<Instacart_Waves_V1_StepVersion>>>;
};

/** Request to list steps */
export type Instacart_Waves_V1_ListStepsRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  enable_schedule?: InputMaybe<Scalars['Boolean']>;
  /**
   * When true and author_ipp_uuid is set, only return steps the caller has Sesame edit access to.
   * Ignored (no filtering) when false, unset, or author_ipp_uuid is absent.
   */
  filter_by_edit_access?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['BigInt']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  /**
   * Filter steps whose stable `metadata.sentinel.entities` contains an entity
   * matching this value (exact id, or case-insensitive name substring).
   * Type-agnostic: sentinel entities are not necessarily managed attributes.
   */
  sentinel_entity?: InputMaybe<Scalars['String']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  step_filter_tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  step_type?: InputMaybe<Scalars['String']>;
};

/** Response containing list of steps */
export type Instacart_Waves_V1_ListStepsResponse = {
  __typename?: 'instacart_waves_v1_ListStepsResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  steps?: Maybe<Array<Maybe<Instacart_Waves_V1_Step>>>;
  total_result_count?: Maybe<Scalars['BigInt']>;
};

/** Request for ListWorkflowRuns endpoint */
export type Instacart_Waves_V1_ListWorkflowRunsRequest_Input = {
  page?: InputMaybe<Scalars['BigInt']>;
  page_size?: InputMaybe<Scalars['BigInt']>;
  pipeline_step_version_id?: InputMaybe<Scalars['String']>;
};

/** Response for ListWorkflowRuns endpoint */
export type Instacart_Waves_V1_ListWorkflowRunsResponse = {
  __typename?: 'instacart_waves_v1_ListWorkflowRunsResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  workflow_run_ids?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
};

/** Pipeline-level alert configuration; one row per PIPELINE-type step. */
export type Instacart_Waves_V1_PipelineAlertConfig = {
  __typename?: 'instacart_waves_v1_PipelineAlertConfig';
  /** Effective minimum 15 minutes. */
  alert_threshold_max_duration?: Maybe<Scalars['BigInt']>;
  /** Alert if no run started in N minutes (started_at, not completed_at). */
  alert_threshold_minutes_between_runs?: Maybe<Scalars['BigInt']>;
  created_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['String']>;
  datadog_downtime_ids?: Maybe<Array<Maybe<Scalars['BigInt']>>>;
  datadog_duration_monitor_id?: Maybe<Scalars['BigInt']>;
  datadog_frequency_monitor_id?: Maybe<Scalars['BigInt']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['BigInt']>;
  priority?: Maybe<Instacart_Waves_V1_AlertPriority>;
  step_id?: Maybe<Scalars['BigInt']>;
  /** Server-managed; ignored on writes. */
  tombstoned?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

/**
 * A single result cell, stringified. `value` is unset for a SQL NULL, which
 * keeps NULL distinct from an empty string.
 */
export type Instacart_Waves_V1_PreviewSnowflakeQueryCell = {
  __typename?: 'instacart_waves_v1_PreviewSnowflakeQueryCell';
  value?: Maybe<Scalars['String']>;
};

/** Request for a bounded preview of the rows a SELECT query returns. */
export type Instacart_Waves_V1_PreviewSnowflakeQueryRequest_Input = {
  /**
   * Maximum number of rows to return. Unset applies the service default; the
   * service may cap this to a maximum.
   */
  limit?: InputMaybe<Scalars['Int']>;
  /** A self-contained SELECT statement to execute. */
  query?: InputMaybe<Scalars['String']>;
};

/**
 * Result of a preview query. `columns` is ordered and matches the query's
 * projection order, even when no rows are returned. Each row contains exactly
 * one cell per column, aligned positionally to `columns`.
 */
export type Instacart_Waves_V1_PreviewSnowflakeQueryResponse = {
  __typename?: 'instacart_waves_v1_PreviewSnowflakeQueryResponse';
  columns?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
  rows?: Maybe<Array<Maybe<Instacart_Waves_V1_PreviewSnowflakeQueryRow>>>;
  status_code?: Maybe<Scalars['Int']>;
};

/**
 * A single result row: one cell per column, aligned positionally to
 * PreviewSnowflakeQueryResponse.columns.
 */
export type Instacart_Waves_V1_PreviewSnowflakeQueryRow = {
  __typename?: 'instacart_waves_v1_PreviewSnowflakeQueryRow';
  cells?: Maybe<Array<Maybe<Instacart_Waves_V1_PreviewSnowflakeQueryCell>>>;
};

/**
 * Lifecycle state of an async step preview.
 * Note on spelling: CANCELLED (UK) matches the persisted DB value
 * written by the backend reaper/cancel path; the Temporal SDK uses
 * the US spelling CANCELED, which the backend maps onto CANCELLED.
 */
export enum Instacart_Waves_V1_PreviewState {
  PreviewStateCancelled = 'PREVIEW_STATE_CANCELLED',
  PreviewStateCompleted = 'PREVIEW_STATE_COMPLETED',
  PreviewStateFailed = 'PREVIEW_STATE_FAILED',
  PreviewStateInProgress = 'PREVIEW_STATE_IN_PROGRESS',
  PreviewStateUnknown = 'PREVIEW_STATE_UNKNOWN'
}

/** Request to run a CAMP step version */
export type Instacart_Waves_V1_RunCampStepVersionRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  /** required */
  created_by?: InputMaybe<Scalars['String']>;
  input_s3_file?: InputMaybe<Scalars['String']>;
  is_test?: InputMaybe<Scalars['Boolean']>;
  /** required */
  step_version_id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Optional inline inputs for a manual test run. When is_test=true and more
   * than 100 entries are supplied, the service truncates to the first 100 and
   * returns a warning_message on the response.
   */
  test_inputs?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

/** Response after starting a CAMP step version run */
export type Instacart_Waves_V1_RunCampStepVersionResponse = {
  __typename?: 'instacart_waves_v1_RunCampStepVersionResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  warning_message?: Maybe<Scalars['String']>;
  workflow_run_id?: Maybe<Scalars['String']>;
};

/** Interval-based schedule specification for regular recurring executions. */
export type Instacart_Waves_V1_ScheduleIntervalSpec_Input = {
  every?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['String']>;
};

/** Schedule specification defining when and how often a workflow should run. */
export type Instacart_Waves_V1_ScheduleSpec_Input = {
  cron_expressions?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Instacart_Waves_V1_ScheduleIntervalSpec_Input>;
};

/**
 * Request for the totem_system typeahead picker on the pipeline-create form.
 * Substring-matches `query` against System name + display_name (case-insensitive)
 * across all Totem Systems. `limit` caps the response (server cap: 50).
 */
export type Instacart_Waves_V1_SearchTotemSystemsRequest_Input = {
  limit?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
};

/** Response for SearchTotemSystems — top-N matches. */
export type Instacart_Waves_V1_SearchTotemSystemsResponse = {
  __typename?: 'instacart_waves_v1_SearchTotemSystemsResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  systems?: Maybe<Array<Maybe<Instacart_Waves_V1_TotemSystemSummary>>>;
};

/** Schema information for a single Snowflake table column */
export type Instacart_Waves_V1_SnowflakeColumn = {
  __typename?: 'instacart_waves_v1_SnowflakeColumn';
  check?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  default?: Maybe<Scalars['String']>;
  expression?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nullable?: Maybe<Scalars['Boolean']>;
  policy_name?: Maybe<Scalars['String']>;
  primary_key?: Maybe<Scalars['Boolean']>;
  privacy_domain?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unique_key?: Maybe<Scalars['Boolean']>;
};

/** Representation of Step Object */
export type Instacart_Waves_V1_Step = {
  __typename?: 'instacart_waves_v1_Step';
  /**
   * Server-populated by ListSteps from get_active_version(step_id).step_attributes.
   * Generic surface for top-level metadata keys (totem_system, ai_gateway_source_id,
   * enable_schedule, etc.). Ignored on writes — versions are mutated through
   * CreateNewStepVersion's `attributes` Struct.
   */
  active_version_step_attributes?: Maybe<Scalars['JSON']>;
  /** Server-computed by ListSteps; ignored on writes. */
  can_caller_edit?: Maybe<Scalars['Boolean']>;
  /** required */
  description?: Maybe<Scalars['String']>;
  filter_tags?: Maybe<Array<Maybe<Instacart_Waves_V1_StepFilterTag>>>;
  id?: Maybe<Scalars['BigInt']>;
  /**
   * Single-key carve-out from active version's step_attributes. Superseded by
   * `active_version_step_attributes` (field 13). Readers should migrate to
   * `active_version_step_attributes['enable_schedule']`. Field number retained
   * for wire-compat; removal tracked in CAT-65515.
   */
  latest_step_version_enable_schedule?: Maybe<Scalars['Boolean']>;
  /** required */
  name?: Maybe<Scalars['String']>;
  /** required */
  owner?: Maybe<Scalars['String']>;
  sesame_edit_action_id?: Maybe<Scalars['BigInt']>;
  sesame_view_action_id?: Maybe<Scalars['BigInt']>;
  /** required */
  step_category?: Maybe<Instacart_Waves_V1_StepCategory>;
  tombstoned?: Maybe<Scalars['Boolean']>;
  /** required */
  type?: Maybe<Scalars['String']>;
};

/** Per-child-step thresholds inside a pipeline alert config. */
export type Instacart_Waves_V1_StepAlertThreshold = {
  __typename?: 'instacart_waves_v1_StepAlertThreshold';
  alert_threshold_max_runtime_seconds?: Maybe<Scalars['BigInt']>;
  alert_threshold_min_task_count?: Maybe<Scalars['BigInt']>;
  /** Range [0.0, 1.0]. */
  alert_threshold_task_error_rate?: Maybe<Scalars['Float']>;
  datadog_error_rate_monitor_id?: Maybe<Scalars['BigInt']>;
  datadog_step_duration_monitor_id?: Maybe<Scalars['BigInt']>;
  /** Server-managed; ignored on writes. */
  datadog_task_count_monitor_id?: Maybe<Scalars['BigInt']>;
  step_id?: Maybe<Scalars['BigInt']>;
};

/** Category of a step */
export enum Instacart_Waves_V1_StepCategory {
  StepCategoryApiService = 'STEP_CATEGORY_API_SERVICE',
  StepCategoryAudit = 'STEP_CATEGORY_AUDIT',
  StepCategoryDecorator = 'STEP_CATEGORY_DECORATOR',
  StepCategoryExtractionModel = 'STEP_CATEGORY_EXTRACTION_MODEL',
  StepCategoryInput = 'STEP_CATEGORY_INPUT',
  StepCategoryNormalization = 'STEP_CATEGORY_NORMALIZATION',
  StepCategoryPipeline = 'STEP_CATEGORY_PIPELINE',
  StepCategoryPublish = 'STEP_CATEGORY_PUBLISH',
  StepCategoryUnknown = 'STEP_CATEGORY_UNKNOWN',
  StepCategoryValidation = 'STEP_CATEGORY_VALIDATION'
}

/** Represents a single step filter tag */
export type Instacart_Waves_V1_StepFilterTag = {
  __typename?: 'instacart_waves_v1_StepFilterTag';
  created_at?: Maybe<Scalars['String']>;
  filter_metadata?: Maybe<Scalars['JSON']>;
  step_id?: Maybe<Scalars['BigInt']>;
  tag_name?: Maybe<Scalars['String']>;
  tag_value?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

/** Represents a single step filter tag */
export type Instacart_Waves_V1_StepFilterTag_Input = {
  created_at?: InputMaybe<Scalars['String']>;
  filter_metadata?: InputMaybe<Scalars['JSON']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tag_name?: InputMaybe<Scalars['String']>;
  tag_value?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['String']>;
};

/** Representation of a step run */
export type Instacart_Waves_V1_StepRun = {
  __typename?: 'instacart_waves_v1_StepRun';
  /**
   * Child steps currently in progress inside this pipeline run.
   * Populated only for pipeline rows with state=in_progress; empty otherwise.
   */
  active_steps?: Maybe<Array<Maybe<Instacart_Waves_V1_ActiveStep>>>;
  created_at?: Maybe<Scalars['DateTime']>;
  dashboard_url?: Maybe<Scalars['String']>;
  failed_reasons?: Maybe<Scalars['String']>;
  failed_task_count?: Maybe<Scalars['BigInt']>;
  id?: Maybe<Scalars['BigInt']>;
  pipeline_id?: Maybe<Scalars['BigInt']>;
  pipeline_name?: Maybe<Scalars['String']>;
  product_count?: Maybe<Scalars['BigInt']>;
  requester?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  state_message?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['BigInt']>;
  workflow_run_id?: Maybe<Scalars['BigInt']>;
};

/** Representation of the details in a step run. */
export type Instacart_Waves_V1_StepRunDetail = {
  __typename?: 'instacart_waves_v1_StepRunDetail';
  inputs?: Maybe<Array<Maybe<Scalars['String']>>>;
  outputs?: Maybe<Array<Maybe<Scalars['String']>>>;
  pipeline_step_id?: Maybe<Scalars['String']>;
  run_metadata?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  step_id?: Maybe<Scalars['BigInt']>;
  step_run_id?: Maybe<Scalars['BigInt']>;
};

/**
 * Errors grouped by the step they belong to. One entry per offending step.
 * When the validated step contains nested children (e.g. a Pipeline),
 * each child step with errors gets its own entry. The entry with an
 * empty step_id, if present, holds errors on the top-level step's own
 * attributes (or, for non-container step types, all errors).
 */
export type Instacart_Waves_V1_StepValidationErrors = {
  __typename?: 'instacart_waves_v1_StepValidationErrors';
  /**
   * Errors within this step. Paths are relative to the step's own
   * attributes, not the top-level validation payload.
   */
  errors?: Maybe<Array<Maybe<Instacart_Waves_V1_ValidationError>>>;
  /**
   * Stable identifier of the step these errors belong to. For nested
   * children of a container step, this is the child's stable id (e.g.
   * Pipeline.steps[].pipelineStepId). Empty when the errors belong to
   * the top-level step itself rather than a nested child.
   */
  step_id?: Maybe<Scalars['String']>;
  /**
   * Type of the step these errors belong to (e.g. "control", "task",
   * "Pipeline"). Lets consumers pick the right per-row renderer.
   */
  step_type?: Maybe<Scalars['String']>;
};

/** Representation of a step version */
export type Instacart_Waves_V1_StepVersion = {
  __typename?: 'instacart_waves_v1_StepVersion';
  attributes?: Maybe<Scalars['JSON']>;
  created_at?: Maybe<Scalars['DateTime']>;
  created_by?: Maybe<Scalars['String']>;
  created_why?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['BigInt']>;
  /** Input field names observed across completed workflow runs. */
  inputs?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Output field names observed across completed workflow runs. */
  outputs?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  step?: Maybe<Instacart_Waves_V1_Step>;
  step_id?: Maybe<Scalars['BigInt']>;
  tombstoned?: Maybe<Scalars['Boolean']>;
  version?: Maybe<Scalars['BigInt']>;
};

/** Representation of Step Object */
export type Instacart_Waves_V1_Step_Input = {
  /**
   * Server-populated by ListSteps from get_active_version(step_id).step_attributes.
   * Generic surface for top-level metadata keys (totem_system, ai_gateway_source_id,
   * enable_schedule, etc.). Ignored on writes — versions are mutated through
   * CreateNewStepVersion's `attributes` Struct.
   */
  active_version_step_attributes?: InputMaybe<Scalars['JSON']>;
  /** Server-computed by ListSteps; ignored on writes. */
  can_caller_edit?: InputMaybe<Scalars['Boolean']>;
  /** required */
  description?: InputMaybe<Scalars['String']>;
  filter_tags?: InputMaybe<Array<InputMaybe<Instacart_Waves_V1_StepFilterTag_Input>>>;
  id?: InputMaybe<Scalars['BigInt']>;
  /**
   * Single-key carve-out from active version's step_attributes. Superseded by
   * `active_version_step_attributes` (field 13). Readers should migrate to
   * `active_version_step_attributes['enable_schedule']`. Field number retained
   * for wire-compat; removal tracked in CAT-65515.
   */
  latest_step_version_enable_schedule?: InputMaybe<Scalars['Boolean']>;
  /** required */
  name?: InputMaybe<Scalars['String']>;
  /** required */
  owner?: InputMaybe<Scalars['String']>;
  sesame_edit_action_id?: InputMaybe<Scalars['BigInt']>;
  sesame_view_action_id?: InputMaybe<Scalars['BigInt']>;
  /** required */
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  tombstoned?: InputMaybe<Scalars['Boolean']>;
  /** required */
  type?: InputMaybe<Scalars['String']>;
};

/** Request to soft delete a step */
export type Instacart_Waves_V1_TombstoneStepRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
  tombstoned_by?: InputMaybe<Scalars['String']>;
};

/** Response to soft delete a step */
export type Instacart_Waves_V1_TombstoneStepResponse = {
  __typename?: 'instacart_waves_v1_TombstoneStepResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to soft delete a single step version */
export type Instacart_Waves_V1_TombstoneStepVersionRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  step_version_id?: InputMaybe<Scalars['BigInt']>;
  tombstoned_by?: InputMaybe<Scalars['String']>;
};

/** Response to soft delete a single step version */
export type Instacart_Waves_V1_TombstoneStepVersionResponse = {
  __typename?: 'instacart_waves_v1_TombstoneStepVersionResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/**
 * Compact summary of a Totem System for the typeahead picker.
 * `name` is the Totem slug (what gets persisted in step_attributes.totem_system).
 * `display_name` is the human label rendered in the dropdown.
 */
export type Instacart_Waves_V1_TotemSystemSummary = {
  __typename?: 'instacart_waves_v1_TotemSystemSummary';
  display_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

/** Request to partially update a pipeline alert config. */
export type Instacart_Waves_V1_UpdatePipelineAlertConfigRequest_Input = {
  alert_threshold_max_duration?: InputMaybe<Scalars['BigInt']>;
  alert_threshold_minutes_between_runs?: InputMaybe<Scalars['BigInt']>;
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  priority?: InputMaybe<Instacart_Waves_V1_AlertPriority>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after updating a pipeline alert config. */
export type Instacart_Waves_V1_UpdatePipelineAlertConfigResponse = {
  __typename?: 'instacart_waves_v1_UpdatePipelineAlertConfigResponse';
  config?: Maybe<Instacart_Waves_V1_PipelineAlertConfig>;
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to update a step's owner and/or description. */
export type Instacart_Waves_V1_UpdateStepRequest_Input = {
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  /**
   * Generic step-level metadata (stable, version-independent). Pipeline managed-
   * attribute identity is nested under the `sentinel` key:
   * { sentinel: { entities: [{ type, id, name }] } }. Written only for non-LLM steps.
   */
  metadata?: InputMaybe<Scalars['JSON']>;
  owner?: InputMaybe<Scalars['String']>;
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after updating a step */
export type Instacart_Waves_V1_UpdateStepResponse = {
  __typename?: 'instacart_waves_v1_UpdateStepResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
};

/** Request to upsert a per-step threshold inside a pipeline alert config. */
export type Instacart_Waves_V1_UpsertStepAlertThresholdRequest_Input = {
  alert_threshold_max_runtime_seconds?: InputMaybe<Scalars['BigInt']>;
  alert_threshold_min_task_count?: InputMaybe<Scalars['BigInt']>;
  alert_threshold_task_error_rate?: InputMaybe<Scalars['Float']>;
  author_ipp_uuid?: InputMaybe<Scalars['String']>;
  /** Parent PIPELINE-type step that owns the alert config. */
  pipeline_step_id?: InputMaybe<Scalars['BigInt']>;
  /** Child step the threshold applies to. */
  step_id?: InputMaybe<Scalars['BigInt']>;
};

/** Response after upserting a step threshold. */
export type Instacart_Waves_V1_UpsertStepAlertThresholdResponse = {
  __typename?: 'instacart_waves_v1_UpsertStepAlertThresholdResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  threshold?: Maybe<Instacart_Waves_V1_StepAlertThreshold>;
};

/** Request to validate step attributes without persisting them. */
export type Instacart_Waves_V1_ValidateStepAttributesRequest_Input = {
  attributes?: InputMaybe<Scalars['JSON']>;
  step_category?: InputMaybe<Instacart_Waves_V1_StepCategory>;
  /**
   * Step type (e.g. "Pipeline", "LLMPromptTemplate"). Required: multiple
   * step types map to one step_category, so the validator can't pick the
   * right per-type ruleset from step_category alone.
   */
  step_type?: InputMaybe<Scalars['String']>;
};

/** Response from ValidateStepAttributes. */
export type Instacart_Waves_V1_ValidateStepAttributesResponse = {
  __typename?: 'instacart_waves_v1_ValidateStepAttributesResponse';
  message?: Maybe<Scalars['String']>;
  status_code?: Maybe<Scalars['Int']>;
  step_errors?: Maybe<Array<Maybe<Instacart_Waves_V1_StepValidationErrors>>>;
};

/**
 * A single structured validation error pointing at one field within a
 * step's attributes.
 */
export type Instacart_Waves_V1_ValidationError = {
  __typename?: 'instacart_waves_v1_ValidationError';
  /**
   * Stable machine-readable code. Examples: "UNSUPPORTED_FUNCTION",
   * "SYNTAX_ERROR", "ARITY_ERROR", "EMPTY_EXPRESSION", "MISSING_TITLE",
   * "INVALID_CRON".
   */
  code?: Maybe<Scalars['String']>;
  /** Optional code-specific details, e.g. {"function_name": "fundc"}. */
  details?: Maybe<Scalars['JSON']>;
  /** Human-readable explanation suitable for displaying inline. */
  message?: Maybe<Scalars['String']>;
  /**
   * Dotted path identifying the offending field, relative to the
   * enclosing step's attributes. Example: "nextStepsRule.expressions[0].expression".
   */
  path?: Maybe<Scalars['String']>;
};

/** Individual input item containing key-value data for workflow processing. */
export type Instacart_Waves_V1_WorkflowInputItem_Input = {
  data?: InputMaybe<Scalars['JSON']>;
};

/** Input parameters for WAVES workflow execution. */
export type Instacart_Waves_V1_WorkflowLoopInput_Input = {
  first_step_version_id?: InputMaybe<Scalars['BigInt']>;
  input?: InputMaybe<Array<InputMaybe<Instacart_Waves_V1_WorkflowInputItem_Input>>>;
  input_s3_file?: InputMaybe<Scalars['String']>;
  is_test?: InputMaybe<Scalars['Boolean']>;
  requester?: InputMaybe<Scalars['String']>;
};

export type AddFreeMonthSubscriptionMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
  requestContext: Instacart_Customers_Shared_V1_RequestContext_Input;
}>;


export type AddFreeMonthSubscriptionMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_AddFreeMonthSubscription?: { __typename?: 'instacart_care_tools_v1_AddFreeMonthSubscriptionResponse', membership?: { __typename?: 'instacart_care_tools_v1_InstacartPlusMembership', subscriptionId?: string, autorenew?: boolean, endsOn?: any } } };

export type AddOrUpdateFulfillmentOrderLineMutationVariables = Exact<{
  orderItemId: Scalars['BigInt'];
  orderDeliveryId: Scalars['BigInt'];
  markFound?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentOrderLineMarkFound_Input>;
  markNotFound?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentOrderLineMarkNotFound_Input>;
  actorType?: InputMaybe<Instacart_Care_Tools_V1_FulfillmentPickingActorType>;
  actorNote?: InputMaybe<Scalars['String']>;
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type AddOrUpdateFulfillmentOrderLineMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_AddOrUpdateFulfillmentOrderLine?: { __typename?: 'instacart_care_tools_v1_AddOrUpdateFulfillmentOrderLineResponse', orderItemId?: string } };

export type AdminCancelSubscriptionMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  subscriptionId: Scalars['BigInt'];
  adminId?: InputMaybe<Scalars['BigInt']>;
  hasElevatedRefundPermission?: InputMaybe<Scalars['Boolean']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
  requestContext: Instacart_Customers_Shared_V1_RequestContext_Input;
}>;


export type AdminCancelSubscriptionMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_AdminCancelSubscription?: { __typename?: 'instacart_care_tools_v1_AdminCancelSubscriptionResponse', wasRefunded?: boolean, membership?: { __typename?: 'instacart_care_tools_v1_InstacartPlusMembership', subscriptionId?: string, autorenew?: boolean, endsOn?: any, canceledAt?: any }, refundAmount?: { __typename?: 'GoogleTypeMoney', units?: string, nanos?: number, currencyCode?: string } } };

export type CheckAdminRefundEligibilityQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  subscriptionId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  requestContext: Instacart_Customers_Shared_V1_RequestContext_Input;
}>;


export type CheckAdminRefundEligibilityQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_CheckAdminRefundEligibility?: { __typename?: 'instacart_care_tools_v1_CheckAdminRefundEligibilityResponse', eligible?: boolean, ineligibilityReason?: Instacart_Care_Tools_V1_AdminRefundIneligibilityReason } };

export type CreateAddressForUserMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  streetAddress: Scalars['String'];
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  instructions?: InputMaybe<Scalars['String']>;
  skipValidation?: InputMaybe<Scalars['Boolean']>;
  requestContext: Instacart_Customers_Shared_V1_RequestContext_Input;
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type CreateAddressForUserMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_CreateAddressForUser?: { __typename?: 'instacart_care_tools_v1_CreateAddressForUserResponse', address?: { __typename?: 'instacart_care_tools_v1_AddressResponse', id?: string, streetAddress?: string, apartmentNumber?: string, city?: string, state?: string, postalCode?: string, zoneName?: string, regionName?: string, countryCode?: string } } };

export type CreateCustomerMiaIssueMutationVariables = Exact<{
  customerId: Scalars['BigInt'];
  orderId: Scalars['BigInt'];
  orderDeliveryId: Scalars['BigInt'];
  caseNumber: Scalars['String'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  uiOrigin?: InputMaybe<Instacart_Care_Tools_V1_UiOrigin>;
}>;


export type CreateCustomerMiaIssueMutation = { __typename?: 'Mutation', instacart_care_tools_v1_AppeasementsOrchestratorService_CreateCustomerMIAIssue?: { __typename?: 'instacart_care_tools_v1_CreateCustomerMIAIssueResponse', success?: { __typename?: 'instacart_care_tools_v1_CreateCustomerMIAIssueSuccess', orderIssueId?: string }, failure?: { __typename?: 'instacart_care_tools_v1_CreateCustomerMIAIssueFailure', errorMessage?: string } } };

export type CreateNoteForOrderMutationVariables = Exact<{
  orderId: Scalars['BigInt'];
  note: Scalars['String'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
}>;


export type CreateNoteForOrderMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_CreateNoteForOrder?: { __typename?: 'instacart_care_tools_v1_CreateNoteForOrderResponse', note?: { __typename?: 'instacart_care_tools_v1_Note', id?: string, note?: string, userId?: string, userType?: string, notableId?: string, notableType?: Instacart_Care_Tools_V1_Note_NotableType, createdAt?: any, updatedAt?: any, firstName?: string, lastName?: string } } };

export type CreateNoteForUserMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  note: Scalars['String'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
}>;


export type CreateNoteForUserMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_CreateNoteForUser?: { __typename?: 'instacart_care_tools_v1_CreateNoteForUserResponse', note?: { __typename?: 'instacart_care_tools_v1_Note', id?: string, note?: string, userId?: string, userType?: string, notableId?: string, notableType?: Instacart_Care_Tools_V1_Note_NotableType, createdAt?: any, updatedAt?: any, firstName?: string, lastName?: string } } };

export type CreateOrderReturnMutationVariables = Exact<{
  orderDeliveryId: Scalars['BigInt'];
  returnRequesterType: Instacart_Care_Tools_V1_ReturnRequesterType;
  returnReasonCode: Instacart_Care_Tools_V1_ReturnReasonCode;
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type CreateOrderReturnMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_CreateOrderReturn?: { __typename?: 'instacart_care_tools_v1_CreateOrderReturnResponse', returnId?: string } };

export type CreateUserShopperBanMutationVariables = Exact<{
  shopperId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
  appliesTo: Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType;
  userShopperBanReasonId: Scalars['BigInt'];
  reason?: InputMaybe<Scalars['String']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type CreateUserShopperBanMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_CreateUserShopperBan?: { __typename?: 'instacart_care_tools_v1_CreateUserShopperBanResponse', userShopperBan?: { __typename?: 'instacart_fulfillment_user_shopper_ban_v1_UserShopperBan', id?: string, shopperId?: string, userId?: string, appliesTo?: Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType } } };

export type DeleteUserShopperBanMutationVariables = Exact<{
  id: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type DeleteUserShopperBanMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_DeleteUserShopperBan?: any };

export type FindRelatedUsersQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type FindRelatedUsersQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_FindRelatedUsers?: { __typename?: 'instacart_care_tools_v1_FindRelatedUsersResponse', users?: Array<{ __typename?: 'instacart_care_tools_v1_RelatedUser', id?: string, firstName?: string, lastName?: string, email?: string, phone?: string, matchTypes?: Array<Instacart_Care_Tools_V1_MatchType>, accountType?: Instacart_Care_Tools_V1_RelatedUser_AccountType, createdAt?: any }> } };

export type FindUsersQueryVariables = Exact<{
  query: Scalars['String'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type FindUsersQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_FindUsers?: { __typename?: 'instacart_care_tools_v1_FindUsersResponse', users?: Array<{ __typename?: 'instacart_care_tools_v1_UserSearchResult', id?: string, firstName?: string, lastName?: string, email?: string, phone?: string, isolationContext?: { __typename?: 'instacart_care_tools_v1_IsolationContext', id?: string, name?: string } }>, pageInfo?: { __typename?: 'InstacartCustomersSharedV1PageInfo', endCursor?: string, hasNextPage?: boolean } } };

export type ForceCompleteOrderMutationVariables = Exact<{
  orderDeliveryId: Scalars['BigInt'];
  reason: Instacart_Care_Tools_V1_ForceCompleteOrderReason;
  description?: InputMaybe<Scalars['String']>;
  ippAccountId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type ForceCompleteOrderMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_ForceCompleteOrder?: any };

export type GetActiveBenefitsQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
}>;


export type GetActiveBenefitsQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetActiveBenefits?: { __typename?: 'instacart_care_tools_v1_GetActiveBenefitsResponse', benefits?: Array<string> } };

export type GetCustomerSpendingSummaryQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  countryId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type GetCustomerSpendingSummaryQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummary?: { __typename?: 'instacart_care_tools_v1_GetCustomerSpendingSummaryResponse', currencyCode?: string, totalSpend?: number, totalOrders?: string, avgBasketSize?: number, creditAvailable?: number, lifetimeCredits?: number, creditSpendPct?: number, creditRefundPct?: number } };

export type GetCustomerSpendingSummaryV2QueryVariables = Exact<{
  userId: Scalars['BigInt'];
}>;


export type GetCustomerSpendingSummaryV2Query = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummaryV2?: { __typename?: 'instacart_care_tools_v1_GetCustomerSpendingSummaryV2Response', userMetrics?: { __typename?: 'instacart_care_tools_v1_CustomerSpendingMetrics', creditToSpendRatioPct?: number, totalOrderCount?: string, totalSpendUsd?: number, appeasementsUsd?: number, refundsUsd?: number }, combinedMetrics?: { __typename?: 'instacart_care_tools_v1_CustomerSpendingMetrics', creditToSpendRatioPct?: number, totalOrderCount?: string, totalSpendUsd?: number, appeasementsUsd?: number, refundsUsd?: number } } };

export type GetHouseholdByUserQueryVariables = Exact<{
  userId: Scalars['BigInt'];
}>;


export type GetHouseholdByUserQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetHouseholdByUser?: { __typename?: 'instacart_care_tools_v1_GetHouseholdByUserResponse', household?: { __typename?: 'instacart_care_tools_v1_Household', id?: string, ownerUserId?: string, householdMembers?: Array<{ __typename?: 'instacart_care_tools_v1_HouseholdUser', firstName?: string, id?: string, lastName?: string }> } } };

export type GetInstacartPlusMembershipQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
}>;


export type GetInstacartPlusMembershipQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetInstacartPlusMembership?: { __typename?: 'instacart_care_tools_v1_GetInstacartPlusMembershipResponse', memberships?: Array<{ __typename?: 'instacart_care_tools_v1_InstacartPlusMembership', autorenew?: boolean, startsOn?: any, endsOn?: any, countryId?: string, subscriptionId?: string, canceledAt?: any, termLength?: string, renewalPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, discount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number } }> } };

export type GetLatestActiveAttributeForUserQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type GetLatestActiveAttributeForUserQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetLatestActiveAttributeForUser?: { __typename?: 'instacart_care_tools_v1_GetLatestActiveAttributeForUserResponse', activeAttribute?: { __typename?: 'instacart_care_tools_v1_LatestActiveAttributeForUser', userId?: string, storeConfigurationId?: string, oauthApplicationId?: string, countryId?: string, addressId?: string, retailerId?: string, timeZoneName?: string, locale?: string } } };

export type GetLifetimeSavingsForUserQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
}>;


export type GetLifetimeSavingsForUserQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetLifetimeSavingsForUser?: { __typename?: 'instacart_care_tools_v1_GetLifetimeSavingsForUserResponse', totalSavings?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number } } };

export type RetailerLocationFieldsFragment = { __typename?: 'instacart_customers_partners_v1_RetailerLocation', id?: string, name?: string, retailerId?: string, streetAddress?: string, city?: string, state?: string, postalCode?: string, timeZone?: string };

export type OrderItemFieldsFragment = { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } };

export type OrderLineFieldsFragment = { __typename?: 'instacart_care_tools_v1_OrderLine', replacementPolicy?: Instacart_Care_Tools_V1_OrderLine_ReplacementPolicy, status?: Instacart_Care_Tools_V1_OrderLine_Status, substitutionStatus?: Instacart_Care_Tools_V1_OrderLine_SubstitutionStatus, creationDate?: any, addedByDriverId?: string, specialInstructions?: string, orderItemId?: string, pickedQuantityEach?: string, refundQuantityEach?: string, productType?: Instacart_Care_Tools_V1_OrderLine_ProductType, item?: { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } }, substitute?: { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } }, customerSelectedReplacement?: { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } }, orderedQuantity?: { __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }, pickedQuantity?: { __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }, refundQuantity?: { __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }, customerPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, customerOrderedPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, fullPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, refundableQuantities?: Array<{ __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }> };

export type GetOrderQueryVariables = Exact<{
  orderReference: Scalars['String'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type GetOrderQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetOrder?: { __typename?: 'instacart_care_tools_v1_GetOrderResponse', order?: { __typename?: 'instacart_care_tools_v1_Order', baggingOption?: Instacart_Customers_Commerce_Types_V1_BaggingOption, arrivedAtCustomerLocationAt?: any, batchAssignedAt?: any, certifiedDelivery?: boolean, clientConfigurationId?: string, communicationLocale?: string, confirmedAt?: any, creationClientIdentifier?: string, creationDate?: any, customerBagCount?: string, customerOrderNumber?: string, deliveredAt?: any, deliveryStartedAt?: any, deliveryStatus?: Instacart_Care_Tools_V1_DeliveryStatus, expressSubscriptionId?: string, finalizedAt?: any, fulfillmentType?: Instacart_Customers_Shared_V1_FulfillmentTypeWrapper_FulfillmentType, id?: string, lateEmailSent?: boolean, loyaltyNumber?: string, orderAhead?: boolean, orderDeliveryId?: string, orderReference?: string, plannedDeliveredAt?: any, plannedDeliveryStartedAt?: any, receiptSuppressionEnabled?: boolean, redelivery?: boolean, retailerReferenceId?: string, serviceOptionId?: string, serviceType?: Instacart_Customers_Shared_V1_ServiceType, storeConfigurationId?: string, sourceWebsite?: string, brandedName?: string, ratingLink?: string, receiptUrl?: string, checkoutRetailerLocation?: { __typename?: 'instacart_customers_partners_v1_RetailerLocation', id?: string, name?: string, retailerId?: string, streetAddress?: string, city?: string, state?: string, postalCode?: string, timeZone?: string }, closestRetailerLocation?: { __typename?: 'instacart_customers_partners_v1_RetailerLocation', id?: string, name?: string, retailerId?: string, streetAddress?: string, city?: string, state?: string, postalCode?: string, timeZone?: string }, fulfillmentWindow?: { __typename?: 'instacart_care_tools_v1_Order_OrderFulfillmentWindow', windowStart?: any, windowEnd?: any }, retailer?: { __typename?: 'instacart_customers_partners_v1_Retailer', id?: string, name?: string, slug?: string, logoImagePath?: string }, shoppedRetailerLocation?: { __typename?: 'instacart_customers_partners_v1_RetailerLocation', id?: string, name?: string, retailerId?: string, streetAddress?: string, city?: string, state?: string, postalCode?: string, timeZone?: string }, shopperSummary?: { __typename?: 'instacart_care_tools_v1_ShopperSummary', fullService?: boolean, currentShopperProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string }, driverProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string }, pickerProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string }, runnerProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string } }, batchIds?: { __typename?: 'instacart_care_tools_v1_Order_BatchIds', deliveringBatchIds?: Array<string>, drivingToStoreBatchIds?: Array<string>, shoppingBatchIds?: Array<string> }, user?: { __typename?: 'instacart_care_tools_v1_User', firstName?: string, lastName?: string, email?: string, phone?: string }, userBirthday?: { __typename?: 'google_type_Date', year?: number, month?: number, day?: number }, orderLines?: Array<{ __typename?: 'instacart_care_tools_v1_OrderLine', replacementPolicy?: Instacart_Care_Tools_V1_OrderLine_ReplacementPolicy, status?: Instacart_Care_Tools_V1_OrderLine_Status, substitutionStatus?: Instacart_Care_Tools_V1_OrderLine_SubstitutionStatus, creationDate?: any, addedByDriverId?: string, specialInstructions?: string, orderItemId?: string, pickedQuantityEach?: string, refundQuantityEach?: string, productType?: Instacart_Care_Tools_V1_OrderLine_ProductType, item?: { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } }, substitute?: { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } }, customerSelectedReplacement?: { __typename?: 'instacart_care_tools_v1_OrderItem', name?: string, imageUrl?: string, sizeDetails?: string, alcoholic?: boolean, restrictedOtc?: boolean, rx?: boolean, ebt?: boolean, unitPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, productCategory?: { __typename?: 'instacart_care_tools_v1_OrderItem_ProductCategory', productCategory?: string } }, orderedQuantity?: { __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }, pickedQuantity?: { __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }, refundQuantity?: { __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }, customerPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, customerOrderedPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, fullPrice?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, refundableQuantities?: Array<{ __typename?: 'instacart_types_v1_MeasuredQuantity', quantity?: number, unit?: { __typename?: 'instacart_types_v1_MeasurementUnit', unitCode?: string, costUnit?: Instacart_Types_V1_MeasurementUnit_CostUnit } }> }>, latestOrderChargeLines?: Array<{ __typename?: 'instacart_care_tools_v1_Order_OrderChargeLine', labelInEnglish?: string, amount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number } }>, creationOrderChargeLines?: Array<{ __typename?: 'instacart_care_tools_v1_Order_OrderChargeLine', labelInEnglish?: string, amount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number } }>, orderHandlingDetails?: { __typename?: 'instacart_care_tools_v1_OrderHandlingDetails', delivery?: { __typename?: 'instacart_care_tools_v1_OrderHandlingDetails_Delivery', addressType?: Instacart_Care_Tools_V1_OrderHandlingDetails_AddressType, doorCode?: string, dropoffLocation?: string, instructions?: string, notes?: string, address?: { __typename?: 'google_type_PostalAddress', addressLines?: Array<string>, locality?: string, administrativeArea?: string, postalCode?: string, regionCode?: string }, latLng?: { __typename?: 'google_type_LatLng', latitude?: number, longitude?: number } } }, orderStateChanges?: Array<{ __typename?: 'instacart_care_tools_v1_OrderStateChange', orderDeliveryEventId?: string, orderDeliveryId?: string, fromState?: string, toState?: string, trigger?: string, transitionedAt?: any }>, heavyPayInfo?: { __typename?: 'instacart_care_tools_v1_Order_HeavyPayInfo', orderHeavyPayLbs?: number, batchHeavyPayLbs?: number, shopperPaidForHeavyPay?: boolean }, country?: { __typename?: 'instacart_customers_partners_v1_Country', id?: string, name?: string }, zone?: { __typename?: 'instacart_customers_partners_v1_Zone', name?: string }, deliveryPhoto?: { __typename?: 'instacart_care_tools_v1_DeliveryPhoto', id?: string, url?: string } } } };

export type GetOrderByIdBasicQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type GetOrderByIdBasicQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetOrderByIdBasic?: { __typename?: 'instacart_care_tools_v1_GetOrderByIdBasicResponse', order?: { __typename?: 'instacart_care_tools_v1_OrderSummary', id?: string, confirmedAt?: any, retailerId?: string, userId?: string, userFullName?: string, fulfillmentDate?: any, serviceType?: Instacart_Customers_Shared_V1_ServiceType, deliveryStatus?: Instacart_Care_Tools_V1_DeliveryStatus } } };

export type GetOrderReturnQueryVariables = Exact<{
  orderDeliveryId: Scalars['BigInt'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type GetOrderReturnQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetOrderReturn?: { __typename?: 'instacart_care_tools_v1_GetOrderReturnResponse', returnBatchId?: string } };

export type GetOrderReturnEligibilityQueryVariables = Exact<{
  orderDeliveryId: Scalars['BigInt'];
  returnRequesterType: Instacart_Care_Tools_V1_ReturnRequesterType;
  returnReasonCode: Instacart_Care_Tools_V1_ReturnReasonCode;
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type GetOrderReturnEligibilityQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetOrderReturnEligibility?: { __typename?: 'instacart_care_tools_v1_GetOrderReturnEligibilityResponse', eligible?: boolean, items?: Array<{ __typename?: 'instacart_care_tools_v1_ReturnItem', itemAction?: string, orderItemId?: string }> } };

export type GetUserByIdQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type GetUserByIdQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetUser?: { __typename?: 'instacart_care_tools_v1_GetUserResponse', user?: { __typename?: 'instacart_care_tools_v1_User', active?: boolean, createdAt?: any, email?: string, firstName?: string, lastName?: string, phone?: string, isolationContext?: { __typename?: 'instacart_care_tools_v1_IsolationContext', id?: string, name?: string } } } };

export type IssueIcPlusFreeMonthMutationVariables = Exact<{
  customerId: Scalars['BigInt'];
  orderId: Scalars['BigInt'];
  orderDeliveryId: Scalars['BigInt'];
  caseNumber: Scalars['String'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  uiOrigin?: InputMaybe<Instacart_Care_Tools_V1_UiOrigin>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
  requestContext: Instacart_Customers_Shared_V1_RequestContext_Input;
}>;


export type IssueIcPlusFreeMonthMutation = { __typename?: 'Mutation', instacart_care_tools_v1_AppeasementsOrchestratorService_IssueIcPlusFreeMonth?: { __typename?: 'instacart_care_tools_v1_IssueIcPlusFreeMonthResponse', success?: { __typename?: 'instacart_care_tools_v1_IssueIcPlusFreeMonthSuccess', appeasementRequestId?: string, subscriptionId?: string }, failure?: { __typename?: 'instacart_care_tools_v1_IssueIcPlusFreeMonthFailure', errorMessage?: string } } };

export type LinkIsolatedUserMutationVariables = Exact<{
  isolatedUserId: Scalars['BigInt'];
  marketplaceUserId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type LinkIsolatedUserMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_LinkIsolatedUser?: { __typename?: 'instacart_care_tools_v1_LinkIsolatedUserResponse', success?: boolean } };

export type ListActiveAttributesByCountryQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type ListActiveAttributesByCountryQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListActiveAttributesByCountry?: { __typename?: 'instacart_care_tools_v1_ListActiveAttributesByCountryResponse', countries?: Array<{ __typename?: 'instacart_care_tools_v1_ActiveAttributesForCountry', countryId?: string, attributes?: Array<{ __typename?: 'instacart_care_tools_v1_UserAttribute', storeConfigurationId?: string, storeName?: string }> }> } };

export type ListAddressesForUserQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  limit?: InputMaybe<Scalars['Int']>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type ListAddressesForUserQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListAddressesForUser?: { __typename?: 'instacart_care_tools_v1_ListAddressesForUserResponse', nodes?: Array<{ __typename?: 'instacart_care_tools_v1_AddressResponse', id?: string, streetAddress?: string, apartmentNumber?: string, city?: string, state?: string, postalCode?: string, zoneName?: string, regionName?: string, countryCode?: string, businessName?: string }> } };

export type ListAdminMoveOrAddChargesPaymentInstrumentsQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
  orderDeliveryId?: InputMaybe<Scalars['BigInt']>;
}>;


export type ListAdminMoveOrAddChargesPaymentInstrumentsQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListAdminMoveOrAddChargesPaymentInstruments?: { __typename?: 'instacart_care_tools_v1_ListAdminMoveOrAddChargesPaymentInstrumentsResponse', paymentInstruments?: Array<{ __typename?: 'instacart_care_tools_v1_PaymentInstrument', id?: string, isCurrentOnOrder?: boolean, creditCard?: { __typename?: 'instacart_care_tools_v1_PaymentInstrument_CreditCard', creditCardType?: Instacart_Customers_Payments_V1_CreditCardType, suffix?: string }, debitCard?: { __typename?: 'instacart_care_tools_v1_PaymentInstrument_DebitCard', creditCardType?: Instacart_Customers_Payments_V1_CreditCardType, suffix?: string }, disableInfo?: { __typename?: 'instacart_customers_payments_v1_RenderableInstrument_InstrumentDisableInfo', disabledForAlcoholic?: boolean, disabledForCbdOrThc?: boolean, disabledForDeprecation?: boolean, disabledForEbt?: boolean, disabledForMaintenance?: boolean, disabledForMastercardScenario?: boolean, disabledForRx?: boolean } }> } };

export type ListBannersQueryVariables = Exact<{
  userId: Scalars['BigInt'];
}>;


export type ListBannersQuery = { __typename?: 'Query', instacart_care_tools_v1_BannersService_ListBanners?: { __typename?: 'instacart_care_tools_v1_ListBannersResponse', banners?: Array<{ __typename?: 'instacart_care_tools_v1_Banner', id?: string, severity?: Instacart_Care_Tools_V1_BannerSeverity, header?: string, message?: string, infoLink?: string, infoLinkText?: string }> } };

export type ListChargeLogsForOrderDeliveryQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  orderDeliveryId: Scalars['BigInt'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type ListChargeLogsForOrderDeliveryQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListChargeLogsForOrderDelivery?: { __typename?: 'instacart_care_tools_v1_ListChargeLogsForOrderDeliveryResponse', chargeLogs?: Array<{ __typename?: 'instacart_care_tools_v1_ChargeLog', id?: string, chargeType?: string, description?: string, authedAt?: any, createdAt?: any, captureAt?: any, capturedAt?: any, gatewayTransactionId?: string, paymentGateway?: string, authAmount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, captureAmount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, capturedAmount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, initialCapturableAmount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, instrumentDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail', instrumentReference?: string, creditCardDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CreditCardDetail', creditCardType?: Instacart_Customers_Payments_V1_CreditCardType, lastFour?: string }, ebtCardDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_EbtCardDetail', lastFour?: string }, paypalDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_PaypalDetail', email?: string }, venmoDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_VenmoDetail', username?: string }, cashAppDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_CashAppDetail', username?: string }, klarnaDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_KlarnaDetail', email?: string }, externalInstrumentDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_ExternalInstrumentDetail', lastFour?: string, customDisplayLabel?: string }, digitalWalletDetail?: { __typename?: 'instacart_customers_payments_v1_InstrumentDetail_DigitalWalletDetail', currencyCode?: string } } }> } };

export type ListCommonIdentityUsersQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type ListCommonIdentityUsersQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetCommonIdentityUsers?: { __typename?: 'instacart_care_tools_v1_GetCommonIdentityUsersResponse', users?: Array<{ __typename?: 'instacart_care_tools_v1_CommonIdentityUser', id?: string, active?: boolean, email?: string, phone?: string, firstName?: string, lastName?: string, createdAt?: any, isolationContext?: { __typename?: 'instacart_care_tools_v1_IsolationContext', id?: string, name?: string } }> } };

export type ListLinkedUserAccountsQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  includeDeactivatedAccounts?: InputMaybe<Scalars['Boolean']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type ListLinkedUserAccountsQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_GetLinkedUserAccounts?: { __typename?: 'instacart_care_tools_v1_GetLinkedUserAccountsResponse', linkedUserAccounts?: Array<{ __typename?: 'instacart_care_tools_v1_LinkedUserAccount', id?: string, active?: boolean, email?: string, phone?: string, firstName?: string, lastName?: string, accountType?: Instacart_Care_Tools_V1_LinkedUserAccount_AccountType, identityStrategy?: Instacart_Care_Tools_V1_LinkedUserAccount_IdentityStrategy }> } };

export type ListNotesForUserQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  limit?: InputMaybe<Scalars['Int']>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type ListNotesForUserQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListNotesForUser?: { __typename?: 'instacart_care_tools_v1_ListNotesForUserResponse', notes?: Array<{ __typename?: 'instacart_care_tools_v1_Note', id?: string, userId?: string, note?: string, createdAt?: any, updatedAt?: any, notableId?: string, notableType?: Instacart_Care_Tools_V1_Note_NotableType, userType?: string, firstName?: string, lastName?: string }> } };

export type ListOrderBannersQueryVariables = Exact<{
  orderReference: Scalars['String'];
  userId: Scalars['BigInt'];
}>;


export type ListOrderBannersQuery = { __typename?: 'Query', instacart_care_tools_v1_BannersService_ListBanners?: { __typename?: 'instacart_care_tools_v1_ListBannersResponse', banners?: Array<{ __typename?: 'instacart_care_tools_v1_Banner', id?: string, severity?: Instacart_Care_Tools_V1_BannerSeverity, header?: string, message?: string, infoLink?: string, infoLinkText?: string }> } };

export type ListOrderChatMessagesAndNotesQueryVariables = Exact<{
  orderId: Scalars['BigInt'];
  userId: Scalars['BigInt'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
  adminAuditContext?: InputMaybe<Instacart_Care_Tools_V1_AdminAuditContext_Input>;
}>;


export type ListOrderChatMessagesAndNotesQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListOrderChatMessagesAndNotes?: { __typename?: 'instacart_care_tools_v1_ListOrderChatMessagesAndNotesResponse', chatMessages?: Array<{ __typename?: 'instacart_care_tools_v1_ChatMessage', id?: string, body?: string, createdAt?: any, image?: string, orderDeliveryId?: string, read?: boolean, readAt?: any, recipientId?: string, recipientType?: string, senderId?: string, senderType?: string }>, notes?: Array<{ __typename?: 'instacart_care_tools_v1_Note', id?: string, note?: string, userId?: string, userType?: string, notableId?: string, notableType?: Instacart_Care_Tools_V1_Note_NotableType, createdAt?: any, updatedAt?: any, firstName?: string, lastName?: string }> } };

export type ListOrderResolutionsAndAppeasementsQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  orderId: Scalars['BigInt'];
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
}>;


export type ListOrderResolutionsAndAppeasementsQuery = { __typename?: 'Query', instacart_care_tools_v1_AppeasementsService_ListOrderResolutionsAndAppeasements?: { __typename?: 'instacart_care_tools_v1_ListOrderResolutionsAndAppeasementsResponse', resolutionsAndAppeasements?: Array<{ __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement', createdAt?: any, valueType?: Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_ValueType, fulfillmentStatus?: Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_FulfillmentStatus, requester?: { __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement_Requester', requesterType?: Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Requester_RequesterType, requesterName?: string }, ticket?: { __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement_Ticket', ticketId?: string, ticketType?: Instacart_Care_Tools_V1_OrderResolutionAndAppeasement_Ticket_TicketType, caseUrl?: string }, value?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number }, orderIssues?: Array<{ __typename?: 'instacart_care_tools_v1_OrderResolutionAndAppeasement_OrderIssueInfo', orderIssueId?: string, isItemLevel?: boolean, issueTypeCategory?: Instacart_Customers_Order_Issues_V1_OrderIssueTypeCategory, issueTypeName?: string }> }>, totalIssued?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, units?: string, nanos?: number } } };

export type ShopperProfileFieldsFragment = { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string, avatarUrl?: string, mapIconUrl?: string, startDate?: { __typename?: 'google_type_Date', year?: number, month?: number, day?: number } };

export type ListOrdersByCustomerQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  pagination?: InputMaybe<InstacartCustomersSharedV1PaginationInput>;
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
  orderId?: InputMaybe<Scalars['BigInt']>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  includeCustomerName?: InputMaybe<Scalars['Boolean']>;
  includeRetailerName?: InputMaybe<Scalars['Boolean']>;
  includeRetailerLocationName?: InputMaybe<Scalars['Boolean']>;
  includeShopperSummary?: InputMaybe<Scalars['Boolean']>;
  includeBatchId?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListOrdersByCustomerQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListOrdersByCustomer?: { __typename?: 'instacart_care_tools_v1_ListOrdersByCustomerResponse', orders?: Array<{ __typename?: 'instacart_care_tools_v1_OrderSummary', orderDeliveryId?: string, id?: string, orderReference?: string, confirmedAt?: any, fulfillmentDate?: any, serviceType?: Instacart_Customers_Shared_V1_ServiceType, userId?: string, userFullName?: string, retailerId?: string, retailerName?: string, retailerLocationId?: string, retailerLocationName?: string, deliveryStatus?: Instacart_Care_Tools_V1_DeliveryStatus, marketplaceOrder?: boolean, expressSubscriptionId?: string, batchId?: string, customerOrderNumber?: string, shopperSummary?: { __typename?: 'instacart_care_tools_v1_ShopperSummary', fullService?: boolean, pickerProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string, avatarUrl?: string, mapIconUrl?: string, startDate?: { __typename?: 'google_type_Date', year?: number, month?: number, day?: number } }, driverProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string, avatarUrl?: string, mapIconUrl?: string, startDate?: { __typename?: 'google_type_Date', year?: number, month?: number, day?: number } }, runnerProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string, avatarUrl?: string, mapIconUrl?: string, startDate?: { __typename?: 'google_type_Date', year?: number, month?: number, day?: number } }, currentShopperProfile?: { __typename?: 'instacart_care_tools_v1_ShopperSummary_ShopperProfile', id?: string, name?: string, firstName?: string, avatarUrl?: string, mapIconUrl?: string, startDate?: { __typename?: 'google_type_Date', year?: number, month?: number, day?: number } } }, totalAmount?: { __typename?: 'GoogleTypeMoney', currencyCode?: string, nanos?: number, units?: string } }>, pageInfo?: { __typename?: 'InstacartCustomersSharedV1PageInfo', endCursor?: string, hasNextPage?: boolean } } };

export type ListRecentRestaurantOrdersForUserQueryVariables = Exact<{
  userId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  limit?: InputMaybe<Scalars['BigInt']>;
}>;


export type ListRecentRestaurantOrdersForUserQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListRestaurantOrdersByCustomer?: { __typename?: 'instacart_care_tools_v1_ListRestaurantOrdersByCustomerResponse', restaurantOrders?: Array<{ __typename?: 'instacart_care_tools_v1_RestaurantOrder', id?: string, status?: string, createdAt?: any, externalOrderId?: string, restaurantName?: string, serviceType?: Instacart_Customers_Shared_V1_ServiceType, eta?: any }> } };

export type ListUserShopperBanReasonsQueryVariables = Exact<{
  appliesTo?: InputMaybe<Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType>;
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type ListUserShopperBanReasonsQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListUserShopperBanReasons?: { __typename?: 'instacart_care_tools_v1_ListUserShopperBanReasonsResponse', reasons?: Array<{ __typename?: 'instacart_fulfillment_user_shopper_ban_v1_UserShopperBanReason', id?: string, reason?: string, appliesTo?: Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType }> } };

export type ListUserShopperBansQueryVariables = Exact<{
  shopperId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
}>;


export type ListUserShopperBansQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ListUserShopperBans?: { __typename?: 'instacart_care_tools_v1_ListUserShopperBansResponse', userShopperBans?: Array<{ __typename?: 'instacart_fulfillment_user_shopper_ban_v1_UserShopperBan', id?: string, appliesTo?: Instacart_Fulfillment_User_Shopper_Ban_V1_AppliesToType, banReasonDescription?: string, createdAt?: any, reason?: string, shopperId?: string, userId?: string, userName?: string, userShopperBanReasonId?: string }> } };

export type UnlinkIsolatedUserMutationVariables = Exact<{
  isolatedUserId: Scalars['BigInt'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type UnlinkIsolatedUserMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_UnlinkIsolatedUser?: { __typename?: 'instacart_care_tools_v1_UnlinkIsolatedUserResponse', success?: boolean } };

export type UpdateAddressForUserMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  addressId: Scalars['BigInt'];
  streetAddress: Scalars['String'];
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  requestContext: Instacart_Customers_Shared_V1_RequestContext_Input;
  serviceUser: Instacart_Care_Tools_V1_ServiceUser;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type UpdateAddressForUserMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_UpdateAddressForUser?: { __typename?: 'instacart_care_tools_v1_UpdateAddressForUserResponse', address?: { __typename?: 'instacart_care_tools_v1_AddressResponse', id?: string, streetAddress?: string, apartmentNumber?: string, city?: string, state?: string, postalCode?: string, zoneName?: string, regionName?: string, countryCode?: string } } };

export type UpdateSubscriptionAutorenewMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  subscriptionId: Scalars['BigInt'];
  autorenew: Scalars['Boolean'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
  requestContext?: InputMaybe<Instacart_Customers_Shared_V1_RequestContext_Input>;
}>;


export type UpdateSubscriptionAutorenewMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_UpdateSubscriptionAutorenew?: { __typename?: 'instacart_care_tools_v1_UpdateSubscriptionAutorenewResponse', membership?: { __typename?: 'instacart_care_tools_v1_InstacartPlusMembership', autorenew?: boolean, subscriptionId?: string } } };

export type UpdateUserNameMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type UpdateUserNameMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_UpdateUserName?: { __typename?: 'instacart_care_tools_v1_UpdateUserNameResponse', user?: { __typename?: 'instacart_care_tools_v1_User', firstName?: string, lastName?: string, email?: string, phone?: string } } };

export type UpdateUserPhoneMutationVariables = Exact<{
  userId: Scalars['BigInt'];
  phone: Scalars['String'];
  serviceUser?: InputMaybe<Instacart_Care_Tools_V1_ServiceUser>;
  adminAuditContext: Instacart_Care_Tools_V1_AdminAuditContext_Input;
}>;


export type UpdateUserPhoneMutation = { __typename?: 'Mutation', instacart_care_tools_v1_CareToolsService_UpdateUserPhone?: { __typename?: 'instacart_care_tools_v1_UpdateUserPhoneResponse', user?: { __typename?: 'instacart_care_tools_v1_User', firstName?: string, lastName?: string, email?: string, phone?: string } } };

export type ValidateSalesforceCaseQueryVariables = Exact<{
  caseId?: InputMaybe<Scalars['String']>;
}>;


export type ValidateSalesforceCaseQuery = { __typename?: 'Query', instacart_care_tools_v1_CareToolsService_ValidateSalesforceCase?: { __typename?: 'instacart_care_tools_v1_ValidateSalesforceCaseResponse', valid?: boolean } };

export const RetailerLocationFieldsFragmentDoc = gql`
    fragment RetailerLocationFields on instacart_customers_partners_v1_RetailerLocation {
  id
  name
  retailerId
  streetAddress
  city
  state
  postalCode
  timeZone
}
    `;
export const OrderItemFieldsFragmentDoc = gql`
    fragment OrderItemFields on instacart_care_tools_v1_OrderItem {
  name
  imageUrl
  sizeDetails
  alcoholic
  restrictedOtc
  rx
  ebt
  unitPrice {
    currencyCode
    units
    nanos
  }
  productCategory {
    productCategory
  }
}
    `;
export const OrderLineFieldsFragmentDoc = gql`
    fragment OrderLineFields on instacart_care_tools_v1_OrderLine {
  item {
    ...OrderItemFields
  }
  substitute {
    ...OrderItemFields
  }
  customerSelectedReplacement {
    ...OrderItemFields
  }
  replacementPolicy
  status
  substitutionStatus
  orderedQuantity {
    quantity
    unit {
      unitCode
      costUnit
    }
  }
  pickedQuantity {
    quantity
    unit {
      unitCode
      costUnit
    }
  }
  refundQuantity {
    quantity
    unit {
      unitCode
      costUnit
    }
  }
  customerPrice {
    currencyCode
    units
    nanos
  }
  customerOrderedPrice {
    currencyCode
    units
    nanos
  }
  fullPrice {
    currencyCode
    units
    nanos
  }
  creationDate
  addedByDriverId
  specialInstructions
  orderItemId
  pickedQuantityEach
  refundQuantityEach
  refundableQuantities {
    quantity
    unit {
      unitCode
      costUnit
    }
  }
  productType
}
    ${OrderItemFieldsFragmentDoc}`;
export const ShopperProfileFieldsFragmentDoc = gql`
    fragment ShopperProfileFields on instacart_care_tools_v1_ShopperSummary_ShopperProfile {
  id
  name
  firstName
  avatarUrl
  mapIconUrl
  startDate {
    year
    month
    day
  }
}
    `;
export const AddFreeMonthSubscriptionDocument = gql`
    mutation addFreeMonthSubscription($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!, $requestContext: instacart_customers_shared_v1_RequestContext_Input!) {
  instacart_care_tools_v1_CareToolsService_AddFreeMonthSubscription(
    input: {userId: $userId, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext, requestContext: $requestContext}
  ) {
    membership {
      subscriptionId
      autorenew
      endsOn
    }
  }
}
    `;

/**
 * __useAddFreeMonthSubscriptionMutation__
 *
 * To run a mutation, you first call `useAddFreeMonthSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFreeMonthSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFreeMonthSubscriptionMutation, { data, loading, error }] = useAddFreeMonthSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useAddFreeMonthSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddFreeMonthSubscriptionMutation, AddFreeMonthSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddFreeMonthSubscriptionMutation, AddFreeMonthSubscriptionMutationVariables>(AddFreeMonthSubscriptionDocument, options);
      }
export type AddFreeMonthSubscriptionMutationHookResult = ReturnType<typeof useAddFreeMonthSubscriptionMutation>;
export type AddFreeMonthSubscriptionMutationResult = ApolloReactCommon.MutationResult<AddFreeMonthSubscriptionMutation>;
export type AddFreeMonthSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<AddFreeMonthSubscriptionMutation, AddFreeMonthSubscriptionMutationVariables>;
export const AddOrUpdateFulfillmentOrderLineDocument = gql`
    mutation addOrUpdateFulfillmentOrderLine($orderItemId: BigInt!, $orderDeliveryId: BigInt!, $markFound: instacart_care_tools_v1_FulfillmentOrderLineMarkFound_Input, $markNotFound: instacart_care_tools_v1_FulfillmentOrderLineMarkNotFound_Input, $actorType: instacart_care_tools_v1_FulfillmentPickingActorType, $actorNote: String, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_CareToolsService_AddOrUpdateFulfillmentOrderLine(
    input: {orderItemId: $orderItemId, orderDeliveryId: $orderDeliveryId, markFound: $markFound, markNotFound: $markNotFound, actorType: $actorType, actorNote: $actorNote, serviceUser: $serviceUser}
  ) {
    orderItemId
  }
}
    `;

/**
 * __useAddOrUpdateFulfillmentOrderLineMutation__
 *
 * To run a mutation, you first call `useAddOrUpdateFulfillmentOrderLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdateFulfillmentOrderLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateFulfillmentOrderLineMutation, { data, loading, error }] = useAddOrUpdateFulfillmentOrderLineMutation({
 *   variables: {
 *      orderItemId: // value for 'orderItemId'
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      markFound: // value for 'markFound'
 *      markNotFound: // value for 'markNotFound'
 *      actorType: // value for 'actorType'
 *      actorNote: // value for 'actorNote'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useAddOrUpdateFulfillmentOrderLineMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddOrUpdateFulfillmentOrderLineMutation, AddOrUpdateFulfillmentOrderLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddOrUpdateFulfillmentOrderLineMutation, AddOrUpdateFulfillmentOrderLineMutationVariables>(AddOrUpdateFulfillmentOrderLineDocument, options);
      }
export type AddOrUpdateFulfillmentOrderLineMutationHookResult = ReturnType<typeof useAddOrUpdateFulfillmentOrderLineMutation>;
export type AddOrUpdateFulfillmentOrderLineMutationResult = ApolloReactCommon.MutationResult<AddOrUpdateFulfillmentOrderLineMutation>;
export type AddOrUpdateFulfillmentOrderLineMutationOptions = ApolloReactCommon.BaseMutationOptions<AddOrUpdateFulfillmentOrderLineMutation, AddOrUpdateFulfillmentOrderLineMutationVariables>;
export const AdminCancelSubscriptionDocument = gql`
    mutation adminCancelSubscription($userId: BigInt!, $subscriptionId: BigInt!, $adminId: BigInt, $hasElevatedRefundPermission: Boolean, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!, $requestContext: instacart_customers_shared_v1_RequestContext_Input!) {
  instacart_care_tools_v1_CareToolsService_AdminCancelSubscription(
    input: {userId: $userId, subscriptionId: $subscriptionId, adminId: $adminId, hasElevatedRefundPermission: $hasElevatedRefundPermission, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext, requestContext: $requestContext}
  ) {
    membership {
      subscriptionId
      autorenew
      endsOn
      canceledAt
    }
    wasRefunded
    refundAmount {
      units
      nanos
      currencyCode
    }
  }
}
    `;

/**
 * __useAdminCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useAdminCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCancelSubscriptionMutation, { data, loading, error }] = useAdminCancelSubscriptionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      subscriptionId: // value for 'subscriptionId'
 *      adminId: // value for 'adminId'
 *      hasElevatedRefundPermission: // value for 'hasElevatedRefundPermission'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useAdminCancelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AdminCancelSubscriptionMutation, AdminCancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AdminCancelSubscriptionMutation, AdminCancelSubscriptionMutationVariables>(AdminCancelSubscriptionDocument, options);
      }
export type AdminCancelSubscriptionMutationHookResult = ReturnType<typeof useAdminCancelSubscriptionMutation>;
export type AdminCancelSubscriptionMutationResult = ApolloReactCommon.MutationResult<AdminCancelSubscriptionMutation>;
export type AdminCancelSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<AdminCancelSubscriptionMutation, AdminCancelSubscriptionMutationVariables>;
export const CheckAdminRefundEligibilityDocument = gql`
    query checkAdminRefundEligibility($userId: BigInt!, $subscriptionId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $requestContext: instacart_customers_shared_v1_RequestContext_Input!) {
  instacart_care_tools_v1_CareToolsService_CheckAdminRefundEligibility(
    input: {userId: $userId, subscriptionId: $subscriptionId, serviceUser: $serviceUser, requestContext: $requestContext}
  ) {
    eligible
    ineligibilityReason
  }
}
    `;

/**
 * __useCheckAdminRefundEligibilityQuery__
 *
 * To run a query within a React component, call `useCheckAdminRefundEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckAdminRefundEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckAdminRefundEligibilityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      subscriptionId: // value for 'subscriptionId'
 *      serviceUser: // value for 'serviceUser'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useCheckAdminRefundEligibilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CheckAdminRefundEligibilityQuery, CheckAdminRefundEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckAdminRefundEligibilityQuery, CheckAdminRefundEligibilityQueryVariables>(CheckAdminRefundEligibilityDocument, options);
      }
export function useCheckAdminRefundEligibilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckAdminRefundEligibilityQuery, CheckAdminRefundEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckAdminRefundEligibilityQuery, CheckAdminRefundEligibilityQueryVariables>(CheckAdminRefundEligibilityDocument, options);
        }
export type CheckAdminRefundEligibilityQueryHookResult = ReturnType<typeof useCheckAdminRefundEligibilityQuery>;
export type CheckAdminRefundEligibilityLazyQueryHookResult = ReturnType<typeof useCheckAdminRefundEligibilityLazyQuery>;
export type CheckAdminRefundEligibilityQueryResult = ApolloReactCommon.QueryResult<CheckAdminRefundEligibilityQuery, CheckAdminRefundEligibilityQueryVariables>;
export const CreateAddressForUserDocument = gql`
    mutation createAddressForUser($userId: BigInt!, $streetAddress: String!, $apartmentNumber: String, $city: String!, $state: String!, $postalCode: String!, $instructions: String, $skipValidation: Boolean, $requestContext: instacart_customers_shared_v1_RequestContext_Input!, $serviceUser: instacart_care_tools_v1_ServiceUser!, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_CreateAddressForUser(
    input: {userId: $userId, streetAddress: $streetAddress, apartmentNumber: $apartmentNumber, city: $city, state: $state, postalCode: $postalCode, instructions: $instructions, skipValidation: $skipValidation, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext, requestContext: $requestContext}
  ) {
    address {
      id
      streetAddress
      apartmentNumber
      city
      state
      postalCode
      zoneName
      regionName
      countryCode
    }
  }
}
    `;

/**
 * __useCreateAddressForUserMutation__
 *
 * To run a mutation, you first call `useCreateAddressForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddressForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddressForUserMutation, { data, loading, error }] = useCreateAddressForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      streetAddress: // value for 'streetAddress'
 *      apartmentNumber: // value for 'apartmentNumber'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      instructions: // value for 'instructions'
 *      skipValidation: // value for 'skipValidation'
 *      requestContext: // value for 'requestContext'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useCreateAddressForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAddressForUserMutation, CreateAddressForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAddressForUserMutation, CreateAddressForUserMutationVariables>(CreateAddressForUserDocument, options);
      }
export type CreateAddressForUserMutationHookResult = ReturnType<typeof useCreateAddressForUserMutation>;
export type CreateAddressForUserMutationResult = ApolloReactCommon.MutationResult<CreateAddressForUserMutation>;
export type CreateAddressForUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateAddressForUserMutation, CreateAddressForUserMutationVariables>;
export const CreateCustomerMiaIssueDocument = gql`
    mutation createCustomerMIAIssue($customerId: BigInt!, $orderId: BigInt!, $orderDeliveryId: BigInt!, $caseNumber: String!, $serviceUser: instacart_care_tools_v1_ServiceUser, $uiOrigin: instacart_care_tools_v1_UiOrigin) {
  instacart_care_tools_v1_AppeasementsOrchestratorService_CreateCustomerMIAIssue(
    input: {customerId: $customerId, orderId: $orderId, orderDeliveryId: $orderDeliveryId, caseNumber: $caseNumber, serviceUser: $serviceUser, uiOrigin: $uiOrigin}
  ) {
    success {
      orderIssueId
    }
    failure {
      errorMessage
    }
  }
}
    `;

/**
 * __useCreateCustomerMiaIssueMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMiaIssueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMiaIssueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMiaIssueMutation, { data, loading, error }] = useCreateCustomerMiaIssueMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      orderId: // value for 'orderId'
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      caseNumber: // value for 'caseNumber'
 *      serviceUser: // value for 'serviceUser'
 *      uiOrigin: // value for 'uiOrigin'
 *   },
 * });
 */
export function useCreateCustomerMiaIssueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCustomerMiaIssueMutation, CreateCustomerMiaIssueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCustomerMiaIssueMutation, CreateCustomerMiaIssueMutationVariables>(CreateCustomerMiaIssueDocument, options);
      }
export type CreateCustomerMiaIssueMutationHookResult = ReturnType<typeof useCreateCustomerMiaIssueMutation>;
export type CreateCustomerMiaIssueMutationResult = ApolloReactCommon.MutationResult<CreateCustomerMiaIssueMutation>;
export type CreateCustomerMiaIssueMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateCustomerMiaIssueMutation, CreateCustomerMiaIssueMutationVariables>;
export const CreateNoteForOrderDocument = gql`
    mutation createNoteForOrder($orderId: BigInt!, $note: String!, $serviceUser: instacart_care_tools_v1_ServiceUser!, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input) {
  instacart_care_tools_v1_CareToolsService_CreateNoteForOrder(
    input: {orderId: $orderId, note: $note, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    note {
      id
      note
      userId
      userType
      notableId
      notableType
      createdAt
      updatedAt
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useCreateNoteForOrderMutation__
 *
 * To run a mutation, you first call `useCreateNoteForOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteForOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteForOrderMutation, { data, loading, error }] = useCreateNoteForOrderMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      note: // value for 'note'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useCreateNoteForOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNoteForOrderMutation, CreateNoteForOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNoteForOrderMutation, CreateNoteForOrderMutationVariables>(CreateNoteForOrderDocument, options);
      }
export type CreateNoteForOrderMutationHookResult = ReturnType<typeof useCreateNoteForOrderMutation>;
export type CreateNoteForOrderMutationResult = ApolloReactCommon.MutationResult<CreateNoteForOrderMutation>;
export type CreateNoteForOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNoteForOrderMutation, CreateNoteForOrderMutationVariables>;
export const CreateNoteForUserDocument = gql`
    mutation createNoteForUser($userId: BigInt!, $note: String!, $serviceUser: instacart_care_tools_v1_ServiceUser!, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input) {
  instacart_care_tools_v1_CareToolsService_CreateNoteForUser(
    input: {userId: $userId, note: $note, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    note {
      id
      note
      userId
      userType
      notableId
      notableType
      createdAt
      updatedAt
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useCreateNoteForUserMutation__
 *
 * To run a mutation, you first call `useCreateNoteForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteForUserMutation, { data, loading, error }] = useCreateNoteForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      note: // value for 'note'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useCreateNoteForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNoteForUserMutation, CreateNoteForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNoteForUserMutation, CreateNoteForUserMutationVariables>(CreateNoteForUserDocument, options);
      }
export type CreateNoteForUserMutationHookResult = ReturnType<typeof useCreateNoteForUserMutation>;
export type CreateNoteForUserMutationResult = ApolloReactCommon.MutationResult<CreateNoteForUserMutation>;
export type CreateNoteForUserMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateNoteForUserMutation, CreateNoteForUserMutationVariables>;
export const CreateOrderReturnDocument = gql`
    mutation createOrderReturn($orderDeliveryId: BigInt!, $returnRequesterType: instacart_care_tools_v1_ReturnRequesterType!, $returnReasonCode: instacart_care_tools_v1_ReturnReasonCode!, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_CareToolsService_CreateOrderReturn(
    input: {orderDeliveryId: $orderDeliveryId, returnRequesterType: $returnRequesterType, returnReasonCode: $returnReasonCode, serviceUser: $serviceUser}
  ) {
    returnId
  }
}
    `;

/**
 * __useCreateOrderReturnMutation__
 *
 * To run a mutation, you first call `useCreateOrderReturnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderReturnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderReturnMutation, { data, loading, error }] = useCreateOrderReturnMutation({
 *   variables: {
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      returnRequesterType: // value for 'returnRequesterType'
 *      returnReasonCode: // value for 'returnReasonCode'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useCreateOrderReturnMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrderReturnMutation, CreateOrderReturnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateOrderReturnMutation, CreateOrderReturnMutationVariables>(CreateOrderReturnDocument, options);
      }
export type CreateOrderReturnMutationHookResult = ReturnType<typeof useCreateOrderReturnMutation>;
export type CreateOrderReturnMutationResult = ApolloReactCommon.MutationResult<CreateOrderReturnMutation>;
export type CreateOrderReturnMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrderReturnMutation, CreateOrderReturnMutationVariables>;
export const CreateUserShopperBanDocument = gql`
    mutation createUserShopperBan($shopperId: BigInt!, $userId: BigInt!, $appliesTo: instacart_fulfillment_user_shopper_ban_v1_AppliesToType!, $userShopperBanReasonId: BigInt!, $reason: String, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_CreateUserShopperBan(
    input: {shopperId: $shopperId, userId: $userId, appliesTo: $appliesTo, userShopperBanReasonId: $userShopperBanReasonId, reason: $reason, serviceUser: $serviceUser}
  ) {
    userShopperBan {
      id
      shopperId
      userId
      appliesTo
    }
  }
}
    `;

/**
 * __useCreateUserShopperBanMutation__
 *
 * To run a mutation, you first call `useCreateUserShopperBanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserShopperBanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserShopperBanMutation, { data, loading, error }] = useCreateUserShopperBanMutation({
 *   variables: {
 *      shopperId: // value for 'shopperId'
 *      userId: // value for 'userId'
 *      appliesTo: // value for 'appliesTo'
 *      userShopperBanReasonId: // value for 'userShopperBanReasonId'
 *      reason: // value for 'reason'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useCreateUserShopperBanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserShopperBanMutation, CreateUserShopperBanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserShopperBanMutation, CreateUserShopperBanMutationVariables>(CreateUserShopperBanDocument, options);
      }
export type CreateUserShopperBanMutationHookResult = ReturnType<typeof useCreateUserShopperBanMutation>;
export type CreateUserShopperBanMutationResult = ApolloReactCommon.MutationResult<CreateUserShopperBanMutation>;
export type CreateUserShopperBanMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateUserShopperBanMutation, CreateUserShopperBanMutationVariables>;
export const DeleteUserShopperBanDocument = gql`
    mutation deleteUserShopperBan($id: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_DeleteUserShopperBan(
    input: {id: $id, serviceUser: $serviceUser}
  )
}
    `;

/**
 * __useDeleteUserShopperBanMutation__
 *
 * To run a mutation, you first call `useDeleteUserShopperBanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserShopperBanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserShopperBanMutation, { data, loading, error }] = useDeleteUserShopperBanMutation({
 *   variables: {
 *      id: // value for 'id'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useDeleteUserShopperBanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserShopperBanMutation, DeleteUserShopperBanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserShopperBanMutation, DeleteUserShopperBanMutationVariables>(DeleteUserShopperBanDocument, options);
      }
export type DeleteUserShopperBanMutationHookResult = ReturnType<typeof useDeleteUserShopperBanMutation>;
export type DeleteUserShopperBanMutationResult = ApolloReactCommon.MutationResult<DeleteUserShopperBanMutation>;
export type DeleteUserShopperBanMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteUserShopperBanMutation, DeleteUserShopperBanMutationVariables>;
export const FindRelatedUsersDocument = gql`
    query findRelatedUsers($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_FindRelatedUsers(
    input: {userId: $userId, serviceUser: $serviceUser}
  ) {
    users {
      id
      firstName
      lastName
      email
      phone
      matchTypes
      accountType
      createdAt
    }
  }
}
    `;

/**
 * __useFindRelatedUsersQuery__
 *
 * To run a query within a React component, call `useFindRelatedUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRelatedUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRelatedUsersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useFindRelatedUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindRelatedUsersQuery, FindRelatedUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindRelatedUsersQuery, FindRelatedUsersQueryVariables>(FindRelatedUsersDocument, options);
      }
export function useFindRelatedUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindRelatedUsersQuery, FindRelatedUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindRelatedUsersQuery, FindRelatedUsersQueryVariables>(FindRelatedUsersDocument, options);
        }
export type FindRelatedUsersQueryHookResult = ReturnType<typeof useFindRelatedUsersQuery>;
export type FindRelatedUsersLazyQueryHookResult = ReturnType<typeof useFindRelatedUsersLazyQuery>;
export type FindRelatedUsersQueryResult = ApolloReactCommon.QueryResult<FindRelatedUsersQuery, FindRelatedUsersQueryVariables>;
export const FindUsersDocument = gql`
    query findUsers($query: String!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!, $limit: Int) {
  instacart_care_tools_v1_CareToolsService_FindUsers(
    input: {query: $query, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext, pagination: {limit: $limit}}
  ) {
    users {
      id
      firstName
      lastName
      email
      phone
      isolationContext {
        id
        name
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFindUsersQuery__
 *
 * To run a query within a React component, call `useFindUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindUsersQuery({
 *   variables: {
 *      query: // value for 'query'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFindUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
      }
export function useFindUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FindUsersQuery, FindUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FindUsersQuery, FindUsersQueryVariables>(FindUsersDocument, options);
        }
export type FindUsersQueryHookResult = ReturnType<typeof useFindUsersQuery>;
export type FindUsersLazyQueryHookResult = ReturnType<typeof useFindUsersLazyQuery>;
export type FindUsersQueryResult = ApolloReactCommon.QueryResult<FindUsersQuery, FindUsersQueryVariables>;
export const ForceCompleteOrderDocument = gql`
    mutation forceCompleteOrder($orderDeliveryId: BigInt!, $reason: instacart_care_tools_v1_ForceCompleteOrderReason!, $description: String, $ippAccountId: BigInt, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_ForceCompleteOrder(
    input: {orderDeliveryId: $orderDeliveryId, reason: $reason, description: $description, ippAccountId: $ippAccountId, serviceUser: $serviceUser}
  )
}
    `;

/**
 * __useForceCompleteOrderMutation__
 *
 * To run a mutation, you first call `useForceCompleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForceCompleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forceCompleteOrderMutation, { data, loading, error }] = useForceCompleteOrderMutation({
 *   variables: {
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      reason: // value for 'reason'
 *      description: // value for 'description'
 *      ippAccountId: // value for 'ippAccountId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useForceCompleteOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForceCompleteOrderMutation, ForceCompleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForceCompleteOrderMutation, ForceCompleteOrderMutationVariables>(ForceCompleteOrderDocument, options);
      }
export type ForceCompleteOrderMutationHookResult = ReturnType<typeof useForceCompleteOrderMutation>;
export type ForceCompleteOrderMutationResult = ApolloReactCommon.MutationResult<ForceCompleteOrderMutation>;
export type ForceCompleteOrderMutationOptions = ApolloReactCommon.BaseMutationOptions<ForceCompleteOrderMutation, ForceCompleteOrderMutationVariables>;
export const GetActiveBenefitsDocument = gql`
    query getActiveBenefits($userId: BigInt!, $requestContext: instacart_customers_shared_v1_RequestContext_Input) {
  instacart_care_tools_v1_CareToolsService_GetActiveBenefits(
    input: {userId: $userId, requestContext: $requestContext}
  ) {
    benefits
  }
}
    `;

/**
 * __useGetActiveBenefitsQuery__
 *
 * To run a query within a React component, call `useGetActiveBenefitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveBenefitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveBenefitsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useGetActiveBenefitsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetActiveBenefitsQuery, GetActiveBenefitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetActiveBenefitsQuery, GetActiveBenefitsQueryVariables>(GetActiveBenefitsDocument, options);
      }
export function useGetActiveBenefitsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveBenefitsQuery, GetActiveBenefitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetActiveBenefitsQuery, GetActiveBenefitsQueryVariables>(GetActiveBenefitsDocument, options);
        }
export type GetActiveBenefitsQueryHookResult = ReturnType<typeof useGetActiveBenefitsQuery>;
export type GetActiveBenefitsLazyQueryHookResult = ReturnType<typeof useGetActiveBenefitsLazyQuery>;
export type GetActiveBenefitsQueryResult = ApolloReactCommon.QueryResult<GetActiveBenefitsQuery, GetActiveBenefitsQueryVariables>;
export const GetCustomerSpendingSummaryDocument = gql`
    query getCustomerSpendingSummary($userId: BigInt!, $countryId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummary(
    input: {userId: $userId, countryId: $countryId, serviceUser: $serviceUser}
  ) {
    currencyCode
    totalSpend
    totalOrders
    avgBasketSize
    creditAvailable
    lifetimeCredits
    creditSpendPct
    creditRefundPct
  }
}
    `;

/**
 * __useGetCustomerSpendingSummaryQuery__
 *
 * To run a query within a React component, call `useGetCustomerSpendingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSpendingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSpendingSummaryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      countryId: // value for 'countryId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useGetCustomerSpendingSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomerSpendingSummaryQuery, GetCustomerSpendingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomerSpendingSummaryQuery, GetCustomerSpendingSummaryQueryVariables>(GetCustomerSpendingSummaryDocument, options);
      }
export function useGetCustomerSpendingSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomerSpendingSummaryQuery, GetCustomerSpendingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomerSpendingSummaryQuery, GetCustomerSpendingSummaryQueryVariables>(GetCustomerSpendingSummaryDocument, options);
        }
export type GetCustomerSpendingSummaryQueryHookResult = ReturnType<typeof useGetCustomerSpendingSummaryQuery>;
export type GetCustomerSpendingSummaryLazyQueryHookResult = ReturnType<typeof useGetCustomerSpendingSummaryLazyQuery>;
export type GetCustomerSpendingSummaryQueryResult = ApolloReactCommon.QueryResult<GetCustomerSpendingSummaryQuery, GetCustomerSpendingSummaryQueryVariables>;
export const GetCustomerSpendingSummaryV2Document = gql`
    query getCustomerSpendingSummaryV2($userId: BigInt!) {
  instacart_care_tools_v1_CareToolsService_GetCustomerSpendingSummaryV2(
    input: {userId: $userId}
  ) {
    userMetrics {
      creditToSpendRatioPct
      totalOrderCount
      totalSpendUsd
      appeasementsUsd
      refundsUsd
    }
    combinedMetrics {
      creditToSpendRatioPct
      totalOrderCount
      totalSpendUsd
      appeasementsUsd
      refundsUsd
    }
  }
}
    `;

/**
 * __useGetCustomerSpendingSummaryV2Query__
 *
 * To run a query within a React component, call `useGetCustomerSpendingSummaryV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerSpendingSummaryV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerSpendingSummaryV2Query({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetCustomerSpendingSummaryV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomerSpendingSummaryV2Query, GetCustomerSpendingSummaryV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomerSpendingSummaryV2Query, GetCustomerSpendingSummaryV2QueryVariables>(GetCustomerSpendingSummaryV2Document, options);
      }
export function useGetCustomerSpendingSummaryV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomerSpendingSummaryV2Query, GetCustomerSpendingSummaryV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomerSpendingSummaryV2Query, GetCustomerSpendingSummaryV2QueryVariables>(GetCustomerSpendingSummaryV2Document, options);
        }
export type GetCustomerSpendingSummaryV2QueryHookResult = ReturnType<typeof useGetCustomerSpendingSummaryV2Query>;
export type GetCustomerSpendingSummaryV2LazyQueryHookResult = ReturnType<typeof useGetCustomerSpendingSummaryV2LazyQuery>;
export type GetCustomerSpendingSummaryV2QueryResult = ApolloReactCommon.QueryResult<GetCustomerSpendingSummaryV2Query, GetCustomerSpendingSummaryV2QueryVariables>;
export const GetHouseholdByUserDocument = gql`
    query getHouseholdByUser($userId: BigInt!) {
  instacart_care_tools_v1_CareToolsService_GetHouseholdByUser(
    input: {userId: $userId}
  ) {
    household {
      householdMembers {
        firstName
        id
        lastName
      }
      id
      ownerUserId
    }
  }
}
    `;

/**
 * __useGetHouseholdByUserQuery__
 *
 * To run a query within a React component, call `useGetHouseholdByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHouseholdByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHouseholdByUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetHouseholdByUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHouseholdByUserQuery, GetHouseholdByUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHouseholdByUserQuery, GetHouseholdByUserQueryVariables>(GetHouseholdByUserDocument, options);
      }
export function useGetHouseholdByUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHouseholdByUserQuery, GetHouseholdByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHouseholdByUserQuery, GetHouseholdByUserQueryVariables>(GetHouseholdByUserDocument, options);
        }
export type GetHouseholdByUserQueryHookResult = ReturnType<typeof useGetHouseholdByUserQuery>;
export type GetHouseholdByUserLazyQueryHookResult = ReturnType<typeof useGetHouseholdByUserLazyQuery>;
export type GetHouseholdByUserQueryResult = ApolloReactCommon.QueryResult<GetHouseholdByUserQuery, GetHouseholdByUserQueryVariables>;
export const GetInstacartPlusMembershipDocument = gql`
    query getInstacartPlusMembership($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input) {
  instacart_care_tools_v1_CareToolsService_GetInstacartPlusMembership(
    input: {userId: $userId, adminAuditContext: $adminAuditContext, serviceUser: $serviceUser}
  ) {
    memberships {
      autorenew
      startsOn
      endsOn
      countryId
      subscriptionId
      canceledAt
      termLength
      renewalPrice {
        currencyCode
        units
        nanos
      }
      discount {
        currencyCode
        units
        nanos
      }
    }
  }
}
    `;

/**
 * __useGetInstacartPlusMembershipQuery__
 *
 * To run a query within a React component, call `useGetInstacartPlusMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstacartPlusMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstacartPlusMembershipQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useGetInstacartPlusMembershipQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInstacartPlusMembershipQuery, GetInstacartPlusMembershipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInstacartPlusMembershipQuery, GetInstacartPlusMembershipQueryVariables>(GetInstacartPlusMembershipDocument, options);
      }
export function useGetInstacartPlusMembershipLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInstacartPlusMembershipQuery, GetInstacartPlusMembershipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInstacartPlusMembershipQuery, GetInstacartPlusMembershipQueryVariables>(GetInstacartPlusMembershipDocument, options);
        }
export type GetInstacartPlusMembershipQueryHookResult = ReturnType<typeof useGetInstacartPlusMembershipQuery>;
export type GetInstacartPlusMembershipLazyQueryHookResult = ReturnType<typeof useGetInstacartPlusMembershipLazyQuery>;
export type GetInstacartPlusMembershipQueryResult = ApolloReactCommon.QueryResult<GetInstacartPlusMembershipQuery, GetInstacartPlusMembershipQueryVariables>;
export const GetLatestActiveAttributeForUserDocument = gql`
    query getLatestActiveAttributeForUser($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_GetLatestActiveAttributeForUser(
    input: {userId: $userId, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    activeAttribute {
      userId
      storeConfigurationId
      oauthApplicationId
      countryId
      addressId
      retailerId
      timeZoneName
      locale
    }
  }
}
    `;

/**
 * __useGetLatestActiveAttributeForUserQuery__
 *
 * To run a query within a React component, call `useGetLatestActiveAttributeForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestActiveAttributeForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestActiveAttributeForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useGetLatestActiveAttributeForUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLatestActiveAttributeForUserQuery, GetLatestActiveAttributeForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLatestActiveAttributeForUserQuery, GetLatestActiveAttributeForUserQueryVariables>(GetLatestActiveAttributeForUserDocument, options);
      }
export function useGetLatestActiveAttributeForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLatestActiveAttributeForUserQuery, GetLatestActiveAttributeForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLatestActiveAttributeForUserQuery, GetLatestActiveAttributeForUserQueryVariables>(GetLatestActiveAttributeForUserDocument, options);
        }
export type GetLatestActiveAttributeForUserQueryHookResult = ReturnType<typeof useGetLatestActiveAttributeForUserQuery>;
export type GetLatestActiveAttributeForUserLazyQueryHookResult = ReturnType<typeof useGetLatestActiveAttributeForUserLazyQuery>;
export type GetLatestActiveAttributeForUserQueryResult = ApolloReactCommon.QueryResult<GetLatestActiveAttributeForUserQuery, GetLatestActiveAttributeForUserQueryVariables>;
export const GetLifetimeSavingsForUserDocument = gql`
    query getLifetimeSavingsForUser($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $requestContext: instacart_customers_shared_v1_RequestContext_Input) {
  instacart_care_tools_v1_CareToolsService_GetLifetimeSavingsForUser(
    input: {userId: $userId, serviceUser: $serviceUser, requestContext: $requestContext}
  ) {
    totalSavings {
      currencyCode
      units
      nanos
    }
  }
}
    `;

/**
 * __useGetLifetimeSavingsForUserQuery__
 *
 * To run a query within a React component, call `useGetLifetimeSavingsForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLifetimeSavingsForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLifetimeSavingsForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useGetLifetimeSavingsForUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetLifetimeSavingsForUserQuery, GetLifetimeSavingsForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLifetimeSavingsForUserQuery, GetLifetimeSavingsForUserQueryVariables>(GetLifetimeSavingsForUserDocument, options);
      }
export function useGetLifetimeSavingsForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLifetimeSavingsForUserQuery, GetLifetimeSavingsForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLifetimeSavingsForUserQuery, GetLifetimeSavingsForUserQueryVariables>(GetLifetimeSavingsForUserDocument, options);
        }
export type GetLifetimeSavingsForUserQueryHookResult = ReturnType<typeof useGetLifetimeSavingsForUserQuery>;
export type GetLifetimeSavingsForUserLazyQueryHookResult = ReturnType<typeof useGetLifetimeSavingsForUserLazyQuery>;
export type GetLifetimeSavingsForUserQueryResult = ApolloReactCommon.QueryResult<GetLifetimeSavingsForUserQuery, GetLifetimeSavingsForUserQueryVariables>;
export const GetOrderDocument = gql`
    query getOrder($orderReference: String!, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_CareToolsService_GetOrder(
    input: {orderReference: $orderReference, serviceUser: $serviceUser}
  ) {
    order {
      baggingOption
      arrivedAtCustomerLocationAt
      batchAssignedAt
      certifiedDelivery
      checkoutRetailerLocation {
        ...RetailerLocationFields
      }
      clientConfigurationId
      closestRetailerLocation {
        ...RetailerLocationFields
      }
      communicationLocale
      confirmedAt
      creationClientIdentifier
      creationDate
      customerBagCount
      customerOrderNumber
      deliveredAt
      deliveryStartedAt
      deliveryStatus
      expressSubscriptionId
      finalizedAt
      fulfillmentType
      fulfillmentWindow {
        windowStart
        windowEnd
      }
      id
      lateEmailSent
      loyaltyNumber
      orderAhead
      orderDeliveryId
      orderReference
      plannedDeliveredAt
      plannedDeliveryStartedAt
      receiptSuppressionEnabled
      redelivery
      retailer {
        id
        name
        slug
        logoImagePath
      }
      retailerReferenceId
      serviceOptionId
      serviceType
      shoppedRetailerLocation {
        ...RetailerLocationFields
      }
      shopperSummary {
        fullService
        currentShopperProfile {
          id
          name
          firstName
        }
        driverProfile {
          id
          name
          firstName
        }
        pickerProfile {
          id
          name
          firstName
        }
        runnerProfile {
          id
          name
          firstName
        }
      }
      storeConfigurationId
      orderDeliveryId
      batchIds {
        deliveringBatchIds
        drivingToStoreBatchIds
        shoppingBatchIds
      }
      user {
        firstName
        lastName
        email
        phone
      }
      userBirthday {
        year
        month
        day
      }
      orderLines {
        ...OrderLineFields
      }
      latestOrderChargeLines {
        amount {
          currencyCode
          units
          nanos
        }
        labelInEnglish
      }
      creationOrderChargeLines {
        amount {
          currencyCode
          units
          nanos
        }
        labelInEnglish
      }
      orderHandlingDetails {
        delivery {
          address {
            addressLines
            locality
            administrativeArea
            postalCode
            regionCode
          }
          addressType
          doorCode
          dropoffLocation
          instructions
          latLng {
            latitude
            longitude
          }
          notes
        }
      }
      orderStateChanges {
        orderDeliveryEventId
        orderDeliveryId
        fromState
        toState
        trigger
        transitionedAt
      }
      heavyPayInfo {
        orderHeavyPayLbs
        batchHeavyPayLbs
        shopperPaidForHeavyPay
      }
      sourceWebsite
      brandedName
      country {
        id
        name
      }
      zone {
        name
      }
      deliveryPhoto {
        id
        url
      }
      ratingLink
      receiptUrl
    }
  }
}
    ${RetailerLocationFieldsFragmentDoc}
${OrderLineFieldsFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      orderReference: // value for 'orderReference'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderQueryResult = ApolloReactCommon.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrderByIdBasicDocument = gql`
    query getOrderByIdBasic($orderId: BigInt, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_GetOrderByIdBasic(
    input: {orderId: $orderId, serviceUser: $serviceUser, includeCustomerName: true}
  ) {
    order {
      id
      confirmedAt
      retailerId
      userId
      userFullName
      fulfillmentDate
      serviceType
      deliveryStatus
    }
  }
}
    `;

/**
 * __useGetOrderByIdBasicQuery__
 *
 * To run a query within a React component, call `useGetOrderByIdBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderByIdBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderByIdBasicQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useGetOrderByIdBasicQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOrderByIdBasicQuery, GetOrderByIdBasicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderByIdBasicQuery, GetOrderByIdBasicQueryVariables>(GetOrderByIdBasicDocument, options);
      }
export function useGetOrderByIdBasicLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderByIdBasicQuery, GetOrderByIdBasicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderByIdBasicQuery, GetOrderByIdBasicQueryVariables>(GetOrderByIdBasicDocument, options);
        }
export type GetOrderByIdBasicQueryHookResult = ReturnType<typeof useGetOrderByIdBasicQuery>;
export type GetOrderByIdBasicLazyQueryHookResult = ReturnType<typeof useGetOrderByIdBasicLazyQuery>;
export type GetOrderByIdBasicQueryResult = ApolloReactCommon.QueryResult<GetOrderByIdBasicQuery, GetOrderByIdBasicQueryVariables>;
export const GetOrderReturnDocument = gql`
    query getOrderReturn($orderDeliveryId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_CareToolsService_GetOrderReturn(
    input: {orderDeliveryId: $orderDeliveryId, serviceUser: $serviceUser}
  ) {
    returnBatchId
  }
}
    `;

/**
 * __useGetOrderReturnQuery__
 *
 * To run a query within a React component, call `useGetOrderReturnQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderReturnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderReturnQuery({
 *   variables: {
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useGetOrderReturnQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrderReturnQuery, GetOrderReturnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderReturnQuery, GetOrderReturnQueryVariables>(GetOrderReturnDocument, options);
      }
export function useGetOrderReturnLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderReturnQuery, GetOrderReturnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderReturnQuery, GetOrderReturnQueryVariables>(GetOrderReturnDocument, options);
        }
export type GetOrderReturnQueryHookResult = ReturnType<typeof useGetOrderReturnQuery>;
export type GetOrderReturnLazyQueryHookResult = ReturnType<typeof useGetOrderReturnLazyQuery>;
export type GetOrderReturnQueryResult = ApolloReactCommon.QueryResult<GetOrderReturnQuery, GetOrderReturnQueryVariables>;
export const GetOrderReturnEligibilityDocument = gql`
    query getOrderReturnEligibility($orderDeliveryId: BigInt!, $returnRequesterType: instacart_care_tools_v1_ReturnRequesterType!, $returnReasonCode: instacart_care_tools_v1_ReturnReasonCode!, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_CareToolsService_GetOrderReturnEligibility(
    input: {orderDeliveryId: $orderDeliveryId, returnRequesterType: $returnRequesterType, returnReasonCode: $returnReasonCode, serviceUser: $serviceUser}
  ) {
    eligible
    items {
      itemAction
      orderItemId
    }
  }
}
    `;

/**
 * __useGetOrderReturnEligibilityQuery__
 *
 * To run a query within a React component, call `useGetOrderReturnEligibilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderReturnEligibilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderReturnEligibilityQuery({
 *   variables: {
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      returnRequesterType: // value for 'returnRequesterType'
 *      returnReasonCode: // value for 'returnReasonCode'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useGetOrderReturnEligibilityQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrderReturnEligibilityQuery, GetOrderReturnEligibilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrderReturnEligibilityQuery, GetOrderReturnEligibilityQueryVariables>(GetOrderReturnEligibilityDocument, options);
      }
export function useGetOrderReturnEligibilityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrderReturnEligibilityQuery, GetOrderReturnEligibilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrderReturnEligibilityQuery, GetOrderReturnEligibilityQueryVariables>(GetOrderReturnEligibilityDocument, options);
        }
export type GetOrderReturnEligibilityQueryHookResult = ReturnType<typeof useGetOrderReturnEligibilityQuery>;
export type GetOrderReturnEligibilityLazyQueryHookResult = ReturnType<typeof useGetOrderReturnEligibilityLazyQuery>;
export type GetOrderReturnEligibilityQueryResult = ApolloReactCommon.QueryResult<GetOrderReturnEligibilityQuery, GetOrderReturnEligibilityQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($userId: BigInt, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_GetUser(
    input: {userId: $userId, serviceUser: $serviceUser}
  ) {
    user {
      active
      createdAt
      email
      firstName
      lastName
      phone
      isolationContext {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = ApolloReactCommon.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const IssueIcPlusFreeMonthDocument = gql`
    mutation issueIcPlusFreeMonth($customerId: BigInt!, $orderId: BigInt!, $orderDeliveryId: BigInt!, $caseNumber: String!, $serviceUser: instacart_care_tools_v1_ServiceUser, $uiOrigin: instacart_care_tools_v1_UiOrigin, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!, $requestContext: instacart_customers_shared_v1_RequestContext_Input!) {
  instacart_care_tools_v1_AppeasementsOrchestratorService_IssueIcPlusFreeMonth(
    input: {customerId: $customerId, orderId: $orderId, orderDeliveryId: $orderDeliveryId, caseNumber: $caseNumber, serviceUser: $serviceUser, uiOrigin: $uiOrigin, adminAuditContext: $adminAuditContext, requestContext: $requestContext}
  ) {
    success {
      appeasementRequestId
      subscriptionId
    }
    failure {
      errorMessage
    }
  }
}
    `;

/**
 * __useIssueIcPlusFreeMonthMutation__
 *
 * To run a mutation, you first call `useIssueIcPlusFreeMonthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueIcPlusFreeMonthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueIcPlusFreeMonthMutation, { data, loading, error }] = useIssueIcPlusFreeMonthMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      orderId: // value for 'orderId'
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      caseNumber: // value for 'caseNumber'
 *      serviceUser: // value for 'serviceUser'
 *      uiOrigin: // value for 'uiOrigin'
 *      adminAuditContext: // value for 'adminAuditContext'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useIssueIcPlusFreeMonthMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IssueIcPlusFreeMonthMutation, IssueIcPlusFreeMonthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IssueIcPlusFreeMonthMutation, IssueIcPlusFreeMonthMutationVariables>(IssueIcPlusFreeMonthDocument, options);
      }
export type IssueIcPlusFreeMonthMutationHookResult = ReturnType<typeof useIssueIcPlusFreeMonthMutation>;
export type IssueIcPlusFreeMonthMutationResult = ApolloReactCommon.MutationResult<IssueIcPlusFreeMonthMutation>;
export type IssueIcPlusFreeMonthMutationOptions = ApolloReactCommon.BaseMutationOptions<IssueIcPlusFreeMonthMutation, IssueIcPlusFreeMonthMutationVariables>;
export const LinkIsolatedUserDocument = gql`
    mutation linkIsolatedUser($isolatedUserId: BigInt!, $marketplaceUserId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_LinkIsolatedUser(
    input: {isolatedUserId: $isolatedUserId, marketplaceUserId: $marketplaceUserId, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    success
  }
}
    `;

/**
 * __useLinkIsolatedUserMutation__
 *
 * To run a mutation, you first call `useLinkIsolatedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkIsolatedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkIsolatedUserMutation, { data, loading, error }] = useLinkIsolatedUserMutation({
 *   variables: {
 *      isolatedUserId: // value for 'isolatedUserId'
 *      marketplaceUserId: // value for 'marketplaceUserId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useLinkIsolatedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<LinkIsolatedUserMutation, LinkIsolatedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<LinkIsolatedUserMutation, LinkIsolatedUserMutationVariables>(LinkIsolatedUserDocument, options);
      }
export type LinkIsolatedUserMutationHookResult = ReturnType<typeof useLinkIsolatedUserMutation>;
export type LinkIsolatedUserMutationResult = ApolloReactCommon.MutationResult<LinkIsolatedUserMutation>;
export type LinkIsolatedUserMutationOptions = ApolloReactCommon.BaseMutationOptions<LinkIsolatedUserMutation, LinkIsolatedUserMutationVariables>;
export const ListActiveAttributesByCountryDocument = gql`
    query listActiveAttributesByCountry($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_ListActiveAttributesByCountry(
    input: {userId: $userId, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    countries {
      countryId
      attributes {
        storeConfigurationId
        storeName
      }
    }
  }
}
    `;

/**
 * __useListActiveAttributesByCountryQuery__
 *
 * To run a query within a React component, call `useListActiveAttributesByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListActiveAttributesByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListActiveAttributesByCountryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useListActiveAttributesByCountryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListActiveAttributesByCountryQuery, ListActiveAttributesByCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListActiveAttributesByCountryQuery, ListActiveAttributesByCountryQueryVariables>(ListActiveAttributesByCountryDocument, options);
      }
export function useListActiveAttributesByCountryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListActiveAttributesByCountryQuery, ListActiveAttributesByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListActiveAttributesByCountryQuery, ListActiveAttributesByCountryQueryVariables>(ListActiveAttributesByCountryDocument, options);
        }
export type ListActiveAttributesByCountryQueryHookResult = ReturnType<typeof useListActiveAttributesByCountryQuery>;
export type ListActiveAttributesByCountryLazyQueryHookResult = ReturnType<typeof useListActiveAttributesByCountryLazyQuery>;
export type ListActiveAttributesByCountryQueryResult = ApolloReactCommon.QueryResult<ListActiveAttributesByCountryQuery, ListActiveAttributesByCountryQueryVariables>;
export const ListAddressesForUserDocument = gql`
    query listAddressesForUser($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $limit: Int, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_ListAddressesForUser(
    input: {userId: $userId, serviceUser: $serviceUser, pagination: {limit: $limit}, adminAuditContext: $adminAuditContext}
  ) {
    nodes {
      id
      streetAddress
      apartmentNumber
      city
      state
      postalCode
      zoneName
      regionName
      countryCode
      businessName
    }
  }
}
    `;

/**
 * __useListAddressesForUserQuery__
 *
 * To run a query within a React component, call `useListAddressesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAddressesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAddressesForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      limit: // value for 'limit'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useListAddressesForUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListAddressesForUserQuery, ListAddressesForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListAddressesForUserQuery, ListAddressesForUserQueryVariables>(ListAddressesForUserDocument, options);
      }
export function useListAddressesForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListAddressesForUserQuery, ListAddressesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListAddressesForUserQuery, ListAddressesForUserQueryVariables>(ListAddressesForUserDocument, options);
        }
export type ListAddressesForUserQueryHookResult = ReturnType<typeof useListAddressesForUserQuery>;
export type ListAddressesForUserLazyQueryHookResult = ReturnType<typeof useListAddressesForUserLazyQuery>;
export type ListAddressesForUserQueryResult = ApolloReactCommon.QueryResult<ListAddressesForUserQuery, ListAddressesForUserQueryVariables>;
export const ListAdminMoveOrAddChargesPaymentInstrumentsDocument = gql`
    query listAdminMoveOrAddChargesPaymentInstruments($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser!, $orderDeliveryId: BigInt) {
  instacart_care_tools_v1_CareToolsService_ListAdminMoveOrAddChargesPaymentInstruments(
    input: {userId: $userId, serviceUser: $serviceUser, orderDeliveryId: $orderDeliveryId}
  ) {
    paymentInstruments {
      id
      isCurrentOnOrder
      creditCard {
        creditCardType
        suffix
      }
      debitCard {
        creditCardType
        suffix
      }
      disableInfo {
        disabledForAlcoholic
        disabledForCbdOrThc
        disabledForDeprecation
        disabledForEbt
        disabledForMaintenance
        disabledForMastercardScenario
        disabledForRx
      }
    }
  }
}
    `;

/**
 * __useListAdminMoveOrAddChargesPaymentInstrumentsQuery__
 *
 * To run a query within a React component, call `useListAdminMoveOrAddChargesPaymentInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAdminMoveOrAddChargesPaymentInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAdminMoveOrAddChargesPaymentInstrumentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *   },
 * });
 */
export function useListAdminMoveOrAddChargesPaymentInstrumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListAdminMoveOrAddChargesPaymentInstrumentsQuery, ListAdminMoveOrAddChargesPaymentInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListAdminMoveOrAddChargesPaymentInstrumentsQuery, ListAdminMoveOrAddChargesPaymentInstrumentsQueryVariables>(ListAdminMoveOrAddChargesPaymentInstrumentsDocument, options);
      }
export function useListAdminMoveOrAddChargesPaymentInstrumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListAdminMoveOrAddChargesPaymentInstrumentsQuery, ListAdminMoveOrAddChargesPaymentInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListAdminMoveOrAddChargesPaymentInstrumentsQuery, ListAdminMoveOrAddChargesPaymentInstrumentsQueryVariables>(ListAdminMoveOrAddChargesPaymentInstrumentsDocument, options);
        }
export type ListAdminMoveOrAddChargesPaymentInstrumentsQueryHookResult = ReturnType<typeof useListAdminMoveOrAddChargesPaymentInstrumentsQuery>;
export type ListAdminMoveOrAddChargesPaymentInstrumentsLazyQueryHookResult = ReturnType<typeof useListAdminMoveOrAddChargesPaymentInstrumentsLazyQuery>;
export type ListAdminMoveOrAddChargesPaymentInstrumentsQueryResult = ApolloReactCommon.QueryResult<ListAdminMoveOrAddChargesPaymentInstrumentsQuery, ListAdminMoveOrAddChargesPaymentInstrumentsQueryVariables>;
export const ListBannersDocument = gql`
    query listBanners($userId: BigInt!) {
  instacart_care_tools_v1_BannersService_ListBanners(
    input: {pageType: PAGE_TYPE_CUSTOMER, customerContext: {userId: $userId}}
  ) {
    banners {
      id
      severity
      header
      message
      infoLink
      infoLinkText
    }
  }
}
    `;

/**
 * __useListBannersQuery__
 *
 * To run a query within a React component, call `useListBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListBannersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListBannersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListBannersQuery, ListBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListBannersQuery, ListBannersQueryVariables>(ListBannersDocument, options);
      }
export function useListBannersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListBannersQuery, ListBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListBannersQuery, ListBannersQueryVariables>(ListBannersDocument, options);
        }
export type ListBannersQueryHookResult = ReturnType<typeof useListBannersQuery>;
export type ListBannersLazyQueryHookResult = ReturnType<typeof useListBannersLazyQuery>;
export type ListBannersQueryResult = ApolloReactCommon.QueryResult<ListBannersQuery, ListBannersQueryVariables>;
export const ListChargeLogsForOrderDeliveryDocument = gql`
    query listChargeLogsForOrderDelivery($userId: BigInt!, $orderDeliveryId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_CareToolsService_ListChargeLogsForOrderDelivery(
    input: {userId: $userId, orderDeliveryId: $orderDeliveryId, serviceUser: $serviceUser}
  ) {
    chargeLogs {
      id
      chargeType
      description
      authAmount {
        currencyCode
        units
        nanos
      }
      authedAt
      captureAmount {
        currencyCode
        units
        nanos
      }
      createdAt
      captureAt
      capturedAt
      capturedAmount {
        currencyCode
        units
        nanos
      }
      gatewayTransactionId
      paymentGateway
      initialCapturableAmount {
        currencyCode
        units
        nanos
      }
      instrumentDetail {
        instrumentReference
        creditCardDetail {
          creditCardType
          lastFour
        }
        ebtCardDetail {
          lastFour
        }
        paypalDetail {
          email
        }
        venmoDetail {
          username
        }
        cashAppDetail {
          username
        }
        klarnaDetail {
          email
        }
        externalInstrumentDetail {
          lastFour
          customDisplayLabel
        }
        digitalWalletDetail {
          currencyCode
        }
      }
    }
  }
}
    `;

/**
 * __useListChargeLogsForOrderDeliveryQuery__
 *
 * To run a query within a React component, call `useListChargeLogsForOrderDeliveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListChargeLogsForOrderDeliveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListChargeLogsForOrderDeliveryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      orderDeliveryId: // value for 'orderDeliveryId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useListChargeLogsForOrderDeliveryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListChargeLogsForOrderDeliveryQuery, ListChargeLogsForOrderDeliveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListChargeLogsForOrderDeliveryQuery, ListChargeLogsForOrderDeliveryQueryVariables>(ListChargeLogsForOrderDeliveryDocument, options);
      }
export function useListChargeLogsForOrderDeliveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListChargeLogsForOrderDeliveryQuery, ListChargeLogsForOrderDeliveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListChargeLogsForOrderDeliveryQuery, ListChargeLogsForOrderDeliveryQueryVariables>(ListChargeLogsForOrderDeliveryDocument, options);
        }
export type ListChargeLogsForOrderDeliveryQueryHookResult = ReturnType<typeof useListChargeLogsForOrderDeliveryQuery>;
export type ListChargeLogsForOrderDeliveryLazyQueryHookResult = ReturnType<typeof useListChargeLogsForOrderDeliveryLazyQuery>;
export type ListChargeLogsForOrderDeliveryQueryResult = ApolloReactCommon.QueryResult<ListChargeLogsForOrderDeliveryQuery, ListChargeLogsForOrderDeliveryQueryVariables>;
export const ListCommonIdentityUsersDocument = gql`
    query listCommonIdentityUsers($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_GetCommonIdentityUsers(
    input: {userId: $userId, serviceUser: $serviceUser}
  ) {
    users {
      id
      active
      email
      phone
      firstName
      lastName
      createdAt
      isolationContext {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useListCommonIdentityUsersQuery__
 *
 * To run a query within a React component, call `useListCommonIdentityUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCommonIdentityUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCommonIdentityUsersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useListCommonIdentityUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListCommonIdentityUsersQuery, ListCommonIdentityUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListCommonIdentityUsersQuery, ListCommonIdentityUsersQueryVariables>(ListCommonIdentityUsersDocument, options);
      }
export function useListCommonIdentityUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListCommonIdentityUsersQuery, ListCommonIdentityUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListCommonIdentityUsersQuery, ListCommonIdentityUsersQueryVariables>(ListCommonIdentityUsersDocument, options);
        }
export type ListCommonIdentityUsersQueryHookResult = ReturnType<typeof useListCommonIdentityUsersQuery>;
export type ListCommonIdentityUsersLazyQueryHookResult = ReturnType<typeof useListCommonIdentityUsersLazyQuery>;
export type ListCommonIdentityUsersQueryResult = ApolloReactCommon.QueryResult<ListCommonIdentityUsersQuery, ListCommonIdentityUsersQueryVariables>;
export const ListLinkedUserAccountsDocument = gql`
    query listLinkedUserAccounts($userId: BigInt!, $includeDeactivatedAccounts: Boolean, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_GetLinkedUserAccounts(
    input: {userId: $userId, includeDeactivatedAccounts: $includeDeactivatedAccounts, serviceUser: $serviceUser}
  ) {
    linkedUserAccounts {
      id
      active
      email
      phone
      firstName
      lastName
      accountType
      identityStrategy
    }
  }
}
    `;

/**
 * __useListLinkedUserAccountsQuery__
 *
 * To run a query within a React component, call `useListLinkedUserAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLinkedUserAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLinkedUserAccountsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeDeactivatedAccounts: // value for 'includeDeactivatedAccounts'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useListLinkedUserAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListLinkedUserAccountsQuery, ListLinkedUserAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListLinkedUserAccountsQuery, ListLinkedUserAccountsQueryVariables>(ListLinkedUserAccountsDocument, options);
      }
export function useListLinkedUserAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListLinkedUserAccountsQuery, ListLinkedUserAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListLinkedUserAccountsQuery, ListLinkedUserAccountsQueryVariables>(ListLinkedUserAccountsDocument, options);
        }
export type ListLinkedUserAccountsQueryHookResult = ReturnType<typeof useListLinkedUserAccountsQuery>;
export type ListLinkedUserAccountsLazyQueryHookResult = ReturnType<typeof useListLinkedUserAccountsLazyQuery>;
export type ListLinkedUserAccountsQueryResult = ApolloReactCommon.QueryResult<ListLinkedUserAccountsQuery, ListLinkedUserAccountsQueryVariables>;
export const ListNotesForUserDocument = gql`
    query listNotesForUser($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $limit: Int, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_ListNotesForUser(
    input: {userId: $userId, serviceUser: $serviceUser, pagination: {limit: $limit}, adminAuditContext: $adminAuditContext}
  ) {
    notes {
      id
      userId
      note
      createdAt
      updatedAt
      notableId
      notableType
      userType
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useListNotesForUserQuery__
 *
 * To run a query within a React component, call `useListNotesForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListNotesForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListNotesForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      limit: // value for 'limit'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useListNotesForUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListNotesForUserQuery, ListNotesForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListNotesForUserQuery, ListNotesForUserQueryVariables>(ListNotesForUserDocument, options);
      }
export function useListNotesForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListNotesForUserQuery, ListNotesForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListNotesForUserQuery, ListNotesForUserQueryVariables>(ListNotesForUserDocument, options);
        }
export type ListNotesForUserQueryHookResult = ReturnType<typeof useListNotesForUserQuery>;
export type ListNotesForUserLazyQueryHookResult = ReturnType<typeof useListNotesForUserLazyQuery>;
export type ListNotesForUserQueryResult = ApolloReactCommon.QueryResult<ListNotesForUserQuery, ListNotesForUserQueryVariables>;
export const ListOrderBannersDocument = gql`
    query listOrderBanners($orderReference: String!, $userId: BigInt!) {
  instacart_care_tools_v1_BannersService_ListBanners(
    input: {pageType: PAGE_TYPE_ORDER, orderContext: {orderReference: $orderReference, userId: $userId}}
  ) {
    banners {
      id
      severity
      header
      message
      infoLink
      infoLinkText
    }
  }
}
    `;

/**
 * __useListOrderBannersQuery__
 *
 * To run a query within a React component, call `useListOrderBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrderBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrderBannersQuery({
 *   variables: {
 *      orderReference: // value for 'orderReference'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useListOrderBannersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListOrderBannersQuery, ListOrderBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListOrderBannersQuery, ListOrderBannersQueryVariables>(ListOrderBannersDocument, options);
      }
export function useListOrderBannersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListOrderBannersQuery, ListOrderBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListOrderBannersQuery, ListOrderBannersQueryVariables>(ListOrderBannersDocument, options);
        }
export type ListOrderBannersQueryHookResult = ReturnType<typeof useListOrderBannersQuery>;
export type ListOrderBannersLazyQueryHookResult = ReturnType<typeof useListOrderBannersLazyQuery>;
export type ListOrderBannersQueryResult = ApolloReactCommon.QueryResult<ListOrderBannersQuery, ListOrderBannersQueryVariables>;
export const ListOrderChatMessagesAndNotesDocument = gql`
    query listOrderChatMessagesAndNotes($orderId: BigInt!, $userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser!, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input) {
  instacart_care_tools_v1_CareToolsService_ListOrderChatMessagesAndNotes(
    input: {orderId: $orderId, userId: $userId, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    chatMessages {
      id
      body
      createdAt
      image
      orderDeliveryId
      read
      readAt
      recipientId
      recipientType
      senderId
      senderType
    }
    notes {
      id
      note
      userId
      userType
      notableId
      notableType
      createdAt
      updatedAt
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useListOrderChatMessagesAndNotesQuery__
 *
 * To run a query within a React component, call `useListOrderChatMessagesAndNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrderChatMessagesAndNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrderChatMessagesAndNotesQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useListOrderChatMessagesAndNotesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListOrderChatMessagesAndNotesQuery, ListOrderChatMessagesAndNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListOrderChatMessagesAndNotesQuery, ListOrderChatMessagesAndNotesQueryVariables>(ListOrderChatMessagesAndNotesDocument, options);
      }
export function useListOrderChatMessagesAndNotesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListOrderChatMessagesAndNotesQuery, ListOrderChatMessagesAndNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListOrderChatMessagesAndNotesQuery, ListOrderChatMessagesAndNotesQueryVariables>(ListOrderChatMessagesAndNotesDocument, options);
        }
export type ListOrderChatMessagesAndNotesQueryHookResult = ReturnType<typeof useListOrderChatMessagesAndNotesQuery>;
export type ListOrderChatMessagesAndNotesLazyQueryHookResult = ReturnType<typeof useListOrderChatMessagesAndNotesLazyQuery>;
export type ListOrderChatMessagesAndNotesQueryResult = ApolloReactCommon.QueryResult<ListOrderChatMessagesAndNotesQuery, ListOrderChatMessagesAndNotesQueryVariables>;
export const ListOrderResolutionsAndAppeasementsDocument = gql`
    query listOrderResolutionsAndAppeasements($userId: BigInt!, $orderId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser!) {
  instacart_care_tools_v1_AppeasementsService_ListOrderResolutionsAndAppeasements(
    input: {userId: $userId, orderId: $orderId, serviceUser: $serviceUser}
  ) {
    resolutionsAndAppeasements {
      createdAt
      requester {
        requesterType
        requesterName
      }
      ticket {
        ticketId
        ticketType
        caseUrl
      }
      valueType
      fulfillmentStatus
      value {
        currencyCode
        units
        nanos
      }
      orderIssues {
        orderIssueId
        isItemLevel
        issueTypeCategory
        issueTypeName
      }
    }
    totalIssued {
      currencyCode
      units
      nanos
    }
  }
}
    `;

/**
 * __useListOrderResolutionsAndAppeasementsQuery__
 *
 * To run a query within a React component, call `useListOrderResolutionsAndAppeasementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrderResolutionsAndAppeasementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrderResolutionsAndAppeasementsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      orderId: // value for 'orderId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useListOrderResolutionsAndAppeasementsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListOrderResolutionsAndAppeasementsQuery, ListOrderResolutionsAndAppeasementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListOrderResolutionsAndAppeasementsQuery, ListOrderResolutionsAndAppeasementsQueryVariables>(ListOrderResolutionsAndAppeasementsDocument, options);
      }
export function useListOrderResolutionsAndAppeasementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListOrderResolutionsAndAppeasementsQuery, ListOrderResolutionsAndAppeasementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListOrderResolutionsAndAppeasementsQuery, ListOrderResolutionsAndAppeasementsQueryVariables>(ListOrderResolutionsAndAppeasementsDocument, options);
        }
export type ListOrderResolutionsAndAppeasementsQueryHookResult = ReturnType<typeof useListOrderResolutionsAndAppeasementsQuery>;
export type ListOrderResolutionsAndAppeasementsLazyQueryHookResult = ReturnType<typeof useListOrderResolutionsAndAppeasementsLazyQuery>;
export type ListOrderResolutionsAndAppeasementsQueryResult = ApolloReactCommon.QueryResult<ListOrderResolutionsAndAppeasementsQuery, ListOrderResolutionsAndAppeasementsQueryVariables>;
export const ListOrdersByCustomerDocument = gql`
    query listOrdersByCustomer($userId: BigInt!, $pagination: InstacartCustomersSharedV1PaginationInput, $from: DateTime, $to: DateTime, $orderId: BigInt, $serviceUser: instacart_care_tools_v1_ServiceUser, $includeCustomerName: Boolean, $includeRetailerName: Boolean, $includeRetailerLocationName: Boolean, $includeShopperSummary: Boolean, $includeBatchId: Boolean) {
  instacart_care_tools_v1_CareToolsService_ListOrdersByCustomer(
    input: {userId: $userId, pagination: $pagination, from: $from, to: $to, orderId: $orderId, serviceUser: $serviceUser, includeCustomerName: $includeCustomerName, includeRetailerName: $includeRetailerName, includeRetailerLocationName: $includeRetailerLocationName, includeShopperSummary: $includeShopperSummary, includeBatchId: $includeBatchId}
  ) {
    orders {
      orderDeliveryId
      id
      orderReference
      confirmedAt
      fulfillmentDate
      serviceType
      userId
      userFullName
      retailerId
      retailerName
      retailerLocationId
      retailerLocationName
      deliveryStatus
      marketplaceOrder
      expressSubscriptionId
      shopperSummary {
        fullService
        pickerProfile {
          ...ShopperProfileFields
        }
        driverProfile {
          ...ShopperProfileFields
        }
        runnerProfile {
          ...ShopperProfileFields
        }
        currentShopperProfile {
          ...ShopperProfileFields
        }
      }
      batchId
      totalAmount {
        currencyCode
        nanos
        units
      }
      customerOrderNumber
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ShopperProfileFieldsFragmentDoc}`;

/**
 * __useListOrdersByCustomerQuery__
 *
 * To run a query within a React component, call `useListOrdersByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOrdersByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOrdersByCustomerQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      pagination: // value for 'pagination'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      orderId: // value for 'orderId'
 *      serviceUser: // value for 'serviceUser'
 *      includeCustomerName: // value for 'includeCustomerName'
 *      includeRetailerName: // value for 'includeRetailerName'
 *      includeRetailerLocationName: // value for 'includeRetailerLocationName'
 *      includeShopperSummary: // value for 'includeShopperSummary'
 *      includeBatchId: // value for 'includeBatchId'
 *   },
 * });
 */
export function useListOrdersByCustomerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListOrdersByCustomerQuery, ListOrdersByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListOrdersByCustomerQuery, ListOrdersByCustomerQueryVariables>(ListOrdersByCustomerDocument, options);
      }
export function useListOrdersByCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListOrdersByCustomerQuery, ListOrdersByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListOrdersByCustomerQuery, ListOrdersByCustomerQueryVariables>(ListOrdersByCustomerDocument, options);
        }
export type ListOrdersByCustomerQueryHookResult = ReturnType<typeof useListOrdersByCustomerQuery>;
export type ListOrdersByCustomerLazyQueryHookResult = ReturnType<typeof useListOrdersByCustomerLazyQuery>;
export type ListOrdersByCustomerQueryResult = ApolloReactCommon.QueryResult<ListOrdersByCustomerQuery, ListOrdersByCustomerQueryVariables>;
export const ListRecentRestaurantOrdersForUserDocument = gql`
    query listRecentRestaurantOrdersForUser($userId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $limit: BigInt) {
  instacart_care_tools_v1_CareToolsService_ListRestaurantOrdersByCustomer(
    input: {userId: $userId, serviceUser: $serviceUser, limit: $limit}
  ) {
    restaurantOrders {
      id
      status
      createdAt
      externalOrderId
      restaurantName
      serviceType
      eta
    }
  }
}
    `;

/**
 * __useListRecentRestaurantOrdersForUserQuery__
 *
 * To run a query within a React component, call `useListRecentRestaurantOrdersForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRecentRestaurantOrdersForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRecentRestaurantOrdersForUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      serviceUser: // value for 'serviceUser'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListRecentRestaurantOrdersForUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListRecentRestaurantOrdersForUserQuery, ListRecentRestaurantOrdersForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListRecentRestaurantOrdersForUserQuery, ListRecentRestaurantOrdersForUserQueryVariables>(ListRecentRestaurantOrdersForUserDocument, options);
      }
export function useListRecentRestaurantOrdersForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListRecentRestaurantOrdersForUserQuery, ListRecentRestaurantOrdersForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListRecentRestaurantOrdersForUserQuery, ListRecentRestaurantOrdersForUserQueryVariables>(ListRecentRestaurantOrdersForUserDocument, options);
        }
export type ListRecentRestaurantOrdersForUserQueryHookResult = ReturnType<typeof useListRecentRestaurantOrdersForUserQuery>;
export type ListRecentRestaurantOrdersForUserLazyQueryHookResult = ReturnType<typeof useListRecentRestaurantOrdersForUserLazyQuery>;
export type ListRecentRestaurantOrdersForUserQueryResult = ApolloReactCommon.QueryResult<ListRecentRestaurantOrdersForUserQuery, ListRecentRestaurantOrdersForUserQueryVariables>;
export const ListUserShopperBanReasonsDocument = gql`
    query listUserShopperBanReasons($appliesTo: instacart_fulfillment_user_shopper_ban_v1_AppliesToType, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_ListUserShopperBanReasons(
    input: {appliesTo: $appliesTo, serviceUser: $serviceUser}
  ) {
    reasons {
      id
      reason
      appliesTo
    }
  }
}
    `;

/**
 * __useListUserShopperBanReasonsQuery__
 *
 * To run a query within a React component, call `useListUserShopperBanReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserShopperBanReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserShopperBanReasonsQuery({
 *   variables: {
 *      appliesTo: // value for 'appliesTo'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useListUserShopperBanReasonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ListUserShopperBanReasonsQuery, ListUserShopperBanReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListUserShopperBanReasonsQuery, ListUserShopperBanReasonsQueryVariables>(ListUserShopperBanReasonsDocument, options);
      }
export function useListUserShopperBanReasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListUserShopperBanReasonsQuery, ListUserShopperBanReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListUserShopperBanReasonsQuery, ListUserShopperBanReasonsQueryVariables>(ListUserShopperBanReasonsDocument, options);
        }
export type ListUserShopperBanReasonsQueryHookResult = ReturnType<typeof useListUserShopperBanReasonsQuery>;
export type ListUserShopperBanReasonsLazyQueryHookResult = ReturnType<typeof useListUserShopperBanReasonsLazyQuery>;
export type ListUserShopperBanReasonsQueryResult = ApolloReactCommon.QueryResult<ListUserShopperBanReasonsQuery, ListUserShopperBanReasonsQueryVariables>;
export const ListUserShopperBansDocument = gql`
    query listUserShopperBans($shopperId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser) {
  instacart_care_tools_v1_CareToolsService_ListUserShopperBans(
    input: {shopperId: $shopperId, serviceUser: $serviceUser}
  ) {
    userShopperBans {
      id
      appliesTo
      banReasonDescription
      createdAt
      reason
      shopperId
      userId
      userName
      userShopperBanReasonId
    }
  }
}
    `;

/**
 * __useListUserShopperBansQuery__
 *
 * To run a query within a React component, call `useListUserShopperBansQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUserShopperBansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUserShopperBansQuery({
 *   variables: {
 *      shopperId: // value for 'shopperId'
 *      serviceUser: // value for 'serviceUser'
 *   },
 * });
 */
export function useListUserShopperBansQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListUserShopperBansQuery, ListUserShopperBansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListUserShopperBansQuery, ListUserShopperBansQueryVariables>(ListUserShopperBansDocument, options);
      }
export function useListUserShopperBansLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListUserShopperBansQuery, ListUserShopperBansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListUserShopperBansQuery, ListUserShopperBansQueryVariables>(ListUserShopperBansDocument, options);
        }
export type ListUserShopperBansQueryHookResult = ReturnType<typeof useListUserShopperBansQuery>;
export type ListUserShopperBansLazyQueryHookResult = ReturnType<typeof useListUserShopperBansLazyQuery>;
export type ListUserShopperBansQueryResult = ApolloReactCommon.QueryResult<ListUserShopperBansQuery, ListUserShopperBansQueryVariables>;
export const UnlinkIsolatedUserDocument = gql`
    mutation unlinkIsolatedUser($isolatedUserId: BigInt!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_UnlinkIsolatedUser(
    input: {isolatedUserId: $isolatedUserId, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    success
  }
}
    `;

/**
 * __useUnlinkIsolatedUserMutation__
 *
 * To run a mutation, you first call `useUnlinkIsolatedUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkIsolatedUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkIsolatedUserMutation, { data, loading, error }] = useUnlinkIsolatedUserMutation({
 *   variables: {
 *      isolatedUserId: // value for 'isolatedUserId'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useUnlinkIsolatedUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnlinkIsolatedUserMutation, UnlinkIsolatedUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnlinkIsolatedUserMutation, UnlinkIsolatedUserMutationVariables>(UnlinkIsolatedUserDocument, options);
      }
export type UnlinkIsolatedUserMutationHookResult = ReturnType<typeof useUnlinkIsolatedUserMutation>;
export type UnlinkIsolatedUserMutationResult = ApolloReactCommon.MutationResult<UnlinkIsolatedUserMutation>;
export type UnlinkIsolatedUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UnlinkIsolatedUserMutation, UnlinkIsolatedUserMutationVariables>;
export const UpdateAddressForUserDocument = gql`
    mutation updateAddressForUser($userId: BigInt!, $addressId: BigInt!, $streetAddress: String!, $apartmentNumber: String, $city: String!, $state: String!, $postalCode: String!, $requestContext: instacart_customers_shared_v1_RequestContext_Input!, $serviceUser: instacart_care_tools_v1_ServiceUser!, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_UpdateAddressForUser(
    input: {userId: $userId, addressId: $addressId, streetAddress: $streetAddress, apartmentNumber: $apartmentNumber, city: $city, state: $state, postalCode: $postalCode, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext, requestContext: $requestContext}
  ) {
    address {
      id
      streetAddress
      apartmentNumber
      city
      state
      postalCode
      zoneName
      regionName
      countryCode
    }
  }
}
    `;

/**
 * __useUpdateAddressForUserMutation__
 *
 * To run a mutation, you first call `useUpdateAddressForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressForUserMutation, { data, loading, error }] = useUpdateAddressForUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      addressId: // value for 'addressId'
 *      streetAddress: // value for 'streetAddress'
 *      apartmentNumber: // value for 'apartmentNumber'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      postalCode: // value for 'postalCode'
 *      requestContext: // value for 'requestContext'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useUpdateAddressForUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAddressForUserMutation, UpdateAddressForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAddressForUserMutation, UpdateAddressForUserMutationVariables>(UpdateAddressForUserDocument, options);
      }
export type UpdateAddressForUserMutationHookResult = ReturnType<typeof useUpdateAddressForUserMutation>;
export type UpdateAddressForUserMutationResult = ApolloReactCommon.MutationResult<UpdateAddressForUserMutation>;
export type UpdateAddressForUserMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAddressForUserMutation, UpdateAddressForUserMutationVariables>;
export const UpdateSubscriptionAutorenewDocument = gql`
    mutation updateSubscriptionAutorenew($userId: BigInt!, $subscriptionId: BigInt!, $autorenew: Boolean!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!, $requestContext: instacart_customers_shared_v1_RequestContext_Input) {
  instacart_care_tools_v1_CareToolsService_UpdateSubscriptionAutorenew(
    input: {userId: $userId, subscriptionId: $subscriptionId, autorenew: $autorenew, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext, requestContext: $requestContext}
  ) {
    membership {
      autorenew
      subscriptionId
    }
  }
}
    `;

/**
 * __useUpdateSubscriptionAutorenewMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionAutorenewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionAutorenewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionAutorenewMutation, { data, loading, error }] = useUpdateSubscriptionAutorenewMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      subscriptionId: // value for 'subscriptionId'
 *      autorenew: // value for 'autorenew'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *      requestContext: // value for 'requestContext'
 *   },
 * });
 */
export function useUpdateSubscriptionAutorenewMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionAutorenewMutation, UpdateSubscriptionAutorenewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionAutorenewMutation, UpdateSubscriptionAutorenewMutationVariables>(UpdateSubscriptionAutorenewDocument, options);
      }
export type UpdateSubscriptionAutorenewMutationHookResult = ReturnType<typeof useUpdateSubscriptionAutorenewMutation>;
export type UpdateSubscriptionAutorenewMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionAutorenewMutation>;
export type UpdateSubscriptionAutorenewMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionAutorenewMutation, UpdateSubscriptionAutorenewMutationVariables>;
export const UpdateUserNameDocument = gql`
    mutation updateUserName($userId: BigInt!, $firstName: String!, $lastName: String!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_UpdateUserName(
    input: {userId: $userId, firstName: $firstName, lastName: $lastName, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    user {
      firstName
      lastName
      email
      phone
    }
  }
}
    `;

/**
 * __useUpdateUserNameMutation__
 *
 * To run a mutation, you first call `useUpdateUserNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNameMutation, { data, loading, error }] = useUpdateUserNameMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useUpdateUserNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserNameMutation, UpdateUserNameMutationVariables>(UpdateUserNameDocument, options);
      }
export type UpdateUserNameMutationHookResult = ReturnType<typeof useUpdateUserNameMutation>;
export type UpdateUserNameMutationResult = ApolloReactCommon.MutationResult<UpdateUserNameMutation>;
export type UpdateUserNameMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserNameMutation, UpdateUserNameMutationVariables>;
export const UpdateUserPhoneDocument = gql`
    mutation updateUserPhone($userId: BigInt!, $phone: String!, $serviceUser: instacart_care_tools_v1_ServiceUser, $adminAuditContext: instacart_care_tools_v1_AdminAuditContext_Input!) {
  instacart_care_tools_v1_CareToolsService_UpdateUserPhone(
    input: {userId: $userId, phone: $phone, serviceUser: $serviceUser, adminAuditContext: $adminAuditContext}
  ) {
    user {
      firstName
      lastName
      email
      phone
    }
  }
}
    `;

/**
 * __useUpdateUserPhoneMutation__
 *
 * To run a mutation, you first call `useUpdateUserPhoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPhoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPhoneMutation, { data, loading, error }] = useUpdateUserPhoneMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      phone: // value for 'phone'
 *      serviceUser: // value for 'serviceUser'
 *      adminAuditContext: // value for 'adminAuditContext'
 *   },
 * });
 */
export function useUpdateUserPhoneMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>(UpdateUserPhoneDocument, options);
      }
export type UpdateUserPhoneMutationHookResult = ReturnType<typeof useUpdateUserPhoneMutation>;
export type UpdateUserPhoneMutationResult = ApolloReactCommon.MutationResult<UpdateUserPhoneMutation>;
export type UpdateUserPhoneMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateUserPhoneMutation, UpdateUserPhoneMutationVariables>;
export const ValidateSalesforceCaseDocument = gql`
    query validateSalesforceCase($caseId: String) {
  instacart_care_tools_v1_CareToolsService_ValidateSalesforceCase(
    input: {caseId: $caseId}
  ) {
    valid
  }
}
    `;

/**
 * __useValidateSalesforceCaseQuery__
 *
 * To run a query within a React component, call `useValidateSalesforceCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateSalesforceCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateSalesforceCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useValidateSalesforceCaseQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidateSalesforceCaseQuery, ValidateSalesforceCaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ValidateSalesforceCaseQuery, ValidateSalesforceCaseQueryVariables>(ValidateSalesforceCaseDocument, options);
      }
export function useValidateSalesforceCaseLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidateSalesforceCaseQuery, ValidateSalesforceCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ValidateSalesforceCaseQuery, ValidateSalesforceCaseQueryVariables>(ValidateSalesforceCaseDocument, options);
        }
export type ValidateSalesforceCaseQueryHookResult = ReturnType<typeof useValidateSalesforceCaseQuery>;
export type ValidateSalesforceCaseLazyQueryHookResult = ReturnType<typeof useValidateSalesforceCaseLazyQuery>;
export type ValidateSalesforceCaseQueryResult = ApolloReactCommon.QueryResult<ValidateSalesforceCaseQuery, ValidateSalesforceCaseQueryVariables>;